/* tslint:disable */
export const RECORDS = [
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': 'המכללה הוקמה בשנת 2016 על ידי איריס שטרן לוי וטל גרנות במטרה לסייע לנשים היוצאות ממעגל הזנות באמצעות רכישת הכשרה ושיפור יכולת השתכרות. המכללה מפעילה הכשרות מקצועיות בתחומים שונים לנשים שורדות שנות ומסייעת להן להשתלב במקומות עבודה. שמה הרשמי של העמותה אצל רשם העמותות: המכללה: בית ספר חברתי למען נשים החוזרות למעגל התעסוקה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'זנות'
      ],
      [
        'רווחה וקהילה',
        'זנות וסחר בנשים'
      ],
      [
        'תעסוקה ועבודה',
        'הכשרה מקצועית'
      ]
    ],
    'id': 'YB64',
    'is_active': true,
    'keywords': [
      'שיקום',
      'ביטחון תעסוקתי',
      'הכשרה מקצועית',
      'אלימות מינית',
      'פמיניזם'
    ],
    'name': 'Her Academy - המכללה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת גן',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'זנות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.heracademy.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>המכללה: בית ספר חברתי למען נשים החוזרות למעגל התעסוקה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580622645'
      },
      {
        'title': 'עמותת המכללה – Her Academy, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/HerAcademy/'
      },
      {
        'title': 'עמותת המכללה – Her Academy. נדלה מתוך בן-חורין אלכסנדרוביץ\'',
        'url': 'http://www.ibh.co.il/%D7%A2%D7%9E%D7%95%D7%AA%D7%AA-%D7%94%D7%9E%D7%9B%D7%9C%D7%9C%D7%94'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '11/05/2018'
    },
    'description': 'א.ל.ן ״ארגון אמהות לא נשואות״ נוסדו ב-1981 ונרשמו כעמותה במאי 1983 (580053866). בדצמבר 1983 התקיים הכינוס הארצי הראשון. א.ל.ן ראו עצמן כארגון הייציג של האמהות שילדו מחוץ למסגרת הנישואין ואינן נשואות. הן נאבקו להכרה ממסדית באמהות חד הוריות, קידמו בעיקר נושאים הקשורים בסוגיות כלכליות של אמהות חד הוריות (מיסוי, שכר לימוד, עלויות טיפול וכו\') אך גם עסקו בהעלאת מודעות והעניקו ייעוץ לאמהות חד הוריות אחת לשבוע בלשכה המרכזית של נעמת. לפי משרד המשפטים, הודעה מוקדמת על מחיקה ניתנה ב-2000, אך נראה שהפעילות פסקה כמה שנים קודם לכן.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'YH130',
    'is_active': false,
    'keywords': [
      'אמהות',
      'חד-הוריות',
      'ביטחון סוציאלי',
      'ביטחון תעסוקתי',
      'זכויות',
      'סיוע לאמהות',
      'משפחות'
    ],
    'name': 'א.ל.ן - ארגון אמהות לא נשואות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': '70 אמהות לא נשואות מכל הארץ התכנסו בת״א (1983, 25 דצמבר). <b>דבר</b>. נדלה מתוך',
        'url': 'http://www.jpress.nli.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=DAV%2F1983%2F12%2F25&id=Ar00600&sk=6396989E'
      },
      {
        'title': 'מעריב (1989, 4 יולי). 5,000 אמהות כאלה בארץ. נדלה מתוך',
        'url': 'http://www.jpress.nli.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=MAR%2F1989%2F07%2F04&id=Ar04101&sk=B771998F'
      },
      {
        'title': 'מוסקונה לרמן, בילי (1990, 2 אפריל). אמאזונות של יום-יום. <b>מעריב</b>. נדלה מתוך',
        'url': 'http://www.jpress.nli.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=MAR%2F1990%2F04%2F02&id=Ar02300&sk=3F83FD09'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '29/10/2019'
    },
    'year_closed': 2000,
    'year_closed_text': '2000',
    'year_founded': 1981,
    'year_registered': 1983
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '31/12/2018'
    },
    'description': 'עמותת אבות גאים (ע״ר 580578292) הוקמה בשנת 2013 ומטרותיה הן: ״לפעול בכל צורה ואופן על מנת לקדם את זכויותיהם של האבות הגאים בישראל ו/או לצורך קידום מחקר והנגשת מידע ו/או לצורך מתן ייעוץ לאבות גאים ו/או לפעול לקידום המעמד והדימוי החברתי של האבות הגאים בישראל ו/או לפעול לייזום פעילויות חברתיות לאבות הגאים בישראל ו/או לפעול למען האינטרסים של אבות גאים בישראל הן באמצעות עידוד לעזרה הדדית והן באמצעות פניה לגופים ו/או ארגונים ו/או רשויות ו/או תאגידים ו/או בתי משפט ו/או בפני כל גוף אחר שיידרש לצורך האמור.״ העמותה פועלת לשיפור מצבם, זכויותיהם ומעמדם של אבות גאים בישראל ולהנגשת כלל האופציות של הורות לאבות גאים - אימוץ, הורות משותפת ופונדקאות. שירותי העמותה כוללים סיוע משפטי, עבודת חקיקה, ליווי בהליכים וכיו״ב. העמותה תומכת בקידום מחקר על הורות גאה ופועלת בגופי התקשורת ומערכת החינוך לקידום מעמדם של אבות גאים. בנוסף היא מארגנת פעילויות חברתיות לאבות גאים וילדיהם, למען ייצור קבוצת שווים, ומעניקה ייעוץ וסיוע בתחומי הרווחה והבריאות למשפחות אלה. העמותה מפעילה תכנית לסיוע כלכלי בהליכי פונדקאות וסדנאות מידע משפטי בשיתוף פעולה עם הארגון הבינלאומי Men Having Babies שהוקם בשנת 2012.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'להט״ב',
        'משפחה'
      ],
      [
        'בריאות ופריון',
        'טכנולוגיות פריון'
      ]
    ],
    'id': 'LR33',
    'is_active': true,
    'keywords': [
      'פונדקאות',
      'אבהות',
      'הומואים',
      'סיוע משפטי',
      'אימוץ',
      'הורות גאה',
      'פילנתרופיה',
      'סיוע כלכלי'
    ],
    'name': 'אבות גאים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'משפחה',
    'primary_target_audience': 'גברים',
    'retrieved': {
      'type{date}': '2018-12-31'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.gaydads.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אבות גאים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580578292'
      },
      {
        'title': 'כ״ץ, ישראל, מעוז, עדי, אלפסי, דנה, לוי, ניר (2018). <b>מיפוי ארגוני הלהט״ב בישראל - דו״ח מסכם</b>. האגודה למען הלהט״ב ואלכא – המכון למנהיגות וממשל בג\'וינט ישראל, ירושלים. נדלה מתוך',
        'url': 'https://a9991848-b055-4c6f-a966-a6bdabf09321.filesusr.com/ugd/be9e5d_e13bb06adc274327b97bb41c199efc0c.pdf'
      },
      {
        'title': 'Men Having Babies, official website.',
        'url': 'http://www.menhavingbabies.org/'
      }
    ],
    'target_audiences': [
      'גברים',
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '31/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '28/11/2018'
    },
    'description': '״אביב״ הוקמה על ידי צביה גל-זכריה אשר סבלה בעברה מאנורקסיה. העמותה איגדה את כל קבוצות התמיכה למשפחות ופעלה לפתיחת מחלקות יעודיות בבתי החולים. היא פעלה לקידום זכויותיהם של אנשים הסובלים מהפרעות אכילה ולהעלאת מודעות בציבור על ידי הסברה והפצת מידע. העמותה לא פעילה, לא ברור ממתי. לפי מאגר העמותות מ-2013 בהליכי מחיקה והודעה סופית על מחיקה קיימת מ-2018.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'LR28',
    'is_active': false,
    'keywords': [
      'הפרעות אכילה',
      'דימוי גוף',
      'תמיכה נפשית',
      'קבוצות תמיכה'
    ],
    'name': 'אביב- ארגון ישראלי להפרעות אכילה, אנורקסיה ובולמיה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת גן',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות הנפש וטיפול',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אביב – ארגון ישראלי להפרעות אכילה – אנורקסיה ובולמיה (ע״ר): עמותה מחוקה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580330504'
      },
      {
        'title': 'מרלין-רוזנצוויג, אורית (2013, 6 יוני). לא כל גל נושא מזכרת. <b>לאשה</b>. נדלה מתוך',
        'url': 'https://xnet.ynet.co.il/laisha/articles/0,14961,L-3101297,00.html'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '19/02/2019'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '25/02/2019'
    },
    'description': 'ההוסטל ״אבני דרך״ לצעירים להט״ב בחולון, הוקם בשנת 2018 בשיתוף פעולה בין עמותת ״אותות - דלת לחיים חדשים״ למשרד העבודה והרווחה, במסגרת סדרת פרויקטים יעודיים למציאת פתרונות דיור לצעירים במצבי סיכון מהקהילה הלהט״בית. מדובר בצעירים חסרי קורת גג ועורף משפחתי. בהוסטל מקום לעד 12 צעירות וצעירים והוא פתוח 24/7 ומיועד לשהייה של חצי שנה עד שנה וחצי. ההוסטל מספק ליווי טיפולי, פעילויות פנאי וחוגים, כמו גם דמי כיס של 100 ש״ח לשבוע בחודשי השהות הראשונים. בנוסף, מותאמת לכל צעירה תוכנית אישית של לימודים ועבודה, הכשרה כלכלית וחברתית.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'רווחה ובריאות'
      ],
      [
        'נערות וצעירות',
        'בריאות'
      ],
      [
        'רווחה וקהילה',
        'להט״ב'
      ]
    ],
    'id': 'LR52',
    'is_active': true,
    'keywords': [
      'צעירות',
      'להט״בופוביה',
      'הוסטל',
      'תעסוקה',
      'דיור',
      'תמיכה נפשית'
    ],
    'name': 'אבני דרך',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חולון',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'רווחה ובריאות',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2019-02-25'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://otot-il.org.il/%d7%94%d7%95%d7%a1%d7%98%d7%9c%d7%99%d7%9d-%d7%90%d7%a8%d7%95%d7%9b%d7%99-%d7%98%d7%95%d7%95%d7%97/#tab-1-11'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>״אותות״ – דלת לחיים חדשים (ע״ר): עמותה</b> [דף העמותה המפעילה]. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580031722'
      },
      {
        'title': 'אבני דרך – להט״ב צעירים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/lgbt.avnei.derech/'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '25/02/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2018,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'פילנתרופיה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/11/2018'
    },
    'description': 'ארגון הסורופטימיסט הבינלאומי נוסד בארה״ב בשנת 1921 כארגון נשים א-פוליטי המאגד נשים העוסקות במקצועות חופשיים ובעסקים. מטרות הארגון המקוריות היו לקדם נשים מקצועיות לתעסוקה ועצמאות כלכלית ולפעול בתחומים רחבים הנוגעים לזכויות אדם, מוסר אישי ומקצועי, פעילות חברתית לקהילה המקומית והבינלאומית, לטפח קשרי אחווה וידידות בין חברות הארגון ברחבי העולם ולפעול בנושאי איכות הסביבה חינוך, תרבות ובריאות. מועדון הסורופטימיסט הראשון בישראל הוקם בחיפה על ידי רחל שלון בשנת 1955 והארגון הוא לחלק ממועצת ארגוני הנשים מאז הקמתה ועד היום. בשנת 2018 פעלו בישראל כ-14 מועדונים שונים המאוגדים תחת ארגון הגג שנרשם כעמותה (ע״ר 580337780) בשנת 1999 ומטרותיה הן: ״לקיים רמה מוסרית-אתית גבוהה בעסקים, בעבודה מקצועית ובתחומים האחרים של החיים. לשאוף לקיים זכויות האדם ולקדם את מעמד האישה. לטפח רוח ידידות ואחווה בין החברות הסורופטימיסטיות בעולם כולו״. פעילותו של הארגון בשנים האחרונות כוללת מפגשים חברתיים ותרבותיים לחברות ומעניק מלגות לסטודנטיות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'SA87',
    'is_active': true,
    'keywords': [
      'מלגות',
      'שיתוף פעולה בינלאומי'
    ],
    'name': 'אגוד ארצי של מועדוני הסורופטימיסט בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חולון',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'התאגדויות ורשתות מקצועיות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-11-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.soroptimist-israel.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אגוד ארצי של מועדוני הסורופטימיסט בישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580337780'
      },
      {
        'title': 'למרחב (1955, 17 פברואר). שנה ראשונה ליסוד ״סורופטימיסט״. נדלה מתוך',
        'url': 'http://www.jpress.nli.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=LMRV%2F1955%2F02%2F17&id=Ar00406&sk=6FC9F231'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '15/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': 1999
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'פילנתרופיה'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '10/07/2018'
    },
    'description': 'על פי חנה הרצוג (1994) הארגון נוסד בישראל ב-1923 כאגודה עותומנית ונקרא ״אגודת נשים בעלות השכלה אקדמית בפלשתינה-א״י״. על פי מקורות אחרים, הארגון נוסד ב-1932. מדובר בסניף מקומי של ארגון בינלאומי בריטי-אמריקאי שכונה בעבר International Federation of Universuty Women (כיום קרוי Graduate Women International) שהוקם על ידי שלוש נשים יהודיות ממוצא בריטי במטרה לשמש כרשת חברתית לקידום המעמד החברתי והתרבותי של נשים אקדמאיות וטיפוח קשרים בינלאומיים. בתחילה היו לארגון שלושה סניפים בתל אביב, חיפה וירושלים והוא הגיע לשיאו בשנות השבעים כשהפעיל שישה סניפים ברחבי הארץ. בשנת 1983 נרשמה העמותה בשם ״אגוד נשים אקדמיות בישראל״ (ע״ר  580023307) שמטרתה: ״לייצג את הנשים בישראל במסגרת האיגוד הבינלאומי של נשים אקדמאיות ולקדם את מטרותיו״. במקביל נוסדה עמותה נוספת הנקראת ״קרן מענקים איגוד נשים אקדמאיות״ (ע״ר 580031995) שמטרתה ״ליזום לעודד ולטפח פעילות לקידום עינינן של נשים אקדמאיות״ והיא מעניקה מלגות. בשנת 2018 היה לארגון סניף אחד שפועל באוניברסיטה העברית ועיקר עשייתו היא קיום כנסים והענקת מלגות לדוקטורנטיות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'אגודות מקצועיות'
      ],
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'YH55',
    'is_active': true,
    'keywords': [
      'קידום נשים',
      'שיתוף פעולה בינלאומי',
      'שוויון הזדמנויות',
      'מדע',
      'מחקר',
      'מלגות'
    ],
    'name': 'אגוד נשים אקדמיות בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אגודות מקצועיות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אגוד נשים אקדמיות בישראל: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580023307'
      },
      {
        'title': 'בשן, טל (1978, 24 אפריל). תואר לה – ומילגה. <b>דבר</b>. נדלה מתוך',
        'url': 'http://www.jpress.nli.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=DAV%2F1978%2F04%2F24&id=Ar00904&sk=BF914D21'
      },
      {
        'title': 'הרצוג, חנה (1994). ארגוני נשים בחוגים האזרחיים – פרק נשכח בהיסטוריוגרפיה של היישוב. <b>קתדרה 70</b>, 111–133. נדלה מתוך',
        'url': 'https://www.ybz.org.il/_Uploads/dbsAttachedFiles/Article_70.4.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '20/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': 1983
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '03/01/2019'
    },
    'description': '‏״אגודת יד אשה לרעותה״ הוקמה בשנת 1990 בירושלים במטרה לסייע ליולדות בעבודות הבית בתקופה ‏לאחר הלידה ובשמירת הריון – בישול, נקיון ועזרה בשמירה על הילדים האחרים. לעיתים האגודה ‏סייעה בתשלום עבור ‏בית החלמה. סטטוס האגודה כעמותה לא אושרה ובשנת 2001 היא נמחקה מרשם ‏העמותות.‏',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ],
      [
        'דת ומעמד אישי',
        'בריאות ופריון'
      ],
      [
        'רווחה וקהילה',
        'כללי'
      ]
    ],
    'id': 'SW42',
    'is_active': false,
    'keywords': [
      'סיוע כלכלי',
      'סיוע לאמהות',
      'גמ״ח'
    ],
    'name': 'אגודת יד אשה לרעותה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אגודת יד אישה לרעותה: עמותה מחוקה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580174522'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 5043 (2001, 31 דצמבר). <b>הודעה סופית בדבר מחיקה מפנקס העמותות</b>. אגודת יד אישה לרעותה (מספר עמותה 580174522). עמ\' 1030. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_html/law10/yalkut-5043.pdf'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '02/01/2019'
    },
    'year_closed': 2001,
    'year_closed_text': '2001',
    'year_founded': 1990,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '01/09/2019'
    },
    'description': 'פורום הנשים של מפלגת העבודה הוקם בשנת 2006 תחת השם ״עת נשים״ ביוזמתה של ח״כ שלי יחימוביץ במטרה לאגד את מאות החברות במפלגת העבודה. יושבת הראש העיקרית של האגף היתה לאה פדידה ששימשה כחברת כנסת לזמן קצר בכנסת ה-20. הפורום ״חרט על דגלו קידום שוויון חברתי כלכלי ותרבותי לנשים בכלל ובחברה בפרט״. מאוחר יותר השתנה שמו של הפורום ל״אגף הנשים״ במפלגה. אגף הנשים או אגף החברות פועל למען המטרות הבאות: \n* הקמת ועדת על מפלגתית בה ידונו בסוגיות מרכזיות העומדות על סדר היום הציבורי של החברה הישראלית בתחום החברתי- כלכלי, ומדיני מנקודת ראות מגדרית.\n* הגברת התודעה בשילוב פעולות על מנת להביא ליישום מדיניות התומכת בקידום צדק חברתי, שוויון הזדמנויות לנשים ושילובן בעמדות מפתח בחברה הישראלית בכלל ובמפלגת העבודה בפרט.\n* גיבוש ועידוד מדיניות ופעילות לקידום מעמד האישה ולשוויון בין המינים.\n* הכשרה, תמיכה וסיוע למנהיגות נשים בפוליטיקה, עידוד נשים להשתלב בעשייה הציבורית והפוליטית, ייצוג הולם במוקדי קבלת ההחלטות בציבוריות הישראלית ובמפלגת העבודה.\n* בניית תוכנית ״עוצמה נשית״ – פעילות במחוזות ובסניפי המפלגה ברחבי הארץ, ברמה מקומית ואזורית.\n* תכנון, ייזום פרויקטים, סדנאות, אירועים, ימי עיון וקורסים לקידום נשים.\n* הטמעת ההיבט המגדרי ככלי לעיצוב מדיניות.\n* מאבק בתופעה נגד אלימות נשים, הטרדה מינית וסחר בנשים.\n* מתפקדות ומשפיעות – הרחבת מעגל התומכות במפלגת העבודה.',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ],
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'SA113',
    'is_active': true,
    'keywords': [
      'מנהיגות',
      'שוויון',
      'תעסוקה',
      'אלימות',
      'תאים מפלגתיים'
    ],
    'name': 'אגף הנשים במפלגת העבודה',
    'name_ar': 'أثينا – الوحدة المهنية – المشروع الوطني لتعزيز مكانة النساء في الرياضة',
    'name_change_year': 2016,
    'name_common': null,
    'name_past': 'עת נשים- פורום נשות מפלגת העבודה',
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'מפלגות, שדולות ותאים מפלגתיים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-09-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.havoda.org.il/%D7%9E%D7%95%D7%A1%D7%93%D7%95%D7%AA/%D7%AA%D7%90-%D7%94%D7%97%D7%91%D7%A8%D7%95%D7%AA/'
      },
      {
        'title': '(2006, 15 פברואר). בעקבות הטור ב-ynet: מטה נשים חדש למפלגת העבודה. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-3216587,00.html'
      },
      {
        'title': 'חברת הכנסת שלי יחימוביץ (אתר) (2011, 21 ספטמבר). ״עת נשים״ – פורום נשות מפלגת העבודה החליט לתמוך בשלי. נדלה מתוך',
        'url': 'https://shelly.org.il/index.php/node/5695'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2006,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '17/05/2018'
    },
    'description': 'אד\'אר - פורום אנשי ונשות מקצוע למאבק בפשעי רצח נשים (ע.ר. 580628055) היא עמותה שהוקמה על ידי קבוצה של אנשי ונשות מקצוע בתחום העבודה הסוציאלית, בריאות הנפש וההנחיה החינוכית בשנת 2011 בעקבות תהליך למידה קבוצתי על רצח נשים. מטרת הקבוצה היתה לחקור ולגבש תפיסה לגבי התפקיד של אנשי מקצוע בתחום האבחון, המניעה וההתערבות בנושא. בעקבות כך, נוסדה העמותה בשנת 2016 בחיפה ומטרותיה הן: ״הקניית ידע, יכולות וכלים לאנשי המקצוע הרלוונטיים להתמודדות יומיומית ושוטפת עם האלימות ורצח הנשים בחברה הערבית וזאת באמצעות הכשרות, ליווי והדרכות על ידי מומחים לטיפול בנושא בין היתר מתחומי העבודה הסוציאלית, הפסיכולוגיה והייעוץ החינוכי. פיתוח שיח מקצועי אלטרנטיבי בחברה הערבית בהתמודדות עם רצח הנשים והאלימות כלפיהן וזאת באופן המספק מענה לצרכים ולרגשות של הפרט ותוך התחשבות בנסיבות חייו וסביבתו החברתית. יצירת מערך תמיכה לאנשי המקצוע, המבוסס בין היתר על העברת ידע וקידום שותפויות ושיתופי פעולה עם המסגרות והגופים המקצועיים הרלוונטיים בחברה.״',
    'description_ar': 'اذار- منتدى المهنيات والمهنيين لمكافحة جرائم قتل النساء (ج.م 580628055) تأسست الجمعية، في العام 2016 ومقرّها في حيفا، بمبادرة من مهنين ومهنيات في مجال العمل نحن مجموعة من المتخصصات والمتخصصين في العمل الاجتماعي، الصحة النفسية والاستشارة التربوية، بدأت جمعية آذار في العام 2011، بتنظيم حوار فكري عميق حول قتل النساء والقراءة الاجتماعية العميقة لهم لاستباق وتعزيز الدور المهني للعاملات والعاملين في المجال والتشخيص والوقاية والتدخل، حيث كانت هذه المبادرة تجسيدًا للقلق الإنساني والمهني الخطير بشأن انتشار هذه الجريمة ونفاقمها بشكل خاص وانتشار العنف في العائلة بشكل عام. تسعى الجمعية جاهدة للمساهمة في القضاء على ظاهرة قتل النساء من منظور التحليل النفسي الاجتماعي ولاثراء وتوسيع هذا السياق الاجتماعي وتقديم الحلول المناسبة والمهنية للمهنيات والمهنيين العاملات والعاملين في هذا المجال وتوفير أدوات مهنية وتنمية المعرفة والقدرات والآليات لدى المهنيات والمهنيين في مجالات العمل المتعددة في العمل الاجتماعي والصحة النفسية والمتخصصات والمتخصصين في مجال علاج العنف، للتعامل مع ظاهرة العنف وقتل النساء على أساس جندري. كما تعمل الجمعية على تأهيل ملائم لعلاج العنف الجندري في مجال ״ تقييم الخطورة״ وتشدّد في عملها على أهمية علاج المعالج/ة مرافقته/ها ودعمه/ها وتعزيزه/ها.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YB42',
    'is_active': true,
    'keywords': [
      'טיפול נפשי',
      'רצח נשים',
      'חינוך'
    ],
    'name': 'אד\'אר - פורום אנשי ונשות מקצוע למאבק בפשעי רצח נשים',
    'name_ar': 'اذار - منتدى المهنيات والمهنيين لمكافحة جرائم قتل النساء',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אד\'אר – פורום אנשי ונשות מקצוע למאבק בפשעי רצח נשים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580628055'
      },
      {
        'title': 'אד\'אר - פורום אנשי ונשות מקצוע למאבק בפשעי רצח נשים  جمعية اذار Ad\'ar Association, עמוד פייסבוק.\n',
        'url': 'https://www.facebook.com/%D8%AC%D9%85%D8%B9%D9%8A%D8%A9-%D8%A7%D8%B0%D8%A7%D8%B1-1701743920117140/'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '09/05/2021'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2011,
    'year_registered': 2016
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '10/07/2018'
    },
    'description': 'קבוצת ״אדוות״ נוסדה בשנת 2012 על ידי נשים דתיות, חלקן נשות מקצוע במקצועות הקשורים לטבילה ‏ולמקווה, על מנת להעלות על סדר היום שיח של ועבור נשים וטבילתן במקווה. הקבוצה מקיימת דף ‏פייסבוק סגור בשם ״טובלות בנחת״ ועובדת עם ואל מול מוסדות דת ומועצות מקומיות. נושאי העיסוק העיקריים ‏של הקבוצה עוסקים בזכות האישה לטבילה במקווה על פי דרכה, תנאי העבודה ושכר הבלניות וייצוג נשים במועצות ‏הדתיות. לצורך כך ״אדוות״ גם עובדות בשיתוף פעולה עם עיתים, שתי״ל, נאמני תורה ועבודה, ועוד. חברות הקבוצה היו מעורבות ב״בג״ץ המקוואות״, עתירה שהוגשה בשנת 2015 נגד המשרד לשרותי דת, הרבנות הראשית לישראל והמועצה הדתית בירושלים, בדרישה כי יתאפשר לנשים לטבול במקוואות טהרה על פי אמונתן.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'YH52',
    'is_active': true,
    'keywords': [
      'מקווה',
      'בלניות',
      'הלכה',
      'ייצוג',
      'רשות מקומית',
      'תנאי העסקה',
      'הלכה'
    ],
    'name': 'אדוות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-07-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.advot-group.org/ לא פעיל.'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2017, 5 יוני). <b>פרוטוקול מס\' 170: אפליית נשים המעוניינות לטבול ללא בלנית וגביית יתר לטבילת נשים</b>. נדלה מתוך',
        'url': 'https://oknesset.org/meetings/2/0/2017164.html'
      },
      {
        'title': 'פרקש, טלי (2012, 28 נובמבר). קו פרשת המים: נפגעות המקווה שוברות שתיקה. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-4312410,00.html'
      },
      {
        'title': 'קליין בר-נוי, אמונה ויחיאלי-פרסיקו, יעל (2019). קול פרטי: מקווה משלהן: המאבק הציבורי על פרטיות בטבילה במקווה. <b>משפט חברה ותרבות</b> ב\', עמ\' 447–456. נדלה מתוך',
        'url': 'https://law.tau.ac.il/sites/law.tau.ac.il/files/media_server/law_heb/Law_Society_Culture/books/Privacy_and_Company/19%20klein%20%26%20Yechiely.pdf'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '10/07/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2012,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '20/12/2018'
    },
    'description': 'עמותת ״אדיסיה״ (ע״ר 580235323) הוקמה בשנת 1994 ונתמכה על ידי ויצו במטרה לייצר מקורות פרנסה לעולות מאתיופיה בעיקר באמצעות רקמה מסורתית. העמותה נרשמה במעלה גלבוע אצל רות הר ציון שניהלה אותה ופעלה בעפולה. בשנת 2002 פורסמה הודעה על מחיקת העמותה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'הגירה',
        'קליטת עלייה'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'תרבות וספורט',
        'מלאכות מסורתיות'
      ]
    ],
    'id': 'YH160',
    'is_active': false,
    'keywords': [
      'העצמה כלכלית',
      'עולות מאתיופיה',
      'יזמות',
      'הכשרה מקצועית'
    ],
    'name': 'אדיסיה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'עפולה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'הגירה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קליטת עלייה',
    'primary_target_audience': 'נשים יוצאות אתיופיה',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>אדיסיה</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'ויצו (אתר).',
        'url': 'http://www.wizo.org.il/'
      },
      {
        'title': 'שירות ביזנס (2000, 20 יוני). 4,000 בובות כהות עור יחולקו ברחבי הארץ. <b>גלובס</b>. נדלה מתוך',
        'url': 'https://www.globes.co.il/news/article.aspx?did=249585'
      }
    ],
    'target_audiences': [
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '20/12/2018'
    },
    'year_closed': 2002,
    'year_closed_text': '2002',
    'year_founded': 1994,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '22/10/2018'
    },
    'description': 'אום -קולטור היא קבוצת אמניות שהתגבשה במהלך הלימודים בבית-הספר לאמנות במכללת ספיר: שבע נשים שהתקבצו ממקומות שונים בארץ, ויוצרות אירועי פרפורמנס ואמנות מנקודת מבט פמיניסטית ותוך חיבור לקהילות השונות בדרום. הקבוצה התגבשה ב-2012. ב-2014 הוקמה עמותה (ע״ר 580590545) שמטרתה גיוס כספים ותפעול יום-יומי של בית אום קולטור המבנה הפיזי של העמותה הממוקם בשדרות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'אמנות'
      ]
    ],
    'id': 'YH165',
    'is_active': true,
    'keywords': [
      'פמיניזם',
      'אמנות',
      'אמניות',
      'אקטיביזם'
    ],
    'name': 'אום קולטור',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'שדרות',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אמנות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-12-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://ummculture.wixsite.com/umm-culture'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בית אום קולטור (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580590545'
      },
      {
        'title': 'אום קולטור Umm culture, עמוד פייסבוק',
        'url': 'https://www.facebook.com/UmmCulture/'
      },
      {
        'title': 'סער, צפי (2013, 27 מאי). האמנות הפמיניסטית שצומחת מדרום. <b>הארץ</b>. נדלה מתוך',
        'url': 'https://www.haaretz.co.il/gallery/mejunderet/.premium-1.2030896'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים מזרחיות',
      'גברים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '22/10/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2012,
    'year_registered': 2014
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': 'פרויקט ״אופק נשי״ הוקם ב-2008 כשיתוף פעולה בין משרד הרווחה, משרד הבריאות, עיריית חיפה והרשות למעמד האישה. הפרויקט מופעל על ידי עיריית חיפה במטרה להעניק עזרה לנשים שורדות רחוב הלכודות במעגל הזנות והסמים, ולסייע בשיקומן. לשם כך מפעילה אופק נשי לנשים בזנות דירת חירום, מרכז יום והוסטל שבו מקבלות המטופלות ליווי צמוד, סיוע במציאת תעסוקה, רכישת מקצוע ולימודים, תיווך מול מוסדות, טיפול פסיכיאטרי ועוד.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף מוניציפלי',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'זנות'
      ],
      [
        'רווחה וקהילה',
        'זנות וסחר בנשים'
      ],
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ]
    ],
    'id': 'YB73',
    'is_active': true,
    'keywords': [
      'שיקום',
      'הוסטל',
      'דיור',
      'טראומה',
      'אונס',
      'פמיניזם',
      'תמיכה נפשית'
    ],
    'name': 'אופק נשי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'ממשלתי',
      'מוניציפלי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'זנות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://profhaifa.wordpress.com/about/'
      },
      {
        'title': 'אופק נשי – סיוע לנשים במעגל הזנות – חיפה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/OfekNashiHifa/'
      },
      {
        'title': 'המטה למאבק בסחר בנשים ובזנות. הקואליציה למאבק בזנות (ללא תאריך). <b>אופק נשי</b>. נדלה מתוך',
        'url': 'https://tfht.org/hebrew/%D7%90%D7%95%D7%93%D7%95%D7%AA/%D7%94%D7%A7%D7%95%D7%90%D7%9C%D7%99%D7%A6%D7%99%D7%94-%D7%9C%D7%9E%D7%90%D7%91%D7%A7-%D7%91%D7%96%D7%A0%D7%95%D7%AA/'
      },
      {
        'title': 'תודעה (אתר). <b>אופק נשי</b> (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2008,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '01/01/2020'
    },
    'description': '״אות הזדהות למען נפגעי תקיפה מינית״ (ע״ר 580601771) היא עמותה שהוקמה בשנת 2015 על ידי שני שטלריד במטרה לפעול למען: ״הקמת קו-חירום למען נפגעי תקיפה מינית. מתן עזרה נפשית וייצוג משפטי חינם לקורבנות תקיפה מינית״. בשנת 2014, שטלריד פרסמה פוסט אישי בפייסבוק שהיכה גלים ושינה את חייה. היא עזבה את עבודתה כמחנכת ומורה לאנגלית והחלה להקדיש את זמנה לפעול נגד תקיפות מיניות בפעילות ציבורית, הרצאות וקמפיינים. שמה של העמותה נקשר לפעילות למען החמרה בענישה וליווי נפגעות ושורדות של תקיפה מינית מול עורכי דין, עובדים סוציאליים ופסיכולוגיים המתמחים בנפגעי עבירה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ]
    ],
    'id': 'SA172',
    'is_active': true,
    'keywords': [
      'אלימות מינית'
    ],
    'name': 'אות הזדהות למען נפגעי תקיפה מינית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת גן',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אות הזדהות למען נפגעי תקיפה מינית (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580601771'
      },
      {
        'title': 'ועדת החוקה, חוק ומשפט (2017, 19 דצמבר). <b>פרוטוקול מס\' 510: הצעת חוק סדר הדין הפלילי (תיקון - שינוי שם עילת ״חוסר עניין לציבור״ בסגירת תיקים), התשע״ז–2017.</b> נדלה מתוך',
        'url': 'https://m.knesset.gov.il/Activity/committees/huka/Pages/CommitteeProtocols.aspx?ItemID=2024373'
      },
      {
        'title': 'ספיר ויץ, כרמית (2019, 7 מרץ). יום האישה 2019: ״הוא היה אלים ועצבני, הייתי בטוחה שיהרוג אותי״. <b>מעריב</b>. נדלה מתוך',
        'url': 'https://www.maariv.co.il/women/Article-688282'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/01/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': 2014
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '20/09/2018'
    },
    'description': 'עמותת ״אותות- דלת לחיים חדשים״ (ע״ר 580031722) הוקמה בשנת 1981 ונרשמה כעמותה ב - 1983. העמותה מספקת פתרונות דיור ומפעילה עשרות פרויקטים חינוכיים וטיפוליים לצעירים וצעירות חסרי עורף משפחתי, כולל במגזר הערבי, הדתי והחרדי ולקהילת הלהט״ב. מטרות העמותה הן: ״להקים מסגרות חינוך פנימיתי לבני נוער במצוקה ולנהלם לחנך בני נוער לעקוב אחר התקדמותם ולחקור את דרכי הטיפול״. ״אותות״ מפעילה בשיתוף משרד הרווחה והביטוח הלאומי מערך דיור לצעירות וכן דירות מעבר, הוסטלים ושלטרים לטרנסים/ות ולהט״בים/ות כולל ״בית דרור״ ו״הגג הורוד״ בתל אביב ו״אבני דרך״ בחולון. משרדי העמותה ממוקמים בירושלים, אך הפרויקטים והמסגרות השונות שמופעלות על ידיה מצויים בכל רחבי הארץ: ירושלים, תל אביב, אשקלון, הרצליה, קריית טבעון, נס ציונה, כפר יונה, חיפה ועפולה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'להט״ב',
        'רווחה ובריאות'
      ],
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ]
    ],
    'id': 'YH90',
    'is_active': true,
    'keywords': [
      'דיור',
      'תמיכה נפשית',
      'טרנסקסואלים',
      'שיקום',
      'נערות בסיכון',
      'התמכרויות',
      'הוסטל',
      'זנות',
      'אלימות'
    ],
    'name': 'אותות- דלת לחיים חדשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'אותות',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'צעירות במצבי סיכון',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://otot-il.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>״אותות״ – דלת לחיים חדשים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580031722'
      },
      {
        'title': 'אותות: רשת מעונות לנוער בסיכון, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/ototil/'
      },
      {
        'title': 'כ״ץ, ישראל, מעוז, עדי, אלפסי, דנה, לוי, ניר (2018). <b>מיפוי ארגוני הלהט״ב בישראל - דו״ח מסכם</b>. האגודה למען הלהט״ב ואלכא – המכון למנהיגות וממשל בג\'וינט ישראל, ירושלים. נדלה מתוך',
        'url': 'https://a9991848-b055-4c6f-a966-a6bdabf09321.filesusr.com/ugd/be9e5d_e13bb06adc274327b97bb41c199efc0c.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'להט״ב'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '16/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1981,
    'year_registered': 1983
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '25/06/2018'
    },
    'description': 'האחווה הסטודנטיאלית הגאה היא תכנית הפועלת, החל משנת 2015, בגרעיני פעילות בקמפוסים ברחבי הארץ. מטרתה – יצירת מרחב בטוח ועידוד יוזמות ופעילויות סטודנטיאליות גאות ע״י תמיכה ומתן כלים רעיוניים ופרקטיים. ברחבי הארץ פועלים, נכון ל - 2018, כ- 25 אחוות גאות, הפרוסות מתל חי בצפון ועד ב״ש בדרום. התכנית בכלל והגרעינים בפרט, חותרים להתמודד ולהפחית הומופוביה על כלל צורותיה, וכנגדה לקדם ערכים של סובלנות, קבלת האחר ושוויון. הגרעינים באחווה נועדו להיות בית חם בו כל אחד ואחת יוכלו להרגיש בנוח, כמו גם כר פעולה להנהגה ושינוי חברתי בסוגיות הנוגעות לקהילת הלהט״ב. הפעילות מיועדת לסטודנטים וסטודנטיות בכל המוסדות האקדמיים בארץ, אך גם מופנית גם כלפי כלל החברה והקהילה מסביב. תכנית משותפת של התאחדות הסטודנטים והסטודנטיות בישראל, האגודה למען הלהט״ב ופר״ח. בנוסף לסניפי האחווה בקמפוסים השונים, בפקולטה למשפטים באוניברסיטת תל אביב ובאוניברסיטה העברית פועלות בעשור האחרון קבוצות לקידום זכויות להט״ב באמצעות המשפט, המארגנות פעילויות חברתיות ומחקריות ומפעילות מאגרי מידע בנושא.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'להט״ב',
        'חינוך והשכלה'
      ],
      [
        'השכלה גבוהה ומחקר',
        'תאים סטודנטיאליים'
      ]
    ],
    'id': 'YB109',
    'is_active': true,
    'keywords': [
      'הומופוביה',
      'אקטיביזם',
      'זכויות',
      'שוויון',
      'סטודנטיות',
      'גאווה',
      'קהילה',
      'מנהיגות'
    ],
    'name': 'אחווה סטודנטיאלית גאה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'אקדמי',
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'חינוך והשכלה',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-06-25'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.achvalgbt.org.il/'
      },
      {
        'title': 'האחווה הסטודנטיאלית הגאה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/LgbtAchva/'
      },
      {
        'title': 'התאחדות הסטודנטים והסטודנטיות בישראל (2017, 5 ספטמבר). <b>האחווה הסטודנטיאלית הגאה</b> (סרטון). נדלה מתוך',
        'url': 'https://www.youtube.com/watch?v=RjJ6_y7tR4Y'
      },
      {
        'title': '(ללא תאריך). האחווה הסטודנטיאלית הגאה. <b>וודג\'</b>. נדלה מתוך',
        'url': 'http://www.wdg.co.il/%D7%94%D7%90%D7%97%D7%95%D7%95%D7%94-%D7%94%D7%A1%D7%98%D7%95%D7%93%D7%A0%D7%98%D7%99%D7%90%D7%9C%D7%99%D7%AA-%D7%94%D7%92%D7%90%D7%94/'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '01/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'אקטיביזם רשת',
      'שירותים משפטיים'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '11/11/2018'
    },
    'description': 'בשנת 2014 עורכת הדין החרדית ורד עובדיה התחילה באקטיביזם רשת של ״‏הפורום המשפטי למען נשים חרדיות״, בפרט בתחום של אלימות מינית ומגדרית. בשנת 2017 היא התחברה עם רחלי רושגולד ויוזמים נוספים להקמת העמותה ״אחותנו 2017״ (ע״ר 580652907) להמשיך את הסיוע המשפטי לנשים בו עסק הפורום.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'דת ומעמד אישי',
        'אלימות'
      ]
    ],
    'id': 'SW32',
    'is_active': true,
    'keywords': [
      'סיוע משפטי',
      'אלימות מינית'
    ],
    'name': 'אחותנו 2017',
    'name_ar': null,
    'name_change_year': 2017,
    'name_common': null,
    'name_past': 'הפורום המשפטי למען נשים חרדיות',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'אקטיביזם רשת',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אחותנו 2017 (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580652907'
      },
      {
        'title': 'אחותנו 2017 (2018, 5 נובמבר). הפרטים אומתו בשיחות טלפון עם נציגות הארגון.'
      },
      {
        'title': 'חריטן, שיפי (2016, 30 נובמבר). הקמפיין של עו״ד ורד עובדיה: תהיה גבר. <b>בחדרי חדרים</b>. נדלה מתוך',
        'url': 'http://www.bhol.co.il/news/774428'
      },
      {
        'title': 'עובדיה, ורד (2015, 25 נובמבר). המכה השלישית של האישה החרדית. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-4730788,00.html'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '11/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': 2017
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'שירותים משפטיים'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '23/08/2018'
    },
    'description': 'עמותת אחת אחת (ע״ר 580559664) נוסדה בשנת 2012 על ידי תושבות בקעת אונו, במטרה לפעול לקידומן של נשות בקעת אונו (קריית אונו, גני תקווה, גבעת שמואל, אור יהודה, יהוד-נווה מונוסון, סביון-גני יהודה) ונשים בכלל. פעילות העמותה כוללת מתן ייעוץ משפטי בדיני עבודה (ע״י נציגת שדולת הנשים), יעוץ בכתיבת קורות חיים ובהשתלבות בשוק העבודה, ייעוץ בפתיחת עסק עצמאי. בנוסף משתפת פעולה עם עמותת ״מחשב לכל ילד״ על מנת לספק, ללא עלות, מחשבים מחודשים לאמהות חד-הוריות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'YH83',
    'is_active': true,
    'keywords': [
      'קידום נשים',
      'זכויות בעבודה',
      'חד-הוריות',
      'יזמות עסקית',
      'אלימות'
    ],
    'name': 'אחת אחת - מנהלת נשים בקעת אונו',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'אור יהודה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-08-23'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.haht1.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אחת אחת – מנהלת נשים בקעת אונו (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580559664'
      },
      {
        'title': 'אחת אחת, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/women.biqat.ono/?fref=ts'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '12/11/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2012,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/02/2020'
    },
    'description': 'מועצת הנשים בגבעתיים הוקמה ב-1996 על ידי הרבנית ד״ר איילה גליקסברג. מרבית שנות פעילותה כיהנה בראשה חברת מועצת העיר איריס אברהם. בשנת 2017 הוקמה המועצה מחדש תחת השם ״אחת אחת הצד הנשי של גבעתיים״ על ידי חברת המועצה אור-לי ניב, מחזיקת תיק הנשים במועצה. מועצת הנשים פעלה לאורך השנים בין היתר בתחומי: ספורט, שירותים לאמהות ולאמהות חד-הוריות ובנושא תכנון עירוני ממבט מגדרי. המועצה פועלת כיום בעיקר באמצעות הרצאות והכשרות לנשות העיר וכן הרצאות והכשרות בבתי ספר ובתיכונים בנושאים מדעיים וטכנולוגיים.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'חינוך',
        'מדע וטכנולוגיה'
      ]
    ],
    'id': 'YH199',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'מועצה',
      'סיוע לאמהות',
      'חינוך מגדרי'
    ],
    'name': 'אחת אחת הצד הנשי של גבעתיים',
    'name_ar': null,
    'name_change_year': 2017,
    'name_common': null,
    'name_past': 'מועצת נשים גבעתיים',
    'name_replaced_by': null,
    'official_address': 'גבעתיים',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2020-02-01'
    },
    'sources': [
      {
        'title': 'אתר המועצה כפי שנוטר ב-5.12.12 בארכיון האינטרנט (internet archive)',
        'url': 'https://web.archive.org/web/20121205085433/http://giv-women.org.il/Pages/mapSite.aspx'
      },
      {
        'title': 'נשים בגבעתיים אחת אחת, קבוצת פייסבוק.',
        'url': 'https://www.facebook.com/groups/1847570642236906//'
      },
      {
        'title': 'גולדפינגר, רבקי (2010, 9 דצמבר). בשבע 421: פמיניסטית למהדרין. <b>ערוץ 7</b>. נדלה מתוך',
        'url': 'https://www.inn.co.il/Besheva/Article.aspx/10098'
      },
      {
        'title': '(2018, 25 דצמבר). מועצת הנשים של גבעתיים הוקמה מחדש. <b>רמת גן גבעתיים News</b>. נדלה מתוך',
        'url': 'https://www.rgg-news.co.il/home-page-headlines/%d7%9e%d7%95%d7%a2%d7%a6%d7%aa-%d7%94%d7%a0%d7%a9%d7%99%d7%9d-%d7%a9%d7%9c-%d7%92%d7%91%d7%a2%d7%aa%d7%99%d7%99%d7%9d-%d7%94%d7%95%d7%a7%d7%9e%d7%94-%d7%9e%d7%97%d7%93%d7%a9//'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '01/02/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1996,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '06/11/2018'
    },
    'description': 'המרכז הוקם על ידי ד״ר תלמה כהן ב-2002 ברעננה במטרה לספק טיפול פסיכולוגי נגיש ובעלויות סמליות לנפגעות ונפגעי תקיפה מינית. העמותה (ע״ר 580428803) נרשמה בשנת 2004 ומטרותיה היו: ״מתן טיפול פסיכולוגי איכותי אך מוזל לנפגעי אלימות מינית - ילדים ומבוגרים. מתן טיפול ויעוץ לנפגעי תקיפה מינית, לרבות לבני זוג ובני משפחה בכלל, ולרבות ילדים ונוער. הגברת המודעות הציבורית לנושא, תוך עידוד נפגעים לפנות לעזרה. טיפוח ופעילות בתחומי החינוך, המדע והתרבות״. על פי הדוחות שנמסרו לרשם העמותות, העמותה הפסיקה את פעילותה בסוף שנת 2008 ופורקה מרצון בשנת 2012. נראה שתחת אותו השם משמש המקום (עתה בזכרון יעקב) כקליניקה פרטית של תלמה כהן.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'YH131',
    'is_active': false,
    'keywords': [
      'אונס',
      'תקיפה מינית',
      'טיפול נפשי'
    ],
    'name': 'אחת ואחד מאתנו',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רעננה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אחת ואחד מאיתנו (ע״ר): עמותה מחוקה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580428803'
      },
      {
        'title': 'אחת ואחד מאתנו - הבית לתמיכה נפשית בנפגעי אלימות מינית, עמוד פייסבוק (לא פעיל מ-2011).',
        'url': 'https://www.facebook.com/%D7%90%D7%97%D7%AA-%D7%95%D7%90%D7%97%D7%93-%D7%9E%D7%90%D7%AA%D7%A0%D7%95-%D7%94%D7%91%D7%99%D7%AA-%D7%9C%D7%AA%D7%9E%D7%99%D7%9B%D7%94-%D7%A0%D7%A4%D7%A9%D7%99%D7%AA-%D7%91%D7%A0%D7%A4%D7%92%D7%A2%D7%99-%D7%90%D7%9C%D7%99%D7%9E%D7%95%D7%AA-%D7%9E%D7%99%D7%A0%D7%99%D7%AA-174035935950833/'
      },
      {
        'title': '(2015, 10 ספטמבר). נשים חזקות (ראיון עם המייסדת, ד״ר תלמה כהן). <b>את</b>. נדלה מתוך',
        'url': 'https://atmag.co.il/%D7%A6%D7%A8%D7%9B%D7%A0%D7%95%D7%AA-%D7%A9%D7%99%D7%95%D7%95%D7%A7%D7%99%D7%AA/womens-power-3'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/06/2018'
    },
    'year_closed': 2008,
    'year_closed_text': '2008',
    'year_founded': 2002,
    'year_registered': 2004
  },
  {
    'activity_kinds': [
      'אקטיביזם רשת',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '24/04/2018'
    },
    'description': '״אחת מתוך אחת״ (ע״ר 580591535) היה מיזם אידאולוגי-פוליטי-פמיניסטי, שצמח בפייסבוק במטרה להוות פלטפורמה לשיתוף והפצה של עדויות על הטרדות מילוליות, תקיפות מיניות, מעשים מגונים ואונס, מתוך הכרה שהטרדות ותקיפות קורות לכל אישה בגלל שהיא אישה. המיזם נולד ביוני 2013 על ידי שלומית הברון וגל שרגיל, בעקבות אווירה שיתופית נשית שנוצרה ברשת ובתקשורת, אחרי הקמתו ופעולתו של תא העיתונאיות (וחשיפת פרשת עמנואל רוזן), שיתוף סיפור האונס של העיתונאית אריאנה מלמד וקריאתה של העיתונאית שרון שפורר לנשים ״לצאת מהארון״ ולספר על ההטרדות המיניות שהן עוברות. כאשר התמלאה הרשת סיפורים של נשים בשמן המלא, ששיתפו סיפורי הטרדות ותקיפות מיניות. ״אחת מתוך אחת״ החליטה לרכז את כל העדויות בעמוד פייסבוק שבו ממשיכים להעלות עדויות של נערות ונשים, נערים וגברים על אלימות מינית בישראל. בשנת 2015 נרשמה העמותה שכתובתה בראש פינה, ומטרותיה הן: ״לפעול למען העלאת המודעות החברתית בקרב הציבור בישראל בכל הנוגע לפגיעות מיניות והנזקים הגלומים בהם, הן לחברה בכללותה והן לנפגע/ת עצמו/ה באמצעות חינוך, מתן הרצאות ומוצרים נלווים. לסייע הן במישור המשפטי והן במישור הטיפולי לאוכלוסיות נפגעות תקיפה מינית. לחתור ולפעול למען שוויון זכויות בין המגדרים בישראל. לפעול למען המטרות הנ״ל בכל אמצעי חוקי.״ במהלך שנת 2019 הודיעו מייסדות העמותה על כוונה להפסיק את פעילותה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ]
    ],
    'id': 'YB23',
    'is_active': true,
    'keywords': [
      'אונס',
      'הטרדה מינית',
      'פמיניזם',
      'אינטרנט',
      'סיוע משפטי'
    ],
    'name': 'אחת מתוך אחת',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ראש פינה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'אקטיביזם רשת',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-04-24'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.oneofone.org.il/'
      },
      {
        'title': 'אחת מתוך אחת, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/oneofone1'
      },
      {
        'title': 'אחת מתוך אחת (2017, 18 אוגוסט). הפרטים אומתו בריאיון עם שלומית הברון.'
      },
      {
        'title': 'אחת מתוך אחת (2017, 23 יוני). הפרטים אומתו בריאיון עם גל שרגיל.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '05/02/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': 2015
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '20/06/2018'
    },
    'description': '״אחת מתשע נשים, למען נפגעות סרטן״ ( 580245637) נוסדה בשנת 1994 במטרה ״לשמש מסגרת אירגונית וולנטרית לנשים שנפגעו ממחלת הסרטן, ולייצגן בפני מוסדות וגופים ציבוריים וממלכתיים. לפתח מודעות ציבורית לקיימה והשלכותיה של מחלת הסרטן. לסייע ביצירת מערכות תמיכה ועזרה הדדית לחולות.״ אחת מתשע היא העמותה הוותיקה בישראל המתמחה בפעילות למען נשים חולות סרטן השד וקרוביהן ובחתירה להעלאת המודעות הציבורית למחלה. העמותה הוקמה על ידי קבוצת נשים בראשות נורית טולנאי, שחלו בסרטן השד ונתקלו בקשיים רבים בהתמודדות עם מחלתן, בהיעדר תמיכה ומידע מספיקים. הנשים הקימו רשת תמיכה בשיתוף אנשי מקצוע, המציעה לנשים שחלו בסרטן השד ולקרוביהן סיוע משפטי, נפשי ורפואי. העמותה מעניקה תמיכה באמצעות מתנדבות שהחלימו מסרטן השד, לצד תמיכה רגשית על ידי אנשי מקצוע, ומסייעת במידע, ליווי מקצועי ובמיצוי זכויות. העמותה מקיימת פעילויות הסברה ומהלכים תקשורתיים להעלאת המודעות לגילוי מוקדם של המחלה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'SA26',
    'is_active': true,
    'keywords': [
      'בריאות',
      'סרטן שד',
      'סדנאות',
      'קו סיוע'
    ],
    'name': 'אחת מתשע נשים, למען נפגעות סרטן',
    'name_ar': 'واحدة من تسعة',
    'name_change_year': null,
    'name_common': 'אחת מתשע',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.onein9.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אחת מתשע נשים, למען נפגעות סרטן: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580245637'
      },
      {
        'title': 'אברמוביץ, דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/01/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1994,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '24/05/2018'
    },
    'description': '״איגוד היועצות לקידום מעמד האשה״ הוקם ביוזמת מספר יועצות לקידום מעמד האישה בשנת 2008 בראשות ישראלה בן-אשר מראשון לציון, שמונה שנים לאחר חקיקת חוק הרשויות המקומיות (תש״ס-2000) שקבע חובת מינוי יועצת למעמד האשה. מטרות העמותה (ע״ר 580490282) הן: ״לארגן ולאגד את היועצות למעמד האישה של כל הרשויות המקומיות בישראל, לייצגן לפני מוסדות וגופים הנוגעים למעמדה של היועצת. לקדם את הידע המקצועי של חברת העמותה. לפתח טכניקות ומחקרים, לעזור בביצוע כל תכנית אשר תקדם את נושא מעמד האישה ברשויות המקומיות״. בהתאם לכך, האיגוד פועל למיצובן המקצועי והכרה בתפקידן של היועצות כתפקיד פרופסיונאלי וסטטוטורי. האיגוד גם מקדם שיתופי פעולה עם גורמים שונים במישור המקומי והארצי, לשם קידום נושאים, מיזמים וחקיקה הקשורה לנשים ולשוויון מגדרי. פעילויות האיגוד מכוונות ליצירת קהילה מקצועית בעלת קשרי עבודה מתמשכים, סיוע ליועצות ברמה מקצועית ואישית, יצירת קשרי עבודה עם גופים ממשלתיים ואזרחיים הקשורים לתחומי הפעילות של היועצות, השתתפות בוועדות ובדיונים להתוויית מדיניות בתחום השוויון המגדרי.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ]
    ],
    'id': 'YH5',
    'is_active': true,
    'keywords': [
      'איגוד מקצועי',
      'יועצות לקידום מעמד האשה',
      'רישות',
      'רשות מקומית',
      'תקצוב מגדרי'
    ],
    'name': 'עמותת יועצות למעמד האישה לראשי רשויות מקומיות בישראל',
    'name_ar': 'إتحاد المستشارات للنهوض بمكانة المرأة في إسرائيل',
    'name_change_year': null,
    'name_common': 'איגוד היועצות לקידום מעמד האשה בישראל',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ראשון לציון',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'מוניציפלי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-12-09'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://yoatzot-w.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת יועצות למעמד האישה לראשי רשויות מקומיות בישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580490282'
      },
      {
        'title': 'איגוד היועצות לקידום מעמד האשה ברשויות המקומיות בישראל, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/igudyoatzot/about/?ref=page_internal'
      },
      {
        'title': 'אלמגור־לוטן, אורלי (2012). <b>יועצות למעמד האישה ברשויות המקומיות</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/074e6b58-e9f7-e411-80c8-00155d010977/2_074e6b58-e9f7-e411-80c8-00155d010977_11_6746.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '14/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2008,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '22/10/2018'
    },
    'description': '״איגוד הכדורשת הישראלי״ (Israel Catchball Association - ICA) (ע״ר 580507952) הוקם ב-2007 על ידי שמונה מייסדות, שחלקן משמשות חברות ועד מנהל של העמותה. זהו איגוד ספורט הנשים הגדול בישראל על פי מספר הספורטאיות הבוגרות הרשומות בו. מטרות העמותה הן: ״ארגון, תאום, פיתוח, עזרה, תמיכה ועידוד פעילות הספורט בענף כדורשת נשים בישראל. קביעת חוקות ויישומן, קביעת תקנות, נהלים וסדרים בענף, קביעת חוקים וכללים למשחק הכדורשת נשים. ארגון תחרויות ליגה וגביע ברמות משחק שונות בענף כדורשת נשים, ארגון אירועי ספורט שונים.״ הארגון מספק פלטפורמה תחרותית בכדורשת לכל אשה באשר היא אישה - מכל גיל, מגזר וכושר גופני, ובכל הארץ. האיגוד הוא יוזמה אזרחית נשית, מתפקד באופן אוטונומי, מנוהל על ידי נשים ועבור נשים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'ספורט'
      ],
      [
        'נערות וצעירות',
        'חינוך'
      ]
    ],
    'id': 'YH111',
    'is_active': true,
    'keywords': [
      'העצמה',
      'ספורט',
      'ספורטאיות',
      'כדורשת'
    ],
    'name': 'איגוד הכדורשת הישראלי',
    'name_ar': null,
    'name_change_year': 2015,
    'name_common': null,
    'name_past': 'המועדון הישראלי לכדורשת נשים',
    'name_replaced_by': null,
    'official_address': 'רעננה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ספורט',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://kadureshet.com/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>איגוד הכדורשת הישראלי (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580507952'
      },
      {
        'title': 'איגוד הכדורשת הישראלי, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/IsraelCatchball/'
      },
      {
        'title': 'איגוד הכדורשת הישראלי. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%90%D7%99%D7%92%D7%95%D7%93_%D7%94%D7%9B%D7%93%D7%95%D7%A8%D7%A9%D7%AA_%D7%94%D7%99%D7%A9%D7%A8%D7%90%D7%9C%D7%99'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '22/10/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2007,
    'year_registered': 2009
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '14/10/2018'
    },
    'description': 'איגוד מרכזי הסיוע לנפגעות ולנפגעי תקיפה מינית נוסד בשנת 1990 כארגון גג, המאגד תחתיו תשעה מרכזי סיוע מקומיים המספקים מענה טלפוני 24 שעות ביממה, במספרי 1202 (נשים) ו-1203 (גברים). העמותה מאגדת את המרכזים הבאים: מרכז סיוע גליל גולן; מרכז סיוע נצרת; מרכז סיוע חיפה והצפון; מרכז סיוע השרון; מרכז סיוע תל אביב; מרכז סיוע ירושלים; תהל - מרכז הסיוע לנשים וילדים דתיים; מרכז סיוע תאיר - שפלה; מסל״ן. מטרת האיגוד היא לתאם ולרכז את פעולות מרכזי הסיוע לנפגעות תקיפה מינית בישראל ולפעול להרחבת ושיפור השירותים הזמינים לקורבנות אלימות מינית; לייזום חקיקה בנושא; לפעול ליצירת גוף ידע והתאמת מודלים לעבודה עם קורבנות תקיפה מינית מאוכלוסיות מגוונות; ולהעלות למודעות ציבורית את השלכות הפגיעה המינית. האיגוד ותשעת מרכזי הסיוע החברים בו הם ארגוני שינוי חברתי, בין החזקים והמשמעותיים ביותר בישראל, ומקיימים שיתופי פעולה עם כל הגורמים המקצועיים העוסקים בנושא של אלימות מינית במערכת אכיפת החוק במדינת ישראל: הפרקליטות, משטרת ישראל, משרד המשפטים והמחלקה לחקירות שוטרים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'חינוך',
        'מניעת אלימות'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ]
    ],
    'id': '1YB22',
    'is_active': true,
    'keywords': [
      'אונס',
      'הטרדה מינית',
      'קו סיוע',
      'פורום',
      'חקיקה',
      'נתונים'
    ],
    'name': 'איגוד מרכזי הסיוע לנפגעות ולנפגעי תקיפה מינית בישראל',
    'name_ar': 'اتحاد مراكز مساعدة ضحايا الاعتداء الجنسي',
    'name_change_year': 2004,
    'name_common': null,
    'name_past': 'איגוד מרכזי הסיוע לנפגעות תקיפה מינית בישראל',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-14'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.1202.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>איגוד מרכזי הסיוע לנפגעות תקיפה מינית ולנפגעי תקיפה מינית בישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580173730'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '14/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1990,
    'year_registered': 1991
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '24/05/2018'
    },
    'description': '״איגוד נבחרות הציבור ברשויות המקומיות בישראל״ היא עמותה (ע״ר 580539617) שהוקמה בשנת 2011 במטרה לאגד את הנשים הנבחרות בבחירות מוניציפאליות וחיזוק הדמוקרטיה בישראל באמצעות מנהיגות נשית. מטרות העמותה הן: ״ליצור תרבות פוליטית ערכית בישראל. לשמש איגוד נבחרות הציבור ברשויות המקומיות כמנוף ליצירת כוח פוליטי של מנהיגות נשים מקומית וארצית. לחזק מעמד חברות המועצה ברשויות המקומיות. לייצג חברות המועצה ברשויות המקומיות ברשויות שונות לרבות משרד הפנים, כנסת ישראל, מרכז השלטון המקומי״. מייסדות העמותה הן מלי פולישוק-בלוך, נאוה גלעד, עדית דיאמנט, אביבה מנצור, שלי עמרמי-בוזגלו, סימה פרי, ישראלה רוזן, סיגל שיינמן, ליקה לוי, וויוי וולפסון. באיגוד חברות נשים מכל הקשת הפוליטית, חברות מפלגות ארציות ורשימות מקומיות. תחומי הפעילות של האיגוד כוללים מפגשים אזוריים ברחבי הארץ עם חברות מועצה, שליחת דף מידע לכל חברות המועצה ברחבי הארץ, ביסוס מעמדן של חברות מועצה, הענקת סיוע אישי לחברות מועצה הנתקלות בבעיות בפעילותן המקומית, סדנאות והכשרות בנושאים שונים ועוד.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'YH6',
    'is_active': true,
    'keywords': [
      'מנהיגות',
      'רשות מקומית'
    ],
    'name': 'איגוד נבחרות הציבור ברשויות המקומיות בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רעננה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'מוניציפלי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-24'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.nivcharot.022.co.il/BRPortal/br/P102.jsp?arc=581611'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>איגוד נבחרות הציבור ברשויות המקומיות בישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580539617'
      },
      {
        'title': 'איגוד נבחרות הציבור ברשויות המקומיות בישראל, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pg/nivcharot/about/?ref=page_internal'
      },
      {
        'title': 'איגוד נבחרות הציבור ברשויות המקומיות בישראל (בלוג). <b>קול הנבחרות</b>. נדלה מתוך',
        'url': 'http://nivcharot.blogspot.co.il/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2009,
    'year_registered': 2011
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '18/12/2018'
    },
    'description': 'איגוד נשים מנהלות (ע״ר 580073245) הוקמה ב-1984 על ידי לבנה זמיר במטרה לפעול ל״קידום מקצועי לנשים בדרג ניהולי״ והחל מ-1990 הפיצה רבעון בשם ״נטע: האשה בשנות ה-2000 - נשים בניהול, טכנולוגיה ועסקים״ העמותה נמחקה ב-2002, אך הירחון המשיך לצאת עד 2007 (בהוצאת המכון להוראת מדעים וטכנולוגיה - ממט״ן).',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ],
      [
        'תרבות וספורט',
        'כתבי עת והוצאה לאור'
      ]
    ],
    'id': 'YH159',
    'is_active': false,
    'keywords': [
      'ניהול',
      'מנהלות',
      'נשות עסקים'
    ],
    'name': 'איגוד נשים מנהלות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'התאגדויות ורשתות מקצועיות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>איגוד נשים מנהלות: עמותה מחוקה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580073245'
      },
      {
        'title': 'ריאיון עם לבנה זמיר, מקימת ״איגוד נשים מנהלות״ (2016). נדלה מתוך',
        'url': 'https://sephardivoices.com/wp-content/uploads/2016/11/Levana-Zamir-Transcription.htm'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '18/12/2018'
    },
    'year_closed': 2002,
    'year_closed_text': '2002',
    'year_founded': 1984,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '20/10/2018'
    },
    'description': 'ארגון הנוער הגאה הוקם ב - 2001 על ידי יניב ויצמן וגל אוחובסקי. ב - 2007 קיבל הארגון הכרה רשמית ממשרד החינוך שהשווה את מעמדו לזה של תנועות הנוער האחרות הפועלות בארץ וב - 2010 הפך גם לחלק מפרויקט מחויבות אישית. הארגון מפעיל קבוצות נוער ב - 32 רשויות ומועצות מקומיות ברחבי הארץ בהן משתתפים כ - 2,000 חניכות וחניכים בשנה, כולל קבוצות יעודיות לקהילה האתיופית, נוער דתי, נוער ערבי, נוער טרנס*, נערות וביסקסואליות, במוקדים שונים. בנוסף, הארגון מפעיל מועדוני נוער ובוגרים (19-23) ברחבי הארץ וקומונות שירות הפעולות הן במתכונת של שנת שירות והן כמסגרת שירות לאומי. בעשור הראשון לקיומו הארגון פעל בעיקר כמנגנון תמיכה מתוך תפיסה טיפולית, אולם בעשור השני עבר לפעול כארגון נוער חברתי לכל דבר, המעודד פיתוח מנהיגות, שינוי ועשייה חברתית. הפעילות עוסקת במקביל בתכנים הנוגעים לקהילה הגאה ובתכנים רחבים יותר כמו פמיניזם, אקטיביזם ומגדר. הנוער הפך לגורם מרכזי בעיצוב השיח הארגוני, והחל להוביל גם פעילות שטח, בין היתר דרך הקמת המטה ״אג׳נדה״ ב - 2015, שמתפקד כ״מועצת נוער״ שמובילה פעילויות של הסברה ואקטיביזם. החל מ - 2011 הארגון גם מפעיל בשיתוף עם השירות הפסיכולוגי חינוכי של משרד החינוך (שפ״י) את תוכנית ״ניר״ (ע״ש ניר כץ ז״ל) שנועדה לייצר מרחב שיוויוני ונקי מאלימות ולהט״בופובייה בבתי הספר.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'חינוך והשכלה'
      ],
      [
        'נערות וצעירות',
        'להט״ב'
      ],
      [
        'חינוך',
        'להט״ב'
      ]
    ],
    'id': 'LR7',
    'is_active': true,
    'keywords': [
      'גאווה',
      'תנועת נוער',
      'חינוך',
      'שירות לאומי',
      'תמיכה נפשית',
      'אקטיביזם',
      'נערות',
      'להט״בופוביה',
      'ערביות',
      'טרנסקסואלים'
    ],
    'name': 'איגי - ארגון נוער גאה',
    'name_ar': 'إيجي-منظمة الشبيبة المثلية',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'חינוך והשכלה',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-10-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://igy.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת איגי (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580426369'
      },
      {
        'title': 'בקר, אהוד (2015). <b>תוכניות להכרה וללימוד של זהות מגדרית שונה במערכת החינוך</b>. ירושלים: מרכז המחקר והמידע של הכנסת.'
      },
      {
        'title': 'מן, א\' (2018). <b>סיפור הפיכת ארגון ״איגי״ מארגון למען נוער לתנועת נוער אקטיביסטית</b>. עבודה בקורס ״תנועות פמיניסטיות בישראל״, אוניברסיטת בן-גוריון.'
      },
      {
        'title': 'פזמוני-לוי, אורן, שילה, גיא ופנחסי, בתיה (2011). בעקבות הזמן הוורוד: השוואה בין-דורית בין צרכים של נוער להט״בי לבין צורכיהם של להט״בים בוגרים. <b>מפגש לעבודה חינוכית-סוציאלית, 33</b>, 103–122.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '16/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2001,
    'year_registered': 2004
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '24/12/2018'
    },
    'description': '‏״אילה- ארגון יולדות לנשות השכונה״ (ע״ר 580296754) הוקמה בשנת 1997 במטרה לעזור לנשות שכונת הר נוף ‏שבירושלים בתקופת הריון, בשמירת הריון ואחרי לידה‎.‎',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ],
      [
        'דת ומעמד אישי',
        'בריאות ופריון'
      ],
      [
        'רווחה וקהילה',
        'כללי'
      ]
    ],
    'id': 'SW36',
    'is_active': true,
    'keywords': [
      'סיוע לאמהות',
      'גמ״ח'
    ],
    'name': 'אילה ארגון יולדות לנשות השכונה ‏',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אילה ארגון יולדות לנשות השכונה – עמותה רשומה: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580296754'
      },
      {
        'title': 'המדריך החרדי ירושלים – ספר טלפונים חרדי (2018–2019). <b>אילה - ארגון יולדות לנשות שכונת הר נוף בלבד</b>.נדלה מתוך',
        'url': 'http://mhb.co.il/magazine2019/index.html#XLIX/z'
      },
      {
        'title': 'מפתח הקהילות - מרכז החדשות, המידע, הקניות והפנאי של הציבור החרדי (ללא תאריך). מספר הטלפון של ‏אילה - ארגון יולדות לנשות שכונת הר נוף בלבד (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '24/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1997,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '16/05/2018'
    },
    'description': 'עמותת ״אשה לאשה״ נוסדה בשנת 1978 בירושלים כקבוצה פמיניסטית. בשנת 1982 החליטה להפעיל את המקלט לנשים מוכות בירושלים בשיתוף עם העירייה. המקלט אשר פועל בחסות ובפיקוח משרד העבודה והרווחה נקרא בתחילה ״בית ציפורה״ ובחצי השנה הראשונה לפעולתו חסו בו 65 נשים וכמאה ילדים בערך. ״בית ציפורה״ היתה עמותה רשומה (1984) שנמחקה. בשנותיו הראשונות, ״מתוך נאמנות למסורת הפמיניסטית ניהל את המקלט קולקטיב של שלוש נשים, בסיוע חמש מתנדבות.״ בשנת 1992 עבר המקלט לבית חדש, שנרכש ושופץ בידי ״הקרן לירושלים״. מיום היווסדו פועל המקלט למען רווחתן של נשים שנפגעו מאלימות מצד בני זוגן, ולמען ילדיהן, אשר גדלו בצל האלימות ונפגעו ממנה במישרין או בעקיפין. מטרות העמותה הן: (1) טיפול ישיר, מיידי ולאורך זמן בנשים ובילדיהן, קורבנות לאלימות בביתם. (2) העלאת המודעות החברתית לנושא האלימות במשפחה, חינוך למניעתה, ושינוי מדיניות הרשויות כלפיה. פעילויות העמותה כוללות: הפעלת מקלט לנשים, בית ילדים, דירות מעבר לנשים מוכות, תוכנית לשיקום קהילתי ולשכה לסיוע משפטי לנשים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YB39',
    'is_active': true,
    'keywords': [
      'אלימות במשפחה',
      'נשים מוכות',
      'מקלט',
      'ביטחון אישי',
      'פמיניזם',
      'דיור',
      'סיוע משפטי'
    ],
    'name': 'אישה לאישה, המקלט לנשים מוכות, ירושלים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': 'בית ציפורה',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.jerusalemshelter.org.il/web/8888/nsf/sbs.py?&_ID=15551&did=5552&G=15551&PF=1&lang=HE'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אשה לאשה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580007409'
      },
      {
        'title': 'ג\'יניאו, עפרה (2017, 27 יוני). אישה לאישה - תמונות ממעון לנשים מוכות. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-4981395,00.html'
      },
      {
        'title': 'ינאי, אורי (2005). מקלטי נשים בישראל: מחדשנות וולנטרית לאימוץ ממלכתי. <b>ביטחון סוציאלי, 70</b>, 77–109. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/SocialSecurity/70/article5.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '22/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1978,
    'year_registered': 1982
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '07/05/2018'
    },
    'description': '״אישית״ הוקמה על ידי נורית ורבין ב-2003 (ע״ר 580407377) תחת השם ״״מעלה - נשות רמת השרון״ במטרה לעודד יזמות עסקית בקרב נשים. שם העמותה שונה לשמה הנוכחי ב-2008. העמותה פועלת לסייע לנשים במצוקה כלכלית באמצעות קורסים להקניית ידע עסקי, ליווי אישי במהלך בניית עסק והרצתו וייעוץ משפטי במחיר סמלי.\nהעמותה אף מפעילה ומנהלת חנות יד שנייה לבגדים וכלי בית בשם ״בגדקפה״ ברמת השרון. הפעילות בחנות נעשית בהתנדבות והרווחים מפעילותה מיועדים למימון ההכשרות של העמותה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ]
    ],
    'id': 'YH49',
    'is_active': true,
    'keywords': [
      'העצמה',
      'רישות',
      'יזמיות',
      'מנטורינג',
      'יזמות עסקית',
      'עוני'
    ],
    'name': 'אישית - קידום נשים ליזמות עסקית',
    'name_ar': null,
    'name_change_year': 2008,
    'name_common': null,
    'name_past': 'מעלה - נשות רמת השרון',
    'name_replaced_by': null,
    'official_address': 'רמת השרון',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-07'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.esheet.org.il/index.php/he/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אישית – קידום נשים ליזמות עסקית (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580407377'
      },
      {
        'title': 'סגל, אסתי (2012, 31 אוקטובר). ממצוקה לעצמאות פיננסית. <b>סלונה</b>. נדלה מתוך',
        'url': 'http://saloona.co.il/blog/%D7%9E%D7%9E%D7%A6%D7%95%D7%A7%D7%94-%D7%9C%D7%A2%D7%A6%D7%9E%D7%90%D7%95%D7%AA-%D7%A4%D7%99%D7%A0%D7%A0%D7%A1%D7%99%D7%AA/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '07/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2003,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'שירותים משפטיים',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': '״איתך- َمَع ِك משפטניות למען צדק חברתי״ (ע״ר 580375582) הוקמה בשנת 2001 במטרה לפעול ל״קידום מעמד הנשים בישראל, פעולות לקידום צדק חברתי עבור נשים. העמותה פועלת למען נשים משכבות מוחלשות״. מייסדות העמותה כללו משפטניות בולטות וביניהן אורית קמיר, דפנה הקר, נטע זיו, נטע עמר שיף, סנאא חמוד-אבו סייף, ענת סרגוסטי, קלריס חרבון, רחל בנזימן ושרון אברהם-וייס. בפרסומי העמותה נאמר כי היא הוקמה על מנת לקדם השמעת קולן של נשים הנמצאות בשוליים החברתיים, הגיאוגרפיים, לאומיים, אתניים וכלכלייים בחברה בישראל. התפיסה של חברות העמותה היא כי על המשפט לכלול את זוויות המבט הייחודיות של נשים מכלל הקבוצות בחברה ולהבטיח את נגישותן המלאה למימוש זכויותיהן. כחלק מחזונה, עמותת איתך َمَع ِك פועלת לקידום שיח מגדרי רב תרבותי בקרב קהילות מזהויות מגוונות של נשים ערביות, חרדיות, יוצאות אתיופיה, דוברות רוסית ובתחומי העסקה רבים. יחד עם הנשים מהקהילות השונות, פועלת העמותה לפיתוח מנהיגות, תוך יצירת מודלים קהילתיים חדשניים, אשר תורמים ליצירת פרוייקטים פמיניסטיים ייחודיים ופורצי דרך בתחום המשפט. העמותה פועלת בשלושה מעגלי פעילות: הראשון, הפעלת קו סיוע וייצוג משפטי בתחומי דיני עבודה וביטוח לאומי עבור נשים החיות בעוני. הקו מופעל בשפות עברית, ערבית ורוסית. המעגל השני הוא פעילות ומנהיגות בקהילות מגוונות - מתן כלים ועידוד מנהיגות בקרב קהילות של נשים לטובת עיצוב משותף של מדיניות המיטיבה את מצבן. המעגל השלישי הוא פעילות לשינוי מדיניות מתוך ראיית הצרכים של נשים ממגוון הקבוצות המוחלשות בחברה - עבודה במישור הארצי והמוניצפאלי על ידי עיצוב תכניות פעולה לאומיות, הגשת הצעות חוק, עבודה מול משרדי ממשלה שונים והגשת עתירות לבג״ץ.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'כללי'
      ]
    ],
    'id': 'YB63',
    'is_active': true,
    'keywords': [
      'בדואיות',
      'דיור',
      'החלטה 1325',
      'זכויות',
      'חרדיות',
      'עוני',
      'פמיניזם משפטי',
      'צדק חברתי',
      'קו סיוע',
      'מעונות ומשפחתונים'
    ],
    'name': 'איתך-מעכי - משפטניות למען צדק חברתי',
    'name_ar': 'معكِ – حقوقيات من أجل العدالة الإجتماعية',
    'name_change_year': 2008,
    'name_common': null,
    'name_past': 'איתך- משפטניות למען צדק חברתי',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'שירותים משפטיים',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.itach.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>איתך-מעכי – משפטניות למען צדק חברתי (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580375582'
      },
      {
        'title': 'אברמוביץ, דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות',
      'נשים מזרחיות',
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '18/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2001,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': 'עמותת ״אל הלב״ (ע״ר 580416634) הוקמה ב-2003 במטרה להעצים נערות ונשים המעוניינות לעסוק באומנויות לחימה ולהסיר את שלל החסמים העומדים בפניהן, מתוך כוונה לתרום ליצירת אקלים חברתי של שוויון הזדמנויות. מטרות העמותה המעודכנות הן: ״הקניית מיומנויות בטיחות אישית והגנה עצמית מעצימה לילדות/ים, בני/ות נוער, צעירות/ים, נשים ומבוגרות/ים, קשישות/ים ואנשים בעלי צרכים מיוחדים, תוך שאיפה למניעת אלימות לסוגיה וצמצום השלכותיה, בקרב כל מגזרי החברה ובפריסה ארצית, לרבות הפריפריה החברתית-גיאוגרפית, כמובילת התנועה העולמית להגנה עצמית מעצימה בישראל״. העמותה נוסדה במטרה להנגיש חוגים, אימונים והכשרות לנשות מקצוע תוך שיתוף פעולה עם בתי ספר ומסגרות חינוכיות במטרה לעודד קורסים של הגנה עצמית לנשים ונערות. עם השנים התפתחו מטרותיה המקוריות של ״אל הלב״ והארגון יצר מערך ארצי של הכשרה, הדרכה, פיתוח תכניות, חינוך והסברה. התכניות השונות שמפעיל הארגון עוסקות בצמצום ומניעת אלימות פיזית, מינית, רגשית וכלכלית המופנית כלפי ילדים, בני נוער, נשים, אנשים עם מוגבלויות וקשישים מכל מגזרי החברה הישראלית. כיום פועלת העמותה בקרב מאות ארגונים, רשויות מוניציפאליות, חברות עסקיות, עמותות ומוסדות חינוך, בריאות ורווחה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'חינוך',
        'מניעת אלימות'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ],
      [
        'תרבות וספורט',
        'ספורט'
      ]
    ],
    'id': 'YB62',
    'is_active': true,
    'keywords': [
      'תקיפה מינית',
      'הגנה עצמית',
      'דימוי גוף',
      'נערות וצעירות'
    ],
    'name': 'אל הלב - איגוד לאומנויות הלחימה לנשים בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'חינוך',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מניעת אלימות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.elhalev.org/women-self-defense?gclid=Cj0KCQjwlv_XBRDrARIsAH-iRJS2SHNdwoLYkwsDWBLIcyWMwcbU6duAhg7jR8Tzw_0ZWJJDiIK5CUAaAks8EALw_wcB'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אל הלב (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580416634'
      },
      {
        'title': 'אל הלב, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/elhalev/'
      },
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל. עמ\' 24–25.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2003,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '18/01/2019'
    },
    'description': '״אלאסאלה לפעילות חברתית-קהילתית״ היא עמותה (ע״ר 580571719) שנוסדה בשנת 2013 בוואדי סלמה. מטרות העמותה הן: ״הפעלת מעונות יום רגילים ושיקומיים. הפעלת צהרונים, גני ילדים, משפחתונים. טיפול בילד ובאישה. הפעלת מסגרות התנדבות חברתית קהילתית. הפעלת שירות לאומי. קידום מעמד האישה בחברה הבדואית בפרט והערבית בכלל. הפעלת מסגרות לקשישים. טיפוח דו קיום ופעילות חברתית וקהילתית בין הנשים באזור הצפון.״ העמותה מפעילה מרכז לגיל הרך ועורכת פעילות חברתית וימי כיף ואירועים לאמהות וילדים. יש תיעוד לפעילות העמותה בפייסבוק ובאתר רשם העמותות עד לשנת 2016.',
    'description_ar': 'مركز الاصالة للنشاطات الاجتماعية-الجماهيرية״- هي جمعية (ج.م 580571719) التي تأسست عام 2013 في وادي سلامة. أهدافها: تشغيل مراكز الرعاية النهارية العادية والتأهيلية. تشغيل رياض الأطفال والمنازل العائلية. رعاية طفل وامرأة. تمكين أطر التطوع الاجتماعي المجتمعي. تشغيل خدمة وطنية. تعزيز مكانة المرأة في المجتمع البدوي بشكل خاص والعربية بشكل عام. تشغيل إطارات للمسنين. تعزيز التعايش والأنشطة الاجتماعية والمجتمعية بين النساء في منطقة الشمال״. تدير الجمعية مركزًا لمرحلة ما قبل المدرسة وتجري أنشطة اجتماعية وأيامًا وفعاليات ممتعة للأمهات والأطفال. تم توثيق أنشطته على الفيسبوك وعلى الموقع الخاص بالمنظمات غير الربحية حتى عام 2016.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'חינוך',
        'הגיל הרך'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'YA6',
    'is_active': true,
    'keywords': [
      'אמהות',
      'פנאי',
      'ילדים',
      'בדואיות'
    ],
    'name': 'אלאסאלה - לפעילות חברתית קהילתית',
    'name_ar': 'مركز الأصالة',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'סלמה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'חינוך',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הגיל הרך',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אלאסאלה לפעילות חברתית-קהילתית (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580571719'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '25/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '17/01/2019'
    },
    'description': '״אל-בדיל״ (״האלטרנטיבה״) נוסדה בשנת 1994 כקואליציה של ארגונים ופעילים למאבק בפשע ״כבוד המשפחה״. הקואליציה פעילה בעיקר בצפון ובמשולש ועסקה בתיעוד מקרי רצח של רצח נשים ערביות על רקע כבוד המשפחה ובהעלאת מודעות לתופעה בקרב הרשויות בישראל. הקואליציה דרשה שינויי חקיקה ואכיפה לשם הגברת ההגנה על נשים ונערות מפני רצח והשתתפה בדיונים בכנסת, בהכשרות שוטרים ובהעלאת מודעות ציבורית לנושא זה. בין הארגונים שנטלו חלק בפעילות הקואליציה היו: נשים נגד אלימות, אל-סיואר, האגודה הערבית לזכויות האדם, אל-טופולה, כייאן, מעון לנשים חיפה, תנד״י ועוד.',
    'description_ar': 'الائتلاف البديل لمحاربة جريمة شرف العائلة. تأسست عام 1994 كائتلاف بين المنظمات والناشطين لمكافحة الجريمة ״شرف العائلة״. ينشط التحالف بشكل اساسي في الشمال وفي المثلث، ويتعامل مع توثيق حالات قتل النساء العربيات على أساس شرف العائلة وزيادة الوعي حول الظاهرة لدى السلطات الإسرائيلية. طالب التحالف بتغييرات تشريعية وتطبيقية لزيادة حماية النساء والفتيات من القتل والمشاركة في مناقشات الكنيست وتدريب الشرطة وتوعية الجمهور بهذه القضية. بين المنظات المشاركة في الائتلاف: نساء ضد العنف، السوار، الاتحاد العربي لحقوق الانسان، الطفولة، كيان، ملجأ نساء حيفا، نساء ديمقراطيات وغيرهم.',
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YA2',
    'is_active': false,
    'keywords': [
      'אלימות במשפחה',
      'האמנה לביעור כל צורות ההפליה נגד נשים 1979 CEDAW',
      'בדואיות',
      'דרוזיות',
      'חקיקה',
      'משטרה',
      'רצח נשים',
      'מידע',
      'קואליצייה'
    ],
    'name': 'אלבדיל',
    'name_ar': 'ائتلاف البديل لمحاربة جريمة ״ شرف العائلة״',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נצרת',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (1997, 20 מאי). <b>פרוטוקול מס\' 51: רצח על רקע כבוד המשפחה ויחס המשטרה ובתי המשפט לתופעה זו</b>. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/14/Committees/14_ptv_478343.PDF'
      },
      {
        'title': 'Islam and Human Rights Fellowship Program (n.d). <b>Regional human rights organizations – Middle East</b>. Retrieved from',
        'url': 'https://scholarblogs.emory.edu/islam-humanrights-fellowship/research/rights-organizations/regional-human-rights-organizations-middle-east/'
      },
      {
        'title': 'Swirski, Barbara (2000). The citizenship of Jewish and Palestinian Arab women in Israel. In Suad, Joseph (Ed.) <b>Gender and citizenship in the Middle East</b> (pp. 314-344). Syracuse, NY: Syracuse University Press.'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '19/02/2019'
    },
    'year_closed': 2007,
    'year_closed_text': '2007',
    'year_founded': 1994,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '19/01/2019'
    },
    'description': '״אלביר- לטיפוח התרבות והקהילה בוואדי ערה״ (ע״ר 580460285) היא עמותה שנוסדה בשנת 2007 בערערה. מטרות העמותה הן: ״טיפוח היכולות הנשיות והעמדתן לשירות הקהילה. הרחבת קשת העשייה וההשפעה של הנשים על המרקם החברתי. יצירת מרחב תומך מכיל ומחזק לנשים. חיזוק וטיפוח השורשים, המסורת והתרבות המקומית והגדלת מרחב האפשרויות לביטוי ועשייה בתחומים אלו.״ העמותה יוזמת תערוכות אמנות, סדנאות וקורסים לצילום ומקדמת מנהיגות מקומית תוך הנחלת התרבות והזהות פלסטינית. קהל היעד הוא נשים, גברים ונוער.',
    'description_ar': 'جمعية ״البير״ لتنمية الثقافة والمجتمع في وادي عارة (ج.م 580460285) تأسست عام 2007 في عرعرة المثلث. بهدف تطوير القدرات النسائية وتزويدهن بالخدمات الاجتماعية. توسيع نطاق نشاط المرأة وتأثيرها على النسيج الاجتماعي. خلق مساحة داعمة للنساء. تعزيز ورعاية الجذور والتقاليد المحلية والثقافة، وزيادة إمكانيات التعبير والعمل في هذه المجالات. تقوم الجمعية بإدارة ورش عمل حول مخاطر الخدمة المدنية، وتنظيم المسيرات ״مسيرة العودة״، وتنظيم ورش العمل ودورات تصوير فوتوغرافي. تتطرق الجمعية بفعاليتها للجانب التربوي والثقافي بالتشديد على الجانب السياسي، جمهور الهدف لهذه الجمعية هم نساء ورجال.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'אמנות'
      ]
    ],
    'id': 'YA7',
    'is_active': true,
    'keywords': [
      'תרבות',
      'אמנות',
      'תיאטרון',
      'מנהיגות',
      'סיורים'
    ],
    'name': 'אלביר- לטיפוח התרבות והקהילה בוואדי ערה',
    'name_ar': 'جمعية البير - لتنمية الثقافة والمجتمع',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ערערה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אמנות',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-01-19'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.facebook.com/pg/%D8%AC%D9%85%D8%B9%D9%8A%D8%A9-%D8%A7%D9%84%D8%A8%D9%8A%D8%B1-%D9%84%D8%AA%D9%86%D9%85%D9%8A%D8%A9-%D8%A7%D9%84%D8%AB%D9%82%D8%A7%D9%81%D8%A9-%D9%88%D8%A7%D9%84%D9%85%D8%AC%D8%AA%D9%85%D8%B9-266339386716339/posts/?ref=page_internal'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אלביר – לטיפוח התרבות והקהילה בוואדי ערה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580460285'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '25/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2007,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '20/11/2018'
    },
    'description': 'אלה היא אשפוזית יחידה מסוגה אשר הוקמה בשנת 2015 על מנת לספק מענה מיידי ושהות של עד שלושה חודשים לנערות וצעירות בגילאים 14-30 המכורות לסמים או אלכוהול. האשפוזית הוקמה על ידי עמותת רטורנו המפעילה מערך של מרכזי גמילה לאוכלוסיות שונות ונמצאת תחת פיקוח של משרד הבריאות. הצוות המפעיל את האשפוזית הינו מעורב וכולל דתיים וחילוניים וכך גם המטופלות. האשפוזית ממוקמת בבית שמש אך מספקת שירות לנערות וצעירות מרחבי הארץ.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'נערות וצעירות',
        'בריאות'
      ]
    ],
    'id': 'YH150',
    'is_active': true,
    'keywords': [
      'התמכרות',
      'גמילה',
      'אשפוז',
      'טיפול נפשי',
      'אלימות',
      'אלימות מינית'
    ],
    'name': 'אלה לנשים ונערות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'בית שמש',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'התמכרויות ושיקום',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-11-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://retorno.org.il/%D7%94%D7%9E%D7%97%D7%9C%D7%A7%D7%94-%D7%9C%D7%92%D7%9E%D7%99%D7%9C%D7%94-%D7%95%D7%9C%D7%94%D7%A2%D7%A6%D7%9E%D7%94-%D7%A0%D7%A9%D7%99%D7%AA/'
      },
      {
        'title': 'אשפוזית אלה רטורנו, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/profile.php?id=100025717463087&lst=653321500%3A100025717463087%3A1542710516'
      },
      {
        'title': 'הוועדה המיוחדת למאבק בנגעי הסמים והאלכוהול (2016, 23 יוני). <b>פרוטוקול מס\' 43: סיור ברטורנו</b>. נדלה מתוך',
        'url': 'https://oknesset.org/meetings/2/0/2004105.html'
      },
      {
        'title': 'מפתח התקציב (2018). <b>התקשרות עם רטורנו – אלה – הפעלת אשפוזית גמילה לנוער: בקשת פטור ממכרז. משרד הבריאות -> עמותת נוה מלכישוע</b>. נדלה מתוך',
        'url': 'https://next.obudget.org/i/tenders/exemptions/608842/none?li=0'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '25/02/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '19/01/2019'
    },
    'description': 'אלהודא אלנסאא\'יה – רינה (ע.ר. 580373108) נוסדה בשנת 2001 בכפר רינה בגליל. מטרות העמותה כללו פעילות לקידום מעמד האישה במגזר הערבי, עזרה לנזקקים ולנכים. לא נמצאו דוחות רשמיים של העמותה ובשנת 2019 היא נמחקה סופית מפנקס העמותות. יחד עם זאת, מאז שנת 2013 קיים דף פייסבוק שממנו נראה שהעמותה מקיימת פעילות מקומית ומארגנת סדנאות של לימודי קוראן, כלכלת בית, שילוב קריירה ומשפחה, סדנאות פרחים, טיולים וכו\'. בנוסף, חברות העמותה מחלקות תרומות של מזון ובגדים.',
    'description_ar': 'جمعية الهدى النسائية- الرينة (ج.م 580373108) تأسست في عام 2001 في قرية الرينة في الجليل. تضمنت أهداف الجمعية أنشطة لتعزيز مكانة المرأة في المجتمع العربي ومساعدة المحتاجين والمعاقين. لم يتم العثور على أي تقارير رسمية للجمعية وفي عام 2019 تم حذفها بشكل دائم من سجل الجمعيات. ومع ذلك، فمنذ عام 2013، توجد صفحة على فيسبوك يبدو من خلالها أن الجمعية تقوم بإجراء أنشطة محلية وتنظيم دراسات القرآن، والاقتصاد المنزلي، والتكامل المهني والعائلي، وورش عمل الزهور ورحلات، إلخ. بالإضافة إلى ذلك، تتبرع مشاركات الجمعية بطرود الغذائية والملابس.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'השכלה'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'YA8',
    'is_active': false,
    'keywords': [
      'דת',
      'אסלאם',
      'פנאי',
      'סיורים',
      'גמ״ח'
    ],
    'name': 'אלהודא אלנסאא\'יה - רינה',
    'name_ar': 'جمعية الهدى النسائية - الرينة',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ריינה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'השכלה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2017-01-19'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.facebook.com/ALHODAY.ELRENI/'
      },
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>אלהודא אלנסאא\'יה - רינה</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 8190 (2019, 7 אפריל). <b>הודעה סופית בדבר מחיקה מפנקס העמותות</b>. אלהודא אלנסאא\'יה – רינה (עמותה מספר 580373108). עמ\' 9684. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_word/Law10/yalkut-8190.pdf'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '19/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': '2018',
    'year_founded': 2001,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '16/09/2019'
    },
    'description': 'עמותת ״אלואפא ואל אמל״ נוסדה בבאקה אל-גרבייה בשנת 1983 ונרשמה כעמותה (ע״ר 580056331) שמטרתה לפעול למען רווחה וחברת הציבור, לרבות קידום מעמד האשה. העמותה פועלת לגיוס כספים והענקת מלגות לסטודנטיות וסטודנטים הנוטלים חלק בפעילויות קהילתיות וחינוכיות. בנוסף, העמותה מסייעת בפעילויות צדקה ודת, עזרה לנזקקים, שיעורי לימוד וקורסים שונים לנשים (תפירה, רקמה וכדומה).',
    'description_ar': 'جمعية الوفاء والامل تأسست في باقة الغربية عام 1983 وسجلت كجمعية (ج.م 580056331) وأهدافها العمل من اجل الرفاه والمجتمع المدني ولزيادة تعزيز مكانة المرأة. تعمل الجمعية بهدف تجنيد الأموال وتقديم منح للطالبات والطلاب الذين يتطوعون في المشاريع الجماهيرية والتربوية، إضافة الى ذلك تساعد الجمعية في الأنشطة الخيرية والدينية، وتساعد المحتاجين، دروس تعليمية ودورات مختلفة للنساء (الخياطة والتطريز وما شابه).',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'חינוך',
        'צמצום פערים בחינוך'
      ],
      [
        'רווחה וקהילה',
        'כללי'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'SA155',
    'is_active': true,
    'keywords': [
      'דת',
      'צדקה',
      'גמ״ח',
      'מלגות',
      'קידום מעמד האשה',
      'אסלאם'
    ],
    'name': 'אלופא ואל אמל ״ג\'מעיה נישאיה ח\'ירייה״',
    'name_ar': 'جمعية الوفاء والأمل',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באקה אל-גרביה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'חינוך',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'צמצום פערים בחינוך',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אלופא ואל אמל ״ג\'מעיה נישאיה ח\'ירייה״ (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580056331'
      },
      {
        'title': 'جنان عبده. (2008). الجمعيّات النسائيّة والنسويّة الفلسطينيّة- في مناطق 48, مدى الكرمل'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '16/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1983,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '19/01/2019'
    },
    'description': '״אלזהראא - עמותה לקידום מעמד האשה״ (ע.ר.580307817) היא עמותה שנוסדה בשנת 1997 בסח\'נין. מטרות העמותה הן ״קידום מעמד האישה הערביה בחברה ובמשפחה הישראלית בכל התחומים. מניעת אלימות על כל אופניה - פיזית, נפשית, מילולית ומינית. קידום זכויות האשה הן בחברה והן במשפחה.״ פעילות העמותה מתמקדת בסח\'נין ואזור הגליל. העמותה מפעילה מרכז לנשים בעיר ומקיימת סדנאות, הרצאות וקורסים בתחום של העצמת נשים, בריאות, הכנת נשים ליציאה לשוק העבודה ומעורבות בקהילה.',
    'description_ar': 'الزهراء- جمعية للنهوض بمكانة المرأة (ج.م .580307817) هي جمعية تأسست عام 1997 في سخنين. أهداف الجمعية هي ״تعزيز مكانة المرأة العربية في المجتمع والأسرة الإسرائيلية في جميع المجالات. منع العنف بجميع أشكاله – الجسدية، النفسية، اللفظية والجنسية. تعزيز حقوق المرأة في المجتمع والأسرة״. تتركز أنشطة الجمعية في سخنين ومنطقة الجليل. تدير الجمعية مركزًا نسائيًا في المدينة وتجري ورش عمل ومحاضرات ودورات في مجال تمكين المرأة، الصحة وتجهيز النساء للخروج إلى سوق العمل والتداخل الاجتماعي.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תעסוקה ועבודה',
        'השמה וליווי בתעסוקה'
      ]
    ],
    'id': 'YA9',
    'is_active': true,
    'keywords': [
      'אלימות',
      'הכשרה מקצועית',
      'העצמה',
      'רישות',
      'פריפריה',
      'קידום נשים'
    ],
    'name': 'אלזהראא- עמותה לקידום מעמד האשה',
    'name_ar': 'الزهراء - للنهوض بمكانة المرأة',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'סח\'נין',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-01-19'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.facebook.com/pg/Al-Zahraa-Organization-for-the-Advancement-of-Women-519848188210580/posts/?ref=page_internal'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אלזהראא – עמותה לקידום מעמד האשה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580307817'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '19/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1997,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '19/01/2019'
    },
    'description': 'אלח״ה הוקמה ב-1993 על ידי עולות מחבר העמים. ברשם העמותות נקראת ״אגודה למשפחות חד הוריות הזקוקות לסיוע״ ובמקורות אחרים (הדוקטורט של ענת הרבסט למשל) ״אגודה ישראלית למשפחות חד הוריות הנמצאות במצוקה״. מטרות רשמיות: ״עזרה למשפחות חד הורית במציאת דיור, בקניית אוכל, ביגוד וספרי לימוד לילדים. מפגשים של משפחות חד הוריות״. נראה שהפסיקה לפעול ב-2003. נמחקה סופית ב-2018.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ],
      [
        'הגירה',
        'קליטת עלייה'
      ]
    ],
    'id': 'YH180',
    'is_active': false,
    'keywords': [
      'אמהות גרושות',
      'עולות מברה״מ',
      'סיוע כלכלי',
      'דיור'
    ],
    'name': 'אלח״ה - אגודה למשפחות חד הוריות הזקוקות לסיוע',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים עולות מחבר העמים',
    'retrieved': null,
    'sources': [
      {
        'title': '(2001, 21 אוגוסט). עצומה להורדת תשדיר שירות של אגודת אלח״ה בערוץ 2. <b>וואלה!NEWS</b>. נדלה מתוך',
        'url': 'https://news.walla.co.il/item/106637'
      },
      {
        'title': 'הרבסט, ענת (2007). <b>מ״עלובת הנפש במשפחה שבורה״ לזעקת קול אם״. אמהות חד הוריות בישראל- מדיניות הרווחה, שיח ולגיטימציה, 1972–2003</b> (חיבור לשם קבלת תואר ״דוקטור לפילוסופיה״). אוניברסיטת בר-אילן, רמת גן.'
      },
      {
        'title': 'סבירסקי, שלמה, קראוס, ורד, קונור-אטיאס, אתי והרבסט, ענת (2002). אמהות חד הוריות בישראל. <b>מידע על שוויון, 12</b>. מרכז אדוה.',
        'url': 'http://adva.org/wp-content/uploads/2014/09/gil12.pdf'
      }
    ],
    'target_audiences': [
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '19/01/2019'
    },
    'year_closed': 2003,
    'year_closed_text': '2003',
    'year_founded': 1993,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/11/2018'
    },
    'description': 'עמותת ״אליסקוד -בנות לומדות תכנות״ (ע״ר 580633733) הוקמה בשנת 2016 למען קידום ילדות ונערות, להשתלבותן במקצועות טכנולוגיים ולהעלאת המודעות לחשיבות לימודי טכנולוגיה בכלל האוכלוסיה והטמעת לימוד טכנולוגיה בגילאים צעירים. העמותה מפעילה את המיזם ״בנות לומדות תכנות״ בשיתוף פעולה עם עיריית ראשון לציון שנועדה לקדם תלמידות בחינוך היסודי (כיתות ד\'-ו\') בתחום הטכנולוגי. העמותה מכשירה מדריכות - תלמידות תיכון ממגמות מדעי המחשב - שעברו הכשרה מקיפה על נושאים מקצועיים ונושאי הדרכה בליווי מהנדסות תוכנה ומקיימת פעילויות העשרה שכוללות סיורים בחברות הי-טק והאקאתונים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'חינוך'
      ],
      [
        'חינוך',
        'מדע וטכנולוגיה'
      ],
      [
        'תעסוקה ועבודה',
        'הכשרה מקצועית'
      ]
    ],
    'id': 'SA88',
    'is_active': true,
    'keywords': [
      'תכנות',
      'הכשרה מקצועית',
      'מדע וטכנולוגיה',
      'נערות'
    ],
    'name': 'אליסקוד- בנות לומדות תכנות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ראשון לציון',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'חינוך',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-11-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.alicecode.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אליסקוד – בנות לומדות תכנות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580633733'
      },
      {
        'title': 'מנהל החינוך, עיריית ראשון לציון (ללא תאריך). <b>אליסקוד – בנות לומדות תיכנות</b>. נדלה מתוך',
        'url': 'http://www.rlz-edu.org.il/?CategoryID=1226&ArticleID=2464'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': 'עמותת אלמנהאל (ע.ר. 580342228) הוקמה בשנת 1999 באבו-סנאן במטרה לפעול לשם ״עידוד השכלה גבוהה אצל נשים דרוזיות. שיפור וקידום מעמד האישה הדרוזית ועידוד מעורבותה בחברה. עידוד וסיוע למשפחות שכולות, אלמנות ונשים מוכות.״ פעילות העמותה כוללת ארגון של כנסים, ימי עיון, הרצאות וסיורים בישראל לנשים דרוזיות לשם העמקת המורשת והדת דרוזית. ככל הנראה עיקר סיורי העמותה מכוונים לביקור במקומות קדושים לעדה הדרוזית.',
    'description_ar': 'جمعية المناهل (ج.م 580342228) تأسست عام 1999 في قرية أبو سنان بهدف تشجيع الدراسات العليا لدى النساء الدرزيات. تحسين وتمكين',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ],
      [
        'דת ומעמד אישי',
        'השכלה'
      ]
    ],
    'id': 'YB67',
    'is_active': true,
    'keywords': [
      'אלמנות',
      'דרוזיות',
      'דת',
      'השכלה',
      'אלימות'
    ],
    'name': 'אלמנאהל - עמותה למען קידום הנשים הדרוזיות',
    'name_ar': 'المناهل جمعية لتطوير مكانة المرأة الدرزية',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'אבו סנאן',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אלמנאהל – עמותה למען קידום הנשים הדרוזיות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580342228'
      },
      {
        'title': 'דנסגייד (ללא תאריך). <b>אלמנאהל - עמותה למען קידום הנשים הדרוזיות (ע״ר)</b>. נדלה מתוך',
        'url': 'https://www.dunsguide.co.il/C65e43562ac343fab86490d8eaf76e96b_%D7%90%D7%99%D7%92%D7%95%D7%93%D7%99%D7%9D_%D7%9E%D7%A7%D7%A6%D7%95%D7%A2%D7%99%D7%99%D7%9D/%D7%90%D7%9C%D7%9E%D7%A0%D7%90%D7%94%D7%9C_%D7%A2%D7%9E%D7%95%D7%AA%D7%94_%D7%9C%D7%9E%D7%A2%D7%9F_%D7%A7%D7%99%D7%93%D7%95%D7%9D_%D7%94%D7%A0%D7%A9%D7%99%D7%9D_%D7%94%D7%93%D7%A8%D7%95%D7%96%D7%99%D7%95%D7%AA_%D7%A2%D7%A8/'
      },
      {
        'title': 'רוח טובה (ללא תאריך). <b>אלמנאהל: עמותה לקידום הנשים הדרוזיות</b>. נדלה מתוך',
        'url': 'http://ruachtova.ynet.co.il/ynet/orgdetails.asp?id=3556'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '09/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': 1999
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '28/01/2019'
    },
    'description': 'עמותת אלמעאלי להכוון חברתי (ע״ר 580600153) נוסדה בשנת 2014, במטרה להביא ל״עידוד, עזרה ותמיכה להעמקת ההשכלה הגבוהה בקרב נשים ערביות והגברת מעורבותן בחיי החברה. הרחבת מעגל ההשכלה העל תיכונית בקרב נשים ערביות ופיתוח תודעה על השתלבות ושותפות בחיי משפחה, כלכלה ותעסוקה, הנגשת השכלה שלשונית על תיכונית בקרב נשים וגברים בתוך יריעה של מסלולים : חינוך לקריירה, התמקצעות ונגישות להשכלה גבוהה ופיתוח מקצועי. עידוד רכישת השכלה גבוהה באמצעות חלוקת מלגות לסטודנטים לפי חוק חלוקת מלגות וקיום פעילות הכוונה לנרשמים ללימודים באוניברסיטאות״. העמותה מקיימת תכניות, הרצאות וקורסים הקשורים להכוונה אקדמית וגם מחלקת מלגות לסטודנטים. קהל היעד הינו נשים וגברים כאחד.',
    'description_ar': 'جمعية المعالي للتغيير المجتمعي (ج.م 580600153) تأسست عام 2014 بهدف تشجيع، مساعدة ودعم التعليم العالي لدى النساء العربيات وزيادة اندماجهن في الحياة الاجتماعية. توسيع دائرة التعليم الجامعي لدى النساء العربيات، وتنمية الوعي على الاندماج والشراكة في الحياة الاسرية، الاقتصاد والتوظيف، خلق فرص التعليم العالي للنساء والرجال في مسارات متنوعة: التعليم المهني، الاحتراف والوصول للتعليم العالي والتطوير المهني. التشجيع على اكتساب التعليم العالي من خلال توزيع منح تعليمية للطلاب بموجب قانون توزيع المنح الدراسية وعقد أنشطة التحاق الطلاب المنتسبين للجامعة. للجمعية برامج، محاضرات ومساقات المتعلقة في التوجيه الأكاديمي وقسم المنح للطلاب وجمهور الهدف هم نساء ورجال على حد سواء.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'חינוך',
        'צמצום פערים בחינוך'
      ],
      [
        'תעסוקה ועבודה',
        'השמה וליווי בתעסוקה'
      ]
    ],
    'id': 'YA10',
    'is_active': true,
    'keywords': [
      'השכלה',
      'מלגות'
    ],
    'name': 'אלמעאלי להכוון חברתי',
    'name_ar': 'جمعية المعالي للتغير المجتمعي',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'אום אל-פחם',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'חינוך',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'צמצום פערים בחינוך',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-01-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.elmaaly.org/news/news/27/%D9%85%D9%86-%D9%86%D8%AD%D9%86.html'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אלמעאלי להכוון חברתי (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580600153'
      }
    ],
    'target_audiences': [
      'נשים ערביות',
      'גברים'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '28/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '28/06/2018'
    },
    'description': '״העמותה לקידום השכלת נשים בדואיות בנגב״ הוקמה  בשנת 1997 בבאר שבע על ידי ערבים ויהודים ונרשמה כעמותה בשנת 1998 (ע״ר 580319655). העמותה הוקמה במטרה לעודד ולקדם השכלה בכלל והשכלה גבוהה בפרט לנשים ונערות בדואיות בנגב על מנת להביא לשילובן המוצלח בחברה הישראלית ולשיפור מעמדן בקהילה. מטרות העמותה הן: ״עידוד והעמקת השכלה לנשים בדואיות מהגיל הרך ועד לאקדמיה. פעולות להכרה בזכות ההשכלה לנשים וחשיבותה. ישום תכניות להכשרה מקצועית לנשים הבדואיות המתאימות למאפייני הקהילה.״  מדי שנה מפעילה העמותה פרוייקטים בבאר שבע ובישובים הבדואים בנגב שבהם משתתפים כ-1,000 נערות, נשים ונערים בדואים. חזון העמותה מושתת על תפיסה הומניסטית מערכתית ועל יצירת מעגלי תמיכה ודגש על התחום החינוכי והאקדמי, החברתי, התרבותי, והזהות האישית. פעילויות העמותה כוללות ייזום תוכניות להכשרה מקצועית והשכלה המתאימות לאפיוני הקהילה הבדואית בנגב ולצרכיה באמצעות מתן מלגות, פרויקט חונכות ופרויקט לנוער.',
    'description_ar': 'جمعية النهوض بثقافة المرأة العربية في النقب- تأسست في عام 1997 في بئر السبع من قبل العرب واليهود، وقد تم تسجيلها كجمعية في عام 1998 (ج.م 580319655(تأسست الجمعية لتشجيع وتعزيز التعليم بشكل عام والتعليم العالي وخاصة للفتيات البدويات من أجل تحقيق اندماج ناجح في المجتمع الإسرائيلي وتحسين وضعهم في المجتمع. أهداف الجمعية هي: ״تشجيع وتعزيز اهمية التعليم للنساء البدويات من مرحلة ما قبل المدرسة وحتى الأكاديمية. بالإضافة للعمل من اجل الاعتراف بحق المرأة في التعليم وأهميته. تنفيذ برامج التدريب المهني للنساء البدويات بما يتماشى مع خصائص المجتمع. في كل عام، تنشط الجمعية مشاريع في بئر السبع والقرى البدوية في النقب، حيث يشارك حوالي 1000 فتاة وشاب بدوي. تعتمد رؤية الجمعية على مفهوم إنساني منهجي وعلى إنشاء دوائر دعم والتأكيد على الهويات التعليمية، الأكاديمية، الاجتماعية، الثقافية والشخصية. تشمل أنشطة الجمعية الشروع في برامج للتدريب والتعليم المهني تتناسب مع خصائص المجتمع البدوي في النقب واحتياجاته من خلال توفير المنح الدراسية ومشروع التوجيه ومشروع الشباب.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'חינוך',
        'צמצום פערים בחינוך'
      ],
      [
        'תעסוקה ועבודה',
        'הכשרה מקצועית'
      ]
    ],
    'id': 'YH36',
    'is_active': true,
    'keywords': [
      'בדואיות',
      'השכלה',
      'מלגות',
      'הכשרה מקצועית'
    ],
    'name': 'העמותה לקידום השכלת נשים בדואיות מחינוך לגיל הרך עד האקדמיה',
    'name_ar': 'جمعية النهوض بثقافة المرأة العربيه في النقب',
    'name_change_year': null,
    'name_common': 'אלנוהוד',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'חינוך',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'צמצום פערים בחינוך',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-06-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://alnuhud97.wordpress.com/about/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>העמותה לקידום השכלת נשים בדואיות מחינוך לגיל הרך עד האקדמיה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580319655/documents'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '11/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1997,
    'year_registered': 1998
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': '״אלסיואר- תנועה פמיניסטית ערבית״ היא עמותה (ע.ר. 580296283) שמטרותיה הן: ״מתן תמיכה לנפגעות תקיפה מינית. מאבק נגד פשעי האלימות המינית נגד נשים. הגברת המודעות בחברה בנושא האלימות המינית לנשים.״ העמותה פועלת בחיפה משנת 1997 ומשרתת את הציבור הערבי-פלסטיני, במיוחד באזור הצפון והמרכז באמצעות הפעלת קו תמיכה וסיוע טלפוני המספק מענה 24 שעות, הפעלת סדנאות חינוכיות בבתי ספר, הכשרת אנשי מקצוע, יצירת קמפיינים תקשורתיים ופרסום מידע בערוצים שונים. אלסיואר נאבקת נגד כל סוגי הדיכוי והניצול הפטריארכלי, הכלכלי, הלאומי והאתני ומחויבת לשחרר ולהעצים נשים מקבוצות שוליות ופגיעות בחברה. בהתאם לכך, אל-סיואר רואה בפמיניזם תנועה מהפכנית חברתית-פוליטית המבקשת לשנות את יחסי הכוח והשליטה השוררים בחברה ולתמוך בקידום סוגיות הנוגעות למעמד האשה הפלסטינית.',
    'description_ar': 'السوار- حركة نسوية عربية״ هي جمعية (ج.م. 580296283) التي أهدافها هن: ״إعطاء دعم لضحايا التحرش الجنسي. مكافحة جرائم العنف الجنسي ضد النساء. رفع المعرفة في المجتمع حول موضوع العنف الجنسي عند النساء. ״الجمعية تعمل في حيفا منذ عام 1997 وتخدم المجتمع العربي – الفلسطيني، وخصوصا منطقة الشمال والمركز. من خلال تشغيل خط دعم ومساعدة هاتفية الذي يعطي رد على مدار 24 ساعة، تشغيل ورشات تربوية بالمدارس، تدريب أصحاب مهن، انشاء حملات إعلامية ونشر معلومات بقنوات مختلفة. السوار تعمل لمكافحة ضد كل أنواع الظلم والاستغلال الأبوي، الاقتصادي، القومي والعرقي وتلتزم بتحرير وتعزيز نساء من المجموعات المستضعفة والمتضررة في المجتمع. بملائمة لذلك، ترى ״السوار״ بالنسوية حركة ثورية اجتماعية- سياسية التي تطالب بتغيير علاقات القوة والتحكم المستشريين في المجتمع ولدعم بتطوير القضايا المتعلقة بمكانة المرأة الفلسطينية.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'חינוך',
        'מניעת אלימות'
      ]
    ],
    'id': 'YB69',
    'is_active': true,
    'keywords': [
      'אונס',
      'הטרדה מינית',
      'קו סיוע',
      'תמיכה נפשית',
      'סיוע משפטי',
      'בדואיות',
      'דרוזיות',
      'פלסטיניות',
      'צעירות',
      'מידע'
    ],
    'name': 'אלסיואר - תנועה פמיניסטית ערבית',
    'name_ar': 'السوار حركة عربية نسوية',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-10-09'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://assiwar.org/ar/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אלסיואר – תנועה פמיניסטית ערבית (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580296283'
      },
      {
        'title': 'א-סיוואר. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%90-%D7%A1%D7%99%D7%95%D7%95%D7%90%D7%A8'
      },
      {
        'title': 'Marteu, Elisabeth (2009). <b>Civil organizations and protest movements in Israel: Mobilization around the Israeli-Palestinian conflict</b>. New York, NY: Palgrave Macmillan.'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '30/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1997,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחאה',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '15/09/2019'
    },
    'description': 'אלפנאר-ארגון פמיניסטי-פלשתיני (כך במקור) הוקם בשנת 1991 בחיפה על ידי קבוצת נשים צעירות ובמשך הזמן נוספו לו סניפים נוספים בירושלים, יפו וטייבה. מטרות העמותה שנרשמה בכתובתה של מנאר חסן בשנת 1993 (ע״ר 580209039) היו: ״קידום מעמד האשה. סיוע לנשים במצוקה״. הארגון קשר בין שלושה מאבקים- החברתי, המעמדי והפמיניסטי והיה הארגון הפמיניסטי הפלסטיני הראשון אשר נאבק בתופעת רצח נשים. פעילויות הארגון כללו הפגנות, חלוקת עלונים, פרסומים בכלי התקשורת, פנייה למוסדות ורשויות, ארגון ימי עיון והענקת סיוע לנשים. העמותה נמחקה בתחילת שנות ה-2000 מפנקס העמותות ובשנת 2009 שבה לפעול לזמן קצר.',
    'description_ar': 'تأسس الفنار- التنظيم النسوي الفلسطيني عام 1991 في حيفا على يد مجموعات نساء شابات ومع الوقت توسع لفروع أخرى في القدس، يافا والطيبة. اهداف الجمعية والتي سجلتها منار حسن عام 1993 (ج.م 580209039) هم: تعزيز مكانة المرأة. ومساعدة النساء المحتاجات. ربطت المنظمة ثلاث كفح – الاجتماعي، الطبقي والنسوي، وكانت أول منظمة نسوية فلسطينية تناضل ضد ظاهرة قتل النساء. وشملت أنشطة المنظمة المظاهرات، وتوزيع المنشورات، والنشر في وسائل الإعلام، التوجه للمؤسسات والسلطات، تنظيم الحلقات الدراسية وتقديم المساعدة للنساء. تم محو الجمعية في أوائل عام 2000 من سجل الجمعيات وفي عام 2009 عادت للعمل لفترة قصيرة.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ]
    ],
    'id': 'SA153',
    'is_active': false,
    'keywords': [
      'רצח נשים'
    ],
    'name': 'אלפנאר - ארגון פמיניסטי פלשתיני',
    'name_ar': 'الفنار- التنظيم النسوي الفلسطيني',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>אלפנאר – ארגון פמיניסטי פלשתיני</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'אבו בקר, ח\'אולה (2015). התנועה הנשית-פמיניסטית הפלסטינית בתוך ישראל. בתוך: סבאע\'-ח\'ורי, אריז\' ורוחאנא, נדים (עורכים). <b>הפלסטינים בישראל: עיונים בהיסטוריה, בפוליטיקה ובחברה</b>, כרך שני (עמ\' 205–222). חיפה: מדה אל-כרמל – המרכז הערבי למחקר חברתי יישומי. נדלה מתוך',
        'url': 'http://mada-research.org/wp-content/uploads/2016/01/hebrew_2-4.pdf'
      },
      {
        'title': 'חסן, מנאר (1999). הפוליטיקה של הכבוד: הפטריארכיה, המדינה ורצח נשים בשם כבוד המשפחה. בתוך: יזרעאלי ואחרות (עורכות), <b>מין, מגדר ופוליטיקה</b> (עמ\' 267–305). תל אביב: הקיבוץ המאוחד. נדלה מתוך',
        'url': 'https://kotar.cet.ac.il/KotarApp/Index/Book.aspx?nBookID=43424736'
      },
      {
        'title': 'جنان عبده. (2008). الجمعيّات النسائيّة والنسويّة الفلسطينيّة- في مناطق 48, مدى الكرمل'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '15/09/2019'
    },
    'year_closed': 2003,
    'year_closed_text': '2003',
    'year_founded': 1991,
    'year_registered': 1993
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '15/11/2018'
    },
    'description': 'אלקאוס (״הקשת״ בערבית) הוקם בשנת 2001 כפרויקט אוטונומי של הבית הפתוח בירושלים והפך לארגון נפרד ועמותה רשומה בשנת 2008 (ע.ר. 580485472) הארגון פועל בארבעה אזורים עיקריים - יפו, חיפה, מזרח ירושלים ורמאללה. הוא מציע תמיכה ללהט״בים פלסטינים ובני משפחותיהם, מייצר תכנים חינוכיים בנושאים להט״בים עבור האוכלוסיה הכללית, מטפלים ואנשי מקצוע ופועל נגד להט״בופוביה בחברה הפלסטינית. לארגון יש קו חם של תמיכה נפשית ורשת של אנשי טיפול ידידותיים ללהט״בים, כולל שירותי יעוץ יחודיים לקהילה הטרנסית. הארגון מפעיל קבוצות של סטודנטים וצעירים ופועל לטיפוח מנהיגות להט״בית. בנוסף, הוא מארגן אירועים קהילתיים כמו הקרנות סרטים, הרצאות ומסיבות. הוא גם מפעיל פרוייקטים לקידום הבריאות בקהילה הלהט״בית הפלסינית ומקיים שיתופי פעולה מחקריים עם ארגוני זכויות אדם בגדה המערבית, על מנת לחקור את הגישה למיעוטים מיניים ומגדריים בחברה הפלסטינית וכיוצא בזו.',
    'description_ar': 'تأسس القوس عام 2001 كمشروع مستقل داخل البيت المفتوح في القدس وأصبح منظمة منفصل وجمعية مسجل في عام 2008 (ج.م580485472) تعمل المنظمة في أربع مناطق مركزية: يافا، حيفا، القدس الشرقية ورام الله. تعرض المنظمة خدمات دعم المثليين الفلسطينيون واهلهم، من خلال خلق محتوى تعليمي حول قضايا المثليين في المجتمع العام، معالجين ومختصين يعملون ضد رهاب المثليين في المجتمع الفلسطيني. يوجد للمنظمة خط ساخن للدعم النفسي وسلسلة من المختصين الوديين للمثليين، والذي يشمل خدمات استشارة نوعية للمجتمع المتحول جنسيا. تدير المنظمة مجموعات من الطلبة والشباب وتعمل على تعزيز القيادة المثلية. بالإضافة تنظم احداث اجتماعية مثل عروض أفلام، محاضرات وحفلات. المنظمة تدير مشاريع لتعزيز موضوع الصحة في المجتمع المثلي الفلسطيني ويقوم بالتعاونيات البحثية مع منظمات حقوق الانسان في الضفة الغربية من اجل التحقيق في إمكانية الوصول للأقليات الجنسية والجنسانية في المجتمع العربي وما شابه ذلك.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'כללי'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'LR24',
    'is_active': true,
    'keywords': [
      'להט״בופוביה',
      'קבוצות תמיכה',
      'טיפול נפשי',
      'מחקר',
      'טרנסקסואלים',
      'פלסטיניות',
      'קו סיוע',
      'מנהיגות'
    ],
    'name': 'אלקאוס לשונות מינית ומגדרית בחברה הפלסטינית',
    'name_ar': 'القوس للتعدّديّة الجنسيّة والجندريّة في المجتمع الفلسطينيّ',
    'name_change_year': null,
    'name_common': 'אלקאוס',
    'name_past': null,
    'name_replaced_by': 'הקבוצה הפלסטינית של הבית הפתוח שפעלה מ 2001',
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-11-15'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://alqaws.org/'
      },
      {
        'title': 'גרוס, אייל (2016). הפוליטיקה של זכויות להט״ב: בין (הומו) נורמטיביות ו(הומו) לאומיות לפוליטיקה קווירית. בתוך: גרוס, אייל, זיו, עמליה ויוסף, רז (עורכים), <b>סקס אחר - מבחר מאמרים בלימודים להט״בים וקוויריים ישראליים</b> (עמ\' 183–245). תל אביב: רסלינג.'
      }
    ],
    'target_audiences': [
      'נשים ערביות',
      'להט״ב',
      'גברים ערבים'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '21/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2001,
    'year_registered': 2008
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'מחאה'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '04/10/2018'
    },
    'description': 'ארגון אל״ף הוקם במאי 1978, בכנס הפמיניסטי בבאר שבע ופעל במשך שנה וחצי. הוא איחד נשים משלושת המרכזים הפמיניסטיים בירושלים, חיפה ותל אביב. פעילותו כללה ארגון ערבי תרבות ומסיבות, דיונים ומפגשים, מעורבות בהפגנת ״הנעימים והנעימות״ ואף קורס על פמיניזם בהנחיית חברת הכנסת לשעבר מרשה פרידמן. הארגון התפרק כתוצאה ממתחים בין חברות שרצו להדגיש את הפעילות הפמיניסטית הפוליטית לבין חברות שהעדיפו שעיקר הדגש בקבוצה יהיה על הקמת מסגרת חברתית לסבית.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'LR1',
    'is_active': false,
    'keywords': [
      'לסביות',
      'מחאה',
      'פמיניזם',
      'זכויות',
      'קהילה'
    ],
    'name': 'אל״ף - ארגון לסבי פמיניסטי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'גזית, מיכל (1979, 19 יולי). אל״ף – הן לסביות. <b>מעריב</b>. נדלה מתוך',
        'url': 'http://www.jpress.nli.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=MAR%2F1979%2F07%2F19&id=Ar02100&sk=041D7830'
      },
      {
        'title': 'לנדס, דורית (1984, 5 ספטמבר). לא רוצות מהפכות. <b>מעריב</b>.',
        'url': 'http://www.jpress.nli.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=MAR%2F1984%2F09%2F05&id=Ar04502&sk=00FC07C7'
      },
      {
        'title': 'ספרן, חנה, הרטל, רחלי וששון-לוי, אורנה (2016). הי[א]סטוריה לסבית מקומית: פעילות, מאבקים והישגים. בתוך: הראל, אלון, לושינסקי, יניב ומורגנשטרן, עינב (עורכים), <b>זכויות הקהילה הגאה בישראל: משפט, נטייה מינית וזהות מגדרית</b> (עמ\' 45–80). האוניברסיטה העברית, המכון למחקרי חקיקה ולמשפט השוואתי. צפרירים: נבו.'
      },
      {
        'title': 'רחמימוב, איריס (2015). ״סעודות, הפגנות והתפכחות״: רדיקליזם לסבי בירושלים, 1972–1989. <b>זמנים, 161</b>, 62–71. נדלה מתוך',
        'url': 'https://www.academia.edu/25633520/%D7%A8%D7%93%D7%99%D7%A7%D7%9C%D7%99%D7%96%D7%9D_%D7%9C%D7%A1%D7%91%D7%99_%D7%91%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D_1989-1972_%D7%96%D7%9E%D7%A0%D7%99%D7%9D_131'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '27/11/2018'
    },
    'year_closed': 1979,
    'year_closed_text': '1979',
    'year_founded': 1978,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '05/06/2018'
    },
    'description': '״אם הבנים״ (ע״ר 580400547) נוסדה בשנת 2001 על ידי מלכה ירום. מטרת העמותה היא: ״הקמת מרכז תמיכה למשפחות ללא אב (נשים גרושות ואלמנות וילדיהן) במגזר החרדי/דתי, שיתן סיוע למשפחות בייעוץ, גיבוש קבוצות תמיכה והפעלת אנשי מקצוע.״ המרכז שמפעילה העמותה בירושלים הוקם בתמיכתם ובעידודם של משרדים ממשלתיים, המוסד לביטוח לאומי ולשכות הרווחה ונמצאת תחת חסותו של הרב ישראל גנס שליט״א. בגלגולו הקודם נקרא הארגון ״אחיו״ת- ארגון נשים חד הוריות דתיות-חרדיות״ ואף נוסדה תחת שם זה עמותה שנסגרה. ״אם הבנים״ נותנת סיוע לנשים חרדיות גרושות בשני מישורים. ראשית, על ידי פעילות קהילתית להגברת המודעות לצרכי המשפחות ולתמיכה בהן, בקרב אנשי מקצוע, מחלקות רווחה וחינוך, ומובילי דעת קהל. שנית, על ידי מתן תמיכה ממשית במשפחות אלה, הן בסיוע פרטני לאימהות ולילדים במגוון תחומים, והן בתא המשפחתי כיחידה שלמה. כ-450 נשים משתתפות בפעילויות הארגון מדי שנה ונעזרות בכ-20 מתנדבות ונשות מקצוע המספקות ליווי והעצמה אישית, כולל הכוונה לתעסוקה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ],
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ],
      [
        'תעסוקה ועבודה',
        'השמה וליווי בתעסוקה'
      ]
    ],
    'id': 'SW11',
    'is_active': true,
    'keywords': [
      'גירושין',
      'אמהות גרושות',
      'חד-הוריות',
      'ילדות/ים'
    ],
    'name': 'בית תקוות אם הבנים שמחה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'אם הבנים - למען משפחות גרושות בקהילה',
    'name_past': null,
    'name_replaced_by': 'אחיו״ת- ארגון אמהות חד הוריות דתיות-חרדיות',
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2018-06-05'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.emhabanim.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בית תקוות אם הבנים שמחה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580400547'
      },
      {
        'title': 'אם הבנים – למען משפחות גרושות בקהילה (2018, 5 נובמבר). הפרטים אומתו בשיחת טלפון עם נציגת הארגון.'
      },
      {
        'title': 'כל זכות (ללא תאריך). <b>עמותת אם הבנים - בית תקוות אם הבנים שמחה</b>. נדלה מתוך',
        'url': 'https://www.kolzchut.org.il/he/%D7%A2%D7%9E%D7%95%D7%AA%D7%AA_%D7%90%D7%9D_%D7%94%D7%91%D7%A0%D7%99%D7%9D_-_%D7%91%D7%99%D7%AA_%D7%AA%D7%A7%D7%95%D7%95%D7%AA_%D7%90%D7%9D_%D7%94%D7%91%D7%A0%D7%99%D7%9D_%D7%A9%D7%9E%D7%97%D7%94'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '04/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': 2002
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '13/11/2018'
    },
    'description': 'עמותת ״אם הבנים שמחה – תמר״, מקורה בארגון ״נשות ת.מ.ר. (תמיכה, מזור, רפואה) - ארגון נשים ‏מתנדבות בבני ברק״, שהוקמה בשנת 1992 כארגון של נשים מתנדבות למען עזרה לחולים ונזקקים ‏שאחת ממטרותיה היו ״ליזום ולארגן פעילות תרבותית למען קהילת הנשים בארץ ובני משפחותיהן״. ‏בשנת 2001 נמחקה העמותה המקורית והוקמה עמותה חדשה (ע״ר 580378917) בשם ״אם הבנים שמחה - תמר״ שמסייעת ‏לחולים ב-״מרכז הרפואי מעייני הישועה״. באופן מעשי, מתנדבות העמותה משמשות כתומכות ליולדות ‏במיגזר החרדי ופועלות בהתנדבות מלאה בחדרי הלידה לרווחת היולדת ובהתאם לבקשתה. המלוות ‏שנקראות ״חונכות לידה״ הוכשרו לסייע לנשים בזמן הלידה וללוותן עד לצאתן לביתן.‏ בנובמבר 2020 העמותה נמחקה על ידי רשם העמותות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ],
      [
        'דת ומעמד אישי',
        'בריאות ופריון'
      ]
    ],
    'id': 'SA90',
    'is_active': true,
    'keywords': [
      ''
    ],
    'name': 'אם הבנים שמחה-תמר',
    'name_ar': null,
    'name_change_year': 2001,
    'name_common': null,
    'name_past': 'נשות ת.מ.ר. תמיכה, מזור, רפואה - ארגון נשים מתנדבות בבני ברק',
    'name_replaced_by': null,
    'official_address': 'בני ברק',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אם הבנים שמחה – תמר (ע״ר): עמותה מחוקה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580378917'
      },
      {
        'title': 'הרשת להתנדבות ישראלית, המועצה הלאומית להתנדבות בישראל (ללא תאריך). <b>ארגון נשות ת.מ.ר- תמיכה מזור רפואה - מגן שר הרווחה למתנדבים מצטיינים בתחום רווחת המשפחה</b> (העמוד אינו זמין יותר).'
      },
      {
        'title': 'מרכז רפואי מעייני הישועה (ללא תאריך). <b>מתנדבים – עולם חסד יבנה</b>. נדלה מתוך',
        'url': 'https://www.mymc.co.il/visiting-us/volunteers/'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '29/09/2021'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1992,
    'year_registered': 2002
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '11/03/2019'
    },
    'description': '״אמא יקרה״ נוסדה בשנת 2014 על ידי ימית אורבין בעקבות דיכאון אחרי לידה שחוותה. המיזם נרשם כעמותה (ע״ר 580643625) ב-2017. מטרת העמותה - העמותה להעלות למודעות הציבורית את נושא הדיכאון והקשיים הרגשיים שעוברות נשים במהלך ההריון ובתקופה שלאחר הלידה, ולמצוא פתרונות בכדי להקל על הנשים ובני המשפחה הקרובה. העמותה פועלת באמצעות הנגשת ידע עדכני והקמת קבוצות תמיכה לנשים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'YH146',
    'is_active': true,
    'keywords': [
      'הריון',
      'לידה',
      'דיכאון אחרי לידה',
      'קבוצת תמיכה',
      'העלאת מודעות',
      'יולדות'
    ],
    'name': 'אמא יקרה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רחובות',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'תמיכה נפשית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-11-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://imayekara.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אמא יקרה עמותה לחוות קושי רגשי/דיכאון בהריון ולאחר לידה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580643625'
      },
      {
        'title': 'אמא יקרה - מיזם לנשים החוות קושי רגשי/דיכאון בהיריון ולאחר לידה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/imayekaraPostpartumWomen/?ref=page_internal'
      },
      {
        'title': 'אורבין, ימית (2017, 19 ספטמבר). יוזמה מרגשת של תושבת העיר: אמהות תומכות באמהות: דיכאון אחרי לידה – אמא יקרה. <b> mynet רחובות</b> (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': 2017
  },
  {
    'activity_kinds': [
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '18/11/2019'
    },
    'description': 'הגרעין של עמותת ״אמהות בגליל״ צמח משנת 2005 מקבוצה של כ-10 אמהות מוסלמיות, דרוזיות נוצריות ויהודיות אשר קיימו מפגשים חברתיים, טיולים, צפייה בסרטים, סעודות משותפות ושיתוף בסיפורי חיים. בשנת 2009, נרשמה העמותה (ע״ר 580513281) כהתארגנות פרטית ללא השתייכות פוליטית או רעיונית אשר מטרתה: ״מתן דוגמא אישית לאהבת האדם ומתן תמיכה רגשית לכל אמא בגליל. להבין מנקודת מבטה של האם את המנהגים, אמונות, טקסים, חגים, פולקלור של העדות בגליל. למידה מניסיון החיים של האמהות בגליל ע״י סיפורי חיים ותיעוד סיפוריהם בכתיבה, צילום וסיורים ביישובים. יצירת שיתוף פעולה בין אמהות מתרבויות שונות בגליל.״ חברות העמותה הגיעו בעיקר מהיישובים: סלמה, מאכר, פקיעין, ירכא, חוסן וכפר ורדים ועיקר פעילותן התקיימה בבית אותו שכרו בפקיעין. הפעילויות כללו ארועים תרבותיים, סיורים מודרכים, מפגשים, פעילויות, סדנאות אמנות, טיולים, בישולים, סרטים, ספרים, העוסקים בעולם האמהות. העמותה הפעילה אתר אינטרנט שבו מתועדת פעילות עד שנת 2011. בשנת 2019 נמחקה העמותה מפנקס העמותות.',
    'description_ar': 'وُلدت فكرة جمعية ״أمهات الجليل״ في عام 2005 على يد 10 أمهات مسلمات، درزيات، مسيحيات ويهوديات واللواتي قمن بلقاءات اجتماعية، جولات، مشاهدة أفلام، وموائد مشتركة بالإضافة لمشاركة قصص حياتهم الشخصية. في عام 2009 سجلت الجمعية بشكل رسمي (580513281) على شكل تجمهر فردي وغير مُسَيَّس. الا ان الهدف كان ״إعطاء امثلة شخصية لحب الانسان وتقديم الدعم المعنوي لكل امرأة في الجليل. لفهم رؤية كل أم في مواضيع مختلفة مثل القيادة، الفنون، الطقوس، الأعياد والفلكلور الخاص بكل ديانة في الجليل. التعلم من تجربة الحياة الخاصة بأمهات الجليل من خلال قصص حياتهم وتوثيق رواياتهن من خلال الكتابة، التصوير والجولات في بلداتهم. خلق شراكات بين أمهات من خلفيات مختلفة في الجليل״. صديقات الجمعية في الأساس هم من البلدات: سلامة، المكر، بقعاثا، يركا،حوسن وكفار فرديم. ومركز نشاطهن كان في بيت استأجروه في بقعاثا. شملت النشاطات فعاليات تربوية، جولات إرشادية، لقاءات، نشاطات، ورشات فنون، رحلات، أفلام، كتب التي تختص بعالم الأمهات. كما وقد قامت الجمعية بتنشيط موقع الكتروني الذي وثقت به نشاطاتها حتى عام 2011. في عام 2019 حذفت الجمعية من سجل الجمعيات.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'SA163',
    'is_active': false,
    'keywords': [
      'אמהות',
      'בישול',
      'דו קיום'
    ],
    'name': 'אמהות בגליל',
    'name_ar': 'أمهات الجليل',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'פקיעין (בוקייעה)',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פנאי',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>אמהות בגליל</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'ישראל תורמת (ללא תאריך). <b>אמהות בגליל (ע״ר)</b>. נדלה מתוך',
        'url': 'https://www.israeltoremet.org//amuta/580513281'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 8190 (2019, 7 אפריל). <b>הודעה סופית בדבר מחיקה מפנקס העמותות</b>. אמהות בגליל (עמותה מספר 580513281). עמ\' 9780. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_word/Law10/yalkut-8190.pdf'
      }
    ],
    'target_audiences': [
      'נשים ערביות',
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '18/11/2019'
    },
    'year_closed': 2011,
    'year_closed_text': '2011',
    'year_founded': 2005,
    'year_registered': 2009
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '18/11/2019'
    },
    'description': 'עמותת ״אמהות ללא אמהות בצל האובדן״ (ע״ר 580437002) נרשמה בתל אביב בשנת 2004. מטרת העמותה היתה: ״בניית רשת תמיכה ארצית לאמהות שאיבדו את אמותיהן. יצירת מעגלי תמיכה וסעד הכוללים מענה טיפולי קבוצת בהנחיה מקצועית. יעוץ אישי. מפגשים. ימי עיון וסדנאות. קידום בריאות התא המשפחתי על ידי שיפור קשר אם-ילד. יצירת מרחב לשיתוף, הקשבה והתחזקות ממורשת האובדן המשותפת״. העמותה פעלה כ-10 שנים והעניקה מענה טיפולי קבוצתי וייעוץ אישי, ארגנה כנסים, ימין עיון וסדנאות והפיצה מידע בנושא. בשנת 2008, התקיים בתל אביב הכנס הארצי הראשון בנושא אמהות ללא אמהות ואליו הגיעו כ-300 משתתפות. אחרי 2015 אין אזכורים לפעילות העמותה והיא נמחקה סופית בשנת 2018. מקימת העמותה, שושנית לופו-פייגנברג, ממשיכה להפעיל מכון פרטי.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'SA165',
    'is_active': false,
    'keywords': [
      'אמהות',
      'תמיכה נפשית',
      'סיוע לאמהות',
      'קבוצת תמיכה',
      'העלאת מודעות'
    ],
    'name': 'אמהות ללא אמהות בצל האובדן',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'תמיכה נפשית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-11-18'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://sites.google.com/site/mlelom/'
      },
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>אמהות ללא אמהות בצל האובדן</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'לוי, גלית (2008, 18 ינואר). אמהות ללא אמהות: איך הן מתמודדות? <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-3494730,00.html'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 8008 (2018, 26 נובמבר). <b>הודעה סופית בדבר מחיקה מפנקס העמותות</b>. אמהות ללא אמהות בצל האובדן (מספר עמותה 580437002). עמ\' 3411. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_word/Law10/yalkut-8008.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '18/11/2019'
    },
    'year_closed': 2015,
    'year_closed_text': '2015',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '17/01/2018'
    },
    'description': '״אמהות למען עתיד פורח״ היא עמותה (ע״ר 580378925) שנוסדה בשנת 2001 באבו סנאן. מטרות העמותה הן: ״עידוד הקמת מעונות יום במגזר הערבי, כפוף לחוק הפיקוח על מעונות תשכ״ה-1965 ו/או כל חוק אחר. שיפור וקידום מעמד האשה ועידודה ליציאה לעבודה. טיפוח וסיוע לאמהות עובדות ולילדים בסיכון. שיפור השירותים החברתיים לטף במגזר הערבי. חינוך, ניהול ופתיחת גני ילדים ע״פי חוק הפיקוח תשכ״ט״. העמותה מפעילה שלושה גני ילדים ומעון יום באבו סנאן ובכפר יאסיף ומקיימת פעילויות תרבותיות לאמהות וילדים.',
    'description_ar': 'أمهات من اجل مستقبل مزهر- هي (ج.م 580378925) تأسست عام 2001 في أبو سنان. اهداف الجمعية هي: التشجيع على انشاء مراكز للرعاية في المجتمع العربي، مع مراعاة قانون المراقبة الملاجئ لعام 1965 و\\أو أي قانون اخر. تحسين وتعزيز وضع المرأة وتشجيعها للخروج لسوق العمل. رعاية ومساعدة الأمهات العاملات المعرضات للخطر. تحسين الخدمات الاجتماعية للاستفادة من المجتمع العربي، التعليم، تدير الجمعية ثلاثة رياض أطفال ومراكز للرعاية النهارية في أبو سنان وكفر ياسيف وتجري أنشطة ثقافية للأمهات والأطفال.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'חינוך',
        'הגיל הרך'
      ]
    ],
    'id': 'YA3',
    'is_active': true,
    'keywords': [
      'ילדים',
      'משפחה',
      'פנאי'
    ],
    'name': 'אמהות למען עתיד פורח',
    'name_ar': 'أمهات من أجل مستقبل زاهر',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'אבו סנאן',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעונות ומשפחתונים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-01-17'
    },
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אמהות למען עתיד פורח (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580378925'
      },
      {
        'title': 'حضانة كيف وليش كفر ياسيف, [אמהות למען עתיד פורח] עמוד פייסבוק.',
        'url': 'https://www.facebook.com/keefoleesh/'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '23/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2001,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחאה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/07/2018'
    },
    'description': 'תנועת ״הורים נגד שתיקה״ שנקראה גם ״אמהות נגד שתיקה״ הוקמה ב-3.5.1983 והתפרקה ב-5.6.1985 עם סיומה הרשמי של מלחמת לבנון. התנועה הוקמה על ידי הורים לחיילים למעלה משני-שליש מחברותיה היו נשים ולכן נחשבת לאחת מתנועות השלום הנשיות הראשונות בישראל. מטרת התנועה היתה ״הוצאת צה״ל מלבנון מיד, תוך הבטחת סדרי הביטחון הטובים ביותר שאפשר ליישובי הצפון״. התנועה היתה בלתי-מפלגתית ורוב חברותיה היו תושבות מרכז הארץ והיא פעלה באמצעות הפגנות, מכתבים ועצומות. המנהיגה המרכזית היתה שושנה שמואלי מתל אביב.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'ביטחון לאומי'
      ]
    ],
    'id': 'SA35',
    'is_active': false,
    'keywords': [
      'מלחמה',
      'צבא',
      'אמהות'
    ],
    'name': 'אמהות נגד שתיקה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'צוקרמן-בראלי, חיה, בנסקי, טובה (1989). \'הורים נגד שתיקה\': תנאים ותהליכים המובילים לצמיחת תנועת מחאה. <b>מגמות,ל״ב</b>(1), 27–45.‎'
      },
      {
        'title': 'Hermann, Tamar (2009). <b>The Israeli peace movement: a shattered dream</b>. Cambridge, UK: Cambridge University Press.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '15/10/2018'
    },
    'year_closed': 1985,
    'year_closed_text': '1985',
    'year_founded': 1983,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחאה',
      'חינוך, הכשרה והעלאת מודעות',
      'אקטיביזם רשת'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '14/01/2020'
    },
    'description': 'הקבוצה ״אמהות על המשמר״ הוקמה בפברואר 2016 על ידי קבוצת אמהות הפועלת בשיתוף אגודת יהודי אתיופיה. מטרת הקבוצה היא להאבק באלימות משטרתית ובגזענות. פעילותה החלה בעקבות המחאה של צעירי העדה האתיופית שיצאו לרחובות לאחר סגירת תיק החקירה בנוגע למותו של יוסף סלמסה, צעיר ממוצא אתיופי בן 22 שנמצא מת ביולי 2014 לאחר שנעצר ונחקר באלימות במשטרת זכרון יעקב. משמרות המחאה הראשונות נערכו תחת הכותרת ״כולנו אמא סלאמסה״ בתיאור הקבוצה בפייסבוק נאמר כי ״בעיני חלקים מהממסד הישראלי וביחוד המשטרה, אדם שחור מסמן פשע ואלימות. כמעט על בסיס יומיומי ילדנו חווים השפלות, זלזול ואלימות פיזית ומילולית ללא אפשרות להגן על עצמם. אנחנו לא יכולות/ים לבקש מהן/ם להשאיר בבית את צבע עורן/ם. אנו האימהות שלהן/ם רואים אותן/ם נלחמות/ים נאבקות/ים להשמיע את קולן/ם בהפגנות ובכל מקום שהן/ם יכולות/ים. נאבקות/ים לקבל את מה שמגיע להן/ם כאזרחיות/ים שווי זכיות כמו כל ילד/ה, נער/ה ובוגר/ת במדינת ישראל.״ מאז הקמתה, התרחבה פעילות הקבוצה למספר קהילות באזור ירושלים, הצפון ודרום. ״אמהות על המשמר״ מקיימות משמרות מחאה שבועיות מול תחנות משטרה, מארגנות התכנסויות של משפחות ויחידים לשיחה על נושאים קהילתיים ומשפחתיים, מתראיינות בתקשורת בנושאים העוסקים בגזענות ואלימות משטרתית ומפעילות עמוד פייסבוק.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'הגירה',
        'קליטת עלייה'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'ביטחון אישי'
      ]
    ],
    'id': 'SA181',
    'is_active': true,
    'keywords': [
      'משטרה',
      'נשק',
      'ביטחון אישי',
      'גזענות',
      'הפגנה'
    ],
    'name': 'אמהות על המשמר',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'הגירה',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'קליטת עלייה',
    'primary_target_audience': 'נשים יוצאות אתיופיה',
    'retrieved': {
      'type{date}': '2020-01-14'
    },
    'sources': [
      {
        'title': 'עמוד הפייסבוק של אמהות על המשמר',
        'url': 'https://www.facebook.com/groups/201822603515543/'
      },
      {
        'title': 'דרסלר, תמר (2016, 23 מרץ). לאמהות יוצאות אתיופיה נמאס: ״לא מוכנות שילדינו ישלמו מחיר בגלל צבע עורם״. <b>מעריב</b>. נדלה מתוך',
        'url': 'https://www.maariv.co.il/news/israel/Article-532698'
      }
    ],
    'target_audiences': [
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '14/01/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '20/08/2018'
    },
    'description': 'ארגון מיילדות הבית בישראל – אמה״י (ע״ר 580456564) הוקם בשנת 2006 על ידי מיילדות מוסמכות בעלות רישיון המומחיות ללוות וליילד בלידה מסגרת ביתית נשים. מטרותיו העיקריות של הארגון היא לאסוף נתונים ולספק מידע על לידות בית, לאגד מיילדות בית ולקדם את מיסוד לידות הבית במסגרת שירותי הבריאות בישראל כולל הגדרת פרוטוקולים המסדירים את הטיפול בנשים ויילודים בסיכון נמוך במסגרת ביתית. בשנת 2016 הארגון היה מעורב (ביחד עם קבוצות נוספות) בתיקון החקיקה להשוואת זכויות לקבלת מענק לידה לנשים שילדו בבית. לא נמצאו דוחות שנתיים של העמותה ובשנת 2021 היא נמצאת בהליכי מחיקה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ],
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ]
    ],
    'id': 'SA50',
    'is_active': true,
    'keywords': [
      'הריון',
      'לידה',
      'לידה טבעית',
      'לידת בית',
      'מיילדות',
      'אמהות',
      'הנקה'
    ],
    'name': 'אמה״י - ארגון מיילדות ויולדות הבית בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת השרון',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-08-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.imahi.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אמה״י – ארגון מיילדות ויולדות הבית בישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580456564/documents'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '29/09/2021'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2006,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '25/05/2018'
    },
    'description': '‏״תנועת האישה הדתית לאומית״ נוסדה בשנת 1959 כמיזוג בין ארגון נשי מזרחי ״אמן״ לבין ארגון ‏הפועלות של הפועל המזרחי, בראשות הרבנית שרה הרצוג. בשנת 1977 התווסף לשם הארגון השם ‏‏״אמונה״ ובאותה שנה הוקמה התנועה העולמית של ״אמונה״. בשנת 1982 נרשמה התנועה כעמותה. ‏כיום, מפעילה ״אמונה״ 37 סניפים ובתי מדרש לנשים ללימודי יהדות ומחשבת ישראל ברחבי הארץ, ‏‏140 מעונות יום ומעונות רב-תכליתיים, 4 אולפנות תיכוניות, מכללה אקדמית להכשרת עובדי הוראה ‏בתחומי אמנות, תיאטרון ועיצוב, 5 בתי ילדים, פנימיות וכפרי נוער, מרכז חירום וקלט חירום לילדים ‏במצבי סיכון, 13 מרכזים לייעוץ וטיפול במשפחה, בת עמי – אגודת השרות הלאומי בשיתוף עם ״אלומה״, מכון באר אמונה להכשרת מנחים ומטפלים במשפחה, מרכז להב״ה – ללימודי הבית היהודי, ‏מועדון נשות עסקים וקריירה, חוגים ארציים לדוברות אנגלית, ו-28 סניפי אמונה עולמית בתפוצות.‏',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'דת ומעמד אישי',
        'פוליטיקה ומנהיגות'
      ]
    ],
    'id': 'SW5',
    'is_active': true,
    'keywords': [
      'יהדות',
      'מנהיגות',
      'הדרת נשים',
      'קידום נשים',
      'הלכה'
    ],
    'name': 'אמונה תנועת האישה הדתית לאומית',
    'name_ar': null,
    'name_change_year': 1977,
    'name_common': null,
    'name_past': 'תנועת האישה הדתית לאומית',
    'name_replaced_by': 'ארגון הפועלות של הפועל המזרחי, אמן ארגון נשי מזרחי',
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-05-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.emunah.org.il'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אמונה – תנועת האשה הדתית לאומית: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580011146'
      },
      {
        'title': '(1959, 19 אוקטובר). בכנס מפואר בנוכחות ראשי התנועה ואלפי פעילות הוקמה התנועה המאוחדת של נשים דתיות-לאומיות. <b>הצופה</b>. נדלה מתוך',
        'url': 'http://jpress.org.il/olive/apa/nli_heb/?href=HZH%2F1959%2F10%2F19&page=1&entityId=Ar00101#panel=document'
      },
      {
        'title': 'Huebner, Yehudith (2009, February 27). Emunah. In <b>Jewish women: A comprehensive historical encyclopedia</b>, Jewish women\'s archive. Retrieved from',
        'url': 'https://jwa.org/encyclopedia/article/emunah'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '14/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': 1982
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'מחאה',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '09/08/2018'
    },
    'description': '״אמח״ה- איגוד משפחות חד הוריות בישראל״ (ע״ר 580236404) הוקמה על ידי ילנה קים, בעצמה אם חד הוריות שעלתה ב-1992 עם אמה המבוגרת וילדה השני. קים הקימה את הארגון יחד עם שבע אמהות במעמדה. ב-1993 ערכו שביתה וצעדת מחאה בגן הורדים בירושלים. הארגון פעל בשיתוף פעולה עם נעמת ועם ארגון ״מיח״ד - העמותה של המשפחות החד הוריות בישראל״. בכתבה שכותרתה ״הדברים מטרידים הנשים חושדות בנו״, מיום 26.4.1996 בידיעות אחרונות, רואיינה ילנה קים וציינה כי באותה שנה מנה אמח״ה 5,200 משפחות ו-35 סניפים. ב-2013 הוגשה בקשה לפירוק העמותה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ],
      [
        'הגירה',
        'קליטת עלייה'
      ]
    ],
    'id': 'YH72',
    'is_active': false,
    'keywords': [
      'אמהות גרושות',
      'עולות מברה״מ',
      'תעסוקה',
      'זכויות',
      'חד הוריות'
    ],
    'name': 'אמח״ה - איגוד משפחות חד - הוריות בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נתניה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים עולות מחבר העמים',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אמח״ה איגוד משפחות חד-הוריות בישראל: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580236404'
      },
      {
        'title': 'גלילי, לילי (2003, 22 ספטמבר). איך זה שאין עולות מרוסיה במאהל החד-הוריות. <b>הארץ</b>.',
        'url': 'https://www.haaretz.co.il/misc/1.912151?=&ts=_1533801670418'
      },
      {
        'title': 'סבירסקי, שלמה, קראוס, ורד, קונור-אטיאס, אתי, והרבסט, ענת (2002). אמהות חד הוריות בישראל. <b>מידע על שוויון, 12</b>. מרכז אדוה. נדלה מתוך',
        'url': 'http://adva.org/wp-content/uploads/2014/09/gil12.pdf'
      }
    ],
    'target_audiences': [
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '15/01/2019'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 1993,
    'year_registered': 1994
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '20/12/2018'
    },
    'description': '״העמותה לטיפול באלימות במשפחה ובחברה ופגיעות מיניות בישראל״ (ע״ר 580444685) הוקמה ב-2005 על ידי חוקרים מאוניברסיטת חיפה ובראשם רחל לב-ויזל וצבי איזיקוביץ, במטרה ״לאסוף ולהפיץ ידע אקדמי בתחום האלימות במשפחה, קורבנות בילדות ופגיעות מיניות, לגבש לובי חברתי ופוליטי, ליזום הצעות חקיקה לטיפול בקורבנות אלימות, לעודד מחקרים בתחום ולייעץ לגופי ממשל על בסיס הידע שיצטבר״. על אף היותה רשומה, ככל הנראה העמותה לא פעילה כבר משנת 2013.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף אקדמי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'השכלה גבוהה ומחקר',
        'מרכזי מחקר'
      ]
    ],
    'id': 'YH161',
    'is_active': false,
    'keywords': [
      'מחקר',
      'אונס',
      'אלימות במשפחה',
      'גילוי עריות',
      'ילדות/ים',
      'נפגעות התעללות בילדות',
      'אלימות מינית'
    ],
    'name': 'אמינות- העמותה לטיפול באלימות במשפחה ובחברה ופגיעות מיניות בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'אקדמי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אמינות – העמותה לטיפול באלימות במשפחה ובחברה ופגיעות מיניות בישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580444685'
      },
      {
        'title': 'העמותה לטיפול באלימות במשפחה ובחברה ופגיעות מיניות בישראל ומשרד הרווחה (2009). <b>אלימות,1 </b>(ב).',
        'url': 'http://web.macam.ac.il/~offprint/87749.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '21/02/2019'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '12/02/2018'
    },
    'description': '״נופית - בית שיקומי לנערות עם בעיות אכילה״ הוא ההוסטל השיקומי הראשון לנשים הסובלות מהפרעות אכילה שנפתח בישראל. הוא הוקם בשנת 2008 ב״הוד השרון״ בשיתוף פעולה בין המרכז למפעלים מיוחדים של הבזח הלאומי״, משרד הבריאות ומשרד הרווחה, ומנוהל אדמיניסטרטיבית על ידי עמותת ״נופית פרויקטים בקהילה״. הבית שיכול להכיל עד 14 נשים, משלב את השוהות במסגרות לימודיות ותעסוקתיות, ובמקביל מציע טיפול נפשי ובריאותי ומערך תמיכה רחב. העמותה מפעילה גם דירות המשך לבוגרות הבית השיקומי. מרכז נופית מציע גם תוכנית לטיפול יום ללא אשפוז, קבוצת תמיכה להורים לילדים הסובלים מהפרעות אכילה, קבוצת טיפול בתנועה וקבוצה לסיוע להרזייה ללא דיאטה וסדנאות וטיפולים לסובלים מדכאון וחרדה. בנוסף, העמותה מפעילה קו חם לתמיכה בהפרעות אכילה. שמו המקורי של הבית היה ״אמצע הדרך״, מה שמשתלב עם שמות הבתים האחרים ״דרך חדשה״ ו״צידה לדרך״, אולם הוא ידוע כעת יותר בשם הנוכחי המזוהה עם שם העמותה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'נערות וצעירות',
        'בריאות'
      ]
    ],
    'id': 'LR29',
    'is_active': true,
    'keywords': [
      'דיור',
      'הפרעות אכילה',
      'תעסוקה',
      'הוסטל'
    ],
    'name': 'נופית בית שיקומי לנערות עם הפרעות אכילה (עמותת נופית פרוייקטים בקהילה)',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'אמצע הדרך',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'הוד השרון',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'בריאות הנפש וטיפול',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-02-12'
    },
    'sources': [
      {
        'title': 'www.nofit.org'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת נופית פרוייקטים בקהילה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580327526'
      },
      {
        'title': 'בלנק, רוני (2016). <b>הטיפול בהפרעות אכילה בישראל</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/732c28b1-995f-e611-80dd-00155d010ede/2_732c28b1-995f-e611-80dd-00155d010ede_11_10422.pdf'
      },
      {
        'title': 'היוש, טלי, היישריק, מיכל, יצחק-מונסונגו, עינת ולזובסקי, רבקה (2013). <b>תכנית הבתים השיקומיים לנשים צעירות המחלימות מהפרעות אכילה</b>. מפעלים מיוחדים 152. ירושלים: המוסד לביטוח לאומי, מינהל המחקר והתכנון והאגף לפיתוח שירותים. נדלה מתוך',
        'url': 'https://www.btl.gov.il/Publications/Special_Activities_publications/Documents/mifal_152.pdf'
      },
      {
        'title': 'סידס-כהן, דפנה (2009). <b>הקמת מרכזים לטיפול בהפרעות אכילה - המשך מעקב</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/21586b58-e9f7-e411-80c8-00155d010977/2_21586b58-e9f7-e411-80c8-00155d010977_11_7139.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '24/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2008,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '11/03/2019'
    },
    'description': 'אנד״י - אנדומטריוזיס ישראל (ע״ר 580544351) פעלה בין השנים 2011-2015 במטרה לפעול למען ״העלאת המודעות לאנדומטריוזיס בקרב רופאי המשפחה, רופאי הנשים, מטפלי הפוריות, נשים, בנות נוער, מערכת החינוך, צה״ל, מעסיקים והאוכלוסיה בישראל ככלל. תמיכה וליווי לנשים הסובלות מאנדומטריוזיס ולבני משפחותיהן.״ העמותה קיימה כנסים בנושא אנדומטריוזיס והעניקה תמיכה וסיוע לנשים הסובלות מהמחלה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'YH162',
    'is_active': false,
    'keywords': [
      'אנדומטריוזיס',
      'מחלות כרוניות',
      'גניקולוגיה',
      'בריאות נשים',
      'העלאת מודעות',
      'מוגבלות'
    ],
    'name': 'אנד״י - אנדומטריוזיס ישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'הוד השרון',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-12-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://endiisrael.wordpress.com/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אנד״י – אנדומטריוזיס ישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580544351/documents'
      },
      {
        'title': 'מירב גראו. אנדומטריוזיס ישראל (בלוג). באתר Saloona. נדלה מתוך',
        'url': 'http://saloona.co.il/meiravendo/?p=1?ref=blog_morefrom'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '20/12/2018'
    },
    'year_closed': 2015,
    'year_closed_text': '2015',
    'year_founded': 2011,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '25/07/2018'
    },
    'description': 'הארגון ״אנחנו שוות״ הוקם על ידי ״לינדה״ (אנט קולניס) ואסתר עילם באביב 1991 כהתארגנות קטנה בתל אביב שיצרה קשר עם נשים בזנות במטרה לסייע להן ולהשמיע את קולן. ״אנחנו שוות״ יצרו קשרים עם ארגוני נשים דומים במקומות אחרים בעולם (אירופה וארה״ב) ופרסמו עלונים, מאמרים ותרגומים בנושא זה בעיתונות הפמיניסטית בישראל. הקבוצה היתה מעורבת בכתיבת הדוח הראשון אודות סחר בנשים בישראל שהתפרסם מטעם שדולת הנשים (1997) ובהקמת הקואליציה למאבק בסחר בנשים. חברותיה נטלו חלק בכנסים פמיניסטיים ואף השתתפו כנציגות בדיונים של הועדה לקידום מעמד האשה בכנסת. בשנת 2002 היא נרשמה כעמותה (ע״ר: 580394328) (בין המייסדות- אנט ומריגולד קולינס וקרן ידעיה), אשר מטרותיה היו: ״להלחם בתופעת הסחר בנשים וגברים ולהחזיר ל״נשות הלילה״ את ערכן וכבודן העצמי. העמותה תספק ל״נשות הלילה״ עזרה סוציאלית, רפואית, משפטית, פסיכולוגית, ללא הבדל בין דת, גזע ולאום. השירותים ינתנו על ידי אישים מוסמכים לכך על פי דין.״ הארגון חדל לפעול בערך בשנת 2006 והעמותה נמחקה רשמית מפנקס העמותות בשנת 2019.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'זנות'
      ],
      [
        'הגירה',
        'סחר בבני אדם'
      ]
    ],
    'id': 'SA36',
    'is_active': false,
    'keywords': [
      'סחר בנשים',
      'טראומה',
      'תמיכה נפשית',
      'זנות',
      'פמיניזם'
    ],
    'name': 'אנחנו שוות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'זנות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>אנחנו שוות</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'ונדנברג, מרטינה (1997). <b>הברחת נשים לישראל וזנות בכפייה: דו״ח של שדולת הנשים בישראל</b>. ירושלים: שדולת הנשים בישראל.'
      },
      {
        'title': 'לינדה (2017, 15 אפריל). מה לנו ולזונות? <b>פרלמנט נשים</b>. פרלמנט נשים: במה לפוליטיקה מזוית אחרת, מושב 47, מושבי תשס״ז (2006-2007). נדלה מתוך',
        'url': 'http://womenparliament.org/%D7%9E%D7%94-%D7%9C%D7%A0%D7%95-%D7%95%D7%9C%D7%96%D7%95%D7%A0%D7%95%D7%AA-%D7%9C%D7%99%D7%A0%D7%93%D7%94/'
      },
      {
        'title': 'עילם, אסתר (2012). פמיניסטית באקדמיה בשנות השבעים. <b>מגדר: כתב עת למגדר ופמיניזם</b>, 1, 117–132. נדלה מתוך',
        'url': 'http://blogdebate.org/gender/journal/wp-content/uploads/2012/12/%D7%90%D7%A1%D7%AA%D7%A8-%D7%A2%D7%99%D7%9C%D7%9D.pdf'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 8190 (2019, 7 אפריל). <b>הודעה סופית בדבר מחיקה מפנקס העמותות</b>. אנחנו שוות (מספר עמותה 580394328). עמ\' 9703. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_word/Law10/yalkut-8190.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים מהגרות עבודה או חסרות מעמד'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/12/2018'
    },
    'year_closed': 2006,
    'year_closed_text': '2006',
    'year_founded': 1991,
    'year_registered': 2002
  },
  {
    'activity_kinds': [
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '12/01/2019'
    },
    'description': '״אנטאה״ או ״אנטיאה״ היתה גלריה פמיניסטית שפעלה בשינקין 27, תל אביב מסוף 1985 עד 1988 בערך. בשנת 1986 הגלריה נרשמה כעמותה (ע״ר 580093730) שמטרתה היתה ״לעודד ולקדם את האומנות בכלל, ולהתמקד בהישגי נשים באומנות בפרט״. את הגלריה הקימה וניהלה אישה בריטית שהתגוררה בישראל בשם ג\'ואנה ריאם אשר החליטה להקים גלריה פמיניסטית כחלופה לגלריות הותיקות בתל אביב. הגלריה הפמיניסטית היתה אחת מחללי האמנות שהחלו להפתח בשנות השמונים ברחוב שינקין, בהתחלה של ״דינמיקה גאוגרפית צעירה שהציעה רגישות אחרת לקריאה ולהצגה של אמנות״. משמעות השם ,אנטיאה, במיתולוגיה היוונית היא אלת הצד האפל של הירח. בגלריה הציגו אמניות שונות וביניהם ג\'ניפר בר-לב, ארנה ל. ברוק, לאה דולינסקי ועוד. בשנת 1994 פנתה איבון דויטש, פמיניסטית ירושלמית, לקבוצה של אמניות - ביניהן ריטה מנדס פלור ונעמי טנהאוזר בהצעה להקים בירושלים גלריה פמיניסטית. גלריה ״אנטיאה״ השנייה פעלה בירושלים בין השנים 1994-2009, בתוך המרכז הפמיניסטי ״קול האישה״. שמה של הגלריה - אנטיאה - נבחר מתוך רצון להמשיך את היוזמה הפמיניסטית של גלריית ״אנטיאה״ התל אביבית. הבחירה בשם הזהה היתה מחווה ורמז לרצון להנכיח שושלת ועשייה רבת שנים של נשים בשדה האמנות בישראל.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'אמנות'
      ]
    ],
    'id': 'SA166',
    'is_active': false,
    'keywords': [
      'גלריה',
      'פמיניזם'
    ],
    'name': 'אנטאה (אנטיאה)',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אמנות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'אהרוני, שרי (2019, 1 דצמבר). <b>עזרה במידע</b> [התכתבות עם טל דקל].'
      },
      {
        'title': 'בוגנים, איתן (2005, 17 מאי). לו הייתי רוטשילד. <b>גלובס</b>. נדלה מתוך',
        'url': 'https://www.globes.co.il/news/article.aspx?did=914187'
      },
      {
        'title': 'טנהואזר, נעמי. <b>פוסט #1: שמלה, סימלה, שיבה לאנטיאה</b>. נדלה מתוך אתר הגלריה',
        'url': 'https://www.antea-dress.com/antea-and-jennifer-bar-lev'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '12/01/2019'
    },
    'year_closed': 1988,
    'year_closed_text': '1988',
    'year_founded': 1985,
    'year_registered': 1986
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '29/10/2018'
    },
    'description': 'ב-1996 קמה ביוזמתה של הסופרת אורה עשהאל קבוצה של נשים יוצרות במסגרת ״איגוד הנשים האקדמאיות״ שנקראה ״סניף נשים יוצרות״. ב-2003 נרשמה הקבוצה כעמותה בשם אנ״י - איגוד נשים יוצרות ישראל (ע״ר 580406783). המטרה - מתן ביטוי ובמה ליוצרות ואמניות: סופרות, משוררות ואמניות. האיגוד פרסם שתי אנתולוגיות בשם ״מעגלים״ בשנת 2000 ובשנת 2002. העמותה ככל הנראה פעלה עד 2013 ולא פעילה כיום.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'ספרות'
      ],
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ]
    ],
    'id': 'YH121',
    'is_active': false,
    'keywords': [
      'איגוד מקצועי',
      'רישות',
      'סופרות',
      'משוררות',
      'אמניות',
      'אמנות',
      'יוצרות'
    ],
    'name': 'אנ״י - איגוד נשים יוצרות ישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'גבעתיים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ספרות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'אורה עשהאל, בימתי (אתר פרטי). אנ״י - איגוד נשים יוצרות ישראל, סקירה היסטורית.',
        'url': 'http://www.bimati.net/public-work'
      },
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>אנ״י - איגוד נשים יוצרות ישראל</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '27/10/2019'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 1996,
    'year_registered': 2003
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '06/12/2018'
    },
    'description': '״אסוואת - מרכז פמיניסטי פלסטיני לזכויות מיניות ומגדריות״ היא עמותה של נשים פלסטיניות גאות שהוקמה בשנת 2003 על ידי שלוש פעילות לסביות פלסטיניות וביניהן ראודה מרקוס. בין השנים 2003-2017 פעל המרכז באופן עצמאי במסגרת הארגון הפמיניסטי ״כייאן״ בבית קואליציית נשים חיפה ובשנת 2018 נרשם כעמותה עצמאית (ע״ר 580645489). ״אסוואת״, אשר משמעות שמה בערבית הינה ״קולות״, פונה ללסביות, ביסקסואליות, טרנסיות, אינטרסקס וקוויריות. מטרות העמותה הן לפעול ״בתוך ולמען החברה הערבית. לפרסם ולהוציא לאור מאמרים, חוברות, מחקרים ופרסומים אחרים בתחום הזהות המינית והמגדרית. להעביר הרצאות ולתכנן ימי עיון לצורך הגברת המודעות בחברה הערבית בישראל בנושאים הקשורים לזהות מינית ומגדרית. לארגן פעילויות חברתיות ותרבותיות בנושאים הקשורים לזהויות מיניות ומגדריות. לתת תמיכה אישית וקבוצתית ללהט״בים על ידי עבודה עם אנשי מקצוע רלוונטיים״. בנוסף, אסוואת מקדמת נושאים הקשורים בזכויות להט״ב, דיכוי נשים פלסטיניות הן במרחב הפטריארכלי והן במרחב הישראלי-ציוני, וקושרות בין מאבקים להט״בים, פמיניסטיים ופלסטינים. פעילויות המרכז כוללות מפגשים חודשיים ברחבי הארץ, קבוצה לטרנסג׳נדריות, פעילויות חברתיות, מסיבות, אירועי ספורט, טיולים והפעלת קו תמיכה ויעוץ. בנוסף, מפעיל הארגון קבוצת לימוד לאנשי ונשות מקצוע בתחומי החינוך והטיפול על מגון מיני ומגדרי, ומפרסם חומרים ומידע בערבית על הקהילה הלהט״בית וצרכיה בחברה הערבית.',
    'description_ar': '״أصوات- مركز نسوي فلسطيني من اجل الحقوق الجنسانية والجندرية״- هي جمعية للنساء الفلسطينيات المثليات والتي أقيمت عام 2003، بمبادرة ثلاث نساء فلسطينيات مثليات. وواحدة منهن هي روضة مرقص. بين السنوات 2003-2017، عمل المركز بشكل مستقل داخل المركز النسوي ״كيان״ في بيت ائتلاف النساء في حيفا. وفي عام 2008 سجلت الجمعية بشكل رسمي ومستقل (ج.م 580645489). ״أصوات״ والتي تتوجه للنساء المثليات، مزدوجة الجنس، المتحولات، المتوسطات والكويريات.״ تهدف الجمعية لنشاط داخل ومن اجل المجتمع العربي. لنشر مقالات، كتيبات وابحاث وغيرها من المنشورات حول الهوية الجنسية والجندرية. تمرير محاضرات وبناء أيام دراسية بهدف زيادة الوعي، إقامة نشاطات اجتماعية وتربوية حول مواضيع الهوية الجنسية والجندرية للمجتمع العربي في إسرائيل. تقديم الدعم الشخصي والجماعي للمثليين من خلال العمل مع مهنيين ذو صلة״. إضافة الى ذلك تقوم ״أصوات״ بتعزيز القضايا المتعلقة بحقوق المثليين، قمع النساء الفلسطينيات في كلا المساحتين الابوية والإسرائيلية-الصهيونية، والروابط بين المثليين، الصراعات النسوية والفلسطينية. يشمل نشاط المنظمة لقاءات شهرية في كل انحاء المنطقة. مجموعة متحولات، نشاطات اجتماعية، حفلات، فعاليات رياضية، رحلات وتفعيل خط مساعدة واستشارة. بالإضافة الى هذا تدير المنظمة مجموعة دراسة لنساء ورجال من مجال التربية حول التنوع الجنسي والجنسانية، وتنشر المواد والمعلومات باللغة العربية عن مجتمع المثليين واحتياجاتهم في المجتمع العربي.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ],
      [
        'חינוך',
        'להט״ב'
      ]
    ],
    'id': 'SA20',
    'is_active': true,
    'keywords': [
      'לסביות',
      'קו סיוע',
      'פמיניזם',
      'מיניות',
      'אקטיביזם',
      'אינטרסקס',
      'מחקר פמיניסטי',
      'תמיכה נפשית',
      'כיבוש',
      'הוצאה לאור'
    ],
    'name': 'אסוואת -מרכז פמיניסטי פלסטיני לזכויות מיניות ומגדריות',
    'name_ar': 'أصوات- المركز النسوي الفلسطيني للحريات الجنسية والجندرية',
    'name_change_year': null,
    'name_common': 'אסוואת',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-09-06'
    },
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אסוואת – מרכז פמיניסטי פלסטיני לזכויות מיניות ומגדריות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580645489'
      },
      {
        'title': 'ספרן, חנה, הרטל, רחלי וששון-לוי, אורנה (2016). הי[א]סטוריה לסבית מקומית: פעילות, מאבקים והישגים. בתוך: הראל, אלון, לושינסקי, יניב ומורגנשטרן, עינב (עורכים), <b>זכויות הקהילה הגאה בישראל: משפט, נטייה מינית וזהות מגדרית</b> (עמ\' 45–80). האוניברסיטה העברית, המכון למחקרי חקיקה ולמשפט השוואתי. צפרירים: נבו.'
      },
      {
        'title': 'Krahulik, Karen C. (2005). Aswat (Voices): An interview with Rauda Morcos. <b>Peace & Change 30</b>(4), 492-520.'
      },
      {
        'title': 'Habib, Samar (2016). LGBT activism in the Middle East. In <b>The Wiley Blackwell encyclopedia of gender and sexuality studies</b>.'
      }
    ],
    'target_audiences': [
      'נשים ערביות',
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '11/04/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2003,
    'year_registered': 2018
  },
  {
    'activity_kinds': [
      'אקטיביזם רשת',
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '19/05/2018'
    },
    'description': 'אסל״י (ארגון \'סרט לבן\' ישראל) היא עמותה ישראלית (ע״ר 580619799) והסניף המקומי של תנועת ה\'סרט הלבן\' (White Ribbon) הבינלאומית. \'סרט לבן\' היא התנועה הגדולה בעולם של גברים ונערים שפועלים לשים קץ לאלימות נגד נשים ונערות ולפעול לקידום שוויון מגדרי, יחסים בריאים בין המינים וחזון חדש של גבריות. התנועה הוקמה בקנדה בשנת 1991 ופועלת כיום ביותר מ- 60 מדינות ברחבי העולם. התנועה מקדמת את חזונה ורעיונותיה באמצעות פעילויות חינוכיות, העלאת מודעות, הפצת חומרי הסברה, פעולות שטח, הקמת שותפויות וקמפיינים יצירתיים במטרה ליצור שינוי חברתי ותרבותי שיסייע לצמצם ולמגר את תופעת האלימות נגד נשים. מטרות העמותה הישראלית הן: ״לפעול להעלאת המודעות לכל סוג של אלימות כלפי נשים, בדגש על העלאת מודעותם של גברים. אופן הפעולה לקידום מטרה זו יכלול כתיבת מאמרים בעיתונים וברשתות החברתיות, הפצת עלוני מידע, מתן הרצאות, הפקת סרטים, מסעי פרסום, וכל אמצעי אחר להפצת מידע בקרב הציבור; לפעול למניעת אלימות כלפי נשים. על מנת לקדם מטרה זו תפעל העמותה בשני ערוצים עיקריים: 1. השפעה על דעת הקהל ומקבלי ההחלטות במטרה להגביר את מדיניות האכיפה כנגד גברים אלימים ועברייני מין מחד, והטיפול בקורבנות מאידך. במקביל תפעל העמותה מול הגורמים הרלוונטיים להכנסת שיעורי מגדר ושיעורי חינוך מיני למערכת החינוך ולקידום יוזמות שפונות לגברים בוגרים במטרה למנוע אלימות כלפי נשים ולעודד התערבות של ״העומד מן הצד״ במקרי אלימות. 2. עיסוק ישיר של העמותה בחינוך ילדים ונוער לגבריות בלתי אלימה, העברת סדנאות והרצאות לבני נוער ולמבוגרים בנושא זה וקריאה לגברים להצטרף למאבק באלימות כלפי נשים באמצעות דף הפייסבוק של העמותה, באמצעות קמפיינים תקשורתיים ובדרכי פירסום והסברה נוספים; לבצע כל פעולה שתהיה דרושה או מועילה או רצויה לשם ביצוע מטרות העמותה וכל פעולה שיוחלט עליה במוסדות העמותה.״ בין מייסדי העמותה הישראלית אביב יהלום, יותם קונסטנטיני וירון שוורץ.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'חינוך',
        'פמיניזם ושוויון בין המינים'
      ],
      [
        'תעשיית המין',
        'פורנוגרפיה'
      ]
    ],
    'id': 'YB57',
    'is_active': true,
    'keywords': [
      'גבריות',
      'שוויון מגדרי',
      'אלימות במשפחה',
      'אלימות מינית',
      'פורנוגרפיה',
      'הטרדה מינית'
    ],
    'name': 'ארגון סרט לבן ישראל',
    'name_ar': 'أصلي- منظّمة الشريط الأبيض في إسرائيل',
    'name_change_year': null,
    'name_common': 'אסל״י',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'לפיד',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'אקטיביזם רשת',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'גברים',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אסל״י – ארגון סרט לבן ישראלי (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580619799'
      },
      {
        'title': 'אסל״י – ארגון \'סרט לבן\' ישראל, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/whiteribbonisrael/'
      },
      {
        'title': 'אביב יהלום (אסל״י – ארגון סרט לבן ישראל) גברים הפועלים נגד אלימות מינית כלפי נשים (2015). סרטון [יו״ר אסל״י אביב יהלום נואם]. נדלה מתוך',
        'url': 'https://www.youtube.com/watch?v=BHS6V8XkY-c'
      }
    ],
    'target_audiences': [
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': 2016
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '28/01/2019'
    },
    'description': '״אפאק אלמסתקבל להעצמת האדם״ (ע״ר 580590867) נוסדה בשנת 2014 במטרה לפעול ל״קידום החינוך והתעסוקה בדרום, קיום הדרכות העצמה במיוחד לנשים מהמגזר הבדואי, מתן מלגות לסטודנטים הלומדים במוסדות להכשרה גבוהה, הדרכה והכוונה לתלמידי י״ב בבחירת מקצוע הלימודים באוניברסיטה״.העמותה מקיימת קייטנות, אירועי תרבות וטיולים בטבע. קהל היעד הוא תלמידים ותלמידות בחינוך היסודי, בנים ובנות כאחד.',
    'description_ar': 'افاق المستقبل للتمكين (ج.م 580590867) تأسست عام 2014 بهدف العمل لتطوير التعليم والعمل في الجنوب، اقامة دورات ارشاد وتمكين بالأخص للنساء من المجتمع البدوي، توزيع منح لطلاب الاكاديميات، توجيه وارشاد لطلاب الثواني عشر في مجال التوجيه المهني. تقيم الجمعية مخيمات وفعاليات ثقافية ومسارات طبيعية. جمهور الهدف هو الطلاب والطلاب في التعليم الابتدائي، بنين وبنات على حد سواء.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'חינוך',
        'צמצום פערים בחינוך'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'YA11',
    'is_active': true,
    'keywords': [
      'בדואיות',
      'השכלה',
      'מלגות'
    ],
    'name': 'אפאק אלמסתקבל להעצמת האדם',
    'name_ar': 'افاق المستقبل عرعرة',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ערערה-בנגב',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'חינוך',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'צמצום פערים בחינוך',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אפאק אלמסתקבל להעצמת האדם (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580590867'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '28/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחאה',
      'סנגור, מחאה ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': '״ארבע אמהות״ היתה תנועת מחאה נשית אשר הוקמה בשנת 1997 בעקבות אסון המסוקים, על ידי ארבע נשים תושבות צפון ישראל ואמהות לחיילים ששירתו בלבנון, במטרה להביא ליציאת צה״ל מרצועת הביטחון בדרום לבנון. ארבעת מקימות התנועה: רחל בן דור, מירי סלע, רונית נחמיאס וזהרה ענתבי החלו לקיים משמרות מחאה בצמתים ברחבי הארץ בקריאה לנסיגה חד-צדדית מלבנון. למרות שהתנועה החלה את דרכה ללא כוח פוליטי ומשאבים היא זכתה בתמיכה הולכת וגוברת מצד נשים וגברים וכן בסיקור תקשורתי מתמשך שהיה בחלקו אוהד ובחלקו מזלזל. התנועה נרשמה כעמותה (ע״ר 580306678) שכתובתה הרשמית היתה בקיבוץ מחניים, אך פעלה באופן ארצי ממשרד בתל אביב. ב-24 במאי 2000, כשלוש שנים לאחר הקמת התנועה, יצא צה״ל מלבנון ולאחר מכן התפרקה תנועת ארבע אמהות. ארכיון התנועה שהיה בידי רחל בן-דור מצוי באוניברסיטת אוהיו. לעמותה ניתן צו פירוק בשנת 2005.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'ביטחון לאומי'
      ]
    ],
    'id': '1YB11',
    'is_active': false,
    'keywords': [
      'אמהות',
      'מלחמה',
      'צבא',
      'שלום'
    ],
    'name': 'ארבע אמהות- יוצאים בשלום מלבנון',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'ארבע אמהות',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://library.osu.edu/projects/fourmothers/'
      },
      {
        'title': 'בנסקי, טובה (2005). תנועות נשים לשלום בישראל: מאפיינים וסוגיות נרחבות. <b>מפנה</b>, 46–47.'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 5443 (2005, 29 ספטמבר). <b>הודעות מאת הכונס הרשמי</b>. ארבע אמהות- יוצאים בשלום מלבנון (מספר עמותה 580306678). עמ\' 3478. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_word/Law10/YALKUT-5443.pdf'
      },
      {
        'title': 'Lemish, Dafna, & Barzel, Inbal (2000). \'Four Mothers\': The womb in the public sphere. <b>European Journal of Communication, 15</b>(2), 147-169.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/11/2019'
    },
    'year_closed': 2000,
    'year_closed_text': '2000',
    'year_founded': 1997,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/10/2018'
    },
    'description': '״ארגון אלמנות ויתומי צה״ל״ (ע״ר 580202166) נרשם בירושלים בשנת 1991 בשם ״העמותה למען ציבור שארי חללי מערכות ישראל״. בשנת 1996 הוכרה העמותה על ידי משרד הביטחון כארגון היציג הבלעדי הפועל לרווחת האלמנות והיתומים אשר בני זוגן או אביהם נהרג מאז מלחמת השחרור ועד היום ובשנת 1999 שונה שמה בהתאם. ההכרה של משרד הביטחון סייעה לעמותה לקבל תמיכות ממשלתיות ולגייס תרומות בארץ ובחו״ל למימוש מטרותיה: ״העמותה תפעל אצל כל אדם או גוף או ארגון או רשות שלטונית או בציבור בכלל, למען שיקום מצבם של חברי העמותה, הן כציבור וכן כפרטים, ולמען אירגון וגיוס סיוע ועזרה מגופים שונים בתחום החברתי והכלכלי ובכל הקשור בחינוך ותעסוקה״. מאז הקמתו, הארגון מקיים מפעלים ופעילויות רבות כגון טיולים, מחנה קיץ וארועי תרבות למען משפחות שכולות, תוך מתן תמיכה רגשית או כל תמיכה נחוצה אחרת. העמותה גם מפיקה ביטאון ומחלקת שי לנישואים ומלגות לסטודנטים. הארגון פועל כישות דמוקרטית ומוסדותיו נבחרים על ידי חבריו בבחירות המתקיימות אחת ל- 4 שנים, בהן נבחרת אסיפה כללית המונה 50 חברות וחברים. חברי האסיפה הכללית הם אלה הבוחרים את הועד המנהל המונה 7 חברות ובראשו עומדת יו״ר הארגון. הועד המנהל עוסק בין היתר בבחינת צרכיהם של האלמנות והיתומים ודרכים לסיוע, מגיש למשרד הביטחון הצעות לשיפורים בתקנות הקיימות וכן פועל בממשלה ובכנסת ליזום חקיקה בנושאים שונים הקשורים לקידום מצבם של האלמנות והיתומים. בהקשר זה, הסוגיה המרכזית שבה עסק הארגון נגעה לזכויותיהן הכלכליות של אלמנות צה״ל הנישאות בשנית או המקיימות קשר זוגי ללא נישואין.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'צבא, ביטחון ומדיניות חוץ',
        'התאגדויות'
      ],
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ]
    ],
    'id': 'SA71',
    'is_active': true,
    'keywords': [
      'אלמנות',
      'חקיקה',
      'מלגות',
      'מלחמה',
      'פנאי',
      'תמיכה נפשית'
    ],
    'name': 'ארגון אלמנות ויתומי צה״ל',
    'name_ar': null,
    'name_change_year': 1999,
    'name_common': null,
    'name_past': 'העמותה למען ציבור שארי חללי מערכות ישראל',
    'name_replaced_by': null,
    'official_address': 'גבעת שמואל',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'צבא, ביטחון ומדיניות חוץ',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'התאגדויות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-24'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.idfwo.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>ארגון אלמנות ויתומי צה״ל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580202166'
      },
      {
        'title': 'לבל, אודי (2012). גבולות הוויקטימיזציה ועיצוב ההיררכיה של השכול: חללי הטרור אל מול דעיכתו ותקומתו של שיח השכול הרפובליקני. <b>תרבות דמוקרטית, 14</b>, 153–200.‎ נדלה מתוך',
        'url': 'https://www.jstor.org/stable/24146648?seq=1#metadata_info_tab_contents'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '12/02/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1991,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחאה',
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '15/01/2019'
    },
    'description': 'ארגון האמהות החד-הוריות בדימונה הוקם בסוף 2003 על ידי קבוצת נשים מקומיות בראשות אילנית לוגסי שייסדה קייטנה לאמהות חד-הוריות בעיר בשנת 1997. הארגון הוקם כקבוצת מחאה בעקבות מדיניות קיצוץ הקצבאות שהנהיג שר האוצר בנימין נתניהו. קיים מעט מאוד מידע על פעילות הקבוצה שלא נרשמה כעמותה, אך נראה כי בין פעילויותיה נכללו הקמת מפעל הזנה בבתי ספר שנועד לספק תעסוקה לאמהות חד-הוריות (בתמיכת משרד התמ״ת והביטוח הלאומי), ארגון קייטנה שנתית למשפחות חד-הוריות ופעילויות חברתיות אחרות. בשנת 2010 קוצץ תקציב הקייטנות וככל הנראה הסתיימה פעילות הקבוצה. לא נמצא מידע נוסף.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ]
    ],
    'id': 'SA118',
    'is_active': false,
    'keywords': [
      'אמהות גרושות',
      'ילדים/ות',
      'פריפריה',
      'סיוע כלכלי',
      'רשות מקומית'
    ],
    'name': 'ארגון האמהות החד-הוריות של דימונה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'דימונה',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים מזרחיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'גאון, בעז (2004, 27 אוגוסט). מחכות לביבי. <b>מעריב, מוסף שבת</b>.'
      },
      {
        'title': 'גיל, סימה (2010, 30 מאי). הקייטנה למשפחות חד-הוריות בדימונה בסכנה. <b>וואלה!NEWS</b>. נדלה מתוך',
        'url': 'https://news.walla.co.il/item/1680576'
      }
    ],
    'target_audiences': [
      'נשים מזרחיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '15/01/2019'
    },
    'year_closed': 2010,
    'year_closed_text': '2010',
    'year_founded': 2003,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/02/2018'
    },
    'description': '״ארגון המילדות- בישראל״ (ע״ר 580171056) הוקם בשנת 1998 במטרה: ״לעדכן את הידע וההבנה בכל הקשור לפריון ילודה ותכנון משפחה ולהשתתף בפעולות לקידום בריאות המשפחה ושיפור הטיפול ביולדת ובילוד.״ חברות הארגון בוחרות נציגה מכל חדר לידה שמייצגת אותן במועצת הארגון. הארגון פועל בתחום החינוך (הוצאה לאור של העיתון ״מילדות״ וארגון כנסים וימי עיון) וקידום של מחקר ואיסוף נתונים ופרוטוקולים שונים בתחום הלידה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ],
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ]
    ],
    'id': 'SA79',
    'is_active': true,
    'keywords': [
      'העלאת מודעות',
      'תנאי העסקה',
      'זכויות',
      'הריון',
      'לידה',
      'לידה טבעית',
      'אמהות',
      'תכנון משפחה'
    ],
    'name': 'ארגון המילדות- בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'שוהם',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-02-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.midwivesil.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>ארגון המילדות – בישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580171056'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/02/2018'
    },
    'description': '״ארגון המניפה של מקצועות הליווי וההדרכה מסביב ללידה ובמעגלי החיים״ הוקם בשנת 2007 בתל אביב על ידי קבוצה של מדריכות הכנה ללידה ותומכות לידה (דולות) בישראל. נרשם כעמותה (ע״ר 580494888) מטרות העמותה הן: ״הסדרה הכשרה וייצוג של עוסקים במקצועות הליווי וההדרכה מסביב ללידה ובמעגלי החיים. עדכון וההגדרה מעת לעת של המקצועות הנ״ל בהתאם לנסיבות. הפקת ימי עיון והשתלמויות. יידוע הציבור באשר לזכותו לליווי בלידה ולאחר לידה. ייצוג חברי הארגון הן כלפי חוץ והן כלפי פנים-כערכאה לבירורים בסוגיות שונות.״ העמותה הקימה אתר אינטרנט וקיימה מספר כנסים ומפגשים (כפי שעולה מהדוח הכספי של 2010) שעסקו בחקיקה, מדיניות ציבורית בנושאים הנוגעים למעמדן החוקי והתעסוקתי של תומכות לידה בישראל. בשנת 2017 הוגש הדוח האחרון של העמותה ולאחר מכן היא החלה בהליכי מחיקה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ],
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ]
    ],
    'id': 'SA78',
    'is_active': false,
    'keywords': [
      'הכשרה מקצועית',
      'העלאת מודעות',
      'תעסוקה',
      'תנאי העסקה',
      'זכויות',
      'דולות',
      'הריון',
      'לידה'
    ],
    'name': 'ארגון המניפה של מקצועות הליווי וההדרכה מסביב ללידה ובמעגלי החיים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-02-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://dulot.co.il/hamenifa/show.asp?art=1'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>ארגון המניפה של מקצועות הליווי וההדרכה מסביב ללידה ובמעגלי החיים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580494888'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '29/09/2021'
    },
    'year_closed': 2017,
    'year_closed_text': '2017',
    'year_founded': 2007,
    'year_registered': 2009
  },
  {
    'activity_kinds': [
      'פילנתרופיה',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/02/2019'
    },
    'description': 'ארגון נשות-אורט נוסד בשנת 1950 בסיוע ארגון נשות אורט באמריקה במטרה לשמש כזרוע הנשים של ״אורט ישראל״ (1949, חל״צ). הארגון החל לפעול בתחילה בשלוש הערים הגדולות: ירושלים, חיפה ותל-אביב, ולימים הרחיב את פעילותו במרבית היישובים שבהם ממוקמים מוסדות אורט. הארגון פועל על בסיס התנדבותי, רשומות בו 45,000 נשים, מתוכן פעילות 400. הארגון פועל למען קידום רווחתם של התלמידים ברשת אורט– החל מצרכים פיזיים (כמו מזון ולבוש לנזקקים, מזנון/קפיטריה בבתיה״ס וכו\'), וכלה בצרכים לימודיים (ספריות, מלגות לנזקקים ולמצטיינים בתחום החברתי ועוד). בין המטרות המעודכנות של הארגון - עידוד בנות ללימודי טכנולוגיה ומדע.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'חינוך',
        'כללי'
      ]
    ],
    'id': 'YH173',
    'is_active': true,
    'keywords': [
      'חינוך',
      'מלגות',
      'פילנתרופיה',
      'מדע וטכנולוגיה',
      'ילדות/ים'
    ],
    'name': 'ארגון נשות אורט',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'פילנתרופיה',
    'primary_field_of_activity': 'חינוך',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'כללי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': '(1973, 11 יוני). ״בזאר אורט 73״: בחסות חנה מרון. <b>דבר</b>. נדלה מתוך',
        'url': 'http://www.jpress.nli.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=DAV%2F1973%2F06%2F11&id=Ar01102&sk=8B19FAEC'
      },
      {
        'title': 'הוועדה לקידום מעמד האשה (1999, 13 ינואר). פרוטוקול מס\' 185: מליאה – ישיבת עבודה עם מועצת ארגוני הנשים. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_word/Law103/14_ptv_478730.pdf'
      },
      {
        'title': 'הרשת להתנדבות ישראלית, המועצה הלאומית להתנדבות בישראל (ללא תאריך). <b>ארגון נשות אורט</b> (העמוד אינו זמין יותר).'
      },
      {
        'title': 'צפרוני, אבי (2009). ריאיון עם גב\' דבורה תומר, הנשיאה לשעבר של ארגון נשות אורט, ועם גב\' רחל מאיר, הנשיאה הנוכחית. <b>עיונים, 9</b>.',
        'url': 'https://books.ort.org.il/%D7%A8%D7%99%D7%90%D7%99%D7%95%D7%9F-%D7%A2%D7%9D-%D7%92%D7%91-%D7%93%D7%91%D7%95%D7%A8%D7%94-%D7%AA%D7%95%D7%9E%D7%A8-%D7%94%D7%A0%D7%A9%D7%99%D7%90%D7%94-%D7%9C%D7%A9%D7%A2%D7%91%D7%A8-%D7%A9/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '01/07/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '02/03/2019'
    },
    'description': 'הארגון הארצי לקידום מעמד השוטר והסוהר, ״ארגון נשות השוטרים והסוהרים״, הוא עמותה רשומה (ע״ר 580045474) אשר נוסדה בשנת 1983 על ידי נשות השוטרים והסוהרים, במטרה לסייע לרווחת ציבור השוטרים והסוהרים. מכיוון שעל שוטרים וסוהרים בישראל נאסר להתארגן באיגוד מקצועי מופעל הארגון על ידי חברי משפחות השוטרים והסוהרים, בעיקר נשותיהם. לפני הקמת הארגון ב-1982, פעל בארץ מ-6 ביוני 1976 ארגון בשם ״ועד הפעולה של נשות השוטרים״, שהוקם על ידי נורית שפירא; הארגון הפסיק לפעול עם הקמת איגוד השוטרים, ורק אחרי חקיקת חוקים נגד התארגנות שוטרים הפעילה שפירא שנית את ״ארגון נשות השוטרים בישראל״. מטרות הארגון הן: לפעול לקידום מעמדם של השוטרים והסוהרים בישראל, שמירה ושיפור רווחתם. לסייע לשוטרים ולסוהרים הנמצאים במצוקה משפטית, כספית, בריאותית, משפחתית ואישית מכל סוג. לקדם פעולות של עזרה הדדית בקרב החברים. ליזום ולעודד פעילות חברתית, תרבותית והתנדבותית בקרב החברים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'צבא, ביטחון ומדיניות חוץ',
        'התאגדויות'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'SA123',
    'is_active': true,
    'keywords': [
      'תנאי עבודה',
      'תנאי העסקה',
      'ביטחון סוציאלי',
      'זכויות',
      'רישות',
      'סיוע כלכלי',
      'סיוע משפטי',
      'תעסוקה'
    ],
    'name': 'הארגון הארצי לקידום מעמד השוטר והסוהר',
    'name_ar': null,
    'name_change_year': 1983,
    'name_common': 'ארגון נשות השוטרים והסוהרים',
    'name_past': 'ועד הפעולה של נשות השוטרים',
    'name_replaced_by': null,
    'official_address': 'לוד',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'צבא, ביטחון ומדיניות חוץ',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'התאגדויות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-03-02'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://neshot.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>הארגון הארצי לקידום מעמד השוטר והסוהר: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580045474/documents'
      },
      {
        'title': 'סמובסקי, אבי, ואסתרמן-מדינה, תמר (2002). נסיון התאגדות השוטרים בישראל – 1978–1979: אנטומיה של כשלון התארגנות, <b>משטרה וחברה, 6</b>, 173. נדלה מתוך',
        'url': 'https://www.xn--7dbl2a.com/wp-content/uploads/2015/05/%D7%A1%D7%9E%D7%95%D7%91%D7%A1%D7%A7%D7%99-%D7%95%D7%90%D7%A1%D7%AA%D7%A8%D7%9E%D7%9F-%D7%94%D7%AA%D7%90%D7%92%D7%93%D7%95%D7%AA-%D7%A9%D7%95%D7%98%D7%A8%D7%99%D7%9D.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '02/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1976,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/12/2018'
    },
    'description': 'ארגון נשות עובדי משרד החוץ הוקם בשנת 1981 במטרה לקדם את הזכויות הסוציאליות של נשות הדיפלומטים, לשמור את זכויות הפנסיה שלהן ולהתמודד עם בעיית העדר הרצף התעסוקתי של נשות עובדי משרד החוץ. בין המטרות המקוריות של הארגון נכללה גם פעולה לקראת מיסוד מעמדה של אשת השגריר כישות עצמאית. עם השנים, הצטמצמה פעילות הארגון והסתעפה לכלול גם את ארגון נשות גמלאי משרד החוץ. העדויות האחרונות לפעילות הארגון הן משנת 2002. מאז הארגון, ככל הנראה, אינו פעיל יותר.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'צבא, ביטחון ומדיניות חוץ',
        'התאגדויות'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'SA105',
    'is_active': false,
    'keywords': [
      'פנסיה',
      'תעסוקה',
      'ביטחון סוציאלי',
      'זכויות'
    ],
    'name': 'ארגון נשות עובדי משרד החוץ',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'צבא, ביטחון ומדיניות חוץ',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'התאגדויות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'ברזילי-יגר, דבורה (2002). חמישים שנות תמורה בשירות החוץ של נשות הדיפלומטים. בתוך: גוברין, יוסף, יגר, משה ועודד, אריה (עורכים). <b>משרד החוץ: 50 השנים הראשונות</b>, כרך ב (עמ\' 1124). ירושלים: כתר.'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה (1999, 12 ינואר). <b>פרוטוקול מס\' 184: מליאה – הגדלת ייצוג נשים במשרות הבכירות בשירות הדיפלומטי וקידומן</b>. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il//14/Committees/14_ptv_478727.PDF'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '21/02/2019'
    },
    'year_closed': 2003,
    'year_closed_text': '2003',
    'year_founded': 1981,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/07/2019'
    },
    'description': '״ארגון נשי עכו״ הוא אחד הארגונים הותיקים ביותר שהוקמו על ידי נשים ערביות בישראל. הוא נרשם כאגודה עותומנית בשנת 1975 וכעמותה בשנת 1990. מטרת העמותה (ע״ר 580105963) היא לפעול למען ״ארגון הנשים הערביות וקיום פעילות למען קידום מעמדן ופתרון בעיותיהן החברתיות, החינוכיות התרבותיות.״ החל ממשנת 1976 מפעיל הארגון גן ומעון יום המוכרים על ידי משרד העבודה והרווחה. בנוסף, הוא מפעיל מועדון בעיר עכו שבו מתקיימים קורסים לנשים, כולל הכשרת מטפלות ונשות חינוך וספריה לקהל הרחב. העמותה גם מחזיקה קרן הלוואות קטנות (עד 15,000 ₪ ללא ריבית) לנשים מעכו והסביבה שזקוקות לכך.',
    'description_ar': 'جمعية النساء العكيات: وهو أحد أقدم الجمعيات التي أقمتها نساء عربيات في إسرائيل. وقد سجل كسجل عثماني عام 1975 وكجمعية عام 1990. تهدف الجمعية للعمل من أجل ״ تنظيم النساء العربيات وتحقيق نشاطات من اجل تعزيز مكانة النساء وحل مشاكلهن الاجتماعية التربوية والثقافية.״ منذ مطلع عام 1976 تدير الجمعية حضانة ونادي يومي المعترف بهم من قبل وزارة الرفاه الاجتماعي، كما وانها تدير نويدية في عكا التي توفر مساقات للنساء تشمل: تدريب حاضنات ومربيات ومكتبة عامة. تقوم الجمعية بتمويل صندوق قروض صغيرة حتى 15,000 لا يشمل ضرائب. لنساء محتاجات من عكا والمنطقة.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'חינוך',
        'הגיל הרך'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'YH174',
    'is_active': true,
    'keywords': [
      'הלוואות',
      'העצמה',
      'השכלה',
      'משפחה'
    ],
    'name': 'ארגון נשי עכו- מרכז פדגוגי',
    'name_ar': 'جمعية النساء العكيات',
    'name_change_year': null,
    'name_common': 'ארגון נשי עכו',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'עכו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעונות ומשפחתונים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-07-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://projectrozana.org/acre-arab-women-association/'
      },
      {
        'title': 'משרד המשפטים (2017). <b>ארגון נשי עכו - מרכז פדגוגי (ע״ר): דוחות כספיים לשנה שנסתיימה ב-31 בדצמבר 2016</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/VF_View_File?guid=42b4b2f84dcc38c-acf78b5df67d8e88-f5223bc3b70d57b0a955f353103244532a43abcb6c051d00f55b79281b69c3a7-93b8ca0c4dbc6979-65aabfb02f2507619'
      },
      {
        'title': 'אבו-בקר, ח\'אולה (1998). <b>בדרך לא סלולה: נשים ערביות כמנהיגות פוליטיות בישראל</b>. רעננה: הוצאת המרכז לחקר החברה הערבית בישראל.'
      },
      {
        'title': 'אבו-בקר, ח\'אולה (2015). התנועה הנשית-פמיניסטית הפלסטינית בתוך ישראל. בתוך: סבאע\'-ח\'ורי, אריז\' ורוחנא, נדים (עורכים). <b>הפלסטינים בישראל: עיונים בהיסטוריה, בפוליטיקה ובחברה</b>. כרך שני (עמ\' 205–222). חיפה: מדה אל-כרמל. נדלה מתוך',
        'url': 'http://mada-research.org/wp-content/uploads/2016/01/hebrew_2-4.pdf'
      },
      {
        'title': 'ועדת החוקה, חוק ומשפט (1989, 18 יולי). <b>פרוטוקול מס\' 54: חוק איסור מכירת משקאות משכרים לקטינים, התשמ״ט-1989(מאת חבר-הכנסת מי בר-זהר}; חוק לתיקון פקודת מניעת טרור (מס\' 3), התשמ״ט-1989</b>. נדלה מתוך',
        'url': 'https://oknesset.org/meetings/2/0/2051055.html'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/07/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1975,
    'year_registered': 1990
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/07/2018'
    },
    'description': 'עמותת א.נ.לי. היא ארגון נשים מהוותיקים בארץ. בעבר נקרא הארגון ״ארגון נשים ליברליות״ שנוסד לאחר איחוד עם ״ארגון נשים ציוניות כלליות״. בראש הארגון עמדו נשים מובילות, ביניהן חברות הכנסת לשעבר שושנה פרסיץ, שרה דורון ונעמי בלומנטל. הארגון פעל בעיקר בתחומים החברתיים, כאשר בחסותו הוקמו מעונות יום, מרכז קהילתי ובתי ספר מקצועיים לבנות. היום ארגון א.נ.לי. מפעיל מעון לילדים ברחובות (מעון הדקל) וממשיך בפעילות חברתית לקידום נשים בקהילה, בציבור ובעבודה. מטרות העמותה הן: ליטול חלק פעיל בהתפתחות החברתית, הכלכלית והמדינית של ישראל. לקדם את מעמד האישה הישראלית בחברה, בכלכלה ובפוליטיקה. סיוע להתפתחות האישה בכל שטחי החיים בישראל. סיוע למוסדות ומפעלים תרבותיים, חינוכיים וחברתיים. שיתוף בעבודה הקהילתית בערים, בעיירות, בישובי פיתוח בהתיישבות. לעזור לעולים חדשים להתאקלם בארץ. להרחיב את ההיכרות עם ארץ ישראל עם מורשת ישראל ועם מדינת ישראל. ליצור איכות חיים ואיכות חברה טובות יותר.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ]
    ],
    'id': 'SA85',
    'is_active': true,
    'keywords': [
      'מעונות ומשפחתונים',
      'חינוך',
      'הכשרה מקצועית',
      'קליטת עלייה',
      'כנסת'
    ],
    'name': 'עמותת א.נ.לי.',
    'name_ar': null,
    'name_change_year': 1983,
    'name_common': 'ארגון נשים ליברליות',
    'name_past': 'ארגון נשים ליברליות וארגון נשים ציוניות כלליות',
    'name_replaced_by': null,
    'official_address': 'רחובות',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעונות ומשפחתונים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-11-07'
    },
    'sources': [
      {
        'title': 'על הארגון באתר ״מעון הדקל״ ברחובות',
        'url': 'https://hadekel.infogan.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת א.נ.לי. (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580052470'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/07/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': 1983
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/02/2018'
    },
    'description': '״ארגון תומכות הלידה בישראל״ (ע״ר 580475614) הוקם בשנת 2007 בכפר סבא על ידי רוני חטב מבית הספר ״קשת בענן״ כאיגוד מקצועי של דולות במטרה: ״לאגד את כל תומכות הלידה תחת קורת גג אחת וליצור הידברות חוזית סדירה והוגנת מול בתי החולים בארץ והצוותים הרפואיים. לרבות ציבור המיילדות. להעלות את המודעות של נשים הרות למקצועיותן של תומכות הלידה בישראל. לאפשר לנשים הרות לבחור ללדת בדרכן, כל עוד לא קיימת סכנה להן או לילוד״. לעמותה אין דוחות פעילות ונראה כי היא פעלה במשך זמן מועט. בשנת 2008 הוקם ״ארגון המניפה של מקצועות הליווי וההדרכה מסביב ללידה״ אשר פועל למטרות דומות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ],
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ]
    ],
    'id': 'SA77',
    'is_active': false,
    'keywords': [
      'העלאת מודעות',
      'תעסוקה',
      'תנאי העסקה',
      'זכויות',
      'דולות',
      'הריון',
      'לידה',
      'איגוד מקצועי'
    ],
    'name': 'ארגון תומכות הלידה בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר סבא',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>ארגון תומכות הלידה בישראל</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/09/2019'
    },
    'year_closed': 2008,
    'year_closed_text': '2008',
    'year_founded': 2007,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '20/06/2018'
    },
    'description': 'אשה לאשה מרכז פמיניסטי חיפה״ (ע״ר 580051456) הוקמה בחיפה בשנת 1983 והיא אחד הארגונים הפמיניסטיים הוותיקים בישראל ומהקולות המובילים במאבק למען זכויות נשים בארץ. מטרות העמותה הן: ״קידום מעמד וזכויות נשים ונערות וקידום ביטחון, שלום וצדק חברתי וכלכלי מתוך תפישה פמיניסטית על ידי חינוך, מחקר ואספקת מידע, סיוע, קידום חקיקה, קיום פעילויות תרבותיות וציבוריות ומתן סיוע כספי״. אשה לאשה מנוהלת על ידי קולקטיב הפתוח לכל הנשים. כל ההחלטות מתקבלות פה אחד, על דעת כל המשתתפות בקולקטיב. מבנה העמותה הנו אופקי, ללא היררכיה – אין הנהלה ואין מנהלת. כל המוסדות נבחרים לפי ״שיטת הרבעים״ הקוראת לייצוג שווה לנשים ערביות, מזרחיות, לסביות ואשכנזיות. לאורך השנים עסק הארגון בנושאים שונים כמו: אלימות כלפי נשים, תעסוקה, העלאת מודעות פמיניסטית, פרסום פוגע, בריאות נשים, נשים וזקנה, נשים שלום ובטחון, נשים וטכנולוגיות רפואיות, מאבק בסחר בנשים, נשים ומוגבלות ועוד. מרכז ״אשה לאשה״ הוא בית פתוח המקיים פעילויות קהילתיות ותרבותיות לאורך כל השנה: כנסים, הרצאות, סמינרים, הכשרות והתמחויות, מידע ויעוץ טלפוני, קבוצות מנהיגות ועוד. בבית קיים מרכז מידע הכולל ספריה וארכיון פמיניסטי.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'תעשיית המין',
        'סחר בנשים'
      ]
    ],
    'id': 'SA27',
    'is_active': true,
    'keywords': [
      'אזרחות',
      'אלימות במשפחה',
      'ביטחון אישי',
      'החלטה 1325',
      'הפלה',
      'זקנה',
      'חינוך פמיניסטי',
      'טכנולוגיות פריון',
      'מגוון',
      'מחקר פמיניסטי',
      'נשק',
      'פונדקאות',
      'פרסום פוגע',
      'קולקטיב',
      'שלום',
      'צדק חברתי',
      'תרומת ביציות',
      'מחאה'
    ],
    'name': 'אשה לאשה-מרכז פמיניסטי חיפה',
    'name_ar': 'إمرأة لإمرأة - المركز النسوي حيفا',
    'name_change_year': 1993,
    'name_common': null,
    'name_past': 'אשה לאשה מרכז נשים חיפה',
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://isha2isha.com/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אשה לאשה מרכז פמיניסטי חיפה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580051456'
      },
      {
        'title': 'אשה לאשה - מרכז פמיניסטי חיפה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/HaifaFeministCenter'
      },
      {
        'title': 'ספרן, חנה ובר-דין, תלמה (עורכות). (2013). <b>אשה לאשה פמיניסטית: שלושים שנות פעילות</b>. חיפה: הוצאת פרדס ואשה לאשה, מרכז פמיניסטי. נדלה מתוך',
        'url': 'http://isha2isha.com/wp-content/uploads/2018/01/%D7%90%D7%A9%D7%94-%D7%9C%D7%90%D7%A9%D7%94-%D7%A4%D7%9E%D7%99%D7%A0%D7%99%D7%A1%D7%98%D7%99%D7%AA.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'להט״ב',
      'נשים מהגרות עבודה או חסרות מעמד',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1983,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '24/05/2018'
    },
    'description': '״אתנה״ שנוסדה בשנת 2006 היא היחידה המקצועית של המועצה הציבורית לקידום ספורט הנשים בישראל, בפיקוח משרד התרבות והספורט. ״אתנה״ מוגדרת כפרויקט לאומי לקידום נשים בספורט ומופעלת על ידי מכון וינגייט. תהליך הקמת הפרויקט הלאומי נבע מהמלצות הועדה המייעצת שמינתה שרת התרבות והספורט, לימור לבנת (״ועדת קונסטנטיני״) בשנת 2004 ומהחלטת ממשלה מספר 3416 ממרס 2005, אשר אימצה אותן ואישרה את הקמת המועצה הציבורית לקידום ספורט נשים בישראל. אתנה פועלת בתכנית רב-שנתית במטרה לקדם תכניות ייעודיות לילדות, נערות ונשים במגוון ענפי ספורט, גופי ספורט, פרויקטים במועדוני ספורט. התכניות כוללות שיתופי פעולה עם רשויות מקומיות ברחבי הארץ, בתחום הספורט התחרותי והספורט העממי, ופעילות לקידום מנהיגות נשים בספורט. בנוסף, אתנה פועלת לקידום השיח הציבורי והמקצועי בתחום נשים בספורט באמצעות כנסים, פורומים ומפגשים.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'ספורט'
      ],
      [
        'נערות וצעירות',
        'חינוך'
      ]
    ],
    'id': 'YH8',
    'is_active': true,
    'keywords': [
      'ספורט',
      'ליגה',
      'מלגות',
      'מנהיגות'
    ],
    'name': 'הפרויקט הלאומי לקידום ספורט הנשים בישראל',
    'name_ar': 'أثينا – الوحدة المهنية – المشروع الوطني لتعزيز مكانة النساء في الرياضة',
    'name_change_year': null,
    'name_common': 'אתנה',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נתניה',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'ספורט',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-24'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.athenawomen.org.il/'
      },
      {
        'title': 'מבקר המדינה ונציב תלונות הציבור (2013). היבטים בפעולות לקידום ספורט נשים בישראל.  יוסף חיים שפירא (מבקר המדינה), <b>דוח מבקר המדינה 63ג, לשנת 2012 ולחשבונות שנת הכספים 2011</b> (עמ\' 1481–1545). נדלה מתוך',
        'url': 'http://www.mevaker.gov.il/he/Reports/Report_114/d9c55a26-855b-4c9d-8f72-444c2943c341/7994.pdf'
      },
      {
        'title': 'מזרחי, שלי (2013, 24 יוני). <b>שילוב נשים בספורט: פעילות המועצה הציבורית לקידום ספורט הנשים בישראל</b>. ירושלים: מרכז המידע והמחקר של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/e6ef6d8d-f1f7-e411-80c8-00155d01107c/2_e6ef6d8d-f1f7-e411-80c8-00155d01107c_11_10006.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2006,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '07/04/2019'
    },
    'description': 'באלעטאא נחיא (ע״ר 580593135) היא עמותה שהוקמה בשנת 2014 באכסאל. מטרות העמותה הן ״לסייע להרחבת המודעות בקרב הנשים בעיקר בכל הנוגע לזכויותיהן בחברה, מתן הדרכות והרצאות בכל הנוגע לקידום הפן הנשי ושילובו בתוך האוכלוסייה, תוך הגברת המודעות והפניית שימת הלב לדרכים ולשיטות חדשניות שיגרמו לשיפור מעמדן של הנשים בראי החברה הישראלית בכלל ובראי החברה הערבית בפרט״. פעילויות העמותה מתרכזות באכסאל וכוללות הדרכות, הרצאות וחוגי העשרה והכשרה לנשים בנושאים הנוגעים לזכויות נשים ומעמדן בחברה',
    'description_ar': 'بالعطاء نحيا (ج.م 580593135) هي مؤسسة غير ربحية تأسست عام 2014 في إكسال. تتمثل أهداف الجمعية في ״المساعدة على زيادة الوعي بين النساء، خاصة فيما يتعلق بحقوقهن في المجتمع، توفير التدريب والمحاضرات حول تعزيز وإدماج الوجه الأنثوي داخل المجتمع، مع زيادة الوعي وتوجيه انتباههم إلى طرق وأساليب مبتكرة من شأنها تحسين وضع المرأة في وجه المجتمع الإسرائيلي بشكل عام والعربي بشكل خاص. تتركز أنشطة الجمعية في اكسال وتشمل دورات تدريبية، محاضرات ودورات إثراء والتأهيل النساء في القضايا المتعلقة بحقوق المرأة ووضعها في المجتمع.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'YA14',
    'is_active': true,
    'keywords': [
      'העצמה',
      'דת',
      'קידום נשים',
      'ערביות',
      'אסלאם'
    ],
    'name': 'באלעטאא נחיא',
    'name_ar': 'بالعطاء نحيا',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'אכסאל',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-04-07'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.facebook.com/%D8%AC%D9%85%D8%B9%D9%8A%D8%A9-%D8%A8%D8%A7%D9%84%D8%B9%D8%B7%D8%A7%D8%A1-%D9%86%D8%AD%D9%8A%D8%A7-533871730073704/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>באלעטאא נחיא (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580593135'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '30/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית',
      'שירותים משפטיים'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '28/05/2018'
    },
    'description': '״באשר תלכי״ היא עמותה (ע״ר 580581585) המספקת עזרה מיידית לנשים חרדיות ודתיות הנמצאות בהליכי גירושין ופרידה. הארגון הוקם על ידי פייני סוקניק בשנת 2013 לאחר שהשתתפה בתכנית מנהיגות נשים של ויצו. הארגון רשום בירושלים אך פועל ברחבי הארץ ועוסק בתחומים הבאים: הפעלת קו חם לפניות ושאלות בנושאים הקשורים בתהליך הגירושין; מתן ייעוץ משפטי וליווי של טוענות רבניות ועובדות סוציאליות; הפעלת רשת תמיכה טלפונית; סדנאות להעצמה אישית וקבוצות תמיכה לנשים ברחבי הארץ; ייעוץ וליווי כלכלי לנשים בתהליכי גירושין, כולל תכניות לעזרה כלכלית וליווי עסקי.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ],
      [
        'אלימות',
        'אלימות במשפחה'
      ]
    ],
    'id': 'SW7',
    'is_active': true,
    'keywords': [
      'גירושין',
      'אמהות גרושות',
      'טוענות רבניות',
      'סיוע כלכלי',
      'סיוע משפטי'
    ],
    'name': 'באשר תלכי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2018-05-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://baasher.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>באשר תלכי (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580581585'
      },
      {
        'title': 'פייני סוקניק בוגרת תכנית ה״חממה ליזמות חברתית״ של ויצו תדליק משואה. נדלה מתוך אתר ויצו',
        'url': 'http://www.wizo.org.il/page_35567'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '07/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': 2013
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'מחאה'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '11/11/2018'
    },
    'description': 'בוש - BUSH הן קולקטיב אומנות ותרבות פמיניסטי, להט״בי וקווירי. מאז 2015 הן פועלות למען שינוי חברתי דרך יצירת במות ומרחבים של אמנות, תרבות ואקטיביזם קווירי ופמיניסטי. הן עוסקות בעיקר בחקר זהות מגדרית ומינית, כמו גם סוגיות אקטואליות. הקולקטיב שעיקר פעילותו מרוכזת באזור תל אביב, פועל במגוון פלטפורמות כולל הדפסת פנזין, הקרנת סרטים, יצירת תערוכות ופסטיבלי אומנות, מיצגים והרצאות. הוא גם מייצר חממת אומנות לאמניות מתחומים שונים המבקשות להתבטא בתחומים אותם הוא מבקש לחקור. היצירות של האומניות בחממה הוצגו בשני לוחות שנה ואסופת גלויות שהפיק הקולקטיב.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'אמנות'
      ],
      [
        'להט״ב',
        'תרבות וספורט'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ]
    ],
    'id': 'LR21',
    'is_active': true,
    'keywords': [
      'קוויר',
      'קהילה',
      'פרפורמנס',
      'יצירה',
      'מיניות',
      'אקטיביזם'
    ],
    'name': 'בוש - BUSH',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'אמנות',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'בוש, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/letthebushbegin'
      },
      {
        'title': '(2018, 7 אוקטובר). ״שיח פרוזדור״ – תערוכת אמנות קבוצתית שהיא גם ליין אפ אירועים. <b>וודג\'</b>. נדלה מתוך',
        'url': 'https://www.wdg.co.il/%D7%A9%D7%99%D7%97-%D7%A4%D7%A8%D7%95%D7%96%D7%93%D7%95%D7%A8-%D7%AA%D7%A2%D7%A8%D7%95%D7%9B%D7%AA-%D7%90%D7%9E%D7%A0%D7%95%D7%AA-%D7%A7%D7%91%D7%95%D7%A6%D7%AA%D7%99%D7%AA-%D7%A9%D7%94%D7%99/'
      },
      {
        'title': 'ממיסטבלוב, תמי (2019, 8 אפריל). שוברות קירות: יוצרות קולקטיב ״הבוש״ פותחות תערוכה חדשה. <b>מעריב</b>. נדלה מתוך',
        'url': 'https://www.maariv.co.il/women/Article-693080'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '02/01/2019'
    },
    'description': 'בזכות נשים (ע״ר 580505493) נוסדה בשנת 2009 למתן תמיכה כלכלית, הלוואות, ויעוץ לנשים חרדיות עובדות ובעלות עסקים; וזאת על מנת לתמוך במשפחות חרדיות. אחת ממקימות העמותה היא אביגיל שקוביצקי – רו״ח חרדית עם משרד משלה ״קבוצת מישור״ (סניף בירושלים, סניף בבני ברק, ‏ואביגיל ‏שקוביצקי עצמה גרה בבית״ר עילית), והיא מאוד מוכרת בציבור החרדי ובמעגלי ממשל בשל ‏העיסוק הרב ‏מאוד שלה לטובת הציבור החרדי, בפרט בנושא מימון מוסדות חינוך, וגם מתמקצעת ‏בחשבונאות למלכ״רים ועמותות. למרות שהיא מאורע מאוד מדינית וחברתית, והיא בעצמה אשה ‏חרדית מצליחה ופורצת דרך בתחום העסקי ‏והציבורי.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'דת ומעמד אישי',
        'תעסוקה ועבודה'
      ]
    ],
    'id': 'SW38',
    'is_active': true,
    'keywords': [
      'נשות עסקים',
      'סיוע כלכלי',
      'קריירה',
      'קידום נשים'
    ],
    'name': 'בזכות נשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בזכות נשים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580505493'
      },
      {
        'title': 'ועדת הכספים (2001, 15 מרץ). <b>פרוטוקול מס\' 672: פגיעה בתנאי שכרם של עובדי הוראה במגזר החרדי</b>. נדלה מתוך',
        'url': 'https://oknesset.org/meetings/2/0/2015544.html'
      },
      {
        'title': 'קבוצת מישור – רו״ח אביגיל שקוביצקי (2019). <b>עיתונות ומדיה: הידברות</b>. נדלה מתוך',
        'url': 'http://www.mishorcpa.co.il/%D7%A2%D7%99%D7%AA%D7%95%D7%A0%D7%95%D7%AA/'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '02/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2009,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'מחאה'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '15/04/2019'
    },
    'description': 'הארגון ״ביסקסואלים בישראל״ נוסד על ידי דניאל הופמן בשנת 2004. הוא נועד להלחם בביפוביה בתוך קהילת הלהט״ב ומחוצה לה ולהעלות את המודעות לצרכיהם של ביסקסואלים. הוא פעל בעיקר בירושלים וארגן מפגשים לקהילה הביסקוסאלית בעיר. בנוסף, הוא ארגן גושים ביסקסואלים במצעדי גאווה, הפעיל אתר עם תכנים לקהילה הביסקסואלית והוציא הודעות לתקשורת בנושאים הקשורים לקהילה. הארגון הפסיק לפעול בשנת 2007, בהחלטתו של הופמן, אשר הרגיש תחושה של מיצוי הפעילות והשלמה חלקית של מטרות הארגון.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'LR53',
    'is_active': false,
    'keywords': [
      'ביסקסואליות',
      'מצעד',
      'להט״בופוביה',
      'קהילה',
      'גאווה',
      'תקשורת'
    ],
    'name': 'ביסקסואלים בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'אייזנר, שירי (2011, 31 מאי). <b>״לשנה הבאה בי-רושלים״ – על ההיסטוריה של התנועה הביסקסואלית בארץ</b>. נדלה מתוך',
        'url': 'https://bidyke.wordpress.com/2011/05/31/%D7%9C%D7%A9%D7%A0%D7%94-%D7%94%D7%91%D7%90%D7%94-%D7%91%D7%99-%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D-%D7%A2%D7%9C-%D7%94%D7%94%D7%99%D7%A1%D7%98%D7%95%D7%A8%D7%99%D7%94-%D7%A9%D7%9C-%D7%94%D7%AA/#more-451'
      },
      {
        'title': 'גוגיי (2007, 14 מאי). נסגר ארגון ״ביסקסואלים בישראל״. נדלה מתוך',
        'url': 'http://gogay.co.il/item.php?id=5651'
      },
      {
        'title': 'Eisner, Shiri (2012). Love, rage and the occupation: Bisexual politics in Israel/Palestine. <b>Journal of Bisexuality 12</b>(1), 80-137.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '15/04/2019'
    },
    'year_closed': 2007,
    'year_closed_text': '2007',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '09/11/2018'
    },
    'description': 'בית אלה הוא המסגרת היחידה מסוגה לנשים מעל גיל 18 שסובלות מפוסט טראומה מורכבת בגין פגיעה מינית. על הקמתו הומלץ בתכנית הבין-משרדית לטיפול בנפגעות תקיפה מינית שאושרה בשנת 2007 אך הוא נוסד רק ב-2015. היוזמה להקמה והמימון להפעלת הבית הם מטעם משרד הרווחה והשירותים החברתיים והפעלתו נעשית על ידי עמותת קש״ת. הבית ממוקם ברעננה ומשרת נשים מכל רחבי ישראל. מטרת הטיפול בבית אלה היא יצירת תחושת ביטחון, הקלה, ייצוב וויסות של סימפטומים על ידי טיפול פרטני וקבוצתי. זמן השהות הממוצעת הוא שלושה חודשים.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'רווחה וקהילה',
        'אלימות מינית'
      ]
    ],
    'id': 'YH142',
    'is_active': true,
    'keywords': [
      'שיקום',
      'דיור',
      'טיפול נפשי',
      'טראומה'
    ],
    'name': 'בית אלה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רעננה',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-05-06'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.beitella.org.il/'
      },
      {
        'title': 'אשרי, מיה (2015, 31 דצמבר). מרחב נשי לטיפול: נשים שסובלות טראומה מתקיפה מינית קיבלו אלטרנטיבה לאשפוז. <b>הארץ</b>. נדלה מתוך',
        'url': 'https://www.haaretz.co.il/news/education/1.2812058'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2016, 14 פברואר). <b>פרוטוקול מס\' 58: סיור הוועדה בחלופת אשפוז</b>. נדלה מתוך',
        'url': 'http://fs.knesset.gov.il/20/Committees/20_ptv_349493.doc'
      },
      {
        'title': 'משרד העבודה הרווחה והשירותים החברתיים. סיוע לבוגרים נפגעי תקיפה מינית: שיקום נפשי במצבים קשים – חלופה אשפוזית [בית אלה]. נדלה מתוך',
        'url': 'http://www.molsa.gov.il/POPULATIONS/CRIMINALVICTIMS/ADULTSEXVICTIMS/Pages/AlternativeHospitalization.aspx'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '05/11/2018'
    },
    'description': 'הבית הגאה בבאר שבע הוקם בשנת 2000, ועד 2014 פעל כסניף מקומי של אגודת הלהט״ב. ב - 2014, בעקבות החלטת האגודה להפסיק ולתקצב את הסניפים השונים, הפך הבית הגאה לעמותה נפרדת ורשומה. בשנים האחרונות החלה העמותה לשתף פעולה עם עיריית באר שבע, אשר מתקצבת את המרכז הקהילתי שהיא מפעילה ברחוב סמילנסקי ואת שירותי העובדת הסוציאלית שהוא מציע. במרכז הקהילתי מוצעות מגוון פעילויות לקהלים שונים מתוך קהילת הלהט״ב - נשים, טרנס*, ילדים של להט״ב, מבוגרים ועוד. כמו גם חוגים כדוגמת פסיכודרמה. בנוסף מועברות בו הרצאות, מתרחשים דיונים קהילתיים והוא מהווה מקום מפגש קהילתי לארוחת שבת וחג. הבית הגאה מפעיל קבוצת קריאה קווירית בשיתוף עם המחלקה למגדר באוניברסיטת בן-גוריון. שיתוף פעולה נוסף מתרחש עם הפאב המקומי ״ביאליק 26״ שמהווה אכסניה לאירועים כמו הקרנות של האירוויזיון והרצאות לקהל הרחב. הבית הגאה פועל גם בתחומי החינוך וההסברה בעיר, ומארגן אירועי מחאה ואת אירוע הגאווה השנתי בבאר שבע, אשר בשנים האחרונות התגבש למצעד גאווה עירוני.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף מוניציפלי',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ],
      [
        'חינוך',
        'להט״ב'
      ]
    ],
    'id': 'LR12',
    'is_active': true,
    'keywords': [
      'גאווה',
      'מצעד',
      'קבוצות תמיכה',
      'קוויר',
      'חיי לילה',
      'תמיכה נפשית'
    ],
    'name': 'בית גאה בבאר שבע ובדרום',
    'name_ar': null,
    'name_change_year': 2014,
    'name_common': null,
    'name_past': 'סניף באר שבע של אגודת הלהט״ב',
    'name_replaced_by': 'סניף ב״ש של אגודת הלהט״ב',
    'official_address': 'באר שבע',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'מוניציפלי'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-11-05'
    },
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בית גאה בבאר שבע (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580590701'
      },
      {
        'title': 'בית גאה בבאר שבע ובדרום, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/proudHouseBS/about/?ref=page_internal'
      },
      {
        'title': 'מנדלבאום, רני, משגב, חן ויפתחאל, אורן (2018, 13 מאי). <b>הצד המואר של התכנון? נפילתו ועלייתו של המרחב הגאה בבאר שבע</b>. הרצאה בכנס ״סקס אחר 18״. אוניברסיטת תל אביב.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': 2014
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '08/11/2018'
    },
    'description': 'בית דרור הוא בית מחסה זמני לבני נוער להט״בים, שהוקם על ידי עיריית תל אביב ומשרד הרווחה ב - 2002. ההוסטל, המופעל על ידי עמותת ״אותות״, פתוח 24/7 בכל ימות השנה, ויכול להכיל 14 בני ובנות נוער בכל רגע נתון. קהל היעד שלו הם נערות ונערים בני 13-18 המנותקים ממסגרת חינוכית ומשפחתית בעקבות נטיתם המינית או המגדרית ומצויים בסיכון, משבר או מצוקה. הבית מעניק לדיירות מזון, קורת גג, עזרה בתחומי החיים השונים והשמה במסגרת לימודית ו/או תעסוקתית, בהתאם לרצונה של הנערה. הבית פועל גם לסיוע בגישור עם המשפחות ובמידת האפשר לשילוב מחודש של הנערה במסגרת המשפחתית. במידה ושילוב מחודש אינו עומד על הפרק ״בית דרור״ מסייע במציאת פתרונות המשך חלופיים. בנוסף הוא מעניק לשוהות בו תמיכה נפשית וליווי ביציאה לעצמאות, בהתאם לצרכיהן. ההוסטל גם מפעיל תוכנית מיוחדת לליווי נוער להט״בי שנקלע לזנות.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'רווחה ובריאות'
      ],
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'רווחה וקהילה',
        'להט״ב'
      ]
    ],
    'id': 'LR16',
    'is_active': true,
    'keywords': [
      'להט״בופוביה',
      'הוסטל',
      'תעסוקה',
      'דיור',
      'תמיכה נפשית',
      'זנות',
      'חינוך'
    ],
    'name': 'בית דרור',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'רווחה ובריאות',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-11-08'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://bethdror.org/about'
      },
      {
        'title': 'בית דרור, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/beitdror'
      },
      {
        'title': 'פזמוני-לוי, אורן, שילה, גיא ופנחסי, בתיה (2011). בעקבות הזמן הוורוד: השוואה בין-דורית בין צרכים של נוער להט״בי לבין צורכיהם של להט״בים בוגרים. <b>מפגש לעבודה חינוכית-סוציאלית, 33</b>, 103–122.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2002,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '01/05/2020'
    },
    'description': '״בית הבראה לאם ולילד בני ברק״ (ע״ר 580047124) היא עמותה שנרשמה בשנת 1984 אשר נועדה להפעלת ״בית הבראה לאמהות אחרי לידה, למשפחות ברוכות ילדים ונזקקות״. בית ההחלמה היה החלוץ מבין בתי ההחלמה ליולדות כשהוקם בשנת 1970 ביוזמת אסתר וינברג, רעיית ראש עיריית בני ברק שמואל וינברג ופעילה ב״בקור חולים״, כאגודה עותומנית (״בית הבראה לאם ולילד מיסודו של בקור חולים״). בית ההחלמה ״אם וילד״ החל את פעילותו הודות לתרומות פרטיות ולתמיכה של עיריית בני ברק והיו בו בתחילה 13 מיטות ועריסות וכן צוות של אחיות, מטפלות ועובדות נקיון ורופאה אחת שביקרה מדי יום. במשך השנים גדלה פעילותו של בית ההבראה ויש בו מעל ל-30 חדרים המיועדים ליולדות מהמגזר החרדי-דתי.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ],
      [
        'דת ומעמד אישי',
        'בריאות ופריון'
      ]
    ],
    'id': 'SA176',
    'is_active': true,
    'keywords': [
      'לידה',
      'יולדות',
      'גמ״ח'
    ],
    'name': 'בית החלמה והבראה לאם ולילד בני ברק',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'בני ברק',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2020-05-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://em-vayeled.co.il/about.html'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בית החלמה והבראה לאם ולילד בני ברק: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580047124'
      },
      {
        'title': '(1970, 9 אפריל). בית החלמה ליולדות בבני ברק. <b>למרחב</b>. נדלה מתוך',
        'url': 'https://www.nli.org.il/he/newspapers/lmrv/1970/04/09/01/article/36/?e=-------he-20--1--img-txIN%7ctxTI-%d7%91%d7%99%d7%aa+%d7%94%d7%97%d7%9c%d7%9e%d7%94+%d7%9c%d7%99%d7%95%d7%9c%d7%93%d7%95%d7%aa+%d7%91%d7%91%d7%a0%d7%99+%d7%91%d7%a8%d7%a7-------------1'
      }
    ],
    'target_audiences': [
      'נשים חרדיות',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/05/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1970,
    'year_registered': 1984
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '01/01/2020'
    },
    'description': '״בית החלמה ליולדות״ (ע״ר 580073781) נרשם כעמותה בשנת 1984 שמטרתה ״להקים, להחזיק, לנהל בתי החלמה לאם ולתינוק בו תשהינה אמהות עם תינוקותיהן לאחר הלידה״. לא ידועה שנת ההקמה המקורית של בית ההחלמה אבל בתחילה הוא הוקם בבית דירות בשכונת בית וגן בירושלים ובשנת 1989 עבר בית למשכנו הנוכחי בקרית יערים. המקום מיועד בעיקר לקהל החרדי ומספק לינה, מזון ומנוחה לאמהות בעלות משפחות ברוכות ילדים או בעלות אמצעים כלכליים מועטים. דמי ההחלמה שמשלמות הנשים אינם מכסים את העלויות ובחלקם ממומנים על ידי תרומות שונות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ],
      [
        'דת ומעמד אישי',
        'בריאות ופריון'
      ]
    ],
    'id': 'SA173',
    'is_active': true,
    'keywords': [
      'לידה',
      'יולדות',
      'גמ״ח'
    ],
    'name': 'בית החלמה ליולדות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'קרית יערים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בית החלמה ליולדות: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580073781'
      },
      {
        'title': 'מועצה מקומית קריית יערים (ללא תאריך). <b>אודות קריית יערים – טלזסטון</b>. נדלה מתוך',
        'url': 'https://kiryatyearim.muni.il/%D7%90%D7%95%D7%93%D7%95%D7%AA/'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/01/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1977,
    'year_registered': 1984
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '07/03/2018'
    },
    'description': '״קהילת נשים לומדת״ (ע״ר 580418465) היתה ארגון פמיניסטי רב תרבותי שהוקם על ידי נשים יהודיות מזרחיות ואשכנזיות, ערביות-פלסטיניות, הטרוסקסואליות ולסביות, דתיות וחילוניות. חזונה של ״קהילת נשים לומדת״ היה בניית קהילות אכפתיות ומעורבות של מנהיגות נשים בפריפריה, המקיימות מסגרת קבועה של פעילות ציבורית לקידום נשים באזורן. קהל היעד של העמותה היה נשים יהודיות, בעיקר מזרחיות ועולות חדשות, לצד נשים ערביות-פלסטיניות החיות בישראל. התפיסה הרב-תרבותית שעליה נבנה הארגון ביקשה לחשוף את הקונפליקטים הקיימים בין הקבוצות השונות ולבנות באמצעותם שיתוף הפעולה. קבלת ההחלטות בכל מסגרות העמותה נעשתה בקונצנזוס. הקהילה נרשמה כעמותה בינואר 2004, לאחר שהתנהלה במשך שנתיים כפרויקט במרכז הנשים ״קול האשה״ בירושלים. מטרות העמותה היו ״לפעול בקהילות פריפריה מוחלשות של נשים להעצמת נשים והעצמה כלכלית באמצעות פרויקטים, קורסים, לימוד ועיון. להביא את הנשים לעמדות מנהיגות בקהילה שתיצור הזדמנות לקידום. לשאוף לשינוי מצבן הפוליטי, חברתי, תרבותי ותודעתי של הנשים.״ בשנים הראשונות פעל הפרויקט כבית ספר ללא קירות והפעיל קורסים להעצמה כלכלית ופמיניסטית ביישובים ברחבי הארץ, בהם לקחו חלק כ-600 תלמידות. ברשימת הנשים המובילות נמנו מרשה פרידמן, טרי גרינבלט, אמל אל סנא, הנרייט דהאן, ויקי שירן, לאה שקדיאל, דלית באום, אסתר עילם, עמירה גלבלום ואחרות. משרדי העמותה התחלקו בין כפר קרע ולוד. המנהלות השותפות האחרונות של העמותה היו: אילנה סוגבקר (שזור) ומרוות עומרי-מרזוק. הארגון חדל לפעול בשנת 2010 והעמותה נמצאת בהליכי פירוק מרצון.',
    'description_ar': 'البيت الجماهيري للنساء (ج.م 580418465) كانت منظمة نسوية متعددة الثقافات أسستها نساء يهوديات شرقيات، اشكنازيات، فلسطينيات، مثلييات، متدينات وعلمانيات. كانت رؤية ״مجموعة النساء المتعلمات״ هي بناء مجتمعات رعاية وإشراك القيادات النسائية في المحيط، والتي تحافظ على إطار منتظم للنشاط العام لتشجيع النساء في منطقتهن. وكانت جمهور الهدف من النساء اليهوديات، وخاصة الشرقيات والمهاجرين الجدد، إلى جانب النساء العربيات الفلسطينيات المقيمات في إسرائيل. سعى المفهوم متعدد الثقافات الذي بنيت عليه المنظمة إلى كشف النزاعات القائمة بين المجموعات المختلفة وبناء التعاون من خلالها. تم تنفيذ عملية صنع القرار بالإجماع. تم تسجيل المجتمع كمؤسسة غير ربحية في يناير 2004، بعد تشغيله لمدة عامين كمشروع في مركز ״صوت المرأة ״ في القدس. أهداف الجمعية هي ״العمل في المجتمعات المهمشة النسائية والتي تفتقر لتمكين المرأة والتمكين الاقتصادي. تقوم الجمعية بهذا من خلال المشاريع والدورات ولأيام الدراسية. لجلب النساء إلى مناصب قيادية في المجتمع مما سيخلق فرصة للتقدم. والسعي من أجل التغيير وضع المرأة سياسيا، اجتماعيا وثقافيا. ״ في السنوات الأولى للمشروع عمل كمدرسة دون اطر وشغل مساقات مختلفة للتمكين الاقتصادي والنسوي في بلدات عديدة في جميع انحاء البلاد، والتي شارك بها 600 طالبة. بقائمة النساء القياديات نجد: مارشا فريدمن، تري جرينبلط، امل الصانع، هنريت دهان/ فيكي شيران، ليا شكديئيل، داليت باوم، استير عيلم، عميرة جلبلوم وغيرهن. مكاتب الجمعية كانو في كفر قرع واللد. والمديرات الشريكات هن: ايلانا سوجبرج ومرفت عمري-مرزوق. توقفت المنظمة عن العمل في عام 2010 وتخضع الجمعية للتصفية الطوعية.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'חינוך',
        'פמיניזם ושוויון בין המינים'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ]
    ],
    'id': 'YB117',
    'is_active': false,
    'keywords': [
      'העצמה',
      'חינוך פמיניסטי',
      'לסביות',
      'מנהיגות',
      'פלסטיניות',
      'פמיניזם מזרחי',
      'פריפריה',
      'שלום'
    ],
    'name': 'קהילת נשים לומדת',
    'name_ar': 'البيت الجماهيري للنساء',
    'name_change_year': null,
    'name_common': 'בית הספר הקהילתי לנשים',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר קרע',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים מזרחיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>קהילת נשים לומדת (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580418465'
      },
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל. עמ\' 120–122.'
      },
      {
        'title': 'אוסצקי-לזר, שרה (2009). <b>״לא כמו אמי״: נשים מעצימות את עצמן – המקרה של כפר קרע</b>. ירושלים: בית הספר ע״ש פדרמן למדיניות ציבורית וממשל - האוניברסיטה העברית בירושלים. נדלה מתוך',
        'url': 'https://www.sarahozacky.com/862/%D7%9C%D7%90-%D7%9B%D7%9E%D7%95-%D7%90%D7%9E%D7%99-%D7%A0%D7%A9%D7%99%D7%9D-%D7%9E%D7%A2%D7%A6%D7%99%D7%9E%D7%95%D7%AA-%D7%90%D7%AA-%D7%A2%D7%A6%D7%9E%D7%9F-%E2%80%93-%D7%94%D7%9E%D7%A7%D7%A8/'
      },
      {
        'title': 'כאן חינוכית (2018, 6 פברואר). <b>קיאן נוכחים – פמיניזם</b> (סרטון). ראיון עם מרוות עומרי מרזוק, מנהלת קהילת נשים לומדת (2009). נדלה מתוך',
        'url': 'https://www.youtube.com/watch?v=zUNeeTh-cqc'
      }
    ],
    'target_audiences': [
      'נשים מזרחיות',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '22/05/2019'
    },
    'year_closed': 2010,
    'year_closed_text': '2010',
    'year_founded': 2002,
    'year_registered': 2004
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '04/11/2018'
    },
    'description': 'בית הקהילות לגאווה וסובלנות בחיפה, נחנך ב - 02.02.2017. מדובר במרכז קהילתי הפונה לקהילה החיפאית הגאה, שהוקם בשיתוף פעולה בין העירייה, בהובלת חבר המעוצה הגאה יוסי שלום, לבין אירגונים להט״בים בעיר, כדוגמת ״הקשת החיפאית״ ו״פיץ׳ - בית לנוער גאה״. המרכז כולל סלון שמתפקד כמרחב הכרויות ומפגשים לחברי הקהילה, משרדים עבור הארגונים השונים הפועלים בעיר, מרפאה לבדיקות אידס ובית קפה. המרכז משמש כמרחב להעברת סדנאות, הרצאות וקורסים, כמוקד לארגון מחאה קהילתית, כמרחב פעולה לקבוצות חברתיות וקבוצות תמיכה עבור קהילות ספציפיות כמו טרנס*, קוויר ובי, כמרכז מפגש לארגונים ולקבוצות הפעולות מתוכם, כמקום מפגש לארוחה קהילתית בערבי שישי, וכחלל לתערוכות והקרנות סרטים עבור הקהילה, מועדון לנוער להט״בי ועוד.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'בריאות ופריון',
        'בריאות ומגדר'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'LR11',
    'is_active': true,
    'keywords': [
      'גאווה',
      'קהילה',
      'סדנאות',
      'מרפאות',
      'מחלות מין',
      'מעונות ומשפחתונים',
      'אמנות',
      'פנאי',
      'תמיכה נפשית',
      'שבתות וחגים',
      'נערות וצעירות'
    ],
    'name': 'בית הקהילות לגאווה וסובלנות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-11-04'
    },
    'sources': [
      {
        'title': 'בית הקהילות - לגאווה וסובלנות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pg/Haifa.LGBT.House/posts/?ref=page_internal'
      },
      {
        'title': 'כ״ץ, ישראל, מעוז, עדי, אלפסי, דנה, לוי, ניר (2018). <b>מיפוי ארגוני הלהט״ב בישראל - דו״ח מסכם</b>. האגודה למען הלהט״ב ואלכא – המכון למנהיגות וממשל בג\'וינט ישראל, ירושלים. נדלה מתוך',
        'url': 'https://a9991848-b055-4c6f-a966-a6bdabf09321.filesusr.com/ugd/be9e5d_e13bb06adc274327b97bb41c199efc0c.pdf'
      },
      {
        'title': '(2017, 6 פברואר). נחנך בית הקהילות – המרכז הקהילתי בחיפה לקהילה הגאה. <b>וודג\'</b>. נדלה מתוך',
        'url': 'https://www.wdg.co.il/%D7%A0%D7%97%D7%A0%D7%9A-%D7%91%D7%99%D7%AA-%D7%94%D7%A7%D7%94%D7%99%D7%9C%D7%95%D7%AA-%D7%94%D7%9E%D7%A8%D7%9B%D7%96-%D7%94%D7%A7%D7%94%D7%99%D7%9C%D7%AA%D7%99-%D7%91%D7%97%D7%99%D7%A4%D7%94-%D7%9C/'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2017,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/08/2018'
    },
    'description': 'את ״עמותת בית נועם למניעת אלימות במשפחה״ (ע״ר 580096519) יסדה בשנת 1986 עפרה קינן, עובדת סוציאלית שהחליטה כי בטיפול באלימות יש לבודד את הגורם האלים ולטפל בו. כפעולה משלימה לארגוני הנשים ולמוסדות הרווחה הממשלתיים, המתרכזים בסיוע לאישה המוכה ולילדיה, פנתה עמותת בית נועם לתחום הפחות מטופל: הגבר האלים. מטרות העמותה היו: ״ליזום, לרכז, לתכנן, להפעיל, וללוות תוכניות לגמילה מאלימות במשפחות אשר בהן אחד מבני הזוג או שניהם מפעילים אלימות פיזית ו/או מילולית כלפי בני משפחה כולל הילדים״. שמה המקורי של העמותה היה ״העמותה לגמילה מאלימות במשפחה״ והוא שונה באופן רשמי בשנת 2003 (על פי תעודת הרישום של העמותה). בשנת 1997 הקימה העמותה ברעננה את הפרויקט הייחודי ״בית נועם״ - הוסטל טיפולי, חינוכי ולימודי לגברים אלימים בשיתוף פעולה עם הקרן למפעלים מיוחדים של הביטוח הלאומי, משרד העבודה והרווחה וקרן סקט״א רש״י. בשנת 2007 ההוסטל, שעבר להרצליה הוצא להפעלה דרך מכרז ובשנת 2013 הועבר לניהול של עמותת ״קשת״, מה שהוביל להפסקת פעילות העמותה המקורית. מהדוחות הכספיים שהגישה העמותה בשנים 2007-2011 עולה כי ״פרויקט בית נועם הינו המיזם העיקרי של העמותה. בית נועם המופעל על ידי העמותה משמש לשיקום וטיפול בגברים מורחקי בית בגין התנהגות אלימה כלפי בת הזוג במימון שמקורו בחלקו במשרד הרווחה. כמו כן מפעילה העמותה פרויקטים נוספים אחרים במקומות שונים בארץ בתחום טיפול ומניעת אלימות במשפחה.״ בשנים 2012-2004 הפעילה העמותה בשיתוף עם עיריית באר שבע תחנה טיפולית למשפחות בהן קיימת אלימות במשפחה ודירת קלט המשמשת נשים מוכות וילדיהן במימון עיריית באר שבע. בדוח האחרון של העמותה נכתב כי היא נקלעה לגרעונות כספיים אשר ״מקורם בירידה במספר הגברים הנשלחים להוסטל על ידי משרד הרווחה, קושי בגיוס מקורות מימון נוספים לעמותה, על אף שרמת ההוצאות נשארה אחידה״. העמותה הפסיקה את פעילותה במהלך שנת 2013.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'YB125',
    'is_active': false,
    'keywords': [
      'הוסטל',
      'גברים אלימים',
      'קבוצת תמיכה',
      'מרכזים למניעה וטיפול באלימות במשפחה'
    ],
    'name': 'בית נועם - העמותה למניעת אלימות במשפחה',
    'name_ar': null,
    'name_change_year': 2003,
    'name_common': null,
    'name_past': 'העמותה לגמילה מאלימות במשפחה',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'גברים',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בית נועם – העמותה למניעת אלימות במשפחה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580096519'
      },
      {
        'title': 'הרטף, חגית ובר-און, נעמה (2000). <b>״בית-נועם״: כיוון חדש לגברים אלימים</b>. המוסד לביטוח לאומי, מנהל המחקר והתכנון. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/mifal_74.pdf'
      },
      {
        'title': 'Convention on the elimination of all forms of discrimination against women. Distr.: General, 16 November, 2001. CEDAW / C / ISR / 3. Retrieved from',
        'url': 'https://unispal.un.org/DPA/DPR/unispal.nsf/0/8E1A118276E4B77E8525709800654D2C'
      }
    ],
    'target_audiences': [
      'גברים',
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/05/2019'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 1986,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '19/05/2019'
    },
    'description': '״בית נועם-הוסטל לגברים אלימים״ החל לפעול בשנת 1997 כחלק מתכנית ניסיונית שאושרה כמפעל מיוחד על ידי המוסד לביטוח לאומי, במימון משותף של המוסד לביטוח לאומי ושל משרד העבודה והרווחה, וביוזמה של ״עמותת נועם- למניעת אלימות במשפחה״ בהובלת עפרה קינן. ההוסטל, שהיה הראשון מסוגו בישראל, הוקם תחילה ברעננה מתוך מטרה להביא להפסקת ההתנהגות האלימה של הגברים המטופלים כלפי בנות זוגם. הבית נועד במקור לקלוט בכל פעם כ-12 גברים לתקופה של 4 חודשים כאשר קהל היעד כלל את הגברים האלימים ביותר שהוצא נגדם צו-הרחקה מהבית. בשנתיים וחצי הראשונות להקמתו כ- 86 גברים החלו טיפול בהוסטל. בשלב מסויים עבר ההוסטל לכפר מל״ל ובשנת 2007 הפעלתו נקבעה בהליך התקשרות המבוסס על מכרז. קשיים כספיים ותפעוליים שאליהם נקלעה העמותה הובילו לכך שהחוזה להפעלת הבית לא הוארך והיא הפסידה במכרז. מאז שנת 2013 מופעל ״בית נועם״ על ידי עמותת ״קשת- שרותי תקון״. על פי פרסומי משרד הרווחה ניתן להפנות אל הבית עד 75 גברים חדשים מדי שנה במסגרת ההליך הפלילי. בבית נועם פועלים שלושה מסלולי טיפול: מסלול הוסטל, מסלול מרכז טיפול יום ומסלול משולב המיועד לגברים ברמת סיכון בינונית-גבוהה או לגברים שזקוקים להתייחסות טיפולית אינטנסיבית כשלב ראשוני בעת שחרורם ממסגרת המעצר.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'SA134',
    'is_active': true,
    'keywords': [
      'הוסטל',
      'גברים אלימים',
      'קבוצת תמיכה',
      'דיור'
    ],
    'name': 'בית נועם- בית טיפולי לגברים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'הרצליה',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'גברים',
    'retrieved': {
      'type{date}': '2019-05-19'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.keshet.co/%D7%91%D7%99%D7%AA-%D7%A0%D7%95%D7%A2%D7%9D/'
      },
      {
        'title': 'הרטף, חגית ובר-און, נעמה (2000). <b>״בית-נועם״: כיוון חדש לגברים אלימים</b>. המוסד לביטוח לאומי, מנהל המחקר והתכנון. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/mifal_74.pdf'
      },
      {
        'title': 'ויילר-פולק, דנה (2014, 17 אפריל). מחדל ההוסטל: גברים מכים חוזרים הביתה ללא טיפול. <b>וואלה!NEWS</b> נדלה מתוך',
        'url': 'https://news.walla.co.il/item/2738563'
      },
      {
        'title': 'רחל וינשטיין ומירי בן שמחון. (2018). ״מבוגרים המעורבים בהליכים פליליים״ מתוך: סקירת השירותים החברתיים 2016, משרד העבודה, הרווחה והשירותים החברתיים.',
        'url': 'https://www.gov.il/blobFolder/reports/molsa-social-services-review-2016/he/SocialServicesReview_2016_molsa-chapter4-adults-on-adversity-part2-2016.pdf'
      }
    ],
    'target_audiences': [
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/05/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1997,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'מחאה'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '17/05/2018'
    },
    'description': '״בית נשים פמיניסטי תל אביב-יפו״ (ע״ר 580450203) הוקם על ידי יערה (ארנקרנץ) חוצן ונעמה בן-שמחון מתוך רצון להקים מרחב חברתי, תרבותי ולימודי פמיניסטי בתל אביב. במהלך שנות פעילותו \'בית נשים פמיניסטי\' היווה מרכז של מפגש לנשים פמיניסטיות רבות מתל אביב והסביבה. מטרות העמותה כפי שהופיעו ברישומי רשם העמותות היו: ״להוביל שינוי חברתי פמיניסטי. להוות מרחב בטוח ופתוח לכל אישה. להפיץ ידע פמיניסטי בקרב נערות, ילדות, נשים ובחברה כולה. לעורר בקרב הנשים את המודעות ליחסי הכוחות החברתיים הנוטים לרעתן. לעודד שיתוף פעולה והתאחדות של נשים לצבירת כוח שיוביל לשינוי מצבן בחברה״. ב״בית נשים פמיניסטי״ התקיימו מגוון רחב של אירועי תרבות, כנסים, תערוכות, מסיבות, קבוצות לימוד והעלאת מודעות, קבוצת נטוורקיניג לבעלות עסקים, מפגשי אקטיביזם פמיניסטי, ארגון הפגנות ועוד. למרות שהעמותה מופיעה בפנקס העמותות, פעילות המרכז הפסיקה בשנת 2008.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ]
    ],
    'id': 'YB47',
    'is_active': false,
    'keywords': [
      'אקטיביזם',
      'חינוך פמיניסטי',
      'לסביות',
      'תרבות'
    ],
    'name': 'בית נשים פמיניסטי תל אביב - יפו',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בית נשים פמיניסטי תל אביב-יפו (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580450203'
      },
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל. עמ\' 30–31.'
      },
      {
        'title': 'ארנקרנץ-חוצן, אביגיל (2018). <b>״בית נשים פמיניסטי״ – סיפורו של ארגון ״בית נשים פמיניסטי״ בין השנים 2004–2009</b>. (עבודה מסכמת בקורס ״תנועות בפמיניזם הישראלי״, התוכנית ללימודי מגדר). אוניברסיטת בן-גוריון.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/09/2018'
    },
    'year_closed': 2008,
    'year_closed_text': '2008',
    'year_founded': 2004,
    'year_registered': 2005
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/09/2019'
    },
    'description': '״בית נתן״ (ע״ר 580273746) הוא מרכז תמיכה הממוקם בירושלים לנשים המתמודדות עם מחלת הסרטן, לרבות סרטן השד, המיועד בעיקרו לקהל הדתי. המרכז מפעיל בין השאר קו תמיכה טלפוני בשם \'לב רחל\' המאויש על ידי מתנדבות מחלימות או נשים שהתמודדו עם בן משפחה חולה סרטן, קבוצות תמיכה וסדנאות, ביקורי בית לחולים קשים, ליווי נשים בטיפול יום, סבסוד ימי נופש והבראה לזוגות שאחד מהם מתמודד עם סרטן וקבוצות תמיכה ייחודיות לאימהות חולות סרטן ובנותיהן ולנערות שחוו אובדן של אחד ההורים על רקע מחלת הסרטן.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'SA162',
    'is_active': true,
    'keywords': [
      'סרטן שד',
      'קו סיוע',
      'תמיכה נפשית'
    ],
    'name': 'בית נתן',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בית נתן (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580273746'
      },
      {
        'title': 'בית נתן, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/BeitNatan/'
      },
      {
        'title': 'כמוני: חברים לבריאות (אתר). <b>העמותות התומכות בחולות סרטן השד</b>. נדלה מתוך',
        'url': 'https://www.camoni.co.il/%D7%94%D7%A2%D7%9E%D7%95%D7%AA%D7%95%D7%AA-%D7%94%D7%AA%D7%95%D7%9E%D7%9B%D7%95%D7%AA-%D7%91%D7%97%D7%95%D7%9C%D7%95%D7%AA-%D7%A1%D7%A8%D7%98%D7%9F-%D7%94%D7%A9%D7%93'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1995,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '30/10/2018'
    },
    'description': '״בית שיח נשים״ הוקם ביומתה של איילת כהן שכיהנה בין השנים 2003-2008 כחברת מועצה בפ״ת. ראשיתה של היוזמה באירוע שהתקיים ב-2005 ובו נחשפו סיפוריהן של 14 ממייסדות העיר. ב-2008 הוקמה עמותה במטרה להקים ארכיון, לאסוף מידע ולהקים בית שבו יסופר על פועלן של נשות פ״ת מאז היווסדה ועד היום. בתמיכת העירייה, נחנך הבית ב-2017 ומלבד ארכיון ומוזיאון מתקיימות בו הרצאות, קורסים ופעילויות חינוכיות ותרבותיות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'פנאי'
      ],
      [
        'חינוך',
        'פמיניזם ושוויון בין המינים'
      ]
    ],
    'id': 'YH126',
    'is_active': true,
    'keywords': [
      'היסטוריה',
      'הנצחה',
      'ארכיון',
      'שוויון מגדרי',
      'גלריה'
    ],
    'name': 'בית שיח נשים פתח תקווה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'פתח תקווה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פנאי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-30'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.bsn.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>שיח נשים פתח תקוה (ע״ר): עמותה מחוקה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580499523'
      },
      {
        'title': 'בית שיח נשים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/%D7%91%D7%99%D7%AA-%D7%A9%D7%99%D7%97-%D7%A0%D7%A9%D7%99%D7%9D-1776976155946096/?ref=page_internal'
      },
      {
        'title': 'כהן, מאיה (2017, 20 יוני). לאן נעלמו האמהות של אם המושבות? ״צריך לתקן את העוול״. <b>ישראל היום</b>. נדלה מתוך',
        'url': 'https://www.israelhayom.co.il/article/485115'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '29/10/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2005,
    'year_registered': 2008
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/08/2018'
    },
    'description': '״בית של״ב- בית שהייה טיפולי לגברים אלימים מורחקים- עירית חיפה והסביבה״ הוקם בשנת 2010 בכדי לספק מענה לגברים אלימים אשר הורחקו מביתם על ידי צו בית משפט לענייני משפחה או ע״י המשטרה ובכדי למנוע את הסכנה הנשקפת לחיי האישה בעקבות תביעתה לצו הרחקה. בדומה לדירת השל״ב בבאר שבע, הבית נועד לטיפול בגברים מאזור חיפה והפריפריה ונערך לקלוט עד 15 גברים בו בזמן במתכונת של הוסטל עם צוות מטפלים 24 שעות ביממה. הבית סיפק סיוע בתחומים הבאים: (1) טיפול ממוקד ואינטנסיבי בשלב המשבר; (2) תמיכה והתחלת תהליך טיפולי להפסקת האלימות; (3) הפחתת רמת הסיכון של הגבר המורחק כלפי האישה והילד על ידי פתרון הדיור. ההפנייה לבית נעשתה בהסכמה של הגבר האלים ותקופת השהייה בה היתה תלוייה באורך צו ההרחקה. בשנת 2011 הופנו 25 אנשים לדירת של״ב בחיפה ע״י קציני מבחן, מתוכם נקלטו לטיפול 7 אנשים. הפרויקט הובל על ידי ועדת היגוי שכללה נציגי משרד הרווחה, השרות לרווחת הפרט ומשפחה ומערכות שרותים חברתיים- עיריית חיפה. על פי דוח הממונה על יישום חוק חופש המידע במשרד הרווחה (2012) השירות נסגר בראשית שנת 2013, ככל הנראה בשל חילוקי דעות בין משרד הרווחה ועיריית חיפה בנוגע למימון פעילותו.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף מוניציפלי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'YB126',
    'is_active': false,
    'keywords': [
      'הוסטל',
      'גברים אלימים',
      'קבוצת תמיכה',
      'דיור'
    ],
    'name': 'בית של״ב - שהיה למורחקי בית בחיפה והסביבה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'ממשלתי',
      'מוניציפלי'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'גברים',
    'retrieved': null,
    'sources': [
      {
        'title': 'אתר משרד העבודה הרווחה והשירותים החברתיים (ללא תאריך). <b>אלימות במשפחה: אבחון וטיפול בפוגעים</b>. נדלה מתוך',
        'url': 'https://www.molsa.gov.il/Populations/Distress/FamilyViolence/OffendersTreatment/Pages/TM_02_02_03.aspx'
      },
      {
        'title': 'בירן, מיכל ח״כ (2013, 18 פברואר). סגירת בית של״ב בחיפה, ראיון בתכנית יהיה בסדר בגלי צה״ל [פוסט פייסבוק]. נדלה מתוך: //www.facebook.com/MichalBiran/videos/vb.386001744772337/10200543409965054/?type=2&theater'
      },
      {
        'title': 'וינשטיין, רחל, גורבטוב, רנטה ובן שמחון, מירי (2011). מבוגרים המעורבים בהליכים פליליים. בתוך <b>סקירת השירותים החברתיים לשנת 2010</b> (פרק 4 חלק ג\'). משרד העבודה הרווחה והשירותים החברתיים. נדלה מתוך',
        'url': 'https://www.gov.il/he/Departments/publications/reports/molsa-social-services-review-2010'
      }
    ],
    'target_audiences': [
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/05/2019'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 2010,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '28/11/2018'
    },
    'description': '״ביתך- עמותה לנשים עם הפרעות אכילה״ (ע״ר 580510923) הוקמה ב- 2009 על ידי יעל אלחנן ונעמה כרמון על מנת לספק מענה לצעירות הסובלות מהפרעות אכילה היוצאות מהמסגרות הקיימות ומתקשות להשתלב בחברה בעקבות הפערים הגדולים בינן לבין בנות גילן. מטרת העמותה היתה: ״לקדם את החזרה לתפקוד של נשים עם הפרעות אכילה. להוות מרכז מגורים נתמכים שמקדם התנהגות אכילה נכונה. להוות מסגרת מחזיקה ולמנוע התדרדרות להפרעת אכילה. לצמצם את כמות האישפוזים החוזרים אצל נשים בוגרות עם הפרעות אכילה. לצמצם את תחושת החריגות אצל נשים עם הפרעות אכילה״. העמותה הפעילה דירה ברח׳ יהודה המכבי בתל אביב, שתפקדה כ״בית למחלימות מהפרעות אכילה״. בדירה הן קיבלו ליווי של פסיכולוגיות קליניות, דיאטניות קליניות ופסיכיאטרים. הצעירות למדו, עבדו וחיו בדירה והשתתפו בפעילויות מותאמות, כולל מגוון סדנאות, חוגים ויציאות שבועיות לבילויים. העמותה גם ארגנה ערבי התרמה לגיוס כספים לעמותה והעלאת מודעות בציבור להפרעות אכילה. מאז שנת 2013 הפסיק המרכז להתקיים והעמותה נמצאת בהליכי פירוק.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'נערות וצעירות',
        'בריאות'
      ]
    ],
    'id': 'LR26',
    'is_active': false,
    'keywords': [
      'דיור',
      'הפרעות אכילה',
      'דימוי גוף',
      'תמיכה נפשית'
    ],
    'name': 'ביתך - עמותה לנשים עם הפרעות אכילה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות הנפש וטיפול',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>ביתך – עמותה לנשים עם הפרעות אכילה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580510923/documents'
      },
      {
        'title': 'אלחנן, יעל וכרמון, נעמה (2010, 2 אוקטובר). בית למחלימות מהפרעות אכילה. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-3921983,00.html'
      },
      {
        'title': 'שלזינגר, ליאת (2009, 23 אוקטובר). עמותת ביתך: בית חדש לטיפול בחולות אנורקסיה בישראל. <b>NRG</b>. נדלה מתוך',
        'url': 'https://www.makorrishon.co.il/nrg/online/29/ART1/956/631.html'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/01/2020'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 2009,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '22/05/2018'
    },
    'description': '״בצדק״ היא תכנית צדק מאחה במקרים של פגיעה מינית, אשר פועלת במסגרת ״המרכז הישראלי לגישות מאחות״ [ע״ר], מפתחת ומיישמת תהליכי צדק מאחה בפגיעות מיניות בישראל. התכנית מבוססת על מודלים של תכניות צדק מאחה מקבילות מרחבי העולם. היא ייחודית וחדשנית בשל התאמתה לתחום פגיעות מיניות, לתרבות, לנורמות, לתהליכי העבודה ולמבנה המערכות הקיימות בישראל. התכנית שמה לה מטרה לפתח, לשפר ולקדם את מודל העבודה, להיות הגוף המקצועי המוביל בישראל בתחום צדק מאחה בפגיעה מינית ומהתכניות המובילות בעולם בתחום זה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ]
    ],
    'id': 'YB93',
    'is_active': true,
    'keywords': [
      'אונס',
      'הטרדה מינית',
      'תקיפה מינית',
      'מגדר בניהול סכסוכים',
      'גישור'
    ],
    'name': 'המרכז הישראלי לגישות מאחות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'בצדק',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://betsedek.org.il/about-us/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>המרכז הישראלי לגישות מאחות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580555472'
      },
      {
        'title': 'בצדק. עמוד פייסבוק.',
        'url': 'https://www.facebook.com/betsedek/'
      },
      {
        'title': '(2017, 5 ינואר). ״בצדק״-תכנית צדק מאחה בפגיעות מיניות. <b>הטלוויזיה החברתית</b>. נדלה מתוך',
        'url': 'https://tv.social.org.il/social/2017/01/05/restorative-justice'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '25/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2011,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '28/01/2019'
    },
    'description': '״בראעם אל רביע כפר יאסיף״ (ע״ר 580490746) היא עמותה שנוסדה בשנת 2008. מטרותיה הן: ״יסוד וניהול מסגרות לילדים בגיל הרך מגיל 3 עד 5 שנים לרבות גני ילדים. שיפור מעמד האישה באמצעות הרצאות וסדנאות בתחומים שונים. קידום מעמדו של הילד. עידוד וטיפוח יכולות אישיות. קיום מסגרות להגנה על ילדים מקיפוח. קיום וניהול מסגרות לילדים עם צרכים מיוחדים.״  העמותה מפעילה גני ילדים בכפר יאסיף.',
    'description_ar': 'براعم الربيع كفر ياسيف (ج.م 580490746) تأسس عام 2008, اهداف الجمعية هي تأسيس وادارة إطار مناسب للطفولة المبكرة بين اجيال 3-5 سنوات. تحسين مكانة المرأة بواسطة محاضرات وورش عمل بمجالات مختلفة. تطوير مكانة الطفل، دعم وتمكين القدرات الشخصية، اقامة إطار الذي يحمي الاولاد من الحرمان، بناء وادارة اطر للأطفال ذوي الاحتياجات الخاصة. الجمعية تدير رياض أطفال في كفر ياسيف.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'חינוך',
        'הגיל הרך'
      ]
    ],
    'id': 'YA12',
    'is_active': true,
    'keywords': [
      'ילדים',
      'משפחה',
      'מוגבלות'
    ],
    'name': 'בראעם אל רביע כפר יאסיף',
    'name_ar': 'براعم الربيع كفر ياسيف',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר יאסיף',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעונות ומשפחתונים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-01-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.facebook.com/baraamalrbeaa'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בראעם אל רביע כפר יאסיף (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580490746'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '28/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2008,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': 'בשבילך היא תכנית שהוקמה בשיתוף משרד הרווחה, עיריית באר שבע ובהפעלת עמותת יחדיו כחלק מהתכנית לאומית לטיפול בזנות. התכנית הנותנת מענים טיפוליים ותמיכתיים לנשים במעגל הזנות. התכנית מפעילה מרכז טיפולי הפועל בשעות היום המציע טיפול, ליווי, תמיכה, תיווך מול רשויות, מקום להפוגה ולפסק זמן , ארוחות חמות, מסגרת חברתית. התכנית מבוססת על התפיסה שהקשר עם הנשים צריך להתחיל במקום בו הן נמצאות ולכן מרכיב הישוג בתכנית הינו מרכזי.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף מוניציפלי',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'זנות'
      ],
      [
        'רווחה וקהילה',
        'זנות וסחר בנשים'
      ],
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ]
    ],
    'id': 'YB74',
    'is_active': true,
    'keywords': [
      'שיקום',
      'טראומה',
      'אונס',
      'פמיניזם',
      'תמיכה נפשית'
    ],
    'name': 'בשבילך',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'ממשלתי',
      'מוניציפלי'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'זנות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'יחדיו (אתר). <b>בשבילך</b>. נדלה מתוך',
        'url': 'http://www.yachdav.org.il/%D7%91%D7%A9%D7%91%D7%99%D7%9C%D7%9A.html'
      },
      {
        'title': 'עיריית באר שבע (אתר). יחידת ״בשבילך״ לנשים במעגל הזנות. נדלה מתוך',
        'url': 'https://www.beer-sheva.muni.il/Residents/Welfare/TreatmentCenters/Pages/bishvilech.aspx?AspxAutoDetectCookieSupport=1'
      },
      {
        'title': 'תודעה (אתר). <b>בשבילך</b> (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2010,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '21/12/2018'
    },
    'description': '״בשבילך - לדרך חדשה״ (ע״ר 580580827) הוקמה על ידי תמר שירי - בעברה נפגעת אלימות במשפחה, במטרה למנוע אלימות בקרב גברים באמצעות תמיכה נפשית, מקצועית, מקום לינה וייעוץ משפטי. העמותה רשומה בבית שמש אך פועלת בפתח תקווה ומטרותיה הן: ״מניעת אלימות והסלמה של גברים ביחסים זוגיים. הקמת מרכזי סיוע מיידי לגברים בכל רחבי הארץ. קידום פרויקטים למניעת אלימות במשפחה בכל דרך חוקית הן משפטית ו/או פרלמנטארית ו/או הסברתית מול כל הרשויות. הקמת מסגרות תמיכה פיזיות ״בית חם״ והן מסגרות משפטיות ו/או סוציאליות לתמיכה בגברים שהורחקו מבתיהם. לעשות כל פעולה חוקית שתסייע לגברים במצוקה״. העמותה מפעילה קו חם לסיוע ועזרה ראשונית לגברים במצוקה באמצעות מתנדבים וליווי אישי במציאת תעסוקה. מלבד שתי הרצאות למשרד הבריאות בנושא אלימות גברים, אין לעמותה התקשרויות עם הממשלה ופעילותה היא קהילתית בעיקרה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YH163',
    'is_active': true,
    'keywords': [
      'גברים אלימים',
      'תמיכה נפשית',
      'קו סיוע',
      'קבוצת תמיכה',
      'סיוע משפטי',
      'אימון אישי'
    ],
    'name': 'בשבילך - לדרך חדשה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'פתח תקווה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'גברים',
    'retrieved': {
      'type{date}': '2018-12-21'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://beshvilcha.org/?page_id=107'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בשבילך – לדרך חדשה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580580827'
      },
      {
        'title': 'בשבילך – לדרך חדשה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pg/beshvilcha/about/?ref=page_internal'
      },
      {
        'title': 'עצמון, אייל (2018, 20 יולי). גברים כן בוכים בלילה: תמר שירי הקימה עמותה שמטפלת בגברים מכים. <b>mynet הוד השרון</b>. נדלה מתוך',
        'url': 'https://hodhasharon.mynet.co.il/local_news/article/m_306385'
      }
    ],
    'target_audiences': [
      'גברים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '21/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': 2014
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '28/10/2018'
    },
    'description': '״בשבילך - מרכז רפואי לאשה״ (ע״ר 580421592) הוקם ב-2004 על ידי שרה סעמיאטיצקי, מנהלת מרכז רפואי בירושלים ופעילה קהילתית יחד ‏עם ד״ר דיאנה פלשר – רופאה ופעילה בתחום בריאות האישה. מטרות עמותה הן: ״להעניק ייעוץ והכוונה לשירותי בריאות ע״י צוות איכפתי ומקצועי באווירה נשית. לשפר את איכות החיים ולהשפיע ישירות ובאופן חיובי על האשה, משפחתה והקהילה ע״י חינוך לבריאות. למנוע מחלות ע״י חינוך האשה לפעולות מנע במהלך חייה. ליצור עירנות והנחיה לגילוי מוקדם של בריאות השד ומחלות לב.״ המרכז מיועד לנשים חרדיות ומפעיל ‏קליניקה רפואית ומקצועית ששמה דגש על מניעה וגילוי מוקדם. בנוסף, המרכז גם פועל לשינוי מדיניות, עוסק במחקר ‏והערכה ומפעיל תכניות קהילתיות והכשרות מקצועיות, כולל תוכנית חינוך לבריאות לנשים ‏במגזר החרדי עבור משרד הבריאות. עיקר פעילות העמותה היא בירושלים אך קיים גם סניף בבני ברק.‏',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ],
      [
        'דת ומעמד אישי',
        'בריאות ופריון'
      ],
      [
        'חינוך',
        'חינוך מיני/מיניות בריאה'
      ]
    ],
    'id': 'YH119',
    'is_active': true,
    'keywords': [
      'חינוך',
      'הכשרה מקצועית',
      'מחקר',
      'גניקולוגיה'
    ],
    'name': 'בשבילך - מרכז רפואי לאשה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2018-10-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://bishvilaych.org/?lang=he'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בית בריאות האשה – בשבילך (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580421592'
      },
      {
        'title': 'כפיר, מעיין (2016, 3 יולי). לאישה החרדית אין זמן ללכת לחמישה רופאים כל שנה, לכן החלטנו להקים לה מרפאה מיוחדת. ראיון עם שרה סעמיאטיצקי, מייסדת העמותה. <b>הידברות</b> נדלה מתוך',
        'url': 'https://www.hidabroot.org/article/210531'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '28/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '12/06/2018'
    },
    'description': '״בשלה״ – קבוצת לסביות בנות 45 ומעלה שהוקמה בשנת 2007, שמה לעצמה למטרה ליצור קהילה שתיתן מענה למגוון צרכיהן הייחודיים של לסביות בוגרות. הרעיון של הקמת קבוצה או קהילה תומכת לנשים לסביות בגיל השלישי, עלה והתבשל כבר בסוף שנות ה-90 של המאה הקודמת אצל ד״ר רותי ליטוין, פסיכותרפיסטית חיפאית ולסבית גאה ופעילה בקהילה המקומית והארצית. בכנס הלסבי הארצי שנערך בדצמבר 2004 במלון כרמל בנתניה, נזרע הזרע הראשון להקמת הקבוצה ובמרץ 2007 נפגש הגרעין המייסד של בשלה בתובל שבגליל. הקבוצה כוללת כ כ- 200 חברות מכל רחבי הארץ ומקיימת ארועים קהילתיים ועוסקת בסוגיות נוספות הנוגעות להזדקנות בקהילת הלהט״ב. בשנת 2018, החלה לפעול בפייסבוק גם קבוצת ״דורותיאה״ שמקיימת פעילויות חברתיות מגוונות לנשים לסביות מבוגרות. הקשר בין שתי ההתארגנויות אינו ברור.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ]
    ],
    'id': 'SA21',
    'is_active': false,
    'keywords': [
      'לסביות',
      'זקנה',
      'קבוצת תמיכה',
      'גאווה'
    ],
    'name': 'בשלה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-12-06'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.lgbt.org.il/bshela בתוך אתר האגודה למען הלהט״ב'
      },
      {
        'title': 'בשלה, עמוד פייסבוק (אינו פעיל).',
        'url': 'https://www.facebook.com/%D7%91%D7%A9%D7%9C%D7%94-Beshela-100654214767815'
      },
      {
        'title': 'לטווין, רותי (2016, 1 יוני). בת 70, כבר לא בארון. <b>סלונה</b>. נדלה מתוך',
        'url': 'http://saloona.co.il/?p=323628?ref=saloona_tags'
      },
      {
        'title': 'ספרן, חנה, הרטל, רחלי וששון-לוי, אורנה (2016). הי[א]סטוריה לסבית מקומית: פעילות, מאבקים והישגים. בתוך: הראל, אלון, לושינסקי, יניב ומורגנשטרן, עינב (עורכים), <b>זכויות הקהילה הגאה בישראל: משפט, נטייה מינית וזהות מגדרית</b> (עמ\' 45–80). האוניברסיטה העברית, המכון למחקרי חקיקה ולמשפט השוואתי. צפרירים: נבו.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '06/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': '2018',
    'year_founded': 2007,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '21/08/2018'
    },
    'description': '״בת המדבר - עמותה לקידום מעמד האישה הבדואית בחורה״ (ע.ר. 580405934) הוקמה בשנת 2003 ומטרותיה הן: ״קידום מעמד האישה הבדואית בתחומי חינוך, בריאות ותעסוקה. קידום השכלת נשים ושיבוצן במסגרות תעסוקה מתאימה. תמיכה וחיזוק במשפחות חד-הוריות והעלאת מודעות בקרב נשים לנושא בריאות״. העמותה עוסקת בהעצמת נשים בדואיות, בעיקר חד הוריות כתוצאה מפוליגמיה, באמצעות פרויקטים של הכשרה מקצועית בתחום הרקמה והתפירה ומכירתן במרכז המבקרים. את העמותה הקימה נהאדה אל-עוקבי שהיא גם היועצת למעמד האישה בח\'ורה.',
    'description_ar': 'تأسست ״ابنة الصحراء - جمعية للنهوض بمكانة المرأة البدوية في حورة״ (ج. م580405934) في عام 2003 وأهدافها هن: ״تعزيز مكانة النساء البدويات في التعليم والصحة والتوظيف. تطوير تعلم النساء ومرافقتهن في اطر تشغيلية مناسبة. دعم وتقوية الأسر ذات العائل الواحد وزيادة الوعي بين النساء حول القضايا الصحة ״. تعمل الجمعية بهدف تمكين النساء البدويات، خاصة العائلات الوحيدات نتيجة لتعدد الزوجات في العائلة الواحدة، من خلال مشاريع التدريب المهني في مجال التطريز والخياطة وبيعها في مركز الزوار. تأسست الجمعية بمبادرة من ناهدة العقبي التي تعمل أيضا كمستشارة لمكانة المرأة في حورة.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'תרבות וספורט',
        'מלאכות מסורתיות'
      ]
    ],
    'id': 'YH77',
    'is_active': true,
    'keywords': [
      'בדואיות',
      'סחר הוגן',
      'השכלה',
      'הכשרה מקצועית',
      'חד הוריות',
      'פוליגמיה'
    ],
    'name': 'בת המדבר - עמותה לקידום מעמד האישה הבדואית בחורה',
    'name_ar': 'بنت الصحراء - جمعية لتطوير مكانة المرأة البدوية',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חורה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בת המדבר – עמותה לקידום מעמד האישה הבדואית בחורה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580405934'
      },
      {
        'title': 'אוסצקי-לזר, שרה (2009). <b>״לא כמו אמי״: נשים מעצימות את עצמן – המקרה של כפר קרע</b>. ירושלים: בית הספר ע״ש פדרמן למדיניות ציבורית וממשל - האוניברסיטה העברית בירושלים. נדלה מתוך',
        'url': 'https://www.sarahozacky.com/862/%D7%9C%D7%90-%D7%9B%D7%9E%D7%95-%D7%90%D7%9E%D7%99-%D7%A0%D7%A9%D7%99%D7%9D-%D7%9E%D7%A2%D7%A6%D7%99%D7%9E%D7%95%D7%AA-%D7%90%D7%AA-%D7%A2%D7%A6%D7%9E%D7%9F-%E2%80%93-%D7%94%D7%9E%D7%A7%D7%A8/'
      },
      {
        'title': 'קסם המדבר (ללא תאריך). <b>בנות המדבר- נשים רוקמות</b>? נדלה מתוך',
        'url': 'https://kesem-hamidbar.co.il/tiran/%D7%91%D7%A0%D7%95%D7%AA-%D7%94%D7%9E%D7%93%D7%91%D7%A8-%D7%A0%D7%A9%D7%99%D7%9D-%D7%A8%D7%95%D7%A7%D7%9E%D7%95%D7%AA/'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '11/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2003,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '16/05/2018'
    },
    'description': '״בת מלך״ (ע״ר 580270395) קמה בשנת 1995 כעמותה למען נשים דתיות וחרדיות אשר מפעילה שני מקלטים ודירות מעבר לנשים נפגעות אלימות. המקלטים ממוקמים האחד בירושלים והשני במרכז הארץ. כמו כן פועלת העמותה למען שילובן של נשים אלו בקהילה לאחר עזיבת המקלטים ודירות המעבר במתן סיוע משפטי למועטות יכולת, הפעלת קו חירום טלפוני לנשים במצוקה והפעלת תכניות למניעת אלימות במשפחה וקידום מעמד האשה בתוך הקהילה הדתית והחרדית.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YB34',
    'is_active': true,
    'keywords': [
      'אלימות מינית',
      'מקלט',
      'דיור',
      'תמיכה נפשית',
      'נשים מוכות',
      'ילדות/ים',
      'דת',
      'סיוע משפטי'
    ],
    'name': 'בת מלך',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2018-05-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://batmelech.org/?lang=he'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בת מלך: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580270395'
      },
      {
        'title': 'בת מלך, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/batmelechShelter'
      },
      {
        'title': 'Convention on the elimination of all forms of discrimination against women. Distr.: General, 24 March, 2010. CEDAW / C / ISR / 5.'
      }
    ],
    'target_audiences': [
      'נשים חרדיות',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '31/05/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1995,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '06/06/2018'
    },
    'description': '‏״בת קול ארגון לסביות דתיות״ הוקם בשנת 2005, על ידי קבוצה של כעשר נשים, לסביות, דתיות, שביקשו ‏לתת מענה לנשים כמותן שרוצות לחיות את חייהן מתוך שילוב של זהות לסבית וזהות דתית. בשנת 2008 הארגון עבר תהליך של ארגון מחדש, כתיבת קווי יסוד ובחירת ועד מנהל, בשנת ‏‏2010 נרשם כעמותה (ע״ר 580534493). ״בת קול״ פונה לנשים מעל גיל 18 ומספקת לחברותיה מפגשים חברתיים המתקימים במקרים רבים בבתי המשתתפות, קבוצת לימוד בחברותא, ״שבת בת קול״ המתרחשת אחת לשנה בה נפגשות החברות לסופ״ש בבית הארחה וקבוצות תהליכיות המתפקדות כקבוצות תמיכה. בנוסף, הארגון מפעיל אתר עתיר מידע ומאמרים ובלוגריות הכובות על נושאים הקשורים לקהילה, ופועלת להעלאת ‏המודעות והסובלנות בחברה הדתית לקהילה הלהט״בית ולנושאים הקשורים בה. יחד עם ״חברותא״, ארגון של הומואים דתיים, הן יוצרות את ״קהילה דתית גאה״ המקיימת פעילויות משותפות, ומפעילה את ״המניין הגאה״. הן צועדות ביחד בקביעות במצעדי הגאווה השונים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'דת'
      ],
      [
        'דת ומעמד אישי',
        'להט״ב'
      ]
    ],
    'id': 'SW15',
    'is_active': true,
    'keywords': [
      'לסביות',
      'מצעד',
      'קבוצת תמיכה',
      'גאווה'
    ],
    'name': 'בת קול ארגון לסביות דתיות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'דת',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-06-06'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.bat-kol.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בת-קול – ארגון לסביות דתיות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580534493'
      },
      {
        'title': 'בת-קול, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pg/batkolorg'
      },
      {
        'title': 'ספרן, חנה, הרטל, רחלי וששון-לוי, אורנה (2016). הי[א]סטוריה לסבית מקומית: פעילות, מאבקים והישגים. בתוך: הראל, אלון, לושינסקי, יניב ומורגנשטרן, עינב (עורכים), <b>זכויות הקהילה הגאה בישראל: משפט, נטייה מינית וזהות מגדרית</b> (עמ\' 45–80). האוניברסיטה העברית, המכון למחקרי חקיקה ולמשפט השוואתי. צפרירים: נבו.'
      }
    ],
    'target_audiences': [
      'נשים דתיות',
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '06/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2005,
    'year_registered': 2010
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'עבודה קהילתית',
      'מחאה'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': 'בשנת 1989 התקיים בבריסל מפגש נשים בינלאומי בהשתתפות פעילות ישראליות ופלסטיניות. בעקבותיו החלה פעילות משותפת של ״רשת נשים לשלום״ ואחריה הוקם בשנת 1994 ה״קשר הירושלמי״ או ה-״JERUSALEM LINK״. עמותת ״המרכז הירושלמי לפעילות נשים״ (ע״ר 580235406) נרשמה בסוף דצמבר 1993 ומטרותיה הרשמיות היו ״לקיים פעילות בתחומי החינוך והתרבות לנשים. לקיים פעילות בתחומי החינוך והתרבות בעניני נשים״. ה״קשר הירושלמי״ הורכב משני ארגוני נשים, ״בת שלום״ במערב ירושלים ו״המרכז הירושלמי לנשים״ במזרחה. לשני ארגונים אלה היו עקרונות פוליטיים משותפים, שהיו בסיס לשיתוף פעולה ביניהם ומודל לשיתוף פעולה בין שני העמים - הישראלי והפלסטיני. ״בת שלום״ הגדירה עצמה כארגון נשים פמיניסטי ישראלי, שפעל לקידום שיתוף פעולה ודיאלוג פוליטי בין נשים ישראליות ופלסטיניות ולקידום שלום המבוסס על פתרון צודק לסכסוך הישראלי-פלסטיני, לכיבוד זכויות האדם ולמתן קול שווה לנשים יהודיות וערביות בתוככי החברה הישראלית. בשנות קיומו פעל הארגון בתחומים הבאים: עריכת סיורים פוליטיים, הרצאות, פאנלים וקבוצות דיאלוג יהודיות-פלסטיניות. הארגון קיים מספר קמפיינים פוליטיים וביניהם Sharing Jerusalem/״לחיות ביחד בירושלים״ שהושק בשנת 1997 כתכנית מעשית לפתרון בעיית ירושלים. פעילות מרכזיות ב״בת-שלום״ היו מהמובילות להקמת ״נציבות הנשים הבינלאומית״ (IWC) בשנת 2005. הארגון לא נסגר רשמית אך בשנת 2009 צמצמה העמותה את פעילותה בעקבות החלטת הועד המנהל. בנוסף על המרכז בירושלים, הוקמה ״בת שלום צפון״, שמרכזה היה בעיר עפולה. קבוצה זו הוקמה על ידי פעילות ישראליות ופלסטיניות ממושבים, קיבוצים, ערים וכפרים מאזור מגידו, נצרת והעמקים והיא פעלה ליצירת קבוצות דיאלוג בין נשים ישראליות ופלסטיניות באזור. בשנת 2005, התפצל הסניף מהארגון ופעילותיו הקימו ארגון חדש תחת השם ״בת שלום צפון״. הפילוג נוצר משום חוסר ההסכמה על האג\'נדה הפוליטית הנוגעת למרכזיותם של הנושאים הקשורים לערביי ישראל בתחומי המדינה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ]
    ],
    'id': '1YB9',
    'is_active': false,
    'keywords': [
      'החלטה 1325',
      'כיבוש',
      'חינוך',
      'פלסטיניות',
      'שלום',
      'תרבות',
      'שיתוף פעולה בינלאומי'
    ],
    'name': 'המרכז הירושלמי לפעילות נשים',
    'name_ar': 'بنت السلام',
    'name_change_year': null,
    'name_common': 'בת-שלום',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-11-11'
    },
    'sources': [
      {
        'title': 'אתר הארגון בארכיון האינטרנט',
        'url': 'https://web.archive.org/web/20190805053853/https://www.batshalom.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>המרכז הירושלמי לפעילות נשים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580235406'
      },
      {
        'title': 'גולן-עגנון, דפנה (2002). <b>איפה אני בסיפור הזה?</b> (עמ\' 105–134). תל אביב: כתר.'
      },
      {
        'title': 'Bat-Shalom (2011). In Stange, Mary Zeiss, Carol K. Oyster & Jane E. Sloan (Eds.), <b>Encyclopedia of women in today\'s world</b> ( Vol. 1, pp.132). London, UK: Sage. Retrieved from',
        'url': 'https://books.google.co.il/books?id=B50Jad7552MC&pg=PA132&lpg=PA132&dq=BAT+SHALOM+DAUGHTER+ACTION+CENTER&source=bl&ots=28wVRrcvdH&sig=x2ZvlExzy8YbtyMWYPd3JvFYTas&hl=en&sa=X&ei=V9NgVJqvJ4OwmAXNsIDYDA#v=onepage&q=BAT%20SHALOM%20DAUGHTER%20ACTION%20CENTER&f=false'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/10/2018'
    },
    'year_closed': 2010,
    'year_closed_text': '2010',
    'year_founded': 1994,
    'year_registered': 1993
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '16/09/2019'
    },
    'description': 'עמותת ״ג\'מעיית תאלא נסאא פי אלטליעה״ (ע״ר 580462463) הוקמה בטייבה על ידי קבוצת נשים מקומיות בהובלת היפא חאג\' ונהאיא חביב. מטרות העמותה היו: ״הקמת ספריות, קורסים להעשרה, הקמת קבוצות ריקוד מזרחי ומשחק אשר תקיים מופעים שונים, הקמת קבוצת נערים ונערות ללימוד משחק ותיאטרון, הקמת ספריה לעוורים, לימוד קריאה וכתיבה למוגבלי ראייה, עידוד תעסוקת נשים, הקמת מועדון נשים ומתנ\'\'ס.״ פעילות העמותה מתועדת בדוחות שהוגשו לרשם העמותות עד שנת 2013 מהם עולה שהיא ערכה קורסים לנשים בתחום התעסוקה וגייסה כסף להקמת מגרש ספורט קהילתי. בשנת 2020 העמותה נמחקה על ידי רשם העמותות. סגירת העמותה תוארכה ל-2014.',
    'description_ar': 'جمعية ״تالا نساء في الطليعة״ (ج.م 580462463) تأسست في الطيبة بمبادرة من نساء محليات وبإدارة هيفاء حج ونهاية حبيب. اهداف الجمعية هن: تأسيس مكاتب، مساقات للأثراء، مجموعات رقص شرقي وتمثيل والتي ستقوم بأداء عروض مختلفة. إقامة مجموعة شباب وشابات لتعليم المسرح، مكتبة للمكفوفين، تعلم القراءة والكتابة لمحدودي النظر، تشجيع تشغيل النساء، إقامة نويدية للنساء ومركز جماهيري. نشاط الجمعية موثق في التقارير التي قدمت لسجل الجمعيات حتى عام 2013، والتي تبين منها انها قامت بتقديم مساقات لنساء في مجال التوظيف وجندت الأموال بهدف بناء ملعب رياضي جماهيري.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'תרבות וספורט',
        'ספורט'
      ]
    ],
    'id': 'SA156',
    'is_active': false,
    'keywords': [
      'תעסוקה',
      'ספורט',
      'תרבות'
    ],
    'name': 'ג\'מעיית תאלא נסאא פי אלטליעה',
    'name_ar': 'تالا- نساء في الطليعة',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'טייבה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). ג\'מעיית תאלא נסאא פי אלטליעה (ע״ר): עמותה**. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580462463'
      },
      {
        'title': 'جنان عبده. (2008). الجمعيّات النسائيّة والنسويّة الفلسطينيّة- في مناطق 48, مدى الكرمل'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '29/09/2021'
    },
    'year_closed': 2014,
    'year_closed_text': '2014',
    'year_founded': 2006,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '25/01/2019'
    },
    'description': 'גאווה בליכוד, התא הגאה של המפלגה, הוקם בשלהי 2011, על ידי עו״ד אוון כהן. התא פועל לקידום זכויות הקהילה הגאה במפלגה ומחוצה לה. התא הוביל לשינוי חוקת הליכוד כך שתכלול התנגדות לאפלייה על רקע נטייה מינית, והיה מעורב בבחירתו של חבר כנסת אמיר אוחנה (אשר מונה בהמשך לשר המשפטים והשר הגאה הראשון בישראל, בממשלת המעבר של קיץ 2019) לרשימת המפלגה לכנסת בבחירות 2015. התא מארגן חוגי בית ומפגשים בנושאים הנוגעים לקהילה הגאה כגון: הומופוביה, פונדקאות ועוד. גאווה בליכוד זכה לביקורות קשות מצד חלקים ניכרים מהקהילה הלהט״בית, הן סביב הצבעותיה של המפלגה נגד חוקים שתומכים בזכויות הקהילה, והן סביב בחירותיה הפוליטיות של המפלגה בכלל, ומצא את עצמו לא פעם בעימות עם ארגוני קהילה אחרים.',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'להט״ב',
        'פוליטיקה ומנהיגות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ]
    ],
    'id': 'LR48',
    'is_active': true,
    'keywords': [
      'חקיקה',
      'כנסת',
      'גאווה',
      'מצעד',
      'זכויות להט״ב',
      'תאים מפלגתיים'
    ],
    'name': 'גאווה בליכוד',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'גאווה בליכוד, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/likudglbt/'
      },
      {
        'title': 'גרוס, אייל (2016). הפוליטיקה של זכויות להט״ב: בין (הומו) נורמטיביות ו(הומו) לאומיות לפוליטיקה קווירית. בתוך: גרוס, אייל, זיו, עמליה ויוסף, רז (עורכים), <b>סקס אחר - מבחר מאמרים בלימודים להט״בים וקוויריים ישראליים</b> (עמ\' 183–245). תל אביב: רסלינג.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '25/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2011,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות',
      'שירותים משפטיים'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '07/03/2018'
    },
    'description': '״גרנית עמותה לסיוע לנשים בהליכי גירושין״ (ע״ר 580349249) נוסדה בינואר 2000 ע״י ד״ר תקווה רגר במטרה לסייע לנשים בהליכי גירושין ולאחריהם על מנת לסייע להן להתמודד ולצמצם את מידת הנזק הכלכלי, הנפשי והחברתי, במהלך הגירושין ואחריהם. בין היתר יזמה העמותה חקיקה לחלוקת זכויות הפנסיה לאחר הגירושין, הפעילה קבוצות תמיכה ברחבי הארץ לנשים לנשים הנמצאות לפני, בתוך או אחרי תהליכי גירושין, הפעילה קו פתוח לנשים בתהיכי גירושין והפנתה אותן לגורמים מקצועיים. הסיוע ניתן על ידי מתנדבים ואנשי מקצוע מומחים כגון: פסיכולוגים, משפטנים, עובדים סוציאליים, מגשרים ומאמנים.\nאתר האינטרנט ועמוד הפייסבוק של העמותה אינם פעילים והדוח הכספי האחרון שנמצא באתר הגיידסטאר הוא לשנת 2017 וממנו עולה שבאותה שנה לא בוצעה כל פעילות. לא ברור האם העמותה עדין פעילה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ]
    ],
    'id': 'YH43',
    'is_active': true,
    'keywords': [
      'גירושין',
      'דיני משפחה',
      'פנסיה',
      'סיוע משפטי',
      'קבוצת תמיכה',
      'תמיכה נפשית',
      'קו סיוע',
      'אמהות גרושות'
    ],
    'name': 'גרנית- עמותה לסיוע לנשים בהליכי גירושין',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'גבעת שמואל',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://web.archive.org/web/20160306082028/http://granitwomen.org/ \nאתר העמותה כפי שנוטר בארכיון האינטרנט (internet archive) ב- 6.3.2016.'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>גרנית עמותה לסיוע לנשים בהליכי גירושין (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580349249'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה (2008, 25 פברואר). <b>פרוטוקול מס\' 121: הצעת חוק חלוקת זכויות פנסיה בין בני זוג, התשס״ז-2007</b>. נדלה מתוך',
        'url': 'http://fs.knesset.gov.il/17/Committees/17_ptv_571197.docx'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/12/2019'
    },
    'year_closed': 2017,
    'year_closed_text': '2017',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '16/09/2019'
    },
    'description': 'קבוצת העבודה לבדיקת מעמדן של הנשים הפלסטיניות בישראל היתה קואליציה של ארגוני נשים ונשים פרטיות שכתבה את דוח הצללים הראשון שהוגש בשנת 1997 מטעם ארגוני חברה אזרחית בישראל לועדת האו״ם של ה״אמנה למניעת כל צורות האפלייה כנגד נשים״ (CEDAW). בקואליצייה השתתפו הארגונים הבאים: נשים נגד אלימות, האגודה הערבית לזכויות האדם, אל סיואר, מעון חירום חיפה, ועדת המעקב לענייני החינוך הערבי, העמותה להכוון לימודי לתלמידים ערבים. את הקבוצה ריכזה רינה רוזנברג מעדאלה ובין חברותיה נכללו עאידה תומא-סלימאן, הודא רוחאנא, סיהאם בדארנה, נבילה אספניולי, האלה אספניולי, ערין הווארי, סוהאד בשארה וערבייה מנצור. הקואליציה נוצרה בשנת 1996 לאחר שמדינת ישראל הגישה את הדו״ח הראשון לועדת ה-CEDAW ובו כמעט שלא היה אזכור למצבן של נשים ערביות. במהלך עבודתה אספה הקבוצה נתונים רבים אודות מצבן של נשים פלסטיניות אזרחיות ישראל והפיקה דו״ח צללים בן 88 עמודים שכלל גם המלצות ליישום סעיפי האמנה בתחומים שונים. הדו״ח הוגש בצמוד להגשה החוזרת של הדוח השני של מדינת ישראל ביולי 1997.',
    'description_ar': 'لجنة العمل لفحص مكانة المرأة الفلسطينية في إسرائيل- عبارة تحالف من المنظمات النسائية ونساء فرديات التي كتبت تقرير ״تسلاليم״ الأول الذي قدمته في عام 1997 منظمات المجتمع المدني في إسرائيل إلى لجنة الأمم المتحدة المعنية باتفاقية منع جميع أشكال التمييز ضد المرأة. شارك فالائتلاف كل من الجمعيات: نساء ضد العنف، الاتحاد العربي لحقوق الانسان، السوار، ملجأ الطوارئ حيفا، لجنة المتابعة للجماهير العربية، الجمعية للتوجيه الأكاديمي للعرب. ركزت المجموعة رينا روزنبرج من عدالة ومن المشاركات: عايدة توما سليمان، هدى روحانا، سهام بدارنة، نبيلة اسبنيولي، هالة اسبنويلي، عرين هواري، سهاد بشارة وعربية منصور. نشأ الائتلاف عام 1996 بعد ان قامت دولة إسرائيل بتقديم التقرير الأول للجنة سيدو والتي لم تتطرق لحال النساء العربيات. في مسيرة عمل الائتلاف جمعت المجموعة مواد ومعلومات كثيرة التي تشرح حال النساء الفلسطينيات في إسرائيل وأصدرت تقرير ״تسلاليم״ وهو عبارة عن 88 صفحة وشملت توصيات لتنفيذ بنود اللجنة بمجالات مختلفة. قُدم التقرير بالتزامن مع إعادة تقديم التقرير الثاني لدولة إسرائيل في يوليو 1997.',
    'display_organization_kind': 'התארגנות שאינה עמותה בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ],
      [
        'חינוך',
        'צמצום פערים בחינוך'
      ]
    ],
    'id': 'SA154',
    'is_active': false,
    'keywords': [
      'פלסטיניות',
      'האמנה לביעור כל צורות ההפליה נגד נשים 1979 CEDAW',
      'תעסוקה',
      'בריאות',
      'מעמד אישי',
      'אלימות',
      'זכויות',
      'נתונים',
      'קואליצייה'
    ],
    'name': 'קבוצת העבודה לבדיקת מעמדן של הנשים הפלסטיניות בישראל',
    'name_ar': 'لجنة العمل على مكانة المرأة الفلسطينية في إسرائيل',
    'name_change_year': null,
    'name_common': 'דו״ח צללים CEDAW',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נצרת',
    'organization_kind': [
      'התארגנות שאינה עמותה',
      'בינלאומי'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-09-16'
    },
    'sources': [
      {
        'title': 'The Working Group on the Status of Palestinian Women Citizens of Israel. 1997. The Status of Palestinian Women Citizens of Israel, Submitted to the Committee on the Elimination of Discrimination against Women',
        'url': 'https://www.adalah.org/uploads/oldfiles/eng/intladvocacy/pal_women1.pdf'
      },
      {
        'title': 'אבו-בקר, ח\'אולה (2015). התנועה הנשית-פמיניסטית הפלסטינית בתוך ישראל. בתוך: סבאע\'-ח\'ורי, אריז\' ורוחנא, נדים (עורכים). <b>הפלסטינים בישראל: עיונים בהיסטוריה, בפוליטיקה ובחברה</b>. כרך שני (עמ\' 205–222). חיפה: מדה אל-כרמל. נדלה מתוך',
        'url': 'http://mada-research.org/wp-content/uploads/2016/01/hebrew_2-4.pdf'
      },
      {
        'title': 'אהרוני, שרי (2015). <b>נשים, שלום וביטחון: החלטה 1325 של מועצת הביטחון בהקשר הישראלי, נייר מדיניות</b>. שוות - המרכז לקידום נשים בזירה הציבורית, מכון ון-ליר בירושלים. נדלה מתוך',
        'url': 'http://din-online.info/pdf/vn21.pdf'
      },
      {
        'title': 'جنان عبده (2008). الجمعيّات النسائيّة والنسويّة الفلسطينيّة- في مناطق 48, مدى الكرمل'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '16/09/2019'
    },
    'year_closed': 1997,
    'year_closed_text': '1997',
    'year_founded': 1996,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '21/08/2018'
    },
    'description': 'דירת המעבר הינה מסגרת משקמת המאפשרת לאשה ולילדיה תהליך של הסתגלות ויציאה לחיים עצמאיים לאחר שהות במקלט. בדירת המעבר נשים מנהלות אורח חיים עצמאי המלווה בטיפול, תמיכה, ליווי וסיוע משפטי תוך התייחסות לקשיים הקיומיים בתהליך השיקום. התמיכה הניתנת בעת השהות בדירת המעבר כוללת רכישת מיומנויות יום-יומיות הנדרשות לניהול חיים עצמאיים; השתלבות בהכשרה מקצועית, מסגרת תעסוקתית או מסגרת לימודית; סיוע בהליכים משפטיים בנושאי גירושין, חלוקת רכוש, משמורת, הסדרי ראיה; העשרה ועזרה מקצועית לילדים. הדירה הראשונה הוקמה ב-1994 כפרויקט של ״אשה לאשה״ בירושלים תחת השם ״תכנית נע״מ - נשים עוזבות מקלט״. בשנת 1997 התחיל משרד הרווחה, באמצעות השירות לרווחת הפרט והמשפחה, להפעיל פרויקט ניסיוני תחת הכותרת ״דירות קלט לנשים בסכנת אלימות ולילדיהן״. את הפרויקט לווה מחקר הערכה של הביטוח הלאומי והוא מומן על ידי משרד הרווחה והמוסד לביטוח לאומי. הדירה הראשונה הופעלה באמצעות עמותת בת מלך ובין השנים 1997-1998 החלו לפעול תשע דירות נוספות בתשע רשויות מקומיות בשלוש דרכים עיקריות: ישירות על ידי המחלקות לשירותים חברתיים, באמצעות מרכזים למניעת אלימות במשפחה או על ידי עמותות. בשנת 2001 הפרויקט הופך לשירות קבוע ובשנת 2017 היו ברחבי הארץ 15 דירות. 10 מתוקצבות על ידי משרד הרווחה, אחת על ידי רשות מקומית והיתר על ידי עמותות, ביניהן שתי דירות לנשים ערביות ואחת לדתיות/חרדיות.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ],
      [
        'תעסוקה ועבודה',
        'השמה וליווי בתעסוקה'
      ]
    ],
    'id': 'YH76',
    'is_active': true,
    'keywords': [
      'דיור',
      'תמיכה נפשית',
      'אמהות'
    ],
    'name': 'דירות קלט (מעבר) לנשים נפגעות אלימות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-05-19'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.molsa.gov.il/Populations/Distress/FamilyViolence/ProtectionAndFirstAid/Pages/TM_02_02_01_A02.aspx'
      },
      {
        'title': 'אישה לאישה: אתר העמותה.',
        'url': 'http://www.jerusalemshelter.org.il/web/8888/nsf/sbs.py?&_ID=15551&did=5552&G=15551&PF=1&lang=HE'
      },
      {
        'title': 'אמזלג-באהר, חיה, והכהן וולף, חגית (2001). <b>דירות קלט לנשים בסיכון וילדיהן</b>. ירושלים: המוסד לביטוח לאומי, מינהל המחקר והתכנון והאגף לפיתוח שירותים. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/mifal_76.pdf'
      },
      {
        'title': 'חסון, יעל (2017). <b>תקצוב המאבק למיגור האלימות נגד נשים: היעדר שקיפות וביצוע חסר</b>. מרכז אדוה. נדלה מתוך',
        'url': 'http://adva.org/wp-content/uploads/2017/11/Violence-against-women-1.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים חרדיות',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '21/08/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1994,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '10/01/2018'
    },
    'description': '״דלת פתוחה״ - היא הגוף המוביל בישראל בתחום של קידום הזכות למיניות בריאה וחינוך מיני. דלת פתוחה הוקמה בשנת 1966 בשם ״האגודה הישראלית לתכנון המשפחה״ והפכה לעמותה רשומה בשנת 1984 שמטרותיה: ״קידום החינוך וההדרכה למיניות בריאה, תכנון המשפחה ואורח חיים בריא, למען רווחת הפרט והמשפחה וייעוץ במצבי מצוקה.״ על פי הדוחות הכספיים, שם האגודה שונה ל״דלת פתוחה״ באופן רשמי, ב-2011. לפני כן נקראה כשנתיים (מ-2009) ״א.י.ת.כ.ם - דלת פתוחה״. העמותה היא חלק מהאגודה הבינלאומית לתכנון המשפחה ׁ(IPPF) הפועלת בכ-180 מדינות: https://www.ippf.org/. האגודה מפעילה רשת ארצית של מרכזי תמיכה לנוער וצעירים, המעניקה שירותי ייעוץ, תמיכה וסיוע ראשוני על רקע מצוקה רגשית בגיל ההתבגרות, ובנושאים של זוגיות ומיניות; מעבירה סדנאות חינוכיות בקהילה; תכניות הכשרה לאנשי מקצוע בתחום הבריאות והחינוך; וקידום מדינות וחקיקה בתחום הפריון והבריאות, בדגש על נגישות לאמצעי מניעה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'תכנון משפחה וחינוך מיני'
      ],
      [
        'נערות וצעירות',
        'בריאות'
      ],
      [
        'חינוך',
        'חינוך מיני/מיניות בריאה'
      ]
    ],
    'id': 'YH95',
    'is_active': true,
    'keywords': [
      'אמצעי מניעה',
      'הריון',
      'הפלה',
      'תכנון משפחה',
      'חינוך מיני'
    ],
    'name': 'דלת פתוחה לקידום מיניות בריאה',
    'name_ar': 'الباب المفتوح',
    'name_change_year': 2011,
    'name_common': null,
    'name_past': 'האגודה הישראלית לתכנון המשפחה',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'תכנון משפחה וחינוך מיני',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-01-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.opendoor.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>דלת פתוחה, לקידום מיניות בריאה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580030179'
      },
      {
        'title': 'ארקין, נילי (1972, 27 פברואר). כנס האגודה הישראלית לתכנון משפחה: ״משפחה מרובת ילדים״ לרוב אינה ״משפחה ברוכת ילדים״. <b>מעריב</b>. נדלה מתוך',
        'url': 'http://jpress.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=MAR%2F1972%2F02%2F27&id=Ar01605&sk=72E2E80E'
      },
      {
        'title': 'דלת פתוחה (עמותה). <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%93%D7%9C%D7%AA_%D7%A4%D7%AA%D7%95%D7%97%D7%94_(%D7%A2%D7%9E%D7%95%D7%AA%D7%94)'
      },
      {
        'title': 'מעריב (1979, 18 נובמבר). הסתכלו בלוח השנה ותכננו את גודל המשפחה. <b>מעריב</b>. נדלה מתוך',
        'url': 'http://jpress.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=MAR%2F1979%2F11%2F18&id=Ar01921&sk=797A1A32'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '13/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': 1984
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '20/08/2018'
    },
    'description': 'מרכז ״דרך אם״ הוקם בתל אביב בשנת 1991 על ידי המיילדת אילנה שמש ומדריכות ההכנה ללידה רותי פולדן ואיריס יודפת. המרכז שם לו למטרה לקדם את נושא הלידה הטבעית וחינוך ללידה בישראל. תרומתו הגדולה של המרכז היתה בהעלאת מודעות הציבור לכך ש״אפשר ללדת גם אחרת״. המרכז עבר בשלב מסוים לפרדס חנה ובשנת 2003 הפכה ״דרך אם״ לרשת ״דיאדה״. המרכז שימש כבית גידול להתפתחות של פעילות מרכזיות וארגונים העוסקים בקידום מדיניות וזכויות נשים בלידה ובלידה טבעית (נשים קוראות ללדת, ארגון מיילדות הבית בישראל ועוד).',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ]
    ],
    'id': 'SA49',
    'is_active': false,
    'keywords': [
      'הריון',
      'לידה',
      'לידה טבעית',
      'הנקה'
    ],
    'name': 'דרך אם',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'פרדס חנה-כרכור',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'איריס יוטבת. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%90%D7%99%D7%A8%D7%99%D7%A1_%D7%99%D7%95%D7%98%D7%91%D7%AA'
      },
      {
        'title': 'רונאל, גילה, ארצי-פדן, מירה וכהן-ורדי, עלמה (2002). <b>טבעי ללדת: המדריך המקיף להריון וללידה ולימים שאחרי</b>. תל אביב: כתר.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '20/08/2018'
    },
    'year_closed': 2003,
    'year_closed_text': '2003',
    'year_founded': 1991,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '20/11/2018'
    },
    'description': 'בשנת 2000 הוקם בחיפה ביוזמת ובמימון הרשות למלחמה בסמים בית טיפולי לנשים בקהילה. המסגרת, שנקראה ״מב״ט נשי״ היתה התכנית היחידה בישראל לטיפול בהתמכרויות שיועדה לנשים בלבד והופעלה על ידי המרכז לטיפול בנפגעי סמים ברמב״ם בשיתוף משרד הרווחה והאגודה לבריאות הציבור (חברת בת של משרד הבריאות). ב-2015, הוציא משרד הרווחה את השירות למכרז אשר בו זכתה עמותת ״הדרך״ אשר מפתחת ומפעילה שירותים למכורים. הבית נותר באותה הכתובת (מסדה 26) ושמו שונה ל״דרך אריאלה״.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'YH149',
    'is_active': true,
    'keywords': [
      'התמכרות',
      'גמילה',
      'אשפוז',
      'טיפול נפשי',
      'אלימות'
    ],
    'name': 'דרך אריאלה',
    'name_ar': null,
    'name_change_year': 2015,
    'name_common': null,
    'name_past': 'מב״ט נשי',
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'התמכרויות ושיקום',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-11-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.haderech.org/objDoc.asp?PID=156673&OID=421532&DivID=1'
      },
      {
        'title': 'הוועדה למאבק בנגעי הסמים והאלכוהול (2016, 28 יולי). <b>פרוטוקול: סיור בחיפה במסגרות המטפלות בנשים על רצף ההתמכרות</b>. נדלה מתוך',
        'url': 'https://oknesset.org/meetings/2/0/2004701.html'
      },
      {
        'title': 'המשרד לביטחון הפנים (2016). מבט״פ 2016 – תשע״ז: שנתון המשרד לביטחון הפנים. עמ\' 77–78. נדלה מתוך',
        'url': 'https://www.gov.il/BlobFolder/reports/mops_annual_ns_2016/he/mops_annual_ns_2016.pdf'
      },
      {
        'title': 'מ.ב.ט נשי: בית טיפולי לנשים אחרי גמילה, חיפה. בתוך אתר: מרכז רפואי רמב״ם – מרכז לטיפול בנפגעי סמים, חיפה. נדלה מתוך',
        'url': 'http://www.hdatc.co.il/hostel_heb_top.htm'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '20/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '24/12/2018'
    },
    'description': '״דרך חדשה״ הוא החדש ביותר מבין שלושת ההוסטלים השיקומיים הפועלים בארץ עבור צעירות הסובלות מהפרעות אכילה. הבתים השיקומיים הוקמו בשיתוף פעולה בין המרכז למפעלים מיוחדים של הביטוח הלאומי, משרד הבריאות ומשרד הרווחה, והניהול האדמיניסטרטיבי של ״דרך חדשה״ נעשה על ידי החברה הפרטית ״ח.צ. שיקום בקהילה״. ההוסטלים נועדו לפתור את בעיית ״הדלת המסתובבת״, של אשפוזים חוזרים ונשנים של צעירות, אשר משתחררות לביתן ללא כל מסגרת המשך קהילתית. ההוסטל מיועד ל - 14 שוהות בגילאי 18-35. במהלך השהות, הצעירות משתלבות במסגרות לימודים ותעסוקה, מקבלות ליווי סביב הארוחות וטיפול פסיכולוגי ופסיכיאטרי, נפגשות בקביעות עם דיאטנית, לומדות כישורי חיים וניהול משק בית בסיסיים, משתתפות בקבוצות תמיכה ומשתתפות בפעילויות חברתיות בבית ומחוצה לו. כבר בשלבים הראשוניים של המעקב אחר הקמת שני ההוסטלים הראשונים ב -2008 ו -2009, עלה צורך בהקמה של הוסטל נוסף בדרום הארץ, אולם רק ב - 2015 הוא הוקם.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'נערות וצעירות',
        'בריאות'
      ]
    ],
    'id': 'LR31',
    'is_active': true,
    'keywords': [
      'דיור',
      'הפרעות אכילה',
      'תעסוקה',
      'הוסטל'
    ],
    'name': 'דרך חדשה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'ממשלתי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'בריאות הנפש וטיפול',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-12-24'
    },
    'sources': [
      {
        'title': 'www.hetz-s.co.il/index.php?page=info_page&id=67'
      },
      {
        'title': 'בלנק, רוני (2016). <b>הטיפול בהפרעות אכילה בישראל</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/732c28b1-995f-e611-80dd-00155d010ede/2_732c28b1-995f-e611-80dd-00155d010ede_11_10422.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '24/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '25/04/2018'
    },
    'description': 'האגודה הישראלית ללימודים פמיניסטיים ולחקר המגדר הוקמה ונרשמה כעמותה ב-1998 אצל חנה ספרן באוניברסיטת חיפה במטרה לקדם את לקדם את הלימודים הפמיניסטיים וחקר המגדר, לייצר ולאפשר שיח פמיניסטי עדכני, פלורליסטי ואידיאולוגי, ולעודד יצירת והפצת מידע שיביא להבנת מצבן של נשים. בשנות פעילותה יזמה האגודה את פרסום המקראה ״ללמוד פמיניזם״ (הקיבוץ המאוחד, 2006) בעריכת דלית באום הכוללת מבחר תרגומים לעברית של טקטסים מכוננים בתיאוריה פמיניסטית וחקר המגדר. האגודה קיימה כנס שנתי ארצי, ימי עיון ופרסמה עלון בעריכת דפנה למיש ויפה ברלוביץ. ראשות האגודה היו: מרילין ספר, פרנסס רדאי ויפה ברלוביץ. האגודה מפעילה האתר פועל בשיתוף פעולה עם ארגונים העוסקים בהוראה ובמחקר, נשים וגברים בסגל האקדמי, סטודנטיות וסטודנטים, ארגוני נשים, פעילות ופעילי שטח.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף אקדמי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'אגודות מקצועיות'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ]
    ],
    'id': 'SA8',
    'is_active': true,
    'keywords': [
      'מחקר פמיניסטי',
      'לימודי מגדר',
      'פמיניזם'
    ],
    'name': 'האגודה הישראלית ללימודים פמיניסטיים ולחקר המגדר',
    'name_ar': 'الرابطة الاسرائيلية للدراسات النسوية والبحث الجنسوية',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'אקדמי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אגודות מקצועיות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-04-25'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.gendersite.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>האגודה הישראלית ללימודים פמיניסטיים ולחקר המגדר (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580315356'
      },
      {
        'title': 'אמיר, דלילה, באום, דלית, ברייר-גארב, רונה, ברלוביץ\', יפה, גריינימן, דבורה, הלוי, שרון, חרובי, דינה ופוגל-ביז\'אוי, סילביה (עורכות) (2006). <b>ללמוד פמיניזם: מקראה – מאמרים ומסמכי יסוד בחשיבה פמיניסטית. תל אביב: הקבוץ המאוחד, האגודה הישראלית ללימודים פמיניסטיים ולחקר המגדר</b>. נדלה מתוך',
        'url': 'https://kotar.cet.ac.il/KotarApp/Viewer.aspx?nBookID=96026506'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '10/04/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'ייעוץ שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '26/03/2018'
    },
    'description': 'האגודה למען הלהט״ב בישראל הוקמה בתל אביב בשנת 1975 תחת השם ״אגודה לזכויות הפרט״, והייתה חלוצת ארגוני הקהילה בארץ. בשנת 1982 נרשמה כעמותה. לעמותה היו סניפים מקומיים בחיפה ובבאר שבע, אשר נסגרו בתחילת שנות ה - 2000 והוחלפו על ידי קבוצות פעילות אזוריות. פעילויותה המגוונות של האגודה מכוונות לקדם את מעמדה החוקי, המשפטי והחברתי של הקהילה הגאה, להעניק שירותים ומענים מקצועיים, לתמוך בפיתוח יוזמות קהילתיות, להנגיש מידע לאוכלוסיות מודרות ומוחלשות בקהילה ולסייע לקהילות אלה לפתח נראות והכרה ציבורית. בנוסף, האגודה פועלת גם לשימור הזיכרון הקהילתי, לציון אירועים קהילתיים ופיתוח וקידום אירועי גאווה. כמו כן, האגודה מפעילה קו תמיכה טלפוני בשם ״הקו הלבן״ עבור חברי הקהילה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'זכויות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ],
      [
        'פוליטיקה ומנהיגות',
        'כללי'
      ]
    ],
    'id': 'SA1',
    'is_active': true,
    'keywords': [
      'קהילה',
      'זכויות',
      'מצעד',
      'גאווה',
      'סיוע משפטי',
      'קו סיוע',
      'מחאה',
      'מיצוי זכויות',
      'הסברה',
      'זכויות להט״ב'
    ],
    'name': 'אגודה לשמירת זכויות הפרט',
    'name_ar': 'الاجودة-جمعية المثليين/مثليات ومزدوجي الميول الجنسية ومتحولي الجنس الإسرائيليين (مجتمع الإل جي بي تي)',
    'name_change_year': null,
    'name_common': 'האגודה למען הלהט״ב בישראל',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'זכויות',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-03-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.lgbt.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אגודה לשמירת זכויות הפרט: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580014058'
      },
      {
        'title': 'ספרן, חנה, הרטל, רחלי וששון-לוי, אורנה (2016). הי[א]סטוריה לסבית מקומית: פעילות, מאבקים והישגים. בתוך: הראל, אלון, לושינסקי, יניב ומורגנשטרן, עינב (עורכים), <b>זכויות הקהילה הגאה בישראל: משפט, נטייה מינית וזהות מגדרית</b> (עמ\' 45–80). האוניברסיטה העברית, המכון למחקרי חקיקה ולמשפט השוואתי. צפרירים: נבו.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '10/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1975,
    'year_registered': 1982
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '28/10/2018'
    },
    'description': '״האגודה לקידום בריאות נשים בישראל״ (ע״ר 580241636) נוסדה בשנת 1994 כארגון התנדבותי במטרה לספק מענה לצרכי בריאות הנשים בישראל. האגודה שמה לה למטרה : לספק מידע ותמיכה לצרכניות בריאות, להעצים ולחזק נשים כספקות שירותים, להשפיע על קובעי המדיניות בהפניית משאבים לרפואת הנשים בישראל, להעלות על סדר היום הציבורי צרכים בריאותיים ייחודיים של נשים בניסיון למצוא מענה. פעילות האגודה כללה: איסוף והפצת מידע בריאותי, חינוך לצרכנות בריאות, הכשרת מנהיגות בקרב אנשי מקצוע הבריאות, פעילות פרלמנטרית לקידום מדיניות הבריאות. האגודה הפעילה אתר שכלל מידע מגוון ורחב על סוגיות שונות הקשורות בבריאות נשים, כולל נערות, נשים בנות 60 ומעלה ונשים בעלות מוגבלויות. את העמותה ניהלה איימי אבגר ועל חברות הוועד המנהל נמנו: שרה איינשטיין, רויטל גרוס, רשל זהר-קדוש, פט צברי, ג\'ולי צוויקל, שרון שנהב. העמותה אינה פעילה עוד וקיבלה החלטה על פירוק מרצון ב-2005 או בסמוך.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'YH13',
    'is_active': false,
    'keywords': [
      'בריאות נשים',
      'גוף',
      'גיל המעבר',
      'גניקולוגיה',
      'דימוי גוף',
      'העלאת מודעות',
      'הריון',
      'לידה',
      'בריאות הנפש',
      'פוריות',
      'צעירות',
      'מוגבלויות'
    ],
    'name': 'האגודה לקידום בריאות נשים בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>האגודה לקידום בריאות נשים בישראל: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580241636/documents'
      },
      {
        'title': 'ארכיון האינטרנט (2018, 28 דצמבר). **האגודה לקידום בריאות נשים בישראל). נדלה מתוך',
        'url': 'https://web.archive.org/web/20181228161626/http://www.la-briut.org.il/about/'
      },
      {
        'title': 'בית דין אזורי לעבודה בירושלים (2015, 9 יוני). <b>איימי אבגר נגד פסגות קופות גמל ופנסיה בע״מ חברות – פסק דין</b>. פסק הדין מציין פירוק מרצון של העמותה בשנת 2005. נדלה מתוך',
        'url': 'https://www.takdin.co.il/Searchg/%D7%A6%20%D7%95%20%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D%204826%2001%2015%20%D7%90%D7%99%D7%99%D7%9E%D7%99%20%D7%90%D7%91%D7%92%D7%A8%20%D7%A0%20%D7%A4%D7%A1%D7%92%D7%95%D7%AA%20%D7%A7%D7%95%D7%A4%D7%95%D7%AA%20_hd_5014941.html'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/05/2019'
    },
    'year_closed': 2005,
    'year_closed_text': '2005',
    'year_founded': 1994,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '05/07/2018'
    },
    'description': 'האגף למעונות יום ומשפחתונים״ במשרד העבודה, הרווחה והשירותים החברתיים הוא אחת היחידות הממשלתיות המוקדמות ביותר אשר הוקמו לקידום נשים בישראל. האגף פועל מתוקף חוק הפיקוח על מעונות (תשכ״ה 1965) ומטרותיו הן: קביעת מדיניות להפעלת מעונות היום, המשפחתונים והצהרונים בישראל. האגף הוקם לצורך קידום תעסוקת נשים בשלהי שנות השישים מתוך הבנה כי המעון, המשפחתון והצהרון מאפשרים לאימהות לילדים בגיל הרך להשתלב בהכשרה מקצועית ובשוק העבודה. לאורך השנים השתנה שם האגף וסמכויותיו אך ייעודו נשמר. בשנת 1966 ועדה בין-משרדית המליצה על השתתפות המדינה בהקמת מעונות יום כדי לעודד תעסוקת נשים ואמהות. כתוצאה מכך, בשנת 1967 הוכרז על מינוי ״הממונה על עבודת נשים במשרד העבודה״. בשנת 1970 הוקמה ה״יחידה לעבודת נשים״ במשרד העבודה ובאמצע שנות השבעים היא הופכת לאגף. בדו״ח נמיר (1978) צוין כי ״רוב מעונות היום כ-90% מופעלים על ידי ארגוני הנשים המתנדבות (נעמ״ת, ויצ״ו, תנועת האשה הדתית-לאומית ואחרים) ומקצתם על ידי רשויות מקומיות״. המלצה 94 בדו״ח מתייחסת לשני עניינים: ״א)יש להקים מעונות ילדים בהיקף שיאפשר קליטת כל ילד שהוריו זקוקים לשירות זה. ב) יש לרכז את האחריות לשירותי טיפול חינוכי בילדים בזרוע ממשלתית אחת שתפקח על ההיבטים התוכניים, ארגוניים ותקציביים של השירותים״. במהלך שנות השמונים, לאחר חקיקת ״חוק הזדמנות שווה בתעסוקה״ (1981), הורחב תפקיד ה״יחידה לעבודת נשים״ והיא הוגדרה כאגף האחראי לאכיפת הוראות החוק. מתוקף כך פעלו בו חמש מפקחות, אחת לכל מחוז. בשנת 1989 שונה שם האגף והוא נקרא ״תעסוקת נשים ומעמד האישה״ ובשנת 2001 שמו מופיע כ״אגף תעסוקת נשים״. בשנת 2006 שוב השתנה שמו והוא נקרא ״האגף לתעסוקת נשים, מעונות יום ומשפחתונים״. בשנת 2018 שמו הרשמי של הוא ״האגף למעונות ומשפחתונים״.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'רווחה וקהילה',
        'תעסוקה ועבודה'
      ]
    ],
    'id': 'YH50',
    'is_active': true,
    'keywords': [
      'אמהות',
      'ילדים/ות',
      'שירות ציבורי',
      'מעונות ומשפחתונים',
      'צהרונים',
      'הכשרה מקצועית'
    ],
    'name': 'האגף למעונות יום ומשפחתונים במשרד העבודה הרווחה והשירותים החברתיים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': 'הממונה על עבודת נשים; היחידה לתעסוקת נשים; האגף לתעסוקת נשים; אגף תעסוקת נשים, מעונות יום ומשפחתונים',
    'name_replaced_by': 'האגף לתעסוקת נשים',
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'מעונות ומשפחתונים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-07'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://employment.molsa.gov.il/meonot-yom'
      },
      {
        'title': 'הוועדה למעמד האשה (1978). <b>צוותי הוועדה למעמד האשה: דיונים ומימצאים</b>. ירושלים: משרד ראש הממשלה.'
      },
      {
        'title': 'דורון, אברהם (2017). הרחבת רשת מעונות היום לילדים בגיל הרך בישראל בשנות ה-70 – חקר מקרה של מדיניות חברתית. <b>ביטחון סוציאלי, 101</b>, 119–140. נדלה מתוך',
        'url': 'https://www.btl.gov.il/Publications/Social_Security/bitahon101/Documents/50-doron.pdf'
      },
      {
        'title': 'נבו, רעיה (1970, 20 יולי). יחידה לתעסוקת נשים הוקמה במשרד העבודה. <b>דבר</b>. נדלה מתוך',
        'url': 'http://jpress.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=DAV%2F1970%2F07%2F20&id=Ar00901&sk=2DC25FD3'
      },
      {
        'title': 'Galily, Yair & Betzer-Tayar, Moran (2014). Losing is not an option! Women\'s basketball in Israel and its struggle for equality (1985-2002). <b>The International Journal of the History of Sport 31</b>(13), 1694-1705.'
      },
      {
        'title': 'שוורץ, אליעזר (2010). <b>ניתוח תקציב ופעילות האגף לתעסוקת נשים במשרד התעשייה, המסחר והתעסוקה</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/87526b58-e9f7-e411-80c8-00155d010977/2_87526b58-e9f7-e411-80c8-00155d010977_11_8593.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '27/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': 'בשנת 1995 העבירה הכנסת את תיקון מס\' 7 ל״חוק שירות המדינה״ (מינויים - ‎1959) המגדיר כי שירות המדינה מחוייב לעקרון של ייצוג הולם וקובע את סמכותה של נציבות שירות המדינה לפעול באמצעים שונים להשגת יעד זה כולל שימוש בהעדפה מתקנת. החוק תוקן והורחב בשנת ‎ 2000 במקביל לתיקון של ״חוק שיווי זכויות האשה״, והחיל את החובה על כלל השירות הציבורי. בנובמבר 1996 הקים שמואל הולנדר, עם כניסתו לתפקיד נציב שירות המדינה את האגף לקידום ולשילוב נשים בנציבות שירות המדינה. לראשונה הכירה הנהלת הנציבות בצורך לייחד תקנים וסמכויות לטיפול בנושא והנימוק שניתן לכך הייתה החובה המוטלת על נציב שירות המדינה לפעול ליישום הוראת החוק הנוגעת לייצוג הולם של נשים. הקמת האגף נועדה לרכז את פעילות הממונות על מעמד האישה במשרדי הממשלה. בראש האגף עמדה עו״ד רבקה שקד אשר ראתה אותו כמנגנון חשוב במכלול הנושאים הרלוונטיים להעסקה ולקידום של נשים בשירות המדינה שנועד לתת מענה לפעילות בכנסת ובקרב ארגוני הנשים ולהתייחס לפסיקה מתחדשת ולהתעצמות השיח הציבורי והאקדמי בנושאי שוויון הזדמנויות בכלל ומעמד האישה בפרט. בהתאם לכך גדל מגוון הפעילויות של האגף והתרחב היקפן. פעולות האגף כוללות: 1) גיבוש עבודת המטה ותכנית העבודה הנוגעת לקידום נשים בשירות המדינה, הנחייה, הדרכה והפעלה של הממונות על מעמד האשה כחלק מיישום החוק; 2) טיפול בתלונות נשים על קיפוח, אפליה והטרדה מינית; 3) יישום החוק למניעת הטרדה מינית והדרכת האחראיות במשרדים; 4) תכנון ופיתוח הדרכה והסברה בנושאי שיויון הזדמנויות ומעמד האשה; 5) איסוף נתונים ומידע ופרסום מחקרים בנושאים של שיויון הזדמנויות ומעמד האשה. 6) סיוע וקידום של חקיקה רלבנטית; 7) קיום קשרי עבודה עם גופים, ארגונים ואקדמיה. באוקטובר 2014, בעקבות ועדת שטאובר ו״לאחר עבודת מטה מעמיקה שביצע האגף שונה שם התפקיד של הממונות על מעמד האשה ל״ממונה על שוויון מגדרי ויועצת המנכ״ל לקידום נשים״.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ]
    ],
    'id': '1YB10',
    'is_active': true,
    'keywords': [
      'אפליה מגדרית בתעסוקה',
      'גיוון במקום העבודה',
      'הטמעת חשיבה מגדרית',
      'העדפה מתקנת',
      'ייצוג הולם',
      'מידע',
      'ממונה על הטרדה מינית',
      'שוויון הזדמנויות',
      'שירות ציבורי',
      'שעות עבודה גמישות'
    ],
    'name': 'האגף לשיוויוון מגדרי בנציבות שירות המדינה',
    'name_ar': null,
    'name_change_year': 2014,
    'name_common': null,
    'name_past': 'האגף לקידום נשים בנציבות שירות המדינה',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.gov.il/he/departments/units/woman_unit'
      },
      {
        'title': 'שטינברג, פנינה (2012). <b>מקידום נשים להטמעת חשיבה מגדרית: תמורות בתפקיד הממונה על קידום מעמד האישה במשרדי הממשלה – מחקר מדיניות</b>. שוות: המרכז לקידום נשים בזירה הציבורית. ירושלים: ון ליר. נדלה מתוך',
        'url': 'https://www.vanleer.org.il/sites/files/product-pdf/%D7%AA%D7%A4%D7%A7%D7%99%D7%93%20%D7%94%D7%9E%D7%9E%D7%95%D7%A0%D7%95%D7%AA%20%D7%A2%D7%9C%20%D7%A7%D7%99%D7%93%D7%95%D7%9D%20%D7%9E%D7%A2%D7%9E%D7%93%20%D7%94%D7%90%D7%A9%D7%94%20-%20%D7%9E%D7%97%D7%A7%D7%A8%20%D7%9E%D7%93%D7%99%D7%A0%D7%99%D7%95%D7%AA.pdf'
      },
      {
        'title': 'שקד, רבקה (2004). יישום החוק להעדפה מתקנת בשירות המדינה. בתוך: מאור, ענת (עורכת), <b>העדפה מתקנת והבטחת ייצוג בישראל</b> (עמ\' 261–278). תל אביב: רמות. נדלה מתוך',
        'url': 'https://kotar-cet-ac-il.ezproxy.bgu.ac.il/KotarApp/Viewer.aspx?nBookID=92677230&sSelectedTab=tdBookInfo#1.0.8.fitwidth'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '23/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1995,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '05/11/2018'
    },
    'description': 'עמותת ״האור שבקצה״ ממוקמת בירושלים ותקוע. מציעה ליווי ותמיכה נפשית וכספית לנשים מוכות וילדיהן לאחר צאתן ממקלט לנשים מוכות. מייסדת העמותה היא נאווה מלכיאל, מאמנת אישית. עיקרה של התמיכה היא במתכונת של ליווי אישי. בעמותה מצמידים לכל אישה מלווה התומכת בהשתלבותה בעבודה ובחיי הקהילה, בעזרה לילדים, במימוש זכויות מול מוסדות המדינה וכדומה. כמו כן העמותה מסייעת, בהתאם ליכולת, בפרויקטים מיוחדים, מעבר לדירה חדשה, עזרה לילדים בקייטנות, ריהוט בסיסי, סלי מזון, רכישת מקצוע וכיו״ב.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'SA82',
    'is_active': true,
    'keywords': [
      'אימון אישי',
      'תמיכה נפשית',
      'גמ״ח'
    ],
    'name': 'האור שבקצה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>האור שבקצה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580604916'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחאה',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '15/10/2018'
    },
    'description': 'תנועת ״האם החמישית״ הוקמה בחודש מרץ 2002 ע״י נשים מתנועת ״ארבע אמהות״ ונשים מתנועות אחרות בקריאה ״מלחמה היא לא השפה שלי ״. התנועה שמה לה למטרה להביא לשיח הציבורי את השפה ואת הנסיון המצטבר של יישוב סכסוכים יחד עם הייחודיות של הקול הנשי כאלטרנטיבה לשפה ולפרקטיקה המיליטריסטית המובילה את הסכסוך הישראלי-פלסטיני. ״תפקידינו כנשים וכאמהות להשמיע את הקול הקיים בכל אחת ואחת מאיתנו-הקול הנשי היודע להכיל כאב, לחוש חמלה, להתמודד עם פחד ועם חוסר וודאות ולפתור סכסוכים ע״י הדברות ומתן כבוד הדדי. אנו מאמינות שלכל סכסוך יש פתרון וסכסוכים פותרים במילים ולא בכדורים...״. התנועה היתה אחת מהקבוצות השותפות בקואליציית נשים לשלום ורוכזה על ידי אורית לבנין-דגני מכפר תבור. לאחר שנת 2010, אין כמעט אזכורים לתנועה או לפעילותה.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'שלום'
      ]
    ],
    'id': 'SA65',
    'is_active': false,
    'keywords': [
      'שלום',
      'אמהות',
      'דו קיום'
    ],
    'name': 'האם החמישית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר תבור',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-15'
    },
    'sources': [
      {
        'title': 'על ה״אם החמישית״ באתר קואליציית נשים לשלום',
        'url': 'http://www.coalitionofwomen.org/%D7%94%D7%90%D7%9D-%D7%94%D7%97%D7%9E%D7%99%D7%A9%D7%99%D7%AA/'
      },
      {
        'title': 'Hermann, Tamar (2009). <b>The Israeli peace movement: a shattered dream</b>. Cambridge, UK: Cambridge University Press.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '15/10/2018'
    },
    'year_closed': 2010,
    'year_closed_text': '2010',
    'year_founded': 2002,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'שירותים משפטיים',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '08/05/2018'
    },
    'description': 'קואליציית ״האקדח על שולחן המטבח״ נוסדה בשנת 2011 על ידי רלה מזלי וסמדר בן-נתן כקמפיין רב ארגוני שמתמקד בהשפעות המגדריות של תעשיית האבטחה והשמירה בישראל, כולל רצח בנות ובני משפחה בנשק חברות אבטחה שנישא מחוץ לשעות העבודה. הקואליצייה פועלת תחת ארגון ״אשה לאשה-מרכז פמיניסטי חיפה״ ומאגדת 13 ארגוני חברה אזרחית: אשה לאשה, איתך-מעכי, האגודה לזכויות האזרח בישראל, הכצעקתה, ל.א. לאלימות נגד נשים, מרכז נגה למען נפגעי עבירה, נשים לגופן, פסיכואקטיב-אנשי ונשות בריאות הנפש למען זכויות אדם, פרופיל חדש, קואליציית נשים לשלום, רופאים לזכויות אדם, שדולת הנשים ותמורה-המרכז המשפטי למניעת אפליה. פעילות הקואליצייה כוללת: (1) קמפיינים ציבוריים ותקשורתיים על ההשפעה של נשק קל במרחב הציבורי; (2) פנייה לחברי כנסת ושרים בנושאי חקיקה הנוגעים לכלי ירייה; (3) עתירות לבית המשפט על נזיקין (מוגבלות גופנית) כתוצאה משימוש בלתי תקין בכלי נשק; (4) תיעוד ומחקר על נשק קל במרחב האזרחי בישראל; (5) קבוצות למידה.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'צבא, ביטחון ומדיניות חוץ',
        'ביטחון אישי'
      ],
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'בריאות ופריון',
        'מוגבלות'
      ]
    ],
    'id': 'SA44',
    'is_active': true,
    'keywords': [
      'משטרה',
      'צבא',
      'נשק',
      'ביטחון אישי',
      'מוגבלות',
      'נתונים'
    ],
    'name': 'האקדח על שולחן המטבח',
    'name_ar': 'إئتلاف المسدس على طاولة المطبخ',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'קואליציה, איגוד או פורום',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'צבא, ביטחון ומדיניות חוץ',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'ביטחון אישי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-08'
    },
    'sources': [
      {
        'title': 'דף הקואליצייה באתר ״אשה לאשה״',
        'url': 'http://isha2isha.com/%D7%AA%D7%97%D7%95%D7%9E%D7%99-%D7%A4%D7%A2%D7%99%D7%9C%D7%95%D7%AA/%D7%94%D7%90%D7%A7%D7%93%D7%97-%D7%A2%D7%9C-%D7%A9%D7%95%D7%9C%D7%97%D7%9F-%D7%94%D7%9E%D7%98%D7%91%D7%97/%D7%90%D7%95%D7%93%D7%95%D7%AA%D7%94%D7%90%D7%A7%D7%93%D7%97%D7%A2%D7%9C%D7%A9%D7%95%D7%9C%D7%97%D7%9F%D7%94%D7%9E%D7%98%D7%91%D7%97/'
      },
      {
        'title': 'האקדח על שולחן המטבח, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/%D7%94%D7%90%D7%A7%D7%93%D7%97-%D7%A2%D7%9C-%D7%A9%D7%95%D7%9C%D7%97%D7%9F-%D7%94%D7%9E%D7%98%D7%91%D7%97-160175817353648/'
      },
      {
        'title': 'מזלי, רלה (2017). <b>לא נצור: נשק קל במרחב האזרחי. כמה כלים וכמה פיקוח?</b>. תל אביב: פרויקט ״האקדח על שולחן המטבח״ ואשה לאשה חיפה. נדלה מתוך',
        'url': 'http://isha2isha.com/wp-content/uploads/2017/01/%D7%9C%D7%90-%D7%A0%D7%A6%D7%95%D7%A8-%D7%92%D7%A8%D7%A1%D7%94-%D7%93%D7%99%D7%92%D7%99%D7%98%D7%9C%D7%99%D7%AA-1-%D7%99%D7%A0%D7%95%D7%90%D7%A8-2017.pdf'
      },
      {
        'title': 'מזלי, רלה (2017). האקדח על שולחן המטבח: הדיכוי המגדרי הטמון בתעשיית האבטחה בישראל. בתוך: אולמרט, דנה, ברייר-גארב, רונה, קזין, ארנה ותירוש, יופי (עורכות). <b>קפיטליזם ומגדר: סוגיות פמיניסטיות בתרבות השוק</b> (עמ\' 124–145). תל אביב: ון ליר והקיבוץ המאוחד.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '08/05/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2011,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'יעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '25/10/2018'
    },
    'description': 'הבית הפתוח בירושלים לגאווה ולסובלנות הוקם ב - 1997 על ידי קבוצת מתנדבים ירושלמים. בשנתיים הראשונות לפעילותו פעל הארגון ללא מקום קבוע, ובמהלכן תוכנן המרכז הקהילתי שפעל בהתחלה במדרחוב ברחוב בן יהודה ובמהשך ברחוב הסורג. הארגון פועל בשני מישורים מרכזיים - הפעלת שירותים ותמיכה לחברי הקהילה הלהט״בית, ופעולה למען שינוי חברתי בנושאים הנוגעים לקהילה, ובעיקר להפיכתה של ירושלים לעיר שיוויונית ופלורליסטית יותר. מאז 2002 מארגן הבית הפתוח את מצעד הגאווה בירושלים וב - 2006 אירח בעיר את אירועי הגאווה העולמיים. הבית הפתוח פועל כמרכז קהילתי בו יש סלון, ספריה ותערוכות מתחלפות. הוא מפעיל קבוצת נוער וצעירים בשם בנ״צ, מרפאה פתוחה, שירותי יעוץ ותמיכה פסיכולוגים, מערכים חינוכיים בבתי ספר תיכונים ברחבי העיר וקבוצות פעילות יעודיות לנשים, טרנס*, משפחות ועוד.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'בריאות ופריון',
        'בריאות ומגדר'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'LR10',
    'is_active': true,
    'keywords': [
      'גאווה',
      'קהילה',
      'תמיכה נפשית',
      'קבוצות תמיכה',
      'נערות',
      'מצעד',
      'חינוך',
      'חינוך מגדרי',
      'מרפאות'
    ],
    'name': 'הבית הפתוח בירושלים לגאווה ולסובלנות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-10-25'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.joh.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>הבית הפתוח בירושלים לגאווה ולסובלנות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580304111'
      },
      {
        'title': 'הבית הפתוח בירושלים לגאווה ולסובלנות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/jerusalemopenhouse1/'
      },
      {
        'title': 'פנסטר, טובי ומנור, איתי (2010). אזרחות עירונית הומו-לסבית במרחב התל אביבי והירושלמי. <b>סוציולוגיה ישראלית, י״ב</b>(1), 7–28.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '18/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1997,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '08/11/2018'
    },
    'description': 'הגג הורוד הוא מעון להלנת חירום לצעירים וצעירות להט״בים, בגילאי 18-25 שנפתח בתל אביב במרץ 2018 על ידי משרד העבודה והרווחה, המופעל על ידי עמותת ״אותות״. המעון יכול להכיל עד 12 צעירים וצעירות והשהות בו מוגבלת לארבעה חודשים לכל היותר, לאחריהן מופנים השוהים למסגרת המשך בקהילה. המקום מציע לפונים, לפני הכל מיטה חמה, מקלחת וארוחה, אולם בהמשך הוא מספק גם סיוע במיצוי זכויות, הנגשת שירותי בריאות; טיפול ותמיכה רגשית; סיוע בתחום התעסוקה; ליווי משפטי; גישור מול המשפחה; תיווך לשירותים ולמענים קיימים והשמה במסגרות המשך.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'רווחה ובריאות'
      ],
      [
        'רווחה וקהילה',
        'להט״ב'
      ],
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ]
    ],
    'id': 'LR17',
    'is_active': true,
    'keywords': [
      'צעירות',
      'להט״בופוביה',
      'הוסטל',
      'תעסוקה',
      'דיור',
      'תמיכה נפשית',
      'סיוע משפטי',
      'מיצוי זכויות'
    ],
    'name': 'הגג הורוד',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'רווחה ובריאות',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-11-08'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.facebook.com/pg/hagag.havarod/about/?ref=page_internal'
      },
      {
        'title': 'הגג הורוד - הלנת חירום לצעירות.ים להט״ב, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pg/hagag.havarod/about/?ref=page_internal'
      },
      {
        'title': 'אלון, אמיר (2018, 18 מאי). ״הגג הורוד״: ״הרבה מגיעים לפה אחרי שיצאו או הוצאו מהארון וחטפו מכות״. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-5262152,00.html'
      },
      {
        'title': 'אותות (ללא תאריך). <b>״הגג הורוד״ שלטר צעירים וצעירות להט״ב תל אביב</b>. נדלה מתוך',
        'url': 'https://www.otot-il.org.il/%D7%A7%D7%95%D7%A8%D7%95%D7%AA-%D7%92%D7%92-2/'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2018,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '18/12/2018'
    },
    'description': 'התכנית ״הגר ומרים - ברית נשים אפריקה ישראל״ פותחה ונוהלה על ידי אביטל בנאי יחד בעזרת המיילדת דבי ארדן וד״ר סוזן וורצ\'הייזר מארגון רופאים לזכויות אדם. פעלה במסגרת שיתוף פעולה בין עמותת טופז – ליזמות וחדשנות חברתית (ע״ר 580357556) ועמותת ברית עולם – להתנדבות ולפיתוח בינלאומי. פעלה בעיקר כמרכז תמיכה באזור תל אביב לנשים בהריון ואמהות צעירות מקהילת הפליטות ומבקשות המקלט בישראל. התכנית כללה ליווי הנשים לבדיקות הריון ומעקב, ליווי הנשים על ידי מיילדות או דולות לחדר הלידה. לאחר הלידה סיפקה התכנית מדריכת הנקה ועזרה בתהליך השחרור מבית החולים, ביקורי בית, ליווי לבדיקות מעקב של התינוק, ליווי למשרד הפנים ועוד. לנשים הוענק ליווי אף במקרים של בעיות רפואיות מיוחדות כגון תינוקות נשאי איידס, בעלי מוגבלויות ועוד וכן ייעוץ בנושא תכנון משפחתי והפסקת הריון. לפי האתר של עמותת טופז, התכנית פעלה עד 2016.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'הגירה',
        'פליטות ומבקשות מקלט'
      ],
      [
        'בריאות ופריון',
        'הריון ולידה'
      ]
    ],
    'id': 'YH158',
    'is_active': false,
    'keywords': [
      'פליטות ומבקשות מקלט',
      'תמיכה נפשית',
      'טראומה',
      'הגירה',
      'סיוע לאמהות',
      'תכנון משפחה',
      'חינוך מיני',
      'מיניות בריאה',
      'העצמה'
    ],
    'name': 'הגר ומרים - ברית נשים אפריקה ישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'התארגנות שאינה עמותה',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'הגירה',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'פליטות ומבקשות מקלט',
    'primary_target_audience': 'נשים מהגרות עבודה או חסרות מעמד',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>טופז – ליזמות וחדשנות חברתית (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580357556'
      },
      {
        'title': 'ברית עולם (ללא תאריך). <b>״הגר ומרים – ברית נשים אפריקה ישראל״: מרכז תמיכה וליווי לנשים אפריקאיות</b>. נדלה מתוך',
        'url': 'https://www.plitim.co.il/media/hagar-miriam.pdf'
      },
      {
        'title': 'ברית עולם (ללא תאריך). <b>הגר ומרים</b>. נדלה מתוך',
        'url': 'http://www.britolam.org/heb/hagar-and-miriam'
      },
      {
        'title': 'גריינפלד, דן (2010, 24 פברואר). \'הגר ומרים\' - למען נשים הרות פליטות בישראל. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-3853656,00.html'
      }
    ],
    'target_audiences': [
      'נשים מהגרות עבודה או חסרות מעמד'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '18/12/2018'
    },
    'year_closed': 2016,
    'year_closed_text': '2016',
    'year_founded': 2007,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '07/10/2018'
    },
    'description': '״גשר לשלום״ או ״גשר נשים לשלום״ הוקמה בשנת 1975 בעקבות התכתבות בין רות ליס ששכלה את בנה לבין ג\'יהאן סאדאת מתוך מטרה ״לפעול לפעילות משותפת ולמען הבנה הדדית״ ו״לקדם את השלום במזה״ת״. ״גשר״ הוא כנראה אחד מארגוני השלום הראשונים שהוקמו על ידי נשים בישראל בעקבות מלחמת יום הכיפורים. בפגישת הייסוד נכחו רות ליס, רות דיין, ויולט חורי ואחרות. האגודה נרשמה כאגודה עותומנית (מספר 589613934) בשנת 1978 ופעלה לקדם מפגשים וקשרי ידידות בין נשים יהודיות וערביות. בפעילויות השתתפו בין היתר עליה שטראוס, רות רזניק, רונית לנטין, עדה אהרוני ואחרות. מאוחר יותר התמקד הארגון בפעילות תרבותית וקהילתית בעיקר בתחום הספרות והאמנות ביחד עם ארגון ״שוחרי הספרות והתרבות למען קידום השלום״. בשנת 1998 הקימו חלק מחברות הקבוצה את לנ״ה- ליגת נשים נגד הפליה שעסקה בהחתמת עצומות נגד אפליית נשים בבתי הדין הרבניים. אחרי 2002 אין אזכורים לפעילות הקבוצה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ],
      [
        'תרבות וספורט',
        'כתבי עת והוצאה לאור'
      ]
    ],
    'id': 'SA31',
    'is_active': false,
    'keywords': [
      'שלום',
      'שיתוף פעולה בינלאומי',
      'תרבות'
    ],
    'name': 'הגשר- נשים יהודיות וערביות בונות גשר לשלום',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': '(1975, 4 מאי). הוקם ארגון נשים להתקרבות יהודית-ערבית. <b>דבר</b>. נדלה מתוך',
        'url': 'http://www.jpress.nli.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=DAV%2F1975%2F05%2F04&id=Ar00628&sk=0EF043CD'
      },
      {
        'title': '(2000), הגשר: נשים יהודיות וערביות בונות גשר לשלום. <b>איפל״ק גלים: כתב עת לספרות, תרבות, אמנות וחברה, 9</b>, אנתולוגיה לתרבות השלום.'
      },
      {
        'title': 'אהרוני, עדה (2002). <b>נשים יוצרות עולם ללא מלחמות ואלימות</b>, חיפה: לנה.'
      },
      {
        'title': '<b>מכתב של רות ליס על המפגש הראשון בחיפה</b>. אותר בארכיון הפמיניסטי ב״אשה לאשה – מרכז פמיניסטי חיפה״.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/09/2019'
    },
    'year_closed': 2002,
    'year_closed_text': '2002',
    'year_founded': 1975,
    'year_registered': 1978
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/09/2019'
    },
    'description': '״הדדי - המרכז למתמודדת עם סרטן שד בע״מ״ (חל״צ) הוקם בשנת 2006 ונרשם כחברה לתועלת הציבור (513870261) בשנת 2007. המרכז, אשר הוקם על ידי רוחי (רחל-הניה) שיצקובסקי-איבקר ז״ל מספק תמיכה הדדית לנשים המתמודדות עם סרטן שד בתוך קהילה בטוחה ומכילה של נשים למען נשים. מרכז הדדי, שהוא היחיד מסוגו בארץ, מכוון להעניק תמיכה לצרכים לא רפואיים של נשים המתמודדות עם סרטן שד. המרכז מציע מידע, הרצאות, ליווי פרטני של עו״ס, פרויקט מתנדבות-מלוות, קבוצות תמיכה שונות (בעברית ובאנגלית, דמיון מודרך, תרפיה בתנועה, ביבליותרפיה, קבוצה לזוגות) , פעילויות גוף-נפש (ריקודי בטן, יוגה, שיאצו, ועוד), ליווי רוחני של רב, סדנאות איפור במהלך כימותרפיה, בנק פאות ועוד. בשנת 2018 העביר המרכז את פעילותו לבית ויצו-ירושלים ברח\' מאפו.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'SA161',
    'is_active': true,
    'keywords': [
      'חל״צ',
      'סרטן שד',
      'תמיכה נפשית'
    ],
    'name': 'הדדי - המרכז למתמודדת עם סרטן שד בע״מ (חל״צ)',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>הדדי – המרכז למתמודדת עם סרטן שד בע״מ (חל״צ): חל״צ</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/513870261'
      },
      {
        'title': 'מיכל פישמן-רואה (2019, 24 אוקטובר). אמא ירושלמית – הטור של מיכל | פרידה עצובה מרוחי ז״ל – מייסדת המרכז למתמודדת עם סרטן השד. <b>כל העיר</b>. נדלה מתוך',
        'url': 'https://www.kolhair.co.il/arena/110955/'
      },
      {
        'title': 'Hadadi - The Center For The Breast Cancer Survivor, Facebook page.',
        'url': 'https://www.facebook.com/Hadadi-The-Center-For-The-Breast-Cancer-Survivor-183734748327369/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2006,
    'year_registered': 2007
  },
  {
    'activity_kinds': [
      'פילנתרופיה',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '08/06/2018'
    },
    'description': '״הדסה״ או בשמה המלא ״הסתדרות הנשים הציוניות באמריקה״ נוסדה בשנת 1912 בניו יורק על ידי קבוצת נשים בראשות הנרייטה סאלד. מטרת הארגון, שנקרא על שמה של אסתר המלכה, נקבעה כ״עידוד מוסדות ומפעלים יהודיים בא״י וחיזוק האידיאלים היהודיים״. ארגון הדסה הפך במהרה לארגון הנשים היהודי הגדול בארצות הברית. הוא היה אחראי להקמתם של שני בתי חולים בירושלים, לבניית בית הספר לרפואה באוניברסיטה העברית בירושלים ולהקמתו של בית הספר לאחיות. במרוצת השנים התמקד הארגון בפילנתרופיה ותמך בעיקר בתחומי הרפואה, החינוך וקליטת העלייה בישראל. הארגון היה שותף גם למאמצים לקידום זכויות נשים. בשנת 1983 נוסדה עמותת ״הדסה ישראל״ (ע״ר 580057966) למען ״קירוב נשים לפעולות הדסה בישראל. עידוד תמיכה ועזרה להסתדרות מדיצינית הדסה״. העמותה פועלת כקרן אשר מטפלת בהעברת תרומות ותמיכות כספיות מטעם ארגון נשות הדסה העולמי לפעילויות בישראל ובעיקר למימון שירותים רפואיים (בית חולים הדסה) השכלה גבוהה (מכללת הדסה) ופנימיות לנוער (כפר הנוער הדסה נעורים). מאז 1998, מפעילה הדסה את ״קרן הדסה״ אשר תומכת בהעצמה של נשים ונערות בישראל ובארה״ב.',
    'description_ar': null,
    'display_organization_kind': 'בינלאומי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ],
      [
        'חינוך',
        'כללי'
      ],
      [
        'הגירה',
        'קליטת עלייה'
      ]
    ],
    'id': 'SW18',
    'is_active': true,
    'keywords': [
      'בית חולים',
      'נערות',
      'פילנתרופיה',
      'קליטת עלייה',
      'בריאות'
    ],
    'name': 'הסתדרות הנשים הציוניות באמריקה (The Women\'s Zionist Organization of America)',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'הדסה ישראל',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'בינלאומי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'פילנתרופיה',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'בינלאומי',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-08-06'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.hadassah-israel.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>הדסה – ישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580057966'
      },
      {
        'title': 'הדסה אינטרנשיונל (אתר). הדסה אינטרנשיונל ישראל. נדלה מתוך',
        'url': 'http://hadassahinternational.org/where-we-are/hadassah-international-israel/'
      },
      {
        'title': 'Hadassah, the Women’s Zionist Organization of America, Inc (website). Retrieved from',
        'url': 'http://www.hadassah.org.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים עולות מחבר העמים',
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '08/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': 1983
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '23/10/2018'
    },
    'description': 'הוועד למלחמה באיידס הוקם ב - 1985 על ידי קבוצת פעילים חברתיים ונרשם כעמותה בשנת 1987 (ע״ר 580104545) שמטרותיה: ״הסברה בארץ בכלל ובקרב קבוצות הסיכון בפרט, למניעת המחלה. מתן סיוע נפשי וסיעודי לחולים, בני משפחותיהם ולמי שנחשפו למחלה״. הוא פועל בשלושה מישורים עיקריים - תמיכה וסיוע לנשאים, חולי איידס וקרוביהם; הסברה וחינוך ביחס למחלת האיידס ומניעתה, כולל קמפיינים אינטרנטיים ותקשורתיים, סדנאות לבני נוער, וקו יעוץ טלפוני; פעילות פוליטית ותקשורתית שנועדה לאפשר חיים בכבוד לנשאים וחולים. בוועד כ - 150 מתנדבים וצוות מצומצם של עובדים ועובדות בשכר, כמחציתם נשים. במסגרת הוועד פועלת גם קבוצת ״בלה דואגת״ שהוקמה ב - 1994 ופונה ישירות לקהילה הגאה. הוועד מפעיל גם קבוצות יעודיות לנשים נשאיות, כמו גם קבוצות הפונות לאוכלוסיה האתיופיות ולפליטים. בנוסף לעיסוק ספציפי במחלת האיידס, הסדנאות הפונות לבני נוער, עוסקות גם בקידום מיניות בריאה, שיוויון מגדרי ושבירת סטריאוטיפים מגדריים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות ומגדר'
      ],
      [
        'להט״ב',
        'רווחה ובריאות'
      ],
      [
        'חינוך',
        'חינוך מיני/מיניות בריאה'
      ]
    ],
    'id': 'LR8',
    'is_active': true,
    'keywords': [
      'מחלות מין',
      'מיניות',
      'קבוצות תמיכה',
      'שיוויון מגדרי',
      'אתיופיות',
      'פליטות',
      'תמיכה נפשית',
      'הומואים',
      'ביסקסואליות',
      'מיניות בריאה',
      'צעירות'
    ],
    'name': 'הוועד למלחמה באיידס',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': 'הועד למלחמה באיידס- הסברה וסיוע לחולים',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות ומגדר',
    'primary_target_audience': 'גברים',
    'retrieved': {
      'type{date}': '2018-10-23'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://aidsisrael.org.il'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>הוועד למלחמה באיידס (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580104 545'
      },
      {
        'title': 'הוועד למלחמה באיידס, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/IsraelAIDStaskforce/'
      }
    ],
    'target_audiences': [
      'גברים',
      'נשים (כללי)',
      'נשים מהגרות עבודה או חסרות מעמד',
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1985,
    'year_registered': 1987
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '18/09/2018'
    },
    'description': '״הוועדה הבין-משרדית לטיפול בבעיית האלימות במשפחה״ הוקמה בפברואר 1998 מתוקף החלטת ממשלה 3291 במטרה לבחון את התיאום, הנהלים, המדיניות, שיתוף הפעולה וההסדרים הבין-משרדיים בעניין ההגנה, הטיפול, המניעה והענישה בתחום האלימות במשפחה. בין תחומי העיסוק של הועדה נכללו גם ״ביסוס הסדרים מיוחדים לחיזוק האיתור והדיווח על אלימות במשפחה ולצמצום סיכונים הנובעים מאחזקת נשק צבאי או אזרחי״. יו״ר הועדה היה יגאל בן-שלום, מנכ״ל משרד העבודה והרווחה וחבריה כללו נציגים ממשרדי ממשלה שונים: משרד ראש הממשלה, משרד המשפטים, משרד הביטחון, המשרד לביטחון פנים, משרד הבריאות, משרד החינוך ועוד. במסגרת עבודת הועדה כונסו 8 ועדות משנה וביניהן צוות בכיר לטיפול בנושא ״נשק שבידי בן משפחה אלים״ שבראשו עמדה גב\' נילי ארד. הוועדה הגישה דוח ראשון בנובמבר 1998 שכלל מידע רב אודות תופעת האלימות במשפחה בישראל והמנגנונים הקיימים, המלצות הועדה עסקו בצורך לבסס שיתוף פעולה נרחב בתחום, לתקן חקיקה ולתקצב שירותים חדשניים. באפריל 1999 אימצה הממשלה את המלצות הועדה והחליטה על יישומן באופן הדרגתי. למרות שהועדה היתה אמורה להמשיך ולתפקד כצוות בכיר קבוע לשם מעקב ועיצוב מדיניות בנושא, בפועל היא חדלה מלהתקיים והמלצותיה ייושמו באופן חלקי. בפועל, חבריה מתכנסים כ״וועדה הבין-משרדית לבדיקת מקרי רצח נשים בידי בני זוגן״, לאחר כל מקרה של רצח אישה בידי בן זוגה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'YH86',
    'is_active': false,
    'keywords': [
      'מרכזים למניעה וטיפול באלימות במשפחה',
      'משטרה',
      'מקלט',
      'נשק',
      'חקיקה',
      'נתונים',
      'ועדה'
    ],
    'name': 'הוועדה הבין-משרדית לטיפול בבעיית ״האלימות במשפחה״',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הועדה הבין-משרדית לטיפול בבעיית ״האלימות במשפחה״ (1998). <b>דו״ח מספר 1 בנושא ״אלימות נגד נשים במשפחה</b>. בראשות יגאל בן שלום (יו״ר הועדה). נדלה מתוך',
        'url': 'http://ccfisrael.org/wp-content/uploads/2011/05/%D7%94%D7%95%D7%A2%D7%93%D7%94_%D7%94%D7%91%D7%99%D7%9F_%D7%9E%D7%A9%D7%A8%D7%93%D7%99%D7%AA_-_%D7%93%D7%95%D7%97_%D7%91%D7%9F_%D7%A9%D7%9C%D7%95%D7%9D_%D7%91%D7%A0%D7%95%D7%A9%D7%90_%D7%90%D7%9C%D7%99%D7%9E%D7%95%D7%AA_%D7%A0%D7%92%D7%93_%D7%A0%D7%A9%D7%99%D7%9D_%D7%91%D7%9E%D7%A9%D7%A4%D7%97%D7%94.pdf'
      },
      {
        'title': 'מבקר המדינה (2012). פעילות רשויות מקומיות למניעת אלימות בין בני זוג ולטיפול בנפגעיה. יוסף חיים שפירא (מבקר המדינה), <b>דוחות על הביקורת בשלטון המקומי לשנים 2011–2012</b> (עמ\' 19–66). ירושלים. נדלה מתוך אתר מבקר המדינה ונציב תלונות הציבור',
        'url': 'http://www.mevaker.gov.il/he/Reports/Pages/111.aspx?AspxAutoDetectCookieSupport=1'
      },
      {
        'title': 'Convention on the Elimination of All Forms ofConvention on the elimination of all forms of discrimination against women. Distr.: General, 16 November, 2001. CEDAW / C / ISR / 3. Retrieved from',
        'url': 'https://unispal.un.org/DPA/DPR/unispal.nsf/0/8E1A118276E4B77E8525709800654D2C'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/02/2019'
    },
    'year_closed': 1998,
    'year_closed_text': '1998',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '19/02/2019'
    },
    'description': 'בנובמבר 1998 פרסמה הוועדה הבין-משרדית לטיפול באלימות במשפחה דוח והמלצות שאומצו על ידי הממשלה באפריל 1999. הממשלה קבעה שהוועדה הבינמשרדית תמשיך את תפקידה כצוות קבוע ותלווה את יישום ההמלצות. דו״ח מבקר המדינה ב-2001 הצביע על כך שהוועדה לא המשיכה לפעול וכן הצביע המבקר על היעדרו של מעקב קבוע לליבון מקרי רצח של נשים לשם בחינת טיב המעורבות הטיפולית של לשכת הרווחה במשפחה. בעקבות הדוח קיבלה ועדת השרים לתיאום, מינהל וביקורת המדינה את החלטה תמ/42 ,שבמאי 2002 קיבלה תוקף של החלטת ממשלה. בהחלטה נקבע, בין היתר: ״בדיקת כל מקרה רצח של אישה בידי בן זוגה תהיה באחריות מנכ״ל משרד העבודה והרווחה, בשיתוף עם המשרד לביטחון הפנים, משטרת ישראל, משרד החינוך, משרד הבריאות והרשות המקומית אשר בתחומה היה האירוע, במטרה להפיק לקחים לגבי טיפולה של לשכת הרווחה במשפחה, טרם הרצח״. בפועל, הוועדה החלה את עבודתה בשנת 2004. הוועדה מתכנסת לאחר כל רצח של אישה בידי בן זוגה אולם לעיתים היא דנה בכמה מקרים יחד. עו״ס איילה מאיר, מנהלת השירות לרווחת הפרט והמשפחה במשרד הרווחה, היא העומדת בראש הוועדה בשנים האחרונות. לוועדה אין מעמד סטטוטורי, אין לה סמכויות מוגדרות וברורות או נוהל עבודה כתוב ומוגדר.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YH189',
    'is_active': true,
    'keywords': [
      'רצח נשים',
      'ועדה',
      'ביטחון אישי',
      'משטרה'
    ],
    'name': 'הוועדה הבין-משרדית לבדיקת מקרי רצח של נשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'הוועדה הבינמשרדית לבדיקת מקרי רצח של נשים',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'בניטה, רינת (2017). <b>רצח וניסיונות לרצח של נשים בדגש על רקע של אלימות במשפחה: מוגש לוועדה לקידום מעמד האישה ולשוויון מגדרי</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/fc918cb2-9090-e711-80d9-00155d0a6d26/2_fc918cb2-9090-e711-80d9-00155d0a6d26_11_10325.pdf'
      },
      {
        'title': 'מבקר המדינה (2002). הטיפול בתופעת האלימות בין בני זוג. אליעזר גולדברג (מבקר המדינה), <b>דוח שנתי 52ב: לשנת 2001 ולחשבונות שנת הכספים 2000</b> (עמ\' 771–794). נדלה מתוך',
        'url': 'https://www.mevaker.gov.il/he/Reports/Pages/590.aspx'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/02/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '20/09/2018'
    },
    'description': 'הרקע להקמת הוועדה היה אירוע של רצח עולה יוצאת אתיופיה על ידי בן זוגה בעיר ראשון לציון, אשר בעקבותיו התקיים דיון בוועדת העלייה והקליטה בכנסת בינואר 2012. ועדת העלייה פנתה למנכ״לי המשרדים וביקשה להכין ״תוכנית מקיפה למיגור תופעת האלימות והרצח בקרב העדה, שתכלול את משרדי הרווחה, ביטחון הפנים, האוצר, השלטון המקומי״. בפברואר 2012 פנה מנכ״ל המשרד לקליטת העלייה למנכ״לי המשרדים שלעיל ולשני משרדים נוספים- משרד הבריאות ומשרד החינוך וביקשם למנות נציג מטעמם לוועדה. משרד האוצר לא מצא מקום ליטול חלק בוועדה. בראשות הוועדה עמדה גב\' שרה כהן- מנהלת שירות הרווחה במשרד לקליטת העלייה. דיוני הועדה נמשכו כ-8 חודשים וסוכמו בדוח מפורט. הדוח כלל נתונים והמלצות שונות: להרחיב את הפעילות למניעת אלימות בקהילה האתיופית, להגדיל את כוח האדם המטפל בבעיות הקהילה, לטפל בבעיות של גברים אלימים ולהרחיב את מערך ההכשרה המכוון לכשירות תרבותית של מערך הרווחה. התקציב הכולל שהוערך ליישום ההמלצות הוערך בכ-30 מיליון ₪.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'הגירה',
        'קליטת עלייה'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'YH88',
    'is_active': false,
    'keywords': [
      'רצח נשים',
      'דיור',
      'גברים אלימים'
    ],
    'name': 'הוועדה הבין-משרדית לנושא ההתמודדות עם תופעת הרצח והאלימות כלפי נשים יוצאות אתיופיה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'הוועדה הבינמשרדית לנושא ההתמודדות עם תופעת הרצח והאלימות כלפי נשים יוצאות אתיופיה',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים יוצאות אתיופיה',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד הרווחה והשירותים החברתיים ומשרד העליה והקליטה (2013). <b>דו״ח הוועדה הבינמשרדית לנושא ההתמודדות עם תופעת הרצח והאלימות כלפי נשים יוצאות אתיופיה.</b> ירושלים.'
      }
    ],
    'target_audiences': [
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '20/09/2018'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 2012,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '09/02/2019'
    },
    'description': 'הוועדה המשותפת לעניין שינוי הטיפול במקרי אונס פעלה בכנסת התשיעית בין ה-02/08/1977 לבין ה-13/06/1978 כתת-ועדה של ועדת חוקה וועדת הפנים. יושבת ראש הועדה היתה חה״כ שולמית אלוני ופעילות הוועדה כללה פגישות עם בכירים במערכת המשפט, מומחים בדין הפלילי, וניתוח של פסקי דין רבים בתחום האונס. בסיום עבודתה הגישה הועדה דו״ח והמלצות לשינויי חקיקה. הממצא העיקרי שעלה מהדו״ח היה שבמרבית תיקי האונס שהובאו בפני בתי המשפט נטו השופטים להקל בעונשם של התוקפים, תוך התמקדות מיותרת בסוגיות שנוגעות לעיסוקה, אופייה, אורח חייה ומעשיה של הקורבן. בין המלצות הועדה נכללה ההמלצה לחוקק עונשי מינימום על עבירות אונס, להחמיר את הענישה על עבירות מין, לאסור חקירת הקורבנות על עברן המיני ועוד. בשנים 1982-1991 אומצו המלצות הועדה על ידי שורה של תיקונים בחוק העונשין שהביאו להחמרה בענישה על עבירות אונס בישראל.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'SA124',
    'is_active': false,
    'keywords': [
      'אונס',
      'חקיקה',
      'ועדה',
      'כנסת'
    ],
    'name': 'הוועדה המשותפת לעניין שינוי הטיפול במקרי אונס',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הכנסת, חברי הכנסת לדורותיהם: שולמית אלוני. נדלה מתוך אתר הכנסת',
        'url': 'https://main.knesset.gov.il/mk/Pages/MKPersonalPrint.aspx?MKID=132'
      },
      {
        'title': 'מרין, יובל (2011). מבט פמיניסטי על דיני הראיות: ה״אמת״ הממוגדרת והשתקת הקול השונה, <b>המשפט, טז</b>(1–2), 97–129. נדלה מתוך',
        'url': 'http://hamishpat-arch.colman.ac.il/heb/Issues/vol16_1/article,764/'
      },
      {
        'title': 'Ajzenstadt, Mimi & Steinberg, Odeda (2001). Never mind the law: Legal discourse and rape reform in Israel. <b>Affilia 16</b>(3), 337-359.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '02/09/2019'
    },
    'year_closed': 1978,
    'year_closed_text': '1978',
    'year_founded': 1977,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '06/04/2018'
    },
    'description': '״הוועדה הציבורית לקידום נשים בשלטון המקומי״ הוקמה באפריל 2016 ברוח החלטת הממשלה מספר 481 מיום 30.06.2013 שבה אושר דו״ח הועדה לשיפור ניהול ההון האנושי בשירות המדינה ומעמדן של הנשים בשירות המדינה (ועדת שטאובר). בכתב המינוי של ועדה צויין כי מטרת הועדה היא ״לחולל שינוי ולהביא לקידום מעמדן של נשים בשלטון המקומי [...] הוועדה תמליץ על דרכים לקידום נשים הן בדרג הנבחר והן בדרגים המקצועיים, הן ברשויות המקומיות והן בתאגידים העירוניים״. בראש הוועדה עמדה גב\' ליזי דלריצ\'ה, ראש המועצה המקומית גני תקוה וחבריה כללו את מנהלת הרשות לקידום מעמד האשה ונציגים מהמרכז לשלטון מקומי; המשרד לפריפריה, הנגב והגליל; משרד הפנים; משרד הכלכלה; משרד האוצר; ונציבות שירות המדינה. \nהוועדה הציבורית בחנה את ייצוגן של נשים ברשויות המקומיות בין השנים 2003-2013. על פי דו״ח הועדה שהוגש לשר הפנים אריה מכלוף דרעי במרס 2018, רק ב-2.5% מהרשויות בישראל מכהנת ראשת עיר. בבחינת אחוזי הייצוג במועצות המקומיות נמצא כי ב-2003 היוו נשים רק 9% נשים מכלל החברים במועצות, זאת אל מול 13% בשנת 2013. בבדיקה זהה שכללה 113 רשויות, ללא רשויות חרדיות וערביות, היו אחוזי הייצוג גבוהים יותר, אך עדיין בלתי שוויוניים: 13% נשים במועצות בשנת 2003 , אל מול 21% בשנת 2013. מרבית העלייה באחוזי הייצוג ברשויות אלה התרחשה במחצית השנייה של העשור (2008-2013). על פי מסקנות הוועדה, על אף שניתן להבחין במגמת עלייה בייצוג הנשים במועצות, מדובר בעלייה מתונה מאוד שעדיין לא מביאה לייצוג שוויוני. הועדה גם עסקה בהגדרות התפקיד של היועצות לקידום מעמד האשה ברשויות המקומיות והמליצה להכין קורס הכשרה מחייב לתפקיד היועצות לקידום מעמד האישה, תוך מתן קדימות לרשויות במעמד סוציו-אקונומי נמוך.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ],
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ]
    ],
    'id': 'SA169',
    'is_active': false,
    'keywords': [
      'ועדה',
      'חקיקה',
      'יועצות לקידום מעמד האשה',
      'ייצוג הולם'
    ],
    'name': 'הוועדה הציבורית לקידום נשים בשלטון המקומי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי',
      'מוניציפלי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'ועדות פרלמנטריות וממשלתיות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-11-12'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.gov.il/he/Departments/General/committee-for-advancement'
      },
      {
        'title': 'אליהו, אילה (2019). <b>היועצות לקידום מעמד האישה ברשויות המקומיות</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/5f1f2c38-ab11-e911-80e1-00155d0a98a9/2_5f1f2c38-ab11-e911-80e1-00155d0a98a9_11_10876.pdf'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2017, 20 נובמבר). <b>פרוטוקול מס\' 197: מסקנות הוועדה הציבורית לקידום נשים בשלטון המקומי</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/Activity/committees/Women/Pages/CommitteeProtocols.aspx?ItemID=2016485'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '12/11/2019'
    },
    'year_closed': 2018,
    'year_closed_text': '2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '20/09/2018'
    },
    'description': 'הוועדה הוקמה בעקבות ״מקרים קשים של אלימות במשפחה״ שהועלו לדיון בנוכחות השר לביטחון פנים ושר הרווחה ב-10.9.2014. בדיון הוחלט על הקמת ועדה בין-משרדית בראשות המשנה למנכ״ל המשרד לביטחון הפנים, מר אליעזר רוזנבאום. מטרת הוועדה היתה לפעול ל״טיוב הטיפול המערכתי בהתמודדות עם תופעת האלימות במשפחה״. תפקידי הוועדה כללו: א) גיבוש תמונת מצב עדכנית ומתמשכת בנוגע לתופעת האלימות במשפחה (מאפייני התופעה, היקף התופעה, מענים וחסמים קיימים);  ב) גיבוש מדיניות ודרכי פעולה מומלצות וסנכרון מאמצים אופרטיביים בין משרדי הממשלה השונים והארגונים הפועלים בתחום. הוועדה כללה נציגים מכלל המשרדים העוסקים בצמצום תופעת האלימות במשפחה: משרד הרווחה והשירותים החברתיים, משרד המשפטים, משרד הבריאות, משרד העלייה והקליטה, משרד החינוך, משרד ראש הממשלה והמשרד לביטחון הפנים. כמו כן הופיעו לפני הוועדה נציגי ממשלה שאינם חברים בוועדה וארגונים חוץ ממשלתיים שהציגו את עשייתם בתחום הטיפול באלימות במשפחה. המלצות הוועדה שהוגשו ביוני 2016 עסקו בצורך לגבש מדיניות לאומית לטיפול בנושא על ידי: אימוץ הגדרה ממשלתית אחידה לתופעת האלימות במשפחה על כל גווניה; הסרת חסמים ארגוניים וחוקיים המקשים או מונעים העברת מידע על הפוגעים והנפגעים בין הגורמים המטפלים הרלוונטיים למקרה; יצירת מנגנונים וכלים לשיפור שיתוף הפעולה על הרצף הטיפולי; בניית כלים להערכת מסוכנות של פוגעים; הרחבת סל הטיפול והשיקום לנשים, גברים וקשישים נפגעי אלימות במשפחה ועוד. ביוני 2017 ועדת השרים למאבק באלימות בראשות השר ארדן אישרה את המלצות הצוות הבין-משרדי ליישום התכנית הלאומית למאבק באלימות במשפחה. נכון לספטמבר 2018 לא אושרו התקציבים הנדרשים ליישום התכנית.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YH87',
    'is_active': false,
    'keywords': [
      'חקיקה',
      'ועדה',
      'משטרה',
      'נתונים'
    ],
    'name': 'הוועדה הבין-משרדית לטיפול בבעיית האלימות במשפחה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'הוועדה לטיפול בבעיית האלימות במשפחה',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'המשרד לביטחון הפנים (2017, 20 יוני). אושרה התוכנית הבין-משרדית למאבק באלימות במשפחה. נדלה מתוך',
        'url': 'https://www.gov.il/he/Departments/news/plan_prov_violence_approved_200617'
      },
      {
        'title': 'מנגן-אלמליח, כנרת ורוזנבאום, אליעזר (עורכים) (2016). <b>דו״ח הוועדה לטיפול בתופעת האלימות במשפחה</b>. ירושלים: המשרד לביטחון הפנים.',
        'url': 'https://www.gov.il/BlobFolder/reports/domestic_violence_committee_report_2016/he/domestic_violence_response_report_2016_0.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '20/09/2018'
    },
    'year_closed': 2016,
    'year_closed_text': '2016',
    'year_founded': 2014,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'שירותים משפטיים',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '30/12/2018'
    },
    'description': '״הוועדה לקידום עורכות הדין״ פועלת כוועדה מייעצת לועד של לשכת עורכי הדין. היא הוקמה בשנת 1996 על ידי עו״ד רבקה מלר-אולשיצקי במטרה ״לקדם ולהרחיב את מעגלי ההשפעה של עורכות הדין, לעודדן לקחת חלק בפעילות פוליטית – ארגונית בלשכה (ייצוג הולם בלשכה), להעלות מודעות וכן לפתור בעיות הנוגעות ספציפית לעורכות הדין כגון, העדפתם של לקוחות לשכור שירותי עורך דין גבר, אי מינויין לתפקידי כונסות /בוררות״ או בעיות הנובעות משילוב בין משפחה לעבודה. וועדות נוספות שהוקמו לצדה היו ״הפורום לשופטות ועורכות דין״ ו״הוועדה למעמד האשה״. הועדות עסקו במשך השנים במגוון נושאים וביניהם: ניטור מספרן של עורכות דין ושופטות במערכת המשפט, בחינת זכויות של עורכות דין אמהות (עצמאיות ושכירות), דיון בהצעות חוק שונות וכתיבת ניירות עמדה ועריכת ימי עיון בנושאים שעל סדר היום הציבורי.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ]
    ],
    'id': 'SA108',
    'is_active': true,
    'keywords': [
      'אפלייה',
      'חקיקה',
      'משפט',
      'קידום נשים'
    ],
    'name': 'הוועדה למעמד האשה וקידום עורכת הדין',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'שירותים משפטיים',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'התאגדויות ורשתות מקצועיות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-12-30'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.israelbar.org.il/vaada_inner.asp?pgId=5191&catId=8&commityID=0'
      },
      {
        'title': 'ארז, ליאור (2004). <b>אפליית עורכות דין בישראל - האמנם?</b> (עבודה במסגרת הסמינריון ״מקצוע עריכת הדין: בין תיאוריה לפרקטיקה״, בהנחיית פרופ’ רונן שמיר). בית הספר למשפטים, המכללה למנהל. נדלה מתוך',
        'url': 'http://www.israelbar.org.il/article_inner.asp?catID=8&pgID=8978'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '30/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1996,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'סנגור, מעקב ושינוי מדיניות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': 'ה״ועדה לקידום מעמד האישה״, הוקמה בכנסת ה-13 על פי החלטת הכנסת מיום 16 בנובמבר 1992 במטרה ליישם את אחת ההמלצות המרכזיות שהופיעו בדו״ח הוועדה הממלכתית לקידום מעמד האישה (1978). יושבת הראש הראשונה של הוועדה הייתה חברת הכנסת יעל דיין וכל יושבי ראש הוועדה מאז הקמתה היו נשים , למעט גדעון סער. תחום העיסוק העיקרי של הוועדה הוא קידום מעמד האשה לקראת שוויון בייצוג; בחינוך ובמעמד האישי, וכן למניעת אפליה בשל מין או נטייה מינית בכל התחומים; להקטנת פערים בכלכלה ובשוק העבודה ולמאבק באלימות כלפי נשים. בדצמבר 2013 שונה שם הוועדה לשמה הנוכחי, ביוזמת יושבת ראש הוועדה, עליזה לביא.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': '1YB6',
    'is_active': true,
    'keywords': [
      'אלימות',
      'הדרת נשים',
      'ועדה',
      'זנות',
      'חד הוריות',
      'חקיקה',
      'חרדיות',
      'כנסת',
      'מעמד אישי',
      'סחר בנשים',
      'ערביות',
      'צה״ל',
      'קידום נשים',
      'קליטת עלייה',
      'רווחה',
      'רצח נשים',
      'שוויון',
      'תעסוקה',
      'תקשורת',
      'תרבות'
    ],
    'name': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי',
    'name_ar': 'لجنة النهوض بمكانة المرأة',
    'name_change_year': 2013,
    'name_common': null,
    'name_past': 'הוועדה לקידום מעמד האישה',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://main.knesset.gov.il/Activity/committees/Women/Pages/default.aspx'
      },
      {
        'title': 'בן-אריה, שביט (2012, 18 יולי). הוועדה לקידום מעמד האישה: עבר, הווה ועתיד. מאמר דעה, <b>המכון הישראלי לדמוקרטיה</b>. נדלה מתוך',
        'url': 'https://www.idi.org.il/articles/9570'
      },
      {
        'title': 'ברוך, חזקי (2013, 16 דצמבר). מתחדשת: שם חדש לועדה של ח״כ לביא. <b>ערוץ 7</b>. נדלה מתוך',
        'url': 'https://www.inn.co.il/News/News.aspx/267128'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '14/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1992,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '24/10/2018'
    },
    'description': 'ההוסטל לאסירות משוחררות הוא בית טיפולי עבור נשים שהן אסירות משוחררות אשר פועל כמסגרת חצי פתוחה ומיועדת ל-10 דיירות. הנשים מתגוררות בהוסטל במשך כשנה, ובהמשך נבנית להן תכנית המשך בהתאם לצרכיהן. טרם השתלבותן של דיירות ההוסטל בתעסוקה, הן משתתפות בתכנית מרכז היום. דיירות ההוסטל זכאיות לדיור, טיפול וליווי אינטנסיביים בכל תחומי החיים, טיפול בפוסט טראומות המורכבות ובמצוקות המתמשכות אשר הביאו לעבריינות וכליאה. ההוסטל הוקם בהמלצותיה של ועדה שמונתה ב-1985 על ידי מנכ״ל הרשות לשיקום האסיר, ל״בחינה והכנת תכנית הקמה להוסטל כמסגרת מעבר בקהילה לאסירות משוחררות״. יו״ר הוועדה, יוספה שטיינר, ניהלה את שירותי הטיפול בנשים ונערות במשרד הרווחה ורכזת הוועדה היתה ציפי נחשון, ששימשה יועצת הרשות לשיקום האסיר בכלא נווה תרצה. הוועדה הגישה המלצותיה ב-1987. את ההוסטל הקימה וניהלה ב-1989, ענת גור. החל מ-2015 פועל ההוסטל במסגרת ״המרכז ההוליסטי לשיקום אסירות משוחררות״.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'YH116',
    'is_active': true,
    'keywords': [
      'אסירות',
      'שיקום',
      'תמיכה נפשית',
      'אמהות',
      'העצמה',
      'חינוך',
      'אלימות',
      'דיור'
    ],
    'name': 'הוסטל לאסירות משוחררות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'התמכרויות ושיקום',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.pra.co.il/180409/%D7%A9%D7%99%D7%A7%D7%95%D7%9D-%D7%A0%D7%A9%D7%99%D7%9D'
      },
      {
        'title': 'הרשות לשיקום האסיר (2015, אפריל). <b>סיכום שנות עבודה 2013–2014</b>. נדלה מתוך',
        'url': 'http://sfile-pull.f-static.com/image/users/180409/ftp/my_files/%D7%97%D7%95%D7%91%D7%A8%D7%AA%20%D7%A1%D7%99%D7%9B%D7%95%D7%9D%20%D7%A9%D7%A0%D7%95%D7%AA%20%D7%A2%D7%91%D7%95%D7%93%D7%94%202013-2014.pdf?id=22866309'
      },
      {
        'title': 'משרד העבודה, הרווחה והשירותים החברתיים, שירותי טיפול בנשים ונערות (1987, 16 יולי). <b>הוועדה להכנת הוסטל לאסירה המשוחררת</b>. אותר בארכיון המדינה, תיק מס\' ISA-molsa-WelfareWomen-0003rpp.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '28/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1989,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '13/07/2019'
    },
    'description': '‏״הוסטל לנערות וצעירות – חמלה״ הינו הוסטל שיקומי בירושלים לנערות, בעיקר חרדיות ודתיות. ‏שורשי ההוסטל הם בשנות ה-90 בפעילותה האישית של הרבנית רחל ברנס שהחלה לקלוט, ואולי לחפש, ‏נערות יהודיות שיצאו ממערכות יחסים עם גברים ערביים. סביב שנת 2002, עמותת ״חמלה סיוע ‏לנזקקים״ לקחה חסות על המפעל הזה והחל להפעיל את ההוסטל תחת ניהולה של רחל ברנס. מנכ״ל ‏העמותה הוא אליקים ניימן, פעיל בארגונים כגון להב״ה, כפי שגם חברי עמותה נוספים: אברהם ‏קרויזר, בנצי גופשטיין, ענת גופשטיין, ועוד. כמו כן, היו התבטאויות מפורשות של העמותה ושל הבית ‏החם עד שנת 2014 אודות מטרתם להציל נערות יהודיות מזוגיות עם ערבים. עם זאת, לפי עדותו של ‏שר הרווחה בשנים 2013-2014 מאיר כהן שביקר בבית החם על מנת לבחון את אותן הטענות נגד ‏אידיאולוגיית העמותה, הוא פגש רק נערה אחת ‏שחולצה מזוגיות עם איש ערבי וגם היא טענה שהקשר ‏ושהותה במזרח ירושלים היו נגד רצונה; וכל ‏שאר הנערות היו נערות במצוקה ״רגילות״ מבתים דתיים ‏וחרדיים. בשנת 2016 משרד הרווחה הכפיל את התמיכה שלו בבית החם ל-1.3 מיליון ₪ המהווה כ-‏‏50% מתקציב הבית.‏',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'SW50',
    'is_active': true,
    'keywords': [
      'צעירות במצבי סיכון',
      'נערות במצוקה',
      'אלימות',
      'הוסטל',
      'דיור',
      'העצמה כלכלית',
      'תעסוקה',
      'דת'
    ],
    'name': 'הוסטל לנערות וצעירות – חמלה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'צעירות במצבי סיכון',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b> חמלה סיוע לנזקקים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580350411'
      },
      {
        'title': 'הבית החם להצלת בנות ישראל (2012, ספטמבר). <b>שהחזרת בי נשמתי בחמלה</b>. נדלה מתוך',
        'url': 'https://cdn.the7eye.org.il/uploads/2014/04/hemla.pdf'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2016, 14 נובמבר). <b>פרוטוקול מס\' 116: תמיכת משרד הרווחה בעמותת חמלה והמקלט לצעירות בהפעלתה</b>. נדלה מתוך‏',
        'url': 'https://oknesset.org/meetings/2/0/2008479.html'
      },
      {
        'title': 'משרד העבודה, הרווחה והשירותים החברתיים, ‏מינהל סיוע לבתי המשפט ותקון (2017). <b>‏אוגדן תכניות השירות לנוער, צעירות וצעירים</b>. נדלה מתוך',
        'url': 'http://www.lsf.org.il/data/files/3377_f0935cd7d576df1c9218c5e8e032b42d.pdf'
      },
      {
        'title': 'קשתי, אורי (2016, 4 נובמבר). משרד הרווחה מגדיל את תרומתו למאבק בהתבוללות. <b>הארץ</b>. נדלה מתוך',
        'url': 'https://www.haaretz.co.il/news/education/.premium-1.3112310'
      },
      {
        'title': '(2009, ספטמבר). שהכל נהיה בדברו. <b>ארץ ישראל שלנו</b> (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים חרדיות',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '13/07/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2002,
    'year_registered': 1999
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '11/07/2019'
    },
    'description': '‏״מורשת אברהם״ נוסד כעמותה בשנת 2011 לזכר חה״כ לשעבר מטעם דגל תורה וסיעת יהדות התורה, ‏הרב אברהם רביץ, שכיהן בין היתר כסגן שרת החינוך (לימור לבנת) בשנים 2001-2003 וסגן שר הרווחה ‏והשרותים החברתיים בשנים 2005-2006 (נכנס לתפקיד כמה חודשים לאחר שזבולון אורלב סיים את ‏כהונתו כשר). הוא נפטר ב-2009.‏ ב-2016 הופץ מסמך התקשרות לשיתוף פעולה ללא מכרז בין משרד הרווחה לבין העמותה להפעלת הוסטל שיקומי ‏ודירת מעבר לנערות חרדיות בירושלים עובר 13 נערות. ההתקשרות היא על סך 369,948 ₪ מכל ‏צד (המשרד והעמותה, סך תקציב של 739,896 ₪). ״המסגרת תעניק: קורת גג, ארוחות, ליווי ותיווך ‏לשירותים נוספים, גישור על הפערים עם המשפחה והחברה החרדית. הצעירות במסגרת יוצאות לעבודה ‏או ללימודים בשעות הבוקר ובשעות אחר הצהריים הן נמצאות במסגרת. העמותה נותנת קליטה וטיפול ‏פיזי ונפשי, חוגי העשרה, השלמה השכלה לצעירות חרדיות מתבגרות המצויות במצוקה קשה, בסיכון ‏ובסכנה.״ ומצויין שם גם ש״העמותה בעלת ניסיון וידע... בסיוע ובליווי במציאת בן זוג הולם עד ‏החופה״.‏ ב-2017 ״אוגדן תכניות השירות לנוער, צעירות וצעירים״ של משרד הרווחה מעיד על הכפלה בתקציב ‏העמותה (1,232,976 ₪) ובכמות הנערות (28) הנתמכות על ידה. וב-2018 ״ידידות טורונט״ מעידות על ‏תמיכתם בעמותה ועל הפעלת 3 דירות מעבר והוסטל אך עדיין 28 נערות.‏ בדוח המילולי לשנת 2011 של העמותה באתר בגיידסאר (אצל רשם העמותות) יש פירוט נרחב על עשיית הארגון, כולל פילוח סטטיסטי של רקע הנערות ‏המטופלות, הצרכים והקשיים שלהן, ועוד. ‏',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'SW49',
    'is_active': true,
    'keywords': [
      'צעירות במצבי סיכון',
      'נערות במצוקה',
      'אלימות',
      'הוסטל',
      'דיור',
      'העצמה כלכלית',
      'תעסוקה',
      'דת'
    ],
    'name': 'מורשת אברהם על שם הרב אברהם רביץ זצ״ל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'הוסטל מורשת אברהם',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'צעירות במצבי סיכון',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מורשת הרב אברהם רביץ (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580549582'
      },
      {
        'title': 'ידידות טורונטו, פרויקט ״פניניות״ (ללא תאריך). <b>מעני דיור לצעירות בנות 18–25</b>. נדלה מתוך',
        'url': 'http://www.ff-yt.org/wp-content/uploads/2018/08/pnin.pdf'
      },
      {
        'title': 'משרד העבודה, הרווחה והשירותים החברתיים, ‏מינהל סיוע לבתי המשפט ותקון (2017). <b>‏אוגדן תכניות השירות לנוער, צעירות וצעירים</b>. נדלה מתוך',
        'url': 'http://www.lsf.org.il/data/files/3377_f0935cd7d576df1c9218c5e8e032b42d.pdf'
      },
      {
        'title': 'משרד הרווחה והשירותים החברתיים, אגף מנהל ומשק – תחום מכרזים להתקשרויות ורכש (2016, 11 אוגוסט). <b>כוונת התקשרות פומבית מס\' 571/2016 לביצוע מיזם משותף לצורך הפעלת הוסטל ודירת מעבר לצעירות חרדיות במצוקה קשה וסכנה בירושלים</b>. נדלה מתוך:\n',
        'url': 'https://mr.gov.il/ilgstorefront/he/p/attachment/005056BF19AF1EDA95A380A03D276121/%D7%A0%D7%A1%D7%A4%D7%97%D7%99%D7%9D%20%D7%9C%D7%A4%D7%A8%D7%95%D7%98%D7%95%D7%A7%D7%95%D7%9C'
      }
    ],
    'target_audiences': [
      'נשים חרדיות',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '13/07/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2011,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '19/05/2019'
    },
    'description': 'הוסטל מפתחות לטיפול בגברים אלימים - אסירים משוחררים בקהילה הוקם בראשון לציון בשנת 2005 על ידי הרשות לשיקום האסיר, בחסות הקרן למפעלים מיוחדים של הביטוח הלאומי וקרן סקט״א רש״י. ההוסטל מיועד לאכלס עד 14 דיירים, אסירים משוחררים. ההוסטל משמש ככלי טיפולי בתום תקופת הענישה ומסייע בכך להפחית את מסוכנותם של הגברים האלימים לאחר שחרורם מבית הכלא. מטרת ההוסטל הינה ״ללמד את הגברים האלימים טכניקות חדשות להידברות, לשוויוניות, לזוגיות ולמשפחתיות, וכל זאת כדי למנוע הן את הקורבן הבא והן את המקרבן הבא, ובכדי למנוע העברה בין-דורית של שימוש באלימות אינטימית בתוך התא המשפחתי, אשר אמור להוות תא בטוח עבור בני המשפחה״. אוכלוסיית היעד של ההוסטל כוללת אסירים השפוטים בגין אלימות במשפחה אשר אובחנו כברי שיקום ועברו טיפול משמעותי בכלא או בקהילה (פרטני, קבוצתי, אחר) והם נקיים מסמים ומאלכוהול. השהות בהוסטל אורכת כ-4 חודשים וכוללת טיפול פרטני, טיפול קבוצתי, הכנה לתעסוקה והכשרה מקצועית. לאחר סיום השהות בהוסטל נמשך הקשר הטיפולי על ידי השתתפות בקבוצת בוגרים והמשך טיפול זוגי או משפחתי. בשנת 2017 פורסם כי הרשות לשיקום האסיר בוחנת את סגירתם של ההוסטלים לשיקום אסירים שבאחריותה בשל מחסור בתקציבים שלא מאפשר לה להמשיך ולקיים מערך שיקום ראוי.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'SA137',
    'is_active': true,
    'keywords': [
      'הוסטל',
      'גברים אלימים',
      'אסירים',
      'שיקום',
      'הכשרה מקצועית',
      'דיור'
    ],
    'name': 'הוסטל מפתחות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ראשון לציון',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'גברים',
    'retrieved': {
      'type{date}': '2019-05-19'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.pra.co.il/%D7%94%D7%95%D7%A1%D7%98%D7%9C-%D7%9E%D7%A4%D7%AA%D7%97%D7%95%D7%AA.html'
      },
      {
        'title': 'ירון, לי (2017, 30 אוקטובר). נבחנת סגירת ההוסטלים לשיקום אסירים בשל מחסור בתקציבים. <b>הארץ</b>. נדלה מתוך',
        'url': 'https://www.haaretz.co.il/news/education/.premium-1.4552096'
      },
      {
        'title': 'מליקסון, אנבל (עורכת) (2018). <b>הרשות לשיקום האסיר: סיכום שנת 2017</b>. הרשות לשיקום האסיר – הנהלה ראשית.',
        'url': 'https://sfilev2.f-static.com/image/users/180409/ftp/my_files/%D7%97%D7%95%D7%91%D7%A8%D7%AA%20%D7%A1%D7%99%D7%9B%D7%95%D7%9D%20%D7%A9%D7%A0%D7%94%20%D7%9C%D7%A9%D7%A0%D7%AA%202017.pdf?id=31003097'
      },
      {
        'title': 'שמאי, מיכל, בוכינדר, אלי, אנוש, גיא, דותן, גלי, וברזילי, יעל (2009). <b>הוסטל ״מפתחות״ לאסירים משוחררים אלימים 2005–2008</b>. ירושלים: המוסד לביטוח לאומי, מינהל המחקר והאגף לפיתוח שירותים. נדלה מתוך',
        'url': 'https://www.btl.gov.il/Publications/Special_Activities_publications/Documents/mifal_135.pdf'
      }
    ],
    'target_audiences': [
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/05/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '23/06/2019'
    },
    'description': 'הוסטל עדן הוקם בשנת 2016 עבור צעירות מהחברה הערבית שחסרות עורף משפחתי או נתונות במצבי סיכון. ההוסטל מספק מגורים לכ-12 נערות וצעירות בגילאי 17-25 ומשך השהייה המרבי בו הוא שלוש שנים, כאשר השהייה הממוצעת היא שנתיים. ההוסטל הוא מסגרת ״המספקת סביבה טיפולית, שיקומית והשכלתית״ באמצעות תכנית טיפולית מותאמת, שילוב במסגרות חינוך, השלמת השכלה או עבודה וארגון פעילויות פנאי ותרבות. ההוסטל, בתקצוב מפעל הרווחה, מופעל על ידי קבוצת ״תפארת בית חם״ - חברה פרטית המפעילה המספקת דיור מוגן ושירותי בריאות, בעיקר לבעלי מוגבלויות ובתחום של בריאות הנפש, בפיקוח ובהפניה של משרדי הבריאות. החברה זכתה ב-2018 במכרז של משרד הרווחה על הפעלת שתי מסגרות של חסות הנוער.',
    'description_ar': 'عدن منزل للفتيات والشابات يضم البيت 12 فتاة وشابة في سن 12-25 من شمالي البلاد لعدم وجود احتواء عائلية والذي يعرضهن للخطر. فترة النزول في البيت هي ثلاث سنوات بحيث معدل البقاء في المنزل هو سنتين. يعتبر منزل عدت اطار الذي يمنح بيئة علاجية، تأهيلية وتعليمية. من خلال برنامج علاج مناسب وانخراط النزيلات في اطر تربيةـ استكمال تعليمم او العمل في تنظيم نشاطات لا منهجية وثقافية. المنزل ممول من قبل وزارة الرفاه الاجتماعي ومجموعة ״فخر البيت الدافئ״- شركة خاصة تقدم سكن امن وخدمات صحة بالاسا لاصحاب الاحتياجات الخاصة وفي مجالات الصحة النفسية. وبرقابة من وزارة الصحة. فازت الشركة في عام 2018 بمناقصة لادارة مركزين لرعاية الشبابش.',
    'display_organization_kind': 'ממשלתי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ],
      [
        'אלימות',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YH193',
    'is_active': true,
    'keywords': [
      'נשים מוכות',
      'צעירות במצבי סיכון',
      'ביטחון אישי',
      'הוסטל',
      'חינוך',
      'דיור'
    ],
    'name': 'הוסטל עדן',
    'name_ar': 'عدن منزل للفتيات والشابات',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'עכו',
    'organization_kind': [
      'ממשלתי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'צעירות במצבי סיכון',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-06-23'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.teferet.org/single.php?id=26'
      },
      {
        'title': 'יכימוביץ-כהן, נורית (2016). <b>נערות וצעירות בסיכון בחברה הערבית והמענים הניתנים להן</b>. מוגש לוועדה לזכויות הילד ולוועדה לקידום מעמד האישה ולשוויון מגדרי. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/20/Committees/20_cs_bg_367983.pdf'
      },
      {
        'title': 'מפתח התקציב. <b>תפארת ״בית חם״ בע״מ</b>. נדלה מתוך',
        'url': 'https://next.obudget.org/i/org/company/513449173?li=0'
      },
      {
        'title': 'משרד העבודה, הרווחה והשירותים החברתיים ומינהל סיוע לבתי משפט ותקון השרות לנוער, צעירות וצעירים (2017). <b>אוגדן תכניות השירות לנוער, צעירות וצעירים</b>. ירושלים. נדלה מתוך',
        'url': 'http://www.lsf.org.il/data/files/3377_f0935cd7d576df1c9218c5e8e032b42d.pdf'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '23/06/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': 'הופכות את היוצרות פועלת להעצמה אישית וכלכלית של נשים היוצאות ממעגל הזנות והסחר. אלפי נשים, נערות ונערים נמצאות במעגל הזנות בישראל. העמותה מאמינה כי מחיר הזנות אינו מתמצה בנזקים האישיים לנשים, אלא מתגלם גם במצבן של כלל הנשים בחברה ועל כן יש לתמוך במי שעושה צעדיה הראשונים לצאת ממעגל הזנות. \'הופכות את היוצרות\' מתמקדת בסוגיית השיקום התעסוקתי לנשים ממעגל זה באופן מקיף ועוטף, תוך דגש על שני היבטים מרכזיים: התפתחות מקצועית וביטוי עצמי. במרכז מודל פעילות הארגון עומדים שני מסלולי הכשרה מקצועית: אופנה ושיווק דיגיטלי, העטופים בשיקום רגשי וכלכלי, פיתוח יזמות והכנסות עצמיות, מיצוי זכויות ועסק חברתי, הכול מבוסס על צרכיהן הייחודיים של נשים המשתקמות מזנות ומיועד לשכפול בערים נוספות. בשנת 2013 נפתח סטודיו הקבע הראשון של העמותה בתל אביב-יפו ובשנת 2015 סניפה השני בחיפה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'זנות'
      ],
      [
        'רווחה וקהילה',
        'זנות וסחר בנשים'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ]
    ],
    'id': 'YB75',
    'is_active': true,
    'keywords': [
      'שיקום',
      'אלימות מינית',
      'סחר בנשים',
      'הכשרה מקצועית',
      'העצמה'
    ],
    'name': 'הופכות את היוצרות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'זנות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.yotsrot.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>הופכות את היוצרות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580549905'
      },
      {
        'title': 'הופכות את היוצרות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pg/hofchot/about/?ref=page_internal'
      },
      {
        'title': 'המטה למאבק בסחר בנשים ובזנות. הקואליציה למאבק בזנות (ללא תאריך). <b>הופכות את היוצרות</b>. נדלה מתוך',
        'url': 'https://tfht.org/hebrew/%D7%90%D7%95%D7%93%D7%95%D7%AA/%D7%94%D7%A7%D7%95%D7%90%D7%9C%D7%99%D7%A6%D7%99%D7%94-%D7%9C%D7%9E%D7%90%D7%91%D7%A7-%D7%91%D7%96%D7%A0%D7%95%D7%AA/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2011,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '28/10/2018'
    },
    'description': 'הוצאת ה״מין השני״ הוקמה בשנת 1977 על ידי שרה סייקס ואילנה גולן שהיו פעילות בתנועה הפמיניסטית בתל אביב וממקימות מרכז הסיוע לנפגעות תקיפה מינית. סייקס וגולן תרגמו יחד מאנגלית ספרי יסוד ואסופות עם מאמרים פמיניסטיים מתורגמים ומקוריים. בין הספרים שיצאו בהוצאת ה״מין השני״: האסופה ״אשה ו...חופשיה״ (1977); ״שובניזם זכרי״ מאת מייקל קורדה (1979); ״בניגוד לרצוננו: גברים, נשים ואונס״ מאת סוזן בראונמילר; ״גופנו עצמיותנו״ עם התאמות לקהל הישראלי (1982); ״שיטה טבעית לתכנון משפחה״ מאת מרגרט נופיצר (1984) ו״בנות חוה-בנות לילית״ מאת ברברה סבירסקי (1984). ההוצאה הפסיקה להוציא ספרים חדשים בערך בשנת 1985.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'כתבי עת והוצאה לאור'
      ],
      [
        'תקשורת'
      ]
    ],
    'id': 'SA73',
    'is_active': false,
    'keywords': [
      'הוצאה לאור',
      'פמיניזם',
      'מיניות',
      'פוליטיקה',
      'בריאות'
    ],
    'name': 'הוצאת ״המין השני״',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'גבעתיים',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'כתבי עת והוצאה לאור',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'רשימת ספרי ההוצאה בקטלוג הספרייה הלאומית, ירושלים. נדלה מתוך',
        'url': 'https://merhav.nli.org.il/primo-explore/search?query=lsr01,contains,%22%D7%94%D7%9E%D7%99%D7%9F%20%D7%94%D7%A9%D7%A0%D7%99%22,AND&tab=default_tab&search_scope=Local&sortby=rank&vid=NLI&lang=iw_IL&mode=advanced&offset=0'
      },
      {
        'title': 'עילם, אסתר (31 במרץ 2013). <b>בצער רב אני מודיעה על פטירתה של שרה סייקס ז״ל</b>. נדלה מתוך',
        'url': 'http://www.gendersite.org.il/2013/04/23/%D7%94%D7%95%D7%93%D7%A2%D7%94-%D7%9E%D7%90%D7%AA-%D7%90%D7%A1%D7%AA%D7%A8-%D7%A2%D7%99%D7%9C%D7%9D-%D7%91%D7%A6%D7%A2%D7%A8-%D7%A8%D7%91-%D7%90%D7%A0%D7%99-%D7%9E%D7%95%D7%93%D7%99%D7%A2%D7%94/'
      },
      {
        'title': 'ספרן, חנה (2002). יום אחד יבינו שאנחנו צודקות. <b>פנים: כתב עת לחינוך, חברה ותרבות, 22</b>. נדלה מתוך הספרייה הווירטואלית של מטח',
        'url': 'https://lib.cet.ac.il/pages/item.asp?item=7207'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '28/10/2018'
    },
    'year_closed': 1985,
    'year_closed_text': '1985',
    'year_founded': 1977,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '31/12/2018'
    },
    'description': 'הו״ד- הומוסקסואלים דתיים (ע״ר 580543445) הוקם בשנת 2008 על ידי הרב רן יוסף במטרה להוות בית להומוסקסואלים דתיים אורתודוקסים. מטרת העמותה: ״לפעול למען הציבור היהודי האורתודוקסי ההומוסקסואלי בישראל וברחבי העולם, המתמודדים עם נטייתם המינית. לערוך פעילויות חינוכיות ובכללן כינוסים, אסיפות וימי עיון למטרות העמותה ו/או כל נושא רלוונטי אחר. לפעול למען קידום הסובלנות והשוויון בחברה הדתית.״ הארגון עוסק בשיח עם רבנים והעלאת מודעות לסוגיות להט״ביות וזכויות להט״ב בחברה הדתית, כמו גם מול מערכת החינוך, הצבא ואנשי טיפול. הארגון מחויב לתפיסות הלכתיות ולפיכך מתנגד למשכב זכר, אך אינו מתנגד לזוגיותח חד מינית. הארגון גם מפעיל קו סיוע ומערך פסיכולוגים שנועדו לסייע להומואים דתיים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'דת'
      ],
      [
        'דת ומעמד אישי',
        'להט״ב'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'LR38',
    'is_active': true,
    'keywords': [
      'הומואים',
      'חרדים',
      'תמיכה נפשית',
      'הלכה',
      'לסביות',
      'קו סיוע',
      'טיפול נפשי',
      'קבוצות תמיכה'
    ],
    'name': 'הו״ד - הומוסקסואלים דתיים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נתניה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'דת',
    'primary_target_audience': 'גברים',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>הו״ד – הומוסקסואלים דתיים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580543445'
      },
      {
        'title': 'כ״ץ, ישראל, מעוז, עדי, אלפסי, דנה, לוי, ניר (2018). <b>מיפוי ארגוני הלהט״ב בישראל - דו״ח מסכם</b>. האגודה למען הלהט״ב ואלכא – המכון למנהיגות וממשל בג\'וינט ישראל, ירושלים. נדלה מתוך',
        'url': 'https://a9991848-b055-4c6f-a966-a6bdabf09321.filesusr.com/ugd/be9e5d_e13bb06adc274327b97bb41c199efc0c.pdf'
      },
      {
        'title': 'ארגון הו״ד, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/ort.gays/?__tn__=kCH-R&eid=ARDYzzAQLvE4ktVqhSzD6BSv7SARIjbOJWoE30fPNK-zDIcPGk7IFCMsb-LveOAt_uD1Y5CgopeVMRrc&hc_ref=ARQdN6yti_T5fsvsLA43qgtK3bgV_jH6pzxaoy5Acq7QrDuuS3SieLW-OckaSasrpnM&fref=nf'
      }
    ],
    'target_audiences': [
      'גברים',
      'להט״ב',
      'גברים דתיים'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '31/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2008,
    'year_registered': 2011
  },
  {
    'activity_kinds': [
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '19/10/2018'
    },
    'description': '״הזמן הורוד״ היה כתב עת להט״בי אשר התפרסם לראשונה ב - 1996. הוא הופק ביוזמתו של העיתונאי יאיר קדר, אשר גם שימש כעורך, ובסיועם של אנשי מחיי הלילה הקהילתיים, האקדמיה ועיתון העיר. בראשית ימיו הוא התפרסם בצבע, בפורמט טבלואיד והופץ בדוכני העיתונים בתל אביב. הוא התפרנס מפרסומים הפונים לקהילה. ב - 1999 העיתון נמכר ל״אגודה לשמירת זכויות הפרט״ והעריכה עברה לידיה של אורנה אושרי ובהמשך לידיו של גדי ששון. העיתון עבר לפורמט מגזיני, שהופץ ב - 15,000 עותקים בכל הערים הגדולות ברחבי הארץ. ב - 2004, בעקבות קשיים כלכליים של המו״ל, הוא התפרסם לתקופה מסוימת תחת השם ״הזמן החדש״ בחסות החברה המסחרית טלטאץ׳ ועיתון ״העיר״. ב - 2005 חידשה האגודה את הוצאת העיתון, אולם ב - 2008 נמכרו הזכויות עליו לעיתון ״העיר״ באופן סופי. הוא הפך למגזין בידורי שעסק בעיקר בענייני אופנה ולייף סטייל, והפסיק להתפרסם בשנת 2010. לאורך שנות ה - 90 היה המגזין הבמה התקשורתית המרכזית של הקהילה הלהט״בית. הוא ליווה ותיעד רבים ממאבקי הקהילה. במקביל הוא כלל גם פן בידורי ומדורי רכילות והיה מעורב בארגון אירועים קהילתיים.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'כתבי עת והוצאה לאור'
      ],
      [
        'להט״ב',
        'תרבות וספורט'
      ],
      [
        'תקשורת'
      ]
    ],
    'id': 'LR6',
    'is_active': false,
    'keywords': [
      'הומואים',
      'לסביות',
      'כתב עת'
    ],
    'name': 'הזמן הורוד',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'התארגנות שאינה עמותה',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'כתבי עת והוצאה לאור',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'קדר, יאיר (2013, 6 יוני). מזכרונותיו של פנתר פרינט ורוד: כך נולדה העיתונות הגאה בישראל. <b>וואלה! ברנז\'ה</b>. נדלה מתוך',
        'url': 'https://b.walla.co.il/item/2648648'
      },
      {
        'title': 'קניאס, יואב (2012). לקרוא בין צבעי הקשת: שיח של דיכוי, איום ואינטימיות בעיתונות ההומו-לסבית בישראל. <b>קשר, תקשורת ומחאה חברתית, 43</b> (קיץ), 100–113. נדלה מתוך',
        'url': 'https://www.jstor.org/stable/i23918726'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2010,
    'year_closed_text': '2010',
    'year_founded': 1996,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '17/10/2018'
    },
    'description': 'מדובר בארגון ללא מטרות רווח ששייך להסתדרות הרפואית והוקם מתוקף התקנון שלה. מונה מעל 130 חברים וחברות מ-16 דסיפלינות ו-11 בתי חולים, אוניברסיטאות ומוסדות מחקר. חברה בחברה הבינלאומית לרפואה מגדרית (ISOGEM). הארגון עורך כנסים וקורסים, מקשר בין חוקרים.ות, המציעים.ות פרויקטים מחקריים ברפואה מודעת מין ומגדר ועובד בשיתוף פעולה הדוק עם אוניברסיטת תל אביב ועם המרכז לחקר הרפואה מודעת מין ומגדר בבה״ח בילינסון.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף אקדמי',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות ומגדר'
      ],
      [
        'השכלה גבוהה ומחקר',
        'אגודות מקצועיות'
      ]
    ],
    'id': 'YH108',
    'is_active': true,
    'keywords': [
      'מחקר',
      'רפואה מגדרית',
      'חינוך מגדרי'
    ],
    'name': 'החברה הישראלית לרפואה מודעת מין ומגדר',
    'name_ar': null,
    'name_change_year': 2017,
    'name_common': null,
    'name_past': 'החברה הישראלית לרפואה מגדרית',
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'אקדמי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות ומגדר',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-17'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.isragem.org.il/blank-8'
      },
      {
        'title': 'החברה הישראלית לרפואה מודעת מין ומגדר – Isragem, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/isragem/'
      },
      {
        'title': 'סידון, יונתן (2018, 8 יולי). רפואה מודעת מין ומגדר היא צעד גדול לשיפור איכות הרפואה. <b>כלכליסט</b>. נדלה מתוך',
        'url': 'https://www.calcalist.co.il/articles/0,7340,L-3741669,00.html'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '18/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2009,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '25/10/2018'
    },
    'description': 'החברה לרפואת להט״ב הוקמה בשנת 2016 על ידי ד״ר רות גופן וד״ר גל וגנר-קוסקו, המשמשים גם כיו״רים שותפים שלה ואושרה על ידי ההסתדרות הרפואית בישראל. מטרת החברה היא להרחיב את הידע הקיים לשם מתן טיפול רפואי מיטבי לקהילת הלהט״ב, הסברה בנוגע לקהילה ולצרכיה ומאבק בלהט״בופוביה בקרב צוותים רפואיים, השפעה על קביעת מדיניות ונהלים הנוגעים לקהילה מול המדינה ומול קופות החולים ובתי החולים, קידום בריאות בתוך הקהילה הלהט״בית ועידוד ותמיכה במחקרים רפואיים על הקהילה, כמו גם שיתופי פעולה עם חברות מקבילות בחו״ל. פעילותה כוללת בין היתר: כתיבת ניירות עמדה בשיתוף ההסתדרות הרפואית ביחס לאימוץ ולטיפולי המרה; הרצאות לצוותי רפואה; ארגון כנסים בנושאים כמו טיפולים רפואיים בטרנס*; סמים וסקס ושיוויון בבריאות; העברת סדנאות לחברי וחברות הקהילה; פרויקט הכנסת נאמני קהילה לבתי החולים; והסברה בכנסת בנושאים הקשורים לקהילה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף אקדמי',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות ומגדר'
      ],
      [
        'להט״ב',
        'רווחה ובריאות'
      ],
      [
        'השכלה גבוהה ומחקר',
        'אגודות מקצועיות'
      ]
    ],
    'id': 'LR9',
    'is_active': true,
    'keywords': [
      'להט״בופוביה',
      'מיניות',
      'הומואים',
      'הומופוביה',
      'זהות מגדרית',
      'חינוך',
      'טרנסקסואלים',
      'לסביות',
      'סדנאות',
      'קוויר',
      'מחלות מין'
    ],
    'name': 'החברה לרפואת להט״ב',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'אקדמי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות ומגדר',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'החברה לרפואת להט״ב, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pg/lgbt.med/about/?ref=page_internal'
      },
      {
        'title': '(2018, 16 אפריל). החברה לרפואת להט״ב מסכמת שנה. <b>וודג\'</b>. נדלה מתוך',
        'url': 'https://www.wdg.co.il/%D7%94%D7%97%D7%91%D7%A8%D7%94-%D7%9C%D7%A7%D7%99%D7%93%D7%95%D7%9D-%D7%94%D7%91%D7%A8%D7%99%D7%90%D7%95%D7%AA-%D7%91%D7%A7%D7%94%D7%99%D7%9C%D7%AA-%D7%94%D7%9C%D7%94%D7%98%D7%91-%D7%9E%D7%A1%D7%9B/'
      },
      {
        'title': '(2017, 10 פברואר). החברה לרפואה להט״ב אושרה ע״י ההסתדרות הרפואית בישראל. <b>וודג\'</b>. נדלה מתוך',
        'url': 'https://www.wdg.co.il/%D7%94%D7%97%D7%91%D7%A8%D7%94-%D7%9C%D7%A8%D7%A4%D7%95%D7%90%D7%AA-%D7%9C%D7%94%D7%98%D7%91-%D7%90%D7%95%D7%A9%D7%A8%D7%94-%D7%A2%D7%99-%D7%94%D7%94%D7%A1%D7%AA%D7%93%D7%A8%D7%95%D7%AA-%D7%94%D7%A8/'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחאה'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '22/01/2019'
    },
    'description': 'החוג הגאה במפלגת העבודה הוקם ב-2011 על ידי דן סליפר וניב נוניס, בעידודה ותמיכתה של היו״ר דאז שלי יחימוביץ׳. מפגש הפעילים הראשון התקיים בינואר 2012. החוג פעל לקידום יוזמות חקיקה הנוגעות לקהילה והכנסת שינויים התומכים בקהילה במצע המפלגה. הוא עודד את ההתפקדות למפלגה והצליח להגדיל בצורה ניכרת את מספר הצירים הלהט״בים בוועידת המפלגה. החוג מקיים מפגשי פעילים ומפגשים עם ח״כים מטעם המפלגה. המפגשים מתרחשים בעיקר בתל אביב, במקרים רבים בדירות פרטיות. בנוסף פעילי החוג לוקחים חלק בפעילויות מחאה קהילתיות ומצעדי גאווה בכל רחבי הארץ.',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'להט״ב',
        'פוליטיקה ומנהיגות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ]
    ],
    'id': 'LR47',
    'is_active': true,
    'keywords': [
      'חקיקה',
      'כנסת',
      'גאווה',
      'מצעד',
      'זכויות להט״ב',
      'תאים מפלגתיים'
    ],
    'name': 'החוג הגאה של מפלגת העבודה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'החוג הגאה - מפלגת העבודה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/Israeli.Labor.Party.LGBT.Circle/'
      },
      {
        'title': 'גרוס, אייל (2016). הפוליטיקה של זכויות להט״ב: בין (הומו) נורמטיביות ו(הומו) לאומיות לפוליטיקה קווירית. בתוך: גרוס, אייל, זיו, עמליה ויוסף, רז (עורכים), <b>סקס אחר - מבחר מאמרים בלימודים להט״בים וקוויריים ישראליים</b> (עמ\' 183–245). תל אביב: רסלינג.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '25/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2011,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '01/09/2019'
    },
    'description': 'החוג הפמיניסטית במפלגת העבודה הוקם בסוף שנת 2016 על ידי קבוצת פעילות שהחלו להתארגן לפני הבחירות לכנסת ה-20 (2015). מטרת החוג היא לפעול אל מול החוגים בתוך מפלגת העבודה כדי להטמיע נקודת השקפה מגדרית ולקדם סוגיות פמיניסטיות בתוך המפלגה. בנוסף, החוג מקיים שיתופי פעולה עם פורומים ותאים פמיניסטיים במפלגות אחרות. בין מייסדות החוג: אור סרי, עדי עזוז, יעל שרר ולילי פרגמניקוב.',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ]
    ],
    'id': 'SA112',
    'is_active': true,
    'keywords': [
      'תאים מפלגתיים',
      'תעסוקה',
      'קידום נשים',
      'מדיניות',
      'הטמעת חשיבה מגדרית'
    ],
    'name': 'החוג הפמיניסטית במפלגת העבודה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'מפלגות, שדולות ותאים מפלגתיים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-09-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.havoda.org.il/%D7%97%D7%95%D7%92%D7%99%D7%9D/%D7%94%D7%97%D7%95%D7%92-%D7%94%D7%A4%D7%9E%D7%99%D7%A0%D7%99%D7%A1%D7%98%D7%99%D7%AA-%D7%91%D7%9E%D7%A4%D7%9C%D7%92%D7%AA-%D7%94%D7%A2%D7%91%D7%95%D7%93%D7%94/'
      },
      {
        'title': 'החוג הפמיניסטית במפלגת העבודה (2019, 9 ינואר). הפרטים אומתו בשיחת טלפון עם אחת ממייסדות התא.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '09/06/2019'
    },
    'description': 'עמותת ״החוט המשולש - בית חם לנוער״ הוקמה בירושלים בשנת 1999 על ידי יגאל ודנה גולדשטיין. העמותה מנסה לספק מענים הוליסטים לצעירים וצעירות בגילאי 14-25 במצבי סיכון, מחוסרי קורת גג ומסגרת. העמותה מפעילה שלושה מרחבים - 1. מרחב פתוח לגילאי 14-25 הפועל במרכז ירושלים מ - 10:00 - 22:00, אליו יכולים להגיע בני נוער וצעירים כדי לקבל ארוחה חמה, תמיכה נפשית, מרחב קהילתי, מקלחת וכביסה, תכניות העשרה והכשרה לתעסוקה. 2. בית לבנות בגילאי 18-25 שהוקם בשיתוף משרד הרווחה, בו הן יכולות להתגורר במשך שנתיים ולקבל תמיכה נפשית, הכשרה לתעסוקה וסיוע במציאת עבודה וסדנאות העצמה וכישורי חיים. הבית יכול להכיל עד 12 צעירות וב - 2016 היו לו 80 בוגרות. רבות מהמגיעות אליו נמצאות בשלבי הריון מתקדם, הן מקבלות הכשרה ללידה ולהורות, ליווי ותמיכה בהחלטה האם למסור את הילד לאימוץ או לגדלו והן יכולות להמשיך ולשהות במעון עד חצי שנה לאחר הלידה. 3. בית לבנים בגילאי 18-25 שמציע מענה לעד 18 בנים בו זמנית, המקבלים אף הם, תמיכה נפשית והכשרה תעסוקתית, בתוכנית של 6-18 חודשים. העמותה משתפת פעולה עם מסעדת ״אנה״ בבית אנה טיכו, המספק הכשרה ושילוב תעסוקתי לבני נוער בסיכון.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ],
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'LR55',
    'is_active': true,
    'keywords': [
      'דיור',
      'הוסטל',
      'הריון',
      'צעירות במצבי סיכון',
      'העצמה כלכלית',
      'תעסוקה',
      'אלימות'
    ],
    'name': 'החוט המשולש - בית חם לנוער',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'נערות וצעירות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-09-06'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://meshulash.org/he/homepage/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>החוט המשולש – בית חם לנוער (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580341592'
      },
      {
        'title': 'משרד העבודה, הרווחה והשירותים החברתיים ומינהל סיוע לבתי משפט ותקון השרות לנוער, צעירות וצעירים (2017). <b>אוגדן תכניות השירות לנוער, צעירות וצעירים</b>. ירושלים. נדלה מתוך',
        'url': 'http://www.lsf.org.il/data/files/3377_f0935cd7d576df1c9218c5e8e032b42d.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '06/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1999,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/12/2018'
    },
    'description': 'החטיבה ללימודי נשים ומגדר במכללה האקדמית עמק יזרעאל פעלה כמקבץ בתוך המסלול הרב תחומי לתואר ראשון במדעי החברה עד שנסגרה. מקימת החטיבה היתה פרופ\' מיכל פלגי שעמדה בראשה בשנים 1998-2002. בין המרצות שלימדו בחטיבה היו הלנה דה-סיביליה, דלית יסעור-בורוכוביץ, רות ברזילי-לומברוזו, חנה ספרן, עדנה גורני ואסתר כרמל-חכים.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תכניות לתואר אקדמי בלימודי מגדר'
      ]
    ],
    'id': 'SA107',
    'is_active': false,
    'keywords': [
      'לימודי מגדר',
      'פריפריה'
    ],
    'name': 'החטיבה ללימודי נשים ומגדר במכללת עמק יזרעאל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'יזרעאל',
    'organization_kind': [
      'אקדמי',
      'ממשלתי'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תכניות לתואר אקדמי בלימודי מגדר',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'האגודה הישראלית ללימודים פמיניסטיים ולחקר המגדר (ללא תאריך). <b>לימודי מגדר בישראל</b>. נדלה מתוך',
        'url': 'http://www.gendersite.org.il/gender-studies/'
      },
      {
        'title': 'מיכל פלגי. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%9E%D7%99%D7%9B%D7%9C_%D7%A4%D7%9C%D7%92%D7%99'
      },
      {
        'title': 'ספרן, חנה (2009). בין אקדמיה לקהילה פמיניסטית: לימודי נשים בישראל. בתוך: אופלטקה, יזהר והרץ לזרוביץ, רחל (עורכים), <b>מגדר ואתניות בהשכלה הגבוהה בישראל</b> (עמ\' 169–188). חיפה: פרדס. נדלה מתוך',
        'url': 'https://gendersite.org.il/wp-content/uploads/2010/08/Safran.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '30/12/2018'
    },
    'year_closed': 2011,
    'year_closed_text': '2011',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '03/07/2018'
    },
    'description': 'חצר נשית (ע.ר.  580418721) היא מרחב נשי, רב תרבותי, מגן ומעצים לנערות ונשים צעירות במצבי מצוקה וסיכון. בשנת 2003 נפתחה לראשונה החצר הנשית בשכונת עגמי ביפו על ידי על ידי ליאורה קסל ומירית סידי. החצר הנשית הינה מקום מפגש קהילתי, נשי, מגן ומוגן, אשר פתוח עבור כל נערות יפו והסביבה בגילאי 18-25 ללא כל הגדרה, אבחנה או סייג. בשנת 2013 החלה לפעול גם החצר הנשית בחיפה ובנתניה (בשיתוף פעולה עם העירייה). חצר נוספת פעלה בקרית מלאכי אך היא נסגרה בשנת 2016. החצר הנשית פועלת לקידום ערכים של צדק חברתי ושוויון הזדמנויות ומאמינה בזכותה של כל אישה ונערה למימוש עצמי בהתאם לרצונותיה, שאיפותיה וצרכיה ללא תלות במוצאה הלאומי או העדתי. מטרות העמותה הן: ״סיוע לנערות ולנשים צעירות המתמודדות עם מצבי מצוקה. הרחבת המודעות בקהילה לצורכי נערות ונשים צעירות. יצירת מרחב מוגן המאפשר קשר עמוק ומשמעותי ושיח נשי בנדורי. הרחבת מגוון השירותים עבור נערות ונשים צעירות. סיוע לנערות ולנשים צעירות לצאת ממעגל המצוקה ולבניית חיים עצמאיים ויציבים.״ בכל אחד מהמקומות שבהם מופעלת חצר נשית מתקיימות פעילויות מגוונות הכוללות סיוע בלימודים, ליווי בתעסוקה, מיצוי זכויות, פעילות פנאי וכן ארוחות חמות, ביגוד, מלגות ומספרה. בכל חצר יש צוות מקצועי של עובדות סוציאליות המסייעות בליווי וייעוץ פרטני ובהדרכת סדנאות קבוצתיות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ],
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'תעסוקה ועבודה',
        'השמה וליווי בתעסוקה'
      ]
    ],
    'id': 'YB115',
    'is_active': true,
    'keywords': [
      'תמיכה נפשית',
      'מיצוי זכויות',
      'נערות בסיכון',
      'השלמת השכלה',
      'העצמה',
      'דיור'
    ],
    'name': 'החצר הנשית',
    'name_ar': 'الساحة النسائية',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'נערות וצעירות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-07-03'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://hatzer.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>חצר נשית (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580418721'
      },
      {
        'title': 'החצר הנשית, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/womenscourtyard/'
      },
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל. עמ\' 45–47.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות',
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '09/04/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2003,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '08/09/2018'
    },
    'description': 'היא מקודדת (she codes) היא קהילה טכנולוגית של נשים, שהוקמה ב-2013 על ידי רות פולצ\'ק במטרה להגיע ל- 50% מפתחות תכנה בתוך עשור בישראל. היא מקודדת נרשמה כעמותה ב-2014 ומוזגה עם ״הארגון לשוויון נשי בטכנולוגיה בע״מ״ (חל״צ 515289379) ב-2017. \nהחברות הן נשים שמבקשות ללמוד פיתוח תוכנה או לעשות הסבה מקצועית לתחום ההייטק, מפתחות שמטרתן להתפתח במקצוען ולפגוש מפתחות אחרות ונערות בגילאי תיכון שלומדות תכנות. הקהילה מהווה חלק מארגון בינלאומי שנוסד בארצות הברית ומונה למעלה 20,000 חברות וכ-40 סניפים ברחבי הארץ. בסניפים מתנהלים מסלולי לימוד תכנות, קבוצות עבודה על פרויקטים בליווי מתנדבות מהקהילה, הרצאות, מפגשים עם נשים מעוררות השראה, יעוץ קריירה ועוד. ב-2017 הודיע משרד העבודה והרווחה על מיזם משותף עם העמותה למשל 3 שנים בעלות של 20 מיליון ובמימון משותף (50:50) במטרה להרחיב את מספר הסניפים ואת מספרי המשתתפות. הארגון והסניפים מנוהלים בהתנדבות.',
    'description_ar': 'تهدف أنشطتها إلى تحقيق أربعة أهداف استراتيجية: 1) الوصول إلى المعرفة من خلال تحسين المستوى التعليمي للمرأة البدوية؛ 2) الوصول إلى الموارد من خلال زيادة الحصانة الاقتصادية لدى النساء البدويات وخلق مصادر دخل متوفرة. المساواة بين الجنسين من خلال تعزيز الوضع الاجتماعي للمرأة وتعزيز حقوق المرأة؛ 4) التنمية المستدامة من خلال زيادة الاحتراف والتطوير التنظيمي. تدير الجمعية مشاريع اقتصادية تهدف إلى تمكين النساء البدويات اللائي ينتجن السجاد في بيوتهن ويبيعنهن في البلاد والخارج وأيضًا يستضيفون السياح في بيوتهن. بالإضافة إلى ذلك، تجري الجمعية تدريباً مهنياً للنساء يشمل تشجيع ريادة الأعمال للشركات الصغيرة، واستكمال تعليم الكبار، تعزيز صحة المرأة، تحسين شروط الحياة الأسرية، والقيادة الشابة.',
    'display_organization_kind': 'בינלאומי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'הכשרה מקצועית'
      ],
      [
        'חינוך',
        'מדע וטכנולוגיה'
      ],
      [
        'נערות וצעירות',
        'מדע וטכנולוגיה'
      ]
    ],
    'id': 'YH69',
    'is_active': true,
    'keywords': [
      'תכנות',
      'מדע וטכנולוגיה',
      'היי-טק',
      'שוק העבודה',
      'רישות',
      'חל״צ'
    ],
    'name': 'הארגון לשוויון נשי בטכנולוגיה בע״מ (חל״צ)',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'היא מקודדת (she codes)',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'בינלאומי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'בינלאומי',
    'primary_sub_field_of_activity': 'הכשרה מקצועית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-08'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://she-codes.org/he/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>הארגון לשוויון נשי בטכנולוגיה בע״מ (חל״צ): חל״צ</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/515289379'
      },
      {
        'title': 'בית המשפט המחוזי מרכז-לוד (2017, 22 פברואר). <b>בקשה למיזוג: ״היא מקודדת״ והארגון לשוויון נשי בטכנולוגיה בע״מ – פסק דין</b>. נדלה מתוך',
        'url': 'https://www.psakdin.co.il/Court/%D7%A4%D7%A8-%D7%A7-44931-02-17-%D7%94%D7%99%D7%90-%D7%9E%D7%A7%D7%95%D7%93%D7%93%D7%AA-%D7%95%D7%90%D7%97-%D7%A0-%D7%9E%D7%A9%D7%A8%D7%93-%D7%94%D7%9E%D7%A9%D7%A4%D7%98%D7%99%D7%9D-%D7%90%D7%92%D7%A3-%D7%A8%D7%A9%D7%9D-%D7%94%D7%97%D7%91%D7%A8%D7%95%D7%AA,%D7%A9%D7%95%D7%AA#.XXPcQ-NvaYk'
      },
      {
        'title': ';she codes. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/She_codes;'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '08/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': 2014
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '20/01/2019'
    },
    'description': 'עמותת ״היווט - עמותה לסיוע סוציאלי חינוכי וכלכלי ליוצאי אתיופיה״ (ע״ר 580384758) הוקמה באופן רשמי בשנת 2001 בעקבות התארגנות שהחלה כבר בשנת 1993, על ידי קבוצת סטודנטיות עולות מאתיופיה באוניברסיטת חיפה שביקשו להנהיג שינוי בקהילתן. העמותה רשומה בחיפה על שם אלמז פנטה - פעילה חברתית בקהילה האתיופית שהקימה עמותות נוספות. הפעילות - באזור חיפה והקריות. פועלות בעיקר בתחום החינוך הבלתי פורמלי - מפעילות מועדוניות לבני 6-12 ומרכזי נוער לבני 13-18. בנוסף - מפעילות תכניות העצמה להורים - אמהות בעיקר. העמותה מקבלת תמיכות ממשלתיות ממשרד הקליטה וממשרד החינוך. מנכ״לית העמותה היא מלכה דניאל-דוק, שעלתה מאתיופיה כילדה וכיום בעלת תואר ראשון בחינוך ומסיימת תואר שני בייעוץ חינוכי. מלכה דניאל-דוק החליפה ב-2013 את ריקי טגבה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'הגירה',
        'קליטת עלייה'
      ],
      [
        'חינוך',
        'צמצום פערים בחינוך'
      ],
      [
        'נערות וצעירות',
        'חינוך'
      ]
    ],
    'id': 'YH181',
    'is_active': true,
    'keywords': [
      'השכלה',
      'מלגות',
      'העצמה',
      'סיוע לאמהות',
      'משפחות'
    ],
    'name': 'היווט - עמותה לסיוע סוציאלי חינוכי וכלכלי ליוצאי אתיופיה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'הגירה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קליטת עלייה',
    'primary_target_audience': 'נשים יוצאות אתיופיה',
    'retrieved': {
      'type{date}': '2019-01-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.hiyot.org/he/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>היווט – עמותה לסיוע סוציאלי חינוכי וכלכלי ליוצאי אתיופיה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580384758'
      },
      {
        'title': 'היווט, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/hiyotngo/'
      }
    ],
    'target_audiences': [
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '20/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1993,
    'year_registered': 2001
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '22/01/2019'
    },
    'description': 'היחידה לחקר בריאות האישה והילד, בראשותה של פרופ\' ליאת לרנר-גבע הוקמה ביולי 2001 כאחת היחידות בחטיבת האפידמיולוגיה במכון גרטנר לאפידמיולוגיה וחקר מדיניות בריאות (חל״צ). מטרת היחידה: מחקרי איכותי שישמש בסיס לקבלת החלטות ומדיניות בתחום בריאות האישה והילד. פעילות העמותה - פיתוח מתודולוגיות וכלי מחקר, השתתפות בוועדות ומועצות לאומיות של משרד הבריאות, הוראה והדרכת סטודנטים לרפואה.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ],
      [
        'השכלה גבוהה ומחקר',
        'מרכזי מחקר'
      ]
    ],
    'id': 'YH183',
    'is_active': true,
    'keywords': [
      'רפואה מגדרית',
      'מחקר',
      'טכנולוגיות פריון',
      'סרטן',
      'הריון',
      'גיל המעבר',
      'חל״צ'
    ],
    'name': 'היחידה לחקר בריאות האישה והילד במכון גרטנר',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת גן',
    'organization_kind': [
      'אקדמי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-01-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.gertnerinst.org.il/'
      },
      {
        'title': 'מכון גרטנר (ללא תאריך). <b>מחקרי בריאות האשה</b>. נדלה מתוך',
        'url': 'http://www.gertnerinst.org.il/epidemiology/woman_child/women_child_researches/women_healthy/212.htm'
      },
      {
        'title': 'רוזנבלום, שרית (2009, 12 אוקטובר). מחקר ענק: תינוקות מבחנה - סיכון כפול למומים. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-3788697,00.html'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '22/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2001,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '07/11/2018'
    },
    'description': '״היחידה למיניות ומניעת פגיעה בילדים ובני נוער״ הוקמה בשנת 1973 על מנת ״למנוע את ההידרדרות המוסרית של הנוער״. בראשית דרכה היוותה היחידה חלק מהמזכירות הפדגוגית של המשרד, אך בסוף שנות השמונים הפכה לחלק מהשירות הפסיכולגי ייעוצי (שפ״י). המעבר לשפ״י סימל גם שינוי מהותי בתפקידה וגישתה של היחידה ממנגנון שנועד למשטר מיניות ולחנך להתנהגות מוסרית, למנגנון הפועל מתוך תפיסה של הענקת כישורי חיים ובריאות נפשית. החל מאמצע שנות התשעים החלה היחידה גם לעסוק בבריאות, בעקבות משבר האיידס, לקדם תכנים העוסקים בשוויון מגדרי ולעסוק בסוגיות להט״ביות. כיום, היחידה שכל חברותיה נשים, עוסקת בהפקת והפצת מערכי שיעור ותכנים בנושאים כגון שוויון מגדרי, שבירת סטריאוטיפים מגדריים, הסכמה, מיניות בריאה, הימנעות ממערכות יחסים מתעללות, ביטחון מיני, להט״ב ועוד. בנוסף, היחידה מקיימת מדי שנה הפעלות לציון היום הבינלאומי למאבק בלהט״בופוביה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'חינוך',
        'חינוך מיני/מיניות בריאה'
      ],
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'להט״ב',
        'חינוך והשכלה'
      ]
    ],
    'id': 'LR15',
    'is_active': true,
    'keywords': [
      'חינוך',
      'חינוך מגדרי',
      'מיניות בריאה',
      'שיוויון',
      'מחלות מין',
      'ילדות/ים',
      'נערות',
      'פגיעה מינית בילדות'
    ],
    'name': 'היחידה למיניות ומניעת פגיעה בילדים ובני נוער',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'חינוך',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'חינוך מיני/מיניות בריאה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-11-07'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://cms.education.gov.il/EducationCMS/Units/Shefi/Hitpatchut/'
      },
      {
        'title': 'ידיד, נטע, רימון, יעל וצימרמן, שוש (2011). מדיניות משרד החינוך בנושא הלהט״בי: בין ״קלפים פתוחים״ לבין חוזר מנכ״ל כנגד ההומופוביה. <b>מפגש לעבודה חינוכית סוציאלית, 33</b>, גיליון מיוחד בנושא נוער לסבי, הומוסקסואלי, טרנסג׳נדרי וביסקסואלי (להט״ב): התבגרות, זהות וסיכון בתוך חברה הטרוסקסואלית, עמ\' 211–221.'
      },
      {
        'title': 'מגדר בקיבוץ. <b>ויקיפדיה</b>.  נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%9E%D7%92%D7%93%D7%A8_%D7%91%D7%A7%D7%99%D7%91%D7%95%D7%A5'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'להט״ב',
      'גברים'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1973,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '06/11/2018'
    },
    'description': 'בשנת 1994 נקבעה מדיניות שוויון מגדרי בחינוך וכדי ליישמה הוקמה ״היחידה לשוויון בין המינים״ במזכירות הפדגוגית במשרד החינוך אשר כללה בשלב ראשון ממונה ראשית ומספר יועצות שעבדו במשרות חלקיות. בשנת 2000 התמנתה מרים שכטר ל״ממונה על השוויון בין המינים בחינוך״ במשרה מלאה ובשנת 2002 התפרסם חוזר מנכ״ל משרד החינוך בנושא ״חינוך לשוויון מגדרי״ שקבע כי על מוסדות החינוך לעצב מדיניות ליישום שוויון מגדרי והטיל על היחידה את האחריות לגיבושה. ב-2012 החליפה את מרים שכטר אושרה לרר-שייב אשר מכהנת בתפקיד נכון ל-2018. מטרות היחידה לשוויון בין המינים הן: קידום השוויון בין המינים במערכת החינוך; העלאת המודעות של צוותי החינוך, ההורים והתלמידים להבניות חברתיות ושינוי העמדות המצריכות שינוי; חשיפת התלמידים לדרכי חשיבה יצירתיות ולא שגרתיות והרחבת אפשרויות ההתנהגות והבחירות האישיות בקרב בנים ובנות.\nהיחידה אמונה על כתיבת תכניות והטמעת החשיבה המגדרית ברמות השונות של מערכת החינוך, כולל קידום נערות בתחום המדעים והמתמטיקה, ופועלת בשישה מחוזות: צפון, דרום, מרכז, ירושלים, חיפה ובזרם החינוך הערבי ממלכתי. במשך השנים, חלק מפעולות היחידה התבצעו ישירות על ידי משרד החינוך ומקצתן בשיתוף גורמים חיצוניים, בכפוף למכרז או במסגרת מיזם משותף עם ארגוני נשים וחברות פרטיות. היחידה אחראית גם לתכלול פעולות משרד החינוך הקשורות למגדר ומקיימת שיתופי פעולה עם היחידות הרלוונטיות במשרד: השירות הפסיכולוגי-ייעוצי, מינהל חברה ונוער, המזכירות הפדגוגית, הפיקוח על הוראת מדע וטכנולוגיה והפיקוח על הוראת מתמטיקה. היחידה מנחה את כלל היחידות במשרד החינוך בנושא הטמעה של חשיבה מגדרית. פעילויות היחידה הן פעילויות רשות ובתי הספר בוחרים אם להשתתף בהן. תפקיד ראש היחידה קוצץ במשך השנים והקיפו בשנת 2018 היה חצי משרה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'חינוך',
        'פמיניזם ושוויון בין המינים'
      ],
      [
        'נערות וצעירות',
        'מדע וטכנולוגיה'
      ]
    ],
    'id': 'YH20',
    'is_active': true,
    'keywords': [
      'הטמעת חשיבה מגדרית',
      'חינוך מגדרי',
      'חינוך פמיניסטי',
      'ילדות/ים',
      'מדע וטכנולוגיה',
      'גבריות',
      'מדעים מדויקים',
      'סטריאוטיפים',
      'שוויון מגדרי'
    ],
    'name': 'היחידה לשוויון בין המינים במשרד החינוך',
    'name_ar': 'وحدة المساواة بين الجنسين- وزارة التربية والتعليم',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'חינוך',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'פמיניזם ושוויון בין המינים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-11-12'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://edu.gov.il/minhalpedagogy/Gender-Equality/Pages/gender-equality.aspx'
      },
      {
        'title': 'משרד החינוך (2002). חוזר מנכ״ל תשס״ג\\4 (ד)9.4-4: חינוך לשוויון מגדרי במוסדות חינוך. נדלה מתוך',
        'url': 'http://cms.education.gov.il/educationcms/applications/mankal/arc/sc4dk9_4_4.htm'
      },
      {
        'title': 'אבגר, עדו (2017). <b>מדיניות לקידום שוויון מגדרי במערכת החינוך – סקירה משווה</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/b541a8eb-04ff-e511-80d7-00155d0a9581/2_b541a8eb-04ff-e511-80d7-00155d0a9581_11_10537.pdf'
      },
      {
        'title': 'אדן, דבורה (2011). מדיניות שוויון בין המינים במערכת החינוך: השפעות, עיצוב, יישום. <b>עיונים בחינוך: כתב עת לעיון ולמחקר בחינוך, 4</b>, 124–143. נדלה מתוך',
        'url': 'https://www.jstor.org/stable/10.2307/23394136'
      },
      {
        'title': 'שכטר, מרים (2008). עושים פמיניזם במשרד החינוך: על מהלכי המשרד. <b>הד החינוך: אל המאה ה-21, כ״ב</b>, 6, 80–81. נדלה מתוך',
        'url': 'https://cdn-cms.f-static.com/uploads/264589/normal_59ad185ba3ae9.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות',
      'גברים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1994,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '30/12/2018'
    },
    'description': 'היחידה לקידום נשים הוקמה באוקטובר 2000 בוועידה שבה התאחדו תנועת הקיבוץ הארצי והתנועה הקיבוצית המאוחדת לתנועה אחת - ״התנועה הקיבוצית״. קדמו ליחידה המדורים לשוויון בין המינים בתק״מ ובקיבוץ הארצי שפעלו בין 1981-1990 במטרה לקדם תכנית אסטרטגית משותפת אך נסגרו בשל חוסר בתקציבים. היחידה פעלה לקידום נשים לתפקידי מנהיגות, מאבק בהטרדות מיניות (כולל קו חם שפעל כשנה ונסגר בשל מיעוט פניות), חינוך מגדרי ועוד.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ],
      [
        'חינוך',
        'פמיניזם ושוויון בין המינים'
      ]
    ],
    'id': 'YH168',
    'is_active': true,
    'keywords': [
      'חינוך מגדרי',
      'ייצוג הולם',
      'מנהיגות',
      'קו סיוע',
      'קיבוץ',
      'קידום נשים',
      'שוויון מגדרי',
      'תעסוקה'
    ],
    'name': 'היחידה לשוויון מגדרי בתנועה הקיבוצית',
    'name_ar': null,
    'name_change_year': 2012,
    'name_common': null,
    'name_past': 'היחידה לקידום נשים בתנועה הקיבוצית',
    'name_replaced_by': 'המדורים לשוויון בין המינים בתק״מ ובקיבוץ הארצי',
    'official_address': 'ארצי',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'שוויון בין המינים/שוויון מגדרי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-12-30'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.kibbutz.org.il/he/content-worlds/%D7%A7%D7%99%D7%93%D7%95%D7%9D-%D7%A0%D7%A9%D7%99%D7%9D'
      },
      {
        'title': 'מגדר בקיבוץ. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%9E%D7%92%D7%93%D7%A8_%D7%91%D7%A7%D7%99%D7%91%D7%95%D7%A5'
      },
      {
        'title': 'עילם, אסתר (2012). פמיניסטית באקדמיה בשנות השבעים. <b>מגדר: כתב עת למגדר ופמיניזם</b>, 1, 117–132. נדלה מתוך',
        'url': 'http://blogdebate.org/gender/journal/wp-content/uploads/2012/12/%D7%90%D7%A1%D7%AA%D7%A8-%D7%A2%D7%99%D7%9C%D7%9D.pdf'
      },
      {
        'title': '(2014, 30 יוני). היחידה לנשים - עובדות על שינוי מגדרי בקיבוצים. <b>mynet קיבוץ</b> (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '31/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '12/08/2019'
    },
    'description': 'הישיבה בראש צורים הוקמה תחת ארגון בית מדרש דרישה בארה״ב, ובהובלת הרבנית חנה גודינגר (דרייפוס) ובשנת 2108 פתחה את המחזור הראשון של תלמידות. הישיבה נועדה לנשים בגילאי העשרים עם רקע לימודי במדרשה ולאחר שירות הצבאי/הלאומי. מתכונתה היא מערכת לימודים מלאה של לימודי גמרא, תנ״ך, הלכה, מחשבה והגות, וכן יש עיסוק בתפילה ובכתיבה תורנית.',
    'description_ar': null,
    'display_organization_kind': 'מוסד תורני בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'השכלה'
      ],
      [
        'נערות וצעירות',
        'דת'
      ]
    ],
    'id': 'SW55',
    'is_active': true,
    'keywords': [
      'הלכה',
      'מנהיגות',
      'מדרשה',
      'תורה',
      'יהדות'
    ],
    'name': 'הישיבה בראש צורים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ראש צורים',
    'organization_kind': [
      'מוסד תורני',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'יהודה ושומרון',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'מוסד תורני',
    'primary_sub_field_of_activity': 'השכלה',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2019-08-13'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.drisha.co.il/home-page/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>דרישה ישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580632396'
      },
      {
        'title': 'ישיבת \'דרישה\' בראש צורים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/%D7%94%D7%99%D7%A9%D7%99%D7%91%D7%94-%D7%91%D7%A8%D7%90%D7%A9-%D7%A6%D7%95%D7%A8%D7%99%D7%9D-132513827549630/'
      },
      {
        'title': 'Drisha (n.d). <b>Yeshivat Drisha</b>. Retrieved from',
        'url': 'https://drisha.org/yeshiva/'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '13/08/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2018,
    'year_registered': 2016
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '02/01/2019'
    },
    'description': '‏״הכל למענך״ היא עמותה (ע״ר 580577245) שקמה בשנת 2013 במטרה לספק הכשרה מקצועית לנשים, כנראה בפרט ‏לנשים חרדיות מזרחיות. מבין מובילי העמותה נרשמות אביבה ח\'גבי ואורנה יחיאל. הראשונה היא ‏אשה חרדית מנתיבות הפעילה בשדות הצדק החברתי הממוסד והלא ממוסד. יתכן ופרוייקט העמותה ‏הוא בית ספר למקצועות היופי שהוקם בגבעת שמואל בשנת 2014 בהנהלת אורנה יחיאל.‏ בשנת 2018 התקיימה התקשרות ללא מכרז בין המשרד לשירותי דת לבין ״הכל למענך״ עבור קורס בלניות עבור התקופה 26.11.18-26.11.19 על סך 49,000 ש״ח.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'הכשרה מקצועית'
      ],
      [
        'דת ומעמד אישי',
        'תעסוקה ועבודה'
      ]
    ],
    'id': 'SW39',
    'is_active': true,
    'keywords': [
      'הכשרה מקצועית',
      'קידום נשים',
      'סיוע כלכלי',
      'בלניות'
    ],
    'name': 'הכל למענך',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'בני ברק',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הכשרה מקצועית',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>הכל למענך (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580577245'
      },
      {
        'title': 'אורנה ביוטי סנטר, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/ornabeautycenter/'
      },
      {
        'title': 'אורנה בית ספר למקצועות היופי, עמוד פייסבוק (לא פעיל מ-2014).',
        'url': 'https://www.facebook.com/%D7%90%D7%95%D7%A8%D7%A0%D7%94-%D7%91%D7%99%D7%AA-%D7%A1%D7%A4%D7%A8-%D7%9C%D7%9E%D7%A7%D7%A6%D7%95%D7%A2%D7%95%D7%AA-%D7%94%D7%99%D7%95%D7%A4%D7%99-1453788921570045/'
      },
      {
        'title': 'משרד המשפטים, היחידה הממשלתית לחופש המידע (2019, 14 ינואר). <b>התקשרויות רבעון 4 2018- המשרד לשירותי דת</b>. נדלה מתוך',
        'url': 'https://foi.gov.il/he/node/6463'
      },
      {
        'title': 'קניא, קטלא (2003, 23 אוקטובר). <b>״אני לא מורדת״ אישה יכולה למרוד רק בבעלה</b> [הודעה בפורום חדרי חרדים. המקור פורסם ככל הנראה במעריב]״. נדלה מתוך',
        'url': 'http://www.bhol.co.il/forums/topic.asp?topic_id=654099&forum_id=771'
      }
    ],
    'target_audiences': [
      'נשים חרדיות',
      'נשים מזרחיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '02/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'אקטיביזם רשת',
      'מחאה',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '03/06/2018'
    },
    'description': '״הכצעקתה״ עלה באוקטובר 2010 כשלוחה הישראלית של תנועת Hollaback העולמית. האתר הוקם על ידי קבוצה של סטודנטיות בירושלים ובדומה לאתרים המשוייכים לתנועה העולמית גם האתר הישראלי שם לו למטרה “לייצר מרחב בטוח בו ניתן להגיב, לספר ולצעוק חזרה את כל הפשעים ה\'קטנים\' שלא מדווחים ביומיום, ולתרום למודעות לגבי ההיקפים האמיתיים של הטרדות-הרחוב בישראל״. הקמת האתר לוותה בפרסומים בעיתונות הפופולרית ובטלוויזיה ובעקבות כך הגיעו אליו עשרות דיווחים, תגובות וסיפורים אישיים על הטרדות רחוב בישראל שפורסמו בציבור. בשיא הפעילות של הקבוצה (2010-2012) אשר פעלה בהתנדבות, הגיעו לאתר הישראלי כ-450 דיווחים על הטרדות רחוב. מתוך הדיווחים שהצטברו באתר עלה שתחבורה ציבורית, אוטובוסים ומוניות היו מרחבים בעייתיים ביותר עבור נשים. בנוסף, חברות הקבוצה קיימו שיתוף פעולה עם עיריית הועדה למעמד האשה בעיריית תל אביב שביצעה סקר טלפוני להערכת שכיחות התופעה של הטרדות רחוב בעיר בשנת 2011 ובו התגלה כי כ-80% מכלל הנשים עברו הטרדה מינית ומגדרית בחייהן.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'אלימות',
        'הטרדה מינית'
      ]
    ],
    'id': 'YB94',
    'is_active': false,
    'keywords': [
      'הטרדת רחוב',
      'אינטרנט',
      'נתונים'
    ],
    'name': 'הכצעקתה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'התארגנות שאינה עמותה',
      'בינלאומי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'אקטיביזם רשת',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'הטרדה מינית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-03'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://israel.ihollaback.org/'
      },
      {
        'title': 'הכצעקתה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pg/Haketzaakata/about/?ref=page_internal'
      },
      {
        'title': 'וילמובסקי, ענבל (2013). מהרחוב הממוגדר למרחב הווירטואלי ובחזרה: על הטרדות-רחוב ועל האתר <b>הכצעקתה</b>. רוני הלפרן (עורכת), <b>היכן אני נמצאת? פרפסקטיבות מיגדריות על מרחב</b> (עמ\' 313–351). אבן יהודה: קרן פרידריך אברט והמכללה האקדמית בית ברל. נדלה מתוך',
        'url': 'https://fes-org-il-pub.s3.amazonaws.com/Beit%20Berl/Where%20am%20I%20situated_hebr.pdf'
      },
      {
        'title': 'ליאור, אילן (2011, 23 נובמבר). 83% מנשות ת״א הוטרדו מינית במרחב הציבורי. <b>הארץ</b> נדלה מתוך',
        'url': 'https://www.haaretz.co.il/news/education/1.1573325'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '07/08/2019'
    },
    'year_closed': 2015,
    'year_closed_text': '2015',
    'year_founded': 2010,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחאה',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '13/10/2018'
    },
    'description': 'בינואר 1979, בצל מחלוקות שהתעוררו בוועידת האו״ם לענייני נשים בנוגע לשאלה הפלסטינית, החליט ארגון WILPF העולמי לסגור את הנציגות שלו בישראל. בשנת 1983 נפתח מחדש סניף של הליגה הבינלאומית של נשים לשלום וחופש - ישראל (WILPF) שהוקם על ידי קבוצת נשים יהודיות וערביות שהיו פעילות בארגוני שלום וזכויות אדם בישראל. הסניף נרשם כעמותה מקומית (מס\' 58013382) בשנת 1988. מטרותיה היו: ״לתפקד כסניף הישראלי של הליגה הבינלאומית של נשים לשלום וחופש -ג`נבה. לקיים קשרים בינלאומיים עם תנועות שלום אחרות. לפעול למען דו-קיום יהודי-ערבי במגמה ליצור גשר לשלום בין בני שני העמים.״ בתקופה זו נוסד גם סניף של הארגון הבינלאומי בפלסטין בהנהגת חנאן עוואד. העמותה פעלה באופן עצמאי עד שנת 2003 ובאופן הדרגתי התמזגה לתוך הפעילות של ״קואליציית נשים לשלום״. אשת קשר בתעודת הרישום היתה מרים בר-און זהבי. רכזת הפעילות של הארגון בישראל היתה עליה שטראוס.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'זכויות אדם'
      ]
    ],
    'id': 'SA61',
    'is_active': false,
    'keywords': [
      'שיתוף פעולה בינלאומי',
      'כיבוש'
    ],
    'name': 'הליגה הבינלאומית של נשים לשלום וחופש - ישראל W.I.L.P.F.',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-13'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://wilpf.org/israel/'
      },
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>הליגה הבינלאומית של נשים לשלום וחופש – ישראל W.I.L.P.F.</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'בנסקי, טובה (2006). ״קואליציית הנשים לשלום צודק״: פרויקט השלום הפמיניסטי כחלק מהמגמות לאזרוח החברה הישראלית. בתוך: בן רפאל, אליעזר, בראלי, אבי, יער, אפרים וכהן, אורי (עורכים), <b>ישראל והמודרניות, למשה ליסק ביובל</b> (עמ\' 524–549). באר שבע: מכון בן גוריון לחקר ישראל, הציונות ומורשת בן גוריון.'
      },
      {
        'title': 'Snyder, Anna C. (2003). <b>Setting the agenda for global peace: Conflict and consensus building</b>. (p.58). London, UK: Routledge. P. 58.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '15/10/2018'
    },
    'year_closed': 2003,
    'year_closed_text': '2003',
    'year_founded': 1983,
    'year_registered': 1988
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/05/2019'
    },
    'description': 'ה.ל.ה - הוקמה בינואר 1986 בשם ״הועד הציבורי למען החינוך בשכונות ובעיירות הפיתוח״. היא הוקמה על ידי קבוצת פעילי חינוך שכללה הורים, סטודנטים, אנשי חינוך, סופרים, חוקרים ואנשי תיאטרון, בהם: ד״ר שלמה סבירסקי, פרופ\' מאיר עמור, עו״ס אילנה שמאי, הסופר אמנון שמוש, השחקן יוסף שילוח, עו״ד יעקב אלעזר, האמן שלמה בר והפעיל החברתי יוסף דחוח-הלוי. הארגון החל את פעילותו בחיפה. קבוצות הורים ראשונות הופיעו בחצור הגלילית, בבאר יעקב, בראש העין, בשכונת דורה שבנתניה וברמת שקמה בתל אביב. חברי הקבוצה פעלו מתוך תחושה שמערכת החינוך לא תורמת תרומה מהותית לצמצום אי השוויון. ב-1987 נרשמה כעמותה (ע״ר 580111342) תחת השם: ״הלה למען החינוך בשכונות ובעיירות הפיתוח״ (הכתובת המופיעה בתעודת הרישום היא ארלוזורוב 88 בחיפה, משרדי אשה לאשה-מרכז פמיניסטי חיפה ,אך העמותה עברה לתל אביב כבר בסופה של אותה השנה) . מאז 1987 ועד פטירתה בשנת 2012, נוהל הארגון על ידי תקוה לוי, שהייתה ממובילות המאבק הפמיניסטי מזרחי בשנות ה-90. פעילות הל״ה היו ממארגנות הכנס הפמיניסטי-מזרחי הראשון בשנת 1996. מטרות העמותה הן לסייע לאמהות והורים מ״שכונות הערים ובעירות-פתוח להתארגן ולרכוש כלים ומיומנות לשם הפיכת בתי הספר למוסדות מתקדמים ולעודד אהורים להתארגן ולפעול לשיפור ההזדמנויות החינוכיות ולביטול אי- השוויון הקיים במערכת החינוך. מאבק להצבת ילדים מאזורים שונים על מסלולי למידה וקידום שווים.״ כיום פועל הארגון בקרב אוכלוסיות מוחלשות (עולים חדשים בעיקר יוצאי אתיופיה, תושבי שכונות ועיירות פיתוח, אזרחים ערבים מיישובים מוכרים ובלתי מוכרים) ומפעיל מרכז מידע וקו חם המעניק סיוע משפטי להורים שזכויות ילדיהם נפגעו במערכת החינוך; קבוצות הורים ופעילויות סנגור, כולל עתירות לבית המשפט, בנושאים הנוגעים לחינוך שוויוני. במאי 2020 הודיעה הנהלת הארגון כי בשל קשיים תקציביים שפקדו את הארגון בעת מגפת הקורונה הוחלט לסיים את פעילות העמותה לאחר 35 שנה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'חינוך',
        'צמצום פערים בחינוך'
      ]
    ],
    'id': 'SA2',
    'is_active': true,
    'keywords': [
      'זכויות',
      'חינוך',
      'סיוע משפטי',
      'קו סיוע',
      'פמיניזם מזרחי',
      'פריפריה',
      'צדק חברתי',
      'שוויון הזדמנויות',
      'ילדות/ים'
    ],
    'name': 'הל״ה למען החינוך בשכונות ובעיירות פיתוח',
    'name_ar': 'هيلا',
    'name_change_year': null,
    'name_common': null,
    'name_past': 'ה.ל.ה הועד הציבורי למען החינוך בשכונות ובעיירות הפיתוח',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'חינוך',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'צמצום פערים בחינוך',
    'primary_target_audience': 'נשים מזרחיות',
    'retrieved': {
      'type{date}': '2018-10-04'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://hila-equal-edu.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>הל״ה למען החנוך בשכונות ובעירות-פתוח (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580111342'
      },
      {
        'title': 'הל״ה (עמותה). <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%94%D7%9C%22%D7%94_(%D7%A2%D7%9E%D7%95%D7%AA%D7%94)'
      },
      {
        'title': 'אופנהיימר, ורד (2012). חיים מלאי תקווה – לזכרה של תקווה לוי (1961–2012). <b>מגדר: כתב עת למגדר ופמיניזם</b>, 1. נדלה מתוך',
        'url': 'https://a0892f23-8915-4259-a76e-148e464cfcf1.filesusr.com/ugd/6ec31f_28853bbf3a4e4c7d95cf6c0b7e5920b6.pdf'
      },
      {
        'title': 'חדשות הלה: הועד הציבורי למען החינוך בשכונות ובעיירות-הפיתוח (1986, ספטמבר) גיליון מס\' 4. נדלה מתוך',
        'url': 'http://hila-equal-edu.org.il/wp-content/uploads/2016/04/%D7%97%D7%93%D7%A9%D7%95%D7%AA-%D7%94%D7%9C%D7%94-%D7%A1%D7%A4%D7%98%D7%9E%D7%91%D7%A8-1986.pdf'
      },
      {
        'title': 'כהן, סתיו (2020, 30 מאי). עמותת הל״ה למען החינוך מסיימת את פעילותה. [פוסט פייסבוק]. נדלה מתוך',
        'url': 'https://www.facebook.com/stuv.cohen/posts/10218202564878762'
      },
      {
        'title': 'תורג\'מן, ורד (2011). <b>״מעברה על הדשא״: מיקומים פוליטיים מצטלבים במאבק להשתתפות שוויונית בזירה הפמיניסטית בשנות ה-90</b>. (עבודת גמר לקבלת תואר ״מוסמך למדעי החברה״). אוניברסיטת תל אביב'
      }
    ],
    'target_audiences': [
      'נשים מזרחיות',
      'נשים ערביות',
      'נשים יוצאות אתיופיה',
      'גברים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '22/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1986,
    'year_registered': 1987
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '31/12/2018'
    },
    'description': 'המדורים נוסדו בשנת 1982 כשיתוף פעולה בין שתי התנועות הקיבוציות הגדולות - הקיבוץ הארצי והתנועה הקיבוצית המאוחדת. בראשם עמדו נשים בעלות עמדות פמיניסטיות מוצהרות. שיתוף הפעולה בין המדורים הביא לתכנית פעולה ואסטרטגיה משותפת. המדורים פעלו ברמת הפרט, ברמת הקיבוץ וברמה התנועתית. ערכו סדנאות להעלאת מודעות, הרצאות וכנסים, פרסמו כתב עת בשם ״המשווה״, אספו וסיפקו מידע אודות תופעות של אי שוויון בקיבוצים, ניהלו מאבק להגברת שיעורי נשים בתפקידי מנהיגות וניהול, הקימו קרן מענקים לנשים שלמדו ניהול וקידמו העלאת שיעורי הגברים בעבודות החינוך והטיפול בקיבוצים. לאורך כל הדרך ספגו התנגדויות מחברי וחברות קיבוץ, על רקע היותן פמיניסטיות. פורקו ב-1992 על רקע קיצוצים תקציביים בין היתר בעקבות משבר הקיבוצים.\nבאוקטובר 2000 אוחדו שתי התנועות ל״תנועה הקיבוצית״ ובוועדיה משותפת בקיבוץ כנרת הוקמה ״היחידה לקידום נשים״.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'פוליטיקה ומנהיגות',
        'כללי'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'YH169',
    'is_active': false,
    'keywords': [
      'ניהול',
      'בידול תעסוקתי',
      'סיוע כלכלי',
      'העלאת מודעות',
      'שוויון מגדרי'
    ],
    'name': 'המדורים לשוויון בין המינים בתנועה הקיבוצית המאוחדת ובקיבוץ הארצי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'אדר, גילה (1996). נשים בקיבוץ: שינוי והמשכיות (1980–1995). <b>נשים בקיבוץ המשתנה, 146</b>. אוניברסיטת חיפה, המרכז הקיבוצי, המכון לחקר הקיבוץ והרעיון השיתופי, 20–38.',
        'url': 'http://kibbutz.haifa.ac.il/images/publications/wemem%20in%20changing%20kibbutz%20adar%20palgi.pdf'
      },
      {
        'title': 'זמיר, אביבה (1999). <b>מבעד לתקרת הזכוכית: נשים בתפקידי ניהול בכירים בקיבוץ</b>. רמת אפעל: יד טבנקין. עמ\' 120.',
        'url': 'https://kotar.cet.ac.il/KotarApp/Viewer.aspx?nBookID=101449030#1.5582.6.default'
      },
      {
        'title': 'מגדר בקיבוץ. <b>ויקיפדיה</b>.  נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%9E%D7%92%D7%93%D7%A8_%D7%91%D7%A7%D7%99%D7%91%D7%95%D7%A5'
      },
      {
        'title': 'פלגי, מיכל (1996). נשים בכלכלה הקיבוצית המשתנה. <b>נשים בקיבוץ המשתנה, 146</b>. אוניברסיטת חיפה, המרכז הקיבוצי, המכון לחקר הקיבוץ והרעיון השיתופי, 1–19.',
        'url': 'http://kibbutz.haifa.ac.il/images/publications/wemem%20in%20changing%20kibbutz%20adar%20palgi.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '31/12/2018'
    },
    'year_closed': 1992,
    'year_closed_text': '1992',
    'year_founded': 1981,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '16/09/2019'
    },
    'description': 'המדרשה בבר-אילן הוקמה בשנת 1976 כחלק מהמכון הגבוה לתורה באוניברסיטה שנוסדה כמה שנים קודם לכן. הרב פרופסור דניאל שפרבר הקים את המדרשה מתוך התפיסה שלימוד תורה חשוב לנשים כפי שהוא לגברים. בתחילה, הלימוד במדרשה היה בתצורת שיעורים פרונטליים, אך עם השנים ד״ר טובה גנזל, העומדת בראש המדרשה, קידמה את הלימוד ליותר מעמיק, רחב, ובשיטת לימוד ישיבתית. כיום, המדרשה מפעילה מגוון רחב של תוכניות, בינהן תוכניות מובנות המזכות במלגה המתמקדות כל אחת בתחום כגון גמרא ותורה שבעל פה, חסידות, זהות יהודית, ועוד. ישנן תוכניות יעודיות לדוקטורנטיות או לחוקרות, וכן גם לסטודנטיות ללא רקע דתי. המדרשה מארגנת כנסים ומפיצה דברי תורה, וכן החל משנת 2016 מפרסמת כתב עת מחקרי-תורני ״דרישה״ במטרה ״לתת במה ולעודד נשים לכתוב ברמה תורנית גבוהה בענייני תורה שבעל פה: משנה, גמרא, מדרש והלכה ובכך לקדם ולהעצים לימוד תורה של נשים בכלל ובמדרשה בפרט״.',
    'description_ar': null,
    'display_organization_kind': 'מוסד תורני בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'השכלה'
      ],
      [
        'השכלה גבוהה ומחקר',
        'אקדמיה, חברה וקהילה'
      ]
    ],
    'id': 'SW57',
    'is_active': true,
    'keywords': [
      'מדרשה',
      'תורה',
      'יהדות',
      'הלכה'
    ],
    'name': 'המדרשה בבר-אילן',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'המדרשה לבנות',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת גן',
    'organization_kind': [
      'מוסד תורני',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'מוסד תורני',
    'primary_sub_field_of_activity': 'השכלה',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2019-09-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://midrasha.biu.ac.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>המכון הגבוה לתורה ע״ש לודביג ז״ל ואריקה יסלזון (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580082121'
      },
      {
        'title': 'אוניברסיטת בר-אילן (אתר). <b>ציוני דרך היסטוריים</b>. נדלה מתוך',
        'url': 'https://www1.biu.ac.il/milestones'
      },
      {
        'title': 'המדרשה ע״ש לודביג ואריקה יסלזון, אוניברסיטת בר-אילן (אתר). <b>תיקון עולם</b>. נדלה מתוך',
        'url': 'https://midrasha.biu.ac.il/node/1314'
      },
      {
        'title': 'הקואליציה להבטחת תשלום מזונות ילדים (2015). <b>הצעה לתיקון חוק המזונות</b>. מוגש לוועדה לקידום זכויות הילד. נדלה מתוך',
        'url': 'http://rackmancenter.com/wp-content/uploads/2015/10/%D7%A0%D7%99%D7%99%D7%A8-%D7%A2%D7%9E%D7%93%D7%94-%D7%A9%D7%99%D7%A0%D7%95%D7%99-%D7%97%D7%95%D7%A7-%D7%94%D7%9E%D7%96%D7%95%D7%A0%D7%95%D7%AA-%D7%99%D7%95%D7%9D-%D7%94%D7%9E%D7%90%D7%91%D7%A7-%D7%91%D7%A2%D7%95%D7%A0%D7%99.pdf'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '16/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1976,
    'year_registered': 1991
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '31/05/2018'
    },
    'description': '״המועצה הלאומית לבריאות האישה״ הוקמה בשנת 2000 והראשונה לעמוד בראשה היתה ד״ר רחל אדטו. המועצה היא אחת מ-22 מועצות לאומיות המייעצות למשרד הבריאות ואשר חבריהן וחברותיהן ממונים/ת על ידי שר הבריאות או מנכ״ל משרד הבריאות. נכון לשנת 2018 יו״ר המועצה היא פרופ\' נעמה קונסטנטיני. תפקיד המועצה הלאומית לבריאות האישה הוא לבחון ולייעץ למשרד הבריאות בתחומים הבאים: השפעה על עיצוב מדיניות הבריאות בתחום בריאות נשים; קידום בריאות נשים; סוגיות ייחודיות בבריאות נשים; דירוג תעדוף של טכנולוגיות ותרופות עבור ועדת סל שירותי הבריאות.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'YH12',
    'is_active': true,
    'keywords': [
      'בריאות נשים',
      'לידה',
      'גניקולוגיה',
      'גיל המעבר',
      'הנקה',
      'הפלה',
      'הריון',
      'הפסקת הריון',
      'הפרעות אכילה',
      'פוריות',
      'מחלות כרוניות',
      'סרטן השד',
      'מיניות בריאה',
      'טכנולוגית פריון',
      'מועצה לאומית'
    ],
    'name': 'המועצה הלאומית לבריאות האישה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-31'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.health.gov.il/Services/Committee/NationalCouncils/WomanHealth/Pages/default.aspx'
      },
      {
        'title': 'קונסטסטיני, נעמה (2018). המועצה הלאומית לבריאות האישה. גרסיאלה ביל (רכזת), <b>המועצות הלאומיות לבריאות: דו״ח פעילות שנתית</b> (עמ\' 91–102).',
        'url': 'https://www.health.gov.il/Services/Committee/NationalCouncils/Documents/m2018.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/03/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/12/2019'
    },
    'description': 'ה״מועצה הלאומית לקידום מעמד האישה״ הוקמה ב-1984, כניסיון ליישם את ההמלצה הראשונה של דוח נמיר משנת 1978 שהמליצה להקים מועצה ציבורית כחלק מהקמת רשות ממלכתית לטיפול ומעקב בנושא מעמד האשה. יושבת הראש הראשונה של המועצה היתה פרופ\' רות לפידות שכיהנה כיו״ר כשנתיים. יו״ריות שכיהנו לאחר מכן היו פרופ\' מרילין ספר ונאוה ארד. למועצה לא היה מעמד סטטוטורי, היא הוקמה ללא הגדרות תפקיד ברורות וללא תקציב וכבר מראשיתה מנתה חברות רבות, נשים שמונו בשל הישגים אישיים, נציגות ארגוני נשים ואף כמה גברים. בשנת 1986 הוחלט להקים מספר צוותי משנה למועצה: נשים במועצת מנהלים; חינוך טכנולוגי לבנות; שירותי בריאות לנשים; נשים במועצות דתיות; אבטלת נשים; גיל פרישה וזכויות נלוות של נשים; זכויות הוריות בעבודה; בעיות נשים במגזר הערבי. מספר החברים והחברות בה התרחב עד לכ-200 בשנת 1992 מה שהפך אותה לגוף לא אופרטיבי. בשנת 1993 עם המינוי של נאוה ארד ל״יועצת ראש הממשלה למעמד האישה״, מינה ראש המשלה דאז יצחק רבין ז״ל ועדה מייעצת קטנה יותר בת 34 חברות והמועצה סיימה את תפקידה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'כללי'
      ]
    ],
    'id': 'YH176',
    'is_active': false,
    'keywords': [
      'קידום נשים',
      'מועצה לאומית',
      'חקיקה'
    ],
    'name': 'המועצה הלאומית לקידום מעמד האישה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הישיבה המאה-וארבע-עשרה של הכנסת השלוש-עשרה (‎7 ביולי 1993). ‎1512: התפטרות יושבת-ראש המועצה הלאומית לקידום מעמד האשה. נדלה מתוך אתר הכנסת',
        'url': 'http://knesset.gov.il/tql/knesset_new/knesset13/HTML_27_03_2012_06-21-01-PM/19930707@19930707030@030.html'
      },
      {
        'title': 'הוועדה למעמד האשה (1978). <b>צוותי הוועדה למעמד האשה: דיונים ומימצאים</b>. ירושלים: משרד ראש הממשלה.'
      },
      {
        'title': 'לנדס, דורית (1984, 5 ספטמבר). לא רוצות מהפכות. <b>מעריב</b>. נדלה מתוך',
        'url': 'http://www.jpress.nli.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=MAR%2F1984%2F09%2F05&id=Ar04502&sk=00FC07C7'
      },
      {
        'title': 'שדולת הנשים בישראל (1987). <b>מעמד האשה בישראל: בדיקת המלצות הועדה למעמד האשה 1978</b>. ירושלים: משרד ראש הממשלה.'
      },
      {
        'title': 'Halperin-Kaddari, Ruth (2004). <b>Women in Israel: A state of their own</b>. Pennsylvania studies in human rights. Philadelphia, Pa.: University of Pennsylvania Press. pp. 47.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '23/01/2020'
    },
    'year_closed': 1993,
    'year_closed_text': '1993',
    'year_founded': 1984,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'פילנתרופיה',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/10/2018'
    },
    'description': 'המועצה הלאומית של נשים יהודיות (The National Council of Jewish Women ‏- NCJW) הוא ארגון נשים אמריקאי יהודי שנוסד ב-1893. המועצה מבוססת על פעילות התנדבותית ברוח ערכים יהודיים וליברליים וחותרת לצדק חברתי באמצעות שיפור חייהן של נשים, ילדים ומשפחות והגנה על זכויות וחרויות הפרט. ״המועצה הלאומית של נשים יהודיות״ פועלת בישראל מאז הקמתה ותומכת בקידום זכויות נשים במספר דרכים: מתן מענקים ותרומות לארגוני נשים ותנועות פמיניסטיות, השתתפות בקואליציות של ארגוני נשים בישראל, כתיבת ניירות עמדה ומחקרים, סיוע לקידום החינוך, ההשכלה והמחקר בישראל. ה-NCJW סייע בהקמת המחלקה לחינוך באוניברסיטת עברית בירושלים וכן תמך בהקמת המכון לחקר הטיפוח בחינוך (RIFIE) באוניברסיטה עברית שנוסד בשנת 1968. בשנת 2001 המועצה סייעה לייסד את התכנית ללימודי נשים ומגדר באוניברסיטת תל אביב שהיתה התכנית הראשונה שהעניקה תואר בלימודי מגדר בישראל.',
    'description_ar': null,
    'display_organization_kind': 'בינלאומי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'חינוך',
        'כללי'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ]
    ],
    'id': 'SA58',
    'is_active': true,
    'keywords': [
      'לימודי מגדר',
      'צדק חברתי',
      'פמיניזם',
      'קידום נשים'
    ],
    'name': 'המועצה הלאומית של נשים יהודיות (NCJW)',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'בינלאומי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'פילנתרופיה',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'בינלאומי',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.ncjw.org/'
      },
      {
        'title': 'Rogow, Faith (2009. March 20). National Council of Jewish Women. In <b>Jewish women: A comprehensive historical encyclopedia</b>. Jewish women\'s archive. Retrieved from',
        'url': 'https://jwa.org/encyclopedia/article/national-council-of-jewish-women'
      },
      {
        'title': 'המועצה הלאומית של נשים יהודיות.<b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%94%D7%9E%D7%95%D7%A2%D7%A6%D7%94_%D7%94%D7%9C%D7%90%D7%95%D7%9E%D7%99%D7%AA_%D7%A9%D7%9C_%D7%A0%D7%A9%D7%99%D7%9D_%D7%99%D7%94%D7%95%D7%93%D7%99%D7%95%D7%AA'
      },
      {
        'title': 'Strichman, Nancy (2018). <b>Past Achievements and Future Directions of Women’s and Feminist Organizations in Israel</b>. Dafna Fund and NCJW. Retrieved from',
        'url': 'https://www.ncjw.org/wp-content/uploads/2018/03/Full-Report-of-Research.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '15/11/2018'
    },
    'description': 'המועצה הפוליטית לזכויות הגייז בישראל (ע״ר 580376069) הוקמה בשנת 2001 על מנת לקדם את המאבק ההומו-לסבי לשיוויון זכויות בכלים פוליטיים, ולקידום המנהיגות ההומו-לסבית, כולל בארגונים חברתיים ופוליטיים. מטרות העמותה היו: ״קידומו של המאבק ההומו-לסבי לשוויון. שימת דגש על קידומו של המאבק דרך המסגרות הפוליטיות השונות. עידודה והכשרתה של הנהגה הומו-לסבית בכל הארגונים החברתיים/פוליטיים. קידומם של פרוייקטים ספציפיים שיקדמו את המאבק לשוויון.״ בשנת 2001 המועצה פרסמה את ״הדוח הראשון לזכויות הומואים, לסביות, בי-סקסואלים וטרנסג\'נדרים לשנת 2001-2000״, שסקר את מצב הקהילה בישראל בנושאים שונים, כולל מערכת החינוך, מערכת המשפט, מערכת הבריאת, צה״ל והמערכת הפוליטית, כמו גם המלצות ורעיונות לקידום המאבק הלהט״בי לשיוויון. אחת הדרישות המשמעותיות של הדו״ח הייתה התנצלות של צה״ל על אפלית להט״ב במסגרת הצבא.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'זכויות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'כללי'
      ]
    ],
    'id': 'LR22',
    'is_active': false,
    'keywords': [
      'הומואים',
      'לסביות',
      'זכויות',
      'מחקר',
      'צה״ל',
      'קהילה',
      'זכויות להט״ב',
      'שיוויון'
    ],
    'name': 'המועצה הפוליטית לזכויות הגייז בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'זכויות',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>המועצה הפוליטית לזכויות הגייז בישראל</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': '(2018, 18 מאי). צה״ל צריך להתנצל על יחסו להומואים. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-1055968,00.html'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '15/11/2018'
    },
    'year_closed': 2005,
    'year_closed_text': '2005',
    'year_founded': 2001,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '03/10/2020'
    },
    'description': 'המועצה הציבורית לקידום ילדות, נערות ונשים בספורט, פועלת מתוקף החלטת ממשלת ישראל מספר 3416, משנת 2005. החלטת הממשלה התקבלה בעקבות המלצות הוועדה המייעצת שמינתה שרת התרבות והספורט, לימור לבנת (״ועדת קונסטנטיני״) בשנת 2004. המועצה משמשת גוף מייעץ לממשלה, למשרד התרבות והספורט ולשרה הממונה באשר לקידום ולפיתוח ספורט הנשים בישראל. המועצה פועלת לקידום מדיניות התומכת בספורט הנשים, לרבות פיתוח ענפי ספורט אולימפיים ובגיבוש המלצות לקידום מנהיגות נשים בספורט הנשים בישראל. המועצה יוזמת תכניות פעולה רב-שנתיות ליצירת תשתית בפריסה רחבה לפעילות של ספורט נשים וקידום ספורט הישגי. כמו כן, עוסקת המועצה בשינוי עמדות בקרב הציבור בישראל בכל הנוגע לספורט הנשים. הרכב חברות וחברי המועצה מגוון ובעל רקע מקצועי, חינוכי, וערכי לתחום הספורט ולקידום השיוויון המיגדרי בישראל. חברות וחברי המועצה תורמים מניסיונם להגשמת החזון והמטרות שלאורן הוקמה המועצה ומסייעים במישורים שונים לקידום ספורט הנשים בישראל. ליו״ר המועצה הראשונה מונתה הגב\' חנה גרטלר. בחודש מאי 2013, מונתה ליו״ר המועצה הגב\' מיכל כפרי ירדני במקום.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'ספורט'
      ]
    ],
    'id': 'YH210',
    'is_active': true,
    'keywords': [
      'ספורט',
      'מועצה לאומית'
    ],
    'name': 'המועצה הציבורית לקידום ילדות, נערות ונשים בספורט',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נתניה',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'ספורט',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2020-03-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.gov.il/he/departments/units/promot_women_sports'
      },
      {
        'title': 'אתנה: המרכז לקידום ספורט הנשים בישראל (אין תאריך). <b>המועצה הציבורית</b>. נדלה מתוך',
        'url': 'http://www.athenawomen.org.il/%d7%94%d7%9e%d7%95%d7%a2%d7%a6%d7%94-%d7%94%d7%a6%d7%99%d7%91%d7%95%d7%a8%d7%99%d7%aa/'
      },
      {
        'title': 'מבקר המדינה ונציב תלונות הציבור (2013). היבטים בפעולות לקידום ספורט נשים בישראל.  יוסף חיים שפירא (מבקר המדינה), <b>דוח מבקר המדינה 63ג, לשנת 2012 ולחשבונות שנת הכספים 2011</b> (עמ\' 1481–1545). נדלה מתוך',
        'url': 'http://www.mevaker.gov.il/he/Reports/Report_114/d9c55a26-855b-4c9d-8f72-444c2943c341/7994.pdf'
      },
      {
        'title': 'מזרחי, שלי (2013, 24 יוני). <b>שילוב נשים בספורט: פעילות המועצה הציבורית לקידום ספורט הנשים בישראל</b>. ירושלים: מרכז המידע והמחקר של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/e6ef6d8d-f1f7-e411-80c8-00155d01107c/2_e6ef6d8d-f1f7-e411-80c8-00155d01107c_11_10006.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '10/03/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2006,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '24/05/2018'
    },
    'description': '״המועצה לקידום נשים במדע ובטכנולוגיה״, הוקמה מתוקף החלטת ממשלה 2660 מדצמבר 2000 במטרה ״להגדיל את התוצר הלאומי ולשפר את איכות החיים באמצעות הגדלת השתתפות נשים בתחומי מדע וטכנולוגיה״. המועצה מתאמת בין גורמים ממלכתיים, ציבוריים ופרטיים לצורך קידום נשים במדע ובטכנולוגיה: המועצה מתכננת ומבצעת פעילויות המעודדות קידום נשים במדע ובטכנולוגיה, מרכזת את הפעילות הישראלית מול האיחוד האירופי ופועלת להעלאת המודעות הציבורית לבעיות הקשורות בתחום. נוסף לכך, תומכת המועצה במיזמים ובפעולות לקידום נשים בחינוך, באקדמיה ובתעשייה. במועצה מכהנות: נציגת המדענים הראשיים במשרדי הממשלה, מנהלת מינהל המדע במשרד החינוך, מנהלת המכון להכשרה טכנולוגית בתמ״ת, נציגת הוועדה לתכנון ותקצוב, יו״ר פורום המנהלות בתעשייה ויועצת הרמטכ״ל לענייני מגדר.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף אקדמי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'קידום נשים במדע'
      ],
      [
        'חינוך',
        'מדע וטכנולוגיה'
      ],
      [
        'נערות וצעירות',
        'מדע וטכנולוגיה'
      ]
    ],
    'id': 'YH7',
    'is_active': true,
    'keywords': [
      'מחקר',
      'תעסוקה',
      'קידום נשים',
      'טכנולוגיה',
      'שיתוף פעולה בינלאומי',
      'מועצה לאומית'
    ],
    'name': 'המועצה לקידום נשים במדע ובטכנולוגיה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי',
      'אקדמי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים במדע',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2020-02-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.gov.il/he/departments/Units/most_women_council'
      },
      {
        'title': 'מסר-ירון, חגית, מאור, ענת וכהנוביץ, שירלי (2004). קידום הנשים במדע ובסגל האקדמי בישראל. בתוך: מאור, ענת (עורכת), <b>העדפה מתקנת והבטחת ייצוג בישראל</b> (עמ\' 331–350). תל אביב: רמות. נדלה מתוך',
        'url': 'http://www.kotar.co.il/KotarApp/Viewer.aspx?nBookID=92677230#4.8381.6.default'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '17/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות',
      'שירותים משפטיים'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': 'המוקד הוקם בשנת 1998 תחת השם ״מוקד סיוע לעובדי חוץ במעצר״ על-ידי קבוצה של תושבי תל אביב, שהתאגדה בעקבות סדרת כתבות בשם “התל אביבים החדשים” בעיתון “העיר”, שעסקה בניצולם החמור של מהגרי העבודה. ב-1999 נרשמו כעמותה (ע״ר: 580333094) בשם ״העמותה לסיוע לעובדים הזרים הכלואים בישראל״, במשרדי קו לעובד. בשנת 2001 שונה שם העמותה ל״מוקד סיוע לעובדים זרים״ וב-2013 שונה השם לשמה הנוכחי ״המוקד לפליטים ולמהגרים״. העמותה שמה לה למטרה לקדם את זכויותיהם של מהגרי עבודה ופליטים ולהגן עליהם, ולהילחם בסחר בבני אדם בישראל. המוקד מפעיל קו חם המאוייש על ידי מתנדבים המספקים ייצוג וסיוע פארא-משפטי (paralegal) מול בית הדין לביקורת משמורת הפועל בבתי הכלא, מול בית הדין לעררים וכן מול רשויות שונות כגון רשות האוכלוסין, יחידת האכיפה ברשות האוכלוסין, משטרת ישראל ועוד. בנוסף, המוקד עוסק בפעילות משפטית הכוללת הגשת עתירות במטרה לקדם שקיפות, אחריות ואכיפה של חוקי המדינה שנועדו להגן על פליטים ומהגרים. בין ההישגים במישור זה ניתן למנות: טיפול רפואי ואשרות עבודה לקורבנות סחר למטרות זנות המעידות כנגד סוחרי האדם, ביקורת שיפוטית על הליכי מעצר וגירוש של מהגרים והשגת פיצויים לקורבנות הסחר מידי סוחריהן. בשיתוף פעולה עם ארגונים נוספים פעל המוקד לביטול כליאה ללא הגבלת זמן של מבקשי מקלט, סגירת מתקן “חולות” ומניעת גירוש מבקשי המקלט לאוגנדה ולרואנדה. המוקד אף עוסק בפעילות ציבורית הכוללת עבודה מול התקשורת, סיורים וסדנאות חינוכיות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'הגירה',
        'פליטות ומבקשות מקלט'
      ],
      [
        'תעשיית המין',
        'סחר בנשים'
      ]
    ],
    'id': 'YB76',
    'is_active': true,
    'keywords': [
      'קו סיוע',
      'פליטות ומבקשות מקלט',
      'סחר בבני אדם',
      'סיוע משפטי',
      'הסברה',
      'העלאת מודעות',
      'מחאה',
      'זכויות',
      'מהגרות עבודה'
    ],
    'name': 'המוקד לפליטים ולמהגרים',
    'name_ar': null,
    'name_change_year': 2013,
    'name_common': null,
    'name_past': 'מוקד סיוע לעובדים זרים',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'הגירה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פליטות ומבקשות מקלט',
    'primary_target_audience': 'נשים מהגרות עבודה או חסרות מעמד',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://hotline.org.il/main/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>המוקד לפליטים ומהגרים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580333094'
      },
      {
        'title': 'המוקד לפליטים ולמהגרים. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%94%D7%9E%D7%95%D7%A7%D7%93_%D7%9C%D7%A4%D7%9C%D7%99%D7%98%D7%99%D7%9D_%D7%95%D7%9C%D7%9E%D7%94%D7%92%D7%A8%D7%99%D7%9D'
      },
      {
        'title': 'המטה למאבק בסחר בנשים ובזנות. הקואליציה למאבק בזנות (ללא תאריך). <b>המוקד לפליטים ומהגרים</b> (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים מהגרות עבודה או חסרות מעמד',
      'גברים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '14/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': 1999
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחאה'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '26/01/2019'
    },
    'description': 'המטה הגאה ב״יש עתיד״ הוקם ב - 2012, במקביל להקמת המפלגה ביוזמתו של יו״ר המפלגה, יאיר לפיד. לפיד פנה לזוהרית שורק אשר הייתה פעילה בקהילה הגאה ומעורבת בפעילות הגאה במפלגת קדימה והציע לה לקחת חלק בהקמת המפלגה. בבחירות 2015 שורק שובצה ברשימת המפלגה לכנסת. המטה הגאה פועל לקידום זכויות הקהילה בתוך המפלגה ומחוצה לה. התא פועל בפריסה ארצית, מקיים מפגשי פעילים, מפגשים לקהילה עם חברי הכנסת של המפלגה, משתתף בארועי מחאה ומצעדים קהילתיים ומקדם את זכויות הקהילה ברשת. בתקופה בה ״יש עתיד״ ישבה בקואליציה, זכה התא לביקורת מצד הקהילה, כאשר מתוקף המשמעת הקואליציונית, חברי הכנסת של המפלגה הצביעו נגד הצעות חוק למען הקהילה. בבחירות 2019 ״יש עתיד״ חברה למפלגות ״חוסן לישראל״ ו״תל״מ״ שהפכו ביחד למפלגת ״כחול לבן״ בהנהגת בני גנץ. בעקבות זאת, המטה הגאה של יש עתיד שינה את שמו ל״המטה הגאה - כחול לבן״.',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'להט״ב',
        'פוליטיקה ומנהיגות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ]
    ],
    'id': 'LR50',
    'is_active': true,
    'keywords': [
      'חקיקה',
      'כנסת',
      'גאווה',
      'מצעד',
      'זכויות להט״ב',
      'תאים מפלגתיים'
    ],
    'name': 'המטה הגאה - יש עתיד',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'ארליך, גיא (2012, 16 נובמבר). פתק ורוד: הפוליטיקאים מחזרים אחר הקהילה הגאה. <b>הארץ</b>. נדלה מתוך',
        'url': 'https://www.haaretz.co.il/gallery/night-life/1.3411660'
      },
      {
        'title': 'המטה הגאה - יש עתיד (2018, 26 ינואר). הפרטים אומתו בשיחה של ליהי רוטשילד עם אבי סופר.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '26/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2012,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': 'המטה למאבק בסחר בנשים הוקם בשנת 2003, כשיתוף פעולה בין עמותת עצו״מ – עבודה צדקה ומשפט (ע״ר 580411775) ומשרד עו״ד כבירי-נבו-קידר-בלום ושות\'. המטה פועל בתחומי המשפט, קידום המדיניות והפעילות הציבורית במטרה למגר את תופעות הזנות והסחר בנשים לישראל. בתחילת דרכו קידם המטה את העלאת המודעות לתופעת הסחר בנשים וליצירת לחץ מקומי ובינלאומי על ישראל להביא למיגורה. לקראת סוף העשור הראשון של שנות ה-2000 החל המטה למקד את עיקר מאמציו במאבק בצריכת זנות. המטה הוביל, בשיתוף עם ארגוני חברה אזרחית וחברי כנסת מכלל הקשת הפוליטית, את המאבק להפללת לקוחות זנות בישראל. בנוסף, פועל המטה בזירה החינוכית במטרה להגביר את תודעת הציבור להשפעות הקשות והחמורות של תעשיית הזנות ומעודד שיח ציבורי בנושא, באמצעות ערוצי התקשורת, הרצאות ופאנלים. מאז שנת 2013 המטה מרכז את ״הקואליציה למאבק בזנות״ הכוללת 13 ארגונים ישראליים הפועלים בשותפות במאבק בצריכת זנות, בהם ארגונים ממשלתיים, חצי ממשלתיים ועמותות. מטרת הקואליציה היא לקדם את הרחבת שירותי הטיפול והשיקום לשורדות הזנות, להיאבק בזנות באמצעות קידום חקיקה לאיסור צריכת זנות ולפעול לשינוי תפיסות הציבור והעלאת מודעות ביחס לזנות.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'הגירה',
        'סחר בבני אדם'
      ],
      [
        'תעשיית המין',
        'זנות'
      ]
    ],
    'id': 'YB82',
    'is_active': true,
    'keywords': [
      'סחר בנשים',
      'זנות',
      'הפללת צרכני זנות',
      'חקיקה',
      'משפט',
      'העלאת מודעות',
      'חינוך',
      'תקשורת'
    ],
    'name': 'המטה למאבק בסחר בנשים ובזנות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'בית שמש',
    'organization_kind': [
      'התארגנות שאינה עמותה',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'הגירה',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'סחר בבני אדם',
    'primary_target_audience': 'נשים מהגרות עבודה או חסרות מעמד',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://tfht.org/hebrew/%D7%90%D7%95%D7%93%D7%95%D7%AA/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עצום – עבודות צדקה ומשפט (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580411775'
      },
      {
        'title': 'המטה למאבק בסחר בנשים ובזנות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pg/TaskForceHumanTrafficking/about/?ref=page_internal'
      },
      {
        'title': 'המטה למאבק בסחר בנשים ובזנות (ללא תאריך). <b>הקואליציה למאבק בזנות</b>. נדלה מתוך',
        'url': 'https://tfht.org/hebrew/%d7%90%d7%95%d7%93%d7%95%d7%aa/%d7%94%d7%a7%d7%95%d7%90%d7%9c%d7%99%d7%a6%d7%99%d7%94-%d7%9c%d7%9e%d7%90%d7%91%d7%a7-%d7%91%d7%96%d7%a0%d7%95%d7%aa/'
      },
      {
        'title': 'עצו״מ – עבודות צדקה ומשפט (ללא תאריך). <b>המטה למאבק בסחר בנשים</b>. נדלה מתוך',
        'url': 'http://atzum.org/hebrew/projects/task-force-on-human-trafficking/'
      }
    ],
    'target_audiences': [
      'נשים מהגרות עבודה או חסרות מעמד',
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '16/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2003,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'שירותים משפטיים'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/01/2019'
    },
    'description': 'תפקיד ״הממונה על חוק עבודת נשים״ במשרד העבודה והרווחה הוא לבחון בקשות של מעסיקים לפיטורי נשים המוגנות על פי חוק עבודת נשים, לערוך שימועים ולתת היתרים רק במקרה שהבקשה מוצדקת. הממונה פועלת תחת מינהל הסדרה שהוא אחת משתי הזרועות של מינהל הסדרה ואכיפה במשרד העבודה והרווחה (אוחדו ב-2004). מינהל האכיפה אחראי על איתור מעסיקים שפיטרו נשים בהריון שלא כחוק ולהביאם לשימוע. \nה״ממונה על חוק עבודת נשים״ נוסדה כמנגנון שנועד להחליף את האגף לפיקוח על חוקי עבודה במשרד העבודה/המפקח על יחסי עבודה, שנסגר בערך בשנת 2003 והיה מנגנון ״רזה״. המנגנון הרזה שיקף את הדרישות המקוריות בחוק עבודת נשים מ-1954. לפי החוק, בסמכות שר העבודה ניתן היתר הפיטורין של נשים בהריון והשר האציל זאת על המפקח הראשי על חוקי עבודה. באוגוסט 2004, אהוד אולמרט, אז שר התמ״ת האציל סמכויות באופן רשמי לממונה על חוק עבודת נשים רבקה מקובר.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'YH170',
    'is_active': true,
    'keywords': [
      'זכויות',
      'זכויות בעבודה',
      'לידה',
      'הריון',
      'אפליה מגדרית בתעסוקה',
      'אפליה בתעסוקה',
      'אמהות',
      'שירות ציבורי'
    ],
    'name': 'הממונה על חוק עבודת נשים במשרד העבודה והרווחה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': 'האגף לפיקוח על חוקי עבודה במשרד העבודה',
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'זכויות ומדיניות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-01-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://employment.molsa.gov.il/employment/workrights/licensesandpermits/permits/pages/permitwomendismissal.aspx'
      },
      {
        'title': 'מבקר המדינה ונציב תלונות הציבור (2008). אכיפת חוקי העבודה. מיכה לינדנשטראוס (מבקר המדינה), <b>דוח שנתי 58ב לשנת 2007 ולחשבונות שנת הכספים 2006</b> (עמ\' 1105–1141). נדלה מתוך',
        'url': 'http://www.mevaker.gov.il/he/Reports/Report_326/f0c0a616-b3dc-43aa-88c3-bedc811ee2b4/part-141-ver-4.pdf'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 5349 (2004, 14 דצמבר). <b>העברת סמכויות, מינוי מפקחת עבודה</b>. הממונה על חוק עבודת נשים במשרד העבודה והרווחה. עמ\' 764–765. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_word/Law10/yalkut-5349.pdf'
      },
      {
        'title': 'תושב-אייכנר, נירית ופרנקל, מיכל (2011). הגנת המדינה על עובדות הרות מפני פיטורים בישראל: האם זה עובד ועבור מי? <b>הרבעון לכלכלה, 58</b>, 1(2), 41–65. נדלה מתוך',
        'url': 'https://www.jstor.org/stable/23781902?seq=1#metadata_info_tab_contents'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/11/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מדיניות ציבורית',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '23/10/2018'
    },
    'description': 'ההמלצה למנות ״ממונות על מעמד האשה״ במשרדי ממשלה וברשויות המקומיות הופיעה לראשונה בדו״ח נמיר משנת 1978. בהמלצה 218 בדו״ח נאמר ״בכל משרד ממשלתי ובכל רשות מקומית תמונה אשה שתפקידה לטפל בבעיותיהן המיוחדות של נשים באותו משרד או רשות״. כעשור מאוחר יותר, בעקבות החלטת הממשלה מס\' 548 בדבר מתן שוויון הזדמנויות לעובדות ולעובדים בשירות המדינה (28 אפריל 1985) וכדי ליישם את חוק שוויון הזדמנויות בעבודה (1988) קיבלה הממשלה בשנת 1990 את המלצות ועדת קוברסקי. ההמלצות קבעו שיש לעגן ולתקצב את תפקיד הממונות ולהכפיף אותן ליועצת ראש הממשלה למעמד האשה. בשנת 1991, ביוזמת יועצת ראש הממשלה למעמד האשה עו״ד אתיה שמחה, נקבעו בתקשי״ר הוראות מיוחדות בדבר מינוי ממונות על מעמד העובדות בכל משרדי הממשלה. מאוחר יותר, בהמלצות ועדת בן-ישראל (1993) נקבע שיש להקים יחידה בנציבות שירות המדינה שאליה יוכפפו הממונות. משנת 1995, ה״אגף לקידום ושילוב נשים בנציבות שירות המדינה״ אחראי על מינוי, הכשרה, ליווי ופיקוח על עבודת הממונות. בשנת 2014, בעקבות דוח שטאובר שונה שם התפקיד ל״ממונה על שוויון מגדרי וקידום מעמד האישה״. בשנת 2018 היו כ-80 ממונות במשרדים ורשויות ממשלתיות. תפקידן העיקרי הוא: קידום הנושאים הרלוונטיים, לרבות מניעת הטרדה מינית והתנכלות, ייצוג הולם, אפליה מגדרית, זכויות נשים וזכויות הורות. הממונות מופקדות גם על העברת מידע רלוונטי והטמעתו במשרד בקרב מקבלי החלטות והעובדים. במקרים חריגים, יש ממונות שאחראיות על יישום פקודות וחוקים ייחודיים, כמו למשל הממונה על סטטיסטיקה מגדרית בלמ״ס שפועלת באופן ייחודי על פי התיקון לפקודת הסטטיסטיקה (2010).',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'SA67',
    'is_active': true,
    'keywords': [
      'הטרדה מינית',
      'אפליה מגדרית בתעסוקה',
      'ייצוג הולם',
      'קידום נשים',
      'העצמה'
    ],
    'name': 'הממונות על שוויון מגדרי וקידום מעמד האישה',
    'name_ar': null,
    'name_change_year': 2014,
    'name_common': null,
    'name_past': 'הממונות לקידום מעמד האשה',
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-23'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.gov.il/he/departments/units/woman_unit'
      },
      {
        'title': 'משרד ראש הממשלה, נציבות שירות המדינה (2014, 8 יוני). <b>דוח הוועדה לקידום נשים בשירות המדינה</b> (דו״ח שטאובר). ירושלים. נדלה מתוך',
        'url': 'https://www.gov.il/he/departments/publications/reports/report_women_committee_2014'
      },
      {
        'title': 'שטינברג, פנינה (2012). <b>מקידום נשים להטמעת חשיבה מגדרית: תמורות בתפקיד הממונה על קידום מעמד האישה במשרדי הממשלה – מחקר מדיניות</b>. שוות: המרכז לקידום נשים בזירה הציבורית. ירושלים: ון ליר. נדלה מתוך',
        'url': 'https://www.vanleer.org.il/sites/files/product-pdf/%D7%AA%D7%A4%D7%A7%D7%99%D7%93%20%D7%94%D7%9E%D7%9E%D7%95%D7%A0%D7%95%D7%AA%20%D7%A2%D7%9C%20%D7%A7%D7%99%D7%93%D7%95%D7%9D%20%D7%9E%D7%A2%D7%9E%D7%93%20%D7%94%D7%90%D7%A9%D7%94%20-%20%D7%9E%D7%97%D7%A7%D7%A8%20%D7%9E%D7%93%D7%99%D7%A0%D7%99%D7%95%D7%AA.pdf'
      },
      {
        'title': 'שקד, רבקה (2004). יישום החוק להעדפה מתקנת בשירות המדינה. בתוך: מאור, ענת (עורכת), <b>העדפה מתקנת והבטחת ייצוג בישראל</b> (עמ\' 261–278). תל אביב: רמות. נדלה מתוך',
        'url': 'https://kotar-cet-ac-il.ezproxy.bgu.ac.il/KotarApp/Viewer.aspx?nBookID=92677230&sSelectedTab=tdBookInfo#1.0.8.fitwidth'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '23/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1990,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '17/05/2018'
    },
    'description': '״המקלט לנשים מוכות אשדוד״ היה המקלט הרביעי שהוקם בארץ, אך הראשון שהוקם כשירות משולב במערכת שירותי הרווחה. המקלט הוקם כמפעל ניסיוני בדצמבר 1983 כשיתוף פעולה בין שלושה גורמים: ויצו, המוסד לביטוח לאומי ומשרד העבודה והרווחה. היוזמה להקמתו היתה של מיכל מודעי יו״ר ויצו ישראל, רינה ברקאי מנהלת ענף לאמהות וילדים במוסד לביטוח לאומי ויפה לונדון-יערי שהיתה מנהלת השירות לרווחת הפרט והמשפחה. לאחר תקופת חיפושים, ראש עיריית אשדוד הביע נכונות לתת חסות למקלט והעירייה תרמה מבנה. בשנתיים הראשונות התחלקו שלושת הגופים בתכנון, מימון והפעלת המקלט מתוך כוונה שלאחר מכן הוא יהפוך להיות חלק ממערך השירותים הסוציאליים של משרד הרווחה בהפעלת ויצו. עם הקמת המקלט הוגדרו שלוש מטרות עיקרות לקיומו: ״מתן מקלט פיזי לאשה המוכה ולילדיה, מתן תמיכה וחיזוק לאשה ולילדיה בתקופת השהות במקלט, הכנת האשה לקראת חזרתה לקהילה״. על פי הדוח שהוגש לועידת CEDAW (1997), עד שנת 1995 משרד הרווחה כיסה כ- 50% מהוצאות המקלטים ובשנת 1996 הועלתה ההשתתפות לכ-75% מההוצאות של קיום המקלטים.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YB43',
    'is_active': true,
    'keywords': [
      'נשים מוכות',
      'מקלט',
      'ביטחון אישי',
      'מחקר',
      'דיור',
      'סיוע משפטי'
    ],
    'name': 'המקלט לנשים מוכות באשדוד',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'אשדוד',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-17'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.wizo.org.il/%D7%A1%D7%A0%D7%99%D7%A3-%D7%95%D7%99%D7%A6%D7%95-%D7%90%D7%A9%D7%93%D7%95%D7%93'
      },
      {
        'title': 'ינאי, אורי (2005). מקלטי נשים בישראל: מחדשנות וולנטרית לאימוץ ממלכתי. <b>ביטחון סוציאלי, 70</b>, 77–109. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/SocialSecurity/70/article5.pdf'
      },
      {
        'title': 'פינטון, נעמי, סלעי, נעמי (1985). <b>מקלט לנשים מוכות אשדוד: מעקב מחקרי, 22</b>. המשרד לביטוח לאומי ומשרד העבודה והרווחה. מפעלים מיוחדים. נדלה מתוך',
        'url': 'https://www.btl.gov.il/Publications/Special_Activities_publications/Pages/mifal22.aspx'
      },
      {
        'title': 'Convention on the Elimination of All Forms of Discrimination against Woman. Distr.: General, 8 April 1997. CEDAW / C / ISR / 1-2.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1983,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '21/07/2019'
    },
    'description': 'המקלט לנשים מוכות הוקם על ידי ויצו בשנת 1995 בשיתוף ובמימון משרד הרווחה ופועל בדומה למקלט שייסדה ויצו באשדוד בשנת 1983. הוא אחד משלושת המקלטים הפועלים בירושלים. במהלך שנות פעילותו סייע המקלט ליותר מ- 1400 נשים מרקעים מגוונים ול-1800 ילדים שהגיעו עימן. במהלך השהייה במקלט, שנמשכת כחצי שנה, מקבלות הנשים חדר משפחתי וליווי לפי צורכיהן - כולל סיוע מצד עובדות סוציאליות ופסיכולוגים. הילדים זוכים להעשרה לימודית, חוגי העשרה, אבחונים, טיולים וקייטנות.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'SA144',
    'is_active': true,
    'keywords': [
      'נשים מוכות',
      'מקלט',
      'ביטחון אישי',
      'דיור'
    ],
    'name': 'המקלט לנשים מוכות- ויצו ירושלים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'ויצו (אתר). <b>מקלטים לנשים מוכות</b>. נדלה מתוך',
        'url': 'http://www.wizo.org.il/page_35681'
      },
      {
        'title': 'ויצו (אתר). <b>20 שנות פעילות למקלט לנשים מוכות – ויצו ירושלים</b>. נדלה מתוך',
        'url': 'http://www.wizo.org.il/page_35507'
      },
      {
        'title': 'ינאי, אורי (2005). מקלטי נשים בישראל: מחדשנות וולנטרית לאימוץ ממלכתי. <b>ביטחון סוציאלי, 70</b>, 77–109. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/SocialSecurity/70/article5.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '21/07/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1995,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '08/11/2018'
    },
    'description': 'המרכז האקוטי לנפגעי תקיפה מינית בסורוקה הוקם ב-2012 והוא אחד מ-5 מרכזים אקוטיים לטיפול בנפגעות תקיפה מינית, באחריות ובתקצוב משרד הבריאות. על פי כתבות בעיתונות ומפרוטוקול מישיבה הוועדה למעמד האישה שעסקה בנושא המרכז מצוי במשבר על רקע תת-תקצוב ומתקשה לספק את השירותים לתושבות הדרום.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'YH140',
    'is_active': true,
    'keywords': [
      'טראומה',
      'אונס',
      'מחלות מין',
      'הריון',
      'בית חולים',
      'משפט'
    ],
    'name': 'המרכז האקוטי לנפגעי תקיפה מינית בסורוקה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'אנגל משעלי, נעמה (2016, 17 אוגוסט). בשל מחסור בתקציב: נפגעות תקיפה מינית מוותרות על טיפול. <b>NRG</b>. נדלה מתוך',
        'url': 'https://www.makorrishon.co.il/nrg/online/1/ART2/814/127.html'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2017, 10 ינואר). <b>פרוטוקול מס\' 137: טיוב הטיפול הראשוני בנפגעות אלימות מינית - חדרי מיון ומרכזים אקוטיים</b>. נדלה מתוך',
        'url': 'https://oknesset.org/meetings/2/0/2011732.html'
      },
      {
        'title': 'מרכז רפואי סורוקה (2012, 12 ינואר). <b>מרכז לטיפול בנפגעות תקיפה מינית נחנך בסורוקה</b>. נדלה מתוך',
        'url': 'https://hospitals.clalit.co.il/soroka/he/news/Pages/news-12-1-12.aspx'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/08/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2012,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '05/10/2018'
    },
    'description': 'המרכז הגאה הוקם על ידי עיריית תל אביב בינואר 2008 כשירות עירוני ייחודי, בעקבות סקר בנוגע לצרכי הקהילה שהתקיים ב - 2004. הוא ממוקם במבנה בן שלוש קומות בגן מאיר. המרכז מספק מגוון שירותים לקהילה הגאה - מרכז תרבותי, מקום מפגש לקבוצות פעילות (כולל קבוצה ביסקסואלית, ״רדוגה״ - להט״ביות רוסיות ו״בשלה״ - לסביות מגיל 45 ומעלה), חוגים יעודיים כמו יוגה קווירית והגנה עצמית לטרנס*, קליניקה לבדיקות מחלות מין ומרפאה, גן ילדים גאה, בית קפה, שירותי יעוץ שונים, מרחב פעילות לארגונים כמו חוש״ן ואיג״י ועוד. המימון למרכז ולעובדים המועסקים בו מגיע ברובו מעיריית תל אביב, בשיתוף עם ארגוני חברה אזרחית. כמו כן, מספר רב של מתנדבים המעורבים בהפעלתו של המרכז.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'בריאות ופריון',
        'בריאות ומגדר'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'LR2',
    'is_active': true,
    'keywords': [
      'גאווה',
      'קהילה',
      'חוגים',
      'מרפאות',
      'מעונות ומשפחתונים',
      'תאטרון',
      'פנאי',
      'תמיכה נפשית',
      'מחלות מין'
    ],
    'name': 'המרכז העירוני לקהילה הגאה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'המרכז הגאה',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-05-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.lgbtqcenter.org.il/'
      },
      {
        'title': 'המרכז הגאה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/tlvLGBTQcenter/'
      },
      {
        'title': 'גרוס, אייל (2016). הפוליטיקה של זכויות להט״ב: בין (הומו) נורמטיביות ו(הומו) לאומיות לפוליטיקה קווירית. בתוך: גרוס, אייל, זיו, עמליה ויוסף, רז (עורכים), <b>סקס אחר - מבחר מאמרים בלימודים להט״בים וקוויריים ישראליים</b> (עמ\' 183–245). תל אביב: רסלינג.'
      },
      {
        'title': 'Misgav, Chen (2015). With the current, against the wind: Constructing spatial activism and radical politics in the Tel-Aviv Gay Center. <b>ACME: An International E-Journal for Critical Geographies, 14</b>(4), 1208-1234.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '16/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2008,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '08/09/2018'
    },
    'description': '״המרכז הישראלי לחינוך ללידה״ הוקם בשנת 1981 על ידי וונדי בלומפילד שהיתה מדריכת הכנה ללידה באנגליה והיה המרכז הראשון מסוגו שהוקם בישראל. מטרות העמותה, שנרשמה בשנת 1982 ופורקה מרצון בשנת 2011 היו: ״נהול קורסים להכנה ללידה בשיטת לאמאז והכשרת מורות לשיטה זו. עידוד הנקה והדרכתה ליולדות קיום קבוצות פגישה לנשים לאחר לידה. קיום ימי עיון ודיונים לאנשי מקצוע והורים הקמה ועדה טכנית למחקר ומידע.״ המרכז היה ארגון אחות או סניף ישראלי של ה– National Childbirth Trust NCT, הפועל באנגליה מטעם משרד הבריאות הבריטי. המרכז הפעיל קורסים ופעילויות בהתנדבות להכשרת מדריכות הכנה ללידה, תומכות לידה- דולות, מדריכות הנקה, ומדריכות לקבוצות אמהות ותינוקות. בנוסף, עובדות המרכז נטלו חלק בפעילויות ציבוריות לקידום ההכרה המוסדית במקצועות ההכנה והליווי בלידה ובמהלך שנת חייו הראשונה של היילוד. המרכז הישראלי לחינוך ללידה קיים ימי עיון, כנסים וסדנאות המיועדים לנשות מקצוע ולציבור הרחב.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ]
    ],
    'id': 'SA47',
    'is_active': false,
    'keywords': [
      'הריון',
      'לידה',
      'לידה טבעית',
      'הנקה'
    ],
    'name': 'המרכז הישראלי לחינוך ללידה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'פרדס חנה-כרכור',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז לחינוך לידה בישראל: עמותה מחוקה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580008852'
      },
      {
        'title': '(1986). <b>שתילון 2</b>. אותר בארכיון הפמיניסטי ב״אשה לאשה – מרכז פמיניסטי חיפה״.'
      },
      {
        'title': 'אמנות הלידה (אתר). <b>מי אני: וונדי בלומפילד</b>. נדלה מתוך',
        'url': 'http://www.leida.co.il/Wendy/show.asp?art=1&t=l'
      },
      {
        'title': 'רונאל, גילה, ארצי-פדן, מירה וכהן-ורדי, עלמה (2002). <b>טבעי ללדת: המדריך המקיף להריון וללידה ולימים שאחרי</b>. תל אביב: כתר.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/02/2018'
    },
    'year_closed': 2011,
    'year_closed_text': '2011',
    'year_founded': 1981,
    'year_registered': 1982
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '09/11/2018'
    },
    'description': '״המרכז הרב תחומי לטיפול בנפגעות ונפגעי תקיפה מינית״ בבני ציון הוא אחד מהמרכזים הרב-תחומיים הציבוריים המתמחים בטיפול בטראומה מינית. המרכז, שהיה אחד הראשונים מסוגו, נוצר כשיתוף פעולה בין משרד הרווחה (השירות לטיפול בנשים ונערות), עיריית חיפה והמרכז הרפואי בני ציון. נמצא באחריות משרד הרווחה. פעילות המרכז הורחבה ב-2008 בעקבות התכנית הבין-משרדית לטיפול בנפגעות תקיפה מינית.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'רווחה וקהילה',
        'אלימות מינית'
      ]
    ],
    'id': 'YH143',
    'is_active': true,
    'keywords': [
      'טראומה',
      'טיפול נפשי',
      'אונס',
      'תקיפה מינית',
      'הכשרה מקצועית'
    ],
    'name': 'המרכז הרב תחומי לטיפול בנפגעות ונפגעי תקיפה מינית בבני ציון',
    'name_ar': 'ملركز متعدد التخصصات في مستشفى بني تسيون، حيفا',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'מוניציפלי',
      'ממשלתי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.b-zion.org.il/pages/907.aspx'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2009, 27 יולי). <b>פרוטוקול מס\' 17: דיווח בנושא התוכניות לטיפול בנפגעות תקיפה מינית והוצאת נשים ממעגל הזנות - בהשתתפות שר הרווחה והשירותים החברתיים, ח״כ יצחק הרצוג</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/Activity/committees/Women/Pages/CommitteeProtocols.aspx?ItemID=327911'
      },
      {
        'title': 'משרד העבודה הרווחה והשירותים החברתיים, עיריית חיפה והמרכז הרפואי בני ציון בחיפה. <b>המרכז הרב תחומי לטיפול בנפגעות תקיפה מינית</b>. נדלה מתוך',
        'url': 'http://www.b-zion.org.il/download/files/%D7%91%D7%A8%D7%95%D7%A9%D7%95%D7%A8-%20%D7%94%D7%9E%D7%A8%D7%9B%D7%96%20%D7%94%D7%A8%D7%91-%20%D7%AA%D7%97%D7%95%D7%9E%D7%99_1.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2002,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '22/01/2019'
    },
    'description': 'המרכז נוסד ב-1998 על ידי פניה גוסטסלר הלר ז״ל סופרת ופילוסופית, ניצולת שואה. מטרתו לעודד ולתמוך במחקרים אקדמיים, ימי עיון וכינוסים אקדמיים הקשורים בחקר מקומה של האישה ביהדות. המרכז פועל בפקולטה למדעי היהדות בבר-אילן ושותף בהוצאה לאור של כתב העת ״מסכת״ שנושאו הוא האישה היהודייה בתרבות ובתולדות עם ישראל וההיסטוריה של האנושות.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'מרכזי מחקר'
      ],
      [
        'דת ומעמד אישי',
        'השכלה'
      ]
    ],
    'id': 'YH184',
    'is_active': true,
    'keywords': [
      'הלכה',
      'יהדות',
      'לימודי מגדר',
      'מחקר'
    ],
    'name': 'המרכז לחקר האישה ביהדות ע״ש פניה גוטספלד הלר באוניברסיטת בר-אילן',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת גן',
    'organization_kind': [
      'אקדמי',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'מרכזי מחקר',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'המרכז לחקר האישה ביהדות - אוניברסיטת בר-אילן, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/%D7%94%D7%9E%D7%A8%D7%9B%D7%96-%D7%9C%D7%97%D7%A7%D7%A8-%D7%94%D7%90%D7%99%D7%A9%D7%94-%D7%91%D7%99%D7%94%D7%93%D7%95%D7%AA-%D7%90%D7%95%D7%A0%D7%99%D7%91%D7%A8%D7%A1%D7%99%D7%98%D7%AA-%D7%91%D7%A8-%D7%90%D7%99%D7%9C%D7%9F-2539394029435097/'
      },
      {
        'title': 'הפקולטה למדעי היהדות, אוניברסיטת בר-אילן (אתר). <b>מרכזים ומכונים וקתדראות</b>. נדלה מתוך',
        'url': 'http://jewish-faculty.biu.ac.il/node/301'
      },
      {
        'title': 'Fanya Heller. <b>Wikipedia</b>. Retrieved from',
        'url': 'https://en.wikipedia.org/wiki/Fanya_Heller'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '22/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '23/01/2019'
    },
    'description': 'המרכז לחקר הרפואה המגדרית במרכז הרפואי רבין, הוקם ב-2012 על ידי פרופ\' מרק גלזרמן שכיהן קודם לכן את מחלקות הנשים בבית החולים רבין (בלינסון) והשרון ואף היה מהמייסדים של החברה הישראלית לרפואה מגדרית בשנת 2009. המרכז המרכז פועל בשיתוף פעולה הדוק עם החברה הישראלית לרפואה מגדרית, יוזם מחקרים ומרכז את העשייה המחקרית בנושא. מטרותיו: לקדם את הרפואה המגדרית בישראל, ליזום מחקר ברפואה המגדרית, להעלות מודעות בקרב הצוות הרפואי והפארא-רפואי לגבי הרפואה המגדרית, ליזום יישום של עקרונות הרפואה המגדרית בפעילות הקלינית, באבחון ובטיפול.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ],
      [
        'השכלה גבוהה ומחקר',
        'מרכזי מחקר'
      ]
    ],
    'id': 'YH186',
    'is_active': true,
    'keywords': [
      'רפואה מגדרית',
      'מחקר',
      'סרטן',
      'מחלות כרוניות',
      'הריון',
      'לידה',
      'גוף'
    ],
    'name': 'המרכז לחקר הרפואה המגדרית במרכז הרפואי רבין',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'פתח תקווה',
    'organization_kind': [
      'אקדמי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-01-23'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://hospitals.clalit.co.il/rabin/he/departments-and-clinics/gender-medicine/Pages/gender_medicine_Research_center.aspx'
      },
      {
        'title': 'מרק גלזרמן. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%9E%D7%A8%D7%A7_%D7%92%D7%9C%D7%96%D7%A8%D7%9E%D7%9F'
      },
      {
        'title': 'סידון, יונתן (2018, 8 יולי). רפואה מודעת מין ומגדר היא צעד גדול לשיפור איכות הרפואה. <b>כלכליסט</b>. נדלה מתוך',
        'url': 'https://www.calcalist.co.il/articles/0,7340,L-3741669,00.html'
      },
      {
        'title': 'שני, איילת (2014, 26 יוני). רפואה נפרדת לנשים ולגברים? פרופ\' מרק גלזרמן חושב שהגיע הזמן. <b>הארץ</b>. נדלה מתוך',
        'url': 'https://www.haaretz.co.il/magazine/ayelet-shani/.premium-1.2359667'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '23/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2012,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '11/11/2018'
    },
    'description': 'המרכז לחקר וקידום בריאות האישה באוניברסיטת בן-גוריון בנגב, נוסד בשנת 1999 כדי ללמד ולקדם את בריאות הנשים ורווחתן. זהו המרכז האקדמי היחיד בישראל המתמקד בקידום הנושאים של נשים תוך שילוב מחקר חדשני, רב תחומי עם תרומה לקהילה. כל פעילויות המרכז מדגישות את המפתח לבריאות טובה: מניעה והתערבות. המרכז מפעיל את תכנית ״אם לאם בקהילה״ ואת פרויקט ״אישה בשלה״ - טיפול רגיש לסוגיות מגדריות ורב תרבותיות.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ],
      [
        'השכלה גבוהה ומחקר',
        'מרכזי מחקר'
      ]
    ],
    'id': 'YH147',
    'is_active': true,
    'keywords': [
      'לידה',
      'רפואה מגדרית',
      'אמהות',
      'תרפיה',
      'סרטן',
      'פריפריה'
    ],
    'name': 'המרכז לחקר וקידום בריאות האישה באוניברסיטת בן-גוריון בנגב',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'אקדמי',
      'ממשלתי'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-11-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://in.bgu.ac.il/humsos/womancenter/Pages/about.aspx'
      },
      {
        'title': 'המרכז לחקר וקידום בריאות האישה, אוניברסיטת בן-גוריון בנגב (2016, 7 יולי). <b>מידעון המרכז לחקר וקידום בריאות האישה, 1</b>. נדלה מתוך',
        'url': 'http://in.bgu.ac.il/humsos/womancenter/DocLib/Pages/bulletin/%D7%9E%D7%99%D7%93%D7%A2%D7%95%D7%9F-1.pdf'
      },
      {
        'title': 'The Center for Women’s Health Studies and Promotion, Ben-Gurion University of the Negev (2016). <b>Annual report – 2016</b>. Retrieved from',
        'url': 'http://in.bgu.ac.il/humsos/womancenter/DocLib/Pages/AnnualReports/annual%20report%202016.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '18/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1999,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '30/12/2018'
    },
    'description': 'המרכז ללימודי נשים ומגדר במכללה האקדמית על שם דוד ילין נוסד בשנת 1992 על ידי ד״ר לילי זמיר העומדת בראשו מאז. הלימודים במרכז מקבילים ללימודי חטיבה לתואר ראשון בלימודי מגדר באוניברסיטאות ובנויים מלימודי חובה שמקנים תעודה מיוחדת הנלווית לתואר הבוגר או לימודי תעודה המוכרים לגמול השתלמות.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תכניות לתואר אקדמי בלימודי מגדר'
      ]
    ],
    'id': 'SA109',
    'is_active': true,
    'keywords': [
      'לימודי מגדר',
      'חינוך'
    ],
    'name': 'המרכז ללימודי נשים ומגדר במכללה האקדמית ע״ש דוד ילין',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'אקדמי',
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תכניות לתואר אקדמי בלימודי מגדר',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-12-30'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.dyellin.ac.il/bed/women_and_gender_studies'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '30/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1992,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '08/11/2018'
    },
    'description': 'המרכז למיניות אלטרנטיבית החל ב- 2014 כיוזמה של מפגשים חברתיים לקהילה הבדס״מית שהתנהלו בבית הפתוח בירושלים, וב - 2018 הפך לחל״צ. הוא פועל על מנת לקדם שיח על מיניות ולתמוך באנשים וקהילות בעלי רצונות מיניים ואינטימיים החורגים מהתכתיבים החברתיים העכשיווים, כהגדרתם - בדס״מים, פוליאמורים, א-מונוגמים וא-מיניים. המרכז מציע טיפולים וייעוץ, וכן מעביר סדנאות לבעלי מקצוע בתחומים הטיפוליים. הוא גם מציע ליווי מקצועי בפרויקטים קהילתיים, ופועל להרחבת הידע בתחום המיניות ויצירת מאגרי מידע על חוויותיהם של חברי הקהילות המעורבות בו. הצוות מורכב ממתנדבים ואנשי מקצוע בתחומים כמו עבודה סוציאלית, פסיכולוגיה ובריאות הציבור.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'רווחה ובריאות'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'חינוך',
        'חינוך מיני/מיניות בריאה'
      ]
    ],
    'id': 'LR19',
    'is_active': true,
    'keywords': [
      'מיניות',
      'העלאת מודעות',
      'תמיכה נפשית',
      'פוליאמוריה',
      'א-מיניות',
      'בדסמ',
      'חל״צ'
    ],
    'name': 'מרכז חברתי קהילתי בע״מ',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'המרכז למיניות אלטרנטיבית',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'רווחה ובריאות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-08-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://altsex.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז חברתי קהילתי בע״מ (חל״צ): מל״צ</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/515876951'
      },
      {
        'title': 'המרכז למיניות אלטרנטיבית (2019, 3 יוני). הפרטים אומתו בשיחה עם נציג העמותה.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': 2018
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '15/11/2018'
    },
    'description': 'המרכז למשפחה האלטרנטיבית (ע״ר 580448512) נרשם כעמותה ב- 2005, וככל הנראה הפסיק את פעילותו בסביבות 2009-2010. מטרות העמותה היו: ״לפעול למען המשפחה האלטרנטיבית, קרי: משפחה שאינה מורכבת בהכרח מגבר ואשה אשר קיימו ו/או מקיימים ביניהם קשר זוגי, ואשר הינם הורים לילדים משותפים. לפעול במיוחד למען המשפחה האלטרנטיבית בקרב חברי הקהילה ההומו-לסבית. מתן סיוע והדרכה לגברים ולנשים המעוניינים להיות הורים ללא יצירת קשר זוגי.״ המרכז פעל על מנת לסייע למשפחות אלטרנטיביות, בין היתר במתן סיוע והדרכה להומואים ולסביות המעוניינים להיות הורים במסגרות לא זוגיות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'משפחה'
      ]
    ],
    'id': 'LR23',
    'is_active': false,
    'keywords': [
      'הורות משותפת',
      'תמיכה נפשית',
      'לסביות',
      'הומואים',
      'משפחות',
      'הורות גאה'
    ],
    'name': 'המרכז למשפחה האלטרנטיבית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'משפחה',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>התנועה לגבריות חדשה</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2010,
    'year_closed_text': '2010',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': '״המרכז למשפחה היהודית״ (ע״ר 580630325) נוסד ב-2016 על ידי הארגון ״יד שרה״ ובהובלת ד״ר שלומית להמן, עובדת סוציאלית שמתמחה באלימות במשפחה שהיתה גם חברה ב-״פורום תקנה״. מטרות העמותה הן ״לפעול למניעת אלימות במשפחה בישראל. ללמוד וללמד ניהול חיי משפחה הרמוניים ולסייע להשגת שלום בית בתוך המשפחה. לשמש כמרכז חינוכי והפעלת קורסים, הדרכה והרצאות. להעניק תמיכה נפשית וחומרית לילדים, נשים וגברים הסובלים מאלימות או התעללות במשפחה - פיזית או נפשית.״ העמותה איננה פעילה, אך המרכז עצמו פועל כחלק מ״יד שרה״ שיתוף פעולה עם מחלקת הרווחה בעיריית ירושלים ומעניק שירותים בתחום המניעה והטיפול באלימות במשפחה במגזר החרדי, בדגש על עבודה עם רבני קהילות לשבירת השתיקה סביב הנושא.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף מוניציפלי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'דת ומעמד אישי',
        'אלימות'
      ]
    ],
    'id': 'YB65',
    'is_active': true,
    'keywords': [
      'מרכזים למניעה וטיפול באלימות במשפחה',
      'אלימות מינית',
      'תמיכה נפשית',
      'העלאת מודעות'
    ],
    'name': 'המרכז למשפחה היהודית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'מוניציפלי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>המרכז למשפחה היהודית (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580630325'
      },
      {
        'title': 'כל זכות (ללא תאריך). <b>המרכז למשפחה ביד שרה - טיפול בעקבות אלימות או התעללות</b>. נדלה מתוך',
        'url': 'https://www.kolzchut.org.il/he/%D7%94%D7%9E%D7%A8%D7%9B%D7%96_%D7%9C%D7%9E%D7%A9%D7%A4%D7%97%D7%94_%D7%91%D7%99%D7%93_%D7%A9%D7%A8%D7%94_-_%D7%98%D7%99%D7%A4%D7%95%D7%9C_%D7%91%D7%A2%D7%A7%D7%91%D7%95%D7%AA_%D7%90%D7%9C%D7%99%D7%9E%D7%95%D7%AA_%D7%90%D7%95_%D7%94%D7%AA%D7%A2%D7%9C%D7%9C%D7%95%D7%AA'
      },
      {
        'title': 'פרץ, ידידה (2008, 22 יוני). שוברים שתיקה. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-3558711,00.html'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '27/05/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '23/01/2019'
    },
    'description': 'המרכז למשפט, מגדר ומדיניות חברתית, בפקולטה למשפטים באוניברסיטת חיפה הוקם ב-2014 על ידי פרופ\' שולמית אלמוג ופרופ\' נויה אימלט. מטרת המרכז הינה לקיים מסגרת אקדמית ראשונה מסוגה, שמשמשת מחד גיסא כמוקד של מחקר והוראה ומהווה מאידך גיסא גשר למקבלי ההחלטות תוך התמקדות במשפט ככלי מרכזי להנעת רפורמות, שתכליתן העצמת נשים וקידום השוויון המגדרי בישראל. לצד זיהוי שאלות של מדיניות ציבורית, עוסק המרכז בקידום הדיון בסוגיות של אי שוויון מגדרי במעגלי השפעה שונים: משרדי ממשלה, מחוקקים, שופטים, עורכי דין, אקדמיה, ארגוני שטח פמיניסטים בארץ ובעולם.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'מרכזי מחקר'
      ]
    ],
    'id': 'YH185',
    'is_active': true,
    'keywords': [
      'מחקר פמיניסטי',
      'אפליה מגדרית במשפט',
      'שוויון מגדרי',
      'קידום נשים',
      'העצמה',
      'פמיניזם משפטי'
    ],
    'name': 'המרכז למשפט, מגדר ומדיניות חברתית באוניברסיטת חיפה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'אקדמי',
      'ממשלתי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'מרכזי מחקר',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-01-23'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://law.haifa.ac.il/index.php/he/?option=com_content&view=article&id=458'
      },
      {
        'title': 'אוניברסיטת חיפה, הפקולטה למשפטים (ללא תאריך). <b>המרכז למשפט, מגדר ומדיניות חברתית</b>. נדלה מתוך',
        'url': 'http://law.haifa.ac.il/images/Pics/GLheb.png'
      },
      {
        'title': 'המרכז למשפט, מגדר ומדיניות חברתית, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/genderlawcenter/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '23/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '26/11/2018'
    },
    'description': 'ה״מרכז לפדגוגיה ביקורתית״ הוקם בסמינר הקיבוצים בשנת 2005 במטרה להפיץ ידע על אסכולת החינוך הביקורתי אשר עוסק בחינוך לצדק ושינוי חברתי באמצעות החינוך. מטרות המרכז, אשר נרשם כעמותה בשנת 2007 (ע״ר 580484327), היו (1) להכשיר אנשי ונשות חינוך ופעילים/ות חברתיים ליזום פרויקטים חינוכיים הפועלים על פי עקרונות הפדגוגיה הביקורתית פמיניסטית על בסיס של תפישת עולם הכוללת צדק חברתי וסביבתי וחינוך לשלום. (2) יצירה וכתיבה של חומרים למידה ותיאוריות, תרגום ועריכת חומרים בתחום הפדגוגיה הביקורתית - פמיניסטית בארץ ובעולם. (3) יצירת קשרים אקדמיים וקשרים עם ארגונים לשינוי חברתי בארץ ובעולם, ויוזמה של כנסים מקומיים ובינלאומיים בנושאים שונים בתחום הפדגוגיה ביקורתית פמיניסטית. המרכז הפעיל את התכנית לחינוך לצדק חברתי, סביבתי וחינוך לשלום במכללת סמינר הקיבוצים (תכנית לתאר B.ed ותעודת הוראה) שהיא תכנית להכשרת מורים לבית הספר היסודי שנועדה לחנך מורים לשינוי חברתי באמצעות החינוך. בשנת 2014, לאחר תהליך הדרגתי, התכנית נסגרה והוטמעה בתוך המרכז לחינוך מתקדם בסמינר הקיבוצים. בין מייסדות המרכז חגית גור-זיו, גליה זלמנסון-לוי וגל הרמט. העמותה מופיעה כרשומה אך איננה מגישה דוחות פעילות לרשם העמותות.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תכניות לתואר אקדמי בלימודי מגדר'
      ],
      [
        'תעסוקה ועבודה',
        'הכשרה מקצועית'
      ],
      [
        'שלום'
      ]
    ],
    'id': 'SA97',
    'is_active': false,
    'keywords': [
      'צדק חברתי',
      'חינוך',
      'פמיניזם',
      'שלום',
      'סביבה'
    ],
    'name': 'המרכז לפדגוגיה ביקורתית פמיניסטית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'אקדמי',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תכניות לתואר אקדמי בלימודי מגדר',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-11-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.criticalpedagogy.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>המרכז לפדגוגיה ביקורתית פמיניסטית (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580484327'
      },
      {
        'title': 'גור זיו, חגית (2013). <b>פדגוגיה ביקורתית-פמיניסטית וחינוך לתרבות של שלום</b>. תל אביב: מכון מופ״ת. נדלה מתוך',
        'url': 'https://kotar.cet.ac.il/KotarApp/Viewer.aspx?nBookID=104626950#2.467.6.default'
      },
      {
        'title': 'חרומצ\'נקו, יולי (2005, ספטמבר 28). בברזיל ובנפאל זה עובד. <b>הארץ</b>. נדלה מתוך',
        'url': 'https://www.haaretz.co.il/misc/1.1047845'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '23/11/2018'
    },
    'year_closed': 2014,
    'year_closed_text': '2014',
    'year_founded': 2005,
    'year_registered': 2007
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/08/2018'
    },
    'description': '״המרכז לשלום המשפחה הבדואית״ הוקם בשנת 2005 כמרכז היחיד למניעת אלימות במגזר הבדואי בנגב. המרכז הוקם על פי החלטת המפקחת המחוזית במשרד הרווחה, ד״ר מירי בקר, אשר לתפיסתה הפניית נשים בדואיות למקלטים לנשים מוכות אינה פתרון מספק עבורן ויש להתאים את הפתרונות לתרבות ולמנהגים של החברה הבדואית. המרכז שהופעל בבאר שבע על ידי עמותת אלואחא בנגב בשיתוף משרד הרווחה, נתן מענה טלפוני, טיפול קבוצתי וליווי חלקי לכ-80-150 נשים בשנה על ידי עובדות סוציאליות ומתנדבות. המרכז גם קיים שיתוף פעולה עם שייח\'ים מקומיים ולשכות רווחה, אך נסגר בשנת 2014 לאחר הפסקת פעילות העמותה.',
    'description_ar': 'الواحة لسلام العائلة البدوية- تأسس عام 2005 وهو المركز الوحيد لمنع العنف في المجتمع العربي البدوي في النقب. تأسس المركز بعد قرار مفتشة الشؤون الاجتماعية الولائية في النقب د.ميري بكر، والتي بحسب اعتقادها إن إدراك إحالة النساء البدويات إلى أماكن إيواء النساء اللائي يتعرضن للضرب ليس حلاً مرضياً لهن ويجب تكييف الحلول مع الثقافة والعادات البدوية.تم إدارة المركز في بئر السبع من قبل جمعية ״الواحة״ في النقب بالتعاون مع وزارة الرفاه الاجتماعي، توفير خدمات هاتفية والعلاج الجماعي والدعم الجزئي لحوالي 80-150 امرأة في السنة من قبل الأخصائيين الاجتماعيين والمتطوعين. يتعاون المركز أيضًا مع الشيوخ المحليين ومكاتب الرعاية الاجتماعية، لكنه أغلق في عام 2014 بعد أن توقفت المنظمة عن العمل.',
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'YB124',
    'is_active': false,
    'keywords': [
      'אלימות במשפחה',
      'אלימות מינית',
      'בדואיות',
      'מרכזים למניעה וטיפול באלימות במשפחה',
      'טיפול נפשי',
      'משפחות',
      'פוליגמיה',
      'פריפריה',
      'קבוצות תמיכה',
      'קו סיוע'
    ],
    'name': 'המרכז לשלום המשפחה הבדואית בנגב',
    'name_ar': 'الواحة في النقب',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אלואחה בנגב עמותה לרותי רווחה וחינוך (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580221687'
      },
      {
        'title': 'אבו שארב, אינסאף (2013). <b>קשר השתיקה: אלימות במשפחה נגד נשים ערביות-בדואיות בנגב</b>. דו״ח מחקר, עמותת איתך: משפטניות למען צדק חברתי ע.ר.. נדלה מתוך',
        'url': 'http://www.itach.org.il/wp-content/uploads/maamad2013-06-03.pdf (גרסה באנגלית: http://www.itach.org.il/wp-content/uploads/Report-on-Violence-Against-Bedouin-Women-Translation-June.pdf)'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה (2013, 8 דצמבר). <b>פרוטוקול מס\' 48: סיור הוועדה – ארגוני הנשים הערביות בנגב</b>. נדלה מתוך',
        'url': 'https://main.knesset.gov.il/Activity/committees/Women/Pages/CommitteeAgenda.aspx?tab=3&ItemID=543338'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '29/04/2019'
    },
    'year_closed': 2014,
    'year_closed_text': '2014',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '14/10/2018'
    },
    'description': 'מועצת הנשים העירונית אשדוד הינה גוף התנדבותי שהוקם בשנת 1984 במטרה להעצים ולהעמיד לטובת הנשים באשדוד אפשרויות והזדמנויות בתחום המעמד האישי, החברתי והכלכלי תוך הקטנת פערים מגדריים ובכך לתרום להתפתחותה ויציבותה של העיר. מועצת הנשים פועלת במספר תחומים עיקריים: יצוג הקול הנשי במוסדות העיר; פיתוח אשדוד כעיר מובילה בישראל בתחומי קידום מעמד האישה באמצעות פרויקט ״עיר ידידותית לנשים״; יזום, הובלה וקידום פרוייקטים מורכבים בנושאי תעסוקה, עסקים, השכלה, רווחה, תשתיות תרבות ואמנות',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'YH106',
    'is_active': true,
    'keywords': [
      'העצמה',
      'חד הוריות',
      'יועצות לקידום מעמד האשה',
      'מנהיגות',
      'פנאי',
      'רשות מקומית',
      'קידום נשים'
    ],
    'name': 'מועצת נשים אשדוד',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'המשרד לקידום מעמד האשה- אשדוד',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'אשדוד',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-14'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.ashdod.muni.il/he-il/%D7%90%D7%AA%D7%A8-%D7%94%D7%A2%D7%99%D7%A8/%D7%9E%D7%99%D7%A0%D7%94%D7%9C-%D7%94%D7%9B%D7%9C%D7%9C%D7%99/%D7%94%D7%9E%D7%A9%D7%A8%D7%93-%D7%9C%D7%A7%D7%99%D7%93%D7%95%D7%9D-%D7%9E%D7%A2%D7%9E%D7%93-%D7%94%D7%90%D7%99%D7%A9%D7%94/%D7%9E%D7%95%D7%A2%D7%A6%D7%AA-%D7%A0%D7%A9%D7%99%D7%9D/'
      },
      {
        'title': 'מועצת נשים עירונית אשדוד, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/%D7%9E%D7%95%D7%A2%D7%A6%D7%AA-%D7%A0%D7%A9%D7%99%D7%9D-%D7%A2%D7%99%D7%A8%D7%95%D7%A0%D7%99%D7%AA-%D7%90%D7%A9%D7%93%D7%95%D7%93-149002358521202/'
      },
      {
        'title': 'עיריית אשדוד (2014, 10 יוני). <b>30 שנה למועצת נשים אשדוד</b>. נדלה מתוך',
        'url': 'https://www.ashdod.muni.il/he-il/%D7%90%D7%AA%D7%A8-%D7%94%D7%A2%D7%99%D7%A8/%D7%90%D7%A8%D7%9B%D7%99%D7%95%D7%9F-%D7%97%D7%93%D7%A9%D7%95%D7%AA/%D7%97%D7%93%D7%A9%D7%95%D7%AA/2014/6/30-%D7%A9%D7%A0%D7%94-%D7%9C%D7%9E%D7%95%D7%A2%D7%A6%D7%AA-%D7%A0%D7%A9%D7%99%D7%9D-%D7%90%D7%A9%D7%93%D7%95%D7%93/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '23/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1984,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': 'המשרד לשוויון חברתי הוקם בשנת 2015 כהרחבה של ״המשרד לאזרחים ותיקים״ שנוסד בשנת 2007. תקציב המשרד נגזר מהתקציב הכללי של משרד ראש הממשלה והוא מטפל בתחומים הבאים: קידום אוכלוסיית האזרחים הוותיקים בישראל, קידום מעמד האישה – באמצעות הרשות לקידום מעמד האישה, פיתוח כלכלי של המגזר הערבי – באמצעות הרשות לפיתוח כלכלי של מגזר המיעוטים, קידום אוכלוסיית הצעירים וקידום ויישום מדיניות לאומית לשימוש בטכנולוגיות מידע ותקשורת באמצעות המיזם הלאומי ״ישראל דיגיטלית״. בעקבות הקמת המשרד הועברה האחריות על הרשות לקידום מעמד האשה ממשרד ראש הממשלה למשרד לשוויון חברתי. בשנים 2015-2019 עמדה בראש המשרד השרה גילה גמליאל.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ],
      [
        'פוליטיקה ומנהיגות',
        'כללי'
      ]
    ],
    'id': '1YB16',
    'is_active': true,
    'keywords': [
      'הטמעת חשיבה מגדרית',
      'הטרדה מינית',
      'העדפה מתקנת',
      'יועצות לקידום מעמד האישה',
      'שוויון מגדרי'
    ],
    'name': 'המשרד לשיוויון חברתי',
    'name_ar': 'وزارة المساواة الإجتماعية',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'שוויון בין המינים/שוויון מגדרי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.gov.il/he/Departments/ministry_for_social_equality'
      },
      {
        'title': 'אזולאי, מורן (2015, 4 אוגוסט). שונה שם המשרד לאזרחים ותיקים - ייקרא ״המשרד לשוויון חברתי״. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-4687399,00.html'
      },
      {
        'title': 'חרותי-סובר, טלי (2017, 10 מרץ). המשרד לקידום מקורבים לשרה גילה גמליאל. <b>TheMarker</b>. נדלה מתוך',
        'url': 'https://www.themarker.com/markerweek/1.3918686'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל בר צדק',
      'on': '23/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '19/07/2018'
    },
    'description': '״ה״ן- עמותת נשים הרצליה״ נשים (ע״ר 580130136) הוקמה בשנת 1986 על ידי נשים מהרצליה וביניהן רות רזניק. בראש העמותה עמדה עו״ד יונה מרקוביץ. מטרת העמותה היתה לשמש ״רשימת נשים בלתי מפלגתית למען רווחת התושבים בהרצליה ולהגברת מעורבות נשים במוקדי קבלת ההחלטות״. בפועל, העמותה ביקשה להציב נשים מועמדות למועצת העיר ולהרחיב את מעורבותן של נשים בפוליטיקה המקומית והארצית. בשנות התשעים וראשית שנות האלפיים, העמותה פעלה בשיתוף פעולה עם נציגות בולטות בפוליטיקה העירונית והארצית (יעל גרמן, מרים פיירברג ואחרות) מאזור השרון. מאז ראשית שנות האלפיים פעילותו העיקרית של הארגון נעשתה בשיתוף עם תנועת ש.י.ן. ואירועי ״פרלמנט נשים״. הארגון אינו פעיל מאז שנת 2010.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'ייצוג הולם'
      ]
    ],
    'id': 'SA33',
    'is_active': false,
    'keywords': [
      'ייצוג הולם',
      'קידום נשים',
      'רשות מקומית',
      'בחירות'
    ],
    'name': 'הן- עמותת נשים הרצליה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'הרצליה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ייצוג הולם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>הן – עמותת נשים הרצליה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580130136'
      },
      {
        'title': 'ה״ן- עמותת נשים הרצליה (2018, 14 אוקטובר). הפרטים אומתו בשיחת טלפון עם אסתר הרצוג.'
      },
      {
        'title': 'פרלמנט נשים – במה לפוליטיקה מזווית אחרת (אתר). נדלה מתוך',
        'url': 'http://womenparliament.org/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '18/11/2019'
    },
    'year_closed': 2010,
    'year_closed_text': '2010',
    'year_founded': 1986,
    'year_registered': 1988
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '09/08/2018'
    },
    'description': 'העמותה ״לחקר אמנות נשים ומגדר בישראל״(ע״ר 580611176) הוקמה על ידי ד״ר רות מרקוס בשנת 2015 בשיתוף חברות מייסדות נוספות: טל דקל, מור פרסיאדו, חגית שחל, אורנה נוי-לניר, רותיחינסקי-אמיתי, במטרה ״לעודד מחקר על אמנות נשים בישראל ולחזק את הדיסציפלינה של לימודי מגדר באמנות בכללוהישראלית בפרט. להקים אתר אינטרנט שבו יופיעו המחקרים הקשורים לנושאי אמנות נשים ומגדר באמנות הישראלית ולקיים כנסים בנושאים הנ״ל״. העמותה רשומה בכתובתה של המייסדת רות מרקוס אך פועלת בחסות החוג לתולדות האמנות והתכניתהרב תחומית באמנויות באוניברסיטת תלאביב. העמותה מקיימת שיתופי פעולה עם גופים, ארגונים ומוסדות שונים,בהם מכללת סמינר הקיבוצים, מכללת אורנים, האגודה הישראלית ללימודים פמיניסטיים,מוזיאון חיפה, מוזיאון \'על התפר\' בירושלים, \'גלרית השלום\' בגבעת חביבה, גלרית \'וטרינה\' במכון הטכנולוגי חולון, כתב העת \'מגדר\' ועוד\'. בנוסף, האגודה מציעה הרצאות וסדרות שנתיות הפתוחות לקהל הרחב, פרוייקטי אוצרות שנתיים של תערוכות בנושאים שונים שלמגדר ונשים, כנסים אקדמיים, הענקת הכרה לאמניות העמותה (\'אמנית החודש\') והפצה ידע על אמניות באמצעות דף פייסבוק ייעודי ואתר מקצועי מקוון. בשנת 2019 העמותה יסדה פרס שנתי, ראשון מסוגו בישראל, ״פרס בקי דקל״ לאמנית מצטיינת.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף אקדמי',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'אמנות'
      ],
      [
        'השכלה גבוהה ומחקר',
        'אגודות מקצועיות'
      ]
    ],
    'id': 'YH73',
    'is_active': true,
    'keywords': [
      'אמנות',
      'מחקר',
      'קידום נשים',
      'חינוך מגדרי'
    ],
    'name': 'העמותה לחקר אמנות נשים ומגדר בישראל',
    'name_ar': 'الجمعية للبحث في الفن النسوي والجندرية',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'אקדמי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אמנות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-08'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.womenartandgender.com/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>העמותה לחקר אמנות נשים ומגדר בישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580611176'
      },
      {
        'title': 'ערב רב (2015, 28 מרץ). אגודה חדשה לחקר אמנות נשים ומגדר בישראל. <b>ערב רב</b>. נדלה מתוך',
        'url': 'https://www.erev-rav.com/archives/36373'
      },
      {
        'title': 'רות מרקוס. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%A8%D7%95%D7%AA_%D7%9E%D7%A8%D7%A7%D7%95%D7%A1'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '02/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '17/07/2019'
    },
    'description': 'ה״עמותה למניעת אלימות במשפחה הערבית״ הוקמה בדצמבר 1993 על ידי אנשי מקצוע ואקדמאים באזור טייבה שבמשולש. העמותה (ע״ר 580239838) נרשמה בשנת 1994 ביישוב זמר אצל עאידה אבו חבלה. על פי ינאי (2005) ״התארגנות זו היתה ברובה של נשים, שנועצו ברות רזניק. הכוונה היתה להחזיר לפעילות בטייבה קו חירום לטיפול בנפגעי אלימות במשפחה, שפעילותו נפסקה. ואכן הוקם והופעל קו חירום חדש, והיתה גם יוזמה חדשה להקים מקלט לנשים.״ בשנת 1994 זכתה היוזמה להקמת מקלט באזור המשולש לנשים ערביות לגיבוי מטעם משרד הרווחה, אך כחודש לאחר שנפתח וכבר קלט מספר נשים הוא נסגר בשל לחץ תושבי המקום והתנגדות של ראש עיריית טייבה. העמותה המשיכה לפעול במשך מספר שנים וקיימה הרצאות ופעילות חינוכית. נסגרה בצו בית משפט בשנת 2012.',
    'description_ar': 'في ديسمبر 1993 أسس مهنيين وأكاديميين من منقطة الطيبة في المثلث الجنوبي ״جمعية لمنع العنف في العائلة العربية״ الجمعية (ج.م 580239838) والتي تم تسجيلها عام 1994 في قرية زيمر لدى عايدة أبو حبلة. وبحسب مقال اور ياناي (2005)״ غالبية هذا التجمع هو نسائي باستشارة روت رزنيك. الهدف من هذا التجمع هو اعادة تفعيل نشاط خط الطوارئ لعلاج ضحايا العنف المنزلي في الطيبة بعد توقف عمله. وبهذا تم انشاء وتفعيل خط طوارئ جديد، الى جانبه كان هناك مبادرة لإقامة ملجأ للنساء. ״ في عام 1994 حضت المبادرة بالفرصة لإقامة ملجأ للنساء العربيات في منطقة المثلث بدعم من وزارة الرفاه الاجتماعي، الا ان بعد شهر من النشاط الذي شمل إيواء عدد من النساء، تم اغلاق الملجأ بضغط من سكانا المنطقة واعتراض رئيس بلدية الطيبة. استمرت الجمعية في نشاطها لسنوات عديدة واقامت محاضرات ونشاطات تربوية مختلفة وتم اغلاقها في عام 2012 بأمر من المحكمة.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ]
    ],
    'id': 'SA140',
    'is_active': false,
    'keywords': [
      'אלימות במשפחה',
      'רצח נשים',
      'מקלט',
      'קו סיוע'
    ],
    'name': 'העמותה למניעת אלימות במשפחה הערבית בישראל',
    'name_ar': 'جمعية منع العنف بالعائلة العربية',
    'name_change_year': null,
    'name_common': 'העמותה למניעת אלימות',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'זמר',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b> העמותה למניעת אלימות במשפחה הערבית בישראל: עמותה מחוקה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580239838'
      },
      {
        'title': 'העמותה למניעת אלימות במשפחה הערבית בישראל (2019, 20 אוגוסט). הפרטים אומתו בשיחת טלפון עם נציגת הארגון.'
      },
      {
        'title': 'ינאי, אורי (2005). מקלטי נשים בישראל: מחדשנות וולנטרית לאימוץ ממלכתי. <b>ביטחון סוציאלי, 70</b>, 77–109. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/SocialSecurity/70/article5.pdf'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 6434 (2012, 20 יוני). <b>הודעות על מתן צווי פירוק</b>. העמותה למניעת אלימות (עמותה מספר 513886168). עמ\' 109. נדלה מתוך',
        'url': 'http://www.reshumot.co.il/notifications/issue/6434/109'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '17/07/2019'
    },
    'year_closed': 2000,
    'year_closed_text': '2000',
    'year_founded': 1993,
    'year_registered': 1994
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '20/11/2018'
    },
    'description': '״העמותה לקידום נשים בספורט״ (ע״ר 580304269) הוקמה ב-1997 במטרה להגביר ולהעמיק את המודעות לנושא נשים בספורט, לפעול להשגת ייצוג הולם של נשים במוסדות ספורט, לקדם חינוך לפעילות גופנית לנשים, לקדם מחקרים על נשים בספורט ולתמוך בהם ולגייס כספים למלגות לימודים לספורטאיות. העמותה יזמה אירועי ספורט וכנסים, קידמה ועקבה אחר חקיקה בנושא ספורט נשים והיתה שותפה לגיבוש התכנית הלאומית לספורט נשים. בדוח מבקר המדינה (2013) נכתב כי: ״לפי הסברי משרד רואת החשבון של העמותה למשרד מבקר המדינה במאי 2011, העמותה אינה פעילה בארבע השנים האחרונות, האספה הכללית שלה לא התכנסה, ואין כסף בקופתה; עם זאת עדיין לא ננקטו שום צעדים לסגירת העמותה. לדברי רואת החשבון לא נראה שהעמותה צפויה לחדש את פעילותה. מאידך, בדצמבר 2011 כתבה יו״ר העמותה, שהיא גם מנכ״לית מכון וינגייט (להלן - המנכ״לית), למשרד מבקר המדינה בשם העמותה, כי היקף פעילות העמותה אינו כבעבר, אולם לנוכח חשיבות מטרותיה ״אנו שוקלים אפשרות להרחבת פעילותה״. מכיוון שאין עדויות לפעילות העמותה אחרי 2011 נקבע תאריך סיום הפעילות לשנה זו.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'ספורט'
      ]
    ],
    'id': 'YH151',
    'is_active': false,
    'keywords': [
      'ספורט',
      'ייצוג הולם',
      'ספורטאיות',
      'קידום נשים',
      'אפליה',
      'תקציב',
      'שוויון מגדרי'
    ],
    'name': 'העמותה לקידום נשים בספורט',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ספורט',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>העמותה לקידום נשים בספורט בישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580304269'
      },
      {
        'title': 'מבקר המדינה ונציב תלונות הציבור (2013). היבטים בפעולות לקידום ספורט נשים בישראל.  יוסף חיים שפירא (מבקר המדינה), <b>דוח מבקר המדינה 63ג, לשנת 2012 ולחשבונות שנת הכספים 2011</b> (עמ\' 1481–1545). נדלה מתוך',
        'url': 'http://www.mevaker.gov.il/he/Reports/Report_114/d9c55a26-855b-4c9d-8f72-444c2943c341/7994.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/05/2019'
    },
    'year_closed': 2011,
    'year_closed_text': '2011',
    'year_founded': 1997,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחאה'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '19/01/2019'
    },
    'description': 'הפורום הוקם ב-1996 על ידי שתי״ל וב-1997 פרשו ממנו מספר ארגונים והקימו את הקואליציה הארצית למשפחות חד הוריות. שתי הקואליציות פעלו במקביל. במחקר של ענת הרבסט צויין שבפורום היו שתי נציגות מכל עיר. פעילות מרכזיות בפורום היו חנה מרגלית, שהקימה עמותה בשם ע.ל.מ.ה לחד הוריות ברמת גן וג\'ודי דון שהיתה אחר כך פעילה גם בארגון הנכים. לא ברור מתי הפסיק הפורום לפעול באופן פורמלי, אך לא נמצא תיעוד לפעילות אחרי שנת 2004.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ]
    ],
    'id': 'YH179',
    'is_active': false,
    'keywords': [
      'אמהות גרושות',
      'דיור',
      'תעסוקה',
      'ביטחון סוציאלי',
      'גירושין',
      'זכויות'
    ],
    'name': 'הפורום הארצי למשפחות חד הוריות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (1999, 6 דצמבר). <b>פרוטוקול מס\' 22: פגיעה באוכלוסיית חד-הוריות עקב שינויים בקריטריונים לזכאות לשכר דירה</b>. נדלה מתוך',
        'url': 'https://main.knesset.gov.il/Activity/committees/Pages/AllCommitteesAgenda.aspx?Tab=3&ItemID=2062588'
      },
      {
        'title': 'הרבסט, ענת (2007). <b>מ״עלובת הנפש במשפחה שבורה״ לזעקת קול אם״. אמהות חד הוריות בישראל- מדיניות הרווחה, שיח ולגיטימציה, 1972–2003</b> (חיבור לשם קבלת תואר ״דוקטור לפילוסופיה״). אוניברסיטת בר-אילן, רמת גן.'
      },
      {
        'title': 'סבירסקי, שלמה, קראוס, ורד, קונור-אטיאס, אתי והרבסט, ענת (2002). אמהות חד הוריות בישראל. <b>מידע על שוויון, 12</b>. מרכז אדוה.',
        'url': 'http://adva.org/wp-content/uploads/2014/09/gil12.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '19/01/2019'
    },
    'year_closed': 2004,
    'year_closed_text': '2004',
    'year_founded': 1996,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'יעוץ, שירות וסיוע',
      'מחאה'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '06/11/2018'
    },
    'description': 'ה״הפורום החיפאי לקהילה ההומו-לסבית בי וטרנס״ הוקם ב- 1999, לאחר סגירת סניף אגודת הלהט״ב בעיר, ופעל כארגון ללא בית במשך שלוש השנים הראשונות לקיומו. בשנת 2002 הוא נרשם כעמותה (ע״ר 580400802) שמטרותיה היו: ״ליווי ותמיכה חברתית של הקהילה ההומו- לסבית בי וטרנס בחיפה, להוות בית חם לקהילה, חינוך, הסברה והעלאת המודעות לגבי נושאים יחודיים בקהילה״ וקיבל מבנה בתרומה ממרכז חינוך ליאו בק. הפורום המשיך לפעול עד שנת 2012, כאשר הפסקת התמיכה מליאו בק הובילה להתפרקותו. במהלך שנות פעילותו, הפורום הפעיל קבוצות חברתיות לקבוצות שונות בקהילה הלהט״בית - נשים, דוברי רוסית, נוער, דובים ועוד. הפורום גם אירח מסיבות להט״ביות, הרצאות, סדנאות וקבוצת קריאה קווירית. הפורום ארגן את אירועי הגאווה בעיר, שהתפתחו מרונדו למצעד, ומשמרות גאווה קבועות לקידום הסברה ומניעת להט״בופוביה. בנוסף, הוא הפעיל קו תמיכה נפשית טלפוני וסיפק שירותי יעוץ פסיכולוגי לנוער להט״ב, כמו גם סיוע משפטי לחברי הקהילה. בשנת 2019 העמותה נמחקה באופן רשמי מפנקס העמותות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'LR13',
    'is_active': false,
    'keywords': [
      'גאווה',
      'קהילה',
      'מצעד',
      'קבוצות תמיכה',
      'סיוע משפטי',
      'קו סיוע',
      'טיפול נפשי',
      'נערות',
      'תמיכה נפשית'
    ],
    'name': 'הפורום החיפאי לקהילה ההומו-לסבית בי וטרנס',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': 'סניף חיפה של אגודת הלהט״ב',
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-11-06'
    },
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>הפורום החיפאי – לקהילה הומו-לסבית בי וטרנס (ע״ר): עמותה מחוקה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580400802'
      },
      {
        'title': 'מרחב, דוד (2002, 14 יוני). מצנע: ״אנו לצד הקהילה ההומו-לסבית בחיפה!״ <b>גוגיי</b>. נדלה מתוך',
        'url': 'http://gogay.co.il/item.php?id=3794'
      },
      {
        'title': 'רוזן, מיכל (2017, 2 יולי). הרשימות הוורודות של חיפה. <b>דבר</b>. נדלה מתוך',
        'url': 'https://www.davar1.co.il/74510/'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2012,
    'year_closed_text': '2012',
    'year_founded': 1999,
    'year_registered': 2002
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '14/09/2019'
    },
    'description': 'הפורום למיניות, או בשמו המלא ״הפורום הערבי למיניות הפרט והמשפחה״ (ע״ר 580457612), נוסד בשנת 2006 על ידי קבוצת נשים פלסטיניות מחיפה ומרמאללה, אשר יוצרות ומפיצות חומרי הסברה לקידום המודעות למיניות בריאה, מניעת מחלות, אמצעי מניעה וחשיבות ההסכמה ההדדית, וכן לקידום חינוך מיני למתבגרים, לזוגות צעירים ולכלל האוכלוסיה. את העמותה מנהלת ספא טמיש. כתובת העמותה בחיפה אך הפעילות היא ארצית, כולל במזרח ירושלים. מטרות העמותה הן: ״העלאת מודעות לבריאות וחינוך למיניות בחברה הערבית בישראל; קידום בריאות וחינוך למיניות בבתי ספר בשיתוף משרדי החינוך והבריאות; הקניית מיומנויות וכלים מקצועיים לאנשי מקצוע ערביים בתחום החינוך למיניות ע״י קורסים וסדנאות; פיתוח מקורות מידע וספרות בתחום המיניות וקידום נגישותו לקהל הרחב.״ העמותה מקיימת קורסי הכשרה לבעלי מקצוע וצוותי הוראה בנושא חינוך למיניות, מפתחת פרוייקטים בחינוך למיניות לבעלי צרכים מיוחדים, מעבירה הרצאות לבני נוער ומפתחת חומרי הדרכה.',
    'description_ar': 'منتدى الجنسانية، او باسمه الكامل ״المنتدى العربي لجنسانية الفرد والعائلة״. (ج.م 580457612), تأسس عام 2006 بواسطة نساء فلسطينيات من حيفا ورام الله،  بحيث يقومون بكتابة ونشر مواد تعليمية لتعزيز الوعي حول جنسانية صحية، الوقاية من الأمراض، وسائل منع الحمل وحماية وأهمية الاتفاق المتبادل، وكذلك تعزيز التثقيف الجنسي للمراهقين، الأزواج الشابة وعامة المجتمع. تدير الجمعية صفاء طاميش، مركز الجمعية في حيفا لكن نشاطها قطري ويشمل القدس الشرقية. اهداف الجمعية هن: رفع الوعي حول الصحة والتربية الجنسية في المجتمع العربي في إسرائيل. تعزيز الصحة والتربية الجنسية في المدارس بالشراكة مع وزارة التربية والتعليم ووزارة الصحة. توفير المهارات والأدوات للمهنيين العرب في مجال التربية الجنسية من خلال الدورات وورش العمل، تطوير مصادر المعلومات والأدب في مجال النشاط الجنسي وتعزيز وصولها إلى الجمهور العام ״. تنظم الجمعية دورات تدريبية للمهنيين وأعضاء هيئة التدريس في التربية الجنسية، وتطور مشاريع في التربية الجنسية لذوي الاحتياجات الخاصة، وتجري محاضرات للشباب وتضع مواد تدريبية.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'חינוך',
        'חינוך מיני/מיניות בריאה'
      ],
      [
        'בריאות ופריון',
        'תכנון משפחה וחינוך מיני'
      ]
    ],
    'id': 'SA151',
    'is_active': true,
    'keywords': [
      'פלסטיניות',
      'מיניות',
      'מוגבלות'
    ],
    'name': 'הפורום הערבי למיניות הפרט והמשפחה',
    'name_ar': 'منتدى الجنسانية',
    'name_change_year': null,
    'name_common': 'הפורום למיניות',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'חינוך',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'חינוך מיני/מיניות בריאה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-09-14'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://jensaneya.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>הפורום הערבי למיניות הפרט והמשפחה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580457612'
      },
      {
        'title': 'אבו בקר, ח\'אולה (2015). התנועה הנשית-פמיניסטית הפלסטינית בתוך ישראל. בתוך: סבאע\'-ח\'ורי, אריז\' ורוחאנא, נדים (עורכים). <b>הפלסטינים בישראל: עיונים בהיסטוריה, בפוליטיקה ובחברה</b>, כרך שני (עמ\' 205–222). חיפה: מדה אל-כרמל – המרכז הערבי למחקר חברתי יישומי. נדלה מתוך',
        'url': 'http://mada-research.org/wp-content/uploads/2016/01/hebrew_2-4.pdf'
      },
      {
        'title': 'ענברי, איתמר (2007, 9 יוני). איך אומרים חינוך מיני בערבית? <b>NRG מעריב</b>. נדלה מתוך',
        'url': 'https://www.makorrishon.co.il/nrg/online/1/ART1/592/737.html'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '14/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2006,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '27/11/2018'
    },
    'description': 'בשנת 2000 מונה פורום בכיר לקידום נשים במדע ובאקדמיה, בשיתוף ועדת המדע והטכנולוגיה והוועדה לקידום מעמד האישה בכנסת. הפורום כלל 25-20 פרופסוריות ופרופ\' נינה תורן נבחרה להיות רכזת הפורום. המינוי לא נשא בחובו סמכויות או מימון. במהלך השנים מיעטו ראשי האוניברסיטאות ונציגיהם להגיע לישיבות בנושא בכנסת. אחד ההישגים של הפורום הוא חשיפת קשיים וחסמים והמלצה על הצעות קונקרטיות לפתרונן: הפורום הציע ליישם את רעיון היועצות לענייני נשים, שאותו העלתה שדולת הנשים בישראל שנים קודם לכן, במטרה שהיועצות תהיינה צמודות לנשיא או לרקטור. הגדרת התפקיד תשתנה מאוניברסיטה לאוניברסיטה; בהמשך לחוק הדירקטוריונות, הומלץ להנהיג גם באוניברסיטאות העדפה מתקנת; הפורום הציע שקיפות בתהליכי קבלת החלטות, אשר תמנע השפעת גורמים לא ענייניים; ביטול מגבלת הגיל והגדלת מכסות הנשים שהאוניברסיטאות מגישות כמועמדות למלגות וקרנות; הענקת מלגות רבות יותר לנשים, אשר תסייענה להן לצאת לבתר-דוקטורט בחו״ל; הקפדה על ייצוג פרופורציונלי של נשים בכנסים, מכיוון שהשתתפות בכנסים היא דרך חשובה ליצירת רשתות חברתיות-מקצועיות (בשנים האחרונות מקובל רעיון הכנת מועמדות פוטנציאליות או אוגדן נשים במדע). רשימת הדרישות הוגשה לכל ראשי האוניברסיטאות, אך לא נעשו פעולות כוללות ורציניות ליישום ההצעות. הפורום הפסיק את פעולתו לאחר כשנתיים.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'אגודות מקצועיות'
      ],
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ]
    ],
    'id': 'SA96',
    'is_active': false,
    'keywords': [
      'מחקר',
      'תעסוקה',
      'קידום נשים',
      'מדע',
      'אפליה',
      'פורום',
      'יועצות לקידום מעמד האישה'
    ],
    'name': 'הפורום לקידום נשים באקדמיה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'אקדמי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'אגודות מקצועיות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'וילמובסקי, ענבל ותמיר, טל (2013). פעולות הובלת שינוי מגדרי באוניברסיטאות, בתוך הנ״ל (עורכות), <b>נשים בישראל – בין תאוריה למציאות: מגמות, שינויים ונתונים</b>. רמת גן: שדולת הנשים בישראל וקרן קונראד אדנאואר בישראל.'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי והוועדה לענייני מחקר ופיתוח מדעי וטכנולוגי (2001, 15 ינואר). <b>פרוטוקול מס\' 54: קידום נשים באקדמיה; קידום נשים במדע וקליטת מדעניות עולות – ישיבת מעקב</b>. נדלה מתוך: \n',
        'url': 'http://www.knessetnow.co.il/%D7%95%D7%A2%D7%93%D7%95%D7%AA/%D7%A4%D7%A8%D7%95%D7%98%D7%95%D7%A7%D7%95%D7%9C/12261/%D7%9E%D7%A9%D7%95%D7%AA%D7%A4%D7%AA-%D7%A9%D7%9C-%D7%94%D7%95%D7%95%D7%A2%D7%93%D7%94-%D7%9C%D7%A2%D7%A0%D7%99%D7%99%D7%A0%D7%99-%D7%9E%D7%97%D7%A7%D7%A8-%D7%95%D7%A4%D7%99%D7%AA%D7%95%D7%97-%D7%9E%D7%93%D7%A2%D7%99-%D7%95%D7%98%D7%9B%D7%A0%D7%95%D7%9C%D7%95%D7%92%D7%99-%D7%95%D7%94%D7%95%D7%95%D7%A2%D7%93%D7%94-%D7%9C%D7%A7%D7%99%D7%93%D7%95%D7%9D-%D7%9E%D7%A2%D7%9E%D7%93-%D7%94%D7%90%D7%99%D7%A9%D7%94-%D7%A7%D7%99%D7%93%D7%95%D7%9D-%D7%A0%D7%A9%D7%99%D7%9D-%D7%91%D7%90%D7%A7%D7%93%D7%9E%D7%99%D7%94'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '27/11/2018'
    },
    'year_closed': 2002,
    'year_closed_text': '2002',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '01/12/2020'
    },
    'description': '״הצוות הבין משרדי לבחינת הכלים לצמצום צריכת זנות בישראל״ הוקם ביוני 2016 על ידי שרת המשפטים איילת שקד במטרה לבחון את הכלים לצמצום צריכת הזנות בישראל, וכן לבחון את האפשרות לקביעת עבירה של צריכת זנות. בראש הצוות עמדה עו״ד אמי פלמור, מנכ״לית משרד המשפטים והשתתפו בו נציגות ונציגים ממשרד המשפטים, יחידת תיאום המאבק בסחר בבני אדם, הסניגוריה הציבורית, פרקליטות המדינה, המשרד לביטחון פנים, משטרת ישראל, משרד החינוך, משרד הרווחה, משרד האוצר, משרד הבריאות והמשרד לשוויון חברתי. הצוות הגיש דוח מסכם בדצמבר 2017 שכלל סקירה כללית של מאפייני הזנות בישראל ניתוח מודלים ממדינות אחרות לצמצום והתמודדות עם תופעת הזנות והתייחסות לתחום המשפט והאכיפה תוך דגש על הצעות החוק בדבר הפללת לקוחות זנות. המלצות הצוות עסקו בהיבטים חינוכיים (קיום הדרכות וקמפיינים ציבוריים להעלאת מודעות לצמצום צריכת זנות); שירותי רווחה (הרחבת השירותים המוצעים לעוסקים בזנות ולמבקשים לצאת ממעגל הזנות); הכשרות לאנשי מקצוע וסדנאות לקידום מין מוגן; גיבוש תכנית התערבות עבור גברים צרכני זנות; הגברת האמצעים לשיפור האכיפה של עבירות הנוגעות לזנות, זנות קטינים וסרסרות. בכל הנוגע להפללת לקוחות, הוצע לבחון ״מודל של אכיפה פלילית מדורגת, שייקבע במסגרת הנחיות אכיפה, במסגרתו ייעשה שימוש בסמכויות של סגירת תיק החקירה לאחר חקירה באזהרה ושל סגירת תיק בהסדר״. באוגוסט 2018 החליטה הממשלה על הקמת ״צוות לבחינת דרכי יישום של דו״ח הצוות הבין-משרדי לצמצום צריכת זנות ולבחינת האפשרות להפללת לקוחות זנות״ (החלטה מספר 4099) בראשות מנכ״לית משרד המשפטים ונציגי משרדים רלוונטיים. מטרת הצוות היא לבחון את המלצות הדוח ולנסח תכנית ליישומן, כולל מקור תקציבי ומועדי ביצוע.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'זנות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'SA179',
    'is_active': false,
    'keywords': [
      'חקיקה',
      'אלימות מינית',
      'נתונים'
    ],
    'name': 'הצוות הבין‑משרדי לבחינת הכלים לצמצום צריכת זנות בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'זנות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2020-12-01'
    },
    'sources': [
      {
        'title': 'דוח הצוות הבין משרדי לבחינת הכלים לצמצום צריכת זנות',
        'url': 'https://www.gov.il/BlobFolder/reports/18_1_10_3/he/reducing_feeds.pdf'
      },
      {
        'title': 'משרד ראש הממשלה (2018, 5 אוגוסט). החלטת ממשלה מס\' 4099. הקמת צוות לבחינת דרכי יישום של דו״ח הצוות הבין-משרדי לצמצום צריכת זנות ולבחינת האפשרות להפללת לקוחות זנות. נדלה מתוך',
        'url': 'https://www.gov.il/he/departments/policies/dec4099_2018'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/12/2020'
    },
    'year_closed': 2018,
    'year_closed_text': '2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '01/12/2020'
    },
    'description': 'בדצמבר 2011 החליטה הממשלה להקים צוות בין-משרדי שיציע לממשלה דרכים ופתרונות אפשריים להתמודד עם הדרת נשים מן המרחב הציבורי. בראש הצוות עמדה השרה לימור לבנת. הצוות הגיש את המלצותיו במרץ, ובין ההמלצות הוזכרו הצורך בהגברת המודעות הציבורית לנושא, מניעת הדרת נשים בבתי-עלמין, מניעת הדרת נשים בתחבורה הציבורית, מניעת הדרת נשים בכלי-התקשורת והגברת האכיפה המשטרתית של חוקים המונעים הדרת נשים. בינואר 2012, בעקבות דיווחים רבים על תופעות שונות של אפליית נשים ובעיקר הדרתן מהמרחב הציבורי, לעתים תוך אלימות מילולית ופיזית, מינה היועץ המשפטי לממשלה צוות משרדי בנושא הדרת נשים. על הצוות, בראשות עו״ד שרית דנה, הוטל לבחון את ההיבטים המשפטיים של כמה ביטויים עיקריים של תופעה זו ולגבש המלצות לטיפול בהם, הן במישור הפלילי והן במישור המינהלי. כמו כן, התבקש הצוות לחוות את דעתו בשאלת הצורך בתיקוני חקיקה. הצוות התמקד בחוקיות אפליית הנשים בכמה תחומים, אשר נמצאים באחריות משרדי הממשלה האלה: משרד הפנים, המשרד לשירותי דת, משרד התחבורה, משרד התקשורת, משרד התרבות והספורט ומשרד הבריאות. בין הנושאים שנדונו: הפרדה בין נשים לגברים בבתי-עלמין ובבתי-הספד; הפרדה בין נשים לגברים בסניפים של קופות-החולים; הצבת ״שלטי צניעות ״ במרחב הציבורי; הפרדה בין נשים לגברים בקווים מסוימים בתחבורה הציבורית ועוד. דוח הוועדה הוגש ליועץ המשפטי לממשלה בחודש מרץ 2013. הועדה מצאה כי בכל אחד מההקשרים שנבחנו אין שוני רלוונטי המצדיק הפרדה בין גברים ונשים וכי אין יחס ראוי בין עוצמת הפגיעה בזכויות היסוד החוקתיות ובין מידת התועלת החברתית המושגת. לאור זאת קבעה הוועדה כי על כל אחת מהרשויות הציבוריות הנוגעות בדבר לפעול במהירות להפסקת ביטויי ההפרדה. במאי 2013 אימץ היועץ המשפטי לממשלה יהודה וינשטיין את דוח הוועדה , ופנה לשרים הנוגעים בדבר לשם קבלת התייחסותם טרם הפצת הנחיות אופרטיביות מטעמו. עו״ד דינה זילבר מונתה לאחראית ליישום המלצות הצוות המשרדי לבחינה של תופעת הדרת הנשים במרחב הציבורי. במרץ 2014 התקבלה החלטת ממשלה מס\' 1526 ולפיה שרי המשרדים הרלוונטיים ידווחו לממשלה תוך 90 ימים על פעולות שננקטו לקראת בחינה ויישום של ההנחיות שנכללו בדו״ח.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'פוליטיקה ומנהיגות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'SA180',
    'is_active': false,
    'keywords': [
      'חקיקה',
      'הדרת נשים',
      'אפלייה מגדרית',
      'תחבורה',
      'תקשורת',
      'צבא'
    ],
    'name': 'הצוות הבין‑משרדי למניעת הדרת נשים במרחב הציבורי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2020-12-01'
    },
    'sources': [
      {
        'title': 'המלצות הצוות הבין-משרדי למניעת הדרת נשים במרחב הציבורי, הוגש לממשלה ב-11 מרץ 2012',
        'url': 'https://www.haokets.org/wp-content/uploads/2012/03/livnat.pdf'
      },
      {
        'title': 'המשרד לשוויון חברתי, הרשות לקידום מעמד האישה (2013, 7 מרץ). <b>דו״ח הצוות המשרדי לבחינת תופעת הדרת הנשים במרחב הציבורי</b>, הוגש ליועץ המשפטי לממשלה (העמוד אינו זמין יותר).'
      },
      {
        'title': 'משרד ראש הממשלה (2011, 13 דצמבר). החלטת ממשלה מס\' 4052. הדרת נשים מן המרחב הציבורי. נדלה מתוך',
        'url': 'https://www.gov.il/he/departments/policies/2011_des4052'
      },
      {
        'title': 'מזרחי סימון, שלי (2015, 31 מאי). הדרת נשים. בתוך: <b>נשים בישראל - סוגיות מרכזיות</b> (עמ\' 46–48). מוגש לוועדה לקידום מעמד האישה ולשוויון מגדרי. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'http://m.knesset.gov.il/Activity/Info/MMMSummaries19/Women_8.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים חרדיות',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/12/2020'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 2011,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '11/06/2018'
    },
    'description': 'הקואליציה הוקמה ב-2010 ע״י אורנה עמוס, עו״ס ומרצה באוניברסיטת בן-גוריון בעקבות מאבק עובדות הניקיון באוניברסיטה בסוף שנות ה-2000. הקואליציה מונה כ-30 ארגוני עובדים, ארגוני סטודנטים, ארגונים חברתיים, ועדי עובדים ופעילים חברתיים, והוקמה כדי לקדם נורמה של העסקה ישירה במשק העבודה הישראלי, בראש וראשונה במגזר הציבורי.\nבתוך הקואליציה פועלת קואליציה להעסקה ישירה בחינוך שבה כ-25,000 מורות קבלן.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'YH132',
    'is_active': true,
    'keywords': [
      'עובדות קבלן',
      'הפרטה',
      'אקטיביזם',
      'זכויות',
      'זכויות בעבודה',
      'עובדות ניקיון'
    ],
    'name': 'הקואליציה הארצית להעסקה ישירה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'זכויות ומדיניות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://coalition4de2013.wordpress.com/'
      },
      {
        'title': 'הקואליציה הארצית להעסקה ישירה. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%94%D7%A7%D7%95%D7%90%D7%9C%D7%99%D7%A6%D7%99%D7%94_%D7%94%D7%90%D7%A8%D7%A6%D7%99%D7%AA_%D7%9C%D7%94%D7%A2%D7%A1%D7%A7%D7%94_%D7%99%D7%A9%D7%99%D7%A8%D7%94'
      },
      {
        'title': 'הקואליציה הארצית להעסקה ישירה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pg/coalition4de/about/?ref=page_internal'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/06/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2010,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחאה'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '19/01/2019'
    },
    'description': 'הקואליציה הוקמה ב-1997 כאשר חלק מהארגונים המרכיבים אותה פרשו מהפורום הארצי למשפחות חד הוריות שהוקם על ידי שתי״ל שנה קודם לכן. הקואליציה עוסקת בעיקר בזכויות דיור ובראשה עמדה ברכה ארג\'ואני שתפקדה גם כיו״ר הארגון לזכויות (נרשם כעמותה ב-1996). לא ברור אם עדין פועלת. נכון לשנת 2015 נציגות מהקואליצייה הופיעו לדיונים בכנסת שעסקו בזכויותיהן של אמהות חד הוריות.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ]
    ],
    'id': 'YH178',
    'is_active': false,
    'keywords': [
      'אמהות גרושות',
      'דיור',
      'ביטחון סוציאלי',
      'גירושין',
      'זכויות'
    ],
    'name': 'הקואליציה הארצית למשפחות חד הוריות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים מזרחיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2008, 28 מאי). <b>פתרונות דיור בקרב משפחות חד הוריות - המשך דיון</b>. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_html/law103/maamad2008-05-28.htm'
      },
      {
        'title': 'הרבסט, ענת (2007). <b>מ״עלובת הנפש במשפחה שבורה״ לזעקת קול אם״. אמהות חד הוריות בישראל- מדיניות הרווחה, שיח ולגיטימציה, 1972–2003</b> (חיבור לשם קבלת תואר ״דוקטור לפילוסופיה״). אוניברסיטת בר-אילן, רמת גן.'
      },
      {
        'title': 'סבירסקי, שלמה, קראוס, ורד, קונור-אטיאס, אתי והרבסט, ענת (2002). אמהות חד הוריות בישראל. <b>מידע על שוויון, 12</b>. מרכז אדוה.',
        'url': 'http://adva.org/wp-content/uploads/2014/09/gil12.pdf'
      }
    ],
    'target_audiences': [
      'נשים מזרחיות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '21/02/2019'
    },
    'year_closed': 2016,
    'year_closed_text': '2016',
    'year_founded': 1997,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '29/07/2018'
    },
    'description': 'בשנת 2014 חברו מספר ארגוני נשים בחברה החרדית ובכלל יחד עם כמה רשויות לקואליציה במטרה לקדם שינוי ב-״חוק המזונות - המוסד לביטוח לאומי״ כדי לאפשר לאימהות החד-הוריות ‏להתפרנס בכבוד ולפרנס את ילדיהן מבלי לוותר על דמי המזונות. בקואליציה חברים: רוח נשית, מרכז רקמן, קבוצת הסינגור ע״י אם הבנים״, באשר תלכי, נשים נגד אלימות, שינוי חד, מעל״ה - מעגלי עוצמה לאם העצמאית, עדינה בר-שלום, עם אחד לב אחד, האגודה הישראלי למען יוצאי אתיופיה, מחלקות הרווחה בעיריית ירושלים ועיריית ראש העין.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ],
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ]
    ],
    'id': 'YH64',
    'is_active': true,
    'keywords': [
      'אמהות גרושות',
      'דמי מזונות',
      'ביטחון סוציאלי',
      'זכויות',
      'חקיקה'
    ],
    'name': 'הקואליציה להבטחת תשלום דמי מזונות ילדים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'הקואליציה להבטחת תשלום דמי מזונות ילדים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/komezonot/'
      },
      {
        'title': 'נייר עמדה מאוקטובר 2015: ״הצעה לתיקון חוק המזונות״',
        'url': 'http://rackmancenter.com/wp-content/uploads/2015/10/%D7%A0%D7%99%D7%99%D7%A8-%D7%A2%D7%9E%D7%93%D7%94-%D7%A9%D7%99%D7%A0%D7%95%D7%99-%D7%97%D7%95%D7%A7-%D7%94%D7%9E%D7%96%D7%95%D7%A0%D7%95%D7%AA-%D7%99%D7%95%D7%9D-%D7%94%D7%9E%D7%90%D7%91%D7%A7-%D7%91%D7%A2%D7%95%D7%A0%D7%99.pdf'
      },
      {
        'title': 'הקואליציה להבטחת תשלום מזונות ילדים (2018). <b>נייר עמדה – עבודה לא מדווחת של נשים החיות בעוני – לקראת דיון בועדה לקידום מעמד האשה ביום</b>. נדלה מתוך',
        'url': 'http://rackmancenter.com/wp-content/uploads/2018/02/%D7%A0%D7%99%D7%99%D7%A8-%D7%A2%D7%9E%D7%93%D7%94-%D7%A0%D7%A9%D7%99%D7%9D-%D7%9E%D7%AA%D7%97%D7%AA-%D7%9C%D7%A7%D7%95-%D7%94%D7%A2%D7%95%D7%A0%D7%99-2018-2.pdf'
      }
    ],
    'target_audiences': [
      'נשים דתיות',
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '26/05/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/04/2018'
    },
    'description': 'הקואליציה למניעת סחר בנשים הוקמה ב-1997 בעקבות פרסום דוח של שדולת הנשים תחת הכותרת: ״הברחת נשים לישראל וזנות בכפייה״ (ונדנברג, 1997). מטרת הקואליציה היתה: למגר את הסחר בנשים בישראל ולטפל בקורבנותיו. הארגונים החברים בקואליציה היו שדולת הנשים, אשה לאשה, מוקד סיוע לעובדים זרים, איגוד מרכזי סיוע לנפגעות תקיפה מינית, אנחנו שוות, האגודה לזכויות האזרח, אמנסטי אינטרנשיונל, קל״ף, ל.א.- לאלימות נגד נשים, קול האשה, שומרי משפט-רבנים למען זכויות אדם, תמר- הנשמה מתחת לבגדים, הקשת הדמוקרטית המזרחית ועצו״ם. בעקבות התרבות מספר הארגונים שפעלו בתחום הזה והצטרפותם של ארגונים נוספים לקואליציה, הוחלט בשנת 2003 לפנות לארגון שתי״ל כדי שירכז את הפעילות, יסייע בגיוס כספים ויעניק ייעוץ ארגוני שוטף. הארגון מינה לקואליציה רכזת בהיקף של חצי משרה. הקואליציה הפסיקה את פעילותה בשנת 2007.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'סחר בנשים'
      ],
      [
        'הגירה',
        'סחר בבני אדם'
      ]
    ],
    'id': 'SA6',
    'is_active': false,
    'keywords': [
      'קואליציה',
      'העלאת מודעות',
      'סחר בנשים',
      'זנות',
      'מידע',
      'טראומה',
      'אלימות',
      'פמיניזם'
    ],
    'name': 'הקואליציה למאבק בסחר בנשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'סחר בנשים',
    'primary_target_audience': 'נשים מהגרות עבודה או חסרות מעמד',
    'retrieved': null,
    'sources': [
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל. עמ\' 60–61.'
      },
      {
        'title': 'ונדנברג, מרטינה (1997). <b>הברחת נשים לישראל וזנות בכפייה</b>. ירושלים: שדולת הנשים בישראל.'
      },
      {
        'title': 'חייקין, ריטה וחנה ספרן (2012). ״בין סחר בנשים לזנות - גלגולו של מאבק חברתי״. אותר בארכיון הפמיניסטי ב״אשה לאשה – מרכז פמיניסטי חיפה״.'
      }
    ],
    'target_audiences': [
      'נשים מהגרות עבודה או חסרות מעמד'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '14/09/2019'
    },
    'year_closed': 2007,
    'year_closed_text': '2007',
    'year_founded': 1997,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '07/05/2018'
    },
    'description': 'ה״קואליציה נגד פורנוגרפיה״ הוקמה בשנת 2001 כחלק משיתוף פעולה בין ויקי שירן שהיתה חברה בקשת הדמוקרטית המזרחית ופרסמה מאמר במדור דעות ב״ידיעות אחרונות״ (זנות מצולמת, 23.07.2001) לבין אסתר הרצוג מתנועת ש.י.ן שפרסמה מאמר דומה במדור דעות ב״מעריב״ (נשים נגד פורנוגרפיה 22.07.2001). הקואליצייה התגבשה במחאה על מתן היתר לערוץ שידורים של ארוטיקה ופורנוגרפיה בטלוויזיה המסחרית והשקתם של שלושה ערוצים למבוגרים על ידי חברות הכבלים ביולי 2000 והתיקונים השונים ל״חוק התקשורת״ שהתרחשו בעקבותיו. על רקע זה החלה ההתארגנות של הקואליציה נגד הפורנוגרפיה שכללה כ-15 ארגונים (ש.י.ן, ויצו, אמונה, שדולת הנשים, ל.א. לחימה באלימות, אלמאנהל, אחותי, ה״ן הרצליה נשים, פרלמנט נשים, הקשר הפמיניסטי, מועצות נשים ברשויות המקומיות, התנועה לגבריות חדשה והקשת הדמוקרטית המזרחית) ומטרותיה היו: \nלהביא לחקיקה האוסרת באופן אפקטיבי שידורים פורנוגרפיים בערוצי השידור הציבוריים, מתוך השקפת עולם פמיניסטית חברתית; \nלהביא למודעות הציבור את נזקי הפורנוגרפיה, את הקשר בינה לבין דיכוי נשים ולהתנהגות אלימה כלפיהן; \nלשנות את התפיסה החברתית הרואה בפורנוגרפיה סממן של חברה חופשית ופתוחה מבחינה מינית ובמתנגדים לה, מייצגי תפישת עולם דתית שמרנית. \nעל מנת לקדם מטרות אלו יצרו חברות הקואליצייה שיתוף פעולה פרגמטי עם פוליטיקאים מהמפלגות הדתיות והחרדיות כדי לנסח במשותף חוק מרחיב יותר ולהפוך את המאבק בפורנוגרפיה לנחלת הציבור. ביולי 2001, בעקבות פעילותם של חברי כנסת מהמפד״ל וש״ס ביחד עם הקואליציה הפמיניסטית נוסף תיקון 25 ל״חוק התקשורת״ שאסר על שידורו של ערוץ שעיקר שידוריו הם משדרי מין. התיקון קבע כי: ״בעל רשיון לשידורי כבלים לא ישדר שידורים (2א)... שחלק מהותי מתוכם כולל תכנים העוסקים במין בדרך של הצגת יחסים מיניים או בדרך של הצגת מעשים המיועדים לעורר גירוי מיני או שיש בהם ביזוי או השפלה מיניים או שהם מציגים אדם כחפץ זמין לשימוש מיני או כנתון להתעללות גופנית או מינית״. \nשינוי חקיקתי זה הביא את המועצה לשידורי כבלים ולשידורי לוויין לקיים דיונים ציבוריים ולפרסם פרשנות מרחיבה לפיה החוק חל על ערוצים של משדרי מין אך לא על שידורים בשיטת תשלום לפי צפייה. בהתאם לכך, קבעה המועצה כי ניתן לקיים שידור ערוצי מבוגרים בשיטת תשלום לפי צפייה ומגבלות נוספות. אולם, באוקטובר 2001 עתרה חברת פלייבוי לבית המשפט נגד התיקון לחוק בשל טענה כי הוא פוגע בחופש הביטוי, בחופש העיסוק ובזכות הקניין ובראשית חודש מרץ 2002 הפסיק ערוץ פלייבוי את שידוריו עקב קשיים במכירת הערוצים לפי התנאים החדשים. הדיונים בבג״ץ על עתירת פלייבוי נמשכו עד 2003 כאשר הוחלט (בג״ץ 5432/03) לאפשר את שידורי ערוץ פלייבוי. במקביל, אישרה הכנסת את תיקון מס\' 27 ל״חוק התקשורת״ האוסר לחלוטין שידורי פורנוגרפיה בטלוויזיה ו״חומר תועבה״. פעילות הקואליציה עוררה התנגדות מצד ארגונים פמיניסטיים אשר ביקרו את שיתוף הפעולה עם חברי כנסת דתיים וחששו שהחקיקה עלולה לפגוע בקהילה ההומו-לסבית. הקמת הקואליציה נגד שידורי הפורנוגרפיה היתה המאבק החברתי-פמיניסטי האחרון שבו היתה מעורבת ויקי שירן.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'פורנוגרפיה'
      ],
      [
        'תקשורת'
      ]
    ],
    'id': 'YH51',
    'is_active': false,
    'keywords': [
      'פורנוגרפיה',
      'תקשורת',
      'קואליצייה',
      'חקיקה'
    ],
    'name': 'הקואליציה נגד פורנוגרפיה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'פורנוגרפיה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'בן-נתן, סמדר (2004). <b>פורנוגרפיה כהסתה נגד נשים</b>. פרלמנט נשים – במה לפוליטיקה מזווית אחרת וקרן פרידריך אברט. נדלה מתוך',
        'url': 'http://womenparliament.org/%D7%A4%D7%95%D7%A8%D7%A0%D7%95%D7%92%D7%A8%D7%A4%D7%99%D7%94-%D7%9B%D7%94%D7%A1%D7%AA%D7%94-%D7%A0%D7%92%D7%93-%D7%A0%D7%A9%D7%99%D7%9D-%D7%A2%D7%95%D7%93-%D7%A1%D7%9E%D7%93%D7%A8-%D7%91%D7%9F/'
      },
      {
        'title': 'הרצוג, אסתר (2002). ״בין חופש הביטוי לחופש הדיכוי״. <b>פנים 22</b>, 47–55 . נדלה מתוך',
        'url': 'http://www.itu.org.il/?CategoryID=521&ArticleID=1540&Page=1'
      },
      {
        'title': 'הרצוג, אסתר ושירן, ויקי (2013). פורנוגרפיה בין הון, שלטון ועיתון. בתוך: הרצוג, אסתר ושדמי, אריאלה (עורכות), <b>בשר ודמים: זנות, סחר ונשים ופורנוגרפיה בישראל</b> (עמ\' 271–295). חיפה: פרדס.'
      },
      {
        'title': 'זיו, עמליה (2004). וביקורת מיניים: המחלוקת הפמיניסטית על פורנוגרפיה. <b>תיאוריה וביקורת 25</b>, 163–194.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '18/12/2019'
    },
    'year_closed': 2004,
    'year_closed_text': '2004',
    'year_founded': 2001,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחאה',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '30/10/2018'
    },
    'description': 'קבוצת ״הקול הנשי״ היא התארגנות הוקמה בשנת 2011 לפעילות מוגדרת למען אימהות חד הוריות בעיקר ״בשל מצוקה ו״מלחמה״ לקיום יומיומי בשל סירוב אבות לתשלום מזונות והקושי לגבייתם. הקבוצה שמה לה למטרה לפעול בכל דרך אפשרית לשינוי חוק הביטוח הלאומי לשינוי הליך גביית חוב מזונות יחד עם שינוי מעמד האשה, האם החד הורית״ (מתוך עמוד הפייסבוק של הקבוצה). ההתארגנות, שמונה כיום מעל 1000 נשים ברחבי הארץ, הוקמה על ידי בובה לוי וגלית נחום מראשון לציון, שתי אמהות חד הוריות שפועלות לשינוי חוק המזונות. פעילות הקבוצה מכוונת למשפחות במצוקה וכוללת הדרכה, ייעוץ ומיצוי זכויות, הוצאת נשים ממעגל האלימות, הרצאות, ליווי נשים לבתי המשפט, ליווי טרום גירושין ולאחריהן, נוכחות בוועדות בכנסת, פגישות עם ח״כים ושרים, הגברת המודעות בקרב החברה ושינוי התדמית בחברה.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ]
    ],
    'id': 'YH125',
    'is_active': true,
    'keywords': [
      'אמהות גרושות',
      'דמי מזונות',
      'אלימות',
      'סיוע כלכלי',
      'אקטיביזם רשת',
      'ביטחון סוציאלי',
      'זכויות'
    ],
    'name': 'הקול הנשי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ראשון לציון',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'בובה לוי וגלית נחום -הקול הנשי, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/bubahakolhanasi/'
      },
      {
        'title': 'בובה לוי (בלוג). באתר Saloona. נדלה מתוך',
        'url': 'http://saloona.co.il/bubalevi/'
      },
      {
        'title': 'ביאור, חיים (2014, 7 אוקטובר). לא אוותר על אוכל מפנק לילדים, המקרר תמיד מלא: בובה לוי. <b>TheMarker</b>. נדלה מתוך',
        'url': 'https://www.themarker.com/career/1.2453910'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים מזרחיות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '30/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2011,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'מחאה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '19/12/2018'
    },
    'description': 'ה״קשר הפמיניסטי״ שנרשמה כעמותה (ע״ר 580252047) בשנת 1994 היא גלגול מאוחר של ״התנועה הפמיניסטית בישראל״ שנוצר לאחר הפרידה ממרכז הסיוע בתל אביב. אסתר עילם כותבת כי היוזמה נועדה לפתוח מרכז פמיניסטי עצמאי במתנ״ס בשכונת נווה אליעזר בדרום מזרח תל אביב אך פעילותה גוועה בשנת 1997 והיא נסגרה סופית בשנת 2002. מטרות העמותה היו: ״הקמת מרכז (בית) פמיניסטי בעיר תל אביב. הפעלת מרכז מידע לנשים. הפעלת קורסים וחוגים לנשים. ארגון כנסים, משמרות מחאה בנושאים פמיניסטיים ובנושאי מעמד האשה.״',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ]
    ],
    'id': 'SA103',
    'is_active': false,
    'keywords': [
      'פמיניזם',
      'מידע'
    ],
    'name': 'הקשר הפמיניסטי - בית לכל אשה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'עילם, אסתר (2012). פמיניסטית באקדמיה בשנות השבעים. <b>מגדר: כתב עת למגדר ופמיניזם</b>, 1, 117–132. נדלה מתוך',
        'url': 'http://blogdebate.org/gender/journal/wp-content/uploads/2012/12/%D7%90%D7%A1%D7%AA%D7%A8-%D7%A2%D7%99%D7%9C%D7%9D.pdf'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 5064 (2002, 7 אפריל). <b>הודעה מוקדמת בדבר מחיקה מפנקס העמותות</b>. הקשר הפמיניסטי – בית לכל אישה (מספר עמותה 580252047). עמ\' 1840. נדלה מתוך',
        'url': 'https://www.gov.il/he/departments/dynamiccollectors/gazette-official?skip=0&FolderType=2&BookletNum=5064'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/12/2018'
    },
    'year_closed': 2002,
    'year_closed_text': '2002',
    'year_founded': 1994,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'מחאה',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'description': '״הקשת החיפאית״ היא ארגון להט״בי שפעל בחיפה בין השנים 2012-2017. בשלוש השנים הראשונות לפעילותה היא פעלה תחת הכותרת ״קואליצית ארגוני הגאווה של חיפה״, מנגנון אד הוקי שנועד להחליף את ״הפורום החיפאי״ בארגון מצעדי הגאווה והפעילות הקהילתית בעיר. ב - 2015 היא הפכה לעמותה רשומה, כאשר היא השתלטה במהלך מוסכם על הרישום העמותתי של ״שישה צבעים״ שהייתה בתהליכי התפרקות. בנוסף לארגון מפגשים חברתים ופעילויות קהילתיות, הקשת החיפאית ארגנה את מצעדי הגאווה בחיפה והייתה מעורבת בעבודה מול העירייה על הקמת בית הקהילות. ״פרויקט ההיסטוריה החיפאית הגאה״ פעל בראשית ימיו כחלק מהקשת החיפאית, והפך בהמשך לפרויקט עצמאי.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'LR25',
    'is_active': false,
    'keywords': [
      'מצעד',
      'גאווה',
      'היסטוריה'
    ],
    'name': 'הקשת החיפאית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': 'קואליציית ארגוני הגאווה של חיפה',
    'official_address': 'חיפה',
    'organization_kind': [
      'קואליציה, איגוד או פורום',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>שישה צבעים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580483303'
      },
      {
        'title': 'הקשת החיפאית, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/HaifaRainbow/'
      },
      {
        'title': '(2016, 13 פברואר). מסיבת ההשקה של הקשת החיפאית. <b>וודג׳</b>. נדלה מתוך',
        'url': 'https://www.wdg.co.il/%D7%9E%D7%A1%D7%99%D7%91%D7%AA-%D7%94%D7%94%D7%A9%D7%A7%D7%94-%D7%A9%D7%9C-%D7%94%D7%A7%D7%A9%D7%AA-%D7%94%D7%97%D7%99%D7%A4%D7%90%D7%99%D7%AA/'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2017,
    'year_closed_text': '2017',
    'year_founded': 2012,
    'year_registered': 2007
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': '״הרשות לקידום מעמד האישה״ היא רשות ממשלתית שהוקמה בשנת 1998 והחליפה את תפקיד ״יועצת ראש הממשלה למעמד האישה״ (1979-1997) במטרה ליישם בצורה מלאה יותר את ההמלצה הראשונה בדו״ח ועדת נמיר (1978). ההמלצה המקורית קבעה כי ״תוקם רשות ממלכתית לטיפול ומעקב בנושא מעמד האשה. א) הרשות לטיפול ומעקב בנושא מעמד האשה תפעל בחסות משרד ראש הממשלה. ב) הרשות תפעל למימוש המלצות הועדה ותעקוב אחר ביצוען.״ חוק ״הרשות לקידום מעמד האשה״ התשנ״ח - 1998״ הכפיף את הרשות למשרד ראש הממשלה והסמיך אותה כגוף האחראי לתת מענה בכל הנושאים הקשורים במעמד האישה בישראל. החוק קובע כי מטרת הרשות היא ״לקדם את השוויון בין נשים לגברים בישראל, להביא לתיאום בין הגופים המטפלים במעמד האישה בישראל, לקדם את החינוך, החקיקה והאכיפה בתחומים אלה, להבטיח כי בהליכי החקיקה ייבחנו השלכות החקיקה המוצעת על השוויון בין נשים לגברים, לקדם פעילות למניעת אלימות נגד נשים, להעמיד לרשות הממשלה את הכלים והמידע הנדרשים להשגת המטרות האמורות, ולהקים רשות מרכזית שתפעל ליישום עקרונות אלה״. תפקיד נוסף של הרשות היא לקבל דיווחים שוטפים מהיועצות לקידום מעמד האישה ברשויות המקומיות. בשנת 2015, בכנסת ה-20 תוקן החוק והאחריות על פעולות הרשות הועברה לידי המשרד לשיוויון חברתי (או בשמו המקורי ״המשרד לאזרחים ותיקים״). מנהלות הרשות לדורותיהן הן עו״ד נעמי לירן (2000-1998), רונית לב-ארי (2003-2000), יהודית פלוטקין (2006-2003), מרית דנון (2010-2006) ורד סוויד (2010-2016) ואווה מדז\'יבוז\'.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'אלימות',
        'אלימות במשפחה'
      ]
    ],
    'id': '1YB12',
    'is_active': true,
    'keywords': [
      'האמנה לביעור כל צורות ההפליה נגד נשים 1979 CEDAW',
      'הטמעת חשיבה מגדרית',
      'הטרדה מינית',
      'העדפה מתקנת',
      'חקיקה',
      'יועצות לקידום מעמד האישה',
      'כנסת',
      'מידע'
    ],
    'name': 'הרשות לקידום מעמד האישה',
    'name_ar': 'سلطة النهوض بمكانة المرأة',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': 'יועצת ראש הממשלה למעמד האישה',
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.gov.il/he/Departments/Topics/improving_women_status'
      },
      {
        'title': 'המשרד לשוויון חברתי (1998). <b>חוק הרשות לקידום מעמד האשה תשנ״ח</b>. נדלה מתוך',
        'url': 'https://www.gov.il/BlobFolder/legalinfo/rule_women/he/%D7%97%D7%95%D7%A7%20%D7%94%D7%A8%D7%A9%D7%95%D7%AA%20%D7%9C%D7%A7%D7%99%D7%93%D7%95%D7%9D%20%D7%9E%D7%A2%D7%9E%D7%93%20%D7%94%D7%90%D7%99%D7%A9%D7%94.pdf'
      },
      {
        'title': 'הרשות לקידום מעמד האישה (2014, אוגוסט). הפרטים אומתו בשיחה עם נציגת הרשות.'
      },
      {
        'title': 'שטינברג, פנינה (2012). <b>מקידום נשים להטמעת חשיבה מגדרית: תמורות בתפקיד הממונה על קידום מעמד האישה במשרדי הממשלה – מחקר מדיניות</b>. שוות: המרכז לקידום נשים בזירה הציבורית. ירושלים: ון ליר. נדלה מתוך',
        'url': 'https://www.vanleer.org.il/sites/files/product-pdf/%D7%AA%D7%A4%D7%A7%D7%99%D7%93%20%D7%94%D7%9E%D7%9E%D7%95%D7%A0%D7%95%D7%AA%20%D7%A2%D7%9C%20%D7%A7%D7%99%D7%93%D7%95%D7%9D%20%D7%9E%D7%A2%D7%9E%D7%93%20%D7%94%D7%90%D7%A9%D7%94%20-%20%D7%9E%D7%97%D7%A7%D7%A8%20%D7%9E%D7%93%D7%99%D7%A0%D7%99%D7%95%D7%AA.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '03/02/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '31/12/2018'
    },
    'description': 'השדולה למען הקהילה הגאה הוקמה לראשונה בשנת 2011, ביום הבינלאומי נגד להט״בופוביה. היא הוקמה תחת השם ״השדולה למאבק בהומופוביה״ על ידי חברי הכנסת ניצן הורוביץ ממרצ ונינו אבסדזה מקדימה. ב-2013 הורוביץ הקים מחדש את השדולה, הפעם יחד עם חבר הכנסת עופר שלח מ״יש עתיד״ והיא פועלת מאז ברצף. השדולה עוסקת בנושאים הקשורים לקהילת הלהט״ב על קבוצותיה השונות, ומארגנת מאז 2015 את יום הקהילה הגאה בכנסת. יושבי הראש של השדולה בכנסת ה-20 היו יואב קיש, יעל גרמן, מיכל רוזין, מירב בן-ארי, מרב מיכאלי ושרן השכל. השכל התפטרה מתפקידה במהלך הקדנציה במחאה על התנהלות הליכוד בנושא חוק הפונדקאות.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'להט״ב',
        'פוליטיקה ומנהיגות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ],
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ]
    ],
    'id': 'LR34',
    'is_active': true,
    'keywords': [
      'חקיקה',
      'כנסת',
      'גאווה',
      'להט״בופוביה',
      'קהילה',
      'זכויות להט״ב'
    ],
    'name': 'השדולה לקהילה הגאה',
    'name_ar': null,
    'name_change_year': 2013,
    'name_common': null,
    'name_past': 'השדולה למאבק בהומופוביה',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'השדולה הגאה בכנסת ה-20, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/%D7%94%D7%A9%D7%93%D7%95%D7%9C%D7%94-%D7%94%D7%92%D7%90%D7%94-%D7%91%D7%9B%D7%A0%D7%A1%D7%AA-%D7%94-20-366990026825324/'
      },
      {
        'title': 'הכנסת (ללא תאריך). שדולות בכנסת, <b>השדולה למען הקהילה הגאה</b>.',
        'url': 'https://main.knesset.gov.il/mk/Pages/Lobby.aspx'
      },
      {
        'title': 'יולדוס רוזנצוייג, רועי (2013, 19 פברואר). כנסת ורודה: הוקמה השדולה הגאה בכנסת. <b>Mako גאווה</b>. נדלה מתוך',
        'url': 'https://www.mako.co.il/pride-news/local/Article-46552ed49b1fc31006.htm'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '31/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2011,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '03/02/2019'
    },
    'description': 'התא הוקם בשנת 2013 בשיתוף פעולה בין סטודנטיות ומדור אקדמיה באגודת הסטודנטים. התא פועל בשיתוף פעולה עם ספירניסטיות - הפורום הפמיניסטי של המרצות בספיר. מארגנות כנסים, אירועים והרצאות.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תאים סטודנטיאליים'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ]
    ],
    'id': 'YH188',
    'is_active': true,
    'keywords': [
      'הטרדה מינית',
      'אקטיביזם',
      'סטודנטיות',
      'פריפריה'
    ],
    'name': 'התא הפמיניסטי במכללת ספיר',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'שדרות',
    'organization_kind': [
      'אקדמי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תאים סטודנטיאליים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'התא הפמיניסטי - מכללת ספיר, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/SAC.Feminist.Cell'
      },
      {
        'title': 'כחלון, ג\'ולי (2013, 3 מרץ). מגדירים מציאות מדומה. <b>פנחס, 33</b>, עמ\' 8–9. נדלה מתוך',
        'url': 'https://issuu.com/pinhas.sapir/docs/pinhas_sapir_33_web'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '02/03/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה',
      'אקטיביזם רשת'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '27/11/2018'
    },
    'description': '״התא לשוויון מגדרי - פמיניזם בתל חי״ הוקם בשנת 2017. לגלגול הנוכחי של התא הפמיניסטי במכללת תל חי קדמו מספר ניסיונות התארגנות במכללה בשנים 2009-10 מטעם סטודנטיות מהמקבץ ללימודי מגדר שקיימו אסיפות, הפגנות וארועים בקמפוס. מאז קיומו של התא, הוא פועל בשלושה מישורים: מפגשי שיח ולמידה בנושאי מגדר; יזום ארועים לכלל המכללה שמטרתם להעלות מודעות בנושאים שונים; יצירת פלטפורמה לעשייה אקטיביסטית פמיניסטית ושינוי מדיניות. תחומי הפעילות העיקריים שבהם עוסק התא כוללים: הטמעת חשיבה מגדרית, מאבק באלימות מגדרית, מאבק באלימות מינית, פעילות הקשורה לדימוי גוף וסטריאוטיפים, מאבק בהדרת נשים ועוד.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תאים סטודנטיאליים'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ],
      [
        'פוליטיקה ומנהיגות',
        'תאים סטודנטיאליים'
      ]
    ],
    'id': 'YH152',
    'is_active': true,
    'keywords': [
      'הטרדה מינית',
      'אקטיביזם',
      'סטודנטיות'
    ],
    'name': 'התא לשוויון מגדרי - פמיניזם בתל חי',
    'name_ar': 'خلية المساواة الجندريّة- النسويّة كلية تل-حاي',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'קרית שמונה',
    'organization_kind': [
      'אקדמי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תאים סטודנטיאליים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'התא לשוויון מגדרי - פמיניזם בתל חי, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/getelhai/'
      },
      {
        'title': 'יודעת - מרכז ידע נשים ומגדר (אתר). <b>התא לשוויון מגדרי - פמיניזם במכללת תל חי</b>. נדלה מתוך',
        'url': 'https://yodaat.org/item/org/1019'
      },
      {
        'title': 'מועצת המכינות הקדם-צבאיות (2018, 26 ספטמבר). <b>מצפון תיפתח הטובה: האקטיביסטית כרמל קידר משנה את סדר היום במכללת תל חי</b>. נדלה מתוך',
        'url': 'https://mechinot.org.il/magazine/bogrim/carmel-983'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/06/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2017,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '08/11/2018'
    },
    'description': 'בתחילת 2007 הוגשו שתי תוכניות בין-משרדיות הנוגעות לאלימות נגד נשים: האחת לטיפול בנפגעות תקיפה מינית והשנייה להוצאת נשים ממעגל הזנות. את התכניות קידמה מרית דנון שהיתה מנהלת הרשות לקידום מעמד האישה והן אושרו על ידי ראש הממשלה דאז, אהוד אולמרט שהקצה להן תקציב ייעודי של 30 מיליון ₪ למשך שנתיים כסכום חד פעמי. בהמשך הוחלט לוותר על חלק מהסכום ובתמורה להכניס 20 מיליון ₪ לבסיס התקציב להמשך מימון השירותים שנבנו והורחבו במסגרת התכנית. התכנית הבין משרדית לטיפול בנפגעות תקיפה מינית החלה לפעול בשנת 2008 והיתה אמורה להביא להרחבה של 3 מרכזים רב-תחומיים קיימים והקמת 3 מרכזים חדשים, להקמה של 6 דירות מגורים, לחלופת אשפוז, להכשרות והשתלמויות לאנשי/נשות מקצוע ולתקצוב 25 עו״סיות לאיתור נערות וצעירות נפגעות תקיפה מינית. התכנית יושמה באופן חלקי על ידי משרד הבריאות ומשרד הרווחה ולאחר שנת 2013 צומצמו התקציבים שהועברו לתכנית.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'רווחה וקהילה',
        'אלימות מינית'
      ]
    ],
    'id': 'YH141',
    'is_active': false,
    'keywords': [
      'ועדה',
      'תקיפה מינית',
      'דיור',
      'טיפול נפשי',
      'בית חולים'
    ],
    'name': 'התכנית הבין-משרדית לטיפול בנפגעות תקיפה מינית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'איגוד מרכזי הסיוע לנפגעות ולנפגעי תקיפה מינית (2012). <b>אחריות חברתית: התמודדות עם פגיעה מינית בישראל 2012</b>. נדלה מתוך',
        'url': 'http://www.wavo.org/pics/140303144723report%20heb%20SMALL-spr.pdf'
      },
      {
        'title': 'ברנובסקי, יעל (2010, 24 נובמבר). אין הוסטלים: נפגעות תקיפה מינית נשארות בבית. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-3988681,00.html'
      },
      {
        'title': 'הוועדה לקידום מעמד האשה (2009, 27 יולי). <b>דיווח על התכניות לטיפול בנפגעות מינית ולהוצאת נשים ממעגל הזנות</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/activity/committees/women/news/pages/pr_498_27072009.aspx'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2008, 12 מאי). <b>פרוטוקול מס\' 127: דיווח על יישום התכניות לטיפול בנפגעות תקיפה מינית ולהוצאת נשים ממעגל הזנות</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/Activity/committees/Women/Pages/CommitteeProtocols.aspx?ItemID=290732'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/08/2018'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 2007,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '23/08/2018'
    },
    'description': 'בתחילת 2007 הוגשו שתי תוכניות בין-משרדיות הנוגעות לאלימות נגד נשים: האחת לטיפול בנפגעות תקיפה מינית והשנייה להוצאת נשים ממעגל הזנות. את התכניות קידמה מרית דנון שהיתה מנהלת הרשות לקידום מעמד האישה והן אושרו על ידי ראש הממשלה דאז, אהוד אולמרט שהקצה להן תקציב ייעודי של 30 מיליון ₪ למשך שנתיים כסכום חד פעמי. בהמשך הוחלט לוותר על חלק מהסכום ובתמורה להכניס 20 מיליון ₪ לבסיס התקציב להמשך מימון השירותים שנבנו והורחבו במסגרת התכנית. לצורך הכנת התכנית להוצאת נשים ממעגל הזנות הוקמה ועדה בין-משרדית בראשות מרית דנון. הוועדה גיבשה מתווה, הכינה תכניות עבודה ואישרה את תקציב הפעילות של התכנית. התוכנית החלה לפעול באופן חלקי בשנים 2008-2009 בשיתוף פעולה של משרדי ממשלה, רשויות מקומיות, ארגונים ועמותות. מטרות התוכנית כללו בין היתר צמצום ומניעה של הזנות ונזקיה בחברה הישראלית, שיקום נשים העוסקות בזנות וקידום החלמתן של נשים שורדות זנות. התכנית הובילה להקמתם של שלושה פרויקטים עירוניים: ״סלעית״ בתל-אביב, ״אופק נשי״ בחיפה ו״בשבילך״ בבאר-שבע ובאזור הדרום. בשנים שחלפו מאז הקמתה הועברה האחריות על השירותים למשרד הרווחה ובשנת 2018 פעלו כ-13 מסגרות טיפול (כולל הוסטלים, דירות חירום, ניידות ומרכזי יום וערב) שונות ב-5 תכניות: סלעית, אופק נשי, ניידות, ערים בלילה (על״ם) ובשבילך. מימון התכנית מגיע בעיקר מתקציב משרד הרווחה (76%), משרד הבריאות (16%) והשתתפות של רשויות מקומיות (4%).',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'זנות'
      ],
      [
        'רווחה וקהילה',
        'זנות וסחר בנשים'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'YH80',
    'is_active': true,
    'keywords': [
      'דיור',
      'תמיכה נפשית',
      'תעסוקה',
      'אלימות',
      'התמכרויות',
      'הוסטל'
    ],
    'name': 'התכנית הבין-משרדית לטיפול בצעירות ונשים במעגל הזנות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'זנות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הוועדה לקידום מעמד האישה (2009, 27 יולי). <b>הודעה לעיתונות: דיווח על התכניות לטיפול בנפגעות מינית ולהוצאת נשים ממעגל הזנות</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/activity/committees/women/news/pages/pr_498_27072009.aspx'
      },
      {
        'title': 'כרמלי, אברהם, כרמלי, יעל ואברמוביץ\', צורית (2016). <b>התכנית הבין משרדית לטיפול בנשים ובצעירות במעגל הזנות: מחקר הערכה</b>. משרד הרווחה והשירותים החברתיים. נדלה מתוך',
        'url': 'http://www.molsa.gov.il/CommunityInfo/ResearchAndEvaluation/tb_ResearchesAndPublications/%D7%9E%D7%97%D7%A7%D7%A8%20%D7%94%D7%A2%D7%A8%D7%9B%D7%94%20-%20%D7%9B%D7%A8%D7%9E%D7%9C%D7%99%20-%207-7-16.pdf'
      },
      {
        'title': 'לי, ורד (2008, 12 דצמבר). תוכנית ממשלתית חדשה פועלת להוצאת נשים ממעגל הזנות. <b>הארץ</b>. נדלה מתוך',
        'url': 'https://www.haaretz.co.il/news/education/1.1366772'
      },
      {
        'title': 'מזרחי, שלי (2013). <b>התוכנית הבין משרדית לטיפול בצעירות ונשים במעגל הזנות</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'http://fs.knesset.gov.il/globaldocs/MMM/eaef6d8d-f1f7-e411-80c8-00155d01107c/2_eaef6d8d-f1f7-e411-80c8-00155d01107c_11_10074.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '23/08/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2007,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '17/12/2018'
    },
    'description': 'התוכנית ללימודי האישה והיהדות במכון שכטר היא תוכנית רב־תחומית לתואר שני, המשלבת לימודים תיאורטיים ומעשיים בתחום של מגדר ויהדות ומזוהה עם הזרם הקונסרבטיבי ועם מורשתה של אליס שלוי. המסלול ללימודי האישה ביהדות במכון שכטר החל לפעול בשנת הלימודים 1995-1996 כתכנית הראשונה לתואר שני במגדר וכחלוצה בתחום המחקר על מגדר ויהדות. התכנית כוללת לימוד של טקסטים מסורתיים ומחקרים אקדמיים מתחומי דעת מגוונים ומתמקדת בתרומתן, חוויותיהן והווייתן של הנשים בחברה היהודית, בהיסטוריה היהודית ובהלכה. בין הפעילויות השונות הקשורות אל התכנית גם הוצאת כתב העת ״נשים- NASHIM״ (החל משנת 1997) והמרכז לחקר האשה בהלכה, ארגון כנסים בינלאומיים בנושא נשים ויהדות, פעילות ציבורית בנושאים הנוגעים לדיני אישות ועוד. מאז שנת 2018 מפעילה התכנית גם מסלול מעשי (פרקטיקום) שתכליתו לשלב פתרונות ויישום של הטמעה מגדרית בעבודה. את התכנית הקימה ד״ר דבי וייסמן והיא רוכזה במשך שנים על ידי פרופ\' רינה לוין מלמד. כיום עומדת בראש התכנית פרופ\' בת-שבע מרגלית שטרן.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תכניות לתואר אקדמי בלימודי מגדר'
      ],
      [
        'דת ומעמד אישי',
        'השכלה'
      ]
    ],
    'id': 'SA101',
    'is_active': true,
    'keywords': [
      'פמיניזם',
      'יהדות',
      'לימודי מגדר',
      'דיני משפחה',
      'הלכה'
    ],
    'name': 'התכנית ללימודי האשה והיהדות במכון שכטר',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'אקדמי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תכניות לתואר אקדמי בלימודי מגדר',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-12-17'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.schechter.ac.il/track/women-and-jewish-studies/'
      },
      {
        'title': 'התכנית ללימודי האשה והיהדות במכון שכטר (2018, 20 דצמבר). הפרטים אומתו בתכתובת דוא״ל עם פרופ\' בת-שבע מרגלית שטרן.'
      },
      {
        'title': 'ספרן, חנה (2009). בין אקדמיה לקהילה פמיניסטית: לימודי נשים בישראל. בתוך: אופלטקה, יזהר והרץ לזרוביץ, רחל (עורכים), <b>מגדר ואתניות בהשכלה הגבוהה בישראל</b> (עמ\' 169–188). חיפה: פרדס. נדלה מתוך',
        'url': 'https://gendersite.org.il/wp-content/uploads/2010/08/Safran.pdf'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '23/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1995,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '02/01/2019'
    },
    'description': 'בשנת 1989 נוסדה באוניברסיטת בן-גוריון בנגב חטיבה ללימודי מגדר במסגרת הלימודים הרב-תחומיים לתואר ראשון על ידי פרופ\' אילנה לוריא 1989. התכנית ללימודי מגדר לתארים מתקדמים (תואר שני ושלישי) נפתחה רשמית בשנת 2008 כתכנית בינתחומית מחקרית המשלבת בין מדעי הרוח והחברה. מיקומה של התכנית בדרום, מאפשר לפתח באופן מיוחד את העיסוק בנשים ופריפריה. התכנית מעודדת אקטיביזם ופעילות פמיניסטית באפיקים שונים ויש בה הדגש על תיאוריה קווירית, מיניות ופוליטיקה. בין ראשות התכנית היו פרופ\' הנרייט דהאן-כלב (מקימה), פרופ\' ניצה ינאי, פרופ\' קתרין רוטנברג וד״ר עמליה זיו.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תכניות לתואר אקדמי בלימודי מגדר'
      ]
    ],
    'id': 'SA110',
    'is_active': true,
    'keywords': [
      'לימודי מגדר',
      'מחקר פמיניסטי',
      'קוויר',
      'פריפריה'
    ],
    'name': 'התכנית ללימודי מגדר באוניברסיטת בן-גוריון בנגב',
    'name_ar': 'دراسات الجندر',
    'name_change_year': 2008,
    'name_common': null,
    'name_past': 'החטיבה ללימודי מגדר',
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'אקדמי',
      'ממשלתי'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תכניות לתואר אקדמי בלימודי מגדר',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-02-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://in.bgu.ac.il/humsos/gender/Pages/default.aspx'
      },
      {
        'title': 'ספרן, חנה (2009). בין אקדמיה לקהילה פמיניסטית: לימודי נשים בישראל. בתוך: אופלטקה, יזהר והרץ לזרוביץ, רחל (עורכים), <b>מגדר ואתניות בהשכלה הגבוהה בישראל</b> (עמ\' 169–188). חיפה: פרדס. נדלה מתוך',
        'url': 'https://gendersite.org.il/wp-content/uploads/2010/08/Safran.pdf'
      },
      {
        'title': 'Safir, Marylin, P. (2009). Women\'s Studies in Israel. In <b>Jewish women: A comprehensive historical encyclopedia</b>, Jewish women\'s archive. Retrieved from',
        'url': 'https://jwa.org/encyclopedia/article/womens-studies-in-israel'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1989,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '09/06/2018'
    },
    'description': 'התכנית ללימודי מגדר באוניברסיטת בר-אילן נפתחה בשנת 2000 בעקבות הביקוש הגובר ללימוד ומחקר אקדמיים בתחום, והייתה התכנית האוניברסיטאית הראשונה בישראל ללימודים מתקדמים במגדר לתואר שני ושלישי. התכנית היא חלק מהיחידה ללימודים רב תחומיים ומשלבת בין מדעי הרוח, החברה, היהדות, הטבע והמשפט. את היוזמה להקמת התכנית הובילה פרופ\' יזרעאלי מהחוג לסוציולוגיה ואנתרופולוגיה. פרופ\' יזרעאלי הקימה את הקתדרה לחקר המגדר אותה הקדישה לזכר הוריה ובמותה ציוותה על הקמת המרכז לחקר נשים ומגדר אשר נקרא על שמה. בתכנית פועל גם מסלול ״מגדר בשטח״ המציע תואר שני ללא מחקר לתיזה אשר משלב גם פעילות חברתית לקידום נשים. בין המרצות בתכנית: פרופ\' אורנה ששון-לוי, פרופ\' אורלי בנימין, ד״ר מירי רוזמרין, פרופ\' רבקה תובל-משיח, פרופ\' טובה כהן, ד״ר ענת הרבסט, ד״ר רונית עיר-שי, ד״ר גילי הרטל ואחרות.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תכניות לתואר אקדמי בלימודי מגדר'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ]
    ],
    'id': 'SA18',
    'is_active': true,
    'keywords': [
      'יהדות',
      'לימודי מגדר',
      'אקטיביזם',
      'מחקר פמיניסטי',
      'גבריות'
    ],
    'name': 'התכנית ללימודי מגדר באוניברסיטת בר-אילן',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת גן',
    'organization_kind': [
      'אקדמי',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תכניות לתואר אקדמי בלימודי מגדר',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-06'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://gender.biu.ac.il/about'
      },
      {
        'title': 'ספרן, חנה (2011). פמיניזמ(ים), נשים ומגדר במרחב האקדמי. <b>המשפט ט״ז</b> (1–2), 321–341. נדלה מתוך',
        'url': 'http://hamishpat-arch.colman.ac.il/files/05_2011/12-Safran.pdf'
      },
      {
        'title': 'ששון־לוי, אורנה ומשגב, חן (2017, 2 אפריל). חקר מגדר בישראל בתחילת המאה ה-21: בין נאו-ליברליזם לבין נאו-קולוניאליזם. <b>מגמות</b> נא(2): 165–206.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '08/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '17/12/2018'
    },
    'description': 'התכנית ללימודי נשים ומגדר בבית ברל הוקמה על ידי קבוצת מרצות וחוקרות פמיניסטיות מהמכללה בראשות ד״ר ויקי שירן, ריבה בכרך, אסתר הרצוג ואראלה שדמי, והיתה המחלקה השלישית שהוקמה בישראל ללימודי תואר ראשון בתחום. התכנית החלה לפעול בשנת הלימודים 2003/4 כתכנית אקדמית משולבת עם לימודים לקראת תואר ראשון במדעי הרוח והחברה של האוניברסיטה הפתוחה. בהתאם לרוח הפמיניזם המזרחי, התכנית היתה פתוחה ללא תנאי קבלה ״לכל אישה ואיש מגיל 18 ועד 120. ככזו, התכנית פותחת את שערי האקדמיה גם לנשים וגברים שהחיים לא זימנו להן ולהם את האפשרות ללמוד לימודים אקדמיים. [...] הלימודים נעשים באווירה תומכת ומאפשרת תוך מאמץ מודע ומכוון לסייע ללומדות וללומדים הן מבחינה כלכלית, הן מבחינה אקדמית והן מבחינה רוחנית ורגשית״. בין השנים 2004-2016 התקיימו במכללת בית ברל כנסים שנתיים לזכר ויקי שירן אשר משכו את הקהילה הפמיניסטית-אקדמית אל המכללה למטרות של מפגש ומחקר. ראשות התכנית היו ויקי שירן, אראלה שדמי, קציעה אלון, רוני הלפרן, שרון ששון-שטרית ויאלי השש. מחזור הרישום האחרון לתכנית נפתח בשנה״ל 2016-17. התכנית נסגרה בעקבות הפיכת המכללה למוסד עצמאי המוכר על ידי מל״ג.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תכניות לתואר אקדמי בלימודי מגדר'
      ]
    ],
    'id': 'SA100',
    'is_active': false,
    'keywords': [
      'לימודי מגדר',
      'פמיניזם מזרחי',
      'השלמת השכלה',
      'פריפריה',
      'חינוך'
    ],
    'name': 'התכנית ללימודי נשים ומגדר במכללת בית ברל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'בית ברל',
    'organization_kind': [
      'אקדמי',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תכניות לתואר אקדמי בלימודי מגדר',
    'primary_target_audience': 'נשים מזרחיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'התכנית ללימודי נשים ומגדר בבית ברל (2018, 12 דצמבר). הפרטים אומתו בתכתובת דוא״ל עם אראלה שדמי.'
      },
      {
        'title': 'התכנית ללימודי נשים ומגדר במכללת בית ברל (2018, 16 דצמבר). הפרטים אומתו בשיחה עם אחת החוקרות בתוכנית.'
      },
      {
        'title': 'שקד, רבקה (2005, 5 אפריל). <b>תכנית ללימודי מגדר במכללת בית ברל</b>. מכתב אל הממונות על מעמד האישה במשרדי הממשלה.'
      }
    ],
    'target_audiences': [
      'נשים מזרחיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/12/2018'
    },
    'year_closed': 2017,
    'year_closed_text': '2017',
    'year_founded': 2003,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '22/11/2018'
    },
    'description': 'בשנת 1986 נוסד באוניברסיטת תל אביב ״הפורום ללימודי נשים״ שהיה הבסיס להקמת התכנית ללימודי מגדר. הפורום קיים מפגשים ביום שישי אחת לחודש שבהם הוצגו מחקרים העוסקים בנשים. המפגשים התקיימו באוניברסיטת תל אביב אך לא כתוכנית לימודים עצמאית אלא כסדרת הרצאות. בין מובילות הפורום בראשית דרכו היו פרופ\' רינה שפירא, פרופ\' אריאלה פרידמן, פרופ\' חנה הרצוג, ובמיוחד ד״ר דלילה אמיר שהייתה הרוח החיה ומתאמת הפורום למעלה מעשור. בתחילת שנות ה-90 נוספה חטיבה ללימוד ההבדלים בין המינים בפקולטה למדעי החברה ובשנת 1999 הוקמה תכנית לתואר ראשון בשיתוף פעולה בין שלוש פקולטות (רוח, חברה, אמנויות) ואליהן הצטרפה כעבור שנה גם פקולטה רביעית (משפטים) זאת לאחר שהתקבל מענק מ״המועצה הלאומית של נשים יהודיות NCJW״. בשנת 2001 התמסדה התוכנית ללימודי נשים מגדר באופן סופי כתוכנית בינתחומית עצמאית בתוך הפקולטה למדעי הרוח בראשות פרופ\' חנה נווה ומשנת 2008 התכנית מעניקה גם תואר שני בלימודי מגדר. הפורום ללימודי נשים ממשיך לקיים הרצאות ציבוריות.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תכניות לתואר אקדמי בלימודי מגדר'
      ]
    ],
    'id': 'SA94',
    'is_active': true,
    'keywords': [
      'לימודי מגדר',
      'מחקר פמיניסטי',
      'חינוך מגדרי'
    ],
    'name': 'התכנית ללימודי נשים ומגדר בסיוע NCJW- אוניברסיטת תל אביב',
    'name_ar': null,
    'name_change_year': 2001,
    'name_common': null,
    'name_past': 'הפורום ללימודי נשים ומגדר',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'אקדמי',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תכניות לתואר אקדמי בלימודי מגדר',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-11-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://humanities.tau.ac.il/gender/about-gender'
      },
      {
        'title': 'התכנית ללימודי נשים ומגדר בסיוע NCJW- אוניברסיטת תל אביב (2018, 22 נובמבר). הפרטים אומתו בתכתובת דוא״ל עם פרופ\' דפנה הקר, ראשת התוכנית ללימודי מגדר.'
      },
      {
        'title': 'ספרן, חנה (2009). בין אקדמיה לקהילה פמיניסטית: לימודי נשים בישראל. בתוך: אופלטקה, יזהר והרץ לזרוביץ, רחל (עורכים), <b>מגדר ואתניות בהשכלה הגבוהה בישראל</b> (עמ\' 169–188). חיפה: פרדס. נדלה מתוך',
        'url': 'https://gendersite.org.il/wp-content/uploads/2010/08/Safran.pdf'
      },
      {
        'title': 'Safir, Marylin, P. (2009). Women\'s Studies in Israel. In <b>Jewish women: A comprehensive historical encyclopedia</b>, Jewish women\'s archive. Retrieved from',
        'url': 'https://jwa.org/encyclopedia/article/womens-studies-in-israel'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '22/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1986,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע',
      'מחאה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '28/10/2018'
    },
    'description': '״התנועה לשחרור האשה בתל אביב״ נוסדה באפריל 1972 לאחר ש\'התנועה לשחרור האשה\' קמה בירושלים ו״נלח״ם-נשים למען חברה מחודשת״ קמה בחיפה. בשנת 1975 היא נרשמה כאגודה עותומאנית בשם ״התנועה הפמיניסטית בישראל״ (תעודת הרישום הקיימת היא משנת 1982, לאחר כניסתו לתוקף של חוק העמותות החדש). מטרות העמותה (ע״ר 580008373) היו: ״הפצת תרבות פמיניסטית שעיקרה קידום הרעיון של השגת שוויון הזדמנויות מלא לאשה בישראל וביעור ההפליה בין המינים בכל מוסדות החברה״. בשנת 1975, יזמה הקבוצה (בהובלת שרה סייקס) את ההוצאה לאור של המקראה הפמיניסטית הראשונה ״אשה, נשים נשיות״ שכללה תרגומים של מאמרי יסוד מהתנועה הפמיניסטית האמריקאית. בשנת 1977 הקימה התנועה את קו הסיוע לנפגעות אונס בתל אביב שהפך למרכז הראשון מסוגו בישראל והחלה לפעול באופן ציבורי בארגון פעולות מחאה (״קחי את הלילה לידיך״, הפגנות נגד פורנוגרפיה ותחרויות מלכת היופי). חברות התנועה השתתפו בדיונים של ועדת נמיר (1976-1978), בכינוסים הבינלאומיים של ועידות האו״ם לענייני נשים (בניירובי ובבייג\'ין), קיימו הרצאות ופעולות הסברה ציבוריות, הקימו מרכז מידע וארכיון ועוד. מובילת ״התנועה הפמיניסטית״ היתה אסתר עילם. בשנותיה האחרונות נוהלה העמותה על ידי ענת גור, ממשרד ששכן ברחוב בן יהודה בתל אביב, לצד מרכז סיוע לנפגעות תקיפה מינית. באמצע שנות ה-90 החליפה התנועה את שמה ל״קשר הפמיניסטי״ (נרשמה כעמותה בשנת 1994) ועברה לפעול במתנ״ס בשכונת נווה אליעזר. אסתר עילם כותבת: ״בשנת 1997, נותרתי יחידה ועד היום הטלפון בביתי משמש כתובת לפניות אל התנועה הפמיניסטית״. העמותה נמחקה באופן סופי מפנקס העמותות בשנת 2019.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'תרבות וספורט',
        'כתבי עת והוצאה לאור'
      ]
    ],
    'id': 'SA74',
    'is_active': false,
    'keywords': [
      'פמיניזם',
      'אונס',
      'זנות',
      'פרסום פוגע',
      'פנאי'
    ],
    'name': 'התנועה הפמיניסטית בישראל',
    'name_ar': null,
    'name_change_year': 1975,
    'name_common': null,
    'name_past': 'התנועה לשחרור האשה בתל אביב',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'רשומות ילקוט הפרסומים 8190 (2019, 7 אפריל). <b>הודעה סופית בדבר מחיקה מפנקס העמותות</b>. התנועה הפמיניסטית בישראל (מספר עמותה 580008373). עמ\' 9579. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_word/Law10/yalkut-8190.pdf'
      },
      {
        'title': 'ספרן, חנה (2006). <b>לא רוצות להיות נחמדות: המאבק על זכות הבחירה לנשים וראשיתו של הפמיניזם החדש בישראל</b>. חיפה: פרדס. נדלה מתוך',
        'url': 'https://kotar.cet.ac.il/KotarApp/Viewer.aspx?nBookID=95436106'
      },
      {
        'title': 'עילם, אסתר (2012). פמיניסטית באקדמיה בשנות השבעים. <b>מגדר: כתב עת למגדר ופמיניזם</b>, 1, 117–132. נדלה מתוך',
        'url': 'http://blogdebate.org/gender/journal/wp-content/uploads/2012/12/%D7%90%D7%A1%D7%AA%D7%A8-%D7%A2%D7%99%D7%9C%D7%9D.pdf'
      },
      {
        'title': '<b>ביטאון התנועה הפמיניסטית בישראל</b>, אותר בארכיון מרכז הסיוע לנפגעות ונפגעי תקיפה מינית - תל אביב'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/12/2018'
    },
    'year_closed': 1993,
    'year_closed_text': '1993',
    'year_founded': 1972,
    'year_registered': 1975
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '02/09/2018'
    },
    'description': 'התנועה לגבריות חדשה היתה עמותה ישראלית שפעלה לקידום שוויון בין גברים ונשים בחברה. התנועה הוקמה בשלהי 1993 על ידי ד״ר חן נרדי, ונרשמה אצל רשם העמותות בשם ״תנועת גברים נגד אלימות״ (ע״ר 580247468) בשנת 1999. מטרות העמותה היו: ״לאגד גברים לפעול לצמצום ולמניעת תופעות של אלימות, השפלה ופגיעה בכבוד האדם במשפחה ובחברה״. לאחר שהונהגה מדיניות של שוויון לייצוג נשים בהנהגת התנועה, שונה השם ל״התנועה לגבריות חדשה״. בתנועה השתתפו נשים וגברים, בעלי מקצוע בתחומים שונים: עובדים סוציאליים, עורכי דין, אנשי מחשבים, פסיכולוגים ועוד. פעילות התנועה נקשרה עם ״מכון דיאלוג״ שנוהל על ידי רבקה וחן נרדי. בשנת 2004 יזמה התנועה לגבריות חדשה, בשיתוף תנועת ש.י.ן. (שוויון ייצוג נשים) ושדולת הנשים, את הקמת התנועה לשוויון ולשלום בין המינים (שוש״ן). כיום חלק מחברי התנועה לגבריות החדשה הינם גם חברי שוש״ן. התנועה נועדה במקור להתמודד עם אתגר מניעת אלימות גברית במשפחה ובחברה, ומאוחר יותר החלה לעסוק באופן רחב יותר בנורמות החברתיות הגבריות המתקשרות לתפקידי המגדר המקובלים בחברה. התנועה פעלה ל״פיתוח מערכות תמיכה וסיוע לגברים, תוך מתן דגש ליחסים המבוססים על שוויון וכבוד הדדי בין גברים לנשים״. מאז שנת 2005 פעילות התנועה דעכה ובנתוני רשם העמותות רשום שהעמותה נמחקה רשמית בשנת 2016.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'חינוך',
        'פמיניזם ושוויון בין המינים'
      ],
      [
        'תעשיית המין',
        'פורנוגרפיה'
      ]
    ],
    'id': 'SA53',
    'is_active': false,
    'keywords': [
      'גברים אלימים',
      'קו סיוע',
      'תמיכה נפשית',
      'סדנאות',
      'גבריות'
    ],
    'name': 'התנועה לגבריות חדשה',
    'name_ar': null,
    'name_change_year': 1999,
    'name_common': null,
    'name_past': 'גברים נגד אלימות',
    'name_replaced_by': null,
    'official_address': 'כפר סבא',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'גברים',
    'retrieved': {
      'type{date}': '2018-09-02'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.dialog-nardi.co.il/%D7%92%D7%91%D7%A8%D7%99%D7%95%D7%AA-%D7%97%D7%93%D7%A9%D7%94-%D7%94%D7%AA%D7%A0%D7%95%D7%A2%D7%94-%D7%9C%D7%92%D7%91%D7%A8%D7%99%D7%95%D7%AA-%D7%97%D7%93%D7%A9%D7%94/'
      },
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>התנועה לגבריות חדשה</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'נרדי, רבקה, ונרדי, חן (2003). יחסי נשים וגברים – מבט אל העתיד בחברה שוחרת שלום. בתוך: מרקס, עמנואל וניצן, יניב (עורכים), <b>אחרי השלום: המשימות הדחופות של החברה בישראל</b>. אוניברסיטת תל אביב, החוג לסוציולוגיה ואנתרופולוגיה.'
      }
    ],
    'target_audiences': [
      'גברים',
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '10/11/2018'
    },
    'year_closed': 2016,
    'year_closed_text': '2016',
    'year_founded': 1993,
    'year_registered': 1994
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '07/04/2018'
    },
    'description': 'התנועה לשוויון ושלום בין המינים הוקמה ב-2004 כשיתוף פעולה בין התנועה לגבריות חדשה, שדולת הנשים ותנועת ש.י.ן לשויון ייצוג נשים. התנועה נרשמה כעמותה (ע״ר 580460798) בשנת 2008. המטרות המוצהרות של התנועה היו: גינוי כל ביטוי או פעולה של אפליה, דיכוי, השפלה, פגיעה בכבוד או הגבלת החופש האישי של אישה ואיש בשל מינם/ן. טיפוח היחס המכבד כלפי גופם/ן של נשים וגברים ומיניותם/ן. \nעל מייסדי העמותה נמנו חן נרדי, יונת קלר, ציון בודאי, חוה תדהר, יוכבד יהל, עודד אביגדורי ורנה שחר.\nאת הוועד המנהל הובילו אביב יהלום ועידית שחם.\nהתנועה פעלה על בסיס התנדבותי ולא היו לה עובדים בשכר.\nהעמותה נמצאת בהליכי פירוק וככל הנראה פעלה עד 2014.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ]
    ],
    'id': 'YH44',
    'is_active': false,
    'keywords': [
      'שוויון מגדרי',
      'גבריות',
      'שוויון הזדמנויות',
      'חינוך מגדרי'
    ],
    'name': 'התנועה לשוויון ושלום בין המינים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'שוויון בין המינים/שוויון מגדרי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>התנועה לשוויון ושלום בין המינים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580460798'
      },
      {
        'title': 'התנועה לשוויון ושלום בין המינים (2006, 22 דצמבר). <b>הזמנה ליום עיון בנושא: נשים וגברים בעולם העבודה</b>. נדלה מתוך',
        'url': 'http://img2.tapuz.co.il/forums/1_90968916.pdf'
      },
      {
        'title': 'מכון דיאלוג (אתר). <b>ד״ר חן נרדי</b> (מיוזמי התנועה לשוויון ושלום בין המינים). נדלה מתוך',
        'url': 'https://www.dialog-nardi.co.il/%d7%93%d7%a8-%d7%97%d7%9f-%d7%a0%d7%a8%d7%93%d7%99/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '26/11/2019'
    },
    'year_closed': 2014,
    'year_closed_text': '2014',
    'year_founded': 2004,
    'year_registered': 2008
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '28/05/2018'
    },
    'description': 'תנועת ״ובזכותן – חרדיות עושות שינוי״ נוסדה בשלהי שנת 2014 כמפלגה חרדית נשית שתרוץ בבחירות ‏לכנסת ה-20 בשנת 2015, בהובלת רות קוליאן. מטרת המפלגה לתת קול וייצוג לנשים חרדיות שהודרו ‏מהמפלגות החרדיות ולקדם את הצרכים והאינטרסים שלהן במדיניות ובחקיקה. המפלגה זכתה ב-1,802 ‏קולות שהן 0.04% מהקולות; ולא עברה את אחוז החסימה. התנועה ממשיכה לפעול לעיתים מאז ויש לה ‏נראות בדף הפייסבוק.‏',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ],
      [
        'דת ומעמד אישי',
        'פוליטיקה ומנהיגות'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'SW8',
    'is_active': true,
    'keywords': [
      'ייצוג',
      'קידום נשים',
      'אפליה מגדרית',
      'מנהיגות',
      'הלכה'
    ],
    'name': 'ובזכותן חרדיות עושות שינוי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'מפלגות, שדולות ותאים מפלגתיים',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2018-05-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://913669.wixsite.com/uvizchutaz-site'
      },
      {
        'title': 'משרד המשפטים, רשות התאגידים: רשם המפלגות (ללא תאריך). <b>מפלגות שהגישו רשימות מועמדים בבחירות לכנסת ה-20</b>. נדלה מתוך',
        'url': 'https://www.gov.il/BlobFolder/reports/20_parties_candidates_lists/he/parties_candidates_lists.pdf'
      },
      {
        'title': 'משרד המשפטים, רשות התאגידים: רשם המפלגות (2015). <b> הודעת מפלגה לפי סעיף 25א(א) ו-(ב) לחוק המפלגות לשנת 2015 - אחריות - לב אחד ורוח חדשה</b>. נדלה מתוך',
        'url': 'http://www.justice.gov.il/Units/RasutHataagidim/documents/%D7%90%D7%97%D7%A8%D7%99%D7%95%D7%AA%202015.pdf'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '14/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '03/07/2018'
    },
    'description': 'ויצו היא תנועה ציונית בינלאומית א-מפלגתית ועצמאית כלכלית של נשים מתנדבות אשר נוסדה בשנת 1920 בבריטניה. מייסדות ויצו רבקה זיו, ורה וייצמן, אדית אדר, רומנה גודמן והנרייטה אירוול ייסדו את הארגון מתוך מטרה לספק את צורכיהן של נשים וילדים בארץ ישראל (פלשתינה). ב-1933, התאחדה השלוחה המקומית של ויצו עם ״הסתדרות הנשים העבריות״. בראשית דרכה פעלה התנועה לייסוד שירותי רווחה וחברה ומוסדות להכשרה חקלאית ולהקניית מקצועות לנערות. מאוחר יותר המשיכה בפיתוח שירותי מעונות יום ושירותים למשפחות, קליטת עלייה, הקמת בתי ספר וכפרי נוער, הכשרה מקצועית ותעסוקת נשים וכן בפעילות ציבורית. לאחר הקמת מדינת ישראל המשיכה ויצו את פעילויותיה והרחיבה אותן למשימות שונות ״שנועדו לספק את הצרכים החברתיים שנוצרו בעקבות העלייה המסיבית. מחויבותה של ויצו למדינה ונכונותה להשתלב במאמץ הלאומי, באה לידי ביטוי בהחלטה להעביר את המטה של ויצו העולמית מלונדון לתל אביב״. מאז שנות ה-70 פועל ארגון ויצו גם לצמצום פערים חברתיים, הרחבת שירותי רווחה לאוכלוסיות חלשות, פיתוח שירותי הגנה לנשים נפגעות אלימות, פיתוח שירותים לנערות במצוקה, הקמת לשכות משפטיות, פיתוח פעילות תרבותית וקידום מעמד האשה. בסוף שנות ה-80 היו בוויצו ישראל כ- 100,000 חברות שהתנדבו בתחומים רבים: שירותי רווחה וסיוע לפעוטות, לנוער ולקשישים. הארגון תמיד הדגיש באופן מיוחד את הפעילות לקידום מעמדה של האשה ומראשית שנות ה-60, באמצעות המועצה לקידום מעמד האשה של ויצו, פיתח הארגון מערך שירותים לנשים הכוללים ייעוץ, סיוע משפטי, הדרכה וקידום מקצועי, קייטנות לאמהות, סיוע לאלמנות, הפעלת מקלטים לנשים נפגעות אלימות, קווי חירום ועוד. מטרות הארגון כיום הן ״לקדם את מעמד האישה בישראל באמצעות חקיקה, פיתוח מנהיגות ומודעות אישית וחברתית למען שוויון נשים בחברה. להעניק לפעוטות, ילדים, בני נוער וקשישים שוויון הזדמנויות למען צימצום פערים בחברה הישראלית. להתאים את הצרכים המשותפים בין נשים יהודיות בתפוצות ובין נשים בישראל למען המשכיות העם היהודי וקליטת עליה״.',
    'description_ar': null,
    'display_organization_kind': 'בינלאומי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'אלימות',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YB118',
    'is_active': true,
    'keywords': [
      'גברים אלימים',
      'מקלט',
      'הכשרה מקצועית',
      'חד הוריות',
      'חינוך',
      'חקיקה',
      'מרכזים למניעה וטיפול באלימות במשפחה',
      'נערות במצוקה',
      'סיוע משפטי',
      'פוליטיקה',
      'פרסום פוגע',
      'קו סיוע'
    ],
    'name': 'ויצו - הסתדרות עולמית לנשים ציוניות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'בינלאומי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'בינלאומי',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-03-07'
    },
    'sources': [
      {
        'title': 'www.wizo.org.il'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>ויצו – הסתדרות עולמית לנשים ציוניות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580057321'
      },
      {
        'title': 'אברמוביץ, דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל.'
      },
      {
        'title': 'גרינברג, עפרה והרצוג, חנה (1978). <b>ארגון נשים וולנטרי בחברה מתהווה: תרומתה של ויצ״ו לחברה הישראלית</b>. תל אביב: המכון למחקר חברתי ליד החוג לסוציולוגיה ואנתרופולוגיה, אוניברסיטת תל אביב.'
      },
      {
        'title': 'הרצוג, חנה (1994). <b>נשים ריאליות: נשים בפוליטיקה המקומית בישראל</b>. מחקרי מכון ירושלים לחקר ישראל (מס\' 51). ירושלים: מכון ירושלים לחקר ישראל.'
      },
      {
        'title': 'קטן, יוסף וזיכלינבסקי, אסתר (2006). <b>תרומת ויצו לחברה הישראלית – בין המשכיות לשינוי</b>, תל אביב: בית הספר לעבודה סוציאלית ע״ש בוב שאפל, המרכז הבינתחומי לחקר מדיניות וטיפול בילדים ונוער'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים עולות מחבר העמים',
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '07/10/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': 1999
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'שירותים משפטיים'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '15/09/2019'
    },
    'description': 'ועד הפעולה לשוויון בענייני אישות הוא קואליציה שהוקמה בשנת 1995 על ידי ארגונים ויחידים העוסקים בקידום זכויות נשים בפרט וזכויות אדם בכלל. הארגונים החברים בוועד הם: עמותת נשים נגד אלימות, האגודה לזכויות האזרח בישראל, מרכז אל-טופולה – נצרת, שדולת הנשים וכיאן – ארגון פמיניסטי, בנוסף לעורכי/ות דין ועובדים/ות סוציאליים/ות. הקואליציה פעלה לקידום השוויון בין המינים בדיני משפחה וכן לקידום זכויותיהם של המתדיינים בפני בתי דין דתיים ובתי משפט לענייני משפחה במגזר הערבי, תוך שימוש בכלים משפטיים וחברתיים כאחד. בנוסף, הקולאציה עסקה בנישואי קטינות וקידום החקיקה להעלאת גיל הנישואים.',
    'description_ar': 'لجنة العمل للمساواة في قضايا الأحوال الشخصية. هي ائتلاف تأسس عام 1995، من قبل المنظمات التي تعمل لتعزيز حقوق النساء بشكل خاص وحقوق الانسان بشكل عام. أعضاء اللجنة هم: جمعية نساء ضد العنف، الاتحاد لحقوق الفرد في إسرائيل، مركز الطفولة- الناصرة، لوبي النساء وكيان-تنظيم نسوي، بالإضافة لمحامين\\ات عاملين\\ات اجتماعيين\\ات. عمل الائتلاف تعزيز المساواة بين الجنسين في قانون الأسرة وتعزيز حقوق الخصوم أمام المحاكم الشرعية وقانون الأسرة في المجتمع العربي، باستخدام الأدوات القانونية والاجتماعية. تعاملت المجموعة مع الزواج دون السن القانونية وتشجيع التشريعات لرفع سن الزواج.',
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ],
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ],
      [
        'נערות וצעירות',
        'זכויות'
      ]
    ],
    'id': 'SA152',
    'is_active': true,
    'keywords': [
      'בדואיות',
      'בית דין שרעי',
      'פוליגמיה',
      'גירושין',
      'חקיקה',
      'אסלאם',
      'קואליצייה'
    ],
    'name': 'ועד הפעולה לשוויון בדיני אישות',
    'name_ar': 'لجنة العمل للمساواة في قضايا الأحوال الشخصية',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'אבו-בקר, ח\'אולה (2015). התנועה הנשית-פמיניסטית הפלסטינית בתוך ישראל. בתוך: סבאע\'-ח\'ורי, אריז\' ורוחנא, נדים (עורכים). <b>הפלסטינים בישראל: עיונים בהיסטוריה, בפוליטיקה ובחברה</b>. כרך שני (עמ\' 205–222). חיפה: מדה אל-כרמל. נדלה מתוך',
        'url': 'http://mada-research.org/wp-content/uploads/2016/01/hebrew_2-4.pdf'
      },
      {
        'title': 'בולוס, סוניה (2006, 1 דצמבר). <b>השאת קטינות: בין חוק לחברה</b>. ועד הפעולה לשוויון בדיני אישות, האגודה לזכויות האזרח. נדלה מתוך',
        'url': 'https://law.acri.org.il/he/1586'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2004, 8 דצמבר). <b>פרוטוקול מס\' 142: נישואי קטינות – העלאת גיל הנישואים</b>. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_html/law103/maamad2004-12-08.htm'
      },
      {
        'title': 'جنان عبده. (2008). الجمعيّات النسائيّة والنسويّة الفلسطينيّة- في مناطق 48, مدى الكرمل'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '15/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1995,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '12/11/2019'
    },
    'description': 'ב-1976 הוקמה ״ועדה ארצית לשילוב נשים ברשויות המקומיות״. בוועדה היו חברות נציגות של ארגוני נשים א-מפלגתיים- ויצו, ארגון נשים אקדמאיות והאיגוד הארצי של מועדוני הסורופטימיסטיות בישראל. בראש הוועדה עמדה חברת ויצו, טניה לוונפיש. הוועדה היתה בין יוזמי החקיקה להפרדה בין מועדי הבחירות לכנסת ולרשויות המקומיות אשר הובילה לשינוי שיטת הבחירות בשנת 1978. מטרת החוק, שהצטרף לחוק הבחירות הישירות לראשי הערים, היתה לנתק בין המדיניות המקומית לפוליטיקה המפלגתית הארצית. התפיסה שעמדה בבסיס עבודת הוועדה היתה ש״האשה מעורבת ומעורה בבעיות המתעוררות ברשות המקומית כי לה מגע תמידי עם בעיות בתחומי חינוך, בריאות, תברואה, שירותים ותחבורה, ולכן דאגתה לשיכלול ושיפור תהיה משמעותית כאשר תיבחר״ (מצוטט אצל גרינברג והרצוג 111-110:1978).',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'ייצוג הולם'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'SA168',
    'is_active': false,
    'keywords': [
      'בחירות',
      'חקיקה',
      'רשות מקומית'
    ],
    'name': 'ועדה ארצית לשילוב נשים ברשויות המקומיות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'ייצוג הולם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'גרינברג, עפרה והרצוג, חנה (1978). <b>ארגון נשים וולנטרי בחברה מתהווה: תרומתה של ויצ״ו לחברה הישראלית</b>. תל אביב: המכון למחקר חברתי ליד החוג לסוציולוגיה ואנתרופולוגיה, אוניברסיטת תל אביב.'
      },
      {
        'title': 'הרצוג, חנה (1994). <b>נשים ריאליות: נשים בפוליטיקה המקומית בישראל</b>. מחקרי מכון ירושלים לחקר ישראל (מס\' 51). ירושלים: מכון ירושלים לחקר ישראל.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '12/11/2019'
    },
    'year_closed': 1977,
    'year_closed_text': '1977',
    'year_founded': 1976,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '02/12/2019'
    },
    'description': '״הועדה המיוחדת למעמד האשה״ הוקמה בכנסת בשלהי הכנסת ה-12, בנובמבר 1991 מיד עם האשרור הרשמי של ״האמנה בדבר ביטול האפליה נגד נשים לצורותיה״ (CEDAW) בכנסת. כחצי שנה לאחר מכן היא הוחלפה בועדה לקידום מעמד האשה שנוסדה לאחר הבחירות לכנסת ה-13 (1992). בראשות הועדה המיוחדת עמדה ח״כ שרה דורון מהליכוד והיו חברות בה שולמית אלוני, גאולה כהן, תמר גוז\'נסקי ואחרות. בתקופת פעילותה הקצרה רשמה הועדה כמה הישגים וביניהם הסכמת הרבנות הראשית לפרסום תקנות בנושא מעמד האישה בבתי דין רבניים; ותמיכה בחקיקה שאפשרה הכרה בנשים נשואות להיות נישום עצמאי במס הכנסה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'SA126',
    'is_active': false,
    'keywords': [
      'האמנה לביעור כל צורות ההפליה נגד נשים 1979 CEDAW',
      'חקיקה',
      'כנסת',
      'קידום נשים',
      'שוויון'
    ],
    'name': 'ועדה מיוחדת למעמד האשה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הכנסת, חברי הכנסת לדורותיהם: שרה דורון. נדלה מתוך אתר הכנסת',
        'url': 'https://main.knesset.gov.il/mk/Pages/MKPositions.aspx?MKID=359'
      },
      {
        'title': 'בן-אריה, שביט (2012, 18 יולי). הוועדה לקידום מעמד האישה: עבר, הווה ועתיד. מאמר דעה, <b>המכון הישראלי לדמוקרטיה</b>. נדלה מתוך',
        'url': 'https://www.idi.org.il/articles/9570'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '02/12/2019'
    },
    'year_closed': 1992,
    'year_closed_text': '1992',
    'year_founded': 1991,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '23/08/2018'
    },
    'description': 'בפברואר 2011 מינתה ות״ת (הועדה לתכנון ותקצוב) צוות לבחינת מצבן של נשים בסגל האקדמי במוסדות להשכלה גבוהה בראשות פרופ\' רבקה כרמי. חברות הצוות היו: פרופ\' דפנה ברק-ארז, פרופ\' פייסל עזאיזה, פרופ\' מלכה רפפורט-חובב ופרופ\' עליזה שנהר. עם הקמתו, פנה הצוות למוסדות להשכלה גבוהה בבקשה לקבל נתונים לגבי מצבן של נשים בסגל האקדמי ובחן אותם בהשוואה למצב במדינות אחרות. בדו״ח שהוגש למל״ג בחודש מאי 2011 קבע צוות כרמי כי למרות ההשגים של נשים הלומדות וחוקרות במוסדות להשכלה גבוהה בישראל, הן עדיין מתמודדות עם חסמים וקשיים יחודיים וכי קידום שוויון מגדרי במוסדות להשכלה גבוהה הינו ״יעד ראשון במעלה- הן מטעמים של צדק והוגנות והן מטעמים שעניינם קידום המצוינות האקדמית עצמה״. הצוות המליץ למסד את תפקיד יועצות הנשיא לקידום מעמד האשה באוניברסיטאות; לסייע לדוקטורנטיות/ים היוצאים לחופשת לידה; לעשות מאמצים לאתר נשים מועמדות לאיוש משרות; לשמר ולקדם חוקרות צעירות; לאמץ עקרון של ייצוג הולם בוועדות במוסדות להשכלה גבוהה ועוד. בעקבות המלצות הועדה, הוקמה בשנת 2013 ה״וועדה לקידום וייצוג נשים במוסדות להשכלה גבוהה״ בראשות פרופ\' רות ארנון, נשיאת האקדמיה הלאומית למדעים דאז, כוועדת היגוי קבועה של המועצה להשכלה גבוהה (מל״ג), הוועדה לתכנון ולתקצוב (ות״ת) ומשרד המדע. ביולי 2015 פרסמה הוועדה דו״ח המלצות ונספח תמונת מצב לגבי קידום וייצוג נשים במוסדות להשכלה גבוהה. בדו״ח הושם דגש על שלושה נושאים מרכזיים: \nהכוונת נשים למחקר אקדמי, לרבות הגדלת מספר מלגות הצטיינות, ושיפור תהליכי חניכה במהלך הדוקטורט.\nגיוס נשים לסגל האקדמי הבכיר, לרבות גיוס פרואקטיבי והכשרה מגדרית של ראשי ועדות הגיוס וראשי מחלקות. קידום נשים בסגל האקדמי הבכיר על ידי תמרוץ המוסדות לטיפול בנושא, ימי עיון וסדנאות, בקרב בעלי תפקידים במוסדות ועוד.\nעל בסיס המלצות ועדת כרמי וועדת ארנון החליטה ות”ת ביולי 2015 להשתתף בשלב ההתנעה, בתקצוב פעילות היועצות במוסדות המתוקצבים וכן להקצות תקציב תחרותי לתמיכה בפעילות רוחבית משותפת לקידום נשים.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף אקדמי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'קידום נשים במדע'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ],
      [
        'חינוך',
        'מדע וטכנולוגיה'
      ]
    ],
    'id': 'YH79',
    'is_active': false,
    'keywords': [
      'מחקר',
      'תעסוקה',
      'קידום נשים',
      'מדע',
      'ועדה'
    ],
    'name': 'הוועדה לקידום וייצוג נשים במוסדות להשכלה גבוהה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'ועדת ארנון',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי',
      'אקדמי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים במדע',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'המועצה להשכלה גבוהה (2013, 10 ספטמבר). <b>החלטות משיבת המועצה להשכלה גבוהה השתים – עשרה</b>. נדלה מתוך',
        'url': 'http://che.org.il/wp-content/uploads/2013/10/%D7%94%D7%97%D7%9C%D7%98%D7%95%D7%AA-%D7%94%D7%9E%D7%95%D7%A2%D7%A6%D7%94-%D7%9E%D7%99%D7%A9%D7%99%D7%91%D7%AA-%D7%94%D7%9E%D7%95%D7%A2%D7%A6%D7%94-%D7%9E%D7%99%D7%95%D7%9D-10-9-2013.pdf'
      },
      {
        'title': 'המועצה להשכלה גבוהה (2011, 18, מאי). <b>דוח והמלצות הצוות לבחינת מצבן של נשים בסגל האקדמי במוסדות להשכלה גבוהה</b>. נדלה מתוך',
        'url': 'https://che.org.il/wp-content/uploads/2013/08/%d7%a6%d7%95%d7%95%d7%aa-%d7%a7%d7%99%d7%93%d7%95%d7%9d-%d7%a0%d7%a9%d7%99%d7%9d-%d7%93%d7%95%d7%97-%d7%9e%d7%a1%d7%9b%d7%9d-.pdf'
      },
      {
        'title': 'המועצה להשכלה גבוהה (אתר). <b>קול קורא – קידום וייצוג נשים במוסדות להשכלה גבוהה – תשע”ז</b>. נדלה מתוך',
        'url': 'https://che.org.il/%D7%A7%D7%95%D7%9C-%D7%A7%D7%95%D7%A8%D7%90-%D7%A7%D7%99%D7%93%D7%95%D7%9D-%D7%95%D7%99%D7%99%D7%A6%D7%95%D7%92-%D7%A0%D7%A9%D7%99%D7%9D-%D7%91%D7%9E%D7%95%D7%A1%D7%93%D7%95%D7%AA-%D7%9C%D7%94%D7%A9/'
      },
      {
        'title': 'משרד המדע, הטכנולוגיה והחלל, המועצה לקידום נשים במדע ובטכנולוגיה והמועצה להשכלה גבוהה (2015, יולי). <b>דוח הוועדה לקידום וייצוג נשים במוסדות להשכלה גבוהה</b> (ועדת ארנון). ירושלים. נדלה מתוך',
        'url': 'https://che.org.il/wp-content/uploads/2015/07/%d7%93%d7%95%d7%97-%d7%99%d7%99%d7%a6%d7%95%d7%92-%d7%a0%d7%a9%d7%99%d7%9d.pdf'
      },
      {
        'title': 'סלומון, עידית (2019, מרץ). <b>שיפור מפת הייצוג המגדרי באקדמיה בעזרת היועצות לקידום נשים</b>. מוסד שמואל נאמן למחקר מדיניות לאומי, הטכניון: חיפה. נדלה מתוך',
        'url': 'https://www.neaman.org.il/Files/%D7%A9%D7%99%D7%A4%D7%95%D7%A8%20%D7%9E%D7%A4%D7%AA%20%D7%94%D7%99%D7%99%D7%A6%D7%95%D7%92%20%D7%94%D7%9E%D7%92%D7%93%D7%A8%D7%99%20%D7%91%D7%90%D7%A7%D7%93%D7%9E%D7%99%D7%94%20%D7%91%D7%A2%D7%96%D7%A8%D7%AA%20%D7%94%D7%99%D7%95%D7%A2%D7%A6%D7%95%D7%AA%20%D7%9E%D7%95%D7%A0%D7%92%D7%A9_20191113111551.739.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '05/03/2020'
    },
    'year_closed': 2015,
    'year_closed_text': '2015',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '23/10/2018'
    },
    'description': 'הוועדה להגברת שילובן וקידומן של נשים בשירות הממשלתי, בראשותה של פרופ\' רות בן-ישראל, מונתה בשנת 1993 במשרד הכלכלה והתכנון בעקבות המלצות ועדת קוברסקי. בוועדה השתתפו נציגות של ארגוני נשים ועובדות מדינה בתפקידים בכירים. הועדה ניסחה המלצות אופרטיביות למיסוד מעמדה ותפקידיה של הממונה על מעמד האישה והמליצה להקים אגף מטה לנושא מעמד האישה בנציבות שירות המדינה. בעקבות המלצות הוועדה, הוקם ב-1995 אגף בנציבות שירות המדינה, שמטרתו לרכז את כל הפעולות הנוגעות לקידום ושילוב נשים בשירות המדינה (כיום - האגף לשוויון מגדרי).',
    'description_ar': 'مكانة المرأة الدرزية وتعزيز اندماجها في المجتمع. تشجيع ومساعدة العائلات الثكلى، الارامل والنساء الاتي يتعرضن للضرب. نشاط الجمعية يشمل تنظيم مؤتمرات، أيام دراسية، محاضرات وجولات في إسرائيل للنساء الدرزيات بهدف تعميق التراث الدرزي والدين. غالبا تهدف معظم جولات الجمعية إلى زيارة الأماكن المقدسة للطائفة الدرزية.',
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'YH113',
    'is_active': false,
    'keywords': [
      'ועדה',
      'חקיקה',
      'ממונה על מעמד האשה',
      'שירות ציבורי',
      'קידום נשים',
      'שוויון הזדמנויות',
      'פערי שכר'
    ],
    'name': 'הוועדה להגברת שילובן וקידומן של נשים בשירות הממשלתי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'ועדת בן ישראל',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'זכויות ומדיניות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'אתר השירותים והמידע הממשלתי, נציבות שירות המדינה (ללא תאריך). <b>אגף לשוויון מגדרי</b>. נדלה מתוך',
        'url': 'https://www.gov.il/he/departments/units/woman_unit'
      },
      {
        'title': 'יזרעאלי, דפנה (2004). החוק לייצוג הולם של נשים בדירקטוריונים. בתוך: מאור, ענת (עורכת). <b>העדפה מתקנת והבטחת ייצוג בישראל</b> (עמ\' 235–260). תל אביב: רמות. נדלה מתוך',
        'url': 'http://www.kotar.co.il/KotarApp/Viewer.aspx?nBookID=92677230#4.8381.6.default'
      },
      {
        'title': 'משרד המשפטים, ספריית משרד המשפטים (2017, 3 אוקטובר). <b>דוחות ועדות שמינו גורמים ממשלתיים</b>. נדלה מתוך',
        'url': 'https://www.justice.gov.il/Units/Sifria/Dochot/Pages/Rashim.aspx'
      },
      {
        'title': 'שטינברג, פנינה (2012). <b>מקידום נשים להטמעת חשיבה מגדרית: תמורות בתפקיד הממונה על קידום מעמד האישה במשרדי הממשלה – מחקר מדיניות</b>. שוות: המרכז לקידום נשים בזירה הציבורית. ירושלים: ון ליר. נדלה מתוך',
        'url': 'https://www.vanleer.org.il/sites/files/product-pdf/%D7%AA%D7%A4%D7%A7%D7%99%D7%93%20%D7%94%D7%9E%D7%9E%D7%95%D7%A0%D7%95%D7%AA%20%D7%A2%D7%9C%20%D7%A7%D7%99%D7%93%D7%95%D7%9D%20%D7%9E%D7%A2%D7%9E%D7%93%20%D7%94%D7%90%D7%A9%D7%94%20-%20%D7%9E%D7%97%D7%A7%D7%A8%20%D7%9E%D7%93%D7%99%D7%A0%D7%99%D7%95%D7%AA.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '23/10/2018'
    },
    'year_closed': 1995,
    'year_closed_text': '1995',
    'year_founded': 1993,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '14/06/2018'
    },
    'description': 'ועדת ההיגוי למעקב ובקרה אחר חובת הניתוח המגדרי של תקציב המדינה הוקמה מכוח החלטת ממשלה 2084 מאוקטובר 2014 שעניינה ״אימוץ המלצות הוועדה לבחינה מגדרית של תקציב המדינה בישראל״. ״הוועדה לבחינה מגדרית של תקציב המדינה״ מונתה באוקטובר 2013 על ידי שר האוצר דאז יאיר לפיד, במטרה ״לבחון את ההיבטים השונים הקשורים בניתוח מגדרי של תקציב המדינה ולגבש המלצות לתכנון של קווים מנחים לניתוח מגדרי של תקציבים ותחומי מדיניות שונים״. הוועדה הוקמה בעקבות ישיבה שהתקיימה בוועדה למעמד האישה בכנסת, בראשותה של ח״כ ד״ר עליזה לביא ובה הוצגו ההשלכות המגדריות של חוק ההסדרים והצעת תקציב המדינה לשנים 2013-2014. אלו הוצגו על ידי נציגות מרכז אדוה, הגוף העיקרי שהוביל עד אז את נושא התקצוב המגדרי בישראל. בראשות הוועדה עמדה סגנית הממונה על התקציבים באוצר, הגברת יעל מבורך והיא כללה נציגים בכירים ממשרדי הממשלה, המוסד לביטוח לאומי, בנק ישראל, הלשכה המרכזית לסטטיסטיקה, נציבות שוויון הזדמנויות בעבודה והאקדמיה. הוועדה הגישה את המלצותיה ביולי 2014 ועיקרן המלצה להחלת ניתוח מגדרי של תקציב המדינה כולו. במסגרת ההחלטה נקבע כי ״לצורך ביצוע מעקב ובקרה אחר חובת הניתוח המגדרי, תוקם ועדת היגוי בראשות סגן הממונה על התקציבים במשרד האוצר ויהיו חברים בה מנהלת הרשות לקידום מעמד האישה, המנהל הכללי של משרד ממשלתי וכן נציג ציבור״. לאחר בחירות 2015 ועם הקמתו של המשרד לשוויון חברתי שונה הרכב הוועדה כך שמנכ״ל המשרד לשוויון חברתי יעמוד בראשה. עוד חברים: מנכ״ל של משרד ממשלתי, - סגן הממונה על התקציבים במשרד האוצר, נציגת הרשות לקידום מעמד האישה ונציג/ת ציבור. הוועדה נפגשה פעמים בודדות ובמרווחי זמן גדולים. המפגשים עסקו בהתקדמות הליך הניתוח כמו גם בחסמים ומכשולים. בינואר 2018 עברה החלטת ממשלה אשר מתקנת פעם נוספת את הרכב הוועדה ומעמידה בראשה את מנהלת הרשות לקידום מעמד האישה (החלטה 3451).',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ],
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ]
    ],
    'id': 'YH22',
    'is_active': true,
    'keywords': [
      'תקציב',
      'תקצוב מגדרי',
      'הטמעת חשיבה מגדרית',
      'נתונים',
      'סטטיסטיקה מגדרית',
      'ועדה',
      'ניתוח מגדרי'
    ],
    'name': 'ועדת ההיגוי למעקב ובקרה אחר חובת הניתוח המגדרי של תקציב המדינה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'ועדות פרלמנטריות וממשלתיות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד ראש הממשלה (2014, 7 אוקטובר). החלטת ממשלה מס\' 2084. אימוץ המלצות הוועדה לבחינה מגדרית של תקציב המדינה בישראל. נדלה מתוך',
        'url': 'https://www.gov.il/he/Departments/policies/2014_des2084'
      },
      {
        'title': 'אתר השירותים והמידע הממשלתי, משרד האוצר (ללא תאריך), <b>הוועדה לבחינה מגדרית של תקציב המדינה בישראל</b>. נדלה מתוך אתר משרד האוצר',
        'url': 'https://www.gov.il/he/departments/PublicBodies/gender_examination_committee'
      },
      {
        'title': 'אתר השירותים והמידע הממשלתי, משרד האוצר (ללא תאריך), <b>הוועדה לבחינה מגדרית של תקציב המדינה בישראל</b>. נדלה מתוך אתר משרד האוצר',
        'url': 'https://www.gov.il/he/departments/PublicBodies/gender_examination_committee'
      },
      {
        'title': 'פרוטוקולים של ישיבות הוועדה, ארכיון פרטי של יעל חסון'
      },
      {
        'title': 'משרד ראש הממשלה (2015, 20 אוגוסט). החלטת ממשלה מס\' 492. ועדת ההיגוי למעקב ובקרה אחר חובת הניתוח המגדרי של תקציב המדינה - שינוי הרכב. נדלה מתוך',
        'url': 'https://www.gov.il/he/Departments/policies/2015_dec492'
      },
      {
        'title': 'משרד ראש הממשלה (2018, 18 ינואר). החלטת ממשלה מס\' 3451. הרכב ועדת ההיגוי למעקב ובקרה אחר חובת הניתוח המגדרי של תקציב המדינה - תיקון החלטת ממשלה. נדלה מתוך',
        'url': 'https://www.gov.il/he/Departments/policies/dec3451_2018'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '20/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '12/02/2019'
    },
    'description': 'ועדת החקירה הפרלמנטרית לבדיקת רצח נשים על ידי בני זוגן הוקמה בכנסת ב-7.3.1995 כתוצאה מפעילותה של ״ועדת המשנה בנושא אלימות נגד נשים״ בראשות ח״כ נעמי בלומנטל שנוסדה בתחילת הכנסת ה-13. ועדת החקירה הוקמה על מנת לבחון כיצד ניתן לצמצם את ממדי התופעה ולהגיש המלצות לחקיקה ומדיניות בתחום. הועדה קיימה 17 ישיבות, סיור בכלא באר שבע ומספר רב של התייעצויות עם חוקרים ומומחים. עבודת הועדה לוותה באיסוף ואימות נתונים והיא הגישה דו״ח ומסקנות ביוני 1996. שלושת הנושאים העיקריים שבהם עסקה הועדה היו: (א) ניסיון לאמוד את היקף התופעה; (ב) בחינת המאפיינים הפסיכו-סוציאליים של גברים מכים; (ג) בחינת הכשלים והחסרים בשירותים הציבוריים בתחום. בראש הועדה עמדה חה״כ לימור לבנת ומחליפתה יעל דיין. בין חברות הועדה היו נעמי חזן, נעמי בלומנטל, סילבן שלום, הרב עזרן, אליעזר זנדברג, בני טמקין, האשם מחמיד, סלאח טריף ודליה איציק. בישיבות הועדה השתתפו באופן קבוע נציגות של ארגוני נשים. הועדה המליצה להקים רשות ממלכתית לקידום מעמד האשה, לקיים סקר לאומי בנושא אלימות כלפי נשים, לתקצב מקלטים לנשים מוכות והוסטלים לגברים אלימים, להשתתף במימון של קווי סיוע וקווי חירום, להקים תוכניות חינוך והכשרה (כולל בשפה הערבית), להחמיר בענישה ואכיפה, ולפעול בקרב אוכלוסיות ייעודיות- נשים ערביות, חרדיות ועולות.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'SA125',
    'is_active': false,
    'keywords': [
      'חקיקה',
      'ועדת חקירה',
      'משטרה',
      'נתונים'
    ],
    'name': 'ועדת החקירה הפרלמנטרית לבדיקת רצח נשים על ידי בני זוגן',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-12-02'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://main.knesset.gov.il/Activity/committees/documents/piqwifemurderreport.pdf'
      },
      {
        'title': 'להב, דן וגולדמן, שחר (2002). <b>מסמך רקע בנושא: סמכויותיה של ועדת-חקירה פרלמנטרית</b>. מוגש לח״כ דוד מגן, יו״ר ועדת החקירה הפרלמנטרית לנושא משק המים (גרסת אינטרנט). ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/4bcb66b4-9132-e811-80de-00155d0a0235/2_4bcb66b4-9132-e811-80de-00155d0a0235_11_7763.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/02/2019'
    },
    'year_closed': 1996,
    'year_closed_text': '1996',
    'year_founded': 1995,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '23/08/2018'
    },
    'description': 'ועדת החקירה הפרלמנטרית לעניין הסחר בנשים הוקמה בתאריך ה-13 ביוני 2000 במהלך הכנסת ה-15 בראשות חברת הכנסת זהבה גלאון וביוזמתה. לוועדה היו שתי מטרות: 1) יצירת מהפך תודעתי ביחס לנשים, קורבנות הסחר בבני-אדם, באופן שיראו בהן קורבנות עבירה, נשים שזכויותיהן הופרו, ולא עברייניות או שוהות בלתי חוקיות. 2) החמרת ההתייחסות לעבריינים הסוחרים והמסרסרים בגופן של נשים. ב-31 בדצמבר 2004, סיימה הוועדה את עבודתה כוועדת חקירה והמלצותיה הוגשו במרס 2005. החל ב-1 בינואר 2005 המשיכה הוועדה את עבודתה כוועדת משנה למאבק בסחר בנשים, במסגרת הוועדה לביקורת המדינה. בתחילת הכנסת ה-17 הוועדה הוקמה מחדש כוועדת משנה במסגרת הוועדה לקידום מעמד האישה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'סחר בנשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ],
      [
        'הגירה',
        'סחר בבני אדם'
      ]
    ],
    'id': 'YH81',
    'is_active': false,
    'keywords': [
      'ועדה',
      'ועדת חקירה',
      'סחר בנשים',
      'חקיקה',
      'כנסת',
      'הפללת צרכני זנות'
    ],
    'name': 'ועדת החקירה הפרלמנטרית למאבק בסחר בנשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'סחר בנשים',
    'primary_target_audience': 'נשים מהגרות עבודה או חסרות מעמד',
    'retrieved': {
      'type{date}': '2019-09-19'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.knesset.gov.il/committees/heb/docs/sachar_main.htm'
      },
      {
        'title': 'ארליך, יונתן (2006). <b>דוח מעקב - יישום מסקנות ועדת החקירה הפרלמנטרית למאבק בסחר בנשים 2000-2004</b>. ועדת המשנה למאבק בסחר בנשים. נדלה מתוך',
        'url': 'http://www.knesset.gov.il/committees/heb/docs/sachar.pdf'
      },
      {
        'title': 'לוצקי, מיכל (2005). <b>ועדת החקירה הפרלמנטרית למאבק בסחר בנשים - דוח מסכם</b>. נדלה מתוך',
        'url': 'https://www.knesset.gov.il/committees/heb/docs/sachar_final2005.htm'
      }
    ],
    'target_audiences': [
      'נשים מהגרות עבודה או חסרות מעמד'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '19/09/2019'
    },
    'year_closed': 2004,
    'year_closed_text': '2004',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '23/08/2018'
    },
    'description': 'ועדת המשנה הוקמה ב-2005 בעקבות ועדת החקירה הפרלמנטרית לנושא סחר בנשים שפעלה בין השנים 2000-2004. ועדת המשנה היתה למעשה הסבה של פעילות ועדת החקירה והיא פעלה תחת הוועדה לביקורת המדינה, הראשונה לעמוד בראשה היתה זהבה גלאון. בכנסת ה-17 הוקמה מחדש תחת הוועדה למעמד האישה (וכך היא גם כיום). כשהוקמה בכנסת ה-19, שינתה ח״כ עליזה לביא את שמה של ועדת המשנה כשהוסיפה את המילה ״זנות״.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'סחר בנשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ],
      [
        'הגירה',
        'סחר בבני אדם'
      ]
    ],
    'id': 'YH82',
    'is_active': true,
    'keywords': [
      'סחר בנשים',
      'זנות',
      'ועדה',
      'חקיקה',
      'כנסת',
      'הפללת צרכני זנות'
    ],
    'name': 'ועדת המשנה למאבק בסחר בנשים ובזנות',
    'name_ar': null,
    'name_change_year': 2013,
    'name_common': null,
    'name_past': 'ועדת המשנה למאבק בסחר בנשים',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'סחר בנשים',
    'primary_target_audience': 'נשים מהגרות עבודה או חסרות מעמד',
    'retrieved': {
      'type{date}': '2019-09-19'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://oknesset.org/committees/983.html'
      },
      {
        'title': 'ארליך, יונתן (2006). <b>דוח מעקב - יישום מסקנות ועדת החקירה הפרלמנטרית למאבק בסחר בנשים 2000-2004</b>. ועדת המשנה למאבק בסחר בנשים. נדלה מתוך',
        'url': 'http://www.knesset.gov.il/committees/heb/docs/sachar.pdf'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי, ועדת המשנה למאבק בסחר בנשים ובזנות (2013, 18 יוני). <b>פרוטוקול מס\' 1: 1. הקמת הוועדה וסמכויותיה. 2. תיאום ציפיות. 3. סקירות: משרד המשפטים המשרד לבטחון הפנים, משרד הרווחה והשירותים החברתיים</b>.',
        'url': 'https://oknesset.org/meetings/4/8/484691.html'
      }
    ],
    'target_audiences': [
      'נשים מהגרות עבודה או חסרות מעמד'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '19/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/02/2019'
    },
    'description': 'ועדת המשנה לעניין בדיקת תשלומי מזונות מהמוסד לביטוח לאומי הוקמה בשנת 2015 בכנסת ה-20 כתת-ועדה של ועדת העבודה, הרווחה והבריאות. יו״ר ועדת המשנה היתה ח״כ מירב בן ארי וחברים נוספים היו ח״כ טלי פלוסקוב, ח״כ מיכאל מלכיאלי, ח״כ עבדאללה אבו מערוף וח״כ שולי מועלם-רפאלי.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'SA132',
    'is_active': true,
    'keywords': [
      'אמהות גרושות',
      'דמי מזונות',
      'ביטחון סוציאלי',
      'זכויות',
      'חקיקה',
      'ועדה'
    ],
    'name': 'ועדת המשנה לעניין בדיקת תשלומי מזונות מהמוסד לביטוח לאומי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'ועדת העבודה, הרווחה והבריאות, וועדת המשנה לעניין בדיקת תשלומי מזונות של המוסד לביטוח לאומי (2016, 14 נובמבר). <b>פרוטוקול מס\' 1: בדיקת נושא תשלומי מזונות של המוסד לביטוח לאומי</b>. נדלה מתוך',
        'url': 'https://main.knesset.gov.il/Activity/committees/Labor/Pages/SubComNIAlimony.aspx'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '25/02/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/02/2019'
    },
    'description': 'ועדת המשנה לקידום נשים בעבודה ובכלכלה הוקמה בשנת 1996 בכנסת ה-14 כתת-ועדה של הועדה לקידום מעמד האשה. בראשות ועדת המשנה עמדה ח״כ ענת מאור וח״כ נחום לנגנטל (כנסת ה-15). בין הנושאים שנידונו בוועדת המשנה היו: פערי שכר בין גברים לנשים בשירות הציבורי, הכשרה מקצועית לנשים ערביות וחרדיות, זכויות פנסיוניות לנשים גרושות, יזמות עסקית לנשים מעוטות הכנסה ועוד. הועדה הפסיקה לפעול בשנת 2003.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'SA128',
    'is_active': false,
    'keywords': [
      'ועדה',
      'הכשרה מקצועית',
      'חקיקה',
      'יזמות עסקית',
      'כנסת',
      'פערי שכר',
      'פנסיה'
    ],
    'name': 'ועדת המשנה לקידום נשים בעבודה ובכלכלה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'זכויות ומדיניות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הכנסת, ועדות (2002, 17 יולי). <b>הוועדה לקידום מעמד האשה - דין וחשבון</b>. נדלה מתוך',
        'url': 'https://www.knesset.gov.il/committees/heb/docs/maamad15-4.htm#3'
      },
      {
        'title': 'הכנסת, ועדות (ללא תאריך). <b>ועדת המשנה לקידום נשים בכלכלה ובעבודה לדורותיה</b>. נדלה מתוך',
        'url': 'https://www.knesset.gov.il/committees/heb/CommitteeHistoryByCommittee.asp?com=147'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '06/09/2019'
    },
    'year_closed': 2003,
    'year_closed_text': '2003',
    'year_founded': 1996,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '06/03/2018'
    },
    'description': '״ועדת השרים לקידום מעמד האשה בחברה הישראלית״ היא ועדת שרים קבועה אשר החלה לפעול בשנת 2001 בראשות שרת החינוך, לימור לבנת. בנוסף לשרים שהיו חברים בוועדה, הוזמנה אליה מנהלת הרשות לקידום מעמד האישה במשרד ראש הממשלה כחברה קבועה. סמכויות הוועדה היו: ״ גיבוש מדיניות וקידום מגוון הנושאים הקשורים במעמד האישה ובשוויון ההזדמנויות לנשים בחברה הישראלית״. פעילות ועדת השרים בראשות לבנת, ששימשה כשרת החינוך ואז כשרת התרבות, אושררה מחדש בשנת 2003 (החלטת ממשלה מס\' 23), בשנת 2006 (החלטת ממשלה מס\' 58), בשנת 2009 (החלטת ממשלה מס\' 450) ובשנת 2013 (החלטת ממשלה מס\' 139). בשנת 2015 שינתה הועדה את שמה ל״ועדת השרים לקידום השוויון המגדרי״ (החלטת ממשלה מס\' 36) ואת סמכויותיה ותחומי פעילותה אשר נוסחו כך: ״קידום השוויון המגדרי בכל תחומי החיים. הרשות לקידום מעמד האישה תשמש מרכזת הוועדה ותהיה ממונה על תאום ומעקב של החלטות הוועדה ככל שלא ייקבע אחרת.״ יושבת ראש הוועדה מאז היא השרה לשוויון חברתי, גילה גמליאל.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'YH15',
    'is_active': true,
    'keywords': [
      'חקיקה',
      'ייצוג הולם'
    ],
    'name': 'ועדת השרים לקידום שוויון מגדרי',
    'name_ar': null,
    'name_change_year': 2015,
    'name_common': null,
    'name_past': 'ועדת שרים לקידום מעמד האישה בחברה הישראלית',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-03-06'
    },
    'sources': [
      {
        'title': 'דף הוועדה באתר משרד ראש הממשלה',
        'url': 'http://www.pmo.gov.il/Secretary/ministersCommissions/Pages/isha34.aspx'
      },
      {
        'title': 'משרד ראש הממשלה (2003, 9 מרץ). החלטת ממשלה מס\' 23: ועדת שרים לקידום מעמד האישה בחברה הישראלית. נדלה מתוך',
        'url': 'https://www.gov.il/he/departments/policies/2003_mar23'
      },
      {
        'title': 'משרד ראש הממשלה (2006, 21 מאי). החלטת ממשלה מס\' 58. ועדת שרים לקידום מעמד האישה בחברה הישראלית. נדלה מתוך',
        'url': 'https://www.gov.il/he/departments/policies/2006_des58'
      },
      {
        'title': 'משרד ראש הממשלה (2009, 21 יוני). החלטת ממשלה מס\' 450. ועדת שרים לקידום מעמד האישה בחברה הישראלית. נדלה מתוך',
        'url': 'https://www.gov.il/he/departments/policies/2009_des450'
      },
      {
        'title': 'משרד ראש הממשלה (2013, 13 מאי). החלטת ממשלה מס\' 139. ועדת שרים לקידום מעמד האישה בחברה הישראלית. נדלה מתוך',
        'url': 'https://www.gov.il/he/departments/policies/2013_dec139'
      },
      {
        'title': 'משרד ראש הממשלה (2015, 26 מאי). החלטת ממשלה מס\' 36. ועדת השרים לקידום השוויון המגדרי. נדלה מתוך',
        'url': 'https://www.gov.il/he/departments/publicbodies/isha34'
      },
      {
        'title': 'נהרי, תמר (2002, 13 פברואר). יותר נשים ברשימה לכנסת- יותר מימון מפלגות. <b>וואלה!NEWS</b>. נדלה מתוך',
        'url': 'https://news.walla.co.il/item/182991'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/11/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2001,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'שירותים משפטיים'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '01/01/2019'
    },
    'description': 'וועדת זכויות הלהט״ב בלשכת עורכי הדין נוסדה ב - 2006, בראשותו של דורי ספיבק (אשר לימים מונה לשופט עליון). בשנים 2006-2009 קיימה ישיבות קבועות והגישה המלצות להחלטות ועמדות ללשכת עורכי הדין, אשר הובילו להצהרות ופרסומים של הלשכה בנושאים להט״בים. בתקופה הזו היא אף ארגנה אירועים והרצאות בנושאים להט״בים על ידי משפטנים העוסקים בתחום. ב - 2016 הוועדה שבה והתכנסה, הפעם בראשותם של מיכל עדן ומשה שוכטמן, על מנת ״למפות את צרכי הקהילה הגאה, להגיש סיוע משפטי למימושם וליזום פעילויות, השתלמויות וכנסים שיעלו את הנושא הלהט״בי על סדר היום הציבורי.״ לא ברור מה מידת הפעילות של הוועדה בין השנים 2009-2016 ומאז.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'להט״ב',
        'זכויות'
      ],
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ]
    ],
    'id': 'LR41',
    'is_active': true,
    'keywords': [
      'קהילה',
      'זכויות',
      'עריכת דין',
      'סיוע משפטי',
      'מעמד איש׳',
      'הרצאות'
    ],
    'name': 'ועדת זכויות הלהט״ב בלשכת עורכי הדין',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'זכויות',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': '(2007, 24 ינואר). לשכת עורכי הדין מתנגדת להצעת חוק האוסרת רישום נישואים של הומואים. <b>כאן ישראל</b>. נדלה מתוך',
        'url': 'https://kanisrael.co.il/10018/'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '01/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2007,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '10/06/2019'
    },
    'description': 'וועדת מדז׳יבוז׳ הוקמה על רקע פעולתה של תנועת ה-#MeToo אשר שמה זרקור על היקף תופעת ההטרדות המיניות, וחשפה את המציאות העגומה של הטרדות מיניות במקומות עבודה. בעקבות זאת ולאור החלטת ועדת השרים לשוויון מגדרי בראשות השרה גילה גמליאל, שקיבלה תוקף של החלטת ממשלה מס\' 3229 מתאריך 7 דצמבר 2017, יזמה הרשות לקידום מעמד האישה הקמת ועדה (ועדת מדז\'יבוז\') לגיבוש תכנית לאומית למאבק בתופעת ההטרדות המיניות בחברה הישראלית, בראשות מנהלת הרשות לקידום מעמד האישה. במסגרת החלטת הממשלה הנ״ל הוקצו 10 מיליון ₪ לשלוש שנים, מתוך תקציב הרשות במשרד לשוויון חברתי. משתתפי הועדה שהתכנסה לראשונה ביוני 2018 כללו את מנכ״ל המשרד לשוויון חברתי, מנכ״לית משרד המשפטים, יועצת המפכ״ל לענייני נשים, יועצת הרמטכ״ל לענייני מגדר, מנכ״לית איגוד מרכזי הסיוע לנפגעות תקיפה מינית ונציגים מטעם מנכ״לי משרד החינוך ומשרד האוצר. במסגרת עבודת הועדה, במהלך חודש אוגוסט 2018 נערך סקר במטרה לבחון את תופעת ההטרדות המיניות בישראל ומידת התרחשותן במקומות העבודה. דוח הועדה שהוגש בינואר 2019 כלל 38 המלצות העוסקות בהגברת הפיקוח והאכיפה של החוק למניעת הטרדה מינית במקום העבודה ובמוסדות חינוך והשכלה גבוהה וקרא גם להרחבת יוזמות חקיקה ותקצוב של פעילויות חינוך ומניעה. דוח הועדה נכתב בסיוע חברת הייעוץ Deloitte ישראל.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'הטרדה מינית'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'SA139',
    'is_active': true,
    'keywords': [
      'הטרדה מינית',
      'חקיקה',
      'ועדה',
      'נתונים'
    ],
    'name': 'הוועדה לגיבוש תכנית לאומית למאבק בתופעת ההטרדות המיניות בחברה הישראלית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'ועדת מדז\'יבוז\'',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'הטרדה מינית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הרשות לקידום מעמד האשה (2018, 4 יולי). <b>ועדת מדז\'יבוז\' לגיבוש תכנית לאומית למאבק בתופעת ההטרדות המיניות בחברה הישראלית התכנסה לראשונה</b> (העמוד אינו זמין יותר).'
      },
      {
        'title': 'הרשות לקידום מעמד האשה (2019). דוח פעילות שנת 2018. נדלה מתוך',
        'url': 'https://www.gov.il/BlobFolder/generalpage/information_law_shivyon/he/%D7%93%D7%95%D7%97%20%D7%A4%D7%A2%D7%99%D7%9C%D7%95%D7%AA%20%D7%94%D7%A8%D7%A9%D7%95%D7%AA%20%D7%9C%D7%A7%D7%99%D7%93%D7%95%D7%9D%20%D7%9E%D7%A2%D7%9E%D7%93%20%D7%94%D7%90%D7%99%D7%A9%D7%94%202018.pdf'
      },
      {
        'title': 'הרשות לקידום מעמד האשה (2019). <b>המלצות הוועדה לגיבוש תכנית לאומית למאבק בתופעת ההטרדות המיניות בחברה הישראלית</b>. נדלה מתוך',
        'url': 'https://www.gov.il/BlobFolder/news/harassment_committee/he/%D7%94%D7%9E%D7%9C%D7%A6%D7%95%D7%AA%20%D7%94%D7%95%D7%A2%D7%93%D7%94%20%D7%9C%D7%9E%D7%90%D7%91%D7%A7%20%D7%91%D7%94%D7%98%D7%A8%D7%93%D7%95%D7%AA%20%D7%9E%D7%99%D7%A0%D7%99%D7%95%D7%AA%20%D7%91%D7%9E%D7%A7%D7%95%D7%9E%D7%95%D7%AA%20%D7%A2%D7%91%D7%95%D7%93%D7%94-%20%D7%A1%D7%95%D7%A4%D7%99%2030.7.19_.pdf'
      },
      {
        'title': 'משרד ראש הממשלה (2017, 20 נובמבר, תיקוף: 2017, 7 דצמבר). החלטת ממשלה מס\' 3229: גיבוש תוכנית לאומית למאבק בתופעת ההטרדות המיניות. נדלה מתוך',
        'url': 'https://www.gov.il/he/departments/policies/2017_dec3229'
      },
      {
        'title': 'יורובסקי, ענת (2019, 28 ינואר). נלחמים בהטרדות – אפס סובלנות: פורסמו המלצות הוועדה למאבק בהטרדות המיניות. <b>דבר</b>. נדלה מתוך',
        'url': 'https://www.davar1.co.il/171245/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '06/10/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2017,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '11/10/2018'
    },
    'description': 'הוועדה מונתה בעקבות החלטת ממשלה מספר 3123 מיום 16 מאי 1994 (והיא בעקבות פסק דין מ-26.1.94). בראש ועדת המנכ״לים עמד מנכ״ל משרד ראש הממשלה. הוועדה מונתה על מנת שתמליץ על פתרון שיקיים את חופש הגישה והתפילה בכותל תוך צמצום הפגיעה ברגשות המתפללים. המלצותיה הוגשו באפריל 1996.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'פוליטיקה ומנהיגות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'YH100',
    'is_active': false,
    'keywords': [
      'תפילה',
      'ייצוג',
      'שוויון',
      'יהדות',
      'הלכה',
      'כותל',
      'תורה'
    ],
    'name': 'ועדת מנכ״לים לבחינת הסדרי התפילה ברחבת הכותל המערבי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'הצוות המייעץ לסוגיית הסדרי התפילה בכותל המערבי (2016). <b>המלצות</b>. נדלה מתוך',
        'url': 'https://www.womenofthewall.org.il/wp-content/uploads/2018/02/%D7%93%D7%95%D7%97-%D7%9E%D7%AA%D7%95%D7%95%D7%94-%D7%94%D7%9B%D7%95%D7%AA%D7%9C.docx.pdf'
      },
      {
        'title': 'משה, נטע (2013, 28 אפריל). <b>תפילה של נשות הכותל בכותל המערבי</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/7cbe8d55-f7f7-e411-80c8-00155d010977/2_7cbe8d55-f7f7-e411-80c8-00155d010977_11_8450.pdf'
      }
    ],
    'target_audiences': [
      'נשים דתיות',
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '11/10/2018'
    },
    'year_closed': 1996,
    'year_closed_text': '1996',
    'year_founded': 1994,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/02/2019'
    },
    'description': '״בית חולים הקריה״ היה שמו העממי של בית החולים לנשים (בית יולדות ומחלקות גינקולוגיות) אשר שכן בין השנים 1951–1997 בקריה בתל אביב. שמו הרשמי היה ״בית היולדות ע״ש יוסף סרלין״ והוא שימש במשך 46 שנים מקום משכנן של מחלקות הנשים והיולדות של העיר תל אביב עד שהועבר אל בית החולים ליס במתחם איכילוב. ועדת המשנה בנושא סגירת בית החולים ליולדות בתל אביב הוקמה במהלך הכנסת ה-9 ב-30/05/1978, ככל הנראה על מנת לבחון את המשך פעילות בית החולים. יו״ר הועדה היתה ח״כ שרה דורון. חברי הועדה היו: יעקב ז`אק אמיר (אמזלג), חייקה גרוסמן-אורקין, הלל זיידל, אורה נמיר ושרה שטרן-קטן.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'SA127',
    'is_active': false,
    'keywords': [
      'בית חולים',
      'לידה',
      'ועדה',
      'כנסת'
    ],
    'name': 'ועדת משנה בנושא סגירת בית החולים ליולדות בתל אביב',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הכנסת (ללא תאריך). ועדת משנה בנושא סגירת בית החולים ליולדות בתל אביב: הרכב הוועדה בכנסת התשיעית [1977–1981]. נדלה מתוך',
        'url': 'https://www.knesset.gov.il/committees/heb/CommitteeHistoryByComAndKnes.asp?com=442&kn=9'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/02/2019'
    },
    'year_closed': 1980,
    'year_closed_text': '1980',
    'year_founded': 1978,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/02/2019'
    },
    'description': 'ועדת המשנה לדיני אישות וייצוג נשים הוקמה בשנת 1992 בכנסת ה-13 כתת-ועדה של הועדה לקידום מעמד האשה. חברות ועדת המשנה היו ח״כ נעמי חזן וח״כ לימור לבנת. מהפרוטוקלים של הכנסת עולה כי ועדת המשנה הוסיפה לקיים דיונים גם בכנסת ה-14 ופעלה לפחות עד שנת 1998. בין הנושאים שנידונו בועדת המשנה נכללו: רישום נישואין מחו״ל, חוק יחסי ממון, סיוע לנשים לקראת גירושין, הקמת קו חם לנשים חרדיות ועוד.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'SA129',
    'is_active': false,
    'keywords': [
      'חקיקה',
      'דיני משפחה',
      'גירושין',
      'ועדה',
      'כנסת'
    ],
    'name': 'ועדת משנה לדיני אישות וייצוג נשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הוועדה לקידום מעמד האישה (1998). <b>הוועדה לקידום מעמד האשה בכנסת ה-14</b>. נדלה מתוך',
        'url': 'https://www.knesset.gov.il/committees/heb/docs/maamad14_2.pdf'
      },
      {
        'title': 'ועדת משנה לדיני אישות וייצוג נשים (1992, 13 יולי). הרכב הוועדה בכנסת השלוש-עשרה',
        'url': 'https://www.knesset.gov.il/committees/heb/CommitteeHistoryByComAndKnes.asp?com=127&kn=13'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/02/2019'
    },
    'year_closed': 1999,
    'year_closed_text': '1999',
    'year_founded': 1992,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/02/2019'
    },
    'description': 'ועדת המשנה לחד-הוריות, עולות ופניות הציבור הוקמה בשנת 1992 בכנסת ה-13 כתת-ועדה של הוועדה לקידום מעמד האשה. יושבת ראש הועדה היתה ח״כ אסתר סלמוביץ. ועדת המשנה הפסיקה לפעול בשנת 1996. ועדת המשנה עסקה בין היתר בתיקון חוק משפחות חד-הוריות (1994) בשיתוף פעולה עם חברות כנסת נוספות וארגוני נשים.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ],
      [
        'הגירה',
        'קליטת עלייה'
      ]
    ],
    'id': 'SA131',
    'is_active': false,
    'keywords': [
      'אמהות גרושות',
      'עולות מברה״מ',
      'ועדה',
      'חקיקה',
      'כנסת'
    ],
    'name': 'ועדת משנה לחד-הוריות, עולות ופניות הציבור',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים עולות מחבר העמים',
    'retrieved': null,
    'sources': [
      {
        'title': 'הרבסט, ענת (2007). <b>מ״עלובת הנפש במשפחה שבורה״ לזעקת קול אם״. אמהות חד הוריות בישראל- מדיניות הרווחה, שיח ולגיטימציה, 1972–2003</b> (חיבור לשם קבלת תואר ״דוקטור לפילוסופיה״). אוניברסיטת בר-אילן, רמת גן.'
      },
      {
        'title': 'ועדת משנה לחד-הוריות, עולות ופניות הציבור (1992–1996). <b>הרכב הוועדה בכנסת ה-13</b>. נדלה מתוך',
        'url': 'https://www.knesset.gov.il/committees/heb/CommitteeHistoryByComAndKnes.asp?com=135&kn=13'
      }
    ],
    'target_audiences': [
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '24/02/2019'
    },
    'year_closed': 1996,
    'year_closed_text': '1996',
    'year_founded': 1992,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/02/2019'
    },
    'description': 'ועדת המשנה לקידום מעמד האישה במגזר הערבי הוקמה בשנת 1992 בכנסת ה-13 תחת השם ״ועדת משנה לקידום מעמד האשה הערבייה״ כתת-ועדה של הועדה לקידום מעמד האשה. היו״ר הראשון של ועדת המשנה היה ח״כ עבד אלוהאב דראושה, אחריו כהנו בתפקיד ח״כ תמר גוזנסקי (כנסת ה-14) וח״כ חוסניה ג\'בארה וח״כ מוחמד כנעאן (כנסת ה-15). ועדת המשנה הפסיקה לפעול בשנת 2003. בין הנושאים שנידונו בוועדת המשנה היו: רצח נשים ערביות, נשים ערביות בשוק העבודה, פערי שכר ועידוד יזמות עסקית, ייצוג נשים ערביות ברשויות המקומיות, נשים חד הוריות במגזר הערבי ועוד.',
    'description_ar': 'اقيمت اللجنة الثانوية لتعزيز مكانة المرأة في المجتمع العربي عام 1992 في الكنيست ال 13 تحت اسم ״اللجنة الثانوية لتعزيز مكانة المرأة العربية״ كلجنة فرعية من لجنة تعزيز مكانة المرأة. رئيس اللجنة الأول كان عضو البرلمان عبد الوهاب دراوشة وبعدها في الكنيست ال 14 عضوة البرلمان تمار جوزنسكي وبعدها حسنية جبارة ومحمد كنعان في الكنيست ال 15. توقف نشاط اللجنة في عام 2003. ومن بين المواضيع التي طرحت كانت: قتل النساء العربيات، النساء العربيات في سوق العمل، الفجوات في الدخل، تشجيع ريادة الاعمال، تمثيل نسائي عربي في السلطات المحلية، العائلات أحادية الوالدية في الوسط العربي وغيره.',
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'SA130',
    'is_active': false,
    'keywords': [
      'חד הוריות',
      'כנסת',
      'העצמה כלכלית',
      'רצח נשים',
      'רווחה',
      'חקיקה'
    ],
    'name': 'ועדת משנה לקידום מעמד האישה במגזר הערבי',
    'name_ar': 'لجنة ثانوية لمكانة المرأة العربية',
    'name_change_year': 1996,
    'name_common': null,
    'name_past': 'ועדת משנה לקידום מעמד האשה הערבייה',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'הוועדה לקידום מעמד האישה (1998). <b>הוועדה למעמד האשה: הכנסת ה-14</b>. נדלה מתוך',
        'url': 'https://www.knesset.gov.il/committees/heb/docs/maamad14_2.pdf'
      },
      {
        'title': 'הכנסת (2002, 17 יולי). <b>הוועדה לקידום מעמד האשה - דין וחשבון</b>. נדלה מתוך',
        'url': 'https://www.knesset.gov.il/committees/heb/docs/maamad15-4.htm#13'
      },
      {
        'title': 'הכנסת (ללא תאריך). <b> ועדת משנה לקידום מעמד האשה הערבייה: הרכב הוועדה בכנסת ה-15</b>. נדלה מתוך',
        'url': 'https://www.knesset.gov.il/committees/heb/CommitteeHistoryByComAndKnes.asp?com=132&kn=15'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '24/02/2019'
    },
    'year_closed': 2003,
    'year_closed_text': '2003',
    'year_founded': 1992,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': '״ועדת נמיר״ היתה הועדה הממשלתית הראשונה לבחינת מעמד האשה בישראל. היא נוסדה ביוזמת ראש הממשלה יצחק רבין ז״ל בהחלטת ממשלה מה-28 לדצמבר 1975 (כ״ד טבת תשל״ו) לאחר השתתפות ישראל בוועידת הנשים של האו״ם במקסיקו ובעקבות הכרזת האו״ם על שנת האשה הבינלאומית. בראשות הועדה עמדה ח״כ אורה נמיר והיא הורכבה מתשעה צוותי עבודה: ״חינוך והכשרה מקצועית״, ״מעמד האשה בדיני משפחה״, ״מעמד האשה בדיני עבודה ובביטחון הסוציאלי״, ייצוגן ומעורבותן של נשים בחיים הציבוריים והפוליטיים״, ״תדמית ותקשורת״, ״תפקודי האשה במשפחה-שירותים ציבוריים״, ״האשה בכח העבודה״, ״נשים במצבי מצוקה״, ו-״האשה במערכת הבטחונית״. בוועדה היו חברים 92 נשים וגברים מתחומים ועיסוקים שונים אשר קיימו דיונים, סיורים, ימי עיון וכנסים ברחבי הארץ. הוועדה הגישה לרה״מ מנחם בגין את המלצותיה בפברואר 1978. בדו״ח שכלל מאות עמודים פורסמו לראשונה נתונים אודות חוסר השוויון בין נשים וגברים בחברה הישראלית. בין השאר, הצביע הדו״ח על מיעוט נשים בתפקידים בכירים, על ריכוז נשים במקצועות שאינם מוערכים ומתוגמלים דיים כגון הוראה, סיעוד ועבודה סוציאלית, והתריע על חוסר ייצוג נשים במערך קבלת ההחלטות וקביעת המדיניות בכנסת, בממשלה ובשלטון המקומי. המלצות הוועדה התייחסו אל הצורך לפתח מנגנונים ממשלתיים לקידום מעמד האישה וכללו שורה של תביעות חברתיות וביניהן הנהגת יום לימודים ארוך, פיתוח שירותי רווחה ובריאות ייעודיים לנשים, תכנון משפחה, רפורמות בתחום האלימות המינית ועוד. המלצות ועדת נמיר שימשו כאבן יסוד לבניית המערך המדינתי לקידום מעמד האשה בישראל. בעשור שלאחר פרסום הדו״ח נחקקו שורה של חוקים לקידום נשים וביניהם: חוק הזדמנות שווה בתעסוקה -1981 (הוחלף ותוקן בשנת 1988); חוק הבטחת הכנסה (המזכה אישה בגמלה חודשית להבטחת הכנסה) - 1982; תיקונים בחוקי מס הכנסה הנוגעים לנשים - 1984-1988; החלטת ממשלה ״שוויון הזדמנויות לנשים בשירות הממשלתי״ - 1985; תיקון ״חוק עבודת נשים״ והתרת עבודת לילה לנשים - 1986; חוק גיל פרישה שווה לעובדת ולעובד - 1987; החוק למניעת הטרדה מינית - 1988; חוק שוויון ההזדמנויות בעבודה - 1988. חלק ניכר מישיבות צוותי העבודה מתועד בתיקיות שנסרקו על ידי ארכיון המדינה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': '1YB1',
    'is_active': false,
    'keywords': [
      'אלימות',
      'רווחה',
      'תעסוקה',
      'מעונות יום',
      'השכלה',
      'הכשרה מקצועית',
      'נערות במצוקה',
      'זנות'
    ],
    'name': 'הוועדה למעמד האשה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'ועדת נמיר',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הוועדה למעמד האשה (1978). <b>צוותי הוועדה למעמד האשה: דיונים ומימצאים</b>. ירושלים: משרד ראש הממשלה.'
      },
      {
        'title': 'בן ישראל, רות (1998). <b>שוויון הזדמנויות ואיסור הפליה בעבודה</b> (כרך ב). תל אביב: האוניברסיטה הפתוחה.'
      },
      {
        'title': 'ברקוביץ, ניצה (2003). גלובליזציה של זכויות אדם ושל זכויות נשים: המדינה והמערכת הפוליטית העולמית. <b>תיאוריה וביקורת, 23</b>, 13–48.'
      },
      {
        'title': 'הלפרין-קדרי, רות (2006). ״שוויון זכויות... בלי הבדל... מין״: נשים, משפט ושינוי חברתי בישראל. <b>תרבות דמוקרטית, 10</b>, 163–190. נדלה מתוך',
        'url': 'http://rackmancenter.com/publications/%D7%9E%D7%90%D7%9E%D7%A8%D7%99%D7%9D-%D7%A4%D7%A8%D7%95%D7%A4%D7%A1%D7%95%D7%A8-%D7%A8%D7%95%D7%AA-%D7%90%D7%9C%D7%A4%D7%A8%D7%99%D7%9F-%D7%A7%D7%99%D7%93%D7%A8%D7%99/'
      },
      {
        'title': 'שלוי, אליס (1998). נשים בישראל: שנות השבעים – ראשיתו של מפנה. בתוך: אהרוני, מאיר ואהרוני שרה (עורכים), <b>אישים ומעשים בישראל: ספר היובל</b>. כפר-סבא: מקסם. תקציר המאמר באתר מטח',
        'url': 'https://lib.cet.ac.il/pages/item.asp?item=2278'
      },
      {
        'title': '(1978, 23 פברואר). 241 המלצות לשיפור מעמד האשה. <b>דבר</b>. נדלה מתוך',
        'url': 'http://jpress.org.il/olive/apa/nli_heb/SharedView.Article.aspx?href=DAV/1978/02/23&id=Ar00303'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '13/11/2018'
    },
    'year_closed': 1978,
    'year_closed_text': '1978',
    'year_founded': 1976,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '23/10/2018'
    },
    'description': 'הועדה מונתה ב-1986 על ידי שמעון פרס, ראש הממשלה ושר האוצר דאז, בעקבות החלטת ממשלה מס\' 548 מיום 24.8.1985 בדבר ״מתן שוויון הזדמנויות לעובדות ולעובדים בשירות המדינה וברשויות הכפופות למשרדי הממשלה״. דוח הוועדה הוגש ב-1989 והממשלה אימצה את המלצותיו ב-1990. במסגרת הועדה פעל צוות (תת-ועדה) בנושא נשים בראשות יהודית היבנר. דוח הוועדה התייחס ישירות להחלטת הממשלה וניסח המלצות בתחום תעסוקת נשים ומינוי ממונות למעמד האישה במשרדי הממשלה. ההמלצה המרכזית של הדוח בנושא נגעה לעיגון תפקיד הממונות ותקצובן וכן הכפפתן ליועצת רה״מ למעמד האישה. בעקבות אימוץ המלצות הוועדה מונתה ב-1993 ועדת בן-ישראל ליישום מסקנות ועדת קוברסקי בנושא קידום ושילוב נשים במגזר הציבורי.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'YH112',
    'is_active': false,
    'keywords': [
      'העדפה מתקנת',
      'ועדה',
      'חקיקה',
      'שירות ציבורי',
      'קידום נשים',
      'שוויון הזדמנויות'
    ],
    'name': 'הוועדה הציבורית-מקצועית לבדיקה כוללת של שירות המדינה וגופים הנתמכים מתקציב המדינה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'ועדת קוברסקי',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'זכויות ומדיניות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-23'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.gov.il/BlobFolder/reports/helek1/he/Helek1.pdf'
      },
      {
        'title': 'החלטת הממשלה מס\' 548 מיום 28/4/1985 (נספח י״א): שוויון הזדמנויות לנשים בשירות המדינה וברשויות הכפופות למשרדי הממשלה. בתוך: נציבות שירות המדינה, משרד ראש הממשלה (2014). <b>דוח הוועדה לקידום נשים בשירות המדינה</b> (עמ\' 207–209). בראשות דלית שטאובר. ירושלים.',
        'url': 'https://www.gov.il/BlobFolder/reports/report_women_committee_2014/he/ReportWomenCommittee2014.pdf'
      },
      {
        'title': 'שטינברג, פנינה (2012). <b>מקידום נשים להטמעת חשיבה מגדרית: תמורות בתפקיד הממונה על קידום מעמד האישה במשרדי הממשלה – מחקר מדיניות</b>. שוות: המרכז לקידום נשים בזירה הציבורית. ירושלים: ון ליר. נדלה מתוך',
        'url': 'https://www.vanleer.org.il/sites/files/product-pdf/%D7%AA%D7%A4%D7%A7%D7%99%D7%93%20%D7%94%D7%9E%D7%9E%D7%95%D7%A0%D7%95%D7%AA%20%D7%A2%D7%9C%20%D7%A7%D7%99%D7%93%D7%95%D7%9D%20%D7%9E%D7%A2%D7%9E%D7%93%20%D7%94%D7%90%D7%A9%D7%94%20-%20%D7%9E%D7%97%D7%A7%D7%A8%20%D7%9E%D7%93%D7%99%D7%A0%D7%99%D7%95%D7%AA.pdf'
      },
      {
        'title': 'שקד, רבקה (2004). יישום החוק להעדפה מתקנת בשירות המדינה. בתוך: מאור, ענת (עורכת), <b>העדפה מתקנת והבטחת ייצוג בישראל</b> (עמ\' 261–278). תל אביב: רמות. נדלה מתוך',
        'url': 'https://kotar-cet-ac-il.ezproxy.bgu.ac.il/KotarApp/Viewer.aspx?nBookID=92677230&sSelectedTab=tdBookInfo#1.0.8.fitwidth'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '23/10/2018'
    },
    'year_closed': 1989,
    'year_closed_text': '1989',
    'year_founded': 1986,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '20/09/2018'
    },
    'description': 'באוגוסט 1986 מינה היועץ המשפטי לממשלה בפעם הראשונה בישראל ועדה שנועדה ״ללמוד את סוגיית האלימות במשפחה ולהמליץ המלצות בנושא מדיניות החקירה, התביעה והמשפט בתחום זה״. המלצות הוועדה בראשותה של המשנה ליועץ המשפטי לממשלה דאז, גב\' יהודית קרפ, שהתפרסמו באוקטובר 1989 הביאו למפנה בטיפול בבעיית האלימות במשפחה. בדוח הוועדה נכתב בין היתר שתופעת האלימות במשפחה אינה מתבטאת במעשה יחיד וחד פעמי, אלא ברצף של התנהגות מתעללת לאורך זמן, שמעשה האלימות הוא רק אחד מביטוייה. עוד נאמר בדוח, כי ״לאלימות במשפחה יש יסודות חומרה נוספים על חומרתה של אלימות סתם, יסודות המגבירים את סכנתה החברתית של התופעה והמצדיקים אבחונה בחומרה מיוחדת לעומת תקיפה רגילה בידי זרים״. ועדת קרפ המליצה, בין היתר, על שינויי חקיקה וביניהם על הסדרה חקיקתית של מודל צווי הגנה שייתן סעד לבן משפחה בסיכון. דוח הוועדה הביא לחקיקת החוק למניעת אלימות במשפחה, התשנ״א (1991) וכתוצאה מכך להרחבת הפעילות הממשלתית והמשטרתית בתחום האלימות במשפחה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'YH89',
    'is_active': false,
    'keywords': [
      'חקיקה',
      'ועדה',
      'משטרה',
      'נתונים'
    ],
    'name': 'הוועדה הבין-משרדית בנושא מדיניות חקירה, תביעות, ומשפט בעבירות אלימות במשפחה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'ועדת קרפ',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הועדה הבין-משרדית לטיפול בבעיית ״האלימות במשפחה״ (1998). <b>דו״ח מספר 1 בנושא ״אלימות נגד נשים במשפחה</b>. בראשות יגאל בן שלום (יו״ר הועדה). נדלה מתוך',
        'url': 'http://ccfisrael.org/wp-content/uploads/2011/05/%D7%94%D7%95%D7%A2%D7%93%D7%94_%D7%94%D7%91%D7%99%D7%9F_%D7%9E%D7%A9%D7%A8%D7%93%D7%99%D7%AA_-_%D7%93%D7%95%D7%97_%D7%91%D7%9F_%D7%A9%D7%9C%D7%95%D7%9D_%D7%91%D7%A0%D7%95%D7%A9%D7%90_%D7%90%D7%9C%D7%99%D7%9E%D7%95%D7%AA_%D7%A0%D7%92%D7%93_%D7%A0%D7%A9%D7%99%D7%9D_%D7%91%D7%9E%D7%A9%D7%A4%D7%97%D7%94.pdf'
      },
      {
        'title': 'מבקר המדינה ונציב תלונות הציבור (2005). אכיפת צווי הגנה. פרק שני: משרדי ממשלה – המשרד לביטחון הפנים: משטרת ישראל. אליעזר גולדברג (מבקר המדינה). <b>דוח שנתי 55ב לשנת 2004 ולחשבונות שנת הכספים 2003</b> (עמ\' 405–418). ירושלים.',
        'url': 'https://www.mevaker.gov.il/he/Reports/Report_573/51bff4cd-c3ae-4a98-a072-7fe46bb7bb65/402-hagana.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/02/2019'
    },
    'year_closed': 1989,
    'year_closed_text': '1989',
    'year_founded': 1986,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '14/06/2018'
    },
    'description': 'הוועדה לקידום נשים בשירות המדינה הוקמה בעקבות החלטת ממשלה מס\' 481 לאישור דוח הוועדה לשיפור ניהול ההון האנושי בשירות המדינה. לפי בקשת יו״ר ועדת השרים לקידום מעמד האישה, שרת התרבות והספורט, ח״כ לימור לבנת, בהחלטת הממשלה נקבע כי מעמדן של נשים בשירות המדינה, קידומן, תנאי עבודתן ושכרן ייבחנו בידי צוות ממשלתי, ומסקנותיו יובאו לפני הממשלה בתום עבודת הוועדה.  באוקטובר 2013, מונתה דלית שטאובר (שכיהנה אז כמנכ״לית משרד החינוך) לעמוד בראש הוועדה. התפקיד שהוגדר לוועדה: לבחון את מעמדן של הנשים בשירות המדינה, קידומן, תנאי עבודתן ושכרן, ולהביא את המלצותיה בפני הממשלה. המלצות הוועדה הוגשו ביוני 2014.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'YH23',
    'is_active': false,
    'keywords': [
      'ועדה',
      'שוויון מגדרי',
      'שעות עבודה גמישות',
      'שכר שווה',
      'שירות ציבורי'
    ],
    'name': 'הוועדה לקידום נשים בשירות המדינה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'ועדת שטאובר',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'זכויות ומדיניות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד ראש הממשלה, נציבות שירות המדינה (2014, 8 יוני). <b>דוח הוועדה לקידום נשים בשירות המדינה</b> (דו״ח שטאובר). ירושלים. נדלה מתוך',
        'url': 'https://www.gov.il/he/departments/publications/reports/report_women_committee_2014'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '14/06/2018'
    },
    'year_closed': 2014,
    'year_closed_text': '2014',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '01/07/2020'
    },
    'description': 'במסגרת החלטת ממשלה כוללת לפיתוח כלכלי חברתי של האוכלוסייה הבדואית בנגב, התקבלה החלטה 2345 מיום 17.1.29 שקבעה הקמת ״ועדת שרים לעניין התמודדות עם תופעת הפוליגמיה״. בהחלטת הממשלה נאמר כי הועדה הוקמה ״נוכח הצורך בהתמודדות מקיפה עם תופעת הפוליגמיה, ששורשיה עמוקים ונטועים במסורת רבת שנים ולאור השלכותיה הקשות על בני המשפחה הפוליגמית, ובראש ובראשונה על הנשים והילדים, ועל החברה בכללותה, ובניסיון ממשלתי ראשון להתמודדות כלל ממשלתית עם התופעה האמורה.״ סמכויות הועדה היו: א. לאשר תכנית הפעולה שיגבש צוות בין-משרדי שיוקם מתוקף החלטת הממשלה; ב. לעקוב ולפקח אחר יישום תכנית הפעולה שיגבש הצוות הבין-משרדי. יו״ר הועדה היתה שרת המשפטים איילת שקד ובין חבריה נכללו: שר החינוך, שר העבודה, הרווחה והשירותים החברתיים, שר הפנים, שר הבריאות, שר החקלאות ופיתוח הכפר, השר לביטחון הפנים, ושר הכלכלה והתעשייה (שצורף באוגוסט 2018). הצוות הבין-משרדי בראשות אמי פלמור, מנכ״לית משרד המשפטים, כלל נציגים ממשרדי הממשלה השונים, הרשויות המקומיות הרלוונטיות והחברה האזרחית הגיש דו״ח מסכם ביולי 2018. הדוח התבסס על פעילות מגוונת של הצוות אשר כללה סיורים בנגב ופגישות עם מגוון רחב של אנשים, מנהיגים מקומיים, אנשי דת ושייח\'ים, אנשי מקצוע, אנשי חינוך וטיפול, פעילות ופעילים חברתיים ועוד, בעלי זיקה לסוגיה. המסקנות העיקריות של הדו״ח העלו כי קיים חוסר במידע אחיד ומגובה בדבר היקף התופעה וכי ממשלות ישראל לדורותיהן נמנעו מפעילות אכיפה במכלול ההיבטים של פוליגמיה, במישור הפלילי ובמישור האזרחי והמנהלי כאחד. בנוסף, הדו״ח קבע כי הסתגרות והתבדלות החברה הבדואית בנגב משפיעה על הנישואין בתוך החברה הבדואית ועל תופעת הפוליגמיה. המלצות הדו״ח עסקו במספר סוגיות: (1) חשיבות מערכת החינוך ככלי לשינוי תודעה בקרב האוכלוסייה הבדואית, צמצום הנשירה, העלאת גיל הנישואין ועוד. (2) השפעת דפוסי התעסוקה של גברים ונשים על הפוליגמיה. (3) הצורך במתן מענה לצרכים הפיזיים והרווחתיים של נשים וילדים שהינם הקורבנות העיקריים של התופעה. (4) הטיפול בתופעה מצריך הגברת המשילות, טיפול רוחבי והתווית מדיניות אחידה של כלל משרדי הממשלה. הצוות אף המליץ לקיים מנגנון קבוע של תאום פעולות ומעקב שיכלול את כלל הגורמים הממשלתיים הפועלים בנושא.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'SA178',
    'is_active': true,
    'keywords': [
      'פוליגמיה',
      'בדואיות',
      'משפט',
      'אסלאם',
      'מעמד אישי'
    ],
    'name': 'ועדת שרים לעניין התמודדות עם תופעת הפוליגמיה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2020-07-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.gov.il/he/Departments/policies/2017_dec2345'
      },
      {
        'title': 'משרד ראש הממשלה (2017). <b>ועדת שרים לעניין התמודדות עם תופעת הפוליגמיה</b>. נדלה מתוך',
        'url': 'https://www.gov.il/he/departments/publicbodies/poligamia'
      },
      {
        'title': 'משרד ראש הממשלה (2018, 7 אוקטובר, תיקוף: 2018, 25 אוקטובר). החלטת ממשלה מס\' 4211. מדיניות ממשלתית להתמודדות עם הפוליגמיה - יישום ומעקב אחר עקרונות דו״ח הצוות הבין-משרדי להתמודדות עם השלכותיה השליליות של הפוליגמיה. נדלה מתוך',
        'url': 'https://www.gov.il/he/departments/policies/dec4211_2018'
      },
      {
        'title': 'משרד ראש הממשלה (2018). <b>דו״ח מסכם, הצוות הבין-משרדי להתמודדות עם השלכותיה השליליות של הפוליגמיה</b>. נדלה מתוך',
        'url': 'https://www.gov.il/BlobFolder/generalpage/polygamy_final_report/he/polygamy_final_report.pdf'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/07/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2017,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '14/11/2018'
    },
    'description': '״זייתונת אלבטוף-נשים קולעות סלים מכפר מנדא״ (ע.ר. 580582773) נוסדה בשנת 2013 בכפר מנדא בגליל. מטרות העמותה הן: קידום מעמד האשה ופתיחת אופקים כלכליים בחייה. פיתוח מרכז מבקרים וקידום פרויקט מכירת סלים פרי עבודת הנשים במרכז. פתיחת מרכז לפעולות החברתיות לנשים. פיתוח פרוייקטים כלכליים לעבודת הנשים, ע״מ ליצור תוצרת ביתית יחד עם הקליעה. מפגשי תרבות בין הנשים המקומיות בינן לבין עצמן, ובינן לבין נשים אחרות מהסביבה, ערביות ויהודיות. הקמת דוכן למכירת המוצרים שיוצרות בנשים במרכז או בבית.״ חברות העמותה מתארחות בקיבוצים באזור עמק יזרעאל ומעבירות סדנאות שונות של קליעת סלים בשיטות מסורתיות, הפעילות המתועדת האחרונה הייתה במרץ 2018.',
    'description_ar': 'تأسست الجمعية عام 2013، (ج.م 580582773) في قرية كفر مندا في الجليل. أهداف الجمعية هي: تعزيز مكانة المرأة وفتح آفاق اقتصادية في حياتها. تطوير مركز للزوار وتشجيع مشروع بيع سلال الفاكهة من صنع النساء في المركز. افتتاح مركز لنشاطات اجتماعية للمرأة. تطوير المشاريع الاقتصادية لعمل المرأة، من خلال إنشاء منتجات محلية الصنع إلى جانب السلال. لقاءات ثقافية بين النساء المحليات وانفسهن وغيرهن من النساء من المجتمع العربي واليهودي. انشاء كشك لبيع المنتجات التي تصنعها النساء في المركز او في البيت. تتم استضافة أعضاء الجمعية في كيبوتسات في منطقة وادي يزرعيل وإجراء ورش عمل مختلفة في نسج السلال باستخدام الطرق التقليدية، وكان آخر نشاط تم توثيقه في مارس 2018.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'תרבות וספורט',
        'מלאכות מסורתיות'
      ]
    ],
    'id': 'YA1',
    'is_active': true,
    'keywords': [
      'סחר הוגן',
      'העצמה כלכלית',
      'דו קיום'
    ],
    'name': 'זייתונת אלבטוף- נשים קולעות סלים מכפר מנדא',
    'name_ar': 'زيتونة البطوف كفر مندا',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר מנדא',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>זייתונת אלבטוף (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580582773'
      },
      {
        'title': 'זאיתונאת אל בטוף, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/elbatofcom/?ref=page_internal'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '23/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '05/01/2019'
    },
    'description': '‏״זכרון אלעזר״ היא עמותה שקמה בשנת 2005 על ידי יהודי אמריקאי נפתלי פרלוביץ עבור הפרוייקט ‏‏״הבית של רינה״ שקם בשנת 2004. הפרוייקט בניהולה של רינה רוזנבלום מספק בית, תמיכה ושיקום ‏לנערות יהודיות בגילאים 14-22 שהן חסרות בית ועברו טראומה, פגיעות, התמכרויות, והתרחקות ‏מהמשפחה או הקהילה הדתית.‏',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'SW43',
    'is_active': true,
    'keywords': [
      'דיור',
      'תמיכה נפשית',
      'נערות במצוקה',
      'צעירות במצבי סיכון',
      'השלמת השכלה',
      'דת',
      'תעסוקה'
    ],
    'name': 'זכרון אלעזר מרכזי סיוע בירושלים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'צעירות במצבי סיכון',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2018-11-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.aishel.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>זכרון אלעזר – מרכזי סיוע בירושלים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580437754'
      },
      {
        'title': 'משרד החינוך (2014). <b>פירוט מקבלי ההקצבות וסכומי ההקצבה לפי מטרות ההקצבה: ) זיכרון אליעזר - מרכזי סיוע בירושלים</b>. נדלה מתוך',
        'url': 'https://www.gov.il/BlobFolder/reports/decisions_estates_committee1/he/2014.pdf'
      },
      {
        'title': 'נראות – פורום ארגוני צעירות (ללא תאריך). <b>רשימת בתים לנערות חרדיות: הבית של רינה – אשל</b> (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים חרדיות',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '26/05/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2004,
    'year_registered': 2005
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '31/12/2018'
    },
    'description': 'חברותא החלה את פעילותה ב - 2007 כקבוצה חברתית ירושלמית להומואים דתיים שנתמכה על ידי הבית הפתוח. ב - 2010 הארגון הרחיב את פעילותו ונרשם כעמותה עצמאית (ע״ר 580533305) שמטרותיה: ״לפעול על מנת לאפשר ליהודים בני החבורה הדתית ו/או בעלי זיקה דתית, בעלי נטייה מינית שונה ו/או שונות מגדרית, לחיות בשלום עם נטייתם המינית ו/או עם שונותם המגדרית, ולשם כך לפעול הן לקיים עבורם מסגרות ייחודיות והן לסייע בשילובם כשווים בחברה הכללית ובחברה הדתית. חלוקת מלגות ופרסים למתנדבים״. עם השנים החל הארגון לפעול גם בתל אביב. העמותה מארגנת מפגשים ופעילויות קהילתיות להומואים דתיים כולל הרצאות, ימי עיון, טיולים ושבתות קהילתיות. חברותא שותפה ב״קהילה דתית גאה״ יחד עם ארגונים נוספים הצועדים יחד במצעדי הגאווה ומארגנים פעילויות נוספות כדוגמת המניין הגאה. חברותא פועלת לקידום הסובלנות כלפי להט״בים בחברה הדתית בארגון כנסים והפצת עלונים לבתי כנסת עם דברי תורה והגות. לחברותא אין עמדה ארגונית בנוגע למשכב זכר, אך היא מתנגדת לטיפולי המרה ולניסיונות לשדך הומואים ללסביות. היא תומכת בזוגיות חד מינית ופועלת על מנת לאפשרה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'דת'
      ],
      [
        'דת ומעמד אישי',
        'להט״ב'
      ]
    ],
    'id': 'LR36',
    'is_active': true,
    'keywords': [
      'הומואים',
      'מצעד',
      'גאווה',
      'חינוך',
      'קבוצת תמיכה',
      'שבתות וחגים'
    ],
    'name': 'חברותא - הומואים דתיים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'דת',
    'primary_target_audience': 'גברים',
    'retrieved': {
      'type{date}': '2020-02-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://havruta.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>חברותא – הומואים דתיים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580533305'
      },
      {
        'title': 'חברותא: הומואים דתיים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/Havruta.IL/?__tn__=%2Cd%2CP-R&eid=ARD0CBYR5orO3R5XXz5zCbz_sOq3EYqWt0_l9BeBm2LCv3oVlY0-qnVt2HNja6o2uZ0ga_TiLwOveYe0'
      },
      {
        'title': 'כ״ץ, ישראל, מעוז, עדי, אלפסי, דנה, לוי, ניר (2018). <b>מיפוי ארגוני הלהט״ב בישראל - דו״ח מסכם</b>. האגודה למען הלהט״ב ואלכא – המכון למנהיגות וממשל בג\'וינט ישראל, ירושלים. נדלה מתוך',
        'url': 'https://a9991848-b055-4c6f-a966-a6bdabf09321.filesusr.com/ugd/be9e5d_e13bb06adc274327b97bb41c199efc0c.pdf'
      }
    ],
    'target_audiences': [
      'גברים',
      'להט״ב',
      'גברים דתיים'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '31/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2007,
    'year_registered': 2010
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '08/11/2018'
    },
    'description': 'חדר 10 - המרכז האקוטי לטיפול בנפגעי תקיפה מינית בבני ציון נפתח ב-2002. המרכז פועל 24 שעות ביממה ומסייע לפונות המגיעות עד שבוע מיום הפגיעה וזקוקות לטיפול ראשוני, נפשי ופיזי, תוך שיתוף פעולה עם גורמי המשטרה והמשפט. צוות המרכז כולל עובדות סוציאליות, אחיות ורופאים מומחים. המרכז פועל באחריות ובמימון משרד הבריאות.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'YH138',
    'is_active': true,
    'keywords': [
      'טראומה',
      'אונס',
      'מחלות מין',
      'הריון',
      'בית חולים',
      'משפט'
    ],
    'name': 'חדר 10 - מרכז אקוטי לטיפול בנפגעי תקיפה מינית בבני ציון',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-08-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.b-zion.org.il/pages/1144.aspx'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2017, 10 ינואר). <b>פרוטוקול מס\' 137: טיוב הטיפול הראשוני בנפגעות אלימות מינית - חדרי מיון ומרכזים אקוטיים</b>. נדלה מתוך',
        'url': 'https://oknesset.org/meetings/2/0/2011732.html'
      },
      {
        'title': 'רימון-גרינשפן, הילה (2016). <b>טראומה בטיפול. פגיעה מינית ואשפוז פסיכיאטרי: מיפוי שירותים ומדיניות בריאות</b>. נייר מדיניות מטעם איגוד מרכזי הסיוע לנפגעות ונפגעי תקיפה מינית וארגון בזכות – המרכז לזכויות אדם של אנשים עם מוגבלות: ירושלים. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/20/Committees/20_cs_bg_344255.pdf'
      },
      {
        'title': 'שושני, מאיר ולרמן, אייל (2002, 4 דצמבר). מרכז לנפגעי תקיפה מינית נפתח בבני-ציון. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-2293514,00.html'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/08/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2002,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '08/11/2018'
    },
    'description': 'חדר 4 - המרכז האקוטי לטיפול בנפגעות תקיפה מינית בבית החולים וולפסון נפתח ב-2000 כמרכז האקוטי הראשון מסוגו לטיפול בנפגעי/ות תקיפה מינית. 92% מהמטופלות הן נשים. המרכז פועל 24 שעות ביממה ומסייע לפונות המגיעות עד שבוע מיום הפגיעה וזקוקות לטיפול ראשוני, נפשי ופיזי, תוך שיתוף פעולה עם גורמי המשטרה והמשפט. המרכז פועל באחריות ובמימון משרד הבריאות.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'YH137',
    'is_active': true,
    'keywords': [
      'טראומה',
      'אונס',
      'מחלות מין',
      'הריון',
      'בית חולים',
      'משפט'
    ],
    'name': 'חדר 4 - מרכז אקוטי לטיפול בנפגעות תקיפה מינית בוולפסון',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חולון',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-08-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.wolfson.org.il/?CategoryID=402&ArticleID=890'
      },
      {
        'title': 'אברמוב, אתי (2012, 18 מאי). מאחורי הדלת של חדר 4 בוולפסון. <b>ידיעות אחרונות – המוסף לשבת</b>.נדלה מתוך',
        'url': 'http://www.wolfson.org.il/?CategoryID=917&ArticleID=1671'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/08/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '13/10/2018'
    },
    'description': '״חוש״ן״ הוקם ב - 2004 כחברה לתועלת הציבור (חל״צ) ועוסק בפעילות חינוך והסברה למען קהילת הלהט״ב בכל רחבי הארץ. הפעילות העיקרית של הארגון היא העברת הרצאות וסדנאות בבתי ספר, כאשר רוב ההרצאות מבוססות על הסיפור האישי של המרצות, העובדות לרוב בצוות מעורב מגדרית. מרבית הפעילות בארגון נעשית על ידי מתנדבות, אולם ישנם גם בעלי תפקידים בתשלום, המרכזים את תחומי הפעילות השונים, והחל מ - 2017 מחזיק הארגון גם צוות מרצים בתשלום, המחויבים לכמות גדולה יותר של הרצאות בשנה. בנוסף להרצאות לתלמידים בבתי הספר, חוש״ן מעביר גם הרצאות לאנשי ונשות חינוך, לגופים אזרחיים וציבוריים, ולמשטרה. עד השנה האחרונה העביר הארגון פעילויות גם לצה״ל, אולם חייל חינוך החליט לסיים את שיתוף הפעולה עם הארגון.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'חינוך והשכלה'
      ],
      [
        'נערות וצעירות',
        'להט״ב'
      ],
      [
        'חינוך',
        'להט״ב'
      ]
    ],
    'id': 'LR4',
    'is_active': true,
    'keywords': [
      'חינוך',
      'חינוך מגדרי',
      'להט״בופוביה',
      'הסברה',
      'מגוון',
      'זכויות',
      'זהות מגדרית',
      'הרצאות',
      'צה״ל',
      'נערות',
      'חל״צ'
    ],
    'name': 'חוש״ן - חינוך ושינוי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'חינוך והשכלה',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-10-13'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.hoshen.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>חוש״ן – חינוך ושינוי, חברה לתועלת הציבור בע״מ (חל״צ): חל״צ</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/513544494'
      },
      {
        'title': 'חוש״ן, עמוד פייסבוק.',
        'url': 'https://he-il.facebook.com/hoshen.il'
      },
      {
        'title': 'ידיד, נטע, רימון, יעל וצימרמן, שוש (2011). מדיניות משרד החינוך בנושא הלהט״בי: בין ״קלפים פתוחים״ לבין חוזר מנכ״ל כנגד הומופוביה. <b>מפגש לעבודה חינוכית-סוציאלית, 33</b>, 211–221.'
      },
      {
        'title': 'ינקו, אדיר (2018, 7 יוני). בלי מאבקי הקהילה וייצוג מועט בספרות: הלהט״בים נעדרים מתכני הלימוד בישראל. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-5278513,00.html'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2004,
    'year_registered': 2004
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '19/10/2018'
    },
    'description': '״חזון נשות עכו״ הוקמה בשנת 2004 על ידי קבוצת נשים ערביות ויהודיות מעכו בהובלת ד״ר ג\'אנן פראג\'-פלאח, מרצה בכירה לספרות עברית ומגדר במכללה הערבית לחינוך בחיפה. הקבוצה נרשמה בשנת 2008 כעמותה (ע״ר 580490670) שמטרותיה הן: ״ קידום מעמד האשה, חיזוק הקשר הבין עדתי למען שלום אמת. טיפוח וחיזוק הדו-קיום בין הערבים ליהודים בעיר עכו.״ פעילות העמותה משתרעת על פני העיר כולה, העתיקה והחדשה כאחד ומכוונת לצעירות ולמבוגרות, למשכילות וללא משכילות. העמותה חנכה ב-2014 את ״בית אישה לשלום״ בעיר - מרכז תרבות, מחקר וגלריה ומקיימת בה מפגשים עם נשים פלסטיניות ונשים מרחבי העולם לקידום נושאי השלום ומעמד האישה.',
    'description_ar': 'أقيمت ״رؤيا نساء عكا״ في عام 2000 بواسطة مجموعة نساء عربيات ويهوديات من عكا بقيادة د. جنان فرج- فلاح، محاضرة في الأدب العبري والجندر في الكلية العربية للتربية في حيفا. المجموعة سجلت عام 2008 كجمعية (ج.م 580490670). أهدافها هن:  ״ تطوير مكانة المرأة، تقوية العلاقة بين الطوائف من اجل سلام حقيقي. التطوير وتعزيز التعايش بين العرب واليهود في مدينة عكا״.    تنتشر اعمال هذه الجمعية في جميع انحاء المدينة، الجديدة والقديمة في آن واحد. وتتوجه للشابات والكبيرات، للمتعلمات والغير متعلمات. في عام 2014، افتتحت الجمعية ״بيت امرأة السلام״ في المدينة - وهو مركز ثقافي، أبحاث ومعرض. وعقدت اجتماعات مع النساء والفتيات الفلسطينيات من جميع أنحاء العالم لتعزيز قضايا السلام ومكانة المرأة.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'שלום'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ]
    ],
    'id': 'YH109',
    'is_active': true,
    'keywords': [
      'דו קיום',
      'פלסטיניות',
      'השכלה',
      'תרבות',
      'גלריה'
    ],
    'name': 'חזון נשות עכו',
    'name_ar': 'جمعية رؤيا نساء عكا',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'עכו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>חזון נשות עכו (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580490670'
      },
      {
        'title': 'פראג\'-פלאח, ג\'אנן (2013). השפעת עמותות וקבוצות של נשים ערביות ויהודיות על מהלכים שונים של חיים משותפים בתוך העיר עכו. קרן פרידריך אברט בשיתוף המרכז היהודי-ערבי, אוניברסיטת חיפה. נדלה מתוך',
        'url': 'http://s3-eu-central-1.amazonaws.com/fes-org-il-wp/he/wp-content/uploads/2016/11/22140906/Impact-of-mixed-Arab-and-Jewish-groups-of-Women-on-Co-existence-in-Acre-Hebrew.pdf'
      },
      {
        'title': 'Faraj Falah, Janan (2017). Women can do it: The role of Akko Women Vision Association (Awva) on Bringing the two nations (Arabs and Jews) together. <b>International Journal of Non-Governmental Organizations (NGOs) and Essays, 2</b> (1) 1-10. Retrieved from',
        'url': 'http://www.eajournals.org/wp-content/uploads/Women-can-do-it-The-Role-of-Akko-Women-vision-association-AWVA-on-bringing-the-two-nations-Arabs-and-Jews-together.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '19/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2004,
    'year_registered': 2008
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות',
      'אקטיביזם רשת'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '01/06/2019'
    },
    'description': '״חיבוק בשקט״ הוקמה כקבוצת תמיכה בשנת 2014 על ידי נועה פארן, רות אופק, שירי ברלוט ושרון מזרחי, ארבע נשים שעברו לידות שקטות, במטרה לסייע ולתמוך בנשים שעברו לידה שקטה ולהעלות מודעות לנושא מבחינה ציבורית וחוקית. בשנת 2016 הקבוצה נרשמה כעמותה (ע״ר 580625515) שפועלת בעיקר באזור המרכז. פעילות העמותה כוללת קבוצת תמיכה בפייסבוק בה חברות כ-2000 נשים ומפגשי תמיכה חודשיים. בנוסף, מפעילה העמותה גם עמוד פייסבוק להפצת מידע בנושא לידה שקטה ומעורבת בקידום זכויות ומדיניות. העמותה הייתה מעורבת בהעברת חוק חופשת הלידה לנשים שאיבדו את עובריהן החל משבוע 22, שנכנס לתוקף בשנת 2016, וגם פעלה לשינוי מדיניות בתי החולים ביחס לקבורת תינוקות לאחר הלידה, כך שלהורים תנתן אפשרות להכריע בנוגע לאופן הקבורה. פעילות העמותה מתמקדת כעת בקידום נהלים לטיפול בלידות שקטות ולתמיכה ביולדת בבתי החולים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ]
    ],
    'id': 'LR44',
    'is_active': true,
    'keywords': [
      'תמיכה נפשית',
      'קבוצות תמיכה',
      'לידה',
      'לידה שקטה',
      'חופשת לידה',
      'חקיקה'
    ],
    'name': 'חיבוק בשקט',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר סבא',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>חיבוק בשקט (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580625515'
      },
      {
        'title': 'ברבי-ג\'קמן, הילה (2018, 18 דצמבר). למה תינוק שנרצח בפיגוע זכאי לשם ולקבורה, ותינוק אחר שמת בלידה לא? <b>המקום הכי חם בגיהינום</b>. נדלה מתוך',
        'url': 'https://www.ha-makom.co.il/post/hilla-silent-hug'
      },
      {
        'title': 'חיבוק בשקט - הדף הרשמי תמיכה לנשים לאחר לידה שקטה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/hibukbasheket'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '01/06/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': 2016
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/12/2018'
    },
    'description': 'חיל נשים (ח״ן) היה חיל צה״לי שנוסד עם הקמת צה״ל בשנת 1948 והתקיים עד שנת 2001. תחום אחריותו היה שיבוץ והכשרה של חיילות בשירות חובה. החיל הוקם בתחילה כדי לאגד בתוכו את חברות ההגנה ונשים שגויסו וכונה בתחילה ״חיל עזר לנשים״ בדומה לכינוי של החיל בצבא-היבשה הבריטי. בהקמתו שולב הניסיון של המתנדבות לצבא הבריטי עם מורשת החברות בהגנה, אשר מראשיתה שיתפה נשים ביחידותיה בכל תפקידי המגן. הח״ן הוכפף לאכ״א בדומה למתכונת הארגונית שנקבעה לפי הדגם הבריטי, על פיו הנשים משרתות בגדודי נשים, ומסופחות ליחידות ולמתקנים למילוי תפקידיהן. תוך המלחמה נקבעו דפוסי החיל, דרכי הטיפול בחיילות ומעמדן, שהיו אחר-כך ליסודות הח״ן בצה״ל. קצינת הח״ן הארצית הראשונה היתה מינה רוגוז\'יק-בן-צבי. מאוחר יותר התפתחו תפקידי מערך הח״ן כללו קליטת חיילות, אימונן בהכשרה או טירונות בבסיסי טירוניות, ושיבוצן ביחידות צה״ל השונות. במהלך שירותן היה החיל אחראי על שירותים שונים לחיילות על ידי יחידות ח״ן שפעלו ביחידות. הח״ן גם הפעיל בנות כמורות-חיילות באזורי פיתוח ושכונות עולים בישראל. מאמצע שנות ה-90 החל הח״ן בהדרגה להעביר את סמכויותיו למפקדי היחידות ויחידת המורות החיילות הועברה אל חיל החינוך. בשנת 2001 הורה הרמטכ״ל רב-אלוף שאול מופז על ביטול הח״ן. כתוצאה מכך פורקה מפקדת קצינת חיל נשים ראשית (מקחנ״ר), והוקם גוף יועצת הרמטכ״ל לענייני נשים (יוהל״ן; ומאז פברואר 2016 - יוהל״ם). תפקידיו העיקריים של גוף זה כיום סובבים סביב שמירת זכויות החיילות, קידומן לתפקידים שונים, מתן ייעוץ וכיוצא באלה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'צבא, ביטחון ומדיניות חוץ',
        'קידום נשים ושוויון מגדרי'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'SA104',
    'is_active': false,
    'keywords': [
      'צבא',
      'שוויון',
      'צעירות'
    ],
    'name': 'חיל נשים (ח״ן)',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'צבא, ביטחון ומדיניות חוץ',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים ושוויון מגדרי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'עפרון, יונית (2000). אחיות, לוחמות ואמהות: אתוס ומציאות במבחן בנות דור 1948. <b>עיונים בתקומת ישראל, 10</b>, 353–380.'
      },
      {
        'title': 'Shalvi, Alice (2009, February 27). CHEN: Women\'s Corps of the Israel Defense Forces. In <b>Jewish women: A comprehensive historical encyclopedia</b>. Jewish women\'s archive. Retrieved from',
        'url': 'https://jwa.org/encyclopedia/article/chen-womens-corps-of-israel-defense-forces'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/12/2018'
    },
    'year_closed': 2001,
    'year_closed_text': '2001',
    'year_founded': null,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '03/11/2020'
    },
    'description': 'התחנות לבריאות המשפחה (התחנות לאם ולילד) המוכרות בשם ״טיפת חלב״ התפתחו בירושלים כשיתוף פעולה בין ״הסתדרות נשים עבריות״ לבין נשים שהגיעו לארץ ישראל כחלק ממשלחת רפואית של ״הדסה״ לאחר מלחמת העולם הראשונה. השם ״טיפת חלב״ מבוסס על תרגום מצרפתית- La Goutte de Lait כשמו של ארגון שהוקם בפריס במטרה להעביר חלב סטרילי לאמהות. התחנה הראשונה הוקמה בעיר העתיקה בשנת 1921 על ידי ברטה לנדסמן ולאור הצלחתה, הוחלט להרחיב את המודל למקומות נוספים ביחד עם קופות החולים. לאחר קום המדינה, העבירה הדסה את התחנות שבניהולה להפעלת משרד הבריאות. בשנת 1957 הפעילה קופת החולים הכללית 198 תחנות לאם ולילד ו-323 מרפאות כפר שגם בהן ניתנו שירותי ״טיפת חלב״ בפיקוח משרד הבריאות. ברבות השנים, השירות גדל והתפתח לכדי שירות קהילתי אוניברסלי המתמקד בנשים הרות, אמהות טריות ופעוטות שנועד לצמצם פערים בתחום הבריאות באמצעות פעולות מניעה ויצירת סביבה בריאה ותומכת עבור המשפחה. צוות הבריאות בתחנות כולל אחיות ורופאים, בעלי הכשרה מיוחדת בבריאות הציבור. בתחנות ״טיפת חלב״ ניתנים חיסונים כנגד מחלות בקנה מידה רחב (לכ-96% מכלל האוכלוסייה) בדומה למדינות מפותחות ומעקבי התפתחות שגרתיים לתינוקות ואמהות. השירות נחשב לאחד הטובים בעולם וזכה לפרסים מטעם ארגון הבריאות העולמי. בשנים שלאחר חקיקת ״חוק ביטוח בריאות ממלכתי״ (1994) היו אמורות התחנות לעבור להפעלה על ידי קופות החולים, מהלך אשר נתקל בהתנגדויות רבות עקב חשש מהפרטת השירות וירידה באיכותו. משנת 2007 הנהיג משרד הבריאות מדיניות של צמצום מספר התחנות לבריאות המשפחה תוך ריכוז השירות לתחנות גדולות וסגירת תחנות קטנות. בשנת 2018, ניתנים שירותי טיפת חלב בכ-1030 תחנות באופן משולב על ידי משרד הבריאות, קופות החולים ורשויות מקומיות.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ]
    ],
    'id': 'SA187',
    'is_active': true,
    'keywords': [
      'הריון',
      'גיל רך',
      'אמהות',
      'לידה'
    ],
    'name': 'התחנות לבריאות המשפחה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'טיפת חלב',
    'name_past': 'התחנות לאם ולילד',
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2020-03-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.health.gov.il/Subjects/pregnancy/health_centers/Pages/family_health_centers.aspx'
      },
      {
        'title': 'וייס, דורית (2019). ״תחנות ״טיפת חלב״ בישראל: מבט היסטורי‏״, <b>הרפואה, 158</b>(12), 826–833.'
      },
      {
        'title': 'משרד הבריאות (אתר). <b>רשימת טיפות חלב וזימון תורים</b>. נדלה מתוך',
        'url': 'https://www.health.gov.il/Subjects/pregnancy/health_centers/Pages/Vaccination_centers.aspx'
      },
      {
        'title': 'שורץ, שפרה (1998). הסתדרויות נשים למען אימהות בארץ-ישראל: פעילותן של ״הדסה״, ״הסתדרות נשים עבריות״ ו״ויצ״ו״ להקמת תחנות אם וילד בארץ-ישראל בשנים 1918–1948. <b>ביטחון סוציאלי 51</b>, 57–81.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/03/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '16/01/2020'
    },
    'description': '״יד לאדם״ הוקמה בשנת 1989 על ידי ד״ר עדינה תמיר ונשרשמה כעמותה (ע״ר 580174605) ב-1990. העמותה הוקמה במטרה לסייע ולתמוך בילדי ובנשות אסירים. העמותה הפעילה מועדונים בירושלים, תל אביב, חיפה ובאר שבע בהם התקיימו פעילויות חינוכיות, שיעורי העשרה, פעילויות חברתיות וכן הפעילה משחקיות טיפוליות בבתי הכלא. בנוסף, היתה העמותה מעורבת בקידום חקיקה לשינוי מעמד נשות אסירים כך שיוכרו כחד הוריות לצורך קבלת סיוע והטבות מהמוסד לביטוח לאומי. בקשה לפירוק העמותה הוגשה ב-2011.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ]
    ],
    'id': 'YH208',
    'is_active': false,
    'keywords': [
      'תמיכה נפשית',
      'סיוע לאמהות',
      'אסירים',
      'העצמה'
    ],
    'name': 'יד לאדם',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'התמכרויות ושיקום',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2020-01-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט כפי שנוטר ב-Internet Archive ב-8.8.2007',
        'url': 'https://web.archive.org/web/20070808115816/http://www.yadladam.org.il/default.asp?pageid=1'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>יד-לאדם סיוע ותמיכה לילדי אסירים ונשותיהם (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580174605'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (1999, 13 ינואר). <b>פרוטוקול מס\' 185: מליאה - ישיבת עבודת עם מועצת ארגוני הנשים</b>. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/14/Committees/14_ptv_478730.PDF'
      },
      {
        'title': 'ילדי אסירים. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%99%D7%9C%D7%93%D7%99_%D7%90%D7%A1%D7%99%D7%A8%D7%99%D7%9D'
      },
      {
        'title': 'משרד המשפטים, היחידה הממשלתית לחופש המידע (2020, 16 ינואר). <b>בקשות לפירוק עמותות בין השנים 2010–2015</b>.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '16/01/2020'
    },
    'year_closed': 2011,
    'year_closed_text': '2011',
    'year_founded': 1989,
    'year_registered': 1990
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '28/05/2018'
    },
    'description': 'ארגון ״יד לאישה״ הוקם בשנת 1997 כהמשך ל-״מכון להכשרת טוענות בית דין״ של רשת ״אור תורה סטון״ על מנת להשמיש הכשרה זו לסיוע נשים מסורבות גט. בשנת 2003 הארגון נרשם כעמותה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ]
    ],
    'id': 'SW9',
    'is_active': true,
    'keywords': [
      'הלכה',
      'חקיקה',
      'עגינות',
      'סרבנות גט',
      'גירושין',
      'טוענות רבניות'
    ],
    'name': 'יד לאישה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.yadlaisha.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>יד לאשה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580412864'
      },
      {
        'title': 'יד לאישה, עזרה למסורבות גט ועגונות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/YadLaishaOrg'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '14/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1997,
    'year_registered': 2003
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': 'לאחר בג״ץ אליס מילר (1995) ובעקבות תיקון חוק שירות הביטחון בשנת 2000 והוספת סעיף 16א\' הקובע כי ״דין אישה כדין גבר״ התאפשר לחיילות לשרת שירות צבאי במגוון תפקידים. על מנת ליישם את הוראות החוק, בשנת 2001 נסגר חיל הנשים (ח״ן) ובמקומו הוקמה יחידה בשם ״יועצת הרמטכ״ל לענייני נשים״. בשנת 2016 שונה שם היחידה ל״יועצת הרמטכ״ל לענייני המגדר״, מהות השינוי היא מעבר לגוף שתכליתו קידום שוויון הזדמנויות מגדרי מהותי. מטה היוהל״ם פועל לצמצום אי השוויון המגדרי בצה״ל, לשילוב מתמשך של חיילות בתפקידים מגוונים, לניטור ומעקב אחר אלימות מינית בצה״ל ולמחקר בתחומים אלו. בשנת 2012 הוקם בתוך היוהל״ן מרכז מהו״ת- מרכז התמודדות ותמיכה שייעודו להעניק טיפול רגשי, סיוע רפואי וליווי משפטי לחיילות ולחיילים בתחומי פגיעה מינית, הריון לא מתוכנן ואלימות במשפחה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'צבא, ביטחון ומדיניות חוץ',
        'קידום נשים ושוויון מגדרי'
      ],
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ]
    ],
    'id': '1YB14',
    'is_active': true,
    'keywords': [
      'צבא',
      'שוויון מגדרי',
      'שוויון בארגונים',
      'הטרדה מינית',
      'ממונה על מניעת הטרדה מינית',
      'קידום נשים',
      'שוויון הזדמנויות',
      'צעירות',
      'מחקר',
      'נתונים'
    ],
    'name': 'יוהל״ם - יועצת הרמטכ״ל לענייני מגדר',
    'name_ar': null,
    'name_change_year': 2016,
    'name_common': null,
    'name_past': 'יוהל״ן - יועצת הרמטכ״ל לענייני נשים',
    'name_replaced_by': 'ח״ן- חיל נשים',
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'צבא, ביטחון ומדיניות חוץ',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים ושוויון מגדרי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.idf.il/%D7%90%D7%AA%D7%A8%D7%99%D7%9D/%D7%99%D7%95%D7%94%D7%9C%D7%9D/'
      },
      {
        'title': 'עמרם-כץ, שרית (2018). בין הקפה לרובה: מודלים של שירות נשים בצה״ל. בתוך: לומסקי-פדר, עדנה וששון-לוי, אורנה (עורכות), <b>מגדר בבסיס: נשים וגברים בשירות הצבאי</b> (עמ\' 52–78). ירושלים: ון ליר'
      },
      {
        'title': 'שרביט ברוך, פנינה, הבר, כרמית (2013). <b>שירות נשים בצה״ל: המשך התקדמות או נסיגה לאחור?</b> ירושלים ותל אביב: המכון הישראלי לדמוקרטיה והמכון למחקרי ביטחון לאומי. נדלה מתוך',
        'url': 'https://www.inss.org.il/he/publication/%D7%A9%D7%99%D7%A8%D7%95%D7%AA-%D7%A0%D7%A9%D7%99%D7%9D-%D7%91%D7%A6%D7%94%D7%9C-%D7%94%D7%9E%D7%A9%D7%9A-%D7%94%D7%AA%D7%A7%D7%93%D7%9E%D7%95%D7%AA-%D7%90%D7%95-%D7%A0%D7%A1%D7%99%D7%92%D7%94/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '23/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2001,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '19/12/2018'
    },
    'description': 'העמותה ״יוזמת עתיד״ הוקמה בשנת 2015 בשם ״לתת עתיד- פיתוח יזמות עסקית זעירה מיסודו של ארגון לתת״ ושינתה את שמה ל״יוזמות עתיד״ בשנת 2017. מטרות העמותה היא ״לפעול לצמצום העוני באמצעות חילוץ אוכלוסיות מוחלשות מהעוני על ידי השגת עצמאות כלכלית. לפתח וליישם מודלים של פיתוח יזמות עסקית זעירה, מיקרו מימון. להעניק הלוואות, הכשרות, ליווי אישי, מעטפת תמיכה, סיוע, הענקת כלים, שינוי מדיניות. לפתח ולהקים עסקים זעירים או לקדם אוכלוסייה לתעסוקה, עצמאות כלכלית וחילוץ מעוני של אוכלוסיות מוחלשות בישראל. לפעול ברוח ערכי ארגון לתת ולסייע לאוכלוסיות במצוקה על בסיס אוניברסלי ולחתור להניע את החברה האזרחית לערבות הדדית, נתינה והתנדבות. לפעול באופן שוויוני, ללא הבדל דת, גזע, מין, גיל, תרבות, לאום או גבולות גיאוגרפיים.״ מאז הקמתה מפעילה העמותה קבוצות להכשרה שיווקית ועסקית לנשים יזמיות מאזור באר שבע, ירושלים, תל אביב וחיפה בשיתוף המשרד לפיתוח הנגב והגליל.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ]
    ],
    'id': 'SA102',
    'is_active': true,
    'keywords': [
      'העצמה',
      'מימון זעיר',
      'נשות עסקים',
      'סיוע כלכלי',
      'עוני'
    ],
    'name': 'יוזמות עתיד',
    'name_ar': null,
    'name_change_year': 2017,
    'name_common': null,
    'name_past': 'לתת עתיד- פיתוח יזמות עסקית זעירה מיסודו של ארגון לתת',
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-12-19'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://yozmotatid.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>יוזמות עתיד (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580602258'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '25/07/2018'
    },
    'description': 'בשנת 1988 התקבלה החלטה של ועד ראשי האוניברסיטאות (ור״ה) למנות יועצות לנשיאי האוניברסיטאות לקידום נשים באקדמיה. ההחלטה התקבלה בעקבות פניה של שדולת הנשים. שבע יועצות מונו בכל אחת מהאוניברסיטאות. עם פרישתן לא מונו יועצות חדשות. בשנים 2000-2003, במסגרת פעילות משותפת של הפורום לקידום נשים במדע ובאקדמיה בראשות פרופ\' נינה תורן עם ועדת המדע והטכנולוגיה והוועדה למעמד האישה בכנסת הוצע למסד את תפקיד היועצות. לקראת סוף שנת 2002 יזמה ח״כ דאז ענת מאור פנייה משותפת לור״ה ביחד עם יושבת ראש המועצה לקידום נשים למדע וטכנולוגיה, פרופ\' חגית מסר ירון והרשות לקידום מעמד האישה בתביעה לאשרר את ההחלטה משנת 1988 ולמנות יועצות בכל אחת מהאוניברסיטאות. בחודש אוקטובר 2002 נפגשו חברי ור״ה עם חברת הכנסת ענת מאור, פרופ\' חגית מסר ירון ונציגות נוספות מהמועצה לקידום נשים במדע וטכנולוגיה וראשי האוניברסיטאות אימצו מחדש את ההחלטה למנות יועצות לקידום מעמד האישה באוניברסיטאות. מסוף שנת 2003 מאויש תפקיד יועצת הנשיא לענייני נשים בכל אוניברסיטאות המחקר וכן בחלק מהמכללות האקדמיות, המכללות למורים והמכללות הטכנולוגיות. בשנת 2011 פורסמו המלצות צוות כרמי שעסק במצב הנשים בסגל האקדמי במוסדות להשכלה גבוהה והן אומצו בשנת 2013 על ידי ות״ת ומל״ג. עיקר ההמלצות הצוות נגעו להגדרת תפקידן של היועצות למעמד האישה. בשנת 2015 פורסמו המלצות ועדת ארנון, ועדת ההיגוי המשותפת הקבועה למועצה להשכלה גבוהה (מל״ג) ולות״ת, אשר כוללות בין היתר מיסוד והעמקה של תפקיד היועצת.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'קידום נשים במדע'
      ],
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ],
      [
        'חינוך',
        'מדע וטכנולוגיה'
      ]
    ],
    'id': 'YH62',
    'is_active': true,
    'keywords': [
      'מחקר',
      'תעסוקה',
      'קידום נשים',
      'מדע',
      'אפליה'
    ],
    'name': 'יועצות הנשיא/ רקטור לקידום נשים באקדמיה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'אקדמי',
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'קידום נשים במדע',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'המועצה להשכלה גבוהה (2011, 18, מאי). <b>דוח והמלצות הצוות לבחינת מצבן של נשים בסגל האקדמי במוסדות להשכלה גבוהה</b>. נדלה מתוך',
        'url': 'https://che.org.il/wp-content/uploads/2013/08/%d7%a6%d7%95%d7%95%d7%aa-%d7%a7%d7%99%d7%93%d7%95%d7%9d-%d7%a0%d7%a9%d7%99%d7%9d-%d7%93%d7%95%d7%97-%d7%9e%d7%a1%d7%9b%d7%9d-.pdf'
      },
      {
        'title': 'מסר-ירון, חגית, מאור, ענת וכהנוביץ, שירלי (2004). קידום הנשים במדע ובסגל האקדמי בישראל. בתוך: מאור, ענת (עורכת), <b>העדפה מתקנת והבטחת ייצוג בישראל</b> (עמ\' 331–350). תל אביב: רמות. נדלה מתוך',
        'url': 'http://www.kotar.co.il/KotarApp/Viewer.aspx?nBookID=92677230#4.8381.6.default'
      },
      {
        'title': 'משרד המדע, הטכנולוגיה והחלל, המועצה לקידום נשים במדע ובטכנולוגיה והמועצה להשכלה גבוהה (2015, יולי). <b>דוח הוועדה לקידום וייצוג נשים במוסדות להשכלה גבוהה</b> (ועדת ארנון). ירושלים. נדלה מתוך',
        'url': 'https://che.org.il/wp-content/uploads/2015/07/%d7%93%d7%95%d7%97-%d7%99%d7%99%d7%a6%d7%95%d7%92-%d7%a0%d7%a9%d7%99%d7%9d.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '25/07/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1988,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '20/05/2018'
    },
    'description': 'ביוני 1987 נערך בהרצליה כנס בנושא ״נשים בשלטון המקומי״ ביוזמת יעל רום משדולת הנשים והמרכז לשלטון מקומי במטרה להעלות מודעות להשתלבות של נשים בפוליטיקה מוניציפלית. בשנת 1994 לאחר פעילות מאומצת ותמיכה של יועצת ראש הממשלה למעמד האשה, מונתה ״יועצת לקידום מעמד האשה״ במרכז לשלטון המקומי שהחלה לפעול כדי להקים מועצות לקידום נשים ברשויות המקומיות. תהליך זה הוביל בין היתר גם לחקיקת חוק היועצות לקידום מעמד האשה ברשויות המקומיות (2000). בחוק שתוקן בשנת 2008, נקבעה חובת מינוי יועצת לקידום מעמד האישה ברשויות המקומיות. לפי החוק, תפקידיה של היועצת לקידום מעמד האישה הם לפעול בתחומי הרשות המקומית לקידום מעמד האישה והשוויון בין המינים, לביעור ההפליה נגד נשים ולמניעת אלימות נגד נשים. החוק מסדיר היבטים שונים הנוגעים לפעילות היועצות, לרבות דרך מינוין, תנאי עבודתן, הכשרתן, תפקידיהן ומעמדן ברשות שבה הן מכהנות. רוב היועצות ממלאות את תפקידן נוסף על תפקיד אחר ברשות המקומית, לעיתים בהיקף שאינו מוגדר בצורה ברורה. תקציב הפעילות של היועצות משתנה ממקום למקום וכך גם אופי הפעילויות שהן יוזמות. חלק מהיועצות מתמקדות בקיום פעילויות תרבות ופנאי לנשים, ואחרות עוסקות גם בפעילויות הקשורות לליבת התפקיד, כמו הטמעת חשיבה מגדרית ובחינה מגדרית של תקציב הרשויות. בשנת 2008 הוקם ״איגוד היועצות לקידום מעמד האשה בישראל״ שפועל על מנת לארגן ולאגד את היועצות ולקדם את ההכרה בהן כגוף סטטוטורי. דו״ח של מרכז המחקר והמידע של הכנסת מצא כי בשנת 2018 רוב הרשויות המקומיות מינו יועצת לקידום מעמד האישה, אולם ״יש פערים בין נתוני הרשות לקידום מעמד האישה לבין נתוני משרד הפנים על מספר היועצות המעודכן: לפי הרשות לקידום מעמד האישה יש יועצות ב-253 רשויות מקומיות (מתוך 257 רשויות), ואילו לפי משרד הפנים יש יועצות ב-199 רשויות מקומיות, וב-58 רשויות אין יועצת או לא נמסר מהרשות מידע בעניין זה. לפי משרד הפנים, 172 יועצות מונו באמצעות מכרז.״',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף מוניציפלי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ]
    ],
    'id': 'YH3',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'ייצוג הולם',
      'מנהיגות'
    ],
    'name': 'יועצות למעמד האישה ברשויות המקומיות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'ממשלתי',
      'מוניציפלי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'שוויון בין המינים/שוויון מגדרי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'אליהו, אילה (2019). <b>היועצות לקידום מעמד האישה ברשויות המקומיות</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/5f1f2c38-ab11-e911-80e1-00155d0a98a9/2_5f1f2c38-ab11-e911-80e1-00155d0a98a9_11_10876.pdf'
      },
      {
        'title': 'אלמגור־לוטן, אורלי (2012). <b>יועצות למעמד האישה ברשויות המקומיות</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/074e6b58-e9f7-e411-80c8-00155d010977/2_074e6b58-e9f7-e411-80c8-00155d010977_11_6746.pdf'
      },
      {
        'title': 'הכנסת (2008, 10 יולי). <b>חוק הרשויות המקומיות (יועצת לענייני מעמד האישה) (תיקון), התשס״ח-2008</b>.  נדלה מתוך מאגר החקיקה הלאומי',
        'url': 'https://fs.knesset.gov.il/17/law/17_lsr_300629.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '22/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '06/03/2018'
    },
    'description': 'דו״ח מבקר המדינה לשנת 2012 הצביע על ייצוג נמוך לנשים בתפקידים בכירים במשטרה ועל חוסר ייצוג בדרגים מסוימים. בעקבות פרסום הדו״ח הקים המפכ״ל דאז, יוחנן דנינו ועדה שהמליצה על מיניוי יועצת לענייני נשים בכפיפות ישירה למנכ״ל וכחברת סג הפיקוד הבכיר בממשלה. ביולי 2013 מונתה לראשונה היועצת - תנ״צ יעל אידלמן. תפקיד היועצת הוגדר כ״יצירת תנאים למיצוי היכולות ושוויון הזדמנויות של נשים המשרתות במשטרה״ וכן - עיצוב סביבה ארגונית חדשה בארגון - בטוחה והוגנת לכל. ליוהל״ן כפופות רמ״ד קידום שוויון הזדמנויות ורמ״ד למניעת הטרדות מיניות שתחתיה 256 ממונות להטרדה מינית הפועלות בכל יחידות המשטרה. נכון ל-2019 ממלאה את התפקיד תנ״צ יפעת שקלר.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'צבא, ביטחון ומדיניות חוץ',
        'קידום נשים ושוויון מגדרי'
      ],
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ]
    ],
    'id': 'YH14',
    'is_active': true,
    'keywords': [
      'שוויון מגדרי',
      'שוויון בארגונים',
      'הטרדה מינית',
      'ממונה על מניעת הטרדה מינית',
      'קידום נשים',
      'משטרה',
      'שוויון הזדמנויות',
      'תנאי עבודה'
    ],
    'name': 'יועצת המפכ״ל לענייני נשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'צבא, ביטחון ומדיניות חוץ',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים ושוויון מגדרי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הוועדה לקידום מעמד האישה (2017, 13 יוני). <b>פרוטוקול מס\' 172: דיווח מח״ש והמשטרה על מניעה וטיפול בהטרדות מיניות</b>. נדלה מתוך',
        'url': 'https://committees-next.oknesset.org/meetings/2/0/2017370.html'
      },
      {
        'title': 'פיוטרקובסקי, שלמה (2013, 7 יולי). לראשונה במשטרה: יועצת לענייני נשים. <b>ערוץ 7</b>.',
        'url': 'https://www.inn.co.il/News/News.aspx/258752'
      },
      {
        'title': 'שקלר, יפעת (2019, 5 מרץ). <b>יחידת היוהל״ן במשטרת ישראל</b>. הרצאה בכנס פמיניזם ומדינה בישראל: 40 שנה לדו״ח נמיר (1978–2018). אוניברסיטת בן-גוריון בנגב.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '29/10/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '13/06/2018'
    },
    'description': 'מערך היוהל״ן בשב״ס הוקם בשנת 2014 על ידי סג״ד אודליה אדרי שגם היתה הראשונה למלא את התפקיד. יוהל״ן שב״ס עוסקת בין היתר בקידום נשים בארגון כמו גם בנושא ההטרדות המיניות.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'צבא, ביטחון ומדיניות חוץ',
        'קידום נשים ושוויון מגדרי'
      ],
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ]
    ],
    'id': 'YH18',
    'is_active': true,
    'keywords': [
      'שוויון מגדרי',
      'שוויון בארגונים',
      'הטרדה מינית',
      'קידום נשים',
      'שוויון הזדמנויות',
      'תנאי עבודה'
    ],
    'name': 'יועצת הנציבה לענייני נשים (שירות בתי הסוהר)',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמלה',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'צבא, ביטחון ומדיניות חוץ',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים ושוויון מגדרי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הוועדה לענייני ביקורת המדינה (2018, 11 יוני). <b>פרוטוקול מס\' 339: הטרדות מיניות בשירות בתי הסוהר ובבתי הכלא: תמונת מצב: דו״ח מבקר המדינה על יישום החוק למניעת הטרדה מינית – דיווח לפי סעיף 6א</b>. נדלה מתוך',
        'url': 'https://oknesset.org/meetings/2/0/2071714.html'
      },
      {
        'title': 'חסון, יעל (2018, 7 יוני). <b>שאלה</b> [התכתבות עם אודליה אדרי, מקימת היוהל״ן בשב״ס והראשונה למלא את התפקיד].'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/05/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '22/04/2018'
    },
    'description': 'תפקיד יועצת ראש הממשלה למעמד האשה נוצר כדי ליישם את ההמלצה הראשונה של הועדה למעמד האשה (ועדת נמיר) אשר הגישה את הדוח הסופי בשנת 1978. לשון המלצה 1: ״תוקם רשות ממלכתית לטיפול ומעקב בנושא מעמד האשה. א) הרשות לטיפול ומעקב בנושא מעמד האשה תפעל בחסות משרד ראש הממשלה; ב) הרשות תפעל למימוש המלצות הועדה ותעקוב אחר ביצוען.״ תפקידיה המקוריים של היועצת כללו גיבוש מדיניות ממשלתית לגבי קידום מעמד האשה בישראל, מעקב ופיקוח אחר ביצוע ההמלצות תוך תיאום בין הגורמים האחראים לביצוען, טיפוח תודעה ציבורית בקרב כלל האוכלוסיה ובקרב קובעי מדיניות לבעיות הקשורות במעמד האשה בישראל, עדכון מידע על מצבן של נשים, בדיקת עדיפויות תקציביות ועוד. בתפקיד נשאו פרופ\' רבקה בר-יוסף (1979-1978), ד״ר ניצה שפירא-ליבאי (1988-1980), עו״ד אתיה שמחה (1992-1988), נאוה ארד (1996-1993), סווטלנה אלכסנדרוב (1996) ואמונה אלון (1997-1996). בשנים 1984-1983, חברת הממשלה שרה דורון שכיהנה כשרה ללא תיק הופקדה בפועל על תחום קידום נשים.\nהיועצות לקידום מעמד האשה היו אחראיות על קידום חוקים שנחקקו בתקופה זו, ריכזו את הפעילות הרשמית של מדינת ישראל בכל הנוגע לכינוסים הבינלאומיים של האו״ם לענייני נשים בשנת 1980, 1985 ו-1995 ופעלו בתחומים שונים. לשכת יועצת רה״מ למעמד האשה פרסמה גם כתב עת שנקרא ״מעמד האשה״ אשר התפרסם בין 1982-1992 וכלל 25 גיליונות.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ],
      [
        'תרבות וספורט',
        'כתבי עת והוצאה לאור'
      ]
    ],
    'id': 'YH1',
    'is_active': false,
    'keywords': [
      'האמנה לביעור כל צורות ההפליה נגד נשים 1979 CEDAW',
      'חקיקה',
      'מידע',
      'קידום נשים',
      'שוויון',
      'שיתוף פעולה בינלאומי',
      'תקשורת'
    ],
    'name': 'יועצת ראש הממשלה למעמד האישה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'דויטשקרון, אינגה (1979, 5 יוני). ד״ר רבקה בר יוסף תהיה הממונה לענייני נשים במשרד סגן ראש הממשלה. אותר בארכיון עיתונות יהודית היסטורית.'
      },
      {
        'title': 'המלצות הועדה למעמד האשה, שבט- תשל״ח, פברואר 1978, ירושלים'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/12/2018'
    },
    'year_closed': 1997,
    'year_closed_text': '1997',
    'year_founded': 1979,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '12/01/2019'
    },
    'description': 'העמותה נרשמה ב-2000 על ידי ויקטור כהנא, פעיל חברתי בראשון לציון. העמותה פעלה בעיקר בראשון לציון וככל הנראה גם בגבעתיים. נציגיה השתתפו בדיונים שונים בכנסת שעסקו בזכויות דיור, קצבאות הביטוח הלאומי וזכויות נוספות של משפחות חד-הוריות. ככל הנראה העמותה הפסיקה לפעול  מתישהו בין 2006 ל-2007. ב-2008 רשם ויקטור כהנא עמותה חדשה בשם ״יחד - ארגון לזכויות הפרט בישראל״. באחת מהישיבות בהן השתתף בכנסת הסביר שבעבר עבד רק עם משפחות חד הוריות ואחר כך הרחיב את האוכלוסייה עמה הוא עובד.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'YH177',
    'is_active': false,
    'keywords': [
      'אמהות גרושות',
      'דיור',
      'ביטחון סוציאלי',
      'זכויות'
    ],
    'name': 'יחד - עמותה למשפחות חד הוריות בראשל״צ',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ראשון לציון',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>יחד – עמותה למשפחות חד הוריות בראשל״צ (ע״ר): עמותה מחוקה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580356277'
      },
      {
        'title': '(2004, 7 יולי). נגד כנס קיסריה: ״הסכנה הכלכלית-חברתית - קיומית״. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-2943845,00.html'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2003, 7 יולי). <b>פרוטוקול מס\' 33: הפגיעה בנשים חד הוריות כתוצאה מן הקיצוץ החד בקצבאות הביטוח הלאומי</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/Activity/committees/Women/Pages/CommitteeProtocols.aspx?ItemID=64985'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '01/12/2019'
    },
    'year_closed': 2007,
    'year_closed_text': '2007',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '03/06/2018'
    },
    'description': 'עמותת יחד מחושך לאור הוקמה בשנת 2013 על ידי אורלי פרוינד, נפגעת גילוי עריות בילדות ושותפים לדרך, ביניהם העיתונאית יעל דן שלוותה את אורלי בשנים הראשונות לאחר חשיפת הפגיעה ובתהליך המשפטי שעברה מול הדוד הפוגע ואף יצרה על כך סרט דוקומנטרי. פרוינד ושותפיה פועלים בהתנדבות על מנת לגייס כספים לשם קיומן של קבוצות טיפול בעברית ובערבית לנפגעות/ים תקיפה מינית בכל הארץ וכן למתן טיפול פרטני בעלויות מופחתות לנפגעות/ים. המטרה היא לאפשר לכל נפגע/ת לקבל טיפול נפשי אישי או קבוצתי. הקבוצות הטיפוליות כוללות במכוון נשים וגברים מתוך אמונה בכך שהדרך לריפוי עוברת דרך מפגש משותף. העמותה מכוונת ללוות את הקבוצות הטיפוליות במחקר על מנת לתעד וללמוד מהתהליכים המתרחשים בהן למען נפגעות/ים בעתיד.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'YB98',
    'is_active': true,
    'keywords': [
      'פגיעה מינית בילדות',
      'גילוי עריות',
      'תמיכה נפשית',
      'טיפול פמיניסטי',
      'אונס'
    ],
    'name': 'יחד מחושך לאור',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-27'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.fromdarknesstolighttogether.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>יחד מחושך לאור (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580570158'
      },
      {
        'title': 'עמותת יחד מחושך לאור, עמוד פייסבוק. נדלה מתוך',
        'url': 'https://www.facebook.com/childabusesupport/'
      },
      {
        'title': 'פרוינד, אורלי (2016, 23 מאי) . יחד מחושך לאור. <b>סלונה</b>. נדלה מתוך',
        'url': 'http://saloona.co.il/orli-froind/?tag=%d7%a2%d7%9e%d7%95%d7%aa%d7%aa-%d7%99%d7%97%d7%93-%d7%9e%d7%97%d7%95%d7%a9%d7%9a-%d7%9c%d7%90%d7%95%d7%a8'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '27/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '02/05/2020'
    },
    'description': 'יחידת האמהות בבית שבתי לוי (ע״ר 580009983) הוקמה בשנת 2004 כחלק משירותי ״היחידה לשלום הילד״ המעניקה שירותים קהילתיים לכארבעים משפחות. יחידת האמהות היא הרחבה של פעילות של מרכז החירום לגיל הרך (החל לפעול בשנת 1995) ופנימיית ״בית שבתי לוי״ הפועלת מאז שנות החמישים של המאה ה-20 לקליטת תינוקות וילדים בגיל הרך המצויים בסיכון או ללא משפחה. ״יחידת האימהות״ מיועדת לאימהות, בדרך כלל צעירות, חד-הוריות, שנפלטו ממשפחות מזניחות ופוגעות ואשר נשלחו ליחידה בצו בית משפט, לרוב כמוצא אחרון לפני הוצאת הילדים מהבית. היחידה קולטת עד 14 אימהות, יחד עם ילדיהן, ומעניקה טיפול אינטנסיבי למשך 14 חודשים במטרה להעניק כישורי חיים וכישורי הורות ולסייע להן לשמור על התא המשפחתי בעתיד. תהליך השיקום של האימהות כולל שלושה מסלולים: הגנה על הילדים ללא הפרדה מאמם; שיקום היכולת ההורית של האם ויחסי האם ילד; הקניית כישורי חיים בסיסים. כל הילדים והאימהות מופנים ליחידה על ידי משרד הרווחה והעמותה מגייסת תרומות לפיתוח שירותים, תחזוקת המבנה ופעילות שוטפת לרווחת הילדים והאימהות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ]
    ],
    'id': 'SA186',
    'is_active': true,
    'keywords': [
      'גיל הרך',
      'אמהות',
      'דיור',
      'שיקום'
    ],
    'name': 'יחידת האימהות- בית שבתאי לוי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2020-05-02'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.shabtailevi.org/%d7%94%d7%99%d7%97%d7%99%d7%93%d7%95%d7%aa/%d7%99%d7%97%d7%99%d7%93%d7%aa-%d7%94%d7%90%d7%99%d7%9e%d7%94%d7%95%d7%aa/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בית שבתי לוי (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580009983'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים עולות מחבר העמים',
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '05/02/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '17/01/2019'
    },
    'description': '״ינבוע״ לקידום מעמד האשה בכפר ריינה היא עמותה (ע״ר 580394385) שהוקמה בשנת 2004. מטרות העמותה הן: ״קידום מעמד הנשים בכפר באמצעות הגברת המודעות, שיפור הדימוי העצמי והנשי ע״י נשות מקצוע, הרצאות וימי עיון. עידוד יציאת נשים לעבודה״. העמותה מפעילה את ״מרכז כרם״ המיועד לאלמנות ואמהות חד-הוריות מהכפרים ריינה ומשהד, מקיימת סדנאות ללימוד רקמה ותפירה ומציעה קורסים לסיום תעודת בגרות או השכלה תיכונית. בנוסף, העמותה מסייעת למשפחות נזקקות ומארגנת קייטנות בשיתוף פעולה עם גני הילדים המופעלים על ידי עמותת ״אמהות למען עתיד פורח״ מאבו-סנאן.',
    'description_ar': 'جمعية ״ينبوع״ لتمكين النساء في قرية الرينة. (ج.م 580394385) تأسست عام 2004 وأهدافها: ״تعزيز وضع المرأة في القرية من خلال التوعية، وتعزيز الصورة الذاتية والأنوثة من قبل النساء المحترفات والمحاضرات والندوات. تشجيع النساء على الخروج لسوق العمل ״. تقوم الجمعية بإدارة ״مركز كرم״ للأرامل والامهات العازبات من قريتي الرينة والمشهد، تقوم بورشات عمل للخياطة والتطريز وتقدم مساقات لإنهاء شهادة البجروت او انهاء الثانوية. بالإضافة، تساعد العائلات المحتاجة، وتشغل حضانات أطفال بالشراكة مع حضانات الأطفال التي تشغلها جمعية ״أمهات من اجل مستقبل مزهر״ في أبو سنان.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'חינוך',
        'צמצום פערים בחינוך'
      ]
    ],
    'id': 'YA4',
    'is_active': true,
    'keywords': [
      'אלמנות',
      'אמהות גרושות',
      'תעסוקה',
      'העצמה'
    ],
    'name': 'ינבוע - קידום מעמד האשה והילד בכפר ריינה',
    'name_ar': 'جمعية الينبوع الرينة',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ריינה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-01-17'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.facebook.com/el.yanboa/timeline?lst=1029340516%3A100002189395877%3A1547732783'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>״ינבוע״ קידום מעמד האשה והילד בכפר ריינה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580394385'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '25/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '11/04/2018'
    },
    'description': 'עמותת ״יסמין אלנגב לבריאות האישה והמשפחה״ (ע״ר 580473056) הוקמה בשנת 2007 ונרשמה בבאר שבע. מטרות העמותה אשר פועלת ביישובים הבדואים ובכפרים הבלתי מוכרים הן: ״הקניית ידע למטופלים בסוגיית הבריאות של הנשים ואורח חייהן והשוני בגישה הטיפולית. קידום הבריאות בכל הקשת החברתית. תקשורת תקינה היא תנאי הכרחי לקבלת טיפול רפואי נאות- הכשרת מתורגמנים רפואיים. העלאת המודעות בקרב מטפלים לגבי תרבות ובריאות נשים בדויות, בריאות האישה בהריון וטיפול בתינוק.״ העמותה קיימה פרויקט ״קידום מקצועות הבריאות״ שנועד להגדיל את מספר הסטודנטים הערבים בדואים הלומדים מקצועות בריאות בנגב, ולצמצום הפערים בקבלתם ללימודים באקדמיה. במסגרת פעילות זו, הצליחה העמותה להשפיע על משרד הבריאות לפתוח מסלול ייחודי ללימודי סיעוד לסטודנטים ערבים בדואים באוניברסיטת בן-גוריון. בנוסף, קיימה העמותה פרויקט ״נשים מקדמות בריאות״ בשיתוף האוניברסיטה שנועד לפתח מנהיגות מקומית בתחום בריאות האשה באזור הנגב. העמותה זכתה בפרס יושבת ראש הכנסת לאיכות חיים לשנת 2008.',
    'description_ar': 'جمعية ياسمين النقب لصحة المرأة والعائلة (ج.م 580473056) تأسست عام 2007 وسجلت في بئر السبع. اهداف الجمعية والتي تنشط في البلدات البدوية والقرى الغير معترف بها هن: توفير المعرفة للمرضى حول قضية صحة المرأة ونمط حياتهم المختلفة وتغير طرق تلقي العلاج. تعزيز الصحة عبر الطيف الاجتماعي. التواصل السليم هو شرط أساسي للحصول على الرعاية الطبية المناسبة – تدريب مترجمين طبيين. رفع مستوى الوعي بين المعالجين حول ثقافة وصحة المرأة البدوية وصحة النساء الحوامل ورعاية الطفل. للجمعية مشروع ״تعزيز المهن الصحية״ يهدف إلى زيادة عدد الطلاب البدو العرب الذين يدرسون المهن الصحية في النقب، وتقليص الفجوات في قبولهم في الدراسات الأكاديمية. كجزء من هذا النشاط، تمكنت الجمعية من التأثير على وزارة الصحة لفتح برنامج فريد لتعليم التمريض للطلاب العرب البدو في جامعة بن غوريون. بالإضافة إلى ذلك، عقدت الجمعية مشروع ״تعزيز صحة المرأة״ بالتعاون مع الجامعة، والتي تهدف إلى تطوير القيادة المحلية في صحة المرأة في منطقة النقب. فازت الجمعية بجائزة رئيس الكنيست لجودة الحياة لعام 2008.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ],
      [
        'חינוך',
        'צמצום פערים בחינוך'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'YH128',
    'is_active': false,
    'keywords': [
      'בדואיות',
      'השכלה',
      'בית חולים',
      'פריון ולידה',
      'מנהיגות',
      'העצמה'
    ],
    'name': 'יסמין אלנגב לבריאות האישה והמשפחה',
    'name_ar': 'جمعية ياسمين النقب',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>יסמין אלנגב ״עמותה לבריאות האישה והמשפחה״ (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580473056'
      },
      {
        'title': 'יוגב, תום. 2014. <b>אי שוויון בבריאות: החברה הערבית בדואית בנגב - סוגיות מוקד והמלצות לטיפול</b> (דו״ח שהוגש לשרת הבריאות יעל גרמן) עמותת יסמין אלנגב.'
      },
      {
        'title': 'The Working Group on the Status of Palestinian Women Citizens of Israel (2010).<b>The status of Palestinian women citizens of Israel</b> (Submitted to the committee on the elimination of discrimination against women). Retrieved from',
        'url': 'https://www2.ohchr.org/english/bodies/cedaw/docs/ngos/WomenCitizens_of_Israel_for_the_session_Israel_CEDAW48.pdf'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '21/02/2019'
    },
    'year_closed': 2015,
    'year_closed_text': '2015',
    'year_founded': 2007,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'אקטיביזם רשת'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '28/11/2018'
    },
    'description': '״יפואיות- תא לקידום נשים ושוויון מגדרי במכללה האקדמית תל אביב יפו״ הוקם בשנת 2015 על מנת להוות בית לסטודנטיות מכל קצוות המכללה. מטרות התא: להעלות למודעות את מצבן של נשים בחברה הישראלית ובמכללה האקדמית תל אביב יפו בפרט, לקיים פעילויות בנושא קידום נשים, ופעילויות שיעניקו לסטודנטיות כלים להשתלבות כשוות בחברה, לערוך למידה משותפת בנושאי נשים ושוויון, ולהוות כתובת לכל סוגיה הנוגעת לנשים בקמפוס. התא פעל בשיצוף פעולה עם ״תל-אביביות״, התא הסטודנטיאלי באוניברסיטת תל אביב ובמהלך שנת 2019 צמצם את פעילותו.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תאים סטודנטיאליים'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ],
      [
        'פוליטיקה ומנהיגות',
        'תאים סטודנטיאליים'
      ]
    ],
    'id': 'YH154',
    'is_active': true,
    'keywords': [
      'הטרדה מינית',
      'אקטיביזם',
      'סטודנטיות',
      'מנהיגות',
      'העצמה'
    ],
    'name': 'יפואיות- תא לקידום נשים ושוויון מגדרי במכללה האקדמית תל אביב יפו',
    'name_ar': '-يافاويات',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'אקדמי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תאים סטודנטיאליים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'יפואיות- תא לקידום נשים ושוויון מגדרי, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/yafoiyot/'
      },
      {
        'title': 'הפרטים מבוססים על מידע שהופיע באתר מכללת תל-אביב יפו. העמוד אינו זמין יותר.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '28/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה',
      'אקטיביזם רשת'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '24/06/2018'
    },
    'description': 'תא ״ירושלמיות״ הנו תא לקידום נשים ושוויון מגדרי באוניברסיטה העברית. התא הוקם במטרה לקדם ולהעצים נשים במגוון תחומים, ברוח פתוחה ופלורליסטית. התא הוא א-מפלגתי ופועל מתוך אמונה בשיח רב תרבותי לקידום שינוי חברתי בדגש על אחריות חברתית ומעורבות בקהילה. הפעילות מתבצעת במישורים ונושאים שונים, כגון מניעת הטרדות מיניות, תעסוקה ושכר, הדרת נשים, חינוך, אקדמיה פמיניסטית, הורות ועוד.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תאים סטודנטיאליים'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ],
      [
        'פוליטיקה ומנהיגות',
        'תאים סטודנטיאליים'
      ]
    ],
    'id': 'YB105',
    'is_active': true,
    'keywords': [
      'הטרדה מינית',
      'אקטיביזם',
      'מגוון',
      'סטודנטיות',
      'הדרה'
    ],
    'name': 'ירושלמיות - תא לקידום נשים האוניברסיטה העברית',
    'name_ar': 'قُدسيّات',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'אקדמי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תאים סטודנטיאליים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'ירושלמיות قُدسيّات - תא לקידום נשים ושוויון מגדרי, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/yerushalmiot/'
      },
      {
        'title': 'אגודת הסטודנטים בעברית (אתר). <b>תאים סטודנטיאליים</b>. נדלה מתוך',
        'url': 'https://www.aguda.org.il/article/58'
      },
      {
        'title': 'וחש, נופר (2015, 24 מאי). יוזמה חדשה בירושלים – ״תו מודע״ נגד אלימות מינית בפאבים. <b>טיים אאוט</b>. נדלה מתוך',
        'url': 'https://timeout.co.il/%D7%A2%D7%99%D7%A8%D7%95%D7%A0%D7%99/%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D/%D7%99%D7%95%D7%96%D7%9E%D7%94-%D7%97%D7%93%D7%A9%D7%94-%D7%91%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D-%D7%AA%D7%95-%D7%9E%D7%95%D7%93%D7%A2-%D7%A0%D7%92%D7%93-%D7%90%D7%9C%D7%99%D7%9E%D7%95'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '09/04/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחאה',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '12/06/2018'
    },
    'description': '״כביסה שחורה״ שהוקמה ביוני 2001 הייתה קבוצת פעילות קווירית, אשר עסקה בחיבור בין מאבקים סביב סוגיות של מגדר, זהות ונטייה מינית למאבק נגד הכיבוש ולמען צדק חברתי. בשלבים מאוחרים יותר היא עסקה גם בזכויות בעלי חיים. הקבוצה התגבשה סביב מצעד הגאווה של 2001 שהתרחש בזמן אינתיפאדת אל-אקצה בו צעדו חברותיה, לבושות בשחור, חלקן חשופות חזה עם ססמאות כתובות על גופן, תחת הססמא ״אין גאווה בכיבוש״. בקבוצה היו בין 20-40 פעילות קבועות ועוד כמה מאות שהיו מנויות על רשימת התפוצה והצטרפו אליה באירועים שונים. הקבוצה השתמשה באקטים פרפורמטיבים כדי להביא מחאה בסוגיות .פוליטיות, חברתיות ומגדריות, שכללו אלמנטים של דראג ומשחק מודע עם פרפורמנס מגדרי. כביסה שחורה היוותה עבור חברותיה גם מרחב קהילתי וקבוצת תמיכה אל מול המציאות הישראלית, כמו גם מקום לבחינה של חוויות מגדריות לימנליות וניסוח מחדש של זהויות. הקבוצה הפיצה פלירים מחאתיים שנכתבו בשפה פרובוקטיבית מתוך ניכוס מחדש של מילות גנאי שהוטחו בחברותיה. היא פעלה בעיקר בתל אביב, אולם לתקופה מסוימת כללה גם סניף ירושלמי. החל מ - 2003 דעכה פעילות הקבוצה וב - 2004-2005 היא נפסקה.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'להט״ב',
        'פוליטיקה ומנהיגות'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'זכויות אדם'
      ],
      [
        'שלום'
      ]
    ],
    'id': 'SA19',
    'is_active': false,
    'keywords': [
      'גאווה',
      'כיבוש',
      'שלום',
      'מאבק',
      'קוויר',
      'מיליטריזם',
      'מצעד',
      'צדק חברתי'
    ],
    'name': 'כביסה שחורה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'זיו, עמליה (2008). ״לחצות את גבולות המגדר, לבגוד בגבולות הלאום: הפוליטיקה הפרפורמטיבית של ״כביסה שחורה״״, בתוך: יונה, יוסי וקמפ, אדריאנה (עורכים), <b>פערי אזרחות: הגירה, פריון וזהות בישראל</b>. הוצאת הקיבוץ המאוחד.'
      },
      {
        'title': 'ספרן, חנה, הרטל, רחלי וששון-לוי, אורנה (2016). הי[א]סטוריה לסבית מקומית: פעילות, מאבקים והישגים. בתוך: הראל, אלון, לושינסקי, יניב ומורגנשטרן, עינב (עורכים), <b>זכויות הקהילה הגאה בישראל: משפט, נטייה מינית וזהות מגדרית</b> (עמ\' 45–80). האוניברסיטה העברית, המכון למחקרי חקיקה ולמשפט השוואתי. צפרירים: נבו.'
      },
      {
        'title': 'Baum, Dalit (2006). Women in black and men in pink: Protesting against the Israeli occupation. <b>Social Identities, 12</b>(5), 563-574.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '06/12/2018'
    },
    'year_closed': 2004,
    'year_closed_text': '2004',
    'year_founded': 2001,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '07/03/2018'
    },
    'description': 'לכוח לעובדים חמישה מטות: צפון, גליל, מרכז, ירושלים ודרום. הפורום נוסד בינואר 2013 על ידי שתי פעילות מרכזיות בארגון, שירה פנחס ונעה נוצני. מטרתו לחזק את השוויון המגדרי בכוח לעובדים ולהיאבק נגד האפליה של נשים בעולם העבודה. הפורום הצליח לעשות שינוי משמעותי בתוך הארגון וממשיך לפעול בנושא, ושואף להרחיב את השפעתו במקומות עבודה אותם הארגון מאגד ומעבר להם. בין ההישגים של הפורום: יצירת איזון מגדרי במערך השכיר, גידול משמעותי באחוז הנשים החברות בהנהגת הארגון, השוואת מספר המרצות למרצים בהכשרות בארגון, וכן שוויון בין מרואיינות למרואיינים בתקשורת וסיוע בהטמעה של מודל להסכם קיבוצי רגיש מגדרית שנכתב בשיתוף עם ״הקליניקה לזכויות נשים בעבודה״ באוניברסיטה העברית.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ]
    ],
    'id': 'YH41',
    'is_active': true,
    'keywords': [
      'איגוד מקצועי',
      'אפליה',
      'תנאי עבודה',
      'עובדות',
      'הטמעת חשיבה מגדרית'
    ],
    'name': 'כוח לעובדות – הפורום הפמיניסטי בכוח לעובדים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'זכויות ומדיניות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'כוח לעובדות- הפורום הפמיניסטי בארגון כוח לעובדים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/power.to.women.workers/'
      },
      {
        'title': 'יאבו, מריאלה (2018, 1 מאי). כוח לעובדות. <b>פוליטיקלי קוראת</b>. נדלה מתוך',
        'url': 'http://politicallycorret.co.il/%D7%9B%D7%95%D7%97-%D7%9C%D7%A2%D7%95%D7%91%D7%93%D7%95%D7%AA/'
      },
      {
        'title': 'כוח לעובדים (אתר). <b>כוח לעובדות</b>. נדלה מתוך',
        'url': 'http://workers.org.il/%D7%90%D7%95%D7%93%D7%95%D7%AA-%D7%9B%D7%95%D7%97-%D7%9C%D7%A2%D7%95%D7%91%D7%93%D7%99%D7%9D/%D7%A2%D7%A5-%D7%9E%D7%91%D7%A0%D7%94/%D7%A4%D7%95%D7%A8%D7%95%D7%9D-%D7%9B%D7%95%D7%97-%D7%9C%D7%A2%D7%95%D7%91%D7%93%D7%95%D7%AA/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '07/03/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'אקטיביזם רשת',
      'מחאה',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '24/06/2018'
    },
    'description': 'כולן״ (ע״ר 580651735) הוקמה בשנת 2017 במטרה לפעול ל״קידום האידיאולוגיה הפמיניסטית והשיח הפמיניסטי בישראל״. העמותה נוסדה על ידי קבוצת נשים שהיו ממייסדות ״צעדת השרמוטות״ בתל אביב יפו (2012) וקבוצת הפייסבוק ״שיח פמיניסטי״ (2013) ומתוארת כתנועת שטח פמיניסטית הרואה בקידום השיח הפמיניסטי בכלל, וברשתות החברתיות בפרט, גורם לשינוי משמעותי בחברה הישראלית. פעילות העמותה מתמקדת באקטיביזם רשת, בקמפיינים תקשורתיים ובהפקת צעדות מחאה, בעיקר בתחום של מניעת אלימות מינית. התנועה פועלת בשיתוף פעולה עם ארגוני הנשים הקיימים ומהווה ״פלטפורמה לשיתופי פעולה בין נשים וארגונים, ומרחב סולידרי ובטוח לנשים״. פעילויות נוספות של ״כולן״ כוללות הפקת לוח שנה היא-סטוריה, ארגון וניהול פורום של התאים הפמיניסטיים באוניברסיטאות, וקורסים להכשרת אקטיביסטיות צעירות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ]
    ],
    'id': 'YB103',
    'is_active': true,
    'keywords': [
      'פמיניזם',
      'אונס',
      'הטרדה מינית',
      'צעדה',
      'אינטרנט'
    ],
    'name': 'כולן - קידום השיח והעשייה הפמיניסטית בישראל',
    'name_ar': null,
    'name_change_year': 2017,
    'name_common': 'כולן - كلهن',
    'name_past': 'צעדת השרמוטות תל אביב יפו/ שיח פמיניסטי/ היא -סטוריה',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'אקטיביזם רשת',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-24'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.togetherkulan.com/about'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>כולן – קידום השיח והעשייה הפמיניסטית בישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580651735'
      },
      {
        'title': 'כולן, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/togetherallofus'
      },
      {
        'title': 'כולן – كلهن (2018, מאי). הפרטים אומתו בשיחה עם נציגת העמותה.'
      },
      {
        'title': 'יודעת - מרכז ידע נשים ומגדר (אתר). <b>כולן - לקידום השיח והעשייה הפמיניסטית בישראל</b>. נדלה מתוך',
        'url': 'https://yodaat.org/item/org/580651735'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '09/04/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2012,
    'year_registered': 2017
  },
  {
    'activity_kinds': [
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '29/11/2018'
    },
    'description': '״כולנו אחת״ היא התארגנות שהחלה בשנת 2004 היא יוזמה של אישה מערד בשם אביטל ארגמן ומטרתו היתה העצמה כלכלית לנשים. בראשיתו מלבד מפגשים והרצאות, ארגנו בערד ״שוקנשי״ - שוק עבודות יד ואוכל. ב-2006 נרשמו כעמותה (ע״ר 580451664) וקיבלו מקום שישמש ״בית מלאכה״ וחממה ליזמיות ואמניות (מומן ושופץ על ידי מוטורולה). בקבוצה פעלו במשותף נשים בדואיות, יוצאות אתיופיה וברה״מ וישראליות ותיקות. ב-2015 העמותה נמחקה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'תרבות וספורט',
        'אמנות'
      ]
    ],
    'id': 'YH155',
    'is_active': false,
    'keywords': [
      'אמנות',
      'יזמות עסקית',
      'העצמה כלכלית',
      'בדואיות'
    ],
    'name': 'כולנו אחת - עמותה להעצמת נשות ערד והסביבה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ערד',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>כולנו אחת – עמותה להעצמת נשות ערד והסביבה (ע״ר): עמותה מחוקה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580451664'
      },
      {
        'title': 'ארגמן, אביטל (2005, 31 יולי). נשות ״כולנו אחת״. <b>אסימון</b>. נדלה מתוך',
        'url': 'http://www.asimon.co.il/ArticlePage.aspx?AID=1047&AcatID=25'
      },
      {
        'title': 'גרינברג, מיכל (2007, 6 ינואר). כל אחת מרקע אחר, אך החלום לעצמאות כלכלית הוא משותף. <b>הארץ</b>. נדלה מתוך',
        'url': 'https://www.haaretz.co.il/misc/1.1376690'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות',
      'נשים יוצאות אתיופיה',
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '29/11/2018'
    },
    'year_closed': 2015,
    'year_closed_text': '2015',
    'year_founded': 2004,
    'year_registered': 2006
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות',
      'שירותים משפטיים'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '22/04/2018'
    },
    'description': '״כייאן-ארגון פמיניסטי״ היא עמותה (ע.ר. 580345247) הממוקמת בחיפה אשר פועלת לשירוש אפליה מגדרית, פיתוח מנהיגות וחיזוק כוחן של נשים פלסטיניות בישראל. מטרות העמותה הן: ״לפעול לשינוי חברתי בתפיסת מעמדה ותפקידה של האשה בחברה הערבית. יצירת מסגרת אידאולוגית, רעיונית אלטרנטיבית בנוגע למעמד האשה. יצירת דיאלוג סביב נושאים הקשורים לנשים וזכויותיהן.״ חזונה של העמותה הוא לקדם חברה חופשיה מאפליה מגדרית, הזדמנויות מלאות ושוות ופיתוח מנהיגות לנשים פלסטיניות בישראל. מאז היווסדה בשנת 1998 כייאן פועלת בשיתוף פעולה עם ארגוני נשים נוספים במישור החברתי והמשפטי לקידום מטרותיה: המישור החברתי מתמקד בקידום שיתופן של נשים במרחב הציבורי ובקבלת החלטות. בתחום זה מפעילה כייאן מספר פרויקטים ארציים ומקומיים העוסקים בנשים ופוליטיקה, אלימות ורצח נשים, בריאות האישה והשפעתה בענייני קרקע, מגורים והגירה. המישור המשפטי מתמקד בזכויות סוציאליות של נשים פלסטיניות בישראל ומתן מענה בסוגיות כגון מעמד אישי, זכויות תעסוקה והטרדה מינית. מסגרת זו כוללת מתן ייצוג משפטי סנגור והעלאת מודעות חברתית. ״כייאן״ היא חלק מקואליציית נשים- חיפה ושימשה כארגון האם של ״אסוואת״.',
    'description_ar': 'كيان- تنظيم نسوي جمعية (ج.م. 580345247) ومركزها في حيفا، والتي تعمل على القضاء على التمييز بين الجنسين، تطوير القيادة وتعزيز قوة المرأة الفلسطينية في إسرائيل. اهداف الجمعية هي: العمل من اجل التغيير المجتمعي في تصور وضع ودور المرأة في المجتمع العربي. انشاء إطار مفاهيمي أيديولوجي بديل فيما يتعلق بوضع المرأة، خلق حوار حول قضايا المتعلقة بالنساء وحقوقهن. تتمثل رؤية الجمعية في تعزيز مجتمع خالٍ من التمييز بين الجنسين، وفرص كاملة ومتساوية، تنمية قيادة نسائية فلسطينية في إسرائيل. منذ التأسيس عام 1998، عملت ״كيان״ بالتعاون مع المنظمات نسائية الأخرى في المجالين الاجتماعي والقانوني للنهوض بأهدافها: المجال الاجتماعي يركز على تعزيز مشاركة النساء في الحيز العام وفي اتخاد القرارات، وبهذا المجال تشغل كيان عدد من المشاريع الإقليمية والمحلية التي تتناول قضايا المرأة والسياسة، العنف وقتل النساء، صحة المرأة وتأثيرها على قضايا الأرض، السكن والهجرة. اما المجال القانوني فيتركز على الحقوق الاجتماعية للمرأة الفلسطينية في إسرائيل ويعالج أيضًا قضايا مثل الأحوال الشخصية وحقوق التوظيف والتحرش الجنسي. ويشمل ذلك توفير التمثيل القانوني والدعوة ورفع الوعي الاجتماعي. كيان هي جزء من ائتلاف حيفا النسائي وكانت بمثابة المنظمة الأم ل “أصوات״.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ]
    ],
    'id': 'SA4',
    'is_active': true,
    'keywords': [
      'אלימות',
      'אפליה מגדרית בתעסוקה',
      'בריאות',
      'הטרדה מינית',
      'זכויות',
      'מעמד אישי',
      'סיוע משפטי',
      'רצח נשים',
      'מנהיגות'
    ],
    'name': 'כייאן- ארגון פמיניסטי',
    'name_ar': 'كيان- تنظيم نسوي',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-07-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.kayanfeminist.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>כייאן – ארגון פמיניסטי (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580345247'
      },
      {
        'title': 'קרן דפנה (ללא תאריך). <b>קבוצות פמיניסטיות בישראל</b> (העמוד אינו זמין יותר).'
      },
      {
        'title': 'Deeb, Rula (2010). Kayan–feminist organization: Sustainable grassroots community activism. <b>New England Journal of Public Policy, 23</b>(1), 112-119.'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '11/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': 1999
  },
  {
    'activity_kinds': [
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '07/04/2018'
    },
    'description': '״כל הנשים״ הוקמה על ידי עו״ד אפרת אומיאל פדידה ונרשמה כעמותה ביישוב אבטליון בשנת 2016. מטרות העמותה (ע״ר 580627867) הן רבות וכוללות: ״יצירת שיתופי פעולה בין ארגוני נשים בארץ ובעולם לקידום שוויון וזכויות לנשים. ייצוג כל אישה בישראל באשר היא אישה, ללא הבדלי דת, גזע והעדפה מינית. קידום ייצוג שוויוני והולם של נשים בכל הגופים הממשלתיים, הציבוריים ובמגזר הפרטי. קידום ויוזמת חקיקת חוקים לקידום זכויות ושוויון לנשים. קידום שוויון נשים בחינוך, בחברה, בתרבות, באומנות, בספורט ובבריאות. פיתוח והרחבת ההגנות והזכויות לנשים בהליכי פוריות, הריון, לידה ואימהות. יצירה וקידום של שוויון הזדמנויות אמיתי בתעסוקת נשים שכירות ועצמאיות. העלאת המודעות, הנגשת המידע, סיוע ושינוי הגישה הרווחת לגבי בריאות נשים והטיפול בהן. חיזוק מעמד האישה והתייחסות שוויונית לנשים באמצעי המדיה והתקשורת. התאמה ותגבור התחבורה הציבורית בהתאם לצרכי נשים ברחבי הארץ. פיתוח תשתיות ויצירת מרחבים עירוניים וציבוריים בטוחים לנשים וילדים. העלאת המודעות והחמרת הענישה לכל סוגי האלימות נגד נשים במשפחה ובחברה. קידום חקיקה והרחבת מערך התמיכה למען נשים נפגעות אלימות והטרדה מינית. פיתוח, תמיכה ועידוד ארגונים הנותנים סיוע והכשרה לנשים לפיתוח עצמאות כלכלית. כל הנשים דוגלת בבחירה חופשית של כל אישה לחופש הדת וחופש מדת.מטרתה הוגדרה כ״קידום נושאים הקשורים בזכויות נשים, קידומן והעצמתן״. התקציב השנתי של העמותה קטן מאוד ופעילותה באה לידי ביטוי בעיקר בעמוד הפייסבוק שעוסק בענייני היום, כולל בסוגיות הנוגעות לאלימות נגד נשים ובמיזמים מקומיים באזור הצפון המקדמים אמנות ופעילות עסקית בקרב נשים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'אמנות'
      ]
    ],
    'id': 'YB121',
    'is_active': true,
    'keywords': [
      'פנאי',
      'תקשורת',
      'אלימות'
    ],
    'name': 'כל הנשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'אבטליון',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אמנות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-04-07'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://kolhanashim.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>כל הנשים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580627867'
      },
      {
        'title': 'כל הנשים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/kolhanashim/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '09/04/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '29/10/2018'
    },
    'description': 'מרכז ״כרמל״- המרכז הבינ״ל להכשרה ע״ש גולדה מאיר נוסד בשנת 1961 על ידי משרד החוץ -מש״ב –סוכנות הסיוע הלאומית של ישראל, ו״האיגוד״- חברה להעברת טכנולוגיה, שמוציא אל הפועל את פעילות הסיוע הבינ״ל שמגישה מדינת ישראל למדינות אחרות. את המרכז הקימה מינה בן-צבי שהייתה מהדיפלומטיות הראשונות: קונסול בפינלנד (1953-1955) ונציגת ישראל בוועדה למעמד האישה של האו״ם (1956-1958). כאשר היתה חברת מועצת העיר חיפה ייסדה את המרכז הבינלאומי לעבודה קהילתית ״כרמל״ מטעם משרד החוץ ועמדה בראשו עד שנת 1987. ייעודו של המרכז הוא ליזום ולבצע תוכניות הדרכה המובילות לפיתוח חברתי/כלכלי בארצות המתפתחות, תוך דגש על קידום נשים. ״מרכז כרמל״ הנו ייחודי בעולם בהיותו הראשון ששם את סוגיית השוויון המגדרי על האג\'נדה הבינלאומית – 14 שנים לפני הכרזת האו״ם על ״עשור הנשים״ בוועידת מקסיקו ב- 1975. במשך שנות קיומו, הכשיר המרכז עשרות אלפי אנשי מקצוע מ-149 מדינות אפריקה, אסיה אמריקה הלטינית, אוקיאניה, האיים הקריביים, מדינות חב״מ ומזרח אירופה. רבים מהם מאיישים היום עמדות מפתח ומועסקים ע״י סוכנויות הפיתוח הבינלאומיות. כל פעילות המרכז מכוונת ליעדי המילניום – ביעור העוני, שוויון מגדרי, חינוך לכל, מחלת האיידס, תמותת ילדים, תמותת אימהות, איכות הסביבה ופיתוח בר-קיימא, שותפות בינ״ל לפיתוח. בנוסף, נושאים כגון אלימות כלפי נשים וילדים, סחר בבני אדם, נשים מהגרות, תקשורת לשינוי חברתי וכו\' נכללים בתוכניות הלימוד. הפעילות ב״מרכז כרמל״ מתקיימת לאורך כל השנה בשפות אנגלית, צרפתית, ספרדית, רוסית וערבית.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'צבא, ביטחון ומדיניות חוץ',
        'דיפלומטיה ויחסי חוץ'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'חינוך'
      ]
    ],
    'id': 'SA76',
    'is_active': true,
    'keywords': [
      'דיפלומטיה',
      'הכשרה מקצועית',
      'מנהיגות',
      'קידום נשים',
      'החלטה 1325'
    ],
    'name': 'כרמל – המרכז הבינלאומי להכשרה ע״ש גולדה מאיר',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': 'המרכז הבינלאומי להכשרת נשים- חיפה',
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'ממשלתי',
      'ממשלתי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'צבא, ביטחון ומדיניות חוץ',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'דיפלומטיה ויחסי חוץ',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-29'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://mctc.co.il/'
      },
      {
        'title': 'סיד ישראל (אתר). <b>מרכז ״כרמל״- המרכז הבינ״ל להכשרה ע״ש גולדה מאיר</b>. נדלה מתוך',
        'url': 'https://www.sid-israel.org/%D7%94%D7%97%D7%91%D7%A8%D7%99%D7%9D-%D7%A9%D7%9C%D7%A0%D7%95/%D7%9E%D7%A8%D7%9B%D7%96-%D7%9B%D7%A8%D7%9E%D7%9C'
      },
      {
        'title': 'Herlitz, Esther (2009, February 27). Mina Ben-Zvi. In <b>Jewish women: A comprehensive historical encyclopedia</b>. Jewish women\'s archive. Retrieved from',
        'url': 'https://jwa.org/encyclopedia/article/ben-zvi-mina.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '29/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '16/05/2018'
    },
    'description': 'עמותת ״לא לאלימות״ הוקמה בהרצליה על ידי רות רזניק בשנת 1977 כאחד הארגונים הפמיניסטיים הראשונים בישראל במטרה לסייע נשים וילדיהן הסובלים מאלימות במשפחה ולאפשר להם לצאת לחיים חדשים באמצעות הענקת מקלט, טיפול מקצועי והכשרה מקצועית. העמותה גם פעילה בתהליכי עיצוב מדיניות, שינוי חקיקה והגברת המודעות בחברה לנושא האלימות במשפחה. בשנת 1982 היא נרשמה כעמותה (ע״ר 580022200) שמטרותיה: ״איסוף והפצת מידע על ממדי ותופעות אלימות נגד נשים והקמת בתי מקלט לנשים מוכות ולילדיהן״. מאז, פעילותה המרכזית של העמותה היא ניהול והפעלת 3 מקלטים לנשים הסובלות מאלימות ולילדיהן ודירות מעבר לנשים יוצאות מקלט. בנוסף, מפעילה העמותה באמצעות מתנדבות קווי חירום הפועלים 24 שעות ביממה ואת היחידה המשפטית המטפלת בהליכים המשפטיים של נשים במקלט ומתן ייעוץ משפטי ראשוני לנשים הסובלות מאלימות ואינן זכאיות לסיוע משפטי. העמותה מקיימת הרצאות, ימי עיון וסדנאות במקלט ומחוצה לו, לגופים שונים, כגון: צה״ל, תלמידי תיכון, אנשי משטרה, צוותים רפואיים, ארגוני נשים, סטודנטים ועוד. בדומה לשאר המקלטים, מרבית הוצאות התפעול של עמותת ״לא לאלימות״ ממומנות על ידי משרד העבודה, הרווחה והשירותים החברתיים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YB35',
    'is_active': true,
    'keywords': [
      'נשים מוכות',
      'מקלט',
      'ביטחון אישי',
      'פמיניזם',
      'נתונים',
      'קו סיוע',
      'דיור',
      'סיוע משפטי'
    ],
    'name': 'ל.א.- לחימה באלימות נגד נשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'ל.א. לאלימות נגד נשים',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'הרצליה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://no2violence.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>לא לחימה באלימות נגד נשים: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580022200'
      },
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל. עמ\' 11–13.'
      },
      {
        'title': 'ינאי, אורי (2005). מקלטי נשים בישראל: מחדשנות וולנטרית לאימוץ ממלכתי. <b>ביטחון סוציאלי, 70</b>, 77–109. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/SocialSecurity/70/article5.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1977,
    'year_registered': 1982
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '20/06/2018'
    },
    'description': 'בשנת 1985 התקיימו משחקי המכביה בישראל, ולגמר טורניר הנשים בכדורסל הגיעו נבחרות ישראל וארצות הברית. בעקבות החלטת האיגוד להזיז את המשחק מיד אליהו לאולם המוזנח בכפר המכביה, התארגנו שתי הנבחרות למחאה משותפת והחליטו לא להופיע לגמר. בתגובה קבע האיגוד כי נבחרת ישראל תפורק, אלא שמספר פעילות בענף, ביניהן אורנה אוסטפלד, רחל אוסטרוביץ\', רונית יניצקי, רלי מלחי, ענת דרייגור, ולאה מלמד הגישו לבית המשפט עתירה ומנעו את פירוק הנבחרת. כך גם החלה פעילותה של עמותת ל.כ.ן, לקידום כדורסל וספורט נשים. בשנת 1986 אורנה אוסטפלד, אז שחקנית מכבי תל אביב ומכוכבות הליגה, ויתרה על המשך הקריירה ברמות הגבוהות כדי לייסד ברמת השרון אגודת כדורסל נשים. עמותת ״ל.כ.ן לקידום כדורסל נשים״ (ע״ר 580100121) נוסדה בשנת 1987 ברמת השרון כארגון פמיניסטי שמטרותיה הן: ״ביטול ההפליה הקיימת בתקנון איגוד הכדור-סל. הקמת בתי ספר לכדור-סל בנות מהגיל הצעיר. העלאת התהודה של כדור-סל נשים באמצעי התקשורת. הקמת מספר רב של נבחרות לאומיות, ילדות ונערות, עתודה ונשים.״ בשנות ה-90 השתתפו נציגות מהעמותה בועדה שהוקמה על מנת לקבוע קריטריונים וקווים מנחים להקצאת כספים מטעם המועצה להסדר הימורים בספורט אשר החליטה כי הקצאת המשאבים לגברים ונשים בספורט צריכה להעשות באופן שווה. מאוחר יותר העמותה הגישה מספר עתירות לבית המשפט, כמו למשל בשנת 2004 כאשר זכתה העמותה בעתירה שהגישה לבג״ץ נגד המועצה המקומית רמת השרון, בדרישה להשוות את המימון אותו היא מקבלת למימון אותו מקבלות קבוצות הגבריים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'ספורט'
      ]
    ],
    'id': 'SA29',
    'is_active': true,
    'keywords': [
      'כדורסל',
      'משפט',
      'פערי שכר',
      'תקצוב מגדרי'
    ],
    'name': 'ל.כ.ן לקידום כדורסל נשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת השרון',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ספורט',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-20'
    },
    'sources': [
      {
        'title': 'א.ס. רמת השרון (קבוצת כדורסל)',
        'url': 'http://www.rhbb.org.il/apage/27235.php'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>ל.כ.ן. לקדום כדורסל נשים: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580100121'
      },
      {
        'title': 'Galily, Yair & Betzer-Tayar, Moran (2014). Losing is Not an Option! Women\'s Basketball in Israel and its Struggle for Equality (1985-2002). <b>The International Journal of the History of Sport 31</b>(13), 1694-1705.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '12/02/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1985,
    'year_registered': 1987
  },
  {
    'activity_kinds': [
      'מחאה',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '30/07/2018'
    },
    'description': 'לא נחמדים/לא נחמדות היא קבוצה של פעילי/ות שכונות שהוקמה בקיץ 2011 אשר פועלת ״למען אותן שכונות אשר קולן לא נשמע במאבק. אנו דור שני ושלישי לאפליה חברתית, כלכלית, ומדיניות גזענית ואנחנו פועלים בתחומים אלה מידי יום בנחישות ללא מורא ופחד, מתוך אמונה שלמה שהמאבק שלנו מוצדק, אמיתי וכנה....המאבק בא לידי ביטוי בפעולות בפועל ונלחם בשחיתויות הממשלה, הפוליטיקאים, הטייקונים ונבחרי הציבור לדורותיו. מטרתנו להביא לצמצום הפערים הסוציו-אקונומים (חברתיים-כלכליים), הקיימים בחינוך ובריאות ולאפשר מתן הזדמנות שווה להשכלה, פרנסה, דיור ומעמד חברתי. סוגיה זו של ה״שוליים״ , נוחה לממשל ולאוחזים בו להמשיך ולתחזק את המעמד המוחלש ,לשם שמירה על ההיררכיה החברתית אנחנו כאן בכדי לומר לא עוד!״. ההתארגנות פועלת בחסות תנועת ״אחותי״ ומתרכזת בעיקר באזור מרכז הארץ ונכון לשנת 2018, היא אחת הקבוצות הדומיננטיות בתוך ה״פורום לדיור ציבורי״, קואליצייה של ארגונים וקבוצות אשר מרוכזת על ידי שתי״ל. רוב הפעילות המרכזיות ב״לא נחמדים/לא נחמדות״ הן נשים, ובראיון עם כרמן אלמקייס (2015) יש התייחסות מפורשת לכך שהקבוצה פועלת מתוך תפיסת עולם פמיניסטית המזהה את סוגיית הדיור הציבורי עם צרכים של נשים ואמהות.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ]
    ],
    'id': 'SA39',
    'is_active': true,
    'keywords': [
      'חד-הוריות',
      'דיור',
      'פמיניזם',
      'אפליה',
      'צדק חברתי',
      'זכויות אזרחיות',
      'שוויון',
      'אקטיביזם'
    ],
    'name': 'לא נחמדים/לא נחמדות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים מזרחיות',
    'retrieved': {
      'type{date}': '2018-07-30'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://lonehmadimot.wixsite.com/lonemadim/about'
      },
      {
        'title': 'לא נחמדים - לא נחמדות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/%D7%9C%D7%90-%D7%A0%D7%97%D7%9E%D7%93%D7%99%D7%9D-%D7%9C%D7%90-%D7%A0%D7%97%D7%9E%D7%93%D7%95%D7%AA-485312398245672/'
      },
      {
        'title': 'פרג\', יהל ורוטנברג, מיכל (2016, 13 יולי). פלפל הארץ: שיחה עם כרמן אלמקייס-עמוס, מתנועת לא-נחמדים-לא נחמדות. <b>דבר</b>. נדלה מתוך',
        'url': 'https://www.davar1.co.il/23932/'
      }
    ],
    'target_audiences': [
      'נשים מזרחיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '30/07/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2011,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'אקטיביזם רשת',
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '22/05/2018'
    },
    'description': '״לא עומדות מנגד- מסייעות לנשים במעגל הזנות״ הוקמה ב-2017 כקבוצת פייסבוק על ידי נעמה גולדנברג לצורך גיוס סיוע ותמיכה חומרית ומיידית עבור נשים בזנות. בשנת 2018 נרשמה כעמותה (ע״ר 580663821) שמטרותיה הן: ״סיוע במגוון תחומים לנפגעות ונפגעי מעגל הזנות לשם מתן תמיכה ותחושת שייכות, העלאת מודעות הציבור לנושא והרחבת מעגלי ההשפעה של המאבק למיגור הזנות״. פרויקט הדגל של העמותה הוא ״בגד חברתי״ - מיזם להסבר ומימון פעולות העמותה. מדובר בדוכן שמתקיים בשוק היווני ביפו, בכל יום שישי. הדוכן מופעל על ידי מתנדבות ובו נמכרים בגדי ואביזרי יד שנייה, כאשר כל ההכנסות הן תרומה לעמותה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'זנות'
      ],
      [
        'רווחה וקהילה',
        'זנות וסחר בנשים'
      ]
    ],
    'id': 'YB84',
    'is_active': true,
    'keywords': [
      'תמיכה נפשית',
      'סיוע כלכלי',
      'פמיניזם',
      'שיקום',
      'אלימות מינית',
      'אינטרנט'
    ],
    'name': 'לא עומדות מנגד - מסייעות לנשים במעגל הזנות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'לא עומדות מנגד',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת גן',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'אקטיביזם רשת',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'זנות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'לא עומדות מנגד – מסייעות לנשים במעגל הזנות, קבוצת פייסבוק.',
        'url': 'https://www.facebook.com/groups/aidingWomeninProstitution/'
      },
      {
        'title': 'גולדברג, נעמה (2018). לא עומדות מנגד – סיפור הקמה של קהילה וירטואלית תומכת בנשים שורדות זנות. <b>פסיק – מגזין המכון הדמוקרטי</b> 6. נדלה מתוך:\n',
        'url': 'http://www.democratic.co.il/2018/06/29/%D7%9C%D7%90-%D7%A2%D7%95%D7%9E%D7%93%D7%95%D7%AA-%D7%9E%D7%A0%D7%92%D7%93/'
      },
      {
        'title': 'הדס בשן (2018, 20 יוני). לא עומדות מנגד – קבוצת הפייסבוק שעוזרת לנשים במעגל הזנות. <b>את</b>. נדלה מתוך',
        'url': 'https://www.atmag.co.il/%D7%9C%D7%90-%D7%A2%D7%95%D7%9E%D7%93%D7%95%D7%AA-%D7%9E%D7%A0%D7%92%D7%93/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '25/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2017,
    'year_registered': 2018
  },
  {
    'activity_kinds': [
      'אקטיביזם רשת',
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '04/11/2018'
    },
    'description': '״לא תשתוק״ היא יוזמה שראשיתה ב-2015 בעמוד פייסבוק שמטרתו העלאת מודעות לנושא הפגיעות המיניות בחברה החרדית בעיקר כלפי ילדות וילדים ומתן במה לנפגעות ונפגעים. בין היוזמים היו רחלי רושגולד, אביגיל קרלינסקי וצביקי פליישמן. הקבוצה נרשמה כעמותה ב-2017 (ע״ר 580633840) שמטרותיה הן העלאת ״מודעות ציבורית-כתיבה, הפקה והפצה של חומרים בתחום הפגיעות המיניות והשלכתן ובתחום מיניות בריאה וחינוך מיני. הפעלת דף פייסבוק העוסק בנ\'\'ל, מאמרים במקומות שונים ברשת ובעיתונות, מדיה ויזואלית, כולל אתרי אינטרנט. תיווך-פעילות כגורם מתווך של הציבור מול הגורמים השונים כמו המשטרה, מערכת המשפט, גופי הרווחה השונים, רבנים ומוסדות. חינוך-פעילות חינוכית לילדים ולמבוגרים בנושאי מוגנות וזיהוי נפגעי תקיפה מינית. הכשרות מקצועיות בתחום פגיעה מינית למטפלים, מורים, הורים, ולעוסקים בתחום. סדנאות לחינוך מיני. תורה והלכה . הנגשת פסקי הלכה תורניים בתחום, והתבטאויות בנושא מטעם רבנים לידיעת הציבור. כתיבה תורנית בתחום. סיוע לנפגעי תקיפה. תמיכה מקיפה בנפגעות ונפגעי תקיפה מינית. כולל עזרה סוציאלית, משפטית, פסיכולוגית, וליווי צמוד. רווחה, מתן שירותים מקיפים לנצרכים לכך, בכל האספקטים הנוגעים לחיי היומיום. כולל עזרה נפשית, פיזית ותמיכה כלכלית. קידום יוזמות . עידוד פעילות קהילתית לקידום המודעות בתחום, מתן חומרים מקצועיים לכל המעוניין. אירועים, אירגון וייזום כנסים ואירועים קהילתיים הנושקים לתחום המיניות. וכל מה שקשור לנושאים של מיניות ופגיעות מיניות״. במהרה הפכה העמותה הישראלית לסניף מקומי של הארגון היהודי הבינלאומי JCW- Jewish Community Watch שהחל לפעול בשנת 2014 בניו-יורק למניעה של אלימות מינית כלפי ילדים/ות בחברה החרדית. בשנת 2020 הוגשה לבית המשפט בקשה לפירוק העמותה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'דת ומעמד אישי',
        'אלימות'
      ],
      [
        'חינוך',
        'חינוך מיני/מיניות בריאה'
      ]
    ],
    'id': 'YH129',
    'is_active': true,
    'keywords': [
      'העלאת מודעות',
      'ילדים/ות',
      'תמיכה נפשית',
      'סיוע משפטי'
    ],
    'name': 'לא תשתוק',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'אקטיביזם רשת',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2019-11-06'
    },
    'sources': [
      {
        'title': 'אתר הארגון הבינלאומי Jewish Community Watch',
        'url': 'https://www.jewishcommunitywatch.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>לא תשתוק (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580633840'
      },
      {
        'title': 'לא תשתוק, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/lo.tishtok/'
      },
      {
        'title': 'טוקר, נתי (2017, 1 מאי). ״לא תשתוק״: החרדיות שהחליטו להילחם בתופעת ההטרדות המיניות במגזר. <b>TheMarker</b>. נדלה מתוך',
        'url': 'https://www.themarker.com/allnews/1.4061521'
      }
    ],
    'target_audiences': [
      'נשים חרדיות',
      'גברים חרדים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '04/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': 2017
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '02/01/2019'
    },
    'description': 'לב לעם הארגון למען העגונות ומסורבות/י הגט וילדיהם נוסד כעמותה (ע״ר 580100527) על ידי דניאלה ספיר ומסורבות גט נוספות בשנת 1983 תחת השם ״הארגון לעזרת העגונות ומעוכבי הגט״. בשנת 1996 השם הוחלף לשם הנוכחי. בעלות התפקידים יצגו את העמותה בוועדת המשנה לדיני אישות של הוועדה לקידום מעמד האשה בשנת 1998 ובוועדה לזכויות הילד בשנת 2007. פעילות העמותה תוארה באותה ועדה ב-2007: ״במסגרת הפעילות ‏שלנו אנחנו מקיימים סדנאות, סופי שבוע לאמהות וילדים. אנחנו שומעים את כל הצרות, כל הבעיות וכל מה שקורה. אנחנו ‏דואגים לכך שיהיו סדנאות לאימהות, ושבזמן הזה מישהו ישמור על הילדים וישמע אותם. הם מסיימים את הסדנה בהרגשה ‏נפלאה, שמישהו שמע אותם, טיפל בהם, הקשיב. האימהות יוצאות ממש מאושרות.״',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ],
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ]
    ],
    'id': 'SW40',
    'is_active': false,
    'keywords': [
      'חקיקה',
      'עגינות',
      'סרבנות גט',
      'גירושין',
      'אמהות',
      'דיני אישות'
    ],
    'name': 'לב לעם הארגון למען העגונות ומסורבות/י הגט וילדיהם ‏',
    'name_ar': null,
    'name_change_year': 1996,
    'name_common': null,
    'name_past': 'הארגון לעזרת העגונות ומעוכבי הגט‏',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>לב לעם – הארגון למען העגונות ומסורבות/י הגט וילדיהם (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580100527'
      },
      {
        'title': 'הוועדה המיוחדת לזכויות הילד (2007, 13 נובמבר). <b>פרוטוקול מס\' 48: השפעת סרבנות גט על הילדים</b>. נדלה מתוך',
        'url': 'https://main.knesset.gov.il/Activity/committees/Pages/AllCommitteesAgenda.aspx?Tab=3&ItemID=261764'
      },
      {
        'title': 'לוביץ\', רבקה (2008, 5 מרץ). <b>נשים בבית הדין הרבני: המאבק לפתרון בעייתן של מסורבות הגט – הצלחות ונסיגות</b>. המכון הישראלי לדמוקרטיה. נדלה מתוך',
        'url': 'http://www.cwj.org.il/sites/default/files/EIsraelDemocracyInstitute09.10.08.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '05/01/2019'
    },
    'year_closed': 2008,
    'year_closed_text': '2008',
    'year_founded': 1983,
    'year_registered': 1986
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '21/07/2018'
    },
    'description': 'הארגון נוסד בשנת 1976 תחת השם ש.י.ל.ה – שירותי ייעוץ להריון ומניעה והיה הארגון הקהילתי הראשון מסוגו בארץ שהחל לשלב פעילות חינוכית בקהילה, מתן ייעוץ אישי וזוגי ושירות רפואי תחת קורת גג אחת. בשנת 1983 הוא נרשם כעמותה (ע״ר 580055911) שמטרתה: ״להבטיח שירות נגיש בנושאי מניעה והריון לא רצוי לכל מי שנזקק לו ובמיוחד לנוער ולאותן קבוצות אשר מתקשות להשתמש בשירותים הקיימים בקהילה״. בשנת 2013 שינתה העמותה את שמה ל״לדעת לבחור נכון״. מטרותיה העיקריות הן לעודד התנהגות מינית בריאה ואחראית ולסייע לנשים/נערות הנמצאות בהריון לא מתוכנן. פעילות העמותה כוללת חינוך, מרכז ייעוץ וקידום מדיניות ושיח ציבורי. העמותה מפעילה תוכניות חינוכיות לבריאות מינית באזור ירושלים - סדנאות, הרצאות, והכשרת אנשי מקצוע - בבתי ספר ובמסגרות בלתי פורמאליות, במיוחד עם נוער במצוקה. מטרת התוכניות היא להגביר אצל בני נוער את יכולתם לקבל החלטות שקולות לגבי התנהגותם המינית ואת אחריותם ע״י שימוש באמצעי מניעה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'תכנון משפחה וחינוך מיני'
      ],
      [
        'נערות וצעירות',
        'בריאות'
      ],
      [
        'חינוך',
        'חינוך מיני/מיניות בריאה'
      ]
    ],
    'id': 'YH59',
    'is_active': true,
    'keywords': [
      'אמצעי מניעה',
      'הריון',
      'הפלה',
      'תכנון משפחה',
      'חינוך מיני'
    ],
    'name': 'לדעת- לבחור נכון',
    'name_ar': 'للمعرفة – لإختيار الصحيح',
    'name_change_year': 2013,
    'name_common': null,
    'name_past': 'ש.י.ל.ה שירותי יעוץ להריון ומניעה',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'תכנון משפחה וחינוך מיני',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-07-21'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.ladaat.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>לדעת – לבחור נכון</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580055911'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '21/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1976,
    'year_registered': 1983
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/06/2018'
    },
    'description': 'ליגה היא התארגנות פמיניסטית שהוקמה על ידי פעילות פמיניסטיות דוברות רוסית, המיועדת לדוברות רוסית מכל רחבי הארץ, ונאבקת באפליה ממנה סובלות נשים דוברות רוסית. ליגה פועלת למען קידום כלכלי והעלאת הנראות הציבורית של נשים שהגיעו מברה״מ לשעבר, וחותרת למען השמעת קולן של נשים דוברות רוסית הן בציבוריות ובמוקדי קבלת החלטות, והן בקרב מעגלים אקטיביסטיים חברתיים ופמיניסטים בפרט. ליגה יוצאת כנגד האפליה הכפולה שנשים אלו חוות, וכן שואפת ליצירת סולידריות עם נשים מכל קצוות החברה. ליגה מעניקה תמיכה, ומסייעת בהכוונה והפנייה לגורמים שונים המתאימים לנשים הפונות, בנושאים הקשורים בזכויות תעסוקתיות, דיני משפחה, אלימות במשפחה ועוד. בנוסף, ליגה תומכת בהתארגנויות של נשים דוברות רוסית ומסייעת בקידום מטרותיהן. הקבוצה מקיימת מפגשים קבועים ומעבירה סדנאות, הרצאות וסמינרים לקהלים מגוונים ברחבי הארץ.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'הגירה',
        'קליטת עלייה'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ייצוג הולם'
      ]
    ],
    'id': 'SA83',
    'is_active': true,
    'keywords': [
      'פמיניזם',
      'העלאת מודעות',
      'אפליה',
      'תקשורת',
      'שוק העבודה',
      'אלימות'
    ],
    'name': 'ליגה - פמיניסטיות דוברות רוסית בישראל ЛИГА',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'הגירה',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'קליטת עלייה',
    'primary_target_audience': 'נשים עולות מחבר העמים',
    'retrieved': {
      'type{date}': '2018-06-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://ligafem.org/%D7%9C%D7%99%D7%92%D7%94-%D7%91%D7%A2%D7%91%D7%A8%D7%99%D7%AA/'
      },
      {
        'title': 'ועדת העלייה, הקליטה והתפוצות (2018, 4 דצמבר). <b>פרוטוקול מס\' 348: חיזוק התא המשפחתי בקרב משפחות עולים</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/Activity/committees/Immigration/Pages/CommitteeProtocols.aspx?ItemID=2076090'
      },
      {
        'title': 'קואליציית שותפות (האתר אינו זמין יותר).',
        'url': 'http://shutafot.org.il/'
      }
    ],
    'target_audiences': [
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '15/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '06/05/2018'
    },
    'description': 'ליגת לה-לצ\'ה היא אחת הקבוצות הראשונות בישראל שעסקו בהעלאת מודעות לנושא ההנקה. על פי אתר האינטרנט של הארגון, הסניף הישראלי של הארגון הבינלאומי ליגת לה-לצ\'ה (La Leche League International) החל את פעילותו בשנת 1971. בשנת 1980 ארגנו חברותיו את הסימפוזיון הבינלאומי הראשון בישראל בנושא הנקה. בשנת 1984 נרשמה עמותת ״ליגת לה-לצ\'ה״ (ע״ר 580066421) ומטרותיה העיקריות היו: ״להציע עידוד, מידע ותמיכה לנשים החפצות להניק את תינוקותיהן ותוך כדי כך לטפח אמהות טובה באמצעות הנקה״. בשנים האחרונות פועל הסניף הישראלי באזור תל אביב ומקיים קו תמיכה טלפוני, אתר אינטרנט וקבוצות תמיכה והכשרה ליועצות הנקה ברחבי הארץ. מהדוחות המילוליים האחרונים עולה כי הארגון כולו מנוהל בהתנדבות, ללא עובדות בשכר.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ]
    ],
    'id': 'SA15',
    'is_active': true,
    'keywords': [
      'הנקה',
      'אמהות'
    ],
    'name': 'ליגת לה-לצ\'ה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-06'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.lllisrael.org.il/about-us/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>ליגת לה לצ\'ה: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580066421'
      },
      {
        'title': 'ארקין, נילי (1980, 18 פברואר). המגע האינטימי. <b>מעריב</b>. נדלה מתוך',
        'url': 'http://jpress.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=MAR%2F1980%2F02%2F18&id=Ar01905&sk=E63D7609'
      },
      {
        'title': 'הארגון הבין-לאומי, ליגת לה-לצ\'ה (אתר).',
        'url': 'https://www.llli.org/about/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '06/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1971,
    'year_registered': 1984
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'אקטיביזם רשת'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '19/05/2018'
    },
    'description': 'עמוד הפייסבוק ״לילה טוב״ נוצר באוגוסט 2015 בעקבות פוסט פרטי שבו תוארו הטרדות מיניות במועדון לילה בתל-אביב שהוביל להתארגנות של מספר פעילות פמיניסטיות תחת השם ״דונט קיל מיי וייב״. בין המקימות היו יעל אלבז, שירה מיקין, הגר שיזף, יסמין וקס, קרן גרינבלט ומפרסמת הפוסט גילי רון. הקבוצה, בשיתוף פעולה עם ״שדולת הנשים״ ו״מרכז הסיוע לנפגעות תקיפה מינית תל אביב״ החלו לפעול ביחד עם בעלי ברים ומועדונים ובלייניות ובליינים במטרה להיאבק בהטרדות ובתקיפות מיניות בחיי הלילה וליצור מרחבים בטוחים יותר. העמותה ״לילה טוב- לבלות בלי הטרדות״ (ע״ר 580635589) הוקמה בשנת 2017. מטרות העמותה הן: ״ לפעול להטמעת חקיקה ראשית ו/או בתקנות עזר ברשויות מקומיות המחייבת בתי עסק המוגדרים כמקומות בילוי של חיי הלילה (בר/פאב/מועדון/דיסקוטק) לטפל בהטרדה ופגיעה מינית בשטח בית העסק ומחוצה לו במהירות, ביעילות ובכבוד, לקיים הכשרות עתיות לכל אנשי הצוות בבתי עסק אלו בנושא הטרדה ופגיעה מינית, ולתלות שילוט הולם במקומות הבילוי המכריז על המרחב כמוגן מהטרדה מינית ומפנה לצוות המקום המוכשר לסייע במידת הצורך. לפעול לשינוי תרבות הבילוי בחיי הלילה בישראל ולמגר מתוכה את הפגיעה וההטרדה המינית. לפעול להעלאת מודעות הציבור בישראל לתופעת הפגיעה וההטרדה המינית בחיי הלילה ולדרכים למניעתה ומיגורה. לפעול לחינוך ציבור המבלים והמבלות, עובדי ועובדות, מנהלי ומנהלות בתי העסק בחיי הלילה למניעה ומיגור של הפגיעה וההטרדה המינית, וליצירת מרחב בילוי נעים ובטוח לכל.״ פעילות העמותה כללה ניסוח אמנה וולנטרית שעליה חתמו בעלי עסקים. האמנה מחייבת כל מקום בילוי שבעליו חתמו על האמנה להעביר הכשרות ייעודיות לזיהוי וטיפול במקרים של הטרדה או פגיעה מינית, לתלות שילוט במקום ולמנות אדם אחראי לטיפול בנושא.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'הטרדה מינית'
      ],
      [
        'נערות וצעירות',
        'חינוך'
      ]
    ],
    'id': 'YB58',
    'is_active': true,
    'keywords': [
      'אלימות מינית',
      'ביטחון אישי'
    ],
    'name': 'לילה טוב - לבלות בלי הטרדות',
    'name_ar': 'لايلا طوﭪ- ليلة حلوة',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הטרדה מינית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-19'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.laylatov.org/who'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>לילה טוב – לבלות בלי הטרדות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580635589'
      },
      {
        'title': 'חננאל, איילה (2015, 26 אוגוסט). קבוצת ״לילה טוב״ ומועדוני העיר משיקים אמנה נגד אלימות מינית. <b>טיים אאוט</b>. נדלה מתוך',
        'url': 'https://timeout.co.il/%D7%A2%D7%99%D7%A8%D7%95%D7%A0%D7%99/%D7%AA%D7%9C-%D7%90%D7%91%D7%99%D7%91/%D7%9C%D7%99%D7%9C%D7%94-%D7%98%D7%95%D7%91'
      },
      {
        'title': 'לילה טוב – לבלות בלי הטרדות (2018, 17 מאי). הפרטים אומתו בשיחה עם נציגת הארגון.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': 2017
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '06/01/2019'
    },
    'description': 'משנת 2002 מציעה מכללת תל חי מקבץ בלימודי מגדר כחלק מהתואר בלימודים רב-תחומיים לב.א. במסגרת החטיבה למדעי ההתנהגות. למקבץ שני הדגשים - פסיכולוגי וסוציולוגי והוא מהווה השלמה ללימודים בתחום הסוציולוגיה, תקשורת ושירותי אנוש. המקבץ נוסד על ידי ציונה גרוסמרק ובראשו עומדת אביגיל מור.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תכניות לתואר אקדמי בלימודי מגדר'
      ]
    ],
    'id': 'SA111',
    'is_active': true,
    'keywords': [
      'לימודי מגדר',
      'פריפריה'
    ],
    'name': 'לימודי מגדר במכללת תל חי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'קרית שמונה',
    'organization_kind': [
      'אקדמי',
      'ממשלתי'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תכניות לתואר אקדמי בלימודי מגדר',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-06-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.telhai.ac.il/%D7%97%D7%95%D7%92-%D7%90%D7%A7%D7%93%D7%9E%D7%99/%D7%94%D7%97%D7%95%D7%92-%D7%9C%D7%9C%D7%99%D7%9E%D7%95%D7%93%D7%99%D7%9D-%D7%A8%D7%91-%D7%AA%D7%97%D7%95%D7%9E%D7%99%D7%99%D7%9D'
      },
      {
        'title': 'לימודי מגדר במכללת תל חי (2019, 6 ינואר). הפרטים אומתו בשיחת טלפון עם אחת מהחוקרות במכללה.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/06/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2002,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '22/11/2018'
    },
    'description': '״החטיבה ללימודי האשה״ באוניברסיטת חיפה נוסדה בשנת 1983 על ידי קבוצת חוקרות שהחלו ללמד ולכתוב על נושאים הנוגעים למעמד האשה מתחילת שנות ה-70. בשנת 1981 התקיים באוניברסיטת חיפה כנס בינלאומי בהשתתפות מאות חוקרות מרחבי העולם תחת הכותרת: The First International Interdisciplinary Congress on Women: Women’s Worlds ולאחריו התקבלה ההחלטה למסד את ההוראה בתחום כחטיבה ללימודי תואר ראשון במסגרת החוג ללימודים רב-תחומיים. בין השנים 1983-1988 מומנו קורסי המבוא של החטיבה על ידי נעמ״ת ומאוחר יותר הפכו לחלק ממערך ההוראה האקדמי. חוקרות פמיניסטיות מרכזיות וביניהן פרופ\' מרילין ספר, פרופ\' דבורה ברנשטיין, ד״ר חנה ספרן וד״ר שרון הלוי היו בין מרכזות וראשות החטיבה. בשנת 2012 נפתחה תכנית לימודים בינתחומית בלימודי נשים ומגדר לתואר שני המהווה הרחבה של החטיבה (מקבץ) ללימודי נשים.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תכניות לתואר אקדמי בלימודי מגדר'
      ]
    ],
    'id': 'SA93',
    'is_active': true,
    'keywords': [
      'לימודי מגדר',
      'מחקר פמיניסטי'
    ],
    'name': 'לימודי נשים ומגדר- אוניברסיטת חיפה',
    'name_ar': null,
    'name_change_year': 2012,
    'name_common': null,
    'name_past': 'החטיבה ללימודי האשה',
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'אקדמי',
      'ממשלתי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תכניות לתואר אקדמי בלימודי מגדר',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-11-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://wgsuh.haifa.ac.il/index.php/he/2016-08-18-08-21-01'
      },
      {
        'title': 'ספרן, חנה (2009). בין אקדמיה לקהילה פמיניסטית: לימודי נשים בישראל. בתוך: אופלטקה, יזהר והרץ לזרוביץ, רחל (עורכים), <b>מגדר ואתניות בהשכלה הגבוהה בישראל</b> (עמ\' 169–188). חיפה: פרדס. נדלה מתוך',
        'url': 'https://gendersite.org.il/wp-content/uploads/2010/08/Safran.pdf'
      },
      {
        'title': 'Safir, Marylin, P. (2009). <b>״Women\'s Studies in Israel״ – Jewish Women: A Comprehensive Historical Encyclopedia</b>. Jewish Women\'s Archive Encyclopedia. Retrieved from',
        'url': 'https://jwa.org/encyclopedia/article/womens-studies-in-israel'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '27/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1983,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '07/03/2018'
    },
    'description': 'עמותת מן אג\'ליכי (״למענך למודעות״) (ע״ר 580426187) הוקמה בכפר קרע בשנת 2004 בידי קבוצת נשים מן הכפר שלמדו יחד בקורס ״נשים בקהילה״ שנערך במרכז היהודי-ערבי לשלום בגבעת חביבה. הרעיון להקמת העמותה, הן אומרות, נבע מהצורך לחולל שינוי במצבן. הן לא היססו להעלות על הכתב את הדברים שלהלן, בפרסום רשמי, כהסבר רקע להקמת הארגון: ״החברה הערבית כובלת את האישה במנהגים ובאמונות טפלות ושמה עליה מגבלות. זוהי חברה המקפחת את האישה בכל מובן שהוא, וגוזלת ממנה את זכויות האדם הבסיסיות שלה וגם את זכויותיה החברתיות. לכן, הקמנו את עמותת ״מן אג\'לכי (למענך), כדי לעסוק בהגברת מודעות הנשים באמצעות הרצאות ופעילות במישורים שונים: בריאות, פסיכולוגיה, אמנות, מנהיגות, ומקום האישה בחברה, כל זאת, על מנת לחולל את השינוי במנהגים מקפחים כלפי נשים״ (מתוך בקשת תמיכה לפרויקט של העמותה, 2005). מייסדת העמותה והרוח החיה שלה היא אמנה כנאענה, שמוצאה מן הכפר הסמוך ערה. מטרות העמותה הן: ״ביסוס המעמד החברתי של האשה. העלאת מודעות בתחומים שונים הנוגעים לחברה בכלל ולנשים בפרט. בניית והפעלת פרוייקטים יחודיים לנשים״. העמותה מקיימת קורסים, הרצאות, סדנאות וסיורים לימודיים בכפר קרע וואדי ערה בנושאים הקשורים לזכויות נשים, בריאות והגנת הסביבה.',
    'description_ar': 'جمعية من أجلك (ج.م 580426187) تأسست عام 2004 في كفر قرع- المثلث. بمبادرة من نساء القرية الذين تعلموا سويا مساق ״نساء في المجتمع״ والذي عقد في المركز اليهودي-العربي للسلام في جفعات حبيبة. يقولن إن فكرة تأسيس الجمعية تنبع من الحاجة إلى تغيير وضعهم. لم يترددوا في كتابة ما يلي، في منشور رسمي، كتفسير أساسي للمؤسسة. ״ ״المجتمع العربي يربط المرأة بالعادات والخرافات ويفرض عليها قيوداً. إنه مجتمع يضر بالمرأة بكل معنى الكلمة، ويسرق منها حقوق الإنسان الأساسية وحقوقها الاجتماعية. ولهذا اسسنا جمعية من أجلك، بهدف المشاركة في زيادة وعي المرأة من خلال المحاضرات والأنشطة في مختلف المجالات: الصحة، علم النفس، الفن، القيادة، ومكانة المرأة في المجتمع، كل ذلك من أجل إحداث التغيير في الممارسات غير المؤاتية تجاه المرأة ״(من طلب دعم لمشروع الجمعية، 2005). مؤسسة الجمعية وناشطتها الأساسية هي امنة كناعنة من قرية عارة. اهداف الجمعية هن: تحديد مكانة المرأة الاجتماعية. رفع الوعي في المجالات المختلفة المتعلقة بالمجتمع بشكل عام والمرأة بشكل خاص. بناء وتشغيل مشاريع فريدة للنساء ״.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ],
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'YH40',
    'is_active': true,
    'keywords': [
      'בריאות',
      'סביבה',
      'העצמה כלכלית',
      'זכויות'
    ],
    'name': 'למענך למודעות',
    'name_ar': 'من أجلك',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר קרע',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>למענך למודעות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580426187'
      },
      {
        'title': 'אוסצקי-לזר, שרה (2009). <b>״לא כמו אמי״: נשים מעצימות את עצמן – המקרה של כפר קרע</b>. ירושלים: בית הספר ע״ש פדרמן למדיניות ציבורית וממשל - האוניברסיטה העברית בירושלים. נדלה מתוך',
        'url': 'https://www.sarahozacky.com/862/%D7%9C%D7%90-%D7%9B%D7%9E%D7%95-%D7%90%D7%9E%D7%99-%D7%A0%D7%A9%D7%99%D7%9D-%D7%9E%D7%A2%D7%A6%D7%99%D7%9E%D7%95%D7%AA-%D7%90%D7%AA-%D7%A2%D7%A6%D7%9E%D7%9F-%E2%80%93-%D7%94%D7%9E%D7%A7%D7%A8/'
      },
      {
        'title': 'כנעאן, אמנה (2016, 14 מרץ). האישה שמלמדת נשים ערביות על העצמה נשית. <b>סלונה</b>. נדלה מתוך',
        'url': 'http://saloona.co.il/blog/%D7%94%D7%90%D7%99%D7%A9%D7%94-%D7%A9%D7%9E%D7%9C%D7%9E%D7%93%D7%AA-%D7%A0%D7%A9%D7%99%D7%9D-%D7%A2%D7%A8%D7%91%D7%99%D7%95%D7%AA-%D7%A2%D7%9C-%D7%94%D7%A2%D7%A6%D7%9E%D7%94-%D7%A0%D7%A9%D7%99%D7%AA/'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '09/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'פילנתרופיה',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/04/2019'
    },
    'description': 'לנ״י – ליגת נשים למען ישראל נוסדה על ידי קבוצת מתנדבות יהודיות בניו יורק בשנת 1928 כדי לסייע לעולות צעירות שהגיעו בגפן מאירופה לרכוש שפה, השכלה ומשלח יד הדרושים להן כדי להתחיל את חייהן בארץ ישראל. לשם כך הקימה לנ״י ״בתי חלוצות״ – בחיפה (1931), בתל אביב (1936), בירושלים (1943) ובנתניה (1950). בחלוף הזמן, השתנו והתרחבו פעולותיו של הארגון הפילנתרופי אשר התמקד בעיקר בשיתוף פעולה עם משרד העבודה והרווחה והרחבת שירותי רווחה לאוכלוסיות במצוקה בישראל – נשים, משפחות צעירות משכבות מצוקה, סטודנטים מעוטי יכולת מהפריפריה, ילדים להורים גרושים, קורבנות תקיפה מינית, קורבנות אלימות במשפחה, משפחות אומנות, אומנים ומוזיקאים מעוטי יכולת ועוד. בשנות ה־50 תרמה לנ״י לאוניברסיטה העברית בירושלים את הסכומים שנדרשו לבניית שני בנייני המעונות הראשונים לסטודנטיות, קפיטריה, אולם ספורט ומרכז הסטודנט בקמפוס גבעת רם. כיום ממשיכה לנ״י להעניק מלגות לסטודנטים מצטיינים. בתי החלוצות של לנ״י נסגרו במשך השנים, מלבד הבית ברח\' קינג ג\'ורג\' בתל אביב אשר משמש בשנים האחרונות כדיור זמני לצעירות וצעירים המגיעים לישראל במסגרת ״תגלית״ ו״החוויה הישראלית״.',
    'description_ar': null,
    'display_organization_kind': 'בינלאומי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ],
      [
        'הגירה',
        'קליטת עלייה'
      ]
    ],
    'id': 'SA158',
    'is_active': true,
    'keywords': [
      'דיור',
      'מלגות',
      'אלימות',
      'רווחה'
    ],
    'name': 'לנ״י – ליגת נשים למען ישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'בינלאומי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'פילנתרופיה',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'בינלאומי',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-04-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.womensleagueforisrael.org.il/?lang=he'
      },
      {
        'title': 'אורנה אביקזר (2019, 12 אפריל). <b>איך הפך מבנה \'בית ליגת נשים\' ההיסטורי למאורת אלכוהול סמים</b> (פוסט וסרטון בבלוג). נדלה מתוך',
        'url': 'https://orna-news.co.il/general/%D7%90%D7%99%D7%9A-%D7%94%D7%A4%D7%9A-%D7%91%D7%99%D7%AA-%D7%9C%D7%99%D7%92%D7%AA-%D7%A0%D7%A9%D7%99%D7%9D-%D7%94%D7%94%D7%A1%D7%98%D7%95%D7%A8%D7%99-%D7%9C%D7%9E%D7%90%D7%95%D7%A8%D7%AA-%D7%90/'
      },
      {
        'title': 'רחל שז״ר - ליגת נשים למען ישראל, תיק מסמכים מתאריך 31/07/1971 עד תאריך 1/10/1973, ארכיון המדינה (תיק סרוק) מס\' זיהוי ISA-President-LetterCredence-0010xry'
      },
      {
        'title': 'GuideStar (n.d). <b>Womens League for Israel Inc</b>. Retrieved from',
        'url': 'https://www.guidestar.org/profile/13-1656698'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '09/08/2018'
    },
    'description': 'עמותת ״לצידך- סיוע לנשים נפגעות התמכרויות״ (ע״ר 580564680) הוקמה בשנת 2012 ביהוד-מונסון ומספקת מענה לנשים מכל הארץ. מטרות העמותה הן: ״הורדת כמות הנשים המכורות בישראל. טיפול ושיקום באשפוז בנשים מכורות. טיפול ושיקום אמבולטורי בנשים מכורות. העלאת המודעות בקרב הציבור לבעיית ההתמכרות אצל נשים בישראל. מענה מקצועי למשפחות של נשים מכורות. העלאת המודעות בקרב הציבור בקשר בין אלימות להתמכרות״. אוכלוסיית היעד של העמותה הינה נשים נפגעות התמכרויות, מגיל 18 ומעלה. העמותה מפעילה אשפוזית לגמילה מסמים לנשים בלבד שהוקמה בשיתוף פעולה עם עמותת ״מעגל נשים 911״. העמותה פועלת במספר תחומים: מתן מידע וסיוע מקצועי בסוגיות כמו גמילה, טיפול נפשי, עזרה במיצוי זכויות; יצירת מקום בטוח, מכבד ותומך לנשים נפגעות התמכרות; פעולה אל מול הרשויות לאימוץ מדיניות פרוגרסיבית בכל הנוגע לטיפול בנשים המכורות; העלאת מודעות בקרב הציבור לקשר ההדוק בין אלימות ואלימות מינית בפרט להתפתחות התמכרויות בקרב נשים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'YH68',
    'is_active': true,
    'keywords': [
      'טיפול נפשי',
      'מיצוי זכויות',
      'התמכרות',
      'גמילה',
      'אשפוז',
      'אלימות',
      'אלימות מינית'
    ],
    'name': 'לצידך - סיוע לנשים נפגעות התמכרויות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'יהוד-מונסון',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'התמכרויות ושיקום',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-08'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.letsydech.com/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>״לצידך״ – סיוע לנשים נפגעות התמכרויות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580564680'
      },
      {
        'title': 'לצידךְ - מרכז לטיפול בהתמכרויות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/Womenonlyrehabcenter/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '08/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2012,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '01/08/2018'
    },
    'description': '‏״לשמה - מדיניות, יזמות, קהילה״ הוקמה כפרוייקט שטח ״מעורבות״ של התנועה ״לא נבחרות, לא ‏בוחרות״ (לימים עמותת ״נבחרות״) בשנת 2013. בשנת 2016 ״מעורבות״ נרשמה כעמותת ״חרדיות ‏מעורבות״ (ע״ר 580623908) וכנראה סביב זמן זה התפצלה מ-״נבחרות״ שנרשמה כעמותה בשנת 2015. בשנת 2018 ‏החליפה עמותת ״חרדיות מעורבות״ את שמה ל-״לשמה - מדיניות, יזמות, קהילה״. מטרות ״לשמה״ הן ‏להצמיח מנהיגות נשית מתוך הקהילות החרדיות, קידום המעורבות והעשיה שלהן בתוך הקהילות ‏ובציבור הישראלי בכלל, ולקדם מדיניות וחקיקה עבור נשים חרדיות בתחומי ההשכלה, התעסוקה ‏והבריאות.‏',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ],
      [
        'דת ומעמד אישי',
        'פוליטיקה ומנהיגות'
      ]
    ],
    'id': 'SW4',
    'is_active': true,
    'keywords': [
      'ייצוג',
      'קידום נשים',
      'אפליה מגדרית',
      'מנהיגות'
    ],
    'name': 'לשמה - מדיניות, יזמות, קהילה',
    'name_ar': null,
    'name_change_year': 2018,
    'name_common': null,
    'name_past': 'חרדיות מעורבות',
    'name_replaced_by': null,
    'official_address': 'בני ברק',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום מנהיגות נשים',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2018-08-01'
    },
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>\'לשמה\' – מדיניות, יזמות, קהילה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580623908'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2015, 28 יולי). <b>פרוטוקול מס\' 19: מצב ומעמד הנשים בחברה החרדית</b>. נדלה מתוך',
        'url': 'https://committees-next.oknesset.org/meetings/5/6/568095.html'
      },
      {
        'title': 'נבחרות (ללא תאריך). <b>מה הסיפור שלנו</b>. נדלה מתוך',
        'url': 'http://www.nivcharot.co.il/%D7%9E%D7%94-%D7%94%D7%A1%D7%99%D7%A4%D7%95%D7%A8-%D7%A9%D7%9C%D7%A0%D7%95/'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '11/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': 2016
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '07/04/2019'
    },
    'description': 'מונתדא אלמועילאת אלוחידאת הוקמה על ידי מייסון ריא מסח\'נין בשנת 2010 במטרה לסייע לנשים גרושות בסח\'נין. מטרות העמותה הן: ״העצמת נשים חד הוריות ושילובן בקהילה ע״י הרצאות וחשיפתן לנושאים חברתיים וחוקיים. ארגון סדנאות קבוצתיות לעודד אותן לצאת מהבית. שילוב הנשים בתעסוקה ע״י הכשרתן והקמת מוקד לחיפוש תעסוקה, תמיכה רגשית לילדי החד הוריות ושילובם בחוגים והפעלות״. הקבוצה מקיימת קבוצות וסדנאות לכ-200 נשים וילדים מדי שנה.',
    'description_ar': 'تأسست الجمعية ميسون أبو ريا من سخنين عام 2010، بهدف بهدف مساعدة الأمهات العازبات في سخنين. أهداف الجمعية هي: تمكين الامهات العازبات وإدماجهن في المجتمع من خلال المحاضرات وتعريضهن للقضايا الاجتماعية والقانونية، تنظيم ورش عمل جماعية لتشجيعهن على مغادرة المنزل، وإدماج النساء في العمل من خلال تدريبهن. وبناء مراكز للبحث عن العمل، دعم عاطفي للأطفال ودمجهن في دورات ونشاطات. تقوم المجموعات بنشطات وورشان ل 200 امرأة وطفل كل سنة.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ],
      [
        'תעסוקה ועבודה',
        'השמה וליווי בתעסוקה'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'YA15',
    'is_active': true,
    'keywords': [
      'אמהות גרושות',
      'חד הוריות',
      'גירושין',
      'תעסוקה',
      'העצמה'
    ],
    'name': 'מ.ע.א מונתדא אלמועילאת אלוחידאת',
    'name_ar': 'معا - منتدى المعيلات الوحيدات',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'סח\'נין',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מ.ע.א. מונתדא אלמועיאלת אלוחידאת (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580526218'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '30/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2010,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '10/10/2018'
    },
    'description': 'בשנת 2018, ליגת מאמאנט היתה פרויקט האימהות הספורטיבי-חברתי-קהילתי הגדול בישראל שבו משתתפות אלפי נשים בכל רחבי הארץ אשר משחקות בעשרות קבוצות כדורשת מקומיות. הליגה הוקמה בשנת 2005 בכפר סבא, על ידי עפרה אברמוביץ ונרשמה בשנת 2008 כעמותה (ע״ר 580495455). מטרות העמותה הן ״ארגון תחרויות ומפעלי ספורט לנשים ולילדים ממקומות שונים בארץ. ארגון פרוייקטים קהילתיים חברתיים כגון: אירוח אמהות וילדי שדרות ליום ספורט בכפר סבא, משלוחי מנות בפורים לילדים נזקקים, ארגון פעילויות לילדים בפנימיית עלומים בכפר סבא.״ שחקניות ליגת מאמאנט, רובן נשים שאינן ספורטאיות מקצועיות, משתתפות באימוני כדורשת מקומיים ומתחרות במסגרת ליגה ארצית. חברות הקבוצות מתנדבות גם בפרויקטים קהילתיים ופועלות כדי לקרב בין קבוצות שונות באוכלוסייה הישראלית: חילוניים, דתיים, יהודים, דרוזים, בדווים וערבים. בשנים האחרונות, פועלת ליגת מאמאנט בשיתוף פעולה עם משרד החוץ במטרה להפוך לאגודת ספורט בינלאומית. בשנת 2015, לאחר שהצטרפה כארגון רשמי אל ה-CSIT הקונפדרציה הבינלאומית של ארגוני ספורט מכל העולם, החלו קבוצות של כדורשת נשים מישראל להשתתף בתחרויות בינלאומיות ולארח טורנירים ומחנות אימונים בישראל.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'ספורט'
      ]
    ],
    'id': 'SA57',
    'is_active': true,
    'keywords': [
      'אמהות',
      'בריאות',
      'כדורשת',
      'פנאי'
    ],
    'name': 'מאמאנט- ליגת אמהות לכדורשת בכפר סבא- למען הקהילה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'מאמאנט',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר סבא',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ספורט',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.mamanet.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מאמאנט – ליגת אמהות לכדורשת בכפר סבא – למען הקהילה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580495455'
      },
      {
        'title': 'לוינץ-גילאי, עידית (2014). <b>המטרות להשתתפות במאמאנט</b>. אוניברסטת קולומביה בשיתוף מאמאנט. נדלה מתוך',
        'url': 'http://www.mamanet.org.il/PDF/pre-test%20Dr%20Rechter%20%D7%A7%D7%95%D7%9C%D7%95%D7%9E%D7%91%D7%99%D7%94.pdf'
      },
      {
        'title': 'עמורבן, אפרת (2013, 16 יולי). מאמאנט: צפו בלהיט החדש של ספורט הנשים. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-4405878,00.html'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '10/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2005,
    'year_registered': 2008
  },
  {
    'activity_kinds': [
      'שירותים משפטיים',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '28/05/2018'
    },
    'description': 'מבוי סתום הוקמה כעמותה (ע״ר 580268183) בשנת 1995 שמטרתה ״מתן עזרה לעגונות שנמצאות במצבים קשים. סיוע כספי, משפטי וחברתי״. העמותה קמה על בסיס פעילות אישית של לאה עין גלוב בכדי להעניק סיוע משפטי וסוציאלי לנשים מסורבות גט ועגונות. באתר הארגון נכתב כי ״הכנס הראשון התקיים בביתה בשכונת רחביה בירושלים והמשרד הראשון של הארגון התנהל מתוך מטבח ביתה. עם השנים הצטרפו לארגון נשות מקצוע ומתנדבות שליוו נשים מסורבות גט לבתי הדין ובתי המשפט וצעדו עמן לאורך כל הליך הגירושין עד להשגת הגט.״ בין השנים 2009-2018 ניהלה את הארגון עו״ד בתיה כהנא-דרור. כיום ארגון מבוי סתום הוא אחד הארגונים המרכזיים הפועלים למען נשים עגונות ומסורבות גט וגישתו משלבת טיפול אישי ופרטני יחד עם מהלכים ציבוריים לשינוי חברתי רחב. ברמה האישית הארגון מציע מגוון שירותים: ייעוץ וייצוג משפטי, תמיכה נפשית, ליווי אישי ותכניות העצמה ותרפיה. ברמה הציבורית, הארגון פועל לפתרון ולמניעת בעיית סרבנות הגט, באמצעות קידום פתרונות הלכתיים ושינויי חוקי הנישואין והגירושין בישראל, יצירת לובי אזרחי, פיתוח רשת של קשרים אסטרטגיים, העלאת קמפיינים למודעות ציבורית, חתירה לשינויי דפוסי עבודה בתוך בתי הדין הרבניים, עידוד הקמת בתי דין פרטיים ופעילות למען מינוי דיינים ראויים. \'מבוי סתום\' שואף לחברה ישראלית הוגנת יותר, שבה נשים הרוצות להתגרש לא תיתקלנה עוד במבוי סתום ובאטימות לב.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ]
    ],
    'id': 'SW10',
    'is_active': true,
    'keywords': [
      'הלכה',
      'חקיקה',
      'עגינות',
      'סרבנות גט',
      'גירושין',
      'תמיכה נפשית'
    ],
    'name': 'מבוי סתום DEAD END',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'שירותים משפטיים',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://mavoisatum.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מבוי סתום DEAD END: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580268183'
      },
      {
        'title': 'כהנא-דרור, בתיה (2011). בלי כבלים. <b>הלשכה: בטאון לשכת עורכי הדין, 91</b>, 76.'
      },
      {
        'title': 'ציון-וולדקס, תניא (2018). ״אני מאמינה בשינוי מבפנים״: אסטרטגיות של נשים יהודיות דתיות במאבק נגד סרבנות גט בישראל. <b>המזרח החדש, גיליון מיוחד</b>, 59–89.'
      },
      {
        'title': 'פישר, זהבה (2003). יותר מאלף נשים מסורבות גט היום בישראל. בהמשך לדיון על הפקעת גירושין (דעות 15, 16). <b>דעות, 17</b> (גרסת אינטרנט). נדלה מתוך',
        'url': 'https://toravoda.org.il/files/fisher.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '14/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1995,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '23/04/2019'
    },
    'description': 'מב״ט - המרכז לבריאות טרנסג׳נדרים פועל בבית החולים איכילוב משנת 2017. הוא נועד לרכז במקום אחד את כל השירותים הנדרשים לטרנסג׳נדרים העוברים תהליכי התאמה מגדרית, בניסיון לצמצם את החסמים העומדים בדרכם אל שירותים אלה ופועל מתוך גישה רב-מערכתית הקושרת בין צריכים רפואיים, נפשיים וסוציאלים. בראש המרכז עומדת ד״ר יונה גרינמן, סגנית המכון האנדוקרני, ורופאים בכירים אחרים מהמכון, אשר מספק זה שנים רבות שירותים אנדוקרניולוגים לאוכלוסיה הטרנסג׳נדרית, ביניהם ד״ר איריס יעיש וד״ר אסף אורן. המרכז מציע טיפול הורמונלי, מתן הפניות לניתוחים לשינוי מין (המבוצעים, נכון ל - 2018 רק בבית חולים תל השומר) טיפולים גניקולוגים וטיפולי שימור פריון, הערכה וטיפול פסיכו-סוציאלי, טיפול פסיכיאטרי, קבוצות תמיכה, התערבות מול גורמים משפחתיים וסיוע במיצוי זכויות מול הרשויות.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'להט״ב',
        'רווחה ובריאות'
      ],
      [
        'בריאות ופריון',
        'בריאות ומגדר'
      ]
    ],
    'id': 'LR54',
    'is_active': true,
    'keywords': [
      'טרנסקסואלים',
      'בריאות הנפש',
      'גניקולוגיה',
      'ניתוח לשינוי מין',
      'זהות מגדרית',
      'תמיכה נפשית',
      'קבוצות תמיכה'
    ],
    'name': 'מב״ט - המרכז לבריאות טרנסג׳נדרים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'רווחה ובריאות',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2019-04-23'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.tasmc.org.il/Internalmed/Endocrinology/Pages/Gender-Identity-Disorder.aspx'
      },
      {
        'title': 'יעיש, איריס (2016). <b>חדש באיכילוב: ״מבט״ – מרכז ייחודי לבריאות וטיפול בטרנסג\'נדרים</b>.נדלה מתוך',
        'url': 'https://irisyaish.co.il/%d7%97%d7%93%d7%a9-%d7%91%d7%90%d7%99%d7%9b%d7%99%d7%9c%d7%95%d7%91-%d7%9e%d7%91%d7%98-%d7%9e%d7%a8%d7%9b%d7%96-%d7%99%d7%99%d7%97%d7%95%d7%93%d7%99-%d7%9c%d7%91%d7%a8%d7%99%d7%90%d7%95%d7%aa/'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '24/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2017,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'אקטיביזם רשת'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '19/11/2018'
    },
    'description': '״מגדר״ (ISSN: 2617-4359) הוא כתב עת דיגיטלי רב תחומי ורב תרבותי שהחל לראות אור בשנת 2012. מטרתו של כתב העת לשמש במה להפצה ולהעשרה של השיח המגדרי והפמיניסטי בשפה העברית ולהעלות את המודעות לנושאים אלה. כתב העת הוא אינטרנטי מקוון, וזכויות היוצרים של המאמרים המתפרסמים בו שייכים לכותבות והכותבים. המאמרים מופיעים כקבצי PDF הניתנים להורדה. ״מגדר״ הוא יוזמה עצמאית של ד״ר יוכי שלח, מרצה בחוג לתקשורת וקולנוע במכללת סמינר הקיבוצים ושל ד״ר אורלי צרפתי, מהחוג הרב-תחומי במכללת עמק יזרעאל, ואיננו שייך לעמותה או ארגון כלשהו. קהיליית המגדר של האגודה הסוציולוגית הישראלית ושל האגודה הישראלית ללימודים פמיניסטים מעניקות לכתב העת חסות אקדמית.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'כתבי עת'
      ]
    ],
    'id': 'SA91',
    'is_active': true,
    'keywords': [
      'מחקר פמיניסטי',
      'לימודי מגדר',
      'פמיניזם'
    ],
    'name': 'מגדר- כתב עת אקדמי רב תחומי למגדר ופמיניזם',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'אקדמי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'כתבי עת',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-11-19'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://blogdebate.org/gender/journal/'
      },
      {
        'title': 'האגודה הישראלית ללימודים פמיניסטיים ולחקר המגדר (ללא תאריך). <b>מגדר, כתב עת אקדמי</b>. נדלה מתוך',
        'url': 'http://www.gendersite.org.il/%D7%9E%D7%92%D7%93%D7%A8-%D7%9B%D7%AA%D7%91-%D7%A2%D7%AA-%D7%90%D7%A7%D7%93%D7%9E%D7%99/'
      },
      {
        'title': 'מגדר- כתב עת אקדמי רב תחומי למגדר ופמיניזם (2018, 19 נובמבר). הפרטים אומתו בתכתובת דוא״ל עם ד״ר יוכי פישר.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2012,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '01/05/2020'
    },
    'description': 'מגורים לצעירות- עמותת אור השם, היא דירת מעבר אשר מופעלת על ידי עמותת ״אור השם- יהדות וחסד״ (ע״ר 580637809) אשר מפעילה גם פנימייה לנערות בסיכון בבית שמש מאז שנת 2016. דירת המעבר מופעלת בשיתוף ובפיקוח משרד הרווחה ועיריית בית שמש והיא מיועדת לצעירות מרקע דתי או חרדי בגיל 18-25 שאינן יכולות להתגורר בבית הוריהן וזקוקות לליווי לתקופת מעבר כדי שיוכלו לתפקד באופן עצמאי. משך השהייה בדירה הוא כשנה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף מוניציפלי',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'SA175',
    'is_active': true,
    'keywords': [
      'דיור',
      'תמיכה נפשית',
      'צעירות במצבי סיכון',
      'השלמת השכלה',
      'דת',
      'תעסוקה'
    ],
    'name': 'מגורים לצעירות- עמותת אור השם',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'בית שמש',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'מוניציפלי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'צעירות במצבי סיכון',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2020-05-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://5ceff6ba07e0b.site123.me/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אור השם – יהדות וחסד (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580637809'
      }
    ],
    'target_audiences': [
      'נשים חרדיות',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/05/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '19/10/2018'
    },
    'description': '״מגעים״ היה העיתון ההומו-לסבי המסחרי הראשון שפעל בישראל. הוא התפרסם במתכונת של ירחון, בין השנים 1987-1995. העיתון היה בבעלותו של מרק אריאל, אשר היה גם העורך. ״מגעים״ הופץ בחנויות ובקיוסקים בתל אביב ונשלח בדואר למנויים ברחבי הארץ. העיתון כלל כתבות תוכן, סיקור של תרבות וחיי לילה הנוגעים לקהילה, דיווחים על פעילויות האגודה לשמירה על זכויות הפרט, צילומי עירום גברי אומנותי מהארץ והעולם והצהרות תמיכה בביטול החוק לאיסור משכב זכר. בשלוש השנים הראשונות לקיומו הוא הודפס בצבע, אולם החל משנת 1990 הוא הודפס בשחור-לבן וגם כמות הדפים הצטמצמה מטעמים כלכליים. ב - 1995 הפסיק הירחון להתפרסם בשל חובות של בעליו.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'כתבי עת והוצאה לאור'
      ],
      [
        'להט״ב',
        'תרבות וספורט'
      ],
      [
        'תקשורת'
      ]
    ],
    'id': 'LR5',
    'is_active': false,
    'keywords': [
      'הומואים',
      'לסביות',
      'כתב עת'
    ],
    'name': 'מגעים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'כתבי עת והוצאה לאור',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'קניאס, יואב (2012). לקרוא בין צבעי הקשת: שיח של דיכוי, איום ואינטימיות בעיתונות ההומו-לסבית בישראל. <b>קשר, תקשורת ומחאה חברתית, 43</b>(קיץ), 100–113. נדלה מתוך',
        'url': 'https://www.jstor.org/stable/i23918726'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 1995,
    'year_closed_text': '1995',
    'year_founded': 1987,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/05/2018'
    },
    'description': 'פרויקט ״מדד הביטחון של נשים״ נוסד בשנת 2010 על ידי שישה ארגונים פמיניסטיים: כיאן-ארגון פמיניסטי, אישה לאישה- מרכז פמיניסטי חיפה, קואליציית נשים לשלום, נשים נגד אלימות, אסוואת- נשים לסביות פלסטיניות, ופרופיל חדש- תנועה לאזרוח החברה בישראל. מטרת הפרויקט היא ליצור מדד שיבחן את רמת הביטחון של נשים מקבוצות חברתיות שונות בתוך ישראל ויקיף מגוון תחומים: מגדרי, כלכלי, חברתי, פוליטי, גופני, מיני ועוד. אחת המטרות המרכזיות של המחקר היא לקדם שינוי בתפיסה של מהו ביטחון, שבישראל הוא נתפס לרוב במושגים צבאיים, ולהרחיבו לתחומים נוספים כמו ביטחון כלכלי, תחום הבריאות, אלימות במשפחה, אלימות מינית ועוד. המדד הראשון פורסם בשנת 2012 ומאז נערכים סקרים תקופתיים, קבוצות מיקוד ומחקרי ראיונות בתחומים שונים. פרסומי הקואליצייה מופיעים בעברית, ערבית ורוסית ועוסקים בסוגיות נבחרות הכוללות בין היתר, סקר על תחושת הביטחון של נשים עם מוגבלויות וסקר על תחושת הביטחון של נשים דוברות רוסית בישראל.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'צבא, ביטחון ומדיניות חוץ',
        'ביטחון אישי'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'בריאות ופריון',
        'מוגבלות'
      ]
    ],
    'id': 'SA81',
    'is_active': true,
    'keywords': [
      'אלימות',
      'ביטחון אישי',
      'ביטחון תעסוקתי',
      'מוגבלות',
      'נתונים'
    ],
    'name': 'מדד הביטחון של נשים',
    'name_ar': 'مؤشر الأمن لدى النساء',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'צבא, ביטחון ומדיניות חוץ',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'ביטחון אישי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://wsi-hebrew.blogspot.com/'
      },
      {
        'title': 'איסטושינה, אסיה וזמיר, איריס (2013). <b>ביטחון של נשים עם מוגבלויות</b>, קואליציית מדד הביטחון של נשים. נדלה מתוך',
        'url': 'http://isha.org.il/wp-content/uploads/2014/02/%D7%9E%D7%93%D7%93-%D7%94%D7%91%D7%98%D7%97%D7%95%D7%9F-%D7%A0%D7%A9%D7%99%D7%9D-%D7%A2%D7%9D-%D7%9E%D7%95%D7%92%D7%91%D7%9C%D7%95%D7%99%D7%95%D7%AA.pdf'
      },
      {
        'title': 'מדד הביטחון של נשים (2018, 5 נובמבר). הפרטים אומתו בשיחת טלפון עם אסיה איסטושינה.'
      },
      {
        'title': 'מדד הביטחון של נשים, עמוד פייסבוק (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות',
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '12/05/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2010,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '28/10/2018'
    },
    'description': 'מדרשת לינדנבאום מקורה במדרשת ברוריה שנוסדה ב-1976 ע״י הרב חיים ברובנדר בירושלים. בשנת 1986 המדרשה התמזגה עם רשת אור תורה סטון (ע.ר. 580000768) ושמה הוחלף ל-״מדרשת לינדנבאום״ על שם בלדה ומרסל לינדנבאום, תורמים של הרשת ושל המדרשה בפרט. למדרשה מספר תוכניות לימוד לנשים הכוללות לימוד תורה אינטנסיבי לפני שירות צבאי בגרעין או שירות לאומי, לאחר שירות צבאי או לאומי, הכשרת נשים לרבנות ״מנהיגות הלכתית״ (הן עושות את המבחנים לרבנות אך ללא הכרה רשמית לכך), ועוד. בשנת 2014 או 2015 המדרשה הקימה שלוחת ״מתת כרמיאל״ ובשנת 2017 את שלוחת לוד, שתיהן משלבות לימוד תורה עם עשיה קהילתית ולאחר מכן שירות צבאי בגרעין או לאומי.',
    'description_ar': null,
    'display_organization_kind': 'מוסד תורני בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'השכלה'
      ],
      [
        'נערות וצעירות',
        'דת'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'קידום נשים ושוויון מגדרי'
      ]
    ],
    'id': 'SW27',
    'is_active': true,
    'keywords': [
      'הכשרה מקצועית',
      'הלכה',
      'מנהיגות',
      'מדרשה',
      'תורה',
      'יהדות'
    ],
    'name': 'מדרשת לינדנבאום',
    'name_ar': null,
    'name_change_year': 1986,
    'name_common': null,
    'name_past': 'מדרשת ברוריה',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'מוסד תורני',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'מוסד תורני',
    'primary_sub_field_of_activity': 'השכלה',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-10-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.lind.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אור תורה סטון (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580000768/documents'
      },
      {
        'title': 'אלאור, תמר (1998). <b>בפסח הבא: נשים ואוריינות בציונות הדתית</b>. תל אביב: עם עובד.'
      },
      {
        'title': '(2017, 4 ספטמבר). מהפכת לימוד התורה לבנות מגיעה גם ללוד. <b>חדשות סרוגים</b>. נדלה מתוך: 04.09.17.',
        'url': 'https://www.srugim.co.il/213158-%D7%9E%D7%93%D7%A8%D7%A9%D7%94-%D7%9C%D7%95%D7%93-%D7%9C%D7%99%D7%A0%D7%93%D7%A0%D7%91%D7%90%D7%95%D7%9D-%D7%94%D7%AA%D7%95%D7%A8%D7%94-%D7%9C%D7%91%D7%A0%D7%95%D7%AA-%D7%9E%D7%92%D7%99%D7%A2%D7%94'
      },
      {
        'title': 'El-Or, Tamar (2002). <b>Next year I will know more: Literacy and identity among young women in Israel</b>. Translated by Haim Watzman. Detroit, MI: Wayne State University Press.'
      },
      {
        'title': 'Furstenberg, Rochelle (2000, May 1). The flourishing of higher jewish learning for women. <b>Jerusalem letter 429</b>, 1-11. Retrieved from',
        'url': 'http://www.jcpa.org/jl/jl429.htm'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '28/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1976,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '19/07/2019'
    },
    'description': '״בית מדרש לנשים - מגדל עוז״ הוקם בשנת 1997 על ידי הרבנית אסתי רוזנברג לבקשתם של ובשיתוף עם רבני ישיבת הר עציון ומכללת הרצוג - הרב אהרן ליכטנשטיין, משה מושקוביץ, וד״ר שמואל ויגודה. המדרשה מופעלת על ידי עמותת ״ישיבת הר עציון-גוש עציון״ (ע.ר.  580021939) ונמצאת בקיבוץ מגדל עוז. חזון בית המדרש מושתת על התפיסה כי גם נשים זקוקות ללימוד תורה מעמיק ומתמשך עבור החיים הדתיים והלא-דתיים שלהן, כפי שגברים. לכן, בית המדרש שואף להוות ״כולל״ לנשים למדניות שממשיכות בלימוד התורה שלהן לאורך שנים ולהצמיח כך תלמידות חכמות שמלמדות בבית המדרש ומחוצה לו, ובכלל נשים דתיות בעלות יסודות חזקים ועמוקים באמונה ובתורה שלהן. לבית המדרש תוכנית לנערות בוגרות תיכון לפני שירות צבאי או לאומי וכן תוכניות לשנות לימוד במשך. תחומי הלימוד הם גמרא, משנה, תנ״ך, מחשבת ישראל, הלכה, ועוד; וכן בית המדרש מתאפיין בתפילות מלאות השירה שלו.',
    'description_ar': null,
    'display_organization_kind': 'מוסד תורני בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'השכלה'
      ],
      [
        'נערות וצעירות',
        'דת'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'קידום נשים ושוויון מגדרי'
      ]
    ],
    'id': 'SW51',
    'is_active': true,
    'keywords': [
      'הלכה',
      'מנהיגות',
      'מדרשה',
      'תורה',
      'יהדות'
    ],
    'name': 'בית מדרש לנשים - מגדל עוז',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'מדרשת מגדל עוז',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'מגדל עוז',
    'organization_kind': [
      'מוסד תורני',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'יהודה ושומרון',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'מוסד תורני',
    'primary_sub_field_of_activity': 'השכלה',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2019-07-19'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://skamigdaloz.org/'
      },
      {
        'title': 'בית המדרש לנשים מגדל עוז, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/migdalozska/'
      },
      {
        'title': 'Rosenberg, Esti (2012). “The ‎world of women’s Torah learning – developments, directions and ‎objectives: A report from the field.” <b>Tradition: A Journal of Orthodox Jewish Thought, 45</b>(1), 13-36. Retrieved from',
        'url': 'https://www.jstor.org/stable/23264031?seq=1'
      },
      {
        'title': 'El-Or, Tamar (2002). <b>Next year I will know more: Literacy and identity among young women in Israel</b>. Translated by Haim Watzman. Detroit, MI: Wayne State University Press.'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '19/07/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1997,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '11/08/2019'
    },
    'description': '״מדרשת נעמי״ היא דירה טיפולית בירושלים שיכולה לקלוט עד 15 צעירות. השירות החל לפעול בערך בשנת 2012 ומיועד לנערות אנגלו-סקסיות מרקע חרדי בגיל 18-23 הזקוקות לשיקום חוץ-ביתי בקהילה. מאז שנת 2014 השירות ממומן על ידי השתתפות עצמית ותמיכות ממשרד הרווחה ו״ידידות טורנטו״ ומופעל על ידי עמותת ״בתי דולב לנוער״.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'SW54',
    'is_active': true,
    'keywords': [
      'צעירות במצבי סיכון',
      'נערות במצוקה',
      'אלימות',
      'הוסטל',
      'דיור',
      'העצמה כלכלית',
      'תעסוקה',
      'דת'
    ],
    'name': 'מדרשת נעמי לצעירות חרדיות בסיכון ממוצא אנגלוסקסי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'צעירות במצבי סיכון',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2019-08-12'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://dolev4u.org/jerusalem/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>בתי דולב לנוער (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580113710'
      },
      {
        'title': 'ידידות טורונטו, פרויקט ״פניניות״ (ללא תאריך). <b>מעני דיור לצעירות בנות 18–25</b>. נדלה מתוך',
        'url': 'http://www.ff-yt.org/wp-content/uploads/2018/08/pnin.pdf'
      },
      {
        'title': 'כל זכות (ללא תאריך). <b>מדרשת נעמי לצעירות חרדיות בסיכון ממוצא אנגלוסקסי</b> (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '08/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2012,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '30/10/2018'
    },
    'description': 'מדרשת עין הנצי״ב של הקיבוץ הדתי נוסדה בשנת 1986 בקיבוץ עין הנצי״ב על ידי נשים צעירות שרצו להתעמק בלימוד תורה גבוה לנשים. במדרשה תוכניות לימוד לבנות לפני שירות צבאו בגרעין או לאומי, לאחר השירות, והחל משהת 2015 שינה הכשרת לרבנות בשם ״מורות הלכה״ (הן עושות את המבחנים לרבנות אך ללא הכרה רשמית לכך).',
    'description_ar': null,
    'display_organization_kind': 'מוסד תורני בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'השכלה'
      ],
      [
        'נערות וצעירות',
        'דת'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'קידום נשים ושוויון מגדרי'
      ]
    ],
    'id': 'SW28',
    'is_active': true,
    'keywords': [
      'מדרשה',
      'תורה',
      'יהדות',
      'הלכה'
    ],
    'name': 'מדרשת עין הנצי״ב של הקיבוץ הדתי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': 'מדרשת הבנות של הקיבוץ הדתי עין הנציב',
    'name_replaced_by': null,
    'official_address': 'עין הנצי״ב',
    'organization_kind': [
      'מוסד תורני',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'מוסד תורני',
    'primary_sub_field_of_activity': 'השכלה',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-10-30'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://midrasha.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מדרשת עין הנצי״ב של הקבה״ד (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580296259'
      },
      {
        'title': 'תנועת הקיבוץ הדתי (2006, 19 פברואר). <b>עין הנצי״ב</b>. נדלה מתוך',
        'url': 'http://www.kdati.org.il/cgi-webaxy/sal/sal.pl?lang=he&ID=812319_kdati&act=show&dbid=pages&dataid=pages_891040_kdati_info_amudim_701_07.htm'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '30/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1986,
    'year_registered': 1997
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '16/07/2018'
    },
    'description': 'עמותת מהפך-תע\'ייר (ע״ר 580321685) נרשמה בירושלים כשהחלה את פעילותה בשכונת קטמון. מטרות העמותה הן: ״פעילות למען חינוך ילדים בכל הגילאים לכיוון של קבלת תעודת בגרות מלאה, להרחבת אופקים ע״י שיעורי העשרה, לדמוקרטיה וקבלת ה״אחר״ בחברה.״ כיום הכתובת העיקרית של העמותה היא בנצרת אך פעילותה מתבצעת בקהילות שונות ברחבי הארץ: טמרה, יפו ,נצרת, מע\'אר, קרית שמונה, פלורנטין (תל אביב), יד אליהו (תל אביב) וקרית יובל (ירושלים). שלושת העקרונות שעליהם מבוססת פעילות העמותה הם: פדגוגיה ביקורתית, פמיניזם ושותפות יהודית-ערבית. באתר הארגון נאמר כי מהפך- תע\'ייר ״הוא ארגון נשים יהודי-פלסטיני עממי הפועל לשינוי חברתי. העמותה שואפת לקדם שוויון הזדמנויות חברתיות, כלכליות וחינוכיות על ידי צמצום הפערים בחינוך, הערכה ותמיכה בקהילה המקומית, בפמיניזם ובשותפות היהודית-פלסטינית. באמצעות המודל שלנו אנו שואפים לצדק חברתי בחברה הישראלית, שיכלול שוויון חברתי-כלכלי, הזדמנויות חינוכיות זמינות וחברה דמוקרטית. לפיכך, הצעד הראשון הנדרש להשגת שינוי בשכונות הוא העצמה, על מנת לקיים קהילות עצמאיות המסוגלות לדרוש ולממש את זכויותיהן לגישה שווה לחינוך ולגישה שווה למשאבים ציבוריים ולזכויות אדם חברתיות וכלכליות. תהליך זה חייב לכלול מודעות חברתית ופוליטית רחבה וגוברת, המאפשרת לקהילות אלו להבין את מצבן בהקשר חברתי ופוליטי רחב יותר, ועל בסיס זה, לשתף פעולה עם מגזרים אחרים ולקחת על עצמם אחריות אישית וחברתית״.',
    'description_ar': 'جمعية تغيير (ج.م 580321685) سُجلت الجمعية في القدس مع بداية نشاطها في حارة كتامون وأهدافها هن: ״أنشطة لتعليم الأطفال من جميع الأعمار حتى الحصول على شهادة الثانوية العامة كاملة، توسيع آفاق من خلال دروس الإثراء بمبادئ الديمقراطية وتقبل ״ الآخر ״في المجتمع.״  المقر المركزي للجمعية في السنوات الأخيرة في الناصرة لكن يتوسع نشاطها في جميع انحاء البلاد. طمرة، يافا، الناصرة، المغار، كريات شمونا، فلورنتين (تل ابيب)، يد الياهو (تل ابيب) وكريات يوفال (القدس). المبادئ الثلاثة التي تقوم عليها الجمعية هم: البيداغوجيا النقدية، النسوية والشراكة اليهودية العربية. ينص موقع المنظمة على أن ״مهباخ-تغيير״ هي منظمة نسائية يهودية فلسطينية شعبية تعمل من أجل التغيير الاجتماعي. تهدف الجمعية إلى تعزيز تكافؤ الفرص الاجتماعية والاقتصادية والتعليمية من خلال تقليص الفجوات في التعليم، وتقييم ودعم المجتمع المحلي، الحركة النسائية والشراكة اليهودية- الفلسطينية.\nمن خلال نموذجنا، نسعى جاهدين لتحقيق العدالة الاجتماعية في المجتمع الإسرائيلي، والتي سوف تشمل المساواة الاجتماعية والاقتصادية، والفرص التعليمية المتاحة والمجتمع الديمقراطي. لذلك، تتمثل الخطوة الأولى المطلوبة لتحقيق التغيير هو التمكين، من أجل الحفاظ على مجتمعات مستقلة قادرة على المطالبة وممارسة حقوقها في المساواة في الحصول على التعليم وعلى المساواة في الوصول إلى الموارد العامة وحقوق الإنسان الاجتماعية والاقتصادية. يجب أن تشمل هذه العملية الوعي الاجتماعي والسياسي الواسع والمتنامي، وتمكين هذه المجتمعات من فهم وضعهم في سياق اجتماعي وسياسي أوسع، وعلى هذا الأساس، التعاون مع القطاعات الأخرى وتحمل المسؤولية الشخصية والاجتماعية. ״',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'חינוך',
        'צמצום פערים בחינוך'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ]
    ],
    'id': 'YH58',
    'is_active': true,
    'keywords': [
      'צדק חברתי',
      'פמיניזם',
      'חינוך פמיניסטי'
    ],
    'name': 'מהפך -תע\'ייר',
    'name_ar': 'مهباخ - تغيير',
    'name_change_year': 2005,
    'name_common': null,
    'name_past': 'מהפך',
    'name_replaced_by': null,
    'official_address': 'נצרת',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'חינוך',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'צמצום פערים בחינוך',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-07-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://mahapach-taghir.org/he/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מהפך (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580321685'
      },
      {
        'title': 'מהפך – تغيير, עמוד פייסבוק',
        'url': 'https://www.facebook.com/%D7%9E%D7%94%D7%A4%D7%9A-%D8%AA%D8%BA%D9%8A%D9%8A%D8%B1-173718822661352/?ref=page_internal'
      },
      {
        'title': 'מהפך -תע\'ייר (2018, 16 יולי). הפרטים אומתו בשיחה עם ח\'ולוד אידריס, מנהלת שותפה לשעבר בעמותה.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות',
      'נשים מזרחיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '09/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '14/10/2018'
    },
    'description': '‏״מובילות״ נוסדה בשנת 2013 על ידי רחלי איבנבוים ובשיתוף פעולה בין ג\'וינט ישראל, עמותת קמח ‏ומשרד הכלכלה וכוללות שותפות עם נציבות שוויון הזדמנויות בעבודה, המכון הישראלי ‏לדמוקרטיה, ארגון עולים ביחד ועמותת תמך. התכנית מעניקה לנשים חרדיות אקדמאיות מגוון כלים להשתלבות בעולם התעסוקתי. התכנית כוללת לימודים במשך כ-3 חודשים במכינה למצוינות תעסוקתית, השתלבות בתפקיד מוביל בתחומו במשק, מפגשי ליווי קבוצתיים, ליווי אישי ובהמשך השתלבות בקבוצת בוגרות. לתכנית ״מובילות״ רשת מעסיקים ידידים.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'השמה וליווי בתעסוקה'
      ],
      [
        'דת ומעמד אישי',
        'תעסוקה ועבודה'
      ]
    ],
    'id': 'YH104',
    'is_active': true,
    'keywords': [
      'קידום נשים',
      'נשות עסקים',
      'קריירה',
      'אפליה בתעסוקה'
    ],
    'name': 'מובילות- תכנית למנהיגות ומצוינות תעסוקתית לנשים חרדיות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'התארגנות שאינה עמותה',
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'השמה וליווי בתעסוקה',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2018-10-14'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.movilot.org.il/'
      },
      {
        'title': 'כהנר, לי (2018). <b>מובילות - מחקר הערכה מסכם</b>. ירושלים: המכון הישראלי לדמוקרטיה וג\'וינט ישרל-תבת. נדלה מתוך',
        'url': 'http://employment.jdc.org.il/sites/default/files/knowledge-and-training/%D7%9E%D7%95%D7%91%D7%99%D7%9C%D7%95%D7%AA%20-%20%D7%9E%D7%97%D7%A7%D7%A8%20%D7%94%D7%A2%D7%A8%D7%9B%D7%94%20%D7%9E%D7%A1%D7%9B%D7%9D.pdf'
      },
      {
        'title': 'פרקש, טלי (2014, 30 מרץ). חרדיות לעבודתן: ״כבר לא פועלות שחורות״. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-4504596,00.html'
      },
      {
        'title': 'רותם, תמר (2017, 10 דצמבר). ״תקרת הזכוכית שלנו היא מברזל״: החרדיות שיצאו לעבוד בהייטק - וגילו שלא כל הנוצץ זהב. <b>TheMarker</b>. נדלה מתוך',
        'url': 'https://www.themarker.com/themarker-women/MAGAZINE-1.4653259'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '14/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '31/12/2018'
    },
    'description': 'עמותת ״מועדון ספורט גאה תל אביב״ נוסדה בשנת 2008 במטרה להפעיל קבוצות ספורט גאות. מאז יסודה היא הפעילה קבוצת כדורעף גאה שהשתתפה בליגות המקומיות, אם כי פעילות הקבוצה לא הייתה רציפה ונפסקה למספר שנים. ב - 2014 התחלפו חלק מחברי הוועד והצטרפו אליו טל מעוז ושגיא קריספין המפעילים כיום את המועדון. ב - 2015 הוכרז על הקמה מחודשת של מועדון ספורט גאה בתל אביב, בשיתוף פעולה עם אתר WDG, פורטל הפונה לקהילה הגאה, ופעילות המועדון התרחבה בצורה ניכרת. מאז 2015 הוקמו במועדון קבוצות לשחיה, כדורגל, כדורסל, ריצה ומחניים. חבריו משתתפים במשלחות בתחרויות ספורט בארץ ובעולם, כולל אירוח טורנירים חשובים וארגון אירועי ספורט להט״בים גדולים. מרבית הקבוצות הפועלות במועדון מיועדות לגברים, אך בענפים מסוימים, כמו כדורסל, יש גם קבוצות נשים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'תרבות וספורט'
      ],
      [
        'תרבות וספורט',
        'ספורט'
      ]
    ],
    'id': 'LR37',
    'is_active': true,
    'keywords': [
      'הומואים',
      'גוף',
      'פעילות גופנית',
      'כדורסל',
      'גאווה'
    ],
    'name': 'מועדון ספורט גאה תל אביב',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'תרבות וספורט',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-12-31'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.tlvsportsclub.com/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז ספורט גאה ת״א (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580495174'
      },
      {
        'title': 'מועדון ספורט גאה ת״א, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/tlvsport/'
      },
      {
        'title': 'כ״ץ, ישראל, מעוז, עדי, אלפסי, דנה, לוי, ניר (2018). <b>מיפוי ארגוני הלהט״ב בישראל - דו״ח מסכם</b>. האגודה למען הלהט״ב ואלכא – המכון למנהיגות וממשל בג\'וינט ישראל, ירושלים. נדלה מתוך',
        'url': 'https://a9991848-b055-4c6f-a966-a6bdabf09321.filesusr.com/ugd/be9e5d_e13bb06adc274327b97bb41c199efc0c.pdf'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '31/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2008,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '09/02/2018'
    },
    'description': '״מועצת ארגוני הנשים בישראל״ נוסדה בשנת 1953 כארגון גג של ארגוני הנשים בישראל. בשיא פעילותה היא ייצגה כחצי מיליון נשים שהיו מאוגדות תחת ארגוני הנשים החברות במועצה. על פי המתואר בארכיון המדינה, המועצה נוסדה במטרה לפעול לקידום מעמדן ורווחתן של האישה והמשפחה בישראל, להעמיק את שיתופן של הנשים בתחומי העשייה בישראל, למען שוויון בין המינים, להקמת מסגרות הולמות לילדים ולקידום חקיקה בעניין מעמד האישה ורווחת המשפחה. תפקיד נוסף של המועצה היה לייצג את ישראל בגופים ובפורומים בינלאומיים, לשמש כתובת למוסדות אלו בארץ ולהשמיע את קולה של האישה הישראלית בעולם, במוסדות האו״ם ובארגוני הנשים הבינלאומיים שהמועצה חברה בהם הכוללים את ה-International Council of Jewish Women (ICJW); International Council of Women (ICW-CIF); European Centre of the International Council of Women (ECICW). למועצה מספר ועדות העוסקות בתחומים שונים כגון: קידום מעמד האישה, חינוך ומשפחה, בריאות ואיכות הסביבה, קידום חקיקה, קשרי חוץ, הסברה ודו-שיח בין דתי ובין תרבותי. הארגונים החברים במועצת ארגוני הנשים בישראל הם: נעמ״ת, ויצו, אמונה, הסורופטימיסטיות, הדסה ישראל, בנות ברית ישראל, איגוד נשים אקדמאיות ונשות אורט ישראל. תפקיד הנהגת המועצה מתחלק בין הארגונים המובילים ויצו, נעמ״ת ואמונה.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'כללי'
      ]
    ],
    'id': 'SA51',
    'is_active': true,
    'keywords': [
      'קידום נשים',
      'חינוך',
      'משפחה',
      'בריאות',
      'חקיקה',
      'קשרי חוץ',
      'שיתוף פעולה בינלאומי'
    ],
    'name': 'מועצת ארגוני הנשים בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'מועצת ארגוני הנשים, תיק מסמכים מתאריך 01/01/1963 עד תאריך 31/12/1967. ארכיון המדינה (תיק סרוק) מס\' תיק: ISA-NonGovernment-WomenOrgCncl-000b2jw.'
      },
      {
        'title': 'מועצת ארגוני הנשים בישראל, עמוד פייסבוק (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '09/02/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '20/09/2018'
    },
    'description': 'מועצת הנשים בבת ים הוקמה בשנת 2002 על ידי ויקי יוחנן כפרוייקט סיום קורס מנהיגות נשים תל-אביב יפו ונרשמה כעמותה (ע״ר 580457117) ב-2006. המועצה פועלת לשיפור מעמדן וקידומן של נשים ונערות ומעודדת, להעצמתן וליצירת מפגשים ורשתות חברתיות ביניהן. בין היתר מקדמת המועצה קורסי העצמה, יזמות עסקית, שיתופי פעולה עם פרלמנט הנשים ופרלמנט הנערות שנוסד בעיר ועם המועצה הלאומית לקידום ספורט נשים ״אתנה״, הקמת טורניר ״כדורשת״ נשים, היכרויות עם מעגלי נשים בישראל ובהן נשים דרוזיות וערביות, קידום נשים בספורט ועוד. בראש המועצה מכהנת כיום (2019) ענת לבנת שהיא גם היועצת לקידום מעמד האישה בעירייה ויו״ר איגוד היועצות למעמד האישה ברשויות המקומיות.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'YH91',
    'is_active': true,
    'keywords': [
      'העצמה',
      'רישות',
      'רשות מקומית',
      'קורסים',
      'קהילה',
      'שוויון מגדרי'
    ],
    'name': 'מועצת הנשים בבת ים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'בת ים',
    'organization_kind': [
      'מוניציפלי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מועצת הנשים בבת-ים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580457117'
      },
      {
        'title': 'מועצת נשים בת ים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pg/nasimbatyam/about/?ref=page_internal'
      },
      {
        'title': 'עיריית בת ים (ללא תאריך). <b>מועצת נשים</b>. נדלה מתוך',
        'url': 'https://www.bat-yam.muni.il/info.php?id=3350'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '29/10/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2002,
    'year_registered': 2006
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/01/2020'
    },
    'description': 'מועצת הנשים במועצה האזורית מרחבים הוקמה בשנת 2013. חזון המועצה: ״שוויון הזדמנויות בין המינים בכל התחומים וצמצום פערים. מועצת הנשים תפעל במטרה להעלות את המודעות לנושא, תפעיל תוכניות, ימי עיון ואירועים לקידום מעמד האישה ותקיים שולחנות עגולים בכל יישוב. המועצה תפעל למען ייצוג הולם של נשים בעמדות מפתח המשפיעים על איכות חיינו.המועצה תעודד העצמה נשית דרך שיח וסדנאות.\nהמועצה תטפח מנהיגות נשים ונערות.המועצה תעניק אוזן קשבת לצרכי הנשים בכל ישובי המועצה ותפעל לקידומם״.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'YH198',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'הטמעת חשיבה מגדרית',
      'ספורט',
      'אמהות',
      'חד-הוריות',
      'שוויון מגדרי'
    ],
    'name': 'מועצת הנשים במועצה האזורית מרחבים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'מועצת הנשים במרחבים',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'מועצה איזורית מרחבים',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2020-01-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.merchavim.org.il/%D7%9E%D7%95%D7%A2%D7%A6%D7%AA-%D7%94%D7%A0%D7%A9%D7%99%D7%9D/'
      },
      {
        'title': 'מועצת הנשים במרחבים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/%D7%9E%D7%95%D7%A2%D7%A6%D7%AA-%D7%94%D7%A0%D7%A9%D7%99%D7%9D-%D7%91%D7%9E%D7%A8%D7%97%D7%91%D7%99%D7%9D-1420514864887216/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '01/01/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/12/2018'
    },
    'description': 'העמותה נועדה לשמש כסניף הישראלי של אחד מארגוני הנשים הבינלאומיים הוותיקים ביותר בעולם אשר נקרא: International Council of Women (נוסד בשנת 1888). מטרות העמותה שנרשמה בשנת 1996 (ע״ר 580295723) היו: ״להביא את משרד I.C.W. המועצה הבינלאומית של נשים, לירושלים לשנים 2000-1997. להביא להדברות בין נשים מ-76 מדינות מכל חלקי התבל, בדרכי שלום. לקדם את מעמדה ורווחתה של האישה באמצעות תכניות חינוכיות ופרויקטים״. מי שעמדה בראש הסניף הישראלי ודחפה להקמת העמותה היתה פנינה הרצוג, אלמנתו של ד״ר יעקב הרצוג, שהיה מנכ״ל משרד ראש הממשלה בתקופת כהונתם של לוי אשכול וגולדה מאיר. הרצוג כיהנה בתפקידים ציבוריים רבים, ובהם סמנכ״ל משרד הבריאות, נשיאת מועצת ארגוני הנשים הבינלאומית, סגנית נשיא של ארגון הבריאות העולמי של האו״ם ונשיאת ״אמונה״ - תנועת האשה הדתית הלאומית. בין מייסדות העמותה נרשמו גם: שושנה נתניהו (דודתו של רה״מ בנימין נתניהו), לאה לנדוי, יוסף הדני, דליה גותן, אליזבת פידקמינר ודוד ברטוב. בארכיון המדינה הופקד תיק מעזבונה של פנינה הרצוג שנפטרה בשנת 2005 אשר כולל התכתבויות עם משרד ראש הממשלה בנושאים שונים הקשורים לעמותת I.C.W: בקשה להקמת העמותה, הקמת משרד העמותה בירושלים, הקצאה כספית של משרד רה״מ לעמותה ועוד. מספר התיק: ISA-Privatecollections-PninaHerzog-000zd4e',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'SA106',
    'is_active': false,
    'keywords': [
      'שיתוף פעולה בינלאומי',
      'שלום',
      'חינוך',
      'קידום נשים'
    ],
    'name': 'מועצת הנשים הבינלאומית (אי.סי דאבליו. 2000 - .I.C.W)',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-12-24'
    },
    'sources': [
      {
        'title': 'International Council of Women (official website)',
        'url': 'http://www.icw-cif.com/'
      },
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>מועצת הנשים הבינלאומית (אי.סי.דאבליו. 2000 – .I.C.W)</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'ברקת, עמירם (2005, 23 ינואר). מתה פנינה הרצוג, פעילת ציבור. <b>הארץ</b>. נדלה מתוך',
        'url': 'https://www.haaretz.co.il/misc/1.1495328'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 5639 (2007, 8 מרץ). <b>הודעה מוקדמת בדבר מחיקה מפנקס העמותות</b>. מועצת הנשים הבינלאומית (אי.סי דאבליו. 2000 - .I.C.W) (מספר עמותה 580295723). עמ\' 1957. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_word/law10/yalkut-5639.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/12/2018'
    },
    'year_closed': 2007,
    'year_closed_text': '2007',
    'year_founded': 1996,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '14/10/2018'
    },
    'description': 'את מועצת הנשים העירונית ברעננה ייסדה רינה בר-טל ב-1991 בעת כהונתה כסגנית ראש העיר. המועצה מוגדרת כגוף עירוני הכולל נציגות של הגופים הפוליטיים הפועלים בעיר, של ארגוני הנשים והמוסדות המטפלים בנשים ברעננה ושל נשים בכל מגזרי האוכלוסייה, המסייעות בהתנדבות לקידום נושאי נשים בקהילה. המועצה מתכנסת אחד לחודשיים, דנה בצרכים שונים של נשות העיר ומציעה פתרונות לפעולה. בנוסף, המועצה יוזמת ועורכת, בשיתוף עם ארגוני הנשים השונים בעיר, אירועים ופעילויות שונות למען הקהילה, כמו קורסים והרצאות בנושאים שונים, קידום מנהיגות נשים, סדנאות בנושאי תקציב ויזמות עסקית, שבוע האישה הבינלאומי, פורומים בהשתתפות נשים בתחומים שונים ועוד.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'YH107',
    'is_active': true,
    'keywords': [
      'העצמה',
      'יועצות לקידום מעמד האשה',
      'מנהיגות',
      'פנאי',
      'רשות מקומית',
      'קידום נשים',
      'קליטת עליה',
      'תעסוקה'
    ],
    'name': 'מועצת הנשים העירונית רעננה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רעננה',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-14'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.raanana.muni.il/Residents/Audiences/Women/Pages/women.aspx'
      },
      {
        'title': 'מועצת הנשים העירונית רעננה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/RaananaWomensCouncil/'
      },
      {
        'title': 'רינה בר-טל. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%A8%D7%99%D7%A0%D7%94_%D7%91%D7%A8-%D7%98%D7%9C'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '23/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1991,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/11/2020'
    },
    'description': 'מועצת הנשים באופקים הוקמה בשנת 2016 במסגרת קורס מנהיגות את המחר של עמותת כ״ן. המועצה בין היתר בנושאים של קידום נשים, הנגשת קורסים, טיפול באלימות נגד נשים, הרצאות, סרטים וסדנאות. ב-2018 צורפו נציגות מועצת הנשים כנציגות ציבור בוועדות העירייה.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'YH207',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'העצמה',
      'אלימות'
    ],
    'name': 'מועצת נשים אופקים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'אופקים',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'מרכז אישה אופקים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/sim225555/'
      },
      {
        'title': 'עיריית אופקים. מועצת העיר (2018, 6 מרץ). <b>פרוטוקול מס\' 68: ישיבת מועצת העיר</b>. נדלה מתוך',
        'url': 'https://www.ofaqim.muni.il/uploads/n/1559213187.9492.pdf'
      },
      {
        'title': 'ריאיון עם שולה דהן, יועצת למעמד האישה באופקים באתר איגוד היועצות לקידום מעמד האישה ולשוויון מגדרי (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '01/11/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/02/2020'
    },
    'description': 'מועצת הנשים העירונית באשקלון הוקמה בשנת 1993 ע״י ד״ר תמר הנר. בראש המועצה עומדות כיום סגנית ראש העיר והממונה על קידום מעמד האישה, סופה ביילין, יועצת ראש העיר לקידום מעמד האישה, איריס ליבוביץ ויו״ר מועצת הנשים העירונית, ד״ר תמר הנר. המועצה פועלת לקידום מעמד האישה בעיר אשקלון במגוון תחומים לרבות מנהיגות חברתית, תעסוקת נשים, הכנה למכרזים, מורשת בהיבט נשי, קידום אורח חיים בריא, חודש האישה הבינ“ל, מניעת אלימות כנגד נשים ונערות, נשות עסקים וקריירה, איזון בין קריירה להורות, אימהות משמעותית ועוד. ע״פ עמוד הפייסבוק של המועצה: ״דרכה של הנהלת מועצת הנשים היא דרך הפמיניזם הליברלי, פמיניזם שאינו חולק על עיקרי הסדר החברתי הקיים, אלא מבקש לשנות את התנאים היוצרים אפליה ואי שוויון הזדמנויות לנשים״.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תעסוקה ועבודה',
        'השמה וליווי בתעסוקה'
      ]
    ],
    'id': 'YH201',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'ייצוג הולם',
      'תעסוקת נשים מבוגרות',
      'אלימות',
      'הדרת נשים',
      'הטרדות מיניות',
      'בריאות'
    ],
    'name': 'מועצת נשים אשקלון',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'אשקלון',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'מועצת הנשים עיריית אשקלון, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/ashkelon.womencouncil/'
      },
      {
        'title': 'מרכז אדווה, מרכז אינג\'אז, המשרד לקידום מעמד האישה – עיריית אשקלון ואיגוד היועצות לקידום מעמד האישה (2015). <b>התכנית להטמעת שוויון מגדרי ברשויות המקומיות: סיכום פרויקטים של קבוצת אשקלון 2014/15</b>. נדלה מתוך',
        'url': 'https://adva.org/wp-content/uploads/2015/12/Ashkelon-1.pdf'
      },
      {
        'title': 'עיריית אשקלון. מועצת העיר (2011, 7 ספטמבר). דו״ח מועצת הנשים לשנת 2010. <b>פרוטוקול מועצה מן המניין מס\' 2011־39</b> (עמ\' 8–12). נדלה מתוך',
        'url': 'http://www.ashkelon.muni.il/service/DocLib/%D7%99%D7%A9%D7%99%D7%91%D7%95%D7%AA%20%D7%9E%D7%95%D7%A2%D7%A6%D7%94/2011/39%20-%2039-11%20%D7%A4%D7%A8%D7%95%D7%98%D7%95%D7%A7%D7%95%D7%9C%20%D7%9E%D7%95%D7%A2%D7%A6%D7%94%20%D7%9E%D7%9F%20%D7%94%D7%9E%D7%A0%D7%99%D7%99%D7%9F%20%D7%9E-7.9.11.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '01/02/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1993,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/08/2020'
    },
    'description': 'במרץ 2015 התקיים בבית ג\'ן כנס בהשתתפות 100 נשים תושבות הכפר ואורחות מכפרים בסביבה. הכנס נפתח בהכרזת היועצת היבה סלאלחה על הקמת מועצת הנשים. כחודשיים לאחר מכן החלה לפעול מועצת הנשים והיא מונה כ-45 נשים המייצגות את הקבוצות השונות בכפר.',
    'description_ar': 'في مارس 2015 أقيم في بيت جن مؤتمر بمشاركة 100 امرأة من البلدة وضيوف من القرى القريبة. بحيث انطلق المؤتمر بإعلان المستشارة هبة صلالحة عن تأسيس مجلس النساء. وبعد شهرين انطلق عمل المجلس ويشمل 45 امرأة يمثلن نساء القرى المختلفة.',
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'YH205',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'הטמעת חשיבה מגדרית',
      'קידום נשים'
    ],
    'name': 'מועצת נשים בית ג\'ן',
    'name_ar': 'مجلس نساء بيت جن',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'בית ג\'ן',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'סטרול, מיטל (2016). <b>התכנית להטמעת שוויון מגדרי ברשויות המקומיות: פרויקטים של קבוצת מנהיגות נשים נעמת מרחב מרכז הגליל 2013–2015</b>. מרכז אדוה, נעמת, אינג\'אז ואיגוד היועצות לקידום מעמד האשה.',
        'url': 'https://adva.org/wp-content/uploads/2016/02/Galil.pdf'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '01/08/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/05/2020'
    },
    'description': 'מועצת הנשים במועצה האזורית חוף הכרמל הוקמה בשנת 2004 במטרה לעודד ולכוון לשיוויון בין המינים, מתן הזדמנות לביטוי ופעילות שווה בכל העשייה. מועצת הנשים מורכבת מנציגות מישובים שונים הפועלות בהתנדבות. בראש המועצה עומדת היועצת למעמד האישה ירדן קינן. \nמטרות מועצת הנשים: פריצת תקרת הזכוכית, שילוב נשים בוועדים ובצמתים של קבלת החלטות הנוגעות לכל התושבים במועצה, הגדלת מספר נבחרות הציבור במליאת המועצה, הגברת המודעות לחשיבות שילוב נשים במוקדי השפעה בקהילה, העלאת מעורבות הנשים בחיי הקהילה, הרחבת מאגר הידע על נשים והובלת מיזמים לקידום נשים באזור. \nהמועצה עסקה בין היתר בהעלאת מודעות נשים לסוגיות של בריאות, לקידום נשים בעסקים ותמיכה באמהות ותינוקות (פרויקט אם לאם). המועצה פועלת באמצעות אירועים, ימי עיון הרצאות וקורסים.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'YH204',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'שוויון בין המינים',
      'ייצוג הולם'
    ],
    'name': 'מועצת נשים במועצה אזורית חוף הכרמל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'מועצה איזורית לכיש',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2020-05-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.hof-hacarmel.co.il/%D7%9E%D7%95%D7%A2%D7%A6%D7%AA_%D7%A0%D7%A9%D7%99%D7%9D'
      },
      {
        'title': 'מועצת נשים חוף הכרמל – הקבוצה, קבוצת פייסבוק.',
        'url': 'https://www.facebook.com/groups/474231912638893/?fref=ts'
      },
      {
        'title': 'מועצת נשים במועצה אזורית חוף הכרמל (2020, 5 ינואר). הפרטים אומתו בתכתובת דוא״ל עם נציגת מועצת הנשים במועצה האזורית חוף הכרמל.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '01/05/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/09/2020'
    },
    'description': 'מועצת הנשים במועצה האיזורית לכיש הוקמה בשנת 2016. כיו״ר המועצה מכהנת היועצת לקידום מעמד האישה סופיה וקנין. חזון מועצת הנשים כפי שהוא מופיע באתר של המועצה האיזורית לכיש: \n״שוויון הזדמנויות בין המינים בכל התחומים וצמצום פערים. מועצת הנשים תפעל במטרה להעלות את המודעות לנושא ,תפעיל תוכנית , ימי עיון , קורסים ואירועים לקידום מעמד האישה ותקיים מארחים בכל היישובים . המועצה תפעל למען ייצוג הולם של נשים בעמדות מפתח המשפיעים על איכות חיינו . המועצה תעודד העצמה נשית דרך שיח וסדנאות . המועצה תטפח מנהיגות נשים .\nהמועצה תעניק אוזן קשבת לצורכי הנשים בכל יישובי המועצה״.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'YH206',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'שוויון בין המינים',
      'ייצוג הולם',
      'העצמה'
    ],
    'name': 'מועצת נשים במועצה האזורית לכיש',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'מועצה איזורית לכיש',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2020-09-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://lachish.org.il/%D7%9E%D7%95%D7%A2%D7%A6%D7%AA-%D7%A0%D7%A9%D7%99%D7%9D-%D7%95%D7%9E%D7%A2%D7%9E%D7%93-%D7%94%D7%90%D7%99%D7%A9%D7%94/'
      },
      {
        'title': 'מועצת נשים מ.א.לכיש, קבוצת פייסבוק.',
        'url': 'https://www.facebook.com/groups/1879442308951000/about'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '01/09/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/02/2020'
    },
    'description': 'מועצת נשים הוד השרון הוקמה ב-2010 על ידי יפעת קריב שכיהנה אז כחברת מועצה, בסיוע עמותת כ״ן. המועצה פעלה ללא תמיכה תקציבית מהעירייה והחברות בה היו כולן תושבות העיר, מתנדבות ופעילות חברתית, מתחומי עניין שונים ומגוונים. המועצה פעלה בעיקר באמצעות הרצאות, ימי עיון והכשרות למשל - קורס הכשרת נשים לפוליטיקה המוניציפאלית ולתפקידי מנהיגות. אין עדות לפעילות המועצה אחרי 2013 וככל הנראה היא אינה פעילה יותר.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'YH200',
    'is_active': false,
    'keywords': [
      'רשות מקומית',
      'מנהיגות'
    ],
    'name': 'מועצת נשים הוד השרון',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'הוד השרון',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'לוקאל (2010, 6 ספטמבר). הקמת מועצת הנשים. <b>קול הכפר</b> (העמוד אינו זמין יותר).'
      },
      {
        'title': 'לוקאל (2012, 25 נובמבר). פתיחת קורס הכשרת נשים לתפקידי מנהיגות (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '01/02/2020'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 2010,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '12/12/2019'
    },
    'description': 'מועצת נשים חדרה החלה לפעול במרץ 2001 לאחר שחוקקה הכנסת את חוק הרשויות המקומיות (חובת מינוי יועצת למעמד האשה-2000). מאז, פועלת מועצת הנשים לסירוגין ועוסקת בנושאים שונים. יו״ר המועצה היתה חברת מועצת העיר ויו״ר נעמת בעיר ובעת הקמת המועצה השתתפו בה עשרות נשים בעלות תפקידים בכירים בארגוני נשים, עסקים ובקהילה. תקציב המועצה הועמד על כ-100 אלף ש״ח בשנה. מועצת הנשים המקורית כללה ארבע ועדות אשר נפגשו באופן קבוע: ועדת רווחה ובריאות שהתמקדה בנושא אלימות נגד נשים, בריאות האישה, נשים במשפחות חד הוריות ונשים בגיל השלישי; ועדת חינוך וספורט שעסקה בקידום שוויון מגדרי במערכת החינוך; ועדת אירועים שיזמה ארועי תרבות וסדנאות לקידום מעמד האשה; וועדה לשיפור חזות העיר שיזמה פרויקטים לשיפור תדמית העיר, הגברת הביטחון האישי ולמען איכות הסביבה. פעילויותה של המועצה בשנים הראשונות לקיומה כללו דיונים מעמיקים בבעיות עירוניות ודרישה לפתרונות בתחום התאורה, בטיחות, שיפוץ חזיתות וכיוב; השתלמויות וקורסים לחברות מועצה ותלמידות בבתי ספר; הגדלת תקציבים לספורט נשים; הכשרת סייעות לגננות בנושא שוויון בין המינים; הענקת מלגות; קיום ארועים לכבוד יום האשה הבינלאומי ועצרות לציון יום המאבק באלימות כלפי נשים; הפקת עלוני מידע על זכויות נשים בשפות שונות; תמיכה בנשים חד-הוריות ועוד. בשנת 2003 זכתה עיריית חדרה בציון לשבח מאת נשיא המדינה על פעילותה לקידום נשים והשגיה של מועצת הנשים.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'SA170',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'חינוך',
      'ספורט',
      'בריאות'
    ],
    'name': 'מועצת נשים חדרה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חדרה',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'אמדור, מיכל (2002). מועצת נשים בחדרה: מודל בשיתוף נשים בשלטון המקומי. <b>מפנה: במה לענייני חברה, 38</b>, 37–40.'
      },
      {
        'title': 'אזרחי, מירית (2003, 7 יולי). צל״ש על קידום וטיפוח המעמד הנשי בעיר. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-2684174,00.html'
      },
      {
        'title': 'איגוד היועצות לקידום מעמד האישה ושוויון מגדרי (ללא תאריך). <b>סיפורה של רויטל פוקס, יועצת ראש העיר חדרה למעמד האשה</b> (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '12/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2001,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '12/11/2019'
    },
    'description': 'חיפה הייתה הראשונה בה הוקמה מועצת נשים ליד ראש העיר אשר היוותה דגם חיקוי עבור מועצת נשים נוספות בארץ. בהחלטה על הקמתה של המועצה בשנת 1974 נקבע כי ״המועצה תראה תעודתה להפעיל וליזום מעורבות נשים בפעילות אזרחית וציבורית הן בדרג של קבלת ההחלטות והן בדרג של ביצוע פעולות התנדבותיות״ (מתוך החלטת הנהלת עירית חיפה 17.3.74). בראש המועצה עמדה פרופ\' מרים בן-פרץ שכיהנה כחברת מועצת העיר חיפה ואחריה אילנה צרדנברודה, חוה קופלביץ, רותי אשכנזי, חנה שרודק וביאטריס רוזן. מאז הקמתה, מועצת הנשים שליד ראש העיר מצויה בקשרים עם ארגוני הנשים בעיר, מרכז גולדה מאיר ואוניברסיטת חיפה ומפעילה תוכניות לקידום תעסוקת נשים, השכלה, העצמת נערות, מנהיגות בקהילה ופעילות בתחום מניעת האלימות נגד נשים.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'SA167',
    'is_active': true,
    'keywords': [
      'העצמה',
      'יועצות לקידום מעמד האשה',
      'מנהיגות',
      'רשות מקומית',
      'קידום נשים',
      'תעסוקה',
      'אלימות'
    ],
    'name': 'מועצת נשים חיפה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-11-12'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.haifa.muni.il/Services/Moatza/women/Pages/default.aspx'
      },
      {
        'title': 'גודיץ\'-אברם, קלודיה (2002). ״פוליטיקה חדשה אי שוויון ישן? - מועצות נשים ליד ראש העיר ברשויות המקומיות בישראל: המקרה החיפאי״, <b>חקר מגדר בארץ</b>, 9–19.'
      },
      {
        'title': 'יעל רום (1994). <b>מועצות ציבוריות של נשים ליד ראשי רשויות מקומיות: דברים שרצית לדעת</b>. ירושלים: שדולת הנשים בישראל.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '12/11/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1974,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '14/01/2020'
    },
    'description': 'מועצת הנשים בטמרה החלה לפעול בשנת 2000 לאחר שחוקקה הכנסת את חוק הרשויות המקומיות (חובת מינוי יועצת למעמד האשה-2000). בשנת 2004, הוקמה עמותה בשם ״מועצת נשים טמרה״ (ע״ר 580426146) על ידי סלוא כנעאן, יועצת ראש העיר למעמד האשה. מטרות העמותה הן: ״העלאת המודעות לזכויות הנשים והשתתפות בקבלת החלטות. קידום מעמד האישה בטמרה בכל התחומים.״ העמותה ארגנה פעילויות פנאי וטיולים להכרת הארץ וגם חילקה מזון למשפחות נזקקות. מאז שנת 2013 העמותה איננה פעילה אך מועצת הנשים ממשיכה להתקיים ומציעה מגוון שירותים לנשים הכולל סדנאות, חוגים, הרצאות וכנסים בנושאים של תעסוקה ויזמות עסקית.',
    'description_ar': 'انطلق نشاط مجلس نساء طمرة في عام 2000 بالتزامن مع سن قانون المجالس المحلية (الالتزام بتعيين مستشارة لتعزيز مكانة المرأة-2000). في عام 2004 تأسست جمعية ״مجلس نساء طمرة״ (ج.م 580426146) بمبادرة من سلوى كنعان، مستشارة البلدية لمكانة المرأة. أهداف الجمعية هن: ״رفع الوعي حول حقوق النساء ومشاركتهن في اتخاد القرارات. تعزيز مكانة المرأة في طمرة على جميع الأصعدة.״ نظمت الجمعية نشاطات ترفيهية مختلفة وجولات للتعرف على البلاد بالإضافة لتوزيع طرود غذائية للعائلات المحتاجة. منذ عام 2013 توقف نشاط الجمعية الا ان مجلس المرأة في طمرة استمر في عمله ويعرض خدمات مختلفة ومتنوعة للنساء تشمل ورشات، دورات محاضرات ومؤتمرات في مواضيع التوظيف والمبادرات التجارية.',
    'display_organization_kind': 'מוניציפלי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'SA182',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'פנאי',
      'העצמה'
    ],
    'name': 'מועצת נשים טמרה',
    'name_ar': 'مجلس النساء طمرة',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'טמרה',
    'organization_kind': [
      'מוניציפלי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2020-01-14'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.tamra.muni.il/%D7%9E%D7%95%D7%A2%D7%A6%D7%AA-%D7%94%D7%A2%D7%99%D7%A8/%D7%9E%D7%95%D7%A2%D7%A6%D7%AA-%D7%A0%D7%A9%D7%99%D7%9D/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מועצת נשים טמרה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580426146'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '14/01/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': 2004
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/04/2020'
    },
    'description': 'מועצת נשים יישובית ברמת השרון נוסדה בשנת 2000 ביוזמתה של ד״ר ברכה תקוה במטרה להעצים נשים ולסייע להן בבניית עסקים ובייעוץ משפטי. במועצת הנשים משתתפות למעלה מ-80 תושבות העיר. המועצה פועלת בין היתר באמצעות ארגון אירועים, קידום נשים בעסקים בין היתר באמצעות קורסים לדירקטוריות ומיזם ליצירת רשת לנשים עצמאיות וכן באמצעות שיתופי פעולה עם יחידות אחרות במועצה למשל: פרויקט ״החודש העשירי״ - ליווי נשים צעירות לאחר לידה, בשיתוף המרכז להתנדבות ושיתופי פעולה עם היחידה לטיפול בנערות וצעירות. פרויקט הדגל של המועצה נקרא ״אישה למען אישה״ והוא מתקיים בשיתוף אגף הרווחה בעירייה. מטרתו של הפרויקט: להעניק עזרה מוראלית ופיזית לנשים שחוו אלימות במשפחה. במסגרת הפרויקט, מתנדבות ממועצת הנשים עוברות הכשרה ע״י עובדות סוציאליות, על מנת שתוכלנה לתת תמיכה וסיוע.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YH203',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'העצמה',
      'נשים מוכות',
      'תמיכה נפשית',
      'ייצוג הולם',
      'נשות עסקים',
      'יזמות עסקית',
      'רישות'
    ],
    'name': 'מועצת נשים יישובית רמת השרון',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת השרון',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2020-04-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://ramat-hasharon.muni.il/%D7%9E%D7%95%D7%A2%D7%A6%D7%AA-%D7%A0%D7%A9%D7%99%D7%9D-%D7%99%D7%A9%D7%95%D7%91%D7%99%D7%AA/'
      },
      {
        'title': '(2016, 25 אוגוסט).ידיעה על התפטרותה של של עדנה חרותי אשר כיהנה במשך שנים רבות כיו״ר המועצה. <b>הוד הכפר</b> (העמוד אינו זמין יותר).'
      },
      {
        'title': '(2011, 15 מרץ). ״אישה למען אישה״ - פרויקט הדגל של מועצת הנשים. <b>הוד הכפר</b> (העמוד אינו זמין יותר).'
      },
      {
        'title': 'עיריית רמת השרון, דוח לתושב 2018 (2018). <b>מועצת נשים יישובית</b>. נדלה מתוך',
        'url': 'http://ramat-hasharon.mag.calltext.co.il/magazine/115/articles/2592'
      },
      {
        'title': 'עיריית רמת השרון (2019). <b>יקירת העיר רמת השרון לשנת 2019 – ד״ר ברכה תקוה</b>. נדלה מתוך',
        'url': 'https://ramat-hasharon.muni.il/%d7%99%d7%a7%d7%99%d7%a8%d7%aa-%d7%94%d7%a2%d7%99%d7%a8-%d7%a8%d7%9e%d7%aa-%d7%94%d7%a9%d7%a8%d7%95%d7%9f-%d7%9c%d7%a9%d7%a0%d7%aa-2019-%d7%93%d7%a8-%d7%91%d7%a8%d7%9b%d7%94-%d7%aa%d7%a7%d7%95/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '01/04/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות',
      'שירותים משפטיים'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '10/09/2018'
    },
    'description': 'מועצת נשים כפר סבא הוקמה לראשונה ב-2001 על ידי סגנית ומ״מ ראש העיר דאז, רינה פז ובמשך השנים התרחבה והשתנתה פעילותה. המטרות העיקריות של המועצה היו להרחיב את המעורבות של נשים תושבות העיר בתהליכי קבלת החלטות ברמה המקומית ולספק להן שירותים ייעודיים. ב-2009 הוקם בית מועצת הנשים בכפר סבא. ביולי 2018 הוקמה ביוזמת המועצה ספרייה פמיניסטית באחד מבתי הספר היסודיים בעיר. המועצה היא גוף התנדבותי הפועל בשיתוף פעולה עם העירייה ובעיקר עם היועצת למעמד האישה. תכניות העבודה נכתבות במשותף. העירייה מתקצבת (נכון ל-2015) את המועצה ב-200 אלף ש״ח והממשלה ב-150 אלף נוספים על פרויקטים של מגדר בחינוך. המועצה פועלת בארבעה תחומים עיקריים: מגדר (כולל תכניות למגדר בחינוך), משפחה (בעיקר תכניות תמיכה באמהות, כול אמהות אחרי לידה), קהילה (כולל ייעוץ משפטי ראשוני ללא עלות לתושבות העיר בתחומי דיני עבודה ומעמד אישי וכן מפגשים קבועים של בלוגריות שכותבות על מועצת הנשים) וקריירה (מועדון עסקים, קידום עסקים קטנים ותכניות מנטורינג).',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'חינוך',
        'פמיניזם ושוויון בין המינים'
      ]
    ],
    'id': 'YH99',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'שוויון מגדרי',
      'סיוע משפטי',
      'קידום נשים',
      'סיוע לאמהות',
      'חינוך מגדרי'
    ],
    'name': 'מועצת נשים כפר סבא',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר סבא',
    'organization_kind': [
      'מוניציפלי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.kswomen.co/'
      },
      {
        'title': 'עיריית כפר סבא (2000, 13 אוגוסט). <b>יישום חוקים בעיריית כפר סבא - היועצת למעמד האישה והחוק למניעת הטרדה מינית</b>. נדלה מתוך',
        'url': 'https://www.kfar-saba.muni.il/_Uploads/dbsAttachedFiles/yisum.pdf'
      },
      {
        'title': 'מועצת נשים כפר סבא, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/kswomen/'
      },
      {
        'title': 'מערכת ערוץ הנשים (2018, 9 יולי). נפתחה הספרייה הפמיניסטית הראשונה בישראל. <b>Mako</b>. נדלה מתוך',
        'url': 'https://www.mako.co.il/women-agenda/Article-d8ea07ad9dd7461006.htm'
      },
      {
        'title': 'קוגמן, טל (2017, 4 מאי). <b>יועצות וממונות על מעמד האישה: מנהיגות לקידום או לשימור?</b> פרלמנט נשים: במה לפוליטיקה מזוית אחרת, מושב 30, מושבי תשס״ג–תשס״ד (2002–2004). נדלה מתוך',
        'url': 'http://womenparliament.org/%D7%99%D7%95%D7%A2%D7%A6%D7%95%D7%AA-%D7%95%D7%9E%D7%9E%D7%95%D7%A0%D7%95%D7%AA-%D7%A2%D7%9C-%D7%9E%D7%A2%D7%9E%D7%93-%D7%94%D7%90%D7%99%D7%A9%D7%94-%D7%9E%D7%A0%D7%94%D7%99%D7%92%D7%95%D7%AA-%D7%9C-2/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '18/11/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2001,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '14/01/2020'
    },
    'description': 'מועצת הנשים של כפר קאסם הוקמה בשנת 2014 בסיוע של מרכז אינג\'אז כדי לשמש כגוף מייעץ לראש העיר. המועצה מפעילה פרויקטים לקידום ייצוג של נשים בקבלת החלטות בתוך הרשות המקומית ויזמה הקמת מסלול הליכה לנשים במסגרת פרויקט לקידום בריאות נשים.',
    'description_ar': 'تأسس المجلس عام 2014 بمساعدة من مركز إنجاز بهدف العمل كجسم استشاري لرئيس البلدية. يقوم المجلس بتشغيل مشاريع مختلفة لتعزيز مكانة المرأة في صنع القرارات داخل المجلس وقد بادر لإقامة مسار مشي مناسب للنساء في إطار مشروع تعزيز صحة النساء.',
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'SA183',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'קידום נשים',
      'פנאי',
      'העצמה',
      'ספורט'
    ],
    'name': 'מועצת נשים כפר קאסם',
    'name_ar': 'مجلس نساء كفر قاسم',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר קאסם',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2020-01-14'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://kasmawi.net/?mod=articles&ID=109837&c=3'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '14/01/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '14/09/2019'
    },
    'description': 'מועצת הנשים של כפר קרע קיימת מאז שנת 2000 והיא פועלת בחסות המועצה המקומית. בראש המועצה הנבחרת עמדה פוזיה עזב, בת הכפר, שהסבירה כי הרציונל להקמת המועצה היה התיקון לחוק שחייב מועצות מקומיות להקים מועצת נשים. המועצה מתנהלת בהתנדבות, ללא תקציב ייעודי לפעילות. עיקר הפעילות של מועצת הנשים בראשית הדרך היה ארגון ימי בילוי לנשים, הרצאות בנושאי בריאות, אופנה או קוסמטיקה. מדי שנה בתחילת האביב נערך יום ספורט ובריאות לנשים בחסות קופת החולים הכללית. רופאים ואחיות עורכים בדיקות במקום ונותנים הדרכה בנושא מודעות לבריאות ופעילות גופנית. בנוסף, מועצת הנשים אוספת ומחלקת מזון למשפחות נזקקות, מקיימת פגישות עם נשים מישובים סמוכים ועם נשים יהודיות במסגרת ״מועדון נשות עסקים״ ועוד.',
    'description_ar': 'مجلس نساء كفر قرع - موجودة منذ عام 2000 وبرعاية المجلس المحلي. وكانت رئيسة المجلس المنتخبة هي فوزية عزب ابنة البلد والتي أوضحت أن الهدف الأساسي لإنشاء المجلس هو تعديل القانون الذي يتطلب من المجالس المحلية تشكيل مجلس نسائي. العمل في المجلس هو تطوعي ومن غير ميزانيات مطروحة للنشاط. تركز نشاط مجلس النساء في البداية على تنظيم أيام ترفيهية للنساء، محاضرات حول مواضيع الصحة، الأزياء والتجميل. وفي بداية الربيع من كل سنة ينطلق يوم الرياضة والصحة للنساء برعاية صندوق المرضى العام. أطباء، ممرضات يقومون بفحوصات في هذا اليوم ويقدمون ارشاد حول موضوع الصحة واللياقة البدنية. بالإضافة يقوم مجلس النساء بجمع وتوزيع طرود أغذية للعائلات المحتاجة، وتقوم بمقابلات مع نساء من القرى المجاورة ومع نساء يهوديات في اطار ״منتدى النساء العاملات״ وغيره.',
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'SA150',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'מועצת נשים',
      'בריאות',
      'ספורט',
      'גמ״ח'
    ],
    'name': 'מועצת נשים כפר קרע',
    'name_ar': 'مجلس نساء كفر قرع',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר קרע',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'אוסצקי-לזר, שרה (2009). <b>״לא כמו אמי״: נשים מעצימות את עצמן – המקרה של כפר קרע</b>. ירושלים: בית הספר ע״ש פדרמן למדיניות ציבורית וממשל - האוניברסיטה העברית בירושלים. נדלה מתוך',
        'url': 'https://www.sarahozacky.com/862/%D7%9C%D7%90-%D7%9B%D7%9E%D7%95-%D7%90%D7%9E%D7%99-%D7%A0%D7%A9%D7%99%D7%9D-%D7%9E%D7%A2%D7%A6%D7%99%D7%9E%D7%95%D7%AA-%D7%90%D7%AA-%D7%A2%D7%A6%D7%9E%D7%9F-%E2%80%93-%D7%94%D7%9E%D7%A7%D7%A8/'
      },
      {
        'title': 'יחיא-יונס, תגריד. (2013). מרחב, מיגדר ופוליטיקה מקומית בחברה הפלסטינית בישראל. בתוך: הלפרן, רוני (עורכת). <b>היכן אני נמצאת? פרספקטיבות מגדריות על מרחב</b> (עמ\' 203–242). הרצליה: קרן פרידריך אברט והמכללה האקדמית בית ברל.'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '14/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '13/12/2019'
    },
    'description': 'מועצת הנשים העירונית בנתניה הוקמה בשנת 2013 על ידי אילנה בן שושן גורן, יועצת ראש העיר למעמד האישה שגם עומדת בראשה ואורנה רג‘יניאנו, מנהלת אגף רבעים ושכונות. המועצה החלה את דרכה בקורס - ”נשים מנהיגות את המחר“ של עמותת כוח נשים- כ“ן, המכשיר נשים לפעול בזירה הציבורית והפוליטית. בין היתר פעלה המועצה בשנים האחרונות להעלאת ייצוג נשים במוקדי קבלת החלטות ובפוליטיקה העירונית וכן לקידום בריאות וספורט נשים.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תרבות וספורט',
        'ספורט'
      ]
    ],
    'id': 'YH197',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'ספורט',
      'בריאות',
      'ייצוג הולם',
      'פוליטיקה'
    ],
    'name': 'מועצת נשים נתניה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נתניה',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'מועצת נשים נתניה, קבוצת פייסבוק.',
        'url': 'https://www.facebook.com/groups/508021719314672/about/'
      },
      {
        'title': 'מרכז אדוה, עיריית נתניה, מועצת נשים עירונית – נתניה, מרכז אינג\'אז ואיגוד היועצות לקידום מעמד האישה (2015). <b>התכנית להטמעת שוויון מגדרי ברשויות המקומיות: סיכום פרויקטים של מועצת נשים נתניה 2014/15</b>. נדלה מתוך',
        'url': 'https://adva.org/wp-content/uploads/2015/12/Netanya_mail.pdf'
      },
      {
        'title': 'קפל, ציפי (2019, 19 ינואר). למה יש רק אישה אחת במועצת העיר. <b>mynet נתניה</b> (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '13/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '08/10/2018'
    },
    'description': 'בשנת 2010 נפתח מוקד של משרד הרווחה במתכונת חדשה במטרה לאחד שלושה מוקדים טלפוניים: מוקד 118- בנושאי מצוקה, מוקד שי״ל – בנושא מימוש זכויות האזרח וקו החירום למניעת אלימות במשפחה וילדים בסיכון (1-800-22-0000) שהיה באחריות ויצו. מאז הקמתו ממונה המוקד משרד הרווחה על שלושת הנושאים וגם על מתן מידע והכוונה בנושאים נוספים הנוגעים למצבי חירום חברתיים. המוקד מופעל על ידי חברה חיצונית שזכתה במכרז (בשנים 2010-2016 היתה זו חברת ״שידורית״ ומשנת 2016 זו חברת ״בינת-סמך״). המוקד מספק שירותי מידע והכוונה ומשמש כמוקד חירום ומענה ישיר לפניות בנושא אלימות במשפחה, מצבי מצוקה בקרב נוער, צעירים נשים, גברים ואזרחים ותיקים. המענה ניתן במגוון שפות: עברית, ערבית, אנגלית, רוסית ואמהרית. במהלך שנת 2016 פורסם המוקד בשלושה קמפיינים באמצעי התקשורת ובאמצעות הרשתות המקומיות ובמיוחד לציבור הערבי והחרדי. במוקד מועסקים בקו הראשון נציגים למתן מידע לפונים ובקו השני עובדים סוציאליים במתן ייעוץ וסיוע במקרים מורכבים. בנוסף, מועסקת במוקד עורכת תוכן שמתפקידה לתעד את המידע הניתן לפונים באמצעות מערכת ידע ממוחשבת.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'SA56',
    'is_active': true,
    'keywords': [
      'קו סיוע',
      'זכויות',
      'מידע'
    ],
    'name': 'מוקד 118',
    'name_ar': 'مركز الدعم الهاتفي 118',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': 'קו חירום ארצי למניעת אלימות במשפחה ולמען ילדים בסיכון',
    'official_address': 'ארצי',
    'organization_kind': [
      'ממשלתי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-06-27'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.118revacha.gov.il/'
      },
      {
        'title': 'משרדה עבודה, הרווחה והשירותים החברתיים (ללא תאריך). <b>דוחות חופש המידע של משרד הרווחה לשנים 2006, 2014–2018</b>. נדלה מתוך',
        'url': 'http://www.molsa.gov.il/freeinfo/Pages/FreeInfo.aspx'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות',
      'נשים חרדיות',
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '15/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2010,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '06/06/2018'
    },
    'description': '״קרן נשים למען זכויות אדם בע״מ״ (חל״צ 513573139) המוכרת כ״מחסום ווטש״ הוקמה בשנת 2004. רישום החברה אושר בשנת 2010 ומטרותיה הרשמיות הן: ״למנוע ולתעד מעשים לא מוסריים הנוגדים את החוק הבינלאומי ומהווים הפרת זכויות אדם. הצבת מתנדבות של החברה במחסומי השטחים הכבושים המתעדות את פעילות החיילים בהם. לעודד, ליזום, לייסד, להקים, להחזיק, לנהל לתמוך ולהוציא לפועל פרסומים בתחומים שהם במסגרת מטרות החברה הנזכרות לעיל.״ הקמת הארגון החלה בינואר 2001, בתחילת האינתיפאדה השנייה, כאשר מספר נשים החלו לעמוד בסמוך למחסומים. באופן הדרגתי הקבוצה התרחבה והפכה לתנועה המגדירה עצמה כך: ״נשים ישראליות הבאות מרחבי הקשת של החברה הישראלית על דעותיה ותפיסות עולמה השונות. עם זאת אנו מאוחדות בשני עניינים: התנגדות נחרצת לשלילת זכויות האדם של העם הפלסטיני באזורי הכיבוש ושאיפה עזה להביא לסיום הכיבוש המתמשך מאז 1967, ההורס והפוגע אנושות הן בחברה הפלסטינית הן בחברה הישראלית.״ פעילות הארגון כוללת הצבת מתנדבות-משקיפות ליד מחסומי צה״ל בעומק הגדה המערבית, על גדרות וחומות ההפרדה, במשרדי המִנהל האזרחי (מת״קים) ובבתי משפט צבאיים ותיעוד בזמן אמת של האירועים המתרחשים שם. דוחות הארגון מתפרסמים באתר אינטרנט בעברית ובאנגלית.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'צבא, ביטחון ומדיניות חוץ',
        'זכויות אדם'
      ],
      [
        'שלום'
      ]
    ],
    'id': 'SA17',
    'is_active': true,
    'keywords': [
      'חל״צ',
      'כיבוש',
      'זכויות אדם',
      'אינתיפאדה'
    ],
    'name': 'קרן נשים למען זכויות אדם בע״מ (חל״צ)',
    'name_ar': 'لا للحواجز - المنظمة النسائية لحقوق الإنسان',
    'name_change_year': null,
    'name_common': 'מחסום Watch',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'יהודה ושומרון',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'צבא, ביטחון ומדיניות חוץ',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'זכויות אדם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-06'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://machsomwatch.org/he/about'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>קרן נשים למען זכויות אדם בע״מ (חל״צ): חל״צ</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/513573139'
      },
      {
        'title': 'קוטף, הגר ואמיר, מירב (2013). מחיר האפקטיביות: על גופים, מיגדורים וכשלים במחסום Watch. בתוך: הלפרן, רוני (עורכת), <b>היכן אני נמצאת: פרספקטיבות מגדריות על מרחב</b> (עמ\' 283–311). אבן יהודה: המכללה האקדמית בית ברל.'
      },
      {
        'title': 'Kutz-Flamenbaum, Rachel V. (2012). Mobilizing gender to promote peace: the case of Machsom Watch. <b>Qualitative Sociology</b> 35(3), 293-310.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/01/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2001,
    'year_registered': 2004
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '17/01/2019'
    },
    'description': 'מטה הנשים של מפלגת יש עתיד החל להתארגן בשנת 2012 לקראת הבחירות לכנסת ה-19. מאז 2014 מפעיל המטה רשת של מועצות נשים מקומיות אשר מובילות תכניות ״להעצמת נשים בקהילה המקומית, ובכלל זה אירוח ח״כים ביישוב לשם שמירת הקשר ויכולת ההשפעה במוקדי הכוח, קיום כנסים ועריכת דיונים עם מובילי דעת קהל, על מנת לקדם נושאים החשובים בעיקר לנשים.״ המועצות הנשיות של ״יש עתיד״ מונות כמה מאות חברות אשר מקיימות אירועים ארציים הנוגעים למעמד האשה: שוויון הזדמנויות, מנהיגות בתחום המדיני-בטחוני, שוויון בתעסוקה, פעילות נגד הדרת נשים, סיוע לנשים נפגעות אלימות. יו״ר מטה הנשים הן איילת השחר-סגל, אילאיל קרן.',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ],
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ]
    ],
    'id': 'SA120',
    'is_active': true,
    'keywords': [
      'מנהיגות',
      'שוויון',
      'אלימות',
      'תאים מפלגתיים'
    ],
    'name': 'מטה הנשים- יש עתיד',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'מפלגות, שדולות ותאים מפלגתיים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-01-17'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.yeshatid.org.il/%D7%9E%D7%98%D7%94-%D7%94%D7%A0%D7%A9%D7%99%D7%9D'
      },
      {
        'title': 'לביא, עליזה (2012, 13 דצמבר). יש עתיד עם נשים, מטה הנשים בפעולה [פוסט פייסבוק]. נדלה מתוך',
        'url': 'https://www.facebook.com/aliza.lavie/photos/a.402940923106000/413542382045854/?type=1&theater'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '16/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2012,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '07/01/2019'
    },
    'description': 'הארגון הוקם כארגון גג ליד (וביוזמת) נעמת לארגונים התומכים באמהות חד הוריות ולקידום חקיקה . המטרות (מתוך עמוד העמותה בגיידסטאר): ״לשמש מסגרת אירגונית וולנטרית למשפחות חד- הוריות. להאבק להכרה בראשי משפחות חד-הוריות כמפרנסים יחידים ולהכיר בתנאים ובצרכים המיוחדים שלהם. לסייע ביצירה מסגרות לעזרה הדדית״. הארגון נרשם כעמותה ב-1992. ב-2001 נפרד הארגון מנעמת ושינה את שמו ל״מיחד לעתיד״, בראשו עמד אדם בשם עמנואל דובשק שהשתתף בישיבות בוועדות בכנסת שנגעו לזכויות משפחות חד הוריות. העמותה פעלה ככל הנראה עד 2004 ונמחקה ב-2006.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ]
    ],
    'id': 'YH175',
    'is_active': false,
    'keywords': [
      'אמהות גרושות',
      'סיוע כלכלי',
      'ביטחון סוציאלי',
      'זכויות',
      'תעסוקה',
      'קואליציה'
    ],
    'name': 'מיחד לעתיד - עמותה של משפחות חד-הוריות',
    'name_ar': null,
    'name_change_year': 2001,
    'name_common': null,
    'name_past': 'מיחד נעמת - ארגון למשפחות חד הוריות',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'כהן, עדה (1989, 5 אפריל). מיחד - ארגון חדש למשפחות חד הוריות. <b>דבר</b>. נדלה מתוך',
        'url': 'https://www.nli.org.il/he/newspapers/mar/1989/04/05/01/?e=-------he-20--1--img-txIN%7ctxTI--------------1'
      },
      {
        'title': 'משרד הפנים, רשם העמותות (2001, 11 נובמבר). <b>רשימת פעולות ושינויים בעמותה: שינוי שם</b>. מיחד לעתיד - עמותה של משפחות חד-הוריות (מספר עמותה 580153328), עמ\' 138. נדלה מתוך',
        'url': 'https://foi.gov.il/sites/default/files/%D7%A9%D7%99%D7%A0%D7%95%D7%99%20%D7%A9%D7%9D-%20%D7%A2%D7%9E%D7%95%D7%AA%D7%95%D7%AA%20-%20%D7%9C%D7%A4%D7%A8%D7%A1%D7%95%D7%9D.pdf'
      },
      {
        'title': 'סבירסקי, שלמה, קראוס, ורד, קונור-אטיאס, אתי והרבסט, ענת (2002). אמהות חד הוריות בישראל. <b>מידע על שוויון, 12</b>. מרכז אדוה.',
        'url': 'http://adva.org/wp-content/uploads/2014/09/gil12.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '01/07/2019'
    },
    'year_closed': 2006,
    'year_closed_text': '2006',
    'year_founded': 1989,
    'year_registered': 1992
  },
  {
    'activity_kinds': [
      'אקטיביזם רשת',
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/04/2019'
    },
    'description': '״מילי – מרחב ישראלי לאימהות יחידניות״ הוא מיזם חברתי (ע״ר 580669406) שהוקם בשנת 2017 על ידי יפעת אור עבור אימהות יחידניות ונשים בדרך לאימהות יחידנית מרחבי הארץ. מטרות העמותה הן: ״גיוס ויצירת קשר עם גורמים ממסדיים/ עסקיים/ארגוני נשים/ בעלי עניין ובעלי הון - לתמיכה וסיוע, העלאת המודעות הציבורית, והקמת מערך ליווי התנדבותי, הקמת מערך מייעץ ומסייע - פרטני ו/או קבוצתי, של אנשי מקצוע מתחומים שונים, שיעמוד לרשות אמהות היחידניות בארץ ובעולם, הקמת קרן מלגות - לתמיכה בנושאי רווחה וחינוך, קידום רגולציה וחקיקה בנושא זכויות של אימהות יחידניות, ופיתוח מאגר מידע״. המיזם מיועד לאמהות יחידניות, נשים רווקות, שבחרו להביא ילד ללא בן זוג. בהתאם לכך, העמותה מספקת מידע וייעוץ פרטני לנשים במטרה להנגיש את המידע הקיים על זכויות ושירותים המיועדים לאמהות יחידניות, לקדם ולהוסיף שירותים ומענים חדשים, הטבות, ולאפשר שיח פתוח בנושא הכולל ייעוץ ותמיכה רגשית החל משלבי ההתלבטות, דרך תהליכי פריון הריון ולידה, השנה הראשונה לאחר הלידה, וכן הלאה. בין פעילויות העמותה: הפעלת דף פייסבוק; קיום מפגשים, קבוצות והרצאות; מסירת ציוד וביגוד; פרויקט סבא-סבתא מאמצים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ],
      [
        'בריאות ופריון',
        'טכנולוגיות פריון'
      ]
    ],
    'id': 'SA157',
    'is_active': true,
    'keywords': [
      'חד הוריות',
      'אמהות',
      'לידה',
      'טכנולוגיות פריון'
    ],
    'name': 'מילי - מרחב ישראלי לאמהות יחידניות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'אקטיביזם רשת',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-04-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.me-li.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מילי – מרחב ישראלי לאמהות יחידניות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580669406'
      },
      {
        'title': 'מילי - מרחב ישראלי לאימהות יחידניות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pg/meli.forsinglemoms/about/?ref=page_internal'
      },
      {
        'title': 'אופיר, עדה (2018, 3 מאי). הנשים שעוזרות לאימהות יחידניות. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-5249809,00.html'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2017,
    'year_registered': 2018
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'שירותים משפטיים',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '20/09/2018'
    },
    'description': '״מינהל נשים הרצליה״ נוסד ביוזמת יעל גרמן כשנכנסה לתפקיד ראשת העיר הרצליה ב-1998, הוקם על ידי עו״ד דנה סבוראי שכיהנה בראשו בשנים הראשונות. המינהל מתפקד כמחלקה לקידום מעמד האישה ומתוקצב על ידי העירייה. ראש המינהל כיום (2019) היא גנית לה-ארי שהחליפה את אורנה סדגת-ארז אשר כיהנה בתפקיד שנים רבות. המינהל פועל לקידום שוויון מגדרי בין היתר באמצעות מיצוי זכויות וייעוץ משפטי לנשים תושבות העיר, הכוונה משפטית לנפגעות מין ואלימות, קורסים וסדנאות וקידום שוויון מגדרי בקרב עובדי/ות העירייה.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'YH92',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'שוויון מגדרי',
      'סיוע משפטי',
      'קידום נשים',
      'הטמעת חשיבה מגדרית'
    ],
    'name': 'מינהל נשים הרצליה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'הרצליה',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-10-29'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.herzliya.muni.il/263/'
      },
      {
        'title': 'מינהל נשים - עיריית הרצליה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/minhal.nashim'
      },
      {
        'title': 'סבוראי, דנה (2003). מה זה מינהל נשים? <b>מגזין נשים לפוליטיקה</b> 3. נדלה מתוך',
        'url': 'http://www.haderech.co.il/beitha3.5.html'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '29/10/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '08/12/2019'
    },
    'description': 'מיקרופיי הוקמה בנובמבר 2010 (ע״ר 580530459) תחת השם ״מיקרופייט״ והחלה לפעול בשנת 2011 במטרה לספק ייעוץ, הכשרה ומימון בעיקר לאוכלוסיות חלשות על מנת לאפשר מקורות הכנסה עצמאיים. פעילות העמותה מתמקדת בעיקר בסיוע לקבוצות נשים ערביות ויהודיות מאזור דרום תל-אביב ויפו הנמצאות בקו העוני כולל סיוע לנשים מהגרות ומבקשות מקלט. פעילויות העמותה כוללות קורס יזמות עסקית, ייעוץ להקמת עסק או לניהול עסק קיים, מתן הלוואות זעירות להקמת עסק או הרחבתו. העמותה מקיימת פורום שנתי לבעלות עסקים שבו מושם דגש על רישות עסקי, תמיכה ושיתוף עמיתות ומיומנויות עסקיות מתקדמות. בנוסף, היא מציעה גם ליווי אישי ועסקי של מנטוריות מתנדבות, המסייעות לבוגרות ברמה השבועית.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'הגירה',
        'פליטות ומבקשות מקלט'
      ]
    ],
    'id': 'SA148',
    'is_active': true,
    'keywords': [
      'אימון אישי',
      'הלוואות',
      'יזמות עסקית',
      'מנטורינג',
      'עוני',
      'פליטות ומבקשות מקלט',
      'רישות'
    ],
    'name': 'מיקרופייט',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'מיקרופיי Microfy',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-12-08'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.microfy.com/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מיקרופייט (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580530459'
      },
      {
        'title': 'מיקרופיי, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/Microfy'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים מהגרות עבודה או חסרות מעמד',
      'נשים מזרחיות',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '08/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2010,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '13/12/2018'
    },
    'description': 'הארגון הוקם ב-1998 כ״מכון הנגב לאסטרטגיות של שלום ופיתוח״ במכללת ספיר. ב-2000 נרשם כעמותה עצמאית בבאר שבע בשם ״אגי\'ק- מכון הנגב״ (ע.ר. 580359073) שעסקה בהכשרה לפיתוח קואופרטיבים, עסקים קטנים ופתרון קונפליקטים בניהולה של ויויאן סילבר. ב-2002 הוקם אג\'יק - המרכז היהודי ערבי לשוויון, העצמה ושיתוף, בתוך מכון הנגב על ידי אמל אלסאנע אלחג\'וג\'. המרכז מקדם פרויקטים מגוונים לנשים בקהילות הבדואיות בנגב, כולל: הקמת מסגרות לגיל הרך, תכניות לפיתוח כלכלי, קידום בריאות נשים, מרכז ספורט נשים, הפעלת פרויקט ״נשים רוקמות חלום״ ושותפות בהקמה וניהול של קייטרינג אלסנאבל - מטבח קהילתי.',
    'description_ar': 'تأسست المنظمة عام 1998 ك ״معهد النقب لاستراتيجيات السلام والتنوية في كلية سابير. في عام 2000 سجلت الجمعية بشكل مستقل في بئر السبع تحت اسم ״أجيك-معهد المنقب״ (ج.م 580359073) حيث شكلت مركز تدريبي لتطوير الجمعيات التعاونية، المصالح التجارية الصفير وحل النزاعات بإدارة فيفيان سيلفر. في عام 2002 أقيمت أجيك- المركز العربي اليهودي للسماواة، التمكين والتعاون، داخل معهد النقب على يد امل الصانع الحجوج. يقوم المركز بتطوير مشاريع متنوعة لنساء ومجموعات بدوية في النقب والتي تشمل: فتح اطر للطفولة المبكرة، برنامج للتطوير الاقتصادي، تعزيز الصحة لدى النساء، مركز رياضي للنساء، تفعيل برنامج ״نساء ينسجن حلما״ وشراكة في إقامة وإدارة مطبخ السنابل- مطبخ جماهيري.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'רווחה וקהילה',
        'תעסוקה ועבודה'
      ],
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'YH156',
    'is_active': true,
    'keywords': [
      'אמהות',
      'בדואיות',
      'בישול',
      'הכשרה מקצועית',
      'הריון',
      'ספורט',
      'יזמות עסקית',
      'מעונות ומשפחתונים'
    ],
    'name': 'אג\'יק מכון הנגב',
    'name_ar': 'أجيك',
    'name_change_year': 2002,
    'name_common': 'מכון הנגב לאסטרטגיות של שלום ופיתוח',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעונות ומשפחתונים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-12-13'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://ajeec-nisped.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אג\'יק – מכון הנגב (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580359073'
      },
      {
        'title': 'Abu-Rabia-Queder, Sarab (2009). Cultural and gender-sensitive community development: Interview of Amal Elsana Alhjooj, director of AJEEC. <b>Hagar 9</b>(1), p. 193.'
      },
      {
        'title': 'El-Sana, Amal (2017). <b>Managing the tensions facing indigenous social change organizations that combine service and advocacy: The case of the Arab Jewish centre for equality, empowerment and cooperation in the Negev, Israel</b>. (Doctoral dissertation). McGill University, Canada. Retrieved from',
        'url': 'https://escholarship.mcgill.ca/catalog?f%5Bcreator_sim%5D%5B%5D=El-Sana%2C+Amal&locale=en'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '13/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': 2000
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '08/09/2018'
    },
    'description': 'המכון לחקר תקשורת ומשפחה (ע״ר 580010338) הוקם בחיפה על ידי חמדה ארד-וייס וד״ר גו\'די בת-עדה במטרה לפתח מודעות ציבורית להשפעות של אמצעי התקשורת על המציאות החברתית תוך דגש על פרסום פוגע, פורנוגרפיה ודמותן של נשים בתקשורת. מטרותיה הרשמיות של העמותה היו ״חקר שיטות לימוד והפצת המידע של אמצעי התקשורת ההמונית״. העמותה פעלה באמצעות תגובות לתקשורת, סדנאות וימי עיון בנושאים רבים הנוגעים לדרכי ההצגה של נשים בתקשורת, כולל בבתי ספר ובאוניברסיטאות ובמשך הזמן התרחבה גם לתחומים של סנגור, מחאה ומחקר. בין הנשים שעבדו במכון היו אורנת טורין, ג\'סיקה נבו, דליה לירן-אלפר ואחרות. המכון הפעיל שני סניפים- בחיפה ובירושלים ובשנת 1992 כאשר ד״ר דפנה למיש ניהלה אותו הוא התמזג באופן הדרגתי אל תוך ״שדולת הנשים בישראל״.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תקשורת'
      ],
      [
        'חינוך',
        'פמיניזם ושוויון בין המינים'
      ]
    ],
    'id': 'SA45',
    'is_active': false,
    'keywords': [
      'פרסום פוגע',
      'פורנוגרפיה',
      'סטריאוטיפים'
    ],
    'name': 'מכון לחקר תקשורת ומשפחה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תקשורת',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': '<b>המכון לחקר תקשורת ומשפחה</b>. אותר בארכיון הפמיניסטי ב״אשה לאשה – מרכז פמיניסטי חיפה״ (2018, 6 ספטמבר).'
      },
      {
        'title': 'שיחה פרטית (2018, 3 אוגוסט). תכתובת דוא״ל עם מי ששמשה רכזת העמותה – המכון לחקר תקשורת ומשפחה.'
      },
      {
        'title': '70 אמהות לא נשואות מכל הארץ התכנסו בת״א (1983, 25 דצמבר). <b>דבר</b>. נדלה מתוך',
        'url': 'http://www.jpress.nli.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=DAV%2F1983%2F12%2F25&id=Ar00600&sk=6396989E'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '12/02/2019'
    },
    'year_closed': 1992,
    'year_closed_text': '1992',
    'year_founded': 1982,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '03/01/2019'
    },
    'description': '‏״מכון יהודית ליברמן – מדרשה גבוהה לתורה שבע״פ ברמות שפירא״‏ הוקם במקור כיוזמה של הרב ‏פרופ\' ‏שאול ליברמן (מגדולי חוקרי התלמוד והתורה שבעל פה) ושל הרב יעקב ויינשטיין (מייסד ויו״ר ‏המרכז החינוכי ״רמות שפירא״ בבית ‏מאיר) להנצחת זכרה של יהודית ליברמן, ‏אשתו של שאול ליברמן, ‏באמצעות קידום לימוד תורה שבעל פה ‏לנשים. תחילת גיבוש היוזמה הייתה בשנת ‏‏1980 ותחילת ‏פעילות המדרשה בשנת 1981, כמעט עשור לפני גל ‏הקמת המדרשות (לינדנבאום, מת״ן, נשמת, ‏עין הנציב, ‏מגדל עוז). סיעור המוחות נעשה יחד עם נשים ‏למדניות ופמיניסטיות-דתיות כדוגמת נעמי כהן ‏‏(לימים ‏ממייסדות ״קולך״). העמותה (ע״ר 580054153) נרשמה בשנת 1983. מטרות העמותה היו: ״לקיים מסגרת לימודית לנשים במקצועות היהדות שבמרכזה לימודי תושב״ע ברמה גבוהה. לערוך סמירים בנושא מעמד האשה בהשקפת היהדות. להכשיר נשים למעורבות בחיי החברה הישראלית ולנשיאה בעול תפקידים ציבוריים.״ ה‏מנהלת הראשונה היתה חנה ספראי, ‏ממייסדות/י ״נאמני תורה ועבודה״ שלימים ‏הקימה את ״קולך״ וניהלה את ״פלך ירושלים״. חנה ספראי צירפה את ‏נחמה ליבוביץ\', שעסקה בתנ״ך, לסגל ההוראה. בשנת 2002 המכון שינה את שמו לשם הנוכחי המופיע בגיידסטאר ‏״מכון חינוכי לחיי משפחה ע״ש ‏‏יהודית ליברמן״ ‏העוסק בזוגיות וחיי משפחה. לא ברור אם המעבר הזה היה חד ופתאומי או שמא ‏‏הדרגתי, אך המדרשה חדלה להתקיים. השם המופיע באתר הוא ‏״מכון ליברמן לבניין האישיות והעצמת המשפחה״ – ללא אזכור קיומה של המדרשה רו פריצת הדרך הלימודית התורנית שעוצבה בזכרה של יהודית ליברמן. שם המכון המוכר ‏בציבור (באתר ופרסומים) הוא ״מכון ליברמן – לבניית ‏האישיות והעצמת המשפחה״. בשנת 2018, נמחקה העמותה מפנקס העמותות לאחר מספר שנים של ‏העדר פעילות. המכון ‏ממשיך לפעול, כנראה כמיזם עסקי‏.‏',
    'description_ar': null,
    'display_organization_kind': 'מוסד תורני בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'השכלה'
      ]
    ],
    'id': 'SW41',
    'is_active': false,
    'keywords': [
      'הלכה',
      'מדרשה',
      'תורה',
      'יהדות'
    ],
    'name': 'מכון חינוכי לחיי משפחה ע״ש ‏‏יהודית ליברמן',
    'name_ar': null,
    'name_change_year': 2002,
    'name_common': 'מכון ליברמן לבניין האישיות והעצמת המשפחה‏',
    'name_past': 'מכון יהודית ליברמן – מדרשה גבוהה לתורה שבע״פ ברמות שפירא‏',
    'name_replaced_by': null,
    'official_address': 'בית מאיר',
    'organization_kind': [
      'מוסד תורני',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'מוסד תורני',
    'primary_sub_field_of_activity': 'השכלה',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>מכון חינוכי לחיי משפחה ע״ש ‏‏יהודית ליברמן</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'משרד הפנים, רשם העמותות (2018, 12 אוגוסט). <b>רשימת פעולות ושינויים בעמותה: שינוי שם</b>. מכון חינוכי לחיי משפחה ע״ש ‏‏יהודית ליברמן (מספר עמותה 580054153), עמ\' 66. נדלה מתוך',
        'url': 'https://foi.gov.il/sites/default/files/%D7%A9%D7%99%D7%A0%D7%95%D7%99%20%D7%A9%D7%9D-%20%D7%A2%D7%9E%D7%95%D7%AA%D7%95%D7%AA%20-%20%D7%9C%D7%A4%D7%A8%D7%A1%D7%95%D7%9D.pdf'
      },
      {
        'title': 'נאמני תורה ועבודה (אתר). <b>ההיסטוריה של התנועה</b>. נדלה מתוך',
        'url': 'https://toravoda.org.il/%D7%9E%D7%99-%D7%90%D7%A0%D7%97%D7%A0%D7%95/%D7%94%D7%94%D7%99%D7%A1%D7%98%D7%95%D7%A8%D7%99%D7%94-%D7%A9%D7%9C-%D7%94%D7%AA%D7%A0%D7%95%D7%A2%D7%94/'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '07/01/2019'
    },
    'year_closed': 2003,
    'year_closed_text': '2003',
    'year_founded': 1981,
    'year_registered': 1983
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '16/07/2018'
    },
    'description': '״מכנה משותף לחינוך מגדרי״ הוקם על ידי על ידי סטודנטים וסטודנטיות לתארים מתקדמים מהאוניברסיטה העברית בירושלים, במטרה לקדם שוויון מגדרי באמצעות חיבור אקדמיה וקהילה. נרשמו כעמותה (ע״ר 580592103) ב-2014 ופעילים בה כיום כתשעים מתנדבים ומתנדבות. מטרות העמותה הן: ״העלאת מודעות לסטיראוטיפים מגדריים והדרכים להתמודד עם השפעתם. הטמעה של תכני חינוך מגדרי במערכת החינוך. העמותה תפעל למען מטרות אלו באמצעות פעילות חינוכית (סדנאות לתלמידים/ות והשתלמויות למורים/ות וצוותי חינוך), הסברתית (ארגון והשתתפות בכנסים וימי עיון, הפצת מידע לציבור) וציבורית (קידום נושא החינוך המגדרי בחקיקה, במדיניות ציבורית ובמוסדות ציבוריים).״ פעילות העמותה מתקיימת בירושלים, תל אביב, ערי המרכז והפריפריה במסגרות חינוכיות פורמאליות, בלתי פורמליות ובארגונים שונים. העמותה עורכת סדנאות בקרב נערים/ות, צוותי הוראה והורים במטרה להעלות את המודעות לסטראוטיפים המגדריים ולספק כלים לחשיבה ביקורתית לגבי מגדר, בהתבסס על ידע אקדמי עדכני.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'חינוך',
        'פמיניזם ושוויון בין המינים'
      ],
      [
        'נערות וצעירות',
        'חינוך'
      ]
    ],
    'id': 'YH57',
    'is_active': true,
    'keywords': [
      'סטריאוטיפים',
      'שוויון מגדרי',
      'חינוך מגדרי',
      'העלאת מודעות'
    ],
    'name': 'מכנה משותף לחינוך מגדרי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'חינוך',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פמיניזם ושוויון בין המינים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-07-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.common-ground.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מכנה משותף לחינוך מגדרי (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580592103'
      },
      {
        'title': 'מכנה משותף, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/MexaneMeshutaf/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '27/10/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': 2014
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '24/01/2019'
    },
    'description': 'כתב העת ״מסכת״ הוקם ב-2002 על ידי פרופ\' ישראל אומן, לימים חתן פרס נובל לכלכלה, לזכרה של רעייתו אסתר. כרך א\' של ״מסכת״ ראה אור בתשס״ב - 2002 בהוצאת מת״ן - מכון תורני לנשים והעורכת הראשונה הייתה זיוה קוסופסקי. החל מינואר 2017 יוצא כתב העת לאור במסגרת הפקולטה למדעי היהדות באוניברסיטת בר-אילן. במסכת מתפרסמים מחקרים בהיבטים שונים של חיי האישה היהודייה, מעמדה בחברה היהודית והכללית, תפיסתה העצמית והישגיה בתחומי יצירה מגוונים מאז תקופת התנ״ך.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'כתבי עת'
      ],
      [
        'דת ומעמד אישי',
        'השכלה'
      ]
    ],
    'id': 'YH187',
    'is_active': true,
    'keywords': [
      'יהדות',
      'מחקר'
    ],
    'name': 'מסכת',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'אקדמי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'כתבי עת',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2019-01-24'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://jewish-faculty.biu.ac.il/node/669'
      },
      {
        'title': 'מסכת (כתב עת). <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%9E%D7%A1%D7%9B%D7%AA_(%D7%9B%D7%AA%D7%91_%D7%A2%D7%AA)'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '24/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2002,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '16/05/2018'
    },
    'description': 'מסל״ן- מרכז הסיוע לנפגעות ולנפגעי תקיפה מינית ואלימות בנגב (ע״ר 580141455), פועל מאז שנת 1988 במטרה לסייע, ללוות ולהוות מקור ובסיס לתמיכה מעשית ורגשית לנפגעות, לנפגעים ולבני משפחותיהם. מטרות המרכז הן הענקת סיוע, תמיכה, לווי וטיפול בנפגעות אונס, תקיפה, הטרדה מינית ואלימות במשפחה באזור הדרום. המרכז נמצא בעיר באר שבע ופועל לקידום שינוי חברתי באמצעות פעילות חינוך והסברה בקהילה, הפעלת קו סיוע במספר שפות, ליווי בהליך משפטי והפעלת יחידה טיפולית לנפגעות ונפגעי אלימות מינית ובני משפחותיהם. מרכז הסיוע מעניק את שירותיו, ללא תשלום ובאנונימיות מוחלטת, לנפגעות ולנפגעי תקיפה מינית ואלימות, מבוגרים כמו גם בני נוער וילדים, ללא הבדל דת, גזע, מין או לאום. בין השנים 1994-2005 הפעילה העמותה את המקלט לנשים נפגעות אלימות בדרום. העמותה מתקיימת מתרומות ומתמיכה של משרד הרווחה ופועלת בסיוע של כ-250 מתנדבות שעברו הכשרה ממושכת בתחומי התוכן של תקיפה מינית ואלימות. מנהלת המרכז היא ליזה ניקולאיצ\'וק.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'חינוך',
        'מניעת אלימות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'YB32',
    'is_active': true,
    'keywords': [
      'אונס',
      'הטרדה מינית',
      'קו סיוע',
      'תמיכה נפשית',
      'סיוע משפטי'
    ],
    'name': 'מסל״ן - מרכז הסיוע לנפגעות ולנפגעי תקיפה מינית ואלימות, נגב',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'מסל״ן',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.1202.org.il/local/maslan/about'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מסל״ן – מרכז הסיוע לנפגעות ולנפגעי תקיפה מינית ואלימות, נגב (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580141455'
      },
      {
        'title': 'מסל״ן, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/maslan.negev/'
      },
      {
        'title': 'מסל״ן - מרכז סיוע לנפגעות ונפגעי תקיפה מינית ואלימות, נגב. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%9E%D7%A1%D7%9C%22%D7%9F_-_%D7%9E%D7%A8%D7%9B%D7%96_%D7%A1%D7%99%D7%95%D7%A2_%D7%9C%D7%A0%D7%A4%D7%92%D7%A2%D7%95%D7%AA_%D7%95%D7%A0%D7%A4%D7%92%D7%A2%D7%99_%D7%AA%D7%A7%D7%99%D7%A4%D7%94_%D7%9E%D7%99%D7%A0%D7%99%D7%AA_%D7%95%D7%90%D7%9C%D7%99%D7%9E%D7%95%D7%AA,_%D7%A0%D7%92%D7%91'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים עולות מחבר העמים',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1988,
    'year_registered': 1989
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '28/01/2019'
    },
    'description': '״מעאן לתרבות ויצירתיות״ (ע״ר 580605178) הוקמה בשנת 2015. מטרות העמותה הן ״עידוד תעסוקת נשים: לאור הריבוי במספר הנשים היוצאות לשוק העבודה בנצרת, ראינו לנכון להקים מסגרת מתאימה ואמינה לילדיהן, זאת בנוסף לצורך הרב במציאת מעון יום במחיר הולם כך שאימא היוצאת לעבודה לא תהיה מחויבת לשלם יותר ממחצית שכרה על מעון יום לילד. הקמת תוכניות תרבותיות ולימודיות להכנת התינוקות למעבר ללימודי חובה. מעקב התפתחות רגשית וחברתית וקוגניטיבית בליווי פסיכולוגים מומחים. הדרכת הורים וגננות. איתור מוקדם של בעיות התפתחות והפניה לגורם מטפלים בהקדם. הקמת חוגים ופעילויות אחרי הצהריים לתינוקות וילדים.״ העמותה מפעילה שני מעונות יום בשכונות שונות בנצרת ומרכז תרבותי המציע חוגים ופעילויות העשרה תרבותיות בשעות אחר הצהריים. בנוסף, העמותה מקיימת סדנאות בבתי ספר ובמוסדות שונים.',
    'description_ar': 'معا- للتربية والابداع״ (ج.م 580605178) تاسس عام 2015 بهدف تشجيع تشغيل المرأه: نظرًا للعدد الكبير من النساء اللائي يدخلن سوق العمل في الناصرة ، فقد اعتبرنا أنه من المناسب إنشاء إطار مناسب وموثوق بها لأطفالهن ، بالإضافة إلى الحاجة الماسة لإيجاد بيت رعاية نهارية بسعر مناسب ، حتى لا تكون الأم التي تغادر إلى العمل ملزمة بدفع أكثر من نصف إيجار الرعاية النهارية للطفل. إنشاء برامج ثقافية وتعليمية لإعداد الأطفال للانتقال إلى التعليم الإلزامي. متابعة التطور العاطفي، الاجتماعي والإدراكي برفقة اخصائيين نفسيين. توجيه الوالدين والحاضنات. تتم معالجة الكشف المبكر عن المشكلات التنموية والإحالة إلى الجراء قريبًا. إقامة دورات وأنشطة بعد الظهر للأطفال والرضع. ״تدير الجمعية مركزين للرعاية النهارية في أحياء مختلفة في الناصرة ومركز ثقافي يقدم دروسًا وأنشطة ثقافية خلال فترة ما بعد الظهر. بالإضافة إلى ذلك، تعقد الجمعية ورش عمل في مختلف المدارس والمؤسسات.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ],
      [
        'חינוך',
        'הגיל הרך'
      ]
    ],
    'id': 'YA13',
    'is_active': true,
    'keywords': [
      'ילדים',
      'משפחה',
      'תרבות'
    ],
    'name': 'מעאן לתרבות ויצירתיות',
    'name_ar': 'مركز معاً للتربية والابداع',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נצרת',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעונות ומשפחתונים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-01-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.facebook.com/pg/markezmaan/posts/?ref=page_internal'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מעאן לתרבות ויצירתיות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580605178'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '28/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '08/10/2018'
    },
    'description': '״מעברים״ הוא ארגון שהוקם בשנת 2014 על ידי אלישע אלכסנדר, בר יצחקי ודודו גוטליב, על מנת לענות על מגוון צרכים של הקהילה הטרנסית. לדברי אלכסנדר, הארגון פועל מתוך תפיסת עולם פמיניסטית וקווירית כוללת, הרואה ביצירת נראות של חוסר בינאריות מגדרית במרחב הציבורי, חלק מהותי מהמאבק הפמיניסטי, המערער על כלל הנורמות המגדריות. בשלב הראשון לפעילותו הוא החל ביצירת קבוצת שיח ופעילות לנוער טרנסי במרכז הגאה בשם ״טרנס במרכז - הדור הבא״. עם השנים פעילותו התרחבה וכיום הוא פועל בשלושה מישורים מרכזיים. ברמת הפרט – הפעלת שירות מענה פרטני ״מעברים עונים״ הכולל ליווי, מיצוי זכויות, סנגור (תיווך מול סוגי שירות כמו מטפלים, סיוע בהגשת תביעות מול ביטוח לאומי, מול משרד הפנים, מול משרד הבריאות). ברמת חיזוק הקהילה, הארגון פועל להגברת ידע ומשאבים – אירועים קהילתיים, הכרות, קבוצות העצמה, ימי ״שלישי קהילתי״ במרכז הגאה. מאגר מידע, תוכנית מלגות, אירועים במצעדי גאווה, יום הזכרון, יום הנראות וכו׳. ברמת שינוי מדיניות – כולל תוכנית הכשרות לאנשי מקצוע מטפלים, רופאים, חברות כוח אדם וכאלה. ימי עיון לאנשי מקצוע ועבודה מול משרדי ממשלה. בנוסף לאלה בעתיד הקרוב תתחיל לפעול ניידת שתסע לדירות של נשים טרנסיות בזנות, תציע תמיכה, תה וקפה. הארגון פועל בעיקר בתל אביב, אבל קו התמיכה מציע מענה לטרנס* מכל רחבי הארץ. ברשם העמותות, הארגון מופיע כהרחבה ושינוי של עמותת ״אדם לאדם״ ולפיכך הפער בין שנת הרישום לשנת תחילת פעילות הארגון. מעברים ממשיך להפעיל את הבזאר של ״אדם לאדם״ לגיוס תרומות במרכז הגאה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'רווחה וקהילה',
        'להט״ב'
      ],
      [
        'תעסוקה ועבודה',
        'השמה וליווי בתעסוקה'
      ]
    ],
    'id': 'LR3',
    'is_active': true,
    'keywords': [
      'טרנסקסואלים',
      'זהות מגדרית',
      'קהילה',
      'זכויות',
      'תמיכה נפשית',
      'זנות',
      'מיצוי זכויות',
      'תקשורת',
      'סיוע משפטי',
      'סדנאות',
      'פמיניזם',
      'העצמה',
      'מלגות'
    ],
    'name': 'מעברים - שינוי בר קיימא לקהילה הטרנסית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-08-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.maavarim.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מעברים – שינוי בר קיימא לקהילה הטרנסית (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580525434'
      },
      {
        'title': 'מעברים - שינוי בר קיימא לקהילה הטרנסית, עמוד פייסבוק.',
        'url': 'https://he-il.facebook.com/maavarim.org'
      },
      {
        'title': 'בלומנטל, איתי (2018, 24 יולי). ״מרימות!״: מרכז תעסוקה חדש לקהילה הטרנסית. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-5316029,00.html'
      },
      {
        'title': 'מעברים – שינוי בר קיימא לקהילה הטרנסית (2018, 8 אוקטובר). הפרטים אומתו בשיחת טלפון עם נציג העמותה.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '19/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': 2010
  },
  {
    'activity_kinds': [
      'פילנתרופיה',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '08/09/2018'
    },
    'description': '״מעגלי נשים״ הן התארגנויות מקומיות של נשים אשר פועלות לגיוס כספים לרווחת הקהילה וקיום פעילות חברתית וציבורית. הארגון הבינלאומי שנקרא Ladies Circle נוסד בשנת 1932 בבריטניה במטרה לשמש רשת חברתית ומקצועית לנשים צעירות (18-45) ובמחצית השניה של המאה ה-20 התרחב לעשרות מדינות באירופה, אסיה, אפריקה וצפון אמריקה. בפנקס העמותות מופיעות כ-31 עמותות רשומות בישראל המזוהות כמעגלי נשים מקומיים, רובן נרשמו לאחר שנת 2000. ארגון הגג נקרא ״מעגל נשים ישראל״.',
    'description_ar': null,
    'display_organization_kind': 'בינלאומי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'YH71',
    'is_active': true,
    'keywords': [
      'מלגות',
      'נשות עסקים',
      'פנאי',
      'רשות מקומית',
      'רישות'
    ],
    'name': 'מעגל נשים ישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'בינלאומי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'פילנתרופיה',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'בינלאומי',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-08'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://ladiescircle.org.il/%D7%90%D7%95%D7%93%D7%95%D7%AA/'
      },
      {
        'title': 'מעגל נשים (האתר הבין-לאומי).',
        'url': 'http://www.ladiescircleinternational.org/5-2/'
      },
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>מעגל נשים ישראל</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '08/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1991,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '07/01/2018'
    },
    'description': 'עמותת ״ארגוני נשים ערביות-בדואיות בנגב״ (ע.ר. 580371334) המוכרת בשם פורום ״מען״ (\'ביחד\' בערבית) הינה ארגון הגג של ארגוני הנשים הערביות (בדואיות) בנגב. הארגון נוסד בשנת 1999 על ידי נשים ערביות מארגונים שונים על מנת לקדם את זכויות האישה הבדואית על ידי יצירת קול אחד וקידום פרוייקטים משותפים. הפורום שואף ״לחולל שינוי חברתי משמעותי ולתרום למען חברה דמוקרטית וצודקת אשר מבטיחה לחבריה בכלל ולנשים שבה בפרט מימוש זכויות ושיווין״. מטרות העמותה הן העצמת החברה הערבית בנגב על כל מרכיביה ובמיוחד את ארגוני הנשים בנגב; העמקת תפיסות זכויות אדם ופמיניזם בקרב ארגוני הנשים הערביות בנגב; טיפול בסוגיות מורכבות ורגישות חברתית שעד כה לא התאפשר טיפול בהן ברמה המקומית, כולל אלימות נגד נשים; עידוד מנהיגות נשית מקומית; הכשרת כוח אדם נשי מקצועי בתחומים שונים כולל הוראת אנגלית.',
    'description_ar': 'جمعية ״ تنظيمات نساء عربيات-بدويات في النقب״ (ج.م. 580371334) المعروفة باسم اتحاد ״معًا״ هو الإطار التنظيمي لمؤسسات النساء عربيات (بدويات) بالنقب. تأسس التنظيم عام 1999 وتديره نساء عربيات من تنظيمات مختلفة من اجل تعزيز حقوق المرأة البدوية بواسطة انشاء صوت واحد وانشاء مشاريع مشتركة. تطمح الجمعية “إحداث تغيير اجتماعي كبير والإسهام في مجتمع ديمقراطي وعادل يضمن لأعضائه بشكل عام والمرأة بشكل خاص ممارسة الحقوق والمساواة ״. أهداف الجمعية هي تمكين المجتمع العربي في النقب بجميع مكوناته، وخاصة المنظمات النسائية في النقب. تعميق مفهوم حقوق الإنسان والحركة النسوية بين المنظمات النسائية العربية في النقب؛ معالجة القضايا المعقدة والحساسية الاجتماعية التي لم تتم معالجتها حتى الآن على المستوى المحلي، بما في ذلك العنف ضد المرأة ؛ تشجيع القيادة النسائية المحلية ؛ تدريب الموظفات المحترفات في مختلف المجالات بما في ذلك تدريس اللغة الإنجليزية.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ],
      [
        'אלימות',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YH39',
    'is_active': true,
    'keywords': [
      'אלימות',
      'אסלאם',
      'בדואיות',
      'מעמד אישי',
      'פוליגמיה',
      'בתי משפט לענייני משפחה',
      'מנהיגות',
      'זכויות',
      'האמנה לביעור כל צורות ההפליה נגד נשים 1979 CEDAW',
      'סיוע משפטי'
    ],
    'name': 'פורום ארגוני נשים ערביות בדואיות בנגב',
    'name_ar': 'معاً إتحاد الجمعيات العربية النسائية في النقب',
    'name_change_year': null,
    'name_common': 'מען',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-01-07'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.maanegev.org/index.php/2014-11-04-07-20-16'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת (פורום) ארגוני נשים ערביות-בדואיות בנגב (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580371334'
      },
      {
        'title': 'معاً - منتدى النساء العربيات في النقب Maan- the Forum of Arab Beduin women, Facebook page. Retrieved from',
        'url': 'https://www.facebook.com/pg/maanegev/about/?ref=page_internal'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '11/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1999,
    'year_registered': 2001
  },
  {
    'activity_kinds': [
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '04/08/2019'
    },
    'description': '״מפגש נשי בגלבוע״ היא עמותה (ע״ר 580616456) שנוסדה בשנת 2015. מטרות העמותה הן: ״להפגיש בין נשים יהודיות וערביות מישובי מועצה איזורית הגלבוע. להקים מרכז לנשים שבו יקויימו מפגשים, פעילויות, הרצאות, סדנאות שיש בהם עניין לנשות הגלבוע״. העמותה מבקשת לקשר ״חבורה מגוונת של נשים יהודיות וערביות מקימות עמותה ליצירת מפגשי נשים סביב הדבר הנפלא ביותר שקיים סביבנו - הטבע.״ העמותה פועלת להקמת מרכז משותף להכנת קוסמטיקה טבעית, תה, מאכלים וגינת ירק ותבלינים ולמכירתם בחנות מבקרים שתהווה גם מרכז תרבותי וחברתי.',
    'description_ar': 'ملتقى نساء الجلبوع هي جمعية (ج.م 580616456) التي تأسست عام 2015 بهد الجمع بين النساء اليهوديات والعربيات من مجلس جلبوع الإقليمي. لإنشاء مركز نسائي تُعقد فيه اجتماعات وأنشطة ومحاضرات وورش عمل تهم النساء في جلبوع. تسعى الجمعية إلى ربط ״مجموعة متنوعة من النساء اليهوديات والعربيات بتأسيس جمعية لإنشاء لقاءات نسائية حول أروع ما يوجد حولنا – الطبيعة. تعمل الجمعية على إنشاء مركز مشترك لإعداد مستحضرات التجميل الطبيعية، الشاي والأطعمة وحديقة الخضروات والتوابل وبيعها في متجر للزوار الذي سيشكل أيضًا مركزًا ثقافيًا واجتماعيًا.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'מלאכות מסורתיות'
      ],
      [
        'שלום'
      ]
    ],
    'id': 'YA16',
    'is_active': true,
    'keywords': [
      'קהילה',
      'בישול',
      'דו קיום'
    ],
    'name': 'מפגש נשי בגלבוע',
    'name_ar': 'ملتقى نساء الجلبوع',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רם-און',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מלאכות מסורתיות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-08-04'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.facebook.com/%D7%9E%D7%A4%D7%92%D7%A9-%D7%A0%D7%A9%D7%99-%D7%91%D7%92%D7%9C%D7%91%D7%95%D7%A2-1673919412897566/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מפגש נשי בגלבוע (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580616456'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '30/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '14/10/2018'
    },
    'description': 'מפלגת הנשים- למען כבוד האשה וחרותה (1992) שסימנה נ״כ הוקמה בשנת בהרצליה והתמודדה בבחירות לכנסת ה-13 כרשימה עצמאית מטעם תנועת ש.י.ן (שוויון ייצוג לנשים). רשימת המועמדות היו: רות רזניק (פעילה פמיניסטית בולטת במאבק באלימות נגד נשים), אסתר הרצוג, בלהה מרזיוף-קליין, נילי גוטין, נגיסט מנגשה, פנינה גבע ועאידה אבו-חבלה. המפלגה השתתפה במסע הבחירות והפיקה משדרי תעמולת בחירות שעסקו בנושאים הנוגעים לשוויון זכויות לנשים. המפלגה לא נבחרה לכנסת לאחר שזכתה במספר קטן מדי של קולות (כ-3,000).',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'SA62',
    'is_active': false,
    'keywords': [
      'בחירות',
      'כנסת',
      'שוויון',
      'ייצוג הולם'
    ],
    'name': 'מפלגת הנשים- למען כבוד האשה וחרותה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'הרצליה',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'מפלגות, שדולות ותאים מפלגתיים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הרצוג, אסתר (2009). מפלגות נשים בישראל: איך ולמה הודרו מהכנסת? <b>סוגיות חברתיות בישראל, 7</b>, 6–45. נדלה מתוך',
        'url': 'http://www.gendersite.org.il/2012/04/25/%D7%A4%D7%A8%D7%95%D7%A4-%D7%90%D7%A1%D7%AA%D7%A8-%D7%94%D7%A8%D7%A6%D7%95%D7%92-%D7%9E%D7%A4%D7%9C%D7%92%D7%95%D7%AA-%D7%A0%D7%A9%D7%99%D7%9D-%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C-%D7%90%D7%99/'
      },
      {
        'title': 'הרצוג, אסתר (2018, 14 אוקטובר, שיחת טלפון). פרטים מתוך ארכיון פרטי.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '14/10/2018'
    },
    'year_closed': 1992,
    'year_closed_text': '1992',
    'year_founded': 1992,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '12/10/2018'
    },
    'description': 'מפלגת הנשים-נס הוקמה בתמיכת מרשה פרידמן שהיתה חברת כנסת בכנסת התשיעית (1973-1977) והתמודדה לבחירות בשנת 1977 תחת השם ״מפלגת הנשים״ שסימנה ״נס״. חברות הרשימה היו: שושנה אלינגס, רות רזניק, תחיה בת-אורן, נורית גילת, אתי בן זיו, עמליה ברגמן, רחל אוסטרוביץ ואחרות. מצע המפלגה נפתח בהצהרה הבאה: ״אנחנו, קבוצת נשים בלתי תלויה, מכריזות על הקמת מפלגת הנשים לקראת הבחירות לכנסת התשיעית, כדי להיאבק למען שחרור ושוויון בין המינים. במאבק זה אנו ממשיכות את מלחמתן של חלוצות המאבק לשיווי זכויות לנשים בארץ ישראל, שהתחילה עם הקמת הישוב העברי ונפסקה לאחר הכנסת הראשונה. חברות התאחדות נשים לשיווי זכויות בישראל, שהיו ראשונות המאבק לשוויון, האמינו כי המדינה תעשה צדק לכל אזרחיה בהתאם למגילת העצמאות - כי מדינת ישראל תקיים שוויון זכויות חברתי ומדיני גמור לכל אזרחיה בלי הבדל דת, גזע ומין״. מפלגת הנשים זכתה ל- 5,674 קולות אך לא עברה את אחוז החסימה. לאחר הבחירות, היו מעורבות פעילות המפלגה בהקמת מספר ארגונים פמיניסטיים חשובים ביניהם המקלט הראשון לנשים מוכות, אל״ף, ול.כ.ן לקידום כדורסל נשים.',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ],
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ],
      [
        'אלימות',
        'אלימות במשפחה'
      ]
    ],
    'id': 'SA60',
    'is_active': false,
    'keywords': [
      'בחירות',
      'כנסת',
      'שוויון'
    ],
    'name': 'מפלגת הנשים-נס',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'מפלגות, שדולות ותאים מפלגתיים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': '<b>אותיות הרשימה: ״נס״ – הכינוי: מפלגת הנשים</b> (רשימת המועמדות למפלגת הנשים – נס) [1977]. נדלה מתוך אתר הספרייה הלאומית',
        'url': 'http://web.nli.org.il/sites/NLI/Hebrew/collections/treasures/elections/all_elections/Documents/1977-moamadim/%D7%9B%D7%A0%D7%A1%D7%AA%209-%20%D7%9E%D7%A4%D7%9C%D7%92%D7%AA%20%D7%94%D7%A0%D7%A9%D7%99%D7%9D.pdf'
      },
      {
        'title': 'מפלגת הנשים – נס: מצע בחירות לכנסת התשיעית (נספח 4) (2011 [1977]). בתוך פוגל-ביזאוי, סילביה, <b>דמוקרטיה ופמיניזם: מגדר, אזרחות וזכויות אדם</b> (עמ\' 225–242). רעננה: האוניברסיטה הפתוחה. נדלה מתוך',
        'url': 'https://www.kotar.co.il/KotarApp/Viewer.aspx?nBookID=102579173#227.5112.6.default'
      },
      {
        'title': 'פרידמן, מרשה. (1990). <b>גולה בארץ המובטחת</b>. מאנגלית: מירי קרסין. תל אביב: ברירות.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '22/10/2018'
    },
    'year_closed': 1978,
    'year_closed_text': '1978',
    'year_founded': 1977,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '14/10/2018'
    },
    'description': 'מפלגת ייצוג שווה הוקמה לפני הבחירות לכנסת החמש-עשרה (1999) ונרשמה כחוק בפנקס המפלגות בו היא רשומה נכון לשנת 2018 תחת מספר מפלגה: 59-900040-3. בדומה למפלגת הנשים שהתמודדה בשנת 1992, גם מפלגה זו הוקמה על ידי תנועת ש.י.ן. ובראש הרשימה עמדה אסתר הרצוג. המפלגה לא השתתפה בסופו של דבר בבחירות. ״בעקבות קשיים כלכליים, ארגוניים ואישיים, הוחלט באסיפה דרמטית של פעילות המפלגה לפרוש מהבחירות זמן קצר טרם קיומן.״ באגף רשימות המועמדים בכנסת אין תיעוד של רשימת המועמדות וכנראה שלא הוגשה רשימה. מטרות המפלגה כפי שמופיעות בפנקס המפלגות: ייצוג שווה שכר שווה והזדמנויות שוות לנשים. ייצוג שווה בתהליכים המובילים לשלום ולמחויבות לקדמו. הצבת החינוך בראש סדר העדיפויות במטרה ליצור חברה שויונית וערכית.​',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ],
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ]
    ],
    'id': 'SA63',
    'is_active': true,
    'keywords': [
      'בחירות',
      'כנסת',
      'שוויון',
      'ייצוג הולם',
      'שלום',
      'חינוך'
    ],
    'name': 'מפלגת ייצוג שווה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'אבן יהודה',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'מפלגות, שדולות ותאים מפלגתיים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הרצוג, אסתר (2009). מפלגות נשים בישראל: איך ולמה הודרו מהכנסת? <b>סוגיות חברתיות בישראל, 7</b>, 6–45. נדלה מתוך',
        'url': 'http://www.gendersite.org.il/2012/04/25/%D7%A4%D7%A8%D7%95%D7%A4-%D7%90%D7%A1%D7%AA%D7%A8-%D7%94%D7%A8%D7%A6%D7%95%D7%92-%D7%9E%D7%A4%D7%9C%D7%92%D7%95%D7%AA-%D7%A0%D7%A9%D7%99%D7%9D-%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C-%D7%90%D7%99/'
      },
      {
        'title': 'הרצוג, אסתר (2018, 14 אוקטובר, שיחת טלפון). פרטים מתוך ארכיון פרטי.'
      },
      {
        'title': 'משרד המשפטים, מאגר רשם המפלגות (ללא תאריך). <b>רשימת המפלגות</b>. נדלה מתוך',
        'url': 'https://data.gov.il/dataset/justice-miflagot/resource/1dbfc053-e92f-4354-92d6-1b99aadb20d7'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '18/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1999,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '10/11/2018'
    },
    'description': 'מפלגת פנינה רוזנבלום הוקמה ב-1999, לקראת הבחירות לכנסת ה-16 על ידי אשת העסקים ודוגמנית העבר פנינה רוזנבלום. המפלגה התמודדה לכנסת במערכת בחירות זו בלבד ולא נכנסה לכנסת. באתר של פנינה רוזנבלום נכתב כי ״45 אלף מצביעים הצביעו עבורי בקלפי, והיו חסרים לי רק 3,000 קולות לעבור את אחוז החסימה ולהיבחר לכנסת.״ בין המועמדים ברשימה היו גם אבי בלשניקוב, מאשה לובלסקי (מזכירת נעמ״ת לשעבר) ואשת העסקים גליה אלבין. בקמפיין הבחירות התמקדה רוזנבלום בין היתר בנושאים כמו קידום נשים. מטרות המפלגה הרשומות הן: \n1.לפעול למען קידום זכויות האישה והפרט בישראל.\n2.לפעול למען חיזוק הכלכלה וקידום העצמאים בישראל.\n3.לפעול למען חיזוק מבנה החברה בישראל.\n4.לפעול למען קידום וחיזוק החינוך בישראל.\n5.לפעול למען ציבור הגימלאים בישראל.\n6.לפעול למען קידום השלום והביטחון במזרח התיכון.​\nבבחירות לכנסת ה-16 התמודד רוזנבלום במסגרת מפלגת הליכוד ובדצמבר 2005 לאחר התפטרותו של צחי הנגבי מהכנסת הושבעה כחברת כנסת, וכיהנה עד אפריל 2006.',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ]
    ],
    'id': 'SA59',
    'is_active': true,
    'keywords': [
      'פוליטיקה',
      'מפלגה',
      'ייצוג הולם',
      'בחירות'
    ],
    'name': 'מפלגת פנינה רוזנבלום',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת גן',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'מפלגות, שדולות ותאים מפלגתיים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'הרצוג, אסתר (2009). מפלגות נשים בישראל: איך ולמה הודרו מהכנסת? <b>סוגיות חברתיות בישראל, 7</b>, 6–45. נדלה מתוך',
        'url': 'http://www.gendersite.org.il/2012/04/25/%D7%A4%D7%A8%D7%95%D7%A4-%D7%90%D7%A1%D7%AA%D7%A8-%D7%94%D7%A8%D7%A6%D7%95%D7%92-%D7%9E%D7%A4%D7%9C%D7%92%D7%95%D7%AA-%D7%A0%D7%A9%D7%99%D7%9D-%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C-%D7%90%D7%99/'
      },
      {
        'title': 'משרד המשפטים, מאגר רשם המפלגות (ללא תאריך). <b>מפלגת פנינה רוזנבלום</b>. נדלה מתוך',
        'url': 'http://www.justice.gov.il/Units/RasutHataagidim/units/RashamMiflagot/Services/Pages/AllParties.aspx'
      },
      {
        'title': 'פנינה רוזנבלום (אתר). נדלה מתוך',
        'url': 'http://www.rosenblum.co.il/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1999,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '27/05/2018'
    },
    'description': '״מקומיות 2018״ היינה קואליציה שיזמה עמותת כ״ן בשיתוף עם קרן ״פרידריך אברט״ ו״קרן דפנה״ לקראת הבחירות לרשויות המקומיות. הקואליציה מאגדת 29 ארגוני נשים ופועלת לקידום נשים סביב שולחנות קבלת ההחלטות במטרה לצמצם את הפערים המגדריים ברשויות המקומיות. בקואליציה חברו ארגונים מכל הקשת הפוליטית מהחברה היהודית והערבית כאחד. פעילות הקואליציה כללה הפצת מידע, קבוצות לימוד וסקרים עריכת כנסים ברחבי הארץ על מנת לעודד יותר נשים לרוץ בבחירות. בעקבות פעילות הקואליציה מספר חברות המועצה גדל בכ-100 נשים. יחד עם זאת, מתוך 257 ראשי רשויות שנבחרו בישראל בשנת 2018 רק שש הן נשים – שיעור של כ – 2.3% בלבד. הקואליציה פועלת בארבעה מישורים עיקריים: (1) העלאת המודעות הציבורית באמצעות קמפיינים חברתיים, כגון״ ״מצביעים רק לרשימה שווה״. (2) איתור נשים פוטנציאליות, עידודן והנעתן להתמודד על תפקידים ברשות המקומית. (3) ניסיון להשפיע על המחויבות של הרשויות הממשלתיות לצמצם את הפער המגדרי. (4) מינוף קשרים פוליטיים ועבודה עם ראשי מפלגות פוליטיות לשלב יותר נשים ברשימות מפלגתיות ברשויות המקומיות ולהגדיל את נוכחותן של נשים באמצעות מיקומן במקומות ריאליים. בין הארגונים החברים בקואליציה: קרן אברהם, אנו, איתך- מעכי, ויצו ישראל, שדולת הנשים בישראל, מוסאוא, נבחרות, נבחרות הציבור, שחרית, ש.ת.י.ל, קולך, אעלאם, היחידה לשוויון מגדרי במרכז המועצות האזוריות, מכון ון ליר- שוות, גבעת חביבה, איגוד היועצות לקידום מעמד האישה בישראל, נשים נגד אלימות, רצות ומשפיעות, מרכז אדווה, קבוצת חבצלת ונשים עושות שלום.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ]
    ],
    'id': 'YH10',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'בחירות',
      'מנהיגות'
    ],
    'name': 'מקומיות 2018',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'קידום מנהיגות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2020-01-19'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://2018.org.il/'
      },
      {
        'title': 'מקומיות 2018, עמוד פייסבוק (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '27/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2017,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/01/2019'
    },
    'description': '״מקלט אור הכרמל בעספיא״ הוקם ב-2002 על ידי ריטה צוקהרייה מקהילת היהודים המשיחיים והוא מופעל על ידי עמותת ״כנפי שחר״ (ע״R 580234086) שהוקמה אף היא על ידי הקהילה ב-1993. העמותה מוגדרת כארגון דת אשר עוסק בחינוך, צדקה ותפילה בציבור. בתחילת דרכו, קלט המקלט קלט נשים שהיו קורבנות סחר למטרות זנות ובהמשך הרחיב את פעילותו לסיוע לנשים חסרות מעמד, פליטות ומבקשות מקלט. המימון העיקרי לפעילות המקלט מגיע מתרומות והוא אינו נתמך על ידי גורמים ממשלתיים, על אף שגורמי רווחה וגם עמותות מפנים אליו נשים. מלבד קורת גג, המקלט מספק חינוך לילדים ושירותי בריאות בשיתוף פעולה עם עמותות אחרות ורופאים בהתנדבות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'הגירה',
        'פליטות ומבקשות מקלט'
      ],
      [
        'תעשיית המין',
        'סחר בנשים'
      ],
      [
        'אלימות',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YH171',
    'is_active': true,
    'keywords': [
      'מקלט',
      'טראומה',
      'סחר בנשים',
      'תמיכה נפשית',
      'אלימות',
      'דיור'
    ],
    'name': 'מקלט אור הכרמל בעספיא',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'עספיא',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'הגירה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פליטות ומבקשות מקלט',
    'primary_target_audience': 'נשים מהגרות עבודה או חסרות מעמד',
    'retrieved': {
      'type{date}': '2019-01-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://carmelcongregation.org.il/ministries/womens-shelter'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>כנפי שחר: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580234086'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי, ועדת המשנה למאבק בסחר בנשים ובזנות (2014, 23 פברואר). <b>פרוטוקול מס\' 17: סיורים באזור חיפה: אופק נשי - מרכז סיוע לנשים בזנות, עלם - עמותה לנוער במצבי סיכון, עוספיה, מרפאה ניידת לנזקי הזנות</b>. נדלה מתוך',
        'url': 'https://main.knesset.gov.il/Activity/committees/Pages/AllCommitteesAgenda.aspx?Tab=3&ItemID=547418'
      },
      {
        'title': 'משה, נטע (2013, 4 יוני). <b>שירותי רווחה ובריאות לנשים חסרות מעמד אזרחי בישראל, נפגעות אלימות מינית ופיזית</b>. ירושלים: הכנסת - מרכז המחקר והמידע. נדלה מתוך',
        'url': 'http://assaf.org.il/he/sites/default/files/%D7%9E%D7%A1%D7%9E%D7%9A%20%D7%9E%D7%9E%D7%9E,%20%D7%A9%D7%A8%D7%95%D7%AA%D7%99%20%D7%A8%D7%95%D7%95%D7%97%D7%94%20%D7%95%D7%91%D7%A8%D7%99%D7%90%D7%95%D7%AA%20%D7%9C%D7%A0%D7%A9%D7%99%D7%9D%20%D7%97%D7%A1%D7%A8%D7%95%D7%AA%20%D7%9E%D7%A2%D7%9E%D7%93%20%D7%90%D7%96%D7%A8%D7%97%D7%99%20%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C,%20%D7%A0%D7%A4%D7%92%D7%A2%D7%95%D7%AA%20%D7%90%D7%9C%D7%99%D7%9E%D7%95%D7%AA%20%D7%9E%D7%99%D7%A0%D7%99%D7%AA%20%D7%95%D7%A4%D7%99%D7%96%D7%99%D7%AA,%20%D7%99%D7%95%D7%A0%D7%99%202013%20(1).pdf'
      }
    ],
    'target_audiences': [
      'נשים מהגרות עבודה או חסרות מעמד'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '01/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2002,
    'year_registered': 1993
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '21/07/2019'
    },
    'description': 'המקלט לנשים נפגעות אלימות במשולש הוקם במימון ובפיקוח משרד הרווחה בשנת 2003 כמקלט השני בישראל עבור נשים ערביות נפגעות אלימות במשפחה. כחלק משיטת המכרזים שהוחלה על המקלטים מאז 2002, המקלט מופעל על ידי עמותת ״ארפאד״ (ע״ר 580339752) שנוסדה בשנת 1999 כעמותה רב-תחומית המספקת שירותי רווחה, חינוך ושיקום במגזר הערבי. העמותה מפעילה גם מרכז יום למניעת אלימות ושירותי סיוע נוספים בתחום זה. משנת 2008 מנהלת את המקלט הדיל אבו-חבלה ומטרתו היא להעניק ״בית חם ומעטפת טיפולית לכל אישה וילדיה שזקוקים לטיפול מקצועי״.',
    'description_ar': 'أنشئ ملجأ ״ارفاد״ للنساء المتضررات من العنف في المثلث بتمويل واشراف من وزارة الرفاه الاجتماعي في عام 2003، كالملجأ الثاني في إسرائيل للنساء العربيات اللواتي يتعرضن للعنف في العائلة. وكجزء من سياسة المناقصات التي طبقت على الملاجئ منذ عام 2002، تم تفعيل الملجأ على يد جمعية ״ارفاد״ (ج.م 580339752) والتي تأسست عام 1999 كجمعية متعددة المجالات واليت وفرت أيضا خدمات الشؤون الاجتماعية، التربية، وإعادة التأهيل في المجتمع العربي. الى جانب هذا شغلت الجمعية كمركز يوم لمنع العنف وخدمات مساعدة أخرى في هذا المجال. منذ عام 2008 تقوم هديل أبو حبلة بإدارة الملجأ والذي يهدف لإعطاء ״بيت دافئ ورزمة علاجية لكل امرأة وأولادها الذين يحتاجون علاج مهني״.',
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'SA143',
    'is_active': true,
    'keywords': [
      'אלימות במשפחה',
      'נשים מוכות',
      'מקלט',
      'ביטחון אישי',
      'דיור',
      'רצח נשים',
      'דרוזיות',
      'בדואיות',
      'פלסטיניות',
      'תמיכה נפשית'
    ],
    'name': 'מקלט ארפאד לנשים ערביות נפגעות אלימות וילדיהן במשולש',
    'name_ar': 'أرفاد من اجل النساء العربيات واولادهن',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'טירה',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>ארפאד (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580339752'
      },
      {
        'title': 'מקלט ארפאד לנשים ערביות נפגעות אלימות וילדיהן במשולש (2019, 1 אוגוסט). הפרטים אומתו בשיחת טלפון עם נציגת הארגון.'
      },
      {
        'title': 'משרד העבודה, הרווחה והשירותים החברתיים (ללא תאריך). <b>אלימות במשפחה: הגנה וסיוע ראשוני - המקלטים לנשים נפגעות אלימות</b>.'
      },
      {
        'title': 'שעלאן, חסן (2016, 28 נובמבר). ״בעלי איים לשרוף אותי ואת הילדים״. נשים מהמגזר הערבי מול המצלמה. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-4883528,00.html'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '21/07/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2003,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '23/06/2019'
    },
    'description': 'המקלט נפתח ב-2003 בעקבות מכרז של משרד הרווחה (ככל הנראה במטרה להרחיב את השירותים לנערות וצעירות ערביות). העמותה שזכתה במכרז ומפעילה אותו לאורך השנים היא עמותת זוהור אלג\'ד המפעילה בנוסף מעון שיקומי לילדים באום אל פחם ומעונות יום בריינה. כשהעמותה זכתה במכרז, הוגשה עתירה בעניין על ידי עמותת נשים נגד אלימות בטענה שאין לה את הניסיון הנדרש. העתירה נדחתה. המקלט הוא ארצי ומקבל עד 15 נערות וצעירות בגילאי 13-25 שעברו פגיעות מיניות ואלימות ושזקוקות להגנה מיידית. הן מגיעות דרך משטרה, בתי חולים, מרכזי סיוע, לשכות לשירותים חברתיים.',
    'description_ar': 'ملجأ فتيات في ضائقة: افتتح عام 2003 من قبل وزارة الرفاه الاجتماعي. (على ما يبدو بهدف توسيع الخدمات للشابات والفتيات العربيات). فازت جمعية زهور الغد بمناقصة الملجأ وتقوم بتشغيله الى جانب مركز تأهيل للأطفال في ام الفحم ونادي يومي في الرينة. بعد ان فازت الجمعية في المناقصة قدمت جمعية نساء ضد العنف استئناف للمحكمة مدعية بان جمعية زهور الغد لا تملك الخبرة الكافية لادارة هذا الملجأ. الا ان المحكمة قد رفضت الاستئناف. الملجأ واسع ومتواجد في مناطق عديدة ويستقبل حتى 15 شابة وفتاه بين أجيال 12-24 المتعرضات لتحرش جنسي وعنف ومن الضروري توفير مكان امن لهم بشكل فوري. حيث يتوجهون للملجأ من خلال الشرطة، مستشفيات، مراكز مساعدة، ولجان الخدمات الاجتماعية.',
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'אלימות',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YH192',
    'is_active': true,
    'keywords': [
      'נשים מוכות',
      'צעירות במצבי סיכון',
      'נערות במצוקה',
      'ביטחון אישי',
      'מקלט',
      'שירות ציבורי',
      'דיור'
    ],
    'name': 'מקלט הגנה לנערות וצעירות',
    'name_ar': 'ملجأ الفتيات في ضائقة',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'הצפון',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'צעירות במצבי סיכון',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת זוהור אלג\'ד: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580245066'
      },
      {
        'title': 'דוברות בזק (2004, 15 נובמבר). תרומת נובמבר: למקלט הראשון לנערות במצוקה במגזר הערבי. <b>News1 מחלקה ראשונה</b>. נדלה מתוך',
        'url': 'https://www.news1.co.il/Archive/0020-D-57877-00.html'
      },
      {
        'title': 'משרד העבודה, הרווחה והשירותים החברתיים ומינהל סיוע לבתי משפט ותקון השרות לנוער, צעירות וצעירים (2017). <b>אוגדן תכניות השירות לנוער, צעירות וצעירים</b>. ירושלים. נדלה מתוך',
        'url': 'http://www.lsf.org.il/data/files/3377_f0935cd7d576df1c9218c5e8e032b42d.pdf'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '23/06/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2003,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '30/07/2018'
    },
    'description': '״טספא״ היה מקלט לנפגעות סחר בנשים, הממומן ומפוקח על ידי משרד העבודה, הרווחה והשירותים החברתיים, ומופעל על-ידי עמותת ״קשת״. המקלט מהווה לנשים בית ומעניק להן הגנה פיזית ומענה לצורכיהן הרפואיים, הרגשיים והחברתיים. במשך שהותן במקלט, נבנית לנשים תכנית טיפול ושיקום התואמת את צרכיה הייחודיים של כל אישה אשר כוללת טיפול פסיכיאטרי ושיקום פסיכו-סוציאלי; סיוע משפטי; שיקום תעסוקתי וקורסים להכשרה מקצועית; פעילויות פנאי והעשרה. תקופת השהייה במקלט נמשכת בין שלושה חודשים לשנה. כאשר הנשים חוזרות למדינת מוצאן, המקלט מספק להן סיוע ותמיכה בהליך הקליטה בארצן. זכאיות לשהות במקלט הן נשים אשר משטרת ישראל קבעה כי יש ראיה לכך שהן נפגעות סחר בבני אדם, עבדות או עבודת כפייה. נשים השוהות במקלט זוכות לאשרת שהייה ועבודה זמנית ולסיוע משפטי ממשרד המשפטים, בכל הנוגע להליכים לפי חוק הכניסה לישראל ולהליכים אזרחיים הנובעים מביצוע העבירות כלפיהן.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'סחר בנשים'
      ],
      [
        'הגירה',
        'סחר בבני אדם'
      ],
      [
        'רווחה וקהילה',
        'זנות וסחר בנשים'
      ]
    ],
    'id': 'YH66',
    'is_active': false,
    'keywords': [
      'אלימות מינית',
      'סחר בנשים',
      'מקלט',
      'פליטות',
      'דיור'
    ],
    'name': 'מקלט טספא-תקווה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'סחר בנשים',
    'primary_target_audience': 'נשים מהגרות עבודה או חסרות מעמד',
    'retrieved': null,
    'sources': [
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2014, 15 יולי). <b>פרוטוקול מס\' 21: דו״ח מחלקת המדינה האמריקאית בנושא הטיפול במאבק בסחר בבני-אדם לשנת 2014</b>. נדלה מתוך',
        'url': 'http://www.knessetnow.co.il/%D7%95%D7%A2%D7%93%D7%95%D7%AA/%D7%A4%D7%A8%D7%95%D7%98%D7%95%D7%A7%D7%95%D7%9C/42808/1-%D7%93%D7%95-%D7%97-%D7%9E%D7%97%D7%9C%D7%A7%D7%AA-%D7%94%D7%9E%D7%93%D7%99%D7%A0%D7%94-%D7%94%D7%90%D7%9E%D7%A8%D7%99%D7%A7%D7%90%D7%99%D7%AA-%D7%91%D7%A0%D7%95%D7%A9%D7%90-%D7%94%D7%98%D7%99%D7%A4%D7%95%D7%9C-%D7%91%D7%9E%D7%90%D7%91%D7%A7-%D7%91%D7%A1%D7%97%D7%A8-%D7%91%D7%91%D7%A0%D7%99-%D7%90%D7%93%D7%9D-%D7%9C%D7%A9%D7%A0%D7%AA-2014-1-%D7%93%D7%95-%D7%97-%D7%9E%D7%97%D7%9C%D7%A7%D7%AA-%D7%94%D7%9E%D7%93%D7%99%D7%A0%D7%94'
      },
      {
        'title': 'כל זכות (ללא תאריך). <b>מקלט לנפגעות סחר בנשים</b>. נדלה מתוך',
        'url': 'https://www.kolzchut.org.il/he/%D7%9E%D7%A7%D7%9C%D7%98_%D7%9C%D7%A0%D7%A4%D7%92%D7%A2%D7%95%D7%AA_%D7%A1%D7%97%D7%A8_%D7%91%D7%A0%D7%A9%D7%99%D7%9D'
      },
      {
        'title': 'United States (US) Department of State (2015). <b>Trafficking in persons report</b>. Retrieved from',
        'url': 'https://2009-2017.state.gov/documents/organization/245365.pdf'
      }
    ],
    'target_audiences': [
      'נשים מהגרות עבודה או חסרות מעמד'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '17/10/2018'
    },
    'year_closed': 2015,
    'year_closed_text': '2015',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '20/07/2019'
    },
    'description': 'המקלט לנשים נפגעות אלימות בחדרה הוקם בשנת 1993. הוא אחד משלושת המקלטים אשר הוקמו ומופעלים על ידי עמותת ל.א. לאלימות נגד נשים שנוסדה בשנת 1977 על ידי רות רזניק. שני המקלטים הנוספים של העמותה נמצאים בהרצליה ובראשון לציון. על פי דיווחי העמותה, שוהים במקלט זה בכל שנה בין 60-70 נשים וכ-80 ילדים. המקלט משרת נשים מכל קבוצות האוכלוסייה שהינן קורבנות אלימות (פיסית, מינית, נפשית, כלכלית, חברתית) מצד בני זוגן ואינן יכולות להשאר בביתן מפאת סכנה פיסית ו/או נפשית לחייהן. בעקבות שיטת המכרזים שהוחלה על המקלטים מאז 2002, הפך המקלט לשירות ממשלתי החייב במכרז ומשרד הרווחה מממן כ-60% מעלות החזקת אשה וילדיה במקלט.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'SA141',
    'is_active': true,
    'keywords': [
      'נשים מוכות',
      'מקלט',
      'ביטחון אישי',
      'דיור',
      'סיוע משפטי'
    ],
    'name': 'מקלט לנשים חדרה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חדרה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-07-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://no2violence.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>לא לחימה באלימות נגד נשים: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580022200'
      },
      {
        'title': 'ינאי, אורי (2005). מקלטי נשים בישראל: מחדשנות וולנטרית לאימוץ ממלכתי. <b>ביטחון סוציאלי, 70</b>, 77–109. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/SocialSecurity/70/article5.pdf'
      },
      {
        'title': 'משרד החינוך, מנהל תיאום ובקרה. פרסי ישראל (ללא תאריך). **מקבלי פרס ישראל בשנת תשס״ט – רות רזניק. נדלה מתוך',
        'url': 'http://cms.education.gov.il/EducationCMS/Units/PrasIsrael/PrashTashsath/RuthReznik/CvRuthReznik.htm'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '20/07/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1993,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': 'המקלט לנשים מוכות בהרצליה נפתח ב־4 באפריל 1978 ביוזמת רות רזניק, תושבת העיר, בעלת משרד לשירותי משרד ופרסום ופעילה בתנועה הפמיניסטית, ובסיוע העירייה. המקלט, השני מסוגו בישראל הוקם על ידי ארגון ל.א. לאלימות. הוא הוקם, לאחר שביולי 1977, רצח מריו איזדמיר את אישתו במכות מקל, וטען להגנתו שלא ציפה שאישתו תמות, ״כי היא היתה רגילה לקבל מכות״. ארבעה חודשים לאחר פתיחת המקלט, בספטמבר 1978, החל משרד העבודה והרווחה לסייע במימון עובדת סוציאלית. ב-18 ליולי 1979, נרצחה כרמלה אשכנזי (נקש) בידי בעלה בפתח המקלט לנשים בהרצליה. רצח זה עורר תגובות קשות בציבור והיווה אבן דרך בהתפתחות המודעות לבעיית האלימות נגד נשים בישראל. הודות להתערבותה של רות רזניק, הקים האגף למעמד האישה של נעמ״ת, בשנת 1983, מרכז למניעת אלימות במשפחה. המקלט בהרצליה נקרא גם ״בית תמר ועדה שליט״ והוא אחד משלושת המקלטים שהקימה ומפעילה עמותת ל.א. לא לאלימות נגד נשים. שני המקלטים הנוספים של העמותה נמצאים בחדרה ובראשון לציון. כיום, שוהות במקלט בכל זמן נתון כ-12 נשים וכ- 30 ילדים. המקלט משרת נשים מכל קבוצות האוכלוסייה, אשר הינן קורבנות אלימות (פיסית, מינית, נפשית, כלכלית, חברתית) מצד בני זוגן ואינן יכולות להשאר בביתן מפאת סכנה פיסית ו/או נפשית לחייהן. בעקבות שיטת המכרזים שהוחלה על המקלטים מאז 2002, הפך המקלט לשירות ממשלתי החייב במכרז. משרד הרווחה מממן כ-60% מעלות החזקת אשה וילדיה במקלט זה, אך אינו משתתף בבניית מקלטים והוצאות הצטיידותם. במשך השנים, סייעו עיריית הרצליה ותורמים פרטיים במימון עלויות התחזוק וההקמה של המקלט ואף העניקה לעמותה קרקע לבניית מבנה חדש.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': '1YB3',
    'is_active': true,
    'keywords': [
      'נשים מוכות',
      'מקלט',
      'ביטחון אישי',
      'פמיניזם',
      'דיור',
      'סיוע משפטי'
    ],
    'name': 'מקלט לנשים מוכות הרצליה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'הרצליה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://no2violence.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>לא לחימה באלימות נגד נשים: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580022200'
      },
      {
        'title': 'ינאי, אורי (2005). מקלטי נשים בישראל: מחדשנות וולנטרית לאימוץ ממלכתי. <b>ביטחון סוציאלי, 70</b>, 77–109. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/SocialSecurity/70/article5.pdf'
      },
      {
        'title': 'משרד העבודה הרווחה והשירותים החברתיים (2018, 29 אוקטובר). <b>מכרז פומבי 179/2018: הפעלת מקלטים לנשים מוכות וילדיהן בפריסה ארצית</b>. נדלה מתוך',
        'url': 'https://www.molsa.gov.il/Tenders/ServicesTenders/Documents/%D7%9E%D7%A4%D7%A8%D7%98%20%D7%9E%D7%9B%D7%A8%D7%96%20179-2018.pdf'
      },
      {
        'title': 'Convention on the elimination of all forms of discrimination against women. Distr.: General, 8 April 1997. CEDAW / C / ISR / 1-2.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '22/06/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1978,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '21/07/2019'
    },
    'description': 'המקלט לנשים מוכות וילדיהן בגליל המערבי, הראשון מסוגו, הוקם באוגוסט 1993, ביוזמת הממשלה ובמימונה, בגליל המערבי. קדמה להקמת המקלט הזה התארגנות נשים ערביות בנצרת, שהחלה בשנת 1991 בשם ״עמותת נשים ונערות ערביות נגד אלימות - נצרת״ שבראשה עמדה עאידה תומא-סלימאן. היתה זו התארגנות של נשים שרובן בעלות מקצוע, נגד אלימות פיזית ומינית כלפי נשים וילדות שפעלה להקמת מקלט חירום ייעודי עבור נשים ערביות. לטענת ינאי (2005) ״אמנם היוזמה להקמת מקלט זה היתה של קבוצת הנשים מנצרת, אבל השרה אורה נמיר נטלה עליה את האחריות להקמתו, והדגימה בכך שהמדינה מעורבת בתחום זה לא פחות מאשר קבוצת הנשים מהגליל״. בעקבות שיטת המכרזים שהוחלה על המקלטים מאז 2002, הפך המקלט לשירות ממשלתי החייב במכרז ומשרד הרווחה מממן כ-60% מעלות החזקת אשה וילדיה במקלט אך עמותת ״נשים נגד אלימות״ ממשיכה להפעילו. המקלט מלווה ונותן טיפול וייעוץ פסיכולוגי, סוציאלי ומשפטי לנשים מוכות וילדיהן, השוהים במקלט לפרקי זמן שונים עד למציאת מסגרת מתאימה לקליטתם. הקיבולת של מקלט זה היא עד 12 נשים ו-24 ילדים וצוות עובדים הכולל אמהות בית, גננות ועובדות סוציאליות. בשנת 1994, החל גם פרויקט דירת מעבר המסייע לנשים ביציאתן מהמקלט.',
    'description_ar': 'في أغسطس 1993 بمبادرة من الحكومة وبتمويلها تم انساء اول ملجأ للنساء العربيات المعنفات في الجليل الغربي. وقد سبق إقامة هذ الملجأ تجمعات مختلفة لنساء عربيات في الناصرة والتي بدأت عام 1991 تحت اسم ״جمعية النساء والشابات العربيات ضد العنف-الناصرة״ والتي ترأستها عايدة توما سليمان. تميزت هذه التجمعات كونها جمعت نساء غالبيتهن مهنيات، ضد العنف الجسدي والجنسي اتجاه النساء والفتيات اللواتي عملن لإقامة ملجأ طوارئ مخصص للنساء العربيات. بحسب ادعاء يناي (2005) ״ على الرغم من ان المبادرة لأنشاء هذا الملجأ كانت من مجموعة نساء نصراويات، فقد تحملت الوزيرة أورا نمير مسؤولية تأسيسها، مما يدل على ان الدولة تهتم بهذا المجال مثلها مثل مجموعة النساء من الجليل״. وكنتيجة لسياسة المناقصات المطبقة على الملاجئ منذ عام 2002، تحول الملجأ لمركز خدمات حكومية والذي يجبر وزارة الرفاه الاجتماعي على تمويل ك 60% من تكلفة إيواء امرأة وأولادها في الملجأ لكن تستمر جمعية ״نساء ضد العنف في تفعيله. يرافق الملجأ ويوفر استشارات نفسية، اجتماعية وقانونية للنساء المعنفات واولادهن، والذين يبقون في الملجأ لفترات مختلفة حتى يتم العثور على إطار مناسب لهم. يستوعب الملجأ حتى 12 امرأة و24 طفل وطاقم العمل الذي يشمل مسؤولات سكن، حاضنات وعاملات اجتماعيات. في عام 1994، انطلق مشروع سكن انتقالي الذي يساعد النساء على مغادرة الملجأ.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'SA146',
    'is_active': true,
    'keywords': [
      'אלימות במשפחה',
      'נשים מוכות',
      'מקלט',
      'ביטחון אישי',
      'דיור',
      'רצח נשים',
      'דרוזיות',
      'בדואיות',
      'פלסטיניות',
      'תמיכה נפשית'
    ],
    'name': 'מקלט לנשים מוכות וילדיהן גליל מערבי',
    'name_ar': 'مأوى النساء المعنفات وأولادهن',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'הצפון',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-07-21'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.wavo.org/he'
      },
      {
        'title': 'ינאי, אורי (2005). מקלטי נשים בישראל: מחדשנות וולנטרית לאימוץ ממלכתי. <b>ביטחון סוציאלי, 70</b>, 77–109. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/SocialSecurity/70/article5.pdf'
      },
      {
        'title': 'משרד המשפטים (2017). <b>עמותת סיוע לנשים ונערות נגד אלימות: דוחות כספיים ליום 31 בדצמבר 2017</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/VF_View_File?guid=8386dc0c11bd948-16d03d141d0fef85-db994c15419acf2376d4bd7ad88241ef29a91aa496569f96ce3843708fa5d541-3bf248ad8fba14ef-1292586cf2a813663'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '21/07/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1993,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '16/05/2018'
    },
    'description': '״מעון חירום לנשים״ נוסד בשנת 1995 על ידי עיריית חיפה, משרד הרווחה וקואליציית הנשים המקומית לצורך הפעלת מעון לנשים מוכות ולילדיהן באזור הצפון. מאז, המעון קולט ומטפל בנשים וילדים המגיעים מכל רחבי הארץ. בשנת 1997 הוקמה העמותה ((ע״ר 580290807) המשמשת כזכיין של משרד הרווחה ומטרותיה הרשמיות הן ״להפעיל מקלט חירום לנשים נפגעות אלימות וילדיהן. מקלט החירום יהווה מקום מקלט ומגורים לנשים נפגעות אלימות פיסית ו/או מינית. בעת שהותן במקלט החירום יפעל הצוות למציאת פתרון ארוך טווח לאשה ולילדיה״. המעון מספק הגנה פיזית ונפשית לעשרות נשים מדי שנים ופועל על מנת לסייע להחלמת הנשים והילדים מהטראומה אותה חוו והכנתם לחיים ללא אלימות מחוץ למקלט. ייחודו העיקרי של ״מעון חירום לנשים״ הינו במודל הרב-תרבותי על פיו הוא פועל. צוות העובדות במעון וכן צוות המתנדבות כולל יהודיות, ערביות, עולות וותיקות הדוברות שפות שונות. העמותה מפעילה גם דירת מעבר וכל שירותיה נתונים תחת פיקוח משרד הרווחה אשר מממן חלק ניכר מההוצאות הבסיסיות של התפעול השוטף של המקלט.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YB33',
    'is_active': true,
    'keywords': [
      'נשים מוכות',
      'מקלט',
      'ביטחון אישי',
      'דיור',
      'סיוע משפטי'
    ],
    'name': 'מעון חירום לנשים',
    'name_ar': 'ملجأ الطوارئ للنساء',
    'name_change_year': null,
    'name_common': 'מקלט לנשים מוכות- נפגעות אלימות במשפחה וילדיהן',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.hwcs.org.il/%D7%90%D7%95%D7%93%D7%95%D7%AA'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מעון חירום לנשים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580290807'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות',
      'נשים עולות מחבר העמים',
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1995,
    'year_registered': 1997
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '17/05/2018'
    },
    'description': 'המקלט לנשים נפגעות אלימות וילדיהן בבאר שבע הוקם בשנת 1994 כחלק מתכניתה של שרת העבודה והרווחה אורה נמיר להרחבת מספר המקלטים לנשים נפגעות אלימות. עד שנת 2005 הופעל המקלט על ידי עמותת מסל״ן (מרכז סיוע לנשים- נגב) ולאחר שנקלע לקשיים כלכליים בעקבות שיטת המכרזים שהוחלה על המקלטים מאז 2002, הועבר ניהול המקלט לידי עמותת ״יחדיו״. עמותת יחדיו, מיסודה של קרן רש״י מספקת שירותי רווחה שונים באזור הדרום, כולל בתחום האלימות במשפחה. המקלט פועל כל השנה על ידי צוות רב-מקצועי הכולל עובדות סוציאליות, מדריכות, מטפלות בילדים ורכזת המלווה את הנשים וילדיהן לאורך כל תקופת שהותן במקלט וגם לאחר היציאה ממנו. באתר העמותה נכתב כי ״מקלט הנשים של יחדיו בדרום [...] מהווה פתרון חרום מיידי המקנה מחסה לנשים הנמצאות במצוקה עקב אלימות כלפיהן. במהלך תקופת שהותן במקלט מושגת רגיעה המאפשרת טיפול בנושאי המשפחה, העצמת האישה וילדיה לקראת המשך ההתמודדות ומתן מענה משפטי לבעיות בהן נתקלת האישה. כמו כן, הילדים זוכים למענה טיפולי וחברתי ולתוכניות העשרה מגוונות.״ בשנת 2017 שהו במקלט זה 73 נשים וכ-71 ילדים.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YB40',
    'is_active': true,
    'keywords': [
      'ביטחון אישי',
      'מקלט',
      'פריפריה',
      'תמיכה נפשית',
      'דיור',
      'סיוע משפטי'
    ],
    'name': 'מקלט לנשים נפגעות אלימות וילדיהן- דרום',
    'name_ar': null,
    'name_change_year': 2005,
    'name_common': null,
    'name_past': 'מסל״ן',
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-17'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.yachdav.org.il/%D7%AA%D7%A2%D7%A1%D7%95%D7%A7%D7%94.html'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת יחדיו באר-שבע ודרום (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580323889'
      },
      {
        'title': 'ינאי, אורי (2005). מקלטי נשים בישראל: מחדשנות וולנטרית לאימוץ ממלכתי. <b>ביטחון סוציאלי, 70</b>, 77–109. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/SocialSecurity/70/article5.pdf'
      },
      {
        'title': 'מסל״ן (2009). <b>דוחות כספיים ליום 31 בדצמבר 2008</b>. נדלה מתוך',
        'url': 'https://www.guidestar.org.il/VF_View_File?guid=4cdd3946f744522-d35c48d934093290-38c4599b66edb0d6bedfe8704309ff8502b8e386da04d60a36a3185ee20297cc-959af365378221ba-3fbbe0dacf47cc870'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '20/06/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1994,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '20/07/2019'
    },
    'description': 'המקלט לנשים נפגעות אלימות בראשון לציון הוקם בשנת 1996 בסיוע משרד הרווחה. הוא אחד משלושת המקלטים אשר הוקמו ומופעלים על ידי עמותת ל.א. לאלימות נגד נשים שנוסדה בשנת 1977 על ידי רות רזניק. שני המקלטים הנוספים של העמותה נמצאים בהרצליה ובחדרה. על פי דיווחי העמותה, שוהים במקלט זה בכל שנה בין 40-55 נשים וכ-70 ילדים. המקלט משרת נשים מכל קבוצות האוכלוסייה שהינן קורבנות אלימות (פיסית, מינית, נפשית, כלכלית, חברתית) מצד בני זוגן ואינן יכולות להשאר בביתן מפאת סכנה פיסית ו/או נפשית לחייהן. בעקבות שיטת המכרזים שהוחלה על המקלטים מאז 2002, הפך המקלט לשירות ממשלתי החייב במכרז ומשרד הרווחה מממן כ-60% מעלות החזקת אשה וילדיה במקלט.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'SA142',
    'is_active': true,
    'keywords': [
      'נשים מוכות',
      'מקלט',
      'ביטחון אישי',
      'דיור',
      'סיוע משפטי'
    ],
    'name': 'מקלט לנשים ראשון לציון',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ראשון לציון',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-07-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://no2violence.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>לא לחימה באלימות נגד נשים: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580022200'
      },
      {
        'title': 'ינאי, אורי (2005). מקלטי נשים בישראל: מחדשנות וולנטרית לאימוץ ממלכתי. <b>ביטחון סוציאלי, 70</b>, 77–109. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/SocialSecurity/70/article5.pdf'
      },
      {
        'title': 'משרד החינוך, מנהל תיאום ובקרה. פרסי ישראל (ללא תאריך). **מקבלי פרס ישראל בשנת תשס״ט – רות רזניק. נדלה מתוך',
        'url': 'http://cms.education.gov.il/EducationCMS/Units/PrasIsrael/PrashTashsath/RuthReznik/CvRuthReznik.htm'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '20/07/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1996,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '29/07/2018'
    },
    'description': 'מקלט ״מעגן״ הוקם בעקבות החלטת ממשלה 2806 מיום 1.12.2002. המקלט מיועד לנפגעות סחר בנשים שקודם לכן שהו בבית המעצר ״קישון״. המקלט הממומן ומפוקח על ידי משרד העבודה, הרווחה והשירותים החברתיים, ומופעל על-ידי עמותת ״קשת״. המקלט מהווה לנשים בית ומעניק להן הגנה פיזית ומענה לצורכיהן הרפואיים, הרגשיים והחברתיים. במשך שהותן במקלט, נבנית לנשים תכנית טיפול ושיקום התואמת את צרכיה הייחודיים של כל אישה אשר כוללת טיפול פסיכיאטרי ושיקום פסיכו-סוציאלי; סיוע משפטי; שיקום תעסוקתי וקורסים להכשרה מקצועית; פעילויות פנאי והעשרה. תקופת השהייה במקלט נמשכת בין שלושה חודשים לשנה. כאשר הנשים חוזרות למדינת מוצאן, המקלט מספק להן סיוע ותמיכה בהליך הקליטה בארצן. זכאיות לשהות במקלט הן נשים אשר משטרת ישראל קבעה כי יש ראיה לכך שהן נפגעות סחר בבני אדם, עבדות או עבודת כפייה. נשים השוהות במקלט זוכות לאשרת שהייה ועבודה זמנית ולסיוע משפטי ממשרד המשפטים, בכל הנוגע להליכים לפי חוק הכניסה לישראל ולהליכים אזרחיים הנובעים מביצוע העבירות כלפיהן. על פי מסמכי משרד הרווחה, המסגרת מיועדת לסייע ל-37 נשים וילדיהן.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'סחר בנשים'
      ],
      [
        'הגירה',
        'סחר בבני אדם'
      ],
      [
        'רווחה וקהילה',
        'זנות וסחר בנשים'
      ]
    ],
    'id': 'YH65',
    'is_active': true,
    'keywords': [
      'אלימות מינית',
      'סחר בנשים',
      'מקלט',
      'דיור'
    ],
    'name': 'מקלט מעגן לנשים נפגעות סחר בבני אדם',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'פתח תקווה',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'סחר בנשים',
    'primary_target_audience': 'נשים מהגרות עבודה או חסרות מעמד',
    'retrieved': {
      'type{date}': '2019-05-15'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.keshet.co/%D7%9E%D7%A2%D7%92%D7%9F-%D7%94%D7%9E%D7%A7%D7%9C%D7%98-%D7%9C%D7%A7%D7%95%D7%A8%D7%91%D7%A0%D7%95%D7%AA-%D7%A1%D7%97%D7%A8-%D7%91%D7%A0%D7%A9%D7%99%D7%9D/'
      },
      {
        'title': 'הקר, דפנה וכהן, אורנה (2012). ״דו״ח מחקר: המקלטים בישראל לנשים ולגברים שורדי סחר בבני אדם״. מוגש למחלקת המדינה של ארצות הברית של אמריקה. אוניברסיטת תל אביב. נדלה מתוך',
        'url': 'https://hotline.org.il/wp-content/uploads/hebrew.pdf'
      },
      {
        'title': 'משרד העבודה, הרווחה והשירותים החברתיים ומינהל סיוע לבתי משפט ותקון השרות לנוער, צעירות וצעירים (2017). <b>אוגדן תכניות השירות לנוער, צעירות וצעירים</b>. ירושלים. נדלה מתוך',
        'url': 'http://www.lsf.org.il/data/files/3377_f0935cd7d576df1c9218c5e8e032b42d.pdf'
      },
      {
        'title': 'רבינוביץ\', מריה (2013). <b>סקירת פעילות של מדינת ישראל בתחום המאבק בסחר בבני-אדם: הטיפול בתופעת הסחר בנשים</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/70bd8d55-f7f7-e411-80c8-00155d010977/2_70bd8d55-f7f7-e411-80c8-00155d010977_11_8287.pdf'
      }
    ],
    'target_audiences': [
      'נשים מהגרות עבודה או חסרות מעמד'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '05/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '26/06/2018'
    },
    'description': 'מרכז אדוה (ע״ר 580157402) הוקם ב-1991 על ידי שלמה סבירסקי, ברברה סבירסקי, יוסי דהאן וויקי שירן. מרכז אדוה הוא מכון מחקר המתמחה בניטור של מגמות חברתיות וכלכליות ובניתוח המדיניות הממשלתית אל מול מגמות אלה, לפי אמות המידה של שוויון וצדק חברתי. המרכז עוסק בין היתר בסוגיות מגדריות ובניתוח מגדרי של המדיניות הכלכלית והחברתית ומוביל בישראל את רעיון הטמעת החשיבה המגדרית במדיניות ובתקציבי הממשלה והרשויות המקומיות. המרכז שותף בפרויקטים וקואליציות בנושא שוויון מגדרי ובהן: ״נשים לתקציב הוגן״, ״שוות ערך לקידום שכר שווה״, ״שותפות״ ו״שוויון מגדרי ברשויות מקומיות״. מרכז אדוה מציע הרצאות, ימי עיון וקורסים בנושאים הנגזרים מתוך תחומי המחקר, ובהם שוויון מגדרי.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף אקדמי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'מרכזי מחקר'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'YH29',
    'is_active': true,
    'keywords': [
      'הטמעת חשיבה מגדרית',
      'תקצוב מגדרי',
      'ניתוח מגדרי',
      'מחקר פמיניסטי',
      'שכר שווה',
      'שוויון',
      'צדק חברתי',
      'פערי שכר',
      'סטטיסטיקה מגדרית'
    ],
    'name': 'מרכז אדוה',
    'name_ar': 'مركز أدفا',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'אקדמי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מרכזי מחקר',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://adva.org/he/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז אדוה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580157402'
      },
      {
        'title': 'ברברה סבירסקי. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%91%D7%A8%D7%91%D7%A8%D7%94_%D7%A1%D7%91%D7%99%D7%A8%D7%A1%D7%A7%D7%99'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '26/06/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1991,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '10/11/2018'
    },
    'description': 'המרכז האזורי הרב-תחומי לטיפול בנפגעות תקיפה מינית בראשל״צ הוא אחד מהמרכזים הרב-תחומיים הציבוריים המתמחים בטיפול בטראומה מינית. ב-1999 שירותי הרווחה בראשל״צ פנו למשרד הרווחה בבקשה להקים מרכז טיפולי לנפגעות תקיפה מינית. ב-2001 משרד הרווחה באמצעות השירות לנערות וצעירות בעיר הקימו את השירות. במרכז הוקם מוסד טיפול רב תחומי ששודרג והורחב ב-2008 בעקבות התכנית הבין-משרדית לטיפול בנפגעות תקיפה מינית. המרכז מציע מלבד טיפול יום גם דירת מעבר ופיתח מודל תעסוקה באמצעות הקרן למפעלים מיוחדים בביטוח הלאומי.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'רווחה וקהילה',
        'אלימות מינית'
      ]
    ],
    'id': 'YH144',
    'is_active': true,
    'keywords': [
      'טיפול נפשי',
      'תקיפה מינית',
      'צעירות',
      'דיור',
      'הכשרה מקצועית'
    ],
    'name': 'מרכז אזורי רב-תחומי לטיפול בנפגעות תקיפה מינית בראשל״צ',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ראשון לציון',
    'organization_kind': [
      'מוניציפלי',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'עיריית ראשון לציון (אתר). מרכז אזורי רב תחומי לטיפול בנפגעות/ נפגעי תקיפה מינית. נדלה מתוך',
        'url': 'https://www.rishonlezion.muni.il/Lists/List21/CustomDispForm.aspx?ID=43'
      },
      {
        'title': 'רימון-גרינשפן, הילה (2016). <b>טראומה בטיפול. פגיעה מינית ואשפוז פסיכיאטרי: מיפוי שירותים ומדיניות בריאות</b>. נייר מדיניות מטעם איגוד מרכזי הסיוע לנפגעות ונפגעי תקיפה מינית וארגון בזכות – המרכז לזכויות אדם של אנשים עם מוגבלות: ירושלים. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/20/Committees/20_cs_bg_344255.pdf'
      },
      {
        'title': 'כהן, אילנה (2011). המודל הרב-תחומי לטיפול בנפגעות תקיפה מינית. <b>מידעו״ס 60</b> (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2001,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': 'מואססת חדאנאת אלנאסרה היא כיום עמותה. ראשיתה בהקמת המעון הראשון לגיל הרך בחברה הערבית, בנצרת, בשנת 1984 ביוזמת תנד״י (תנועת נשים דמוקרטיות). שם המעון היה The Nazareth Nursery. בשנת 1989, ביוזמת נבילה אספניולי, התרחבה הפעילות בתחום זה והוקם ״מרכז אלטופולה״ שמטרותיו היו: קידום החינוך לגיל הרך בחברה הפלסטינית בישראל, הכשרת צוותי חינוך לגיל הרך, הכשרת אמהות לטיפול וחינוך בגיל הרך, קידום ותמיכה בנשים ושינוי חברתי. בשנת 1990 המרכז נרשם כעמותה בשם ״מואססת חדאנאת אלנאסרה״ (ע״ר 580131498), שמטרותיה הן: ״צדקה וסיוע לנזקקים. פעילות לרווחת נשים עובדות, טיפול בגיל הרך והקמת והפעלת מעון יום״. מרכז אל-טופולה מקיים פעילויות חינוכיות רבות בבית הארגון בנצרת, כולל הפעלת מעון יום, הוצאה לאור, מרכז הכשרה והדרכה לקידום גישה הוליסטית בחינוך הגיל הרך. הוא גם מעורב בקואליציות פמיניסטיות ופרויקטים קהילתיים לקידום מנהיגות וזכויות של נשים פלסטיניות בישראל. הארגון פועל בין היתר נגד אלימות, גזענות, עוני וכל צורות האפליה.',
    'description_ar': 'في عام 1984 أقيمت في الناصرة الحضانة الأولى للطفولة المبكرة في المجتمع العربي بمبادرة من حركة النساء الديمقراطيات (تاندي) في البداية سُمية الحضانة، بحضانة الناصرة وفي عام 1989 بمبادرة من نبيلة اسبانيولي تم توسيع مجال العمل هذا وتم تأسيس ״مركز الطفولة״ الذي عمل بهدف: تعزيز التربية في مرحلة الطفولة المبكرة في المجتمع الفلسطيني في إسرائيل، تمكين طواقم متخصصة في التربية بمرحلة الطفولة المبكرة، تمكين أمهات للعناية وتربية جيل الطفولة المبكرة، تعزيز ودعم النساء والتغيير المجتمعي. في عام 1990 سُجل المركز كجمعية باسم ״مؤسسة حضانات الناصرة״ (ج.م 580131498) وأهدافها هن: صدقة ومساعدة المحتاجين. نشاطات لشؤون النساء العاملات، العناية بالجيل المبكر وتفعيل حضانة يومية״. يقوم مركز الطفولة بنشاطات تربوية مختلفة في مقر الجمعية في الناصرة، والتي تشمل حضانات يوم، إصدارات- نشر كتب، مركز ارشاد وتدريب لتعزيز النهج الشمولي في التعليم في مرحلة الطفولة المبكرة وله صله في الائتلافات النسوية ومشاريع جماهيرية لتعزيز قيادة وحقوق النسويات في إسرائيل. تعمل المنظمة ضد العنف العنصرية، الفقر وكل أنواع التمييز.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'חינוך',
        'הגיל הרך'
      ]
    ],
    'id': '1YB7',
    'is_active': true,
    'keywords': [
      'אמהות',
      'הכשרה',
      'הוצאה לאור',
      'מוגבלויות',
      'מידע',
      'האמנה לביעור כל צורות ההפליה נגד נשים 1979 CEDAW',
      'החלטה 1325'
    ],
    'name': 'מואססת חדאנאת אלנאסרה',
    'name_ar': 'مركز الطفولة',
    'name_change_year': null,
    'name_common': 'מרכז אלטופולה',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נצרת',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-09-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.altufula.org/en/home'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מואססת חדאנאת אלנאסרה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580131498'
      },
      {
        'title': 'אבו-בקר, ח\'אולה (2015). התנועה הנשית-פמיניסטית הפלסטינית בתוך ישראל. בתוך: סבאע\'-ח\'ורי, אריז\' ורוחנא, נדים (עורכים). <b>הפלסטינים בישראל: עיונים בהיסטוריה, בפוליטיקה ובחברה</b>. כרך שני (עמ\' 205–222). חיפה: מדה אל-כרמל. נדלה מתוך',
        'url': 'http://mada-research.org/wp-content/uploads/2016/01/hebrew_2-4.pdf'
      },
      {
        'title': 'Altufula Center مركز الطفولة, Facebook page.',
        'url': 'https://www.facebook.com/Altufula-Center-%D9%85%D8%B1%D9%83%D8%B2-%D8%A7%D9%84%D8%B7%D9%81%D9%88%D9%84%D8%A9-457016824329504/'
      },
      {
        'title': 'جنان عبده. (2008). الجمعيّات النسائيّة والنسويّة الفلسطينيّة- في مناطق 48, مدى الكرمل'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '11/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1984,
    'year_registered': 1990
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '18/11/2019'
    },
    'description': 'עמותת ״אלי״ס – אימהות למען ילדים בסיכון״ (ע״ר 580477974) הוקמה בשנת 2007 בבני ברק על ידי קבוצת אמהות, יוצאות חבר העמים שילדיהן מכורים לסמים. מטרת העמותה היא לפעול למען: ״חינוך והעצמה לאמהות של ילדים בסיכון. מניעה וטיפול בתופעת התמכרות בסמים ואלכוהול. פעילות לשינוי מדיניות של הממשלה ביחס לטיפול בקבוצות סיכון. הרחבת רשתות טיפוליות שיקומיות ותומכות באוכלוסיית סיכון. הפעלת חוג לתיאטרון ויצירת הופעות והצגות. פעילות הוצאה לאור לשם מניעת שימוש בסמים ואלכוהול. פעילות בקרב עולים חדשים לשם השתלבות בחברה הישראלית וכן פעילות למניעת שימוש בסמים ואלכוהול. הפעלת פרויקטים אמנותיים לשם מניעת שימוש בסמים ואלכוהול״. העמותה פועלת בעיקר באזור תל אביב על מנת לסייע להורים עולים שילדיהם מכורים לסמים על ידי מתן מידע נגיש בשפה הרוסית, תמיכה, סיוע וייעוץ, בין היתר באמצעות קו טלפוני. העמותה גם מפעילה מתנדבים שמציעים הסברה, עזרה וליווי למכורים ברחוב כדי לסייע להם לצאת ממעגל הסמים. בנוסף, העמותה עובדת אל מול מקבלי החלטות בכנסת ובממשלה על מנת לעורר מודעות ציבורית לבעיית הסמים בקרב צעירים דוברי רוסית ולקדם הצעות חקיקה ושינוי מדיניות בתחום הטיפול בבעיית הסמים. בראש העמותה עומדת אירינה לוית. לעמותה נמצאת בקשר שוטף עם כ-400 הורים שילדיהם מכורים לסמים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'הגירה',
        'קליטת עלייה'
      ]
    ],
    'id': 'SA164',
    'is_active': true,
    'keywords': [
      'אמהות',
      'קו סיוע',
      'התמכרות',
      'הורים',
      'תמיכה נפשית',
      'שיקום',
      'סיוע לאמהות'
    ],
    'name': 'מרכז אמהות למען ילדים בסיכון (אלי״ס)',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'התמכרויות ושיקום',
    'primary_target_audience': 'נשים עולות מחבר העמים',
    'retrieved': {
      'type{date}': '2019-11-18'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.alisisrael.org/home-c1gzy'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז אמהות למען ילדים בסיכון (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580477974'
      },
      {
        'title': 'אלי״ס - אימהות למען ילדים בסיכון, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/alisisrael/'
      },
      {
        'title': 'הוועדה למלחמה בנגעי הסמים והאלכוהול (2014, 20 ינואר). <b>פרוטוקול מס\' 12: סקירת המשטרה: סיכום שנת 2013 ומגמות בתחום המאבק בסמים</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/Activity/committees/Pages/AllCommitteeProtocols.aspx?Comid=27&fDate=04/12/2018&tDate=04/12/2018'
      }
    ],
    'target_audiences': [
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '18/11/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2007,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '10/11/2018'
    },
    'description': '״מרכז בנפשנו״ נוסד ב-2013 על מנת לטפל בטראומה מינית בקרב נערות דתיות וחרדיות מגיל 18 ומעלה ומ-2016 גם לגברים. המרכז מופעל על ידי עמותת ״בית חם״ בפיקוח ובמימון משרד הרווחה ובתמיכת קרן ידידות טורונטו. המרכז מקיים שיתוף פעולה מקצועי עם מרכז לטם באיכילוב.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'רווחה וקהילה',
        'אלימות מינית'
      ]
    ],
    'id': 'YH145',
    'is_active': true,
    'keywords': [
      'טראומה',
      'טיפול נפשי',
      'אונס',
      'תקיפה מינית',
      'הכשרה מקצועית'
    ],
    'name': 'מרכז בנפשנו',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'בני ברק',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2018-11-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.bayit-cham.org.il/the-benafsheinu-treatment-center/'
      },
      {
        'title': 'פרקש, טלי (2015, 18 נובמבר). שוברות שתיקה: המלאכים של החרדיות שהותקפו. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-4727607,00.html'
      },
      {
        'title': 'רימון-גרינשפן, הילה (2016). <b>טראומה בטיפול. פגיעה מינית ואשפוז פסיכיאטרי: מיפוי שירותים ומדיניות בריאות</b>. נייר מדיניות מטעם איגוד מרכזי הסיוע לנפגעות ונפגעי תקיפה מינית וארגון בזכות – המרכז לזכויות אדם של אנשים עם מוגבלות: ירושלים. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/20/Committees/20_cs_bg_344255.pdf'
      }
    ],
    'target_audiences': [
      'נשים חרדיות',
      'גברים חרדים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '10/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '08/11/2018'
    },
    'description': 'מרכז בת עמי פועל בהדסה עין כרם משנת 2009 והוא אחד מחמישה מרכזים אקוטיים לטיפול בנפגעות תקיפה מינית, באחריות משרד הבריאות. המרכז מציע לנפגעות ונפגעי תקיפה מינית טיפול יעיל ורב-תחומי בפגיעות גופניות ונפשיות במסגרת המבטיחה הגנה, פרטיות וסודיות. במרכז ניתן סיוע במניעת הריון, מניעת מחלות המועברות ביחסי מין באינוס וכן באיסוף ותיעוד ראיות שישמשו, אם הנפגעת תרצה בכך, לצורך הגשת תלונה במשטרה. שירותי המרכז מיועדים לנפגעי/ות תקיפה מינית בכל גיל, מין, לאום ודת, שהפגיעה בהם התרחשה עד שבוע טרם הפניה לבית החולים. תקציב המרכז מגיע ברובו ממשרד הבריאות ומארגון הדסה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'YH136',
    'is_active': true,
    'keywords': [
      'טראומה',
      'אונס',
      'מחלות מין',
      'הריון',
      'בית חולים',
      'משפט'
    ],
    'name': 'מרכז בת עמי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-08-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.hadassah.org.il/medical-care/%D7%A9%D7%99%D7%A8%D7%95%D7%AA%D7%99%D7%9D-%D7%A8%D7%A4%D7%95%D7%90%D7%99%D7%99%D7%9D-%D7%A0%D7%9C%D7%95%D7%95%D7%99%D7%9D/%D7%A2%D7%91%D7%95%D7%93%D7%94-%D7%A1%D7%95%D7%A6%D7%99%D7%90%D7%9C%D7%99%D7%AA/thomim-yihudiim/bat-ami.aspx'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2017, 10 ינואר). <b>פרוטוקול מס\' 137: טיוב הטיפול הראשוני בנפגעות אלימות מינית - חדרי מיון ומרכזים אקוטיים</b>. נדלה מתוך',
        'url': 'https://oknesset.org/meetings/2/0/2011732.html'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/08/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2009,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'שירותים משפטיים'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '21/07/2019'
    },
    'description': 'מרכז גליקמן נעמת לטיפול ולמניעת אלימות במשפחה פועל כמודל ייחודי המשלב תחת קורת גג אחת טיפול מיידי בנפגעות אלימות במסגרת מקלט מוגן לנשים מוכות וילדיהן, ואבחון וטיפול ארוך טווח במסגרת המרכז הפתוח. השירות פועל בשותפות עם עיריית תל אביב ומשרד העבודה והרווחה. על פי אורי ינאי (2005), בסוף אוגוסט 1994 ביקשו נעמת ועיריית תל־אביב, במשותף, להקים מעון לנשים מוכות בשכונת מעוז אביב במימון ״קרן תל־אביב לפיתוח״ ונעמת-קנדה. פתיחת המקלט נדחתה בשל התנגדות התושבים, אולם, בספטמבר 1996 חנכו שר העבודה והרווחה, ראש עיריית תל־אביב ויושבת־ראש נעמת את המעון לנשים מוכות הראשון בתל־אביב. המימון הראשוני להקמת המקלט, מיליון דולר בערך, בא מכספי תרומות. בעקבות שיטת המכרזים שהוחלה על המקלטים מאז 2002, הפך המקלט לשירות ממשלתי החייב במכרז ומשרד הרווחה מממן חלק ניכר מעלות החזקת אשה וילדיה במקלט. כיום, שוהות במקלט בכל זמן נתון כ-12 נשים וילדיהן והוא משרת נשים מכל קבוצות האוכלוסייה שהינן קורבנות אלימות מצד בני זוגן ואינן יכולות להשאר בביתן מפאת סכנה פיסית ו/או נפשית לחייהן. זמן השהייה הממוצע במקלט הוא כחצי שנה ויש בו גם גן ילדים. בשנת 2002 הורחבה פעילות נעמת בתחום האלימות במשפחה ונפתח מרכז גליקמן כמרכז הדרכה מוביל להתמודדות עם תופעת האלימות במשפחה. המרכז נותן מענה טלפוני מיידי ומתפקד כ״חדר מיון״ לאבחון והערכת סיכון מיידית ועתידית תוך מתן סיוע מיידי לנפגעות אלימות במשפחה. במסגרת הטיפול ארוך הטווח בנפגעות ובתוקפים מתקיימות במרכז קבוצות תמיכה והעצמה לנשים, קבוצות טיפוליות שמטרתן גמילה מאלימות לגברים אלימים ולמידת תקשורת חלופית, קבוצה להורות, טיפול בילדים חשופים לאלימות, וכן יעוץ משפטי ועריכת הסכמי שלום בית או גירושין ע״י עורכת דין ומגשרת מוסמכת התמחה בתחום.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'SA145',
    'is_active': true,
    'keywords': [
      'נשים מוכות',
      'מקלט',
      'ביטחון אישי',
      'דיור',
      'גברים אלימים',
      'מרכזים למניעה וטיפול באלימות במשפחה',
      'סיוע משפטי',
      'קו סיוע',
      'מידע',
      'חינוך',
      'קבוצת תמיכה',
      'תמיכה נפשית'
    ],
    'name': 'מרכז גליקמן נעמת לטיפול ולמניעת אלימות במשפחה',
    'name_ar': null,
    'name_change_year': 2002,
    'name_common': null,
    'name_past': 'מעון חירום לנשים מוכות תל אביב',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-07-21'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.naamat.org.il/%D7%90%D7%9C%D7%99%D7%9E%D7%95%D7%AA-%D7%9B%D7%9C%D7%A4%D7%99-%D7%A0%D7%A9%D7%99%D7%9D/%D7%9E%D7%A8%D7%9B%D7%96-%D7%A7%D7%9C%D7%99%D7%92%D7%9E%D7%9F-%D7%A0%D7%A2%D7%9E%D7%AA/'
      },
      {
        'title': 'ינאי, אורי (2005). מקלטי נשים בישראל: מחדשנות וולנטרית לאימוץ ממלכתי. <b>ביטחון סוציאלי, 70</b>, 77–109. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/SocialSecurity/70/article5.pdf'
      },
      {
        'title': 'משרד המשפטים (2018, 8 יולי). <b>נעמת – תנועת נשים עובדות ומתנדבות (ע.ר). דוח מילולי לשנה שהסתיימה ביום 31 בדצמבר 2017</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/VF_View_File?guid=b79258ec5b7936f-7d0ba7bf5c39929e-dd329c68fdbbd63686b2e53aae3732ff0ae98773d4e91a056fc3a605595003df-de5ff3d7cf7bdbee-3295091fea7b8fe49'
      },
      {
        'title': 'משרד העבודה, הרווחה והשירותים החברתיים, <b>אלימות במשפחה: הגנה וסיוע ראשוני - המקלטים לנשים נפגעות אלימות</b>.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '21/07/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1996,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '19/05/2019'
    },
    'description': 'מרכז ״דיאלוג מחודש״ לטיפול בגברים אלימים הוקם בשנת 2010 בבאר שבע כמרכז יום המעניק שירות באזור הדרום בהתאם למודל של ״בית נועם״ באזור המרכז. המרכז הוקם והופעל באמצעות מכרז על ידי עמותת ״יחדיו״ וקרן רש״י בשיתוף פעולה הדוק עם שירות המבחן למבוגרים ונמצא באחריות השירות לטיפול בפרט ובמשפחה במשרד העבודה, הרווחה והשירותים החברתיים. אוכלוסיית היעד של מרכז היום היתה גברים בגירים הנוהגים באלימות בזוגיות, ובעיקר גברים השוהים תחת תנאים מגבילים בעקבות ביצוע עבירת אלימות במשפחה. במרכז פעלו חמש תוכניות טיפול. (1) מרכז טיפול יום הכולל קבוצות טיפוליות וחווייתיות; (2) מרכז טיפול ערב המיועד לגברים אשר משולבים במסגרות עבודה במהלך היום. (3) קבוצת בוגרים: מיועדת לגברים אשר סיימו את הטיפול במרכז היום או הערב באופן מספק וזקוקים להמשך טיפול ולמסגרת תומכת. (4) דירת של״ב: מסגרת ביתית טיפולית המשמשת קורת גג ופתרון דיור לגברים אשר הורחקו מביתם בהליך פלילי או אזרחי לטווח זמן של עד חצי שנה. (5) תוכנית משולבת: התוכנית משלבת את מרכז היום ואת דירת השל״ב ומאפשרת טיפול אינטנסיבי ופיקוח במשך 24 שעות ביממה. מהדוחות השנתיים של עמותת יחדיו עלה כי בפעילויות המרכז השתתפו כ-80 משתתפים מדי שנה. התכנית הוכרה על די הקרן למפעלים מיוחדים בביטוח לאומי ולוותה במחקר הערכה, אך נסגרה בסוף שנת 2017. בשנת 2018 הוקם מרכז יום חדש לטיפול בגברים אלימים באזור אשקלון שמופעל על ידי עמותת ״קשת-שירותי תקון״.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'SA135',
    'is_active': false,
    'keywords': [
      'הוסטל',
      'גברים אלימים',
      'קבוצת תמיכה',
      'דיור'
    ],
    'name': 'מרכז דיאלוג מחודש',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'גברים',
    'retrieved': null,
    'sources': [
      {
        'title': 'וינשטיין, רחל ובן שמחון, מירי (2018). מבוגרים המעורבים בהליכים פליליים. בתוך <b>סקירת השירותים החברתיים לשנת 2016</b> (פרק 4 חלק ב\'). משרד העבודה הרווחה והשירותים החברתיים. נדלה מתוך',
        'url': 'https://www.gov.il/he/Departments/publications/reports/molsa-social-services-review-2016'
      },
      {
        'title': 'וינשטיין, רחל, גורבטוב, רנטה ובן שמחון, מירי (2011). מבוגרים המעורבים בהליכים פליליים. בתוך <b>סקירת השירותים החברתיים לשנת 2010</b> (פרק 4 חלק ג\'). משרד העבודה הרווחה והשירותים החברתיים. נדלה מתוך',
        'url': 'https://www.gov.il/he/Departments/publications/reports/molsa-social-services-review-2010'
      },
      {
        'title': 'יחדיו, קרן רש״י (ללא תאריך). <b>דיאלוג מחודש – בסכנת סגירה</b> (סרטון). נדלה מתוך',
        'url': 'http://www.yachdav.org.il/%D7%93%D7%99%D7%90%D7%9C%D7%95%D7%92-%D7%9E%D7%97%D7%95%D7%93%D7%A9-%D7%91%D7%A1%D7%A0%D7%AA-%D7%A1%D7%92%D7%99%D7%A8%D7%94.html'
      }
    ],
    'target_audiences': [
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/05/2019'
    },
    'year_closed': 2018,
    'year_closed_text': '2018',
    'year_founded': 2010,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '28/10/2018'
    },
    'description': 'ב-2015 הוקם המרכז ההוליסטי ואוחדו לתוכו מרכז היום התעסוקתי וההוסטל לאסירות משוחררות. בנוסף הורחב המענה הטיפולי הניתן לנשים. במרכז פועל גם סטודיו ״זות זות״ - סטודיות לגרפיקה המספק הכשרה ותעסוקה לנשים בתנאים מוגנים. המרכז מהוות את יחידת הטיפול והשיקום של אסירות משוחררות במחוז מרכז ומשרת אוכלוסיה שבין גדרה לחדרה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ]
    ],
    'id': 'YH118',
    'is_active': true,
    'keywords': [
      'אסירות',
      'שיקום',
      'תמיכה נפשית',
      'אמהות',
      'העצמה',
      'חינוך',
      'סיוע משפטי',
      'אלימות'
    ],
    'name': 'מרכז הוליסטי לשיקום אסירות משוחררות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': 'המנגנון הוא איחוד של שני מנגנונים שקדמו לו: ״הוסטל לאסירות משוחררות״ ו״מרכז יום תעסוקתי לאסירות משוחררות״',
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'התמכרויות ושיקום',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.pra.co.il/%D7%94%D7%95%D7%A1%D7%98%D7%9C.html'
      },
      {
        'title': 'אפודי, רותם ואלעד דהן (2016). <b>הרשות לשיקום האסיר: סיכום שנת עבודה 2015</b>. נדלה מתוך',
        'url': 'https://sfilev2.f-static.com/image/users/180409/ftp/my_files/%D7%97%D7%95%D7%91%D7%A8%D7%AA%20%D7%A1%D7%99%D7%9B%D7%95%D7%9D%20%D7%A9%D7%A0%D7%AA%20%D7%A2%D7%91%D7%95%D7%93%D7%94%202015.pdf?id=27544564'
      },
      {
        'title': 'מליקסון, אנבל (עורכת) (2018). <b>הרשות לשיקום האסיר: דוח מסכם לשנת 2017</b>. נדלה מתוך',
        'url': 'https://sfilev2.f-static.com/image/users/180409/ftp/my_files/%D7%97%D7%95%D7%91%D7%A8%D7%AA%20%D7%A1%D7%99%D7%9B%D7%95%D7%9D%20%D7%A9%D7%A0%D7%94%20%D7%9C%D7%A9%D7%A0%D7%AA%202017.pdf?id=31003097'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '28/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '16/05/2018'
    },
    'description': 'מרכז הסיוע לנפגעות ונפגעי תקיפה מינית- חיפה והצפון (ע״ר 580005767) הוקם כעמותה פמיניסטית המציעה שירותי תמיכה בכל אזור הצפון ומחדרה ועד לגבול הצפוני (למעט אזור קרית שמונה, צפת, גולן וסובב כנרת). המרכז הוקם בשנת 1979 במטרה לתת מענה טלפוני מיידי לנשים ונערות נפגעות אלימות מינית ופעילויותיו הלכו והתרחבו במשך הזמן. המרכז מפעיל קו סיוע הפועל 24 שעות ביממה, מעניק סיוע נפשי ומעשי לנפגעות תקיפה מינית הכולל ליווי בהליך הפלילי, במסגרתו מלוות מתנדבות את הנפגעות לבתי חולים, תחנות משטרה. בנוסף, המרכז מפעיל מחלקת חינוך והסברה ומקדם מערכות קהילתיות המאפשרות טיפול מותאם לצורכי הנפגעות. העמותה מתקיימת מתרומות ומתמיכות של משרד הרווחה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'חינוך',
        'מניעת אלימות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'YB28',
    'is_active': true,
    'keywords': [
      'אונס',
      'הטרדה מינית',
      'קו סיוע',
      'תמיכה נפשית',
      'סיוע משפטי'
    ],
    'name': 'מרכז הסיוע לנפגעות אונס ותקיפה מינית- חיפה והצפון',
    'name_ar': 'مركز مساعدة ضحايا الاغتصاب والاعتداءات الجنسية، حيفا',
    'name_change_year': 2006,
    'name_common': null,
    'name_past': 'מרכז סיוע לקורבנות אונס - אזור חיפה',
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.1202.org.il/local/haifa/about'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז סיוע לנפגעות אונס ותקיפה מינית – חיפה והצפון (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580005767'
      },
      {
        'title': 'מרכז סיוע לנפגעות ונפגעי תקיפה מינית - חיפה והצפון, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/HaifaRapeCrisisCenter/?ref=page_internal'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1979,
    'year_registered': 1981
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '16/05/2018'
    },
    'description': 'מרכז הסיוע לנפגעות תקיפה פיזית ומינית בנצרת הוקם בשנת 1992, כפרויקט הראשון של עמותת ״נשים נגד אלימות״. המרכז מספק קו תמיכה טלפוני שפועל 24 שעות ביממה על ידי צוות מתנדבות ועובדות המספק תמיכה ראשונית, מידע וייעוץ. מעבר לכך, המרכז מסייע בליווי של נשים ונערות בהליך הפלילי ועורך הכשרות לאנשי מקצוע, שוטרים ומשפטנים. תחומי פעילות המרכז כוללים: סיוע, חינוך והסברה, הכשרות לאנשי מקצוע, מניעת הטרדה מינית בעבודה. בתעודת הרישום של משרד הפנים נקראת העמותה ״סיוע לנשים ונערות נגד אלימות״. השם ״מרכז הסיוע לנפגעי ונפגעות תקיפה מינית, נצרת״ הוא שמה בפרסומים ובאתר העמותה. המרכז הוא אחד הארגונים השותפים באיגוד מרכזי הסיוע לנפגעות תקיפה מינית.',
    'description_ar': 'تأسس مركز مساعدة ضحايا العنف والاعتداء الجنسي والجسدي – الناصرة عام 1992، بمثابة المشروع الاوب لجمعية نساء ضد العنف. حيث وفر المركز خدمات خط طوارئ يعمل 24 ساعة بإشراف طاقم متطوعات وموظفات بهدف إعطاء دعم اولي، معلومات واستشارة. إضافة الى ذلك يرافق مركز المساعدة النساء والشابات في الإجراءات الجنائية ويوفر التدريب للمهنيين وضباط الشرطة والمحامين. نشاط المركز يشمل: المساعدة، التعليم والارشاد، تدريب المهنيين والوقاية من التحرش الجنسي في العمل. في شهادة تسجيل وزارة الداخلية سجلت الجمعية باسم ״مساعدة النساء والفتيات ضد العنف״. اسم ״مركز ضحايا الضحايا وضحايا الاعتداء الجنسي، الناصرة״ هو اسمها في المنشورات وعلى موقع الجمعية. المركز هو أحد المنظمات الشريكة في اتحاد مراكز مساعدة ضحايا الاعتداء الجنسي.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'חינוך',
        'מניעת אלימות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'YB27',
    'is_active': true,
    'keywords': [
      'אונס',
      'הטרדה מינית',
      'קו סיוע',
      'תמיכה נפשית',
      'סיוע משפטי',
      'בדואיות',
      'דרוזיות',
      'פלסטיניות'
    ],
    'name': 'מרכז הסיוע לנפגעות ולנפגעי תקיפה מינית, נצרת',
    'name_ar': 'مركز مساعدة ضحايا العنف والإعتداء الجنسي والجسدي - الناصرة',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נצרת',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-05-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.1202.org.il/local/nazareth/about'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>סיוע לנשים ונערות נגד אלימות: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580207199'
      },
      {
        'title': 'משרד הפנים, רשם העמותות (ללא תאריך). <b>תעודת רישום עמותה</b> (מסמך).'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '28/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1992,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/01/2019'
    },
    'description': 'מרכז הסיוע הוקם באילת ונרשם כעמותה ב-1988. העמותה (ע״ר 580121564) שנקראה ״מרכז סיוע לנפגעי תקיפה מינית באילת״ שכנה בסניף ויצו המקומי. עד שנת 2004 היה המרכז חלק מאיגוד מרכזי הסיוע ולאחר מכן התנתק מהאיגוד. בשנים אלו עבר המרכז משברים רבים ונפתח ונסגר לסירוגין. מצב זה הוביל לפירוק העמותה על ידי בית המשפט. בתקופה זו קיבל המרכז תקציב מהחברה הכלכלית ומהעירייה ונוהל לתקופה על ידי עמותת אור שלום (לנוער בסיכון) כמענה אדמיניסטרטיבי וזמני עד שנסגר בשנת 2009. ב-2011 הוא נפתח מחדש בתוך לשכת הרווחה בעירייה ובהפעלה ישירה בתוך המרכז למניעת אלימות במשפחה. כדי לאפשר לעירייה לקבל תמיכה, נאלץ משרד הרווחה לגבש מבחן תמיכה לרשויות שמעוניינות להפעיל מרכזי סיוע. החל מ-2012 עיריית אילת מקבלת תמיכה ממשרד הרווחה תחת הסעיף ״ארגונים שמסייעים לנפגעות ונפגעי תקיפה מינית״.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'YH172',
    'is_active': true,
    'keywords': [
      'אונס',
      'הטרדה מינית',
      'קו סיוע',
      'תמיכה נפשית',
      'סיוע משפטי'
    ],
    'name': 'מרכז הסיוע לנפגעות תקיפה מינית אילת',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': 'כן',
    'official_address': 'אילת',
    'organization_kind': [
      'מוניציפלי',
      'ממשלתי'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז סיוע לנפגעי תקיפה מינית באילת: עמותה מחוקה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580121564'
      },
      {
        'title': '(2009, 5 יוני). סוף למרכז הסיוע לנפגעות תקיפה מינית באילת? <b>יום יום אילת</b>. נדלה מתוך',
        'url': 'https://www.ereverev.co.il/article.asp?id=6659'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2011, 22 נובמבר). <b>פרוטוקול מס\' 114: טיפול באלימות נגד נשים בין המדינה לבין המגזר השלישי</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/Activity/committees/Women/Pages/CommitteeProtocols.aspx?ItemID=64985'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '01/02/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1988,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'שירותים משפטיים',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '14/06/2018'
    },
    'description': 'מרכז זכויות נשים (מ.נ.ע.) בראשון לציון הוקם בשנת 2006 כשירות עירוני ייחודי שנועד לשרת נשים ונערות. המרכז הוקם על ידי דנה אייזנר-לביא בשיתוף עם יועצת ראש העיר לענייני מעמד האשה והיווה הרחבה של הקו החם לנשים נפגעות אלימות בראשון לציון שהחל לפעול בשנת 2004. מרכז הזכויות הוקם במטרה לצמצם אי שוויון מגדרי באמצעות סיוע לנשים במיצוי זכויות והנגשת משאבים. המרכז מעניק שירות ללא תשלום הכולל ייעוץ משפטי והכוונה בכל תחומי החיים, ליווי נשים נפגעות אלימות לבתי משפט ולמשטרה, סיוע בהתנהלות הבירוקרטית מול הרשויות השונות, ניסוח בקשות דחופות, ייעוץ לניהול כלכלת המשפחה, ייעוץ תעסוקתי ועוד. במרכז נמצאות כ-15 עורכות דין וכ-35 מתנדבות המסייעות ללמעלה מ-3000 נשים בעיר בכל שנה. המרכז קשור גם לפעילות של ״רשת נשים״, מודל ייחודי שמטרתו לחזק את התפתחות הנשים כמנהיגות וכמשפיעות במרחב הציבורי באמצעות פורומים וקהילות של נשים פעילות ואקטיביסטיות, במטרה לרתום ולחבר בין נשים עם צרכים מגוונים.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'YH24',
    'is_active': true,
    'keywords': [
      'מעמד אישי',
      'מיצוי זכויות',
      'חד הוריות',
      'גירושין',
      'תעסוקה',
      'הטרדה מינית'
    ],
    'name': 'מרכז זכויות נשים עירוני (מ.נ.ע)',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ראשון לציון',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'שירותים משפטיים',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-02-07'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.rishonlezion.muni.il/Residents/CommunitySports/women/Pages/WomenRightsCenter.aspx'
      },
      {
        'title': 'בן אשר, ישראלה (2006, 11 אוגוסט). <b>העצמה מעשית - מרכז זכויות נשים עירוני, בניית שירות מוניציפאלי חדש חלק א\'</b>. נדלה מתוך',
        'url': 'https://www.articles.co.il/article/4523/%D7%94%D7%A2%D7%A6%D7%9E%D7%94+%D7%9E%D7%A2%D7%A9%D7%99%D7%AA+-+%D7%9E%D7%A8%D7%9B%D7%96+%D7%96%D7%9B%D7%95%D7%99%D7%95%D7%AA+%D7%A0%D7%A9%D7%99%D7%9D+%D7%A2%D7%99%D7%A8%D7%95%D7%A0%D7%99%2C%D7%91%D7%A0%D7%99%D7%99%D7%AA+%D7%A9%D7%99%D7%A8%D7%95%D7%AA+%D7%9E%D7%95%D7%A0%D7%99%D7%A6%D7%99%D7%A4%D7%90%D7%9C%D7%99+%D7%97%D7%93%D7%A9+%D7%97%D7%9C%D7%A7+%D7%90%27'
      },
      {
        'title': 'דוברות (2017, 19 מרץ). עובדת ציבור מנצחת בירוקרטיה. <b>Mcity ראשל״צ אחת</b>. נדלה מתוך',
        'url': 'http://rishon.mcity.co.il/?id=8201703190655494'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים עולות מחבר העמים',
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '14/06/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2006,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '08/11/2018'
    },
    'description': 'מרכז טנ״א הוקם בבית החולים פוריה ב-2001 ביוזמת בית החולים עצמו ופועל במסגרת מחלקת הנשים. המרכז הוא אחד מחמישה מרכזים אקוטיים לטיפול בנפגעות תקיפה מינית בבתי חולים ברחבי הארץ ומצוי באחריות ובתקצוב משרד הבריאות. המרכז, אשר ממוקם במבנה נפרד, מעניק טיפול רב תחומי לנפגעות ונפגעי תקיפה מינית אשר כולל בדיקה רפואית, סיוע פסיכו-סוציאלי ותיעוד משפטי. המרכז משרת את כל אוכלוסיית הצפון, מטפל בנשים, גברים וילדות וילדים בכל הגילאים והמגזרים כולל אוכלוסיות עם צרכים מיוחדים. המרכז גם עורך פעילויות למניעת אלימות בקהילה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'YH139',
    'is_active': true,
    'keywords': [
      'טראומה',
      'אונס',
      'מחלות מין',
      'הריון',
      'בית חולים',
      'משפט'
    ],
    'name': 'מרכז טנ״א',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'פוריה עילית',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-08-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.poria.health.gov.il/?CategoryID=2082&ArticleID=9'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2017, 10 ינואר). <b>פרוטוקול מס\' 137: טיוב הטיפול הראשוני בנפגעות אלימות מינית - חדרי מיון ומרכזים אקוטיים</b>. נדלה מתוך',
        'url': 'https://oknesset.org/meetings/2/0/2011732.html'
      },
      {
        'title': 'רימון-גרינשפן, הילה (2016). <b>טראומה בטיפול. פגיעה מינית ואשפוז פסיכיאטרי: מיפוי שירותים ומדיניות בריאות</b>. נייר מדיניות מטעם איגוד מרכזי הסיוע לנפגעות ונפגעי תקיפה מינית וארגון בזכות – המרכז לזכויות אדם של אנשים עם מוגבלות: ירושלים. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/20/Committees/20_cs_bg_344255.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/08/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2001,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '05/08/2019'
    },
    'description': '״מרכז יד ליולדת״ הינה עמותה (ע״ר 58061876) שנוסדה בראשון לציון בשנת 2015 במטרה ״ללוות יולדות. לפתוח בית חם ליולדות. סדנאות, חוגי העצמה והעשרה. סיוע ליולדות בכל הנדרש להן״. העמותה מפעילה מרכז בראשון לציון שבו היא מקיימת סדנאות, מפגשי לימוד והעשרה לאמהות טריות, פעילות פנאי, ייעוץ הנקה וגם סיוע בהתנדבות ליולדות בכל הנדרש להן.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ]
    ],
    'id': 'SA133',
    'is_active': true,
    'keywords': [
      'לידה',
      'אמהות',
      'העצמה'
    ],
    'name': 'מרכז יד ליולדת',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ראשון לציון',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-08-05'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.yadlayoledet.com/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז יד ליולדת (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580618767'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '05/08/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '18/07/2019'
    },
    'description': 'מרכז היום לטיפול בעברייני מין הוקם ב-2005 כפרויקט ניסיוני, תוצר של שיתוף פעולה בין צוות עמותת קל״ת (קרימינולוגים לפעילות תיקון), שירות המבחן למבוגרים, שירות המבחן לנוער, רשות חסות הנוער במשרד והרווחה והרשות לשיקום האסיר. בעקבות חקיקת ״חוק הגנה על הציבור מפני ביצוע עבירות מין״ תשס״ו-2006 אשר מטיל על משרדי הבריאות והרווחה להקים מערך טיפול לעברייני מין בדרגות מסוכנות שונות באמצעות מרכזי יום לשיקום בקהילה, הוסטלים וקבוצות טיפוליות הורחבה פעילות המרכז. בין השנים 2005-2008 הוא מומן בעיקר על ידי ה״קרן למפעלים מיוחדים של המוסד לביטוח לאומי״ והופעל על ידי עמותת קש״ת. משנת 2008 פועל המרכז במימון שירות המבחן למבוגרים והרשות לשיקום האסיר. עמותת קש״ת הפעילה את מרכז היום עד שנת 2014. באותה שנה פרסם משרד הרווחה מכרז להפעלת הוסטל ומרכז יום לעברייני מין ומאוקטובר 2015 הוא מופעל על ידי חברה פרטית בשם ״פרויקטים שיקומיים בע״מ״, כחלק ממרכז מעגלים הכולל רצף של מסגרות שיקומיות וביניהן הוסטל ומרכז יום.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'YH194',
    'is_active': false,
    'keywords': [
      'שיקום',
      'אונס',
      'גברים אלימים'
    ],
    'name': 'מרכז יום לטיפול בעברייני מין בקהילה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'פתח תקווה',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'גברים',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2015, 2 ספטמבר). <b>עמותת ״קשת״ – קדום שרותי תקון (ע״ר): עמותה</b>. דו״ח מילולי לשנת 2014. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/VF_View_File?guid=e963c9e1a6cf02e-6bcf3ca740470af4-f9ce9f5df811471fb940aba94e472a8f1f472ec7bdc5bc0749130ef32498344a-5ca93d1e525c327f-3bdd3854d61324d6f'
      },
      {
        'title': 'אידיסיס, יעל ושחורי, מלי (2009). <b>״מרכז יום לטיפול בעברייני מין בקהילה״</b>. המוסד לביטוח לאומי, מינהל המחקר והתכנון והאגף לפיתוח שירותים. נדלה מתוך',
        'url': 'https://www.btl.gov.il/Publications/Special_Activities_publications/Documents/mifal_138.pdf'
      },
      {
        'title': 'ועדת החוקה, חוק ומשפט (2010, 16 נובמבר). <b>פרוטוקול מס\' 270: חוק הגנה על הציבור מפני עברייני מין (תיקון מס\' 3), התשע״א-2011 2. הצעת חוק הגנה על הציבור מפני עברייני מין (תיקון - שיקום מניעתי), התש״ע-2009 3. הצעת חוק המלחמה בפדופיליה, התש״ע-2010 </b>. נדלה מתוך',
        'url': 'https://main.knesset.gov.il/Activity/committees/huka/Pages/CommitteeProtocols.aspx?ItemID=392764'
      }
    ],
    'target_audiences': [
      'גברים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '18/07/2019'
    },
    'year_closed': 2014,
    'year_closed_text': '2014',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '28/10/2018'
    },
    'description': '״מרכז יום תעסוקתי לאסירות משוחררות״ (תל״מ) הוקם בשנת 1998 ביוזמת הרשות לשיקום האסיר ובסיוע המוסד לביטוח לאומי באמצעות הקרן למפעלים מיוחדים. בהסבר לנסיבות שהובילו להקמת השירות הייחודי נאמר כי לנשים אסירות ״בשל עברן וההיסטוריה של התעללות בהן על ידי גברים, קשה להשתלב במסגרות בהן יש גברים. סביבת הגברים מקשה על תפיסת המרכז כתומך. מה גם שבמרכזים אלו כחלק מהמדיניות יש איסור על קשר זוגי. אי עמידה בתנאי זה תגרום להרחקה מהמרכז. לאסירות משוחררות רבות קושי להשתלב במרכזים גם בשל הקשיים לעמוד במדיניות זו. מכאן עולה שיש צורך בהקמת מסגרת ייחודית לאסירות משוחררות, שתספק להן את צורכיהן באופן מרוכז, באזור נגיש להן בו הן תוכלנה להרגיש מוגנות ולהיעזר בו במידת הצורך״. המרכז הוקם כמסגרת שיקום המסייעת לאסירות משוחררות לתקופה של משך מספר חודשים. הפעילויות במרכז כללו סדנת תעסוקה, השלמת השכלה, קבוצות תמיכה תעסוקתית, הכשרה וטיפול תואם לצורך של כל אחת מהאסירות המשוחררות. החל משנת 2015 פועל מרכז תל״מ במסגרת ה״מרכז ההוליסטי לשיקום אסירות משוחררות״.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ]
    ],
    'id': 'YH117',
    'is_active': true,
    'keywords': [
      'אסירות',
      'שיקום',
      'תמיכה נפשית',
      'אמהות',
      'העצמה',
      'חינוך'
    ],
    'name': 'מרכז יום תעסוקתי לאסירות משוחררות (תל״מ)',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'התמכרויות ושיקום',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'אפודי, רותם, אפרת שוהם ואירית אדמצ\'וק. (2018). הולכות בתל״מ: שילוב תעסוקתי של אסירות משוחררות בקהילה. <b>צוהר לבית הסוהר</b> 19, 52–67.',
        'url': 'https://www.gov.il/BlobFolder/guide/zohar/he/%D7%A6%D7%95%D7%94%D7%A8%20%D7%9C%D7%91%D7%99%D7%AA%20%D7%94%D7%A1%D7%95%D7%94%D7%A8%20%D7%92%D7%99%D7%9C%D7%99%D7%95%D7%9F%2019.pdf'
      },
      {
        'title': 'טימר, אמנון, סינבני, ארנונה ושריג, עירית (2002). <b>מרכז יום לאסירות משוחררות – חלק א</b>. ירושלים: המוסד לביטוח לאומי, מינהל המחקר והתכנון האגף לפיתוח שירותים. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/mifal_86.pdf'
      },
      {
        'title': 'לי, ורד (2008, 3 יוני). להוריד את גרבי הרשת בדרך לעבודה. <b>הארץ</b>. נדלה מתוך',
        'url': 'https://www.haaretz.co.il/misc/1.1328566'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '28/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '14/06/2018'
    },
    'description': 'ב-1986 נערכה בחסות שדולת הנשים אסיפה רבת משתתפות של נשות מקצוע בתחום בריאות הנפש ומתוכן, קבוצה של אחת-עשרה נשים, כולן פסיכולוגיות קליניות ועובדות סוציאליות קליניות, הקימו את מרכז יעוץ לאישה, במטרה לקדם בישראל את הגישה הפסיכולוגית הפמיניסטית ואת הראיה המגדרית של תחום בריאות הנפש. לאחר שנה של לימוד ורב-שיח הוקם ה\'קולקטיב\', שכלל את \'האימהות המייסדות\' של מרכז יעוץ לאישה. ה\'קולקטיב\' החל לפעול רשמית במתן שירותים קליניים מקצועיים בגישה פמיניסטית, וב-1988 נרשם כעמותה (ע״ר 580130789) בשם: ״ מרכז להתפתחות האישה״. השם שונה ל״מרכז ייעוץ לאישה״ בשנת 1989.\nמרכז יעוץ לאשה פועל לקידום נשים באמצעות פיתוח והטמעת הידע והפרקטיקה של תחום בריאות הנפש בראיה מגדרית. למרכז שני סניפים - ברמת גן ובירושלים והוא מציע שלושה סוגי פעילות: מרכז טיפול, מרכז הכשרה ומרכז העשרה ולמידה. המרכז הוקם מתוך תפיסה פמיניסטית ומציע לקהל הרחב מומחיות וידע בטיפול בנשים ובסוגיות הקשורות לעולמה הנפשי- רגשי של האשה, תוך התבוננות מעמיקה במאפייניה וצרכיה הייחודיים, עולמה הפנימי, כוחותיה ויחסיה עם המעגלים השונים בחייה. תפיסת המרכז היא ״כי קיימים הבדלים בין החוויה הנשית לחוויה הגברית, וכי נשים מושפעות באופן שונה מגורמים חברתיים, תרבותיים ופוליטיים. מתוך כך, עולה הצורך לענות לאתגרים הייחודיים העומדים בפני נשים ולהעמיק את הידע, את המודעות ואת הכלים לצרכים נפשיים שונים עמם הן מתמודדות.״ \nבמרכז מטופלות למעלה מ-300 נשים מדי שבוע בידי צוות של כ- 25 נשות מקצוע – עובדות סוציאליות קליניות, פסיכולוגיות קליניות ופסיכיאטריות – המתמחות בטיפול בנשים בכלל ובנשים עם טראומה בפרט. המרכז מספק יותר מ-10,000 שעות טיפול פרטני, קבוצתי, זוגי ומשפחתי בשנה, לצד תכניות הכשרה לנשות מקצוע ותכניות ללמידה וסדנאות בקהילה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'תעסוקה ועבודה',
        'הכשרה מקצועית'
      ]
    ],
    'id': 'YH25',
    'is_active': true,
    'keywords': [
      'טיפול פמיניסטי',
      'טיפול נפשי',
      'טראומה',
      'פמיניזם',
      'בריאות הנפש',
      'הכשרה מקצועית'
    ],
    'name': 'מרכז יעוץ לאשה',
    'name_ar': null,
    'name_change_year': 1989,
    'name_common': null,
    'name_past': 'מרכז להתפתחות האישה',
    'name_replaced_by': null,
    'official_address': 'רמת גן',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות הנפש וטיפול',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-14'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://ccw.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז יעוץ לאשה: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580130789'
      },
      {
        'title': 'מרכז יעוץ לאישה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/Counseling.Center.for.Women/'
      },
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '12/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1987,
    'year_registered': 1988
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '07/11/2018'
    },
    'description': 'מרכז לטם הוקם ב-1998 על ידי ד״ר צביה זליגמן בבית החולים איכילוב. המרכז מתמחה בטיפול נפשי לנפגעות ונפגעי טראומה על רגע מיני ומיועד לבני/ות 20 ומעלה ומשמש גם כמרכז הכשרה לנשות/אנשי מקצוע במטרה לקדם מחקר, פיתוח והפצת ידע בנושא. המרכז נמצא באחריות ובסבסוד משרד הבריאות.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'YH133',
    'is_active': true,
    'keywords': [
      'טראומה',
      'טיפול נפשי',
      'בריאות הנפש',
      'בית חולים',
      'אונס'
    ],
    'name': 'מרכז לטם לטיפול בטראומה מינית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-07-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.tasmc.org.il/Rehabilitation-Hospital/Psychiatry/Lotem/Pages/Lotem.aspx'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2015, 16 יוני). <b>פרוטוקול מס\' 5: 1. הרפורמה לבריאות הנפש מנקודת מבט מגדרית. 2. מעקב אחר יישום התכנית לטיפול בנפגעות תקיפה מינית. 3. עדכון משרד הבריאות על מסקנות הוועדה בנושא ההפרדה המגדרית ונוהל הטיפול במקרי פגיעה מינית במחלקות אשפוז פסיכיאטריות</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/Activity/committees/Women/Pages/CommitteeProtocols.aspx?ItemID=565606'
      },
      {
        'title': 'רימון-גרינשפן, הילה (2016). <b>טראומה בטיפול. פגיעה מינית ואשפוז פסיכיאטרי: מיפוי שירותים ומדיניות בריאות</b>. נייר מדיניות מטעם איגוד מרכזי הסיוע לנפגעות ונפגעי תקיפה מינית וארגון בזכות – המרכז לזכויות אדם של אנשים עם מוגבלות: ירושלים. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/20/Committees/20_cs_bg_344255.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/08/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '27/11/2018'
    },
    'description': 'בשנת 1982 הוקמה באוניברסיטה העברית ה״תכנית להבדלים בין המינים״ בהובלת גליה גולן ועמיה ליבליך ובשנת 1990, בעקבות תרומה פרטית, הוקם ״מרכז לייפר ללימודי נשים ומגדר״ כתכנית רב-תחומית ומרכז אקדמי ללימוד, עיון ומחקר. במשך שנים רבות הציע מרכז לייפר חטיבה לתואר ראשון וקורסי מבוא בנושאי פמיניזם ומגדר והוא מקיים תכנית התמחות אישית רב-תחומית אישית לתואר מוסמך המאפשרת לסטודנטיות/ים לקבל תעודת התמחות במגדר לצד התואר הראשי. המרכז מקיים קולוקוויום לתלמידות מחקר, כנסים שנתיים וסדרת הרצאות לקהל הכללי ולציבור הסטודנטים ומחלק מדי שנה מלגות לסטודנטיות וסטודנטים לתארים מתקדמים. בראש מרכז לייפר עמדו חוקרות מובילות כגון: ד״ר מאירה וייס, פרופ\' תמר אלאור, פרופ\' נורית ירמיה, פרופ\' מימי אייזנשטדט, פרופ\' תמר זילבר ופרופ\' משה סלוחובסקי.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תכניות לתואר אקדמי בלימודי מגדר'
      ]
    ],
    'id': 'SA95',
    'is_active': true,
    'keywords': [
      'לימודי מגדר',
      'פמיניזם',
      'מגוון'
    ],
    'name': 'מרכז לייפר ללימודי נשים ומגדר- האוניברסיטה העברית',
    'name_ar': null,
    'name_change_year': 1990,
    'name_common': null,
    'name_past': 'התכנית להבדלים בין המינים',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'אקדמי',
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תכניות לתואר אקדמי בלימודי מגדר',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-11-27'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://lafer-center.huji.ac.il/'
      },
      {
        'title': 'ספרן, חנה (2009). בין אקדמיה לקהילה פמיניסטית: לימודי נשים בישראל. בתוך: אופלטקה, יזהר והרץ לזרוביץ, רחל (עורכים), <b>מגדר ואתניות בהשכלה הגבוהה בישראל</b> (עמ\' 169–188). חיפה: פרדס. נדלה מתוך',
        'url': 'https://gendersite.org.il/wp-content/uploads/2010/08/Safran.pdf'
      },
      {
        'title': 'Safir, Marylin, P. (2009). Women\'s Studies in Israel. In <b>Jewish women: A comprehensive historical encyclopedia</b>, Jewish women\'s archive. Retrieved from',
        'url': 'https://jwa.org/encyclopedia/article/womens-studies-in-israel'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '30/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1982,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'מחקר ותיעוד',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '14/06/2018'
    },
    'description': 'מרכז מהות הוקם ב-2004 כפרויקט במסגרת קואליציית נשים חיפה שמטרתו סיוע תעסוקתי לנשים יוצאות מקלטים. המרכז נרשם כעמותה עצמאית ב-2005 (ע״ר 580450120) ופעל עד 2013. המרכז, בניהולה של מיכל דגן, פעל כעמותה פמיניסטית לקידום שוויון מגדרי בשוק העבודה, בדגש על נשים מבוגרות מעוטות הכנסה. המרכז העניק סיוע פרטני - קורסים לנשים, השמה וליווי תעסוקתי. כמו גם עסק במרכז במחקר והפיק דוחות בנושאים: נשים בכלכלת מלחמה (בעקבות מלחמת לבנון השניה), עודות בשוק תעסוקה מעורער, גיל ותעסוקה ונשים בכלכלת פרישה. המרכז אף עסק בקידום מדיניות תעסוקה הוגנת לנשים באמצעות פרסום ניירת עמדה ופעולות סנגור. מרכז מהות נסגר בשל קשיים תקציביים בסוף שנת 2013.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'השמה וליווי בתעסוקה'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ]
    ],
    'id': 'YH26',
    'is_active': false,
    'keywords': [
      'תעסוקת נשים מבוגרות',
      'אפליית גיל בתעסוקה',
      'מחקר פמיניסטי',
      'פנסיה',
      'ביטחון תעסוקתי',
      'הכשרה מקצועית'
    ],
    'name': 'מרכז מהות – מידע הדרכה ותעסוקה לנשים',
    'name_ar': 'مركز ماهوت',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'השמה וליווי בתעסוקה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-08-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://mahutcenter-hebrew.blogspot.com/'
      },
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>מרכז מהות – מידע הדרכה ותעסוקה לנשים</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'מהות- מידע הדרכה ותעסוקה לנשים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pg/mahutcenter/about/?ref=page_internal'
      },
      {
        'title': 'מרכז מהות. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%9E%D7%A8%D7%9B%D7%96_%D7%9E%D7%94%D7%95%D7%AA'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '19/06/2018'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 2004,
    'year_registered': 2005
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '05/06/2018'
    },
    'description': '‏״מרכז מידע לבריאות האשה בני ברק״ (ע״ר 580453173) נוסד בשנת 2005 ביוזמתה של רו״ח שושנה גולדפינגר, מבקרת עיריית בני ברק, במטרה לסייע לנשים בקהילה בגישה למידע רפואי בסיסי. מטרות העמותה הן: ״לייסד, לנהל ולקדם מרכז מידע לבריאות האשה ברוח ישראל סבא. להפיץ מידע על בריאות האשה בקרב נשים ולעזור להן לממש את זכויותיהן בכל הקשור למוסדות בריאות״. המרכז פועל בתוך התחנה לבריאות המשפחה בבני ברק ומופעל על ידי עובדות ומתנדבות ומספק מידע רפואי כללי ופרטני לנשים חרדיות מרחבי הארץ באמצעות קו טלפון ושליחת חוברות עם מידע למתעניינות. בנוסף, המרכז מקיים ימי עיון והשתלמויות בנושא בריאות האשה לגורמים מגוונים בחברה החרדית.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ],
      [
        'דת ומעמד אישי',
        'בריאות ופריון'
      ]
    ],
    'id': 'SW12',
    'is_active': true,
    'keywords': [
      'בריאות',
      'קו סיוע',
      'חינוך',
      'חינוך מיני'
    ],
    'name': 'מרכז מידע לבריאות האשה בני ברק',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'בני ברק',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2018-06-05'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://health-women.org.il/blog/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז מידע לבריאות האשה – בני ברק (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580453173'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '16/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '19/07/2019'
    },
    'description': 'מרכז מעגלים הוא רצף של מסגרות שיקומיות לעברייני מין. המרכז החליף את מרכז היום לשיקום עברייני מין בקהילה שהופעל בין 2005-2014 על ידי עמותת קש״ת במימון ופיקוח משרד הרוווחה. ב-2014 זכתה חברת ״פרויקטים שיקומיים״ (החברה היא חלק מקבוצת ״קידום פרויקטים שיקומיים בע״מ״ המקימה ומתפעלת מסגרות לנפגעי נפש ולבעלי צרכים מיוחדים ואף מספקת שירותי בריאות השן לתלמידים/ות). במכרז להפעלת המרכז ולהקמת הוסטל הפועל מאוקטובר 2015. ההפניה - באמצעות שירות המבחן למבוגרים או הרשות לשיקום האסיר. המימון והפיקוח - משרד הרווחה. רצף המסגרות כולל: הוסטל סגור ל-24 עברייני מין עם רמת מסוכנות גבוהה, מרכז יום בשלבים, קבוצות טיפוליות, מעקב וליווי פסיכיאטרי ותרופתי.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'YH195',
    'is_active': true,
    'keywords': [
      'שיקום',
      'הוסטל',
      'דיור',
      'אונס',
      'גברים אלימים'
    ],
    'name': 'מרכז מעגלים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': 'מרכז יום לטיפול בעברייני מין בקהילה',
    'official_address': 'המרכז',
    'organization_kind': [
      'ממשלתי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'גברים',
    'retrieved': null,
    'sources': [
      {
        'title': 'פרויקטים שיקומיים (2016, 2 מאי). מרכז מעגלים [פוסט פייסבוק]. נדלה מתוך',
        'url': 'https://www.facebook.com/985280291545282/posts/1076492202424090/'
      },
      {
        'title': 'ועדת החוקה, חוק ומשפט (2016, 25 פברואר). <b>פרוטוקול מס\' 131: מעקב אחר יישום חוק הגנה על הציבור מפני ביצוע עבירות מין</b>. נדלה מתוך',
        'url': 'https://oknesset.org/meetings/5/7/575876.html'
      },
      {
        'title': 'וינשטיין, רחל ובן שמחון, מירי (2016). מבוגרים המעורבים בהליכים פליליים. בתוך <b>סקירת השירותים החברתיים לשנת 2016</b> (פרק 4 חלק ב\'). משרד העבודה הרווחה והשירותים החברתיים. נדלה מתוך',
        'url': 'https://www.gov.il/BlobFolder/reports/molsa-social-services-review-2016/he/SocialServicesReview_2016_molsa-chapter4-adults-on-adversity-part2-2016.pdf'
      }
    ],
    'target_audiences': [
      'גברים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '19/07/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'שירותים משפטיים',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': 'מרכז נגה למען נפגעי עבירה הוקם בשנת 2004 על ידי ד״ר דנה פוגץ\' ועו״ד דיקלה טוטיאן בשיתוף הפקולטה למשפטים של הקריה האקדמית אונו כמענה למצוקת נפגעי העבירה ובני משפחותיהם אשר אינם מהווים צד להליך הפלילי. המרכז מקיים ימי עיון, מחקר והכשרות ומתנהלות בו שתי קליניקות: קליניקת ייצוג נפגעי עבירות חמורות וקליניקת עמדת סיוע לנפגעים בבית המשפט המחוזי בפתח תקווה. צוות המרכז יוזם הליכי חקיקה, מגיש עמדות לכנסת ומשתתף באופן פעיל בוועדות הכנסת השונות וגם יוזם ומשתתף בפעולות הסברה, באמצעות הכשרת אנשי מקצוע הנמצאים בקשר עם נפגעי עבירות. המרכז מעניק ייעוץ וייצוג משפטי לנפגעי עבירות חמורות בהליכים המשפטיים, ללא גביית שכר טרחה. במסגרת זו מיוצגים משפחות נרצחים, נפגעי תקיפות מיניות חמורות ונפגעי אלימות במשפחה ואלימות בנשק, מרביתם קטינים וילדים, בהליכים פליליים ואזרחיים. המרכז מפעיל מוקד מידע בשיתוף המוסד לביטוח לאומי ומשרד המשפטים.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'השכלה גבוהה ומחקר',
        'אקדמיה, חברה וקהילה'
      ]
    ],
    'id': 'YB71',
    'is_active': true,
    'keywords': [
      'קליניקה',
      'אלימות מינית',
      'נשק',
      'חקיקה',
      'עריכת דין',
      'קו סיוע',
      'מחקר',
      'רצח נשים',
      'סיוע משפטי'
    ],
    'name': 'מרכז נגה לנפגעי עבירה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'קרית אונו',
    'organization_kind': [
      'אקדמי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'שירותים משפטיים',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.ono.ac.il/academy/social-agenda/noga-center/'
      },
      {
        'title': 'מרכז נגה לנפגעי עבירה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/MerkazNoga/'
      },
      {
        'title': 'כל זכות (ללא תאריך). <b>נגה - המרכז הישראלי לזכויות נפגעי פשיעה</b>. נדלה מתוך',
        'url': 'https://www.kolzchut.org.il/he/%D7%A0%D7%92%D7%94_-_%D7%94%D7%9E%D7%A8%D7%9B%D7%96_%D7%94%D7%99%D7%A9%D7%A8%D7%90%D7%9C%D7%99_%D7%9C%D7%96%D7%9B%D7%95%D7%99%D7%95%D7%AA_%D7%A0%D7%A4%D7%92%D7%A2%D7%99_%D7%A4%D7%A9%D7%99%D7%A2%D7%94'
      },
      {
        'title': 'מרכז נגה. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%9E%D7%A8%D7%9B%D7%96_%D7%A0%D7%92%D7%94'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '16/05/2018'
    },
    'description': 'מרכז הסיוע לנפגעות תקיפה מינית ואונס, קריית-שמונה והגליל הוקם בשנת 1994 ופעל במסגרת פורום נשים קריית-שמונה. בשנת 1999 נפרד מרכז הסיוע מפורום נשים ונרשם כעמותה עצמאית. מטרת העמותה היא להעניק סיוע לנפגעות אלימות מינית ולהיאבק בתופעת האלימות המינית באמצעות העלאת מודעות ושינוי עמדות. מטרות המרכז הן להציע סיוע נפשי, תמיכה, ייעוץ וליווי לנפגעות אלימות מינית ולקרובים אליהן במשך 24 שעות ביממה. לקיים פעילות הסברתית והעלאת המודעות בקרב הציבור ולספק מידע אודות אלימות מינית. לפעול בשיתוף פעולה עם הגופים המטפלים הבאים במגע עם הנפגעת במטרה להיטיב את הבנתם לגבי הבעייתיות והייחוד של הנושא. המרכז פועל בסיוע של מתנדבות ועובדות, הוא מתקיים באמצעות תרומות ותמיכות ממשרד הרווחה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'חינוך',
        'מניעת אלימות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'YB25',
    'is_active': true,
    'keywords': [
      'אונס',
      'הטרדה מינית',
      'קו סיוע',
      'תמיכה נפשית',
      'סיוע משפטי'
    ],
    'name': 'מרכז סיוע לנפגעות תקיפה מינית ואונס (קריית שמונה והגליל)',
    'name_ar': null,
    'name_change_year': 1999,
    'name_common': 'מרכז סיוע גליל גולן',
    'name_past': 'פורום נשים קרית שמונה',
    'name_replaced_by': null,
    'official_address': 'קרית שמונה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.1202.org.il/local/galil-golan/about'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז סיוע לנפגעות תקיפה מינית ואונס (קרית שמונה והגליל) (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580347862'
      },
      {
        'title': 'מרכז סיוע לנפגעות תקיפה מינית גליל-גולן, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/Rccgalil1202/?ref=page_internal'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '21/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1994,
    'year_registered': 1999
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '16/05/2018'
    },
    'description': 'מרכז הסיוע לנפגעות ונפגעי תקיפה מינית בשרון (ע״ר 580107993) הוקם בשנת 1984 כפרויקט של נעמ״ת ונרשם כעמותה עצמאית בשם ״קש״ב- קו שירות לאשה במצוקה״ בשנת 1987. מטרות העמותה הן ״סיוע לנפגעות/י תקיפה מינית ומניעתה.לתת סיוע נפשי ומעשי לנשים נפגעות תקיפה מינית, או במצב מצוקה מכל סיבה אחרת״. שם העמותה שונה בשנת 2002. המרכז משרת את כל אוכלוסיית השרון ב- 4 ערים, 3 מועצות אזוריות ו-10 מועצות מקומיות ומעניק סיוע 24 שעות ביממה באמצעות צוות מתנדבות. למרכז שני מוקדי פעילות עיקריים: סיוע וחינוך. בתחום הסיוע והתמיכה מפעיל המרכז קו סיוע 1202 לנשים וגברים, ליווי למשטרה, לבתי משפט ובתי חולים. במרכז מתקיימות פגישות אישיות וקבוצות תמיכה. בתחום החינוך, מקיים המרכז פעילות לצמצום התקיפה המינית בחברה באמצעות סדנאות וימי עיון בבתי ספר, מתנ״סים, מקומות עבודה, צבא ומסגרות נוספות. המרכז אף מבצע הכשרות לצוותים מקצועיים (עו״ס, פסיכולוגיים, חוקרים, רופאים, אחיות ויועצות). העמותה מתקיימת מתרומות ומתמיכה של משרד הרווחה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'חינוך',
        'מניעת אלימות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'YB29',
    'is_active': true,
    'keywords': [
      'אונס',
      'הטרדה מינית',
      'קו סיוע',
      'תמיכה נפשית',
      'סיוע משפטי'
    ],
    'name': 'מרכז סיוע לנפגעות ונפגעי תקיפה מינית - השרון',
    'name_ar': null,
    'name_change_year': 2002,
    'name_common': 'מרכז סיוע השרון',
    'name_past': 'קש״ב- קו שירות לאשה במצוקה, מרכז סיוע לנשים השרון, רעננה',
    'name_replaced_by': null,
    'official_address': 'רעננה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.1202.org.il/local/hasharon/about'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז סיוע לנפגעות ונפגעי תקיפה מינית – השרון (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580107993'
      },
      {
        'title': 'מרכז סיוע לנפגעות ונפגעי תקיפה מינית - השרון, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/maslan.sharon/?ref=page_internal'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1984,
    'year_registered': 1987
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '16/05/2018'
    },
    'description': 'מרכז הסיוע לנפגעות אונס ותקיפה מינית ירושלים ע״ש לינדה פלדמן (ע״ר) הוקם בשנת 1981 ע״י קבוצת מתנדבות במטרה לסייע לנשים אשר עברו תקיפה מינית. קבוצת המתנדבות הקימה את קו החירום אליו יכולה לפנות כל אישה באופן אנונימי, ולקבל תמיכה והקשבה, ללא כל תשלום, מתוך כבוד ויחס שוויוני ותוך שמירה קפדנית על סודיות. כיום, קו החירום שמספרו 1202 מאוייש 24 שעות ביממה ע״י מתנדבות המוכשרות להגשת סיוע בשעת משבר. המרכז מגיש סיוע נפשי ומעשי לנפגעות אונס ותקיפה מינית והקרובים להן, הכולל פגישות, ליווי לבית החולים, ליווי בהליך הפלילי כולל ליווי למשטרה והשתתפות בקבוצת תמיכה לנפגעות בילדות, לנפגעות בבגרות ולאמהות. במרכז הסיוע פועלת מחלקה חינוכית עניפה המופעלת ע״י מתנדבים ומתנדבות במטרה להביא לשינוי חברתי שיטמון בחובו הבניית שוויון בין המינים, הגברת מודעות בתחום האלימות והמיגדר והפחתת האלימות כלפי נשים והאלימות המינית בפרט. במסגרת זו עורכים המתנדבים והמתנדבות סדנאות לבני נוער בבתי ספר תיכוניים ובחטיבות הביניים לתלמידים ולמורים. במקביל למתן סיוע ולפעילות החינוכית פועל המרכז בתחום עיצוב המדיניות והעלאת נושאים בוערים לסדר היום הציבורי. העמותה מתקיימת מתרומות ומתמיכות של משרד הרווחה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'חינוך',
        'מניעת אלימות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'YB26',
    'is_active': true,
    'keywords': [
      'אונס',
      'הטרדה מינית',
      'קו סיוע',
      'תמיכה נפשית',
      'סיוע משפטי'
    ],
    'name': 'מרכז סיוע לנפגעות אונס ותקיפה מינית - ירושלים ע״ש לינדה פלדמן',
    'name_ar': null,
    'name_change_year': 1992,
    'name_common': null,
    'name_past': 'מרכז סיוע לקורבנות אונס - ירושלים',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.1202.org.il/local/jerusalem/about'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז סיוע לנפגעות אונס ותקיפה מינית – ירושלים ע״ש לינדה פלדמן (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580001261'
      },
      {
        'title': 'מרכז סיוע לנפגעות ולנפגעי אלימות מינית ירושלים ע\'\'ש לינדה פלדמן, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/jrcchb/'
      },
      {
        'title': 'משרד הפנים, רשם העמותות (1992). <b>מרכז סיוע לקרבנות אונס – ירושלים, שינוי שם</b>. נדלה מתוך',
        'url': 'https://www.guidestar.org.il/VF_View_File?guid=eb642cac11267f6-1b089db4c734c90f-ada41f75276bf715e8843beb4618dafe474854f5628b2fc143028a52e267d3b2-8009a5d48c173a4f-481053bc51b4eb9b3'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1981,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': 'מרכז הסיוע בתל אביב הוקם על ידי התנועה הפמיניסטית בשנת 1978, במטרה לשבור את קשר השתיקה בנושא האונס בישראל. המרכז היה הראשון מסוגו בישראל: ״מטרת המרכז היתה להציע לנשים שעברו תקיפה מינית את האפשרות להתקשר באופן מיידי ולשוחח עם נשים אחרות באוירה של אהדה ואמון, ללא ההכרח להחשף, ובמידת הצורך להגיש לה עזרה מעשית״. כיום, מטרות המרכז מוגדרות כ״הגשת סיוע לנפגעות ולנפגעי תקיפה מינית וכן הגברת המודעות הציבורית במטרה לצמצם את שיעורי התופעה בישראל״. המרכז מופעל על ידי צוות מתנדבות/ים שעברו הכשרה ייעודית למענה לטלפון החירום 24 שעות ביממה. הוא מקיים 3 קווי סיוע, תמיכה וליווי - לנשים: 1202, לגברים: 1203 ולגברים דתיים: 02-5328000. המרכז משרת את כל אוכלוסיית גוש דן ומטפל ב 38% מכלל הפניות הארציות בנושאי תקיפה מינית. על פי האתר של מרכז הסיוע, מגיעות למרכז כ 11,000 פניות בשנה ומתקיימות כ - 1000 סדנאות והרצאות במוסדות חינוך ובמקומות עבודה שונים, בנושאים הנוגעים לאלימות מינית והטרדה מינית. מרכז הסיוע מופעל בשיתוף משרד הרווחה, אך עיקר הכנסותיו ממימון עצמאי.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'חינוך',
        'מניעת אלימות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': '1YB2',
    'is_active': true,
    'keywords': [
      'אונס',
      'הטרדה מינית',
      'קו סיוע',
      'תמיכה נפשית',
      'סיוע משפטי'
    ],
    'name': 'מרכז סיוע לנפגעות ולנפגעי תקיפה מינית תל אביב',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': 'מרכז הסיוע לקורבנות אונס בת״א',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.1202.org.il/local/telaviv'
      },
      {
        'title': 'זילבר, תמר (1998). <b>אידאולוגיה, פרקטיקה ועמימות בארגונים: מרכז סיוע לנפגעות תקיפה מינית כארגון פמיניסטי</b> (חיבור לשם קבלת תואר ״דוקטור לפילוסופיה״). האוניברסיטה העברית, ירושלים.'
      },
      {
        'title': 'מרכז סיוע לנפגעות ולנפגעי תקיפה מינית תל אביב (2018, 29 מאי). הפרטים אומתו בשיחה עם נציגת הארגון.'
      },
      {
        'title': 'סלעי, יהודית, בן-צבי, רינה ועילם, אסתר (1983). <b>פניות לעזרה למרכז סיוע לקורבנות אונס בתל אביב בשתי שנות פעילות 1980-1982</b>. משרד העבודה והרווחה, האגף למחקר, תכנון והכשרה. ירושלים.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1978,
    'year_registered': 1985
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '12/12/2018'
    },
    'description': 'מרכז לעידוד נשים במצוקה (ע״ר 580075356) היה רשום כעמותה בשנים 1984-2000 שנוסדה במטרה ״לסייע לנשים במצוקה בכל רחבי הארץ״. כתובת העמותה היתה ברח\' ברודי בירושלים. לא נמצא מידע נוסף.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'כללי'
      ]
    ],
    'id': 'SA98',
    'is_active': false,
    'keywords': [
      'נשים במצוקה'
    ],
    'name': 'מרכז עידוד נשים במצוקה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'כללי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>מרכז עידוד נשים במצוקה</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 5089 (2002, 27 יוני). <b>הודעה סופית בדבר מחיקה מפנקס העמותות</b>. מרכז עידוד נשים במצוקה (עמותה מספר 580075356). עמ\' 3161. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_word/Law10/YALKUT-5089.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '12/12/2018'
    },
    'year_closed': 2000,
    'year_closed_text': '2000',
    'year_founded': 1984,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '08/11/2018'
    },
    'description': 'מרכז ענב״ל הוא אחד מהמרכזים הרב-תחומיים הציבוריים המתמחים בטיפול בטראומה מינית. המרכז נמצא בבאר שבע ומספק מענה אזורי לתושבי הדרום, כולל לאוכלוסייה הבדואית. פעילותו החלה בשנת 1999 כיוזמה מקומית של עיריית באר שבע, בסיוע כימיקלים לישראל (כי״ל) ובשנת 2008 הורחב המרכז בשיתוף פעולה של משרד הרווחה, עיריית באר שבע, קרן רש״י ועמותת יחדיו שמפעילה את השירות. משנת 2014 הוקמה יחידה לטיפול באוכלוסיית גברים נפגעים ובשנת 2016 הורחב הטיפול לאוכלוסיית הנשים מן המגזר הבדואי. המרכז הרב-תחומי מורכב מאנשי מקצוע בעלי ידע ומומחיות ייחודיים בתחום הטראומה המינית. במרכז ניתן לקבל מענים טיפוליים מגוונים לנשים וגברים מגיל 18 ומעלה שחוו ניצול ואלימות מינית לסוגיה השונים בעבר ובהווה. המרכז מעניק טיפול פרטני ושירותים נלווים כגון: ליווי ותיווך לשירותים בקהילה, ייעוץ וליווי פסיכיאטרי, ייעוץ והכשרה לאנשי מקצוע, הגברת המודעות לתופעת הטראומה המינית והשלכותיה וקידום זכויותיהן של נפגעות/ים.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'רווחה וקהילה',
        'אלימות מינית'
      ]
    ],
    'id': 'YH135',
    'is_active': true,
    'keywords': [
      'טראומה',
      'טיפול נפשי',
      'אונס',
      'תקיפה מינית'
    ],
    'name': 'מרכז ענב״ל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'מוניציפלי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-08-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.yachdav.org.il/%D7%A2%D7%A0%D7%91%D7%9C-%D7%A8%D7%91-%D7%AA%D7%97%D7%95%D7%9E%D7%99.html'
      },
      {
        'title': 'דני קיפר תקשורת ועיתונות (2007, 30 אוקטובר). כימיקלים לישראל קוראת להצטרף אליה בתמיכה במרכז ענב״ל. <b>News1 מחלקה ראשונה</b>. נדלה מתוך',
        'url': 'http://www.news1.co.il/Archive/0020-D-144308-00.html'
      },
      {
        'title': 'מקומי (2008, 28 מאי). חנוכת מרכז ענב״ל (העמוד אינו זמין יותר).'
      },
      {
        'title': 'רימון-גרינשפן, הילה (2016). <b>טראומה בטיפול. פגיעה מינית ואשפוז פסיכיאטרי: מיפוי שירותים ומדיניות בריאות</b>. נייר מדיניות מטעם איגוד מרכזי הסיוע לנפגעות ונפגעי תקיפה מינית וארגון בזכות – המרכז לזכויות אדם של אנשים עם מוגבלות: ירושלים. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/20/Committees/20_cs_bg_344255.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/08/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1999,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '27/08/2018'
    },
    'description': '״מרכז פנים״ (ע״ר 580538643) הוקם בשנת 2011 בירושלים במטרה לספק: ״ליווי ותמיכה לנשים וזוגות המתמודדים עם אתגרי פוריות, בגישה הוליסטית. לשמש כמקור מידע לזוגות העוברים אתגרי פוריות. לגרום להעלאת המודעות בציבור למצוקת האוכלוסייה העוברת טיפולי פוריות. לגרום לשינוי מעשי במערכות הבריאות במתן תמיכה לאוכלוסיה זו. לשמש לובי מול מערכות הבריאות וקובעי המדיניות.״ המרכז מקיים שיתופי פעולה עם יחידות להפרייה חוץ-גופית בתי חולים בירושלים במטרה להציע מערכת של תמיכה הוליסטית לנשים וזוגות העוברים טיפולי פוריות. שירותי המרכז כוללים פגישות ייעוץ עם עובדת סוציאלית המתמחה בתחום הפוריות, עיסוי הוליסטי ושיעורי יוגה, פעילות ספורטיבית והפניות לאנשי מקצוע. בנוסף, המרכז מעביר סדנאות והכשרות לאנשי טיפול בתחומים הנוגעים לפוריות לשם העלאת מודעות לסוגיות של אובדן ולידה שקטה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'טכנולוגיות פריון'
      ]
    ],
    'id': 'SW21',
    'is_active': true,
    'keywords': [
      'טכנולוגיות פריון',
      'פוריות',
      'תמיכה נפשית',
      'לידה שקטה'
    ],
    'name': 'מרכז פנים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'טכנולוגיות פריון',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-08-27'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://merkazpanim-fertility.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז פנים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580538643'
      },
      {
        'title': 'מרכז פנים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/Merkaz-Panim-%D7%9E%D7%A8%D7%9B%D7%96-%D7%A4%D7%A0%D7%99%D7%9D-188843851139093/'
      }
    ],
    'target_audiences': [
      'נשים דתיות',
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '18/11/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2011,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'שירותים משפטיים',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': 'מרכז צדק לנשים (ע״ר 580430973) נוסד בשנת 2004 ומקדם פתרונות יסודיים לבעיית העגינות וסרבנות הגט, לבעיית פסילת הגיורים בישראל ולמצוקת הממזרות. המרכז מנסה לגייס את המדינה בכלל ואת בתי המשפט האזרחיים בפרט על מנת לתקן את העוול והנזק שנגרמים לנשים מחמת פסקי הדין של בתי הדין הרבניים וכתוצאה ממדיניות לקויה של הממסד הרבני. המרכז מייצג נשים במקרים שבהם יש סיכוי ליצור תקדימים משפטיים שיעזרו לכלל הנשים בבית הדין, בבית המשפט לענייני משפחה או בבג״צ. על ידי כך מקדם שינוי באופן ההתמודדות של בתי המשפט, בתי הדין הרבניים, הרבנים והקהילה עם נושאים אלו. לצד הפעילות המשפטית, מרכז צדק לנשים יוזם ומשתתף פעולה בהפקת קמפיינים ציבוריים, כתיבה פובליציסטית ואקדמית, וכנסים מקצועיים בנושאי נשים בדת היהודית.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ]
    ],
    'id': 'YB60',
    'is_active': true,
    'keywords': [
      'הלכה',
      'חקיקה',
      'עגינות',
      'סרבנות גט',
      'גירושין',
      'גיור'
    ],
    'name': 'מרכז צדק לנשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'שירותים משפטיים',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.cwj.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז צדק לנשים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580430973'
      },
      {
        'title': 'מרכז צדק לנשים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/cwjisrael/'
      },
      {
        'title': 'לוביץ, רבקה (2017). <b>מסוף העולם ועד סופו: מסע הייסורים של נשים בבית הדין הרבני</b>. ראשון לציון: ידיעות אחרונות.'
      },
      {
        'title': 'רותם, תמר (2007, 4 מאי). המדינה ביטלה מכרז על משרה בביה״ד הרבניים - לאחר תביעה על אפליית נשים. <b>הארץ</b>. נדלה מתוך',
        'url': 'https://www.haaretz.co.il/misc/1.1406961'
      },
      {
        'title': 'Weiss, Susan M. & Gross-Horowitz, Netty C. (2013). <b>Marriage and divorce in the Jewish state: Israel\'s civil war</b>. Waltham, Massachusetts: Brandeis University Press.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '09/08/2018'
    },
    'description': 'המרכז הוקם בתל אביב על ידי פליטות מאריתראה בשנת 2011 ונרשם כעמותה בירושלים בשנת 2013 (אצל רו״ח חיים וורמברנד). המטרה: לשיפור נגישותן לשירותי הרווחה. לקיים פעילות חינוכית לנשים אריתראיות בישראל, לרבות הקניית שפה והתמצאות. להעצים נשים אריתראיות בישראל לפעולה משותפת לשיפור חייהן בישראל. המרכז מפעיל תכניות להעצמה כלכלית, בריאות המשפחה, העצמה אישית ותמיכה פרטנית וקבוצתית.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'הגירה',
        'פליטות ומבקשות מקלט'
      ],
      [
        'רווחה וקהילה',
        'תעסוקה ועבודה'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ]
    ],
    'id': 'YH70',
    'is_active': true,
    'keywords': [
      'פליטות',
      'תמיכה נפשית',
      'טראומה',
      'הגירה',
      'זכויות',
      'סיוע לאמהות'
    ],
    'name': 'מרכז קהילתי לנשים אריתראיות בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'הגירה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פליטות ומבקשות מקלט',
    'primary_target_audience': 'נשים מהגרות עבודה או חסרות מעמד',
    'retrieved': {
      'type{date}': '2018-09-08'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.eritreanwomenscenter.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז קהילתי לנשים אריתראיות בישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580574465'
      },
      {
        'title': 'Eritrean Women\'s Community Center/ ማ’እከል ደቂ-ኣንስትዮ ኤርትራውያን, Facebook page.',
        'url': 'https://www.facebook.com/EritreanWomensCommunityCenter/'
      },
      {
        'title': 'מיליקובסקי, אלישבע ( 2015, דצמבר). המרכז לנשים אריתראיות. <b>המהגר</b>. נדלה מתוך',
        'url': 'http://the-migrant.co.il/he/node/47'
      }
    ],
    'target_audiences': [
      'נשים מהגרות עבודה או חסרות מעמד'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '08/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2011,
    'year_registered': 2013
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'מחקר ותיעוד',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '13/10/2018'
    },
    'description': 'תכנית המנטורינג לנערות וצעירות פועלת בבית הספר לעבודה סוציאלית במכללת ספיר משנת 2008 (פועלת גם באוניברסיטת תל אביב משנת 2002). התכנית פועלת כמיזם משותף עם השירות לנערות, צעירים וצעירות במשרד הרווחה. מרכז רותם הוא התרחבות של התכנית תוך פיתוח של תכניות נוספות ביחידת הפרקטיקה של המרכז, בתחומי התעסוקה, השכלה, ליווי במשברי החיים, מיצוי זכויות וסיוע משפטי ופיתוח קהילת צעירות בדרום. מלבד יחידת הפרקטיקה, קיימת יחידת מחקר והכשרות העוסקת בפיתוח ידע על נערות וצעירות במצבי סיכון ומצוקה ובשינוי מדיניות.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף אקדמי',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ],
      [
        'השכלה גבוהה ומחקר',
        'אקדמיה, חברה וקהילה'
      ]
    ],
    'id': 'YH101',
    'is_active': true,
    'keywords': [
      'מנטורינג',
      'נערות במצוקה',
      'רווחה',
      'מיצוי זכויות',
      'תמיכה נפשית'
    ],
    'name': 'מרכז רותם במכללה האקדמית ספיר',
    'name_ar': null,
    'name_change_year': 2016,
    'name_common': null,
    'name_past': 'תכנית המנטורינג',
    'name_replaced_by': null,
    'official_address': 'שדרות',
    'organization_kind': [
      'ממשלתי',
      'אקדמי'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'צעירות במצבי סיכון',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-13'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.sapir.ac.il/rotemcenter'
      },
      {
        'title': 'מרכז רותם (2016). <b> חוברת תכניות, שנת הלימודים תשע״ז, 2016–2017</b>. נדלה מתוך',
        'url': 'http://www.gendersite.org.il/wp-content/uploads/2017/08/%D7%AA%D7%9B%D7%A0%D7%99%D7%95%D7%AA-%D7%9E%D7%A8%D7%9B%D7%96-%D7%A8%D7%95%D7%AA%D7%9D-%D7%AA%D7%A9%D7%A2%D7%96-1.pdf'
      },
      {
        'title': 'רותם מכללת ספיר, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/bogmentoring'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '13/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2008,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'שירותים משפטיים',
      'סנגור, מעקב ושינוי מדיניות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '29/07/2018'
    },
    'description': 'המרכז על שם רות ועמנואל רקמן נוסד בשנת 2001 במטרה לקדם את מעמד האשה בתחום דיני המשפחה ולשים קץ לאפליה המגדרית ולאי-השוויון בחברה הישראלית. המרכז הינו חלק מהפקולטה למשפטים באוניברסיטת בר-אילן, והוא מהווה נקודת מפגש בין מחקר לאקטיביזם, בין עולם המשפט להלכה, בין קידום מדיניות ציבורית למתן סיוע פרטני, ובין קידום חקיקה לליטיגציה.\nדרך הפעולה הייחודית של המרכז, המשלבת ידע ומחקר אקדמי עם הבנה פרקטית בעולם המשפט ועיצוב מדיניות, הובילה לשורה של שינויים חקיקתיים וחברתיים בדיני המשפחה עבור נשים בישראל, תוך עשייה מתמדת לקידום מעמדן בדיני משפחה בכלל ובהלכה היהודית בפרט. המרכז מאמין בהובלת שינוי במסגרת עולם ההלכה בדרך של שימוש בכלים הפנימיים הקיימים בעולם ההלכה היהודית ויחד עם זאת תומך גם במהלכים של שינוי מבחוץ.\nמרכז רקמן פועל בשתי רמות. ברמת הפרט, במתן מענה פרטני על ידי  ייעוץ וייצוג נשים בתיקים בדיני משפחה . ברמת החברה בכללותה, בשיתוף פעולה עם רשויות וגורמי ממשל על מנת לקדם מדיניות ולהוביל לשינויי חקיקה.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ],
      [
        'השכלה גבוהה ומחקר',
        'מרכזי מחקר'
      ]
    ],
    'id': 'YH63',
    'is_active': true,
    'keywords': [
      'הלכה',
      'דיני משפחה',
      'עגונות',
      'מסורבות גט',
      'שיתוף פעולה בינלאומי',
      'סיוע משפטי'
    ],
    'name': 'מרכז רקמן',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת גן',
    'organization_kind': [
      'אקדמי',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'שירותים משפטיים',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-07-29'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://rackmancenter.com/'
      },
      {
        'title': 'מרכז רקמן, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/RackmanCenter/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '29/07/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2001,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'שירותים משפטיים',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': '״מרכז תמורה - המרכז לקידום השוויון״ (ע״ר 580470201), נוסד על ידי פרופ\' יפעת ביטון ועו״ד אייל שטרנברג במטרה להיאבק למען אוכלוסיות מוחלשות ומושתקות בחברה הישראלית, אשר מופלות על בסיס מרכיבי זהות כגון מגדר, מיניות ואתניות. על מנת להביא לשינוי חברתי וכלכלי, פועל המרכז בזירה המשפטית על ידי כלים כמו פנייה לערכאות, סיוע משפטי לקבוצות ולפרטים שנפגעו כתוצאה מאפליה וליווי של מהלכים המתמקדים בחקיקה מתקנת, ביצירת שינוי בתפיסה החברתית ובתודעה הציבורית בישראל. בתחום קידום השוויון המגדרי פועל המרכז באמצעות פעילות משפטית - ייצוג נשים, בעיקר נפגעות אלימות במשפחה ותקיפה מינית בתביעות נזיקיות שמטרתן רתימת מערכת המשפט לטובת תיקון עוולות שנעשו להן; פעילות חינוכית למשל בנושא של אלימות כלכלית וכן באמצעות חקיקה. עוד פועל המרכז בנושאי הדיור הציבורי, הזכות לחינוך, מאבק בגזענות, שוויון במרחב הציבורי ובקבלת שירותים ומוצרים וקידום שוויון בתעסוקה. בשנים האחרונות, מקיים המרכז שיתוף פעולה הדוק עם ביה״ס למשפטים ע״ש שטריקס של המכללה למנהל. הסטודנטיות והסטודנטים מביה״ס למשפטים פועלות ופועלים במסגרת ״הקליניקה לקידום השוויון באמצעות דיני הנזיקין״, ולוקחים/ות חלק בעבודת המרכז.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'השכלה גבוהה ומחקר',
        'חברה וקהילה'
      ]
    ],
    'id': 'YB70',
    'is_active': true,
    'keywords': [
      'סיוע משפטי',
      'שוויון',
      'דיור',
      'שוויון מגדרי',
      'אלימות כלכלית',
      'אלימות מינית',
      'פמיניזם מזרחי'
    ],
    'name': 'מרכז תמורה - המרכז לקידום השוויון',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'מרכז תמורה',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ראשון לציון',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'שירותים משפטיים',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.tmura.org.il/page1.html'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז תמורה - המרכז לקידום שוויון (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580470201/documents'
      },
      {
        'title': 'כל זכות (ללא תאריך). <b>תמורה - המרכז המשפטי למניעת אפליה</b>. נדלה מתוך',
        'url': 'https://www.kolzchut.org.il/he/%D7%AA%D7%9E%D7%95%D7%A8%D7%94_-_%D7%94%D7%9E%D7%A8%D7%9B%D7%96_%D7%94%D7%9E%D7%A9%D7%A4%D7%98%D7%99_%D7%9C%D7%9E%D7%A0%D7%99%D7%A2%D7%AA_%D7%90%D7%A4%D7%9C%D7%99%D7%94'
      },
      {
        'title': 'מרכז תמורה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/TmuraLegalCenter/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים מזרחיות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '26/11/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2007,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '02/10/2018'
    },
    'description': '״קו החירום״ נוסד בשנת 1990 על ידי שבעה ארגונים שחלקם וולנטריים וחלקם מוסדיים. הגופים היו: משרד העבודה והרווחה- היחידה לטיפול בנשים ונערות; עיריית חיפה- האגף לשירותי רווחה; אוניברסיטת חיפה- החטיבה ללימודי האשה; נשים למען נשים- מקלט לנשים מוכות בחיפה; אשה לאשה- מרכז פמיניסטי חיפה; מרכז סיוע לנפגעות אונס ותקיפה מינית חיפה; ויצו חיפה. הקו נוהל בתחילה כפרויקט של ארגון ״אשה לאשה״ ובשנת 1995 נרשם כעמותה עצמאית תחת השם ״עמותת קו חירום לנפגעות אלימות״ (מס\': 580270767). בשנת 1997, בשיתוף משרד העבודה והרווחה, הפעילה העמותה את ״קו החירום הארצי למניעת אלימות במשפחה וילדים בסיכון״ (1-800-22-0000) שנתן מענה בחמש שפות (עברית, ערבית, רוסית, אמהרית ואנגלית). העמותה גם קיימה פרויקט תמיכה לנשים שורדות אלימות והיתה חלק מ״קואליציית ארגוני נשים חיפה״. לאחר שנת 2006, כשויצו זכתה במכרז להפעלת קו החירום הארצי, שינתה העמותה את שמה והתמקדה במתן שירותים לנשים נפגעות אלימות באזור חיפה והצפון עד שפורקה מרצון באופן סופי בשנת 2011.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'SA54',
    'is_active': false,
    'keywords': [
      'נשים מוכות',
      'קו סיוע',
      'תמיכה נפשית',
      'סיוע משפטי'
    ],
    'name': 'מרכז תמיכה לנפגעות אלימות במשפחה-חיפה',
    'name_ar': 'خط الطوارئ لمساعدة النساء المعنفات في حيفا( هذا الخط جزء من خط الطوارئ القطري لمساعدة ضحايا الإعتداءات الجسدية',
    'name_change_year': 2007,
    'name_common': null,
    'name_past': 'עמותת קו חירום לנפגעות אלימות',
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'ארכיון פמיניסטי, מרכז מחקר פמיניסטי חיפה. אותר בקלסר ״דו״חות מבוקרים: קו חירום״ בארכיון הפמיניסטי ב״אשה לאשה – מרכז פמיניסטי חיפה״.'
      },
      {
        'title': 'פליאל-טרוסמן, עדה (2013). יצירת שינוי: ארגוני נשים מול ממסד – המקרה של אשה לאשה. בתוך חנה ספרן, תלמה בר-דין, <b>אשה לאשה פמיניסטית: שלושים שנות פעילות</b> (עמ\' 91–101). חיפה: פרדס, אשה לאשה, מרכז פמיניסטי חיפה.'
      },
      {
        'title': 'Convention on the elimination of all forms of discrimination against women. Distr.: General, 2 June, 2005. CEDAW / C / ISR / 4. Retrieved from',
        'url': 'https://undocs.org/en/CEDAW/C/ISR/4'
      },
      {
        'title': 'Convention on the elimination of all forms of discrimination against women. Distr.: General, 16 November, 2001. CEDAW / C / ISR / 3. Retrieved from',
        'url': 'https://unispal.un.org/UNISPAL.NSF/0/8E1A118276E4B77E8525709800654D2C'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות',
      'נשים עולות מחבר העמים',
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '10/02/2018'
    },
    'year_closed': 2011,
    'year_closed_text': '2011',
    'year_founded': 1990,
    'year_registered': 1995
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '08/11/2018'
    },
    'description': 'מרכז תמר הוא אחד מהמרכזים הרב-תחומיים הציבוריים המתמחים בטיפול בטראומה מינית. המרכז נותן שירות לנשים מאיזור ירושלים, הוא באחריות משרד הרווחה ומתוקצב גם על ידי משרד הבריאות. מופעל על ידי החברה העירונית ״אריאל״ - חברת בת של עיריית ירושלים. המרכז נפתח בעקבות החלטת ממשלה ב-2007 להקצות תקציבים לנפגעות תקיפה מינית וכן בעקבות וועדה בראשות מרית דנון - מנהלת הרשות למעמד האישה דאז, שיזמה הקמת מרכז ייעודי לנפגעות טראומה.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'רווחה וקהילה',
        'אלימות מינית'
      ]
    ],
    'id': 'YH134',
    'is_active': true,
    'keywords': [
      'טראומה',
      'טיפול נפשי',
      'אונס',
      'תקיפה מינית',
      'הכשרה מקצועית'
    ],
    'name': 'מרכז תמר לטיפול בנפגעות תקיפה מינית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'מוניציפלי',
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-08-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www1.jerusalem.muni.il/jer_sys/picture/atarim/site_form_atar.asp?site_id=11659&pic_cat=1&icon_cat=5&york_cat=8'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2015, 30 יוני). <b>פרוטוקול מס\' 8: 1. מעקב אחר יישום התכנית לטיפול בנפגעות תקיפה מינית. 2. עדכון משרד הבריאות על מסקנות הוועדה בנושא ההפרדה המגדרית ונוהל הטיפול במקרי פגיעה מינית במחלקות אשפוז פסיכיאטריות</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/Activity/committees/Women/Pages/CommitteeProtocols.aspx?ItemID=566551'
      },
      {
        'title': 'מפתח התקציב (2014). <b>הפעלת מרכז תמר – לטיפול בנפגעי תקיפה מינית: בקשת פטור ממכרז. משרד הבריאות -> החברה העירונית אריאל – לתרבות, חברה, חינוך, רווחה, ספורט ואומנויות בע״מ (חל״צ)</b>. נדלה מתוך',
        'url': 'https://next.obudget.org/i/tenders/exemptions/557207/none'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/08/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2008,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '16/07/2018'
    },
    'description': 'המרכזים למניעת אלימות במשפחה הם מרכזי טיפול וסיוע לטווח ארוך וקצר לנשים נפגעות אלימות, לגברים אלימים ולילדים החשופים לאלימות. במרכזים ניתן טיפול פרטני ו/או קבוצתי על ידי עובדים סוציאלים מומחים וגם הדרכה לאנשי מקצוע והתערבות קהילתית. המרכז הראשון למניעת אלימות הוקם על ידי נעמ״ת תל אביב ביוזמת רונית לב-ארי בשנת 1983 כחלק ממערך השירותים של מרכז גליקמן. בשנת 1993, הפכו המרכזים לשירות ממשלתי-מוניציפלי לאחר שנקבעה הוראה בתקנון העבודה הסוציאלית (תע״ס) לפיה לשכות הרווחה יפעלו להקמת מרכזים למניעת אלימות במשפחה. ההוראה עודכנה בשנת 2004 במטרה לקבוע דרכי פעולה ונהלים אחידים למרכזים השונים. במשך השנים מספר המרכזים עולה בהתמדה: בשנת 1998 פעלו 22 מרכזים, ב-2002 פעלו 29 מרכזים (על פי דוח מבקר המדינה 52 ב\'), ב-2012 פעלו 89 מרכזים (על פי משרד הרווחה, סקירת השירותים החברתיים, 2012), בשנת 2016 פעלו 106 מרכזים ובשנת 2017 פעלו 113 (דוח חופש המידע של משרד הרווחה, 2017), מהם 37 ייעודיים לחברה הערבית וארבעה מרכזים מיועדים לחברה החרדית. המרכזים השונים פועלים בכפיפות ללשכות הרווחה המקומיות, בשיתוף משרד הרווחה. משרד הרווחה משתתף במימון של כ-75% מעלות ההפעלה והרשות בכ-25%. רוב המרכזים מופעלים על ידי הרשות ומיעוטם (ויצו-ירושלים, יד שרה-ירושלים) באמצעות ארגונים בהסכם התקשרות עם הרשות.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'YH56',
    'is_active': true,
    'keywords': [
      'משטרה',
      'מרכזים למניעת אלימות במשפחה',
      'גירושין',
      'משפחות',
      'ילדים'
    ],
    'name': 'מרכזים למניעה וטיפול באלימות במשפחה ברשויות המקומיות',
    'name_ar': 'مراكز منع وعلاج العنف الأسري',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'מוניציפלי',
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-05-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.molsa.gov.il/populations/distress/familyviolence/pages/tm_02_02_a01.aspx'
      },
      {
        'title': 'ידיעות אחרונות (2018, 6 מרץ). ענת לב-אדלר על רונית לב-ארי: ״היא קו הזינוק שלי למאבק באלימות נגד נשים״. נדלה מתוך',
        'url': 'https://www.yediot.co.il/articles/0,7340,L-5147823,00.html'
      },
      {
        'title': 'מבקר המדינה (2002). הטיפול בתופעת האלימות בין בני זוג. אליעזר גולדברג (מבקר המדינה), <b>דוח שנתי 52ב: לשנת 2001 ולחשבונות שנת הכספים 2000</b> (עמ\' 771–794). נדלה מתוך',
        'url': 'https://www.mevaker.gov.il/he/Reports/Pages/590.aspx'
      },
      {
        'title': 'משרד העבודה הרווחה והשירותים החברתיים (2017). <b>דוח חופש המידע</b>.',
        'url': 'http://www.molsa.gov.il/FreeInfo/Pages/FreeInfo.aspx'
      },
      {
        'title': 'משרד הרווחה והשירותים החברתיים (2004, 4 יולי). <b>מניעה וטיפול בתופעת האלימות במשפחה</b>. הוראות והודעות: הוראה 3.28 לפרק 3 בתע״ס. נדלה מתוך',
        'url': 'https://www.molsa.gov.il/CommunityInfo/Regulations/SocialRegulations/Documents/%D7%A4%D7%A8%D7%A7%203%20-%20%D7%A4%D7%A8%D7%98%20%D7%95%D7%9E%D7%A9%D7%A4%D7%97%D7%94/3_28.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים',
      'נשים ערביות',
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '16/07/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1983,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': 'המרפאה הניידת בחיפה הוקמה בשנת 2009 כחלק ממדיניות ציבורית להפחתת ממדי הזנות והסחר בנשים בישראל. המרפאה הניידת מהווה שירות של משרד הבריאות, לשכת חיפה ופועלת באמצעות סיורים שבועיים בכלי רכב מצוייד באמצעים רפואיים וקבלת קהל במרפאת הפרסים לייעוץ, אבחון וטיפול במחלות מין. מטרות המרפאה הניידת כוללות, שמירה על בריאותן של נשים בזנות וביסוס קשר טיפולי שיאפשר את יציאתן ממעגל הזנות והאלימות. מעל 1,000 נשים וגברים נבדקו במרפאה מאז הקמתה. שירות מרכזי של המרפאה הניידת הוא הנגשת בדיקות למחלות המועברות באמצעות קיום יחסי מין. עובדות המרפאה מקיימות קשר רציף עם נשים, גברים וטרנסג’נדרים בזנות, סמים ועוני מאזור חיפה והקריות, ומעניקות מידע בעברית, ערבית ורוסית, כולל לנשים חסרות מעמד. טווח גילאי הנבדקות נע בין 14-70, אך רוב הנבדקות הן נשים בין גילאי 20-40. הבדיקות והטיפול ניתנים בחינם ובמידת הצורך ניתן להיבדק ללא מתן פרטים אישים ותחת שם בדוי.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות ומגדר'
      ],
      [
        'תעשיית המין',
        'זנות'
      ]
    ],
    'id': 'YB78',
    'is_active': true,
    'keywords': [
      'איידס',
      'טיפול רפואי',
      'טיפול נפשי',
      'אמצעי מניעה',
      'מחלות מין',
      'טרנסקסואלים',
      'זנות',
      'סחר בנשים'
    ],
    'name': 'מרפאה ניידת חיפה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'בריאות ומגדר',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://womenhelp.org.il/about/'
      },
      {
        'title': 'המטה למאבק בסחר בנשים ובזנות. הקואליציה למאבק בזנות (ללא תאריך). <b>המרפאה הניידת בחיפה</b>. נדלה מתוך',
        'url': 'https://tfht.org/hebrew/%D7%90%D7%95%D7%93%D7%95%D7%AA/%D7%94%D7%A7%D7%95%D7%90%D7%9C%D7%99%D7%A6%D7%99%D7%94-%D7%9C%D7%9E%D7%90%D7%91%D7%A7-%D7%91%D7%96%D7%A0%D7%95%D7%AA/'
      },
      {
        'title': 'מרפאה ניידת חיפה (2018, 20 מאי). הפרטים אומתו בשיחה עם נציגת המרפאה.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים מהגרות עבודה או חסרות מעמד',
      'להט״ב',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '25/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2009,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': 'מרפאת לוינסקי של לשכת הבריאות המחוזית תל אביב היא מרפאה קהילתית לאיתור ולטיפול במחלות מין. המרפאה הוקמה בשנת 2002 עקב עלייה במקרי ההידבקות בזיבה (גונוריאה) החל מסוף שנות התשעים, במיוחד במחוז תל-אביב, והתגברות תופעת הסחר בנשים באותה תקופה. המרפאה מעניקה שירותים רפואיים ופסיכו-סוציאליים חינמיים, בדומה למרפאות מין אחרות בערים גדולות בעולם, ובהתאם להנחיות המרכז למניעת מחלות האמריקני (CDC), לאחר התאמתם לתנאים בישראל. ״צוות המרפאה מפעיל תכניות שונות לקידום מין מוגן גופנית ונפשית, אשר נובעות מתוך תפיסה של כבוד האדם ושוויון בין המינים. פעילות רפואית ופסיכו-חינוכית ייעודית מוגשת לבני נוער בסיכון, לגברים ולנשים בזנות, למכורים לחומרים פסיכו-אקטיביים, לחסרי בית ולחסרי מעמד, לקהילת הלהט״ב ולאנשים שחיים עם HIV .בנוסף מפעילה המרפאה ערוץ ייעוץ טלפוני ואינטרנטי בנושא מין מיניות ומחלות מין״. (מתוך דוח המרפאה לשנת 2018). המרפאה אף מפעילה מרפאה ניידת לנשים ולגברים בזנות המעניקה שירותים רפואיים ושירותים פסיכוסוציאליים.\nכמו כן, ישנו במרפאה תחום להט״ב המפעיל ארבע תכניות עיקריות: מרפאה ניידת לגברים ונשים טרנסג\'נדריות בזנות; מרפאה פתוחה בגן מאיר– פרויקט הנגשת בדיקות של המרפאה, בשיתוף הוועד למלחמה באיידס והמרכז הגאה בתל אביב ; סיוע וטיפול פסיכו-סוציאלי לגברים ולנשים טרנסג\'נדריות בזנות; פיתוח מענים ללהט״בים הנמצאים בסיכון מוגבר להידבק ולהדביק אחרים במחלות מין וב-HIV.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות ומגדר'
      ],
      [
        'תעשיית המין',
        'זנות'
      ],
      [
        'להט״ב',
        'רווחה ובריאות'
      ]
    ],
    'id': 'YB79',
    'is_active': true,
    'keywords': [
      'איידס',
      'טיפול רפואי',
      'טיפול נפשי',
      'קו סיוע',
      'אמצעי מניעה',
      'מחלות מין',
      'טרנסקסואלים',
      'זנות',
      'סחר בנשים'
    ],
    'name': 'מרפאת לוינסקי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'בריאות ומגדר',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://safe-sex.co.il/'
      },
      {
        'title': 'המטה למאבק בסחר בנשים ובזנות (אתר). <b>הקואליציה למאבק בזנות</b>. נדלה מתוך',
        'url': 'https://tfht.org/hebrew/%D7%90%D7%95%D7%93%D7%95%D7%AA/%D7%94%D7%A7%D7%95%D7%90%D7%9C%D7%99%D7%A6%D7%99%D7%94-%D7%9C%D7%9E%D7%90%D7%91%D7%A7-%D7%91%D7%96%D7%A0%D7%95%D7%AA/'
      },
      {
        'title': 'משרד הבריאות (אתר). <b>מרפאת לוינסקי</b> (העמוד אינו זמין יותר).'
      },
      {
        'title': 'משרד הבריאות, מרכז רפואי לוינסקי (2018). <b>מרפאת לוינסקי ושלוחותיה הניידות - סיכום שנת 2018</b>. נדלה מתוך',
        'url': 'https://safe-sex.co.il/wp-content/uploads/2019/06/levinski2018.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים',
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '14/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2002,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '16/01/2019'
    },
    'description': 'הפורום הפמיניסטי במרצ מקדם נושאי נשים ומגדר בתוך מוסדות המפלגה ומוביל מאבקים ופעילות ציבורית לקידום סדר יום פמיניסטי בישראל. הפורום יוזם פעילויות וחובר לארגוני הנשים להגברת המודעות לאי השיוויון המגדרי הקיים בישראל ולשיפור מצבן של נשים מכל חלקי החברה. מאבקים בולטים שקיים הפורום כוללים: מאבק באגודת אפרת וביטול הוועדות להפסקת הריון; חוק הבטחת הכנסה לנשים השוהות במקלטים לנשים מוכות; מאבק בהדרת נשים על כל ביטוייה; מאבק באלימות נגד נשים; שוויון מגדרי בתעסוקה. הפורום שנוהל על ידי שרון אורשלימי מהווה גלגול של פורום הנשים של מרצ שהוקם בשנת 2005 במטרה לחזק את נוכחות הנשים בתנועה. בין הפעילות הבולטות בפורום הנשים היו עדית דיאמנט, מיכל ארבל, מיכל עדן, מיכל רוזין.',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ]
    ],
    'id': 'SA119',
    'is_active': true,
    'keywords': [
      'מנהיגות',
      'הפלה',
      'אלימות',
      'תעסוקה',
      'שוויון',
      'תאים מפלגתיים'
    ],
    'name': 'מרצ- הפורום הפמיניסטי',
    'name_ar': null,
    'name_change_year': 2012,
    'name_common': null,
    'name_past': 'פורום נשים מרצ',
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'מפלגות, שדולות ותאים מפלגתיים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-01-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://meretz.org.il/%D7%A4%D7%95%D7%A2%D7%9C%D7%99%D7%9D-%D7%91%D7%9E%D7%A8%D7%A6/%D7%94%D7%A4%D7%95%D7%A8%D7%95%D7%9D-%D7%94%D7%A4%D7%9E%D7%A0%D7%99%D7%A1%D7%99%D7%98%D7%99/'
      },
      {
        'title': 'אריק בנדר (2012, 25 אוקטובר). מיכל רוזין, יו״ר פורום נשים רצה ל״מרצ״.<b>NRG מעריב</b>. נדלה מתוך',
        'url': 'https://www.makorrishon.co.il/nrg/online/1/ART2/411/282.html'
      },
      {
        'title': 'מרץ (ללא תאריך). <b>על הנשים להוביל את המאבק לשוויון המינים</b>, שיחה עם מיכל עדן מהרצליה, יו״ר פורום הנשים של מרצ וחברת הנהלת מרצ (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '16/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '26/12/2018'
    },
    'description': 'העמותה ״משפחה״ - משפחות חד הוריות בדרום (ע״ר 580441368) הוקמה בשנת 2005, רשומה אצל אדם בשם ז\'קי זריהן ופעלה באשקלון, לא ברור אם ממשיכה לפעול. בהגדרת המטרות: פעילות חינוך ותרבות וסיוע כלכלי למשפחות חד הוריות. בין השנים 2008-2014 קיבלו תמיכות ממשרד הקליטה על הפעלת מרכז לאמנים עולים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'הגירה',
        'קליטת עלייה'
      ],
      [
        'תרבות וספורט',
        'אמנות'
      ],
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ]
    ],
    'id': 'YH166',
    'is_active': false,
    'keywords': [
      'סיוע לאמהות',
      'אמהות',
      'סיוע כלכלי',
      'אמנות'
    ],
    'name': 'משפחה - משפחות חד הוריות בדרום',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'אשקלון',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'הגירה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קליטת עלייה',
    'primary_target_audience': 'נשים עולות מחבר העמים',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>״משפחה״ – משפחות חד הוריות בדרום (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580441368'
      },
      {
        'title': 'מפתח התקציב. <b>״משפחה״ – משפחות חד הוריות בדרום (ע״ר): רשימת תמיכות</b>. נדלה מתוך',
        'url': 'https://next.obudget.org/i/org/association/580441368'
      }
    ],
    'target_audiences': [
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '21/02/2019'
    },
    'year_closed': 2015,
    'year_closed_text': '2015',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'שירותים משפטיים',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': 'ארגון משפחה חדשה הוקם בשנת 1998 על ידי עוה״ד עירית רוזנבלום. הוא נרשם כעמותה תחת השם ״מצעד הנשים הגדול״. מטרותיו היו ״לקדם כל פעילות חברתית ושילוב נשים בכלל זה בתחום הדת, התרבות, החינוך, המדע, הסעד, המשפחה והבריאות. לפעול למען זכויות האדם וזכויות נשים בפרט.״ בדצמבר 1999 שונה שמו ל״משפחה חדשה״ ו״קידום זכות האדם למשפחה״ נוסף למטרותיו. מאז הארגון פעל למען הכרה ערכית וחוקית בכל סוגי התאים המשפחתיים בישראל ולהשוואת זכויותיהן של מגוון משפחות - משפחות של מהגרים, משפחות גאות, משפחות של חסרי דת או בעלי דתות מעורבות, ידועים בציבור וכו׳. הארגון מעניק שלל שירותים בתחום דיני המשפחה המרוכזים כולם במקום אחד - הסכמי יחסי ממון, צוואות, תעודת זוגיות ועריכת טקס נישואין אזרחי, ליווי של הליכי אימוץ ופונדקאות בארץ ובחו״ל ועוד. הארגון פועל גם לשינוי חקיקה על מנת להרחיב את ההכרה בסוגים שונים של משפחות ועושה עבודה תקשורתית על מנת לקדם נושאים אלה. הוא עובד ספציפית מול הקהילה הלהט״בית על מנת להגדיל את ההכרה במשפחות גאות ולמיצוי זכויותיהם של משפחות חד-מיניות. בנוסף הארגון פועל להסברה והפצת ידע על סוגי משפחות שונים וזכויותיהם דרך הפצת זכותונים בדואר, בעיתונות וברשת, ניהול אתר אינטרנט מקיף, כתיבת מאמרי דעה והשתתפות בהרצאות ובפאנלים בנושא. לארגון משרדים בתל אביב הפתוחים לפניות הציבור בימות השבוע בשעות העבודה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ],
      [
        'בריאות ופריון',
        'טכנולוגיות פריון'
      ],
      [
        'להט״ב',
        'משפחה'
      ]
    ],
    'id': 'YB68',
    'is_active': true,
    'keywords': [
      'נישואין',
      'הורות',
      'דיני אישות',
      'אימוץ',
      'פונדקאות',
      'סיוע משפטי',
      'זכויות להט״ב',
      'מיצוי זכויות',
      'נישואים אזרחיים',
      'מעמד אישי'
    ],
    'name': 'משפחה חדשה',
    'name_ar': null,
    'name_change_year': 1999,
    'name_common': null,
    'name_past': 'מצעד הנשים הגדול',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'שירותים משפטיים',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.newfamily.org.il/about/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>משפחה חדשה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580332302'
      },
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל.'
      },
      {
        'title': 'היימס, סיגל (2012, 10 יולי). עם חופשי: 5 אלטרנטיבות לחתונה אורתודוכסית. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-4253703,00.html'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים',
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '10/11/2018'
    },
    'description': 'משפחות הקשת (ע״ר 580519924) הוא ארגון שפעל בין השנים 2009-2014 לקידום ההורות הגאה בישראל. מטרות העמותה היו: ״קידום משפחות הקשת קרי הורות של הומואים, לסביות, ביסקסואלים וטרנסג\'נדרים למען ההורים וילדיהם. פעילות למען שוויון בכל תחומי החיים לרבות בהיבטים רפואיים, כלכליים, חינוכיים וטיפוליים. קידום המידע בתחום והנגשתו. ייצוג ענייני הקהילה וילדיהם בפני הרשויות וגורמים שונים בארץ ובחו״ל״ הארגון הוקם על ידי יאיר קדר ויוסי ברג, שניהם אבות גאים בהורות משותפת. ביום המשפחה 2010 התקיים כנס הייסוד של הארגון. האירוע כלל הפעלות לילדים וסיפורים אישיים והרצאות על מודלים שונים של הורות גאה. העמותה שפעלה בעיקר בתל אביב, שיתפה פעולה עם המרכז הגאה בניסיון לקדם את ההורות הגאה. פעילויותיה כללו, בין היתר, הפעלת קבוצות לטרום-הורות והורות משותפת, קיום פורום חינוכי עם מנהל החינוך בתל אביב והשירות הפסיכולוגי-חינוכי, קיום פעילות חודשית למשפחות גאות, הקמת אתר מידע פעיל וסיוע פרטני.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'משפחה'
      ]
    ],
    'id': 'LR20',
    'is_active': false,
    'keywords': [
      'הורות משותפת',
      'קבוצת תמיכה',
      'אבהות',
      'משפחות',
      'חינוך',
      'אבות',
      'הורות גאה'
    ],
    'name': 'משפחות הקשת',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'הרצליה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'משפחה',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-11-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://keshetfamilies.wordpress.com/%d7%a2%d7%9c-%d7%90%d7%95%d7%93%d7%95%d7%aa/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>משפחות הקשת (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580519924'
      },
      {
        'title': 'משפחות הקשת, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/keshetfamilies.il/'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2014,
    'year_closed_text': '2014',
    'year_founded': 2009,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '26/10/2018'
    },
    'description': 'מדרשת מת״ן הוקמה בירושלים בשנת 1988 על ידי הרבנית מלכה בינה ללימוד תורה גבוה לנשים, עם דגש על לימודי הלכה, תנ״ך וגמרא, והכשרות להצמיח מנהיגות נשית דתית ורוחנית בתחומים אלו ובכלל. בשנת 1989 נרשמה כעמותה (ע״ר 580140184) שמטרתה: ״ להקים מרכז תורני ללימודי קודש ולמחקר. לקדם לימודי קודש ומחקר ברמות שונות ובמסגרות שונות. מתן מילגות למתמחים בלימודי קודש ומחקר.״ לאורך השנים מת״ן פיתחה מספר תוכניות לימוד לנשים בגילאים שונים וברמות אינטנסיביות והעמקה שונות, וכן 11 סניפים ברחבי הארץ - מבאר שבע ועד זכרון יעקב.',
    'description_ar': null,
    'display_organization_kind': 'מוסד תורני בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'השכלה'
      ],
      [
        'נערות וצעירות',
        'דת'
      ]
    ],
    'id': 'SW26',
    'is_active': true,
    'keywords': [
      'הלכה',
      'מדרשה',
      'תורה',
      'יהדות'
    ],
    'name': 'מתן מכון תורני לנשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'מוסד תורני',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'מוסד תורני',
    'primary_sub_field_of_activity': 'השכלה',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-10-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.matan.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז תורני לנשים ותכנית המתמידות בירושלים: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580140184'
      },
      {
        'title': 'Rosenberg, Esti (2012). “The ‎world of women’s Torah learning – developments, directions and ‎objectives: A report from the field.” <b>Tradition: A Journal of Orthodox Jewish Thought, 45</b>(1), 13-36. Retrieved from',
        'url': 'https://www.jstor.org/stable/23264031?seq=1'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '26/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1988,
    'year_registered': 1989
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '19/05/2018'
    },
    'description': '״מתפקדות״ הוקמה ב-2011 ונרשמה כעמותה בשם ״לובי פמיניסטי״ (ע״ר 580550796) על ידי ליאן רם ופליאה קטנר מכפר סבא במטרה ״לפעול לשינוי מצבן של נשים בישראל. לקדם עשייה פרלמנטרית פמיניסטית באמצעות התפקדות למפלגות. להשפיע באופן ישיר על חברות וחברי הכנסת באמצעות השתתפות בבחירות המקדימות, ולתת כוח אלקטורלי לחברות וחברי כנסת המתחייבים לקדם חקיקה ומדיניות לקידום נשים בישראל״. העמותה פעלה בשלושה מישורים:\n1. עידוד התפקדות למפלגות ליצירת לובי פמיניסטי.\n2. מעקב אחר פעילות חברות/י הכנסת בנושאים הנוגעים לנשים, והבאתו לידיעת הציבור.\n3. הפעלת לובי פמיניסטי בכנסת לקידום חקיקה, אכיפה, והקצאת משאבים לנושאים העומדים על סדר היום של נשים.\nב-2012 פרסמה העמותה בשיתוף שדולת הנשים דוח מעקב בנושא קידום השוויון המגדרי בכנסת ה-18. נראה שהעמותה לא המשיכה לפעול אחרי שנת 2014.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'כללי'
      ]
    ],
    'id': 'YB53',
    'is_active': false,
    'keywords': [
      'בחירות',
      'שוויון מגדרי',
      'חקיקה',
      'פמיניזם',
      'תקציב'
    ],
    'name': 'לובי פמיניסטי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'מתפקדות',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר סבא',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'כללי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-12-19'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://mitpakdot.wordpress.com/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>לובי פמיניסטי (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580550796'
      },
      {
        'title': 'מורג, נועה (2014, 24 מאי). רוצות לפרק את הפטריארכיה? תתפקדו לליכוד. <b>פוליטיקלי קוראת</b>. נדלה מתוך',
        'url': 'http://politicallycorret.co.il/newlikud/'
      },
      {
        'title': 'מתפקדות: לובי פמיניסטי, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/groups/mitpakdot/about/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '19/12/2019'
    },
    'year_closed': 2014,
    'year_closed_text': '2014',
    'year_founded': 2011,
    'year_registered': 2012
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '07/05/2018'
    },
    'description': 'העמותה פועלת החל משנת 1999 מתוך מטרה לקדם עסקים של נשים בעיר מודיעין וסביבתה ולהוות מסגרת תומכת שתספק מיומנויות, ידע והעצמה עסקית ואישית. בעמותה פעילות כ-100 בעלות עסקים קטנים ובינוניים ומקומיים, שמתנהלות בשש קבוצות נטוורקינג.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ]
    ],
    'id': 'YH45',
    'is_active': true,
    'keywords': [
      'העצמה',
      'רישות',
      'נשות עסקים',
      'יזמיות'
    ],
    'name': 'נ.י.ב נשים יוזמות בעסקים במודיעין',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'מודיעין-מכבים-רעות',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-07'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://niv.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נ.י.ב. נשים יזמות בעסקים במודיעין והסביבה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580335610'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '07/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1999,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '16/07/2018'
    },
    'description': '״מרגלית - אם בישראל״ (ע״ר  580243335) הוקם כארגון הנשים של מפלגת ש״ס בחודש מרץ 1994, וקיבל את שמו ‏‏״מרגלית״ בחודש אוגוסט 1994 לאחר פטירת אשתו של הרב עובדיה יוסף, מרגלית. מאז הארגון ידוע ‏בעיקר כ-״ארגון נשות ש״ס״ או כ-״מטה הנשים של ש״ס״. מטרתו הרשמית היא: ״ארגון נשים להפצת תורה ויהדות ולהעמקת נושא טהרת הבית היהודי בקרב נשות עם ישראל״. הארגון מארגן כנסים, ערבי תרבות, סופי ‏שבוע ושיעורי תורה עבור נשים – בעיקר ספרדיות, מזרחיות, ומהפריפריה החברתית והגאוגרפית – וכן ‏פעיל בקמפייני הבחירות של מפלגת ש״ס בפעילות אינטנסיבית אל מול ועם קהל הנשים. כמו כן, קשורה ‏לארגון רשת מעונות יום ״נאות מרגלית״ (ע״ר 580362911) שנוסד בשנת 2000 וכיום מונה 80 סניפים המתפרסים כמעט רק ‏בנגב, ומעט בשפלה ובמרכז – מאילת ועד מושב אחיעזר. בתחילת שנת 2019 הופיע בגיידסטאר כי ‏לעמותה ״מרגלית אם בישראל״ ניתן צו פירוק על ידי בית משפט. ארגון נשות ש״ס, הפונה לציבור הנשים, מובדל ‏ממועצת הנשים של המפלגה שהוקמה בשנת 2014 על ידי עדינה בר שלום ואריה דרעי על מנת לייעץ ‏למפלגה בזירה הפוליטית.‏',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ],
      [
        'דת ומעמד אישי',
        'תעסוקה ועבודה'
      ]
    ],
    'id': 'SW16',
    'is_active': true,
    'keywords': [
      'ייצוג',
      'סיוע לאמהות',
      'פריפריה',
      'דת'
    ],
    'name': 'מרגלית אם בישראל',
    'name_ar': null,
    'name_change_year': 1994,
    'name_common': 'נאות מרגלית',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעונות ומשפחתונים',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2018-06-24'
    },
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>ארגון נשים – מרגלית – אם בישראל: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580243335'
      },
      {
        'title': '(2018, 18 אוקטובר). מטה נשות ש״ס מציג: ערב עוצמתי ומרגש. <b>כיכר השבת</b>. נדלה מתוך: ‏',
        'url': 'https://www.kikar.co.il/293897.html'
      },
      {
        'title': 'פלדמן, ענת (2012, 12 יוני). <b>נשים חרדיות לומדות מקצוע - נשות המהפכה</b>. המכללה האקדמית אחווה. נדלה מתוך:\n',
        'url': 'http://www.achva.ac.il/sites/default/files/achvafiles/r&d/publications/ %D7%97%D7%A8%D7%93%D7%99%D7%95%D7%AA %D7%9C%D7%95%D7%9E%D7%93%D7%95%D7%AA %D7%9E%D7%A7%D7%A6%D7%95%D7%A2 - %D7%A0%D7%A9%D7%95%D7%AA %D7%94%D7%9E%D7%94%D7%A4%D7%9B%D7%94 _ %D7%A9_%D7%A1.pdf'
      }
    ],
    'target_audiences': [
      'נשים חרדיות',
      'נשים מזרחיות',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '03/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1994,
    'year_registered': 1994
  },
  {
    'activity_kinds': [
      'אקטיביזם רשת',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '13/05/2018'
    },
    'description': '‏״נבחרות״ הוקמה כתנועת ״לא נבחרות, לא בוחרות״ עם קמפיין אינטרנטי של אסתי שושן, עיתונאית ‏ופרסומאית חרדית, לקראת הבחירות לכנסת ה-19 בסוף שנת 2012. הקמפיין מחה נגד הדרת נשים ‏ממפלגות חרדיות וביקש לקדם ייצוג והשתתפות נשים חרדיות בפוליטיקה ודאגה לאינטרסים שלהן. ‏בשנת 2013 קמה מתוך התנועה פרוייקט ״מעורבות״ לפעילות שטח שהתפצלה מ-״נבחרות״ כנראה בשנת ‏‏2016, שנה לאחר רישום ״נבחרות״ כעמותה ומיסוד הפעילות ואסטרטגיה שלה. ״נבחרות״ פועלות בקרב ‏נשים חרדיות ללמד אותן על זכויותיהן ולקדם את מעורבותן, בקרב החברה החרדית להעלאת מודעות ‏להשלכות של הדרת נשים מהזירה הפוליטית והציבורית, ואל מול גורמי חוק ומשפט לקידום מדיניות על ‏ידי מתן מידע והצעות מדיניות.‏',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'ייצוג הולם'
      ],
      [
        'דת ומעמד אישי',
        'פוליטיקה ומנהיגות'
      ]
    ],
    'id': 'SW3',
    'is_active': true,
    'keywords': [
      'ייצוג',
      'קידום נשים',
      'אפליה מגדרית',
      'מנהיגות',
      'הלכה'
    ],
    'name': 'נבחרות',
    'name_ar': null,
    'name_change_year': 2015,
    'name_common': null,
    'name_past': 'לא נבחרות לא בוחרות',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'אקטיביזם רשת',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ייצוג הולם',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2018-05-13'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.nivcharot.co.il'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נבחרות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580619120'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '14/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2012,
    'year_registered': 2015
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': 'נגה היה כתב עת פמיניסטי שיצא לאור בישראל בשנים 1980-2005 בהוצאת עמותת נֹגה (ע״ר 580008969). מטרות העמותה היו: להוציא לאור עיתון של נשים ,להוציא לאור ולתרגם כתבי עת, חוברת וספרים בנושאי האשה, לקדם את מעמד האשה בישראל, לעזור ולסייע לנשים בכל דרך שהיא. עורכות כתב העת היו רחל אוסטרוביץ, מירה אריאל, רחל גיורא, אראלה דאור ומירי קרסין. כתב העת כלל חדשות על הנעשה בידי נשים ולמען נשים, מאמרים שעסקו בנשים בהיסטוריה, באפליית נשים ובפוליטיקה הישראלית מנקודת מבט נשית. עם הכותבות בכתב העת נמנו דפנה יזרעאלי, תמר אלאור, סילביה פוגל-ביז\'אווי, נורית כהנא, יהודית בובר-אגסי, מרשה פרידמן, רקפת זהר, אהוד עין-גיל ועוד. כתב העת שימש גם במה ליצירות של נשים, במדורים ״חדר משלה״ (לכותבות) ו״שער משלה״ (לאמניות). בגיליונו הראשון התפרסם הסיפור הקצר ״קריעה״, שהוא ראשית דרכה הספרותית של ברכה סרי. לאחר פריצתה של האינתיפאדה השנייה, הצטרפה עמותת נגה לקואליציית נשים לשלום. ב-25 שנות קיומו של כתב העת, יצאו לאור 43 גיליונות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף אקדמי',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'כתבי עת והוצאה לאור'
      ],
      [
        'תקשורת'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ]
    ],
    'id': '1YB4',
    'is_active': false,
    'keywords': [
      'פמיניזם',
      'קידום נשים',
      'אפליה',
      'אקטיביזם',
      'מחקר פמיניסטי',
      'שלום'
    ],
    'name': 'נגה- כתב עת פמיניסטי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': 'לילית',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'אקדמי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'כתבי עת והוצאה לאור',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://lib.cet.ac.il/pages/sub.asp?source=133'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נגה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580008969'
      },
      {
        'title': 'נגה (כתב עת). <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%A0%D7%92%D7%94_(%D7%9B%D7%AA%D7%91_%D7%A2%D7%AA)'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '10/07/2018'
    },
    'year_closed': 2005,
    'year_closed_text': '2005',
    'year_founded': 1980,
    'year_registered': 1982
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '19/06/2019'
    },
    'description': '״השירות לנערות במצוקה״ הוקם במשרד הרווחה (משרד הסעד דאז) ב-1969 במקביל ליחידה לחבורות רחוב, והתמקד בתופעות כגון שוטטות וזנות. בהמשך שולבה היחידה באגף תקון במשרד. ב-1993 הורחב השירות לנערות וצעירות לגילאי 13-21. ב-2008 טווח הגילאים הורחב עוד יותר ל-13-25 וב-2010 אוחד השירות לנערות וצעירות עם השירות לנערים וצעירים תחת השם ״השירות לנוער, צעירות וצעירים״ (נוצ״ץ). השירות מופקד על איתור טיפול ושיקום כ- 40,000 נערות ונערים צעירות וצעירים בגילאי 13-25, הנמצאים בדרגות שונות של ניתוק מהחברה ומנותני השירותים ומצויים במצבי סיכון ומצוקה קשה״. באמצעות עמותות ולשכות לשירותים חברתיים ברשויות מקומיות, השירות מפעיל מקלטים, בתים חמים, הוסטלים, תכניות מנטורינג, תכניות הכשרה מקצועית והשכלה, תמיכה בנפגעות זנות וסחר, תמיכה בנפגעות תקיפה מינית, תמיכה בבני נוער וצעירים להט״בים ועוד.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ],
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ]
    ],
    'id': 'YH191',
    'is_active': true,
    'keywords': [
      'שירות ציבורי',
      'תמיכה נפשית',
      'דיור',
      'תעסוקה',
      'שיקום',
      'זנות',
      'להט״ב',
      'נשים מזרחיות'
    ],
    'name': 'השירות לנוער, צעירות וצעירים במשרד הרווחה',
    'name_ar': null,
    'name_change_year': 2011,
    'name_common': 'נוצ״ץ',
    'name_past': 'השירות לנערות וצעירות; השירות לנערות במצוקה',
    'name_replaced_by': 'השירות לנערות וצעירות',
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'צעירות במצבי סיכון',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.molsa.gov.il/Units/Wings/AgafNoar/ShirutNohar/Pages/ShirutNohar.aspx'
      },
      {
        'title': 'ברקוביץ\'-רומנו, אדוה, קרומר-נבו, מיכל וקומם, מיכל (2013). גוף הידע המחקרי בישראל על נערות במצבי מצוקה: סקירה היסטורית מפרספקטיבה פמיניסטית. <b>חברה ורווחה, לג</b>(1), 7–39. נדלה מתוך',
        'url': 'https://www.molsa.gov.il/CommunityInfo/Magazine/Lists/ArticlesList/Attachments/1416/33-1-BERKOVITZ%20ETC.pdf'
      },
      {
        'title': 'דגן-בוזגלו, נוגה וחסון, יעל (2016). <b>שירותי רווחה לצעירות בישראל: בחינה של מודל ההפעלה והתקצוב</b>. מרכז אדוה, איתך: משפטניות למען צדק חברתי ונראות – פורום ארגוני צעירות. נדלה מתוך',
        'url': 'http://adva.org/wp-content/uploads/2016/09/welfare-young-women-1.pdf'
      },
      {
        'title': 'משרד הרווחה והשירותים החברתיים (2008). <b>מדיניות הטיפול בנערות וצעירות</b>. הוראה 1 לפרק 17 בתע״ס. נדלה מתוך',
        'url': 'https://www.molsa.gov.il/CommunityInfo/Regulations/SocialRegulations/Documents/%D7%A4%D7%A8%D7%A7%2017-%20%D7%98%D7%99%D7%A4%D7%95%D7%9C%20%D7%91%D7%A0%D7%A2%D7%A8%D7%95%D7%AA%20%D7%91%D7%9E%D7%A6%D7%95%D7%A7%D7%94/17_1.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות',
      'נשים עולות מחבר העמים',
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '19/06/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '22/06/2018'
    },
    'description': 'עמותת נ.ט.ע (ע״ר 580456739) הוקמה בשנת 2006, ומנוהלת על ידי ד”ר יעל יצחקי. מטרותיה: לסייע לנשים לממש את שאיפותיהן המקצועיות, להתקדם ולהצליח בעולם העבודה וליצור תרבות ניהול בארגונים המקדמת הוגנות מגדרית. פעילות העמותה מתמקדת בקורסים והכשרות לארגונים ולנשים (כולל קורס לנשים ערביות), ייעוץ תעסוקתי פרטני לנשים ומחקר אודות השפעת עולם העבודה על נשים וגברים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'YH28',
    'is_active': true,
    'keywords': [
      'שוויון בארגונים',
      'שוויון מגדרי',
      'תנאי עבודה',
      'קריירה',
      'שעות עבודה גמישות',
      'רישות'
    ],
    'name': 'נ.ט.ע. - נשים לטובת עתידן - המרכז הרב תחומי לפיתוח קריירה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'נטע - המרכז לפיתוח קריירה',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'בני ברק',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'זכויות ומדיניות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.netta.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נ.ט.ע. – נשים לטובת עתידן – המרכז הרב תחומי לפיתוח קריירה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580456739'
      },
      {
        'title': 'נטע- המרכז לפיתוח קריירה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pg/NettaOrg/about/?ref=page_internal'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '22/06/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2006,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '21/07/2018'
    },
    'description': '״ניסאא ואאפאק״- נשים ואופקים נוסדה בשנת 2002 על ידי קבוצה של פעילות פמיניסטית באזור המשולש, שביקשה לקדם את זכויותיהן של נשים הפלסטיניות על ידי מתן פרשנות מתקדמת של הטקסטים הקדושים לאסלאם. חברות ניסאא ואאפאק מאמינות כי ההשפעה של הדת על מעמדן של נשים מוסלמיות מחייבת פעולה הנובעת מתוך ההקשר החברתי-תרבותי של חייהן. נקודת המוצא של העמותה היא שהדת האסלאמית מקנה לנשים זכויות רבות אבל הן מוכחשות ומושתקות כי מלאכת הפרשנות של הקוראן והחדית\', שהם המקורות לחוקי השריעה, הייתה נחלתם של הגברים הנמנים עם הזרם הדתי השמרני שנטלו לעצמם את המונופול על כך. העמותה הוקמה על ידי סאידה מוחסן באדסי ופעילות אחרות המתגוררות בכפרים שונים באזור ולמרות שרשומה בבאקה אל-גרבייה היא פועלת בכפר קרע. מטרות העמותה (ע.ר. 580397867) הן: ״העצמת האשה הערביה בישראל. פיתוח תפיסה ודפוסים פלורליסטים בהלכה המוסלמית. עידוד דיאלוג בין תרבותי. הפעלת מרכז חינוכי לקידום וטיפוח הידע, היכולות והכישורים של ילדים, נשים והחברה בכלל. קידום וטיפוח שיח ומפגש תרבותי בין הקהילות השונות בארץ ובעולם ליצירת חברה משותפת ורב תרבותית, בין היתר, בעזרת מפגשים, סיורים וטיולים. עידוד וקידום הבריאות לחברה בכלל ולנשים וילדים בפרט״. פעילויות הארגון כוללות סדנאות, הרצאות ומפגשים בנושאים הנוגעים לקידום מעמד האשה בתחום החברתי, הפוליטי והדתי. וכן קידום של חקיקה ומיצוי זכויות בכל הנוגע למעמד אישי וזכויות ירושה בבתי הדין השרעיים.',
    'description_ar': 'تأسست جمعية نساء وافاق عام 2002 من قبل مجموعة ناشطات نسويات في منطقة المثلث الذين سعوا لتعزيز حقوق المرأة الفلسطينية من خلال توفير تفسير متقدم للنصوص المقدسة في الإسلام. تؤمن صديقات الرابطة أن تأثير الدين على وضع المرأة المسلمة يتطلب عملاً ناشئاً عن السياق الاجتماعي والثقافي لحياتها. إن نقطة الانطلاق في الرابطة هي أن الدين الإسلامي يمنح المرأة الكثير من الحقوق ولكن يتم إنكاره وكتمه بأن عمل تفسير القرآن الكريم والحديث الشريف، وهما مصدر الشريعة الإسلامية، كان ملكًا لرجال التابعين للتيار الديني المحافظ الذين احتكروا ذلك.\nقامت سائدة محسن ونساء اخريات اللواتي يسكن في قرى مختلفة من منطقة المثلث بتأسيس الجمعية والتي سجلت في باقة الغربية الا ان نشاطها يتم في بلدة كفر قرع. اهداف الجمعية هن: تمكين المرأة العربية في إسرائيل. تطوير التصور التعددي وأنماطه في الشريعة الإسلامية. تشجيع الحوار بين الثقافات. إدارة مركز تعليمي لتعزيز وتنمية معارف ومهارات وقدرات الأطفال والنساء والمجتمع بشكل عام. تشجيع وتعزيز الخطاب واللقاء الثقافي بين مختلف المجتمعات في إسرائيل وحول العالم لإنشاء مجتمع مشترك متعدد الثقافات، من بين أمور أخرى، من خلال الاجتماعات والجولات والرحلات، تشجيع وتعزيز الصحة للمجتمع بشكل عام والنساء والأطفال بشكل خاص״. تشمل أنشطة المنظمة ورش العمل والمحاضرات والاجتماعات حول القضايا المتعلقة بالنهوض بوضع المرأة في المجالات الاجتماعية والسياسية والدينية.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'השכלה'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'YH60',
    'is_active': true,
    'keywords': [
      'אסלאם',
      'דת',
      'קידום נשים',
      'בדואיות',
      'מעמד אישי',
      'ירושה',
      'חקיקה'
    ],
    'name': 'ניסאא ואאפאק - נשים ואופקים',
    'name_ar': 'نساء وآفاق',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר קרע',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'השכלה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://nisaa-waafaq.org\n לא פעיל'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>ניסאא ואאפאק – נשים ואופקים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580397867'
      },
      {
        'title': 'אוסצקי-לזר, שרה (2009). <b>״לא כמו אמי״: נשים מעצימות את עצמן – המקרה של כפר קרע</b>. ירושלים: בית הספר ע״ש פדרמן למדיניות ציבורית וממשל - האוניברסיטה העברית בירושלים. נדלה מתוך',
        'url': 'https://www.sarahozacky.com/862/%D7%9C%D7%90-%D7%9B%D7%9E%D7%95-%D7%90%D7%9E%D7%99-%D7%A0%D7%A9%D7%99%D7%9D-%D7%9E%D7%A2%D7%A6%D7%99%D7%9E%D7%95%D7%AA-%D7%90%D7%AA-%D7%A2%D7%A6%D7%9E%D7%9F-%E2%80%93-%D7%94%D7%9E%D7%A7%D7%A8/'
      },
      {
        'title': 'עברי, יעל (2007, 8 מאי). להפוך את הדת מאויב הנשים לכלי לשחרורן. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-3391864,00.html'
      },
      {
        'title': 'קוזמא, ליאת (2011). <b>לנוכח בית הדין השרעי: תהליכי שינוי במעמדן של נשים מוסלמיות בישראל ובמזרח התיכון</b>. תל אביב: רסלינג.'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '05/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2001,
    'year_registered': 2002
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '05/07/2018'
    },
    'description': 'ארגון ״ניסן – מנהיגות צעירות״ (ע.ר. 580260586) היה ארגון פמיניסטי, ערבי-יהודי, שהוקם לשם לימוד, הדרכה והכשרת בני נוער בישראל למצוינות ולמעורבות אישית בחברה בדגש על עידוד השתלבותן של נשים צעירות בכל תחומי החינוך, התרבות והעשייה בישראל. פעילות העמותה התמקדה בהעצמה ופיתוח הפוטנציאל המנהיגותי אצל צעירות בישראל: ״אנו חותרות להקמת חברה צודקת, שוויונית ודימוקרטית. ולשים קץ לאפליה ושעבוד באמצעות תכנות חדשני, שיח אלטרנטיבי, אחווה ותמיכה הדדית״. העמותה הפעילה קבוצות דיאלוג ומפגשים בין נערות ונשים צעירות, יהודיות וערביות. מייסדת הארגון היתה כלנית דובר והוא נוהל במשך תקופה ארוכה בידי סנאא זריק בנצרת ובחיפה. מנהלותיו המשותפות האחרונות היו נסרין מזאווי וניצן תנעמי. לאחר המשבר הכלכלי (2008) העמותה הפסיקה לפעול ואינה מקיימת פעילות מאז שנת 2009.',
    'description_ar': 'منظمة ״نيسان- قياديات شابات״ (ج.م 580260586) كان بمثابة منظمة نسوية عربية يهودية تأسست لدراسة وتدريب وتأهيل الشباب في إسرائيل من أجل التميز والمشاركة الشخصية في المجتمع، مع التركيز على تشجيع إدماج الشابات في جميع مجالات التعليم والثقافة والممارسة في إسرائيل. ركزت أنشطة الجمعية على تمكين وتطوير القدرات القيادية للشابات في إسرائيل: ״نحن نسعى جاهدات لإقامة مجتمع عادل، منصف وديمقراطي. ووضع حد للتمييز والاستضعاف من خلال البرمجة المبتكرة، الخطاب البديل، الصداقة والدعم المتبادل ״. تدير الجمعية مجموعات حوار واجتماعات بين الفتيات الصغيرات والنساء اليهوديات والعربيات. كان مؤسس المنظمة متحدثًا باسم شقائق النعمان ولوقت طويل تديره سناء زريق في الناصرة وحيفا. وكان آخر المديرين التنفيذيين المشتركين له هو نسرين مزاوي ونيتسان تنعامي. بعد الأزمة الاقتصادية (2008)، توقفت الجمعية عن العمل ولم تنشط منذ عام 2009',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'מנהיגות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ],
      [
        'שלום'
      ]
    ],
    'id': 'SA9',
    'is_active': false,
    'keywords': [
      'מנהיגות',
      'נערות',
      'צעירות',
      'דו קיום'
    ],
    'name': 'ניסן- מנהיגות צעירות',
    'name_ar': 'نيسان - نساء شابات قياديات',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מנהיגות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-08-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.nisan.org.il -לא פעיל'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>ניסן – מנהיגות צעירות (ע״ר) NISAN – YOUNG WOMEN LEADERS: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'http://www.guidestar.org.il/organization/580260586'
      },
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל. עמ\' 26–74.'
      },
      {
        'title': 'NISAN Young Women Leaders (2015). <b>Young women camp</b>. Retrieved from: www.klon.org.pl/files/01ogloszenia.ngo.pl/public/Young_Women_Camp.doc'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '18/03/2019'
    },
    'year_closed': 2009,
    'year_closed_text': '2009',
    'year_founded': 1994,
    'year_registered': 1995
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/04/2019'
    },
    'description': 'ניצה - רשת תמיכה שלאחר הלידה היא עמותה (ע״ר 580297034) שנוסדה בשנת 1997 במטרה לספק ״עזרה לנשים שסובלות מסימפטומים הקשורים להריון ולאחר הלידה, כולל סיוע כספי וגמילות חסדים״. העמותה פעילה בכל הארץ אך בעיקר באזור ירושלים, בית שמש, מודיעין עילית וכפר חב״ד. הארגון אשר הוקם בטלזסטון, קריית יערים, הוא העמותה היחידה בישראל שליבת פעילותה סיוע ושיקום של נשים הסובלות מדיכאון לפני ואחרי לידה והוא משרת בעיקר נשים מהמגזר הדתי והחרדי. העמותה מפעילה קו סיוע טלפוני, מספקת מידע ומלווה את הנשים והמשפחות הפונות בכל שלבי התמודדות. העמותה מציעה ומעניקה מגוון רחב של פתרונות טיפוליים ואף מעניקה סיוע כספי למשפחות בהן האם סובלת ממשבר לאחר הלידה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ]
    ],
    'id': 'SA159',
    'is_active': true,
    'keywords': [
      'גמ״ח',
      'דיכאון אחרי לידה',
      'קו סיוע',
      'תמיכה נפשית'
    ],
    'name': 'ניצה - רשת תמיכה שלאחר הלידה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2019-04-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.nitza.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>ניצה – רשת תמיכה שלאחר הלידה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580297034'
      }
    ],
    'target_audiences': [
      'נשים חרדיות',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1997,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'שירותים משפטיים',
      'סנגור, מעקב ושינוי מדיניות',
      'מחאה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '06/06/2018'
    },
    'description': 'נשים למען אסירות פוליטיות״ (נלא״פ) היא עמותה (ע.ר. 580168052) שמטרתה ״לפעול לרווחת אסירות״. העמותה נרשמה אצל חוה קלר בתל אביב ונסיבות הקמתה מתוארות כך: ״ קבוצת נשים למען אסירות פוליטיות (נלא״פ) מורכבת מנשים ישראליות, יהודיות ופלסטיניות, המאוחדות בהתנגדותן לכיבוש. מטרת הקבוצה להגן על זכויותיהן האנושיות והדמוקרטיות של נשים העצורות בבתי הכלא בישראל בשל פעילותן החברתית והפוליטית ומאבקן הלגיטימי נגד הכיבוש. העבודה היומיומית, לא פעם מאומצת וקשה, נעשית בהתנדבות - כל אחת תורמת מזמנה לפי יכולתה. הקבוצה הראשונה הוקמה בתל אביב במאי 1988 בתגובה למדיניות דיכוי האינתיפאדה שהביאה, בין השאר, לריבוי מעצרים והתנכלויות לנשים פעילות. בראשית 1988 הוקמה הקבוצה בירושלים מתוך הכרה בצרכים הרבים והמיוחדים של העצירות במגרש הרוסים. בית מעצר זה נודע לשמצה בתנאיו הקשים, ביחס האכזרי לו זוכות העצורות הפוליטיות, ובהעדר הגדרות חוקיות ונוהלים ברורים לגבי זכויותיהן״. בפרסומים מאוחרים מצוין כי הארגון מבקש גם לקדם את שחרור כל האסירות והאסירים הפוליטיים אשר מוחזקים/ות בבתי כלא הישראלים. פעילויות הארגון כוללות הענקת סיוע משפטי וביקורי עו״ד במתקני כליאה, סיוע סוציאלי, נוכחות בבתי משפט ומעקב אחר התנאים בהם מוחזקות האסירות הפוליטיות, כולל תיעוד של איומים והטרדות מיניות בחדרי מעצר וחקירות. העמותה אינה מעסיקה עובדות וכל פעילויותיה נעשות בהתנדבות מלבד שכר טרחה של עורכי דין. הדוח האחרון שהגישה העמותה היה בשנת 2017 וייתכן שהיתה זו שנת הפעילות האחרונה של הארגון.',
    'description_ar': 'جمعية نساء من اجل الاسيرات السياسيات هي جمعية مسجلة (ج. م580168052) والتي تعمل من اجل رفاه الاسيرات الفلسطينيات كجزء من مفهوم سياسي يعارض الاحتلال. انطلق نشاط المجموعة في القدس عام 1988، مباشرة بعد انطلاق الانتفاضة الثانية، بهدف تقديم المساعدة القانونية والإنسانية للمحتجزات في المعتقل الروسي. هدف المنظمة هو دعم الأسيرات السياسيات ودعم إطلاق سراح كل الاسيرات والاسيرين السياسيين المحتجزين في السجون الإسرائيلية. يشمل نشاط المنظمة تقديم المساعدة القانونية وتوفير زيارات للمحامين في مرافق السجون، مساعدات اجتماعية، حضور المحكمة ومتابعة الظروف التي يحتجز فيها الاسيرات السياسيات، والتي تشمل توثيق كل التهديدات والتحرشات الجنسية في غرف الاعتقال والتحقيق. لا تقوم الجمعية في التوظيف وكل نشاطاتها تتم على أساس طوعي باستثناء دفع اتعاب المحامين.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'זכויות אדם'
      ]
    ],
    'id': 'SA16',
    'is_active': true,
    'keywords': [
      'אינתיפאדה',
      'אסירות',
      'זכויות',
      'כיבוש',
      'סיוע משפטי',
      'פלסטיניות',
      'שלום',
      'ערביות'
    ],
    'name': 'נשים למען אסירות פוליטיות',
    'name_ar': 'نساء لأجل الأسيرات السياسيات',
    'name_change_year': null,
    'name_common': 'נלא״פ',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'שירותים משפטיים',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-06'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.wofpp.org/hebrew/aboutus.html'
      },
      {
        'title': 'בנסקי, טובה (2006). ״קואליציית הנשים לשלום צודק״: פרויקט השלום הפמיניסטי כחלק מהמגמות לאזרוח החברה הישראלית. בתוך: כהן, אורי, בן רפאל, אליעזר, בראלי אבי ויער, אפרים (עורכים), <b>ישראל והמודרניות, למשה ליסק ביובל</b> (עמ\' 524–549). באר שבע: מכון בן-גוריון לחקר ישראל, הציונות ומורשת בן-גוריון.'
      },
      {
        'title': 'נשים למען אסירות פוליטיות (1989). עצירות פוליטיות בבית המעצר במגרש הרוסים. <b>נשים למען אסירות פוליטיות</b> (עמ\' 8–12). ירושלים. נדלה מתוך',
        'url': 'http://www.hamoked.org.il/files/2011/114990.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '20/06/2021'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1988,
    'year_registered': 1990
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '10/04/2019'
    },
    'description': 'עמותת ״נמא״ לקידום האשה בשפרעם (ע״ר 580626448) הוקמה בשנת 2016. מטרות העמותה הן: ״קידום ופיתוח יכולות הנשים החד הוריות, עקרות הבית והאישה בכלל, תוך הפעלת קורסים אומנותיים ע״י מאמנים מקצועיים עם הכשרה. פיתוח מיומנויות מקצועיות ותעסוקתיות בתחומים שונים. העצמת הנשים בחברה הערבית ופיתוחן הכללי, הפרטי והעשרת היכולות שלהן, הכל תוך הכנתן באופן מעשי להשתלבות חיונית בתעסוקה הנשית במגזר ולנסות למצוא להן מקומות עבודה ראויים ומציאת פרנסה מכובדת. הפעלת קורסים בתחומים שונים במסגרת החינוך (הפעלת קורסים ע״י מרצים מקצועיים בתחום לימוד סייעות בתחום הגננות, מזכירות) והפעלת פעוטונים ביתיים לאמהות חד הוריות ועקרות בית. הפעלת קורסים בתחום הבישול, איפור ובניית ציפורניים, ריקוד, צילומים, הכנת ממתקים. מתן סיוע, עזרה ותמיכה לנשים במצוקה.״ פעילות העמותה מצומצמת וכוללת בעיקר סדנאות וארועים תרבותיים לנערות ונערים, כולל סיורים בטבע.',
    'description_ar': 'جمعية ״نما״ لتعزيز النساء في شفاعمرو (ج.م 580626448) تأسست عام 2016 وهدفها: تعزيز وتطوير قدرات الأمهات المعيلات الوحيدات وربات البيوت والنساء بشكل عام، من خلال تنفيذ دورات مهنية من قبل مدربين محترفين وتنمية المهارات المهنية والتوظيفية في مختلف المجالات، تمكين المرأة في المجتمع العربي وتنمية قدراتها العامة والخاصة واثراء قدراتها، مع إعدادها عمليا للاندماج الحيوي في عمالة الإناث في القطاع ومحاولة إيجاد وظائف لائقة وإيجاد سبل عيش لائقة. تشغيل الدورات في مجالات التعليم المختلفة (الدورات التدريبية التي يقوم بها المحاضرون المحترفون في مجال المساعدة التعليمية في مجال البستنة والسكريتارية) تشغيل رياض أطفال للأمهات العازبات وربات البيوت، تشغيل دورات في مجالات الطبخ، المكياج وبناء الأظافر، الرقص، التصوير الفوتوغرافي، صنع الحلويات. مساعدة ودعم النساء المحتاجات ״. أنشطة الجمعية محدودة وتشمل بشكل أساسي ورش عمل وفعاليات ثقافية للفتيات والفتيان، بما في ذلك جولات الطبيعة.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'YA19',
    'is_active': true,
    'keywords': [
      'חינוך',
      'נערות',
      'פנאי'
    ],
    'name': 'נמא - לקידום האשה',
    'name_ar': 'جمعية نما',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'שפרעם',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-04-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.facebook.com/association.nma/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת ״נמא״ לקידום האישה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580626448'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '30/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '07/01/2018'
    },
    'description': 'עמותת ״נסיכת המדבר״ (ע״ר 580484947) נוסדה בשנת 2006 כדי לחזק את מעמדן של נשים בדואיות בנגב. העמותה, אשר היתה רשומה ברהט הוקמה על ידי יושבת ראש העמותה, מונא אלחבנין, תושבת המקום. העמותה ביקשה לטפל בסוגיות שונות הנוגעות למעמד האשה הבדואית ועבדה ביחד עם נשים, מנהיגים בקהילות, ועמותות שונות בנגב במטרה להעצים נשים ולהרחיב את שליטתן על חייהן. מטרות העמותה היו ״עזרה לנשים בדואיות במימוש זכויותיהן האישיות במשפחה ובחברה על ידי הדרכה, ייעוץ וסינגור. קידום מעמדה של האישה הבדואית כשותפה מלאה שוות זכויות וחובות בפעילות החברתית, כלכלית ותרבותית על ידי הדרכה, ייעוץ, סינגור, ובמאבק ציבורי במידת הצורך״. בשנת 2013 זכתה מייסדת העמותה בפרס רפפורט לעשייה נשית פורצת דרך ומחוללת שינוי בחברה הישראלית. העמותה חדלה להגיש דיווחים ובאפריל 2019 נמחקה באופן סופי מפנקס העמותות.',
    'description_ar': 'جمعية ״اميرة الصحراء״ (ج.م 580484947) تأسست عام 2006 لتعزيز مكانة المرأة البدوية في النقب والتي كانت مسجلة في رهط، من قبل رئيسة الجمعية، منى الحبنين، من سكان رهط. سعت الجمعية إلى معالجة مختلف القضايا المتعلقة بوضع المرأة البدوية وعملت مع النساء، والقادة في المجتمعات، ومختلف المنظمات غير الحكومية في النقب من أجل تمكين المرأة وتوسيع سيطرتها على حياتهن. كانت أهداف الجمعية هي ״مساعدة النساء البدويات في استحقاق حقوقهن الشخصية في الأسرة والمجتمع من خلال التدريب والاستشارات والدعوة. تعزيز مكانة المرأة البدوية كشريكة كاملة في الحقوق والالتزامات المتساوية في الأنشطة الاجتماعية والاقتصادية والثقافية من خلال التدريب والاستشارات والدعوة والنضال العام إذا لزم الأمر. ״ في عام 2013، حازت مؤسسة الجمعية على جائزة ربابورت عن النشاط النسوي النوعية والهادفة لإحداث تغير مجتمعي في المجتمع الإسرائيلي. في عام 2019 تم حذف الجمعية بشكل نهائي من سجل الجمعيات.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ]
    ],
    'id': 'YH38',
    'is_active': false,
    'keywords': [
      'בדואיות',
      'העצמה',
      'זכויות',
      'אלימות',
      'ערביות'
    ],
    'name': 'נסיכת המדבר',
    'name_ar': 'جمعية أميرة الصحراء',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רהט',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-10-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://ameratofthedeserthebrew.wordpress.com/'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 8190 (2019, 7 אפריל). <b>הודעה סופית בדבר מחיקה מפנקס העמותות</b>. נסיכת המדבר (עמותה מספר 580484947). עמ\' 9762. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_word/Law10/yalkut-8190.pdf'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2014, 5 נובמבר). <b>פרוטוקול מס\' 109: אלימות ורצח נשים ערביות – דרכי התמודדות</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/Activity/committees/Pages/AllCommitteeProtocols.aspx?Comid=27&fDate=04/12/2018&tDate=04/12/2018'
      },
      {
        'title': 'פרס רפפורט (ללא תאריך). <b>לעשייה נשית פורצת דרך ומחוללת שינוי בחברה הישראלית</b>. נדלה מתוך',
        'url': 'https://www.rappaport-prize.org.il/laureates#Womengeneratingchanges'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '09/12/2019'
    },
    'year_closed': 2017,
    'year_closed_text': '2017',
    'year_founded': 2006,
    'year_registered': 2007
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '03/07/2018'
    },
    'description': 'נעמ״ת- נשים עובדות ומתנדבות היא תנועה ששמה לה למטרה קידום מעמד האישה ושינוי המדיניות החברתית במדינה במישורים שונים לקראת שוויון בין המינים בעבודה, בכלכלה, במשפחה ובחברה. נעמת נוסדה בשנת 1921 תחת השם ״מועצת הפועלות״ על ידי חלוצות העלייה השנייה והשלישית, במטרה לאגד נשים שהיו חברות בהסתדרות. ב-1930 התארגנה בתוך מועצת הפועלות יחידה נפרדת בשם״ארגון אימהות עובדות״ וב- 1976 אוחדו כל הפונקציות למערכת אחת תחת השם ״נעמת״ (נשים עובדות ומתנדבות). בשנת 1984 נרשמה נעמת כעמותה (ע״ר 580044261) בתעודת הרישום המקורית, צוין כי מטרות הארגון הן: ״קידום מעמדן במשפחה בעבודה ובחברה של ציבור הנשים במדינת ישראל״. בראש נעמ״ת עומדת יו״ר התנועה, שנבחרת אחת ל-5 שנים. כל חברות ההסתדרות הן חברות בנעמת, והן מקיימות מידי 5 שנים בחירות לראשות התנועה ולמוסדותיה. נעמת פרושה בכל הארץ באמצעות 30 מרחבים. בראש כל מרחב עומדת יושבת ראש נבחרת. תנועת נעמ״ת מנהלת מעונות יום לילדים; מספקת שירותים חברתיים למשפחות ברוכות ילדים וחד-הוריות; ושירותים משפטיים לנשים. עוסקת בנושא של אלימות נגד נשים ובקידום חקיקה בנושא מעמד האשה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'אלימות',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YB119',
    'is_active': true,
    'keywords': [
      'אמהות',
      'מקלט',
      'הכשרה מקצועית',
      'חד הוריות',
      'חינוך',
      'חקיקה',
      'ייצוג הולם',
      'ילדות/ים',
      'מלגות',
      'מרכזים למניעה וטיפול באלימות במשפחה',
      'סיוע משפטי',
      'פוליטיקה'
    ],
    'name': 'נעמ״ת - תנועת נשים עובדות ומתנדבות',
    'name_ar': null,
    'name_change_year': 1976,
    'name_common': null,
    'name_past': 'מועצת הפועלות',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-03-07'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.naamat.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נעמת - תנועת נשים עובדות ומתנדבות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580044261'
      },
      {
        'title': 'נעמת | Women @ Work, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/womenatwork/'
      },
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל. עמ\' 133–135.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים עולות מחבר העמים',
      'נשים יוצאות אתיופיה',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': 1984
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '17/05/2018'
    },
    'description': '״נע״ם - עמותה למען נשים ערביות במרכז- ג\'מעייה לנסא ערביאת באל מרכז״ הינה עמותה (ע.ר. 580505840) שהוקמה ב-2009 על ידי קבוצה של נשים צעירות במטרה לחזק את מעמדה של האישה הפלסטינית בערי המרכז (רמלה, לוד, יפו). מטרות העמותה הן: ״להקנות הכשרה כללית ומקצועית לנשים ערביות מילדות עד זקנה בישראל. להיאבק באמצעות חינוך בתופעת האלימות נגד נשים ונערות במשפחה בחברה הערבית בישראל. להעניק סעד לנשים ונערות ערביות בישראל שנפגעו מאלימות במשפחה ו/או בחברה. הקמת מרכז סיוע לנערות ערביות.״ העמותה הפועלת בלוד מפתחת תכניות קהילתיות בתחומים שונים במטרה לעודד ולעזור לנשים ערביות לקחת חלק פעיל ותפקיד משפיע בסביבתן בתחומי החינוך, החברה, הכלכלה והפוליטיקה. העמותה נאבקת בתופעות של אפליה ודיכוי נגד נשים ערביות על רקע לאום ומין, ובראש ובראשונה בתופעות של אלימות ורצח נשים בתוך החברה ובתוך המשפחה. העמותה פועלת דרך חינוך, העלאת מודעות, קמפיינים ציבוריים והקמת מרכזים המספקים תמיכה וסיוע לנשים ונערות.',
    'description_ar': 'نعم- جمعية من اجل النساء العربيات بالمركز- جمعية للنساء عربيات بالمركز״ هي جمعية (ج.م. 580505840) التي أقيمت بسنة 2009 بواسطة مجموعة نساء شابات بهدف تقوية مكانة المرأة الفلسطينية في مدن المركز (رملة، اللد، يافا). اهداف الجمعية هن ״ اكتساب تدريب عام ومهني لنساء عربيات منذ الطفولة الى الكبر بالسن. محاربة ظاهرت العنف ضد النساء والفتيات في العائلة من خلال التعليم. تقديم المساعدة للنساء والفتيات العربيات في إسرائيل اللائي تأثرن من العنف الاسري. \nإنشاء مركز لمساعدة الفتيات العربيات. ״تعمل الجمعية في اللد لتطوير برامج مجتمعية في مختلف المجالات لتشجيع ومساعدة المرأة العربية لأخذ دور فعال والتأثير في بيئتها في التعليم، المجتمع، الاقتصاد والسياسة. تحارب الجمعية ظاهرة عنف وقتل النساء داخل المجتمع وداخل الأسرة، تعمل الجمعية من خلال التعليم، زيادة الوعي، الحملات العامة وإنشاء مراكز تقدم الدعم والمساعدة للنساء والفتيات.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YB49',
    'is_active': true,
    'keywords': [
      'אלימות',
      'ביטחון אישי',
      'משטרה',
      'נשק',
      'פלסטיניות',
      'פמיניזם',
      'צעירות במצבי סיכון',
      'רצח נשים',
      'מחאה'
    ],
    'name': 'נע״ם - עמותה למען נשים ערביות במרכז- ג\'מעייה לנסא ערביאת באל מרכז',
    'name_ar': 'جمعية نعم نساء عربيات في المركز',
    'name_change_year': null,
    'name_common': 'נע״ם - עמותה למען נשים ערביות במרכז',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'לוד',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-10-18'
    },
    'sources': [
      {
        'title': 'דף הפייסבוק של הארגון',
        'url': 'https://www.facebook.com/profile.php?id=100001165168385'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נע״ם – עמותה למען נשים ערביות במרכז – ג\'מעייה לנסא ערביאת באל מרכז (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580505840'
      },
      {
        'title': 'קרן דפנה (אתר). העמוד אינו זמין יותר.'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '30/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2009,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '30/07/2018'
    },
    'description': '״נציבות הנשים הבינלאומית״ (International Women\'s Commission) היתה גוף בינלאומי שהוקם ונוהל על ידי סוכנות הנשים של האו״ם (UNIFEM) בשנים 2005-2011. מטרת הארגון היתה להפגיש נציגות ישראליות, פלסטיניות ובינלאומיות לדיאלוג פוליטי מתמשך סביב סוגיות הליבה של הסכסוך ולנסות להציע להם פתרונות במטרה להגביר את שילובן של נשים במשא ומתן לסיום הסכסוך. הארגון הוקם כיוזמה ליישום החלטה 1325 של מועצת הביטחון ובין חברותיו נכללו מנהיגות פוליטיות בינלאומיות ממדינות שונות וארגונים בינלאומיים. שיתוף הפעולה המקורי שיצר את הארגון צמח מתוך פעילות קודמת של הג\'רוזלם לינק ונקשר לארגון הירושלמי ״בת-שלום״. הנציבות הפעילה שלושה סניפים שנוהלו באופן עצמאי על ידי רכזת מקומית- ישראלי, פלסטיני ובינלאומי ובכל אחד היו כ-20 חברות. הסניף הישראלי הופעל כפרוייקט עצמאי דרך עמותת ״אשה לאשה״ וקיים כנסים ציבוריים, הפעיל פרויקט שימועים ארצי ופרסם בשנת 2009 דו״ח שעסק בעמדות של נשים ישראליות בנושא שלום וביטחון. נציבות הנשים הבינלאומית התפרקה בשנת 2011 בעקבות סבבי האלימות השונים בעזה וחילוקי דעות פוליטיים.',
    'description_ar': null,
    'display_organization_kind': 'בינלאומי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ייצוג הולם'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'קידום נשים ושוויון מגדרי'
      ]
    ],
    'id': 'SA40',
    'is_active': false,
    'keywords': [
      'כיבוש',
      'החלטה 1325',
      'פלסטיניות',
      'ייצוג הולם'
    ],
    'name': 'נציבות הנשים הבינלאומית (International Women\'s Commission (IWC',
    'name_ar': 'مفوصيَة النساء العالمية',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'בינלאומי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'בינלאומי',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'סרגוסטי, ענת (2009). המהפכה הסודית: שילוב נשים בתהליך המדיני. בתוך: חג\'אג\', נורית, לימור, גליה וסרגוסטי, ענת (עורכות), <b>נשים אל מול השלום: קולות מישראל</b> (עמ\' 7–12). תל אביב: נציבות הנשים הבינלאומית.'
      },
      {
        'title': 'Aharoni, Sarai (2014). Internal variation in norm localization: Implementing Security Council Resolution 1325 in Israel. <b>Social Politics: International Studies in Gender, State & Society 21</b>(1), 1-25.'
      },
      {
        'title': 'Hajer Naili, (2011, September 21). Palestinian-Israeli women lose a voice for peace. <b>Women\'s eNews</b>. Retrieved from',
        'url': 'https://womensenews.org/2011/09/palestinian-israeli-women-lose-voice-peace/'
      },
      {
        'title': 'UNIFEM (2005). <b>International women\'s commission established by Palestinian, Israeli and international women for a just and sustainable peace</b>. Retrieved from',
        'url': 'https://reliefweb.int/report/israel/international-womens-commission-established-palestinian-israeli-and-international'
      },
      {
        'title': 'United Nation (2005) .<b> International women’s commission for a just and sustainable Palestinian-Israeli peace – charter of principles</b>. Retrieved from',
        'url': 'https://www.un.org/unispal/document/auto-insert-200863'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '30/10/2019'
    },
    'year_closed': 2011,
    'year_closed_text': '2011',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'שירותים משפטיים',
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '06/11/2018'
    },
    'description': 'נציבות שוויון הזדמנויות בעבודה הוקמה בשנת 2008 מכוח סעיף 18א לחוק שוויון הזדמנויות בעבודה, התשמ״ח-1988. הנציבות היא יחידה עצמאית במשרד העבודה, הרווחה והשירותים החברתיים בישראל. הקמת הנציבות מהווה יישום של המלצה מספר 3 של דוח הועדה למעמד האשה (1978) הידועה כוועדת נמיר. ההמלצה קבעה כי ״ (א) יש לתת תוקף משפטי מחייה לעקרון השוויון בין המינים במסגרת חוק שייקרא: ״חוק שוויון ההזדמנויות בעבודה לנשים ולגברים [...] ו-(ז) כי יש למנות מנגנון לאכיפת הוראות החוק שיפעל במסגרת המשרד המופקד על ביצוע חוקי העבודה״. בהתאם לכך, הנציבות פועלת להטמעת שוויון ומיגור האפליה בשוק העבודה ומספקת מענה לקשיים המתגלים בכל הנוגע לאכיפה של חוקי השוויון. בהתאם, הנציבות מטפלת באכיפה של חוקי העבודה ברמה האזרחית, פועלת להפנמת נורמות ראויות של שוויון הזדמנויות בעבודה ושואפת להוביל רפורמה מקיפה וכוללת בהטמעת שוויון הזדמנויות בשוק העבודה. לנציבות סמכויות אכיפה משפטיות והסברתיות. נציבת השוויון הראשונה הייתה עו״ד ציונה קניג-יאיר, לשעבר מנכ״לית שדולת הנשים, שכיהנה בתפקיד זה בשנים 2008–2016. מ-2016 מכהנת בתפקיד עו״ד מַרים כבהא. מלבד הנציבה הארצית יש שלוש נציבות נוספות: מחוז ת״א ומרכז, מחוז ירושלים ודרום ומחוז חיפה והצפון.\nתפקידי הנציבות כוללים פעולות הסברה והדרכה להעלאת המודעות הציבורית; טיפול בתלונות עובדים בגין אפליה בעבודה; יכולת להורות בצו למעסיק להעביר נתונים באשר לקיום חובה מחובותיו על פי חקיקת השוויון  בעבודה; הגשת תביעות משפטיות בבתי הדין לעבודה; הגשת בקשה לבית הדין לקבלת צו כללי המורה למעסיק לנקוט פעולות כלליות הנוגעות לעובדים שלו. בנוסף, הנציבות שותפה לפיתוח מדד הגיוון יחד עם הלשכה המרכזית לסטטיסטיקה ופרופ\' אלכסנדרה קלב מהחוג לסוציולוגיה ואנתרופולוגיה באוניברסיטת תל אביב. המדד הושק לראשונה בשנת 2016, הוא מתפרסם מדי שנה ומספק תמונת מצב על אי השוויון בייצוג במקומות העבודה ובשכר של נשים, ערבים, חרדים, יוצאי אתיופיה ובני/ות 45 ומעלה בענפי כלכלה מרכזיים במשק.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'YH19',
    'is_active': true,
    'keywords': [
      'אפליה בתעסוקה',
      'אפליה מגדרית בתעסוקה',
      'אפליית גיל בתעסוקה',
      'גיוון במקומות עבודה',
      'זכויות בעבודה',
      'משפט',
      'סיוע משפטי',
      'פערי שכר',
      'פיטורין',
      'שוויון הזדמנויות',
      'שוק העבודה'
    ],
    'name': 'נציבות שוויון הזדמנויות בעבודה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'שירותים משפטיים',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'זכויות ומדיניות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-11-06'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://employment.molsa.gov.il/Employment/Shivyon/Pages/default1.aspx'
      },
      {
        'title': 'נציבות שוויון הזדמנויות בעבודה (2016). <b>דוח שנתי 2015</b>. נדלה מתוך',
        'url': 'https://employment.molsa.gov.il/About/Units/EqualEmployment/Reports/ShivionReport2015.pdf'
      },
      {
        'title': 'נציבות שוויון הזדמנויות בעבודה והלשכה המרכזית לסטטיסטיקה (2017). <b>מדד הגיוון: ייצוג ושכר בשוק העבודה הפרטי ובאקדמיה</b>. נדלה מתוך',
        'url': 'https://employment.molsa.gov.il/publications/publications/doclib/variability_measure_dec2017.pdf'
      },
      {
        'title': 'נציבות שוויון הזדמנויות בעבודה. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%A0%D7%A6%D7%99%D7%91%D7%95%D7%AA_%D7%A9%D7%95%D7%95%D7%99%D7%95%D7%9F_%D7%94%D7%96%D7%93%D7%9E%D7%A0%D7%95%D7%99%D7%95%D7%AA_%D7%91%D7%A2%D7%91%D7%95%D7%93%D7%94'
      },
      {
        'title': 'שדולת הנשים בישראל (1987). <b>מעמד האשה בישראל: בדיקת המלצות הוועדה למעמד האשה 1978</b>. ירושלים: שדולת הנשים בישראל.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '20/01/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2008,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '05/07/2018'
    },
    'description': 'הפורום הוקם ב-2011 בתמיכת קרן גנדיר, במטרה לקדם את מצבן של צעירות (בנות 18-25) במצבי מצוקה בישראל. הפורום כולל ארגונים מרכזיים המפעילים ומפתחים שירותי רווחה לצעירות בישראל, בהם: עלם, אותות, החצר הנשית, איתך - َمعَ ك משפטניות למען צדק חברתי, אל הלב, תכנית המנטורינג תל-אביב, מרכז רותם לקידום וחקר צעירות – מכללת ספיר, ילדים בסיכוי, בת עמי, הקליניקה הסוציו-משפטית - המכללה למנהל, מהפך - تغيير, نعم - נע״ם - נשים ערביות במרכז, מרכז סיוע לנפגעות תקיפה מינית בתל-אביב, עמותת ידידים.\nדרכי הפעולה כוללות למידה והתכנסויות (לעיתים יחד עם הצעירות שמביעות את קולן) ,צוותי עבודה והיגוי העוסקים בכתיבה, המשגה, שיום (naming) וניתוח נהלים קיימים בזירה של עבודה סוציאלית ונותני שירותים בתחום הרווחה, וכן במרחב שבין עבודה סוציאלית, משפטים ומדיניות ציבורית.\nשני פרויקטים שמקדם הפורום: פרויקט תעסוקה שמטרתו לבנות מודל תעסוקה רגיש מגדרית שהפורום יוכל להטמיע אותו במסגרת תכניות התעסוקה עבור צעירות במצבי סיכון. ופרויקט שמטרתו להעלות למודעות וכן, לפעול למניעה ולצמצום חובות קיימים בקרב צעירות במצבי סיכון.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ]
    ],
    'id': 'YH48',
    'is_active': true,
    'keywords': [
      'הטמעת חשיבה מגדרית',
      'צעירות במצבי סיכון',
      'פורום',
      'תעסוקה'
    ],
    'name': 'נראות - פורום ארגוני צעירות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'צעירות במצבי סיכון',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-07'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.niroot.com/'
      },
      {
        'title': 'נראות פורום ארגוני צעירות, קבוצת פייסבוק.',
        'url': 'https://www.facebook.com/groups/457048554483581/'
      },
      {
        'title': 'דגן-בוזגלו, נוגה וחסון, יעל (2016). <b>שירותי רווחה לצעירות בישראל: בחינה של מודל ההפעלה והתקצוב</b>. מרכז אדוה, איתך – משפטניות למען צדק חברתי, נראות – פורום ארגוני צעירות. נדלה מתוך',
        'url': 'http://adva.org/wp-content/uploads/2016/09/welfare-young-women-1.pdf'
      },
      {
        'title': 'מירטנבאום, דנה וארם, מור ארם (2014). <b>צעירות הגרות בין הכסאות</b>. פורום ארגוני צעירות. נדלה מתוך',
        'url': 'http://www.itach.org.il/wp-content/uploads/young-living-chairs.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '07/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2011,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחאה',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '13/05/2018'
    },
    'description': '‏״נשות הכותל״ נוסד בשנת 1988 לאחר קונגרס בין-לאומי ראשון של פמיניסטיות יהודיות בירושלים. ‏ביום האחרון של הכנס, ביקשו כ-70 מנשות הקבוצה, בהובלת רבקה האוט לערוך ״תפילת הודיה לשלום המדינה״ בכותל המערבי, תפילה הכוללת קריאה בתורה. ‏כאשר נתקלו בהתנגדות מצד חרדיות וחרדים שהיו במקום וניסו לשבש את הקריאה בתורה, הבינו את חשיבות פעולתן והחליטו להנהיג מסורת של תפילות ראש ‏חודש בכותל. כעבור שמונה ימים, ראש חודש טבת התשמ״ט (9 בדצמבר 1988) הביאה עמה הקבוצה ספר תורה. משהחלו לקרוא בתורה בקול רם כשהן עטופות בטליתות החלה התנגדות אלימה מצד עזרת הגברים. אירוע זה הביא להתגבשות קבוצת \'נשות הכותל\' והתגבשות ארגון-אם אמריקאי בשם \'הוועד הבין-לאומי למען נשות הכותל\'. מטרת הארגון היא לאפשר תפילה חופשית לנשים בעזרת הנשים בכותל המערבי, תפילה בקול רם הכוללת התעטפות בטלית, הנחת תפילין וקריאה בספר התורה. ב-1998 נרשם הארגון כעמותה (ע״ר 580325207). כיום, בנוסף לתפילות החודשיות ‏בכותל, הארגון מעביר הרצאות ועוסק בהעלאת מודעות בציבור הישראלי והיהודי-אמריקאי לנושא, וכן ‏מעורב במגעים ותהליכים מדיניים כגון ניסיונות הפשרה למתווה הכותל.‏',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'פוליטיקה ומנהיגות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ייצוג הולם'
      ]
    ],
    'id': 'SW2',
    'is_active': true,
    'keywords': [
      'תפילה',
      'ייצוג',
      'אפליה מגדרית',
      'יהדות',
      'הלכה'
    ],
    'name': 'נשות הכותל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-05-13'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.womenofthewall.org.il/he'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נשות הכותל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580325207'
      },
      {
        'title': 'גולדהירש, אריאלה (2016). <b>נשות הכותל: חקר מקרה של תהליך שינוי</b>. עבודה במסגרת קורס, התכנית ללימודי נשים ומגדר באוניברסיטת תל-אביב. נדלה מתוך',
        'url': 'https://www.womenofthewall.org.il/wp-content/uploads/2016/04/%D7%A0%D7%99%D7%AA%D7%95%D7%97-%D7%9E%D7%97%D7%A7%D7%A8%D7%99-%D7%A0%D7%A9%D7%95%D7%AA-%D7%94%D7%9B%D7%95%D7%AA%D7%9C-%D7%90%D7%A8%D7%99%D7%90%D7%9C%D7%94-%D7%92%D7%95%D7%9C%D7%93%D7%94%D7%99%D7%A8%D7%A9.pdf'
      },
      {
        'title': 'רייטר, יצחק (2016). <b>פמיניזם בהיכל: נשות הכותל ומאבקן בסטטוס-קוו</b>. מכון ירושלים לחקר ישראל. נדלה מתוך',
        'url': 'https://jerusaleminstitute.org.il/wp-content/uploads/2019/05/PUB_women-of-the-wall.pdf'
      }
    ],
    'target_audiences': [
      'נשים דתיות',
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '01/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1988,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחאה',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '05/06/2018'
    },
    'description': '‏״נשות הכותל המקוריות״ התפצלו בשנת 2013 מארגון ״נשות הכותל״ עקב מחלוקת סביב מתווה ‏שרנסקי אשר אישר תפילה מעורבת באיזור קשת רובינזון. הקבוצה שהתפצלה קראה לעצמה ‏‏״נשות הכותל המקוריות״. חברות הקבוצה סרבו לקבל את פשרת המתווה וביקשו להמשיך את המאבק המקורי של ‏‏״נשות הכותל״ לקיים תפילת נשים בתוך עזרת הנשים ברחבה המרכזית ולא ברחבה צדדית ומעורבת מגדרית. ‏הפיצול הובל על ידי אחת מהמייסדות המקוריות של ״נשות הכותל״, בונה דבורה הברמן ז״ל ונשים נוספות, רובן עולות מארצות הברית. בשנת 2015 עתרה הקבוצה לבג״ץ באמצעות \'מרכז צדק לנשים\' בדרישה שרב הכותל יאפשר לנשים להתפלל עם ספרי התורה שנמצאים ברחבת הכותל ודרשו לבטל את נוהל ״הכנסת ספרי תורה לרחבת הכותל המערבי״. ‏רק בשנת 2017 נרשמה הקבוצה כעמותה תחת השם ״תהילה: תפילת נשים בכותל״ (ע״ר 580645877) שמטרתה: ״לנהל ולתמוך בפעילויות עבור נשים והציבור הכללי לקידום הכרה חוקית בזכותן של נשים יהודיות להתפלל בעזרת הנשים בכותל המערבי כקבוצות תפילה בקול רם כשהן מתעטפות בטליתות, מעוטרות בתפילין וקוראות מספר תורה בעת התפילה. לערוך תפילות לנשים בעזרת הנשים בכותל המערבי ולהכשיר נשים לערוך תפילות כאלה. לאסוף תרומות לפעילויות הנ\'\'ל.״',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'פוליטיקה ומנהיגות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ייצוג הולם'
      ]
    ],
    'id': 'SW14',
    'is_active': true,
    'keywords': [
      'תפילה',
      'ייצוג',
      'אפליה מגדרית',
      'יהדות',
      'הלכה'
    ],
    'name': 'תהילה: תפילת נשים בכותל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'נשות הכותל המקוריות (The Original Women of the Wall (OWOW',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-06-05'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.originalwow.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>תהילה: תפילת נשים בכותל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580645877'
      },
      {
        'title': 'גולדהירש, אריאלה (2016). <b>נשות הכותל: חקר מקרה של תהליך שינוי</b>. עבודה במסגרת קורס, התכנית ללימודי נשים ומגדר באוניברסיטת תל-אביב. נדלה מתוך',
        'url': 'https://www.womenofthewall.org.il/wp-content/uploads/2016/04/%D7%A0%D7%99%D7%AA%D7%95%D7%97-%D7%9E%D7%97%D7%A7%D7%A8%D7%99-%D7%A0%D7%A9%D7%95%D7%AA-%D7%94%D7%9B%D7%95%D7%AA%D7%9C-%D7%90%D7%A8%D7%99%D7%90%D7%9C%D7%94-%D7%92%D7%95%D7%9C%D7%93%D7%94%D7%99%D7%A8%D7%A9.pdf'
      },
      {
        'title': 'רייטר, יצחק (2016). <b>פמיניזם בהיכל: נשות הכותל ומאבקן בסטטוס-קוו</b>. מכון ירושלים לחקר ישראל. נדלה מתוך',
        'url': 'https://jerusaleminstitute.org.il/wp-content/uploads/2019/05/PUB_women-of-the-wall.pdf'
      }
    ],
    'target_audiences': [
      'נשים דתיות',
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '01/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': 2017
  },
  {
    'activity_kinds': [
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '01/07/2019'
    },
    'description': 'נשות הליכוד, על המידע באתר המפלגה, ״הינו אגף המאגד את פעילות הנשים במפלגה. במסגרת הפעילות מתקיימים כנסים וחוגי בית בנושאים מדיניים וחברתיים, מפגשים עם שרות ושרי הליכוד ועם חברות וחברי הכנסת. כמו כן מקיים האגף מגוון סיורים לירושלים, ליש״ע, לרמת הגולן, לגליל, לנגב ולעוטף עזה וליישובי המיעוטים: דרוזים, נוצרים״. האגף אינו מופיע ברשימת מוסדות המפלגה באתר. תאריך הייסוד של המנגנון נקבע לשנת 2005 משום שזה האזכור המוקדם ביותר שאותר במסגרת המחקר. בשנה זו תוקן תקנון המפלגה כדי להבטיח את שיטת הייצוג לנשים ברשימת מועמדי המפלגה לכנסת. בראש אגף נשות הליכוד בשנה זו עמדה מרים מסרי. נראה כי האגף פעל לסירוגין במשך עשור כי ב-2012 מעידה הכתבת טל שניידר על הליכוד כמפלגה ״בלי ארגוני נשים פנים ‏מפלגתיים״. ‏מאז 2013, שנת הייסוד של דף הפייסבוק של ״נשות הליכוד״, נראה כי לאגף יש פעילות רציפה ובראשו עמדה פעילת הליכוד מתל אביב חיה שמיר.',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'SW46',
    'is_active': true,
    'keywords': [
      'תאים מפלגתיים',
      'קידום נשים',
      'פנאי'
    ],
    'name': 'נשות הליכוד',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'מפלגות, שדולות ותאים מפלגתיים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'נשות הליכוד, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/likudwomen/'
      },
      {
        'title': 'נשות הליכוד, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/neshotlikud/'
      },
      {
        'title': 'בן דוד, ליאור (2005). <b>סקירה משווה בנושא: ייצוג הולם של נשים במפלגות פוליטיות: מוגש לועדה לקידום מעמד האשה</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/16b5b374-8e32-e811-80de-00155d0a0235/2_16b5b374-8e32-e811-80de-00155d0a0235_11_6979.pdf'
      },
      {
        'title': 'הליכוד (2017, 15 יוני). <b>נשות הליכוד</b>. נדלה מתוך',
        'url': 'https://www.likud.org.il/?view=article&id=2095:%D7%A0%D7%A9%D7%95%D7%AA-%D7%94%D7%9C%D7%99%D7%9B%D7%95%D7%93&catid=235'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '15/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '07/01/2019'
    },
    'description': '‏״נשי אגודת ישראל״ היא תנועת הנשים של התנועה והמפלגה החרדית האשכנזית ״אגודת ישראל״. ‏קיימות עדויות לפעילותה עוד טרום קום המדינה הכוללות ועידה של הארגון בשנת 1931, כרזה לאיסוף מזון ‏לפסח לגולי קפריסין בשנת 1947, ועוד. התנועה מקיימת פעילויות של גמילות חסדים וצדקה לנזקקים ‏בעיקר בחברה החרדית, ומפעילה 5 גני ילדים (אשדוד, בני ברק, פתח תקווה), 4 צהרוניים (פתח תקווה) ומעון יום אחד (בני ברק).‏ במשך השנים הפעילה התנועה מספר עמותות כמו למשל ״מרכז נשי אגודת ישראל ירושלים״ (ע״ר 580023216) שפעלה בין 1982-2019 ונועדה ״להיות ארגון גג לכל סניפי נשי אגודת ישראל; לייסד לנהל לפתח ולהחזיק את פעולות נשי אגודת ישראל בישראל ומחוצה לה״; או ״הסתדרות נשי אגודת ישראל ירושלים״ (ע״ר 580023190) שפעלה בין 1983-2019 ונועדה ״לארגן את הנשים הדתיות לשם פעולות חברתיות וסוציאלית חברתית וארגונית ברוח התורה והמסורה על בסיס העקרונות של הסתדרות ישראל״. העמותה המרכזית הנקשרת לפעילות העמותה בשנת 2018 נקראת ״מוסדות נשי אגודת ישראל תל אביב״ (ע״ר 580022242) אשר מטרותיה הן: ״ליזום, להקים, לפתח, לקדם ולהפעיל גני ילדים ומעונות יום, פעוטונים, צהרונים ומסדרות לשגחה, טיפול, הפעלה וחינוך ילדים ופעולות הקשורות, כרוכות בכך; פעילויות חינוכיות ו/או תורניות לגילאים שונים; ייזום, פיתוח, קיום וביצוע שיעורים, השתלמויות לימוד, עיון בנושאים תורניים ו/או חינוכיים; מפעלי הזנה לצורך פעילויות העמותה ולרבות הזנה במסגרות החינוכיות השונות; פיתוח, יזום, הקמה, בניה של תשתיות ובכלל זה כיתות, מבני לימוד, חינוך והעשרה; קידום, שיפור ותמיכה בכל הקשור לתכנון, הקמה והפעלה של שירותי חינוך, העשרה והכרוך בכך; לארגן פעילויות תרבותיות, סוציאליות ואחרות לנשים דתיות ברוח אגודת ישראל״.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ],
      [
        'דת ומעמד אישי',
        'תעסוקה ועבודה'
      ]
    ],
    'id': 'SW47',
    'is_active': true,
    'keywords': [
      'מעונות ומשפחתונים',
      'צהרונים',
      'גמ״ח'
    ],
    'name': 'מוסדות נשי אגודת ישראל - תל אביב',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'נשי אגודת ישראל',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעונות ומשפחתונים',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מוסדות נשי אגודת ישראל – תל אביב (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580022242'
      },
      {
        'title': '(1931, 29 אפריל). הועידה השלישית של ״בנות אגודת ישראל״. <b>הצפירה</b>.נדלה מתוך',
        'url': 'http://jpress.org.il/olive/apa/nli_heb/SharedView.Article.aspx?href=HZF/1931/04/29&id=Ar00401'
      },
      {
        'title': '4 צהרונים של ״מוסדות נשי אגודת ישראל״ בשנה״ל 2018–2019: 4 בפתח תקווה. נדלה מתוך אתר משרד העבודה, הרווחה והשירותים החברתיים (2019, 1 יולי).'
      },
      {
        'title': 'גני הילדים של ״גן נשי אגודת ישראל״ בשנה״ל 2018–2019: 2 באשדוד, 1 בבני ברק, 2 בפתח תקווה. נדלה מתוך אתר משרד החינוך (2019, 1 יולי).'
      },
      {
        'title': 'הסתדרות נשי ובנות אגודת ישראל (1947). <b>הודעה על ארגון אוסף דחוף של צרכי פסח עבור גולי קפריסין</b>. נדלה מתוך',
        'url': 'http://www.zionistarchives.org.il/Pages/ArchiveItem.aspx?oi=09001e15806ff7ba&ot=cza_poster'
      },
      {
        'title': 'מעון של ״נשי אגודת-ישראל״ בבני ברק בשנה״ל 2018–2019. נדלה מתוך אתר משרד העבודה, הרווחה והשירותים החברתיים (2019, 1 יולי).'
      },
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>מוסדות נשי אגודת ישראל – תל אביב</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '07/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': 1982
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '04/06/2019'
    },
    'description': '״נשי אישי״ הינו מרחב קהילתי לנשים בקרית שמונה אשר הוקם בשנת 2017 על ידי שירה ג\'רג\'י שייסדה עמותת ״נשי אישי גליל גולן״ (ע״ר 580656296) שמטרותיה: ״לקדם ולהעצים נשים, ליזום ולהפעיל פרויקטים בתחום הנשי, ליזום ולפעול בנושאים הקשורים בנשים מוחלשות.״ במקום מתקיימות פעילויות קהילתיות עבור נשים ונערות הכוללות מפגשים קבוצתיים, ארועים, קורסים מקצועיים, חנות בגדים קהילתית ותכנית מנטורינג לליווי נערות נפגעות תקיפה מינית באזור הגליל והגולן.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ]
    ],
    'id': 'SA138',
    'is_active': true,
    'keywords': [
      'נערות במצוקה',
      'אלימות מינית',
      'הכשרה מקצועית',
      'פריפריה'
    ],
    'name': 'נשי אישי גליל גולן',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'נשי אישי- המקום שלך להיות',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'קרית שמונה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נשי אישי גליל גולן (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580656296'
      },
      {
        'title': 'נשי אישי - המקום שלך להיות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/nashieshi/'
      },
      {
        'title': 'פרינאט, שירי (2018, 31 דצמבר). מרחב ״נשי אישי״ חוגג שנה. <b>מידע 8</b>. נדלה מתוך',
        'url': 'https://meida8.co.il/%D7%9E%D7%A8%D7%97%D7%91%D7%99-%D7%A0%D7%A9%D7%99-%D7%90%D7%99%D7%A9%D7%99-%D7%97%D7%95%D7%92%D7%92-%D7%A9%D7%A0%D7%94/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '06/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2017,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '21/08/2018'
    },
    'description': '״ארגון נשי חירות״ נוסד ב-1948 כאגף הנשי של תנועת חירות. כבר משהוקם אימץ את הדפוס שגובש בארגוני הנשים בשמאל: מתן שירותי סעד ורווחה בצד פעילות לגיוס פוליטי למען המפלגה בעת בחירות. עם הזמן התרחבו פעילויות הארגון וכללו הפעלת מעונות יום, פנימיות, מסגרות לילדים בעלי מוגבליות, שירותים לאמהות מרובות ילדים ולקשישים. בתחילת שנות ה-80 היו בארגון כ- 5,000 חברות. בתעודת הרישום של העמותה מופיעה הערה ״זאת לתעודה כי האגודה ארגון נשי חרות בישראל שנוסדה לפי חוק העותמאני על אגודות מיום 29 לחודש רג\'ב 1327 (1909) והודעה על יסודה נמסר במשרד הפנים בתיק מס\' 401/99 במחוז תל-אביב נרשמה כעמותה...״. מכך ניתן ללמוד שארגון נשי חירות הוא גלגול מאוחר של ״ברית נשים לאומיות״, ארגון הנשים שהיה מזוהה עם התנועה הרוויזיוניסטית שהוקם ב-1935 והשתנה לאחר ייסוד ״תנועת חרות״ ב-1948. בשנת 2007 שונו מטרות העמותה והתווסף אליהן גם ״ניהול מעונות יום לילדים״, זאת למרות שידוע שהארגון הפעיל מעונות יום כבר מאז שנת 1950. בשנת 2018, עיקר הפעילות של הארגון היא הפעלת רשת מעונות ארצית הכוללת כ-25 מעונות לגיל הרך.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'SW20',
    'is_active': true,
    'keywords': [
      'מעונות יום',
      'גיל רך'
    ],
    'name': 'ארגון נשי חירות ישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'נשי חרות',
    'name_past': null,
    'name_replaced_by': 'ברית נשים לאומיות',
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעונות ומשפחתונים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-08-21'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.herutwomen.com/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>ארגון נשי חרות בישראל: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580027258'
      },
      {
        'title': 'ארגון נשי חירות ישראל (2016, 21 מרץ). ברכת הנשיא ראובן ריבלין. נדלה מתוך',
        'url': 'http://www.herutwomen.com/president.html'
      },
      {
        'title': 'הרצוג, חנה (1994). <b>נשים ריאליות: נשים בפוליטיקה המקומית בישראל</b>. מחקרי מכון ירושלים לחקר ישראל (מס\' 51). ירושלים: מכון ירושלים לחקר ישראל.'
      },
      {
        'title': 'פוגל-ביז\'אוי, סילביה (1992). האמנם בדרך לשוויון? מאבקן של הנשים לזכות בחירה ביישוב היהודי בארץ-ישראל: 1917–1926. <b>מגמות ל״ד</b>(2), 262–284.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '12/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': 1983
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '07/01/2019'
    },
    'description': '‏״נשי צאנז בארץ הקודש״ נרשם כעמותה (ע״ר 580463008) בשנת 2006 על ידי הרבנית הלברשטם בנתניה, והתחיל לפעול ‏בשנת 2007 כארגון גמילות חסדים שעוזר, בין היתר, עם ארוחות ליולדות. כמו כן, הארגון מפעיל שני ‏מעונות יום ברשת \'פעמוני זה״ב\' עבור ילדים של הורים עובדים המשלבים ילדים עם צרכים מיוחדים ‏וקידום תרפיות וזהירות בדרכים.‏',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'דת ומעמד אישי',
        'תעסוקה ועבודה'
      ]
    ],
    'id': 'SW44',
    'is_active': true,
    'keywords': [
      'מעונות ומשפחתונים',
      'גמ״ח',
      'סיוע לאמהות'
    ],
    'name': 'נשי צאנז בארץ הקודש',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נתניה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעונות ומשפחתונים',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נשי צאנז בארץ הקודש (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580463008'
      },
      {
        'title': '(2018, 25 מאי). רשת מעונות \'פעמון זה״ב\' מגיעה לדרום נתניה. <b>השבת בנתניה 592</b>, 20. נדלה מתוך: ‏anyflip.com/kian/gxbk/basic+&cd=6&hl=en&ct=clnk&gl=il'
      },
      {
        'title': '2 מעונות יום של ״נשי צאנז בארץ הקודש״ בנתניה. נדלה מתוך אתר משרד העבודה, הרווחה והשירותים החברתיים (העמוד אינו זמין יותר).'
      },
      {
        'title': 'אדמקר, יקי (2014, 29 מאי). הצצה: נשות האדמו״רים נחשפות. <b>וואלה! יהדות</b>. נדלה מתוך: ‏',
        'url': 'https://judaism.walla.co.il/item/2750709'
      },
      {
        'title': 'ועדת הכספים (2011, 4 אוקטובר). <b>פרוטוקול הישיבה: אישור מוסדות ציבור לפי סעיף 46 לפקודת מס הכנסה וסעיף 61 לחוק מיסוי מקרקעין</b>. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_html/law103/ksafim2011-10-05.htm'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '07/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2006,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '01/05/2020'
    },
    'description': '״נשים בביטחון לאומי ישראל״ (ע״ר 580550077) נוסדה בשנת 2009 על ידי לאה לנדמן וג\'וליה חזקל כסניף הישראלי של הארגון הבינלאומי Women in International Security במטרה ״להגביר את השפעת הנשים בתחומים בינלאומיים ויחסים ביטחוניים. להעלות את מספר הנשים בגופים ממשלתיים ופרטיים העוסקים ביחסים בינלאומיים ויחסים בטחוניים. לבצע מחקר וללמד בנוגע לנשים בתחום יחסים בינלאומיים ויחסים ביטחוניים. לספק לנשים את הכלים שיאפשרו להם לעבוד בגופים ביטחוניים ולהתקדם לתפקידים בכירים באותם גופים״. הארגון פעל בהשראת החלטת מועצת הביטחון 1325 וקיים שיתוף פעולה עם המרכז הבינתחומי בהרצליה ואוניברסיטאות אחרות בשלושה פרויקטיים מרכזיים: תכנית מנטורינג לסטודנטיות ונשים צעירות; הרצאות ומפגשים בנושאים הנוגעים לנשים, ביטחון בינלאומי ודיפלומטיה; ריכוז מידע על משרות, מלגות, מחקר, כנסים וארועים עבור חברות הארגון.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'צבא, ביטחון ומדיניות חוץ',
        'קידום נשים ושוויון מגדרי'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ייצוג הולם'
      ],
      [
        'נערות וצעירות',
        'מנהיגות'
      ]
    ],
    'id': 'SA177',
    'is_active': true,
    'keywords': [
      'דיפלומטיה',
      'החלטה 1325',
      'מנהיגות',
      'ביטחון',
      'שיתוף פעולה בינלאומי'
    ],
    'name': 'נשים בביטחון בינלאומי ישראל Women in International Security (WIIS) Israel',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'צבא, ביטחון ומדיניות חוץ',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים ושוויון מגדרי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.wiisglobal.org//'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נשים בביטחון בינלאומי ישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580550077'
      },
      {
        'title': 'Women In International Security Israel, עמוד פייסבוק (לא פעיל מ-2018).',
        'url': 'https://www.facebook.com/wiisisrael/posts/522461697788439/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/05/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2009,
    'year_registered': 2012
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '21/07/2018'
    },
    'description': 'עמותת ״נשים בדואיות למען עצמן״ (ע״ר 580470581) הוקמה ביישוב שגב שלום בשנת 2008, וכוללת נשים צעירות ומבוגרות, המאמינות ששינוי החברה יכול להתחיל משינוי מעמד הנשים ופעולה למען עצמן ולמען החברה שבה הן חיות. חזון העמותה הוא: ״אנו מאמינות שהאישה הערבייה בנגב יכולה לשים את עצמה במרכז החיים ולבטא את היכולות האישיות שלה מבלי להיות תלויה תמיד בתמיכתם של גורמים חיצוניים.האישה הערבייה בנגב תטביע חותמת אישית על החברה בה היא חייה, תשמיע קולה ותהיה משמעותית ובעלת יכולת השפעה. מטרות העמותה הן: ״מעורבות נשים בקהילה וחיזוק הקול הנשי בקרב החברה הבדואית. הכשרת מנהיגות מובילות מתוך הקהילה של הנשים הבדואית. קידום יוזמות לפיתוח מקומות תעסוקה לנשים. טיפוח אוכלוסיית הגיל הרך תוך כדי מעורבות האמהות. שימור המורשת והאמנות הבדואיות תוך דגש על חיבור בין הדורות״. העמותה מפעילה מועדונית לילדים ביישוב שגב שלום ומקיימת פעילות לקידום השכלת נשים ולחיזוק המורשת ב״בית מורשת ותרבות הסבתות הבדואיות״.',
    'description_ar': 'جمعية نساء بدويات من أجل نفسهن (ج. م580470581) تأسست عام 2008 ومركزها في قرية شقيب السلام- النقب. والتي تشمل نساء من أجيال مختلفة يؤمنون بتحسين من مكانة المرأة كألية لتحسين من الوضع الاجتماعي عموما بحيث إعطاء للنساء العمل من اجل نفسهن ومن اجل المجتمع الذي ينتمون اليه. رؤية الجمعية هي: ״نؤمن بان المرأة العربية في النقب قادرة على وضع نفسها في مركز الاحداث وبشكل مستقل دون الحاجة لداعم خارجي. النساء العربيات في النقب قادرات على ترك اثر على المجتمع ككل وعلى اسماع صوتها والتأثير. اهداف الجمعية هم: ״تجانس النساء في المجتمع وتعزيز الصوت النسائي في المجتمع البدوي في النقب. تمكين قياديات من داخل المجتمع، تمكين مبادرات لتطوير من مكانة التشغيل لدى النساء. العناية في الأطفال الرضع من خلال دمج الأمهات. الحفاظ على التراث البدوي بالتشديد على التواصل بين الأجيال. تقوم الجمعية بتشغيل نويديات للأطفال في شقيب السلام وبنشاطات لتطوير التعلم لدى النساء وتعزيز التراث البدوي في ״بيت الثقافة البدوية״',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'חינוך',
        'הגיל הרך'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'תרבות וספורט',
        'מלאכות מסורתיות'
      ]
    ],
    'id': 'YH61',
    'is_active': true,
    'keywords': [
      'בדואיות',
      'מעונות ופעוטונים',
      'אמהות',
      'השכלת נשים'
    ],
    'name': 'נשים בדואיות למען עצמן',
    'name_ar': 'نساء بدويات من اجل نفسهن',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'שגב-שלום',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'חינוך',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הגיל הרך',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-07-21'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://bwft.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נשים בדואיות למען עצמן (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580470581'
      },
      {
        'title': 'מענד״ בית מורשת ותרבות הסבתות הבדואיות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/%D7%9E%D7%A2%D7%A0%D7%93-%D7%91%D7%99%D7%AA-%D7%9E%D7%95%D7%A8%D7%A9%D7%AA-%D7%95%D7%AA%D7%A8%D7%91%D7%95%D7%AA-%D7%94%D7%A1%D7%91%D7%AA%D7%95%D7%AA-%D7%94%D7%91%D7%93%D7%95%D7%90%D7%99%D7%95%D7%AA-130344730822886/?ref=page_internal'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '29/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2007,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/10/2018'
    },
    'description': 'פעילות הקבוצה החלה בעקבות כנס בינלאומי בהולנד בשנת 1997 בהשתתפות נשים ישראליות ופלסטיניות יחד עם נשים מאירופה ומדרום אפריקה. מטרת העמותה (ע״ר 580333136) שנרשמה בשנת 1998 היתה לפעול כקבוצה רב-תרבותית לשם ״הגברת המעורבות של נשים והשפעתן על התהליך המדיני באמצעות יצירת רשת ארצית של נשים הפועלות לבנייה ולביסוס של שלום, ביטחון וצדק חברתי.״ בין המייסדות היו נשים בולטות בשדה השלום והפמיניזם המזרחי בישראל: מולי מלקאר, נבילה אספניולי, אליס שלוי, נעמי חזן, שרון אלין שנהב, ויקי שירן ועדנה זרצקי. הארגון התמקד בפעילות קהילתית שכללה מפגשים ושיתופי פעולה קהילתיים בין נשים מזרחיות, פלסטיניות ואחרות. בפרסומים תיארה הקבוצה את עצמה כך: ״נשים בונות תרבות שלום״ היא תנועת נשים יהודית-ערבית, על-מפלגתית, הפועלת ליצירת תרבות שלום וצדק חברתי בישראל. בתנועה משתתפות נשים מזרחיות, פלסטיניות ואשכנזיות מכל רחבי הארץ. במקביל פועלת בפלסטין (עזה והגדה המערבית) תנועת נשים פלסטיניות בעלת מטרות דומות. [...] בשנים האחרונות החל להישמע ביתר עוז קולן של הנשים, גם בישראל וגם בפלסטין, נגד מלחמות, כיבוש וכל צורת דיכוי שהיא, והגיעה השנה שקולנו יישמע במוקדי קבלת החלטות עם סדר היום הפוליטי החברתי שאנו מביאות איתנו״. הקבוצה חדלה לפעול לאחר פרוץ האינתיפאדה השנייה. בשנת 2018, נמחקה העמותה מפנקס העמותות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ייצוג הולם'
      ]
    ],
    'id': 'SA68',
    'is_active': false,
    'keywords': [
      'פלסטיניות',
      'פמיניזם מזרחי',
      'צדק חברתי',
      'שיתוף פעולה בינלאומי'
    ],
    'name': 'נשים בונות תרבות שלום',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>נשים בונות תרבות שלום</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'ספרן, חנה וזק״ש, דליה (2018). ״לא יכולנו לעשות אחרת, היינו מחויבות למאבק בכיבוש ולפמיניזם״: תנועות מחאה ושלום של נשים בישראל. <b>פוליטיקה: כתב עת ישראלי למדע המדינה וליחסים בינלאומיים, 28</b>, 150–177. נדלה מתוך',
        'url': 'https://davis.huji.ac.il/sites/default/files/davisinst/files/Safran_Sachs.pdf'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 8008 (2018, 26 נובמבר). <b>הודעה סופית בדבר מחיקה מפנקס העמותות</b>. נשים בונות תרבות שלום (מספר עמותה 580333136). עמ\' 3422. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_word/Law10/yalkut-8008.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים מזרחיות',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/10/2018'
    },
    'year_closed': 2000,
    'year_closed_text': '2000',
    'year_founded': 1997,
    'year_registered': 1998
  },
  {
    'activity_kinds': [
      'מחאה',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '25/09/2018'
    },
    'description': 'נשים למען עתיד ישראל״ (ע״ר 580231207) הוקמה בשנת 1993 תחת השם ״נשים בירוק״ על ידי רות ומיכאל מטר כמחאה נגד ‏חתימת הסכם אוסלו בספטמבר של אותה השנה. מטרות העמותה הן: ״פעילות למען הקניית ערכי דת תרבות וחינוך בקהילה״ ועיקר פעילויותיה מובלות ומבוצעות על ידי נשים ‏דתיות-ציוניות. בשנות התשעים, כללה פעילות התנועה מחאות ציבוריות נגד תהליך השלום והקמת מאחזים. מאוחר יותר הפכה התנועה למובילה ״את שיח חזון הריבונות הישראלית המלאה על יהודה ושומרון״ ולצורך כך היא מתמקדת בארגון בכנסים, הרצאות ומאמצי הסברה ‏באמצעות כתב העת ״ריבונות״ וכן בארגון מתנדבים לפעולות פוליטיות ולצורך הקמת והפעלת שמורת הטבע ״עוז וגאו״ן״ לזכר גיל-‏עד, אייל ונפתלי בגוש עציון.‏',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'צבא, ביטחון ומדיניות חוץ',
        'ביטחון לאומי'
      ],
      [
        'פוליטיקה ומנהיגות',
        'כללי'
      ],
      [
        'דת ומעמד אישי',
        'פוליטיקה ומנהיגות'
      ]
    ],
    'id': 'SW22',
    'is_active': true,
    'keywords': [
      'ייצוג',
      'מנהיגות',
      'צבא וחברה'
    ],
    'name': 'נשים בירוק - למען עתיד ישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'נשים בירוק',
    'name_past': 'נשים למען עתיד ישראל',
    'name_replaced_by': null,
    'official_address': 'אפרת',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'יהודה ושומרון',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'צבא, ביטחון ומדיניות חוץ',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ביטחון לאומי',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-09-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://womeningreen.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נשים למען עתיד ישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580231207'
      },
      {
        'title': '(2018, 15 אוקטובר). נשים בירוק חגגו 25 שנים לארגון. <b>הקול היהודי: עיתונות יהודית עצמאית</b>. נדלה מתוך',
        'url': 'https://www.hakolhayehudi.co.il/item/Land_Israel/%D7%A0%D7%A9%D7%99%D7%9D_%D7%91%D7%99%D7%A8%D7%95%D7%A7_%D7%97%D7%92%D7%92%D7%95_25_%D7%A9%D7%A0%D7%99%D7%9D_%D7%9C%D7%90%D7%A8%D7%92%D7%95%D7%9F'
      },
      {
        'title': 'Jacoby, Tami Amanda (2005). <b>Women in zones of conflict: Power and resistance in Israel</b>. Montreal : McGill-Queen\'s University Press.'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '09/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1993,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחאה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '22/05/2018'
    },
    'description': '״נשים בשחור״ היא תנועת שלום בינלאומית שמקורה בישראל הפועלת נגד מיליטריזם, מלחמה ודיכוי פוליטי באמצעות משמרות שבועיות, בלתי אלימות שבהן משתתפות נשים לבושות שחור. הקבוצה הראשונה הוקמה בירושלים בשנת 1988 בעקבות פריצת האינתיפאדה הראשונה וכמחאה על הדיכוי האלים של ההפגנות בשטחי יהודה ושומרון על ידי מדינת ישראל. בין השנים 1988- 1994 קיימו ״נשים בשחור״ משמרת מחאה קבועה מדי יום שישי בין השעות אחת לשתיים בצהריים בכיכר פריז בירושלים כשהן לבושות בשחור ונושאות שלטים בצורת יד שעליהם הכיתוב ״די לכיבוש״. המשמרות השבועיות התפשטו לערים נוספות התקיימו באופן סדיר בתל אביב, בחיפה ובצומת מגידו. לקראת סוף האינתיפאדה הראשונה פעלו כשלושים משמרות מחאה קבועות של נשים בשחור במקומות שונים בארץ. עם חתימת הסכם אוסלו בשנת 1993 פסקה פעילות המשמרות עד שהתחדשה שוב לאחר פרוץ האינתיפאדה השנייה, באוקטובר 2000. ״נשים בשחור״ מעולם לא נרשמה כעמותה ואין לה הנהגה אחידה או מצע רשמי מעבר לסיסמא ״די לכיבוש״. באוקטובר 1991, תוך כדי המלחמה ביוגוסלביה לשעבר, התארגנה הפגנה של ״נשים בשחור״ בבלגרד שאימצה את צורת הפעולה של הנשים הישראליות ובכך הפכה צורת המחאה בשחור לסמל בינלאומי של התנגדות נשית למיליטריזם. תנועת נשים בשחור בישראל זכתה בפרס אאכן לשלום (1991), בפרס השלום של העיר סאן-ג\'ובאהי ד\'אסו באיטליה (1994) ובפרס Peacemaker מטעם אגודת השלום היהודית (2001). בשנת 2001 הוענק לתנועת-נשים בשחור העולמית פרס המיליניום לשלום על ידי קרן הפיתוח לנשים של ארגון האומות המאוחדות (UNIFEM).',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'זכויות אדם'
      ]
    ],
    'id': 'SA10',
    'is_active': true,
    'keywords': [
      'אינתיפאדה',
      'כיבוש',
      'מיליטריזם',
      'מחאה',
      'לסביות',
      'פלסטיניות'
    ],
    'name': 'נשים בשחור',
    'name_ar': 'نساء بالسواد',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'התארגנות שאינה עמותה',
      'בינלאומי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://womeninblack.org/'
      },
      {
        'title': 'אקטיבסטילס (2014, 8 מרץ). נשים בשחור: 26 שנות התנגדות לכיבוש, שיחה מקומית. <b>שיחה מקומית</b>. נדלה מתוך',
        'url': 'https://mekomit.co.il/%D7%A4%D7%A8%D7%95%D7%99%D7%99%D7%A7%D7%98-%D7%A6%D7%99%D7%9C%D7%95%D7%9E%D7%99%D7%9D-26-%D7%A9%D7%A0%D7%99%D7%9D-%D7%9C%D7%A0%D7%A9%D7%99%D7%9D-%D7%91%D7%A9%D7%97%D7%95%D7%A8/'
      },
      {
        'title': 'בנסקי, טובה (2006). ״קואליציית הנשים לשלום צודק״: פרויקט השלום הפמיניסטי כחלק מהמגמות לאזרוח החברה הישראלית. בתוך: בן רפאל, אליעזר, בראלי, אבי, יער, אפרים וכהן, אורי (עורכים), <b>ישראל והמודרניות, למשה ליסק ביובל</b> (עמ\' 524–549). באר שבע: מכון בן גוריון לחקר ישראל, הציונות ומורשת בן גוריון.'
      },
      {
        'title': 'הלמן, שרה ורפופורט, תמר (1997). ״אלה נשים אשכנזיות, לבד, זונות של ערבים, לא מאמינות באלוהים, ולא אוהבות את ארץ-ישראל״: ״נשים בשחור״ ואתגור הסדר החברתי״. <b>תיאוריה וביקורת</b> (10), 175–192. נדלה מתוך',
        'url': 'https://theory-and-criticism.vanleer.org.il/product/%D7%90%D7%9C%D7%94-%D7%A0%D7%A9%D7%99%D7%9D-%D7%90%D7%A9%D7%9B%D7%A0%D7%96%D7%99%D7%95%D7%AA-%D7%9C%D7%91%D7%93-%D7%96%D7%95%D7%A0%D7%95%D7%AA-%D7%A9%D7%9C-%D7%A2%D7%A8%D7%91%D7%99%D7%9D-%D7%9C/'
      },
      {
        'title': 'Svirsky, Gila. (2004). Feminist Peace Activism during the al-Aqsa Intifada. In Abdo, Nahla & Lentin, Ronit (Eds.), <b>Women and the politics of military confrontation: Palestinian and Israeli gendered narratives of dislocation</b> (pp. 234-248). New York; Oxford: Berghahn Books.'
      },
      {
        'title': 'Women in Black Belgrade (website).',
        'url': 'http://zeneucrnom.org/index.php?option=com_content&task=view&id=235&Itemid=4&lang=en'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '15/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1988,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/03/2020'
    },
    'description': '״נשים בתיאטרון״ הוקמה בשנת 2008 על ידי תמר קרטמן וייס ופנינה פדרמן שכטר ונרשמה כעמותה (ע״ר 580579589) בשנת 2013. המטרות הרשמיות של העמותה: ״תמיכה וליווי של פרויקטים תרבותיים בארץ, לרבות הצגות תיאטרון, מחזמר ותמיכה באירועי תרבות אחרים. הקמת קבוצת תיאטרון אשר מטרתה העיקרית היא העצמת הנשים בחברה באמצעות מתן הזדמנויות לנשים כדי לטפח את הביטוי היצירתי שלהן. נשים בקדמת הבמה היא קבוצה בין-דורית שמעריכה את המבט של הנשים ברמות האישיות, החברתיות והתרבותיות. הקבוצה תפעל באווירה מקצועית בכדי להביא מודעות שנשים מוכשרות ראויות למקום מרכזי בבמה העולמית. לימוד חינוכי דרך תיאטרון, הקניית ערכים, בטחון עצמי, שפה לעולים חדשים באמצעות התיאטרון״. העמותה מפעילה סדנאות תיאטרון ומוסיקה לנשים ומפיקה הצגות אשר השחקניות בהן נשים עולות חדשות דוברות אנגלית בטווח רחב של גילאים ולקהל נשי. העמותה נתמכת בעיקר על ידי תרומות אך בין השנים 2016-2018 קיבלה תמיכה ממשרד העליה והקליטה תחת הסעיף: ״תמיכה בעמותות העוסקות בקליטה חברתית״.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'תיאטרון'
      ],
      [
        'הגירה',
        'קליטת עלייה'
      ]
    ],
    'id': 'YH202',
    'is_active': true,
    'keywords': [
      'העצמה',
      'עולות',
      'יוצרות'
    ],
    'name': 'נשים בתיאטרון (נ.ב) Women In Theater',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'מודיעין-מכבים-רעות',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'תיאטרון',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2020-03-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.womenintheater.com/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נשים בתיאטרון (נ.ב) (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580579589'
      },
      {
        'title': 'WIT (Women In Theater) Modiin, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/WITmodiin/'
      },
      {
        'title': 'מודיעינט (2019, 31 מרץ). עולות על הבמה. <b>מודיעינט</b>. נדלה מתוך',
        'url': 'https://modiinet.co.il/articles/community/%D7%A2%D7%95%D7%9C%D7%95%D7%AA-%D7%A2%D7%9C-%D7%94%D7%91%D7%9E%D7%94/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '01/03/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2008,
    'year_registered': 2013
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'פילנתרופיה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/07/2018'
    },
    'description': 'עמותת ״נשים בתמונה״ (ע״ר 580423473) הוקמה על ידי ענת שפרלינג-כהן ונעמה פריזנט-אורפז בשנת 2004 במטרה ״לייסד את הפסטיבל הראשון בישראל לנשים יוצרות (בימאיות ומפיקות) בקולנוע ובטלוויזיה. ליצור פסטיבל בינלאומי אשר יפגיש בין היוצרות הישראליות ליוצרות מחו״ל ויאפשר שיתוף פעולה פורה בין המדינות בתחום הקולנוע והטלוויזיה. לעודד ולקדם נשים יוצרות״. פעילותה המרכזית של העמותה היתה הפקת פסטיבל הקולנוע הבינלאומי לסרטי נשים ברחובות שהתקיים מדי שנה בין 2004-2013 בשיתוף עיריית רחובות. לאחר שעיריית רחובות חדלה לתמוך בפסטיבל, השתנתה פעילות העמותה ומאז 2015 מובילה העמותה בשיתוף מועצת הפיס לתרבות ולאמנות, קרן רבינוביץ\' לאמנויות, קרן גשר לקולנוע רב תרבותי ואיגוד התסריטאים פרויקט ״מענק פיתוח ליוצרות בתחום הקולנוע״ במטרה לקדם נשים יוצרות בתעשיית הקולנוע הישראלית. את העמותה המתחדשת מנהלות עטרה פריש וליאור אלפנט.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'קולנוע'
      ]
    ],
    'id': 'SA34',
    'is_active': true,
    'keywords': [
      'אמניות',
      'יוצרות'
    ],
    'name': 'נשים בתמונה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'משגב דב',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קולנוע',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נשים בתמונה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580423473'
      },
      {
        'title': 'אנדרמן, נירית (2015, 7 יוני). חמישה מענקים חדשים יינתנו ליוצרות קולנוע. <b>הארץ</b>. נדלה מתוך',
        'url': 'https://www.haaretz.co.il/gallery/cinema/1.2654176'
      },
      {
        'title': 'מערכת און לייף (2015, 11 מרץ). קולנוע של נשים בישראל: תמונת מצב. <b>Onlife</b>. נדלה מתוך: **',
        'url': 'http://www.onlife.co.il/%D7%A4%D7%A0%D7%90%D7%99/%D7%AA %D7%A8%D7%91%D7%95%D7%AA/91222/%D7%A7%D7%95%D7 %9C%D7%A0%D7%95%D7%A2-%D7%A9%D7%9C- %D7%A0%D7%A9%D7%99%D7%9D- %D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C- %D7%AA%D7%9E%D7%95%D7%A0%D7%AA- %D7%9E%D7%A6%D7%91'
      },
      {
        'title': 'פסטיבל סרטי הנשים ברחובות (אתר). (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/07/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחאה',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '05/06/2018'
    },
    'description': 'תנועת ״נשים דתיות למען קדושת החיים״ קמה בשנת 1996 בעקבות מהומות מנהרות הכותל והייתה ‏פעילה בשנת 1997 סביב קידום יציאת צה״ל מלבנון. בשנת 1998 התנועה נרשמה כעמותה. בשנים הללו תנועה קיימה כנסים בציבור הדתי והשתתפה בצעדות והפגנות יחד עם ארגונים נוספים של נשים לשלום כגון ״בת שלום״, ״אמהות ונשים למען שלום״ ו-״פורום נשים חיפה״ (כנראה לימים ״קואליציית נשים חיפה״). ממקימות ‏ומובילות התנועה נמנית צביה גרינפילד, אשה חרדית שלימים הייתה חברת ועד המנהל של ״בצלם״, ‏מהחותמים על יוזמת ז\'נבה, וחברת כנסת מטעם מרצ במשך כשלושה חודשים בסוף הכנסת ה-17 ‏בעקבות התפטרותו של יוסי ביילין. בשנת 2000 התנועה הייתה מהארגונים המקימים של ״קואליציית ‏נשים לשלום״, ולא נמצא תיעוד לפעילותה לאחר מכן.‏ בשנת 2019 נרשמה מחיקתה הסופית מפנקס העמותות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'דת ומעמד אישי',
        'פוליטיקה ומנהיגות'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'זכויות אדם'
      ]
    ],
    'id': 'SW13',
    'is_active': false,
    'keywords': [
      'שלום',
      'מנהיגות',
      'כיבוש'
    ],
    'name': 'נשים דתיות למען קדושת החיים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נשים דתיות למען קדושת החיים (ע״ר): עמותה מחוקה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580318582'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 8190 (2019, 7 אפריל). <b>הודעה סופית בדבר מחיקה מפנקס העמותות</b>. נשים דתיות למען קדושת החיים (מספר עמותה 580318582). עמ\' 9640. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_word/Law10/yalkut-8190.pdf'
      },
      {
        'title': 'Geneva Initiative (n.d). <b>Tzvia Greenfield</b> (The page is no longer available).'
      },
      {
        'title': 'Oz VeShalom (1999). Parashat Noach 5759. <b>Shabat Shalom, 53</b>. Retrieved from',
        'url': 'http://ozveshalom.org.il/blog/shabath_en/noach-5759-gilayon-53/'
      },
      {
        'title': 'The Israel Council for Israeli-Palestinian Peace (1997). <b>The other Israel, 81</b>. Retrieved from',
        'url': 'http://israelipalestinianpeace.org/issues/81toi.htm'
      },
      {
        'title': 'Women Coalition for Peace (2000). <b>Grant proposal to the European commission</b>. Retrieved from: ‏',
        'url': 'https://library.osu.edu/projects/fourmothers/Documents/731.pdf'
      }
    ],
    'target_audiences': [
      'נשים חרדיות',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '21/02/2019'
    },
    'year_closed': 2000,
    'year_closed_text': '2000',
    'year_founded': 1996,
    'year_registered': 1998
  },
  {
    'activity_kinds': [
      'מחאה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '15/10/2018'
    },
    'description': '״קבוצת אמהות ונשים למען שלום״ (ע״ר 580308567) היתה תנועה מקומית שפעלה בירושלים ובתל אביב לזמן קצר. התנועה החלה את פעילותה לאחר בחירתו של בנימין נתניהו לכהונתו הראשונה בשנת 1996 וארועי מנהרת הכותל. מטרות העמותה היו ״לפעול בכל דרך לגיטימית לקידום השלום במדינת ישראל. להגביר מודעות בחברה לחיזוק ערך חיי אדם. לפתח תקשורת בין מנהיגים נבחרים לבין אימהות, במטרה למנוע מהלכים אשר יסכנו חיי אדם.״ התנועה יצאה להפגין בצמתים ובכיכרות, לעתים בלבוש לבן, ביחד עם ״ארבע אמהות״ ו״נשים למען קדושת החיים״. אחת הסיסמאות של הקבוצה היתה ״אין לנו ילדים למלחמות מיותרות״. פעילות הקבוצה כללה גם קבוצות לימוד לנשים בנושאים הנוגעים ל״נשים, צבא וצבאיות בישראל״. רלה מזלי שהיתה חברה בקבוצה מספרת כי ״תהליך הלימוד התנהל במרחב נשי, בלי גברים, על כל שמשתמע מזה, וכל אחת מאיתנו התקבלה כמקור ידע שנובע במדיה רבה מהתנסות אישית [...] לאחר כמעט שנתיים של מפגשים כאלה, כמה נשים אמרו ,זהו. עכשיו צריך להתעסק, ישירות עם נושאים כמו גיוס, סירוב והימנעות מגיוס בישראל״. לאחר תקופת פעילות קצרה, חדל הארגון מלהתקיים באופן עצמאי ובשנת 2006 העמותה החליטה על פירוק מרצון. חלק מחברות הארגון היו מהמייסדות של ארגון פרופיל חדש (אוקטובר 1997) וקואליציית נשים לשלום (2000).',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'שלום'
      ]
    ],
    'id': 'SA66',
    'is_active': false,
    'keywords': [
      'אמהות',
      'דו קיום',
      'כיבוש'
    ],
    'name': 'קבוצת אמהות ונשים למען שלום',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'נשים ואמהות למען שלום',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'חסון, יעל (2005). <b>״מי שנכנס לפעילות הזאת משתנה כל הזמן״: אקטיביזם וזהות בקרב פעילי תנועות שמאל</b> (עבודת גמר לקבלת תואר ״מוסמך למדעי החברה״). אוניברסיטת בר-אילן, רמת גן.'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 6374 (2012, 9 פברואר). <b>הודעה על פירוק עמותה ומינוי מפרקת</b>. עמותת נשים ואמהות למען השלום (עמותה מספר 580308567). עמ\' 2507. נדלה מתוך',
        'url': 'https://www.nevo.co.il/Law_word/law10/yalkut-6374.pdf'
      },
      {
        'title': 'מזלי, רלה, (2003), סיפור אישי, בתוך: ישכר, חדוה (עורכת), <b>אחיות לשלום: קולות בשמאל הפמיניסטי</b> (עמ\' 21־26). תל אביב: רסלינג.'
      },
      {
        'title': 'שמר, עדית (2003). <b>אז מה את באמת רוצה?</b> ירושלים: כתר.'
      },
      {
        'title': 'Hermann, Tamar (2009). <b>The Israeli peace movement: a shattered dream</b>. Cambridge, UK: Cambridge University Press.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '20/06/2021'
    },
    'year_closed': 2001,
    'year_closed_text': '2001',
    'year_founded': 1997,
    'year_registered': 1998
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '30/05/2018'
    },
    'description': '״נשים לגופן - עמותת נשים למען אחריות על בריאותן״ (ע״ר 580443661) הוקמה ב-2005 במטרה לפעול למען ״איסוף, ריכוז והפקת גוף ידע מקיף ומפורט בנושאים הנוגעים לבריאותן של נשים בישראל למען העמקה והעלאת מודעות והפצה של הידע בנושא. יצירת שיח רב-תרבותי של נשים בנושא בריאות כדי לשקף את מגוון הקולות והצרכים של נשים מאוכלוסיות שונות בחברה הישראלית״. ״נשים לגופן״ היא ״עמותה של נשים, הפועלת למען נשים, איכות חייהן ובריאותן באמצעות העלאת מודעות לזכויות בריאות ואמונה בנשים כמקור סמכות ביחס לגופן״ ומבקשת לקדם בריאות נשים ונערות כסוגיה הקשורה למכלול רחב של היבטים חברתיים, כלכליים, פיזיים, מיניים ורגשיים. פעילות העמותה כוללת הפקת פרסומים וספרים; יזום סדנאות וקבוצות פעולה לנשים ונערות ולצוותים חינוכיים וטיפוליים המיועדות למגוון קבוצות באוכלוסיה; ניהול מרכז מידע באינטרנט העוסק בהבטים רחבים של בריאות ומיניות של נשים; והפעלה של מרכז מומחיות ״נערות לגופן״. בנוסף, עמותת ״נשים לגופן״ מובילה שינוי מדיניות בתחומי בריאות נשים ונערות בפרט כאשר מתגלה מחסור בידע, במשאבים ובתשתיות ציבוריות. העמותה הוציאה לאור שלושה ספרים: \'נשים לגופן\' (הוצאת מודן); הספר בערבית \'المرأة وكيانها\' (הוצאה עצמית וספר ילדים ״סקי השמיעי קול״ העוסק בפגיעות מיניות בגיל הרך.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ],
      [
        'נערות וצעירות',
        'בריאות'
      ]
    ],
    'id': 'SA14',
    'is_active': true,
    'keywords': [
      'בריאות נשים',
      'גוף',
      'גיל המעבר',
      'גניקולוגיה',
      'דימוי גוף',
      'העלאת מודעות',
      'הריון',
      'לידה',
      'בריאות הנפש',
      'פוריות',
      'צעירות',
      'מוגבלויות',
      'מידע'
    ],
    'name': 'נשים לגופן - עמותת נשים למען אחריות על בריאותן',
    'name_ar': 'المرأة وكيانها',
    'name_change_year': null,
    'name_common': 'נשים לגופן',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-30'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.wtb.org.il/hebrew/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נשים לגופן – עמותת נשים למען אחריות על בריאותן (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580443661'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/01/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'שירותים משפטיים'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '12/12/2018'
    },
    'description': '״עזרה משפטית לעצורות״ (ע״ר 580148690) נוסדה בירושלים בשנת 1989 לשם ״מתן סעד משפטי לעצורות לפני משפט, וגיוס כספים למטרה זו בארץ ובחו״ל״. שמה המוכר של הקבוצה היה ״נשים למען אסירות פוליטיות-ירושלים״ והיא התבססה על קבוצת מתנדבות שפעלו במטרה ״להגן על זכויותיהן האנושיות של נשים העצורות בבתי כלא בישראל בשל מאבקן נגד הכיבוש, ולהעלות בפני דעת הקהל את שיטות החקירה והעינויים הנהוגות באגף השב״כ״. הפעילות של הקבוצה כללה בירור מידע על זהות עצורות במגרש הרוסים ומתן סיוע ראשוני, שכירת שירותים של עו״ד לשם מעקב אחר תנאי המעצר, הגנה על העצירות מפני התנכלויות, אספקה של ביגוד חיוני, פניה לדעת הקהל וגופים ציבוריים בארץ ובעולם במקרים של הפרת זכויות אדם ועינויים, ביקור אסירות משוחררות לשם גביית עדות ממקור ראשון על תנאי מאסרן ונוכחות בישיבות בבית המשפט. הארגון פרסם שני דוחות חשובים המתעדים את תנאי המעצר של אסירות פלסטיניות בשנים 1989 ו-1990 ובהם עדויות קשות על עינויים, כולל עינויים בעלי אופי מיני. העמותה נמחקה בפנקס העמותות בשנת 2007 לאחר שלא היתה פעילה כ-13 שנים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'צבא, ביטחון ומדיניות חוץ',
        'זכויות אדם'
      ],
      [
        'שלום'
      ]
    ],
    'id': 'SA99',
    'is_active': false,
    'keywords': [
      'אסירות',
      'פלסטיניות',
      'משפט',
      'זכויות'
    ],
    'name': 'עזרה משפטית לעצורות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'נשים למען אסירות פוליטיות-ירושלים',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'שירותים משפטיים',
    'primary_field_of_activity': 'צבא, ביטחון ומדיניות חוץ',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'זכויות אדם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>עזרה משפטית לעצורות</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 5639 (2007, 8 מרץ). <b>הודעה מוקדמת בדבר מחיקה מפנקס העמותות</b>. עזרה משפטית לעצורות (מספר עמותה 580148690). עמ\' 5. נדלה מתוך',
        'url': 'http://www.reshumot.co.il/notifications/issue/5639/5'
      },
      {
        'title': 'תיק ״נשים למען אסירות פוליטיות״, הארכיון הפמיניסטי ב״אשה לאשה״, חיפה'
      },
      {
        'title': 'מכתב מחגית שלונסקי אל רשם העמותות, 14 ינואר 2007 המאשר כי העמותה אינה פעילה. אותר בתיק העמותה <b>רשם העמותות</b>.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '14/01/2021'
    },
    'year_closed': 1994,
    'year_closed_text': '1994',
    'year_founded': 1989,
    'year_registered': 1990
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '28/10/2018'
    },
    'description': '״אגודת נשים למען בריאות בעומר״ נרשמה כאגודה עותומנית (589707900) אך לא מופיעה בפנקסי רשם העמותות. ככל הנראה פעלה עד אמצע שנות ה-80. האגודה פעלה באזור באר שבע כקולקטיב פמיניסטי שכלל נשות אקדמיה וחוקרות מתחום הבריאות וייתכן שהיא הקבוצה אשר ארגנה את הכנס הפמיניסטי הראשון שהתקיים ב-1 במאי 1978 בבאר שבע ו״אורגן על ידי קבוצה פמיניסטית שם שערכה מחקר עצמאי על התייחסות לנשים במחלקות לידה וגיניקולוגיה בבית החולים סורוקה״ (עילם 2012: 120).',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'SA75',
    'is_active': false,
    'keywords': [
      'לידה',
      'פמיניזם'
    ],
    'name': 'נשים למען בריאות בעומר',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים, היחידה הממשלתית לחופש המידע (2015). <b>רשימת אגודות עותמניות בישראל</b>. נדלה מתוך אתר משרד המשפטים',
        'url': 'https://foi.gov.il/he/node/1908'
      },
      {
        'title': 'עילם, אסתר (2012). פמיניסטית באקדמיה בשנות השבעים. <b>מגדר: כתב עת למגדר ופמיניזם</b>, 1, 117–132. נדלה מתוך',
        'url': 'http://blogdebate.org/gender/journal/wp-content/uploads/2012/12/%D7%90%D7%A1%D7%AA%D7%A8-%D7%A2%D7%99%D7%9C%D7%9D.pdf'
      },
      {
        'title': '(1980). <b>עשור לפמיניזם בישראל</b>. הכנס הארצי ה-3, ירושלים. אותר בארכיון הפמיניסטי ב״אשה לאשה – מרכז פמיניסטי חיפה״.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/12/2018'
    },
    'year_closed': 1985,
    'year_closed_text': '1985',
    'year_founded': 1976,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '17/05/2018'
    },
    'description': '״נשים למען נשים״ היה המקלט הראשון לנשים מוכות בישראל שהוקם בנובמבר 1997 על ידי קבוצת נשים פמיניסטיות מחיפה (ברברה סבירסקי, ג\'ודי היל ואחרות) בשיתוף חה״כ מרשה פרידמן. המקלט שאב השראה מיוזמות דומות בארה״ב ובאנגליה והחל כהתארגנות וולנטרית בעלת אופי שוויוני ופמיניסטי. כשש שנים לאחר הקמת המקלט נרשמה העמותה המפעילה את המקלט (ע״ר 580016632) ומטרותיה הן: ״לדאוג למקלט או לדיור זמני לנשים מוכות כולל הקמת מעונות שמירה וקידום זכויות הנשים במדינת ישראל במסגרת החוק״. לאחר ששולבו המקלטים לנשים נפגעות אלימות במערך השירותים של משרד העבודה והרווחה עבר המקלט בחיפה תהליך של התמסדות והוכפף לפיקוח מקצועי. שירותי המקלט התרחבו במשך הזמן וכיום כ-2/3 מתקציב העמותה מגיע ממשרד העבודה, הרווחה והשירותים החברתיים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YB41',
    'is_active': true,
    'keywords': [
      'נשים מוכות',
      'מקלט',
      'ביטחון אישי',
      'פמיניזם',
      'דיור',
      'סיוע משפטי'
    ],
    'name': 'נשים למען נשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נשים למען נשים: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580016632'
      },
      {
        'title': 'ינאי, אורי (2005). מקלטי נשים בישראל: מחדשנות וולנטרית לאימוץ ממלכתי. <b>ביטחון סוציאלי, 70</b>, 77–109. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/SocialSecurity/70/article5.pdf'
      },
      {
        'title': 'פרידמן, מרשה. (1990). <b>גולה בארץ המובטחת</b>. מאנגלית: מירי קרסין. תל אביב: ברירות.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1977,
    'year_registered': 1983
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '06/03/2018'
    },
    'description': '״נשים נגד אלימות״ היא ארגון פמיניסטי ועמותה לשינוי חברתי אשר פועלת למען קידום מעמדן של הנשים הערביות בישראל. שמה של העמותה שנרשמה בשנת 1992 בנצרת הוא ״סיוע לנשים ונערות נגד אלימות״ (ע.ר. 580207199) והיא נוסדה על ידי קבוצת נשים ערביות חלוצות, ביניהן עובדות סוציאליות, עורכות דין ופעילות בארגוני נשים. בתחילת דרכה, העמותה יזמה את הקמת המקלט הראשון לנשים ערביות אשר פועל בצפון הארץ ומשנת 1993 מפעילה את מרכז הסיוע לנפגעות אלימות מינית בשפה הערבית, וייסדה שתי דירות המעבר לנשים ונערות במצוקה. מטרות העמותה הן: ״הקמת קו חם במגזר הערבי לנשים ונערות במצוקה. הקמת בתים לנשים מוכות. מתן סיוע לנשים ולילדים במצוקה בתחום המשפטי ובענייני רווחה״.  חזון העמותה הוא לקדם שוויון מוחלט לנשים הערביות-פלסטיניות בישראל בכל תחומי החיים; הפצת והעמקת הראייה הפמיניסטית הכוללת בחברה; עידוד, השתתפות וייצוג שווה לנשים בהנהגה ובמוקדי קבלת ההחלטות; הסרת כל החסמים החברתיים והמוסדיים להבטחת זכותן של נשים בעבודה ובהזדמנויות עבודה שוות; גילוי וביעור כל סוגי האלימות נגד הנשים, ומתן תמיכה ושירותים מקצועיים לאוכלוסיית הנשים. מייסדת העמותה היא עאידה תומא-סלימן, אשר ניהלה אותה במשך שנים רבות.',
    'description_ar': 'نساء ضد العنف״ هو تنظيم نسوي وجمعية للتغيير المجتمعي التي تعمل من اجل رفع مكان النساء العربيات في إسرائيل. اسم الجمعية التي سجلت في سنة 1992 في لناصرة هو ״مساعدة لنساء وفتيات ضد العنف״ (ج.م. 580207199) وتأسست بواسطة مجموعة نساء عربيات رياديات، من ضمنهن عاملات اجتماعيات، محاميات وناشطات في تنظيمات نسوية. في بداية طريقها، بادرت الجمعية لإقامة الملجأ الأول للنساء العربيات الذي والذي عمل في شمال البلاد. ومنذ عام 1993 تشغل مركز المساعدة للمتضررات من العنف الجنسي باللغة العربية، وأسست شقتين انتقاليات لنساء وفتيات في ضائقة.         \nاهداف الجمعية هن: ״ انشاء خط ساخن بالوسط العربي لنساء وفتيات في ضائقة. تأسيس بيوت للنساء المعنفات. تقديم مساعدة لنساء ولأولاد في ضائقة بالمجال القضائي والرفاه الاجتماعي״. رؤية الجمعية هي تمكين شامل للنساء العربيات- الفلسطينيات في إسرائيل بكل مجالات الحياة: نشر وتعميق الرؤية النسوي في المجتمع: تشجيع، مشاركة وتمثيل متساوي للنساء في القيادة ومراكز اتخاذ القرارات: إزالة كل الحواجز المجتمعية والمؤسسية لتأمين حقوق النساء العربيات وفرص عمل متساوية: اكتشاف ومنع كل أنواع العنف ضد النساء: إعطاء دعم وخدمات مهنية لفئة النساء. مؤسسة الجمعية هي عايدة توما سليمان والتي قامت بإدارتها لسنوات عديدة.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ]
    ],
    'id': 'YB97',
    'is_active': true,
    'keywords': [
      'אלימות במשפחה',
      'האמנה לביעור כל צורות ההפליה נגד נשים 1979 CEDAW',
      'אלימות מינית',
      'בדואיות',
      'דרוזיות',
      'פלסטיניות',
      'נשים מוכות',
      'מקלט',
      'קבוצות תמיכה',
      'קו סיוע',
      'פמיניזם',
      'מנהיגות',
      'תעסוקה',
      'דיור'
    ],
    'name': 'סיוע לנשים ונערות נגד אלימות',
    'name_ar': 'نساء ضد العنف',
    'name_change_year': null,
    'name_common': 'נשים נגד אלימות',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נצרת',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-09-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.wavo.org/nv/he/?todo=aboutus'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>סיוע לנשים ונערות נגד אלימות: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580207199'
      },
      {
        'title': 'جنان عبده. (2008). الجمعيّات النسائيّة والنسويّة الفلسطينيّة- في مناطق 48, مدى الكرمل'
      },
      {
        'title': 'קרן דפנה (ללא תאריך). <b>מה אנו עושות</b> (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '11/04/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1992,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחאה',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/08/2018'
    },
    'description': '״נשים נגד אלימות נגד נשים״ היה קולקטיב פמיניסטי שפעל בתל אביב בשנים 1982-1986. בין מקימות הקבוצה היתה אסתר עילם (ממייסדות התנועה הפמיניסטית בישראל ומרכז הסיוע בתל אביב). הקבוצה ערכה הפגנות, מצעדים, מחקה שלטים פוגעניים וערכה מבצעים כמו מבצע ״נהגת תני טרמפ לאישה״. ״נשים נגד אלימות נגד נשים״ היתה אחת ההתארגנויות הראשונות שעסקו באופן ציבורי בקשר שבין זכויות נשים, אלימות מינית וייצוגים בתקשורת, כולל פרסום פוגע, שלטי חוצות ופורנוגרפיה. ייתכן שהקבוצה שאבה השראה מארגון דומה שהתקיים בצפון אמריקה בשנים 1976-1979 שנקרא: Women Against Violence Against Women. הקבוצה האמריקאית היתה מהראשונות לארגן את מצעדי ״לוקחות בחזרה את הלילה״.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'תרבות וספורט',
        'כתבי עת והוצאה לאור'
      ]
    ],
    'id': 'SA48',
    'is_active': false,
    'keywords': [
      'פרסום פוגע',
      'פורנוגרפיה',
      'אונס',
      'אלימות מינית',
      'מצעד',
      'קולקטיב'
    ],
    'name': 'נשים נגד אלימות נגד נשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'נשים נגד אלימות נגד נשים: הודעה על פירוק הקבוצה (1986). <b>שתילון, 2</b>. אותר בארכיון הפמיניסטי ב״אשה לאשה – מרכז פמיניסטי חיפה״.'
      },
      {
        'title': 'עילם, אסתר (2012). פמיניסטית באקדמיה בשנות השבעים. <b>מגדר: כתב עת למגדר ופמיניזם</b>, 1, 117–132. נדלה מתוך',
        'url': 'http://blogdebate.org/gender/journal/wp-content/uploads/2012/12/%D7%90%D7%A1%D7%AA%D7%A8-%D7%A2%D7%99%D7%9C%D7%9D.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/12/2018'
    },
    'year_closed': 1986,
    'year_closed_text': '1986',
    'year_founded': 1982,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחאה',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מחאה ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/08/2019'
    },
    'description': '״נשים נגד פרסום פוגע״ (ע״ר 580111706) הוקמה בשנת 1986 במטרה ״לשנות את דימוי האשה בכל תחומי החברה והתרבות: בתקשורת, בפרסומת, בהתבטאויות של אישים ומוסדות, בחינוך ובשפה״. הפעילות העיקרית של הארגון כללה כתיבת מכתבים לאחראים וקריאה להחרמת חברות המפרסמות בצורה פוגעת. הארגון קיים רשת קשר טלפונית שנועדה לגייס במהירות מספר מרבי של מכתבים ופניות על פרסומים בתקשורת הפוגעים בנשים. מייסדות הארגון היו אסתר רטנר, דינה בלכמן וכרמלה נחום. שם הארגון שונה באופן בלתי פורמלי ל״נשים נגד פרסום אנטי נשי״. העמותה נמחקה ב-2000 אך הפסיקה את פעילותה שנים קודם לכן.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תקשורת'
      ]
    ],
    'id': 'YH96',
    'is_active': false,
    'keywords': [
      'פרסום פוגע',
      'הסברה',
      'פמיניזם',
      'תקשורת'
    ],
    'name': 'נשים נגד פרסום פוגע',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'נשים נגד פרסום אנטי נשי',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'תקשורת',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'באום, אילנה (1986, 13 נובמבר). גזענות בלתי מודעת נגד נשים ברדיו ובטלויזיה. <b>מעריב</b>. נדלה מתוך',
        'url': 'http://jpress.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=MAR%2F1986%2F11%2F13&id=Ar01902&sk=A5911BDF'
      },
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>נשים נגד פרסום פוגע</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'שדולת הנשים בישראל (1987). <b>מעמד האשה בישראל: בדיקת המלצות הועדה למעמד האשה 1978</b>. ירושלים: משרד ראש הממשלה.'
      },
      {
        'title': 'שליט, דוד (2001, 6 מרץ). הגיבורות עייפות. <b>גלובס</b>. נדלה מתוך',
        'url': 'https://www.globes.co.il/news/article.aspx?did=474489'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '22/10/2019'
    },
    'year_closed': 2000,
    'year_closed_text': '2000',
    'year_founded': 1986,
    'year_registered': 1987
  },
  {
    'activity_kinds': [
      'מחאה',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מחאה ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '09/02/2018'
    },
    'description': '״נשים עושות שלום״ היא תנועת שטח א-מפלגתית רחבה אשר הוקמה בקיץ 2014 בעקבות מבצע ״צוק איתן״ בדרישה לחתור להסכם מדיני מכבד, מוסכם ולא אלים שיביא לסוף הסכסוך בין ישראל והפלסטינים, תוך שיתוף נשים בתהליך (ברוח החלטה 1325 של האו״ם). בשנת 2015 נרשמה התנועה כעמותה (ע״ר 580602308) שמטרותיה הן: ״חינוך ופיתוח מחקר לקידום דו קיום בין קהילות ולאומים שונים. העצמת נשים לפעילות ציבורית למען עתיד של שלום למדינת ישראל. יצירת שיח ציבורי ומנהיגותי של תקווה שיבטיח את עתיד מדינת ישראל במסגרת יחסי שלום.״ חברות התנועה בכל רחבי הארץ יוזמות ומארגנות פעילויות מקומיות וארציות מגוונות ויצירתיות במסגרת מבנה של כ-50 צוותי שטח, ולצידם צוותים מקצועיים שנותנים תמיכה בנושאים שונים. בין הפעילויות הציבוריות שיזמו ״נשים עושות שלום״ ניתן למנות את ״רכבת השלום״ שבה נסעו כ-1000 נשים ברכבת לשדרות (2014); אוהל ״צום איתן״ במלאת שנה למבצע ״צוק איתן״ שאילו הגיעו מאות נשים לצום במשך 50 יום מול בית ראש הממשלה (2015); ״צעדת התקווה״ שבה צעדו במשך שבועיים מצפון הארץ לירושלים כ-30,000 נשים וגברים, ישראליות ופלסטיניות, יהודיות וערביות (2016). התנועה יזמה פרויקט הקרנת סרט תיעודי העוסק בפעילות שלום של נשים בליבריה ויצרה קשרים עם לימה באוי, כלת פרס נובל לשלום. בינואר 2017 הקימה התנועה״שדולת נשים למען שלום וביטחון״ בכנסת במטרה לקדם חקיקת חוק ״חלופות מדיניות״.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ייצוג הולם'
      ]
    ],
    'id': 'SA52',
    'is_active': true,
    'keywords': [
      'דו קיום',
      'החלטה 1325',
      'חקיקה',
      'מחקר',
      'מגוון',
      'צעדה'
    ],
    'name': 'נשים עושות שלום',
    'name_ar': 'نساء يصنعن السلام',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר סבא',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-02-09'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.womenwagepeace.org.il/about/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נשים עושות שלום (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580602308'
      },
      {
        'title': 'נשים עושות שלום, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/WomenWagePeace/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/02/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': 2015
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '30/05/2018'
    },
    'description': 'הקבוצה המייסדת הוקמה על ידי נירית שפירא בשנת 2001 בשיתוף עם מגזין ״הורים וילדים״, בעקבות סגירתו של בית החולים ליולדות ״משגב לדך״ במטרה לקדם מודעות ולפעול למען חופש בחירה בלידה. עמותת ״נשים קוראות ללדת למען חופש בחירה בלידה״ (ע״ר 580429264) נרשמה בשנת 2004 וזכתה לאורך השנים ללוות אלפי נשים (מתנדבות, מקבלות תמיכה, תומכות). מטרות העמותה הן: ״לפעול למיסוד לידות הבית בישראל. לפעול להקמתם של מרכזי לידה עצמאיים ומוכרים עפ״י חוק. לפעול לאימוץ תנאים המאפשרים לידה ידידותית ליולדת ולילוד. לפעול לשיפור הסיעוד בחדרי לידה ולהקצאת מקומות שהייה נאותים לאמהות אשר תינוקיהן מאושפזים״. העמותה פעילה במספר אפיקים: (1) איסוף והעברת מידע על המתרחש בחדרי לידה, מתן מידע על לידה טבעית וחינוך למודעות מצד הצוות הרפואי בכל הנוגע לזכויות היולדת; (2) חקיקה שתעגן את זכויות היולדת והילוד; (3) מיסוד לידות בית וקידום הקמתם של מרכזי לידה מחוץ ובתוך בתי החולים. בין הפעילויות שנעשו לאורך השנים: עצומה למען חופש בחירה בלידה, כנסים ציבוריים בנושא חופש בחירה בלידה, הופעה בועדות בכנסת, שינוי חוק מענק הלידה שיחול גם על לידות בית, הגנה על זכויות של מיילדות בית, ניסוח מסמכים ומחקרים על מרכזי לידה, עתירות לבג״ץ, הפעלת ״קו ליולדת״ ועוד.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ]
    ],
    'id': 'SA13',
    'is_active': true,
    'keywords': [
      'לידה',
      'בית חולים',
      'לידה טבעית',
      'טראומה',
      'חקיקה',
      'מילדות',
      'קו סיוע',
      'תמיכה נפשית',
      'זכויות'
    ],
    'name': 'נשים קוראות ללדת- למען חופש בחירה בלידה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'פרדס חנה-כרכור',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-30'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://nashimkorot.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נשים קוראות ללדת – למען חופש בחירה בלידה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580429264'
      },
      {
        'title': 'נשים לגופן (אתר).',
        'url': 'http://www.wtb.org.il/hebrew/?page_id=3741'
      },
      {
        'title': 'אמנות הלידה (האתר הישן). <b>מי אנחנו</b>. נדלה מתוך',
        'url': 'http://www.leida.co.il/nashimko/show_top.asp?link=1'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2001,
    'year_registered': 2004
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/10/2018'
    },
    'description': '״נשים״ הינו כתב עת אקדמי בינלאומי שמתפרסם משנת 1989 כשיתוף פעולה בין מכון שכטר למדעי היהדות בירושלים, מכון הדסה-ברדנייס (בוסטון) והוצאת הספרים של אוניברסיטת אינדיאנה. כתב העת מפרסם מאמרים באנגלית והוא יחיד במינו בכך שהוא מהווה במה לכתיבה בינלאומית ורב-תחומית בנושאים הנוגעים לנשים, מגדר ויהדות. כתב העת נוסד בדחיפתה של אליס שלוי בעקבות סדרת מפגשים בכנסים בינלאומים על נשים ביהדות שהתקיימו בשנות ה-80.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'כתבי עת'
      ],
      [
        'דת ומעמד אישי',
        'השכלה'
      ]
    ],
    'id': 'SA70',
    'is_active': true,
    'keywords': [
      'יהדות',
      'מחקר פמיניסטי',
      'שיתוף פעולה בינלאומי'
    ],
    'name': 'נשים- NASHIM',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'אקדמי',
      'בינלאומי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'כתבי עת',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-10-24'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.jstor.org/journal/nashim'
      },
      {
        'title': 'Herzog, Hanna (2008). Re/visioning the women\'s movement in Israel. <b>Citizenship Studies 12</b> (3), 265-282.'
      },
      {
        'title': 'Shalvi, Alice (1998). Introducing Nashim. <b>Nashim: A Journal of Jewish Women\'s Studies & Gender Issues 1</b>, 2.'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '17/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1997,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '25/10/2018'
    },
    'description': 'מדרשת נשמת נוסדה בשנת 1990 (ע.ר. 580161628) על ידי הרבנית חנה הנקין כמוסד ללימודי תורה גבוהים לנשים. במדרשה תוכניות לימוד מלאות לנשים, לבוגרות שירות צבאי או לאומי, ולנערות מסיימות תיכון מחו״ל, וכן שיעורים וימי עיון פתוחים לנשים מהציבור הכללי. בשנת 1997 הקימה המדרשה את התוכנית הראשונה להכשרת יועצות הלכה לנשים בנושא דיני אישות ונידה; ובשנת 2000 הפעילה את הקו החם הטלפוני כדי לאפשר פניות של נשים ליועצות ההלכה. בשנת 1999 הקימה המדרשה תוכנית ״מעיין״ לנערות מהעדה האתיופית לקידום לימודי התורה והמנהיגות הקהילתית בקרבן. בשנת 2007 קמה תוכנית ״מעיין המשך״ המלווה את הנערות הללו בלימודי תואר ראשון תוך תמיכה כלכלית.',
    'description_ar': null,
    'display_organization_kind': 'מוסד תורני בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'השכלה'
      ],
      [
        'נערות וצעירות',
        'דת'
      ]
    ],
    'id': 'SW25',
    'is_active': true,
    'keywords': [
      'הכשרה מקצועית',
      'הלכה',
      'טהרת המשפחה',
      'מדרשה',
      'תורה',
      'יהדות',
      'דיני אישות'
    ],
    'name': 'נשמת- מדרשה גבוהה ללימודי תורה לנשים',
    'name_ar': null,
    'name_change_year': 1994,
    'name_common': null,
    'name_past': 'נשמת- נשים עמילות בתורה',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'מוסד תורני',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'מוסד תורני',
    'primary_sub_field_of_activity': 'השכלה',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-10-25'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.nishmat.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>״נשמת״ מדרשה גבוהה ללימודי תורה לנשים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580161628'
      },
      {
        'title': 'הלכה ובריאות האישה (אתר).',
        'url': 'http://www.yoatzot.org/hebrew/'
      },
      {
        'title': 'כהן, טובה (2006). מנהיגות דתית נשית: האורתודוקסיה המודרנית בישראל כמקרה-מבחן. <b>תרבות דמוקרטית 10</b>, 96–251. נדלה מתוך',
        'url': 'https://www.jstor.org/stable/pdf/24151914.pdf?refreqid=excelsior%3Ad60f2cc9e1337f1768ad9d7cbfd1ea39'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '27/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1990,
    'year_registered': 1989
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '10/04/2018'
    },
    'description': 'התכנית היא יוזמה של קרנות קורת משנת 2006 שהחלה כקרן למתן הלואות זעירות עבור נשים בדואיות בנגב. התכנית התרחבה ופועלת החל משנת 2011 כתכנית ארצית בשיתוף פעולה בין הקרן, הסוכנות לעסקים קטנים ובינוניים במשרד הכלכלה והרשות לפיתוח כלכלי של המגזר הערבי, הבדואי והצ\'רקסי במשרד ראש הממשלה. התכנית פועלת על פי המודל שפיתח מוחמד יונוס בבנגלדש - היא מספקת מימון זעיר (micro-finance) בתנאים נוחים, הכשרה וליווי לנשים ערביות לשם פיתוח פעילות עסקית עצמאית.',
    'description_ar': 'اقيم البرنامج كمبادرة لجمع التبرعات في عام 2006 حيث بدأت كصندوق لتوفير القروض الصغيرة للنساء البدويات في النقب. توسع البرنامج ويعمل منذ عام 2011 كبرنامج واسع النطاق بالتعاون بين المؤسسة ووكالة الأعمال الصغيرة والمتوسطة في وزارة الاقتصاد وهيئة التنمية الاقتصادية في المجتمع العربي، البدوي والشركسي في مكتب رئيس الحكومة. يعمل البرنامج وفقًا للنموذج الذي طوره محمد يونس في بنغلاديش - فهو يوفر تمويلًا صغيرًا في ظل ظروف مواتية، تدريب ومرافقة النساء العربيات لتطوير أنشطة أعمال مستقلة.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ]
    ],
    'id': 'YH97',
    'is_active': true,
    'keywords': [
      'העצמה',
      'מימון זעיר',
      'נשות עסקים',
      'סיוע כלכלי',
      'קידום נשים'
    ],
    'name': 'תכנית SAWA',
    'name_ar': 'سوا',
    'name_change_year': null,
    'name_common': 'סאווה',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-10-04'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.kiedf.com/sawa'
      },
      {
        'title': 'אלאסאד אלהוזייל, נוזהה (2011, 10 פברואר). יש עתיד לאשה הבדווית בישראל. <b>TheMarker</b>. נדלה מתוך',
        'url': 'https://www.themarker.com/career/1.595229'
      },
      {
        'title': 'דגן-בוזגלו, נוגה (2016). <b>עסק משלה- עידוד עסקים קטנים בבעלות נשים בישראל ובמדינות המפותחות, מה נעשה ומה נדרש עוד לעשות</b>. מרכז אדוה וקואליציית שותפות.',
        'url': 'http://adva.org/wp-content/uploads/2017/02/%D7%A2%D7%A1%D7%A7-%D7%9E%D7%A9%D7%9C%D7%94-1.pdf'
      },
      {
        'title': 'משרד הכלכלה והתעשייה וקרן קורת (2018). <b>מחקר הערכה: אשראי חוץ בנקאי זעיר לנשים ערביות</b>. נדלה מתוך',
        'url': 'https://www.sba.org.il/hb/PolicyAndInformation/Researches/Documents/SAWA.pdf'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '10/07/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2006,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '30/06/2018'
    },
    'description': 'עמותת סביבה תומכת (ע״ר 580413821) הוקמה על ידי קבוצת נשות עסקים, כולן עולות מחבר העמים, במטרה לקדם נשים בעלות עסקים זעירים בישראל. העמותה יזמה קורסים להקמת ומינוף עסק, העניקה יעוץ פיננסי ופנסיוני , יעוץ וליווי עסקי, ייעוץ שיווקי, הקימה פורומים עסקיים ועוד. לא ברור אם העמותה עדיין פעילה. בשנת האתר לא קיים ועמוד הפייסבוק התעדכן לאחרונה ב-2017 וגם אז כבמה לפעילות של גופים אחרים. ביוני 2014, נפטרה לנה גורארי, ממיייסדות העמותה והרוח החיה שלה ונראה שמאז גוועה גם פעילות העמותה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'הגירה',
        'קליטת עלייה'
      ]
    ],
    'id': 'YH37',
    'is_active': false,
    'keywords': [
      'פמיניזם',
      'העצמה',
      'פנסיה',
      'נשות עסקים'
    ],
    'name': 'סביבה תומכת',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים עולות מחבר העמים',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>סביבה תומכת – מרכז לקידום יוזמות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580413821'
      },
      {
        'title': 'סביבה תומכת, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/svivatomehetmerkaz/?ref=page_internal'
      }
    ],
    'target_audiences': [
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '21/02/2019'
    },
    'year_closed': 2015,
    'year_closed_text': '2015',
    'year_founded': 2003,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '04/09/2018'
    },
    'description': '‏״סטודיו משלך״ נוסדה בשנת 2010 בירושלים על ידי ציפי מזרחי על מנת לתמוך ב- ולקדם אומניות ‏דתיות בתחילת דרכן. בשנת 2011 נרשם כעמותה (ע״ר 580546927ׂׂ) ומספק מרחב עבודה ותצוגה, חשיפה ופרסום התערוכות, וכן העצמה ‏כלכלית עם קורס פיתוח וקידום יזמות עסקית באמצעות מט״י ירושלים. אחת מחברות ועדת ההיגוי היא ‏פרופ\' רונית קרק.‏ בשנים 2016-2018 העמותה קיבלה תמיכה הולכת ופוחתת ממשרד התרבות והספורט: 60,000 ש״ח, 59,453 ש״ח, ו-45,766 ש״ח בהתאמה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'אמנות'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'דת ומעמד אישי',
        'תרבות ואמנות'
      ]
    ],
    'id': 'YH85',
    'is_active': true,
    'keywords': [
      'אמנות',
      'קידום נשים',
      'ייצוג',
      'העצמה'
    ],
    'name': 'סטודיו משלך',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אמנות',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-09-04'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://studioofherown.com/about'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>סטודיו משלך – מרכז לנשים אמניות יוצרות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580546927'
      },
      {
        'title': 'סטודיו משלך, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/Studio-of-Her-Own-%D7%A1%D7%98%D7%95%D7%93%D7%99%D7%95-%D7%9E%D7%A9%D7%9C%D7%9A-191106910941354/'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '04/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2010,
    'year_registered': 2011
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '07/10/2018'
    },
    'description': '״סידרה״ היא עמותה שנוסדה בשנת 1998 בלקיה שבנגב (ע.ר. 580304517) אשר מטרותיה הן: ״העלאת מודעות האשה הבדואית בנגב למעמדה החברתי, הכלכלי, התרבות והחינוכי. חלוקת מלגות לסטודנטיות שלומדות במוסדות להשכלה גבוהה.״ חזון העמותה הוא לתמוך בנשים הבדואיות בנגב ולהעלות את המודעות לזכויותיהן וליכולתן להשתתף בתהליכי קבלת החלטות בקהילה ובחברה. פעילותה מכוונת להשגת ארבעה יעדים אסטרטגיים: 1) גישה לידע באמצעות שיפור רמת ההשכלה של נשים בדואיות; 2) גישה למשאבים באמצעות הגברת החוסן הכלכלי אצל נשים בדואיות ויצירת מקורות הכנסה זמינים; 3) שוויון בין המינים באמצעות שיפור המעמד החברתי של נשים וקידום זכויות נשים; 4) פיתוח בר קיימא באמצעות הגברת המקצועיות ופיתוח ארגוני. העמותה מפעילה פרויקטים כלכליים שמטרתם העצמת נשים בדואיות אשר מייצרות שטיחים בביתן ומוכרות אותם בארץ ובחו״ל וגם מארחות תיירים בביתן. בנוסף, העמותה עורכת הכשרות מקצועיות לנשים הכוללות עידוד יזמות לעסקים קטנים, השלמת השכלה למבוגרים, חינוך לבריאות האשה, חינוך לחיי משפחה ומנהיגות צעירה.',
    'description_ar': 'تأسست جمعية سدرة في عام 1998 في اللقية- النقب. (ج. م580304517) وأهدافها: رفع وعي المرأة البدوية في النقب بوضعها الاجتماعي، الاقتصادي، الثقافي والتعليمي. توزيع المنح الدراسية للطلاب الذين يدرسون في مؤسسات التعليم العالي ״. تتمثل رؤية الجمعية في دعم المرأة البدوية في النقب وزيادة الوعي بحقوقها وقدرتها على المشاركة في عمليات صنع القرار في المجتمع.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'חינוך',
        'צמצום פערים בחינוך'
      ],
      [
        'תרבות וספורט',
        'מלאכות מסורתיות'
      ]
    ],
    'id': 'YH53',
    'is_active': true,
    'keywords': [
      'הכשרה מקצועית',
      'השלמת השכלה',
      'בדואיות',
      'יזמות עסקית',
      'בריאות',
      'מנהיגות',
      'סחר הוגן'
    ],
    'name': 'סידרה- SIDREH',
    'name_ar': 'جمعية سدرة اللقية',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'לקיה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-10-07'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.sidreh.org/default.aspx'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>סידרה SIDRA: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580304517'
      },
      {
        'title': 'Marteu, Elisabeth (2015). Bedouin women\'s organizations in the Naqab : Social activism for women\'s empowerment?. In Nasasra, Mansour, Richter-Devroe, Sophie, Abu-Rabia-Queder, Sarab & Ratcliffe, Richard (Eds.), <b>The Naqab Bedouin and colonialism</b>. (pp. 145-161). Abingdon, Oxon: Routledge.'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '11/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '26/06/2018'
    },
    'description': 'עמותת סנדיאנת הגליל לקידום ופיתוח (ע.ר. 580264216) הוקמה בשנת 1995 במטרה לקדם הכשרה מקצועית, הזדמנויות כלכליות ומקומות תעסוקה לנשים ערביות. העמותה מחויבת לערכים של שלום, שוויון ורווחה לכל. סינדיאנת הגליל משלבת פעילות מסחרית עם שימור המסורת הייחודית לאזור ופעילות קהילתית. העמותה משווקת מוצרים מסורתיים על פי שיטת הסחר ההוגן ובעיקר שמן זית איכותי שההכנסות ממכירתו מיועדים לסיוע לקהילה ולחברה. העמותה עוסקת בפיתוח וקידום הכשרה מקצועית לנשים באזורים כפריים על ידי (1) פיתוח תחום קליעת הסלים על ידי נשים במרכז המבקרים בכפר כנא ויצירת שיתופי פעולה עם ארגוני נשים ועמותות לקידום מעמד האשה. (2) הטמעת שיטות גידול מודרניות במטעי זיתים. (3) מיזמים של סחר הוגן (שמן זית, תבלינים, סבון) הכוללים מפעל אשר מעסיק נשים בתנאי עבודה הוגנים כאשר הרווחים הולכים לקידום המטרות והפעילויות של העמותה.',
    'description_ar': 'جمعية سنديانة الجليل: تأسست عام 1995 بهدف تشجيع التدريب المهني والفرص الاقتصادية والوظائف للمرأة العربية. تلتزم الجمعية بقيم السلام والمساواة والرفاه للجميع. سنديانة الجليل تجمع بين الأنشطة التجارية والحفاظ على التقاليد الفريدة ونشاط المجتمع. تقوم الجمعية بتسويق المنتجات التقليدية وفقًا لطريقة التجارة العادلة وخاصة زيت الزيتون عالي الجودة الذي تهدف عائداته من المبيعات إلى مساعدة المجتمع. تعمل الجمعية على تطوير وتعزيز التدريب المهني للمرأة في المناطق الريفية من خلال (1) تطوير مجال نسج السلال النسائي في مركز زوار في كفر كنا وتشكيل تعاون مع المنظمات والجمعيات النسائية لتعزيز وضع المرأة. 2) تنفيذ الممارسات الحديثة المتنامية في بساتين الزيتون. (3) مشاريع التجارة العادلة (زيت الزيتون، البهارات، الصابون) التي تشمل مصنعاً يعمل فيه النساء في ظروف عمل عادلة بينما تذهب الأرباح نحو الترويج لأهداف الجمعية وأنشطتها.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'תרבות וספורט',
        'מלאכות מסורתיות'
      ]
    ],
    'id': 'YH30',
    'is_active': true,
    'keywords': [
      'סחר הוגן',
      'העצמה כלכלית',
      'הכשרה מקצועית',
      'חקלאות'
    ],
    'name': 'סנדיאנת הגליל לקידום ופיתוח',
    'name_ar': 'سنديانة الجليل',
    'name_change_year': null,
    'name_common': 'סינדיאנת הגליל',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר כנא',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-10-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.sindyanna.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>סנדיאנת הגליל לקידום ופיתוח: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580264216'
      },
      {
        'title': 'Davenport, Eileen, and Low, William (2015). Fair trade, peace and development in conflict zones. In Raynolds, Laura T. & Bennett, Elizabeth A. (Eds.) <b>Handbook of research on fair trade</b> (pp. 355-371). Cheltenham, UK: Edward Elgar Publishing.'
      },
      {
        'title': 'Sindyanna of Galilee Fair Trade, Facebook page.',
        'url': 'https://www.facebook.com/SindyannaG/?ref=page_internal'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '11/04/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1995,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': 'פרויקט סלעית – סיוע לנשים במעגל הזנות – הינו פרויקט עירוני שהוקם כחלק מפרויקט לאומי למיגור הזנות, על כל היבטיה ומתן מענה טיפולי הולם לנשים הלכודות במעגל הזנות. הקצאת המשאבים נעשית על ידי הממשלה באמצעות משרד הרווחה. עיריית תל אביב- יפו, מינהל השירותים החברתיים, לקחה על עצמה להפעיל את התוכנית בתל אביב, על ידי הקמת מספר מסגרות טיפוליות. הפעלת התוכנית הינה באמצעות חברת מוסדות חינוך ותרבות בתל אביב כזרוע ביצועית. התכנית כוללת רצף של שרותי טיפול ושיקום: דירת חירום לנשים שעדיין נמצאות במעגל הזנות, הוסטל שיקומי ומרכז יום לנשים המביעות רצון להשתקם ולצאת ממעגל הזנות. כמו כן מתוך תפיסה של בניית אמון ורצף טיפולי מתקיימים באופן קבוע סיורי שטח לעבודת יישוג (reaching out) ויצירת קשר עם נשים בזירות הזנות. בנוסף התכנית מפעילה קו חירום ארצי הפועל 24 שעות.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף מוניציפלי',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'זנות'
      ],
      [
        'רווחה וקהילה',
        'זנות וסחר בנשים'
      ],
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ]
    ],
    'id': 'YB81',
    'is_active': true,
    'keywords': [
      'שיקום',
      'הוסטל',
      'דיור',
      'טראומה',
      'אונס',
      'פמיניזם',
      'תמיכה נפשית'
    ],
    'name': 'סלעית - מערך טיפולי תמיכתי לנשים במעגל הזנות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'ממשלתי',
      'מוניציפלי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'זנות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://saleet.org.il/'
      },
      {
        'title': 'סלעית – סיוע לנשים במעגל הזנות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/saleet.org.il/'
      },
      {
        'title': 'רוח טובה (אתר). ״תוכנית סלעית״ – חונכות וליווי נשים. נדלה מתוך',
        'url': 'https://ruachtova.org.il/projects/12403'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '10/08/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2008,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '25/06/2018'
    },
    'description': 'הפורום הפמיניסטי במכללת ספיר הוקם בשנת 2010 בידי נשות ואנשי אקדמיה מהמכללה. הוא נועד לקדם עשייה אקדמית וחברתית, שמטרתה השגת צדק מגדרי ומיני, הן בתוך מכללת ספיר והן מחוצה לה. הפורום פתוח לכל נשות ואנשי הסגל האקדמי וחלק ניכר מפעילותו פתוח גם בפני סטודנטים/ות אנשי הסגל המנהלי ותושבות/ים האזור. פעילות הפורום: מחקר אקדמי, פעילות חברתית-לימודית בתוך הקמפוס ופעילות חברתית באזור הדרום. כחלק מפעולותיו של הפורום הפמיניסטי הוקם האתר ״ספריניסטיות״, המיועד לקדם שיח פמיניסטי מגוון ולהפיץ מידע וידע רלוונטיים לנושא.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'אקדמיה, חברה וקהילה'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ],
      [
        'נערות וצעירות',
        'זכויות'
      ]
    ],
    'id': 'YB110',
    'is_active': true,
    'keywords': [
      'מחקר',
      'פריפריה',
      'אקטיביזם',
      'פמיניזם'
    ],
    'name': 'ספירניסטיות הפורום הפמיניסטי של מכללת ספיר',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'שדרות',
    'organization_kind': [
      'אקדמי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'אקדמיה, חברה וקהילה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-25'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://feminism.wp.sapir.ac.il/'
      },
      {
        'title': 'סופר, אור (2012, 24 יולי). <b>איך אתר נולד – הסיפור של ספירניסטיות</b>. נדלה מתוך',
        'url': 'http://www.gendersite.org.il/2012/07/24/%D7%90%D7%99%D7%9A-%D7%90%D7%AA%D7%A8-%D7%A0%D7%95%D7%9C%D7%93-%D7%94%D7%A1%D7%99%D7%A4%D7%95%D7%A8-%D7%A9%D7%9C-%D7%A1%D7%A4%D7%99%D7%A8%D7%A0%D7%99%D7%A1%D7%98%D7%99%D7%95%D7%AA-%D7%90%D7%95/'
      },
      {
        'title': 'ספירניסטיות. עמוד פייסבוק (לא פעיל מ-2015).',
        'url': 'https://www.facebook.com/%D7%A1%D7%A4%D7%99%D7%A8%D7%A0%D7%99%D7%A1%D7%98%D7%99%D7%95%D7%AA-423459824373175/'
      },
      {
        'title': 'קרן דפנה (ללא תאריך). <b>המרכז לנשים בפוליטיקה</b> (הקרן נסגרה והעמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '09/04/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2010,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'אקטיביזם רשת',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '26/12/2018'
    },
    'description': '״עבודה שווה״ (חל״צ 515905180) נוסדה בשנת 2018 בעקבות יוזמה של טלי בראל-הס ומיכל מטס ליטמנוביץ שהפעילו קהילת פייסבוק משנת 2017. מטרות החל״צ הן: ״קידום שוויון מגדרי בשוק העבודה הישראלי. יצירת מדד מגדרי (״מדד עבודה שווה״), אשר בוחן חברות במשק הישראלי, עד כמה הן שוויוניות מבחינה מגדרית כלפי עובדיהן ועובדיהם.״ הפעילות של עבודה שווה עוסקת בקידום שוויון מגדרי בשוק העבודה על ידי יצירת סנטדרטים ונורמות עבודה בארגונים. העמותה מתמקדת בקידום מדיניות גיוון (diversity) באמצעות דירוג ארגונים על פי מדיניות השוויון המגדרי המיושמת בארגון. בנוסף, היא מציעה לארגונים ליווי בתהליכי מיפוי, המלצות וכתיבת תכנית עבודה להטמעת גיוון בארגון וכן מדד המאפשר השוואה בין ארגונים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'YH167',
    'is_active': true,
    'keywords': [
      'גיוון במקום העבודה',
      'שוויון בארגונים',
      'שוויון מגדרי',
      'תנאי עבודה',
      'שוק העבודה',
      'פערי שכר',
      'בידול תעסוקתי',
      'חל״צ'
    ],
    'name': 'עבודה שווה (חל״צ)',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נטעים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'אקטיביזם רשת',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'זכויות ומדיניות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-12-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.avodashava.co.il/?fbclid=IwAR3JrHyOIATEFOKA70zjX4xQGcKlxVHiaVM0h6r0sqbmD-vmQMDOaUpZ06I'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עבודה שווה בע״מ (חל״צ): חל״צ</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/515905180'
      },
      {
        'title': 'עבודה שווה -שוק עבודה שוויוני, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/Equal.work/'
      },
      {
        'title': 'בראל-הס, טלי ומטס ליטמנוביץ\', מיכל (2018, 3 פברואר).האם מקום העבודה שלך רואה אותך? ספרי לנו את! <b>סלונה</b>. נדלה מתוך',
        'url': 'http://saloona.co.il/blog/avodashava/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '26/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2017,
    'year_registered': 2018
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '01/11/2018'
    },
    'description': 'מרכז ״עדן: המקום שלך, החוויה שלך״ הוקם בשנת 2010 בירושלים על ידי ד״ר נעמי מרמון גרומט במטרה להפוך את המקווה ואת טקס הטבילה ‏לרלוונטית ומעצימה לנשים מודרניות: דתיות, מסורתיות וחילוניות. המרכז, שנרשם כעמותה (ע״ר 580521185) בשנת ‏‏2012 מפעיל מספר תוכניות: קורסי הכשרה והשתלמות לבלניות, למדריכות כלות ולמדריכי חתנים. כמו ‏כן, הוא מעביר הרצאות וקורסים באנגלית ובעברית לנשים בנושאים כגון: אינטימיות ומערכות יחסים בריאות (כולל חינוך ילדים ‏על מיניות), בעיות פוריות ואבדן הריון, התעללות מינית ופיזית ומנטלית, בריאות נשים, אירועים ממעגל ‏החיים הנשי (קבלת הווסת, נישואין, הריון, אבדן ומנופאוזה).‏',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'בריאות ופריון'
      ],
      [
        'חינוך',
        'חינוך מיני/מיניות בריאה'
      ],
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'SW29',
    'is_active': true,
    'keywords': [
      'מקווה',
      'בלניות',
      'מוגבלויות',
      'אלימות מינית',
      'הרצאות',
      'הכשרה מקצועית',
      'דיני אישות'
    ],
    'name': 'עדן: המקום שלך, החוויה שלך',
    'name_ar': null,
    'name_change_year': 2012,
    'name_common': null,
    'name_past': 'עדן - המקום לכולם',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות ופריון',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-11-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://theedencenter.com'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עדן: המקום שלך, החוויה שלך (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580521185'
      },
      {
        'title': 'מרכז עדן (אתר). <b> .</b>Immersing in Inclusionנדלה מתוך',
        'url': 'http://theedencenter.com/%D7%98%D7%94%D7%A8%D7%94-%D7%91%D7%9C%D7%AA%D7%99-%D7%9E%D7%95%D7%92%D7%91%D7%9C%D7%AA/?lang=he'
      },
      {
        'title': 'מרכז עדן, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/merkazeden/'
      },
      {
        'title': 'Marmon Grumet, Naomi (2017). The transmission of sexual mores, norms of procreation and gender expectations through pre-marital counseling (hadrakhat hatanim/kallot). In Nizard, Sophie; Gross, Martine; and Scioldo-Zürcher, Yann (Eds.) <b>Gender, families and transmission in contemporary Jewish context</b> (pp. 38-48). Newcastle upon Tyne, UK: Cambridge Scholars Publishing.'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '18/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2010,
    'year_registered': 2010
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': '״עלם״ הוקמה בשנת 1983 על מנת לסייע במצבי סיכון. העמותה עוסקת לאו דווקא בנשים (נערות) אלא בנוער. לעמותה מגוון רחב של פעילויות ובכללן עבודה עם נערות, פגיעות מיניות, תעסוקה וליווי לחיים עצמאיים, מרכז מידע ויעוץ לנוער, ניידות עלם הפועלות בערים שונות, הפוגשות את הנוער ברחובות, מוקד ייעוץ אינטרנטי וכן הכשרות לאנשי מקצוע ביחס לתחומי המומחיות של עלם - נוער במצוקה. העמותה עובדת בשיתוף עם משרד הרווחה ועם מגוון רשויות מקומיות וומפעילה מסגרות לצעירות/ים בכ-30 ערים ברחבי הארץ.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'להט״ב',
        'רווחה ובריאות'
      ],
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ]
    ],
    'id': 'YB80',
    'is_active': true,
    'keywords': [
      'אלימות מינית',
      'נערות בסיכון',
      'מחוסרי דיור',
      'תמיכה נפשית',
      'אלימות במשפחה',
      'התמכרויות',
      'הוסטל',
      'זנות'
    ],
    'name': 'עלם - עמותה לנוער במצבי סיכון',
    'name_ar': 'عيلم',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'בני ברק',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'צעירות במצבי סיכון',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.elem.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עלם – עמותה לנוער במצבי סיכון (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580036945'
      },
      {
        'title': 'המטה למאבק בסחר בנשים ובזנות. הקואליציה למאבק בזנות (ללא תאריך). <b>עלם</b>. נדלה מתוך',
        'url': 'https://tfht.org/hebrew/%D7%90%D7%95%D7%93%D7%95%D7%AA/%D7%94%D7%A7%D7%95%D7%90%D7%9C%D7%99%D7%A6%D7%99%D7%94-%D7%9C%D7%9E%D7%90%D7%91%D7%A7-%D7%91%D7%96%D7%A0%D7%95%D7%AA/'
      },
      {
        'title': 'כ״ץ, ישראל, מעוז, עדי, אלפסי, דנה, לוי, ניר (2018). <b>מיפוי ארגוני הלהט״ב בישראל - דו״ח מסכם</b>. האגודה למען הלהט״ב ואלכא – המכון למנהיגות וממשל בג\'וינט ישראל, ירושלים. נדלה מתוך',
        'url': 'https://a9991848-b055-4c6f-a966-a6bdabf09321.filesusr.com/ugd/be9e5d_e13bb06adc274327b97bb41c199efc0c.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '25/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1983,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '24/12/2018'
    },
    'description': '‏״עלמה – אומנות נשית ברוח יהודית״ (ע״ר 580650455) נוסדה באופקים בשנת 2017 על ידי מירב חמו, אשה צעירה חרדית ‏מזרחית מקומית. מטרת העמותה ליצור מרחב והזדמנות ליצירה אמנותית של ועבור נשים בפריפריה. ‏מטרות העמותה הן: ״תיאטרון עלמה - אמנות נשית ברוח יהודית. העצמה נשית ועידוד יצירה ישראלית מקורית. קידום אומנויות ורוח על בסיס מקורות יהודיים השואבים השראה מהתנ״ך ומהמסורת היהודית. חיזוק תרבות וערכים דרך עולם הבמה, חיזוק התרבות בפריפריה, ובכל מקום אחר בארץ. נתינת במה ליוצרות ואמניות ונשות רוח. הנגשת תרבות בפריפריה ובכל רחבי הארץ. עידוד צריכה תיאטרון נשי ומענה לקהל נשי. שאיפה לחיבור ואימוץ נערות בסיכון והכשרתן לעולם הבמה. מתן מלגות לתלמידות.״',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'תיאטרון'
      ],
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ]
    ],
    'id': 'SW35',
    'is_active': true,
    'keywords': [
      'אמנות',
      'פריפריה',
      'העצמה',
      'תמיכה נפשית',
      'צעירות במצבי סיכון',
      'נערות במצוקה',
      'דת',
      'יהדות',
      'מלגות'
    ],
    'name': 'עלמה אומנות נשית ברוח יהודית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'אופקים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'תיאטרון',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>״עלמה״ – אומנות נשית ברוח יהודית (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580650455'
      },
      {
        'title': 'תיאטרון עלמה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/ALMAtheaterOF/'
      },
      {
        'title': 'תיאטרון עלמה (2018, 22 נובמבר). <b>תיאטרון עלמה ״מילים של אחרים ״- טריילר</b> (סרטון). נדלה מתוך',
        'url': 'https://www.youtube.com/watch?v=u-pvMJo3oXw&feature=youtu.be&fbclid=IwAR284YgpedfyEv6zf9-ZDv4zlqeJ4qUZ_4tQTb5mSSjwXCwdJiTp1zv9DAs'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '03/02/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2017,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': 'העמותה להעצמה כלכלית לנשים החלה את דרכה בשנת 1997 על ידי קבוצת נשים חיפאיות, פעילות בארגוני נשים ובעיקר בארגון ״אישה לאישה״ ונרשמה כעמותה (ע״ר 580350460) בשנת 2000. מקימות העמותה הן: איילת אילני, רותי גור, פולה מילס, ד״ר חנה ספרן, נטלי רובין, ד״ר שרון הלוי וברכה זיו ז״ל. מטרת העמותה: לקדם את אפשרויותיהן הכלכליות והחברתיות של נשים החיות בפגיעות לעוני, באמצעות פיתוח יזמות עסקית. האסטרטגיה המנחה את העמותה היא ״מיקרו-יזמות״ - סיוע לנשים לפתוח עסקים זעירים המתבססים על כישורים ויכולות המצויים בידיהן. תכנית הדגל של העמותה היא ״עסק משלך״ המיועדת לנשים המעוניינות להקים עסק עצמאי כמקור פרנסה, או בעלות עסק עצמאי בתחילת הדרך. התכנית כוללת הכשרה עסקית והעצמה אישית ופונה בעיקר לנשים מהפריפריה הכלכלית והגיאוגרפית בישראל. פעילות העמותה גם כוללת מתן הלוואות ללא ריבית ותמיכה בעסקים קטנים של נשים בעלות הכנסה נמוכה ופעילות לעידוד מדיניות וחקיקה בנושא יזמות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ]
    ],
    'id': 'YB66',
    'is_active': true,
    'keywords': [
      'מימון זעיר',
      'נשות עסקים',
      'פריפריה',
      'עוני',
      'הלוואות'
    ],
    'name': 'עמותה להעצמה כלכלית של נשים',
    'name_ar': 'جمعية التمكين الاقتصادي للنساء',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.womensown.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותה להעצמה כלכלית לנשים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580350460'
      },
      {
        'title': 'העמותה להעצמה כלכלית לנשים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/womensown.org.il/'
      },
      {
        'title': 'סער, עמליה (2010). יזמות זעירה של נשים כמסלול ניעות חברתית ,מספר היבטים פרדוקסלים. <b>סוציולוגיה ישראלית, י״א</b>(2), 441–462.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1997,
    'year_registered': 2000
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '22/01/2019'
    },
    'description': 'ה״עמותה לפסיכוסומטיקה במילדות וגניקולוגיה בישראל״ נוסדה ב-1996 (נרשמה כעמותה ב-1997, ע״ר 580295244) כעמותת-בת לארגון הבין-לאומי לפסיכוסומטיקה במיילדות וגינקולוגיה (International Society of Psychosomatic Obstetrics and Gynaecology), ביוזמת פרופ\' דליה מררי וד״ר יהודית אכמון, במטרה להעמיק את הבנת הקשר בין המרכיבים הפיזיולוגיים-ביולוגיים לבין המרכיבים הנפשיים בבריאות האישה, ולהפיץ את המידע בתחום זה בקרב אנשי המקצוע. העמותה רשומה באוניברסיטת תל אביב ומקדמת את מטרותיה באמצעות כנסי מדעי שנתי בבלינסון, ימי עיון, הוראת התחום, הקמת מאגר מחקרים, הפצת ניירות עמדה וניוזלטר רבעוני.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ],
      [
        'השכלה גבוהה ומחקר',
        'אגודות מקצועיות'
      ]
    ],
    'id': 'YH182',
    'is_active': true,
    'keywords': [
      'בריאות נשים',
      'בריאות הנפש',
      'מיילדות',
      'גניקולוגיה',
      'טכנולוגיות פריון'
    ],
    'name': 'עמותה לפסיכוסומטיקה במילדות וגניקולוגיה בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-01-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://israpog.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותה לפסיכוסומטיקה במילדות וגניקולוגיה בישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580295244'
      },
      {
        'title': 'דליה מררי. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%93%D7%9C%D7%99%D7%94_%D7%9E%D7%A8%D7%A8%D7%99'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/03/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1996,
    'year_registered': 1997
  },
  {
    'activity_kinds': [
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '10/04/2019'
    },
    'description': 'ה״עמותה לשיוויון ולאחדות נשים בישראל״ (ע.ר. 580309433) נוסדה בשנת 1998 ומקיימת פעילות בכפר ראמה ובע\'ג\'ר. מטרות העמותה הן״ קידום נושא שיוויון ואחדות הנשים בכלל והערביות בפרט. קידום והידוק הקשרים בין הערבים והיהודים בישראל למען דו קיום בשלום.״ פעילויות העמותה מכוונות להגברת תחושת השייכות של נשים ערביות במדינת ישראל; לטיפול בבעיית הפוליגמיה במיוחד בקרב הנשים מהמגזר הבדווי; לקידום נשים בפוליטיקה הארצית והמקומית; לקידום ועידוד השכלה בקרב נשים צעירות במגזר הערבי ועוד. העמותה מקיימת פעילות מצומצמת הכוללת הרצאות, סדנאות, סיורים וימי כיף לנשים מהמגזר הערבי בכל רחב הארץ ובעיקר בצפון. יו״ר העמותה ואחת המייסדות שלה היא סוראייה נוג\'ידאת, המכהנת כיועצת לקידום מעמד האשה במרכז השלטון המקומי.',
    'description_ar': 'جمعية للمساواة ووحدة النساء في إسرائيل (ج.م 580309433) تأسست عام 1998 وتقوم بنشاطها في قرية الرامة والغجر. هدف الجمعية هي ״ تعزيز مواضيع المساواة ووحدة النساء عموما والعربيات خصوصا. تعزيز وتقوية العلاقات بين العرب واليهود في إسرائيل من أجل التعايش السلمي ״ تهدف أنشطة الجمعية إلى زيادة الإحساس بالانتماء للمرأة العربية في دولة إسرائيل؛ معالجة مشكلة تعدد الزوجات وخاصة بين النساء البدويات؛ تشجيع المرأة في السياسة الحكومية والمحلية، تعزيز وتشجيع التعليم بين الشابات في المجتمع العربي وأكثر من ذلك. تنظم الجمعية أنشطة محدودة بما في ذلك المحاضرات وورش العمل والجولات وأيام ترفيهية للمرأة من المجتمع العربي في جميع أنحاء البلاد، وخاصة في الشمال. رئيسة الجمعية وأحد مؤسسيها هي ثريا نجيدات، التي تعمل كمستشارة لتعزيز مكانة المرأة في مركز الحكم المحلي.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ]
    ],
    'id': 'YA18',
    'is_active': true,
    'keywords': [
      'רשות מקומית',
      'פוליגמיה',
      'שוויון',
      'קידום נשים',
      'בדואיות'
    ],
    'name': 'עמותה לשיוויון ולאחדות נשים בישראל',
    'name_ar': 'جمعيه للمساواة والوحدة النسائية في إسرائيل',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ראמה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-04-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.facebook.com/pg/Association-for-Equality-and-Womens-Unity-in-Israel-340351643145393/about/?ref=page_internal'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותה לשיוויון ולאחדות נשים בישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580309433'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '30/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '15/05/2018'
    },
    'description': 'עמותת ״אוהלה״ (ע״ר 580634020) נוסדה בשנת 2016 על ידי מרוה זוהר במטרה להקים ולקדם מרחבי ידע וריפוי נשיים. מקומות של נשים עבור נשים בכל שלבי החיים. מרחבים המוקדשים להקשבה, ריפוי, לחיבור לידע נשי קדום ומחזק ולבניית קהילה. מטרות העמותה הן: ״ליצור מרחבי ריפוי נשיים - קהילתיים המאפשרים לכל נערה ואישה לחוות את עצמה כמקור הידיעה לגבי מה היא צריכה כדי ליילד ולרפא את עצמה, תוך דגש על ריפוי מאונס ומאלימות מגדרית. לחנך, להכשיר ולהפיץ ידע בקרב נשות ואנשי מקצוע, קובעי מדיניות, בני משפחה ובחברה כולה אודות דרכי טיפול פמיניסטיות - הוליסטיות בפוסט - טראומה מינית, תורת המיילדות המסורתית - קהילתית ובריאות האישה בכלל. להוות סביבת עבודה בריאה שתשמש מודל של טיפול עצמי ותקשורת מכבדת ומקרבת לעובדות, למתנדבות ולכל השותפות בעמותה.״ פרויקט הדגל של העמותה הוא פרויקט אמ״ן - אדמת מרפא נשית, כפר לטיפול ושיקום נפגעות תקיפה מינית ואונס אשר החל לפעול בשנת 2019.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'רווחה וקהילה',
        'אלימות מינית'
      ]
    ],
    'id': 'YB91',
    'is_active': true,
    'keywords': [
      'אונס',
      'תרפיה',
      'שיקום',
      'תמיכה נפשית',
      'דיור'
    ],
    'name': 'עמותת אוהלה - לקידום מרחבי ידע וריפוי קהילתיים – נשיים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נטף',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.ohela.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת אוהלה – לקידום מרחבי ידע וריפוי קהילתיים-נשיים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580634020'
      },
      {
        'title': 'אמ״ן -אדמת מרפא נשית, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pg/WomenHealingCenters/about/?ref=page_internal'
      },
      {
        'title': 'לנדסמן, צבי (2018, 16 פברואר). <b> אמ״ן - אדמת מרפא נשית</b> (סרטון). נדלה מתוך',
        'url': 'https://www.youtube.com/watch?v=pJFgARKeORg'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '10/07/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '19/07/2018'
    },
    'description': '״עמותת אלאנואר לקידום מעמד האשה באום אלפאחם״ (ע״ר 580361962) נרשמה בשנת 2000 במטרה לפעול לשם: ״יצירת בסיס להתארגנות קהילתית לייצוג אוכלוסיית הנשים באום אל-פחם. העלאת המודעות לזכויות האשה בחברה. הקמת מרכז רב תרבותי ורב תכליתי לנשים. סיוע לאוכלוסיית הנשים החשופה להתעללות פיזית ולנערות במצוקה. סיוע לילדים בסיכון.״ לעמותה פעילות רבה המרוכזת באום אל-פאחם וכוללת הפעלת מעון יום, גני ילדים ומעון רב-תכליתי. בין השנים 2008-2017 הפעילה העמותה את המרכז להתפתחות הילד כחלק ממכרז של משרד הבריאות.',
    'description_ar': '״جمعية الانوار لتطوير مكانة المرأة في ام الفحم״ (ج. م580361962) - سجلت في عام 2000 بهدف انشاء أساس للتنظيم المجتمعي لتمثيل النساء في ام الفحم. زيادة الوعي حول حقوق المرأة في المجتمع، انشاء مركز متعدد الثقافات ومتعدد الأوجه للنساء. مساندة النساء المعرضات للإيذاء الجسدي والشابات في حالة الضائقة. ومساعدة الأطفال المعرضين للخطر. للجمعية نشاطات متعددة ومركزها في ام الفهم وتشمل تشغيل ملجأ يومي، حضانات أطفال، وملجأ متعدد الأغراض. بين أعوام 2008-2017 شغلت الجمعية مركز تطور الطفل كجزء من مناقصة وزارة الصحة.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ]
    ],
    'id': 'SA32',
    'is_active': true,
    'keywords': [
      'מוגבלות',
      'ילדים'
    ],
    'name': 'עמותת אלאנואר לקידום מעמד האשה באום אלפחם',
    'name_ar': 'الأنوار - جمعية لتطوير مكانة المرأه في ام الفحم',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'אום אל-פחם',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעונות ומשפחתונים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת אלאנואר לקידום מעמד האישה באום אלפחם (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580361962'
      },
      {
        'title': 'المركز العلاجي لتطور الطفل- ام الفحم، המרכז הטיפולי להתפתחות הילדם- א.א.פחם, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/childcenterAAF/'
      },
      {
        'title': 'מפתח התקציב. <b>עמותת אלאנואר לקידום מעמד האישה באום אלפחם (ע״ר)</b>. נדלה מתוך',
        'url': 'https://next.obudget.org/i/org/association/580361962'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '11/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/08/2019'
    },
    'description': 'עמותת ״ברכה - התמודדות והקטנת הסיכון של סרטן תורשתי״ (ע״ר 580508075) נוסדה בכפר סבא בשנת 2009 והינה הארגון היחיד בישראל שמטרתו העיקרית הינה הגדלת המודעות לסרטן שד ושחלות תורשתי ולתמיכה וסיוע לכל קהילת הנשאים ונשאיות המוטציה בגן BRCA וגנים נוספים. פעילותה מוקדשת להגדלת המודעות לבדיקות הגנטיות, למניעת הסרטן התורשתי וכן לשיפור חיי כל מי שנפגע/ה מסרטן זה. עמותת ברכה פועלת על בסיס התנדבותי ותרומות בלבד ומקיימת פעילות בכל מגזרי האוכלוסיה בישראל: במגזר היהודי ובמגזר הערבי, כולל ייעוץ לגברים נשאים. מטרות העמותה הן: ״שיפור איכות החיים של משפחות בהם קיים רקע מורש של סרטן שד ושחלות. הגדלת המודעות בקרב הציבור לקיומן של בדיקות גנטיות לסרטן מורש של שד ושחלות. מתן מידע על ייעוץ גנטי לסרטן שד ושחלות מורשים. מתן מידע לגבי האפשרויות השונות להקטנת הסיכון לפתח סרטן שד ושחלות״. העמותה מספקת מידע רפואי ומענה אישי דרך אתר האינטרנט, קבוצת פייסבוק והטלפון ומקיימת כנסים וארועים לנשאיות של גן BRCA.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'SA160',
    'is_active': true,
    'keywords': [
      'סרטן השד',
      'קו סיוע',
      'מידע'
    ],
    'name': 'עמותת ברכה - התמודדות והקטנת הסיכון של סרטן תורשתי',
    'name_ar': null,
    'name_change_year': 2016,
    'name_common': null,
    'name_past': 'ברכה- התמודדות והקטנת הסיכון של סרטן שד ושחלות משפחתי',
    'name_replaced_by': null,
    'official_address': 'כפר סבא',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-08-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.bracha.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת ברכה – התמודדות והקטנת הסיכון של סרטן תורשתי (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580508075'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/08/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2009,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '22/06/2018'
    },
    'description': 'עמותת יסמין (ע״ר 580566040) החלה את דרכה בשנת 2006 כפרויקט של ה״מרכז היהודי-ערבי לפיתוח כלכלי״ בגבעת חביבה. על פי נתוני רשם העמותות, העמותה נרשמה בשנת 2012 בטייבה בכתובת של כיראם בלעום המייסדת והמנכ״לית. מטרות העמותה הן: ״קידום ערכי השיוויון בין המינים בחברה ע״י שיפור המצב הכלכלי והחברתי של הנשים, דרך עידוד יזמות עסקית נשית, חינוך למצויינות בתחום העסקים וחונכות אישית עם נשים בעלות עסקים. המרצת תהליכי הצמיחה הכלכלית דרך עידוד נשים בעלות עסקים, העצמתן, פיתוח כישוריהן ויכולותיהן, הכשרה ועידוד מצויינות בן.״ פעילויות העמותה כוללות קורסים, סדנאות, ייעוץ וכנסים והן נערכות בשיתוף פעולה עם גורמים עסקיים (בנק הפועלים, בזק וכיוב) ורשויות מקומיות ומכוונים להעצמה כלכלית של נשים בעוני, הכשרת דירקטוריות, מתן הלוואות זעירות לנשים ומתן סיוע בגיבוש תכניות עסקיות לנשים יזמיות. קהל היעד של העמותה הוא נשים ערביות ויהודיות.',
    'description_ar': 'ياسمين – لتطوير المصالح الاقتصادية لصاحبات الاعمال اليهوديات – العربيات بدأ في عام 2006 كمشروع للمركز اليهودي العربي للتنمية الاقتصادية في جفعات حبيبا. وفقًا لبيانات من سجل الجمعيات، تم تسجيل الجمعية في مدينة الطيبة عام 2012 على عنوان اكرام بلعوم، المؤسسة والرئيسة التنفيذية. أهداف الجمعية هي: ״تعزيز المساواة بين الجنسين في المجتمع من خلال تحسين الوضع الاقتصادي والاجتماعي للمرأة، من خلال تشجيع ريادة اعمال النساء، والتعليم للتميز في الأعمال التجارية والتوجيه الشخصي مع سيدات الأعمال. تعزيز عمليات النمو الاقتصادي من خلال تشجيع وتمكين وتطوير مهارات النساء وقدراتهن ومهاراتهن. تشمل أنشطة الجمعية دورات وورش عمل واستشارات ومؤتمرات وتُجرى بالتعاون مع جهات تجارية (بنك العمال، بيزك..) والسلطات المحلية التي تهدف إلى التمكين الاقتصادي للنساء اللواتي يعانين من الفقر وتدريب المديرين وتوفير التمويل وقرض صغير للنساء وتقديم المساعدة في صياغة خطط الأعمال للنساء. الجمهور المستهدف للجمعية هو المرأة العربية واليهودية.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ]
    ],
    'id': 'YH27',
    'is_active': true,
    'keywords': [
      'יזמות',
      'רישות',
      'נשות עסקים',
      'מנהיגות'
    ],
    'name': 'יסמינה - לקידום יזמות ובעלות עסקים יהודיות וערביות',
    'name_ar': 'ياسمين – لتطوير المصالح الاقتصادية لصاحبات الاعمال اليهوديات – العربيات',
    'name_change_year': null,
    'name_common': 'עמותת יסמין',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'גבעת חביבה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://jasmine.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>יסמינה – לקידום יזמות ובעלות עסקים יהודיות וערביות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580566040'
      },
      {
        'title': 'דגן-בוזגלו, נוגה (2016). <b>עסק משלה- עידוד עסקים קטנים בבעלות נשים בישראל ובמדינות המפותחות, מה נעשה ומה נדרש עוד לעשות</b>. מרכז אדוה וקואליציית שותפות.',
        'url': 'http://adva.org/wp-content/uploads/2017/02/%D7%A2%D7%A1%D7%A7-%D7%9E%D7%A9%D7%9C%D7%94-1.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/04/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2006,
    'year_registered': 2012
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '26/06/2018'
    },
    'description': 'עמותת כ״ן-כוח נשים לקידום מנהיגות נשים בישראל (WePower) (ע״ר 580357929) נוסדה בשנת 2000 על ידי מיכל יודין במטרה לקדם נשים למוקדי קבלת ההחלטות בישראל, בדגש על הזירה הציבורית והפוליטית. העמותה פועלת להגדלת מספר הנשים המתמודדות והנבחרות לכנסת ולרשויות המקומיות וכן לקידום נשים לתפקידי ניהול בכירים, לדירקטוריונים, ולשולחנות קבלת ההחלטות.\nהעמותה פועלת בפריסה ארצית בשיתוף משרדי הממשלה, מרכז השלטון המקומי, מוסדות אקדמיים, רשויות מקומיות בכל רחבי הארץ, ושותפים מהמגזר השלישי והעסקי.\nהעמותה מאמינה כי כאשר נשים יהיו בעמדות כוח הן יוכלו להשפיע על חלוקת המשאבים באופן ישיר וכך לענות באופן מיטבי על צרכיהן של נשים בחברה ולהשמיע את קולן, מתוך תפיסה כי ייצוג שוויוני בדרג מקבלי ההחלטות יעלה את מדדי השוויון המגדרי בישראל ויביא לידי שינוי חברתי בסדר העדיפויות האזרחי ובחלוקת המשאבים באופן שיענה על צרכי כלל האוכלוסיה בישראל.\nפעילות העמותה כוללת קורסים והכשרות לנשים שמטרתם עידוד נשים להיכנס למוקדי קבלת החלטות, קידום חקיקה, ארגון ימי עיון, כנסים וקמפיינים. בשנת 2016 הציגה העמותה את מדד המגדר בשלטון המקומי. נכון ל-2018 מנכ״לית העמותה היא ד״ר מזל שאול. לפניה ניהלו את כ״ן ליאל אבן-זהר ויפעת זמיר.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'ייצוג הולם'
      ]
    ],
    'id': 'YH32',
    'is_active': true,
    'keywords': [
      'ייצוג הולם',
      'בחירות',
      'רשות מקומית',
      'קבלת החלטות',
      'שוויון מגדרי',
      'קידום נשים'
    ],
    'name': 'כ״ן - כוח נשים לקידום מנהיגות נשים בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'עמותת כ״ן - כוח נשים',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ייצוג הולם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.ken.org.il/index.php?language=heb'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת כ״ן – כוח נשים לקידום מנהיגות נשים בישראל</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580357929'
      },
      {
        'title': 'עמותת כ״ן - כוח נשים לקידום מנהיגות נשים בישראל. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%A2%D7%9E%D7%95%D7%AA%D7%AA_%D7%9B%22%D7%9F_-_%D7%9B%D7%95%D7%97_%D7%A0%D7%A9%D7%99%D7%9D_%D7%9C%D7%A7%D7%99%D7%93%D7%95%D7%9D_%D7%9E%D7%A0%D7%94%D7%99%D7%92%D7%95%D7%AA_%D7%A0%D7%A9%D7%99%D7%9D_%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C'
      },
      {
        'title': 'עמותת כ״ן-כוח נשים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/ken.org.il/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '12/11/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '10/01/2018'
    },
    'description': '״עמותת נשות רהט״ (ע״ר 580448520) הוקמה בשנת 2004 ונרשמה כעמותה בשנת 2005. מטרות העמותה הן: ״העצמה אישית, העלאת מודעות הנשים לכוחן וזכויותיהן; העצמה כלכלית, שילוב הנשים במעגל התעסוקה והפרנסה; קידום חינוך בקרב נשות רהט. יצירת מרכז קהילתי שיספק לנשים מרחב למפגש חברתי, תרבותי ופנאי, סיוע ותמיכה הדדית. העלאת מעמד האישה ברהט והגברת מעורבות הנשים בכל תחומי הפעילות בעיר.״ את הארגון הקימה קבוצה של נשים מרהט ופעילותה מתבססת על התנדבות, ושיתופי פעולה עם גורמים אחרים בעיר, במטרה להעצים את הנשים לחיזוק המשפחה והחברה בכללה. פעילויות העמותה כוללות קורסי תפירה ויצירה למטרות תעסוקה, תמיכה כלכלית במשפחות נזקקות, העצמה אישית, מנהיגות, התפתחות הילד ומניעת אלימות.',
    'description_ar': 'تأسست ״جمعية نساء رهط״ (ج. م580448520) في عام 2004 وتم تسجيلها كجمعية في عام 2005. أهداف الجمعية هي: ״التمكين الشخصي، رفع وعي النساء حول قوتهن وحقوقهن؛ التمكين الاقتصادي وإدماج المرأة في اطر العمل وسبل المعيشة؛ تعزيز التعليم بين نساء رهط. إنشاء مركز اجتماعي يوفر للنساء مساحة للقاء اجتماعي، ثقافي وترفيهي والمساعدة والدعم المتبادلين. بهدف تمكين المرأة لتقوية الأسرة والمجتمع ككل. تشمل أنشطة الجمعية دورات الخياطة والحياكة لأغراض التوظيف والدعم المالي للأسر المحتاجة والتمكين الشخصي والقيادة وتنمية الطفل ومنع العنف.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'YH94',
    'is_active': true,
    'keywords': [
      'אלימות',
      'בדואיות',
      'הגיל הרך',
      'גמ״ח',
      'העצמה',
      'מנהיגות'
    ],
    'name': 'עמותת נשות רהט',
    'name_ar': 'جمعية نساء رهط',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רהט',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-01-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://rwa.co.il/he/subject.asp?id=10'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת נשות רהט (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580448520'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '11/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2004,
    'year_registered': 2005
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '02/04/2020'
    },
    'description': '״עמותת נשי ערה וערערה״ (ע״ר 580139616) הוקמה בשנת 1989 במטרה ״להקים, להחזיק ולנהל גני ילדים. לשפר את מצב החינוך בגני ילדים קיימים. לנהל פעילות הדרכה לגננות למען קידום חינוך הילדים״. בשנת 1993 העמותה הפעילה 6 גני טרום חובה לגילאי 3-5 המשרתים כ-150 ילדים וילדות והועסקו בהן כ-9 גננות. בשנת 2006 הוגשה בקשה למתן צו פירוק לעמותה.',
    'description_ar': 'جمعية نساء عارة عرعرة (ج.م 580139616) تأسست عام 1989 بهدف إقامة وادارة حضانات أطفال قائمين، ادارة نشاطات ارشادية للمربيات بهدف تمكين تربية الاطفال. في عام 1993، قامت الجمعية بتشغيل 6 رياض اطفال لاجيال 3-5 سنوات والتي تخدم 150 طفل وطفلة، والتي عملت بهم 9 حاضِنات. في عام 2006 تم ارسال طلب لايقاف عمل الجمعية.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ]
    ],
    'id': 'SA185',
    'is_active': false,
    'keywords': [
      'גיל הרך',
      'מעונות יום'
    ],
    'name': 'עמותת נשי ערה וערערה',
    'name_ar': 'جمعية نساء عارة عرعرة',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ערערה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעונות ומשפחתונים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>עמותת נשי ערה וערערה</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'סבירסקי, שלמה וחזן, האלה (1993). החינוך לגיל הרך בישראל. <b>מידע על שוויון 3</b>. תל אביב: מרכז אדוה. נדלה מתוך',
        'url': 'http://adva.org/wp-content/uploads/2016/11/%D7%9E%D7%99%D7%93%D7%A2-%D7%A2%D7%9C-%D7%A9%D7%95%D7%95%D7%99%D7%95%D7%9F-3-%D7%97%D7%99%D7%A0%D7%95%D7%9A-%D7%9C%D7%92%D7%99%D7%9C-%D7%94%D7%A8%D7%9A-1.pdf'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 5649 (2007, 15 אפריל). <b>הודעות בדבר מתן צווי פירוק</b>. עמותת נשי ערה וערערה (עמותה מספר 580139616). עמ\' 2288. נדלה מתוך',
        'url': 'http://www.water.gov.il/Hebrew/Rates/DocLib/HydrologicalSituation1.pdf'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '02/04/2020'
    },
    'year_closed': 2006,
    'year_closed_text': '2006',
    'year_founded': 1989,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': 'העמותה (ע״ר 580250462) הוקמה בשנת 1994 ובשנת 1999 התפצלה למרכז הסיוע גליל גולן. מטרות העמותה הן: ״לפעול ולחתור למען שוויון בין המינים בחברה ולפעול נגד תופעות של אפליה על בסיס מיני ולשיתוף פעולה בין נשים מקבוצות שונות באיזורנו. להוות תמיכה לנשים בעמדות יצוג ולפעול על מנת למנוע אלימות פיזית, מינית ופסיכולוגית כלפי נשים. הפצת תרבות יהודית בקרב קבוצות שונות באוכלוסיה.״ פעילויות העמותה הן קהילתיות בעיקרן וכוללות הרצאות, קורסים וסדנאות בנושאים הנוגעים למנהיגות והעצמה, בריאות האשה, חינוך למניעת אלימות כלפי נשים. העמותה מקיימת גם סיורים ברחבי הארץ לנשים מקריית שמונה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ],
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ]
    ],
    'id': 'YB55',
    'is_active': true,
    'keywords': [
      'פריפריה',
      'קורסים',
      'שוויון הזדמנויות',
      'העצמה',
      'פנאי'
    ],
    'name': 'עמותת פורום הנשים קרית שמונה ואצבע הגליל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'קרית שמונה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת פורום הנשים קרית שמונה ואצבע הגליל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580250462'
      },
      {
        'title': 'דוגרינט: אתר חברתי של תושבי הגליל (אתר). יום האישה הבינלאומי – קריית שמונה [הזמנה, 2010].',
        'url': 'http://dugrinet.co.il/node/7927'
      },
      {
        'title': 'מרכז סיוע לנפגעות תקיפה מינית ואונס, הגליל והגולן ע.ר. (אתר). אודות מרכז הסיוע לנפגעות ולנפגעי תקיפה מינית, גליל גולן. נדלה מתוך',
        'url': 'https://www.1202.org.il/local/galil-golan/about'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1994,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'אקטיביזם רשת'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '07/01/2019'
    },
    'description': 'עמותת ״שכם אחד - ליווי ותמיכה״ (ע״ר 580593481) הוקמה בערד בשנת 2014 על מנת לסייע ולתמוך בשורדות פגיעות מיניות ‏ואלימות מגדרית מתוך החברה החרדית. מטרות העמותה הן: ״סיוע כספי למטופלות. הנגשת חומרים מקצועיים והוצאת ניוזלייטר חודשי. נקיטת אמצעים למזעור היקף הפגיעה במגזר. מתן שכם ותמיכה לנשים ובנות חרדיות המתמודדות עם השלכות פגיעה מינית. חינוך למוגנות במוסדות על יסודי דתי-חרדי. כתיבת תוכניות והפעלתן״. העמותה מפעילה אתר אינטרנט המספק מידע, הצעות לדרכי ‏התמודדות, פורומים שמשמשים פלטפורמת שיח ותמיכה (לשורדות, להורים לשורדות ומטפלות, ולצוות ‏חינוכי), טופס פניה לבקשת מלגות לסיוע כספי במימון טיפול פסיכולוגי, וכן הפקת שני פרסומים שאחד מהם ‏נכתב ע״י שורדות עצמן כתהליך העצמה ושיתוף בשם ״שכ״ם – שורדות כותבות מניסיון״.‏',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'דת ומעמד אישי',
        'אלימות'
      ]
    ],
    'id': 'SW45',
    'is_active': true,
    'keywords': [
      'אונס',
      'אינטרנט',
      'טיפול נפשי',
      'הסברה',
      'העצמה',
      'טראומה',
      'דת'
    ],
    'name': 'עמותת שכם אחד - ליווי ותמיכה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ערד',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2019-01-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.shechem1.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת שכם אחד – ליווי ותמיכה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580593481'
      },
      {
        'title': 'עמותת שכם אחד - ליווי ותמיכה (2019, 5 ינואר). הפרטים אומתו בתכתובת דוא״ל עם נציגת הארגון.'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/05/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '25/10/2018'
    },
    'description': '״עמית- עמותה לשיקום אסירות משוחררות״ (580206654) נרשמה על ידי שרונה חריש והיתה קשורה לפעילות של עמותת ״גגון״ ועמותת ״לשובע״ המפעילה מערך סיוע לנזקקים, כולל בתי תמחוי ומקלטים לדרי רחוב. העמותה הוקמה במטרה לשמש כאגודת ידידים למעון לשיקום אסירות משוחררות שהוקם בתל אביב על ידי הרשות לשיקום האסיר בהובלתה של ענת גור. מטרות העמותה היו ״לדאוג לקליטתה של האסירה המשתחררת בקהילה, לרבות שיקומה בתחום התעסוקה והדיור, הקמת מעונות לאסירות משוחררות חסרות בית לתקופת מעבר והגברת המודעות הציבורית לבעיות שיקום האסירה.״ העמותה נמחקה מפנקס העמותות בשנת 2004. כתוצאה מקשיים בירוקרטיים, בסופו של דבר עיקר פעילות העמותה בוצע דרך עמותת ״גגון״.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ]
    ],
    'id': 'SA72',
    'is_active': false,
    'keywords': [
      'אסירות',
      'שיקום',
      'תעסוקה',
      'העלאת מודעות',
      'זכויות',
      'אלימות',
      'דיור'
    ],
    'name': 'עמית - עמותה לשיקום אסירות משוחררות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת גן',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'התמכרויות ושיקום',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>עמית – עמותה לשיקום אסירות משוחררות</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'עמית - עמותה לשיקום אסירות משוחררות (2019, 7 נובמבר). הפרטים אומתו בשיחת טלפון עם נציגת הארגון.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '25/10/2018'
    },
    'year_closed': 2004,
    'year_closed_text': '2004',
    'year_founded': 1992,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'שירותים משפטיים',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '26/06/2018'
    },
    'description': 'עמותת ״ערוס אלבחר לאישה ביפו״ (ע״ר 580477966) נוסדה בשנת 2007 על ידי נשים ערביות, תושבות העיר יפו. העמותה נוסדה לאור העדר פתרונות מספקים בקהילה ועל מנת לקדם את מעמד האשה הערבייה וזכויותיה. מטרות העמותה, ששמה בעברית הוא ״כלת הים״ הן: ״לימוד קורסים בעברית וערבית לנשים. קידום מעורבותן של הנשים בחיי הקהילה ביפו באמצעות פרויקטים התנדבותיים וחיפוש עבודה. הגברת מודעות הנשים לזכויותיהן במישורים השונים: עבודה משפחה וחברה. קורסי יזמות עסקית ועזרה במציאת עבודה לנשים. תוכניות העשרה לנשים בתחום החינוך והתרבות״. פעילויות הארגון מתקיימות בבית ערוס אלבחר המשמש כמרחב נשי, מוגן ומעצים וכוללות קורסים והרצאות בתחומים שונים: חינוך פיננסי, הוראת העברית והאנגלית, חיזוק ידיעת השפה הערבית; הפעלת מרכז זכויות לנשים וקליניקה משפטית; ליווי וייעוץ בתעסוקה ופעילות קהילתית הכוללת תערוכות וירידים.',
    'description_ar': 'جمعية عروس البحر للمرأة في يافا- تأسست عام 2007 من قبل نساء عربيات، من سكان مدينة يافا. تأسست الجمعية بسبب عدم وجود حلول مرضية في المجتمع وتعزيز مكانة وحقوق المرأة العربية. أهداف الجمعية: ״تعلم دورات في اللغة العبرية واللغة العربية للنساء. تعزيز مشاركة المرأة في الحياة المجتمعية في يافا من خلال المشاريع التطوعية والبحث عن عمل. زيادة وعي المرأة بحقوقها في مختلف المجالات: العمل الأسرة والمجتمع. دورات ريادة الأعمال وتساعد في العثور على عمل للنساء. برامج تطوير للنساء في مواضيع التربية والثقافة.\n تتم أنشطة المنظمة في بين عروس البحر، الذي يعد مساحة نسائية محمية وتمكينية وتتضمن دورات ومحاضرات في مختلف المجالات: الادارة المالية، التعليم باللغة العبرية والإنجليزية، وتعزيز المعرفة باللغة العربية؛ تشغيل مركز لحقوق المرأة وعيادة قانونية؛ مرافقة وتقديم المشورة للعمالة والأنشطة المجتمعية التي تشمل معارض تشغيلية.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'חינוך',
        'צמצום פערים בחינוך'
      ],
      [
        'תעסוקה ועבודה',
        'השמה וליווי בתעסוקה'
      ]
    ],
    'id': 'YH31',
    'is_active': true,
    'keywords': [
      'ערביות',
      'זכויות',
      'סיוע משפטי',
      'השלמת השכלה',
      'תרבות',
      'אמנות',
      'סחר הוגן',
      'מלאכות מסורתיות'
    ],
    'name': 'ערוס אלבחר לאישה ביפו',
    'name_ar': 'جمعية عروس البحر للمرأه في يافا',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-10-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://arous-elbahar.org/he/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת ערוס אלבחר לאישה ביפו (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580477966'
      },
      {
        'title': '(2009, 9 אפריל). ערוס אלבחר. <b>פורטל יפו</b>. נדלה מתוך',
        'url': 'http://www.yaffo.co.il/article_k.asp?id=190'
      },
      {
        'title': 'Arous Elbahar - ערוס אלבחר - عروس البحر, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/arous.elbahar.jaffa/'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2007,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'מחאה'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '31/12/2018'
    },
    'description': 'פאנורמה - קהילה בי ופאנסקסואלית פמיניסטית הוקמה ב-2009 על ידי שירי איזנר במטרה להעלות את הנראות והמודעות לביסקסואליות בקהילה הלהט״בית ובחברה. שנות פעילותו המרכזיות של הארגון היו 2009-2012 והוא פעל בעיקר בתל אביב. פעילויות הארגון כללו ארגון הקרנות של סרטים ביסקסואלים, מסיבות קהילתיות, יום עיון ביסקסואלי, עבודה תקשורתית ועבודה מול ארגונים קהילתיים לשיפור המענה לקהילה הביסקסואלית, מפגשים חברתיים, השתתפות בהפגנות ומצעדי גאווה ודוברות באירועים. בשנים 2013-2014, הפעילות של הארגון הלכה ודעכה, וכאשר איזנר פרשה מפעילות פוליטית, הוא התפוגג והוחלף על ידי קבוצות פעילות ביסקסואליות בפייסבוק ובארגונים קהילתיים.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'LR35',
    'is_active': false,
    'keywords': [
      'ביסקסואליות',
      'מחאה',
      'פמיניזם',
      'קהילה',
      'גאווה',
      'תקשורת'
    ],
    'name': 'פאנורמה - קהילה בי ופאנסקסואלית פמיניסטית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'המידע מבוסס על תכתובות מיילים עם פרוטוקולים של ישיבות מהשנים 2009–2012.'
      },
      {
        'title': 'מורנו, עדי (2011). <b>גאים במרכז: משילות ניאו-ליברלית ותהליכי אינדיבידואליזציה בראי קהילת הלהט״ב בישראל</b>. (עבודת גמר לקבלת תואר ״מוסמך למדעי החברה״). אוניברסיטת תל אביב.'
      },
      {
        'title': 'Eisner, Shiri (2013). <b>BI notes for a bisexual revolution</b>. Berkley, California: Seal Press.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '31/12/2018'
    },
    'year_closed': 2014,
    'year_closed_text': '2014',
    'year_founded': 2009,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '25/06/2018'
    },
    'description': 'פוליטיקאיות צעירות הוא מיזם חברתי שהחל לפעול באוניברסיטה העברית בשנת 2015 ומאז מקיים מפגשים וקורסי הכשרה לסטודנטיות גם באוניברסיטת בן-גוריון ובקמפוסים אחרים בשיתוף פעולה עם התאחדות הסטודנטים הארצית ואגודות הסטודנטים המקומית. מטרת המיזם היא לשלב נשים צעירות בפוליטיקה מקומית וארצית.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה בשיתוף אקדמי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ],
      [
        'השכלה גבוהה ומחקר',
        'אקדמיה, חברה וקהילה'
      ],
      [
        'נערות וצעירות',
        'מנהיגות'
      ]
    ],
    'id': 'YB108',
    'is_active': true,
    'keywords': [
      'סטודנטיות',
      'מנהיגות',
      'אקטיביזם'
    ],
    'name': 'פוליטיקאיות צעירות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'התארגנות שאינה עמותה',
      'אקדמי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'קידום מנהיגות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-07-30'
    },
    'sources': [
      {
        'title': 'פוליטיקאיות צעירות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/youngpoliticaisrael/'
      },
      {
        'title': 'האגודה הסטודנטיאלית, אוניברסיטת בן-גוריון בנגב (אתר). <b>פוליטיקאיות צעירות</b>. נדלה מתוך',
        'url': 'https://bgu4u.co.il/%D7%AA%D7%90%D7%99%D7%9D-%D7%A1%D7%98%D7%95%D7%93%D7%A0%D7%98%D7%99%D7%90%D7%9C%D7%99%D7%99%D7%9D/%D7%A4%D7%95%D7%9C%D7%99%D7%98%D7%99%D7%A7%D7%90%D7%99%D7%95%D7%AA-%D7%A6%D7%A2%D7%99%D7%A8%D7%95%D7%AA/'
      },
      {
        'title': 'סניור שניאור, ניצן (2018, 27 מרץ). לפוליטיקה יש מחיר, וההחלטה לשלם אותו משחררת מכבלים וחסמים. <b>Mako גאווה</b>. נדלה מתוך',
        'url': 'https://www.mako.co.il/good-news-social/Article-d76c4eda8186261006.htm'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '09/04/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'אקטיביזם רשת',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '30/07/2018'
    },
    'description': '״פוליטיקלי קוראת״ היא כלי תקשורת פמיניסטי המפרסם תוכן מקורי ומתורגם בנושאי פמיניזם וזכויות נשים באתר אינטרנט עצמאי ובדף פייסבוק. האתר ודף הפייסבוק משמשים כמרחב לדיונים של הקהילה הפמיניסטית בנושאים מגוונים ונועדו לבנות אלטרנטיבה תקשורתית לתקשורת המרכזית שתבטא את קולן ונקודת מבטן של נשים על ידי כתבות, תחקירים ופוסטים. האתר מבקש ״להביא לקדמת הבמה קולות של נשים מכל שכבות האוכלוסייה ומכל המגזרים״. בשנת 2018 הצליחה הקבוצה לגייס מימון ראשוני בפרויקט גיוס המונים לצורך הקמת גוף תקשורת עצמאי והפכה לעמותה (ע״ר 580655660) שמטרותיה הן: ״פוליטיקלי קוראת״ תהיה ארגון חדשותי פמיניסטי גדול, בנוף התקשורת הישראלי, שפונה לקהל הרחב, משפיעה על סדר היום הציבורי, ומתנהלת בצורה פמיניסטית ובת קיימא. הנגשת רעיונות פמיניסטיות ומתן נקודת מבט פמיניסטית על אירועים אקטואליים״. מייסדות העמותה הן ליאן רם, ליאור אלפנט, תמי דינס ומאיה רומן.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תקשורת'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'תרבות וספורט'
      ]
    ],
    'id': 'SA42',
    'is_active': true,
    'keywords': [
      'אינטרנט',
      'היסטוריה',
      'מגזין',
      'מידע',
      'עיתונאיות',
      'פוליטיקה',
      'פמיניזם',
      'פנאי',
      'קולנוע'
    ],
    'name': 'פוליטיקלי קוראת',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'אקטיביזם רשת',
    'primary_field_of_activity': 'תקשורת',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-07-30'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://politicallycorret.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>פוליטיקלי קוראת (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580655660'
      },
      {
        'title': 'פוליטיקלי קוראת, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/politicallycorret/'
      },
      {
        'title': 'פוליטיקלי קוראת (2018, 30 יולי). הפרטים אומתו בתכתובת דוא״ל עם נציגת הארגון.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '30/07/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': 2018
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחאה',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '16/01/2019'
    },
    'description': 'פורום אדום-ורוד, הוקם במפלגת חד״ש ב - 2003. הוא פעל במשך כעשור והיה התא המפלגתי הגאה השני שהתקיים בישראל. לא ברור מתי בדיוק ומדוע הפסיק הפורום את פעילותו, מאחר ומדובר היה בתהליך של דעיכה הדרגתית. הפורום פעל לקידום הקהילה הגאה בתוך המפלגה ומחוצה לה, וקשר בין המאבק הלהט״בי למאבקים אחרים של צדק חברתי וזכויות אדם. לאורך שנות פעילותו ארגן הפורום שני כנסים משמעותיים, הראשון עסק בזכויותיהם של להט״בים פלסטינים (2004) והשני בזכויות החברתיות של הקהילה הגאה (2010). ב - 2009, בעקבות הרצח בבר נוער, הפורום ארגן את המפגש הראשון בין חבר כנסת ערבי, עפו אג׳בריה, לבין הקהילה הגאה הערבית ואגודת הלהט״ב. הפורום אחראי להוספתם של סעיפים רבים הקשורים בקהילה הגאה למצע המפלגה, כולל הדרישה להכרה במשפחות חד-מיניות.',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'להט״ב',
        'פוליטיקה ומנהיגות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ]
    ],
    'id': 'LR46',
    'is_active': false,
    'keywords': [
      'חקיקה',
      'כנסת',
      'גאווה',
      'מצעד',
      'זכויות להט״ב',
      'תאים מפלגתיים'
    ],
    'name': 'פורום אדום-ורוד - חד״ש',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2019-01-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://adomvarod.wordpress.com/'
      },
      {
        'title': 'גרוס, אייל (2016). הפוליטיקה של זכויות להט״ב: בין (הומו) נורמטיביות ו(הומו) לאומיות לפוליטיקה קווירית. בתוך: גרוס, אייל, זיו, עמליה ויוסף, רז (עורכים), <b>סקס אחר - מבחר מאמרים בלימודים להט״בים וקוויריים ישראליים</b> (עמ\' 183–245). תל אביב: רסלינג.'
      },
      {
        'title': 'ארליך, גיא (2012, 16 נובמבר). פתק ורוד: הפוליטיקאים מחזרים אחר הקהילה הגאה. <b>הארץ</b>. נדלה מתוך',
        'url': 'https://www.haaretz.co.il/hblocked?returnTo=https%3A%2F%2Fwww.haaretz.co.il%2Fgallery%2Fnight-life%2F1.3411660'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '26/01/2019'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 2003,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחאה',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '16/01/2019'
    },
    'description': 'פורום גאות במרצ הוקם בשנת 1996 והיה התא המפלגתי הראשון לזכויות להט״ב בישראל. הפורום פועל מאז באופן סדיר לקידום זכויות הקהילה הלהט״בית בתוך המפלגה ומחוצה לה. מתוך כך, הוא תומך ביוזמות חקיקה ומאבקים ציבוריים. בנוסף הפורום, הפועל בפריסה ארצית, מארגן פעילויות חברתיות לפעילים במפלגה ומפגשים של חברי הקהילה הלהט״בית עם חברי הכנסת מטעם המפלגה. הפורום משתתף במצעדים ואירועי מחאה קהילתיים.',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'להט״ב',
        'פוליטיקה ומנהיגות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ]
    ],
    'id': 'LR45',
    'is_active': true,
    'keywords': [
      'חקיקה',
      'כנסת',
      'גאווה',
      'מצעד',
      'זכויות להט״ב',
      'תאים מפלגתיים'
    ],
    'name': 'פורום גאות - מרצ',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'גאוּת - הפורום הגאה במרצ. עמוד פייסבוק.',
        'url': 'https://www.facebook.com/meretzlgbt/?__tn__=%2Cd%2CP-R&eid=ARAvXpn43dUisCTxejjPfGg9DyT6Iv7HoycQmfbqlBYRypTeQ6kur3EVoCZb2Wv3aeyr7LIEklQLLwRW'
      },
      {
        'title': 'גרוס, אייל (2016). הפוליטיקה של זכויות להט״ב: בין (הומו) נורמטיביות ו(הומו) לאומיות לפוליטיקה קווירית. בתוך: גרוס, אייל, זיו, עמליה ויוסף, רז (עורכים), <b>סקס אחר - מבחר מאמרים בלימודים להט״בים וקוויריים ישראליים</b> (עמ\' 183–245). תל אביב: רסלינג.'
      },
      {
        'title': 'פזמוני-לוי, אורן, שילה, גיא ופנחסי, בתיה (2011). בעקבות הזמן הוורוד: השוואה בין-דורית בין צרכים של נוער להט״בי לבין צורכיהם של להט״בים בוגרים. <b>מפגש לעבודה חינוכית-סוציאלית, 33</b>, 103–122.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '22/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1996,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '30/07/2018'
    },
    'description': 'פורום דבורה״ נוסד בשנת 2009 על ידי קבוצת נשים שנפגשו בחסות הארגון האמריקאי The Institute for Inclusive  Security הפועל לקידום מנהיגות נשים בתחום שלום וביטחון באזורים שונים בעולם ברוח החלטת מועצת הביטחון 1325. בשנת 2015 הפכה הקבוצה הישראלית לעמותה רשומה (ע״ר 80604585) שמטרותיה: ״שילוב שוויוני של נשים בכל התהליכים של עיצוב ויישום מדיניות החוץ והביטחון הלאומי ובתהליכי משא ומתן ליישוב סכסוכים, תוך יישום מלא של הוראות חוק שיווי זכויות האישה. אזרוח השיח הביטחוני לטובת הגדרה מערכתית, מקיימת ומרחיבה של ביטחון לאומי. קידום המימוש המלא של עקרון השוויון של נשים בצה״ל ובמערכת הביטחון והצבתן בעמדות משפיעות במערכות אלה, ברוח עקרון יסוד במדינת ישראל״. הפורום אשר מגדיר עצמו כארגון א-מפלגתי כולל כ-100 מומחיות במגוון תחומים כגון ביטחון, משפטים, כלכלה, סייבר וסביבה. הפורום מארגן כנסים, מפרסם ניירות עמדה ומקיים מפגשים בהשתתפות של מגוון נשים העוסקות ומתעניינות בתחומי הביטחון ומדיניות החוץ, במטרה ליצור רשת חברתית ומקצועית של מומחיות. חברות הפורום גם מעורבות באופן פעיל בתהליכי חקיקה הנוגעים למעמד נשים בצה״ל ולקידום נשים בארגוני ביטחון אחרים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'צבא, ביטחון ומדיניות חוץ',
        'קידום נשים ושוויון מגדרי'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ייצוג הולם'
      ]
    ],
    'id': 'SA41',
    'is_active': true,
    'keywords': [
      'דיפלומטיה',
      'החלטה 1325',
      'מנהיגות',
      'צה״ל',
      'שוויון'
    ],
    'name': 'פורום דבורה- נשים במדיניות חוץ וביטחון',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'צבא, ביטחון ומדיניות חוץ',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים ושוויון מגדרי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-07-30'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.forumdvorah.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>פורום דבורה – נשים במדיניות חוץ וביטחון לאומי (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580604585'
      },
      {
        'title': 'פורום דבורה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/forumdvorah/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '30/07/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2009,
    'year_registered': 2015
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '29/10/2018'
    },
    'description': '״פורום המלחינות והמבצעות בישראל״ הוקם על ידי ד״ר הגר קדימה ב-2000 ונרשם כעמותה (ע״ר 580364453) באותה שנה בכתובתה של המייסדת ברמת השרון. הפורום מארגן פסטיבלים, קונצרטים, הרצאות ותכניות רדיו המוקדשות למוזיקה מאת מלחינות ישראליות; מהווה רשת חברתית למלחינות וליצירת שיתופי פעולה עם יוצרות מתחומי המחול, התיאטרון והאמנות. ב-2014, פתחה העמותה את שעריה גם למבצעות ואז גם שונה השם. הפורום פעל בחסות מרכז פיליציה בלומנטל למוזיקה בתל אביב. בשנת 2020 נמחקה העמותה על ידי רשם העמותות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'מוסיקה'
      ]
    ],
    'id': 'YH122',
    'is_active': true,
    'keywords': [
      'רישות',
      'מוזיקה',
      'יוצרות',
      'העלאת מודעות'
    ],
    'name': 'פורום המלחינות והמבצעות בישראל',
    'name_ar': null,
    'name_change_year': 2014,
    'name_common': null,
    'name_past': 'פורום המלחינות בישראל',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מוסיקה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-29'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://fbmc.co.il/%D7%A4%D7%95%D7%A8%D7%95%D7%9D-%D7%94%D7%9E%D7%9C%D7%97%D7%99%D7%A0%D7%95%D7%AA-%D7%95%D7%94%D7%9E%D7%91%D7%A6%D7%A2%D7%95%D7%AA-%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>פורום המלחינות בישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580364453'
      },
      {
        'title': 'פורום המלחינות והמבצעות בישראל. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%A4%D7%95%D7%A8%D7%95%D7%9D_%D7%94%D7%9E%D7%9C%D7%97%D7%99%D7%A0%D7%95%D7%AA_%D7%95%D7%94%D7%9E%D7%91%D7%A6%D7%A2%D7%95%D7%AA_%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '29/09/2021'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '21/01/2019'
    },
    'description': 'פורום הנשים הפרוגרסיבי של מפלגת בל״ד הוקם בשנת 2004. מטרת הפורום היתה לקדם את מעמד הנשים בפוליטיקה ולקדם סדר יום פמיניסטי בתוך המפלגה. במסגרת הפורום נערכו ימי לימוד וסדנאות באזורים שונים וחברותיו התארגנו כקבוצת לחץ שביקשה לבקר את עבודת המפלגה מנקודת מבט מגדרית. לפורום היו הישגים רבים, אשר החשוב מביניהם הינו הכנסת הסעיף בתקנון המפלגה שמשריין מקום אחד בכנסת לאישה בין כל שלושה מתמודדים גברים. מבין מקימות הפורום היו: רודא עטאללה (ז״ל), אפנאן אגברייה, חנין זועבי, ערין הוארי, מחאסן ראבוס, ראג\'דה זועבי ואינאס חאג\'. הפורום הפסיק להיות פעיל עם הקמת ה״רשימה המשותפת״ בשנת 2015.',
    'description_ar': 'اتحاد المرأة التقدمي لحزب التجمع الوطني الديمقراطي الذي تأسس عام 2004، بهدف تعزيز مكانة المرأة في السياسة ومن اجل تعزيز أجندة نسوية في الحزب. في أطار الاتحاد اقيموا أيام تعليمية ودورات في مناطق مختلفة بحيث تنظمن عضويات الاتحاد كمجموعات ضاغطة والتي طالبت بمراقبة عمل الحزب بمنظور جندري. حقق الاتحاد إنجازات عديدة واهمها ادخال بند على قواعد الحزب الداخلية وهو تحديد مقعد واحد لامرأة بين كل ثلاث مقاعد للذكور في البرلمان. من بين مؤسسات الاتحاد هن: روضة عطا الله، افنان اغبارية، حنين زعبي، عرين هواري، محاسن رابوس، رغدة زعبي وايناس حج. توقف نشاط الاتحاد مه إقامة ״القائمة المشتركة״ عام 2015.',
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ]
    ],
    'id': 'SA122',
    'is_active': false,
    'keywords': [
      'חקיקה',
      'כנסת',
      'מנהיגות',
      'העצמה'
    ],
    'name': 'פורום הנשים בל״ד',
    'name_ar': 'اتحاد المرأة التقدمي',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'מפלגות, שדולות ותאים מפלגתיים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'الفلسطينيات وتاريخ العمل السياسي',
        'url': 'http://palestine.assafir.com/Article.aspx?ArticleID=2596'
      },
      {
        'title': '',
        'url': 'https://www.arab48.com/%D9%85%D8%AD%D9%84%D9%8A%D8%A7%D8%AA/%D8%A3%D8%AE%D8%A8%D8%A7%D8%B1-%D9%85%D8%AD%D9%84%D9%8A%D8%A9/2009/07/18/%D8%A7%D8%AA%D8%AD%D8%A7%D8%AF-%D8%A7%D9%84%D9%85%D8%B1%D8%A3%D8%A9-%D8%A7%D9%84%D8%AA%D9%82%D8%AF%D9%85%D9%8A-%D9%8A%D8%A4%D9%83%D8%AF-%D9%82%D8%AF%D8%B1%D8%A9-%D9%86%D8%B3%D8%A7%D8%A1-%D8%A7%D9%84%D8%AA%D8%AC%D9%85%D8%B9-%D8%B9%D9%84%D9%89-%D8%A7%D9%84%D9%82%D9%8A%D8%A7%D8%AF%D8%A9'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '21/01/2019'
    },
    'year_closed': 2015,
    'year_closed_text': '2015',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '17/01/2019'
    },
    'description': 'פורום הנשים של מפלגת שינוי הוקם לקראת הבחירות לכנסת ה-15 (1999) שבהם התמודדה מפלגת שינוי באופן עצמאי. הפורום הוקם כדי לקדם התמודדות של נשים בתוך המפלגה ולפעול לקידום חקיקה למען נשים בכנסת. מובילות הפורום היו: נויה מסר ששימשה כמזכירת הסיעה בכנסת ועוזרת אישית ופרלמנטרית של חה״כ טומי לפיד ושל אתי לבני, שנבחרה כחברת כנסת בשנת 2003. לאחר שהמפלגה התפרקה בשנת 2006, הפסיק פורום הנשים לפעול.',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'SA121',
    'is_active': false,
    'keywords': [
      'מנהיגות',
      'שוויון',
      'תאים מפלגתיים'
    ],
    'name': 'פורום הנשים של שינוי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'מפלגות, שדולות ותאים מפלגתיים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'ארכיון האינטרנט (2000, 2 מרץ). <b>פורום הנשים של שינוי</b>. נדלה מתוך',
        'url': 'https://web.archive.org/web/20000302101731/http://www.shinui.org.il:80/'
      },
      {
        'title': 'שינוי (2005, 2 נובמבר). <b>מוסדות ופורומים של שינוי</b>. נדלה מתוך',
        'url': 'https://web.archive.org/web/20051122215015/http://www.shinui.org.il:80/site/musadot_forums.asp'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '17/01/2019'
    },
    'year_closed': 2006,
    'year_closed_text': '2006',
    'year_founded': 1999,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '29/10/2018'
    },
    'description': 'הפורום לקידום מעמד האשה ברחובות פועל כמועצת נשים עירונית משנת 2007. בראשו עומדת חברת מועצה ובעלות התפקידים בפורום הן עובדות עירייה (כולל היועצת לקידום מעמד האישה) וחברות מועצה. הפורום לקידום מעמד האישה פועל להעצמת נשים, להעלאת המודעות בציבור לקידומן של נשים והכרה בשוויון בין המינים. מטרות הפורום כוללות: הובלת תהליכים עירוניים ושינוי מדיניות בנושא קידום מעמד האישה בתחומים כלכליים, תעסוקתיים ומנהיגות נשים. הפעילות העיקרית שמבצע הפורום כוללת: קורסים בתחומים תעסוקתיים-כלכליים וחברתיים להעצמת נשים ולפיתוח מנהיגות נשים וכן פרוייקטים קהילתיים כגון ירידי נשים יוצרות, קידום בריאות וספורט, הרצאות וטיולים ומניעת מניעת אלימות כלפי נשים ובכלל זה הטרדה מינית.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ]
    ],
    'id': 'YH123',
    'is_active': true,
    'keywords': [
      'יועצות לקידום מעמד האשה',
      'טכנולוגיה',
      'מלגות',
      'מנהיגות',
      'פנאי',
      'רשות מקומית',
      'חינוך',
      'אלימות'
    ],
    'name': 'פורום לקידום מעמד האישה רחובות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רחובות',
    'organization_kind': [
      'מוניציפלי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-29'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.rehovot.muni.il/170/'
      },
      {
        'title': 'פורום נשים רחובות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/forumrehovotwr/'
      },
      {
        'title': '(2017, 28 מאי). ביוזמת חברות הפורום לקידום מעמד האישה: מלגות להשכלה גבוהה הוענקו לנשים בגילאי 35 ומעלה. <b>08 news</b>. נדלה מתוך',
        'url': 'https://www.news08.net/%d7%91%d7%99%d7%95%d7%96%d7%9e%d7%aa-%d7%97%d7%91%d7%a8%d7%95%d7%aa-%d7%94%d7%a4%d7%95%d7%a8%d7%95%d7%9d-%d7%9c%d7%a7%d7%99%d7%93%d7%95%d7%9d-%d7%9e%d7%a2%d7%9e%d7%93-%d7%94%d7%90%d7%99%d7%a9%d7%94/ /'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '29/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2007,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '21/07/2019'
    },
    'description': 'האזכור המוקדם ביותר של ״מועצת המקלטים״ מופיע אצל ינאי (2005) ומתיחס לפעילות משותפת של נציגות המקלטים ושדולת הנשים להגיע להסדר עם משרד הבינוי והשיכון לפיו אישה ששהתה במקלט והמצויה בהליכי גירושין זכאית לקבל סיוע בשכר דירה למשך שנה אחת, כדי לאפשר לה לחיות באופן עצמאי בקהילה, בלי שתצטרך לשוב למשק־הבית שסבלה בו בעבר. במשך השנים שינתה המועצה את שמה ל״ארגון הגג של מפעילי המקלטים״. בשנת 2015, שב הפורום לפעול תחת השם ״פורום מפעילי המקלטים״. הפורום פועל כקואליצייה המייצגת את כל המקלטים לנשים נפגעות אלימות אל מול משרדי הממשלה ופועל לקידום ענייניהן של נשים נפגעות אלימות השוהות במקלטים. ניהול תקציב הפורום עובר בין המקלטים השונים ובשנת 2018 ריכוזו מצוי בידי עמותת מעון חירום לנשים בחיפה.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'פוליטיקה ומנהיגות',
        'כללי'
      ]
    ],
    'id': 'SA147',
    'is_active': true,
    'keywords': [
      'אלימות במשפחה',
      'נשים מוכות',
      'מקלט',
      'קואליצייה',
      'כנסת'
    ],
    'name': 'פורום מפעילי מקלטים',
    'name_ar': null,
    'name_change_year': 2015,
    'name_common': null,
    'name_past': 'ארגון הגג של מפעילי המקלטים',
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2017). <b> מעון חירום לנשים (ע״ר): עמותה</b>. דוח כספי לשנת 2017. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/VF_View_File?guid=f02c43c3a9e6995-807a41e3ce0c1a13-b9aba4eaab429c3ab6374e1d01bfa0f7360d23852f3c5322c118dc4c1a7bbc3c-b7f76ea86b425cb3-8566aed56eb2e071c'
      },
      {
        'title': 'אלמגור-לוטן, אורלי (2011, 28 יוני). <b>מקלטים לנשים נפגעות אלימות</b>. מוגש לוועדה לקידום מעמד האישה. מרכז המחקר והמידע של הכנסת. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/f34d6b58-e9f7-e411-80c8-00155d010977/2_f34d6b58-e9f7-e411-80c8-00155d010977_11_10195.pdf'
      },
      {
        'title': 'ינאי, אורי (2005). מקלטי הנשים בישראל: מחדשנות וולונטרית לאימוץ ממלכתי. <b>ביטחון סוציאלי, 70</b>, 77–109. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/SocialSecurity/70/article5.pdf'
      },
      {
        'title': 'רובין-קופר, יסמין ורום, מיכל (2019, 2 ספטמבר). <b>רצח נשים ואלימות מגדרית במשפחה: סקירת ידע על הטיפול המערכתי בישראל</b>. שיתופים. נדלה מתוך',
        'url': 'http://wiki.sheatufim.org.il/%D7%A8%D7%A6%D7%97_%D7%A0%D7%A9%D7%99%D7%9D_%D7%95%D7%90%D7%9C%D7%99%D7%9E%D7%95%D7%AA_%D7%9E%D7%92%D7%93%D7%A8%D7%99%D7%AA_%D7%91%D7%9E%D7%A9%D7%A4%D7%97%D7%94_-_%D7%A1%D7%A7%D7%99%D7%A8%D7%AA_%D7%99%D7%93%D7%A2_%D7%A2%D7%9C_%D7%94%D7%98%D7%99%D7%A4%D7%95%D7%9C_%D7%94%D7%9E%D7%A2%D7%A8%D7%9B%D7%AA%D7%99_%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '21/07/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1992,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '07/01/2019'
    },
    'description': 'בשנת 2015 המשרד לשירותי דת יזם שיתוף פעולה עם הוועדה לקידום מעמד האשה להקמת ״פורום ‏נשות הרבנים״. הפורום, הפועל בניהולו של המשרד לשירותי דת, מעניק הכשרה וליווי לנשות רבנים ‏חוצות-מגזרים לטפל בבעיית האלימות המגדרית בתוך הקהילות שלהן. הפורום מובל ע״י הרבנית ציפי ‏לאו, אשתו של הרב הראשי האשכנזי לישראל הרב דוד לאו, ויפה דרעי, אשתו של יו״ר ש״ס אריה דרעי. ‏כמו כן, הרבנית עדינה בר-שלום הייתה מעורבת בהקמת הפורום וליוויו. תוכנית ההכשרה של הרבניות ‏נבנתה על ידי עורכת הדין והטוענת הרבנית מטעם ״יד לאישה״ ורדית רוזנבלום, המכהנת גם כעמיתה ‏במכון למדיניות תורנית ״מידת״.‏',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'דת ומעמד אישי',
        'אלימות'
      ],
      [
        'חינוך',
        'מניעת אלימות'
      ]
    ],
    'id': 'SW48',
    'is_active': true,
    'keywords': [
      'אלימות במשפחה',
      'אונס',
      'הכשרה מקצועית',
      'תמיכה נפשית',
      'דת'
    ],
    'name': 'פורום נשות הרבנים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי',
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': null,
    'sources': [
      {
        'title': 'ברגמן, ברוך (2015, 7 דצמבר). לראשונה: כינוס למניעת אלימות במשפחה החרדית. <b>כל הזמן</b>. נדלה מתוך',
        'url': 'http://www.kolhazman.co.il/77462'
      },
      {
        'title': 'המשרד לשירותי דת (2018). <b>תכנית עבודה לשנת 2018</b>. נדלה מתוך',
        'url': 'https://www.gov.il/BlobFolder/policy/ummaryoftheinistryeligiouservices2018/he/%D7%AA%D7%9E%D7%A6%D7%99%D7%AA %D7%AA%D7%9B%D7%A0%D7%99%D7%AA %D7%94%D7%A2%D7%91%D7%95%D7%93%D7%94 %D7%A9%D7%99%D7%A8%D7%95%D7%AA%D7%99 %D7%93%D7%AA %D7%99%D7%A4%D7%95%D7%A8%D7%A1%D7%9D %D7%9C%D7%A6%D7%99%D7%91%D7%95%D7%A8 25 %D7%9C%D7%A4%D7%91%D7%A8%D7%95%D7%90%D7%A8 18.PDF'
      },
      {
        'title': 'המשרד לשירותי דת (2017). <b>תכנית עבודה לשנים 8–2017</b>. נדלה מתוך',
        'url': 'https://www.gov.il/BlobFolder/aboutoffice/aboutdat/he/work_program_17-18.PDF'
      }
    ],
    'target_audiences': [
      'נשים חרדיות',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '26/05/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '22/08/2018'
    },
    'description': 'פורום נשות עסקים בישראל הוקם ב-2009 ונרשם כעמותה (ע״ר 580635167) ב-2016. העמותה רשומה ברחובות אצל יו״ר הפורום אורלי אברהמי אך המפגשים של הפורום מתקיימים בערים שונות בארץ, בנושאים שונים הקשורים לעידוד עסקי נשים. בפורום חברות נשות עסקים, נשות ציבור, מנכ״ליות בכירות  מהמגזר הציבורי ואנשי מקצועות חופשיים. הפעילות מתקיימת בהתנדבות כאשר המטרה היא לספק רשת לחברות ותשתית לשיתופי פעולה ויזמות עסקית, כמו גם לקדם מעורבותן של נשים ולהפעיל את השפעתן, על החברה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ]
    ],
    'id': 'YH78',
    'is_active': true,
    'keywords': [
      'נשות עסקים',
      'ניהול',
      'מנהלות',
      'יזמות עסקית',
      'רישות'
    ],
    'name': 'פורום נשות עסקים בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רחובות',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'התאגדויות ורשתות מקצועיות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-08-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://israel-bw.com/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>פורום נשות עסקים ישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580635167'
      },
      {
        'title': 'נל״ן - פורום נשות עסקים ישראל, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/nln.israel/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '22/08/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2009,
    'year_registered': 2016
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '22/12/2018'
    },
    'description': '״פורום נשות קריירה במזרח התיכון״ (ע״ר 58-026699-7) היה יוזמה של עמירה דותן שכללה שותפות מירדן, מצרים, מרוקו והרשות הפלסטינית, ונועדה לקדם דיאלוג בין נשים באמצעות קידום מיזמים עסקיים משותפים. היוזמה החלה ככל הנראה בעקבות מפגש הנשים שהתקיים ב״ועידת קזבלנקה״ בשנת 1994 שהיתה הועידה הכלכלית הראשונה למזרח התיכון וצפון אפריקה לאחר חתימת הצהרת העקרונות בין ישראל לאש״ף בשנת 1993. החל משנת 2000 לא נרשמה לעמותה פעילות כספית ובשנת 2003 הוגשה בקשה למחיקה מוקדמת מפנקס העמותות. ב-2011 הוגשה בקשה למחיקה מרצון.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ],
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ]
    ],
    'id': 'YH164',
    'is_active': false,
    'keywords': [
      'מגדר בניהול סכסוכים',
      'נשות עסקים',
      'פלסטיניות',
      'כלכלה'
    ],
    'name': 'פורום נשות קריירה במזרח התיכון',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'דותן, עמירה (2010). פורום נשות קריירה במזרח התיכון. <b>קומון סנס לחשיבה אסטרטגית</b>, מכללת נתניה (העמוד אינו זמין יותר).'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 5252 (2003, 3 דצמבר). <b>הודעות מוקדמות בדבר מחיקה מפנקס העמותות</b>. פורום נשות קריירה במזרח התיכון (עמותה מספר 580266997). עמ\' 1190. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_html/law10/yalkut-5252.pdf'
      },
      {
        'title': 'Dotan, Amira (2009). International advocate for peace award acceptance speech. <b>Cardozo Journal of Conflict Resolution, 11</b>(1), 185-196. Retrieved from',
        'url': 'https://cardozojcr.com/vol11no1/185-196.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '08/07/2019'
    },
    'year_closed': 2000,
    'year_closed_text': '2000',
    'year_founded': 1994,
    'year_registered': 1995
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '27/01/2020'
    },
    'description': '״אלמונתדא עמותת נשים למען החברה״ (ע״ר 580340230) נוסדה בשנת 1999 בכפר קאסם כ״פורום נשים מוסלמיות״ במטרה לקדם ״פעילות תרבות וחינוך לנשים ונערות. עידוד ויזמה של פעילות ספורט אצל נשים ונערות. הגברת המודעות לשמירה על איכות הסביבה.״ מדוחות העמותה לרשם העמותות עולה כי עד שנת 2010 העמותה קיימה פעילות מועטת בהתנדבות שכללה ״הרצאות במסגדים לנשים שעסקו בנושאים מגוונים והתאימו לאווירה השוררת בכפר״. החל משנת 2010, העמותה מפעילה מעון לילדים, מקיימת הרצאות בנושא קידום מעמד האשה במגזר הערבי, סדנאות לשילוב נשים באקדמיה וסיוע לנזקקים.',
    'description_ar': 'المنتدى جميعة نسائية من اجل المجتمع (ج.م 580340230). تأسس عام 1999 في كفر قاسم بأسم (منتدى المرأة المسلمة) بهدف تعزيز نشاطات اجتماعية وتربوية للنساء والشابات. تعزيز ومبادرة لنشاطات رياضية للنساء والشابات. رفع الوعي حول أهمية الحفاظ على البيئة. من تقارير الجمعية يظهر ان نشاط الجمعية حتى عام 2011 كانت قليلة من خلال التطوع لإعطاء محاضرات في المساجد للنساء في مواضيع مختلفة التي تتناسب مع الجو العام في المدينة. وابتداء من عام 2010 تركز نشاط المنتدى في تشغيل حضانات للاطفاال، محاضرات حول مكانة المرأة في المجتمع العربي، وورشات لتعزيز انخراط النساء في الأكاديمية ومساعدة المحتاجين.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'SA184',
    'is_active': true,
    'keywords': [
      'גיל הרך',
      'דת',
      'גמ״ח',
      'אסלאם'
    ],
    'name': 'אלמונתדא עמותת נשים למען החברה',
    'name_ar': 'منتدى المرأة المسلمة. كفر قاسم',
    'name_change_year': null,
    'name_common': 'פורום נשים איסלאמיות',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כפר קאסם',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעונות ומשפחתונים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אלמונתדא עמותת נשים למען החברה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580340230'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '27/01/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2010,
    'year_registered': 1999
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '21/10/2018'
    },
    'description': 'הפורום הוקם ב-1994 בהתאחדות התעשיינים כ״פורום מנהלות בתעשייה״ - רשת של מנהלות בתעשייה וכשדולה פוליטית היה מעורב בקידום חקיקה. הפורום הושק מחדש ב-2015 כ״פורום נשים בתעשייה״ והוא פועל לקידום נשים לתפקידי מנהיגות וניהול, הגדלת ייצוגן בהנהלות ודירקטוריונים ולהעלאת המודעות הציבורית לחשיבות קידומן המקצועי של נשים בכל דרגי הניהול; לחינוך, להכשרה והעצמת נשים בתעשייה. הפורום מהווה רשת, מקום מפגש אינטלקטואלי, מקצועי וחברתי בין נשים ומנהלות מתחומים שונים.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ]
    ],
    'id': 'YH110',
    'is_active': true,
    'keywords': [
      'ניהול',
      'מנהלות',
      'רישות',
      'ייצוג הולם',
      'מנהיגות'
    ],
    'name': 'פורום נשים בתעשייה (בהתאחדות התעשיינים בישראל)',
    'name_ar': null,
    'name_change_year': 2015,
    'name_common': null,
    'name_past': 'פורום מנהלות בתעשייה',
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'התאגדויות ורשתות מקצועיות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.industry.org.il/index.php?dir=site&page=forum_ind&op=item&cs=3116'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2008, 18 יוני). <b>פרוטוקול מס\' 140: קידום נשים בתפקידי ניהול בתעשיה - לציון יום התעשיה הישראלית בכנסת, בסימן הצדעה לתעשיה הישראלית, בשיתוף התאחדות התעשיינים - פורום המנהלות בתעשיה</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/Activity/committees/Women/Pages/CommitteeProtocols.aspx?ItemID=297485'
      },
      {
        'title': 'סילון, רונית (2004). נשים כדירקטוריות בחברות הציבוריות. בתוך מאור, ענת (עורכת), <b>העדפה מתקנת והבטחת ייצוג בישראל</b> (עמ\' 366). תל אביב: רמות. נדלה מתוך',
        'url': 'https://kotar.cet.ac.il/KotarApp/Viewer.aspx?nBookID=92677230#5.579.6.default'
      },
      {
        'title': 'צבי כהן, ניצן (2016, 14 ספטמבר). שוברות את תקרת הזכוכית. <b>דבר</b>. נדלה מתוך',
        'url': 'https://www.davar1.co.il/33205/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '23/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1994,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '11/11/2018'
    },
    'description': '‏״פורום נשים הבית היהודי״ נוסד ביוזמתה והובלתה של עו״ד שגית פרץ-דרעי בשנת 2013 ולאחר כשנה ‏עבר להנהלתה של יערה ישורון. בנוסף לפעילות התמיכה במפלגה, הפורום מקיים קורסים למנהיגות ‏ציבורית פוליטית לנשים, ערבי הרצאות וסיורים לנשים, ופועל לקידום הייצוג וההשתתפות הפוליטית ‏של נשים במפלגה ושל נשים דתיות בכלל.‏',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ],
      [
        'דת ומעמד אישי',
        'פוליטיקה ומנהיגות'
      ]
    ],
    'id': 'SW33',
    'is_active': true,
    'keywords': [
      'חקיקה',
      'כנסת',
      'מנהיגות',
      'העצמה'
    ],
    'name': 'פורום נשים הבית היהודי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ראש העין',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'מפלגות, שדולות ותאים מפלגתיים',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-11-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://nashimby.weebly.com/'
      },
      {
        'title': 'פורום הנשים של מפלגת הבית היהודי, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/NashimBYehudi/'
      },
      {
        'title': 'גיל קלנר (2013, 18 דצמבר). הבית היהודי השיקה פורום נשים. <b>חדשות סרוגים</b>. נדלה מתוך',
        'url': 'https://www.srugim.co.il/63396-%D7%A8%D7%95%D7%A6%D7%94-%D7%A9%D7%97%D7%A6%D7%99-%D7%9E%D7%94%D7%97%D7%9B%D7%99%D7%9D-%D7%A9%D7%9C-%D7%94%D7%91%D7%99%D7%AA-%D7%94%D7%99%D7%94%D7%95%D7%93%D7%99-%D7%91%D7%9B%D7%A0%D7%A1%D7%AA'
      },
      {
        'title': 'הבית היהודי (אתר). <b>פורום נשים</b>. נדלה מתוך',
        'url': 'http://baityehudi.org.il/forum/%D7%A4%D7%95%D7%A8%D7%95%D7%9D-%D7%A0%D7%A9%D7%99%D7%9D/'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '11/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות',
      'פילנתרופיה'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '29/10/2018'
    },
    'description': '״פורום נשים כרמיאל - משגב״ הוקם ב-1997 על ידי פרויקט ״שותפות 2000״ של הסוכנות היהודית המחבר בין קהילות בארץ ובעולם. הפרויקט עסק בתחומים שנוגעים לנשים: בריאות, מניעת אלימות, תעסוקה ורב תרבותיות וכלל שיתוף פעולה עם בולטימור ופיטסבורג, ערים תאומות לכרמיאל ומשגב. בשנת 2002 נרשמה עמותה (ע״ר 580387678) שמטרתה: ״קידום ומענה לצרכי נשים בקהילות כרמיאל ומשגב. חיזוק קשרים ושיתוף פעולה בין נשות קהילות כרמיאל ומשגב בארץ ובולטימור ופיטסבורג בארה״ב״. מבחר הפרויקטים הראשונים של הפורום עסקו בבריאות האישה, ביניהם סדרת הרצאות קהילתיות ויוזמת צעדת היל״ה בגליל להגברת המודעות לגילוי מוקדם של סרטן השד. הצלחת היוזמות והפרויקטים הללו הובילה לביסוס נושא זה כיחידה עצמאית והקמת ״המרכז לבריאות האישה״ בכרמיאל בתמיכת קרן ויינר. הפורום מפעיל חנות יד שניה, מארגן קורסים ואירועי תרבות (למשל פסטיבל סרטי נשים) ואף תומך בפרויקטים בקהילה הקשורים בנשים ונערות למשל בתחומי החינוך והספורט.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תרבות וספורט',
        'ספורט'
      ],
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'YH120',
    'is_active': true,
    'keywords': [
      'בריאות נשים',
      'כדורשת',
      'סרטן שד',
      'נערות',
      'ספורט',
      'צעדה'
    ],
    'name': 'פורום נשים כרמיאל - משגב',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כרמיאל',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-29'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://wiki.misgav.org.il/%D7%A2%D7%A8%D7%9A-102-%D7%A2%D7%9E%D7%95%D7%AA%D7%AA%20%D7%A4%D7%95%D7%A8%D7%95%D7%9D%20%D7%A0%D7%A9%D7%99%D7%9D%20%D7%9B%D7%A8%D7%9E%D7%99%D7%90%D7%9C%20%D7%9E%D7%A9%D7%92%D7%91'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>פורום נשים כרמיאל-משגב (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580387678'
      },
      {
        'title': 'האגודה למלחמה בסרטן (2007, 7 מאי). <b>כ-2000 נשים השתתפו בצעדת היל״ה בגליל שהתקיימה בסוף השבוע - להגברת המודעות לגילוי מוקדם של סרטן השד</b>. נדלה מתוך',
        'url': 'https://www.cancer.org.il/dover_news/new.aspx?newid=1015'
      },
      {
        'title': 'המרכז לבריאות האישה בכרמיאל (אתר). (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '29/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1997,
    'year_registered': 2002
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '05/06/2018'
    },
    'description': 'פורום ״נשים לתקציב הוגן״ הוקם ב-2004 ופעל עד שנת 2012. הפורום מנה עשרות נשים מארגונים חברתיים, ארגוני זכויות אדם וגופים אקדמיים ופעל לקידום מדיניות כלכלית הוגנת לנשים באמצעות ניתוח מגדרי של תקציבים ממשלתיים. פעילות הפורום כללה בין היתר: ניתוח מגדרי של תכניות, פרויקטים והחלטות ממשלה; כתיבה והפצה של ניירות עמדה בנושאים של תקציב ומגדר; עבודת סנגור בכנסת, במשרדי ממשלה, ברשויות השלטון המקומי ובגופים כלכליים; סדנאות וימי עיון למקבלי החלטות, לתקשורת ולקהל הרחב; פעילות הסברה מול כלי התקשורת.\nהארגונים שפעלו בפורום: אג\'נדה, אל אהאלי-מרכז לפיתוח קהילתי, אחותי, אישה לאישה, איתך, אלזהראא, אלזהרא – ארגון נשים ערביות פלסטיניות,  אלנוהוד – העמותה לקידום השכלת נשים בדואיות בנגב, א.פ.ש.ר.י, האגודה לזכויות האזרח בישראל, היחידה לקידום נשים בתנועה הקיבוצית, המועצה לשלום ושוויון בין המינים, המרכז היהודי ערבי לפיתוח כלכלי, המרכז לפלורליזם יהודי, העמותה להעצמה כלכלית לנשים, העמותה לקידום יום ויישום יום חינוך ארוך, ויצו, כייאן – ארגון פמיניסטי, מועצת נשים תל אביב-יפו, מרכז מהות - מידע הדרכה ותעסוקה לנשים, מהפך-תג\'יר, מרכז אדוה, מען – הפורום לארגוני נשים ערביות בנגב, מרכז מוסאוא, מרכז לייפר ללימודי האישה והמגדר, עמותת נשים נגד אלימות, עדאלה, פמיננסי - המכללה להעצמת נשים, קואליציית נשים לשלום, קול האישה, קולך- פורום נשים דתיות, שדולת הנשים בישראל; נשים פרטיות למען המטרה.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ],
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ]
    ],
    'id': 'YH2',
    'is_active': false,
    'keywords': [
      'פורום',
      'תקצוב מגדרי',
      'תקציב',
      'הטמעת חשיבה מגדרית',
      'כלכלה',
      'פמיניזם'
    ],
    'name': 'פורום נשים לתקציב הוגן',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'זכויות ומדיניות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-08-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://adva.org/he/women-budget-forum/'
      },
      {
        'title': 'חסון, יעל וסייגלשיפר, ולריה (2017). לתוך הזרם המרכזי: הטמעת חשיבה מגדרית במדיניות הכלכלית. בתוך: אולמרט, דנה, ברייר-גארב, רונה, קזין, ארנה ותירוש, יופי (עורכות). <b>קפיטליזם ומגדר: סוגיות פמיניסטיות בתרבות השוק</b> (עמ\' 64–83). תל אביב: ון ליר והקיבוץ המאוחד.'
      },
      {
        'title': 'פרוטוקולים של ישיבות הפורום, ארכיון פרטי, יעל חסון'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '10/08/2018'
    },
    'year_closed': 2012,
    'year_closed_text': '2012',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות',
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '29/10/2018'
    },
    'description': '״פורום נשים ראש העין״ נוסד בשנת 2003 כפורום מקומי שהוקם כיוזמה קהילתית הדומה למועצת נשים. בניגוד למועצות נשים אחרות בארץ, לא עומדת בראשו חברת מועצה או היועצת למעמד האישה. יו״ר הפורום מועסקת ברבע משרה ומקבלת את שכרה מהעמותה לשירותים חברתיים. בפורום חברות נכון ל-2017 1,700 נשים תושבות העיר, הוא מפעיל אתר אינטרנט בהתנדבות שכולל בין היתר מאגר עסקי נשים מקומיים. הפורום מקבל תמיכה של כ-20 אלף ש״ח בשנה מתקציב היועצת למעמד האישה ברשות המקומית שמחציתו הולך לאירועי יום האישה והיום הבינלאומי למניעת אלימות נגד נשים. ב-2005 קיבל מבנה לפעילות מהעירייה.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'YH124',
    'is_active': true,
    'keywords': [
      'יועצות לקידום מעמד האשה',
      'רשות מקומית',
      'אלימות',
      'רישות',
      'יזמות עסקית'
    ],
    'name': 'פורום נשים ראש העין',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ראש העין',
    'organization_kind': [
      'מוניציפלי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-29'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.nashimb.org.il/'
      },
      {
        'title': 'פורום נשים א.נשים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/nashimrh/?ref=page_internal'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '21/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2003,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'שירותים משפטיים'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '28/05/2018'
    },
    'description': 'פורום תקנה נוסד ב-2003 על ידי נשות ואנשי הנהגה דתית, חינוך, משפט וטיפול על מנת למנוע ולטפל בפגיעות מיניות מבעלי מרות וסמכות בחברה הדתית ולמען והעלאת המודעות הציבורית לנושא. הפורום נרשם כעמותה בשנת 2009 (ע״ר 580519692) שמטרותיה הן: ״פיתוח מודל התמודדות עם פגיעה מינית מצד בעל מרות או סמכות בתוך הקהילה הדתית, יצירת דרך נוספת עבור מתלוננות ומתלוננים לטפל בניצול או הטרדה ע״י מרות או סמכות, במקרה של סירוב להתלונן במשטרה.״ הפורום מטפל בתלונות על הטרדות או פגיעות מיניות שלא מטופלות על ידי רשויות החוק בין אם מבחירת המתלוננת או בשל הקריטריונים המשפטיים לטיפול על ידי הרשויות. הפורום מקיים שיתוף פעולה והתייעצויות עם היועץ המשפטי לממשלה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'דת ומעמד אישי',
        'אלימות'
      ]
    ],
    'id': 'SW6',
    'is_active': true,
    'keywords': [
      'סיוע משפטי',
      'גברים אלימים',
      'הטרדה מינית',
      'תקיפה מינית'
    ],
    'name': 'פורום תקנה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-05-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://takana.org.il'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>פורום תקנה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580519692'
      },
      {
        'title': 'המכון הישראלי לדמוקרטיה (2010, 10 מאי). <b>החוק והקהילה [פורום תקנה]</b>. נדלה מתוך',
        'url': 'https://www.idi.org.il/events/8947'
      },
      {
        'title': 'Stern, Yedidya Z. (2017). And your camp shall be holy: The case of the Takana Forum. <b>Tradition 50</b> (2), 107-122.'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '28/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2003,
    'year_registered': 2009
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '01/01/2019'
    },
    'description': 'פור״ה- ״פמיניסטיות דוברות רוסית למען צדק חברתי״ הייתה התארגנות של פמיניסטיות דוברות רוסית, שפעלה בין השנים 2005-2011 תחת מטרית הארגונים של ״קואליציית נשים לשלום״. פור״ה ארגנה סמינרים של סופי שבוע ומפגשי פעילות ברחבי הארץ בנושאים הנוגעים למאבק בכיבוש, סקסיזם, הומופוביה, גזענות ומיליטריזם ופעלה על מנת לעורר שיח ציבורי בנושאים אלה בתקשורת הרוסית. אסתר רפפורט שהייתה פעילה מרכזית בקבוצה מספרת שבעוד שהפעילות האשכנזיות של הקואליציה ראו בפור״ה פרוייקט ותו לא, עבור הפעילות דוברות הרוסית היה ברור כי מדובר בארגון נפרד. בין חברות הקבוצה היו אינה מיכאלי, אסיה איסטונישה ואחרות.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'הגירה',
        'קליטת עלייה'
      ],
      [
        'שלום'
      ]
    ],
    'id': 'LR43',
    'is_active': false,
    'keywords': [
      'אלימות מינית',
      'להט״ב',
      'כיבוש',
      'סדנאות',
      'פמיניזם',
      'צדק חברתי',
      'שלום',
      'תקשורת'
    ],
    'name': 'פור״ה - פמינסיטיות דוברות רוסית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'התארגנות שאינה עמותה',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים עולות מחבר העמים',
    'retrieved': null,
    'sources': [
      {
        'title': 'מיכאלי, אינה (2009, 4 נובמבר). מה עושות עולות חדשות? <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-3798289,00.html'
      },
      {
        'title': 'פור״ה - פמינסיטיות דוברות רוסית (2019, 1 ינואר). אומת בשיחה עם נציגת הארגון.'
      }
    ],
    'target_audiences': [
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '01/01/2019'
    },
    'year_closed': 2011,
    'year_closed_text': '2011',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '01/01/2019'
    },
    'description': '״פיות כנען״ הפועלת בישראל משנת 2011, היא הגרסא המקומית של תנועת ה״פיות רדיקליות״ שהחלה לפעול בארה״ב ב - 1979. מדובר בתנועה אנטי-ממסדית שדוגלת בקהילתיות וקיימות ומנסה להוות אלטנרטיבה מגדרית, מינית וחברתית להטרונורמה. התנועה המקומית החלה בפגישות בבתים פרטיים בתל אביב ב-2011, והחל מ - 2013 מקיימת 3-4 מפגשים בטבע בשנה. מדובר בתנועה שהחלה כתנועה גברית, בעיקר של הומואים וביסקסואלים, ומפולגת ביחס לשאלת צירופן של נשים לסביות וביסקסואליות ושל טרנסג׳נדרים. לפיכך כרגע, חלק מהמפגשים מיועדים לגברים בלבד וחלקם מעורבים מגדרית. אם כי, יש לציין כי רבים מהגברים הלוקחים חלק בקבוצה מזדהים על הקשת הא-בינארית מגדרית. בשנה האחרונה העמותה פועלת גם על הקמת מרכז קהילתי, סנקצ׳ורי, בישראל, המבוסס על ערכי התנועה. חלק מחברי הקבוצה יצרו התישבות קהילתית בשם אדאמאמא, כצעד ראשון בדרך להקמתו של המרכז, והם עובדים כרגע על גיוס הכספים הנחוצים להמשך התהליך.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'LR39',
    'is_active': true,
    'keywords': [
      'הומואים',
      'קוויר',
      'קהילתיות',
      'קיימות',
      'מגדר',
      'מיניות',
      'זהות מגדרית'
    ],
    'name': 'פיות כנען',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2019-01-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://canaanfaes.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>פיות כנען (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580652782'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '01/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2011,
    'year_registered': 2017
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '03/06/2018'
    },
    'description': 'פרויקט ״פלטפורמא - תאטרון אקטיביסטי״ הינה עמותה (ע״ר 580615938) שמפעילה תאטרון חברתי שמטרותיו הן ״העלאה למודעות הציבור נושאים חברתיים הקשורים לבעיות של החברה הישראלית באמצעות תיאטרון חברתי, דרך עיסוק דרמטי על הבמה בסיפורים השאובים מהמציאות. יוזמות לקידום תיאטרון חברתי. שימוש בתיאטרון ככלי אקטיביסטי ליצירת שינוי בנושאים חברתיים במגזר, מגדר וזהות בחברה הישראלית. מתן הזדמנות לשילוב נשים נפגעות אלימות ואסירות משוחררות במעגל העבודה באמצעות אמנויות הבמה. יצירת דיון אקטואלי בסוגיות בוערות בחברה הישראלית, באמצעות רבי-שיח וכיו״ב״. העמותה נוסדה בתל אביב ומנוהלת על ידי דנה דבורין וקרן כהן ישראלי, נשות תיאטרון ישראליות וותיקות. פעילות העמותה כוללת העלאת הצגות מקור בעלות אג\'נדה חברתית בשיתוף התיאטרון הלאומי של ישראל – \'הבימה\'; והכשרה במקצועות הבמה לנשים נפגעות אלימות בתוך תיאטרון \'הבימה\' לתפקידים מגוונים כגון : מפיקה, מנהלת הצגה, ע. בימאית, מאפרת, מלבישה ועוד.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'תרבות וספורט',
        'תיאטרון'
      ],
      [
        'תעסוקה ועבודה',
        'הכשרה מקצועית'
      ]
    ],
    'id': 'YB99',
    'is_active': true,
    'keywords': [
      'תיאטרון',
      'הכשרה מקצועית',
      'העצמה'
    ],
    'name': 'פלטפורמא-תיאטרון אקטיביסטי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'פלטפורמא',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-03-06'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://ptn.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>פלטפורמא – תיאטרון אקטיביסטי (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580615938'
      },
      {
        'title': 'רדיו מהות החיים (2017, 5 אפריל). <b> ראיון עם עמותת פלטפורמא - יום מעשים טובים 2017</b> (סרטון). נדלה מתוך',
        'url': 'https://www.youtube.com/watch?v=veAeh7V5eGM'
      },
      {
        'title': 'תיאטרון פלטפורמא מאלימות לאומנות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/platformatheatre/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '25/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '03/06/2018'
    },
    'description': 'פמלי״ה הוא פורום מרצות/ים למניעת הטרדות באוניברסיטה העברית. מטרתו להוות פורום בלתי תלוי באוניברסיטה שפועל למען מוטרדות/ים ועל מנת למנוע הטרדות בעתיד. הפורום נוצר לאחר חשיפתם של מספר מקרי הטרדה ופגיעה מינית של מרצים כלפי סטודנטיות באוניברסיטה העברית במהלך השנים שקדמו להקמת הפורום ולאחר שהאוניברסיטה שינתה את התקנון למניעת הטרדה מינית. חברות/ים הפורום לוקחות על עצמן ליווי של מתלוננות ונפגעות הן במהלך הפניה לערכאות האוניברסיטה והן כחלק מליווי ותמיכה בה בהמשך לימודיה באוניברסיטה.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה בשיתוף אקדמי',
    'fields_of_activity': [
      [
        'אלימות',
        'הטרדה מינית'
      ],
      [
        'השכלה גבוהה ומחקר',
        'אקדמיה, חברה וקהילה'
      ]
    ],
    'id': 'YB100',
    'is_active': true,
    'keywords': [
      'הטרדה מינית',
      'תעסוקה',
      'תמיכה נפשית',
      'מיצוי זכויות'
    ],
    'name': 'פמלי״ה',
    'name_ar': 'م م ت ت ج',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'התארגנות שאינה עמותה',
      'אקדמי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'הטרדה מינית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'עצומה (2015, 19 יולי). <b>פמלי״ה - פורום מרצות ומרצים למניעת הטרדות</b>. נדלה מתוך',
        'url': 'https://www.atzuma.co.il/hujifacultyforum'
      },
      {
        'title': 'פמלי״ה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/pamalya/'
      },
      {
        'title': 'שחר, תום (2016, 14 ינואר). חברי הסגל ב״עברית״ נלחמים בהטרדות המיניות. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://jerusalem.mynet.co.il/local_news/article/m_155205'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '25/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '28/06/2018'
    },
    'description': 'פני״ם חדשות הוקמה ב-2011 ונרשמה כעמותה (ע״ר 580551174) ב-2012, על ידי חלי פרידמן שהיא מייסדת ומנכ״לית של ארגון עסקי בשם ״יהל - יעוץ, הדרכה והתמרה לנשים״. העמותה הוקמה ״למען קידום נשים לעמדות השפעה ולהצבתן במוקדי ההחלטות (דירקטוריונים, חברות וארגונים), תוך שימת דגשים על מצוינות אישית כערך מחולל הצלחה״ העמותה מקדמת מעבר מתפישת המגדר לתפישת המגוון. העמותה פועלת באמצעות פורומים ברחבי הארץ המובילים פרויקטים לנערות ולנשים בתחומים: עידוד נערות ללימודי מדעים, קורסי דירקטוריות, תעסוקת בני/ות 40 ומעלה, רישות, חינוך ומודעות פיננסית, הורות וקריירה, יזמות וקיומיות משותפת – פורום יהודיות ערביות הפועל לקירוב לבבות, היכרות אישית ומשפחתית, הרחקת החסמים והיחסים הטעונים והחלפתם בשיח מכבד. \nהעמותה הקימה ומפעילה את ״המשמר המגדרי בכנסת״ - נציגותיה משתתפות בדיונים שונים ואף השיקו ״מדד מגדרי״ המדרג ח״כיות בהתאם לפעילותן בנושאים של שוויון מגדרי. בנוסף השיקו בכנסת ב-2018 משמר מגדרי בינלאומי בשיתוף שגרירים והקהילה הדיפלומטית. \nהעמותה פועלת על בסיס התנדבותי.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ],
      [
        'נערות וצעירות',
        'מדע וטכנולוגיה'
      ]
    ],
    'id': 'YH35',
    'is_active': true,
    'keywords': [
      'מגוון',
      'שוויון מגדרי',
      'ניהול',
      'גיוון במקום העבודה',
      'יזמות עסקית',
      'יזמיות',
      'רישות',
      'מנטורינג',
      'מנהלות',
      'מנהיגות',
      'נשות עסקים',
      'תעסוקת נשים מבוגרות'
    ],
    'name': 'פני״ם חדשות - פרלמנט נשים ישראליות מנהיגות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'יהוד-מונוסון',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום מנהיגות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.wlp.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>פנים חדשות – פרלמנט נשים ישראליות מנהיגות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580551174'
      },
      {
        'title': 'פני״ם חדשות - פרלמנט נשים ישראליות מנהיגות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/newpace1/?ref=br_rs'
      },
      {
        'title': 'יהל. <b>פני״ם חדשות – פרלמנט נשים ישראליות מנהיגות</b>. נדלה מתוך',
        'url': 'http://ya-hel.com/%D7%A4%D7%A8%D7%9C%D7%9E%D7%A0%D7%98-%D7%A0%D7%A9%D7%99%D7%9D/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '26/11/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2011,
    'year_registered': 2012
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '01/01/2019'
    },
    'description': 'פסיכולוגיי היה פורום מטפלים להט״בים שהוקם בשנת 2001 על ידי הבית הפתוח בירושלים. עם השנים הוא עבר לפעולה עצמאית והפעיל שלוש קבוצות עמיתים בחיפה, תל אביב וירושלים. הפורום פעל לקידום הידע, המחקר וההכשרה בטיפול פסיכותרפי ללהט״בים בישראל, ולהעלאת המודעות של מטפלים לצרכיה הייחודיים של אוכלוסיה זו. הפורום ארגן כנסים, ימי עיון והרצאות, הפעיל קבוצת קריאה וקבוצת מחקר, והפעיל גם אתר מידע ופורום אינטרנטי. בפורום היו חברים כ - 200 מטפלות ומטפלים ומאז שנת 2013 לא אותרה פעילות ציבורית מטעמו.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'להט״ב',
        'רווחה ובריאות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ],
      [
        'חינוך',
        'להט״ב'
      ]
    ],
    'id': 'LR40',
    'is_active': false,
    'keywords': [
      'טיפול נפשי',
      'העלאות מודעות',
      'פסיכולוגיה',
      'להט״בופוביה',
      'מחקר'
    ],
    'name': 'פסיכולוגיי- ארגון מטפלות/ים לסביות, הומואים, טרנסג\'נדרים וביסקסואלים (להט״ב) בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'רווחה ובריאות',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2019-01-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.hebpsy.net/me.asp?id=35'
      },
      {
        'title': 'רוזן, עמליה (2009).<b>בין נטייה [מינית] להטיה [מקצועית] - סקירת יום העיון</b>. נדלה מתוך',
        'url': 'https://www.hebpsy.net/articles.asp?id=2396'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '01/01/2019'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 2001,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '25/06/2018'
    },
    'description': 'התכנית הוקמה בשנת 2012 במרכז הבינתחומי הרצליה על ידי שתי סטודנטיות בשם שני הראל ולינוי קצב. בשנת 2018 נרשמה כעמותה שמטרתה ״לפעול לקידום נשים בפיתוח קריירה משמעותית והשתלבות בתפקידים ניהוליים ויזמיים, החל מתחילת דרכן המקצועית ולכל אורכה. להוות פלטפורמה שתסייע באמצעות רישות מקצועי במציאת הזדמנויות לקידום מקצועי עבור ציבור הנשים, לפעול להקמת סניפים שבהם יפעלו תכניות לקידום ציבור הנשים בפיתוח קריירה במוסדות אקדמאיים בארץ ובחו״ל, לסייע לציבור הנשים במציאת עבודה או בייצור הכנסה עצמאית. לקדם, לקיים, לנהל ולבצע תכניות יזמות ומיזמים חברתיים ו/או חינוכיים ו/או טכנולוגיים, בין בעצמה ובין ביחד עם אחרים בקשר עם ולשם קידום מעמד הנשים בשוק העבודה.״ העמותה מפעילה תכניות מפגש בין סטודנטיות מאוניברסיטאות שונות בארץ ונשות עסקים וקריירה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף אקדמי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ],
      [
        'השכלה גבוהה ומחקר',
        'אקדמיה, חברה וקהילה'
      ],
      [
        'נערות וצעירות',
        'מנהיגות'
      ]
    ],
    'id': 'YB107',
    'is_active': true,
    'keywords': [
      'מנטורינג',
      'סטודנטיות',
      'קריירה',
      'תעסוקה',
      'מנהיגות'
    ],
    'name': 'פרו וומן',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'אקדמי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'התאגדויות ורשתות מקצועיות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-25'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.idc.ac.il/he/students/extracurricular/pages/pro-woman.aspx'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>פרו וומן (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580670099'
      },
      {
        'title': 'האגודה הסטודנטיאלית, אוניברסיטת בן-גוריון בנגב (אתר). <b>תכנית ProWoman לקידום נשים במשק הישראלי</b>. נדלה מתוך',
        'url': 'https://bgu4u.co.il/%D7%AA%D7%90%D7%99%D7%9D-%D7%A1%D7%98%D7%95%D7%93%D7%A0%D7%98%D7%99%D7%90%D7%9C%D7%99%D7%99%D7%9D/%D7%A4%D7%A8%D7%95-%D7%95%D7%95%D7%9E%D7%9F/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '13/03/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2012,
    'year_registered': 2018
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'שירותים משפטיים',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '06/11/2018'
    },
    'description': '״טרנסג\'נדרים למען צדק חברתי״ (ע״ר 580528164) היא עמותה המוכרת גם בשם ״פרויקט גילה להעצמה טרנסית״ שנוסדה בשנת 2010 על ידי עידו קטרי, לילך בן דוד ואלישע אלכסנדר. מטרות העמותה הן: ״הגנה על זכויות הטרנסג\'נדרים. קידום והעצמת הקהילה הטרנסג\'נדרית. פעילות למען צדק חברתי-כלכלי. ניראות תקשורתית וציבורית לקהילה הטרנסג\'נדרית. אירגון כנסים ואירועים ציבוריים מטעם הקהילה הטרנסג\'נדרית למען צדק חברתי. פעילות הסברה ופעילות שדולה״. הארגון נקרא ע״ש גילה גולדשטיין, אחת הפעילות הראשונות והבולטות בקהילה הטרנסג׳נדרית בישראל שנפטרה בשנת 2017. הפרויקט מעניק לחברי הקהילה הטרנסית יעוץ משפטי, סיוע במציאת מקומות תעסוקה ידידותיים וליווי אישי למיצוי זכויות מול גורמים כמו ביטוח לאומי ומשרד הפנים. הוא מפעיל עמדות יעוץ בבתי קפה ברחבי הארץ אחת לשבועים ורשת בלתי פורמלית של פתרונות דיור ארעיים ברחבי הארץ. בנוסף, הארגון פועל על מנת להעצים את חברי הקהילה ולהגן עליהם מאלימות מגדרית.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'זכויות'
      ],
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'תעסוקה ועבודה',
        'השמה וליווי בתעסוקה'
      ]
    ],
    'id': 'LR14',
    'is_active': true,
    'keywords': [
      'טרנסקסואלים',
      'אלימות מגדרית',
      'סיוע משפטי',
      'מיצוי זכויות',
      'תעסוקה',
      'דיור'
    ],
    'name': 'טרנסג׳נדרים למען צדק חברתי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'פרויקט גילה להעצמה טרנסית',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'זכויות',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>טרנסג\'נדרים למען צדק חברתי</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580528164'
      },
      {
        'title': 'כל זכות (ללא תאריך). <b>טרנסג\'נדרים למען צדק חברתי</b>. נדלה מתוך',
        'url': 'https://www.kolzchut.org.il/he/%D7%98%D7%A8%D7%A0%D7%A1%D7%92%27%D7%A0%D7%93%D7%A8%D7%99%D7%9D_%D7%9C%D7%9E%D7%A2%D7%9F_%D7%A6%D7%93%D7%A7_%D7%97%D7%91%D7%A8%D7%AA%D7%99'
      },
      {
        'title': 'קטרי, עידו (2016). על צומת דרכים: מפגשה של הקהילה הטרנסית עם מערכת המשפט. בתוך: הראל, אלון, לושינסקי, יניב ומורגנשטרן, עינב (עורכים), <b>זכויות הקהילה הגאה בישראל: משפט, נטייה מינית וזהות מגדרית</b> (עמ\' 727–776). האוניברסיטה העברית, המכון למחקרי חקיקה ולמשפט השוואתי. צפרירים: נבו.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2010,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '13/10/2018'
    },
    'description': 'מטרת העמותה: קידום יזמות עסקית נשית באמצעות כנסים, הרצאות, סדנאות וקבוצות נטוורקינג לבעלות עסקים. \nהעמותה רשומה בחדרה אך מפעילה קבוצות בפרדס חנה-חדרה, חיפה, כפר סבא, הרצליה',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ]
    ],
    'id': 'YH103',
    'is_active': true,
    'keywords': [
      'נשות עסקים',
      'העצמה',
      'רישות',
      'ניהול',
      'יזמיות'
    ],
    'name': 'פרויקט עסקית - יזמות נשית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חדרה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-13'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://iskit.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>פרויקט עסקית – יזמות נשית (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580596773'
      },
      {
        'title': 'עמותת פרויקט עסקית - יזמות נשית, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/iskitproject/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '13/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': 2014
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '11/07/2018'
    },
    'description': 'פרויקט קשר ישראל הינו הסניף הישראלי של הארגון היהודי הבינלאומי ״קשר״ (Kesher) שממוקם בארה״ב אשר נוסד בשנת 2008. מטרת העמותה היא ״להקים ולהפעיל רשת בין נשים עולות, לסייע להן להתחבר אחת לשנייה ולאפשר להן נגישות למשאבים להם הן זקוקות על מנת לשנות את חייהן, את הקהילה היהודית בה הן חיות ואת החברה בכלל. לעודד אקטיביזם בקרב נשים עולות לקידום שוויון מגדרי וסובלנות דתית ועדתית ברוח הציווי היהודי של תיקון עולם״. הארגון תומך בפעילות של כ-18 קבוצות נשים ברחבי הארץ. הקבוצות מקיימות מפגשים חברתיים, הכשרה מקצועית, לימוד שפה, פעילות למען קידום זכויות נשים ועוד. מייסדת העמותה היא לזלי זקס, שהיתה בעבר מנכלית שדולת הנשים, פעילה ב״נשות הכותל״ ועוד.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'הגירה',
        'קליטת עלייה'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ]
    ],
    'id': 'SA84',
    'is_active': true,
    'keywords': [
      'רישות',
      'קידום נשים',
      'מנהיגות',
      'שוויון מגדרי',
      'אקטיביזם'
    ],
    'name': 'פרויקט קשר ישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'באר שבע',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'הגירה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קליטת עלייה',
    'primary_target_audience': 'נשים עולות מחבר העמים',
    'retrieved': {
      'type{date}': '2018-07-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.projectkesher.org/aboutus.html'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>פרויקט קשר ישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580500312'
      }
    ],
    'target_audiences': [
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '19/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2008,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '26/06/2018'
    },
    'description': '״פרופיל חדש״ היא עמותה (ע״ר 580346120) אשר נוסדה בשנת 1998 במטרה ״ליצור הכרה בזכות היסוד של כל אחד ואחד לסרב לשרת בצבא או בשטחים מטעמי מצפון. ליצור לובי למען חקיקת חוק המכיר בסרוב הנ״ל מטעמי מצפון. ליצור הכרה בזכות של נשים וגברים לבטא את השתתפותם בחברה באמצעות שרות אזרחי אלטרנטיבי.״ העמותה מוצגת במסמכיה ובאתר כ״תנועה לאזרוח החברה בישראל. תנועה פמיניסטית של גברים, נשים ונוער הפועלים לשינוי החשיבה הצבאית ששולטת בכל פינה בחיינו, לעקירת החינוך המיליטריסטי ולביטול חובת הגיוס״. העמותה מקיימת תערוכות, כנסים וארועים העוסקים בביקורת על מיליטריזם ויחסי צבא-חברה בישראל, משתתפת בקואליציות עם ארגוני נשים וזכויות אדם ומפעילה את ״רשת הליווי לסרבנים ונמנעים״, ששמה לעצמה למטרה להעניק לכל פונה מידע מפורט ואמין לגבי ההליכים המאפשרים קבלת פטור משירות צבאי בישראל, ולהעניק למי שמבקשים לקבל פטור כזה תמיכה מורלית.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'ביטחון לאומי'
      ]
    ],
    'id': 'SA30',
    'is_active': true,
    'keywords': [
      'מיליטריזם',
      'כיבוש',
      'צבא'
    ],
    'name': 'פרופיל חדש',
    'name_ar': 'بروفيل جديد',
    'name_change_year': null,
    'name_common': 'פרופיל חדש- תנועה לאזרוח החברה בישראל',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.newprofile.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>פרופיל חדש (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580346120'
      },
      {
        'title': 'בנסקי, טובה (2006). ״קואליציית הנשים לשלום צודק״: פרויקט השלום הפמיניסטי כחלק מהמגמות לאזרוח החברה הישראלית. בתוך: בן רפאל, אליעזר, בראלי, אבי, יער, אפרים וכהן, אורי (עורכים), <b>ישראל והמודרניות, למשה ליסק ביובל</b> (עמ\' 524–549). באר שבע: מכון בן גוריון לחקר ישראל, הציונות ומורשת בן גוריון.'
      },
      {
        'title': 'מזלי, רלה, (2003), סיפור אישי, בתוך: ישכר, חדוה (עורכת), <b>אחיות לשלום: קולות בשמאל הפמיניסטי</b> (עמ\' 21־26). תל אביב: רסלינג.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/10/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '27/06/2018'
    },
    'description': '״פרלמנט נשים הוקם ב-1999 כפורום או קואליצייה על ידי תנועת ש.י.ן-לשוויון ייצוג נשים, ה״״ן (הרצליה נשים), קרן פרידריך אברט, מכללת בית ברל ועיריית הרצליה. הפרלמנט הוא במה לדיון פמיניסטי וביקורתי על המדיניות השלטת והשיח הציבורי הרווח בישראל. מטרותיו: יצירת בולטות לפן הפמיניסטי בשיח הציבורי – מושבי הפרלמנט מעניקים במה להצגתן של עמדות מקוריות וביקורתיות של נשים ממגוון רחב של מסגרות; השגת בולטות לנשים בעלות תרומה ייחודית; יצירת פורום ציבורי פתוח וייחודי לדיון והידברות בין קבוצות נשים שונות ומגוונות, מכל קצוות הקשת הפוליטית, ברמות השכלה, בעלות עיסוקים ובנות גילאים שונים.\nמאז הקמת הפרלמנט (ועד סוף שנת 2016) התקיימו למעלה מ-90 מושבים בשיתוף רשויות מקומיות, מועצות אזוריות ומסגרות חברתיות שונות. הם עסקו בנושאים רבים ומגוונים, תוך הדגשת ההיבט הפמיניסטי: תקציב המדינה, מדיניות החינוך והרווחה, סוגיות של שלום, מלחמה, תקשורת וכלכלה, אלימות, פשע וטרור, משטרה ואלימות כלפי נשים, זנות שכר בנשים ופורנוגרפיה, שכר ותנאי עבודה, ייצוג נשים ברשויות המקומיות בכנסת ובממשלה, מעמד המורות והנהגתן, חינוך ותרבות, קשרי הון ושלטון, ספורט ומגדר, הוצאת ילדים מהוריהם על ידי הרשויות מאז פרשת ילדי תימן ועד היום ועוד נושאים רבים. בין המייסדות: פרופ\' אסתר הרצוג, עו״ד יונה מרקוביץ, ד״ר לינדה עפרוני, יעל גרמן, טורקאן קארקורט, נדין הולנדר, גולדי קורן, ד״ר ורדה גרנות.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ],
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ]
    ],
    'id': 'YH34',
    'is_active': true,
    'keywords': [
      'ייצוג הולם',
      'מנהיגות',
      'שוויון מגדרי',
      'פמיניזם',
      'פורנוגרפיה'
    ],
    'name': 'פרלמנט נשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'הרצליה',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'קידום מנהיגות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-27'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://womenparliament.org/'
      },
      {
        'title': 'פרלמנט נשים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/%D7%A4%D7%A8%D7%9C%D7%9E%D7%A0%D7%98-%D7%A0%D7%A9%D7%99%D7%9D-382265370469/'
      },
      {
        'title': 'הרצוג, אסתר (2010). <b>עשור לפרלמנט נשים 1999–2009 - ספר תקצירים</b>. פרלמנט נשים – במה לפוליטיקה מזווית אחרת וקרן פרידריך אברט. נדלה מתוך',
        'url': 'http://womenparliament.org/wp-content/uploads/2017/09/%D7%97%D7%95%D7%91%D7%A8%D7%AA-%D7%AA%D7%A9%D7%A1%D7%98.pdf'
      },
      {
        'title': 'פרלמנט נשים. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%A4%D7%A8%D7%9C%D7%9E%D7%A0%D7%98_%D7%A0%D7%A9%D7%99%D7%9D'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1999,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/04/2018'
    },
    'description': '״צאינה וראינה״ היתה קולקטיב פמיניסטי וחנות ספרים אשר נוצר מתוך פעילות ה״תנועה הפמיניסטית בתל אביב״. אסתר עילם כותבת: ״בתל אביב שכרנו בדצמבר 1976 דירה ברחוב דיזינגוף 224 שמומנה ממסי החברות ובה גרנו שנתיים. לאחר העזיבה התארגנה קבוצה מתוך חברות התנועה במטרה להקים מרכז אחר. עם נשים נוספות היא הקימה את ״צאינה וראינה״ מרכז פמיניסטי שפעל משנת 1979 עד שנת 1982.״ (עילם 2012: 120). הקבוצה מעולם לא נרשמה כעמותה, אבל יתכן שנרשמה כאגודה עותומנית.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'SA5',
    'is_active': false,
    'keywords': [
      'חנות ספרים',
      'פמיניזם',
      'פנאי',
      'קבוצות להעלאת תודעה',
      'קולקטיב',
      'שלום',
      'לסביות'
    ],
    'name': 'צאינה וראינה, מרכז לתרבות נשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'ספרן, חנה, הרטל, רחלי וששון-לוי, אורנה (2016). הי[א]סטוריה לסבית מקומית: פעילות, מאבקים והישגים. בתוך: הראל, אלון, לושינסקי, יניב ומורגנשטרן, עינב (עורכים), <b>זכויות הקהילה הגאה בישראל: משפט, נטייה מינית וזהות מגדרית</b> (עמ\' 45–80). האוניברסיטה העברית, המכון למחקרי חקיקה ולמשפט השוואתי. צפרירים: נבו.'
      },
      {
        'title': 'עילם, אסתר (2012). פמיניסטית באקדמיה בשנות השבעים. <b>מגדר: כתב עת למגדר ופמיניזם</b>, 1, 117–132. נדלה מתוך',
        'url': 'http://blogdebate.org/gender/journal/wp-content/uploads/2012/12/%D7%90%D7%A1%D7%AA%D7%A8-%D7%A2%D7%99%D7%9C%D7%9D.pdf'
      },
      {
        'title': 'רחמימוב, איריס (2015). ״סעודות, הפגנות והתפכחות״: רדיקליזם לסבי בירושלים, 1972–1989. <b>זמנים, 161</b>, 62–71.'
      },
      {
        'title': 'Shalom, Haya (2005). The story of CLaF: The community of lesbian feminists. In Chava Frankfort-Nachmias & Erella Shadmi (Eds.), <b>Sappho in the holy land: Lesbian existence and dilemmas incontemporary Israel</b>. SUNY series in Israeli studies (pp. 39-63). Albany, NY: State University of New York Press.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '24/12/2018'
    },
    'year_closed': 1982,
    'year_closed_text': '1982',
    'year_founded': 1979,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '23/12/2018'
    },
    'description': 'בית ״צידה לדרך״ הוא הוסטל שיקומי לנשים (ולגברים בודדים) המתמודדות עם הפרעות אכילה, שהוקם בשנת 2009, ברמת ישי, בשיתוף פעולה בין המרכז למפעלים מיוחדים של הביטוח הלאומי, משרד הבריאות ומשרד הרווחה, עם עמותת ״תעסוקת השני״. הוא אחד משלושה בתים שיקומיים הפועלים ברחבי הארץ, ומיועד לחולות שעדיין מפגינות סימפטומים פעילים בגילאי 18-32. הבית יכול להכיל עד 14 שוהות בכל פעם, והוא נמצא באופן קבוע בתפוסה מלאה, עם רשימת המתנה. הצעירות השוהות בבית משתלבות במסגרות לימודים ותעסוקה, מקבלות ליווי סביב הארוחות וטיפול פסיכולוגי ופסיכיאטרי, נפגשות בקביעות עם דיאטנית, לומדות כישורי חיים וניהול משק בית בסיסיים, משתתפות בקבוצות תמיכה ומשתתפות בפעילויות חברתיות בבית ומחוצה לו. ב - 2012 משרד הבריאות התקשר ללא מכרז עם עמותת ״תעסוקת השני״ להמשך ניהול הבית. בשלב כלשהו, ככל הנראה מיד לאחר ההתקשרות, ניהול הבית עבר לחברה הפרטית ״שני בקהילה״, הרשומה ברשם החברות בדיוק באותה הכתובת ממנה פעלה עמותת ״תעסוקת השני״. הרישומים של משרד הבריאות בנושא מאוד בלתי ברורים, וגם היום הוא ממשיך להתקשר לכאורה, עם ״תעסוקת השני״ באופן רשמי, כשהספק הוא ״שני בקהילה״ ובחלק מהמקרים הרשומים בכלל מתיחסים ל״עמותת שני בקהילה״ שלא התקיימה מעולם. זאת למרות ש״תעסוקת השני״ כבר אינה קיימת, לאחר שב - 2014 שינתה את שמה ל״נופית יזמות חברתית״. נראה שמדובר במנהל לא תקין, אך לא ברור מה ובאיזו מידה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'נערות וצעירות',
        'בריאות'
      ]
    ],
    'id': 'LR30',
    'is_active': true,
    'keywords': [
      'דיור',
      'הפרעות אכילה',
      'תעסוקה',
      'הוסטל'
    ],
    'name': 'צידה לדרך',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת ישי',
    'organization_kind': [
      'ממשלתי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'בריאות הנפש וטיפול',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-12-23'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.shany.co.il/%D7%AA%D7%97%D7%95%D7%9E%D7%99-%D7%A2%D7%99%D7%A1%D7%95%D7%A7/%D7%91%D7%99%D7%AA-%D7%A6%D7%99%D7%93%D7%94-%D7%9C%D7%93%D7%A8%D7%9A'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נופית יזמות חברתית (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580461838'
      },
      {
        'title': 'בלנק, רוני (2016). <b>הטיפול בהפרעות אכילה בישראל</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/732c28b1-995f-e611-80dd-00155d010ede/2_732c28b1-995f-e611-80dd-00155d010ede_11_10422.pdf'
      },
      {
        'title': 'היוש, טלי, היישריק, מיכל, יצחק-מונסונגו, עינת ולזובסקי, רבקה (2013). <b>תכנית הבתים השיקומיים לנשים צעירות המחלימות מהפרעות אכילה</b>. מפעלים מיוחדים 152. ירושלים: המוסד לביטוח לאומי, מינהל המחקר והתכנון והאגף לפיתוח שירותים. נדלה מתוך',
        'url': 'https://www.btl.gov.il/Publications/Special_Activities_publications/Documents/mifal_152.pdf'
      },
      {
        'title': 'מפתח התקציב (2012). <b>הגדלת התקשרות עם עמותת שני בקהילה: בקשת פטור ממכרז. משרד הבריאות -> שני בקהילה בע״מ</b>. נדלה מתוך',
        'url': 'https://next.obudget.org/i/tenders/exemptions/533270/none'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '14/02/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2009,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '25/01/2019'
    },
    'description': 'התא הגאה במפלגת קדימה הוקם במאי 2010 ביוזמתו של אבי סופר. היוזמה להקמה, לפי סופר, הייתה עיכוב הכניסה לארץ של תאומים שנולדו בהליך פונדקאות בהודו, בהמתנה לאזרחות ישראלית. הקמת התא נועדה להרחיב את הייצוג הלהט״בי למפלגות שאינן מזוהות עם השמאל. בתקופה הראשונה לפעילותו מדובר היה בתא של איש אחד, אולם בהמשך הוא מנה למעלה ממאה פעילים. פעילות התא יצאה ממרכז המפלגה בפתח תקווה לכל רחבי הארץ. סופר מספר על קשרים בין חברי התא לבין המפלגה, כשחברי המפלגה היו מגיעים לבקשתם לאירועים להט״בים וחברי התא היו באים לחוגי בית ואירועים מפלגתיים עם דגלי גאווה, סיכות וכיו״ב. יו״ר המפלגה ציפי לבני יחד עם ח״כ נינו אבסדזה היו מעורבות מאוד בפעילות התא ובענייני הקהילה. עם הבחרו של שאול מופז, התא עבר עם ציפי לבני ל״תנועה״, אולם הפסיק את פעילותו במהרה.',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי',
    'fields_of_activity': [
      [
        'להט״ב',
        'פוליטיקה ומנהיגות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ]
    ],
    'id': 'LR49',
    'is_active': false,
    'keywords': [
      'חקיקה',
      'כנסת',
      'גאווה',
      'מצעד',
      'זכויות להט״ב',
      'תאים מפלגתיים'
    ],
    'name': 'קדימה בגאווה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'פתח תקווה',
    'organization_kind': [
      'מפלגתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'גרוס, אייל (2016). הפוליטיקה של זכויות להט״ב: בין (הומו) נורמטיביות ו(הומו) לאומיות לפוליטיקה קווירית. בתוך: גרוס, אייל, זיו, עמליה ויוסף, רז (עורכים), <b>סקס אחר - מבחר מאמרים בלימודים להט״בים וקוויריים ישראליים</b> (עמ\' 183–245). תל אביב: רסלינג.'
      },
      {
        'title': 'לויאני, רננה (2011, 23 דצמבר). התאים הגאים בכנסת יוצאים מהארון - לא רק בשמאל. <b>מאקו</b>. נדלה מתוך',
        'url': 'https://www.mako.co.il/pride-news/local/Article-3d33b7d349a6431006.htm'
      },
      {
        'title': 'קדימה בגאווה (2018, 26 ינואר). הפרטים אומתו בשיחה של ליהי רוטשילד עם אבי סופר, מקים התא.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '26/01/2019'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 2010,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '15/09/2019'
    },
    'description': 'הקו נוסד ב-1983 על ידי הייזל אריאלי ונרשם כעמותה ״מרכז מידע לנשים בעניני בריאות- קו הבריאות״ (ע״ר 580109627) בשנת 1987 בתל אביב. העמותה הפעילה את הקו הטלפוני הראשון בישראל שנתן מענה בנושאים הנוגעים לבריאות האישה, קיימה הרצאות ושיתופי פעולה עם ארגונים פמיניסטיים אחרים ואף שכרה חדר במשרד סמוך לתנועה הפמיניסטית ומרכז הסיוע בתל אביב. מטרת העמותה היתה: ״להפיץ מידע על נושא הבריאות בקרב הנשים ולעזור להן לממש את זכויותיהן בכל הקשור למוסדות הבריאות״. פעילות הקו פסקה בשנת 2000 ובשנת 2019 העמותה נמחקה מפנקס העמותות באופן סופי.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'YH115',
    'is_active': false,
    'keywords': [
      'קו סיוע',
      'בריאות נשים',
      'זכויות',
      'מיצוי זכויות'
    ],
    'name': 'קו הבריאות - מרכז מידע לנשים בענייני בריאות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'וינטר, רות (2001). רקוויאם לקו הבריאות - 2000-1983 (ריאיון עם הייזל אריאלי - מייסדת הקו)‏. <b>על הקו</b>, 48–50.'
      },
      {
        'title': 'מנור, הדס (1988, 16 מאי). הגיון בריא במקום בו יש הרבה היסטריה. <b>מעריב</b>. נדלה מתוך',
        'url': 'http://www.jpress.nli.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=MAR%2F1988%2F05%2F16&id=Ar05102&sk=18A1546A'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 8190 (2019, יולי אפריל). <b>הודעה סופית בדבר מחיקה מפנקס העמותות</b>. מרכז מידע לנשים בענייני בריאות - ״קו הבריאות״ (מספר עמותה 580109627). עמ\' 9591. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_word/law10/yalkut-8190.pdf'
      },
      {
        'title': 'ח״כ נעמי חזן, תיק מסמכים מתאריך 01/10/1988 עד תאריך 31/05/1995, ארכיון המדינה (תיק סרוק) מס\' זיהוי ISA-knesset-knesset-000t51o'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '23/10/2018'
    },
    'year_closed': 2000,
    'year_closed_text': '2000',
    'year_founded': 1983,
    'year_registered': 1987
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '19/05/2019'
    },
    'description': 'קו הגברים הוקם בשנת 2005 על ידי ויצו ונועד לתת מענה בנושא אלימות במשפחה. הקו נמצא במשרדי ויצו בבית הכרם בירושלים. זהו הקו היחיד שנותן מענה מסוג זה בישראל. הוא פועל כקו טלפון עם מספר מקומי (אזור ירושלים) ומשנת 2016 הוא מופעל כקו חינמי שמספרו 1-800-39-39-04. הקו נותן מענה טלפוני בין השעות 9-16, חמישה ימים בשבוע ומופעל על ידי מתנדבים גברים שעברו הכשרה והדרכה במטרה לספק תמיכה, מידע וייעוץ ראשוני לגברים. מספר הפניות הוא כ-15 בשבוע (700-800 בשנה).',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'SA136',
    'is_active': true,
    'keywords': [
      'גברים אלימים',
      'קו סיוע',
      'תמיכה נפשית'
    ],
    'name': 'קו הגברים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'התארגנות שאינה עמותה',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'גברים',
    'retrieved': {
      'type{date}': '2019-05-19'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.wizo.org.il/%D7%A7%D7%95%D7%95%D7%99-%D7%9E%D7%99%D7%93%D7%A2-%D7%99%D7%99%D7%A2%D7%95%D7%A5-%D7%95%D7%99%D7%A6%D7%95'
      },
      {
        'title': 'קו הגברים – הקו ליציאה ממעגל האלימות במשפחה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/MenHelpLine/'
      },
      {
        'title': 'ינקו, אדיר (2017, 21 יוני). <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-4978585,00.html'
      },
      {
        'title': 'קו הגברים (2018, 15 אוקטובר). הפרטים אומתו בשיחת טלפון עם נציג מקו הגברים.'
      }
    ],
    'target_audiences': [
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '19/05/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'שירותים משפטיים'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '03/10/2018'
    },
    'description': 'קו החירום הראשון בארץ למען נשים מוכות הוקם בשנת 1987 על ידי ויצו בפורמט של שני קווים – האחד בתל אביב והשני באשדוד, בסמוך למקלט לנשים מוכות בעיר כפרויקט משותף בין ויצו, משרד העבודה והרווחה (האגף לטיפול באישה והנערה) והמוסד לביטוח לאומי. שני הקווים פעלו 24 שעות וניתן בהם מידע לפונות על ידי מתנדבות שעברו הכשרה, בדומה למרכזי הסיוע לנפגעות תקיפה מינית. בשנת 1990 הוקם ״קו חירום למניעת אלימות בחיפה״ ובעשור זה נוספו מספר קוים אזוריים שהופעלו על ידי עמותות שונות (״ל.א. לאלימות״ הפעילו קווים ברוסית ועברית באזור השרון, ״נשים נגד אלימות״ הפעילו קו סיוע בערבית באזור נצרת, ו״תהל״ הפעילו קו חירום לנשים דתיות בירושלים). בשנת 1996/7 נוסד קו החירום הארצי על ידי משרד העבודה והרווחה כקו חינם שמספרו 1-800-22-0000. הקו הופעל דרך מכרז על ידי קו החירום בחיפה עד שנת 2006 וניתן בו מענה על ידי מתנדבות ועובדות סוציאליות בחמש שפות. לאחר מכרז נוסף, הועברה האחריות על הקו לידי ויצו שהפעילה אותו עד 2010. העמותה החיפאית פורקה בשנת 2011 וקו החירום הארצי של ויצו הפך ל״קו הגברים״ שמספרו 1-800-39-39-04 שנותן מענה לגברים אלימים. במשך שנות פעילותו קיים קו החירום הארצי מספר קמפיינים ארציים בשיתוף הרשות לקידום מעמד האשה ומשרד הרווחה בנושאים הנוגעים לאלימות נגד נשים וילדים. בשנת 2010 איחד משרד הרווחה תחת מוקד 118 (מוקד מצוקה לענייני רווחה) את מוקד שי״ל – מימוש זכויות האזרח ואת קו החירום הארצי. מאז מופעל המוקד על ידי חברה חיצונית בהתאם למכרז.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'SA55',
    'is_active': false,
    'keywords': [
      'ביטחון אישי',
      'רצח נשים',
      'קו סיוע',
      'תמיכה נפשית',
      'סיוע משפטי'
    ],
    'name': 'קו חירום ארצי למניעת אלימות במשפחה ולמען ילדים בסיכון',
    'name_ar': null,
    'name_change_year': 1997,
    'name_common': null,
    'name_past': 'קו חירום לנשים מוכות',
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'ורצברגר, רחל (2001, 23 דצמבר).<b> קווי חירום לנשים מוכות: מוגש לוועדה לקידום מעמד האישה</b> (גרסת אינטרנט). ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/7340d17c-9132-e811-80de-00155d0a0235/2_7340d17c-9132-e811-80de-00155d0a0235_11_8325.pdf'
      },
      {
        'title': 'משרדה עבודה, הרווחה והשירותים החברתיים (ללא תאריך). <b>דוחות חופש המידע של משרד הרווחה לשנים 2006, 2014–2018</b>. נדלה מתוך',
        'url': 'http://www.molsa.gov.il/freeinfo/Pages/FreeInfo.aspx'
      },
      {
        'title': 'עובדיה, דבי (1991). <b>קו חירום לנשים מוכות</b>. המוסד לביטוח לאומי, מנהל למחקר ותכנון. נדלה מתוך',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/mifal_43.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות',
      'נשים עולות מחבר העמים',
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '10/08/2018'
    },
    'year_closed': 2010,
    'year_closed_text': '2010',
    'year_founded': 1987,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': '״קואליציית הארגונים הדתיים למאבק בזנות״ נוסדה בשנת 2017 כשיתוף פעולה בין פורום הנשים של מפלגת הבית היהודי ושורת ארגונים ועמותות מהמגזר הדתי. את הקואליציה רכזו מיטל בנשק ונעה מבורך אשר עבדו בשיתוף חברת הכנסת שולי מועלם ממפלגת הבית היהודי. הקואליציה מאגדת 18 עמותות וארגונים אחרים שאינם מפלגתיים: בני עקיבא, צוהר, אמונה, בת עמי, בת מלך, ישיבת מערבא, מתן, בית הלל, קולך, מכון באר אמונה, תהל, מרכז המשפחה - מכללת אורות, איגוד רבני הקהילות, הקיבוץ הדתי, נאמני תורה ועבודה, קדמה, תורת ריבה והמזרחי העולמי. באתר הקואליצייה נאמר כי היא ״קמה מתוך תפיסת עולם דתית חברתית שלוקחת אחריות על השיח וההתרחשות במרחב הציבורי במדינת ישראל. תופעת הזנות אינה שייכת למגזר מסוים, והאחריות להפסיק ולבער את הניצול המיני וההתעללות במוחלשים שבחברה, מוטלת על כלל החברה הישראלית. אנו מאמינים בבריאת האדם בצלם אלוקים. ההתייחסות לאישה ולכל אדם כחפץ וככלי למימוש יצרים, פוגעת במחויבות הבסיסית שלנו לתיקון עולם, לעשיית הטוב ולמילוי רצונו של הקב״ה״. מטרות הקואליצייה כוללות: קידום חוק \'הפללת הלקוח\', יצירת קמפיינים ואירועים ציבוריים להעלאת מודעות לתופעה בקרב הציבור הדתי, עידוד פעילות למניעה וסיוע לנשים בזנות.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום בשיתוף מפלגתי',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'זנות'
      ]
    ],
    'id': 'YB83',
    'is_active': true,
    'keywords': [
      'חקיקה',
      'דת',
      'זנות',
      'הפללת לקוח'
    ],
    'name': 'קואליציית הארגונים הדתיים למאבק בזנות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'קואליציה, איגוד או פורום',
      'מפלגתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'זנות',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://fpcoalition.wordpress.com/'
      },
      {
        'title': 'כרמון, טל (2017, 22 יוני). ״תופעה שצריך למגר״. קואליציה חדשה נוסדה: הארגונים הדתיים למאבק בזנות. <b>דבר</b>. נדלה מתוך',
        'url': 'https://www.davar1.co.il/73228/'
      },
      {
        'title': 'מועלם-רפאלי, שולי (2017, 22 יוני). <b>הציונות הדתית מתגייסת למאבק בזנות: זו האחריות שלנו</b> (סרטון). נדלה מתוך',
        'url': 'https://www.youtube.com/watch?v=IfZzHt-YVC4'
      },
      {
        'title': 'קואליציית הארגונים הדתיים למאבק בזנות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/%D7%A7%D7%95%D7%90%D7%9C%D7%99%D7%A6%D7%99%D7%AA-%D7%94%D7%90%D7%A8%D7%92%D7%95%D7%A0%D7%99%D7%9D-%D7%94%D7%93%D7%AA%D7%99%D7%99%D7%9D-%D7%9C%D7%9E%D7%90%D7%91%D7%A7-%D7%91%D7%96%D7%A0%D7%95%D7%AA-289606768181503/'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '12/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2017,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '28/06/2018'
    },
    'description': 'קואליציית יחדיו הוקמה בעקבות הרצח של העובדת הסוציאלית למלם צהאי ז״ל בידי בעלה במטרה לפעול למניעת האלימות במשפחה האתיופית. הקואליציה רכזה והדריכה קבוצות של פעילים בקהילה האתיופית לצורך התמודדות עם אלימות במשפחה. המטרה של ״יחדיו״ היתה להגביל את רמת האלימות במשפחה תוך העלאת מודעות וסינגור עבור שינויי מדיניות אשר מכוונים לטפל בשורשי הבעיה. הקואליצייה נעזרה ברכזת מטעם שתי״ל והארגונים הפעילים בה כללו את: מוקד קליטה גדרה, עמותת ״פותחים שער״, מכנף דרום לציון, מוקד קליטה רחובות, ביה״ח שמואל הרופא, רמלה, תלם לצעירים אתיופים, פתח תקוה, ״קול הקהילה״, לוד, פידל, מתנ״ס גדרה, טבקה, פרויקט פאקט רחובות, טיפת חלב, האגודה לקידום החינוך מרכז היגוי לעולי אתיופיה בקרית חיים, חברים בטבע, היוות ובהלצ\'ן.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'הגירה',
        'קליטת עלייה'
      ]
    ],
    'id': 'YB112',
    'is_active': false,
    'keywords': [
      'אלימות במשפחה',
      'גברים אלימים',
      'קואליצייה',
      'רצח נשים'
    ],
    'name': 'קואליציית יחדיו',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים יוצאות אתיופיה',
    'retrieved': null,
    'sources': [
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל. עמ\' 56–57.'
      },
      {
        'title': 'ועדת העלייה, הקליטה והתפוצות (2007, 12 יוני). <b>ועדת העלייה, הקליטה והתפוצות והוועדה לקידום מעמד האשה קיימו היום ישיבה משותפת בנושא: התגברות האלימות כלפי נשים בקרב יוצאי אתיופיה</b>. נדלה מתוך',
        'url': 'http://main.knesset.gov.il/Activity/committees/Immigration/News/pages/pr_1475_12062007.aspx'
      },
      {
        'title': 'חותמים מחדש (ללא תאריך). <b> העצמת נשים: התמודדות עם אלימות במשפחה – מדריך לקהילה האתיופית</b>. נדלה מתוך',
        'url': 'https://signinganew.wordpress.com/%D7%AA%D7%9B%D7%A0%D7%99%D7%95%D7%AA/%D7%AA%D7%9B%D7%A0%D7%99%D7%95%D7%AA-%D7%A2%D7%91%D7%A8/%D7%94%D7%A2%D7%A6%D7%9E%D7%AA-%D7%A0%D7%A9%D7%99%D7%9D/'
      }
    ],
    'target_audiences': [
      'נשים יוצאות אתיופיה'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '22/09/2018'
    },
    'year_closed': 2013,
    'year_closed_text': '2013',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '03/11/2018'
    },
    'description': 'קואליציית נשים חיפה הוקמה בשנת 1992 על ידי שלושה גופים: ״אשה לאשה-מרכז פמיניסטי חיפה״, ״קו חירום לנפגעות אלימות״ (נסגר) ו״מרכז סיוע לנפגעות אונס ותקיפה מינית חיפה״. בשנת 1998 הצטרפה עמותת ״כיאן-ארגון פמיניסטי״ לקואליציה ומאוחר יותר גם ארגון ״אסוואת״. ארגוני הקואליצייה חולקים בית משותף בתמיכת עיריית חיפה ומקיימים פעילויות מגוונות. מטרות הקואליציה הן: ״להוות גוף שיפעל במשותף לקידום המאבק בנושא אלימות כלפי נשים והעלאת מודעות ציבורית בנושאי זכויות נשים״. הקואליצייה שמה לה למטרה להיאבק למען שוויון זכויות והזדמנויות לנשים כנגד כל צורות האלימות לטובת נשים מכל גזע, דת, לאום והעדפה מינית. לאורך השנים שימשה הקואליציה חממה להתארגנויות פמיניסטיות רבות ויש בה ספרי, חדרי ישיבות ופעילויות קהילתיות מגוונות. הקואליצייה הפעילה מספר פרויקטים: (א) פרויקט צפייה בבתי משפט (1993-1996) נוסד בעקבות פעילות סביב משט אונס בשמרת והתמקד במעמדן של נשים נפגעות אלימות בבתי משפט. (ב) פרויקט ״חוק וצדק״ (1993-1997) סיוע משפטי לנשים בבתי דין דתיים. (ג) פרויקט חינוך למניעת אלימות (1998-2004) שהעביר סדנאות לתלמידים/ות והכשרות למורות בנושא פמיניזם ואלימות מינית.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום בשיתוף מוניציפלי',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'חינוך',
        'מניעת אלימות'
      ]
    ],
    'id': 'SA80',
    'is_active': true,
    'keywords': [
      'אונס',
      'אלימות במשפחה',
      'פרסום פוגע',
      'נשים יוצאות אתיופיה',
      'חינוך פמיניסטי',
      'קו סיוע',
      'משפט',
      'נשים מוכות'
    ],
    'name': 'קואליציית נשים חיפה',
    'name_ar': 'إئتلاف نساء حيفا',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'קואליציה, איגוד או פורום',
      'מוניציפלי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'ספרן, חנה ובר-דין, תלמה (עורכות). (2013). <b>אשה לאשה פמיניסטית: שלושים שנות פעילות</b>. חיפה: הוצאת פרדס ואשה לאשה, מרכז פמיניסטי. נדלה מתוך',
        'url': 'http://isha2isha.com/wp-content/uploads/2018/01/%D7%90%D7%A9%D7%94-%D7%9C%D7%90%D7%A9%D7%94-%D7%A4%D7%9E%D7%99%D7%A0%D7%99%D7%A1%D7%98%D7%99%D7%AA.pdf'
      },
      {
        'title': 'צברי, הלה (2010). <b>״קואליצית נשים בחיפה״: בין גיוון לאחדות</b>. (עבודת גמר לקבלת תואר ״מוסמך למדעי החברה״). אוניברסיטת בר-אילן.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות',
      'להט״ב',
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1991,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחאה',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '22/05/2018'
    },
    'description': '״קואליציית נשים לשלום״ היא ארגון פמיניסטי שהוקם בנובמבר 2000, עם פרוץ האינתיפאדה השנייה, כפעולה משותפת של הארגונים הבאים: נשים בשחור, בת שלום, מחסום ווטש, נגה, נל״ד, האם החמישית, תנד״י ו-WILPF . הקואליציה פעלה תחילה בירושלים אך מאוחר יותר עברה לתל אביב. בשנת 2004 נרשמה הקואליצייה כעמותה עצמאית (ע״ר 580431799) שמטרותיה הן: ״לפעול למען שלום, צדק ושוויון בחברה הישראלית״. בקואליציה שותפות נשים ממגוון רחב של מגזרים וזהויות, כולל נשים יהודיות ופלסטיניות אזרחיות ישראל, והיא מחויבת למאבק לסיום הכיבוש וליצירת חברה צודקת, תוך הרחבת מעורבותן והשתתפותן של נשים בשיח הציבורי. הקואליציה יוזמת קמפיינים ציבוריים ופעילויות הסברה וחינוך, תוך מחויבות לפיתוח והטמעה של שיח פמיניסטי בכל זירות החברה. בין הקמפיינים הפוליטיים הבולטים שהובילה הקואליציה בשנות פעילותה: הקמפיין להסרת המצור מעל עזה, מחאה ציבורית כנגד מלחמת לבנון השנייה, הובלת קואליציה של 20 ארגוני נשים נגד אלימות מינית של בכירים בממשל ובצבא, ודרישה ציבורית למתן דין וחשבון על פשעי המלחמה שבוצעו על ידי ישראל. בנוסף, הקואליציה תומכת בפעילות פמיניסטיות ובארגונים חברתיים ומעניקה להם סיוע, תוך דגש על סיוע לקבוצות של נשים וצעירים. מדי שנה מארגנת הקואליציה סדנאות והכשרות בתחומי עבודה עם התקשורת, תכנון וארגון פעילות ציבורית וייעוץ משפטי לפעילים/ות. עוד מסייעת הקואליציה ליוזמות עצמאיות וצעירות בתמיכה בהפקת פעילות ובגיוס כספים, תוך יצירת שותפות משמעותית וסולידרית. פרויקט נוסף שיזמה הקואליצייה בשנת 2007 הוא ״מי מרוויח מהכיבוש״ שנועד לחשוף את המעורבות המסחרית של חברות ישראליות ובינלאומיות ״בכלכלת ההתנחלויות, בעיסקאות נדל״ן ופיתוח תשתיות בשטחים, בניית חומות, מחסומים וגדרות על אדמה פלסטינית, פיתוח ומכירה של ציוד ייעודי לשליטה באוכלוסייה האזרחית בשטחים ודיכוייה, תוך כדי הפרת זכויות אדם״. בשנת 2013 הפך ״מי מרוויח״ לעמותה עצמאית. כחלק מהיות הקואליציה ״חממה״ ליוזמות והתארגנויות חדשות, פעלה בקואליציה במשך שנים רבות גם קבוצת \'פור״ה\' (FORA) התארגנות של פעילות דוברות-רוסית המקדמות שינוי חברתי ופוליטי בקרב ציבור דוברי-הרוסית בישראל.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'זכויות אדם'
      ]
    ],
    'id': 'SA11',
    'is_active': true,
    'keywords': [
      'אינתיפאדה',
      'כיבוש',
      'מיליטריזם',
      'נשק',
      'פלסטיניות',
      'צדק חברתי',
      'אסירות',
      'נתונים'
    ],
    'name': 'קואליציית נשים לשלום',
    'name_ar': 'تحالف النساء للسلام',
    'name_change_year': null,
    'name_common': null,
    'name_past': 'קואליצית נשים לשלום צודק',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.coalitionofwomen.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>קואליצית נשים לשלום (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580431799'
      },
      {
        'title': 'בנסקי, טובה (2006). ״קואליציית הנשים לשלום צודק״: פרויקט השלום הפמיניסטי כחלק מהמגמות לאזרוח החברה הישראלית. בתוך: בן רפאל, אליעזר, בראלי, אבי, יער, אפרים וכהן, אורי (עורכים), <b>ישראל והמודרניות, למשה ליסק ביובל</b> (עמ\' 524–549). באר שבע: מכון בן גוריון לחקר ישראל, הציונות ומורשת בן גוריון.'
      },
      {
        'title': 'Svirsky, Gila (n.d). <b>We do not obey: Women in the footsteps of Ilana Hammerman</b>. Retrieved from',
        'url': 'http://www.gilasvirsky.com/index.html'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות',
      'להט״ב',
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '22/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': 2004
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '28/06/2018'
    },
    'description': 'עיקר (International Coalition for Agunah Rights) היא קואליציה בינלאומית של כ-24 ארגונים, הפועלת לקידום מציאת פתרונות במסגרת ההלכה לבעייתן של עגונות ומסורבות גט ולמיגור התופעה. הקואליציה הוקמה בשנת 1992 ביוזמתה של אליס שלוי ובהובלת מנכ״לית שדולת הנשים דאז לזלי זקס. ובשנים 2002- 2010 רוכזה בידי שתי״ל. הקואליציה פעילה בשלושה מישורים: העלאת מודעות לאפליית נשים בהליכי גירושים (עגינות, סרבנות גט) באמצעות כנסים וארועים ציבוריים, שינוי חקיקה והרחבת סמכויות בתי הדין לענייני משפחה, ומציאת פתרונות בשיתוף עם בתי הדין הרבניים, כמו למשל הטלת סנקציות על סרבני גט וניסוח הסכמי קדם-נישואין. הקואליצייה מאחדת ארגונים חברתיים, ארגוני נשים, ארגונים למען זכויות אדם וצדק חברתי ומרכזים אקדמיים, בעלי תפיסות עולם וגישות דתיות שונות ומגוונות והארגונים החברים בה השתנו עם השנים. ביניהם: שדולת הנשים, נעמ״ת, ויצו, אמונה, JOFA- Jewish Orthodox Feminist Alliance, אשה לאשה-מרכז פמיניסטי חיפה, הדסה, מרכז רקמן לקידום מעמד האשה, תהל, מבוי סתום, ליגת נשים מסורתיות, קולך, יד לאישה, המרכז לחקר האשה בהלכה, מרכז צדק לנשים, המרכז לפלורליזם יהודי ועוד.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ]
    ],
    'id': 'YB113',
    'is_active': true,
    'keywords': [
      'דיני אישות',
      'הלכה',
      'חקיקה',
      'עגינות',
      'סרבנות גט',
      'גירושין',
      'שיתוף פעולה בינלאומי',
      'האמנה לביעור כל צורות ההפליה נגד נשים 1979 CEDAW'
    ],
    'name': 'קואליציית עיקר - הקואליציה הבינלאומית לזכויות העגונה ומסורבת הגט',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'קואליציה, איגוד או פורום',
      'בינלאומי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.icar.org.il/home-hebrew.html'
      },
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל. עמ\' 57–58.'
      },
      {
        'title': 'Zylberberg, Sonia (2009, February 27). International coalition for agunah rights (ICAR). In <b>Jewish women: A comprehensive historical encyclopedia</b>. Jewish women\'s archive. Retrieved from',
        'url': 'https://jwa.org/encyclopedia/article/international-coalition-for-agunah-rights-icar'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '22/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1992,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '01/11/2018'
    },
    'description': 'QueenB נוסדה בשנת 2015 על ידי שתי סטודנטיות למדעי המחשב מהאוניברסיטה העברית, נטע מוזס ויסמין דנסקי, במטרה להעלות את מספר הנשים הבוחרות לעסוק במקצועות טכנולוגיים. בשנת 2017 היא נרשמה כעמותה בשם ״קווין בי״ (ע״ר 580644466) שמטרותיה: ״פעילות חינוכית, לימוד נערות לאחר שעות בית הספר. עידוד נערות לבחירת מגמת מחשבים במטרה להשתלב בחברות הייטק״. פעילות העמותה כוללת תכנית שבמהלכה סטודנטיות למדעי המחשב מלמדות נערות בכיתה ח\' ומקבלות מלגה. בנוסף, התכנית מכוונת ליצור רשת מקצועית לסטודנטיות למדעי המחשב והנדסה בשישה מוקדים: אוניברסיטת תל אביב, האוניברסיטה העברית, הטכניון בחיפה, אוניברסיטת בן-גוריון, בחברת Western digital בכפר סבא וב- JestHUB במזרח ירושלים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף אקדמי',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'מדע וטכנולוגיה'
      ],
      [
        'השכלה גבוהה ומחקר',
        'אקדמיה, חברה וקהילה'
      ]
    ],
    'id': 'YH127',
    'is_active': true,
    'keywords': [
      'מנטורינג',
      'סטודנטיות',
      'נערות',
      'תכנות',
      'טכנולוגיה'
    ],
    'name': 'קווין בי- QueenB',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'אקדמי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מדע וטכנולוגיה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-01-11'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.queenb.org.il/?fbclid=IwAR2dyuaU30GuIeYfVFNDzqylU34tVsVcDeDZIDkoXmKfKwkb2PjSTvta3cM'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>קווין בי (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580644466'
      },
      {
        'title': 'QueenB, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/queenb.program/'
      },
      {
        'title': '(2017, יוני אפריל). הסטודנטיות שמעודדות נערות ללמוד במגמת מחשבים. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-4944333,00.html'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/01/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': 2017
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '23/10/2018'
    },
    'description': 'מרכז ״קול האישה״ בחיפה הוקם בשנת 1979 על ידי מרשה פרידמן שכותבת: ״פתחתי עסק קטן ולא נושא רווחים של הזמנת ספרים דרך הדואר, ״קול האשה״ [...] מדי חודש בחודשו נסעתי לתל אביב וסרקתי את כל המדפים בחיפוש אחר ספרות פמיניסטית. [...] החלטנו לשכור דירה בקומה שנייה של בניין-אבן ישן (בחיפה) בבעולתה של אשה מבוגרת שהיתה בעבר פעילה בויצו. [...] מבלי שתכננו זאת מראש, הפך ״קול האשה״ למרכז לנשים וחנות ספרים גם יחד.״ (עמ\' 191). הפעילות ב״קול האשה״ הייתה מגוונת: הרצאות על בריאות ופוליטיקה נשית, הכרות עם מוסדות כמו מרכזי סיוע, קבוצות להעלאת תודעה וחוגים לנשים כמו תיקוני בית, ג\'אז וכדומה. המרכז שימש גם מקום מפגש לקהילה הלסבית הצפונית.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ]
    ],
    'id': '1SA3',
    'is_active': false,
    'keywords': [
      'פמיניזם',
      'קבוצות להעלאת תודעה',
      'חנות ספרים',
      'לסביות',
      'בריאות',
      'פוליטיקה'
    ],
    'name': 'קול האישה - חיפה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'ספרן, חנה (2006). <b>לא רוצות להיות נחמדות: המאבק על זכות הבחירה לנשים וראשיתו של הפמיניזם החדש בישראל</b>. חיפה: פרדס. נדלה מתוך',
        'url': 'https://kotar.cet.ac.il/KotarApp/Viewer.aspx?nBookID=95436106'
      },
      {
        'title': 'ספרן, חנה, הרטל, רחלי וששון-לוי, אורנה (2016). הי[א]סטוריה לסבית מקומית: פעילות, מאבקים והישגים. בתוך: הראל, אלון, לושינסקי, יניב ומורגנשטרן, עינב (עורכים), <b>זכויות הקהילה הגאה בישראל: משפט, נטייה מינית וזהות מגדרית</b> (עמ\' 45–80). האוניברסיטה העברית, המכון למחקרי חקיקה ולמשפט השוואתי. צפרירים: נבו.'
      },
      {
        'title': 'פרידמן, מרשה (1990). <b>גולה בארץ המובטחת</b>. מאנגלית: מירי קרסין. תל אביב: ברירות.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '23/10/2018'
    },
    'year_closed': 1981,
    'year_closed_text': '1981',
    'year_founded': 1979,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '25/04/2018'
    },
    'description': '״קול האשה״ נוסדה ב-1994 כבית לפעילות פמיניסטית רב-תרבותית בירושלים המעצימה מעורבות חברתית ומחוייבות לאחווה בין נשים מזהויות שונות. בעשור הראשון לקיומו השתתף הארגון בקואליציות של ארגונים פמיניסטיים ובארגון הכנסים הפמיניסטיים. כך תיארו עצמן חברות הארגון אז: ״אנו רואות בכוחות אישיים, חברתיים, כלכליים ותרבותיים של נשים משאב ליצירת סולידריות, שינוי וצדק חברתי על פי ערכים פמיניסטיים של שיתוף ושלום. קול האשה מחויבת להגיע לנשים מקהילות מנוחשלות ולהשתתף במאבק למען צדק חברתי ושחרור. כן מחויבת קול האשה לעורר מודעות בדבר יחסי הכוח בחברה בקרב נשים בעלות כוח חברתי וליצור סולידריות בין נשים. אנו רואות בפעילות המשלבת בין צרכים של נשים, העצמה אישית, חברתית ותרבותית ויצירת סולידריות בין קהילות נשים שונות אבן יסוד לפעילות ציבורית פמיניסטית למען שינוי חברתי ואתגר מבני הכוח הדכאניים בחברה.״ (אצל גולן-עגנון 2002) בשנת 1994 הוקמה בבית הארגון בקינג ג\'ורג\' 40 הגלריה הפמיניסטית ״אנטיאה״ על ידי נעמי טנהאוזר וריטה מנדס-פלור שפעלה עד שנת 2009. למרות שהעמותה ממשיכה להתקיים, יש הבדל משמעותי בין תיאור מטרות ופעילות הארגון בשנת 2018 לבין מטרות הארגון בעבר. בעשור זה הארגון התמקד בעיקר בהעצמה כלכלית ותעסוקת נשים ותואר כך: ״קול האישה היא עמותה הקיימת משנת 1994 אשר שמה לה למטרה לקדם את מעמדן ועצמאותן של נשים בחברה, באמצעות קידום תעסוקתי. קול האישה פועלת בירושלים והסביבה ופונה לנשים מרקעים חברתיים וכלכליים מגוונים, מובטלות או המועסקות בעבודה שאינה מתאימה לכישוריהן וצרכיהן״. בשנת 2019 העמותה נמחקה מפנקס העמותות לאחר שפורקה מרצון.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'תעסוקה ועבודה',
        'השמה וליווי בתעסוקה'
      ],
      [
        'תרבות וספורט',
        'אמנות'
      ]
    ],
    'id': 'SA7',
    'is_active': true,
    'keywords': [
      'אמנות',
      'גלריה',
      'דיור',
      'העצמה',
      'חד הוריות',
      'חקיקה',
      'מזרחיות',
      'סיוע משפטי',
      'פמיניזם',
      'צדק חברתי',
      'שלום'
    ],
    'name': 'קול האשה',
    'name_ar': 'صوت المرأة',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-07'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://alizakolhaisha.wixsite.com/kol-haisha/about'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>קול האשה: עמותה מחוקה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580241404'
      },
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל.'
      },
      {
        'title': 'גולן-עגנון, דפנה (2002). <b>איפה אני בסיפור הזה?</b> ירושלים: כתר, עמ\' 232.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '29/09/2021'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1994,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': 'ארגון ״קולך״ נוסד על ידי קבוצת נשים, אשר החלו להפגש בשנת 1996 בראשות חנה קהת וביניהן מרים ‏שפירא, רות קדרי, מיכל פרנץ, הרבנית חנה הנקין (ראש מדרשת נשמת), יהודית שילת (ראש פורום ‏תקנה) וליאורה מינקה (לימים יו״ר אמונה). העמותה (ע״ר 580328136) נוסדה בשנת 1998 לאחר כנס‎ JOFA ‎בניו יורק ‏במטרה לקדם סדר יום פמיניסטי דתי בישראל ולפעול לשם ״קידום מעמד האשה בחברה היהודית ‏הדתית ובחברה הישראלית, קידום יוזמות לפתרונות הלכתיים ומשפטיים לבעיות נשים במשבר ‏משפחתי, עידוד השכלה תורנית לנשים, ייזום מערכות סיוע והכוונה לנשים״ (מתוך מטרות העמותה). ‏בשנים הראשונות התמקדה ״קולך״ בהוצאה לאור של עלון, ובכתיבה פובליציסטית אינטנסיבית ‏בעיתונות הדתית (בעיקר בעיתון ״הצופה״) בסוגיות הנוגעות לשאלת מעמד האישה בחיים הדתיים ובחברה ‏הדתית. מאוחר יותר התרחבה פעילות התנועה לכדי עיסוק בנושאים הקשורים למצוקות של נשים ‏דתיות ובמיוחד בעניין מצוקת מסורבות הגט והעגונות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'דת ומעמד אישי',
        'מעמד אישי ודיני משפחה'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'חינוך',
        'פמיניזם ושוויון בין המינים'
      ]
    ],
    'id': '1YB13',
    'is_active': true,
    'keywords': [
      'פמיניזם',
      'יהדות',
      'מנהיגות',
      'הדרת נשים',
      'צדק חברתי',
      'הלכה'
    ],
    'name': 'קולך- פורום נשים דתיות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'דת ומעמד אישי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מעמד אישי ודיני משפחה',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-09-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.kolech.org.il/he/about-us.html'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>קולך – פורום נשים דתיות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580328136'
      },
      {
        'title': 'Shilo, Margalit (2009, February 27). Kolech: Religious Women\'s Forum. In <b>Jewish women: A comprehensive historical encyclopedia</b>. Jewish women\'s archive. Retrieved from',
        'url': 'https://jwa.org/encyclopedia/article/kolech-religious-womens-forum'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '27/05/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1996,
    'year_registered': 1998
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '27/06/2018'
    },
    'description': '״מרכז טיפול וסיוע לפליטים אפריקאים- ארטס״ (ע״ר 580520526) הוקם בשנת 2010 על ידי דידי מימון כהן, פסיכולוגית קלינית בהכשרתה אשר חקרה את ההשפעה של אונס והתעללות מינית על מבקשות מקלט מאריתראה אשר הגיעו לישראל דרך סיני. העמותה מספקת שירותים לנשים פליטות ומבקשות מקלט וילדיהן. קוצ\'ינטה - פרויקט הדגל של העמותה הוא קולקטיב של נשים הקולעות סלים. העמותה מסייעת במכירתם בירידים וחנויות וכן מכשירה נשים לקליעת סלים. בנוסף מספקת העמותה תמיכה פסיכו-סוציאלית, סיוע בבעיות רפואיות, בקשיי היום-יום וסיוע בטיפול בעצמן ובילדים. העמותה רשומה בכתובת של המייסדת בהרצליה אך הכתובת הרשמית של היא ברח\' הר ציון בדרום תל אביב. העמותה נתמכת בין היתר על ידי הכנסיה (הפטריארך הלטיני בירושלים).',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'הגירה',
        'פליטות ומבקשות מקלט'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'YH33',
    'is_active': true,
    'keywords': [
      'תמיכה נפשית',
      'טראומה',
      'הגירה',
      'זכויות',
      'סיוע לאמהות'
    ],
    'name': 'מרכז טיפול וסיוע לפליטים אפריקאים - ארטס',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'קוצ\'ינטה',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'הגירה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פליטות ומבקשות מקלט',
    'primary_target_audience': 'נשים מהגרות עבודה או חסרות מעמד',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מרכז טיפול וסיוע לפליטים אפריקאים – ארטס (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580520526'
      },
      {
        'title': 'קוצ\'ינטה (ללא תאריך). <b>אודות קולקטיב קוצ\'ינטה</b>. נדלה מתוך',
        'url': 'https://www.kuchinate.com/copy-of'
      },
      {
        'title': 'Latin Patriarchate of Jerusalem (n.d). <b>Kuchinate</b> (The page is no longer available).',
        'url': 'http://project.lpj.org/wp-content/uploads/2016/08/Kuchinate.pdf'
      }
    ],
    'target_audiences': [
      'נשים מהגרות עבודה או חסרות מעמד'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '27/06/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2010,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '09/11/2018'
    },
    'description': 'פרויקט ״קידמה״ לקידום האישה בחברה הישראלית הוקם בשנת 1984 על ידי ארלט אדלר במטרה להעביר הרצאות וקורסים על מעמד האשה לנשים שלא למדו במסגרת אקדמית מסודרת על ידי הבאתן לאוניברסיטת חיפה ועל ידי הרצאות בקהילות שונות. את הפרויקט ניהלה פרופ\' מרילין ספר והוא פעל במסגרת אוניברסיטת חיפה עד שנת 2010. במשך שנות קיומו פעל הפרויקט בשיתוף פעולה עם ארגוני נשים רבים ברמה הארצית והמקומית ויזם אינספור פעילויות חינוכיות. את הפעילויות ב״קידמה״ העבירו נשות אקדמיה ונשות מקצוע. ואלה כללו קבוצות, ימי עיון וקורסים לאוכלוסיות מגוונות בקהילה ובאוניברסיטה. נושאי הפעילויות היו פורצי דרך בזמנם וכללו עיסוק בשיוויון בין המינים, זיהוי ומניעת אלימות כלפי נשים, אסרטיביות, פיתוח כישורי מנהיגות, דימוי עצמי ודימוי גוף, העצמת נשים ומנהיגות. מטרת הפעילויות נועדה ״לקדם נשים מבחינה אישית ומקצועית בקהילה ולהוביל לשינויים חברתיים״.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'אקדמיה, חברה וקהילה'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ],
      [
        'נערות וצעירות',
        'חינוך'
      ]
    ],
    'id': 'SA86',
    'is_active': false,
    'keywords': [
      'השלמת השכלה',
      'קידום נשים',
      'מנהיגות',
      'דימוי גוף',
      'שוויון'
    ],
    'name': 'קידמה- לקידום האישה בחברה הישראלית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חיפה',
    'organization_kind': [
      'אקדמי'
    ],
    'primary_activity_area': 'חיפה',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'אקדמיה, חברה וקהילה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'אוניברסיטת חיפה, מערך דוברות הסברה ותקשורת (ללא תאריך). <b>קידמה- לקידום האישה בחברה הישראלית</b> (העמוד אינו זמין יותר).'
      },
      {
        'title': 'Safir, Marylin, P. (2009). Women\'s Studies in Israel. In <b>Jewish women: A comprehensive historical encyclopedia</b>, Jewish women\'s archive. Retrieved from',
        'url': 'https://jwa.org/encyclopedia/article/womens-studies-in-israel'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '22/11/2018'
    },
    'year_closed': 2010,
    'year_closed_text': '2010',
    'year_founded': 1984,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '13/12/2018'
    },
    'description': '״אלסנבאל- לטיפוח היזמות החברתית והכלכלית״ הוא חל״צ רשום (ח.ר. 513826982) שהוקם בשנת 2006 המקיים מפעל הקייטרינג ומוגדר כעסק חברתי. מפעל הקייטרינג שהחל לפעול בשנת 2008 ביישוב ח\'ורה הינו מיזם משותף של אמל אלסאנע אלחג\'ו\' מ״אג\'יק מכון הנגב״ וראש המועצה, ד״ר מוחמד אלנבארי​. המפעל אשר מעסיק נשים בדואיות מהנגב מייצר מדי יום כ-8,000 מנות חמות המוגשות כארוחות צהריים לילדי בתי הספר בחורה וביישובים בדואיים נוספים באזור. על פי המודל העסקי: 20% מהרווחים מושקעים בפרויקטים חברתיים בחברה הבדואית הנבחרים על ידי ועדת השקעות שחברות בה נציגי העובדות; 40% מועברים לפרוייקטים קהילתיים בישוב חורה; ו-40% נוספים בפרוייקטים חברתיים של מכון אג\'יק. בשנת 2017 נפתח מפעל נוסף במגדל העמק.',
    'description_ar': 'السنابل لتعزيز روح المبادرة الاجتماعية والاقتصادية وهو مطبخ الذي يعتبر ״شركة للمنفعة العامة״ (ח.ר. 513826982) والذي أقيم عام 2006 كمطبخ وكمصلحة اجتماعية. انطلق عمل المطبخ في عام 2008 في بلدة حورة-النقب كمشروع مشترك بين امل الصانع الحجوج من أجيك معهد النقب ورئيس المجلس المحلي في حورة د. محمد النباري. يُشغل المصنع نسار بدويات من النقب وينتج في اليوم ما يقارب 8000 وجبة ساخنة التي تقدك للأطفال المدارس في حورة والقرى البدوية المجاورة. وبحسب النموذج التجاري: 20% من الأرباح تستثمر في مشاريع اجتماعية في النقب والتي يتم اختيارها على يد لجنة الاستثمار المختارة من ممثلي عن المشاريع. 40% مخصصين لمشاريع جماهيرية في حورة. 40% أخرى لمشاريع تجارية تخص أجيك معهد النقب. في عام 2017 افتتح فرع اخر للمصنع في المجيدل.',
    'display_organization_kind': 'התארגנות שאינה עמותה בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'תרבות וספורט',
        'מלאכות מסורתיות'
      ]
    ],
    'id': 'YH157',
    'is_active': true,
    'keywords': [
      'בדואיות',
      'בישול',
      'חל״צ'
    ],
    'name': 'אלסנאבל - לטיפוח היזמות החברתית והכלכלית בע״מ (חל״צ)',
    'name_ar': 'مطبخ نساء حورة - السنابل',
    'name_change_year': null,
    'name_common': 'קייטרינג נשות חורה',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'חורה',
    'organization_kind': [
      'התארגנות שאינה עמותה',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אלסנאבל – לטיפוח היזמות החברתית והכלכלית בע״מ (חל״צ): חל״צ</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/513826982'
      },
      {
        'title': 'ויסברג, הילה (2014, 10 יולי). אי אפשר לבסס עסק חברתי על חמלה. <b>TheMarker</b>. נדלה מתוך',
        'url': 'https://www.themarker.com/tv/career/1.2372024'
      },
      {
        'title': 'קייטרינג נשות חורה. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://www.hamichlol.org.il/%D7%A7%D7%99%D7%99%D7%98%D7%A8%D7%99%D7%A0%D7%92_%D7%A0%D7%A9%D7%95%D7%AA_%D7%97%D7%95%D7%A8%D7%94'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '13/12/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2008,
    'year_registered': 2006
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '28/09/2018'
    },
    'description': 'הארגון ״קיימא יצירת קהילה תומכת לאמהות יחידניות דתיות מבחירה״ נוסד בשנת 2010 על ידי ועבור ‏נשים דתיות בנות 35 ומעלה מישראל, מארה״ב ומאנגליה שאינו נשואות ומועניינות להביא ילדים ללא זוגיות. מטרת הארגון היא ליצור קהילה תומכת ‏לנשים אלו ולספק מידע על תהליכים ואפשרויות שקשורות לפריון ‏ולהתמודדויות עם ההלכה והחברה הדתית. לארגון תמיכה מקצועית-הלכתית רציפה של הרב יובל שרלו ‏והרב בני לאו.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ],
      [
        'דת ומעמד אישי',
        'בריאות ופריון'
      ],
      [
        'בריאות ופריון',
        'הריון ולידה'
      ]
    ],
    'id': 'SW23',
    'is_active': true,
    'keywords': [
      'קהילה',
      'תמיכה נפשית',
      'יהדות',
      'טכנולוגיות פריון',
      'פוריות',
      'הלכה',
      'דיני אישות',
      'חד הוריות'
    ],
    'name': 'קיימא יצירת קהילה תומכת לאמהות יחידניות דתיות מבחירה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-09-28'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.kayamamoms.org/'
      },
      {
        'title': 'קיימא, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/KayamaMoms/'
      },
      {
        'title': 'Schischa, Rebecca (2016, 2 May). Q&A: Dina Pinner of KayamaMoms talks motherhood for single orthodox women. <b>The Sisterhood, Forward</b>. Retrieved from',
        'url': 'https://forward.com/sisterhood/339783/qa-dina-pinner-of-kayamamoms-talks-motherhood-for-single-orthodox-women/'
      },
      {
        'title': 'Richler, Jennifer (2017, 12 January). In Israel, religious single moms gain greater acceptance. <b>Jewish Telegraphic Agency</b>. Retrieved from',
        'url': 'https://www.jta.org/2017/01/12/life-religion/in-israel-religious-single-moms-gain-greater-acceptance'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '11/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2010,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '17/07/2019'
    },
    'description': '״קינוקלאן - נשים עם מצלמות״ (ע״ר 580625523) נוסדה ב-2016 על ידי הקולנוענית דנה גולדברג והמשוררת אפרת מישורי. העמותה היא למעשה אנסמבל של יוצרות, שהוקם במטרה להפיץ יצירות קולנועיות, ספרותיות ואחרות, הנותנות ביטוי לנקודת המבט של נשים ולחוויות החיים שלהן. אנסמבל העמותה, יצר סרטים קצרים וארוכים, קיים סדנאות, כיתות אמן, והוציא לאור ספרים וגיליונות של שירת נשים. סרט באורך מלא שנוצר במסגרת העמותה, ״מות המשוררת״, השתתף בתחרות הרשמית של פסטיבל הקולנוע הבינלאומי בירושלים בשנת 2017 ואף זכה בפרסים. העמותה עוסקת כיום (2019) בעיקר ביצירה קולנועית באמצעות סדנאות מעשיות, מקומיות ובינלאומיות, הקרנות סרטים ושיתופי פעולה מגוונים שתכליתם לספק לנשים מרחב קהילתי-יצירתי ולהנגיש להן כלי ביטוי אודיו-ויזואליים באמצעותם יוכלו לספר את סיפורן מנקודת מבטן.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תרבות וספורט',
        'קולנוע'
      ]
    ],
    'id': 'YH93',
    'is_active': true,
    'keywords': [
      'פמיניזם',
      'יוצרות',
      'קולנוע',
      'רישות',
      'קידום נשים',
      'מנטורינג'
    ],
    'name': 'קינוקלאן - נשים עם מצלמות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תרבות וספורט',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קולנוע',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-10-29'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://he.kinoclan.org/about/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>קינוקלאן – נשים עם מצלמות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580625523'
      },
      {
        'title': 'קינוקלאן, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/kinoclan2016/'
      },
      {
        'title': 'אלפנט, ליאור ודקל, טל (2018). אקטיביזם פמיניסטי באמנות: דרכי פעולה חתרניות במרחב האמנותי-חברתי-פוליטי בישראל. <b>מגדר, 5</b>. נדלה מתוך',
        'url': 'http://blogdebate.org/gender/journal/wp-content/uploads/2018/12/%D7%90%D7%9C%D7%A4%D7%A0%D7%98-%D7%95%D7%93%D7%A7%D7%9C-.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '29/10/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'סנגור, מעקב ושינוי מדיניות',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': '״קל״ף- קהילה לסבית פמיניסטית״ (ע״ר 580271534) הוקמה בשנת 1987, כקבוצה קהילתית לנשים לסביות-פמיניסטיות בתל אביב. עם הזמן התרחבה פעילות הקבוצה ובשנת 1996 היא נרשמה כעמותה תחת הכתובת של טל ואביטל ירוס-חקק בתל אביב. מטרותיה היו: ״להיות בית לקהילה הלסבית פמיניסטית ברוח פלורליסטית, להוביל לשינוי חברתי ולמציאות שוויונית. להוות קבוצת תמיכה ללסביות ובני משפחתן. לחזק ולתמוך בזהות לסבית-פמיניסטית. לפעול להשגת שיוויון זכויות ללסביות.״ ארגון קל״ף קיים פעילויות רבות ומגוונות,:מפגשים חברתיים ותרבותיים כגון מופעים, כנסים ותערוכות; הפעיל קו ייעוץ ומידע; פרסם את העיתונים ״קל״ף חזק״ ו״פנדורה״; ועבד בשיתוף פעולה עם משרד הרווחה כגורם מייעץ. קל״ף היתה שותפה למספר קואליציות פמיניסטיות והובילה עתירות לבית המשפט בנושאים הנוגעים לקהילה הלהט״בית בישראל. בין מייסדות ומנהיגות הארגון היו חיה שלום, מיכל עדן, עדית מרן, עינב זילבר, נועה רז, קרין גוטרמן ועדי מורנו. למרות שהעמותה עדיין מופיעה בפנקס העמותות בשנת 2018, הארגון הפסיק לפעול בשנת 2005.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'תקשורת'
      ]
    ],
    'id': '1YB5',
    'is_active': false,
    'keywords': [
      'לסביות',
      'פמיניזם',
      'מחאה',
      'סיוע משפטי',
      'זכויות',
      'שיוויון',
      'זכויות להט״ב',
      'מגזין'
    ],
    'name': 'קל״ף-קהילה לסבית פמיניסטית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-09-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://web.archive.org/web/20070115100259/http://www.gay.org.il/claf/'
      },
      {
        'title': '<b>בג״ץ 7869/98 קל״ף – קהילה לסבית פמיניסטית נ\' שר החינוך והתרבות והספורט</b> (1998). נדלה מתוך',
        'url': 'http://www.lgbtlaw.tau.ac.il/%D7%91%D7%92%D7%A5-786998-%D7%A7%D7%9C%D7%A3-%E2%80%93-%D7%A7%D7%94%D7%99%D7%9C%D7%94-%D7%9C%D7%A1%D7%91%D7%99%D7%AA-%D7%A4%D7%9E%D7%99%D7%A0%D7%99%D7%A1%D7%98%D7%99%D7%AA-%D7%A0-%D7%A9%D7%A8-%D7%94%D7%97%D7%99%D7%A0%D7%95%D7%9A-%D7%95%D7%94%D7%AA%D7%A8%D7%91%D7%95%D7%AA-%D7%95%D7%94%D7%A1%D7%A4%D7%95%D7%A8%D7%98'
      },
      {
        'title': 'ספרן, חנה, הרטל, רחלי וששון-לוי, אורנה (2016). הי[א]סטוריה לסבית מקומית: פעילות, מאבקים והישגים. בתוך: הראל, אלון, לושינסקי, יניב ומורגנשטרן, עינב (עורכים), <b>זכויות הקהילה הגאה בישראל: משפט, נטייה מינית וזהות מגדרית</b> (עמ\' 45–80). האוניברסיטה העברית, המכון למחקרי חקיקה ולמשפט השוואתי. צפרירים: נבו.'
      },
      {
        'title': 'קל״ף- קהילה לסבית פמיניסטית (2018, 14 אוקטובר). הפרטים אומתו בתכתובת דוא״ל עם אחת ממייסדות העמותה.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '14/10/2018'
    },
    'year_closed': 2005,
    'year_closed_text': '2005',
    'year_founded': 1987,
    'year_registered': 1996
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית',
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '13/11/2018'
    },
    'description': '״קמה- קידום מעמד האשה בירושלים״ (ע.ר. 580093078) היא מועצת נשים עירונית שהוקמה ב-1986 לפני חוק היועצות, ביוזמת חברות מועצה. מטרות העמותה היו: ״להביא לשיתוף פעולה בין ארגוני נשים, ארגוני מתנדבים, קבוצות נשים ונשים פעילות באזורי מגוריהן לשם קידום מטרות הקשורות לנשים״. העמותה תוקצבה על ידי עיריית ירושלים ותקציב זה היה מקור ההכנסות הבלעדי שלה. יושבת ראש העמותה היתה מינוי של ראש העיר וחברות המועצה היו חברות העמותה. העמותה נסגרה ב-2011.',
    'description_ar': null,
    'display_organization_kind': 'מוניציפלי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'פורומים ומועצות נשים'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ]
    ],
    'id': 'YH148',
    'is_active': false,
    'keywords': [
      'רשות מקומית',
      'קידום נשים'
    ],
    'name': 'קמה - קידום מעמד האישה בירושלים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'מוניציפלי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מוניציפלי',
    'primary_sub_field_of_activity': 'פורומים ומועצות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים, רשם העמותות (2018, 11 יולי). <b>דו״ח עמותות חודשי</b>.'
      },
      {
        'title': 'עיריית ירושלים, המנהל העירוני (2007). <b>תפקיד היועצת למעמד האישה והמועצה לקידום מעמד האישה</b>. נדלה מתוך',
        'url': 'https://www.jerusalem.muni.il/media/7624/20065.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '21/09/2019'
    },
    'year_closed': 2011,
    'year_closed_text': '2011',
    'year_founded': 1986,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחקר ותיעוד',
      'פילנתרופיה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '13/06/2018'
    },
    'description': 'קרן בריאה בע״מ (חל״צ 515353340) הוקמה על ידי שרה טנקמן ונרשמה כחברה לתועלת הציבור בשנת 2016. מטרות החברה הן ״לשפר את בריאותן ואיכות חייהן של נשים בישראל לקדם שיח המתמקד בבריאות, בעושר, ביופי והחכמה של הגוף הנשי, לסייע ולתמוך בגופים אחרים, ללא כוונת רווח בעלי מטרות דומות למטרת החברה״. קרן בריאה הוקמה כדי ״לקדם תנועת בריאות פמיניסטית ולהשפיע על מערכת הבריאות בכדי שזו תותאם לצרכים של נשים מרקעים שונים״. בהתאם לכך, פעילות הקרן מתמקדת בהרחבת אפשרויות הבחירה של נשים במצבים בריאותיים ובכלל זה, הרחבת אמצעים לתכנון משפחה ובחירת מקום לידה; שיפור היחס של מערכת הבריאות לנשים וגופן; השפעה על מדיניות הבריאות בישראל כדי להתאימה לנשים מרקעים שונים. הקרן עורכת סקרים צרכים הכוללים את ה״סקר הגיניקולוגי״ ואת ״סקר הלידה״ ומפעילה בין היתר את תכנית \'\'בוראות\'\' ע״ש דפנה מאיר ז״ל שמטרתה לתת מענקי הזנקה חד פעמיים לפרויקטים בנושאי נשים ובריאות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות האישה'
      ]
    ],
    'id': 'SA23',
    'is_active': true,
    'keywords': [
      'גיניקולוגיה',
      'תכנון משפחה',
      'לידה',
      'נתונים',
      'אקטיביזם רשת',
      'חל״צ',
      ''
    ],
    'name': 'קרן בריאה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות האישה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-13'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.briah.org/about'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>קרן בריאה בע״מ (חל״צ): חל״צ</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/515353340'
      },
      {
        'title': 'קרן בריאה, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/kerenbriah/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '13/06/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2014,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'פילנתרופיה',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '08/09/2018'
    },
    'description': '״קרן דפנה – נשים משתפות פעולה לשינוי״, נוסדה בשנת 2003 על ידי פרופ\' דפנה יזרעאלי ז״ל, חוקרת ופעילה פמיניסטית, במטרה לקדם מנהיגות נשים וסדר יום פמיניסטי בישראל. הקרן שפעלה עד 2018 היתה הקרן הפילנתרופית הפמיניסטית היחידה בישראל והתבססה על גישה מכלילה הנותנת ביטוי לכלל חלקי החברה הישראלית. משאבי הקרן הוקדשו לתמיכה בתוכניות הפועלות לקידום מנהיגות וייצוג של נשים ולהטמעת חשיבה מגדרית בארבע זירות מרכזיות: הזירה הפוליטית והציבורית; האקדמיה; עסקים, כלכלה ותעסוקה; ופילנתרופיה. בשנות פעילותה העבירה קרן דפנה מענקים בסך של למעלה מ-1.5 מליון דולרים ליותר מ-30 מיזמים ברחבי הארץ, תוך מתן מענה לקהילות מגוונות של נשים המייצגות מגוון רחב ועשיר של קולות ותפישות פמיניסטיות. כספי הקרן נוהלו על ידי עמותת ״חותמים מחדש״ המנהלת קרנות פינלתרופיה משפחתיות בישראל למען ״יצירת שינוי חינוכי וערכי במדינת ישראל״.',
    'description_ar': null,
    'display_organization_kind': 'בינלאומי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ]
    ],
    'id': 'SA46',
    'is_active': false,
    'keywords': [
      'חברה אזרחית',
      'כלכלה',
      'מגוון',
      'מחקר',
      'מנהיגות',
      'נשות עסקים',
      'פמיניזם',
      'רישות',
      'שוויון מגדרי',
      'תעסוקה'
    ],
    'name': 'קרן דפנה',
    'name_ar': 'صندوق دفنا',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'בינלאומי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'פילנתרופיה',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'בינלאומי',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'קרן דפנה - נשים משתפות פעולה לשינוי, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/DafnaFund'
      },
      {
        'title': 'חותמים מחדש -ע״ר (ללא תאריך). <b>קרן דפנה</b>. נדלה מתוך',
        'url': 'https://signinganew.wordpress.com/%D7%A0%D7%99%D7%94%D7%95%D7%9C-%D7%A7%D7%A8%D7%A0%D7%95%D7%AA-%D7%9E%D7%A9%D7%A4%D7%97%D7%AA%D7%99%D7%95%D7%AA/%D7%A7%D7%A8%D7%9F-%D7%93%D7%A4%D7%A0%D7%94/'
      },
      {
        'title': 'Strichman, Nancy (2018). Past achievements and future directions of women’s and feminist organizations in Israel. Report, co-sponsored by the Dafna Fund and the National Council of Jewish Women (NCJW). Retrieved from',
        'url': 'https://www.ncjw.org/wp-content/uploads/2018/03/Full-Report-of-Research.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '13/08/2019'
    },
    'year_closed': 2018,
    'year_closed_text': '2018',
    'year_founded': 2003,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '02/08/2018'
    },
    'description': 'העמותה נרשמה ב-1983 בשם: ״בית אריאל - עמותה לטיפול בנוער במצוקה״. קודם לכן היתה אגודה עות\'מנית בשם: אגודה לטיפול בנערות בירושלים. ב-2003 שונה השם ל״קשת - קידום שירותי תקון״. המטרה העיקרית של העמותה: ״ליזום ולהפעיל תכניות לקידום, מניעה וטיפול של אוכלוסיות בסכנה, במצבי התדרדרות, שוליות חברתית, עבריינות ואלימות״. העמותה מפעילה שירותים עבור משרד הרווחה בירושלים, פ״ת, רעננה והרצליה. היא מפעילה מקלטים לקרבנות סחר (מקלט ״מעגן״ לנשים ו״אטלס״ לגברים״), הוסטל לגברים אלימים (״בית נועם״) וחלופת אשפוז לבנות 18 ומעלה, נפגעות טראומה תקיפה מינית (״בית אלה״). מנכ״לית העמותה - תמר אלון (2019) מכהנת גם כמנכ״לית עמותת אותות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ],
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ]
    ],
    'id': 'YH67',
    'is_active': true,
    'keywords': [
      'דיור',
      'תמיכה נפשית',
      'שיקום',
      'נערות בסיכון',
      'הוסטל',
      'מקלט',
      'סחר בנשים'
    ],
    'name': 'קשת - קדום שרותי תקון',
    'name_ar': null,
    'name_change_year': 2003,
    'name_common': null,
    'name_past': 'בית אריאל - עמותה לטיפול בנוער במצוקה',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'נערות וצעירות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-04-07'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.keshet.co/%D7%A6%D7%95%D7%95%D7%AA/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>״קשת״ – קדום שרותי תקון (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580038867'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '07/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1983,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '30/12/2018'
    },
    'description': '״קש״ת - קשב ותמיכה״ (ע״ר 580518785) הייתה עמותה שפעלה מ - 2009. מטרות העמותה היו ״פיתוח ומתן שירותי קשב ותמיכה לצרכי קהילת הלהט״ב בסוגיות הנוגעות לקשיים על רקע נטייה מינית, זהות מגדרית ונושאים קשורים אחרים. מניעת אלימות או הסתה לאלימות נגד הקהילה או בקרב הקהילה. ריכוז מידע לרווחת חברי הקהילה. ניתוח מגמות וביצוע מחקרים בנושאי הקהילה הגאה״. העמותה סיפקה שירותי תמיכה נפשית אינטרנטית לקהילה הלהט״בית. מאחר ואין דו״חות שנתיים של העמותה ברשם העמותות, קשה לדעת מתי בדיוק היא הפסיקה את פעילותה, אין כל עדות לפעילות מאז 2012. העמותה נמצאת היום בתהליכי פירוק מרצון.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'רווחה ובריאות'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'LR32',
    'is_active': false,
    'keywords': [
      'תמיכה נפשית',
      'קו סיוע',
      'אינטרנט',
      'להט״בופוביה'
    ],
    'name': 'קש״ת - קשב ותמיכה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רמת גן',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'רווחה ובריאות',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>קש״ת – קשב ותמיכה לקהילה הגאה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580518785'
      },
      {
        'title': 'מורנו, עדי (2011). <b>גאים במרכז: משילות ניאו-ליברלית ותהליכי אינדיבידואליזציה בראי קהילת הלהט״ב בישראל</b>. (עבודת גמר לקבלת תואר ״מוסמך למדעי החברה״). אוניברסיטת תל אביב.'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '31/12/2018'
    },
    'year_closed': 2012,
    'year_closed_text': '2012',
    'year_founded': 2009,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '01/01/2019'
    },
    'description': 'ראדוגה הוא ארגון של הקהילה הלהט״בית דוברת הרוסית שנוסד בשם דבאצ׳טה (״הבנות״ ברוסית) ב - 2006. דבאצ׳טה הוקמה כדי לספק מענה קהילתי וחברתי לנשים להט״ביות דוברות רוסית. ב - 2013, בעקבות פניות של גברים להט״בים דוברי רוסית, הארגון התרחב ושינה את שמו ל״ראדוגה״ (״קשת״ ברוסית) והחל לארגן מפגשים הפונים גם לגברים. עם זאת, הגרעין הפעיל והמוביל של הארגון נשאר נשי, ומפגשים נפרדים לנשות דבאצ׳טה ממשיכים להתקיים במקביל למפגשים המעורבים, במרכז הגאה בתל אביב. הארגון מפעיל קבוצות דיון ומועדון קולנוע, עושה עבודה תקשורתית ומחאתית ופועל לקידום הקהילה הגאה הרוסית בישראל. ב - 2016 קיים הארגון כנס לציון עשור להיווסדו.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'LR42',
    'is_active': true,
    'keywords': [
      'לסביות',
      'קהילה',
      'קבוצות תמיכה',
      'אינטרנט'
    ],
    'name': 'ראדוגה',
    'name_ar': null,
    'name_change_year': 2013,
    'name_common': null,
    'name_past': 'דבצ\'אטה',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'נשים עולות מחבר העמים',
    'retrieved': null,
    'sources': [
      {
        'title': '(2016, 12 ינואר). מרוסיה בגאווה: קבוצת הלהט״בים דוברי הרוסית חוגגת עשור. <b>Mako גאווה</b>. נדלה מתוך',
        'url': 'https://www.mako.co.il/pride-news/local/Article-3061471c8863251006.htm'
      },
      {
        'title': 'ראדוגה (2019, 1 ינואר). הפרטים אומתו בשיחת צ׳ט עם אחת ממייסדות הארגון.'
      }
    ],
    'target_audiences': [
      'נשים עולות מחבר העמים',
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '01/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2006,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '20/05/2018'
    },
    'description': '״רוח נשית״ (ע״ר 580474658) היא עמותה שהוקמה בשנת 2007 על ידי מכי נאמן ודיאנה רוזנר המסייעת לנשים נפגעות אלימות למצוא תעסוקה ולבסס עצמאות כלכלית כדי שיוכלו להיחלץ ממצבי עוני וסיכון. פעילויותיה העיקריות של העמותה כוללות ארבעה מרכיבים עיקריים: הראשון הוא תוכנית מנטורינג שכוללת ליווי אישי צמוד על ידי מתנדבת על בסיס של פגישה שבועית למשך שנה במטרה לסייע ברכישת מקצוע, ניהול תקציב ועוד. השני הוא תכנית אימון אישי שמכוונת לשלב את הנשים הפונות בשוק העבודה ובניית חוסן אישי ותעסוקתי לטווח קצר וטווח ארוך. השלישי הוא סדנאות תעסוקה וכישורים מקצועיים הכוללות פיתוח מיומנויות למציאת עבודה. הרביעי הוא העצמה כלכלית ותכנית לבניית עסקים זעירים לנשים. בנוסף, העמותה פעילה גם במישור הציבורי להעלאת מודעות, לחקיקה וליישום פתרונות מערכתיים לשיפור מצבן הכלכלי והתעסוקתי של נפגעות אלימות בישראל. משרדי העמותה נמצאים בתל אביב, אך פעילותה היא ארצית. בשנת 2018 מנהלת העמותה היא תמר שוורץ.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות במשפחה'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'רווחה וקהילה',
        'אלימות במשפחה'
      ]
    ],
    'id': 'YB61',
    'is_active': true,
    'keywords': [
      'אימון אישי',
      'אלימות',
      'חקיקה',
      'הכשרה מקצועית',
      'מלגות',
      'מנטורינג'
    ],
    'name': 'רוח נשית - עצמאות כלכלית לנשים נפגעות אלימות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות במשפחה',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.ruach-nashit.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>רוח נשית – עצמאות כלכלית לנשים נפגעות אלימות (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580474658'
      },
      {
        'title': 'רוח נשית, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/ruach.nashit/'
      },
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל. עמ\' 43–44.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות',
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '07/01/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2007,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יסמין אבו סאלח',
      'on': '10/04/2019'
    },
    'description': '״רוקמות התחרה חורפיש״ היא עמותה (ע״ר 580552487) אשר רשומה במעלות-תרשיחא אך עיקר פעילותה בכפר חורפיש. מטרות העמותה הן: ״קידום מעמד האשה בכפר חורפיש בכל הגילאים ע״י הכשרות מקצועיות בתחום העצמה, טיפוח אישי, העלאת הערכה עצמית ודימוי אישי. הגברת מודעות בקרב נשים בנושא תעסוקה, מלאכות מסורתיות ויזמות תיירותית. יצירת דיאלוג בין אוכלוסיית נשות חורפיש לאזור ולארץ. הקניית מיומנויות בתחומי מלאכות היד.״ עיקר פעילות העמותה היא הפעלת מיזם תיירותי, תעסוקתי וחברתי המתמקד במלאכות יד מסורתיות במרכז הנקרא ״בית ג\'זל סתי״ ובו מתקיימים קורסים, ביקורים ומכירת מוצרים מקומיים.',
    'description_ar': '״بيت غزل ستي״ (ج. م 580552487) والتي سجلت في معالوت- ترشيحا، الا ان نشاطها في قرية حورفيش. اهداف الجمعية هي: تعزيز مكانة المرأة في قرية حورفيش من جميع الاعمال من خلال تدريبات مهنية في مجال التمكين العناية الشخصية واحترام الذات والصورة الشخصية. زيادة الوعي بين النساء حول العمل والحرف التقليدية والمبادرات السياحية. خلق حوار بين السكان من النساء قرية حورفيش وباقي البلدات واكتساب المهارات في مجال الفنون. ״يتمثل النشاط الرئيسي للجمعية مبادرات سياحية، توظيفية واجتماعية تركز على الحرف التقليدية في مركز يسمى״ بيت غزل ستي ״، حيث تقام دورات وزيارات وبيع المنتجات المحلية.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ]
    ],
    'id': 'YA20',
    'is_active': true,
    'keywords': [
      'סחר הוגן',
      'העצמה כלכלית',
      'הכשרה מקצועית'
    ],
    'name': 'רוקמות התחרה חורפיש',
    'name_ar': 'بيت غزل ستي',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'מעלות-תרשיחא',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2019-04-10'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.facebook.com/%D7%A8%D7%95%D7%A7%D7%9E%D7%95%D7%AA-%D7%94%D7%AA%D7%97%D7%A8%D7%94-131430846920004/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>רוקמות התחרה חורפיש (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580552487'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '30/04/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2009,
    'year_registered': 2012
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '07/10/2018'
    },
    'description': 'בשנות השמונים התאספו קבוצה של נשים בדואיות כדי לשפר את החיים בכפר לקייה. בשנת 1996 הפכה ההתארגנות לעמותה ונהייתה לעמותה הראשונה של נשים בדואיות בדרום הארץ. מטרות ה״עמותה לשיפור מעמד האשה בלקייה״ (ע.ר. 580265536) הן: ״לסייע לאשה הבדואית בדרום לפתח מודעות למעמדה בתנאי החיים המשתנים. לקדם את הישגיהן של נשות לקייה. לבנות קשרים חברתיים ותרבותיים בין נשות לקייה לבין נשים ביישובים אחרים״. העמותה מפעילה תוכנית רקמה לנשים במטרה לייצר הכנסה לנשים בדואיות ולשמור על עבודות יד מסורתיות. בנוסף, היא מפעילה ספרייה ניידת המשרתת למעלה מ -1,500 ילדים, וכן תוכניות חינוכיות לנשים ונוער. העמותה פועלת בלקיה אך רשומה בכתובת בבאר שבע.',
    'description_ar': 'في سنوات الثمانينيات، اجتمعت مجموعة من النساء البدويات لتحسين جودة الحياة في قرية اللقية- النقب.  وفي عام 1996، تحولت الاجتماعات لجمعية نسائية والتي كانت أول جمعية نسائية بدوية في جنوب البلاد. تتمثل أهداف جمعية بتحسين وضع المرأة في قرية اللقية (ج.م 580265536)\n من خلال مساعدة المرأة البدوية في الجنوب على تنمية الوعي حول ظروف المعيشية المتغيرة. تعزيز إنجازات نساء اللقية وبناء الروابط الاجتماعية والثقافية بين نساء اللقية والنساء من بلدات أخرى.\nتدير الجمعية برنامج تطريز نسائي لإنتاج دخل للنساء البدويات والحفاظ على الحرف اليدوية التقليدية. بالإضافة إلى ذلك، تدير مكتبة متنقلة تخدم أكثر من 1500 طفل، بالإضافة إلى برامج تعليمية للنساء والشباب. تعمل الجمعية في اللقية ولكنها مسجلة على عنوان في بئر السبع.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'תרבות וספורט',
        'מלאכות מסורתיות'
      ]
    ],
    'id': 'YH54',
    'is_active': true,
    'keywords': [
      'בדואיות',
      'סחר הוגן',
      'השכלה',
      'ילדות/ים',
      'קידום נשים',
      'מנהיגות'
    ],
    'name': 'עמותה לשיפור מעמד האישה בלקיה',
    'name_ar': 'جمعية تطريز الصحراء لتمكين المرأة في اللقية',
    'name_change_year': null,
    'name_common': 'רקמת המדבר',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'לקיה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'דרום',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': {
      'type{date}': '2018-10-07'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.desert-embroidery.org/index.php'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותה לשיפור מעמד האשה בלקייה: עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580265536'
      },
      {
        'title': 'אוסצקי-לזר, שרה (2009). <b>״לא כמו אמי״: נשים מעצימות את עצמן – המקרה של כפר קרע</b>. ירושלים: בית הספר ע״ש פדרמן למדיניות ציבורית וממשל - האוניברסיטה העברית בירושלים. נדלה מתוך',
        'url': 'https://www.sarahozacky.com/862/%D7%9C%D7%90-%D7%9B%D7%9E%D7%95-%D7%90%D7%9E%D7%99-%D7%A0%D7%A9%D7%99%D7%9D-%D7%9E%D7%A2%D7%A6%D7%99%D7%9E%D7%95%D7%AA-%D7%90%D7%AA-%D7%A2%D7%A6%D7%9E%D7%9F-%E2%80%93-%D7%94%D7%9E%D7%A7%D7%A8/'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '11/05/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1996,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'פילנתרופיה'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '21/08/2019'
    },
    'description': 'רשת החינוך אמי״ת מקורה בהסתדרות נשי מזרחי באמריקה, Mizrachi Women of America, שקמה בשנת 1925 כהתארגנות נשית אוטונומית בתוך תנועת המזרחי בארה״ב כתחליף להתארגנות הנשית ״האחיות מזרחי״ שלא פעלה בעצמאות. בשנת 1934 הכריזה הסתדרות נשי מזרחי באמריקה על עצמאותה מתנועת המזרחי אך שמרה את השם ואת ערכי התנועה. מראשיתה, ההסתדרות שמה לעצמה למטרה לקדם את חינוך הנערות הדתיות בישראל - בהשכלה כללית, דתית ומקצועית. בסוף שנות ה-20 ותחילת ה-30, הקימה הסתדרות נשי מזרחי באמריקה את מוסד החינוך המקצועי הראשון לנערות צעירות בישראל ששכן בירושלים, ולאחר מכן הקימו מוסדות בתל אביב ובבאר שבע. עם השנים ההסתדרות הרחיבה את פעילותה לקליטת עליה והקמת מוסדות חינוך וכפרי נוער לבנות ולבנים ברחבי המדינה. בשנת 1977 התמנה ד״ר עמי זאבי למנכ״ל הארגון בישראל, וזו הייתה תחילת הפיכת מוסדות החינוך של הסתדרות נשי מזרחי באמריקה לרשת חינוכית מתרחבת. בשנת 1981 המדינה הכירה במוסדות החינוך הללו כחלק ממערכת החינוך הממלכתית-דתית ובשנת 1983 החליפה ההסתדרות את שמה ל-״נשי אמי״ת״ שמשמעותה ״ארגון מתנדבות ישראל תורה״ ובאנגלית ״Americans for Israel and Torah״. רשת החינוך נהייתה מוכרת כ-״אמי״ת״, ללא אזכור לנשים המייסדות והמעורבות, ונוהלה על ידי גברים תוך מעורבות גדולה של ״נשי אמי״ת״. כיום מונה הרשת יותר מ-100 מוסדות חינוכיים ממלכתיים-דתיים, ממלכתיים, וחרדיים, בפריפריה ובערים מרכזיות בישראל הכוללים בתי ספר יסודיים, תיכוניים, מרכזים טכנולוגיים, ועל-תיכוניים. בין התוכניות היעודיות של אמי״ת לצעירות כיום נכללות המדרשות הקדם צבאיות ״באר״ בירוחם ובאשדוד.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'חינוך',
        'כללי'
      ],
      [
        'דת ומעמד אישי',
        'נערות וצעירות'
      ],
      [
        'הגירה',
        'קליטת עלייה'
      ]
    ],
    'id': 'SW56',
    'is_active': true,
    'keywords': [
      'מדרשה',
      'פילנתרופיה',
      'קליטת עלייה',
      'הכשרה מקצועית',
      'פריפריה',
      'חינוך'
    ],
    'name': 'נשי אמי״ת',
    'name_ar': null,
    'name_change_year': 1983,
    'name_common': 'רשת חינוך אמי״ת',
    'name_past': 'הסתדרות נשי מזרחי באמריקה',
    'name_replaced_by': null,
    'official_address': 'פתח תקווה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'חינוך',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'כללי',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2019-08-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.amit.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>נשי אמי״ת (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580024800'
      },
      {
        'title': 'אמי״ת (ללא תאריך). <b>ספר אמית, שער ראשון: נשים חולמות ומגשימות ציונות. פרק ב: נשי מזרחי באמריקה</b>. נדלה מתוך',
        'url': 'http://reshetamit.org.il/90anniversary/amit_book/part1/Pages/chapter2.aspx'
      },
      {
        'title': 'אמי״ת (ללא תאריך). <b>ספר אמית, שער רביעי: הקמת כפרי הנוער. פרק ג: קליטת העליות השונות לאחר הקמת המדינה</b>. נדלה מתוך',
        'url': 'http://reshetamit.org.il/90anniversary/amit_book/part4/Pages/P4chapter3.aspx'
      },
      {
        'title': 'אמי״ת (ללא תאריך). <b>ספר אמית, שער חמישי: מארגון קטן לרשת גדולה. פרק א: המעבר למבנה רשת בתקופת כהונתו של דר עמי זאבי</b>. נדלה מתוך',
        'url': 'http://reshetamit.org.il/90anniversary/amit_book/part5/Pages/P5chapter1.aspx'
      }
    ],
    'target_audiences': [
      'נשים דתיות',
      'נשים יוצאות אתיופיה',
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '22/08/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': 1983
  },
  {
    'activity_kinds': [
      'מחאה',
      'סנגור, מעקב ושינוי מדיניות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '24/10/2018'
    },
    'description': '״רשת נשים לשלום״ (Women\'s Peace Network) הוקמה בעקבות האינתיפאדה הראשונה, ביוני 1988 ונרשמה כעמותה (580176022) בשנת 1990 בתל אביב. מטרות העמותה היו ״לחתור ולפעול למען קידום השלום בקרב נשים ישראליות. לחזק את ציבור הנשים בישראל באשר לצורך בהשגת שלום״. הרשת פעלה כקואליציה רופפת של נשים וארגונים של נשים ישראליות ופלסטיניות שנפגשו בבריסל בשנת 1989 ביוזמת סימון סוסקינד, ממנהיגות הקהילה היהודית בבלגיה. היה זה כנס הנשים הפלסטיני-ישראלי הבינלאומי הראשון תחת הכותרת ״תנו סיכוי לשלום: נשים משמיעות את קולן״ (“Give Peace a Chance: Women Speak Out”). בין הנשים הישראליות שהשתתפו במפגש בבריסל ובפעילות הרשת היו חברות הכנסת דאז שולמית אלוני ונאוה ארד, חברות הכנסת לעתיד תמר גוז\'נסקי, יעל דיין, נעמי חזן וענת מאור, השחקניות חנה מרון וסלוואה נקארה חדד ופעילות שלום כגליה גולן, ג\'ודי בלנק, מרים מרעי רוחמה מרטון ואליס שלוי. פעילויותיה העיקריות של הקבוצה היו ארגון מפגשים בערים שונות בישראל ובשטחים בהשתתפות נשים ישראליות ופלסטיניות. ״רשת״ החלה בתהליכי פירוק בשנת 1995 לאחר הקמת ״בת-שלום״ בירושלים ונמחקה סופית מפנקס העמותות בשנת 2003.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ]
    ],
    'id': 'SA69',
    'is_active': false,
    'keywords': [
      'אינתיפאדה',
      'מנהיגות',
      'קואליצייה',
      'שיתוף פעולה בינלאומי',
      'פלסטיניות'
    ],
    'name': 'רשת נשים לשלום',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': '(1996, 19 מרץ). <b>מכתב מאת עו״ד גלעד שר (משרד עורכי הדין קלימיסט את שר עורכי דין) לבין דפנה גולן בנושא ״פירוק רשת״</b>. אוסף ״בת-שלום״, אותר בארכיון הפמיניסטי ב״אשה לאשה – מרכז פמיניסטי חיפה״.'
      },
      {
        'title': 'Deutsch, Yvonne (1994). Israeli women against the occupation. In Mayer, Tamar (Ed.), <b>Women and the Israeli occupation: The politics of change</b> (p.88). London, UK: Routledge.'
      },
      {
        'title': 'Sharoni, Simona (1995). <b>Gender and the Israeli-Palestinian conflict: The politics of women\'s resistance</b>. New York, NY: Syracuse University Press. Retrieved from',
        'url': 'https://books.google.co.il/books?hl=sv&lr=&id=q7bj8OGIcwoC&oi=fnd&pg=PR7&dq=Gender+and+the+Israeli-Palestinian+Conflict&ots=dwjC4wFcCV&sig=EDBpePGwnEi50gHT85UIXxvgPtw&redir_esc=y#v=onepage&q&f=false'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '24/10/2018'
    },
    'year_closed': 1995,
    'year_closed_text': '1995',
    'year_founded': 1988,
    'year_registered': 1990
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '07/03/2018'
    },
    'description': 'ש.י.ן נוסדה ב-1989 על רקע מחאה כנגד היעדר נשים מעמדות מנהיגות ציבוריות ופוליטיות בישראל ונרשמה כעמותה (ע״ר 580163632) ב-1990. מטרות העמותה הן: ״להגביר את מודעות הציבור הרחב, של נשים וגברים כאחד, לזכותן של נשים להיבחר לתפקידים במוקדי הכרעה פוליטיים. להוות גוף התומך ומעודד נשים, בעלות כישורים ושאיפות, בשלבי התמודדותן להשגת עמדות פוליטיות״. הכתובת הרשמית וארכיון התנועה נמצאים בבית המייסדת, פרופ\' אסתר הרצוג, במכמורת. בין פעילויותיה ניתן למנות יוזמות שונות ומגוונות לקידום מנהיגות של נשים בפוליטיקה מקומית וארצית ושיתופי פעולה עם ארגוני נשים מקומיים כמו ל.א. לאלימות, הן- הרצליה נשים, התנועה לגבריות חדשה ועוד. תנועת ש.י.ן פרסמה בטאון (״שעת השין״) והיתה ארגון גג ליוזמות שונות הכוללות בין היתר את הקמת מפלגת הנשים (1992), ״פרלמנט נשים״, אנואר, מנהיגות נשים יהודיות וערביות (2012-2016), פרויקט ״להיוולד מחדש״ (2008-2014), עמותת ע.ל.י.ה לזכויות ילדים והורים ופרלמנט נערות – החל משנת 2010.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'קידום מנהיגות נשים'
      ],
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ],
      [
        'תעשיית המין',
        'פורנוגרפיה'
      ]
    ],
    'id': 'YH42',
    'is_active': true,
    'keywords': [
      'פוליטיקה',
      'ייצוג הולם',
      'מנהיגות',
      'שוויון מגדרי',
      'פמיניזם',
      'פורנוגרפיה'
    ],
    'name': 'ש.י.ן. שויון בייצוג נשים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'ש.י.ן לשוויון ייצוג נשים',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'מכמורת',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום מנהיגות נשים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-03-07'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.shin-women-equality.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>ש.י.ן. שויון בייצוג נשים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580163632'
      },
      {
        'title': 'תנועת ש.י.ן - לשיוויון ייצוג נשים (בלוג). באתר Saloona. נדלה מתוך',
        'url': 'http://saloona.co.il/shin_movement/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1989,
    'year_registered': 1990
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '08/11/2018'
    },
    'description': 'שבל הוא ארגון הדברות והסברה הפועל לקבלתם של להט״בים בחברה הדתית, אשר הוקם בשנת 2008. מתנדבי ומתנדבות הארגון, דתיים ודתיים לשעבר, מקיימים מפגשים עם צוותים חינוכיים בבתי ספר דתיים, מדרשות, אולפנות וישיבות, עם אנשי טיפול ועם קהילות דתיות ברחבי הארץ, ומעבירים להם פעילויות הסברה. פעילויות ההסברה, בהשראת מערכי הפעילות של חוש״ן, מבוססות על סיפור אישי של גבר ואישה, חברי הקהילה. הארגון כולל כ - 30 מתנדבים, ומסתייע לצורך גיוס תרומות ב״בת קול״ וב״חברותא״ (הומואים דתיים).',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'להט״ב',
        'דת'
      ],
      [
        'דת ומעמד אישי',
        'להט״ב'
      ],
      [
        'חינוך',
        'להט״ב'
      ]
    ],
    'id': 'LR18',
    'is_active': true,
    'keywords': [
      'חינוך',
      'הומואים',
      'לסביות',
      'להט״בופוביה',
      'קהילה'
    ],
    'name': 'שבל- שהכל ברא לכבודו',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': 'דת',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-11-08'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.shovalgroup.org/'
      },
      {
        'title': 'שבל - חינוך לסובלנות בציבור הדתי, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/shovalsovlanut/?ref=page_internal'
      },
      {
        'title': 'שביידל, זאב (2011). מתלבטים עם בחירה: דילמות ודרכי התמודדות של בני נוער הומוסקסואלים בציבור הציוני-דתי בישראל. <b>מפגש לעבודה חינוכית-סוציאלית 33</b>, 123–136.'
      }
    ],
    'target_audiences': [
      'להט״ב',
      'נשים דתיות',
      'גברים דתיים'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '15/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2008,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'שירותים משפטיים',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '20/06/2018'
    },
    'description': '״שדולת הנשים בישראל״ (ע״ר 580085686) הוקמה בשנת 1984 ונרשמה כעמותה בשנת 1985 בירושלים בכתובתה הפרטית של אליס שלוי שהיתה מייסדת ויו״ר הארגון בשנותיו הראשונות. מטרות העמותה הן: ״לפעול להעמקת מודעות הציבור בישראל בדבר הצורך להגיע לשוויון בין המינים. לפעול נגד תופעות של אפליה על בסיס של מין״. מאז הקמתה השדולה פועלת בתחומים רבים הנוגעים לקידום זכויות נשים בישראל, דיני משפחה ומעמד אישי, ייצוג הולם, חינוך לשוויון בין המינים במערכות הפורמליות והבלתי פורמליות, העצמת נשים בחיים הפוליטיים והציבוריים, התדיינות בבתי משפט בעיקר במקרים תקדימיים, הפקת קמפיינים תקשורתיים ועוד. דרכי הפעולה של שדולת הנשים הן מגוונות וכוללות: חקיקה ועתירות לבית המשפט, חינוך במובן הרחב ביותר, התדיינות, איסוף נתונים והכנת מחקרים וניירות עמדה. בנוסף, מאז שנת 1987 מפעילה ״שדולת הנשים״ קו פתוח לפניות בנושא אפליה בעבודה, כולל ייעוץ בדיני עבודה במהלך היריון, חופשת לידה, טיפולי פוריות, שכר שווה והטרדות מיניות במקום העבודה בעברית וערבית. במהלך שנות ה-90 עברו משרדי שדולת הנשים לאזור המרכז ועיקר פעילותה מתמקדת באזור המרכז. שבין ההשגים העיקריים של השדולה ניתן למנות את הדרישה לקבל נשים למיונים לקורס טיס (בג”ץ אליס מילר); אכיפת ייצוג נשים בדירקטוריונים של חברות ציבוריות; עדכון חוקי הטרדה מינית במקום העבודה; קידום שכר שווה במשק ואכיפה יעילה בנושא.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ייצוג הולם'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'SA28',
    'is_active': true,
    'keywords': [
      'ייצוג הולם',
      'אפלייה בתעסוקה',
      'דיני משפחה',
      'הטרדה מינית',
      'העצמה',
      'זכויות בעבודה',
      'חינוך מגדרי',
      'מנהיגות',
      'משפט',
      'פמיניזם משפטי',
      'צבא',
      'קו סיוע',
      'שוויון'
    ],
    'name': 'שדולת הנשים בישראל',
    'name_ar': 'لوبي النساء في إسرائيل',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-06-20'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.iwn.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>שדולת הנשים בישראל - ISRAEL WOMEN\'S NETWORK לובי אלנישא פי אישראיל</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580085686'
      },
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל.'
      },
      {
        'title': 'יזרעאלי, דפנה (2006). פוליטיקה מגדרית: המקרה של העדפה מתקנת במינוי נשים לדירקטורים. <b>תרבות דמוקרטית, 10</b>. עמ\' 215–250. רמת גן: אוניברסיטת בר-אילן.'
      },
      {
        'title': 'רן בן-חי, מוריה ‬(2017). <b>האישי, הנשי והציבורי: דיוקנה של פרופ’ אליס שלוי ומפעליה כבבואה לתמורות במעמד האשה בחברה הישראלית</b> (חיבור לשם קבלת תואר ״דוקטור ללימודי ארץ ישראל וארכיאולוגיה״). אוניברסיטת בר-אילן, רמת גן.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '20/06/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1984,
    'year_registered': 1985
  },
  {
    'activity_kinds': [
      'מחאה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '25/07/2018'
    },
    'description': 'תנועת ״שובי״ הוקמה באמצע 2004 על ידי בלהה אילון (ביבה) בישוב כרם מהר״ל. מטרת התנועה היתה להפעיל לחץ על ממשלת ישראל לקדם את תכנית ההתנתקות מרצועת עזה. התנועה פעלה כגוף התנדבותי באמצעות פקסים, מכתבים, הפכנות, עצומות, קמפיינים בעיתונות, חוגי ומפגשים (בין היתר עם תושבי גוש קטיף וצפון השומרון). בראיון עם ביבה אילון צויין: ״חשוב להדגיש כי אין מדובר פה בהצהרה פמיניסטית. הקבוצה המייסדת היא קבוצה של נשים שמדברות באותה שפה, בין נשים קל מאוד לדבר על התחושות הקשות, על החרדה. קל לנו להבין אחת את השנייה וזו הסיבה היחידה שבגללה אנחנו פועלות יחד.״ נוסח העצומה העיקרי שהפיצה התנועה היה: ״מיעוט מקרי לא יקבע את גורלה של ישראל. נשים ישראליות מתגייסות למען יציאה מיידית מעזה. הצטרפי אלינו ! היכנסי לאתר שובי ושלחי פקס או דואר אלקטרוני לראש הממשלה. אנחנו יותר מ 60000 !!! הפיצי מכתב זה לחברותייך. שובי http://www.shuvi.org״. התנועה חדלה להתקיים לאחר ההתנקות בשנת 2005. אתר התנועה אינו פעיל. לא ידוע היכן מצוי ארכיון התנועה.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'ביטחון לאומי'
      ]
    ],
    'id': 'SA37',
    'is_active': false,
    'keywords': [
      'ביטחון',
      'צבא',
      'התנתקות'
    ],
    'name': 'שובי- נשים למען יציאה מעזה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'כרם מהר״ל',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'חרותי-סובר, טלי (2017, 1 ספטמבר). אין לנו דם מיותר. <b>אימגו</b>. נדלה מתוך',
        'url': 'http://www.e-mago.co.il/node/11908'
      },
      {
        'title': 'Hermann, Tamar (2009). <b>The Israeli peace movement: a shattered dream</b>. Cambridge, UK: Cambridge University Press.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'גברים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '25/07/2018'
    },
    'year_closed': 2005,
    'year_closed_text': '2005',
    'year_founded': 2004,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '26/09/2018'
    },
    'description': '״שוות - המרכז לקידום נשים בזירה הציבורית״ הוקם במכון ון ליר בירושלים בתמיכת קרן דפנה יזרעאלי בסוף שנת 2009 מתוך מחויבות לרעיון של הטמעת חשיבה מגדרית (gender mainstreaming) כאסטרטגיה כוללת לקידום מעמדן הדמוקרטי והאזרחי של נשים מקבוצות שונות. עמדה זו מבקשת להוציא את סוגיית אי-השוויון המגדרי מן ה״גטו הנשי״, ולנסחה מחדש בתור תפיסת עולם חברתית כללית, הנוגעת לגברים ולנשים כאחד ולסדרי החברה בישראל בכלל. שוות שם לו למטרה להפוך את המושגים של שוויון מגדרי לחלק בלתי נפרד מן החשיבה והפעולה של קובעי המדיניות והמתכננים בתחומי החיים השונים. שוות עוסק במחקר, מציע חשיבה אסטרטגית ויוזם פרויקטים ותוכניות בתחומים הנוגעים להטמעה של חשיבה מגדרית ולשוויון מגדרי בישראל. מקימות המרכז, פרופ\' נעמי חזן ופרופ\' חנה הרצוג, חותרות להפכו למסגרת שמפגישה בין ארגוני שטח, חוקרות/ים, מחוקקות/ים ומקבלי/ות החלטות, מתוך תקווה שהדיאלוג והחשיבה המשותפת ישמשו מקור מידע, הנחיה וניסיון מקצועי ומחקרי לכל המעוניינים בקידום שוויון וחשיבה מגדריים בישראל.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'שוויון בין המינים/שוויון מגדרי'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ייצוג הולם'
      ],
      [
        'השכלה גבוהה ומחקר',
        'מרכזי מחקר'
      ]
    ],
    'id': '1YB17',
    'is_active': true,
    'keywords': [
      'מחקר',
      'מידע',
      'נתונים',
      'פוליטיקה',
      'הטמעת חשיבה מגדרית',
      'החלטה 1325',
      'סטטיסטיקה מגדרית'
    ],
    'name': 'שוות - המרכז לקידום נשים בזירה הציבורית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'אקדמי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'שוויון בין המינים/שוויון מגדרי',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-09-26'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.vanleer.org.il/he/content/%D7%A2%D7%9C-%D7%90%D7%95%D7%93%D7%95%D7%AA-%D7%94%D7%9E%D7%A8%D7%9B%D7%96-%D7%9C%D7%A7%D7%99%D7%93%D7%95%D7%9D-%D7%A0%D7%A9%D7%99%D7%9D-%D7%91%D7%96%D7%99%D7%A8%D7%94-%D7%94%D7%A6%D7%99%D7%91%D7%95%D7%A8%D7%99%D7%AA'
      },
      {
        'title': 'הרצוג, חנה (2015, 29 נובמבר). <b>פרקטיקות של שוויון: מהשתלבות לשינוי סדר יום חברתי</b> (סרטון). נדלה מתוך',
        'url': 'https://www.youtube.com/watch?v=nFgbA6lRZVg'
      },
      {
        'title': 'מדד המגדר – אי שוויון מגדרי בישראל (אתר). **אודות שוות*. נדלה מתוך',
        'url': 'https://genderindex.vanleer.org.il/%D7%90%D7%95%D7%93%D7%95%D7%AA-%D7%A9%D7%95%D7%95%D7%AA-2/'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '23/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2009,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '08/01/2018'
    },
    'description': '״שוות-מנהיגות נשים״ (ע״ר 580663615) היא עמותה שהוקמה על ידי סטודנטיות צעירות מירושלים (מייסדי העמותה הם רוני קורן ואלדד פוסטן), ככל הנראה בעקבות זכייה במקום הראשון בהאקתון מנהיגות נשים שהתקיים בירושלים בשנת 2018 שבו הוצג מיזם ״סדנאות שוות״. מטרות העמותה הן: ״לעזור לנערות צעירות לממש את הפוטנציאל הטמון בהן באמצעות העצמה והגשמה עצמית. לצמצם את הפער המגדרי הקיים כיום בחברה בין נשים וגברים. להעניק תמיכה ועזרה לרבות מלגות לצעירות בתחומי פעילות העמותה. לקדם מנהיגות נשית בחברה״. העמותה מפעילה תוכנית חונכות שנתית המשלבת סטודנטיות ותלמידות במסגרת תכנית פר״ח וסדנאות בשיתוף הרשות המקומית. מטרת התכנית היא לעודד מנהיגות בקרב נערות ולפתח הערכה עצמית חיובית לטווח רחוק, דרך התנסות מוקדמת בהצבת מטרות והגשמתן. בשנים 2017-2019 התקיימו פעילויות העמותה בבתי ספר בעיר ירושלים ובשנת הלימודים 2019/20 התכנית מתקיימת גם בבת ים וברחובות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'מנהיגות'
      ]
    ],
    'id': 'SA43',
    'is_active': true,
    'keywords': [
      'חינוך',
      'מלגות',
      'העצמה',
      'מנהיגות'
    ],
    'name': 'שוות-מנהיגות נשית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'מנהיגות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-12-02'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.shavot.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>שוות – מנהיגות נשית (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580663615'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '12/02/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2017,
    'year_registered': 2018
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '27/05/2018'
    },
    'description': 'קואליציית שותפוֹת הוקמה בשנת 2012, כקואליציה של ארגונים פמיניסטיים הפועלים יחד לקידום שוויון כלכלי לכלל הנשים בישראל. הקואליציה פועלת בזירה הציבורית והתקשורתית לתיקון האפליה והדרת הנשים בכלכלה ובתעסוקה ולצמצום אי־השוויון המגדרי בישראל. הארגונים החברים בקואליציה פועלים למען קבוצות שונות בחברה הישראלית, נשים יהודיות וערביות, מזרחיות ואשכנזיות, נשים יוצאות אתיופיה ודוברות רוסית, נשים נפגעות אלימות, שורדות זנות, ונשים צעירות ומבוגרות. כקואליציה, שותפוֹת פועלת לייצוג והתחשבות במגוון נקודות המבט של נשים בישראל. הקואליציה פועלת בין היתר להעלות את קצבת הזקנה, למנוע את העלאת גיל הפרישה ולקדם את מעמדן של שנים במקצועות הטיפול. אחת מפעילויות הדגל של הקואליציה היא קידום נשים בעסקים כאפיק, אלטרנטיבי לעצמאות ורווחה כלכלית לנשים. כחלק מפעילות זו, הקימה הקואליציה את אתר ״יוזמות״ – פלטפורמה אינטרנטית אשר נועדה לתמוך בנשים בעלות עסקים קטנים ובינוניים ולעודד את הציבור הרחב לרכוש את המוצרים שלהן. ארגוני הקואליציה הם: מרכז אדוה, מרכז אהטה, תנועת אחותי, איתך מעכי, ליגה, המכללה, כיאן, החצר הנשית, העמותה להעצמה כלכלית לנשים, נע״ם - נשים ערביות במרכז, נסיכת המדבר, ערוס אלבחר, קול האישה, רוח נשית ושדולת הנשים בישראל.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ]
    ],
    'id': 'YH9',
    'is_active': true,
    'keywords': [
      'קואליציה',
      'כלכלה',
      'אפלייה בתעסוקה',
      'שוק העבודה',
      'פנסיה',
      'יזמות עסקית',
      'בידול תעסוקתי',
      'פמיניזם'
    ],
    'name': 'שותפות',
    'name_ar': 'شريكات',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'זכויות ומדיניות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-27'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://shutafot.org.il/'
      },
      {
        'title': 'חרותי-סובר, טלי (2017, 8 מרץ). העסקים של העצמאיות בישראל: קטנים, ללא עובדים ובשכר מינימום. <b>TheMarker</b>. נדלה מתוך',
        'url': 'https://www.themarker.com/career/1.3915786'
      },
      {
        'title': 'יוזמות (אתר). הוקם על ידי קואליציית שותפות. תוכן האתר השתנה.'
      },
      {
        'title': 'פיסו, רונית, סטרול, מיטל וסבירסקי ברברה (2014). <b>לא על הפנסיה לבדה: בטחון סוציאלי בגיל הפרישה והעלאת קצבת הזקנה 2014</b>. נדלה מתוך',
        'url': 'http://adva.org/wp-content/uploads/2014/12/kitzvat-zikna-november-20144.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '15/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2012,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '28/11/2018'
    },
    'description': '״שחף-עמותה למיגור הפרעות אכילה בקהילה״ (ע״ר 580339737) נוסדה בתל אביב בשנת 1999 והחלה בפעילות מלאה בשנת 2001. מטרות העמותה היו: ״לפעול למען קידום בריאותם ורווחתם של החולים בהפרעות אכילה. להפעיל תוכניות מניעה במיגזרים המתאימים לצמצום השכיחות של הפרעות אכילה. לעורר את מודעות הציבור והגופים האחראים על בריאות הציבור להפרעות קשות אלו.״ הפעילות המרכזית של העמותה היתה טיפול בחולות הסובלות מהפרעות אכילה וסיוע לבני משפחותיהן. העמותה הפעילה מוסד שיקומי ללא אשפוז למתמודדות עם הפרעות אכילה, קבוצות למיגור הפרעות אכילה בקהילה וקבוצות תמיכה להורים ולמשפחות של אנשים הסובלים מהפרעות אכילה. המרכז בתל אביב הכשיר אנשי צוות שפעלו בשני מרכזים נוספים, אחד הפונה לאוכלוסיה החרדית ושני הפונה לאוכלוסיה באזור קריית שמונה דרך מרכז ״משאבים״ המציע סיוע לתושבי קו העימות, בליווי פרופ\' מוריה גולן מהחוג למדעי התזונה במכללת תל-חי. בנוסף, העמותה תמכה במחקרים אקדמיים על נשים הסובלות מהפרעות אכילה ופתחה תוכניות לשיפור דימוי הגוף ומניעת הפרעות אכילה עבור משרד החינוך. בשנת 2018, בשל גרעון כספי, החליט ועד העמותה על התחלת תהליכים של פירוק עמותה מרצון.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ],
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'נערות וצעירות',
        'בריאות'
      ]
    ],
    'id': 'LR27',
    'is_active': false,
    'keywords': [
      'הפרעות אכילה',
      'דימוי גוף',
      'תמיכה נפשית',
      'קבוצות תמיכה',
      'טראומה',
      'מחקר'
    ],
    'name': 'שחף - עמותה למיגור הפרעות אכילה בקהילה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'בריאות הנפש וטיפול',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>״שחף״ – עמותה למיגור הפרעות אכילה בקהילה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580339737'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי (2017, 31 ינואר). <b>פרוטוקול מס\' 143: מסגרות לטיפול בהפרעות אכילה- ישיבת מעקב</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/Activity/committees/Women/Pages/CommitteeProtocols.aspx?ItemID=2012057'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': '2018',
    'year_founded': 1999,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '12/11/2018'
    },
    'description': 'בית ״שירת הלב״ נוסד בשנת 2016 (ע״ר 580629582) על ידי יעל אדל הורוביץ כמקום מגורים, תמיכה ושיקום לנשים צעירות חרדיות בסיכון (מעל גיל 18) שנמצאות ברחוב עקב פגיעות, טראומה, וניתוק מהמשפחה או הקהילה הדתית. נכון ל-2018, העמותה מפעילה 8 דירות בירושלים עבור כ-25 צעירות בגילאים 18-25 ויש ניסיון לגייס תרומות ליצירת בית מרכזי עבור כלל הצעירות יחד.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'SW34',
    'is_active': true,
    'keywords': [
      'טראומה',
      'דיור',
      'תמיכה נפשית',
      'נערות במצוקה',
      'צעירות במצבי סיכון',
      'חינוך',
      'השלמת השכלה',
      'דת'
    ],
    'name': 'שירת הלב',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'צעירות במצבי סיכון',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2018-11-12'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.shirat-halev.co.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>שירת הלב ירושלים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580629582'
      },
      {
        'title': 'בית שירת-הלב, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/midreshetshirathalev/'
      },
      {
        'title': 'חולי, אדווה (2017, 19 דצמבר).״אין לי היכן להתגורר״: עמותת \'שירת הלב\' מגייסת כספים לפתיחת בית מרכזי לצעירות בירושלים. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://jerusalem.mynet.co.il/local_news/article/m_249524'
      }
    ],
    'target_audiences': [
      'נשים חרדיות',
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '26/05/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2016,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'עבודה קהילתית',
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '19/06/2018'
    },
    'description': '״שישה צבעים״ הוא ארגון שהוקם ב - 2006. במטרה לבנות את הקהילה הגאה בישראל ובשנת 2007 הפך לעמותה. בעמותה פעלו כ-300 מתנדבים ומתנדבות וכ-2000 משתתפים ומשתתפות בפעילויות שהתקימו ב-7 רשויות מקומיות (בדגש על הפריפריה): שדרות, ראשון לציון, תל אביב-יפו, חדרה, בנימינה-גבעת עדה, חיפה וטבריה. שישה צבעים הפעילה קבוצות מפגש חברתיות לפעילים, כולל טיולים, קבוצות ספורט וחוגי העשרה. העמותה הדפיסה יומן קהילתי והפעילה ערוץ טלוויזיה קהילתי. הארגון ״שישה צבעים״ התפרק בהדרגה במהלך 2014-2015 וב - 2015 העמותה עברה להפעיל את ארגון ״הקשת החיפאית״. ב - 2017 כאשר גם ״הקשת החיפאית״ הפסיקה לפעול, מוקד הפעילות של העמותה עבר ל״פיץ׳ - מרכז לנוער גאה״ בחיפה. בפברואר 2018 נפסקה כמעט לחלוטין פעילות העמותה ולאחר ניסיונות להחיותה במהלך יולי-אוגוסט של אותה השנה, החליט ברוך אורן מקים העמותה והארגון לסיים את פעילותה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'ארגונים קהילתיים'
      ],
      [
        'תקשורת'
      ],
      [
        'תרבות וספורט',
        'פנאי'
      ]
    ],
    'id': 'SA25',
    'is_active': false,
    'keywords': [
      'גאווה',
      'חוגים',
      'אקטיביזם',
      'פעילות גופנית',
      'מצעד',
      'פריפריה'
    ],
    'name': 'שישה צבעים',
    'name_ar': null,
    'name_change_year': 2015,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'בנימינה-גבעת עדה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'עבודה קהילתית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ארגונים קהילתיים',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2018-11-15'
    },
    'sources': [
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>שישה צבעים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580483303'
      },
      {
        'title': 'שישה צבעים | בונים קהילה גאה בישראל, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/6tzvaim/'
      },
      {
        'title': 'כל זכות (ללא תאריך). <b>שישה צבעים</b>: נדלה מתוך',
        'url': 'https://www.kolzchut.org.il/he/%D7%A9%D7%99%D7%A9%D7%94_%D7%A6%D7%91%D7%A2%D7%99%D7%9D'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '21/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': '2018',
    'year_founded': 2006,
    'year_registered': 2007
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '01/05/2020'
    },
    'description': 'עמותת ״שלום בנייך״ (ע״ר 580445310) הוקמה ב- 2005 על ידי אנשי טיפול, רבנים ואנשי חינוך דתיים וחרדים במטרה לתת מענה לבעיה של פגיעות מיניות. מטרות העמותה הפועלת בבני ברק הן: ״לטפל ולהדריך ילדים שנפגעו או עתידים להיפגע הם ומשפחותיהם. לאתר ילדים בסיכון. לסייע לילדים ובני נוער במצבי סיכון ומצוקה באמצעות הקמת הוסטלים ומרכזי יום, מרכז ייעוץ ומידע, הדרכת צוותי חינוך וצוותים מקצועיים וטיפול הן בפוגעים והן בנפגעים.״ העמותה עוסקת במניעה ובטיפול במוסדות חינוך ובקהילה על ידי העלאת המודעות החברתית, הפעלת קו סיוע טלפוני, עריכת אבחונים והגשת טיפול מותאם וכן על ידי הכשרת אנשי טיפול ופרסום חומרים בתחום באמצעות ימי עיון והדרכות. העמותה הנה היחידה בארץ המספקת מענה טיפולי הוליסטי עבור נפגעים, בפוגעים, קטינים, מבוגרים, נשים וגברים מהקהילה החרדית. בעמותה מועסקים כ-20 עובדים מקצועיים כולל עובדות סוציאליות, קרימינולוגיות, פסיכולוגים ומטפלים באומנות. בשנת 2015 עמותת שלום בנייך זכתה במכרז של משרד הרווחה למתן שירותי טיפול פרטני וקבוצתי לפדופילים ועברייני מין משוחררים במסגרת הפרויקט ״מרכזי טיפול מורשים בקהילה״. בנוסף, העמותה מפעילה גם קבוצות טיפוליות בכלא בשיתוף פעולה עם שירות בתי הסוהר. ההפניות לעמותה מגיעות בחלקן כפנייה ישירה מהציבור בעקבות פרסומים בעתונות במגזר החרדי-דתי או דרך קציני מבחן, הסנגוריה הציבורית, בתי המשפט, הרשות לשיקום האסיר, מטפלים פרטיים או נציגי ציבור.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'SA174',
    'is_active': true,
    'keywords': [
      'שיקום',
      'עברייני מין',
      'תקיפה מינית',
      'קו סיוע'
    ],
    'name': 'עמותת שלום בנייך - פתח תקווה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'שלום בנייך - קו חם וסיוע טיפולי לפוגעים ונפגעים',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'בני ברק',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'גברים',
    'retrieved': {
      'type{date}': '2020-05-01'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.2all.co.il/web/Sites16/shlombanaich/DEFAULT.asp'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>עמותת שלום בנייך – פתח תקווה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580445310'
      },
      {
        'title': 'רבינוביץ\', מריה (2013). <b>טיפול הרשויות בפדופילים ובבגירים שפגעו מינית בילדים</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/20/Committees/20_cs_mmm_395891.pdf'
      },
      {
        'title': 'Hamo, Gil, & Idisis, Yael (2017). Pedophiles in the ultra-orthodox haredi sector in Israel: Thought processes regarding their actions. <b>Journal of child sexual abuse, 26</b>(4), 407-427.'
      }
    ],
    'target_audiences': [
      'גברים',
      'גברים חרדים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '01/05/2020'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '15/10/2018'
    },
    'description': '״שני- נשים ישראליות נגד הכיבוש״ היא קבוצה שהוקמה בשנת 1988 והגדירה עצמה כ״קבוצת נשים ירושלמיות הפועלת למען שלום צודק, בטוח ומקובל למען שני הצדדים. בהשפעתה של ההתקוממות הפלסטינית התארגנו, נשים בעלות רקע שונה, כדי להביע את התנגדותנו כנשים ישראליות לכיבוש.״ שני נרשמה כעמותה בשנת 1990 (ע״ר 580174274) ומטרותיה היו: ״פעילות נשים למען שלום צודק בטוח ומקובל על שני הצדדים באזור.״ הארגון תמך בזכות ההגדרה העצמית של העם הפלסטיני ודרש מממשלת ישראל ליזום מו״מ עם נציגי אש״ף כדי לסיים את הסכסוך. פעילויות הקבוצה כללו מפגשים בין נשים ישראליות ופלסטיניות, חוגי לימוד, אסיפות פומביות, משמרות נגד רמיסת זכויות אדם בשטחים ועוד. בקשת המחיקה של העמותה מפנקס העמותות מופיעה ברשומות ילקוט הפרסומים בשנת 2001, אך הארגון חדל מלפעול לפני כן.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'שלום'
      ],
      [
        'צבא, ביטחון ומדיניות חוץ',
        'זכויות אדם'
      ]
    ],
    'id': 'SA64',
    'is_active': false,
    'keywords': [
      'אינתיפאדה',
      'כיבוש',
      'פלסטיניות'
    ],
    'name': 'שני- נשים ישראליות נגד הכיבוש',
    'name_ar': 'نساء إسرائيليات ضد الإحتلال',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'שלום',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'אוסף דפנה וראובן קמינר (ללא תאריך). <b>מי אנחנו - ״שני״ - נשים ישראליות נגד הכיבוש</b>. נדלה מתוך',
        'url': 'http://primo.nli.org.il/primo-explore/fulldisplay?vid=NNL_Ephemera&docid=NNL_Ephemera71265919310005171&context=L&lang=iw_IL'
      },
      {
        'title': 'רשומות ילקוט הפרסומים 4959 (2001, 8 פברואר). <b>הודעה סופית בדבר מחיקה מפנקס העמותות</b>. שני- נשים ישראליות נגד הכיבוש (מספר עמותה 580174274). עמ\' 1611. נדלה מתוך',
        'url': 'https://www.nevo.co.il/law_html/Law10/YALKUT-4959.pdf'
      },
      {
        'title': 'Hermann, Tamar (2009). <b>The Israeli peace movement: a shattered dream</b>. Cambridge, UK: Cambridge University Press.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '15/10/2018'
    },
    'year_closed': 2001,
    'year_closed_text': '2001',
    'year_founded': 1988,
    'year_registered': 1990
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '26/12/2019'
    },
    'description': '״שנת הפועלות״ היתה קואליציית ארגונים שהוקמה בשנת 2000 בעקבות הכנס הפמיניסטי הארצי שהתקיים בשנת 1999 וביוזמת תנועת ״אחותי- למען נשים בישראל״. מטרת הפרויקט היתה לקדם נושאים הנוגעים לחייהן של פועלות ונשים עניות: מזרחיות, ערביות ועולות בפריפריה, ולהעלות אותם לסדר היום הציבורי. בתיאור הנסיבות של הקמת הפרויקט הסבירה אילנה בקאל, מנהלת תנועת אחותי כי הוא התבסס על ״אחוות נשים ותפיסה פמיניסטית שמטרתה לכלול קבוצת נשים מגוונות ובמיוחד נשים שאינן במוקדי קבלת ההחלטות בפעילות של נשים למען נשים. הגיית הפרויקט על ידי נשים מזרחיות באה לאחר בחינת פעילותם של ארגוני הנשים הקיימים בישראל והישגיהם; ארגוני הנשים לא הצליחו עד כה להוות מוקד משיכה לנשים במעמדות הביניים ובשוליים, בעיקר בגלל שסדר היום של ארגונים אלה, למרות החזון לא מצליח להתרומם לכדי מדיניות שתיגע ותקיף את כלל הנשים בישראל. לראשונה בארץ הוקמה קואליצייה של ארגוני נשים שהקו המרכזי המנחה אותה- קידום זכויותיהן של הנשים העובדות בישראל״. הפרויקט נוהל ורוכז על ידי ועדת היגוי ארצית בהובלת תנועת אחותי. בין הארגונים שנכללו בקואליצייה היו: שדולת הנשים, תנד״י, בת שלום, פורום נשים באר שבע, אשה לאשה, כייאן, קול האשה ואיתך. פעילות הקואליציה כללה פרויקטים של התארגנות והעצמה כלכלית בקרב נשים עובדות במפעלים בעיקר באזור הצפון ודרום והתקיימה בישובים יהודיים, כמו מצפה רמון וקריית גת וערביים, כמו חורפיש וירכא. באחד הדיונים בועדה לקידום מעמד האשה סיפרה עו״ד ישראלה גרציאני, היועצת המשפטית של שדולת הנשים, על פעילות הקואליצייה ואמרה:״ ישנה טענה שזה לא פוליטיקלי קורקט להגיד את המילה פועלות, אבל הפועלות היום במדינת ישראל ברובן הן נשים ונשים ערביות. [...] נשים ככלל, לצערי, לא מרימות קול, ובעיקר נשים ערביות לא מרימות קול, והיו הרבה מקרים שאיתרנו במפעלים, שהעובדות שם היו בעיקר נשים ערביות, שגם המעבידים התייחסו אליהם בצורה מחפירה, על גבול עבדות. החל מהפסקת צהרים של רבע שעה, אסור לדבר בטלפון, אסור לעשן ואסור אלף ואחד דברים.״ לאחר כשנתיים של פעילות שבמהלכן הלכה והתרחבה תנועת אחותי, התפרקה הקואליצייה והפרויקט התמזג בפעילות הכללית של הארגון.',
    'description_ar': null,
    'display_organization_kind': 'קואליציה, איגוד או פורום',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ],
      [
        'רב-תחומי',
        'פמיניזם'
      ]
    ],
    'id': 'SA171',
    'is_active': false,
    'keywords': [
      'פריפריה',
      'פמיניזם מזרחי',
      'עוני'
    ],
    'name': 'שנת הפועלות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'קואליציה, איגוד או פורום'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'קואליציה, איגוד או פורום',
    'primary_sub_field_of_activity': 'זכויות ומדיניות',
    'primary_target_audience': 'נשים מזרחיות',
    'retrieved': null,
    'sources': [
      {
        'title': '(2001, 17 מאי). <b>פרוטוקול פורום עמותת ״אחותי״</b>. אותר בקלסר ״שנת הפועלות״ בארכיון הפמיניסטי ב״אשה לאשה – מרכז פמיניסטי חיפה״.'
      },
      {
        'title': 'בקאל, אילנה (2002). ״אחותי מתארגנת״ בתוך: דמרי-מדר, ורדית (עורכת), <b>פמיניזם מזרחי: עזות מצח</b>. ירושלים: צ״ח- תא סטודנטיות/ים לצדק חברתי, האוניברסיטה העברית.'
      },
      {
        'title': 'דהאן-כלב, הנרייט (2007). תנועת אחותי: חבלי ייסוד 2002-1999. בתוך: ליר, שלומית (עורכת), <b>לאחותי: פוליטיקה פמיניסטית מזרחית</b> (41–61). תל אביב: בבל.'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה ולשוויון מגדרי, ועדת המשנה לקידום מעמד האישה במגזר הערבי (2001, 11 דצמבר). <b>פרוטוקול מס\' 7: נשים ערביות בשוק העבודה - הצגת מחקר שנערך לבקשת המכון היהודי-ערבי בבית ברל ותגבור קורסי הכשרה מקצועית כפתרון למצוקת האבטלה הקשה בקרב רווקות במגזר הערבי</b>.'
      }
    ],
    'target_audiences': [
      'נשים מזרחיות',
      'נשים ערביות',
      'נשים עולות מחבר העמים'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '26/12/2019'
    },
    'year_closed': 2003,
    'year_closed_text': '2003',
    'year_founded': 2000,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '13/11/2018'
    },
    'description': 'ארגון ״שפרה ופועה״ בכפר חב״ד הינו בסיס האם והסניף הראשון שהוקם בשנת 1976 כחלק מרשת ‏העמותות ״שפרה ופועה״ שנותנות סיוע ליולדות ומשפחותיהן מהקהילה החרדית. הארגון הוקם על פי ‏חזונו של הרבי מליובאוויטש שהציע את השם ״שפרה ופועה״ על שם המיילדות העבריות שהצילו את ‏ילדי ישראל במצרים. הרבי ציין שהארגון ידאג לכל דבר ועניין שהיולדת נדרשת לו, ״מווייגלע ‏ל״ווינדלע״ (באידיש: מעגלת תינוק, ועד לחיתול). במשך השנים צבר הארגון תאוצה והתפתח למספר ‏עמותות מקומיות המפעילות מאות מתנדבות המסייעות למאות יולדות מדי שנה. הארגון מעניק סיוע ‏ליולדות בתחומים: ארוחת בוקר, עוזרת בית, ארוחת צהריים, שירותי שמרטף, בגד יציאה מבית ‏רפואה, ציוד לאם ולתינוק להשאלה, ביגוד לתינוק, קשר אישי עם היולדת, משחקיית ״שפרה ופועה״, ‏גמ״ח ״לאם ולתינוק״.‏',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'בריאות ופריון',
        'הריון ולידה'
      ],
      [
        'דת ומעמד אישי',
        'בריאות ופריון'
      ]
    ],
    'id': 'SA89',
    'is_active': true,
    'keywords': [
      'גמ״ח',
      'סיוע לאמהות'
    ],
    'name': 'שפרה ופועה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'בריאות ופריון',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'הריון ולידה',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-11-13'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://kfar-chabad.com/info/%D7%A9%D7%A4%D7%A8%D7%94-%D7%95%D7%A4%D7%95%D7%A2%D7%94/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>ארגון שפרה ופועה ע״י נשי חב״ד ירושלים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580039998'
      },
      {
        'title': '(ג\' בניסן תש״ע). נציגות שפרה ופועה מכל הארץ התכנסו ברוח התנדבות. <b>שטורעם.נט</b>. נדלה מתוך',
        'url': 'http://shturem.net/index.php?section=news&id=41967'
      }
    ],
    'target_audiences': [
      'נשים דתיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '13/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1976,
    'year_registered': 1982
  },
  {
    'activity_kinds': [
      'מחאה',
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '04/07/2018'
    },
    'description': 'אל”ה - אוניברסיטה ללא הטרדות, הוקמה על ידי קבוצת סטודנטיות באוניברסיטת באר שבע ובאוניברסיטת תל אביב בעקבות גל פרסומים על תופעה של הטרדות מיניות של מרצים כלפי סטודנטיות במוסדות להשכלה גבוהה. הקבוצה התמקדה בפעולות מחאה בתוך האוניברסיטאות, בגיוס תמיכה של סטודנטיות/ים נגד ניצול לרעה של יחסי כוח בין מרצים/ות לתלמידות/ים ובייזום מפגשים עם קובעי מדיניות בתוך המוסדות להשכלה גבוהה, במטרה לקבוע נהלים ברורים למניעת הטרדות מיניות ולהעמדה לדין של החשודים בביצוען. בשנים האחרונות לפעילותה אל״ה היתה פעילה בעיקר באוניברסיטה העברית בירושלים בה נחשפו מקרים רבים של הטרדה ותקיפה מינית על ידי מרצים חברי הסגל האקדמי של האוניברסיטה.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'אלימות',
        'הטרדה מינית'
      ],
      [
        'השכלה גבוהה ומחקר',
        'תאים סטודנטיאליים'
      ]
    ],
    'id': 'YB120',
    'is_active': false,
    'keywords': [
      'אקטיביזם',
      'צעדה',
      'סטודנטיות',
      'מנהיגות'
    ],
    'name': 'תא אל״ה - אוניברסיטה ללא הטרדות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'אקדמי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'הטרדה מינית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל. עמ\' 13.'
      },
      {
        'title': 'בינדר, אורי (2008, 7 יולי). סטודנטים בבן-גוריון: לטפל בהטרדות מיניות. <b> NRG מעריב</b>. נדלה מתוך',
        'url': 'https://www.makorrishon.co.il/nrg/online/1/ART1/756/563.html'
      },
      {
        'title': 'הוועדה המיוחדת ליישום הנגשת המידע הממשלתי ועקרונות שקיפותו לציבור (2016, 15 מאי). <b>פרוטוקול מס\' 38: הטרדות מיניות באקדמיה</b>. נדלה מתוך',
        'url': 'https://committees-next.oknesset.org/meetings/5/7/579250.html'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '09/04/2018'
    },
    'year_closed': 2017,
    'year_closed_text': '2017',
    'year_founded': 2008,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות',
      'אקטיביזם רשת'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '05/07/2018'
    },
    'description': '״תא העיתונאיות״ הוא התארגנות של נשים מענף התקשורת בישראל. התא החל את דרכו ביוני 2012 ״בסדרת פגישות עם ראשי התקשורת בישראל במטרה לקדם סוגיות בוערות בתקשורת שעל סדר יומו של התא כמו: שוויון מגדרי, סביבת עבודה מכבדת נקייה מהטרדות מיניות, סיקור מכבד, ייצוג נשים על המסך וסיקור בראייה מגדרית״. בין מקימות וחברות התא העיתונאיות נמנו לינוי בר גפן, ענת סרגוסטי, הדס שטייף, אריאנה מלמד, ורד כהן ברזילי וטל שניידר. בשנת 2013 פרסם התא את החשדות להטרדה מינית מצד העיתונאי עמנואל רוזן. בשנת 2014 ערך תא העיתונאיות בשיתוף עם איגוד מרכזי הסיוע והמכון הישראלי לדמוקרטיה ״מסמך עקרונות לסיקור מקרי תקיפה מינית״ שצורף אל הקוד האתי להצגת עבירות תקיפה מינית בתקשורת. פעילויות התא כוללות גם הענקת ״אות תא העיתונאיות״ לעיתונאים ועיתונאיות שתרמו לייצוג של נשים בתקשורת והקמת המאגר המקוון ״ליסטה״ שכולל פרטי מומחיות בנושאים מגוונים המיועד לשימושם של עיתונאיות ועיתונאים בשיתוף ארגון ״אנו״.',
    'description_ar': null,
    'display_organization_kind': 'התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'תקשורת'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ],
      [
        'תעסוקה ועבודה',
        'התאגדויות ורשתות מקצועיות'
      ]
    ],
    'id': 'YH47',
    'is_active': true,
    'keywords': [
      'אלימות מינית',
      'אפליה מגדרית בתעסוקה',
      'עיתונאיות'
    ],
    'name': 'תא העיתונאיות',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'תקשורת',
    'primary_organization_kind': 'התארגנות שאינה עמותה',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'העין השביעית (ללא תאריך). תא העיתונאיות. <b>העין השביעית</b>. נדלה מתוך',
        'url': 'https://www.the7eye.org.il/topic/%D7%AA%D7%90-%D7%94%D7%A2%D7%99%D7%AA%D7%95%D7%A0%D7%90%D7%99%D7%95%D7%AA-%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C'
      },
      {
        'title': 'לחובר, עינת ולמיש, דפנה (2015, 13 אוגוסט). העיתונאית: הפמיניזציה בעיתונות הישראלית – תזה, מחקר ובחינה מחודשת. <b>העין השביעית</b>. נדלה מתוך',
        'url': 'https://www.the7eye.org.il/169603'
      },
      {
        'title': 'ליסטה - מאגר מומחיות לתקשורת (אתר).',
        'url': 'http://lista.org.il/'
      },
      {
        'title': 'תא העיתונאיות. <b>ויקיפדיה</b>. נדלה מתוך',
        'url': 'https://he.wikipedia.org/wiki/%D7%AA%D7%90_%D7%94%D7%A2%D7%99%D7%AA%D7%95%D7%A0%D7%90%D7%99%D7%95%D7%AA'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '07/08/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2012,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '16/05/2018'
    },
    'description': 'מרכז סיוע \'תאיר\' (ע״ר 580320265) פועל משנת 1998 למתן סיוע וליווי לנפגעות ולנפגעי תקיפה מינית, ולהעלאת מודעות, חינוך והסברה בנושא אלימות מינית. המרכז ממוקם ופועל באזור השפלה המורחב, ומשרת כמיליון תושבים - מאשקלון וקריית מלאכי בדרום, ועד לוד ונס-ציונה בצפון, ומודיעין-מכבים-רעות במזרח. מרכז הסיוע מעניק תמיכה וסיוע אנונימיים באמצעות קו טלפוני הפועל 24 שעות ביממה. המרכז פועל להנגשה ושיפור המענים הקיימים לנפגעות ולנפגעי תקיפה מינית באמצעות הדרכות, הכשרות ושיתופי פעולה עם מערכות השירותים הציבוריים באזור, ועם נשות ואנשי מקצוע מתחומי הרווחה, החינוך, הטיפול, הבריאות והחוק. השפעה על הידע הקיים בקהילה בקרב נשות ואנשי מקצוע תשפר את המענה והטיפול בנפגעות אלימות מינית במטרה לתת מענה מדויק יותר. בנוסף, המרכז מקיים סדנאות בקרב בני נוער במסגרות החינוך הפורמאלי והבלתי פורמאלי, הרצאות לצוותים חינוכיים ולהורים, הרצאות במקומות עבודה, והכשרות לממונות על החוק למניעת הטרדה מינית במקומות עבודה.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'חינוך',
        'מניעת אלימות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'YB31',
    'is_active': true,
    'keywords': [
      'אונס',
      'הטרדה מינית',
      'קו סיוע',
      'תמיכה נפשית',
      'סיוע משפטי'
    ],
    'name': 'תאיר - מרכז סיוע לנפגעות ולנפגעי תקיפה והטרדה מינית',
    'name_ar': 'تئير- مركز مساعدة ضحايا العنف الجنسي منطقة الشفيلا',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'רחובות',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-05-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.1202.org.il/local/tair/about'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>תאיר – מרכז סיוע לנפגעות ולנפגעי תקיפה והטרדה מינית (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580320265'
      },
      {
        'title': 'רוח טובה (ללא תאריך). <b>מרכז הסיוע לנפגעי ונפגעות תקיפה מינית - תאיר -רחובות</b>. נדלה מתוך',
        'url': 'http://www.ruachtova.org.il/organizations/1897'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '11/02/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחאה',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '23/10/2018'
    },
    'description': '״תדמית אחרת״ נרשמה כעמותה ב-1982 (ע״ר 580032811). מטרות כפי שמופיעות במאגר העמותות: ״שינויי תדמית האשה כפי שהיא מוצגת באמצעי התקשורת ההמוניים ברוח שויון המינים וכבוד האדם הן ע״י מחאה נגד תדמיות קימות והן ע״י קידום פוזיטובי של תדמית אחרת״. הודעה מוקדמת על מחיקה מפנקס העמותות פורסמה בשנת 2001 והעמותה נמחקה סופית ב-2003. אולם, ככל הנראה הפסיקה לפעול שנים קודם לכן.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תקשורת'
      ]
    ],
    'id': 'YH114',
    'is_active': false,
    'keywords': [
      'פרסום פוגע',
      'העלאת מודעות',
      'מחאה'
    ],
    'name': 'תדמית אחרת',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מחאה',
    'primary_field_of_activity': 'תקשורת',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': null,
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2018, 18 נובמבר). <b>תדמית אחרת</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'ארליך, דוד (1983, 24 מרץ). קול נשים קורא במדבר. <b>דבר</b>. נדלה מתוך',
        'url': 'http://www.jpress.nli.org.il/Olive/APA/NLI_heb/SharedView.Article.aspx?href=DAV%2F1983%2F03%2F24&id=Ar00905&sk=21696795'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '27/10/2019'
    },
    'year_closed': 2001,
    'year_closed_text': '2001',
    'year_founded': 1982,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '18/02/2019'
    },
    'description': 'ארגון תהיל״ה הוקם בשנת 1989 על ידי יונתן דנילוביץ׳ ודבורה לוז ומשמש מאז כמסגרת תמיכה להורים ובני משפחות של להט״בים. בשנת 1992 נרשמה העמותה ״תמיכת הורים של לסביות והומוסקסואלים - תהל״ה״ (ע״ר 580210813) שמטרתה: ״לעזור להורי בני משפחה וחברי לסביות והומוסקסולים לקבל להבין ולאהוב אותם. להפיץ בציבור מידע מדויק ועדכני לגבי הומוסקסואליות״. הארגון שמופעל על ידי מתנדבים מפעיל קבוצות תמיכה להורים ומשפחות בכל רחבי הארץ וקו קשב לתמיכה טלפונית. כמו כן, מתנדבי הארגון מלווים קבוצות של איגי - ארגון הנוער הגאה, ומשתפים אותם בחוויותיהם. שני פרויקטים נוספים של הארגון הם ״הורה בקפה״ המספק תמיכה ללהט״בים בתהליכי יציאה מהארון מול בני משפחותיהם ו״הולך ומשתפר״ - מיזם הכולל הפקה והפצה של סרטונים קצרים, הכוללים סיפורים אישיים של בני משפחה ללהט״בים המספרים על ההתמודדויות, הקשיים, התמיכה והאהבה שהם חווים. ״הולך ומשתפר״ הוא חלק מפרויקט עולמי בשם זה. יש פער בין השם של הארגון ברשם העמותות - ״תמיכת הורים של לסביות והומוסקסואלים - תהל״ה, לבין השם המשמש באתר ובקהילה ״תהילה - תמיכה להורים ובני משפחות הקהילה הלהט״בית״. יתכן כי הפער משקף את השינוי בזיהוי הקהילתי מ״הקהילה ההומו-לסבית״ ל״קהילת הלהט״ב״ בזמן שעבר מאז הקמתו של הארגון.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'להט״ב',
        'משפחה'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'LR51',
    'is_active': true,
    'keywords': [
      'קבוצות תמיכה',
      'משפחות',
      'להט״בופוביה',
      'אקטיביזם',
      'גאווה',
      'קו סיוע',
      'תמיכה נפשית'
    ],
    'name': 'תמיכת הורים של לסביות והומוסקסואלים - תהל״ה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'תהילה - תמיכה להורים ובני משפחות הקהילה הלהט״בית',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נתניה',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'משפחה',
    'primary_target_audience': 'להט״ב',
    'retrieved': {
      'type{date}': '2019-02-18'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.tehila.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>תמיכת הורים של לסביות והומוסקסואלים – תהל״ה (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580210813'
      },
      {
        'title': 'תהל״ה - עמותת הורים למען הורים ללהט״בים, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/Tehila.org.il/?ref=page_internal'
      },
      {
        'title': 'כ״ץ, ישראל, מעוז, עדי, אלפסי, דנה, לוי, ניר (2018). <b>מיפוי ארגוני הלהט״ב בישראל - דו״ח מסכם</b>. האגודה למען הלהט״ב ואלכא – המכון למנהיגות וממשל בג\'וינט ישראל, ירושלים. נדלה מתוך',
        'url': 'https://a9991848-b055-4c6f-a966-a6bdabf09321.filesusr.com/ugd/be9e5d_e13bb06adc274327b97bb41c199efc0c.pdf'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '19/02/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1989,
    'year_registered': 1992
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '16/05/2018'
    },
    'description': 'תהל - מרכז הסיוע לנשים ולילדים דתיים (ע״ר 580229979) נוסד ב-1993 בירושלים כמרכז סיוע המספק מענה לנשים וילדים מהחברה הדתית והחרדית. המרכז מעניק תמיכה, סיוע וטיפול מתוך הכרה בצרכים הייחודיים לנפגעות ונפגעים מהחברה הדתית. המרכז הינו חלק מאיגוד מרכזי הסיוע ומספק תמיכה וליווי אישי, קו חם, סדנאות להעלאת מודעות ומניעת אלימות מינית ובמשפחה, וכן הכשרות מקצועיות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'חינוך',
        'מניעת אלימות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'YB30',
    'is_active': true,
    'keywords': [
      'אונס',
      'הטרדה מינית',
      'קו סיוע',
      'תמיכה נפשית',
      'אמהות',
      'ילדות/ים',
      'סיוע משפטי',
      'דת'
    ],
    'name': 'תהל - מרכז הסיוע לנשים וילדים דתיים',
    'name_ar': null,
    'name_change_year': 2014,
    'name_common': null,
    'name_past': 'מרכז הסיוע לנשים דתיות',
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'נשים דתיות',
    'retrieved': {
      'type{date}': '2018-05-16'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://hebrew.crisiscenter.org.il/services/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>תהל – מרכז הסיוע לנשים וילדים דתיים (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580229979'
      },
      {
        'title': 'איגוד מרכזי הסיוע לנפגעות ולנפגעי תקיפה מינית (אתר). <b> תהל - מרכז הסיוע לנשים וילדים דתיים</b>. נדלה מתוך',
        'url': 'https://www.1202.org.il/local/tahel'
      },
      {
        'title': 'משרד הפנים, רשם העמותות (ללא תאריך). <b>תעודת שינוי שם העמותה</b> (מסמך).'
      }
    ],
    'target_audiences': [
      'נשים דתיות',
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '07/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1993,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מחקר ותיעוד',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '24/04/2018'
    },
    'description': 'עמותת תודעה נוסדה ע״י לאה גרינפטר גולד וניסן בן -עמי בשנת 2002 (שמה הרשום: מהפך תודעתי ע״ר 580396380). העמותה פועלת להעלאת המודעות הציבורית ובקרב קובעי המדיניות להיקפה העצום ותוצאותיה החמורות של תופעת הזנות. מטרות העמותה הן: ״ צמצום מימדי תופעת הזנות עד לביטולה.פעילות כנגד סרסרות, סחר וכפיה בזנות. הרחבת שירותי השיקום לנשים, לגברים ולטרנסג\'נדריות במעגל הזנות.״ העמותה פועלת ליצירת שינוי באמצעות הסברה - כולל השתתפות בוועדות כנסת, סדנאות לנוער וצעירים על זנות וסחר בבני אדם ופרסום מאמרים בתקשורת. בנוסף מפעילה העמותה מרכז מידע אשר כולל נתונים, מחקרים ופרסומים על היקף התופעה ומאפייניה בארץ ובעולם. פעילות העמותה מבוססת בעיקרה על מתנדבות/ים.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'זנות'
      ],
      [
        'הגירה',
        'סחר בבני אדם'
      ]
    ],
    'id': 'YB24',
    'is_active': true,
    'keywords': [
      'זנות',
      'סחר בנשים',
      'העלאת מודעות',
      'מידע'
    ],
    'name': 'מהפך תודעתי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'תודעה - העמותה למאבק בתופעת הזנות',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'זנות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-04-24'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://todaango.org.il/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>מהפך תודעתי (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580396380'
      },
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל. עמ\' 50–52.'
      },
      {
        'title': 'תודעה - העמותה למאבק בתופעת הזנות (2018, 21 אפריל). הפרטים אומתו בשיחה עם ענבל פרן-פרח, חברת וועד מנהל בעמותה.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)',
      'נשים עולות מחבר העמים',
      'נשים מהגרות עבודה או חסרות מעמד'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '14/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2000,
    'year_registered': 2002
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '24/05/2018'
    },
    'description': 'במרץ 1987 פנתה יעל רום מטעם שדולת הנשים אל המרכז לשלטון המקומי בהצעה לסייע בהקמת מועצות ציבוריות של נשים ברשויות המקומיות בדומה למודל החיפאי שהחל בשנת 1974. במכתב נאמר כי ״השירות במועצות הצבוריות עשוי לשמש בית ספר מצוין ללימוד התפקידים של נציגי צבור [...] הנשים הן הצרכניות האמיתיות של מרבית השרותים שמספקת הרשות המקומית ואת דעתן, הערכתן וצרכיהן של המשפחות הן יודעות יותר טוב מכל אחד אחר״. חודשיים מאוחר יותר פרסם מרכז השלטון המקומי חוזר מנכ״ל (מס\' 157) ובו נאמר כי ״שדולת הנשים בישראל פנתה להנהלת המרכז בבקשה להקים מועצות מקומיות של נשים ליד ראשי הרשויות המקומיות. ההנהלה המצומצמת דנה בבקשה והחליטה להמליץ בפני ראשי הרשויות להקים לידם מועצה ציבורית של נשים. המטרה היא להפעיל את הנשים בתחומי הרשות בנושאים המוניציפליים המתאימים כגון: פעולה קהילתית, נקיון העיר וכו״. בחודש יוני 1987, נערך בהרצליה כנס בנושא ״נשים בשלטון המקומי״ ובו הוקם צוות עבודה לקידום נשים בשלטון המקומי ונאספו שמות של נשים שהתעניינו בהשתלבות פעילה בפעילות הועדות של המרכז לשלטון מקומי. בינואר 1988 החלו להתקיים פעילויות הדרכה עבור מועמדות למועצות ציבוריות בשיתוף שדולת הנשים ומשרד הפנים. בשנת 1994, בתמיכה של יועצת ראש הממשלה למעמד האשה, מונתה יועצת לקידום מעמד האשה במרכז לשלטון המקומי שפעלה ביחד עם ועדה מלווה שהורכבה מנשים נבחרות ברשויות מקומיות שונות. הגדרת התפקיד המוקדמת של היועצת היתה לסייע בהקמת מועצות ציבוריות של נשים ברשויות המקומיות. מאוחר יותר, לאחר חקיקת חוק היועצות לקידום מעמד האשה ברשויות המקומיות (2000) החלה היחידה לעסוק בהכשרת יועצות, קידום נהלים ותקנות ברמה המוניציפלית ובמניעת הטרדה מינית בגופי השלטון המקומי.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף מוניציפלי',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'ייצוג הולם'
      ],
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ]
    ],
    'id': 'YH4',
    'is_active': true,
    'keywords': [
      'יועצות לקידום מעמד האשה',
      'רשות מקומית',
      'קידום נשים'
    ],
    'name': 'יועצת למעמד האישה במרכז השלטון המקומי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'תחום מעמד האישה ומניעת הטרדה מינית במרכז השלטון המקומי',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'מוניציפלי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'ייצוג הולם',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2019-12-18'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.masham.org.il/html5/?_id=11903&did=11357&g=11903&title=%F7%E9%E3%E5%ED%20%EE%F2%EE%E3%20%E4%E0%E9%F9%E4'
      },
      {
        'title': 'רום, יעל (1994). <b>מועצות צבוריות של נשים ליד ראשי רשויות מקומיות: דברים שרצית לדעת</b>. ירושלים: שדולת הנשים בישראל.'
      },
      {
        'title': 'Convention on the elimination of all forms of discrimination against women. Distr.: General, 8 April 1997. CEDAW / C / ISR / 1-2.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '18/12/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1994,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '22/05/2018'
    },
    'description': 'יחידת תיאום המאבק בסחר בבני אדם פועלת מכח החלטת ממשלה 63 מיום 21 במאי 2006 לאחר חקיקת חוק איסור סחר בבני אדם. החלטה זו מתייחסת למינוי מתאם בין-משרדי בתחום המאבק בסחר בבני אדם וריכוז עבודתם של הצוותים הבין-משרדיים בנושא: ״עובד משרד המשפטים ימונה כמתאם בין – משרדי ויופקד בין היתר, על תיאום המערכת הממשלתית ותיאום בין הממשלה לגורמים שמחוצה לה בנושא זה״. היחידה אמונה על פיתוח ערוצי תקשורת מובנים בין גורמים ממשלתיים לארגונים לא ממשלתיים וקיום קשר עם גורמים בינלאומיים. מטרת היחידה לסייע בעיצוב מדיניות בכל הנוגע למאבק בסחר בבני אדם והגנה על קורבנותיו, לקדם חקיקה, תקנות ונהלים שיש בהם כדי לקדם את המאבק בסחר בבני אדם, לזהות מוקדי סחר חדשים ולפעול למיגורם, לטפל בבעיות פרטניות המתעוררות בשטח, ליזום ולעודד מבצעי חינוך, הכשרות מקצועיות, מחקרים ופרויקטים שיש בהם חשיבות למאבק בסחר בבני אדם. בנוסף לתיאום בין גופי הממשלה השונים, מהווה יחידת התיאום גשר בין גורמים בממשלה לבין ארגונים לא ממשלתיים המעורבים במאבק בסחר בבני אדם. את הקמת הגוף המתאם יזמה והובילה עו״ד רחל גרשוני ממשרד המשפטים אשר מונתה ב-2006 למתאמת המאבק בסחר בבני אדם, וכיהנה בתפקיד עד שנת 2015.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'סחר בנשים'
      ],
      [
        'הגירה',
        'סחר בבני אדם'
      ]
    ],
    'id': 'YB87',
    'is_active': true,
    'keywords': [
      'סחר בנשים',
      'חקיקה',
      'הסברה',
      'סדנאות',
      'שיתוף פעולה בינלאומי',
      'הכשרה מקצועית',
      'משפט'
    ],
    'name': 'תיאום המאבק בסחר בבני אדם',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'סחר בנשים',
    'primary_target_audience': 'נשים מהגרות עבודה או חסרות מעמד',
    'retrieved': {
      'type{date}': '2018-05-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://www.justice.gov.il/Units/Trafficking/About/Pages/default.aspx'
      },
      {
        'title': 'הקתדרה לזכויות אדם ע״ש אמיל זולא (ללא תאריך). <b>עו״ד רחל גרשוני</b>. נדלה מתוך',
        'url': 'http://zola.colman.ac.il/tinygreatness/%D7%A2%D7%95%D7%93-%D7%A8%D7%97%D7%9C-%D7%92%D7%A8%D7%A9%D7%95%D7%A0%D7%99/'
      },
      {
        'title': 'משרד המשפטים, יחידת תיאום המאבק בסחר בבני אדם (ללא תאריך). <b>סחר למטרות זנות וניצול מיני</b>. נדלה מתוך',
        'url': 'http://www.justice.gov.il/Units/Trafficking/Tip/Sexualexploitation/Pages/sexualexploitation.aspx'
      },
      {
        'title': 'משרד המשפטים, יחידת תיאום המאבק בסחר בבני אדם (ללא תאריך). <b>המאבק בישראל</b>.נדלה מתוך',
        'url': 'http://www.justice.gov.il/Units/Trafficking/IsraelFight/Pages/default.aspx'
      },
      {
        'title': 'קו לעובד (2016, 24 פברואר). <b>חשיבות היחידה לתיאום המאבק בסחר בבני אדם</b>. נדלה מתוך',
        'url': 'http://www.kavlaoved.org.il/%D7%97%D7%A9%D7%99%D7%91%D7%95%D7%AA-%D7%94%D7%99%D7%97%D7%99%D7%93%D7%94-%D7%9C%D7%AA%D7%99%D7%90%D7%95%D7%9D-%D7%94%D7%9E%D7%90%D7%91%D7%A7-%D7%91%D7%A1%D7%97%D7%A8-%D7%91%D7%91%D7%A0%D7%99-%D7%90/'
      }
    ],
    'target_audiences': [
      'נשים מהגרות עבודה או חסרות מעמד',
      'גברים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '14/09/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2006,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'חינוך, הכשרה והעלאת מודעות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '09/10/2018'
    },
    'description': 'תכנית ״אשת חיל״ פותחה על ידי הג\'וינט וראשיתה בשנת 1994 כתכנית חלוץ לעידוד נשים יוצאות אתיופיה להשתלב בעולם העבודה וקיבלה את שמה ב-1997. בשנת 2001 לאחר ממצאי מחקר ההערכה הראשון התחילה התכנית לפעול גם בקרב נשים יוצאות קווקז ובוכרה. במהלך שנת 2005 הוקמה תב״ת – מיזם תעסוקה מיסודם של ממשלת ישראל והג\'וינט, עם הקמתה הועברה תכנית אשת חיל לאחריות תב״ת, הפעלת התכנית התבצעה באותה עת על ידי ״שדולת הנשים״ שביוזמתה התכנית החלה להיות מופעלת גם בקרב יהודיות ותיקות - בעיקר מזרחיות בפריפריה. בשנת 2006 החלה התכנית לפעול בקרב נשים ערביות. לאחר מכן הופעלה גם על ידי ״מעורבות״, ״קרן אברהם״ ו״בעצמי״. בשנת 2010 החליטה ועדה בין משרדית להעביר מספר תכניות לאחריות משרדי הממשלה, ובהן התכנית ״אשת חיל״. הוחלט להעבירה למשרד הרווחה והשירותים החברתיים על מנת שיטמיע אותה במערכותיו וימשיך להפעילה על בסיס קבוע בשותפות עם משרדי ממשלה אחרים: משרד התמ\'\'ת, הרשות לפיתוח כלכלי במגזר הערבי, הדרוזי והצ\'רקסי במשרד ראש הממשלה, המשרד לקליטת עלייה, משרד החינוך, משרד השיכון והבינוי (האגף לשיקום שכונות חברתי) ורשויות מקומיות. מ-2010 ועד 2013 הופעלה התכנית על-ידי החברה למתנ״סים. ב-2013 חזרה להיות מופעלת על ידי עמותת ״בעצמי״, אשר מפעילה אותה גם כיום (2018). התכנית מופעלת ב- 74 יישובים, על פי הפילוח הבא: 54 קבוצות בחברה הערבית; 13 קבוצות של נשים יוצאות אתיופיה; 1 קבוצות יוצאות צרפת; 6 קבוצות של נשים יוצאות קווקז בוכרה + נשים ותיקות מוחלשות. 2 קבוצות במסגרת פעילות מרכז ההזמנות בב״ש: 1 קבוצות יוצאות אתיופיה ו-1 קבוצת נשים ותיקות.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף ממשלתי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'השמה וליווי בתעסוקה'
      ],
      [
        'רווחה וקהילה',
        'תעסוקה ועבודה'
      ],
      [
        'הגירה',
        'קליטת עלייה'
      ]
    ],
    'id': 'YH98',
    'is_active': true,
    'keywords': [
      'אמהות',
      'הכשרה מקצועית',
      'יוצאות קווקז ובוכרה'
    ],
    'name': 'תכנית אשת חיל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'השמה וליווי בתעסוקה',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'הרבסט, ענת (2015). <b>אשת חיל - תכנית לעידוד תעסוקה בקרב נשים. דו״ח מחקר״</b>. התכנית הבינתחומית ללימודי מגדר, אוניברסיטת בר-אילן, האוניברסיטה הפתוחה והמוסד לביטוח לאומי. נדלה מתוך',
        'url': 'https://www.btl.gov.il/Mediniyut/BakashatNetunim/dohot/Documents/EshetHayil.pdf'
      },
      {
        'title': 'חסן-דהאר, סוזאן וקינג, יהודית (2013). <b> הטמעת התכנית ״אשת חיל״ במשרד הרווחה והשירותים החברתיים: מחקר הערכה</b>. ירושלים: מאיירס-ג\'וינט-מכון ברוקדייל. נדלה מתוך',
        'url': 'http://employment.jdc.org.il/sites/default/files/knowledge-and-training/%D7%90%D7%A9%D7%AA%20%D7%97%D7%99%D7%9C%20%D7%9E%D7%97%D7%A7%D7%A8%20%D7%94%D7%A2%D7%A8%D7%9B%D7%94.pdf'
      },
      {
        'title': 'משרד העבודה, הרווחה והשירותים החברתיים (ללא תאריך). <b>אשת חיל - תוכנית לשילוב וקידום נשים בעולם העבודה</b>. נדלה מתוך',
        'url': 'https://www.gov.il/he/Departments/Guides/employment-plans-guide?chapterIndex=6'
      }
    ],
    'target_audiences': [
      'נשים ערביות',
      'נשים יוצאות אתיופיה',
      'נשים עולות מחבר העמים',
      'נשים מזרחיות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '10/09/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1994,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע',
      'מחקר ותיעוד',
      'סנגור, מעקב ושינוי מדיניות'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '13/10/2018'
    },
    'description': 'תכנית המנטורינג ״נערות למען נערות״ באוניברסיטת תל אביב נוסדה בשנת 2002 כשיתוף פעולה של מספר גופים: השירות לנערות וצעירות במשרד הרווחה, ויצו, עמותת אשלים והיחידה ללימודי המשך והשתלמויות בביה״ס לעבודה סוציאלית באוניברסיטת תל אביב. התכנית היתה מתקוצבת כמיזם משותף על ידי השירות לנערות, צעירים וצעירות במשרד הרווחה ומכשירה נערות וצעירות בגילאי 17-21, שהסתייעו בשירותי הרווחה להיות מנטוריות המסייעות לנערות במצוקה. הלימודים בתכנית מתקיימים באמצעות היחידה ללימודי המשך והשתלמויות בבית הספר לעבודה סוציאלית במשך שנת לימודים אקדמית אחת. בשנת 2008 הוקמה תכנית דומה במרכז רותם, במכללת ספיר.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף אקדמי',
    'fields_of_activity': [
      [
        'נערות וצעירות',
        'צעירות במצבי סיכון'
      ],
      [
        'רווחה וקהילה',
        'נערות וצעירות'
      ],
      [
        'השכלה גבוהה ומחקר',
        'אקדמיה, חברה וקהילה'
      ]
    ],
    'id': 'YH102',
    'is_active': true,
    'keywords': [
      'מנטורינג',
      'נערות במצוקה',
      'רווחה',
      'מיצוי זכויות',
      'תמיכה נפשית'
    ],
    'name': 'תכנית המנטורינג ״נערות למען נערות״ באוניברסיטת תל אביב',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'ממשלתי',
      'אקדמי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'נערות וצעירות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'צעירות במצבי סיכון',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': {
      'type{date}': '2018-10-13'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'http://mentoritil.wixsite.com/mentoring'
      },
      {
        'title': 'קאי-צדוק, אביטל, גולן, מרים ומאור, טלי (2015). נערות כמנטוריות – בין הוויה לבין עיסוק: זהות, תפקיד ומעגלי תרומה. בתוך: גרופר, עמנואל ורומי, שלמה (עורכים). <b>ילדים ומתבגרים במצבי סיכון בישראל</b>, כרך ב\': קולם של בני הנוער וסוגיות מעולמם של עובדים בשדה החינוכי (עמ\' 461). מכון מופ״ת.'
      },
      {
        'title': 'גולן, מרים, קאי-צדוק, אביטל, פימנטל, נופר וליבנה, עדי (ללא תאריך). תכנית המנטורינג חוגגת בר מצווה. <b>מידעו״ס 78</b>, 30–33 (העמוד אינו זמין יותר).'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '13/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2002,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '19/07/2019'
    },
    'description': 'תכנית כיוונים היא תכנית לעברייני מין מכורים לסמים/אלכוהול בתנאי פנימיה (הוסטל סגור) למשך 14 חודשים. התכנית מופעלת על ידי עמותת הדרך ובמסגרת הקהילה הטיפולית של העמותה לטיפול בהתמכרויות (ממוקמת בעילבון). התכנית היא שיתוף פעולה בין העמותה, השירות לטיפול בהתמכרויות ושירות המבחן למבוגרים במשרד הרווחה ומפוקחת על ידי המשרד. התכנית הוקמה מתוקף התקנות משנת 2011 לפרק השיקום המונע בחוק הגנה על הציבור מפני ביצוע עבירות מין תשס״ו-2006.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי בשיתוף עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'אלימות',
        'אלימות מינית ומגדרית'
      ],
      [
        'רווחה וקהילה',
        'התמכרויות ושיקום'
      ],
      [
        'בריאות ופריון',
        'בריאות הנפש וטיפול'
      ]
    ],
    'id': 'YH196',
    'is_active': true,
    'keywords': [
      'שיקום',
      'הוסטל',
      'דיור',
      'אונס',
      'גברים אלימים',
      'התמכרות'
    ],
    'name': 'תכנית כיוונים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'עיילבון',
    'organization_kind': [
      'ממשלתי',
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'ייעוץ, שירות וסיוע',
    'primary_field_of_activity': 'אלימות',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אלימות מינית ומגדרית',
    'primary_target_audience': 'גברים',
    'retrieved': null,
    'sources': [
      {
        'title': 'ועדת הפנים והגנת הסביבה (2018, 8 ינואר). <b>פרוטוקול מס\' 542: המשבר בין חברת מקורות ומינהל מקרקעי ישראל בנוגע לפעילות עמותת ״הדרך״</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/Activity/committees/InternalAffairs/Pages/CommitteeProtocols.aspx?ItemID=2063449'
      },
      {
        'title': 'משרד העבודה, הרווחה והשירותים החברתיים (2018, 15 אוגוסט). <b>דיווח על יישום פרק השיקום לחוק הגנה על הציבור מפני עבירות מין התשס״ו-2006</b>.'
      },
      {
        'title': 'עמותת הדרך (אתר). <b>״כיוונים״ – תוכנית ייחודית לטיפול במכורים-פוגעים מינית</b>. נדלה מתוך',
        'url': 'http://www.haderech.org/objDoc.asp?PID=156673&OID=682921&DivID=1'
      }
    ],
    'target_audiences': [
      'גברים'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '19/07/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2017,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מחקר ותיעוד',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '22/11/2018'
    },
    'description': '״התכנית ללימודי נשים בשילוב אמנויות״ נפתחה בשנת 1998 בשלוחת אוניברסיטת לסלי בישראל בנתניה. התכנית נבנתה כתכנית בין-תחומית לתואר שני עם עבודת מחקר (תזה) המבוססת על תפיסה של הוראה אקדמית בתחומי האמנות, הפמיניזם והמגדר תוך התנסות חוויתית. בתיאור התכנית נאמר כי היא ״משלבת תכנים תיאורטיים, ספרות ומחקרים עדכניים, יחד עם התנסות חווייתית בשילוב אמנויות, ככלים המאפשרים ביטוי ויצירה בתהליך ההתפתחות של האישה....יעד מרכזי בתכנית הינו הקניית ידע וכלים להתמודדות עם השינויים האישיים, המקצועיים והחברתיים הנוגעים לעולמן של נשים, והרחבת היכולת להוציא מהכוח אל הפועל תהליכים של שינוי תרבותי.״ בשנת 2010 בעקבות סגירת שלוחת אוניברסיטת לסלי בישראל, הפסיקה התכנית את פעילותה במתכונת המקורית והתמזגה לתוך התואר השני הכללי בחברה ואמנויות ב״מכללה האקדמית לחברה ואמנויות״ בנתניה.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תכניות לתואר אקדמי בלימודי מגדר'
      ],
      [
        'תרבות וספורט',
        'אמנות'
      ],
      [
        'בריאות ופריון',
        'תמיכה נפשית'
      ]
    ],
    'id': 'SA92',
    'is_active': false,
    'keywords': [
      'לימודי מגדר',
      'פמיניזם',
      'תרפיה',
      'אמנות',
      'חינוך'
    ],
    'name': 'תכנית לימודי נשים בשילוב אמנויות באוניברסיטת לסלי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'נתניה',
    'organization_kind': [
      'אקדמי',
      'בינלאומי'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'מחקר ותיעוד',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תכניות לתואר אקדמי בלימודי מגדר',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'חניק, מירה (2004). כאן הלימודים זה סוג של שקט: נשים צומחות ומתעצמות בלימודי נשים. <b>גדיש</b> ט\', 123¬-137. נדלה מתוך',
        'url': 'http://www.haderech.co.il/empower2.html'
      },
      {
        'title': 'ספרן, חנה (2009). בין אקדמיה לקהילה פמיניסטית: לימודי נשים בישראל. בתוך: אופלטקה, יזהר והרץ לזרוביץ, רחל (עורכים), <b>מגדר ואתניות בהשכלה הגבוהה בישראל</b> (עמ\' 169–188). חיפה: פרדס. נדלה מתוך',
        'url': 'https://gendersite.org.il/wp-content/uploads/2010/08/Safran.pdf'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '22/11/2018'
    },
    'year_closed': 2010,
    'year_closed_text': '2010',
    'year_founded': 1998,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'יעל חסון',
      'on': '16/01/2020'
    },
    'description': 'תקציב המדינה לשנת 2003 כלל קיצוצים נרחבים בקצבאות הביטוח הלאומי ובמיוחד בקצבאות הילדים, הבטחת הכנסה ודמי מזונות. כתוצאה, פרצה מחאה חברתית אותה הובילו אמהות חד הוריות. הלחץ הציבורי שנוצר הביא לגיבוש ״התכנית לשילוב הורים יחידים בשוק העבודה״ אשר קיבלה תוקף של החלטת ממשלה (החלטה 757 מיום 28.8.2003). התכנית יועדה לאמהות חד הוריות שקיבלו הבטחת הכנסה או דמי מזונות וכללה בין היתר מענק כספי לאמהות חד הוריות שיגדילו את הכנסתן, הטבות למעסיקים, החזרי נסיעות וזכאות לקורסים ומסלולי הכשרה תוך כדי עבודה. התכנית הופעלה במתכונת ניסיונית עד 2005 והחל מ-2006 הופעלה כתכנית ארוכת טווח שכללה גם מרכיבים כגון: סבסוד מסגרות טיפול בילדים, מסגרות הכשרה מקצועית, עידוד יזמות, סיוע בניידות ומלגות לימודים. התכנית הופעלה על ידי משרד התמ״ת וכללה מספר תכניות משנה אשר אוחדו תחת מסגרת תקציבית אחת ״עידוד תעסוקת חד-הוריות״. ביקורת שערך מבקר המדינה על התכנית העלתה כי היא לא השיגה את יעדיה והתקציבים שהוקצו לה לא נוצלו.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'רווחה וקהילה',
        'אמהות חד הוריות'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ]
    ],
    'id': 'YH209',
    'is_active': false,
    'keywords': [
      'חד הוריות',
      'אמהות גרושות',
      'סיוע לאמהות',
      'הכשרה מקצועית',
      'שוק העבודה',
      'שירות ציבורי'
    ],
    'name': 'התכנית לשילוב הורים יחידים בשוק העבודה',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'תכנית סיוע למשפחות חד הוריות',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ארצי',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'רווחה וקהילה',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'אמהות חד הוריות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': '(2003, 12 אוגוסט). נתניהו: ״הטיפול בחד הוריות מוצה״. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-2723555,00.html'
      },
      {
        'title': 'אחדות, נטע (2007). התכנית לשילוב הורים יחידים בשוק העבודה: משאבים וחסמים להשתלבות בתעסוקה. <b>ביטחון סוציאלי, 73</b>, 69–111.',
        'url': 'https://www.btl.gov.il/SiteCollectionDocuments/btl/Publications/SocialSecurity/73/04_Achdut.pdf'
      },
      {
        'title': 'לוטן, אורלי (2007). <b>תעסוקה ועוני בקרב הורים יחידים: מוגש לוועדה לקידום מעמד האישה</b>. ירושלים: מרכז המחקר והמידע של הכנסת. נדלה מתוך',
        'url': 'https://fs.knesset.gov.il/globaldocs/MMM/4f4d6b58-e9f7-e411-80c8-00155d010977/2_4f4d6b58-e9f7-e411-80c8-00155d010977_11_7807.pdf'
      },
      {
        'title': 'מבקר המדינה ונציב תלונות הציבור (2013).סדרי הטיפול במשפחות חד-הוריות. יוסף חיים שפירא (מבקר המדינה), <b>דוח מבקר המדינה 63ג, לשנת 2012 ולחשבונות שנת הכספים 2011</b> (עמ\' 1325–1370). נדלה מתוך',
        'url': 'https://www.mevaker.gov.il/he/Reports/Report_114/ec00267d-2c97-4724-9d27-30ff35ac8773/7984.pdf'
      },
      {
        'title': 'משרד ראש הממשלה (2003, 28 אוגוסט). החלטת ממשלה מס\' 757. תכנית סיוע לאמהות חד הוריות. נדלה מתוך',
        'url': 'https://www.gov.il/he/departments/policies/2003_aug757'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '16/01/2020'
    },
    'year_closed': 2012,
    'year_closed_text': '2012',
    'year_founded': 2003,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'מחאה',
      'אקטיביזם רשת'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '24/06/2018'
    },
    'description': 'תא ה״תל אביביות״ – הוא תא לקידום נשים באוניברסיטת תל אביב שהוקם בשנת 2015. מטרת התא היא ״להוות בית לסטודנטיות מכל קצוות הקמפוס, להעלות למודעות את מצבן של נשים בחברה הישראלית ובקמפוס בפרט, ולקיים פעילויות שיעניקו לסטודנטיות כלים להשתלבות כשוות בחברה״. פעילות התא כוללת הרצאות, מפגשים ופעילות ציבורית לקידום נושאים שמשפיעים על סטודנטיות ועובדות האוניברסיטה.',
    'description_ar': null,
    'display_organization_kind': 'אקדמי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'השכלה גבוהה ומחקר',
        'תאים סטודנטיאליים'
      ],
      [
        'אלימות',
        'הטרדה מינית'
      ],
      [
        'פוליטיקה ומנהיגות',
        'תאים סטודנטיאליים'
      ]
    ],
    'id': 'YB104',
    'is_active': true,
    'keywords': [
      'הטרדה מינית',
      'אקטיביזם',
      'סטודנטיות',
      'מנהיגות',
      'העצמה'
    ],
    'name': 'תל אביביות - תא לקידום נשים באוניברסיטת תל אביב',
    'name_ar': 'نساء تل ابيب',
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'אקדמי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'השכלה גבוהה ומחקר',
    'primary_organization_kind': 'אקדמי',
    'primary_sub_field_of_activity': 'תאים סטודנטיאליים',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'תל-אביביות, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/groups/telaviviot/'
      },
      {
        'title': 'תל-אביביות: התא הפמיניסטי, עמוד פייסבוק.',
        'url': 'https://www.facebook.com/TelAviviotFeminist/'
      },
      {
        'title': 'אוניברסיטת תל אביב, התוכנית ללימודי נשים ומגדר (אתר) (2019). <b>יום האישה הבינ״ל</b>. נדלה מתוך',
        'url': 'https://humanities.tau.ac.il/gender/int-woman-day'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '09/04/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2015,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'פילנתרופיה',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '11/11/2018'
    },
    'description': '״תמך - קידום תעסוקה ומסחר בישראל״ נוסדה בשנת 2005 במטרה להכשיר וללוות נשים חרדיות למען קידומן בתעסוקה ובעסקים עצמאיים. מנכ״לית ״תמך״ משנת 2008 היא שייני באב״ד. בראיון היא מתארת שהיא הצטרפה לתמך ״כדי לשנות כיוון ולעסוק בתעסוקת נשים חרדיות.״ הארגון הוא ״גוף פילנתרופי״ בכך שאופן הפעולה של ‏הארגון הוא לא שירות השמה פרטינית עבור נשים, אלא יצירת שיתופי פעולה עם עסקים, הבנת הצרכים ‏שלהם מבחינת כ״א, ואז בניית קורסי הכשרה עבור נשים חרדיות בליווי צמוד של העסק ע״מ להכניס את ‏אותן הנשים לתוכו.‏',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ בשיתוף בינלאומי',
    'fields_of_activity': [
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'דת ומעמד אישי',
        'תעסוקה ועבודה'
      ]
    ],
    'id': 'SW31',
    'is_active': true,
    'keywords': [
      'הכשרה מקצועית',
      'קידום נשים',
      'אפליה בתעסוקה',
      'נשות עסקים',
      'קריירה',
      'מנטורינג',
      'אימון אישי'
    ],
    'name': 'תמך - מרכז אמריקאי ישראלי לקידום הכלכלה והתעסוקה בישראל',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'תמך - קידום תעסוקה ומסחר בישראל',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ',
      'בינלאומי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'פילנתרופיה',
    'primary_field_of_activity': 'תעסוקה ועבודה',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'יזמות עסקית והעצמה כלכלית',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2019-09-22'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.temechcon.org'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>תמך – מרכז אמריקאי ישראלי לקידום הכלכלה והתעסוקה בישראל (ע״ר): עמותה</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580452514'
      },
      {
        'title': 'כהנר, לי (2014). <b>הכשרה מקצועית ותעסוקה בקרב נשים חרדיות: דו״ח מחקר הערכה מסכם לתוכנית \'\'צופיה\'\'</b>. משרד הכלכלה. נדלה מתוך',
        'url': 'http://www.economy.gov.il/Research/Documents/X12967.pdf'
      },
      {
        'title': 'שטרקמן, רותם (2017, 4 אוגוסט). ראיון עבודה ״בכאילו״: מה החילונים יכולים ללמוד מהנשים החרדיות. <b>TheMarker</b>. נדלה מתוך',
        'url': 'https://www.themarker.com/markerweek/1.4321518'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'יעל חסון',
      'on': '11/11/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2005,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'מחקר ותיעוד',
      'ייעוץ, שירות וסיוע'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '25/07/2018'
    },
    'description': 'העמותה ״תמר - הנשמה מתחת לבגדים״ (ע״ר 580398410) פעלה בין השנים 2002-2004. היא הוקמה על ידי פעילות פמיניסטיות מאזור תל אביב: עדי מורנו, אסתר עילם ונציגי ״מכון תודעה״, לאה גרינפטר גולד וניסן בן-עמי. על פי מסמך ההקמה, מטרותיה היו: ״לסייע לכל העוסקים במתן שירותי מין, ללא הפליה על בסיס מין, גזע, גיל, או נטייה מינית. הסיוע יכלול מתן מקום מנוחה ומקלט,עזרה ראשונה נפשית, עזרה רפואית על פי הצורך, עזרה משפטית והפנייה לשירותים קיימים בקהילה.״ פעילות הקבוצה כללה: קידום מדיניות ונוכחות בזירות זנות - תל ברוך, הבורסה ברמת גן, והתחנה מרכזית תל אביב. הפעילות קיימו סיורים ואספו עדויות של נשים, בעיקר בנושאי התעמרות הרשויות; השתתפו בדיונים בכנסת ובעיריית תל אביב והיו חברות בקואליציה למאבק בסחר בנשים. פרסומי הקבוצה נמצאים תחת פרסומי ״מכון תודעה״.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'תעשיית המין',
        'זנות'
      ],
      [
        'רווחה וקהילה',
        'זנות וסחר בנשים'
      ]
    ],
    'id': 'SA38',
    'is_active': false,
    'keywords': [
      'תמיכה נפשית',
      'סיוע משפטי',
      'מיצוי זכויות',
      'שיקום',
      'סחר בנשים'
    ],
    'name': 'תמר - הנשמה מתחת לבגדים',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'תעשיית המין',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'זנות',
    'primary_target_audience': 'נשים (כללי)',
    'retrieved': null,
    'sources': [
      {
        'title': 'משרד המשפטים (2018, 12 אוגוסט). <b>תמר – הנשמה מתחת לבגדים</b>. מתוך: מאגר עמותות וחברות לתועלת הציבור: קובץ עמותות רשומות. מתוך Data.gov.il – אתר מאגר המידע הממשלתיים, בכתובת',
        'url': 'https://data.gov.il/dataset/moj-amutot'
      },
      {
        'title': 'תמר - הנשמה מתחת לבגדים (2018, 25 יולי). הפרטים אומתו בשיחה עם חברת הוועד המייסד.'
      }
    ],
    'target_audiences': [
      'נשים (כללי)'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '25/07/2018'
    },
    'year_closed': 2004,
    'year_closed_text': '2004',
    'year_founded': 2002,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'הפעלת מעונות יום',
      'סנגור, מעקב ושינוי מדיניות',
      'מחאה'
    ],
    'created': {
      'by': 'שרי אהרוני',
      'on': '28/05/2018'
    },
    'description': 'תנד״י היא ארגון נשים יהודי-ערבי שהוקם בשנת 1951 כאיחוד של שני ארגונים: ״אלנהדה אלנסאאיה״ (התעוררות נשית) שהוקם ב-1948 כארגון נשים ערבי, ותנועת נשים דמוקרטיות מתקדמות. שני הארגונים היו מזוהים עם פעילות המפלגה הקומוניסטית. כיום התנועה פועלת בעיקר בקרב נשים ערביות-פלסטיניות אזרחיות ישראל, בכפרים ובערים בצפון ובמרכז הארץ. תנועת נשים דמוקרטיות נרשמה במקור כאגודה עותומנית (589606714) תחת השם ״אחוד נשים דמוקרטיות בישראל״ ובשנת 1984 נרשמה כעמותה (ע״ר 580022937) שמטרותיה מוגדרות כ״הגנת זכויות האישה היהודית והערביה בישראל והפעלת מעון יום״. תחומי פעילותה הרבים של התנועה כוללים קידום שוויון לנשים, זכויות ילדים, וכן פעילות למען דו-קיום, שלום ודמוקרטיה. התנועה מפעילה קבוצות מפגש ולימוד לנשים פלסטיניות צעירות במטרה להעצים אותן ולספק להן מידע בנוגע לזכויותיהן בשלב משמעותי בחייהן. הארגון מופעל על ידי מתנדבות ומתמקד גם בעידוד נשים ערביות לצאת לעבודה על ידי הכשרה מקצועית ופיתוח גני ילדים. את הגן הראשון הקימה תנד״י בחיפה ב-1950 וב-1975 הקימה שני גנים נוספים בשפרעם ובטמרה. שאר הגנים נפתחו בשנות השמונים ומספרם בשנות השיא עמד על 30 גני טרום חובה ו-7 פעוטונים בחברה הערבית. רשת גני הילדים שנפתחו על ידי תנד״י נמסרה ברובה לרשויות המקומיות במרוצת הזמן ותנד״י ממשיכה כיום להפעיל ישירות רק חמישה גנים. לתנועה יש עשרות סניפים מקומיים שבהם מתבצעת פעילות קהילתית להעלאת מודעות בקרב נשים לזכויותיהן בכל תחומי החיים, עריכת כנסים, קורסים וסדנאות. בין המנהיגות בולטות של תנד״י ניתן למנות את סמירה ח\'ורי ותמר גוז\'נסקי. ארכיון תנד״י מצוי בחלקו בבית הארגון בנצרת, באוסף של מק״י בתל אביב ובמסמכים שלא מויינו בספרייה הלאומית.',
    'description_ar': 'تاندي ״حركة النساء الديمقراطيات״ الذي تأسس عام 1951 كتوحد لمنظمتين ״النهضة النسائية״ والتي قامت عام 1948 كمنظمة نسائية عربية، وحركة النساء الديمقراطيات التقدميات. لكلتا المنظمتين ارتباط بنشاط الحزب الشيوعي. ويتركز عمل الحركة اليوم مع نساء عربيات فلسطينيات يحملن مواطنة إسرائيلية، في القرى والبلدات في شمال ومركز البلاد. في الأصل سجلت حركة النساء الديمقراطيات كنقابة عثمانية (589606714) تحت عنوان ״اتحاد النساء الديمقراطيات في إسرائيل״. وفي عام 1984 سجلت كجمعية وأهدافها معرفات ب “الدفاع عن حقوق المواطنة اليهودية والعربية في إسرائيل وتشغيل حضانة يومية״. مجال نشاط الحركة الواسع يشمل تعزيز ومساوة للسناء، حقوق الأطفال، نشاطات من اجل التعايش سلام وديمقراطية. كما وتعمل الحركة على إقامة مجموعات تعليمية لنساء فلسطينيات شابات بهدف تمكينهن واطلاعهن على حقوقهن في مرحلة مهمة في حياتهن. تنشط المنظمة على يد متطوعات وتتخصص في تشجيع النساء العربيات للخروج لسوق العمل من خلال إرشادات مهنيو وتطوير حضانات للأطفال. سلسلة الحضانات التي اقامتها حركة النساء الديمقراطية سلموا للبلديات والمجالس المحلية مع مرور الوقت وتستمر حركة النساء الديمقراطيات بتشغيل خمس حضانات فقط. هنالك عشرات من الفروع المحلية التابعة للحركة والتي يتم بها نشاطات جماهيرية من اجل رفع الوعي بين النساء حول حقوقهن في شتى مجالات الحياة، إقامة مؤتمرات، مساقات وورشات. من القياديات المعروفات والبارزات في حركة النساء الديمقراطيات يمكن التعرف على سميرة خوري وتمار جوزنسكي.',
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'קידום נשים'
      ],
      [
        'תעסוקה ועבודה',
        'מעונות ומשפחתונים'
      ],
      [
        'פוליטיקה ומנהיגות',
        'כללי'
      ]
    ],
    'id': 'SA12',
    'is_active': true,
    'keywords': [
      'השלמת השכלה',
      'זכויות',
      'כיבוש',
      'סיוע לאמהות',
      'צדק חברתי',
      'שלום',
      'שיתוף פעולה בינלאומי'
    ],
    'name': 'תנועת נשים דמוקרטיות בישראל',
    'name_ar': 'تندي - حركة نساء ديموقراطيات',
    'name_change_year': null,
    'name_common': 'תנד״י',
    'name_past': null,
    'name_replaced_by': 'הוקם ב-1948 כשילוב של שני ארגונים אלנהדה אלנסאאיה (התעוררות נשית) ותנועת נשים דמוקרטיות מתקדמות',
    'official_address': 'נצרת',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'צפון',
    'primary_activity_kind': 'הפעלת מעונות יום',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'קידום נשים',
    'primary_target_audience': 'נשים ערביות',
    'retrieved': null,
    'sources': [
      {
        'title': 'אבו-בקר, ח\'אולה (1998). <b>בדרך לא סלולה: נשים ערביות כמנהיגות פוליטיות בישראל</b>. רעננה: הוצאת המרכז לחקר החברה הערבית בישראל.'
      },
      {
        'title': 'בנסקי, טובה (2006). ״קואליציית הנשים לשלום צודק״: פרויקט השלום הפמיניסטי כחלק מהמגמות לאזרוח החברה הישראלית. בתוך: בן רפאל, אליעזר, בראלי, אבי, יער, אפרים וכהן, אורי (עורכים), <b>ישראל והמודרניות, למשה ליסק ביובל</b> (עמ\' 524–549). באר שבע: מכון בן גוריון לחקר ישראל, הציונות ומורשת בן גוריון.'
      },
      {
        'title': 'סבירסקי, שלמה וחזן, האלה (1993). החינוך לגיל הרך בישראל. <b>מידע על שוויון 3</b>. תל אביב: מרכז אדוה. נדלה מתוך',
        'url': 'http://adva.org/wp-content/uploads/2016/11/%D7%9E%D7%99%D7%93%D7%A2-%D7%A2%D7%9C-%D7%A9%D7%95%D7%95%D7%99%D7%95%D7%9F-3-%D7%97%D7%99%D7%A0%D7%95%D7%9A-%D7%9C%D7%92%D7%99%D7%9C-%D7%94%D7%A8%D7%9A-1.pdf'
      },
      {
        'title': 'קעדאן, תע\'ריד (2018). <b>ארגון נשים דמוקרטיות בישראל: פמיניזם, ליברליזם וקומוניזם תחת קורת גג אחת</b> (עבודה לשם קבלת תואר דוקטור). האוניברסיטה העברית, ירושלים.'
      }
    ],
    'target_audiences': [
      'נשים ערביות'
    ],
    'updated': {
      'by': 'אחלס סקייק',
      'on': '31/10/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': null,
    'year_registered': 1984
  },
  {
    'activity_kinds': [
      'חינוך, הכשרה והעלאת מודעות',
      'סנגור, מעקב ושינוי מדיניות',
      'עבודה קהילתית'
    ],
    'created': {
      'by': 'יעל בר צדק',
      'on': '07/03/2018'
    },
    'description': '״אחותי – למען נשים בישראל״ היא תנועה חברתית פמיניסטית המושתתת על עקרונות הפמיניזם המזרחי שנוסדה בשנת 2000 על ידי פעילות חברתיות ופמיניסטיות, בהן הנרייט דהאן כלב, ויקי שירן, נטע עמר ושולה קשת. במשך השנים נמנו בין חברות הארגון נשים מובילות כגון סמדר לביא, אסתר עילם, פנינה מוצפי-האלר, פלורה שושן, רונית אלקבץ וכרמן אלמקייס-עמוס. התנועה פועלת לקידום נושאים של צדק כלכלי, חברתי ותרבותי ולהעצמת הסולידריות עם נשים ממעמד כלכלי-חברתי נמוך בישראל. מטרות העמותה (ע״ר 580362747) הן: ״לעורר מודעות בקרב נשים מזרחיות והחברה הישראלית בכללותה לגבי מצבן המושתק, מודחק ומדוכא של ציבור הנשים. לקדם זכויותיהן הכלכליות, תרבותיות, תעסוקתיות והשכלתיות של נשים מזרחיות בפרט ושל ציבור הנשים בכלל. קיום פרויקטים לקידום ועידוד סחר הוגן של מוצרים המיוצרים ע״י נשים. קיום פרויקטים לקידום ועידוד אוכלוסיות מודרות, ובמיוחד נשים מזרחיות, נשים ערביות, נשים דוברות רוסית, נשים ממוצא אתיופי, פליטות ומהגרות. פיתוח וקידום פרויקט ״כוח לקהילה״ לעידוד, קידום אפשרויות תרבותיות, תעסוקתיות של אוכלוסיות מודרות ובמיוחד נשים. קידום קואליציות ושיתופי פעולה עם ארגוני נשים וארגוני תרבות מזרחים. הפצה וקידום של פעילות תרבותית מגוונת של נשים בכלל ושל נשים מזרחיות בפרט, כולל באמצעות הצגתן וחשיפתן לציבור בדרכים בגוונות ובין היתר בפסטיבלים, גלריות ומוזיאונים.״ \nבית התנועה שוכן בשכונת נווה שאנן שבדרום תל אביב ומהווה מרכז תרבות וחברה פמיניסטי. במקום מרכז מידע וייעוץ רב תחומי והפעילות בו כוללת גם תערוכות, הוצאת ספרים, הרצאות, סדנאות, וקורסים לקהל מהשכונה ומחוצה לה. אחותי מקיימת פרוייקטים מגוונים בקהילות ברחבי הארץ וביניהם גם \'אחותי-חנות סחר הוגן\'- זירת מסחר ייחודית שמציגה באמצעות עשרות רבות של מוצרים את המגוון ועושר התרבויות והמסורות בישראל. \'אחותי – חנות סחר הוגן\' היא חנות הסחר ההוגן הראשונה בישראל, הפועלת על פי עקרונות הסחר ההוגן הבינלאומיים: מרבית רווחי המכירה מועברים ליצרניות והרווח שנותר חוזר לתמיכה בפרויקט.',
    'description_ar': null,
    'display_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'fields_of_activity': [
      [
        'רב-תחומי',
        'פמיניזם'
      ],
      [
        'תעסוקה ועבודה',
        'יזמות עסקית והעצמה כלכלית'
      ],
      [
        'תרבות וספורט',
        'אמנות'
      ]
    ],
    'id': 'YB116',
    'is_active': true,
    'keywords': [
      'אמנות',
      'ביטחון אישי',
      'דיור',
      'הוצאה לאור',
      'יזמות עסקית',
      'פמיניזם מזרחי',
      'מיצוי זכויות',
      'עוני',
      'פליטות ומבקשות מקלט',
      'פריפריה',
      'צדק חברתי',
      'קולנוע',
      'קיימות',
      'שלום',
      'תנאי עבודה'
    ],
    'name': 'תנועת אחותי - למען נשים בישראל',
    'name_ar': 'أختي',
    'name_change_year': 2001,
    'name_common': null,
    'name_past': 'עמותת נשים מזרחיות',
    'name_replaced_by': null,
    'official_address': 'תל אביב - יפו',
    'organization_kind': [
      'עמותה רשומה, אגודה עותומנית או חל״צ'
    ],
    'primary_activity_area': 'כל הארץ',
    'primary_activity_kind': 'חינוך, הכשרה והעלאת מודעות',
    'primary_field_of_activity': 'רב-תחומי',
    'primary_organization_kind': 'עמותה רשומה, אגודה עותומנית או חל״צ',
    'primary_sub_field_of_activity': 'פמיניזם',
    'primary_target_audience': 'נשים מזרחיות',
    'retrieved': {
      'type{date}': '2019-08-15'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://shop-il.achoti.org/'
      },
      {
        'title': 'משרד המשפטים (ללא תאריך). <b>אחותי – למען נשים בישראל</b>. נדלה מתוך גיידסטאר: אתר העמותות של ישראל',
        'url': 'https://www.guidestar.org.il/organization/580362747'
      },
      {
        'title': '(2001, 17 מאי). <b>פרוטוקול פורום עמותת ״אחותי״</b>. אותר בקלסר ״שנת הפועלות״ בארכיון הפמיניסטי ב״אשה לאשה – מרכז פמיניסטי חיפה״.'
      },
      {
        'title': 'אברמוביץ\', דורית (2008). <b>ארגונים פמיניסטים יהודים ויהודים-פלסטינים בישראל: מאפיינים ומגמות</b>. תל אביב: קרן היינריך בל. עמ\' 112–116.'
      },
      {
        'title': 'ליר, שלומית (2007). <b>לאחותי: פוליטיקה פמיניסטית מזרחית</b>. תל אביב: בבל.'
      }
    ],
    'target_audiences': [
      'נשים מזרחיות',
      'נשים יוצאות אתיופיה',
      'נשים מהגרות עבודה או חסרות מעמד',
      'נשים ערביות'
    ],
    'updated': {
      'by': 'שרי אהרוני',
      'on': '15/08/2019'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 1999,
    'year_registered': 2000
  },
  {
    'activity_kinds': [
      'סנגור, מעקב ושינוי מדיניות',
      'חינוך, הכשרה והעלאת מודעות'
    ],
    'created': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '06/08/2018'
    },
    'description': '‏״תנועת עיר ואם לקידום נשים חרדיות״ הוקמה כסיעה על ידי מיכל צ\'רנוביצקי בשנת 2013 לקראת הבחירות ‏המוניציפליות באלעד באוקטובר של אותה השנה, אך איננה רשומה ברשם העמותות או ברשם המפלגות. הסיעה לא עברה את אחוז החסימה. ‏מיכל צ\'רנוביצקי עוד פעילה מאז, תחת השם של התנועה ובמסגרות של ״נבחרות״ ושדולת הנשים, ‏לקידום נשים חרדיות ובנושאים כגון מערכת החינוך החרדית.‏',
    'description_ar': null,
    'display_organization_kind': 'מפלגתי בשיתוף התארגנות שאינה עמותה',
    'fields_of_activity': [
      [
        'פוליטיקה ומנהיגות',
        'מפלגות, שדולות ותאים מפלגתיים'
      ],
      [
        'תעסוקה ועבודה',
        'זכויות ומדיניות'
      ],
      [
        'דת ומעמד אישי',
        'פוליטיקה ומנהיגות'
      ]
    ],
    'id': 'SW19',
    'is_active': true,
    'keywords': [
      'ייצוג',
      'קידום נשים',
      'אפליה בתעסוקה',
      'חינוך',
      'הדרת נשים',
      'מנהיגות'
    ],
    'name': 'תנועת עיר ואם לקידום נשים חרדיות בראשות מיכל צ\'רנוביצקי',
    'name_ar': null,
    'name_change_year': null,
    'name_common': null,
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'אלעד',
    'organization_kind': [
      'מפלגתי',
      'התארגנות שאינה עמותה'
    ],
    'primary_activity_area': 'מרכז',
    'primary_activity_kind': 'סנגור, מעקב ושינוי מדיניות',
    'primary_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_organization_kind': 'מפלגתי',
    'primary_sub_field_of_activity': 'מפלגות, שדולות ותאים מפלגתיים',
    'primary_target_audience': 'נשים חרדיות',
    'retrieved': {
      'type{date}': '2018-08-06'
    },
    'sources': [
      {
        'title': 'אתר האינטרנט',
        'url': 'https://www.facebook.com/Earveem/'
      },
      {
        'title': '(2013, 29 ספטמבר). לראשונה: מפלגת אמהות חרדיות באלעד. <b>Ynet</b>. נדלה מתוך',
        'url': 'https://www.ynet.co.il/articles/0,7340,L-4434346,00.html'
      },
      {
        'title': 'נבחרות (ללא תאריך). <b>נבחרות | נעים להכיר</b>. נדלה מתוך',
        'url': 'http://www.nivcharot.co.il/who-we-are/'
      },
      {
        'title': 'שדולת הנשים בישראל (ללא תאריך). <b>אודות עמותת שדולת הנשים בישראל</b>. נדלה מתוך',
        'url': 'http://www.iwn.org.il/pages/%D7%94%D7%A0%D7%94%D7%9C%D7%AA-%D7%A9%D7%93%D7%95%D7%9C%D7%AA-%D7%94%D7%A0%D7%A9%D7%99%D7%9D-%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C'
      }
    ],
    'target_audiences': [
      'נשים חרדיות'
    ],
    'updated': {
      'by': 'שגיא וטמברג-ליוש',
      'on': '06/08/2018'
    },
    'year_closed': 2018,
    'year_closed_text': 'פעיל ב-2018',
    'year_founded': 2013,
    'year_registered': null
  },
  {
    'activity_kinds': [
      'מדיניות ציבורית'
    ],
    'created': {
      'by': 'ליהי רוטשילד',
      'on': '09/06/2019'
    },
    'description': 'וועדת המשנה למניעת אפליה על רקע נטייה מינית, המוכרת גם בשמות ״תת וועדה לקידום זכויות ההומואים והלסביות״, ו״וועדת משנה לקידום זכויות הומואים, לסביות וביסקסואלים״ פעלה כתת וועדה של הוועדה לקידום מעמד האישה בכנסת ה - 13, בין השנים 1992-1996, ביוזמתה של חברת הכנסת לשעבר יעל דיין. הוועדה עסקה בנושאים כמו הזכות להורות וזכויות סוציאליות לזוגות חד-מיניים, תרבות להט״בית, שירות צבאי של להט״ב, מניעת אפליה ועוד. אף כי קיימים פרוטוקלים של הוועדה, בשונה מוועדות משנה אחרות, היא אינה מתועדת באתר הכנסת או בהיסטוריה הפרלמנטרית של הח״כים החברים בה. הוועדה התכנסה לציון יום הגאווה ביולי 1996, לאחר השבעת הכנסת ה - 14, אולם הפסיקה לפעול כוועדת משנה נפרדת לאחר מכן, וישיבות בנושא התקיימו במסגרת הוועדה לקידום מעמד האישה.',
    'description_ar': null,
    'display_organization_kind': 'ממשלתי',
    'fields_of_activity': [
      [
        'להט״ב',
        'פוליטיקה ומנהיגות'
      ],
      [
        'פוליטיקה ומנהיגות',
        'ועדות פרלמנטריות וממשלתיות'
      ]
    ],
    'id': 'LR56',
    'is_active': false,
    'keywords': [
      'חקיקה',
      'כנסת',
      'ועדה',
      'הומואים',
      'לסביות',
      'טרנסקסואלים',
      'אימוץ',
      'פונדקאות',
      'שוויון',
      'אפליה'
    ],
    'name': 'ועדת משנה למניעת אפליה על רקע נטיה מינית',
    'name_ar': null,
    'name_change_year': null,
    'name_common': 'תת וועדה לקידום זכויות ההומואים והלסביות/ וועדת משנה לקידום זכויות הומואים, לסביות וביסקסואלים',
    'name_past': null,
    'name_replaced_by': null,
    'official_address': 'ירושלים',
    'organization_kind': [
      'ממשלתי'
    ],
    'primary_activity_area': 'ירושלים',
    'primary_activity_kind': 'מדיניות ציבורית',
    'primary_field_of_activity': 'להט״ב',
    'primary_organization_kind': 'ממשלתי',
    'primary_sub_field_of_activity': 'פוליטיקה ומנהיגות',
    'primary_target_audience': 'להט״ב',
    'retrieved': null,
    'sources': [
      {
        'title': 'אבני, ג\'ורג\' (2015, 7 יוני). היכל הקהילה 2015: 40 המשפיעים בתולדות הקהילה. <b>Mako גאווה</b>. נדלה מתוך',
        'url': 'https://www.mako.co.il/pride-news/local/Article-758bfd4d52fcd41006.htm'
      },
      {
        'title': 'בן-אריה, שביט (2012, 18 יולי). הוועדה לקידום מעמד האישה: עבר, הווה ועתיד. מאמר דעה, <b>המכון הישראלי לדמוקרטיה</b>. נדלה מתוך',
        'url': 'https://www.idi.org.il/articles/9570'
      },
      {
        'title': 'הוועדה לקידום מעמד האישה (1996, 22 יולי). <b>פרוטוקול מס\' 10: התרבות ההומולסבית כנישה נפרדת - מר אילן שיינפלד; זכויות לסביות כאמהות ובנות זוג - עו״ד הדס תגר; חיזוק הבג״צ בהיעדר חקיקה -עו״ד דן יקיר</b>. נדלה מתוך',
        'url': 'https://m.knesset.gov.il/Activity/committees/Women/Pages/CommitteeProtocols.aspx?ItemID=2055636'
      }
    ],
    'target_audiences': [
      'להט״ב'
    ],
    'updated': {
      'by': 'ליהי רוטשילד',
      'on': '06/09/2019'
    },
    'year_closed': 1996,
    'year_closed_text': '1996',
    'year_founded': 1992,
    'year_registered': null
  }
];
export const PRIMARY_ACTIVITY_AREA = [
  'דרום',
  'חיפה',
  'יהודה ושומרון',
  'ירושלים',
  'כל הארץ',
  'מרכז',
  'צפון'
];
export const PRIMARY_FIELD_OF_ACTIVITY = [
  'אלימות',
  'בריאות ופריון',
  'דת ומעמד אישי',
  'הגירה',
  'השכלה גבוהה ומחקר',
  'חינוך',
  'להט״ב',
  'נערות וצעירות',
  'פוליטיקה ומנהיגות',
  'צבא, ביטחון ומדיניות חוץ',
  'רב-תחומי',
  'רווחה וקהילה',
  'שלום',
  'תעסוקה ועבודה',
  'תעשיית המין',
  'תקשורת',
  'תרבות וספורט'
];
export const PRIMARY_ACTIVITY_KIND = [
  'אקטיביזם רשת',
  'הפעלת מעונות יום',
  'חינוך, הכשרה והעלאת מודעות',
  'ייעוץ, שירות וסיוע',
  'מדיניות ציבורית',
  'מחאה',
  'מחקר ותיעוד',
  'סנגור, מעקב ושינוי מדיניות',
  'עבודה קהילתית',
  'פילנתרופיה',
  'שירותים משפטיים'
];
export const PRIMARY_TARGET_AUDIENCE = [
  'גברים',
  'להט״ב',
  'נשים (כללי)',
  'נשים דתיות',
  'נשים חרדיות',
  'נשים יוצאות אתיופיה',
  'נשים מהגרות עבודה או חסרות מעמד',
  'נשים מזרחיות',
  'נשים עולות מחבר העמים',
  'נשים ערביות'
];
export const PRIMARY_ORGANIZATION_KIND = [
  'אקדמי',
  'בינלאומי',
  'התארגנות שאינה עמותה',
  'מוניציפלי',
  'מוסד תורני',
  'ממשלתי',
  'מפלגתי',
  'עמותה רשומה, אגודה עותומנית או חל״צ',
  'קואליציה, איגוד או פורום'
];
export const FIELDS_OF_ACTIVITY = [
  'אגודות מקצועיות',
  'אלימות',
  'אלימות במשפחה',
  'אלימות מינית',
  'אלימות מינית ומגדרית',
  'אמהות חד הוריות',
  'אמנות',
  'אקדמיה, חברה וקהילה',
  'ארגונים קהילתיים',
  'ביטחון אישי',
  'ביטחון לאומי',
  'בריאות',
  'בריאות האישה',
  'בריאות הנפש וטיפול',
  'בריאות ומגדר',
  'בריאות ופריון',
  'דיפלומטיה ויחסי חוץ',
  'דת',
  'דת ומעמד אישי',
  'הגיל הרך',
  'הגירה',
  'הטרדה מינית',
  'הכשרה מקצועית',
  'הריון ולידה',
  'השכלה',
  'השכלה גבוהה ומחקר',
  'השמה וליווי בתעסוקה',
  'התאגדויות',
  'התאגדויות ורשתות מקצועיות',
  'התמכרויות ושיקום',
  'ועדות פרלמנטריות וממשלתיות',
  'זכויות',
  'זכויות אדם',
  'זכויות ומדיניות',
  'זנות',
  'זנות וסחר בנשים',
  'חברה וקהילה',
  'חינוך',
  'חינוך והשכלה',
  'חינוך מיני/מיניות בריאה',
  'טכנולוגיות פריון',
  'יזמות עסקית והעצמה כלכלית',
  'ייצוג הולם',
  'כללי',
  'כתבי עת',
  'כתבי עת והוצאה לאור',
  'להט״ב',
  'מדע וטכנולוגיה',
  'מוגבלות',
  'מוסיקה',
  'מלאכות מסורתיות',
  'מנהיגות',
  'מניעת אלימות',
  'מעונות ומשפחתונים',
  'מעמד אישי ודיני משפחה',
  'מפלגות, שדולות ותאים מפלגתיים',
  'מרכזי מחקר',
  'משפחה',
  'נערות וצעירות',
  'סחר בבני אדם',
  'סחר בנשים',
  'ספורט',
  'ספרות',
  'פוליטיקה ומנהיגות',
  'פורומים ומועצות נשים',
  'פורנוגרפיה',
  'פליטות ומבקשות מקלט',
  'פמיניזם',
  'פמיניזם ושוויון בין המינים',
  'פנאי',
  'צבא, ביטחון ומדיניות חוץ',
  'צמצום פערים בחינוך',
  'צעירות במצבי סיכון',
  'קולנוע',
  'קידום מנהיגות נשים',
  'קידום נשים',
  'קידום נשים במדע',
  'קידום נשים ושוויון מגדרי',
  'קליטת עלייה',
  'רב-תחומי',
  'רווחה ובריאות',
  'רווחה וקהילה',
  'שוויון בין המינים/שוויון מגדרי',
  'שלום',
  'תאים סטודנטיאליים',
  'תיאטרון',
  'תכנון משפחה וחינוך מיני',
  'תכניות לתואר אקדמי בלימודי מגדר',
  'תמיכה נפשית',
  'תעסוקה ועבודה',
  'תעשיית המין',
  'תקשורת',
  'תרבות ואמנות',
  'תרבות וספורט'
];
export const FIELDS_HIERARCHY = [
  {
    'main': 'אלימות',
    'sub': [
      'אלימות במשפחה',
      'אלימות מינית ומגדרית',
      'הטרדה מינית'
    ]
  },
  {
    'main': 'בריאות ופריון',
    'sub': [
      'בריאות האישה',
      'בריאות הנפש וטיפול',
      'בריאות ומגדר',
      'הריון ולידה',
      'טכנולוגיות פריון',
      'מוגבלות',
      'תכנון משפחה וחינוך מיני',
      'תמיכה נפשית'
    ]
  },
  {
    'main': 'דת ומעמד אישי',
    'sub': [
      'אלימות',
      'בריאות ופריון',
      'השכלה',
      'להט״ב',
      'מעמד אישי ודיני משפחה',
      'נערות וצעירות',
      'פוליטיקה ומנהיגות',
      'תעסוקה ועבודה',
      'תרבות ואמנות'
    ]
  },
  {
    'main': 'הגירה',
    'sub': [
      'סחר בבני אדם',
      'פליטות ומבקשות מקלט',
      'קליטת עלייה'
    ]
  },
  {
    'main': 'השכלה גבוהה ומחקר',
    'sub': [
      'אגודות מקצועיות',
      'אקדמיה, חברה וקהילה',
      'חברה וקהילה',
      'כתבי עת',
      'מרכזי מחקר',
      'קידום נשים במדע',
      'תאים סטודנטיאליים',
      'תכניות לתואר אקדמי בלימודי מגדר'
    ]
  },
  {
    'main': 'חינוך',
    'sub': [
      'הגיל הרך',
      'חינוך מיני/מיניות בריאה',
      'כללי',
      'להט״ב',
      'מדע וטכנולוגיה',
      'מניעת אלימות',
      'פמיניזם ושוויון בין המינים',
      'צמצום פערים בחינוך'
    ]
  },
  {
    'main': 'להט״ב',
    'sub': [
      'ארגונים קהילתיים',
      'דת',
      'זכויות',
      'חינוך והשכלה',
      'משפחה',
      'פוליטיקה ומנהיגות',
      'רווחה ובריאות',
      'תרבות וספורט'
    ]
  },
  {
    'main': 'נערות וצעירות',
    'sub': [
      'בריאות',
      'דת',
      'זכויות',
      'חינוך',
      'להט״ב',
      'מדע וטכנולוגיה',
      'מנהיגות',
      'צעירות במצבי סיכון'
    ]
  },
  {
    'main': 'פוליטיקה ומנהיגות',
    'sub': [
      'ועדות פרלמנטריות וממשלתיות',
      'ייצוג הולם',
      'כללי',
      'מפלגות, שדולות ותאים מפלגתיים',
      'פורומים ומועצות נשים',
      'קידום מנהיגות נשים',
      'תאים סטודנטיאליים'
    ]
  },
  {
    'main': 'צבא, ביטחון ומדיניות חוץ',
    'sub': [
      'ביטחון אישי',
      'ביטחון לאומי',
      'דיפלומטיה ויחסי חוץ',
      'התאגדויות',
      'זכויות אדם',
      'קידום נשים ושוויון מגדרי'
    ]
  },
  {
    'main': 'רב-תחומי',
    'sub': [
      'פמיניזם',
      'קידום נשים',
      'שוויון בין המינים/שוויון מגדרי'
    ]
  },
  {
    'main': 'רווחה וקהילה',
    'sub': [
      'אלימות במשפחה',
      'אלימות מינית',
      'אמהות חד הוריות',
      'התמכרויות ושיקום',
      'זנות וסחר בנשים',
      'כללי',
      'להט״ב',
      'נערות וצעירות',
      'תעסוקה ועבודה'
    ]
  },
  {
    'main': 'שלום',
    'sub': []
  },
  {
    'main': 'תעסוקה ועבודה',
    'sub': [
      'הכשרה מקצועית',
      'השמה וליווי בתעסוקה',
      'התאגדויות ורשתות מקצועיות',
      'זכויות ומדיניות',
      'יזמות עסקית והעצמה כלכלית',
      'מעונות ומשפחתונים'
    ]
  },
  {
    'main': 'תעשיית המין',
    'sub': [
      'זנות',
      'סחר בנשים',
      'פורנוגרפיה'
    ]
  },
  {
    'main': 'תקשורת',
    'sub': []
  },
  {
    'main': 'תרבות וספורט',
    'sub': [
      'אמנות',
      'כתבי עת והוצאה לאור',
      'מוסיקה',
      'מלאכות מסורתיות',
      'ספורט',
      'ספרות',
      'פנאי',
      'קולנוע',
      'תיאטרון'
    ]
  }
];
export const MAX_YEAR = 2018;
